import { useMutation, useQuery, UseMutationOptions, UseQueryOptions } from '@tanstack/react-query';
import { useCustomFetcher } from './useCustomFetcher';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** The `Base64` scalar type represents a base64-encoded String. */
  Base64: { input: any; output: any; }
  /**
   * The `BigInt` scalar type represents non-fractional whole numeric values.
   * `BigInt` is not constrained to 32-bit like the `Int` type and thus is a less
   * compatible type.
   */
  BigInt: { input: any; output: any; }
  /**
   * The `Date` scalar type represents a Date
   * value as specified by
   * [iso8601](https://en.wikipedia.org/wiki/ISO_8601).
   */
  Date: { input: any; output: any; }
  /**
   * The `DateTime` scalar type represents a DateTime
   * value as specified by
   * [iso8601](https://en.wikipedia.org/wiki/ISO_8601).
   */
  DateTime: { input: any; output: any; }
  /** The `Decimal` scalar type represents a python Decimal. */
  Decimal: { input: any; output: any; }
  /**
   * The `GenericScalar` scalar type represents a generic
   * GraphQL scalar value that could be:
   * String, Boolean, Int, Float, List or Object.
   */
  GenericScalar: { input: any; output: any; }
  /**
   * Allows use of a JSON String for input / output from the GraphQL schema.
   *
   * Use of this type is *not recommended* as you lose the benefits of having a defined, static
   * schema (one of the key benefits of GraphQL).
   */
  JSONString: { input: any; output: any; }
  /**
   * The `Time` scalar type represents a Time value as
   * specified by
   * [iso8601](https://en.wikipedia.org/wiki/ISO_8601).
   */
  Time: { input: any; output: any; }
  /**
   * Leverages the internal Python implementation of UUID (uuid.UUID) to provide native UUID objects
   * in fields, resolvers and input.
   */
  UUID: { input: any; output: any; }
  /**
   * Create scalar that ignores normal serialization/deserialization, since
   * that will be handled by the multipart request spec
   */
  Upload: { input: any; output: any; }
};

/**
 * Redeem a one-time activation code to join the caregiver to a clinic tenant.
 *
 * Called when a caregiver submits the code + their child's date of birth and
 * last name in-app. Verifies the DOB and last name against the clinic record,
 * then creates/reactivates the `Membership` linking the caller (`Principal`)
 * to the code's `Organization` (`Tenant`) and spends the code. Returns the
 * verified child's first name so the app can show a personalized success
 * screen.
 */
export type ActivateCaregiverToOrganization = {
  __typename?: 'ActivateCaregiverToOrganization';
  childFirstName?: Maybe<Scalars['String']['output']>;
  membership?: Maybe<MembershipType>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type AddAiReportSectionFields = {
  __typename?: 'AddAiReportSectionFields';
  aiReportSectionFields?: Maybe<Array<Maybe<ReportSectionAiFieldsType>>>;
  message?: Maybe<Scalars['String']['output']>;
  report?: Maybe<ReportType>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type AddClipAnnotationDataByM2M = {
  __typename?: 'AddClipAnnotationDataByM2M';
  clipAnnotationData?: Maybe<ClipAnnotationType>;
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type AddClipAnnotationDataByM2MInput = {
  annotationData: Scalars['JSONString']['input'];
  clipAnnotationId: Scalars['ID']['input'];
  status?: InputMaybe<AnnotationStatusEnumType>;
};

/** Adding missing transcipt data in db, if file is already there but transcript line data is not there */
export type AddMissingTranscriptDataBySuperAdmin = {
  __typename?: 'AddMissingTranscriptDataBySuperAdmin';
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

/**
 * Legacy signature-detail mutation, superseded by `signReport` +
 * in-section `WET_SIGNATURE`/`TYPED_SIGNATURE` fields. Kept and marked
 * `@deprecated` (see the `Field()` registration on `ReportMutations`
 * below) rather than removed outright — expand/contract split per the
 * PROA-2308 PR discussion: removing a public mutation atomically forces
 * every caller (portal-web-ui, and potentially others) to migrate in the
 * same deploy as the new, unproven `signReport` path. Deletion is a
 * follow-up PR, gated on Datadog confirming zero traffic here.
 * A call by the report's current signer on an existing detail row is an
 * edit, not a signing, and does not restamp a `last_signed_at` already set.
 */
export type AddOrUpdateReportSignatureSectionDetail = {
  __typename?: 'AddOrUpdateReportSignatureSectionDetail';
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type AddReportClientDetails = {
  __typename?: 'AddReportClientDetails';
  message?: Maybe<Scalars['String']['output']>;
  report?: Maybe<ReportType>;
  reportClientDetails?: Maybe<ReportClientDetailsType>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type AddReportGoalsSuggestedByAi = {
  __typename?: 'AddReportGoalsSuggestedByAi';
  aiSuggestedGoals?: Maybe<Array<Maybe<ReportGoalType>>>;
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type AddReportTargetsSuggestedByAi = {
  __typename?: 'AddReportTargetsSuggestedByAi';
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type AddSessionAnalyzerFeedback = {
  __typename?: 'AddSessionAnalyzerFeedback';
  message?: Maybe<Scalars['String']['output']>;
  sessionAnalyzerFeedbackDetails?: Maybe<SessionAnalyzerFeedbackType>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type AddSuggestedReportGoals = {
  __typename?: 'AddSuggestedReportGoals';
  message?: Maybe<Scalars['String']['output']>;
  reportGoals?: Maybe<Array<Maybe<ReportGoalType>>>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type AddSuggestedReportTargets = {
  __typename?: 'AddSuggestedReportTargets';
  message?: Maybe<Scalars['String']['output']>;
  reportTargetsData?: Maybe<Array<Maybe<ReportTargetType>>>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type AddTranscriptData = {
  __typename?: 'AddTranscriptData';
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type AddTranscriptDataInput = {
  mediaId: Scalars['ID']['input'];
  transcriptData: Array<InputMaybe<TranscriptLinesInput>>;
  transcriptFileId: Scalars['ID']['input'];
};

export type AddUpdateReportTreatmentPlanPrioritizeFields = {
  __typename?: 'AddUpdateReportTreatmentPlanPrioritizeFields';
  message?: Maybe<Scalars['String']['output']>;
  reportTreatmentPlanPrioritizeFields?: Maybe<ReportTreatmentPlanPrioritizeFieldsType>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type AddUpdateReportTreatmentPlanPrioritizeFieldsByAi = {
  __typename?: 'AddUpdateReportTreatmentPlanPrioritizeFieldsByAI';
  message?: Maybe<Scalars['String']['output']>;
  reportTreatmentPlanPrioritizeFields?: Maybe<ReportTreatmentPlanPrioritizeFieldsType>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

/** Resolved with an `AnalyticsScope` as its value (see resolve_admin_analytics). */
export type AdminAnalyticsType = {
  __typename?: 'AdminAnalyticsType';
  openQaFlags?: Maybe<AnalyticsMetricType>;
  overdueReports?: Maybe<AnalyticsOverdueReportsPage>;
  qaByUser?: Maybe<AnalyticsQaByUserPage>;
  /** QA flag drilldown rows, windowed on flag creation. */
  qaFlags?: Maybe<AnalyticsQaFlagsPage>;
  /** Report drilldown rows, windowed on `dateField`. */
  reports?: Maybe<AnalyticsReportsPage>;
  reportsByStatus?: Maybe<Array<AnalyticsStatusCountType>>;
  reportsByUser?: Maybe<AnalyticsReportsByUserPage>;
  resolvedQaFlags?: Maybe<AnalyticsMetricType>;
  submissionTrend?: Maybe<Array<AnalyticsTrendPointType>>;
  /** Ignores the template-group filter, so it can populate it. */
  templateOptions?: Maybe<Array<AnalyticsTemplateOptionType>>;
  totalReports?: Maybe<AnalyticsMetricType>;
  writingTimeByReportType?: Maybe<Array<AnalyticsWritingTimeRowType>>;
};


/** Resolved with an `AnalyticsScope` as its value (see resolve_admin_analytics). */
export type AdminAnalyticsTypeOpenQaFlagsArgs = {
  filters?: InputMaybe<AnalyticsCellFiltersInput>;
};


/** Resolved with an `AnalyticsScope` as its value (see resolve_admin_analytics). */
export type AdminAnalyticsTypeOverdueReportsArgs = {
  filters?: InputMaybe<AnalyticsCellFiltersInput>;
  page?: InputMaybe<AnalyticsPageInput>;
  sort?: InputMaybe<AnalyticsOverdueReportSortInput>;
};


/** Resolved with an `AnalyticsScope` as its value (see resolve_admin_analytics). */
export type AdminAnalyticsTypeQaByUserArgs = {
  filters?: InputMaybe<AnalyticsCellFiltersInput>;
  page?: InputMaybe<AnalyticsPageInput>;
  sort?: InputMaybe<AnalyticsQaByUserSortInput>;
};


/** Resolved with an `AnalyticsScope` as its value (see resolve_admin_analytics). */
export type AdminAnalyticsTypeQaFlagsArgs = {
  filters?: InputMaybe<AnalyticsCellFiltersInput>;
  page?: InputMaybe<AnalyticsPageInput>;
  sort?: InputMaybe<AnalyticsQaFlagSortInput>;
};


/** Resolved with an `AnalyticsScope` as its value (see resolve_admin_analytics). */
export type AdminAnalyticsTypeReportsArgs = {
  dateField: AnalyticsReportDateField;
  filters?: InputMaybe<AnalyticsCellFiltersInput>;
  page?: InputMaybe<AnalyticsPageInput>;
  sort?: InputMaybe<AnalyticsReportSortInput>;
};


/** Resolved with an `AnalyticsScope` as its value (see resolve_admin_analytics). */
export type AdminAnalyticsTypeReportsByStatusArgs = {
  filters?: InputMaybe<AnalyticsCellFiltersInput>;
};


/** Resolved with an `AnalyticsScope` as its value (see resolve_admin_analytics). */
export type AdminAnalyticsTypeReportsByUserArgs = {
  filters?: InputMaybe<AnalyticsCellFiltersInput>;
  page?: InputMaybe<AnalyticsPageInput>;
  sort?: InputMaybe<AnalyticsReportsByUserSortInput>;
};


/** Resolved with an `AnalyticsScope` as its value (see resolve_admin_analytics). */
export type AdminAnalyticsTypeResolvedQaFlagsArgs = {
  filters?: InputMaybe<AnalyticsCellFiltersInput>;
};


/** Resolved with an `AnalyticsScope` as its value (see resolve_admin_analytics). */
export type AdminAnalyticsTypeSubmissionTrendArgs = {
  filters?: InputMaybe<AnalyticsCellFiltersInput>;
};


/** Resolved with an `AnalyticsScope` as its value (see resolve_admin_analytics). */
export type AdminAnalyticsTypeTemplateOptionsArgs = {
  filters?: InputMaybe<AnalyticsCellFiltersInput>;
};


/** Resolved with an `AnalyticsScope` as its value (see resolve_admin_analytics). */
export type AdminAnalyticsTypeTotalReportsArgs = {
  filters?: InputMaybe<AnalyticsCellFiltersInput>;
};


/** Resolved with an `AnalyticsScope` as its value (see resolve_admin_analytics). */
export type AdminAnalyticsTypeWritingTimeByReportTypeArgs = {
  filters?: InputMaybe<AnalyticsCellFiltersInput>;
};

export enum AiPredictionOfEnum {
  GoalAttainmentScale = 'GOAL_ATTAINMENT_SCALE',
  GoalBaselineData = 'GOAL_BASELINE_DATA',
  GoalProgressSummary = 'GOAL_PROGRESS_SUMMARY',
  LongTermGoal = 'LONG_TERM_GOAL',
  ShortTermGoal = 'SHORT_TERM_GOAL',
  Targets = 'TARGETS',
  TargetProgressSummary = 'TARGET_PROGRESS_SUMMARY'
}

export type AiReportSectionFieldInput = {
  aiSources?: InputMaybe<Scalars['String']['input']>;
  content: Scalars['String']['input'];
  fieldIdentifier?: InputMaybe<Scalars['String']['input']>;
  fieldType: ReportSectionFieldTypeEnums;
  rankOrder: Scalars['Int']['input'];
  title: Scalars['String']['input'];
};

/**
 * One extra AI-generated field value for a goal
 * (goal-customization-ai). ``key`` is the template field's identifier, falling back to
 * its title for custom fields created without an identifier — the same
 * union key basecamp's org settings use.
 */
export type AiSuggestedGoalCustomFieldInput = {
  key: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type AiSuggestedGoalInput = {
  assessmentToolSource?: InputMaybe<Scalars['String']['input']>;
  customFields?: InputMaybe<Array<InputMaybe<AiSuggestedGoalCustomFieldInput>>>;
  description?: InputMaybe<Scalars['String']['input']>;
  goalName: Scalars['String']['input'];
  hasMedicalNecessity?: InputMaybe<Scalars['Boolean']['input']>;
  masteryCriteria?: InputMaybe<Scalars['String']['input']>;
  medicalNecessityCriteria?: InputMaybe<Scalars['String']['input']>;
  predictionId: Scalars['String']['input'];
  programGoal?: InputMaybe<Scalars['String']['input']>;
  reportDomainId?: InputMaybe<Scalars['ID']['input']>;
  timelineEstimationType?: InputMaybe<LongTermTimelineEstimationEnums>;
  timelineEstimationValue?: InputMaybe<Scalars['Int']['input']>;
};

export type AiSuggestedTargetInput = {
  aiGoalId: Scalars['ID']['input'];
  masteryCriteria?: InputMaybe<Scalars['String']['input']>;
  predictionId: Scalars['String']['input'];
  targetDescription?: InputMaybe<Scalars['String']['input']>;
  targetName: Scalars['String']['input'];
  timelineEstimationType?: InputMaybe<TargetTimelineEstimationEnums>;
  timelineEstimationValue?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * Per-cell filters. A field that is omitted or empty inherits the
 * page-level value; any other value replaces it for this cell only.
 */
export type AnalyticsCellFiltersInput = {
  categories?: InputMaybe<Array<AnalyticsQaCategory>>;
  dateRange?: InputMaybe<AnalyticsDateRangeInput>;
  /** Learner full names. */
  learners?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Relay ids of ProviderType. */
  providerIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  qaStatus?: InputMaybe<AnalyticsQaFlagStatus>;
  reportTypes?: InputMaybe<Array<ReportAnalyticsTemplateType>>;
  statuses?: InputMaybe<Array<ReportAnalyticsStatus>>;
  templateGroups?: InputMaybe<Array<Scalars['String']['input']>>;
};

/**
 * PREVIOUS_PERIOD: the same number of days immediately before the range.
 * SAME_PERIOD_LAST_YEAR: the range shifted back one year (Feb 29 -> Feb 28).
 * CUSTOM: `fromDate`/`toDate`, which are required for CUSTOM and rejected for
 * every other mode.
 */
export type AnalyticsComparisonInput = {
  fromDate?: InputMaybe<Scalars['Date']['input']>;
  mode: AnalyticsComparisonMode;
  toDate?: InputMaybe<Scalars['Date']['input']>;
};

/**
 * How a range's comparison window is chosen. The server derives the window
 * from whichever range applies (page-level or a cell's override), so a cell
 * that overrides its range can never drop or mismatch its comparison.
 */
export enum AnalyticsComparisonMode {
  Custom = 'CUSTOM',
  None = 'NONE',
  PreviousPeriod = 'PREVIOUS_PERIOD',
  SamePeriodLastYear = 'SAME_PERIOD_LAST_YEAR'
}

/**
 * Inclusive day range and how to compare it.
 *
 * Omitting `comparison` means no comparison at page level. On a cell, an
 * omitted `comparison` inherits the page-level mode, re-derived for the cell's
 * range; a page-level CUSTOM comparison is not inherited, since its dates
 * belong to the page's window.
 */
export type AnalyticsDateRangeInput = {
  comparison?: InputMaybe<AnalyticsComparisonInput>;
  fromDate: Scalars['Date']['input'];
  toDate: Scalars['Date']['input'];
};

/** Narrow one facet's values to labels containing `query` (case-insensitive). */
export type AnalyticsFacetSearchInput = {
  key: Scalars['String']['input'];
  query: Scalars['String']['input'];
};

/**
 * Values present for one filterable field, counted over the cell's scope
 * with every other field's selection applied but not this field's own.
 *
 * At most `limit` values by count, plus any currently selected value the
 * limit left out (so a selection can always be labelled and cleared).
 */
export type AnalyticsFacetType = {
  __typename?: 'AnalyticsFacetType';
  key: Scalars['String']['output'];
  /** More values matched than `limit` returned; search to narrow. */
  truncated: Scalars['Boolean']['output'];
  values: Array<AnalyticsFacetValueType>;
};

export type AnalyticsFacetValueType = {
  __typename?: 'AnalyticsFacetValueType';
  count: Scalars['Int']['output'];
  label: Scalars['String']['output'];
  /** Pass back in the matching cell filter. */
  value: Scalars['String']['output'];
};

/** Page-level filters (the sticky filter bar). */
export type AnalyticsFiltersInput = {
  dateRange: AnalyticsDateRangeInput;
  reportTypes?: InputMaybe<Array<ReportAnalyticsTemplateType>>;
  templateGroups?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type AnalyticsMetricType = {
  __typename?: 'AnalyticsMetricType';
  /** Same metric over the comparison range; null without one. */
  previousValue?: Maybe<Scalars['Int']['output']>;
  value: Scalars['Int']['output'];
};

export type AnalyticsOverdueReportRowType = {
  __typename?: 'AnalyticsOverdueReportRowType';
  createdDate: Scalars['Date']['output'];
  /** Weekdays open through today, computed when the request runs. Which reports count as overdue comes from the last fact refresh, so a report can pass 7 days before it appears here. */
  daysOpen: Scalars['Int']['output'];
  learnerName?: Maybe<Scalars['String']['output']>;
  providerId?: Maybe<Scalars['ID']['output']>;
  providerName?: Maybe<Scalars['String']['output']>;
  reportId: Scalars['ID']['output'];
  reportType?: Maybe<ReportAnalyticsTemplateType>;
  templateGroup?: Maybe<Scalars['String']['output']>;
};

export enum AnalyticsOverdueReportSortField {
  CreatedDate = 'CREATED_DATE',
  DaysOpen = 'DAYS_OPEN',
  Learner = 'LEARNER',
  Provider = 'PROVIDER',
  ReportType = 'REPORT_TYPE',
  Template = 'TEMPLATE'
}

export type AnalyticsOverdueReportSortInput = {
  direction: AnalyticsSortDirection;
  field: AnalyticsOverdueReportSortField;
};

export type AnalyticsOverdueReportsPage = {
  __typename?: 'AnalyticsOverdueReportsPage';
  facets?: Maybe<Array<AnalyticsFacetType>>;
  rows: Array<AnalyticsOverdueReportRowType>;
  totalCount: Scalars['Int']['output'];
};


export type AnalyticsOverdueReportsPageFacetsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Array<AnalyticsFacetSearchInput>>;
};

export type AnalyticsPageInput = {
  /** Capped at 200. */
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type AnalyticsQaByUserPage = {
  __typename?: 'AnalyticsQaByUserPage';
  rows: Array<AnalyticsQaByUserRowType>;
  totalCount: Scalars['Int']['output'];
};

export type AnalyticsQaByUserRowType = {
  __typename?: 'AnalyticsQaByUserRowType';
  openFlags: Scalars['Int']['output'];
  providerId: Scalars['ID']['output'];
  providerName?: Maybe<Scalars['String']['output']>;
  resolutionRate: Scalars['Float']['output'];
  resolvedFlags: Scalars['Int']['output'];
  totalFlags: Scalars['Int']['output'];
};

export enum AnalyticsQaByUserSortField {
  OpenFlags = 'OPEN_FLAGS',
  Provider = 'PROVIDER',
  ResolutionRate = 'RESOLUTION_RATE',
  ResolvedFlags = 'RESOLVED_FLAGS',
  TotalFlags = 'TOTAL_FLAGS'
}

export type AnalyticsQaByUserSortInput = {
  direction: AnalyticsSortDirection;
  field: AnalyticsQaByUserSortField;
};

/** Curated QA flag categories. Any uncurated `category_group` is OTHER. */
export enum AnalyticsQaCategory {
  CcsQa = 'CCS_QA',
  ClinicalContent = 'CLINICAL_CONTENT',
  Custom = 'CUSTOM',
  DocumentCompleteness = 'DOCUMENT_COMPLETENESS',
  Goals = 'GOALS',
  InsuranceStandards = 'INSURANCE_STANDARDS',
  Other = 'OTHER'
}

export type AnalyticsQaFlagRowType = {
  __typename?: 'AnalyticsQaFlagRowType';
  category: AnalyticsQaCategory;
  createdDate: Scalars['Date']['output'];
  flagId: Scalars['ID']['output'];
  providerId?: Maybe<Scalars['ID']['output']>;
  providerName?: Maybe<Scalars['String']['output']>;
  reportId: Scalars['ID']['output'];
  reportType?: Maybe<ReportAnalyticsTemplateType>;
  resolved: Scalars['Boolean']['output'];
  resolvedDate?: Maybe<Scalars['Date']['output']>;
};

export enum AnalyticsQaFlagSortField {
  Category = 'CATEGORY',
  CreatedDate = 'CREATED_DATE',
  Provider = 'PROVIDER',
  ReportType = 'REPORT_TYPE',
  ResolvedDate = 'RESOLVED_DATE',
  Status = 'STATUS'
}

export type AnalyticsQaFlagSortInput = {
  direction: AnalyticsSortDirection;
  field: AnalyticsQaFlagSortField;
};

export enum AnalyticsQaFlagStatus {
  Open = 'OPEN',
  Resolved = 'RESOLVED'
}

export type AnalyticsQaFlagsPage = {
  __typename?: 'AnalyticsQaFlagsPage';
  facets?: Maybe<Array<AnalyticsFacetType>>;
  rows: Array<AnalyticsQaFlagRowType>;
  totalCount: Scalars['Int']['output'];
};


export type AnalyticsQaFlagsPageFacetsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Array<AnalyticsFacetSearchInput>>;
};

/** Which report timestamp a `reports` drilldown is windowed on. */
export enum AnalyticsReportDateField {
  Completed = 'COMPLETED',
  Created = 'CREATED',
  Submitted = 'SUBMITTED'
}

export type AnalyticsReportRowType = {
  __typename?: 'AnalyticsReportRowType';
  completedDate?: Maybe<Scalars['Date']['output']>;
  createdDate: Scalars['Date']['output'];
  learnerName?: Maybe<Scalars['String']['output']>;
  providerId?: Maybe<Scalars['ID']['output']>;
  providerName?: Maybe<Scalars['String']['output']>;
  reportId: Scalars['ID']['output'];
  reportType?: Maybe<ReportAnalyticsTemplateType>;
  status?: Maybe<ReportAnalyticsStatus>;
  submittedDate?: Maybe<Scalars['Date']['output']>;
  templateGroup?: Maybe<Scalars['String']['output']>;
  writingMinutes?: Maybe<Scalars['Int']['output']>;
};

export enum AnalyticsReportSortField {
  CompletedDate = 'COMPLETED_DATE',
  CreatedDate = 'CREATED_DATE',
  Learner = 'LEARNER',
  Provider = 'PROVIDER',
  ReportType = 'REPORT_TYPE',
  Status = 'STATUS',
  SubmittedDate = 'SUBMITTED_DATE',
  Template = 'TEMPLATE',
  WritingMinutes = 'WRITING_MINUTES'
}

export type AnalyticsReportSortInput = {
  direction: AnalyticsSortDirection;
  field: AnalyticsReportSortField;
};

export type AnalyticsReportsByUserPage = {
  __typename?: 'AnalyticsReportsByUserPage';
  rows: Array<AnalyticsReportsByUserRowType>;
  totalCount: Scalars['Int']['output'];
};

export type AnalyticsReportsByUserRowType = {
  __typename?: 'AnalyticsReportsByUserRowType';
  count: Scalars['Int']['output'];
  previousCount?: Maybe<Scalars['Int']['output']>;
  providerId: Scalars['ID']['output'];
  providerName?: Maybe<Scalars['String']['output']>;
};

export enum AnalyticsReportsByUserSortField {
  Count = 'COUNT',
  Provider = 'PROVIDER'
}

export type AnalyticsReportsByUserSortInput = {
  direction: AnalyticsSortDirection;
  field: AnalyticsReportsByUserSortField;
};

export type AnalyticsReportsPage = {
  __typename?: 'AnalyticsReportsPage';
  facets?: Maybe<Array<AnalyticsFacetType>>;
  rows: Array<AnalyticsReportRowType>;
  totalCount: Scalars['Int']['output'];
};


export type AnalyticsReportsPageFacetsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Array<AnalyticsFacetSearchInput>>;
};

export enum AnalyticsSortDirection {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type AnalyticsStatusCountType = {
  __typename?: 'AnalyticsStatusCountType';
  catalightOnly: Scalars['Boolean']['output'];
  count: Scalars['Int']['output'];
  status: ReportAnalyticsStatus;
};

export type AnalyticsTemplateOptionType = {
  __typename?: 'AnalyticsTemplateOptionType';
  count: Scalars['Int']['output'];
  templateGroup: Scalars['String']['output'];
};

export type AnalyticsTrendPointType = {
  __typename?: 'AnalyticsTrendPointType';
  submitted: Scalars['Int']['output'];
  weekStart: Scalars['Date']['output'];
};

export type AnalyticsWritingTimeRowType = {
  __typename?: 'AnalyticsWritingTimeRowType';
  medianWritingMinutes: Scalars['Int']['output'];
  previousMedianWritingMinutes?: Maybe<Scalars['Int']['output']>;
  reportType: ReportAnalyticsTemplateType;
};

export type AnnotationCategoryType = Node & {
  __typename?: 'AnnotationCategoryType';
  category: Scalars['String']['output'];
  createdDate: Scalars['DateTime']['output'];
  /** The ID of the object */
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  lastUpdatedDate: Scalars['DateTime']['output'];
  organization: OrganizationType;
  pk?: Maybe<Scalars['Int']['output']>;
  value: Scalars['String']['output'];
};

export enum AnnotationStatusEnumType {
  Assigned = 'ASSIGNED',
  Complete = 'COMPLETE',
  InProgress = 'IN_PROGRESS',
  Pending = 'PENDING',
  ReadyForModelIngestion = 'READY_FOR_MODEL_INGESTION',
  ReadyForReview = 'READY_FOR_REVIEW'
}

export type AnnotationTagType = Node & {
  __typename?: 'AnnotationTagType';
  clipannotationSet: ClipAnnotationTypeConnection;
  createdBy?: Maybe<UserType>;
  createdDate: Scalars['DateTime']['output'];
  /** The ID of the object */
  id: Scalars['ID']['output'];
  lastUpdatedDate: Scalars['DateTime']['output'];
  name: Scalars['String']['output'];
  pk?: Maybe<Scalars['Int']['output']>;
};


export type AnnotationTagTypeClipannotationSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  annotationTag?: InputMaybe<Scalars['ID']['input']>;
  assignedUser?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  clip?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  reviewer?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<ApiClipAnnotationStatusChoices>;
};

export type AnnotationTagTypeConnection = {
  __typename?: 'AnnotationTagTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<AnnotationTagTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `AnnotationTagType` and its cursor. */
export type AnnotationTagTypeEdge = {
  __typename?: 'AnnotationTagTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<AnnotationTagType>;
};

export type AnnotationType = Node & {
  __typename?: 'AnnotationType';
  active: Scalars['Boolean']['output'];
  category?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<UserType>;
  createdDate: Scalars['DateTime']['output'];
  endTime?: Maybe<Scalars['Time']['output']>;
  /** The ID of the object */
  id: Scalars['ID']['output'];
  lastUpdatedDate: Scalars['DateTime']['output'];
  media: MediaType;
  notes?: Maybe<Scalars['String']['output']>;
  organization: OrganizationType;
  pk?: Maybe<Scalars['Int']['output']>;
  startTime?: Maybe<Scalars['Time']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type AnnotationTypeConnection = {
  __typename?: 'AnnotationTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<AnnotationTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `AnnotationType` and its cursor. */
export type AnnotationTypeEdge = {
  __typename?: 'AnnotationTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<AnnotationType>;
};

export enum AnnotationUploadMediaTypeEnum {
  AnnotationUpload = 'ANNOTATION_UPLOAD'
}

export enum AnnotationUserRolesEnum {
  Annotator = 'ANNOTATOR',
  AnnotatorAdmin = 'ANNOTATOR_ADMIN'
}

export type AnnotatorUserMetaDataType = Node & {
  __typename?: 'AnnotatorUserMetaDataType';
  active: Scalars['Boolean']['output'];
  annotatorUser: AnnotatorUserType;
  createdDate: Scalars['DateTime']['output'];
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  /** The ID of the object */
  id: Scalars['ID']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  lastUpdatedDate: Scalars['DateTime']['output'];
  pk?: Maybe<Scalars['Int']['output']>;
};

export type AnnotatorUserType = Node & {
  __typename?: 'AnnotatorUserType';
  annotationFileUploadedBy: ClipAnnotationTypeConnection;
  annotatorusermetadata?: Maybe<AnnotatorUserMetaDataType>;
  assignedUser: ClipAnnotationTypeConnection;
  auth0User?: Maybe<UserType>;
  createdBy?: Maybe<UserType>;
  createdDate: Scalars['DateTime']['output'];
  /** The ID of the object */
  id: Scalars['ID']['output'];
  lastUpdatedDate: Scalars['DateTime']['output'];
  pk?: Maybe<Scalars['Int']['output']>;
  reviewer: ClipAnnotationTypeConnection;
  userRoles?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type AnnotatorUserTypeAnnotationFileUploadedByArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  annotationTag?: InputMaybe<Scalars['ID']['input']>;
  assignedUser?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  clip?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  reviewer?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<ApiClipAnnotationStatusChoices>;
};


export type AnnotatorUserTypeAssignedUserArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  annotationTag?: InputMaybe<Scalars['ID']['input']>;
  assignedUser?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  clip?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  reviewer?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<ApiClipAnnotationStatusChoices>;
};


export type AnnotatorUserTypeReviewerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  annotationTag?: InputMaybe<Scalars['ID']['input']>;
  assignedUser?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  clip?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  reviewer?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<ApiClipAnnotationStatusChoices>;
};

export type AnnotatorUserTypeConnection = {
  __typename?: 'AnnotatorUserTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<AnnotatorUserTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `AnnotatorUserType` and its cursor. */
export type AnnotatorUserTypeEdge = {
  __typename?: 'AnnotatorUserTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<AnnotatorUserType>;
};

/** An enumeration. */
export enum ApiBillableSessionSummaryOrganizationTypeChoices {
  /** ARTEMIS */
  Artemis = 'ARTEMIS',
  /** CENTRAL_REACH */
  CentralReach = 'CENTRAL_REACH',
  /** ENSORA */
  Ensora = 'ENSORA',
  /** FRONTERA_CLARITY */
  FronteraClarity = 'FRONTERA_CLARITY',
  /** FRONTERA_EHR */
  FronteraEhr = 'FRONTERA_EHR',
  /** FRONTERA_HEALTH */
  FronteraHealth = 'FRONTERA_HEALTH',
  /** HIPP_HEALTH */
  HippHealth = 'HIPP_HEALTH',
  /** HI_RASMUS */
  HiRasmus = 'HI_RASMUS',
  /** MEASUREPM */
  Measurepm = 'MEASUREPM',
  /** MOTIVITY */
  Motivity = 'MOTIVITY',
  /** PASSAGE_HEALTH */
  PassageHealth = 'PASSAGE_HEALTH',
  /** RETHINK */
  Rethink = 'RETHINK',
  /** THERAPZ */
  Therapz = 'THERAPZ'
}

/** An enumeration. */
export enum ApiBillableSessionSummaryStatusChoices {
  /** COMPLETED */
  Completed = 'COMPLETED',
  /** FAILED */
  Failed = 'FAILED',
  /** IN_PROGRESS */
  InProgress = 'IN_PROGRESS',
  /** PENDING */
  Pending = 'PENDING',
  /** SCHEDULED */
  Scheduled = 'SCHEDULED'
}

/** An enumeration. */
export enum ApiCaregiverConsentConsentTypeChoices {
  /** ai_chatbot_addendum */
  AiChatbotAddendum = 'AI_CHATBOT_ADDENDUM',
  /** ai_hippa_authorization */
  AiHippaAuthorization = 'AI_HIPPA_AUTHORIZATION',
  /** cancellation_policy */
  CancellationPolicy = 'CANCELLATION_POLICY',
  /** community_privacy_policy */
  CommunityPrivacyPolicy = 'COMMUNITY_PRIVACY_POLICY',
  /** community_terms_of_use_agreement */
  CommunityTermsOfUseAgreement = 'COMMUNITY_TERMS_OF_USE_AGREEMENT',
  /** consultation_cancellation_no_show_tardiness */
  ConsultationCancellationNoShowTardiness = 'CONSULTATION_CANCELLATION_NO_SHOW_TARDINESS',
  /** consultation_financial_policy */
  ConsultationFinancialPolicy = 'CONSULTATION_FINANCIAL_POLICY',
  /** consultation_hipaa_authorization */
  ConsultationHipaaAuthorization = 'CONSULTATION_HIPAA_AUTHORIZATION',
  /** consultation_telehealth_services */
  ConsultationTelehealthServices = 'CONSULTATION_TELEHEALTH_SERVICES',
  /** financial_policy */
  FinancialPolicy = 'FINANCIAL_POLICY',
  /** health_information */
  HealthInformation = 'HEALTH_INFORMATION',
  /** hippa_authorization */
  HippaAuthorization = 'HIPPA_AUTHORIZATION',
  /** illness_infection */
  IllnessInfection = 'ILLNESS_INFECTION',
  /** mobile_terms_of_service */
  MobileTermsOfService = 'MOBILE_TERMS_OF_SERVICE',
  /** program_safeguards */
  ProgramSafeguards = 'PROGRAM_SAFEGUARDS',
  /** video_recording */
  VideoRecording = 'VIDEO_RECORDING'
}

/** An enumeration. */
export enum ApiCaregiverMetadataCareStageChoices {
  /** ALREADY_IN_THERAPY */
  AlreadyInTherapy = 'ALREADY_IN_THERAPY',
  /** JUST_EXPLORING */
  JustExploring = 'JUST_EXPLORING',
  /** JUST_GETTING_STARTED */
  JustGettingStarted = 'JUST_GETTING_STARTED',
  /** LOOKING_FOR_DIAGNOSIS */
  LookingForDiagnosis = 'LOOKING_FOR_DIAGNOSIS',
  /** LOOKING_FOR_THERAPY */
  LookingForTherapy = 'LOOKING_FOR_THERAPY',
  /** UNDERSTANDING_DIAGNOSIS */
  UnderstandingDiagnosis = 'UNDERSTANDING_DIAGNOSIS'
}

/** An enumeration. */
export enum ApiCaregiverMetadataGenderChoices {
  /** Agender */
  Agender = 'AGENDER',
  /** Girl/woman */
  F = 'F',
  /** Genderqueer or genderfluid */
  GenderqueerOrGenderfluid = 'GENDERQUEER_OR_GENDERFLUID',
  /** Gender identity is not listed */
  GenderNotListed = 'GENDER_NOT_LISTED',
  /** Boy/man */
  M = 'M',
  /** Non-binary */
  NonBinary = 'NON_BINARY',
  /** Prefer not to disclose */
  PreferNotToDisclose = 'PREFER_NOT_TO_DISCLOSE',
  /** Questioning or unsure */
  QuestioningOrUnsure = 'QUESTIONING_OR_UNSURE'
}

/** An enumeration. */
export enum ApiCaregiverMetadataInvitationConnectionTypeChoices {
  /** google_oauth */
  GoogleOauth = 'GOOGLE_OAUTH',
  /** username_password */
  UsernamePassword = 'USERNAME_PASSWORD'
}

/** An enumeration. */
export enum ApiCaregiverMetadataInvitationStatusChoices {
  /** accepted */
  Accepted = 'ACCEPTED',
  /** expired */
  Expired = 'EXPIRED',
  /** pending */
  Pending = 'PENDING'
}

/** An enumeration. */
export enum ApiCaregiverMetadataMaritalStatusChoices {
  /** cohabitate */
  Cohabitate = 'COHABITATE',
  /** divorced */
  Divorced = 'DIVORCED',
  /** married */
  Married = 'MARRIED',
  /** single */
  Single = 'SINGLE',
  /** widowed */
  Widowed = 'WIDOWED'
}

/** An enumeration. */
export enum ApiChatCareStageChoices {
  /** ACTIVE_TREATMENT */
  ActiveTreatment = 'ACTIVE_TREATMENT',
  /** DIAGNOSED_NOT_RECEIVING_SERVICES */
  DiagnosedNotReceivingServices = 'DIAGNOSED_NOT_RECEIVING_SERVICES',
  /** DIAGNOSTIC_PROCESS */
  DiagnosticProcess = 'DIAGNOSTIC_PROCESS',
  /** EARLY_INTERVENTION */
  EarlyIntervention = 'EARLY_INTERVENTION',
  /** PRE_DIAGNOSIS */
  PreDiagnosis = 'PRE_DIAGNOSIS',
  /** TRANSITION */
  Transition = 'TRANSITION',
  /** UNKNOWN */
  Unknown = 'UNKNOWN',
  /** WAITLISTED_FOR_SERVICES */
  WaitlistedForServices = 'WAITLISTED_FOR_SERVICES'
}

/** An enumeration. */
export enum ApiChatClinicianSummaryStatusChoices {
  /** FAILED */
  Failed = 'FAILED',
  /** PENDING */
  Pending = 'PENDING',
  /** PROCESSING */
  Processing = 'PROCESSING',
  /** SUCCESS */
  Success = 'SUCCESS'
}

/** An enumeration. */
export enum ApiChatMessageRoleChoices {
  /** ASSISTANT */
  Assistant = 'ASSISTANT',
  /** COMMENT */
  Comment = 'COMMENT',
  /** SYSTEM */
  System = 'SYSTEM',
  /** USER */
  User = 'USER'
}

/** An enumeration. */
export enum ApiChatStatusChoices {
  /** FINISHED */
  Finished = 'FINISHED',
  /** OPEN */
  Open = 'OPEN'
}

/** An enumeration. */
export enum ApiChatSummaryStatusChoices {
  /** FAILED */
  Failed = 'FAILED',
  /** PENDING */
  Pending = 'PENDING',
  /** PROCESSING */
  Processing = 'PROCESSING',
  /** SUCCESS */
  Success = 'SUCCESS'
}

/** An enumeration. */
export enum ApiChatTasksStatusChoices {
  /** FAILED */
  Failed = 'FAILED',
  /** PENDING */
  Pending = 'PENDING',
  /** PROCESSING */
  Processing = 'PROCESSING',
  /** SUCCESS */
  Success = 'SUCCESS'
}

/** An enumeration. */
export enum ApiChatTypeChoices {
  /** ASSISTANT */
  Assistant = 'ASSISTANT',
  /** EXPERT */
  Expert = 'EXPERT',
  /** INTAKE */
  Intake = 'INTAKE'
}

/** An enumeration. */
export enum ApiClinicLeadPayorChoices {
  /** AETNA */
  Aetna = 'AETNA',
  /** ANTHEM */
  Anthem = 'ANTHEM',
  /** BCBS */
  Bcbs = 'BCBS',
  /** BEACON_HEALTH_OPTIONS */
  BeaconHealthOptions = 'BEACON_HEALTH_OPTIONS',
  /** BSW */
  Bsw = 'BSW',
  /** CATALIGHT */
  Catalight = 'CATALIGHT',
  /** CIGNA */
  Cigna = 'CIGNA',
  /** EMI_HEALTH */
  EmiHealth = 'EMI_HEALTH',
  /** EVERNORTH */
  Evernorth = 'EVERNORTH',
  /** HUMANA */
  Humana = 'HUMANA',
  /** KAISER_PERMANENTE */
  KaiserPermanente = 'KAISER_PERMANENTE',
  /** MAGELLAN_HEALTH */
  MagellanHealth = 'MAGELLAN_HEALTH',
  /** MEDICAID */
  Medicaid = 'MEDICAID',
  /** MOLINA */
  Molina = 'MOLINA',
  /** OPTUM */
  Optum = 'OPTUM',
  /** OTHER */
  Other = 'OTHER',
  /** SHARE_LATER */
  ShareLater = 'SHARE_LATER',
  /** TRICARE */
  Tricare = 'TRICARE',
  /** UNITED_HEALTHCARE */
  UnitedHealthcare = 'UNITED_HEALTHCARE'
}

/** An enumeration. */
export enum ApiClinicListingStagingCrawlStatusChoices {
  /** COMPLETED */
  Completed = 'COMPLETED',
  /** FAILED */
  Failed = 'FAILED',
  /** IN_PROGRESS */
  InProgress = 'IN_PROGRESS'
}

/** An enumeration. */
export enum ApiClinicListingStagingParseStatusChoices {
  /** COMPLETED */
  Completed = 'COMPLETED',
  /** FAILED */
  Failed = 'FAILED',
  /** IN_PROGRESS */
  InProgress = 'IN_PROGRESS'
}

/** An enumeration. */
export enum ApiClinicListingStagingReviewStatusChoices {
  /** COMPLETED */
  Completed = 'COMPLETED',
  /** FAILED */
  Failed = 'FAILED',
  /** IN_PROGRESS */
  InProgress = 'IN_PROGRESS'
}

/** An enumeration. */
export enum ApiClinicListingVerificationStatusChoices {
  /** PENDING */
  Pending = 'PENDING',
  /** UNVERIFIED */
  Unverified = 'UNVERIFIED',
  /** VERIFIED */
  Verified = 'VERIFIED'
}

/** An enumeration. */
export enum ApiClipAnnotationStatusChoices {
  /** assigned */
  Assigned = 'ASSIGNED',
  /** complete */
  Complete = 'COMPLETE',
  /** in_progress */
  InProgress = 'IN_PROGRESS',
  /** pending */
  Pending = 'PENDING',
  /** ready_for_model_ingestion */
  ReadyForModelIngestion = 'READY_FOR_MODEL_INGESTION',
  /** ready_for_review */
  ReadyForReview = 'READY_FOR_REVIEW'
}

/** An enumeration. */
export enum ApiFronteraGoalPhaseStatusChoices {
  /** Active */
  Active = 'ACTIVE',
  /** Baseline */
  Baseline = 'BASELINE',
  /** Baseline (Assess) */
  BaselineAssess = 'BASELINE_ASSESS_',
  /** Closed */
  Closed = 'CLOSED',
  /** Completed */
  Completed = 'COMPLETED',
  /** Deactivated */
  Deactivated = 'DEACTIVATED',
  /** Discontinued */
  Discontinued = 'DISCONTINUED',
  /** Generalization */
  Generalization = 'GENERALIZATION',
  /** Hold */
  Hold = 'HOLD',
  /** Inactive */
  Inactive = 'INACTIVE',
  /** In Maintenance */
  InMaintenance = 'IN_MAINTENANCE',
  /** Maintenance */
  Maintenance = 'MAINTENANCE',
  /** Mastered */
  Mastered = 'MASTERED',
  /** Not Introduced */
  NotIntroduced = 'NOT_INTRODUCED',
  /** On Hold */
  OnHold = 'ON_HOLD',
  /** Treatment */
  Treatment = 'TREATMENT',
  /** Waiting */
  Waiting = 'WAITING'
}

/** An enumeration. */
export enum ApiFronteraTargetBankTypeChoices {
  /** Duration */
  Duration = 'DURATION',
  /** Frequency */
  Frequency = 'FREQUENCY',
  /** Interval */
  Interval = 'INTERVAL',
  /** Rate */
  Rate = 'RATE',
  /** Scale */
  Scale = 'SCALE',
  /** Task Analysis */
  TaskAnalysis = 'TASK_ANALYSIS',
  /** Trial */
  Trial = 'TRIAL'
}

/** An enumeration. */
export enum ApiFronteraTargetPhaseStatusChoices {
  /** Acquisition */
  Acquisition = 'ACQUISITION',
  /** Already Known */
  AlreadyKnown = 'ALREADY_KNOWN',
  /** Assess */
  Assess = 'ASSESS',
  /** Baseline */
  Baseline = 'BASELINE',
  /** Baseline (Assess) */
  BaselineAssess = 'BASELINE_ASSESS_',
  /** Closed */
  Closed = 'CLOSED',
  /** Completed */
  Completed = 'COMPLETED',
  /** Custom */
  Custom = 'CUSTOM',
  /** Deactivated */
  Deactivated = 'DEACTIVATED',
  /** Discontinued */
  Discontinued = 'DISCONTINUED',
  /** Generalization */
  Generalization = 'GENERALIZATION',
  /** Hold */
  Hold = 'HOLD',
  /** Inactive */
  Inactive = 'INACTIVE',
  /** Intervention */
  Intervention = 'INTERVENTION',
  /** Maintain */
  Maintain = 'MAINTAIN',
  /** Maintenance */
  Maintenance = 'MAINTENANCE',
  /** Mastered */
  Mastered = 'MASTERED',
  /** On Hold */
  OnHold = 'ON_HOLD',
  /** Probe */
  Probe = 'PROBE',
  /** Track */
  Track = 'TRACK',
  /** Train */
  Train = 'TRAIN',
  /** Treatment */
  Treatment = 'TREATMENT',
  /** Waiting */
  Waiting = 'WAITING'
}

/** An enumeration. */
export enum ApiFronteraTargetTypeChoices {
  /** Duration */
  Duration = 'DURATION',
  /** Frequency */
  Frequency = 'FREQUENCY',
  /** Interval */
  Interval = 'INTERVAL',
  /** Rate */
  Rate = 'RATE',
  /** Scale */
  Scale = 'SCALE',
  /** Task Analysis */
  TaskAnalysis = 'TASK_ANALYSIS',
  /** Trial */
  Trial = 'TRIAL'
}

/** An enumeration. */
export enum ApiGoalBankFolderFolderTypeChoices {
  /** ORGANIZATION */
  Organization = 'ORGANIZATION',
  /** USER */
  User = 'USER'
}

/** An enumeration. */
export enum ApiGoalStatusStatusChoices {
  /** Active */
  Active = 'ACTIVE',
  /** Archived */
  Archived = 'ARCHIVED',
  /** Baseline */
  Baseline = 'BASELINE',
  /** Baseline (Assess) */
  BaselineAssess = 'BASELINE_ASSESS_',
  /** Closed */
  Closed = 'CLOSED',
  /** Completed */
  Completed = 'COMPLETED',
  /** Deactivated */
  Deactivated = 'DEACTIVATED',
  /** Discontinued */
  Discontinued = 'DISCONTINUED',
  /** Future */
  Future = 'FUTURE',
  /** Generalization */
  Generalization = 'GENERALIZATION',
  /** Hold */
  Hold = 'HOLD',
  /** Inactive */
  Inactive = 'INACTIVE',
  /** In_Maintenance */
  InMaintenance = 'IN_MAINTENANCE',
  /** In_Progress */
  InProgress = 'IN_PROGRESS',
  /** Maintenance */
  Maintenance = 'MAINTENANCE',
  /** Mastered */
  Mastered = 'MASTERED',
  /** Met */
  Met = 'MET',
  /** Notactive */
  Notactive = 'NOTACTIVE',
  /** Not Introduced */
  NotIntroduced = 'NOT_INTRODUCED',
  /** On_Hold */
  OnHold = 'ON_HOLD',
  /** Progress */
  Progress = 'PROGRESS',
  /** Treatment */
  Treatment = 'TREATMENT',
  /** Waiting */
  Waiting = 'WAITING'
}

/** An enumeration. */
export enum ApiGoalTargetGenerationStatusChoices {
  /** COMPLETED */
  Completed = 'COMPLETED',
  /** FAILED */
  Failed = 'FAILED',
  /** IN_PROGRESS */
  InProgress = 'IN_PROGRESS'
}

/** An enumeration. */
export enum ApiHatchPlanStatusChoices {
  /** ACTIVE */
  Active = 'ACTIVE',
  /** FAILED */
  Failed = 'FAILED',
  /** PARTIAL_SUCCESS */
  PartialSuccess = 'PARTIAL_SUCCESS',
  /** PENDING */
  Pending = 'PENDING',
  /** REJECTED */
  Rejected = 'REJECTED',
  /** SUCCESS */
  Success = 'SUCCESS'
}

/** An enumeration. */
export enum ApiHatchPlanVisualizationVisualizationTypeChoices {
  /** CHOICE_BOARD */
  ChoiceBoard = 'CHOICE_BOARD',
  /** FIRST_THEN */
  FirstThen = 'FIRST_THEN',
  /** VISUAL_SCHEDULE */
  VisualSchedule = 'VISUAL_SCHEDULE'
}

/** An enumeration. */
export enum ApiHiRasmusGoalTypeChoices {
  /** HR_DURATION */
  HrDuration = 'HR_DURATION',
  /** HR_ESDM */
  HrEsdm = 'HR_ESDM',
  /** HR_FREQUENCY */
  HrFrequency = 'HR_FREQUENCY',
  /** HR_INTERVAL */
  HrInterval = 'HR_INTERVAL',
  /** HR_SKILL_ACQUISITION */
  HrSkillAcquisition = 'HR_SKILL_ACQUISITION',
  /** HR_SUFFICIENT_EXEMPLAR_TRAINING */
  HrSufficientExemplarTraining = 'HR_SUFFICIENT_EXEMPLAR_TRAINING',
  /** HR_TASK_ANALYSIS */
  HrTaskAnalysis = 'HR_TASK_ANALYSIS'
}

/** An enumeration. */
export enum ApiHiRasmusTargetTypeChoices {
  /** Duration */
  Duration = 'DURATION',
  /** Frequency */
  Frequency = 'FREQUENCY',
  /** Interval */
  Interval = 'INTERVAL',
  /** Rate */
  Rate = 'RATE',
  /** Scale */
  Scale = 'SCALE',
  /** Task Analysis */
  TaskAnalysis = 'TASK_ANALYSIS',
  /** Trial */
  Trial = 'TRIAL'
}

/** An enumeration. */
export enum ApiHippHealthGoalIntervalRecordingTypeChoices {
  /** MOMENTARY */
  Momentary = 'MOMENTARY',
  /** PARTIAL */
  Partial = 'PARTIAL',
  /** WHOLE */
  Whole = 'WHOLE'
}

/** An enumeration. */
export enum ApiHippHealthGoalTypeChoices {
  /** frequency_duration */
  FrequencyDuration = 'FREQUENCY_DURATION',
  /** interval */
  Interval = 'INTERVAL',
  /** opportunity */
  Opportunity = 'OPPORTUNITY',
  /** rating */
  Rating = 'RATING'
}

/** An enumeration. */
export enum ApiHippHealthTargetSkillAcquisitionGoalTypeChoices {
  /** CHAINED_GOAL */
  ChainedGoal = 'CHAINED_GOAL',
  /** CHAINED_GOAL_TARGET */
  ChainedGoalTarget = 'CHAINED_GOAL_TARGET',
  /** DISCRETE_TRIAL */
  DiscreteTrial = 'DISCRETE_TRIAL',
  /** TASK_ANALYSIS */
  TaskAnalysis = 'TASK_ANALYSIS'
}

/** An enumeration. */
export enum ApiInsuranceDetailsInNetworkChoices {
  /** no */
  No = 'NO',
  /** unknown */
  Unknown = 'UNKNOWN',
  /** yes */
  Yes = 'YES'
}

/** An enumeration. */
export enum ApiInsuranceDetailsInsuranceTypeChoices {
  /** COMMERCIAL */
  Commercial = 'COMMERCIAL',
  /** FEDERAL */
  Federal = 'FEDERAL',
  /** MEDICAID */
  Medicaid = 'MEDICAID',
  /** OTHER */
  Other = 'OTHER'
}

/** An enumeration. */
export enum ApiInsuranceDetailsInsurerChoices {
  /** BLUE_CROSS */
  BlueCross = 'BLUE_CROSS',
  /** HEALTH_FIRST_COLORADO */
  HealthFirstColorado = 'HEALTH_FIRST_COLORADO',
  /** OTHER */
  Other = 'OTHER',
  /** PRESBYTERIAN */
  Presbyterian = 'PRESBYTERIAN',
  /** WESTERN_SKY */
  WesternSky = 'WESTERN_SKY'
}

/** An enumeration. */
export enum ApiIntegrationSyncConfigSyncFeatureChoices {
  /** Hipp Health Clients */
  HippHealthClients = 'HIPP_HEALTH_CLIENTS',
  /** Hipp Health Goals */
  HippHealthGoals = 'HIPP_HEALTH_GOALS',
  /** Hipp Health Treatment Plan */
  HippHealthTreatmentPlan = 'HIPP_HEALTH_TREATMENT_PLAN',
  /** Passage Clients */
  PassageClients = 'PASSAGE_CLIENTS',
  /** Passage Providers */
  PassageProviders = 'PASSAGE_PROVIDERS',
  /** Passage Sessions */
  PassageSessions = 'PASSAGE_SESSIONS',
  /** Passage Treatment Plan */
  PassageTreatmentPlan = 'PASSAGE_TREATMENT_PLAN'
}

/** An enumeration. */
export enum ApiLanguageStylePromptStatusChoices {
  /** COMPLETED */
  Completed = 'COMPLETED',
  /** FAILURE */
  Failure = 'FAILURE',
  /** IN_PROGRESS */
  InProgress = 'IN_PROGRESS'
}

/** An enumeration. */
export enum ApiLearnerAvailabilityDayChoices {
  /** Friday */
  Friday = 'FRIDAY',
  /** Monday */
  Monday = 'MONDAY',
  /** Saturday */
  Saturday = 'SATURDAY',
  /** Sunday */
  Sunday = 'SUNDAY',
  /** Thursday */
  Thursday = 'THURSDAY',
  /** Tuesday */
  Tuesday = 'TUESDAY',
  /** Wednesday */
  Wednesday = 'WEDNESDAY'
}

/** An enumeration. */
export enum ApiLearnerAvailabilityTimeOfDayChoices {
  /** Afternoon */
  Afternoon = 'AFTERNOON',
  /** Evening */
  Evening = 'EVENING',
  /** Midday */
  Midday = 'MIDDAY',
  /** Morning */
  Morning = 'MORNING'
}

/** An enumeration. */
export enum ApiLearnerConsentFilesConsentTypeChoices {
  /** cancellation_policy */
  CancellationPolicy = 'CANCELLATION_POLICY',
  /** financial_policy */
  FinancialPolicy = 'FINANCIAL_POLICY',
  /** health_information */
  HealthInformation = 'HEALTH_INFORMATION',
  /** hippa_authorization */
  HippaAuthorization = 'HIPPA_AUTHORIZATION',
  /** illness_infection */
  IllnessInfection = 'ILLNESS_INFECTION',
  /** program_safeguards */
  ProgramSafeguards = 'PROGRAM_SAFEGUARDS',
  /** video_recording */
  VideoRecording = 'VIDEO_RECORDING'
}

/** An enumeration. */
export enum ApiLearnerFileAssessmentTemplateTypeChoices {
  /** Custom Template */
  CustomTemplate = 'CUSTOM_TEMPLATE',
  /** Frontera Health Template */
  FronteraHealthTemplate = 'FRONTERA_HEALTH_TEMPLATE',
  /** Official Scoring File */
  OfficialScoringFile = 'OFFICIAL_SCORING_FILE'
}

/** An enumeration. */
export enum ApiLearnerFileFileKindChoices {
  Abas = 'ABAS',
  Ablls = 'ABLLS',
  ActionBehavioralCenterIntake = 'ACTION_BEHAVIORAL_CENTER_INTAKE',
  AdiR = 'ADI_R',
  AdiRInterviewNotes = 'ADI_R_INTERVIEW_NOTES',
  AdiRToddler = 'ADI_R_TODDLER',
  Ados = 'ADOS',
  Ados_2 = 'ADOS_2',
  Afls = 'AFLS',
  Apsi = 'APSI',
  Asrs = 'ASRS',
  Basc_3 = 'BASC_3',
  Basc_3Prq = 'BASC_3_PRQ',
  Basc_4 = 'BASC_4',
  Bayley_3 = 'BAYLEY_3',
  Bayley_4 = 'BAYLEY_4',
  Bdi_2 = 'BDI_2',
  Bdi_3 = 'BDI_3',
  Befas = 'BEFAS',
  BehavioralObservations = 'BEHAVIORAL_OBSERVATIONS',
  Bhi = 'BHI',
  Bhtia = 'BHTIA',
  Brief = 'BRIEF',
  Brief_2 = 'BRIEF_2',
  Cars_2 = 'CARS_2',
  CatalightIntake = 'CATALIGHT_INTAKE',
  Cbcl = 'CBCL',
  Cfql = 'CFQL',
  ChatAsset = 'CHAT_ASSET',
  ClinicalNotes = 'CLINICAL_NOTES',
  Conners_4Adhd = 'CONNERS_4_ADHD',
  ConnersCpt3Adhd = 'CONNERS_CPT3_ADHD',
  Ctoni_2 = 'CTONI_2',
  Das_2 = 'DAS_2',
  Dayc = 'DAYC',
  DiagnosisReport = 'DIAGNOSIS_REPORT',
  Dp_4 = 'DP_4',
  Earlipoint = 'EARLIPOINT',
  Esdm = 'ESDM',
  EssentialForLiving = 'ESSENTIAL_FOR_LIVING',
  EssentialForLivingQuick = 'ESSENTIAL_FOR_LIVING_QUICK',
  Evt_3 = 'EVT_3',
  Fast = 'FAST',
  Gars_2 = 'GARS_2',
  Gars_3 = 'GARS_3',
  HanleyFba = 'HANLEY_FBA',
  IntakeCall = 'INTAKE_CALL',
  IntakeCallTranscript = 'INTAKE_CALL_TRANSCRIPT',
  IntakeCallTranscriptJson = 'INTAKE_CALL_TRANSCRIPT_JSON',
  Interview = 'INTERVIEW',
  Kbit_2 = 'KBIT_2',
  Mas = 'MAS',
  Migdas_2 = 'MIGDAS_2',
  MullenScalesOfEarlyLearners = 'MULLEN_SCALES_OF_EARLY_LEARNERS',
  MChat = 'M_CHAT',
  Nichq = 'NICHQ',
  PdbbiParent = 'PDBBI_PARENT',
  PdbbiTeacher = 'PDBBI_TEACHER',
  Pddbi = 'PDDBI',
  Pdpvts = 'PDPVTS',
  Peak = 'PEAK',
  Pls_5 = 'PLS_5',
  Ppvt_5 = 'PPVT_5',
  PreviousAssessment = 'PREVIOUS_ASSESSMENT',
  Psi_4 = 'PSI_4',
  PToni = 'P_TONI',
  Qabf = 'QABF',
  Rcmas_2 = 'RCMAS_2',
  Rias_2 = 'RIAS_2',
  Scared = 'SCARED',
  Scq = 'SCQ',
  SensoryProfile_2 = 'SENSORY_PROFILE_2',
  Sipa = 'SIPA',
  SkillStreaming = 'SKILL_STREAMING',
  SociallySavvy = 'SOCIALLY_SAVVY',
  SocialSkillsSolutions = 'SOCIAL_SKILLS_SOLUTIONS',
  Spm_2 = 'SPM_2',
  Srs2 = 'SRS2',
  Ssis = 'SSIS',
  StanfordBinet = 'STANFORD_BINET',
  StanfordBinet_5 = 'STANFORD_BINET_5',
  Tasi = 'TASI',
  TeleAsdPeds = 'TELE_ASD_PEDS',
  Toni_4 = 'TONI_4',
  TreatmentPlan = 'TREATMENT_PLAN',
  Tscc = 'TSCC',
  Tscyc = 'TSCYC',
  Unclassified = 'UNCLASSIFIED',
  Vbmapp = 'VBMAPP',
  VbmappLearn = 'VBMAPP_LEARN',
  VbmappOpya = 'VBMAPP_OPYA',
  Vineland = 'VINELAND',
  Wais_4 = 'WAIS_4',
  WaisV = 'WAIS_V',
  WasiIi = 'WASI_II',
  WiatIv = 'WIAT_IV',
  WiscV = 'WISC_V',
  WppsiIv = 'WPPSI_IV',
  Wurs = 'WURS'
}

/** An enumeration. */
export enum ApiLearnerFilePdfPreviewStatusChoices {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  Generating = 'GENERATING'
}

/** An enumeration. */
export enum ApiLearnerFileProcessingFailureCodeChoices {
  /** Frontera template exported as PDF */
  FronteraTemplatePdf = 'FRONTERA_TEMPLATE_PDF'
}

/** An enumeration. */
export enum ApiLearnerFileRespondentChoices {
  /** PARENT */
  Parent = 'PARENT',
  /** TEACHER */
  Teacher = 'TEACHER'
}

/** An enumeration. */
export enum ApiLearnerFileStatusChoices {
  /** ai_generating */
  AiGenerating = 'AI_GENERATING',
  /** ai_generating_error */
  AiGeneratingError = 'AI_GENERATING_ERROR',
  /** classifying */
  Classifying = 'CLASSIFYING',
  /** classifying_error */
  ClassifyingError = 'CLASSIFYING_ERROR',
  /** classifying_success */
  ClassifyingSuccess = 'CLASSIFYING_SUCCESS',
  /** pending */
  Pending = 'PENDING',
  /** processing */
  Processing = 'PROCESSING',
  /** process_error */
  ProcessError = 'PROCESS_ERROR',
  /** process_success */
  ProcessSuccess = 'PROCESS_SUCCESS',
  /** uploaded */
  Uploaded = 'UPLOADED'
}

/** An enumeration. */
export enum ApiLearnerLivingConditionsClientHouseholdParentCountChoices {
  /** one_parent */
  OneParent = 'ONE_PARENT',
  /** two_parents */
  TwoParents = 'TWO_PARENTS'
}

/** An enumeration. */
export enum ApiLearnerManualGoalSyncStatusChoices {
  /** AWAITING_REVIEW */
  AwaitingReview = 'AWAITING_REVIEW',
  /** COMPLETED */
  Completed = 'COMPLETED',
  /** FAILURE */
  Failure = 'FAILURE',
  /** HAS_WAITING_ITEMS */
  HasWaitingItems = 'HAS_WAITING_ITEMS',
  /** INPROGRESS */
  Inprogress = 'INPROGRESS',
  /** PENDING */
  Pending = 'PENDING'
}

/** An enumeration. */
export enum ApiLearnerMetadataGenderChoices {
  /** Agender */
  Agender = 'AGENDER',
  /** Girl/woman */
  F = 'F',
  /** Genderqueer or genderfluid */
  GenderqueerOrGenderfluid = 'GENDERQUEER_OR_GENDERFLUID',
  /** Gender identity is not listed */
  GenderNotListed = 'GENDER_NOT_LISTED',
  /** Boy/man */
  M = 'M',
  /** Non-binary */
  NonBinary = 'NON_BINARY',
  /** Prefer not to disclose */
  PreferNotToDisclose = 'PREFER_NOT_TO_DISCLOSE',
  /** Questioning or unsure */
  QuestioningOrUnsure = 'QUESTIONING_OR_UNSURE'
}

/** An enumeration. */
export enum ApiLearnerPayorPayorTypeChoices {
  /** AETNA */
  Aetna = 'AETNA',
  /** ANTHEM */
  Anthem = 'ANTHEM',
  /** BCBS */
  Bcbs = 'BCBS',
  /** BEACON_HEALTH_OPTIONS */
  BeaconHealthOptions = 'BEACON_HEALTH_OPTIONS',
  /** BSW */
  Bsw = 'BSW',
  /** CATALIGHT */
  Catalight = 'CATALIGHT',
  /** CIGNA */
  Cigna = 'CIGNA',
  /** EMI_HEALTH */
  EmiHealth = 'EMI_HEALTH',
  /** EVERNORTH */
  Evernorth = 'EVERNORTH',
  /** HUMANA */
  Humana = 'HUMANA',
  /** KAISER_PERMANENTE */
  KaiserPermanente = 'KAISER_PERMANENTE',
  /** MAGELLAN_HEALTH */
  MagellanHealth = 'MAGELLAN_HEALTH',
  /** MEDICAID */
  Medicaid = 'MEDICAID',
  /** MOLINA */
  Molina = 'MOLINA',
  /** OPTUM */
  Optum = 'OPTUM',
  /** TRICARE */
  Tricare = 'TRICARE',
  /** UNITED_HEALTHCARE */
  UnitedHealthcare = 'UNITED_HEALTHCARE'
}

/** An enumeration. */
export enum ApiLongTermGoalBankGoalTypeChoices {
  /** Behavior_Reduction */
  BehaviorReduction = 'BEHAVIOR_REDUCTION',
  /** Parent_Caregiver_Involvement */
  ParentCaregiverInvolvement = 'PARENT_CAREGIVER_INVOLVEMENT',
  /** Skill_Acquisition */
  SkillAcquisition = 'SKILL_ACQUISITION'
}

/** An enumeration. */
export enum ApiMediaAiPredictionMetricLabelChoices {
  /** artifacts */
  Artifacts = 'ARTIFACTS',
  /** blur */
  Blur = 'BLUR',
  /** brisque */
  Brisque = 'BRISQUE',
  /** overexposed */
  Overexposed = 'OVEREXPOSED',
  /** underexposed */
  Underexposed = 'UNDEREXPOSED'
}

/** An enumeration. */
export enum ApiMediaAiPredictionMetricMetricTypeChoices {
  /** video_quality */
  VideoQuality = 'VIDEO_QUALITY'
}

/** An enumeration. */
export enum ApiMediaAiPredictionPredictionTypeChoices {
  /** PERSON_DETECTOR */
  PersonDetector = 'PERSON_DETECTOR',
  /** RE_ID */
  ReId = 'RE_ID',
  /** VIDEO_QUALITY_METRICS */
  VideoQualityMetrics = 'VIDEO_QUALITY_METRICS'
}

/** An enumeration. */
export enum ApiMediaCommentsCommentTypeChoices {
  /** feedback */
  Feedback = 'FEEDBACK',
  /** love */
  Love = 'LOVE',
  /** praise */
  Praise = 'PRAISE',
  /** question */
  Question = 'QUESTION'
}

/** An enumeration. */
export enum ApiMediaDeviceActiveChoices {
  /** actgive */
  Active = 'ACTIVE',
  /** entered_in_error */
  Error = 'ERROR',
  /** inactive */
  Inactive = 'INACTIVE'
}

/** An enumeration. */
export enum ApiMediaDeviceAvailabilityStatusChoices {
  /** available */
  Available = 'AVAILABLE',
  /** damaged */
  Damaged = 'DAMAGED',
  /** destroyed */
  Destroyed = 'DESTROYED',
  /** lost */
  Lost = 'LOST'
}

/** An enumeration. */
export enum ApiMediaMediaLanguageChoices {
  /** ARABIC */
  Arabic = 'ARABIC',
  /** ENGLISH */
  English = 'ENGLISH',
  /** HINDI */
  Hindi = 'HINDI',
  /** SPANISH */
  Spanish = 'SPANISH'
}

/** An enumeration. */
export enum ApiMediaMediaSourceChoices {
  /** ANNOTATION_TOOL */
  AnnotationTool = 'ANNOTATION_TOOL',
  /** EXPERT_CHAT_UPLOAD */
  ExpertChatUpload = 'EXPERT_CHAT_UPLOAD',
  /** GCP_BUCKET */
  GcpBucket = 'GCP_BUCKET',
  /** GOOGLE_CLOUD_RECORDING */
  GoogleCloudRecording = 'GOOGLE_CLOUD_RECORDING',
  /** GOOGLE_DRIVE */
  GoogleDrive = 'GOOGLE_DRIVE',
  /** IN_CLINIC_VIDEO_CAPTURE */
  InClinicVideoCapture = 'IN_CLINIC_VIDEO_CAPTURE',
  /** OLD_ANNOTATION_TOOL */
  OldAnnotationTool = 'OLD_ANNOTATION_TOOL',
  /** OTHER */
  Other = 'OTHER',
  /** SWIVL */
  Swivl = 'SWIVL',
  /** VIDEO_CAPTURE_APP */
  VideoCaptureApp = 'VIDEO_CAPTURE_APP',
  /** ZOOM_CLOUD_RECORDING */
  ZoomCloudRecording = 'ZOOM_CLOUD_RECORDING'
}

/** An enumeration. */
export enum ApiMediaMediaStatusChoices {
  /** ACTIVE */
  Active = 'ACTIVE',
  /** ARCHIVED */
  Archived = 'ARCHIVED',
  /** DONE */
  Done = 'DONE'
}

/** An enumeration. */
export enum ApiMediaMediaTypeChoices {
  /** annotation upload */
  AnnotationUpload = 'ANNOTATION_UPLOAD',
  /** caregiver intake upload */
  CaregiverIntakeUpload = 'CAREGIVER_INTAKE_UPLOAD',
  /** combined */
  Combined = 'COMBINED',
  /** video */
  Video = 'VIDEO'
}

/** An enumeration. */
export enum ApiMediaModelConfigModelChoices {
  /** AGRESSIVEBEHAVIOR */
  Agressivebehavior = 'AGRESSIVEBEHAVIOR',
  /** CLINICAL_SESSION_SUMMARY */
  ClinicalSessionSummary = 'CLINICAL_SESSION_SUMMARY',
  /** CRYINGANDSCREAMING */
  Cryingandscreaming = 'CRYINGANDSCREAMING',
  /** REID */
  Reid = 'REID',
  /** SESSIONSUMMARY */
  Sessionsummary = 'SESSIONSUMMARY',
  /** SPEAKERID */
  Speakerid = 'SPEAKERID',
  /** SPEECH_SESSION_SUMMARY */
  SpeechSessionSummary = 'SPEECH_SESSION_SUMMARY',
  /** TRANSCRIPT */
  Transcript = 'TRANSCRIPT',
  /** VIDEO_QUALITY_METRICS */
  VideoQualityMetrics = 'VIDEO_QUALITY_METRICS',
  /** VOICE_SIGNATURE */
  VoiceSignature = 'VOICE_SIGNATURE'
}

/** An enumeration. */
export enum ApiMediaTargetPredictionModalityTypeChoices {
  /** AUDIO */
  Audio = 'AUDIO',
  /** VIDEO */
  Video = 'VIDEO'
}

/** An enumeration. */
export enum ApiMediaVideoUploadStatusChoices {
  /** completed */
  Completed = 'COMPLETED',
  /** inprogress */
  Inprogress = 'INPROGRESS'
}

/** An enumeration. */
export enum ApiMotivityGoalGoalTypeChoices {
  /** Behavior_Reduction */
  BehaviorReduction = 'BEHAVIOR_REDUCTION',
  /** Parent_Caregiver_Involvement */
  ParentCaregiverInvolvement = 'PARENT_CAREGIVER_INVOLVEMENT',
  /** Skill_Acquisition */
  SkillAcquisition = 'SKILL_ACQUISITION'
}

/** An enumeration. */
export enum ApiMotivityTargetProgressTypeChoices {
  /** Duration */
  Duration = 'DURATION',
  /** Frequency */
  Frequency = 'FREQUENCY',
  /** Interval */
  Interval = 'INTERVAL',
  /** Rate */
  Rate = 'RATE',
  /** Scale */
  Scale = 'SCALE',
  /** Task Analysis */
  TaskAnalysis = 'TASK_ANALYSIS',
  /** Trial */
  Trial = 'TRIAL'
}

/** An enumeration. */
export enum ApiNotificationOptOutDeliveryMethodChoices {
  /** EMAIL */
  Email = 'EMAIL',
  /** PUSH */
  Push = 'PUSH',
  /** SMS */
  Sms = 'SMS'
}

/** An enumeration. */
export enum ApiNotificationOptOutNotificationTypeChoices {
  /** CIRCLE_COMMUNITY_NOTIFICATION */
  CircleCommunityNotification = 'CIRCLE_COMMUNITY_NOTIFICATION',
  /** CLINIC_LEAD */
  ClinicLead = 'CLINIC_LEAD',
  /** COMMUNITY_DIGEST */
  CommunityDigest = 'COMMUNITY_DIGEST',
  /** COMMUNITY_LIVE_EVENT */
  CommunityLiveEvent = 'COMMUNITY_LIVE_EVENT',
  /** EHR_CLIENT_IMPORT_COMPLETED */
  EhrClientImportCompleted = 'EHR_CLIENT_IMPORT_COMPLETED',
  /** EHR_CONNECTED */
  EhrConnected = 'EHR_CONNECTED',
  /** EXPERT_CHAT_MATCH_ASSIGNED */
  ExpertChatMatchAssigned = 'EXPERT_CHAT_MATCH_ASSIGNED',
  /** EXPERT_CHAT_NEW_MESSAGE */
  ExpertChatNewMessage = 'EXPERT_CHAT_NEW_MESSAGE',
  /** EXPERT_CHAT_REPLY_NEEDED */
  ExpertChatReplyNeeded = 'EXPERT_CHAT_REPLY_NEEDED',
  /** EXPERT_CHAT_UNREAD_CHATS */
  ExpertChatUnreadChats = 'EXPERT_CHAT_UNREAD_CHATS',
  /** MEDIA_COMMENT */
  MediaComment = 'MEDIA_COMMENT',
  /** MEDIA_COMMENT_REPLY */
  MediaCommentReply = 'MEDIA_COMMENT_REPLY',
  /** MEDIA_PROCESSED */
  MediaProcessed = 'MEDIA_PROCESSED',
  /** PARENT_SESSION_SUMMARY */
  ParentSessionSummary = 'PARENT_SESSION_SUMMARY',
  /** PROGRAMMING_REFRESH_COMPLETED */
  ProgrammingRefreshCompleted = 'PROGRAMMING_REFRESH_COMPLETED',
  /** REASSESSMENT_REMINDER */
  ReassessmentReminder = 'REASSESSMENT_REMINDER',
  /** REPORT_REVIEW */
  ReportReview = 'REPORT_REVIEW',
  /** UPLOAD_REMINDER */
  UploadReminder = 'UPLOAD_REMINDER'
}

/** An enumeration. */
export enum ApiNotificationsChannelChoices {
  /** default */
  Default = 'DEFAULT'
}

/** An enumeration. */
export enum ApiNotificationsNotificationTypeChoices {
  /** CIRCLE_COMMUNITY_NOTIFICATION */
  CircleCommunityNotification = 'CIRCLE_COMMUNITY_NOTIFICATION',
  /** CLINIC_LEAD */
  ClinicLead = 'CLINIC_LEAD',
  /** COMMUNITY_DIGEST */
  CommunityDigest = 'COMMUNITY_DIGEST',
  /** COMMUNITY_LIVE_EVENT */
  CommunityLiveEvent = 'COMMUNITY_LIVE_EVENT',
  /** EHR_CLIENT_IMPORT_COMPLETED */
  EhrClientImportCompleted = 'EHR_CLIENT_IMPORT_COMPLETED',
  /** EHR_CONNECTED */
  EhrConnected = 'EHR_CONNECTED',
  /** EXPERT_CHAT_MATCH_ASSIGNED */
  ExpertChatMatchAssigned = 'EXPERT_CHAT_MATCH_ASSIGNED',
  /** EXPERT_CHAT_NEW_MESSAGE */
  ExpertChatNewMessage = 'EXPERT_CHAT_NEW_MESSAGE',
  /** EXPERT_CHAT_REPLY_NEEDED */
  ExpertChatReplyNeeded = 'EXPERT_CHAT_REPLY_NEEDED',
  /** EXPERT_CHAT_UNREAD_CHATS */
  ExpertChatUnreadChats = 'EXPERT_CHAT_UNREAD_CHATS',
  /** MEDIA_COMMENT */
  MediaComment = 'MEDIA_COMMENT',
  /** MEDIA_COMMENT_REPLY */
  MediaCommentReply = 'MEDIA_COMMENT_REPLY',
  /** MEDIA_PROCESSED */
  MediaProcessed = 'MEDIA_PROCESSED',
  /** PARENT_SESSION_SUMMARY */
  ParentSessionSummary = 'PARENT_SESSION_SUMMARY',
  /** PROGRAMMING_REFRESH_COMPLETED */
  ProgrammingRefreshCompleted = 'PROGRAMMING_REFRESH_COMPLETED',
  /** REASSESSMENT_REMINDER */
  ReassessmentReminder = 'REASSESSMENT_REMINDER',
  /** REPORT_REVIEW */
  ReportReview = 'REPORT_REVIEW',
  /** UPLOAD_REMINDER */
  UploadReminder = 'UPLOAD_REMINDER'
}

/** An enumeration. */
export enum ApiOnboardingFormStatusStatusChoices {
  /** completed */
  Completed = 'COMPLETED',
  /** inprogress */
  Inprogress = 'INPROGRESS'
}

/** An enumeration. */
export enum ApiOrganizationAbExportTemplateNameChoices {
  /** Frontera_Template */
  AssessmentReportDocxTemplateDocx = 'ASSESSMENT_REPORT_DOCX_TEMPLATE_DOCX',
  /** Catalight_Template */
  CatalightAssessmentReportDocxTemplateDocx = 'CATALIGHT_ASSESSMENT_REPORT_DOCX_TEMPLATE_DOCX',
  /** Centria_Template */
  CentriaBogusReportDocxTemplateDocx = 'CENTRIA_BOGUS_REPORT_DOCX_TEMPLATE_DOCX',
  /** Learn_Template */
  LearnAssessmentReportDocxTemplateDocx = 'LEARN_ASSESSMENT_REPORT_DOCX_TEMPLATE_DOCX',
  /** Reassessment_Template */
  ReassessmentReportDocxTemplateDocx = 'REASSESSMENT_REPORT_DOCX_TEMPLATE_DOCX',
  /** Step_Ahead_Template */
  StepAheadReportDocxTemplateDocx = 'STEP_AHEAD_REPORT_DOCX_TEMPLATE_DOCX'
}

/** An enumeration. */
export enum ApiOrganizationEhrIntegrationTypeChoices {
  /** DATA_WAREHOUSE */
  DataWarehouse = 'DATA_WAREHOUSE',
  /** ORG_USERNAME_PASSWORD */
  OrgUsernamePassword = 'ORG_USERNAME_PASSWORD',
  /** STANDARD */
  Standard = 'STANDARD'
}

/** An enumeration. */
export enum ApiOrganizationOrganizationTypeChoices {
  /** ARTEMIS */
  Artemis = 'ARTEMIS',
  /** CENTRAL_REACH */
  CentralReach = 'CENTRAL_REACH',
  /** ENSORA */
  Ensora = 'ENSORA',
  /** FRONTERA_CLARITY */
  FronteraClarity = 'FRONTERA_CLARITY',
  /** FRONTERA_EHR */
  FronteraEhr = 'FRONTERA_EHR',
  /** FRONTERA_HEALTH */
  FronteraHealth = 'FRONTERA_HEALTH',
  /** HIPP_HEALTH */
  HippHealth = 'HIPP_HEALTH',
  /** HI_RASMUS */
  HiRasmus = 'HI_RASMUS',
  /** MEASUREPM */
  Measurepm = 'MEASUREPM',
  /** MOTIVITY */
  Motivity = 'MOTIVITY',
  /** PASSAGE_HEALTH */
  PassageHealth = 'PASSAGE_HEALTH',
  /** RETHINK */
  Rethink = 'RETHINK',
  /** THERAPZ */
  Therapz = 'THERAPZ'
}

/** An enumeration. */
export enum ApiOrganizationPayorPayorTypeChoices {
  /** AETNA */
  Aetna = 'AETNA',
  /** ANTHEM */
  Anthem = 'ANTHEM',
  /** BCBS */
  Bcbs = 'BCBS',
  /** BEACON_HEALTH_OPTIONS */
  BeaconHealthOptions = 'BEACON_HEALTH_OPTIONS',
  /** BSW */
  Bsw = 'BSW',
  /** CATALIGHT */
  Catalight = 'CATALIGHT',
  /** CIGNA */
  Cigna = 'CIGNA',
  /** EMI_HEALTH */
  EmiHealth = 'EMI_HEALTH',
  /** EVERNORTH */
  Evernorth = 'EVERNORTH',
  /** HUMANA */
  Humana = 'HUMANA',
  /** KAISER_PERMANENTE */
  KaiserPermanente = 'KAISER_PERMANENTE',
  /** MAGELLAN_HEALTH */
  MagellanHealth = 'MAGELLAN_HEALTH',
  /** MEDICAID */
  Medicaid = 'MEDICAID',
  /** MOLINA */
  Molina = 'MOLINA',
  /** OPTUM */
  Optum = 'OPTUM',
  /** TRICARE */
  Tricare = 'TRICARE',
  /** UNITED_HEALTHCARE */
  UnitedHealthcare = 'UNITED_HEALTHCARE'
}

/** An enumeration. */
export enum ApiOrganizationPayorSubmissionMethodChoices {
  /** EVENT_BRIDGE */
  EventBridge = 'EVENT_BRIDGE'
}

/** An enumeration. */
export enum ApiOrganizationServiceTypeChoices {
  /** ABA */
  Aba = 'ABA',
  /** SPEECH */
  Speech = 'SPEECH'
}

/** An enumeration. */
export enum ApiOrganizationUserRolesRoleChoices {
  /** admin */
  Admin = 'ADMIN',
  /** assessment-bcba */
  AssessmentBcba = 'ASSESSMENT_BCBA',
  /** bcba */
  Bcba = 'BCBA',
  /** caregiver */
  Caregiver = 'CAREGIVER',
  /** director */
  Director = 'DIRECTOR',
  /** enterprise-admin */
  EnterpriseAdmin = 'ENTERPRISE_ADMIN',
  /** evaluation-psychologist */
  EvaluationPsychologist = 'EVALUATION_PSYCHOLOGIST',
  /** frontera-internal */
  FronteraInternal = 'FRONTERA_INTERNAL',
  /** intake */
  Intake = 'INTAKE',
  /** psychologist */
  Psychologist = 'PSYCHOLOGIST',
  /** rbt */
  Rbt = 'RBT'
}

/** An enumeration. */
export enum ApiParentSessionSummaryStatusChoices {
  /** FAILED */
  Failed = 'FAILED',
  /** GENERATED */
  Generated = 'GENERATED',
  /** SENT */
  Sent = 'SENT'
}

/** An enumeration. */
export enum ApiParentSessionSummarySummaryTypeChoices {
  /** DAILY */
  Daily = 'DAILY',
  /** SESSION */
  Session = 'SESSION',
  /** WEEKLY */
  Weekly = 'WEEKLY'
}

/** An enumeration. */
export enum ApiParsedTreatmentPlanFileDataStatusChoices {
  /** COMPLETED */
  Completed = 'COMPLETED',
  /** FAILED */
  Failed = 'FAILED',
  /** IN_PROGRESS */
  InProgress = 'IN_PROGRESS',
  /** PENDING */
  Pending = 'PENDING'
}

/** An enumeration. */
export enum ApiPassageGoalBankTypeChoices {
  /** Behavior */
  Behavior = 'BEHAVIOR',
  /** Skill */
  Skill = 'SKILL'
}

/** An enumeration. */
export enum ApiPassageGoalPhaseStatusChoices {
  /** Baseline */
  Baseline = 'BASELINE',
  /** Closed */
  Closed = 'CLOSED',
  /** Generalization */
  Generalization = 'GENERALIZATION',
  /** Hold */
  Hold = 'HOLD',
  /** Inactive */
  Inactive = 'INACTIVE',
  /** Maintenance */
  Maintenance = 'MAINTENANCE',
  /** Mastered */
  Mastered = 'MASTERED',
  /** Treatment */
  Treatment = 'TREATMENT'
}

/** An enumeration. */
export enum ApiPassageGoalTypeChoices {
  /** Behavior */
  Behavior = 'BEHAVIOR',
  /** Skill */
  Skill = 'SKILL'
}

/** An enumeration. */
export enum ApiPassageTargetBankTypeChoices {
  /** Duration */
  Duration = 'DURATION',
  /** Frequency */
  Frequency = 'FREQUENCY',
  /** Interval */
  Interval = 'INTERVAL',
  /** Rate */
  Rate = 'RATE',
  /** Scale */
  Scale = 'SCALE',
  /** Task Analysis */
  TaskAnalysis = 'TASK_ANALYSIS',
  /** Trial */
  Trial = 'TRIAL'
}

/** An enumeration. */
export enum ApiPassageTargetPhaseStatusChoices {
  /** Baseline */
  Baseline = 'BASELINE',
  /** Closed */
  Closed = 'CLOSED',
  /** Generalization */
  Generalization = 'GENERALIZATION',
  /** Hold */
  Hold = 'HOLD',
  /** Inactive */
  Inactive = 'INACTIVE',
  /** Maintenance */
  Maintenance = 'MAINTENANCE',
  /** Mastered */
  Mastered = 'MASTERED',
  /** Treatment */
  Treatment = 'TREATMENT'
}

/** An enumeration. */
export enum ApiPassageTargetTypeChoices {
  /** Duration */
  Duration = 'DURATION',
  /** Frequency */
  Frequency = 'FREQUENCY',
  /** Interval */
  Interval = 'INTERVAL',
  /** Rate */
  Rate = 'RATE',
  /** Scale */
  Scale = 'SCALE',
  /** Task Analysis */
  TaskAnalysis = 'TASK_ANALYSIS',
  /** Trial */
  Trial = 'TRIAL'
}

/** An enumeration. */
export enum ApiPayorReportReviewStatusChoices {
  /** APPROVED */
  Approved = 'APPROVED',
  /** NEEDS_REVISION */
  NeedsRevision = 'NEEDS_REVISION'
}

/** An enumeration. */
export enum ApiPayorReportSubmissionStatusChoices {
  /** APPROVED */
  Approved = 'APPROVED',
  /** COMPLETED */
  Completed = 'COMPLETED',
  /** FAILED */
  Failed = 'FAILED',
  /** INITIALIZED */
  Initialized = 'INITIALIZED',
  /** IN_PROGRESS */
  InProgress = 'IN_PROGRESS',
  /** NEEDS_REVISION */
  NeedsRevision = 'NEEDS_REVISION'
}

/** An enumeration. */
export enum ApiProviderFileFileCategoryChoices {
  /** PROFILE_IMAGE */
  ProfileImage = 'PROFILE_IMAGE',
  /** STYLE_SAMPLE */
  StyleSample = 'STYLE_SAMPLE'
}

/** An enumeration. */
export enum ApiProviderFileProcessingFailureCodeChoices {
  /** Frontera template exported as PDF */
  FronteraTemplatePdf = 'FRONTERA_TEMPLATE_PDF'
}

/** An enumeration. */
export enum ApiProviderFileStatusChoices {
  /** COMPLETED */
  Completed = 'COMPLETED',
  /** FAILED */
  Failed = 'FAILED',
  /** PENDING */
  Pending = 'PENDING',
  /** PROCESSING */
  Processing = 'PROCESSING',
  /** UPLOADED */
  Uploaded = 'UPLOADED'
}

/** An enumeration. */
export enum ApiProviderMetadataChatAvailabilityChoices {
  /** AVAILABLE */
  Available = 'AVAILABLE',
  /** UNAVAILABLE */
  Unavailable = 'UNAVAILABLE'
}

/** An enumeration. */
export enum ApiProviderMetadataGenderChoices {
  /** Agender */
  Agender = 'AGENDER',
  /** Girl/woman */
  F = 'F',
  /** Genderqueer or genderfluid */
  GenderqueerOrGenderfluid = 'GENDERQUEER_OR_GENDERFLUID',
  /** Gender identity is not listed */
  GenderNotListed = 'GENDER_NOT_LISTED',
  /** Boy/man */
  M = 'M',
  /** Non-binary */
  NonBinary = 'NON_BINARY',
  /** Prefer not to disclose */
  PreferNotToDisclose = 'PREFER_NOT_TO_DISCLOSE',
  /** Questioning or unsure */
  QuestioningOrUnsure = 'QUESTIONING_OR_UNSURE'
}

/** An enumeration. */
export enum ApiProviderMetadataInvitationConnectionTypeChoices {
  /** google_oauth */
  GoogleOauth = 'GOOGLE_OAUTH',
  /** username_password */
  UsernamePassword = 'USERNAME_PASSWORD'
}

/** An enumeration. */
export enum ApiProviderMetadataInvitationStatusChoices {
  /** accepted */
  Accepted = 'ACCEPTED',
  /** expired */
  Expired = 'EXPIRED',
  /** pending */
  Pending = 'PENDING'
}

/** An enumeration. */
export enum ApiRecommendationBankFolderFolderTypeChoices {
  /** ORGANIZATION */
  Organization = 'ORGANIZATION',
  /** USER */
  User = 'USER'
}

/** An enumeration. */
export enum ApiRelationshipRelationshipChoices {
  /** BP */
  Bp = 'BP',
  /** CP */
  Cp = 'CP',
  /** EP */
  Ep = 'EP',
  /** OTHER */
  Other = 'OTHER'
}

/** An enumeration. */
export enum ApiReportClientDetailsGenderChoices {
  /** Agender */
  Agender = 'AGENDER',
  /** Girl/woman */
  F = 'F',
  /** Genderqueer or genderfluid */
  GenderqueerOrGenderfluid = 'GENDERQUEER_OR_GENDERFLUID',
  /** Gender identity is not listed */
  GenderNotListed = 'GENDER_NOT_LISTED',
  /** Boy/man */
  M = 'M',
  /** Non-binary */
  NonBinary = 'NON_BINARY',
  /** Prefer not to disclose */
  PreferNotToDisclose = 'PREFER_NOT_TO_DISCLOSE',
  /** Questioning or unsure */
  QuestioningOrUnsure = 'QUESTIONING_OR_UNSURE'
}

/** An enumeration. */
export enum ApiReportEhrSyncChoices {
  /** AWAITING_REVIEW */
  AwaitingReview = 'AWAITING_REVIEW',
  /** COMPLETED */
  Completed = 'COMPLETED',
  /** FAILURE */
  Failure = 'FAILURE',
  /** HAS_WAITING_ITEMS */
  HasWaitingItems = 'HAS_WAITING_ITEMS',
  /** INPROGRESS */
  Inprogress = 'INPROGRESS',
  /** PENDING */
  Pending = 'PENDING'
}

/** An enumeration. */
export enum ApiReportGoalAiBaselineDataPredictionStatusChoices {
  /** FAILURE */
  Failure = 'FAILURE',
  /** GOAL_PREDICTION_PENDING */
  GoalPredictionPending = 'GOAL_PREDICTION_PENDING',
  /** GOAL_PREDICTION_PREDICTED */
  GoalPredictionPredicted = 'GOAL_PREDICTION_PREDICTED',
  /** GOAL_PREDICTION_SKIPPED */
  GoalPredictionSkipped = 'GOAL_PREDICTION_SKIPPED',
  /** PENDING */
  Pending = 'PENDING'
}

/** An enumeration. */
export enum ApiReportGoalAiGoalAttainmentScalePredictionStatusChoices {
  /** FAILURE */
  Failure = 'FAILURE',
  /** GOAL_PREDICTION_PENDING */
  GoalPredictionPending = 'GOAL_PREDICTION_PENDING',
  /** GOAL_PREDICTION_PREDICTED */
  GoalPredictionPredicted = 'GOAL_PREDICTION_PREDICTED',
  /** GOAL_PREDICTION_SKIPPED */
  GoalPredictionSkipped = 'GOAL_PREDICTION_SKIPPED',
  /** PENDING */
  Pending = 'PENDING'
}

/** An enumeration. */
export enum ApiReportGoalAiProgressSummaryPredictionStatusChoices {
  /** FAILURE */
  Failure = 'FAILURE',
  /** GOAL_PREDICTION_PENDING */
  GoalPredictionPending = 'GOAL_PREDICTION_PENDING',
  /** GOAL_PREDICTION_PREDICTED */
  GoalPredictionPredicted = 'GOAL_PREDICTION_PREDICTED',
  /** GOAL_PREDICTION_SKIPPED */
  GoalPredictionSkipped = 'GOAL_PREDICTION_SKIPPED',
  /** PENDING */
  Pending = 'PENDING'
}

/** An enumeration. */
export enum ApiReportGoalBankTimelineEstimationTypeChoices {
  /** Days */
  Days = 'DAYS',
  /** Months */
  Months = 'MONTHS',
  /** WEEKS */
  Weeks = 'WEEKS'
}

/** An enumeration. */
export enum ApiReportGoalChartTypeChoices {
  /** Avg Daily */
  AvgDaily = 'AVG_DAILY',
  /** Avg Monthly */
  AvgMonthly = 'AVG_MONTHLY',
  /** Avg Quarterly */
  AvgQuarterly = 'AVG_QUARTERLY',
  /** Avg Weekly */
  AvgWeekly = 'AVG_WEEKLY',
  /** Cumulative */
  Cumulative = 'CUMULATIVE',
  /** Progress */
  Progress = 'PROGRESS',
  /** Total Daily */
  TotalDaily = 'TOTAL_DAILY',
  /** Total Monthly */
  TotalMonthly = 'TOTAL_MONTHLY',
  /** Total Quarterly */
  TotalQuarterly = 'TOTAL_QUARTERLY',
  /** Total Weekly */
  TotalWeekly = 'TOTAL_WEEKLY'
}

/** An enumeration. */
export enum ApiReportGoalGasMatchStatusChoices {
  /** FAILURE */
  Failure = 'FAILURE',
  /** HIDDEN */
  Hidden = 'HIDDEN',
  /** MATCHED */
  Matched = 'MATCHED',
  /** MISMATCH */
  Mismatch = 'MISMATCH',
  /** NO_MATCH */
  NoMatch = 'NO_MATCH',
  /** PENDING */
  Pending = 'PENDING',
  /** PREDICTION_PENDING */
  PredictionPending = 'PREDICTION_PENDING'
}

/** An enumeration. */
export enum ApiReportGoalStatusChoices {
  /** Continued */
  Continued = 'CONTINUED',
  /** Discontinued */
  Discontinued = 'DISCONTINUED',
  /** Met */
  Met = 'MET',
  /** New Goal */
  NewGoal = 'NEW_GOAL',
  /** On Hold */
  OnHold = 'ON_HOLD',
  /** Revised */
  Revised = 'REVISED'
}

/** An enumeration. */
export enum ApiReportGoalTimelineEstimationTypeChoices {
  /** Days */
  Days = 'DAYS',
  /** Months */
  Months = 'MONTHS',
  /** WEEKS */
  Weeks = 'WEEKS'
}

/** An enumeration. */
export enum ApiReportNarrativeMappingStatusChoices {
  /** COMPLETED */
  Completed = 'COMPLETED',
  /** FAILED */
  Failed = 'FAILED',
  /** IN_PROGRESS */
  InProgress = 'IN_PROGRESS'
}

/** An enumeration. */
export enum ApiReportReportStatusChoices {
  /** AWAITING_GOAL_SELECTION */
  AwaitingGoalSelection = 'AWAITING_GOAL_SELECTION',
  /** COMPLETED */
  Completed = 'COMPLETED',
  /** DRAFT */
  Draft = 'DRAFT',
  /** FAILURE */
  Failure = 'FAILURE',
  /** GENERATING */
  Generating = 'GENERATING'
}

/** An enumeration. */
export enum ApiReportReportTypeChoices {
  /** DIAGNOSIS_EVALUATION */
  DiagnosisEvaluation = 'DIAGNOSIS_EVALUATION',
  /** INITIAL_ASSESSMENT */
  InitialAssessment = 'INITIAL_ASSESSMENT',
  /** REASSESSMENT */
  Reassessment = 'REASSESSMENT'
}

/** An enumeration. */
export enum ApiReportSectionAiFieldsFieldTypeChoices {
  /** ASSESSMENT_APPOINTMENTS */
  AssessmentAppointments = 'ASSESSMENT_APPOINTMENTS',
  /** ASSESSMENT_IMAGE */
  AssessmentImage = 'ASSESSMENT_IMAGE',
  /** BLANK_SIGNATURE_LINE */
  BlankSignatureLine = 'BLANK_SIGNATURE_LINE',
  /** CHECKBOX */
  Checkbox = 'CHECKBOX',
  /** COORDINATION_OF_CARE */
  CoordinationOfCare = 'COORDINATION_OF_CARE',
  /** DATE */
  Date = 'DATE',
  /** DATETIME */
  Datetime = 'DATETIME',
  /** DSM_TABLE */
  DsmTable = 'DSM_TABLE',
  /** IMAGE */
  Image = 'IMAGE',
  /** RADIO */
  Radio = 'RADIO',
  /** SELECT */
  Select = 'SELECT',
  /** SIMPLE_TEXT */
  SimpleText = 'SIMPLE_TEXT',
  /** SPECIFIERS_TABLE */
  SpecifiersTable = 'SPECIFIERS_TABLE',
  /** TABLE */
  Table = 'TABLE',
  /** TREATMENT_OPTION_TABLE */
  TreatmentOptionTable = 'TREATMENT_OPTION_TABLE',
  /** TREATMENT_PLAN */
  TreatmentPlan = 'TREATMENT_PLAN',
  /** TYPED_SIGNATURE */
  TypedSignature = 'TYPED_SIGNATURE',
  /** WET_SIGNATURE */
  WetSignature = 'WET_SIGNATURE',
  /** WYSIWYG */
  Wysiwyg = 'WYSIWYG'
}

/** An enumeration. */
export enum ApiReportSectionFieldsFieldTypeChoices {
  /** ASSESSMENT_APPOINTMENTS */
  AssessmentAppointments = 'ASSESSMENT_APPOINTMENTS',
  /** ASSESSMENT_IMAGE */
  AssessmentImage = 'ASSESSMENT_IMAGE',
  /** BLANK_SIGNATURE_LINE */
  BlankSignatureLine = 'BLANK_SIGNATURE_LINE',
  /** CHECKBOX */
  Checkbox = 'CHECKBOX',
  /** COORDINATION_OF_CARE */
  CoordinationOfCare = 'COORDINATION_OF_CARE',
  /** DATE */
  Date = 'DATE',
  /** DATETIME */
  Datetime = 'DATETIME',
  /** DSM_TABLE */
  DsmTable = 'DSM_TABLE',
  /** IMAGE */
  Image = 'IMAGE',
  /** RADIO */
  Radio = 'RADIO',
  /** SELECT */
  Select = 'SELECT',
  /** SIMPLE_TEXT */
  SimpleText = 'SIMPLE_TEXT',
  /** SPECIFIERS_TABLE */
  SpecifiersTable = 'SPECIFIERS_TABLE',
  /** TABLE */
  Table = 'TABLE',
  /** TREATMENT_OPTION_TABLE */
  TreatmentOptionTable = 'TREATMENT_OPTION_TABLE',
  /** TREATMENT_PLAN */
  TreatmentPlan = 'TREATMENT_PLAN',
  /** TYPED_SIGNATURE */
  TypedSignature = 'TYPED_SIGNATURE',
  /** WET_SIGNATURE */
  WetSignature = 'WET_SIGNATURE',
  /** WYSIWYG */
  Wysiwyg = 'WYSIWYG'
}

/** An enumeration. */
export enum ApiReportSectionsAiGeneratedStatusChoices {
  /** FAILURE */
  Failure = 'FAILURE',
  /** MANUAL_ENTRY */
  ManualEntry = 'MANUAL_ENTRY',
  /** PENDING */
  Pending = 'PENDING',
  /** SECTION_PREDICTION_PENDING */
  SectionPredictionPending = 'SECTION_PREDICTION_PENDING',
  /** SECTION_PREDICTION_PREDICTED */
  SectionPredictionPredicted = 'SECTION_PREDICTION_PREDICTED'
}

/** An enumeration. */
export enum ApiReportSuggestionGenerationStatusChoices {
  /** COMPLETED */
  Completed = 'COMPLETED',
  /** FAILURE */
  Failure = 'FAILURE',
  /** IN_PROGRESS */
  InProgress = 'IN_PROGRESS'
}

/** An enumeration. */
export enum ApiReportTargetAiProgressSummaryPredictionStatusChoices {
  /** FAILURE */
  Failure = 'FAILURE',
  /** GOAL_PREDICTION_PENDING */
  GoalPredictionPending = 'GOAL_PREDICTION_PENDING',
  /** GOAL_PREDICTION_PREDICTED */
  GoalPredictionPredicted = 'GOAL_PREDICTION_PREDICTED',
  /** GOAL_PREDICTION_SKIPPED */
  GoalPredictionSkipped = 'GOAL_PREDICTION_SKIPPED',
  /** PENDING */
  Pending = 'PENDING'
}

/** An enumeration. */
export enum ApiReportTargetChartTypeChoices {
  /** Avg Daily */
  AvgDaily = 'AVG_DAILY',
  /** Avg Monthly */
  AvgMonthly = 'AVG_MONTHLY',
  /** Avg Quarterly */
  AvgQuarterly = 'AVG_QUARTERLY',
  /** Avg Weekly */
  AvgWeekly = 'AVG_WEEKLY',
  /** Cumulative */
  Cumulative = 'CUMULATIVE',
  /** Progress */
  Progress = 'PROGRESS',
  /** Total Daily */
  TotalDaily = 'TOTAL_DAILY',
  /** Total Monthly */
  TotalMonthly = 'TOTAL_MONTHLY',
  /** Total Quarterly */
  TotalQuarterly = 'TOTAL_QUARTERLY',
  /** Total Weekly */
  TotalWeekly = 'TOTAL_WEEKLY'
}

/** An enumeration. */
export enum ApiReportTargetGoalBankTimelineEstimationTypeChoices {
  /** Days */
  Days = 'DAYS',
  /** Months */
  Months = 'MONTHS',
  /** Sessions */
  Sessions = 'SESSIONS',
  /** WEEKS */
  Weeks = 'WEEKS'
}

/** An enumeration. */
export enum ApiReportTargetProgressTypeChoices {
  /** Duration */
  Duration = 'DURATION',
  /** Frequency */
  Frequency = 'FREQUENCY',
  /** Interval */
  Interval = 'INTERVAL',
  /** Rate */
  Rate = 'RATE',
  /** Scale */
  Scale = 'SCALE',
  /** Task Analysis */
  TaskAnalysis = 'TASK_ANALYSIS',
  /** Trial */
  Trial = 'TRIAL'
}

/** An enumeration. */
export enum ApiReportTargetStatusChoices {
  /** Continued */
  Continued = 'CONTINUED',
  /** Discontinued */
  Discontinued = 'DISCONTINUED',
  /** Met */
  Met = 'MET',
  /** New Goal */
  NewGoal = 'NEW_GOAL',
  /** On Hold */
  OnHold = 'ON_HOLD',
  /** Revised */
  Revised = 'REVISED'
}

/** An enumeration. */
export enum ApiReportTargetTimelineEstimationTypeChoices {
  /** Days */
  Days = 'DAYS',
  /** Months */
  Months = 'MONTHS',
  /** Sessions */
  Sessions = 'SESSIONS',
  /** WEEKS */
  Weeks = 'WEEKS'
}

/** An enumeration. */
export enum ApiReportTemplateExportFrameworkChoices {
  /** DOCXTEMPLATER */
  Docxtemplater = 'DOCXTEMPLATER',
  /** GOOGLE_DOCS */
  GoogleDocs = 'GOOGLE_DOCS',
  /** HANDLEBARS */
  Handlebars = 'HANDLEBARS'
}

/** An enumeration. */
export enum ApiReportTemplateExportTemplateFontChoices {
  /** Arial */
  Arial = 'ARIAL',
  /** Calibri */
  Calibri = 'CALIBRI',
  /** Century Gothic */
  CenturyGothic = 'CENTURY_GOTHIC',
  /** Georgia */
  Georgia = 'GEORGIA',
  /** Public Sans */
  PublicSans = 'PUBLIC_SANS',
  /** Times New Roman */
  TimesNewRoman = 'TIMES_NEW_ROMAN'
}

/** An enumeration. */
export enum ApiReportTemplateFileUploadConfigChoices {
  /** ABC_KUWAIT */
  AbcKuwait = 'ABC_KUWAIT',
  /** CATALIGHT */
  Catalight = 'CATALIGHT',
  /** DEFAULT */
  Default = 'DEFAULT'
}

/** An enumeration. */
export enum ApiReportTemplatePayorTypeChoices {
  /** AETNA */
  Aetna = 'AETNA',
  /** ANTHEM */
  Anthem = 'ANTHEM',
  /** BCBS */
  Bcbs = 'BCBS',
  /** BEACON_HEALTH_OPTIONS */
  BeaconHealthOptions = 'BEACON_HEALTH_OPTIONS',
  /** BSW */
  Bsw = 'BSW',
  /** CATALIGHT */
  Catalight = 'CATALIGHT',
  /** CIGNA */
  Cigna = 'CIGNA',
  /** EMI_HEALTH */
  EmiHealth = 'EMI_HEALTH',
  /** EVERNORTH */
  Evernorth = 'EVERNORTH',
  /** HUMANA */
  Humana = 'HUMANA',
  /** KAISER_PERMANENTE */
  KaiserPermanente = 'KAISER_PERMANENTE',
  /** MAGELLAN_HEALTH */
  MagellanHealth = 'MAGELLAN_HEALTH',
  /** MEDICAID */
  Medicaid = 'MEDICAID',
  /** MOLINA */
  Molina = 'MOLINA',
  /** OPTUM */
  Optum = 'OPTUM',
  /** TRICARE */
  Tricare = 'TRICARE',
  /** UNITED_HEALTHCARE */
  UnitedHealthcare = 'UNITED_HEALTHCARE'
}

/** An enumeration. */
export enum ApiReportTemplateReportTypeChoices {
  /** DIAGNOSIS_EVALUATION */
  DiagnosisEvaluation = 'DIAGNOSIS_EVALUATION',
  /** INITIAL_ASSESSMENT */
  InitialAssessment = 'INITIAL_ASSESSMENT',
  /** REASSESSMENT */
  Reassessment = 'REASSESSMENT'
}

/** An enumeration. */
export enum ApiReportTemplateSampleStatusChoices {
  /** COMPLETED */
  Completed = 'COMPLETED',
  /** FAILURE */
  Failure = 'FAILURE',
  /** GENERATING */
  Generating = 'GENERATING',
  /** PENDING */
  Pending = 'PENDING'
}

/** An enumeration. */
export enum ApiReportTemplateSectionFieldFieldTypeChoices {
  /** ASSESSMENT_APPOINTMENTS */
  AssessmentAppointments = 'ASSESSMENT_APPOINTMENTS',
  /** ASSESSMENT_IMAGE */
  AssessmentImage = 'ASSESSMENT_IMAGE',
  /** BLANK_SIGNATURE_LINE */
  BlankSignatureLine = 'BLANK_SIGNATURE_LINE',
  /** CHECKBOX */
  Checkbox = 'CHECKBOX',
  /** COORDINATION_OF_CARE */
  CoordinationOfCare = 'COORDINATION_OF_CARE',
  /** DATE */
  Date = 'DATE',
  /** DATETIME */
  Datetime = 'DATETIME',
  /** DSM_TABLE */
  DsmTable = 'DSM_TABLE',
  /** IMAGE */
  Image = 'IMAGE',
  /** RADIO */
  Radio = 'RADIO',
  /** SELECT */
  Select = 'SELECT',
  /** SIMPLE_TEXT */
  SimpleText = 'SIMPLE_TEXT',
  /** SPECIFIERS_TABLE */
  SpecifiersTable = 'SPECIFIERS_TABLE',
  /** TABLE */
  Table = 'TABLE',
  /** TREATMENT_OPTION_TABLE */
  TreatmentOptionTable = 'TREATMENT_OPTION_TABLE',
  /** TREATMENT_PLAN */
  TreatmentPlan = 'TREATMENT_PLAN',
  /** TYPED_SIGNATURE */
  TypedSignature = 'TYPED_SIGNATURE',
  /** WET_SIGNATURE */
  WetSignature = 'WET_SIGNATURE',
  /** WYSIWYG */
  Wysiwyg = 'WYSIWYG'
}

/** An enumeration. */
export enum ApiReportTemplateSectionPageLocationChoices {
  /** appendix */
  Appendix = 'APPENDIX',
  /** conclusions */
  Conclusions = 'CONCLUSIONS',
  /** recommendations */
  Recommendations = 'RECOMMENDATIONS',
  /** report-part-1 */
  ReportPart_1 = 'REPORT_PART_1',
  /** report-part-2 */
  ReportPart_2 = 'REPORT_PART_2',
  /** treatment-plan */
  TreatmentPlan = 'TREATMENT_PLAN'
}

/** An enumeration. */
export enum ApiReportTemplateStatusChoices {
  /** Archived */
  Archived = 'ARCHIVED',
  /** Draft */
  Draft = 'DRAFT',
  /** Published */
  Published = 'PUBLISHED'
}

/** An enumeration. */
export enum ApiReportTreatmentPlanAiGoalProgressSummaryPredictionStatusChoices {
  /** FAILURE */
  Failure = 'FAILURE',
  /** GOAL_PREDICTION_PENDING */
  GoalPredictionPending = 'GOAL_PREDICTION_PENDING',
  /** GOAL_PREDICTION_PREDICTED */
  GoalPredictionPredicted = 'GOAL_PREDICTION_PREDICTED',
  /** GOAL_PREDICTION_SKIPPED */
  GoalPredictionSkipped = 'GOAL_PREDICTION_SKIPPED',
  /** PENDING */
  Pending = 'PENDING'
}

/** An enumeration. */
export enum ApiReportTreatmentPlanAiGoalSuggestionStatusChoices {
  /** FAILURE */
  Failure = 'FAILURE',
  /** GOAL_PREDICTION_PENDING */
  GoalPredictionPending = 'GOAL_PREDICTION_PENDING',
  /** GOAL_PREDICTION_PREDICTED */
  GoalPredictionPredicted = 'GOAL_PREDICTION_PREDICTED',
  /** GOAL_PREDICTION_SKIPPED */
  GoalPredictionSkipped = 'GOAL_PREDICTION_SKIPPED',
  /** PENDING */
  Pending = 'PENDING'
}

/** An enumeration. */
export enum ApiReportTreatmentPlanAiLtgPredictionStatusChoices {
  /** FAILURE */
  Failure = 'FAILURE',
  /** GOAL_PREDICTION_PENDING */
  GoalPredictionPending = 'GOAL_PREDICTION_PENDING',
  /** GOAL_PREDICTION_PREDICTED */
  GoalPredictionPredicted = 'GOAL_PREDICTION_PREDICTED',
  /** GOAL_PREDICTION_SKIPPED */
  GoalPredictionSkipped = 'GOAL_PREDICTION_SKIPPED',
  /** PENDING */
  Pending = 'PENDING'
}

/** An enumeration. */
export enum ApiReportTreatmentPlanAiPrioritizeStatusChoices {
  /** FAILURE */
  Failure = 'FAILURE',
  /** PENDING */
  Pending = 'PENDING',
  /** PREDICTION_PENDING */
  PredictionPending = 'PREDICTION_PENDING',
  /** PREDICTION_PREDICTED */
  PredictionPredicted = 'PREDICTION_PREDICTED'
}

/** An enumeration. */
export enum ApiReportTreatmentPlanAiStgPredictionStatusChoices {
  /** FAILURE */
  Failure = 'FAILURE',
  /** GOAL_PREDICTION_PENDING */
  GoalPredictionPending = 'GOAL_PREDICTION_PENDING',
  /** GOAL_PREDICTION_PREDICTED */
  GoalPredictionPredicted = 'GOAL_PREDICTION_PREDICTED',
  /** GOAL_PREDICTION_SKIPPED */
  GoalPredictionSkipped = 'GOAL_PREDICTION_SKIPPED',
  /** PENDING */
  Pending = 'PENDING'
}

/** An enumeration. */
export enum ApiReportTreatmentPlanAiTargetPredictionStatusChoices {
  /** FAILURE */
  Failure = 'FAILURE',
  /** GOAL_PREDICTION_PENDING */
  GoalPredictionPending = 'GOAL_PREDICTION_PENDING',
  /** GOAL_PREDICTION_PREDICTED */
  GoalPredictionPredicted = 'GOAL_PREDICTION_PREDICTED',
  /** GOAL_PREDICTION_SKIPPED */
  GoalPredictionSkipped = 'GOAL_PREDICTION_SKIPPED',
  /** PENDING */
  Pending = 'PENDING'
}

/** An enumeration. */
export enum ApiScraperLearnerImportStatusStatusChoices {
  /** FAILURE */
  Failure = 'FAILURE',
  /** IN_PROGRESS */
  InProgress = 'IN_PROGRESS',
  /** PENDING */
  Pending = 'PENDING',
  /** SUCCESS */
  Success = 'SUCCESS'
}

/** An enumeration. */
export enum ApiScraperLoginStatusChoices {
  /** CAPTCHA_ERROR */
  CaptchaError = 'CAPTCHA_ERROR',
  /** CONNECTION_ERROR */
  ConnectionError = 'CONNECTION_ERROR',
  /** FAILED_CREDS */
  FailedCreds = 'FAILED_CREDS',
  /** FAILED_MFA */
  FailedMfa = 'FAILED_MFA',
  /** LOGGING_IN */
  LoggingIn = 'LOGGING_IN',
  /** LOGIN_ATTEMPTS_EXHAUSTED */
  LoginAttemptsExhausted = 'LOGIN_ATTEMPTS_EXHAUSTED',
  /** MFA_NOT_SUPPORTED */
  MfaNotSupported = 'MFA_NOT_SUPPORTED',
  /** MFA_REQUIRED */
  MfaRequired = 'MFA_REQUIRED',
  /** PROXY_ERROR */
  ProxyError = 'PROXY_ERROR',
  /** SUCCESS */
  Success = 'SUCCESS'
}

/** An enumeration. */
export enum ApiScraperSessionWorkflowEhrIntegrationTypeChoices {
  /** DATA_WAREHOUSE */
  DataWarehouse = 'DATA_WAREHOUSE',
  /** ORG_USERNAME_PASSWORD */
  OrgUsernamePassword = 'ORG_USERNAME_PASSWORD',
  /** STANDARD */
  Standard = 'STANDARD'
}

/** An enumeration. */
export enum ApiScraperSessionWorkflowStatusChoices {
  /** CONNECTED */
  Connected = 'CONNECTED',
  /** CONNECTION_ERROR */
  ConnectionError = 'CONNECTION_ERROR',
  /** CREDENTIALS_FAILED */
  CredentialsFailed = 'CREDENTIALS_FAILED',
  /** DISCONNECTED */
  Disconnected = 'DISCONNECTED',
  /** EXPORTING_TREATMENT_PLAN */
  ExportingTreatmentPlan = 'EXPORTING_TREATMENT_PLAN',
  /** IMPORTING_CLIENT_LIST */
  ImportingClientList = 'IMPORTING_CLIENT_LIST',
  /** IMPORTING_TREATMENT_PLAN */
  ImportingTreatmentPlan = 'IMPORTING_TREATMENT_PLAN',
  /** LOGGING_IN */
  LoggingIn = 'LOGGING_IN',
  /** RECONNECTING */
  Reconnecting = 'RECONNECTING'
}

/** An enumeration. */
export enum ApiSessionAiPredictionPredictionTypeChoices {
  /** PARENT_SUMMARY */
  ParentSummary = 'PARENT_SUMMARY',
  /** SESSION_SUMMARY */
  SessionSummary = 'SESSION_SUMMARY'
}

/** An enumeration. */
export enum ApiSessionEngagementInsightInsightTypeChoices {
  /** disengagement */
  Disengagement = 'DISENGAGEMENT',
  /** engagement */
  Engagement = 'ENGAGEMENT'
}

/** An enumeration. */
export enum ApiSessionMediaReviewActivityLogActivityTypeChoices {
  /** TIME_SPENT */
  TimeSpent = 'TIME_SPENT'
}

/** An enumeration. */
export enum ApiSessionNoteQaTypeChoices {
  /** MULTI_SELECT */
  MultiSelect = 'MULTI_SELECT',
  /** SINGLE_SELECT */
  SingleSelect = 'SINGLE_SELECT',
  /** TEXT */
  Text = 'TEXT'
}

/** An enumeration. */
export enum ApiSessionProviderProviderTypeChoices {
  /** DATA_COLLECTION */
  DataCollection = 'DATA_COLLECTION',
  /** RECORDER */
  Recorder = 'RECORDER'
}

/** An enumeration. */
export enum ApiSessionTargetProgressProgressTypeChoices {
  /** Duration */
  Duration = 'DURATION',
  /** Frequency */
  Frequency = 'FREQUENCY',
  /** Interval */
  Interval = 'INTERVAL',
  /** Rate */
  Rate = 'RATE',
  /** Scale */
  Scale = 'SCALE',
  /** Task Analysis */
  TaskAnalysis = 'TASK_ANALYSIS',
  /** Trial */
  Trial = 'TRIAL'
}

/** An enumeration. */
export enum ApiTaskStatusChoices {
  /** FAILED */
  Failed = 'FAILED',
  /** PENDING */
  Pending = 'PENDING',
  /** PROCESSING */
  Processing = 'PROCESSING',
  /** SUCCESS */
  Success = 'SUCCESS'
}

/** An enumeration. */
export enum ApiTaskTypeChoices {
  /** FILE_UPLOAD */
  FileUpload = 'FILE_UPLOAD',
  /** MEDIA_UPLOAD */
  MediaUpload = 'MEDIA_UPLOAD'
}

/** An enumeration. */
export enum ApiTherapySessionSessionTypeChoices {
  /** EHR */
  Ehr = 'EHR',
  /** EHR_AND_VIDEO */
  EhrAndVideo = 'EHR_AND_VIDEO',
  /** VIDEO */
  Video = 'VIDEO'
}

/** An enumeration. */
export enum ApiTherapySessionStatusChoices {
  /** COMPLETED */
  Completed = 'COMPLETED',
  /** FAILED */
  Failed = 'FAILED',
  /** IN_PROGRESS */
  InProgress = 'IN_PROGRESS',
  /** PENDING */
  Pending = 'PENDING',
  /** SCHEDULED */
  Scheduled = 'SCHEDULED'
}

/** An enumeration. */
export enum ApiTherapzGoalDataCollectionTypeChoices {
  /** TPZ_DURATION */
  TpzDuration = 'TPZ_DURATION',
  /** TPZ_FREQUENCY */
  TpzFrequency = 'TPZ_FREQUENCY',
  /** TPZ_INTERVAL */
  TpzInterval = 'TPZ_INTERVAL',
  /** TPZ_TASK_ANALYSIS */
  TpzTaskAnalysis = 'TPZ_TASK_ANALYSIS',
  /** TPZ_TRIAL */
  TpzTrial = 'TPZ_TRIAL'
}

/** An enumeration. */
export enum ApiTherapzGoalTypeChoices {
  /** TPZ_BEHAVIOR */
  TpzBehavior = 'TPZ_BEHAVIOR',
  /** TPZ_SKILL */
  TpzSkill = 'TPZ_SKILL'
}

/** An enumeration. */
export enum ApiTranscriptTranscriptModelChoices {
  /** aaitranscribe */
  Aaitranscribe = 'AAITRANSCRIBE',
  /** awstranscribe */
  Awstranscribe = 'AWSTRANSCRIBE',
  /** internalasr */
  Internalasr = 'INTERNALASR',
  /** oldinternalasr */
  Oldinternalasr = 'OLDINTERNALASR',
  /** speakerid */
  Speakerid = 'SPEAKERID'
}

/** An enumeration. */
export enum ApiTranscriptTranscriptTypeChoices {
  /** transcriptjson */
  Transcriptjson = 'TRANSCRIPTJSON',
  /** transcriptsrt */
  Transcriptsrt = 'TRANSCRIPTSRT',
  /** transcripttxt */
  Transcripttxt = 'TRANSCRIPTTXT',
  /** transcriptvtt */
  Transcriptvtt = 'TRANSCRIPTVTT'
}

/** An enumeration. */
export enum ApiTreatmentPlanCustomFieldFieldTypeChoices {
  /** CHECKBOX */
  Checkbox = 'CHECKBOX',
  /** DATE */
  Date = 'DATE',
  /** DATETIME */
  Datetime = 'DATETIME',
  /** IMAGE */
  Image = 'IMAGE',
  /** RADIO */
  Radio = 'RADIO',
  /** SELECT */
  Select = 'SELECT',
  /** SIMPLE_TEXT */
  SimpleText = 'SIMPLE_TEXT',
  /** TABLE */
  Table = 'TABLE',
  /** WYSIWYG */
  Wysiwyg = 'WYSIWYG'
}

/** An enumeration. */
export enum ApiTreatmentPlanTemplateAiGenerationConfigChoices {
  /** GOALS_AND_TARGETS */
  GoalsAndTargets = 'GOALS_AND_TARGETS',
  /** GOALS_ONLY */
  GoalsOnly = 'GOALS_ONLY',
  /** NO_AI_GENERATION */
  NoAiGeneration = 'NO_AI_GENERATION'
}

/** An enumeration. */
export enum ApiTreatmentPlanTemplateFieldFieldTypeChoices {
  /** CHECKBOX */
  Checkbox = 'CHECKBOX',
  /** DATE */
  Date = 'DATE',
  /** DATETIME */
  Datetime = 'DATETIME',
  /** IMAGE */
  Image = 'IMAGE',
  /** RADIO */
  Radio = 'RADIO',
  /** SELECT */
  Select = 'SELECT',
  /** SIMPLE_TEXT */
  SimpleText = 'SIMPLE_TEXT',
  /** TABLE */
  Table = 'TABLE',
  /** WYSIWYG */
  Wysiwyg = 'WYSIWYG'
}

/** An enumeration. */
export enum ApiTreatmentPlanTemplateFieldTypeChoices {
  /** DOMAIN */
  Domain = 'DOMAIN',
  /** GOAL */
  Goal = 'GOAL',
  /** TARGET */
  Target = 'TARGET'
}

/** An enumeration. */
export enum ApiUserBillingDetailsPaymentStatusChoices {
  /** cancelled */
  Cancelled = 'CANCELLED',
  /** pending */
  Pending = 'PENDING',
  /** success */
  Success = 'SUCCESS'
}

/** An enumeration. */
export enum ApiUserBillingDetailsTransactionTypeChoices {
  /** credit */
  Credit = 'CREDIT',
  /** debit */
  Debit = 'DEBIT'
}

/** An enumeration. */
export enum ApiUserNotificationDeviceTokensDeviceTypeChoices {
  /** android */
  Android = 'ANDROID',
  /** ios */
  Ios = 'IOS'
}

/** An enumeration. */
export enum ApiVideoSessionRecorderTypeChoices {
  /** CAREGIVER */
  Caregiver = 'CAREGIVER',
  /** INCLINIC */
  Inclinic = 'INCLINIC',
  /** OTHER */
  Other = 'OTHER',
  /** THERAPIST */
  Therapist = 'THERAPIST'
}

/** An enumeration. */
export enum ApiVideoSessionSessionStatusChoices {
  /** COMPLETED */
  Completed = 'COMPLETED',
  /** CREATED */
  Created = 'CREATED',
  /** FAILED */
  Failed = 'FAILED',
  /** FULL_CAPTURE_ERROR */
  FullCaptureError = 'FULL_CAPTURE_ERROR',
  /** PARTIAL_CAPTURE_ERROR */
  PartialCaptureError = 'PARTIAL_CAPTURE_ERROR',
  /** PARTIAL_UPLOAD_ERROR */
  PartialUploadError = 'PARTIAL_UPLOAD_ERROR',
  /** PROCESSING */
  Processing = 'PROCESSING',
  /** RECORDING */
  Recording = 'RECORDING',
  /** SCHEDULED */
  Scheduled = 'SCHEDULED',
  /** UPLOADING */
  Uploading = 'UPLOADING'
}

/** An enumeration. */
export enum ApiVideoSessionSourceTypeChoices {
  /** IN_APP_VIDEO_RECORDING */
  InAppVideoRecording = 'IN_APP_VIDEO_RECORDING',
  /** USER_VIDEO_UPLOAD */
  UserVideoUpload = 'USER_VIDEO_UPLOAD'
}

/**
 * Marks the comment applied. Does not write to the report field's live
 * content -- that happens through a separate, already-existing field-update
 * mutation on the frontend.
 */
export type ApplyReportComment = {
  __typename?: 'ApplyReportComment';
  comment?: Maybe<ReportCommentType>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

/**
 * Archive every learner in the organization whose external id is not in
 * ``active_external_ids``.
 *
 * Used by the Passage full-roster reconcile sync: the caller passes the
 * complete set of external client ids currently present in the source EHR
 * for the org, and this archives the learners that no longer appear there.
 * The archive is scoped to the single organization resolved from
 * ``organization_external_id`` and only touches EHR-synced learners
 * (``external_id`` is not null), leaving Frontera-native learners alone.
 */
export type ArchiveExternalClientsNotIn = {
  __typename?: 'ArchiveExternalClientsNotIn';
  archivedCount?: Maybe<Scalars['Int']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type ArchiveExternalClientsNotInInput = {
  activeExternalIds: Array<InputMaybe<Scalars['String']['input']>>;
  organizationExternalId: Scalars['String']['input'];
};

export type ArchiveOrUnArchiveLearnerReport = {
  __typename?: 'ArchiveOrUnArchiveLearnerReport';
  message?: Maybe<Scalars['String']['output']>;
  report?: Maybe<ReportType>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type AssessmentToolType = {
  __typename?: 'AssessmentToolType';
  categories?: Maybe<Array<Maybe<DiagnosisEvaluationAssessmentToolCategoriesEnum>>>;
  id?: Maybe<Scalars['String']['output']>;
  multipleFileUpload?: Maybe<Scalars['Boolean']['output']>;
  parsingSupported?: Maybe<Scalars['Boolean']['output']>;
  primary?: Maybe<Scalars['String']['output']>;
  reportType?: Maybe<ReportTypeEnums>;
  secondary?: Maybe<Scalars['String']['output']>;
  supportedFileSource?: Maybe<Array<Maybe<LearnerFileAssessmentTemplateTypeEnums>>>;
  supportedFileTypes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type AssignAnnotaterToMedia = {
  __typename?: 'AssignAnnotaterToMedia';
  media?: Maybe<MediaType>;
};

export type Authorizations = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  authorizationId?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['Date']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
};

export type AvailabilityInput = {
  slots?: InputMaybe<Array<InputMaybe<LearnerAvailabilityInput>>>;
};

/**
 * Enum for OnSched availability types that dictates availabilty calculations
 *
 * ALLOCATION: Service/resource uses allocations (one-off "available" time blocks where remainder of time is not available by default )
 * SCHEDULE: Service/resource uses scheduled availability (one-off "not available" time blocks where remainder of time is available by default and configured via recurring week rules)
 */
export enum AvailabilityTypeEnum {
  Allocation = 'ALLOCATION',
  Schedule = 'SCHEDULE'
}

export type AvgQuestionAskedPerVideoGraphType = {
  __typename?: 'AvgQuestionAskedPerVideoGraphType';
  currentAvgQuestionsAskedPerVideo?: Maybe<Scalars['Int']['output']>;
  currentTotalQuestionsAsked?: Maybe<Scalars['Int']['output']>;
  date?: Maybe<Scalars['String']['output']>;
  previousAvgQuestionsAskedPerVideo?: Maybe<Scalars['Int']['output']>;
  previousTotalQuestionsAsked?: Maybe<Scalars['Int']['output']>;
};

export type AvgResponseTimeForBcbaQuestionGraphType = {
  __typename?: 'AvgResponseTimeForBCBAQuestionGraphType';
  currentAvgResponseTime?: Maybe<Scalars['Float']['output']>;
  date?: Maybe<Scalars['String']['output']>;
  previousAvgResponseTime?: Maybe<Scalars['Float']['output']>;
};

export type BcbaCommentsDistributionRawDataType = {
  __typename?: 'BCBACommentsDistributionRawDataType';
  rawData?: Maybe<Array<Maybe<BcbaCommentsDistributionRawTextDataType>>>;
  totalRecordsCount?: Maybe<Scalars['Int']['output']>;
};

export type BcbaCommentsDistributionRawTextDataType = {
  __typename?: 'BCBACommentsDistributionRawTextDataType';
  bcbaName?: Maybe<Scalars['String']['output']>;
  clientId?: Maybe<Scalars['Int']['output']>;
  clientName?: Maybe<Scalars['String']['output']>;
  commentTypeCounts?: Maybe<CommentsDataType>;
  sessionDate?: Maybe<Scalars['Date']['output']>;
  sessionDatetime?: Maybe<Scalars['DateTime']['output']>;
  sessionDuration?: Maybe<Scalars['Float']['output']>;
  totalComments?: Maybe<Scalars['Int']['output']>;
};

export type BcbaSessionAnalyticsVideosDataType = {
  __typename?: 'BCBASessionAnalyticsVideosDataType';
  averageCommentLeftByBcbaPerVideo?: Maybe<Scalars['Int']['output']>;
  averageResponseRateToRbtQuestions?: Maybe<Scalars['Int']['output']>;
  averageResponseTimeToRbtQuestions?: Maybe<Scalars['Float']['output']>;
  averageReviewCompletionTime?: Maybe<Scalars['Float']['output']>;
  averageSessionsReviewedByBcba?: Maybe<Scalars['Int']['output']>;
  commentsData?: Maybe<CommentsDataType>;
  totalVideosCount?: Maybe<Scalars['Int']['output']>;
  videosReviewedPercentage?: Maybe<Scalars['Int']['output']>;
};

export type BcbaSessionAnalyticsVideosType = {
  __typename?: 'BCBASessionAnalyticsVideosType';
  comparisonData?: Maybe<BcbaSessionAnalyticsVideosDataType>;
  currentData?: Maybe<BcbaSessionAnalyticsVideosDataType>;
};

export type BackfillOrganizationUserRoles = {
  __typename?: 'BackfillOrganizationUserRoles';
  message?: Maybe<Scalars['String']['output']>;
  organizationUserRoles?: Maybe<Array<Maybe<OrganizationUserRolesType>>>;
  status?: Maybe<Scalars['Boolean']['output']>;
  usersWithError?: Maybe<Array<Maybe<Scalars['JSONString']['output']>>>;
};

export type BackfillOrganizationUserRolesInput = {
  organizationId: Scalars['ID']['input'];
};

export type BackfillSelfServeUserRoles = {
  __typename?: 'BackfillSelfServeUserRoles';
  message?: Maybe<Scalars['String']['output']>;
  organizationUserRoles?: Maybe<Array<Maybe<OrganizationUserRolesType>>>;
  status?: Maybe<Scalars['Boolean']['output']>;
  usersWithError?: Maybe<Array<Maybe<Scalars['JSONString']['output']>>>;
};

export type BaseEhrInput = {
  ehrId: Scalars['String']['input'];
  fdmId: Scalars['ID']['input'];
  title: Scalars['String']['input'];
};

/** Core field types shared across all BaseField subclasses. */
export enum BaseFieldType {
  Checkbox = 'CHECKBOX',
  Date = 'DATE',
  Datetime = 'DATETIME',
  Image = 'IMAGE',
  Radio = 'RADIO',
  Select = 'SELECT',
  SimpleText = 'SIMPLE_TEXT',
  Table = 'TABLE',
  Wysiwyg = 'WYSIWYG'
}

export type BeaconCameraConfigType = Node & {
  __typename?: 'BeaconCameraConfigType';
  beacon: Scalars['String']['output'];
  camera: Scalars['String']['output'];
  clinic?: Maybe<Scalars['String']['output']>;
  createdDate: Scalars['DateTime']['output'];
  /** The ID of the object */
  id: Scalars['ID']['output'];
  lastUpdatedDate: Scalars['DateTime']['output'];
  organization: OrganizationType;
  pk?: Maybe<Scalars['Int']['output']>;
};

export enum BehaviorsQuestionType {
  BehaviorTrendRecentWeeks = 'BEHAVIOR_TREND_RECENT_WEEKS',
  BigChangesVsLittleChanges = 'BIG_CHANGES_VS_LITTLE_CHANGES',
  EffectiveBehaviorStrategies = 'EFFECTIVE_BEHAVIOR_STRATEGIES',
  ExcessiveActivities = 'EXCESSIVE_ACTIVITIES',
  FavoriteFoodDrinks = 'FAVORITE_FOOD_DRINKS',
  FavoriteSocialActivity = 'FAVORITE_SOCIAL_ACTIVITY',
  FavoriteTechnology = 'FAVORITE_TECHNOLOGY',
  FavoriteThings = 'FAVORITE_THINGS',
  FavoriteToysAndPlayItems = 'FAVORITE_TOYS_AND_PLAY_ITEMS',
  InsistsOnCertainThings = 'INSISTS_ON_CERTAIN_THINGS',
  IrritatedBySoundsSmellsFeels = 'IRRITATED_BY_SOUNDS_SMELLS_FEELS',
  IsPickyOrRestrictiveDiet = 'IS_PICKY_OR_RESTRICTIVE_DIET',
  LiningObjectsUp = 'LINING_OBJECTS_UP',
  MostConcernedBehaviors = 'MOST_CONCERNED_BEHAVIORS',
  MovementActivities = 'MOVEMENT_ACTIVITIES',
  OddInterestsForAge = 'ODD_INTERESTS_FOR_AGE',
  OddOrStrangeMovements = 'ODD_OR_STRANGE_MOVEMENTS',
  OversensitiveToSensoryStimuli = 'OVERSENSITIVE_TO_SENSORY_STIMULI',
  OverFocusedOnSpecificParts = 'OVER_FOCUSED_ON_SPECIFIC_PARTS',
  PlayingWithToyAsIntended = 'PLAYING_WITH_TOY_AS_INTENDED',
  PlayDescription = 'PLAY_DESCRIPTION',
  PlayWithOthers = 'PLAY_WITH_OTHERS',
  PretendPlay = 'PRETEND_PLAY',
  RepeatedActivities = 'REPEATED_ACTIVITIES',
  RepeatedTvPrograms = 'REPEATED_TV_PROGRAMS',
  RepetitiveMovements = 'REPETITIVE_MOVEMENTS',
  RigidChangingMindOrPerspectives = 'RIGID_CHANGING_MIND_OR_PERSPECTIVES',
  RigidRoutines = 'RIGID_ROUTINES',
  SeekingSpecificSensoryExperiences = 'SEEKING_SPECIFIC_SENSORY_EXPERIENCES',
  SignsOfSelfInjury = 'SIGNS_OF_SELF_INJURY',
  SignsOfTantrumsOrAggression = 'SIGNS_OF_TANTRUMS_OR_AGGRESSION',
  SleepTroubleStart = 'SLEEP_TROUBLE_START',
  TroubleFallingOrStayingAsleep = 'TROUBLE_FALLING_OR_STAYING_ASLEEP',
  TypicalInterestsForAge = 'TYPICAL_INTERESTS_FOR_AGE',
  VisualInspection = 'VISUAL_INSPECTION',
  WalkingTalkingToiletTraining = 'WALKING_TALKING_TOILET_TRAINING',
  WhenFirstConcerned = 'WHEN_FIRST_CONCERNED'
}

export enum BillableSessionSummaryStatusEnums {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  InProgress = 'IN_PROGRESS',
  Pending = 'PENDING',
  Scheduled = 'SCHEDULED'
}

export type BillableSessionSummaryType = Node & {
  __typename?: 'BillableSessionSummaryType';
  createdDate: Scalars['DateTime']['output'];
  errorMessage?: Maybe<Scalars['String']['output']>;
  externalClientId?: Maybe<Scalars['String']['output']>;
  externalOrganizationId?: Maybe<Scalars['String']['output']>;
  externalProviderId?: Maybe<Scalars['String']['output']>;
  externalSessionId?: Maybe<Scalars['String']['output']>;
  /** The ID of the object */
  id: Scalars['ID']['output'];
  jobId: Scalars['UUID']['output'];
  lastUpdatedDate: Scalars['DateTime']['output'];
  organizationType?: Maybe<ApiBillableSessionSummaryOrganizationTypeChoices>;
  pk?: Maybe<Scalars['Int']['output']>;
  predictionId?: Maybe<Scalars['String']['output']>;
  providerFirstName?: Maybe<Scalars['String']['output']>;
  providerLastName?: Maybe<Scalars['String']['output']>;
  sessionCode?: Maybe<Scalars['String']['output']>;
  status: ApiBillableSessionSummaryStatusChoices;
  summaryGeneratedAt?: Maybe<Scalars['DateTime']['output']>;
  summaryText?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['String']['output']>;
};

/**
 * Mutation to book an appointment in Care
 *
 * This mutation creates an appointment booking between a Care Customer and a Care Resource for a Care Service
 */
export type BookCareAppointment = {
  __typename?: 'BookCareAppointment';
  appointment?: Maybe<CareAppointmentType>;
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

/**
 * Reassign multiple ReportGoals to new ReportDomains in a single mutation.
 * All records are fetched and validated before any DB write; a failure in any
 * item aborts the entire operation.
 */
export type BulkReassignReportGoals = {
  __typename?: 'BulkReassignReportGoals';
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type CrLearningTreeCheckType = {
  __typename?: 'CRLearningTreeCheckType';
  code: Scalars['String']['output'];
  externalId: Scalars['String']['output'];
  /** error blocks the lock */
  level: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

/** An in-use imported goal or target with no item in the tree. */
export type CrLearningTreeImportedItemType = {
  __typename?: 'CRLearningTreeImportedItemType';
  externalId: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
  /** GOAL or TARGET */
  role: Scalars['String']['output'];
};

export type CrLearningTreeNodeType = {
  __typename?: 'CRLearningTreeNodeType';
  /** Open reports where this item is approved; it can't change */
  approvedIn: Array<Scalars['String']['output']>;
  confirmAnswered: Scalars['Boolean']['output'];
  confirmKind?: Maybe<Scalars['String']['output']>;
  /** What CR calls the item: FOLDER, LTG, STG or TARGET (display only) */
  crLevel?: Maybe<Scalars['String']['output']>;
  crStatus?: Maybe<Scalars['String']['output']>;
  /** Set when the item records data */
  dataType?: Maybe<Scalars['String']['output']>;
  /** What CentralReach's UI calls the data type, e.g. Frequency */
  dataTypeLabel?: Maybe<Scalars['String']['output']>;
  /** CentralReach item id */
  externalId: Scalars['String']['output'];
  /** Of approved_in: reports where this target counts as approved only because its goal is */
  goalApprovedIn: Array<Scalars['String']['output']>;
  /** For a target: its goal */
  goalExternalId?: Maybe<Scalars['String']['output']>;
  /** False means a CR folder */
  hasGoal?: Maybe<Scalars['Boolean']['output']>;
  /** Display only */
  isBehavior?: Maybe<Scalars['Boolean']['output']>;
  locked: Scalars['Boolean']['output'];
  movedInCr: Scalars['Boolean']['output'];
  name?: Maybe<Scalars['String']['output']>;
  /** CR type: 'page', 'datapercent', … */
  nodeType?: Maybe<Scalars['String']['output']>;
  parentExternalId?: Maybe<Scalars['String']['output']>;
  /** Frontera's data collection type once imported, e.g. Trial */
  progressType?: Maybe<Scalars['String']['output']>;
  removed: Scalars['Boolean']['output'];
  role?: Maybe<Scalars['String']['output']>;
  roleSource?: Maybe<Scalars['String']['output']>;
  /** The suggestion rule's role (a hint) */
  ruleRole?: Maybe<Scalars['String']['output']>;
  sortOrder?: Maybe<Scalars['Int']['output']>;
  /** ACTIVE, WAITING or REMOVED */
  status?: Maybe<Scalars['String']['output']>;
  /** What Reset returns to: the imported role, else the rule's */
  suggestedRole?: Maybe<Scalars['String']['output']>;
  /** Open reports (only the report being edited, when given) that use this item's goal or target */
  usedIn: Array<Scalars['String']['output']>;
};

export type CrLearningTreeReportChangeType = {
  __typename?: 'CRLearningTreeReportChangeType';
  /** Approved in this report: blocks the lock */
  approved: Scalars['Boolean']['output'];
  externalId: Scalars['String']['output'];
  fromGoalName?: Maybe<Scalars['String']['output']>;
  /** MOVE, ARCHIVE_GOAL, ARCHIVE_TARGET, TARGET_TO_GOAL, GOAL_TO_TARGET */
  kind: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
  toGoalName?: Maybe<Scalars['String']['output']>;
};

/** What the next lock changes in one open (unsigned) report. */
export type CrLearningTreeReportImpactType = {
  __typename?: 'CRLearningTreeReportImpactType';
  changes: Array<CrLearningTreeReportChangeType>;
  label: Scalars['String']['output'];
  reportId: Scalars['ID']['output'];
};

export type CrLearningTreeRoleInput = {
  confirmAnswered?: InputMaybe<Scalars['Boolean']['input']>;
  externalId: Scalars['String']['input'];
  /** GOAL, TARGET, SKIP_ITEM, SKIP_BRANCH */
  role: Scalars['String']['input'];
  /** PERSON for the row the person set, FOLLOWS for cascade rows, RESET to put the row back to its suggestion (role is then ignored) */
  source?: InputMaybe<Scalars['String']['input']>;
};

export type CrLearningTreeType = {
  __typename?: 'CRLearningTreeType';
  checks: Array<CrLearningTreeCheckType>;
  importedNotInTree: Array<CrLearningTreeImportedItemType>;
  learningTreeId?: Maybe<Scalars['String']['output']>;
  nodes: Array<CrLearningTreeNodeType>;
  /** What the next lock changes in open reports */
  reportChanges: Array<CrLearningTreeReportImpactType>;
  /** The client's import status */
  status?: Maybe<Scalars['String']['output']>;
};

/**
 * Cancels a service by removing the payment intent on Stripe and updating the UserBillingDetails record.
 *
 * This mutation:
 * 1. Retrieves the UserBillingDetails record by payment_intent_id
 * 2. Cancels the payment intent on Stripe (if not already processed)
 * 3. Updates the UserBillingDetails record to mark it as cancelled
 * 4. Returns confirmation of the cancellation
 */
export type CancelService = {
  __typename?: 'CancelService';
  cancelledAmount?: Maybe<Scalars['Float']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  paymentIntentId?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

/**
 * GraphQL type for Care Appointment
 *
 * A Care Appointment represents a booking of a CareService at a CareLocation by a CareCustomer with a CareResource at a particular time.
 *
 *
 * (OnSched Note): For now these are stored and managed in OnSched and FDM is just a wrapper around
 * the OnSched API, but since we may want to move to our own system on day, we are abstracting
 * the API boundary and making the types as generic as possible.
 *
 * OnSched Equivalent Data Type: "Appointment" (https://docs.onsched.com/reference/get_v3-appointments-filter)
 */
export type CareAppointmentType = {
  __typename?: 'CareAppointmentType';
  appointmentMeetingLink?: Maybe<Scalars['String']['output']>;
  /** All custom fields as a JSON object with string values (e.g., {'language': 'Spanish', 'timezone': 'America/Denver'}) */
  customFields?: Maybe<Scalars['JSONString']['output']>;
  customerEmail?: Maybe<Scalars['String']['output']>;
  customerFirstName?: Maybe<Scalars['String']['output']>;
  customerLastName?: Maybe<Scalars['String']['output']>;
  /** ISO 8601 datetime string */
  endTime: Scalars['String']['output'];
  id: Scalars['String']['output'];
  locationId?: Maybe<Scalars['String']['output']>;
  locationName?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  resourceEmail?: Maybe<Scalars['String']['output']>;
  resourceId?: Maybe<Scalars['String']['output']>;
  resourceName?: Maybe<Scalars['String']['output']>;
  serviceId: Scalars['String']['output'];
  serviceName?: Maybe<Scalars['String']['output']>;
  /** ISO 8601 datetime string */
  startTime: Scalars['String']['output'];
  /** Appointment status: scheduled, confirmed, completed, cancelled, no-show */
  status: Scalars['String']['output'];
};

/**
 * GraphQL type for a Care Availability Slot
 *
 * A Care Availability Slot represents a bookable time slot for a particular CareService
 * at a particular CareLocation at a particular time. The duration between start_time and
 * end_time is the duration of the CareService being offered.
 *
 * These are returned from the careServiceAvailibility query and are calculated based on:
 * - the weekly availability rules at the CareLocation level
 * - the padding rules at the CareService level
 * - the availability type (allocations or schedule) at the CareService level
 * - the availability rules (recurring rules + one-off blockages / one-off allocations) at the CareService
 * - the availability type (allocations or schedule) at the CareResource level
 * - the availability rules (recurring rules + one-off blockages / one-off allocations) at the CareResource level
 * - any synced calendar configurations at the CareResource level
 *
 *
 * (OnSched Note): For now these are stored and managed in OnSched and FDM is just a wrapper around
 * the OnSched API, but since we may want to move to our own system on day, we are abstracting
 * the API boundary and making the types as generic as possible.
 *
 * OnSched Equivalent Data Type: "Availability" (https://docs.onsched.com/reference/get_v3-availability)
 */
export type CareAvailabilitySlotType = {
  __typename?: 'CareAvailabilitySlotType';
  /** ISO 8601 datetime string (e.g., 2025-01-15T11:00:00-06:00). This date-time format is crucial to be used exactly as it's returned as an Availability End time when booking an appointment. */
  endTime: Scalars['String']['output'];
  /** The ID of the CareLocation under which this availability slot is available. */
  locationId: Scalars['String']['output'];
  resourceEmail?: Maybe<Scalars['String']['output']>;
  /** The IDs of the CareResources that are available during this time slot. */
  resourceIds: Array<Maybe<Scalars['String']['output']>>;
  resourceName?: Maybe<Scalars['String']['output']>;
  /** The ID of the CareService being offered during this time slot. */
  serviceId: Scalars['String']['output'];
  /** ISO 8601 datetime string (e.g., 2025-01-15T10:00:00-06:00). This date-time format is crucial to be used exactly as it's returned as an Availability Start time when booking an appointment. */
  startTime: Scalars['String']['output'];
};

/**
 * GraphQL type for Care Availability
 *
 * Care Availability represents the total availability of a CareService at a CareLocation.
 * This is effectively a list of CareAvailabilitySlots
 *
 * (OnSched Note): For now these are stored and managed in OnSched and FDM is just a wrapper around
 * the OnSched API, but since we may want to move to our own system on day, we are abstracting
 * the API boundary and making the types as generic as possible.
 *
 *
 * OnSched Equivalent Data Type: "Availability" (https://docs.onsched.com/reference/get_v3-availability)
 */
export type CareAvailabilityType = {
  __typename?: 'CareAvailabilityType';
  availableTimes: Array<Maybe<CareAvailabilitySlotType>>;
  serviceId: Scalars['String']['output'];
};

/** Input type for customer information when booking */
export type CareCustomerAppointmentInputType = {
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
};

/**
 * GraphQL type for Care location
 *
 * The location (i.e. office) space/setting under which a CareService is being offered.
 * For now we effectively only have on location which is "Frontera Health Headquarters (Virtual)"
 *
 * It is worth noting that for now, we don't have much use for this but are representing here for full
 * parity with our current underlying Scheduling system (OnSched)
 *
 *
 * (OnSched Note): For now these are stored and managed in OnSched and FDM is just a wrapper around
 * the OnSched API, but since we may want to move to our own system on day, we are abstracting
 * the API boundary and making the types as generic as possible.
 *
 * OnSched Equivalent Data Type: "Location" (https://docs.onsched.com/reference/get_v3-locations)
 */
export type CareLocationType = {
  __typename?: 'CareLocationType';
  address?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

/**
 * GraphQL type for Care Resource Single Allocation Block
 *
 * A Care Resource Single Allocation Block represents a block of time that is marked as available
 * by a Care Resource. A Care Resource's availability is built up of a series of these blocks.
 *
 * A Single Allocation defines availability for a specific time slot for a date range.
 * For example: 8am-9am on 2025-11-01
 *
 * (OnSched Note): For now these are stored and managed in OnSched and FDM is just a wrapper around
 * the OnSched API, but since we may want to move to our own system on day, we are abstracting
 * the API boundary and making the types as generic as possible.
 *
 * OnSched Equivalent Data Type: "SingleAllocation" (https://docs.onsched.com/reference/get_v3-singleallocation)
 */
export type CareResourceSingleAllocationBlockType = {
  __typename?: 'CareResourceSingleAllocationBlockType';
  deleted: Scalars['Boolean']['output'];
  /** ISO 8601 datetime string */
  endTime: Scalars['String']['output'];
  id: Scalars['String']['output'];
  /** True for recurring allocations, False for single allocations */
  repeats: Scalars['Boolean']['output'];
  resourceEmail?: Maybe<Scalars['String']['output']>;
  resourceId: Scalars['String']['output'];
  /** ISO 8601 datetime string */
  startTime: Scalars['String']['output'];
};

/**
 * GraphQL type for a Care Resource
 *
 * A Care Resource is a representation for the Provider/Clinician/Staff that can be scheduled
 * to fulfill a Care Service appointment. A Care Resource (definied and configured in our Scheduling System)
 * will have a 1:1 "mapping" (via email) to a Provider in FDM. This is "mapping" is not at the table join level
 * for now since the data store for Care Resources is an external system (OnSched) for now.
 *
 * A Care Resource has scheduling-specific properties tied to them, including time-zone,
 * availability type (allocations or schedule), calendar allocations, as well as externally synced calendar configurations
 *
 * (OnSched Note): For now these are stored and managed in OnSched and FDM is just a wrapper around
 * the OnSched API, but since we may want to move to our own system on day, we are abstracting
 * the API boundary and making the types as generic as possible.
 *
 * OnSched Equivalent Data Type: "Resource" (https://docs.onsched.com/reference/get_v3-resources)
 */
export type CareResourceType = {
  __typename?: 'CareResourceType';
  about?: Maybe<Scalars['String']['output']>;
  /** Availability type for this resource */
  availabilityType?: Maybe<AvailabilityTypeEnum>;
  bookingLimit?: Maybe<Scalars['Int']['output']>;
  bookingsPerSlot?: Maybe<Scalars['Int']['output']>;
  /** All custom fields from OnSched as a JSON object with string values (e.g., {'price': '2000', 'category': 'consultation'}) */
  customFields?: Maybe<Scalars['JSONString']['output']>;
  /** The email of the Care Resource */
  email: Scalars['String']['output'];
  id: Scalars['String']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  locations?: Maybe<Array<Maybe<CareLocationType>>>;
  /** Full name of the Care Resource */
  name: Scalars['String']['output'];
  phone?: Maybe<Scalars['String']['output']>;
  services?: Maybe<Array<Maybe<CareServiceType>>>;
  /** A IANA timezone name (e.g. 'America/New_York') in which the Care Resource is based out of. */
  timezone?: Maybe<Scalars['String']['output']>;
};

/**
 * GraphQL type for Care Resource Weekly Allocation Block
 *
 * A Weekly Allocation defines availability across specific days of the week for a date range.
 * For example: Mon/Wed/Fri 8am-4pm, Tue/Thu 7am-9am from 2025-11-01 to 2025-11-14
 *
 * (OnSched Note): For now these are stored and managed in OnSched and FDM is just a wrapper around
 * the OnSched API, but since we may want to move to our own system on day, we are abstracting
 * the API boundary and making the types as generic as possible.
 *
 * OnSched Equivalent Data Type: "WeeklyAllocation" (https://docs.onsched.com/reference/get_v3-weeklyallocation)
 */
export type CareResourceWeeklyAllocationBlockType = {
  __typename?: 'CareResourceWeeklyAllocationBlockType';
  deleted: Scalars['Boolean']['output'];
  /** End date in YYYY-MM-DD format */
  endDate: Scalars['String']['output'];
  /** Friday schedule */
  friday?: Maybe<DayScheduleType>;
  id: Scalars['String']['output'];
  /** Monday schedule */
  monday?: Maybe<DayScheduleType>;
  resourceEmail?: Maybe<Scalars['String']['output']>;
  resourceId: Scalars['String']['output'];
  /** Saturday schedule */
  saturday?: Maybe<DayScheduleType>;
  /** Start date in YYYY-MM-DD format */
  startDate: Scalars['String']['output'];
  /** Sunday schedule */
  sunday?: Maybe<DayScheduleType>;
  /** Thursday schedule */
  thursday?: Maybe<DayScheduleType>;
  /** Tuesday schedule */
  tuesday?: Maybe<DayScheduleType>;
  /** Wednesday schedule */
  wednesday?: Maybe<DayScheduleType>;
};

/**
 * GraphQL type for a Care Service
 *
 * A Care Service is a service that we offer to our Direct To Parent
 * customers through our mobile app that can be purchased and scheduled by Caregivers
 * and administered by Providers.
 *
 * (OnSched Note): For now these are stored and managed in OnSched and FDM is just a wrapper around
 * the OnSched API, but since we may want to move to our own system on day, we are abstracting
 * the API boundary and making the t
 *
 * OnSched Equivalent Data Type: "Service" (https://docs.onsched.com/reference/get_v3-services)
 */
export type CareServiceType = {
  __typename?: 'CareServiceType';
  /** Availability type for this service */
  availabilityType?: Maybe<AvailabilityTypeEnum>;
  /** All custom fields from OnSched as a JSON object with string values (e.g., {'price': '2000', 'category': 'consultation'}) */
  customFields?: Maybe<Scalars['JSONString']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  /** Duration in minutes */
  durationMinutes: Scalars['Int']['output'];
  id: Scalars['String']['output'];
  /** Whether this service is active and can be booked */
  isActive: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  /** How much padding will be needed on each side of an appointment for this service when caluclating availability */
  paddingMinutes?: Maybe<Scalars['Int']['output']>;
  /** Price in US dollars */
  priceDollars?: Maybe<Scalars['Float']['output']>;
};

export enum CaregiverCareStage {
  AlreadyInTherapy = 'ALREADY_IN_THERAPY',
  JustExploring = 'JUST_EXPLORING',
  JustGettingStarted = 'JUST_GETTING_STARTED',
  LookingForDiagnosis = 'LOOKING_FOR_DIAGNOSIS',
  LookingForTherapy = 'LOOKING_FOR_THERAPY',
  UnderstandingDiagnosis = 'UNDERSTANDING_DIAGNOSIS'
}

export type CaregiverConsentInput = {
  caregiverId: Scalars['ID']['input'];
  consentGiven: Scalars['Boolean']['input'];
  consentType?: InputMaybe<ConsentTypeEnums>;
  learnerId: Scalars['ID']['input'];
};

export type CaregiverConsentType = Node & {
  __typename?: 'CaregiverConsentType';
  caregiver: CaregiverType;
  consentGiven: Scalars['Boolean']['output'];
  /** Type of consent being given */
  consentType?: Maybe<ApiCaregiverConsentConsentTypeChoices>;
  createdDate: Scalars['DateTime']['output'];
  /** The ID of the object */
  id: Scalars['ID']['output'];
  lastUpdatedDate: Scalars['DateTime']['output'];
  learner: LearnerType;
  organization: OrganizationType;
  pk?: Maybe<Scalars['Int']['output']>;
};

export type CaregiverConsentTypeConnection = {
  __typename?: 'CaregiverConsentTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<CaregiverConsentTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `CaregiverConsentType` and its cursor. */
export type CaregiverConsentTypeEdge = {
  __typename?: 'CaregiverConsentTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<CaregiverConsentType>;
};

export type CaregiverInput = {
  caregiverCareStage?: InputMaybe<CaregiverCareStage>;
  caregiverId?: InputMaybe<Scalars['ID']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  connectionType?: InputMaybe<ConnectionTypeEnum>;
  country?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName: Scalars['String']['input'];
  isAllowedAppAccess?: InputMaybe<Scalars['Boolean']['input']>;
  isPrimary?: InputMaybe<Scalars['Boolean']['input']>;
  lastName: Scalars['String']['input'];
  nearestLocation?: InputMaybe<Scalars['String']['input']>;
  phoneNumber1?: InputMaybe<Scalars['String']['input']>;
  referralSource?: InputMaybe<Scalars['String']['input']>;
  smsAgreement?: InputMaybe<Scalars['Boolean']['input']>;
  socialRelationship?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

export type CaregiverMetadataType = Node & {
  __typename?: 'CaregiverMetadataType';
  abaClientGoalsForGuardian?: Maybe<Scalars['String']['output']>;
  /** When the activation code was last emailed to the caregiver. NULL means never emailed. */
  activationCodeEmailLastSendDate?: Maybe<Scalars['DateTime']['output']>;
  /** When the activation code was last texted (SMS) to the caregiver. NULL means never texted. */
  activationCodeSmsLastSendDate?: Maybe<Scalars['DateTime']['output']>;
  active: Scalars['Boolean']['output'];
  addressLine1?: Maybe<Scalars['String']['output']>;
  addressLine2?: Maybe<Scalars['String']['output']>;
  /** One-time code the parent enters in-app to claim this caregiver record. Globally unique. NULL until a clinic admin explicitly sends the code — minted on demand so short-lived codes don't expire before being sent. */
  appActivationCode?: Maybe<Scalars['String']['output']>;
  /** Timestamp after which the activation code is no longer redeemable. NULL means no expiry has been set yet. Stamped (now + 3 days) when the code is first sent to the caregiver and reset on code regeneration. */
  appActivationCodeExpiresAt?: Maybe<Scalars['DateTime']['output']>;
  /** Timestamp the activation code was redeemed. NULL means unused. Doubles as the activated/not signal. */
  appActivationCodeUsedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Gates whether this caregiver's activation code may be redeemed. Net-new caregivers are eligible by default; admins toggle this deliberately on existing records via updateCaregiverMetadata. Sending the code (email/text) does not change it. */
  appActivationEligible: Scalars['Boolean']['output'];
  birthDate?: Maybe<Scalars['Date']['output']>;
  /** Care stage selected by the caregiver during D2P onboarding */
  careStage?: Maybe<ApiCaregiverMetadataCareStageChoices>;
  caregiver: CaregiverType;
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<UserType>;
  createdDate: Scalars['DateTime']['output'];
  email?: Maybe<Scalars['String']['output']>;
  employer?: Maybe<Scalars['String']['output']>;
  /** Consecutive failed activation attempts since last code generation. Incremented on a wrong DOB after the code is confirmed valid. Reset to 0 on successful activation or code regeneration. Locks out at 5 attempts. */
  failedActivationAttempts: Scalars['Int']['output'];
  firstName: Scalars['String']['output'];
  gender?: Maybe<ApiCaregiverMetadataGenderChoices>;
  hasEnteredParentCommunity?: Maybe<Scalars['Boolean']['output']>;
  /** The ID of the object */
  id: Scalars['ID']['output'];
  invitationConnectionType?: Maybe<ApiCaregiverMetadataInvitationConnectionTypeChoices>;
  invitationCreatedAt?: Maybe<Scalars['DateTime']['output']>;
  invitationExpiresAt?: Maybe<Scalars['DateTime']['output']>;
  invitationId?: Maybe<Scalars['String']['output']>;
  invitationStatus?: Maybe<ApiCaregiverMetadataInvitationStatusChoices>;
  invitationUrl?: Maybe<Scalars['String']['output']>;
  lastName: Scalars['String']['output'];
  lastUpdatedDate: Scalars['DateTime']['output'];
  maritalStatus?: Maybe<ApiCaregiverMetadataMaritalStatusChoices>;
  nearestLocation?: Maybe<Scalars['String']['output']>;
  occupation?: Maybe<Scalars['String']['output']>;
  organization: OrganizationType;
  phoneNumber1?: Maybe<Scalars['String']['output']>;
  phoneNumber2?: Maybe<Scalars['String']['output']>;
  pk?: Maybe<Scalars['Int']['output']>;
  preferredLanguage: Scalars['String']['output'];
  referralSource?: Maybe<Scalars['String']['output']>;
  requiresInterpreter?: Maybe<Scalars['Boolean']['output']>;
  smsAgreement: Scalars['Boolean']['output'];
  specifyGender?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  /** Free-text description of what the caregiver needs support with, captured during D2P onboarding */
  supportNotes?: Maybe<Scalars['String']['output']>;
  zip?: Maybe<Scalars['String']['output']>;
};

export type CaregiverMetadataTypeConnection = {
  __typename?: 'CaregiverMetadataTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<CaregiverMetadataTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `CaregiverMetadataType` and its cursor. */
export type CaregiverMetadataTypeEdge = {
  __typename?: 'CaregiverMetadataTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<CaregiverMetadataType>;
};

export type CaregiverType = Node & {
  __typename?: 'CaregiverType';
  auth0User?: Maybe<UserType>;
  caregivermetadata?: Maybe<CaregiverMetadataType>;
  consents: CaregiverConsentTypeConnection;
  createdBy?: Maybe<UserType>;
  createdDate: Scalars['DateTime']['output'];
  externalId?: Maybe<Scalars['String']['output']>;
  externalLastUpdate?: Maybe<Scalars['DateTime']['output']>;
  hasEnteredVideoCaptureApp: Scalars['Boolean']['output'];
  hatchPlans: HatchPlanTypeConnection;
  /** The ID of the object */
  id: Scalars['ID']['output'];
  insuranceForCaregiver: InsuranceDetailsTypeConnection;
  isAllowedAppAccess?: Maybe<Scalars['Boolean']['output']>;
  lastUpdatedDate: Scalars['DateTime']['output'];
  learnerconsentfilesSet: LearnerConsentFilesTypeConnection;
  organizationuserrolesSet: OrganizationUserRolesTypeConnection;
  pk?: Maybe<Scalars['Int']['output']>;
  relationshipSet: RelationshipTypeConnection;
  sessioncaregiverSet: SessionCaregiverTypeConnection;
};


export type CaregiverTypeConsentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type CaregiverTypeHatchPlansArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  caregiver?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  learner?: InputMaybe<Scalars['ID']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  organization?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<ApiHatchPlanStatusChoices>;
};


export type CaregiverTypeInsuranceForCaregiverArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type CaregiverTypeLearnerconsentfilesSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  caregiver?: InputMaybe<Scalars['ID']['input']>;
  consentFile?: InputMaybe<Scalars['String']['input']>;
  consentType?: InputMaybe<ApiLearnerConsentFilesConsentTypeChoices>;
  createdDate?: InputMaybe<Scalars['DateTime']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedDate?: InputMaybe<Scalars['DateTime']['input']>;
  learner?: InputMaybe<Scalars['ID']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  organization?: InputMaybe<Scalars['ID']['input']>;
};


export type CaregiverTypeOrganizationuserrolesSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  auth0User?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  caregiver?: InputMaybe<Scalars['ID']['input']>;
  createdDate?: InputMaybe<Scalars['DateTime']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedDate?: InputMaybe<Scalars['DateTime']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  organization?: InputMaybe<Scalars['ID']['input']>;
  provider?: InputMaybe<Scalars['ID']['input']>;
  role?: InputMaybe<ApiOrganizationUserRolesRoleChoices>;
};


export type CaregiverTypeRelationshipSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type CaregiverTypeSessioncaregiverSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type CaregiverTypeConnection = {
  __typename?: 'CaregiverTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<CaregiverTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `CaregiverType` and its cursor. */
export type CaregiverTypeEdge = {
  __typename?: 'CaregiverTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<CaregiverType>;
};

export type CaregiversFilter = {
  /** app_activation_code_used_at is/isn't null. */
  isConnected?: InputMaybe<Scalars['Boolean']['input']>;
  /** Either activation-code send-date column is/isn't null. */
  isInvited?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any linked child has one of these providers. */
  linkedProviderIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Case-insensitive match against the caregiver's first name, last name, email, or phone number (OR'd together). */
  searchTerm?: InputMaybe<Scalars['String']['input']>;
};

export enum CatalightGoalStatus {
  Continued = 'CONTINUED',
  Discontinued = 'DISCONTINUED',
  Met = 'MET',
  NewGoal = 'NEW_GOAL',
  OnHold = 'ON_HOLD',
  Revised = 'REVISED'
}

export type CentralReachGoalDataInput = {
  baselineInformation?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  discontinuedDate?: InputMaybe<Scalars['DateTime']['input']>;
  domainId?: InputMaybe<Scalars['ID']['input']>;
  domainName?: InputMaybe<Scalars['String']['input']>;
  events?: InputMaybe<Array<InputMaybe<CentralReachGoalEventDataInput>>>;
  generalizationCriteria?: InputMaybe<Scalars['String']['input']>;
  goalStatus: CentralReachGoalStatusEnums;
  id: Scalars['ID']['input'];
  initiatedDate?: InputMaybe<Scalars['DateTime']['input']>;
  masteryCriteria?: InputMaybe<Scalars['String']['input']>;
  metDate?: InputMaybe<Scalars['DateTime']['input']>;
  name: Scalars['String']['input'];
  onHoldDate?: InputMaybe<Scalars['DateTime']['input']>;
  phases?: InputMaybe<Array<InputMaybe<CentralReachTargetPhaseDataInput>>>;
  progressData?: InputMaybe<Array<InputMaybe<CentralReachTargetProgressDataInput>>>;
  progressDate?: InputMaybe<Scalars['DateTime']['input']>;
  progressType?: InputMaybe<ProgressType>;
  type: Scalars['String']['input'];
};

export type CentralReachGoalEventDataInput = {
  date: Scalars['DateTime']['input'];
  id: Scalars['ID']['input'];
  text: Scalars['String']['input'];
};

export enum CentralReachGoalStatusEnums {
  Discontinued = 'DISCONTINUED',
  Met = 'MET',
  NotActive = 'NOT_ACTIVE',
  OnHold = 'ON_HOLD',
  Progress = 'PROGRESS'
}

export type CentralReachTargetAndSessionProgressDataInput = {
  dataType?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  discontinuedDate?: InputMaybe<Scalars['DateTime']['input']>;
  domain?: InputMaybe<Scalars['ID']['input']>;
  domainName?: InputMaybe<Scalars['String']['input']>;
  events?: InputMaybe<Array<InputMaybe<CentralReachTargetEventDataInput>>>;
  goalId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
  initiated?: InputMaybe<Scalars['DateTime']['input']>;
  labels?: InputMaybe<Scalars['String']['input']>;
  metDate?: InputMaybe<Scalars['DateTime']['input']>;
  name: Scalars['String']['input'];
  onHoldDate?: InputMaybe<Scalars['DateTime']['input']>;
  phases?: InputMaybe<Array<InputMaybe<CentralReachTargetPhaseDataInput>>>;
  progressData?: InputMaybe<Array<InputMaybe<CentralReachTargetProgressDataInput>>>;
  progressDate?: InputMaybe<Scalars['DateTime']['input']>;
  progressType: ProgressType;
  targetStatus?: InputMaybe<CentralReachTargetStatusEnums>;
};

export type CentralReachTargetEventDataInput = {
  date: Scalars['DateTime']['input'];
  id: Scalars['ID']['input'];
  text: Scalars['String']['input'];
};

export type CentralReachTargetPhaseDataInput = {
  date: Scalars['DateTime']['input'];
  id: Scalars['ID']['input'];
  status: Scalars['String']['input'];
};

export type CentralReachTargetProgressDataInput = {
  count: Scalars['Float']['input'];
  date: Scalars['DateTime']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  total: Scalars['Float']['input'];
};

export enum CentralReachTargetStatusEnums {
  Discontinued = 'DISCONTINUED',
  Met = 'MET',
  NotActive = 'NOT_ACTIVE',
  OnHold = 'ON_HOLD',
  Progress = 'PROGRESS'
}

export type ChangeActiveAnnotation = {
  __typename?: 'ChangeActiveAnnotation';
  changedActiveAnnotation?: Maybe<AnnotationType>;
};

export type ChangePassageProgramingEventsInUseStatusMutation = {
  __typename?: 'ChangePassageProgramingEventsInUseStatusMutation';
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type ChangePassageProgramingInUseStatusMutation = {
  __typename?: 'ChangePassageProgramingInUseStatusMutation';
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type ChangePassageProgramingPhasesInUseStatusMutation = {
  __typename?: 'ChangePassageProgramingPhasesInUseStatusMutation';
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type ChangeReportTreatmentPlanDeleteStatusMutation = {
  __typename?: 'ChangeReportTreatmentPlanDeleteStatusMutation';
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

/**
 * Charges a customer using their saved Stripe payment method.
 *
 * This mutation retrieves and confirms an existing PaymentIntent using the stored
 * `payment_method_id` associated with the user’s Stripe account.
 *
 * Steps:
 * 1. Fetches the PaymentIntent by ID from Stripe.
 * 2. Confirms the intent using the saved payment method (if applicable).
 * 3. Returns confirmation details including the charged amount and status.
 *
 * If the PaymentIntent was already confirmed, it returns a success response
 * without reprocessing the charge.
 *
 * Response:
 * - `message`: Status or error message
 * - `status`: Boolean indicating success
 * - `payment_intent_id`: The ID of the charged PaymentIntent
 * - `amount_charged`: Amount successfully charged (in USD)
 */
export type ChargeSavedPaymentMethod = {
  __typename?: 'ChargeSavedPaymentMethod';
  amountCharged?: Maybe<Scalars['Float']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  paymentIntentId?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

export enum ChartTypes {
  AvgDaily = 'AVG_DAILY',
  AvgMonthly = 'AVG_MONTHLY',
  AvgQuarterly = 'AVG_QUARTERLY',
  AvgWeekly = 'AVG_WEEKLY',
  Cumulative = 'CUMULATIVE',
  Progress = 'PROGRESS',
  TotalDaily = 'TOTAL_DAILY',
  TotalMonthly = 'TOTAL_MONTHLY',
  TotalQuarterly = 'TOTAL_QUARTERLY',
  TotalWeekly = 'TOTAL_WEEKLY'
}

/**
 * Narrows ``chatMessages`` to messages carrying an attachment.
 *
 * Powers the Multimedia accordion in the expert-chat sidebar so the
 * portal can query the gallery directly instead of pulling the full
 * chat history and deriving the list client-side.
 *
 * - ``ANY``    — any media or file attachment
 * - ``VIDEO``  — only completed video uploads (``media`` with
 *                ``video_upload_status=completed``)
 * - ``IMAGE``  — only image-MIME file attachments
 */
export enum ChatAttachmentKindEnum {
  Any = 'ANY',
  Image = 'IMAGE',
  Video = 'VIDEO'
}

export enum ChatCareStage {
  ActiveTreatment = 'ACTIVE_TREATMENT',
  DiagnosedNotReceivingServices = 'DIAGNOSED_NOT_RECEIVING_SERVICES',
  DiagnosticProcess = 'DIAGNOSTIC_PROCESS',
  EarlyIntervention = 'EARLY_INTERVENTION',
  PreDiagnosis = 'PRE_DIAGNOSIS',
  Transition = 'TRANSITION',
  Unknown = 'UNKNOWN',
  WaitlistedForServices = 'WAITLISTED_FOR_SERVICES'
}

/**
 * A chat member and the org they reach in through (PAR-2194).
 *
 * Expert = the member whose ``member.provider`` is set; caregivers have none.
 */
export type ChatMemberType = Node & {
  __typename?: 'ChatMemberType';
  /** Soft-delete flag. */
  active: Scalars['Boolean']['output'];
  chat: ChatType;
  /** The ID of the object */
  id: Scalars['ID']['output'];
  /** User who has access to this chat. */
  member: UserType;
  /** Org the member reaches in through, not the chat's household org. */
  memberOrg: OrganizationType;
};

export type ChatMemberTypeConnection = {
  __typename?: 'ChatMemberTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ChatMemberTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `ChatMemberType` and its cursor. */
export type ChatMemberTypeEdge = {
  __typename?: 'ChatMemberTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<ChatMemberType>;
};

/**
 * Result ordering for ``chatMessages``.
 *
 * Default is ``SEQUENCE_ASC`` to preserve the chat-log shape existing
 * callers expect. ``CREATED_DATE_DESC`` is the right pick for the
 * media gallery (newest first).
 */
export enum ChatMessageSortByEnum {
  CreatedDateDesc = 'CREATED_DATE_DESC',
  SequenceAsc = 'SEQUENCE_ASC'
}

export type ChatMessageType = Node & {
  __typename?: 'ChatMessageType';
  archived: Scalars['Boolean']['output'];
  chat: ChatType;
  content?: Maybe<Scalars['String']['output']>;
  createdDate: Scalars['DateTime']['output'];
  /** Tracks the edited message history */
  editHistory: Scalars['JSONString']['output'];
  edited: Scalars['Boolean']['output'];
  /** Non-video file attachment (PDFs, images). For video uploads use `media`. */
  file?: Maybe<LearnerFileType>;
  /** The ID of the object */
  id: Scalars['ID']['output'];
  lastUpdatedDate: Scalars['DateTime']['output'];
  /** Chat-sourced video attachment (via initiateChatVideoUpload). Surfaces in the video library; carries duration/thumbnail metadata. */
  media?: Maybe<MediaType>;
  /** Source MediaComment for chat-sourced video comment echoes. Set only when role is COMMENT. */
  mediaComment?: Maybe<MediaCommentsType>;
  organization: OrganizationType;
  pk?: Maybe<Scalars['Int']['output']>;
  readAt?: Maybe<Scalars['DateTime']['output']>;
  readBy?: Maybe<UserType>;
  role: ApiChatMessageRoleChoices;
  sequenceNumber: Scalars['Int']['output'];
  user?: Maybe<UserType>;
  userFirstName?: Maybe<Scalars['String']['output']>;
  userLastName?: Maybe<Scalars['String']['output']>;
};

export type ChatMessageTypeConnection = {
  __typename?: 'ChatMessageTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ChatMessageTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `ChatMessageType` and its cursor. */
export type ChatMessageTypeEdge = {
  __typename?: 'ChatMessageTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<ChatMessageType>;
};

export type ChatNoteType = Node & {
  __typename?: 'ChatNoteType';
  chat: ChatType;
  content?: Maybe<Scalars['String']['output']>;
  createdDate: Scalars['DateTime']['output'];
  /** The ID of the object */
  id: Scalars['ID']['output'];
  lastUpdatedDate: Scalars['DateTime']['output'];
  organization: OrganizationType;
  pk?: Maybe<Scalars['Int']['output']>;
  user: UserType;
};

export type ChatNoteTypeConnection = {
  __typename?: 'ChatNoteTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ChatNoteTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `ChatNoteType` and its cursor. */
export type ChatNoteTypeEdge = {
  __typename?: 'ChatNoteTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<ChatNoteType>;
};

export enum ChatStatusEnums {
  Finished = 'FINISHED',
  Open = 'OPEN'
}

export type ChatSuggestionType = Node & {
  __typename?: 'ChatSuggestionType';
  createdDate: Scalars['DateTime']['output'];
  /** The ID of the object */
  id: Scalars['ID']['output'];
  lastUpdatedDate: Scalars['DateTime']['output'];
  learner: LearnerType;
  organization: OrganizationType;
  suggestion: Scalars['String']['output'];
};

export type ChatSuggestionTypeConnection = {
  __typename?: 'ChatSuggestionTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ChatSuggestionTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `ChatSuggestionType` and its cursor. */
export type ChatSuggestionTypeEdge = {
  __typename?: 'ChatSuggestionTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<ChatSuggestionType>;
};

export type ChatTagType = Node & {
  __typename?: 'ChatTagType';
  chats: ChatTypeConnection;
  createdDate: Scalars['DateTime']['output'];
  /** The ID of the object */
  id: Scalars['ID']['output'];
  lastUpdatedDate: Scalars['DateTime']['output'];
  name: Scalars['String']['output'];
  /** Org is Frontera Health (1) if the tag is a default. */
  organization: OrganizationType;
  pk?: Maybe<Scalars['Int']['output']>;
};


export type ChatTagTypeChatsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  learner?: InputMaybe<Scalars['ID']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<ApiChatStatusChoices>;
  summaryStatus?: InputMaybe<ApiChatSummaryStatusChoices>;
  type?: InputMaybe<ApiChatTypeChoices>;
  user?: InputMaybe<Scalars['ID']['input']>;
};

export type ChatTagTypeConnection = {
  __typename?: 'ChatTagTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ChatTagTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `ChatTagType` and its cursor. */
export type ChatTagTypeEdge = {
  __typename?: 'ChatTagTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<ChatTagType>;
};

export type ChatTagsFilter = {
  searchTerm?: InputMaybe<Scalars['String']['input']>;
};

export type ChatType = Node & {
  __typename?: 'ChatType';
  careStage?: Maybe<ApiChatCareStageChoices>;
  chatTasks: TaskTypeConnection;
  clinicianSummary?: Maybe<Scalars['String']['output']>;
  clinicianSummaryStatus: ApiChatClinicianSummaryStatusChoices;
  conversationSummary: Scalars['String']['output'];
  createdDate: Scalars['DateTime']['output'];
  firstMessage?: Maybe<ChatMessageType>;
  history: Scalars['JSONString']['output'];
  /** The ID of the object */
  id: Scalars['ID']['output'];
  isCaregiver?: Maybe<Scalars['Boolean']['output']>;
  isProvider?: Maybe<Scalars['Boolean']['output']>;
  isUnread?: Maybe<Scalars['Boolean']['output']>;
  lastMessage?: Maybe<ChatMessageType>;
  lastUpdatedDate: Scalars['DateTime']['output'];
  learner: LearnerType;
  members: ChatMemberTypeConnection;
  messageDraft?: Maybe<Scalars['String']['output']>;
  messages: ChatMessageTypeConnection;
  needsReview?: Maybe<Scalars['Boolean']['output']>;
  notes: ChatNoteTypeConnection;
  organization: OrganizationType;
  pk?: Maybe<Scalars['Int']['output']>;
  status: ApiChatStatusChoices;
  summary?: Maybe<Scalars['String']['output']>;
  summaryStatus: ApiChatSummaryStatusChoices;
  tags: ChatTagTypeConnection;
  tasksStatus: ApiChatTasksStatusChoices;
  title?: Maybe<Scalars['String']['output']>;
  type: ApiChatTypeChoices;
  user: UserType;
};


export type ChatTypeChatTasksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  chat?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  learner?: InputMaybe<Scalars['ID']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<ApiTaskStatusChoices>;
  type?: InputMaybe<ApiTaskTypeChoices>;
  user?: InputMaybe<Scalars['ID']['input']>;
};


export type ChatTypeMembersArgs = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type ChatTypeMessagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  chat?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  role?: InputMaybe<ApiChatMessageRoleChoices>;
  sequenceNumber?: InputMaybe<Scalars['Int']['input']>;
};


export type ChatTypeNotesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  chat?: InputMaybe<Scalars['ID']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  createdDate?: InputMaybe<Scalars['DateTime']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedDate?: InputMaybe<Scalars['DateTime']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  organization?: InputMaybe<Scalars['ID']['input']>;
  user?: InputMaybe<Scalars['ID']['input']>;
};


export type ChatTypeTagsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdDate?: InputMaybe<Scalars['DateTime']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedDate?: InputMaybe<Scalars['DateTime']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  organization?: InputMaybe<Scalars['ID']['input']>;
};

export type ChatTypeConnection = {
  __typename?: 'ChatTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ChatTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `ChatType` and its cursor. */
export type ChatTypeEdge = {
  __typename?: 'ChatTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<ChatType>;
};

export enum ChatTypeEnums {
  Assistant = 'ASSISTANT',
  Expert = 'EXPERT',
  Intake = 'INTAKE'
}

/**
 * Filter for chatbot-specific chat queries (INTAKE and ASSISTANT chats only).
 *
 * This filter is isolated from the main ChatsFilter to prevent breaking changes
 * in the chatbot microservice when other use cases (like EXPERT chats) require
 * different filter fields.
 */
export type ChatbotChatsFilter = {
  /** Filter chats created after this datetime (ISO 8601 format) */
  createdAfter?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  learnerId?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<ChatStatusEnums>;
  types?: InputMaybe<Array<InputMaybe<ChatTypeEnums>>>;
};

export type ChatsFilter = {
  learnerIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  memberIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ChatStatusEnums>;
  summaryStatus?: InputMaybe<ProcessingStatus>;
  title?: InputMaybe<Scalars['String']['input']>;
  types?: InputMaybe<Array<InputMaybe<ChatTypeEnums>>>;
};

export type CheckAuth0UserRolesAndFdmUserRolesDiff = {
  __typename?: 'CheckAuth0UserRolesAndFdmUserRolesDiff';
  message?: Maybe<Scalars['String']['output']>;
  mismatchedUserRoles?: Maybe<Array<Maybe<CheckAuth0UserRolesAndFdmUserRolesDiffType>>>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type CheckAuth0UserRolesAndFdmUserRolesDiffInput = {
  organizationId: Scalars['ID']['input'];
};

export type CheckAuth0UserRolesAndFdmUserRolesDiffType = {
  __typename?: 'CheckAuth0UserRolesAndFdmUserRolesDiffType';
  auth0Roles?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  fdmRoles?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  organization?: Maybe<Scalars['String']['output']>;
  rolesNotMatched?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  userId?: Maybe<Scalars['String']['output']>;
};

/**
 * GraphQL type for Circle Community Member Authentication Token
 *
 * This token allows a community member to access Circle's Member APIs
 * (home feed, spaces, posts, comments, events, etc.)
 *
 * The token has an expiration time and should be refreshed before expiry.
 *
 * Circle Reference: https://api-headless.circle.so/?urls.primaryName=Auth+APIs
 */
export type CircleAuthTokenType = {
  __typename?: 'CircleAuthTokenType';
  /** JWT access token for Circle Member APIs */
  accessToken: Scalars['String']['output'];
  /** ISO 8601 datetime when the token expires */
  accessTokenExpiresAt: Scalars['String']['output'];
};

/**
 * GraphQL type for Circle Community Member Invitation Status
 *
 * This type represents the current state of a member's invitation:
 * - memberExists: Whether the member has been created/invited in Circle
 * - invitationAccepted: Whether they have accepted the invitation (can get auth token)
 * - member: The member details if they exist
 *
 * When a member is created via Admin API, they receive an invitation email.
 * They must click the link and set up their account before they can access
 * the community. This query checks both states.
 */
export type CircleInvitationStatusType = {
  __typename?: 'CircleInvitationStatusType';
  /** Whether the member has accepted the invitation and can access the community */
  invitationAccepted: Scalars['Boolean']['output'];
  /** The member details if they exist, null otherwise */
  member?: Maybe<CircleMemberType>;
  /** Whether the member has been created/invited in Circle */
  memberExists: Scalars['Boolean']['output'];
};

/**
 * GraphQL type for a Circle Community Member
 *
 * A Circle Community Member represents a user in our Circle.so community.
 * In the Frontera ecosystem, this typically has a 1:1 mapping to a Caregiver
 * as Caregivers are the primary users of the community features in the mobile app.
 *
 * Circle Reference: https://api-headless.circle.so/?urls.primaryName=Admin%20API%20V2#/Community%20Members
 */
export type CircleMemberType = {
  __typename?: 'CircleMemberType';
  /** ISO 8601 datetime when member accepted the invitation, null if not yet accepted */
  acceptedInvitation?: Maybe<Scalars['String']['output']>;
  /** Whether the member is active in Circle */
  active?: Maybe<Scalars['Boolean']['output']>;
  /** URL to member's avatar image */
  avatarUrl?: Maybe<Scalars['String']['output']>;
  /** Member's bio/description */
  bio?: Maybe<Scalars['String']['output']>;
  /** ISO 8601 datetime when member was created */
  createdAt?: Maybe<Scalars['String']['output']>;
  /** Member's email address */
  email: Scalars['String']['output'];
  /** Member's headline/tagline */
  headline?: Maybe<Scalars['String']['output']>;
  /** Circle member ID */
  id: Scalars['Int']['output'];
  /** Member's location */
  location?: Maybe<Scalars['String']['output']>;
  /** Member's display name */
  name?: Maybe<Scalars['String']['output']>;
  /** SSO provider user ID if member uses SSO */
  ssoProviderUserId?: Maybe<Scalars['String']['output']>;
};

/**
 * GraphQL type for a Circle Community Space
 *
 * A Circle Space is a dedicated area within the community where members
 * can post content, have discussions, and engage on specific topics.
 *
 * Circle Reference: https://api-headless.circle.so/?urls.primaryName=Admin%20API%20V2#/Spaces
 */
export type CircleSpaceType = {
  __typename?: 'CircleSpaceType';
  /** URL to custom emoji image */
  customEmojiUrl?: Maybe<Scalars['String']['output']>;
  /** Emoji icon for the space */
  emoji?: Maybe<Scalars['String']['output']>;
  /** Circle space ID */
  id: Scalars['Int']['output'];
  /** Whether the space is hidden */
  isHidden?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the space is hidden from non-members */
  isHiddenFromNonMembers?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the space is private */
  isPrivate?: Maybe<Scalars['Boolean']['output']>;
  /** Space name */
  name: Scalars['String']['output'];
  /** URL-friendly slug for the space */
  slug?: Maybe<Scalars['String']['output']>;
  /** Type of space (e.g., 'basic', 'event') */
  spaceType?: Maybe<Scalars['String']['output']>;
};

export type ClassficationFeedbackInput = {
  classType: ClassificationClassEnum;
  endTime: Scalars['Float']['input'];
  isClassifiedCorrectly: Scalars['Boolean']['input'];
  mediaId: Scalars['ID']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
  startTime: Scalars['Float']['input'];
  subclassType: ClassificationSubClassEnum;
};

export enum ClassificationClassEnum {
  MaladaptiveBehaviour = 'MALADAPTIVE_BEHAVIOUR'
}

export type ClassificationInterval = {
  __typename?: 'ClassificationInterval';
  confidenceLevel?: Maybe<Scalars['Float']['output']>;
  endTime?: Maybe<Scalars['Float']['output']>;
  startTime?: Maybe<Scalars['Float']['output']>;
};

export enum ClassificationSubClassEnum {
  Aggression = 'AGGRESSION',
  CryingAndScreaming = 'CRYING_AND_SCREAMING'
}

export type ClientDataType = {
  __typename?: 'ClientDataType';
  addressLine1?: Maybe<Scalars['String']['output']>;
  addressLine2?: Maybe<Scalars['String']['output']>;
  alias?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  clientId?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  dateOfBirth?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  firstName: Scalars['String']['output'];
  gender?: Maybe<Scalars['String']['output']>;
  lastName: Scalars['String']['output'];
  phone?: Maybe<Scalars['String']['output']>;
  preferredName?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  zipCode?: Maybe<Scalars['String']['output']>;
};

export type ClientListMutation = {
  __typename?: 'ClientListMutation';
  clients?: Maybe<Array<Maybe<ClientDataType>>>;
  /** False when the EHR had more clients than were listed. Set only for Frontera EHR; other EHRs always list every client. */
  isComplete?: Maybe<Scalars['Boolean']['output']>;
};

/**
 * Minimal filter for caregiver clinic leads.
 *
 * Results are always scoped to the logged-in caregiver's linked learners.
 */
export type ClinicLeadFilter = {
  leadId?: InputMaybe<Scalars['ID']['input']>;
  learnerId?: InputMaybe<Scalars['ID']['input']>;
  publicLeadId?: InputMaybe<Scalars['ID']['input']>;
};

export type ClinicLeadType = Node & {
  __typename?: 'ClinicLeadType';
  caregiver?: Maybe<CaregiverType>;
  clinicListing: ClinicListingType;
  createdDate: Scalars['DateTime']['output'];
  /** The ID of the object */
  id: Scalars['ID']['output'];
  lastUpdatedDate: Scalars['DateTime']['output'];
  learner: LearnerType;
  payor?: Maybe<ApiClinicLeadPayorChoices>;
  pk?: Maybe<Scalars['Int']['output']>;
  publicId: Scalars['UUID']['output'];
  requestedModalityTypes: Array<Scalars['String']['output']>;
  requestedServiceTypes: Array<Scalars['String']['output']>;
};

export type ClinicLeadTypeConnection = {
  __typename?: 'ClinicLeadTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ClinicLeadTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `ClinicLeadType` and its cursor. */
export type ClinicLeadTypeEdge = {
  __typename?: 'ClinicLeadTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<ClinicLeadType>;
};

/**
 * Filter options for the caregiver "Find a Clinic" experience.
 *
 * NOTE: For now we only do postal_code matching (no geo / distance calculations).
 */
export type ClinicListingSearchFilter = {
  isClaimed?: InputMaybe<Scalars['Boolean']['input']>;
  modalityTypes?: InputMaybe<Array<InputMaybe<ModalityType>>>;
  payor?: InputMaybe<PayorSelectionType>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  serviceTypes?: InputMaybe<Array<InputMaybe<ClinicalServiceType>>>;
  verificationStatus?: InputMaybe<ClinicVerificationStatus>;
};

export type ClinicListingStagingType = Node & {
  __typename?: 'ClinicListingStagingType';
  clinicListing?: Maybe<ClinicListingType>;
  contactEmail?: Maybe<Scalars['String']['output']>;
  contactFormUrl?: Maybe<Scalars['String']['output']>;
  crawlStatus?: Maybe<ApiClinicListingStagingCrawlStatusChoices>;
  createdDate: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  googlePlaceId?: Maybe<Scalars['String']['output']>;
  googleRating?: Maybe<Scalars['Float']['output']>;
  googleReviewCount?: Maybe<Scalars['Int']['output']>;
  /** The ID of the object */
  id: Scalars['ID']['output'];
  lastUpdatedDate: Scalars['DateTime']['output'];
  location?: Maybe<LocationType>;
  modalityTypes: Array<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  parseStatus?: Maybe<ApiClinicListingStagingParseStatusChoices>;
  payors: Array<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  pk?: Maybe<Scalars['Int']['output']>;
  qualityRating?: Maybe<Scalars['Float']['output']>;
  qualityReasoning?: Maybe<Scalars['String']['output']>;
  reviewStatus?: Maybe<ApiClinicListingStagingReviewStatusChoices>;
  runId: Scalars['String']['output'];
  scrapedText?: Maybe<Scalars['String']['output']>;
  servicesOffered: Array<Scalars['String']['output']>;
  websiteUrl?: Maybe<Scalars['String']['output']>;
};

export type ClinicListingStagingTypeConnection = {
  __typename?: 'ClinicListingStagingTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ClinicListingStagingTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `ClinicListingStagingType` and its cursor. */
export type ClinicListingStagingTypeEdge = {
  __typename?: 'ClinicListingStagingTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<ClinicListingStagingType>;
};

export type ClinicListingType = Node & {
  __typename?: 'ClinicListingType';
  claimedBy?: Maybe<ClinicType>;
  clinicleadSet: ClinicLeadTypeConnection;
  cliniclistingstagingSet: ClinicListingStagingTypeConnection;
  contactEmail?: Maybe<Scalars['String']['output']>;
  createdDate: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  distanceMiles?: Maybe<Scalars['Float']['output']>;
  googlePlaceId?: Maybe<Scalars['String']['output']>;
  googleRating?: Maybe<Scalars['Float']['output']>;
  googleReviewCount?: Maybe<Scalars['Int']['output']>;
  /** The ID of the object */
  id: Scalars['ID']['output'];
  lastUpdatedDate: Scalars['DateTime']['output'];
  location?: Maybe<LocationType>;
  modalityTypes: Array<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  payors: Array<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  pk?: Maybe<Scalars['Int']['output']>;
  publicId: Scalars['UUID']['output'];
  servicesOffered: Array<Scalars['String']['output']>;
  verificationStatus?: Maybe<ApiClinicListingVerificationStatusChoices>;
  verifiedDate?: Maybe<Scalars['DateTime']['output']>;
  websiteUrl?: Maybe<Scalars['String']['output']>;
};


export type ClinicListingTypeClinicleadSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  clinicListing?: InputMaybe<Scalars['ID']['input']>;
  createdDate?: InputMaybe<Scalars['DateTime']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedDate?: InputMaybe<Scalars['DateTime']['input']>;
  learner?: InputMaybe<Scalars['ID']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  payor?: InputMaybe<ApiClinicLeadPayorChoices>;
};


export type ClinicListingTypeCliniclistingstagingSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  crawlStatus?: InputMaybe<ApiClinicListingStagingCrawlStatusChoices>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  parseStatus?: InputMaybe<ApiClinicListingStagingParseStatusChoices>;
  runId?: InputMaybe<Scalars['String']['input']>;
};

export type ClinicListingTypeConnection = {
  __typename?: 'ClinicListingTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ClinicListingTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `ClinicListingType` and its cursor. */
export type ClinicListingTypeEdge = {
  __typename?: 'ClinicListingTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<ClinicListingType>;
};

/**
 * Lightweight summary of a caregiver's active clinic membership.
 *
 * Returned by `clinic_memberships` so the app can show connected /
 * not-connected state. The values are read under `rls_bypass()` in the
 * resolver (the membership's clinic tenant lives outside the caller's own org
 * context) rather than exposing the org-scoped `Membership`/`Organization`
 * rows directly through a connection.
 */
export type ClinicMembershipType = {
  __typename?: 'ClinicMembershipType';
  active: Scalars['Boolean']['output'];
  organizationId: Scalars['ID']['output'];
  organizationName: Scalars['String']['output'];
};

export type ClinicType = Node & {
  __typename?: 'ClinicType';
  cliniclistingSet: ClinicListingTypeConnection;
  createdDate: Scalars['DateTime']['output'];
  /** The ID of the object */
  id: Scalars['ID']['output'];
  lastUpdatedDate: Scalars['DateTime']['output'];
  location?: Maybe<LocationType>;
  name: Scalars['String']['output'];
  organization: OrganizationType;
  payors: Array<Scalars['String']['output']>;
  pk?: Maybe<Scalars['Int']['output']>;
  providermetadataSet: ProviderMetadataTypeConnection;
};


export type ClinicTypeCliniclistingSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdDate?: InputMaybe<Scalars['DateTime']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedDate?: InputMaybe<Scalars['DateTime']['input']>;
  location?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  verificationStatus?: InputMaybe<ApiClinicListingVerificationStatusChoices>;
};


export type ClinicTypeProvidermetadataSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type ClinicTypeConnection = {
  __typename?: 'ClinicTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ClinicTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `ClinicType` and its cursor. */
export type ClinicTypeEdge = {
  __typename?: 'ClinicTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<ClinicType>;
};

export enum ClinicVerificationStatus {
  Pending = 'PENDING',
  Unverified = 'UNVERIFIED',
  Verified = 'VERIFIED'
}

export enum ClinicalServiceType {
  AbaTherapy = 'ABA_THERAPY',
  DiagnosticEvaluations = 'DIAGNOSTIC_EVALUATIONS',
  OccupationalTherapy = 'OCCUPATIONAL_THERAPY',
  ParentTraining = 'PARENT_TRAINING',
  PhysicalTherapy = 'PHYSICAL_THERAPY',
  SpeechTherapy = 'SPEECH_THERAPY'
}

export type ClipAnnotationType = Node & {
  __typename?: 'ClipAnnotationType';
  annotationData?: Maybe<Scalars['JSONString']['output']>;
  annotationTag?: Maybe<AnnotationTagType>;
  assignedAt: Scalars['DateTime']['output'];
  assignedUser?: Maybe<AnnotatorUserType>;
  clip: ClipType;
  createdDate: Scalars['DateTime']['output'];
  fileName?: Maybe<Scalars['String']['output']>;
  fileSize?: Maybe<Scalars['BigInt']['output']>;
  fileUploadedAt?: Maybe<Scalars['DateTime']['output']>;
  fileUploadedBy?: Maybe<AnnotatorUserType>;
  /** The ID of the object */
  id: Scalars['ID']['output'];
  lastUpdatedDate: Scalars['DateTime']['output'];
  organization: OrganizationType;
  pk?: Maybe<Scalars['Int']['output']>;
  reviewer?: Maybe<AnnotatorUserType>;
  signedAnnotationFileUrl?: Maybe<Scalars['String']['output']>;
  spreadsheetRef?: Maybe<Scalars['String']['output']>;
  status?: Maybe<ApiClipAnnotationStatusChoices>;
};

export type ClipAnnotationTypeConnection = {
  __typename?: 'ClipAnnotationTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ClipAnnotationTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `ClipAnnotationType` and its cursor. */
export type ClipAnnotationTypeEdge = {
  __typename?: 'ClipAnnotationTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<ClipAnnotationType>;
};

export type ClipType = Node & {
  __typename?: 'ClipType';
  clipannotationSet: ClipAnnotationTypeConnection;
  createdBy?: Maybe<UserType>;
  createdDate: Scalars['DateTime']['output'];
  endTime: Scalars['Int']['output'];
  /** The ID of the object */
  id: Scalars['ID']['output'];
  lastUpdatedDate: Scalars['DateTime']['output'];
  media: MediaType;
  organization: OrganizationType;
  pk?: Maybe<Scalars['Int']['output']>;
  startTime: Scalars['Int']['output'];
  title: Scalars['String']['output'];
};


export type ClipTypeClipannotationSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  annotationTag?: InputMaybe<Scalars['ID']['input']>;
  assignedUser?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  clip?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  reviewer?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<ApiClipAnnotationStatusChoices>;
};

export type ClipTypeConnection = {
  __typename?: 'ClipTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ClipTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `ClipType` and its cursor. */
export type ClipTypeEdge = {
  __typename?: 'ClipTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<ClipType>;
};

export type CommentsDataType = {
  __typename?: 'CommentsDataType';
  feedback?: Maybe<Scalars['Int']['output']>;
  love?: Maybe<Scalars['Int']['output']>;
  praise?: Maybe<Scalars['Int']['output']>;
  question?: Maybe<Scalars['Int']['output']>;
  totalComments?: Maybe<Scalars['Int']['output']>;
};

export enum CommunicationQuestionType {
  ActingDifferentlyInDifferentSituations = 'ACTING_DIFFERENTLY_IN_DIFFERENT_SITUATIONS',
  CommunicationChallenges = 'COMMUNICATION_CHALLENGES',
  DifferentOddLanguageUseEarlyOn = 'DIFFERENT_ODD_LANGUAGE_USE_EARLY_ON',
  EffortsToBeWithOthers = 'EFFORTS_TO_BE_WITH_OTHERS',
  ExpressiveCommunication = 'EXPRESSIVE_COMMUNICATION',
  FigurativeLanguageSlang = 'FIGURATIVE_LANGUAGE_SLANG',
  Gestures = 'GESTURES',
  HowClientLetYouKnowWanted = 'HOW_CLIENT_LET_YOU_KNOW_WANTED',
  IdiosyncraticPhrasesWords = 'IDIOSYNCRATIC_PHRASES_WORDS',
  InteractingWithOthers = 'INTERACTING_WITH_OTHERS',
  InteractingWithOthersDescription = 'INTERACTING_WITH_OTHERS_DESCRIPTION',
  InterpretingBehaviorsAndWordsOfOthersCorrectly = 'INTERPRETING_BEHAVIORS_AND_WORDS_OF_OTHERS_CORRECTLY',
  KnowingWhenOffensiveCommentWasMade = 'KNOWING_WHEN_OFFENSIVE_COMMENT_WAS_MADE',
  KnowingWhenOthersAreTakingAdvantage = 'KNOWING_WHEN_OTHERS_ARE_TAKING_ADVANTAGE',
  KnowImpactsOfActionsWords = 'KNOW_IMPACTS_OF_ACTIONS_WORDS',
  Neologisms = 'NEOLOGISMS',
  OffWordsOrPhrases = 'OFF_WORDS_OR_PHRASES',
  PickUpOnSocialCues = 'PICK_UP_ON_SOCIAL_CUES',
  PlacedHandOnSomethingToGetManipulation = 'PLACED_HAND_ON_SOMETHING_TO_GET_MANIPULATION',
  QuotingScripting = 'QUOTING_SCRIPTING',
  RepetitivePhrases = 'REPETITIVE_PHRASES',
  SeeSituationsFromDifferentPerspectives = 'SEE_SITUATIONS_FROM_DIFFERENT_PERSPECTIVES',
  SocialInterest = 'SOCIAL_INTEREST',
  StrangerDangerOrOverlyFamiliar = 'STRANGER_DANGER_OR_OVERLY_FAMILIAR',
  TookHandAndLeadToWantedItem = 'TOOK_HAND_AND_LEAD_TO_WANTED_ITEM',
  UnderstandingAccidentsAndJokes = 'UNDERSTANDING_ACCIDENTS_AND_JOKES',
  UnderstandingPersonalSpace = 'UNDERSTANDING_PERSONAL_SPACE',
  UnderstandingWhatOthersSay = 'UNDERSTANDING_WHAT_OTHERS_SAY',
  UnderstandDirectionInstructions = 'UNDERSTAND_DIRECTION_INSTRUCTIONS',
  UsedHandAsTool = 'USED_HAND_AS_TOOL',
  UseOfEyeContact = 'USE_OF_EYE_CONTACT',
  UseOfFacialExpressions = 'USE_OF_FACIAL_EXPRESSIONS'
}

/** Response type for checking if a community member exists */
export type CommunityMemberExistsType = {
  __typename?: 'CommunityMemberExistsType';
  /** Whether the member exists in Circle */
  exists: Scalars['Boolean']['output'];
  /** The member details if they exist, null otherwise */
  member?: Maybe<CircleMemberType>;
};

/**
 * Finalizes a chunked S3 upload for a chat-sourced video.
 *
 * Marks the Media as COMPLETED so it's queryable through MediaType; the
 * caller then calls ``createChatMessage`` with ``mediaId`` to attach the
 * video to the chat.
 */
export type CompleteChatVideoUpload = {
  __typename?: 'CompleteChatVideoUpload';
  media?: Maybe<MediaType>;
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type CompleteChatVideoUploadInput = {
  fileKey: Scalars['String']['input'];
  mediaId: Scalars['ID']['input'];
  /** True after a successful PUT to ``thumbnail_upload_url``. The server then writes the manifest JSON and populates ``Media.thumbnail_manifest_path``. */
  thumbnailUploaded?: InputMaybe<Scalars['Boolean']['input']>;
  totalDuration?: InputMaybe<Scalars['Float']['input']>;
  uploadId: Scalars['String']['input'];
  uploadParts: Array<InputMaybe<CompleteChatVideoUploadPartInput>>;
};

export type CompleteChatVideoUploadPartInput = {
  ETag: Scalars['String']['input'];
  PartNumber: Scalars['Int']['input'];
};

export type CompleteExportReportGeneration = {
  __typename?: 'CompleteExportReportGeneration';
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type CompleteExportReportGenerationInput = {
  reportId: Scalars['ID']['input'];
  reportType: ReportTypeEnums;
  s3DocxKey: Scalars['String']['input'];
  s3PdfKey: Scalars['String']['input'];
  uploadStatus: ReportStatusEnums;
};

export type CompleteLearnerFilePdfPreview = {
  __typename?: 'CompleteLearnerFilePdfPreview';
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type CompleteProviderOnboarding = {
  __typename?: 'CompleteProviderOnboarding';
  message?: Maybe<Scalars['String']['output']>;
  provider?: Maybe<ProviderType>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

/**
 * Called by the Python Temporal worker (DocxToPdfConversionWorkflow) once
 * ConvertAPI has successfully produced a PDF.  Sets the PDF S3 key and marks
 * the report COMPLETED so the frontend can download it.
 */
export type CompleteReportPdfConversion = {
  __typename?: 'CompleteReportPdfConversion';
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type CompleteSampleTemplateGeneration = {
  __typename?: 'CompleteSampleTemplateGeneration';
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type CompleteSampleTemplateGenerationInput = {
  reportTemplate: Scalars['ID']['input'];
  s3Key: Scalars['String']['input'];
  uploadStatus: ReportTemplateSampleStatusEnums;
};

export type CompleteSessionVideoForLearner = {
  __typename?: 'CompleteSessionVideoForLearner';
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type CompleteSessionVideoForLearnerInput = {
  fileKey: Scalars['String']['input'];
  mediaId: Scalars['ID']['input'];
  uploadId: Scalars['String']['input'];
  uploadParts: Array<InputMaybe<CompleteSessionVideoUploadPartInput>>;
};

export type CompleteSessionVideoUploadPartInput = {
  ETag: Scalars['String']['input'];
  PartNumber: Scalars['Int']['input'];
};

export type CompleteUploadAnnotationFile = {
  __typename?: 'CompleteUploadAnnotationFile';
  clipAnnotation?: Maybe<ClipAnnotationType>;
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type CompleteUploadAnnotationFileInput = {
  clipAnnotationId: Scalars['ID']['input'];
  fileKey: Scalars['String']['input'];
  uploadId: Scalars['String']['input'];
  uploadParts: Array<InputMaybe<UploadAnnotationFilePartsInput>>;
};

export type CompleteUploadMediaInput = {
  ETag: Scalars['String']['input'];
  PartNumber: Scalars['Int']['input'];
};

export type CompleteUploadTaskMedia = {
  __typename?: 'CompleteUploadTaskMedia';
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
  task?: Maybe<TaskType>;
};

export type CompleteUploadTaskMediaInput = {
  fileKey: Scalars['String']['input'];
  taskId: Scalars['ID']['input'];
  uploadId: Scalars['String']['input'];
  uploadParts: Array<InputMaybe<CompleteUploadTaskMediaPartInput>>;
};

export type CompleteUploadTaskMediaPartInput = {
  ETag: Scalars['String']['input'];
  PartNumber: Scalars['Int']['input'];
};

export type CompleteUploadVideoMutation = {
  __typename?: 'CompleteUploadVideoMutation';
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type CompleteUploadVideoSessionPartInput = {
  ETag: Scalars['String']['input'];
  PartNumber: Scalars['Int']['input'];
};

export type CompleteUploadVideoSessionVideoMutation = {
  __typename?: 'CompleteUploadVideoSessionVideoMutation';
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

/**
 * Completes the Zoom OAuth process using the provided authorization code.
 * Returns a message indicating the connection and cloud recording status.
 */
export type CompleteZoomConnect = {
  __typename?: 'CompleteZoomConnect';
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type ConfirmPaymentAndAddAssessmentCredits = {
  __typename?: 'ConfirmPaymentAndAddAssessmentCredits';
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

export enum ConnectionTypeEnum {
  GoogleOauth = 'GOOGLE_OAUTH',
  UsernamePassword = 'USERNAME_PASSWORD'
}

export enum ConsentTypeEnums {
  AiChatbotAddendum = 'AI_CHATBOT_ADDENDUM',
  AiHippaAuthorization = 'AI_HIPPA_AUTHORIZATION',
  CancellationPolicy = 'CANCELLATION_POLICY',
  CommunityPrivacyPolicy = 'COMMUNITY_PRIVACY_POLICY',
  CommunityTermsOfUseAgreement = 'COMMUNITY_TERMS_OF_USE_AGREEMENT',
  ConsultationCancellationNoShowTardiness = 'CONSULTATION_CANCELLATION_NO_SHOW_TARDINESS',
  ConsultationFinancialPolicy = 'CONSULTATION_FINANCIAL_POLICY',
  ConsultationHipaaAuthorization = 'CONSULTATION_HIPAA_AUTHORIZATION',
  ConsultationTelehealthServices = 'CONSULTATION_TELEHEALTH_SERVICES',
  FinancialPolicy = 'FINANCIAL_POLICY',
  HealthInformation = 'HEALTH_INFORMATION',
  HippaAuthorization = 'HIPPA_AUTHORIZATION',
  IllnessInfection = 'ILLNESS_INFECTION',
  MobileTermsOfService = 'MOBILE_TERMS_OF_SERVICE',
  ProgramSafeguards = 'PROGRAM_SAFEGUARDS',
  VideoRecording = 'VIDEO_RECORDING'
}

/**
 * Return and clear the pending interactive-MFA code for a workflow.
 *
 * Polled by the CentralReach scraper (M2M) while it holds the browser open on
 * the MFA challenge (PROA-1534). Reads ``ScraperLogin.pending_mfa_code``,
 * clears it (so the same code is consumed once), and returns it — ``code`` is
 * null when no code has been entered yet.
 */
export type ConsumePendingMfaCodeMutation = {
  __typename?: 'ConsumePendingMfaCodeMutation';
  code?: Maybe<Scalars['String']['output']>;
};

export type ContinousInteractionClassification = {
  __typename?: 'ContinousInteractionClassification';
  intervals?: Maybe<Array<Maybe<ClassificationInterval>>>;
  subclass?: Maybe<ClassificationSubClassEnum>;
  totalDuration?: Maybe<Scalars['Float']['output']>;
};

export type CreatCloudRecordingMediaM2M = {
  __typename?: 'CreatCloudRecordingMediaM2M';
  media?: Maybe<MediaType>;
};

export type CreatCloudRecordingMediaM2MInput = {
  endDatetime?: InputMaybe<Scalars['DateTime']['input']>;
  mediaSource: MediaSourceEnum;
  mediaType: Scalars['String']['input'];
  organizationId: Scalars['Int']['input'];
  recordingId: Scalars['String']['input'];
  startDatetime?: InputMaybe<Scalars['DateTime']['input']>;
  videoSessionId: Scalars['ID']['input'];
};

export type CreateAnnotater = {
  __typename?: 'CreateAnnotater';
  annotater?: Maybe<ProviderType>;
};

export type CreateAnnotation = {
  __typename?: 'CreateAnnotation';
  annotation?: Maybe<AnnotationType>;
};

export type CreateAnnotationCategoryValue = {
  __typename?: 'CreateAnnotationCategoryValue';
  annotationCategory?: Maybe<AnnotationCategoryType>;
};

export type CreateAnnotationValidate = {
  __typename?: 'CreateAnnotationValidate';
  annotation?: Maybe<AnnotationType>;
};

export type CreateAnnotatorInput = {
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName?: InputMaybe<Scalars['String']['input']>;
  userRole: AnnotationUserRolesEnum;
};

export type CreateAnnotatorUser = {
  __typename?: 'CreateAnnotatorUser';
  annotatorUserDetails?: Maybe<AnnotatorUserType>;
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type CreateAudio = {
  __typename?: 'CreateAudio';
  audio?: Maybe<MediaAudioType>;
  message?: Maybe<Scalars['String']['output']>;
};

/** Create a new base SuggestionCriteria (is_base_criteria=True) */
export type CreateBaseSuggestionCriteria = {
  __typename?: 'CreateBaseSuggestionCriteria';
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
  suggestionCriteria?: Maybe<SuggestionCriteriaType>;
};

/** Mutation to create a single availability block (one-off availability block) for a resource in the Care Resource Calendar */
export type CreateCareResourceSingleAllocationBlock = {
  __typename?: 'CreateCareResourceSingleAllocationBlock';
  allocation?: Maybe<CareResourceSingleAllocationBlockType>;
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

/** Mutation to create a weekly availability allocation for a resource */
export type CreateCareResourceWeeklyAllocationBlock = {
  __typename?: 'CreateCareResourceWeeklyAllocationBlock';
  allocation?: Maybe<CareResourceWeeklyAllocationBlockType>;
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type CreateCaregiverAuth0User = {
  __typename?: 'CreateCaregiverAuth0User';
  caregiver?: Maybe<CaregiverType>;
};

export type CreateCargiverMetadata = {
  __typename?: 'CreateCargiverMetadata';
  caregiverMetadata?: Maybe<CaregiverMetadataType>;
};

export type CreateChat = {
  __typename?: 'CreateChat';
  chat?: Maybe<ChatType>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type CreateChatMessage = {
  __typename?: 'CreateChatMessage';
  chatMessage?: Maybe<ChatMessageType>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type CreateChatMessageInput = {
  chatId: Scalars['ID']['input'];
  content?: InputMaybe<Scalars['String']['input']>;
  fileId?: InputMaybe<Scalars['ID']['input']>;
  mediaId?: InputMaybe<Scalars['ID']['input']>;
  role: Scalars['String']['input'];
  sequenceNumber?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateChatTag = {
  __typename?: 'CreateChatTag';
  chat?: Maybe<ChatType>;
  chatTag?: Maybe<ChatTagType>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type CreateChatTagInput = {
  chatId?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
};

/**
 * Mutation for creating INTAKE and ASSISTANT chats only.
 * For EXPERT chats, use the main CreateChat mutation.
 */
export type CreateChatbotChat = {
  __typename?: 'CreateChatbotChat';
  chat?: Maybe<ChatType>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

/** Mutation for creating chat messages in INTAKE and ASSISTANT chats. */
export type CreateChatbotChatMessage = {
  __typename?: 'CreateChatbotChatMessage';
  chatMessage?: Maybe<ChatMessageType>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type CreateChatbotChatMessageInput = {
  chatId: Scalars['ID']['input'];
  content: Scalars['String']['input'];
  role: Scalars['String']['input'];
  sequenceNumber?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateCheckoutSession = {
  __typename?: 'CreateCheckoutSession';
  clientSecret?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type CreateClassficationFeedback = {
  __typename?: 'CreateClassficationFeedback';
  classificationFeedback?: Maybe<MediaClassificationFeedbackType>;
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type CreateClientFromEhr = {
  __typename?: 'CreateClientFromEHR';
  learner?: Maybe<LearnerType>;
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type CreateClinicLead = {
  __typename?: 'CreateClinicLead';
  clinicLead?: Maybe<ClinicLeadType>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type CreateClinicLeadInput = {
  clinicListingId: Scalars['ID']['input'];
  learnerId: Scalars['ID']['input'];
  payor?: InputMaybe<PayorSelectionType>;
  requestedModalities?: InputMaybe<Array<InputMaybe<ModalityType>>>;
  requestedServices?: InputMaybe<Array<InputMaybe<ClinicalServiceType>>>;
};

export type CreateClipAnnotationByM2M = {
  __typename?: 'CreateClipAnnotationByM2M';
  clipAnnotationData?: Maybe<ClipAnnotationType>;
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type CreateClipAnnotationByM2MInput = {
  annotationTag: Scalars['String']['input'];
  endTime: Scalars['Int']['input'];
  mediaId: Scalars['ID']['input'];
  startTime: Scalars['Int']['input'];
};

export type CreateClipAssignment = {
  __typename?: 'CreateClipAssignment';
  clipAssignmentData?: Maybe<ClipAnnotationType>;
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type CreateClipAssignmentInput = {
  clipId: Scalars['ID']['input'];
};

export type CreateCloudRecordingVideoSessionM2M = {
  __typename?: 'CreateCloudRecordingVideoSessionM2M';
  videoSession?: Maybe<VideoSessionType>;
};

export type CreateCloudRecordingVideoSessionM2MInput = {
  date: Scalars['DateTime']['input'];
  learnerId?: InputMaybe<Scalars['ID']['input']>;
  meetingId: Scalars['String']['input'];
  organizationId: Scalars['Int']['input'];
  providerId?: InputMaybe<Scalars['ID']['input']>;
};

export type CreateCombinedMedia = {
  __typename?: 'CreateCombinedMedia';
  media?: Maybe<MediaType>;
};

/**
 * Mutation to create a new community member in Circle.so
 *
 * This mutation:
 * 1. Validates that the logged-in user is a Caregiver
 * 2. Checks that the email matches the Caregiver's email (users can only create accounts for themselves)
 * 3. Checks if a member with this email already exists in Circle
 * 4. Creates the member if they don't exist
 * 5. Optionally adds them to specified spaces
 *
 * The mutation uses the Admin API V2 to create members and sends them
 * an invitation email to join the community.
 */
export type CreateCommunityMember = {
  __typename?: 'CreateCommunityMember';
  member?: Maybe<CircleMemberType>;
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

/**
 * Creates a new Stripe SetupIntent for the logged-in user.
 *
 * This mutation is used to initiate the process of securely collecting and saving
 * a user's payment method for future off-session payments.
 *
 * Steps:
 * 1. Ensures the user has an existing Stripe Customer; creates one if missing.
 * 2. Creates a Stripe SetupIntent associated with that customer.
 * 3. Returns the `client_secret`, which the frontend uses to confirm the SetupIntent
 *    using Stripe’s SDK (e.g., `confirmSetupIntent`).
 *
 * Use this mutation when you need to allow a user to save their card details
 * without charging them immediately.
 *
 * Response:
 * - `message`: Status message
 * - `status`: Boolean success flag
 * - `setup_client_secret`: The secret token used on the frontend to complete setup
 * - `stripe_customer_id`: ID of the Stripe customer linked to this user
 */
export type CreateCustomerAndPreparePaymentMethod = {
  __typename?: 'CreateCustomerAndPreparePaymentMethod';
  message?: Maybe<Scalars['String']['output']>;
  setupClientSecret?: Maybe<Scalars['String']['output']>;
  setupIntentId?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
  userAccountDetails?: Maybe<UserStripeAccountDetailsType>;
};

export type CreateEnterpriseReportExportTemplate = {
  __typename?: 'CreateEnterpriseReportExportTemplate';
  /** Signed URL for the file */
  fileUrl?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type CreateExportReportGeneration = {
  __typename?: 'CreateExportReportGeneration';
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type CreateGoalBankFolder = {
  __typename?: 'CreateGoalBankFolder';
  goalBankFolder?: Maybe<GoalBankFolderType>;
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type CreateGoalBankFolderInput = {
  folderType: GoalBankFolderTypeEnum;
  name: Scalars['String']['input'];
};

export type CreateGoalBankGoals = {
  __typename?: 'CreateGoalBankGoals';
  goalBankShortGoalsData?: Maybe<Array<Maybe<ReportGoalBankType>>>;
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type CreateGoalBankGoalsInput = {
  folderId: Scalars['ID']['input'];
  shorttermGoalsData: Array<GoalBankInput>;
};

export type CreateGoalBankLongTermGoals = {
  __typename?: 'CreateGoalBankLongTermGoals';
  goalBankLongGoalsData?: Maybe<Array<Maybe<LongTermGoalBankType>>>;
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type CreateGoalBankLongTermGoalsInput = {
  folderId: Scalars['ID']['input'];
  longtermGoalsData: Array<LongTermGoalBankInput>;
};

export type CreateGoalBankTargets = {
  __typename?: 'CreateGoalBankTargets';
  goalBankTargetsData?: Maybe<Array<Maybe<ReportTargetGoalBankType>>>;
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type CreateGoalBankTargetsInput = {
  folderId: Scalars['ID']['input'];
  targetsData: Array<TargetBankInput>;
};

export type CreateGoalsAndTargets = {
  __typename?: 'CreateGoalsAndTargets';
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type CreateHatchPlanInput = {
  caregiverId: Scalars['ID']['input'];
  learnerId: Scalars['ID']['input'];
  statusReason?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CreateHatchPlanPayload = {
  __typename?: 'CreateHatchPlanPayload';
  planId: Scalars['ID']['output'];
};

export type CreateHatchPlanVisualizationInput = {
  generatedData: Scalars['JSONString']['input'];
  planId: Scalars['ID']['input'];
  renderedSvg: Scalars['String']['input'];
  visualizationType: HatchVisualizationType;
};

export type CreateHatchPlanVisualizationPayload = {
  __typename?: 'CreateHatchPlanVisualizationPayload';
  hatchPlanVisualizationId: Scalars['ID']['output'];
};

/** Upload a LearnerFile associated directly to a Learner, without tying it to a Report. */
export type CreateIndependentLearnerFile = {
  __typename?: 'CreateIndependentLearnerFile';
  learnerFile?: Maybe<LearnerFileType>;
};

export type CreateIndependentLearnerFileInput = {
  fileKind: FileTypeEnum;
  fileSize?: InputMaybe<Scalars['BigInt']['input']>;
  learnerId: Scalars['ID']['input'];
  metadata?: InputMaybe<Scalars['JSONString']['input']>;
  mimeType: Scalars['String']['input'];
  originalFileName: Scalars['String']['input'];
};

export type CreateLanguageStylePrompt = {
  __typename?: 'CreateLanguageStylePrompt';
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
  stylePrompt?: Maybe<LanguageStylePromptType>;
};

export type CreateLearner = {
  __typename?: 'CreateLearner';
  learner?: Maybe<LearnerType>;
};

export type CreateLearnerAndVideoSessionByM2M = {
  __typename?: 'CreateLearnerAndVideoSessionByM2M';
  videoSession?: Maybe<VideoSessionType>;
};

export type CreateLearnerAvailability = {
  __typename?: 'CreateLearnerAvailability';
  learnerAvailability?: Maybe<LearnerAvailabilityType>;
};

export type CreateLearnerCaregiver = {
  __typename?: 'CreateLearnerCaregiver';
  caregiver?: Maybe<CaregiverType>;
  insurance?: Maybe<InsuranceDetailsType>;
  learner?: Maybe<LearnerType>;
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type CreateLearnerEducation = {
  __typename?: 'CreateLearnerEducation';
  learnerEducation?: Maybe<LearnerEducationType>;
};

export type CreateLearnerInsurance = {
  __typename?: 'CreateLearnerInsurance';
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type CreateLearnerInsuranceInput = {
  inNetwork: InsuranceInNetworkEnums;
  insuranceType: InsuranceTypeEnums;
  insurer: InsurerEnums;
  learnerId: Scalars['ID']['input'];
};

export type CreateLearnerMedications = {
  __typename?: 'CreateLearnerMedications';
  learnerMedication?: Maybe<LearnerMedicationsType>;
};

export type CreateLearnerMetadata = {
  __typename?: 'CreateLearnerMetadata';
  learnerMetadata?: Maybe<LearnerMetadataType>;
};

export type CreateLearnerPrimaryProvider = {
  __typename?: 'CreateLearnerPrimaryProvider';
  primaryProvider?: Maybe<LearnerPrimaryProviderType>;
};

export type CreateLearnerVideoSessionMutation = {
  __typename?: 'CreateLearnerVideoSessionMutation';
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  videoSession?: Maybe<VideoSessionType>;
};

export type CreateLearnerWithVideoSessionAndMediaByM2M = {
  __typename?: 'CreateLearnerWithVideoSessionAndMediaByM2M';
  learner?: Maybe<LearnerType>;
  media?: Maybe<MediaType>;
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
  videoSession?: Maybe<VideoSessionType>;
};

export type CreateLearnerWithVideoSessionAndMediaM2MInput = {
  birthDate?: InputMaybe<Scalars['Date']['input']>;
  filePath: Scalars['String']['input'];
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  learnerId?: InputMaybe<Scalars['ID']['input']>;
  mediaSource: MediaSourceEnum;
  organizationId: Scalars['Int']['input'];
  sessionStatus: VideoSessionStatusEnums;
};

export type CreateMedia = {
  __typename?: 'CreateMedia';
  media?: Maybe<MediaType>;
};

export type CreateMediaAiPrediction = {
  __typename?: 'CreateMediaAIPrediction';
  mediaAiPreds?: Maybe<Array<Maybe<MediaAiPredictionType>>>;
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type CreateMediaAiPredictionMetrics = {
  __typename?: 'CreateMediaAIPredictionMetrics';
  mediaAiPredMetrics?: Maybe<Array<Maybe<MediaAiPredictionMetricType>>>;
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type CreateMediaClassificationPrediction = {
  __typename?: 'CreateMediaClassificationPrediction';
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type CreateMediaClip = {
  __typename?: 'CreateMediaClip';
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
  videoClip?: Maybe<ClipType>;
};

export type CreateMediaClipInput = {
  endTime: Scalars['Float']['input'];
  startTime: Scalars['Float']['input'];
  title: Scalars['String']['input'];
  videoId: Scalars['ID']['input'];
};

export type CreateMediaComment = {
  __typename?: 'CreateMediaComment';
  mediaComment?: Maybe<MediaCommentsType>;
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type CreateMediaDevice = {
  __typename?: 'CreateMediaDevice';
  mediaDevice?: Maybe<MediaDeviceType>;
};

export type CreateMediaFronteraM2M = {
  __typename?: 'CreateMediaFronteraM2M';
  media?: Maybe<MediaType>;
};

export type CreateMediaM2M = {
  __typename?: 'CreateMediaM2M';
  media?: Maybe<MediaType>;
};

export type CreateMediaMetadata = {
  __typename?: 'CreateMediaMetadata';
  mediaMetadata?: Maybe<MediaMetadataType>;
};

export type CreateMediaStream = {
  __typename?: 'CreateMediaStream';
  mediaStream?: Maybe<MediaStreamType>;
  message?: Maybe<Scalars['String']['output']>;
};

export type CreateMediaTargetPredictionFeedback = {
  __typename?: 'CreateMediaTargetPredictionFeedback';
  mediaTargetPredictionFeedback?: Maybe<MediaTargetPredictionFeedbackType>;
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type CreateMediaTargetPredictions = {
  __typename?: 'CreateMediaTargetPredictions';
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  targetPredictionsData?: Maybe<Array<Maybe<MediaTargetPredictionType>>>;
};

export type CreateMultipleLearnerAvailabilities = {
  __typename?: 'CreateMultipleLearnerAvailabilities';
  learnerAvailabilities?: Maybe<Array<Maybe<LearnerAvailabilityType>>>;
};

export type CreateMultipleLearnerMedications = {
  __typename?: 'CreateMultipleLearnerMedications';
  learnerMedications?: Maybe<Array<Maybe<LearnerMedicationsType>>>;
};

export type CreateMultipleOnboardingQuestions = {
  __typename?: 'CreateMultipleOnboardingQuestions';
  learnerQuestions?: Maybe<Array<Maybe<LearnerOnboardingQuestionsType>>>;
};

export type CreateNotification = {
  __typename?: 'CreateNotification';
  message?: Maybe<Scalars['String']['output']>;
  notification?: Maybe<NotificationsType>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type CreateNotificationInput = {
  channel?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  payload?: InputMaybe<Scalars['JSONString']['input']>;
  /** Recipient Auth0 ID */
  recipientId: Scalars['ID']['input'];
  title: Scalars['String']['input'];
  type: NotificationTypeEnums;
};

export type CreateOnboardingQuestion = {
  __typename?: 'CreateOnboardingQuestion';
  learnerQuestion?: Maybe<LearnerOnboardingQuestionsType>;
};

export type CreateOrUpdateLearnerFormStatus = {
  __typename?: 'CreateOrUpdateLearnerFormStatus';
  message?: Maybe<Scalars['String']['output']>;
  onboardingFormStatus?: Maybe<OnboardingFormStatusType>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

/** Mutation for creating or updating SES email templates. */
export type CreateOrUpdateTemplate = {
  __typename?: 'CreateOrUpdateTemplate';
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

/** Create a new SuggestionCriteria and link it to the requesting organization */
export type CreateOrganizationSuggestionCriteria = {
  __typename?: 'CreateOrganizationSuggestionCriteria';
  message?: Maybe<Scalars['String']['output']>;
  organizationSuggestionCriteria?: Maybe<OrganizationSuggestionCriteriaType>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type CreateOrganizationTemplateLogo = {
  __typename?: 'CreateOrganizationTemplateLogo';
  /** Signed URL for the file */
  fileUrl?: Maybe<Scalars['String']['output']>;
};

export type CreateOrganizationTemplateLogoInput = {
  /** File size in bytes */
  fileSize: Scalars['BigInt']['input'];
  /** Mime type of the file */
  mimeType: Scalars['String']['input'];
  /** Original file name */
  originalFileName: Scalars['String']['input'];
  /** Global ID of the report */
  reportId: Scalars['String']['input'];
};

export type CreateParsedTreatmentPlanFileData = {
  __typename?: 'CreateParsedTreatmentPlanFileData';
  message?: Maybe<Scalars['String']['output']>;
  record?: Maybe<ParsedTreatmentPlanFileDataType>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type CreateParsedTreatmentPlanFileDataInput = {
  fileIds: Array<InputMaybe<Scalars['ID']['input']>>;
};

export type CreatePassageSessions = {
  __typename?: 'CreatePassageSessions';
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export type CreatePaymentIntent = {
  __typename?: 'CreatePaymentIntent';
  message?: Maybe<Scalars['String']['output']>;
  paymentClientSecret?: Maybe<Scalars['String']['output']>;
  paymentIntentId?: Maybe<Scalars['String']['output']>;
  sessionClientSecret?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
  userAccountDetails?: Maybe<UserStripeAccountDetailsType>;
};

export type CreatePrompt = {
  __typename?: 'CreatePrompt';
  message?: Maybe<Scalars['String']['output']>;
  prompt?: Maybe<PromptType>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type CreateProvider = {
  __typename?: 'CreateProvider';
  message?: Maybe<Scalars['String']['output']>;
  provider?: Maybe<ProviderType>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type CreateProviderFile = {
  __typename?: 'CreateProviderFile';
  providerFile?: Maybe<ProviderFileType>;
};

export type CreateProviderFileInput = {
  fileCategory: ProviderFileCategoryEnum;
  fileSize: Scalars['BigInt']['input'];
  metadata?: InputMaybe<Scalars['JSONString']['input']>;
  /** Mime type of the file */
  mimeType: Scalars['String']['input'];
  originalFileName: Scalars['String']['input'];
};

export type CreateProviderFromAuth0User = {
  __typename?: 'CreateProviderFromAuth0User';
  provider?: Maybe<ProviderType>;
};

export type CreateReassessmentReportGoals = {
  __typename?: 'CreateReassessmentReportGoals';
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type CreateRecommendationBankFolder = {
  __typename?: 'CreateRecommendationBankFolder';
  message?: Maybe<Scalars['String']['output']>;
  recommendationBankFolder?: Maybe<RecommendationBankFolderType>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type CreateRecommendationBankFolderInput = {
  folderType: RecommendationBankFolderTypeEnum;
  name: Scalars['String']['input'];
};

export type CreateRecommendationBankItem = {
  __typename?: 'CreateRecommendationBankItem';
  message?: Maybe<Scalars['String']['output']>;
  recommendationBankItem?: Maybe<RecommendationBankItemType>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type CreateRecommendationBankItemInput = {
  folderId: Scalars['ID']['input'];
  recommendationCategory?: InputMaybe<Scalars['String']['input']>;
  recommendationContent: Scalars['String']['input'];
  recommendationTitle?: InputMaybe<Scalars['String']['input']>;
};

export type CreateReport = {
  __typename?: 'CreateReport';
  message?: Maybe<Scalars['String']['output']>;
  report?: Maybe<ReportType>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

/**
 * Create a root peer-review comment on a field, or a reply to an
 * existing peer-review comment. QA suggestions cannot be replied to.
 */
export type CreateReportComment = {
  __typename?: 'CreateReportComment';
  comment?: Maybe<ReportCommentType>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type CreateReportFromTemplate = {
  __typename?: 'CreateReportFromTemplate';
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type CreateReportInternalLearnerFile = {
  __typename?: 'CreateReportInternalLearnerFile';
  learnerFile?: Maybe<LearnerFileType>;
};

export type CreateReportInternalLearnerFileInput = {
  fileKind: FileTypeEnum;
  fileSize: Scalars['Int']['input'];
  learner?: InputMaybe<Scalars['ID']['input']>;
  metadata?: InputMaybe<Scalars['JSONString']['input']>;
  /** Mime type of the file */
  mimeType: Scalars['String']['input'];
  originalFileName: Scalars['String']['input'];
  parentFile?: InputMaybe<Scalars['ID']['input']>;
  report?: InputMaybe<Scalars['ID']['input']>;
  s3Key?: InputMaybe<Scalars['String']['input']>;
};

export type CreateReportLearnerFile = {
  __typename?: 'CreateReportLearnerFile';
  learnerFile?: Maybe<LearnerFileType>;
};

export type CreateReportLearnerFileInput = {
  assessmentTemplateType?: InputMaybe<LearnerFileAssessmentTemplateTypeEnums>;
  fileKind: FileTypeEnum;
  fileSize?: InputMaybe<Scalars['BigInt']['input']>;
  metadata?: InputMaybe<Scalars['JSONString']['input']>;
  /** Mime type of the file */
  mimeType: Scalars['String']['input'];
  originalFileName: Scalars['String']['input'];
  reportId: Scalars['String']['input'];
};

export type CreateReportSectionField = {
  __typename?: 'CreateReportSectionField';
  message?: Maybe<Scalars['String']['output']>;
  report?: Maybe<ReportType>;
  reportSectionField?: Maybe<ReportSectionFieldsType>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type CreateReportSectionFieldFile = {
  __typename?: 'CreateReportSectionFieldFile';
  /** Signed URL for the uploaded file */
  fileUrl?: Maybe<Scalars['String']['output']>;
};

export type CreateReportSectionFieldFileInput = {
  /** Global ID of the field */
  fieldId: Scalars['String']['input'];
  /** File size in bytes */
  fileSize: Scalars['BigInt']['input'];
  /** Mime type of the file */
  mimeType: Scalars['String']['input'];
  /** Original file name */
  originalFileName: Scalars['String']['input'];
  /** Global ID of the report */
  reportId: Scalars['String']['input'];
};

export type CreateReportSections = {
  __typename?: 'CreateReportSections';
  message?: Maybe<Scalars['String']['output']>;
  report?: Maybe<ReportType>;
  reportSections?: Maybe<Array<Maybe<ReportSectionsType>>>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

/** Create multiple ReportSuggestion objects */
export type CreateReportSuggestions = {
  __typename?: 'CreateReportSuggestions';
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type CreateReportTemplateFileInput = {
  /** File size in bytes */
  fileSize: Scalars['Int']['input'];
  /** Mime type of the file */
  mimeType: Scalars['String']['input'];
  /** Original file name */
  originalFileName: Scalars['String']['input'];
  /** Global ID of the report */
  reportTemplateId: Scalars['String']['input'];
};

export type CreateReportTemplateLogo = {
  __typename?: 'CreateReportTemplateLogo';
  /** Signed URL for the file */
  fileUrl?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

/**
 * Given a page location and report id, generates the appropriate sections from report templates.
 * If running for the first time, will additionally kick off AI generation (via Temporal) for all AI sections.
 *
 * Uses database templates instead of code configuration to determine section structure.
 */
export type CreateReportTemplateSections = {
  __typename?: 'CreateReportTemplateSections';
  message?: Maybe<Scalars['String']['output']>;
  report?: Maybe<ReportType>;
  reportSections?: Maybe<Array<Maybe<ReportSectionsType>>>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

/** Create a new SuggestionCriteria and link it to a ReportTemplate */
export type CreateReportTemplateSuggestionCriteria = {
  __typename?: 'CreateReportTemplateSuggestionCriteria';
  message?: Maybe<Scalars['String']['output']>;
  reportTemplateSuggestionCriteria?: Maybe<ReportTemplateSuggestionCriteriaType>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type CreateSampleTemplate = {
  __typename?: 'CreateSampleTemplate';
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type CreateSelfServeCaregiverFromAuth0User = {
  __typename?: 'CreateSelfServeCaregiverFromAuth0User';
  auth0OrganizationId?: Maybe<Scalars['String']['output']>;
  b2b2cCaregiverCreated?: Maybe<Scalars['Boolean']['output']>;
  caregiver?: Maybe<CaregiverType>;
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type CreateSelfServeProviderFromAuth0User = {
  __typename?: 'CreateSelfServeProviderFromAuth0User';
  message?: Maybe<Scalars['String']['output']>;
  provider?: Maybe<ProviderType>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type CreateSessionAiPrediction = {
  __typename?: 'CreateSessionAIPrediction';
  message?: Maybe<Scalars['String']['output']>;
  sessionAiPreds?: Maybe<Array<Maybe<SessionAiPredictionType>>>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type CreateSessionEngagementScorePart = {
  __typename?: 'CreateSessionEngagementScorePart';
  message?: Maybe<Scalars['String']['output']>;
  sessionEngagementScoreParts?: Maybe<Array<Maybe<SessionEngagementScorePartType>>>;
  status?: Maybe<Scalars['String']['output']>;
};

export type CreateSessionInsights = {
  __typename?: 'CreateSessionInsights';
  message?: Maybe<Scalars['String']['output']>;
  sessionInsights?: Maybe<Array<Maybe<SessionEngagementInsightType>>>;
  status?: Maybe<Scalars['String']['output']>;
};

export type CreateSetupIntent = {
  __typename?: 'CreateSetupIntent';
  message?: Maybe<Scalars['String']['output']>;
  sessionClientSecret?: Maybe<Scalars['String']['output']>;
  setupClientSecret?: Maybe<Scalars['String']['output']>;
  setupIntentId?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
  userAccountDetails?: Maybe<UserStripeAccountDetailsType>;
};

export type CreateTaskLearnerFile = {
  __typename?: 'CreateTaskLearnerFile';
  learnerFile?: Maybe<LearnerFileType>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
  task?: Maybe<TaskType>;
};

export type CreateTaskLearnerFileInput = {
  fileSize: Scalars['Int']['input'];
  metadata?: InputMaybe<Scalars['JSONString']['input']>;
  mimeType: Scalars['String']['input'];
  originalFileName: Scalars['String']['input'];
  taskId: Scalars['ID']['input'];
};

export type CreateTaskMedia = {
  __typename?: 'CreateTaskMedia';
  fileKey?: Maybe<Scalars['String']['output']>;
  media?: Maybe<MediaType>;
  message?: Maybe<Scalars['String']['output']>;
  multipartUploadId?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
  task?: Maybe<TaskType>;
  uploadUrls?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type CreateTaskMediaInput = {
  deviceName: Scalars['String']['input'];
  fileExtension: Scalars['String']['input'];
  location: Scalars['String']['input'];
  requiredParts: Scalars['Int']['input'];
  taskId: Scalars['ID']['input'];
  videoSegmentIndex: Scalars['Int']['input'];
};

export type CreateTranscript = {
  __typename?: 'CreateTranscript';
  message?: Maybe<Scalars['String']['output']>;
  transcript?: Maybe<TranscriptType>;
};

export type CreateTreatmentPlanCustomFieldFile = {
  __typename?: 'CreateTreatmentPlanCustomFieldFile';
  /** Signed URL for the uploaded file */
  fileUrl?: Maybe<Scalars['String']['output']>;
};

export type CreateTreatmentPlanCustomFieldFileInput = {
  /** Global ID of the treatment plan custom field */
  customFieldId: Scalars['String']['input'];
  /** File size in bytes */
  fileSize: Scalars['BigInt']['input'];
  /** Mime type of the file */
  mimeType: Scalars['String']['input'];
  /** Original file name */
  originalFileName: Scalars['String']['input'];
};

export type CreateUpdateChatNote = {
  __typename?: 'CreateUpdateChatNote';
  chatNote?: Maybe<ChatNoteType>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type CreateUpdateChatNoteInput = {
  chatId?: InputMaybe<Scalars['ID']['input']>;
  chatNoteId?: InputMaybe<Scalars['ID']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Upsert the content (value) of a TreatmentPlanCustomField.
 *
 * Two modes:
 *
 * 1. When ``custom_field_id`` is provided, update the existing row.
 * 2. When ``custom_field_id`` is null, the client must provide
 *    ``field_identifier`` and exactly one of ``report_goal_id``,
 *    ``report_target_id``, or ``report_domain_id``. If a matching custom
 *    field already exists for that entity it is updated; otherwise we look
 *    up the TreatmentPlanTemplateField with the same identifier on the
 *    entity's treatment plan template, create a custom field row from that
 *    spec, then set its content.
 */
export type CreateUpdateCustomFieldValue = {
  __typename?: 'CreateUpdateCustomFieldValue';
  customField?: Maybe<TreatmentPlanCustomFieldType>;
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type CreateUpdateReportGoal = {
  __typename?: 'CreateUpdateReportGoal';
  message?: Maybe<Scalars['String']['output']>;
  reportGoalData?: Maybe<ReportGoalType>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type CreateUpdateReportTarget = {
  __typename?: 'CreateUpdateReportTarget';
  message?: Maybe<Scalars['String']['output']>;
  reportTargetDetails?: Maybe<ReportTargetType>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type CreateUpdateSessionMediaReviewActivityLog = {
  __typename?: 'CreateUpdateSessionMediaReviewActivityLog';
  mediaActivityLog?: Maybe<SessionMediaReviewActivityLogType>;
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type CreateUpdateVoiceSignature = {
  __typename?: 'CreateUpdateVoiceSignature';
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
  voiceSignature?: Maybe<VoiceSignatureType>;
};

export type CreateUpdateVoiceSignatureInput = {
  learnerId?: InputMaybe<Scalars['ID']['input']>;
  learnerLevel?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  providerId?: InputMaybe<Scalars['ID']['input']>;
  s3Path?: InputMaybe<Scalars['String']['input']>;
  totalDurationMs?: InputMaybe<Scalars['Int']['input']>;
  voiceSignatureId?: InputMaybe<Scalars['ID']['input']>;
};

export type CreateVerifier = {
  __typename?: 'CreateVerifier';
  verifier?: Maybe<ProviderType>;
};

export type CreateVideoSession = {
  __typename?: 'CreateVideoSession';
  videoSession?: Maybe<VideoSessionType>;
};

export type CreateVideoSessionAndMediaInClinic = {
  __typename?: 'CreateVideoSessionAndMediaInClinic';
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
  videoSession?: Maybe<VideoSessionType>;
};

export type CreateVideoSessionM2M = {
  __typename?: 'CreateVideoSessionM2M';
  videoSession?: Maybe<VideoSessionType>;
};

export type CumulativeTargets = {
  __typename?: 'CumulativeTargets';
  date?: Maybe<Scalars['DateTime']['output']>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type CurriculumType = Node & {
  __typename?: 'CurriculumType';
  /** The ID of the object */
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type CustomFieldValueInput = {
  content: Scalars['String']['input'];
  fieldIdentifier: Scalars['String']['input'];
};

export type CustomGoalBankFoldersType = {
  __typename?: 'CustomGoalBankFoldersType';
  organizationFolders?: Maybe<Array<Maybe<GoalBankFolderType>>>;
  userFolders?: Maybe<Array<Maybe<GoalBankFolderType>>>;
};

/** Input type for a day's schedule within a weekly allocation */
export type DayScheduleInputType = {
  /** End time in HH:MM format (e.g., '17:00') */
  endTime: Scalars['String']['input'];
  /** Start time in HH:MM format (e.g., '09:00') */
  startTime: Scalars['String']['input'];
};

/** GraphQL type for a day's schedule within a weekly allocation */
export type DayScheduleType = {
  __typename?: 'DayScheduleType';
  /** End time in HH:MM format (e.g., '17:00') */
  endTime: Scalars['String']['output'];
  /** Start time in HH:MM format (e.g., '09:00') */
  startTime: Scalars['String']['output'];
};

/**
 * Mutation for a logged-in caregiver to deactivate their own account.
 * Blocks user in Auth0 and deactivates local user.
 */
export type DeactivateCaregiverAccount = {
  __typename?: 'DeactivateCaregiverAccount';
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

/** As we add more sources we will want different defaults for our configs */
export enum DefaultConfigEnums {
  CaregiverVideoCapture = 'CAREGIVER_VIDEO_CAPTURE',
  RbtVideoCapture = 'RBT_VIDEO_CAPTURE'
}

export type DeleteAnnotation = {
  __typename?: 'DeleteAnnotation';
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteAnnotationFile = {
  __typename?: 'DeleteAnnotationFile';
  clipAnnotation?: Maybe<ClipAnnotationType>;
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteAnnotationMedia = {
  __typename?: 'DeleteAnnotationMedia';
  status?: Maybe<Scalars['Boolean']['output']>;
};

/** Mutation to delete a single allocation (one-off availability block) */
export type DeleteCareResourceSingleAllocationBlock = {
  __typename?: 'DeleteCareResourceSingleAllocationBlock';
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

/** Mutation to delete a weekly allocation */
export type DeleteCareResourceWeeklyAllocationBlock = {
  __typename?: 'DeleteCareResourceWeeklyAllocationBlock';
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

/** Delete ASSISTANT chats. */
export type DeleteChat = {
  __typename?: 'DeleteChat';
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteChatNote = {
  __typename?: 'DeleteChatNote';
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteClipAssignmentAnnotation = {
  __typename?: 'DeleteClipAssignmentAnnotation';
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteDeviceToken = {
  __typename?: 'DeleteDeviceToken';
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteDeviceTokenInput = {
  deviceIdentifier: Scalars['String']['input'];
};

/**
 * Delete EHR credentials on logout (Frontend)
 *
 * Also ends any active ScraperSessionWorkflow for this provider
 *
 * returns: Success message
 */
export type DeleteEhrCredentials = {
  __typename?: 'DeleteEhrCredentials';
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

/**
 * The mutation deletes the given report template by ID.
 * Allows deleting base templates and templates with existing reports.
 * Available only to enterprise admins
 */
export type DeleteEnterpriseReportTemplate = {
  __typename?: 'DeleteEnterpriseReportTemplate';
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteGoalBankFolder = {
  __typename?: 'DeleteGoalBankFolder';
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteGoalBankFolderInput = {
  folderId: Scalars['ID']['input'];
  folderType: GoalBankFolderTypeEnum;
};

export type DeleteGoalBankGoal = {
  __typename?: 'DeleteGoalBankGoal';
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteGoalBankGoalInput = {
  folderId: Scalars['ID']['input'];
  goalBankShortTermId: Scalars['ID']['input'];
};

export type DeleteGoalBankLongTermGoal = {
  __typename?: 'DeleteGoalBankLongTermGoal';
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteGoalBankLongTermGoalInput = {
  folderId: Scalars['ID']['input'];
  goalBankLongTermId: Scalars['ID']['input'];
};

export type DeleteGoalBankTarget = {
  __typename?: 'DeleteGoalBankTarget';
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteGoalBankTargetInput = {
  folderId: Scalars['ID']['input'];
  goalBankTargetId: Scalars['ID']['input'];
};

/**
 * Mutation to delete all short term goals for a specific learner.
 * Originally written to support end to end testing scenarios where we need a clean state.
 */
export type DeleteGoalsForLearner = {
  __typename?: 'DeleteGoalsForLearner';
  deletedCount?: Maybe<Scalars['Int']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteLearnerAvailability = {
  __typename?: 'DeleteLearnerAvailability';
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteLearnerFile = {
  __typename?: 'DeleteLearnerFile';
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteMediaClip = {
  __typename?: 'DeleteMediaClip';
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type DeletePaymentMethod = {
  __typename?: 'DeletePaymentMethod';
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
  userAccountDetails?: Maybe<UserStripeAccountDetailsType>;
};

export type DeleteProviderFile = {
  __typename?: 'DeleteProviderFile';
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteRecommendationBankFolder = {
  __typename?: 'DeleteRecommendationBankFolder';
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteRecommendationBankFolderInput = {
  folderId: Scalars['ID']['input'];
  folderType: RecommendationBankFolderTypeEnum;
};

export type DeleteRecommendationBankItem = {
  __typename?: 'DeleteRecommendationBankItem';
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteReport = {
  __typename?: 'DeleteReport';
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

/**
 * Deletes the caller's own comment or reply, whatever its status. The
 * row stays as a tombstone so replies and the activity log survive; its
 * text and edit history are cleared.
 */
export type DeleteReportComment = {
  __typename?: 'DeleteReportComment';
  comment?: Maybe<ReportCommentType>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteReportSection = {
  __typename?: 'DeleteReportSection';
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteReportSectionField = {
  __typename?: 'DeleteReportSectionField';
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

/** The mutation deletes the given report template by ID. */
export type DeleteReportTemplate = {
  __typename?: 'DeleteReportTemplate';
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

/** Mutation for deleting SES email templates. */
export type DeleteTemplate = {
  __typename?: 'DeleteTemplate';
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export enum DevelopmentMilestonesQuestionType {
  AbleToUseAForkAndKnifeToEat = 'ABLE_TO_USE_A_FORK_AND_KNIFE_TO_EAT',
  CanCount_10OrMoreObjects = 'CAN_COUNT_10_OR_MORE_OBJECTS',
  CrawlsAndStandsBrieflyBySelf = 'CRAWLS_AND_STANDS_BRIEFLY_BY_SELF',
  DrawsPeopleWithTwoToFourBodyParts = 'DRAWS_PEOPLE_WITH_TWO_TO_FOUR_BODY_PARTS',
  DressAndUndressWithoutHelp = 'DRESS_AND_UNDRESS_WITHOUT_HELP',
  NamesAtLeastOneColor = 'NAMES_AT_LEAST_ONE_COLOR',
  PlayedPeekABoo = 'PLAYED_PEEK_A_BOO',
  PrintSomeLetters = 'PRINT_SOME_LETTERS',
  RideATricycle = 'RIDE_A_TRICYCLE',
  SaidFirstTwoWordSentence = 'SAID_FIRST_TWO_WORD_SENTENCE',
  SaidFirstWord = 'SAID_FIRST_WORD',
  ToiletTrained = 'TOILET_TRAINED',
  UnderstoodSameAndDifferent = 'UNDERSTOOD_SAME_AND_DIFFERENT',
  UsedFiveToSixWordSentences = 'USED_FIVE_TO_SIX_WORD_SENTENCES',
  UsedThreeToFiveWordSentences = 'USED_THREE_TO_FIVE_WORD_SENTENCES',
  WalkWithoutHelp = 'WALK_WITHOUT_HELP'
}

export enum DiagnosisEvaluationAssessmentToolCategoriesEnum {
  Adaptive = 'ADAPTIVE',
  Cognitive = 'COGNITIVE',
  Diagnostic = 'DIAGNOSTIC',
  RatingScales = 'RATING_SCALES',
  Screeners = 'SCREENERS'
}

/**
 * Soft-disconnect a caregiver from a clinic tenant.
 *
 * A caregiver can disconnect themselves; an internal caller may disconnect a
 * specific caregiver by passing `caregiver`. Sets the `Membership` inactive.
 * The activation code stays spent.
 */
export type DisconnectCaregiverFromOrganization = {
  __typename?: 'DisconnectCaregiverFromOrganization';
  membership?: Maybe<MembershipType>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type DismissNotification = {
  __typename?: 'DismissNotification';
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type DismissNotificationInput = {
  notificationId: Scalars['ID']['input'];
};

export type DispatchMediaCommentNotifications = {
  __typename?: 'DispatchMediaCommentNotifications';
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type DomainInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
};

export type DomainType = Node & {
  __typename?: 'DomainType';
  createdBy?: Maybe<UserType>;
  description?: Maybe<Scalars['String']['output']>;
  /** The ID of the object */
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type DomainTypeConnection = {
  __typename?: 'DomainTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<DomainTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `DomainType` and its cursor. */
export type DomainTypeEdge = {
  __typename?: 'DomainTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<DomainType>;
};

export type DownloadableTemplatesType = {
  __typename?: 'DownloadableTemplatesType';
  assessment: Scalars['String']['output'];
  fronteraFileLink: Scalars['String']['output'];
  key?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  officialFileLink: Scalars['String']['output'];
};

/**
 * Create a new report goal by copying metadata from an existing goal.
 * Resets status to New Goal, strips progress/chart/approval data, and does not
 * copy targets or goal phase/event rows.
 */
export type DuplicateReportGoal = {
  __typename?: 'DuplicateReportGoal';
  message?: Maybe<Scalars['String']['output']>;
  reportGoalData?: Maybe<ReportGoalType>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

/** The mutation duplicates the given report template by ID and saves it in draft state to be edited. */
export type DuplicateReportTemplate = {
  __typename?: 'DuplicateReportTemplate';
  message?: Maybe<Scalars['String']['output']>;
  newTemplate?: Maybe<ReportTemplateType>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type DuplicateReportTemplateInput = {
  isSelfServeUser?: InputMaybe<Scalars['Boolean']['input']>;
  reportTemplateId: Scalars['ID']['input'];
};

export type EhrConnection = {
  __typename?: 'EHRConnection';
  status?: Maybe<EhrConnectionStatus>;
};

/** Input for updating goal and target external IDs from HR system. */
export type EhrGoalTargetInput = {
  externalGoalId: Scalars['String']['input'];
  goalId: Scalars['Int']['input'];
  targets: Array<InputMaybe<EhrTargetInput>>;
};

export type EhrScraperLearnerImportStatusResponse = {
  __typename?: 'EHRScraperLearnerImportStatusResponse';
  leanerImportStatus?: Maybe<LearnerImportStatusType>;
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type EhrScraperLoginStatusType = {
  __typename?: 'EHRScraperLoginStatusType';
  getLoginStatus?: Maybe<ScraperLoginType>;
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type EhrSyncAffectedItemInput = {
  message: Scalars['String']['input'];
};

export type EhrSyncAffectedItemType = {
  __typename?: 'EHRSyncAffectedItemType';
  message: Scalars['String']['output'];
};

export type EhrSyncAlertInput = {
  error?: InputMaybe<Scalars['String']['input']>;
  userMessage?: InputMaybe<Scalars['String']['input']>;
  warnings?: InputMaybe<Array<InputMaybe<EhrSyncWarningInput>>>;
};

export type EhrSyncAlertType = {
  __typename?: 'EHRSyncAlertType';
  error?: Maybe<Scalars['String']['output']>;
  userMessage?: Maybe<Scalars['String']['output']>;
  warnings?: Maybe<Array<Maybe<EhrSyncWarningType>>>;
};

export type EhrSyncAlertsType = {
  __typename?: 'EHRSyncAlertsType';
  exportAlert?: Maybe<EhrSyncAlertType>;
  importAlert?: Maybe<EhrSyncAlertType>;
};

export enum EhrSyncStatusEnum {
  AwaitingReview = 'AWAITING_REVIEW',
  Completed = 'COMPLETED',
  Failure = 'FAILURE',
  HasWaitingItems = 'HAS_WAITING_ITEMS',
  Inprogress = 'INPROGRESS',
  Pending = 'PENDING'
}

export type EhrSyncWarningInput = {
  affectedItems: Array<EhrSyncAffectedItemInput>;
  description: Scalars['String']['input'];
};

export type EhrSyncWarningType = {
  __typename?: 'EHRSyncWarningType';
  affectedItems: Array<EhrSyncAffectedItemType>;
  description: Scalars['String']['output'];
};

/** Input for updating target external IDs from HR system. */
export type EhrTargetInput = {
  externalTargetId: Scalars['String']['input'];
  targetId: Scalars['Int']['input'];
};

/**
 * GraphQL mutation for updating external IDs from EHR system.
 *
 * This mutation is called by Temporal workflow after successful creation
 * of goals and targets in the external EHR system to update our database
 * with the external IDs provided by the EHR system.
 *
 * Supports EHR-specific goal/target models based on org_type:
 * - HI_RASMUS: HiRasmusGoal/HiRasmusTarget (lookup by goal__id/target__id)
 * - MOTIVITY: MotivityGoal/MotivityTarget (lookup by goal__id/target__id)
 * - CENTRAL_REACH: CentralReachGoal/CentralReachTarget (lookup by goal__id/target__id)
 * - HIPP_HEALTH: HippHealthGoal/HippHealthTarget (lookup by goal__id/target__id)
 * - RETHINK: RethinkGoal/RethinkTarget (lookup by goal__id/target__id)
 * - ENSORA: EnsoraGoal/EnsoraTarget (lookup by goal__id/target__id)
 *
 * :param org_type: Organization type to determine which model to update
 * :param goals_and_targets: List of goals with their targets and external IDs
 * :return: EHRUpdateExternalIds: Mutation result with status and message
 * :raises GraphQLError: If goal or target not found
 */
export type EhrUpdateExternalIds = {
  __typename?: 'EHRUpdateExternalIds';
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type EhrUpdateSyncStatusMutation = {
  __typename?: 'EHRUpdateSyncStatusMutation';
  message?: Maybe<Scalars['String']['output']>;
};

/**
 * Edits the body of the caller's own open comment or reply. A Proposed
 * Edit's suggested text is not editable, only the explanation around it.
 */
export type EditReportComment = {
  __typename?: 'EditReportComment';
  comment?: Maybe<ReportCommentType>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

/** One queued or finished EHR action, as the portal sees it. */
export type EhrActionRequestType = {
  __typename?: 'EhrActionRequestType';
  actionType: Scalars['String']['output'];
  childWorkflowId?: Maybe<Scalars['String']['output']>;
  createdDate?: Maybe<Scalars['DateTime']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  finishedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Int']['output'];
  learnerId?: Maybe<Scalars['Int']['output']>;
  pool: Scalars['String']['output'];
  reportId?: Maybe<Scalars['Int']['output']>;
  requestedById: Scalars['Int']['output'];
  startedAt?: Maybe<Scalars['DateTime']['output']>;
  status: Scalars['String']['output'];
};

export type EhrChildCollection = {
  __typename?: 'EhrChildCollection';
  key: Scalars['String']['output'];
  label: Scalars['String']['output'];
  rows: Array<EhrStoredRow>;
};

export enum EhrConnectionStatus {
  Connected = 'CONNECTED',
  ConnectionError = 'CONNECTION_ERROR',
  CredentialsFailed = 'CREDENTIALS_FAILED',
  Disconnected = 'DISCONNECTED',
  ExportingTreatmentPlan = 'EXPORTING_TREATMENT_PLAN',
  ImportingClientList = 'IMPORTING_CLIENT_LIST',
  ImportingTreatmentPlan = 'IMPORTING_TREATMENT_PLAN',
  LoggingIn = 'LOGGING_IN',
  Reconnecting = 'RECONNECTING'
}

/**
 * Check if EHR credentials exist for frontend
 *
 * param: has_credentials: True if credentials exist, False otherwise
 */
export type EhrCredentialsExistType = {
  __typename?: 'EhrCredentialsExistType';
  hasCredentials?: Maybe<Scalars['Boolean']['output']>;
};

/**
 * EHR credentials response type for Temporal
 *
 * param: username: EHR username
 * param: password: EHR password
 */
export type EhrCredentialsType = {
  __typename?: 'EhrCredentialsType';
  password?: Maybe<Scalars['String']['output']>;
  username?: Maybe<Scalars['String']['output']>;
};

/** Auxiliary mutation to codegen EHR enums */
export type EhrEnumsCodegen = {
  __typename?: 'EhrEnumsCodegen';
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type EhrExternalIdPair = {
  __typename?: 'EhrExternalIdPair';
  externalId: Scalars['String']['output'];
  id: Scalars['Int']['output'];
};

export type EhrExternalIdsResult = {
  __typename?: 'EhrExternalIdsResult';
  goals: Array<Maybe<EhrExternalIdPair>>;
  targets: Array<Maybe<EhrExternalIdPair>>;
};

export type EhrGoal = {
  __typename?: 'EhrGoal';
  ehrTargets?: Maybe<Array<Maybe<EhrTarget>>>;
  goalId: Scalars['ID']['output'];
  lastUpdatedDate: Scalars['DateTime']['output'];
  reportGoalCreated: Scalars['Boolean']['output'];
  status?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

export type EhrProgrammingGoal = {
  __typename?: 'EhrProgrammingGoal';
  collections: Array<EhrChildCollection>;
  /** Formatted for display. */
  createdDate?: Maybe<Scalars['String']['output']>;
  externalId?: Maybe<Scalars['String']['output']>;
  fields: Array<EhrStoredField>;
  /** GoalType global id */
  id: Scalars['ID']['output'];
  /** Formatted for display. */
  lastUpdatedDate?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  /** Goal-level session data only (rows with no target). */
  sessionSummary: EhrSessionDataSummary;
  targets: Array<EhrProgrammingTarget>;
};

export type EhrProgrammingTarget = {
  __typename?: 'EhrProgrammingTarget';
  collections: Array<EhrChildCollection>;
  /** Formatted for display. */
  createdDate?: Maybe<Scalars['String']['output']>;
  externalId?: Maybe<Scalars['String']['output']>;
  fields: Array<EhrStoredField>;
  /** TargetType global id */
  id: Scalars['ID']['output'];
  /** Formatted for display. */
  lastUpdatedDate?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  sessionSummary: EhrSessionDataSummary;
};

/**
 * Queue one EHR action for this provider.
 *
 * ``created`` is False when an identical request was already in flight. The
 * caller should show the existing request with attribution ("already
 * running, started by X") — not report a fresh success, and not silently do
 * nothing.
 */
export type EhrRequestAction = {
  __typename?: 'EhrRequestAction';
  created?: Maybe<Scalars['Boolean']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  requestId?: Maybe<Scalars['Int']['output']>;
  requestedById?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export type EhrSessionDataPage = {
  __typename?: 'EhrSessionDataPage';
  rows: Array<EhrSessionDataRow>;
  totalCount: Scalars['Int']['output'];
};

export type EhrSessionDataRow = {
  __typename?: 'EhrSessionDataRow';
  fields: Array<EhrStoredField>;
  /** GoalType global id */
  goalId?: Maybe<Scalars['ID']['output']>;
  /** SessionTargetProgressType global id */
  id: Scalars['ID']['output'];
  session?: Maybe<EhrSessionRecord>;
  /** TargetType global id */
  targetId?: Maybe<Scalars['ID']['output']>;
};

export type EhrSessionDataSummary = {
  __typename?: 'EhrSessionDataSummary';
  dataPointCount: Scalars['Int']['output'];
  /** UTC day, formatted for display. */
  firstDate?: Maybe<Scalars['String']['output']>;
  /** UTC day, formatted for display. */
  lastDate?: Maybe<Scalars['String']['output']>;
  sessionCount: Scalars['Int']['output'];
};

export type EhrSessionRecord = {
  __typename?: 'EhrSessionRecord';
  fields: Array<EhrStoredField>;
  /** TherapySessionType global id */
  id: Scalars['ID']['output'];
};

export type EhrStoredField = {
  __typename?: 'EhrStoredField';
  /** The column name as stored. */
  key: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type EhrStoredRow = {
  __typename?: 'EhrStoredRow';
  fields: Array<EhrStoredField>;
};

export type EhrSyncRun = {
  __typename?: 'EhrSyncRun';
  ehrName: Scalars['String']['output'];
  /** EhrSyncType global id */
  id: Scalars['ID']['output'];
  runFolder: Scalars['String']['output'];
  /** Formatted for display (UTC). */
  startedAt: Scalars['String']['output'];
  temporalWorkflowId?: Maybe<Scalars['String']['output']>;
};

export type EhrSyncRunPage = {
  __typename?: 'EhrSyncRunPage';
  rows: Array<EhrSyncRun>;
  totalCount: Scalars['Int']['output'];
};

export type EhrTarget = {
  __typename?: 'EhrTarget';
  lastUpdatedDate: Scalars['DateTime']['output'];
  reportTargetCreated: Scalars['Boolean']['output'];
  reportTargetExcluded?: Maybe<Scalars['Boolean']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  targetId: Scalars['ID']['output'];
  title: Scalars['String']['output'];
};

export type EndEhrScraperWorkflow = {
  __typename?: 'EndEhrScraperWorkflow';
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type EngagementScoreType = {
  __typename?: 'EngagementScoreType';
  engagementScore?: Maybe<Scalars['Float']['output']>;
  timeInMinute?: Maybe<Scalars['Float']['output']>;
};

export type EnterpriseReportTemplateSectionFieldInput = {
  content?: InputMaybe<Scalars['String']['input']>;
  fieldIdentifier?: InputMaybe<Scalars['String']['input']>;
  fieldType?: InputMaybe<ReportSectionFieldTypeEnums>;
  id: Scalars['ID']['input'];
  inputDependency?: InputMaybe<Array<InputMaybe<InputDependencyChoices>>>;
  isAuditable?: InputMaybe<Scalars['Boolean']['input']>;
  isRequired?: InputMaybe<Scalars['Boolean']['input']>;
  promptId?: InputMaybe<Scalars['ID']['input']>;
  rankOrder?: InputMaybe<Scalars['Int']['input']>;
  sampleData?: InputMaybe<Scalars['String']['input']>;
  tableKey?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type EnterpriseReportTemplateSectionInput = {
  id: Scalars['ID']['input'];
  inputDependency?: InputMaybe<Array<InputMaybe<InputDependencyChoices>>>;
  key?: InputMaybe<Scalars['String']['input']>;
  pageLocation?: InputMaybe<ReportPageLocationEnums>;
  rankOrder?: InputMaybe<Scalars['Int']['input']>;
  sectionFields?: InputMaybe<Array<InputMaybe<EnterpriseReportTemplateSectionFieldInput>>>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type EvalPromptThemeInput = {
  categories?: InputMaybe<Array<Scalars['String']['input']>>;
  description: Scalars['String']['input'];
  groupSize: Scalars['Int']['input'];
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  organizationName?: InputMaybe<Scalars['String']['input']>;
  promptKey: Scalars['String']['input'];
  support: Scalars['Int']['input'];
  title: Scalars['String']['input'];
};

export type EventEhrImportInput = {
  date: Scalars['DateTime']['input'];
  text: Scalars['String']['input'];
};

export type EventType = {
  __typename?: 'EventType';
  date?: Maybe<Scalars['DateTime']['output']>;
  text?: Maybe<Scalars['String']['output']>;
};

export type ExportClientDetailsType = {
  __typename?: 'ExportClientDetailsType';
  address?: Maybe<Scalars['String']['output']>;
  age?: Maybe<Scalars['String']['output']>;
  caregiverNames?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  clientFirstName?: Maybe<Scalars['String']['output']>;
  clientLastName?: Maybe<Scalars['String']['output']>;
  clientName?: Maybe<Scalars['String']['output']>;
  dateOfBirth?: Maybe<Scalars['String']['output']>;
  gender?: Maybe<Scalars['String']['output']>;
  guardian2FirstName?: Maybe<Scalars['String']['output']>;
  guardian2FullName?: Maybe<Scalars['String']['output']>;
  guardian2LastName?: Maybe<Scalars['String']['output']>;
  guardian2Phone?: Maybe<Scalars['String']['output']>;
  guardianName?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  zip?: Maybe<Scalars['String']['output']>;
};

export type ExportEhrEnums = {
  hrGoalStatus?: InputMaybe<HiRasmusGoalStatusEnums>;
  hrGoalType?: InputMaybe<HiRasmusGoalTypeEnums>;
  hrTargetStatus?: InputMaybe<HiRasmusTargetStatusEnums>;
  reassessmentGoalType?: InputMaybe<ReassessmentGoalTypeEnums>;
};

/**
 * Generate a reimportable .xlsx for one of the org's curricula and return a
 * signed S3 download URL.
 *
 * Columns match the importer (Folder Name, Goal Name, Mastery Criteria, Mapped
 * Domains), so a downloaded file is a backup that can be edited and loaded back
 * in. Org is derived from the session, never a client-supplied id.
 */
export type ExportGoalBankCurriculum = {
  __typename?: 'ExportGoalBankCurriculum';
  fileName?: Maybe<Scalars['String']['output']>;
  signedUrl?: Maybe<Scalars['String']['output']>;
};

export type ExportGoalGroupType = {
  __typename?: 'ExportGoalGroupType';
  goalType?: Maybe<Scalars['String']['output']>;
  goals?: Maybe<Array<Maybe<ExportGoalType>>>;
  title?: Maybe<Scalars['String']['output']>;
};

export type ExportGoalTargetType = {
  __typename?: 'ExportGoalTargetType';
  baselineData?: Maybe<Scalars['String']['output']>;
  completionDate?: Maybe<Scalars['String']['output']>;
  masteryCriteria?: Maybe<Scalars['String']['output']>;
  masteryDate?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export type ExportGoalType = {
  __typename?: 'ExportGoalType';
  assessmentToolSource?: Maybe<Scalars['String']['output']>;
  baselineData?: Maybe<Scalars['String']['output']>;
  baselineDate?: Maybe<Scalars['String']['output']>;
  chartImageUrl?: Maybe<Scalars['String']['output']>;
  completionDate?: Maybe<Scalars['String']['output']>;
  expectedMasteryDate?: Maybe<Scalars['String']['output']>;
  gasLevel1?: Maybe<Scalars['String']['output']>;
  gasLevel3?: Maybe<Scalars['String']['output']>;
  gasLevel4?: Maybe<Scalars['String']['output']>;
  gasScore?: Maybe<Scalars['String']['output']>;
  generalizationCriteria?: Maybe<Scalars['String']['output']>;
  goalName?: Maybe<Scalars['String']['output']>;
  masteryCriteria?: Maybe<Scalars['String']['output']>;
  medicalNecessityCriteria?: Maybe<Scalars['String']['output']>;
  programGoal?: Maybe<Scalars['String']['output']>;
  rationale?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  targets?: Maybe<Array<Maybe<ExportGoalTargetType>>>;
};

export type ExportReportDocumentPayload = {
  __typename?: 'ExportReportDocumentPayload';
  file?: Maybe<Scalars['Base64']['output']>;
  fileName?: Maybe<Scalars['String']['output']>;
};

export type ExportSectionFieldType = {
  __typename?: 'ExportSectionFieldType';
  content?: Maybe<Scalars['String']['output']>;
  field_identifier?: Maybe<Scalars['String']['output']>;
  field_type?: Maybe<Scalars['String']['output']>;
  isAuditable?: Maybe<Scalars['Boolean']['output']>;
  rankOrder?: Maybe<Scalars['Int']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type ExportSectionType = {
  __typename?: 'ExportSectionType';
  fields?: Maybe<Array<Maybe<ExportSectionFieldType>>>;
  key?: Maybe<Scalars['String']['output']>;
  pageLocation?: Maybe<Scalars['String']['output']>;
  rankOrder?: Maybe<Scalars['Int']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type ExportSignatureSectionType = {
  __typename?: 'ExportSignatureSectionType';
  isAuditable?: Maybe<Scalars['Boolean']['output']>;
  licenseNumber?: Maybe<Scalars['String']['output']>;
  practitionerEmail?: Maybe<Scalars['String']['output']>;
  professionalTitle?: Maybe<Scalars['String']['output']>;
  signatureDate?: Maybe<Scalars['String']['output']>;
  signatureFieldType?: Maybe<Scalars['String']['output']>;
  signatureImageUrl?: Maybe<Scalars['String']['output']>;
  signatureName?: Maybe<Scalars['String']['output']>;
  signedAt?: Maybe<Scalars['DateTime']['output']>;
  signedAtTimezone?: Maybe<Scalars['String']['output']>;
  signedBy?: Maybe<ExportSignedByType>;
};

export type ExportSignedByType = {
  __typename?: 'ExportSignedByType';
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  licenseNumber?: Maybe<Scalars['String']['output']>;
  professionalTitle?: Maybe<Scalars['String']['output']>;
};

export type ExportTreatmentPlanDomainType = {
  __typename?: 'ExportTreatmentPlanDomainType';
  description?: Maybe<Scalars['String']['output']>;
  fields?: Maybe<Array<Maybe<ExportTreatmentPlanFieldType>>>;
  goals?: Maybe<Array<Maybe<ExportTreatmentPlanGoalType>>>;
  name?: Maybe<Scalars['String']['output']>;
};

/** A single field on a goal or target, keyed by template field_identifier. */
export type ExportTreatmentPlanFieldType = {
  __typename?: 'ExportTreatmentPlanFieldType';
  content?: Maybe<Scalars['String']['output']>;
  fieldIdentifier?: Maybe<Scalars['String']['output']>;
  fieldType?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type ExportTreatmentPlanGoalType = {
  __typename?: 'ExportTreatmentPlanGoalType';
  chartUrl?: Maybe<Scalars['String']['output']>;
  fields?: Maybe<Array<Maybe<ExportTreatmentPlanFieldType>>>;
  hasMedicalNecessity?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  medicalNecessityCriteria?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  rankOrder?: Maybe<Scalars['Int']['output']>;
  targets?: Maybe<Array<Maybe<ExportTreatmentPlanTargetType>>>;
};

export type ExportTreatmentPlanTargetType = {
  __typename?: 'ExportTreatmentPlanTargetType';
  chartUrl?: Maybe<Scalars['String']['output']>;
  fields?: Maybe<Array<Maybe<ExportTreatmentPlanFieldType>>>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  rankOrder?: Maybe<Scalars['Int']['output']>;
};

export type ExportTreatmentPlanType = {
  __typename?: 'ExportTreatmentPlanType';
  domains?: Maybe<Array<Maybe<ExportTreatmentPlanDomainType>>>;
};

export enum ExportTypeEnum {
  Docx = 'DOCX',
  Pdf = 'PDF'
}

export type ExternalClient = {
  address?: InputMaybe<Scalars['String']['input']>;
  addressLine2?: InputMaybe<Scalars['String']['input']>;
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  authorizations?: InputMaybe<Array<InputMaybe<Authorizations>>>;
  birthDate?: InputMaybe<Scalars['Date']['input']>;
  caregiverDetails?: InputMaybe<ExternalClientCaregiverDetails>;
  city?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  lastName?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

export type ExternalClientCaregiverDetails = {
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phoneNumber1?: InputMaybe<Scalars['String']['input']>;
  phoneNumber2?: InputMaybe<Scalars['String']['input']>;
};

export enum ExternalIdFilter {
  Any = 'ANY',
  NewGoalsAndTargets = 'NEW_GOALS_AND_TARGETS',
  WithoutExternalId = 'WITHOUT_EXTERNAL_ID',
  WithExternalId = 'WITH_EXTERNAL_ID'
}

export type ExternalOrganization = {
  id: Scalars['String']['input'];
  name: Scalars['String']['input'];
  updatedAt: Scalars['DateTime']['input'];
};

export enum ExternalOrganizationSyncStatusEnums {
  Created = 'CREATED',
  Updated = 'UPDATED'
}

export type ExternalProvider = {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  externalId: Scalars['String']['input'];
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  updatedAt: Scalars['DateTime']['input'];
};

export type FailLearnerFilePdfPreview = {
  __typename?: 'FailLearnerFilePdfPreview';
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

/**
 * Called by the Python Temporal worker (DocxToPdfConversionWorkflow) when
 * the ConvertAPI conversion fails.  Sets the report status to FAILURE so the
 * frontend can surface an error to the user.
 */
export type FailReportPdfConversion = {
  __typename?: 'FailReportPdfConversion';
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type FieldError = {
  __typename?: 'FieldError';
  field?: Maybe<Scalars['String']['output']>;
  messages?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export enum FileTypeEnum {
  Abas = 'ABAS',
  Ablls = 'ABLLS',
  ActionBehavioralCenterIntake = 'ACTION_BEHAVIORAL_CENTER_INTAKE',
  AdiR = 'ADI_R',
  AdiRInterviewNotes = 'ADI_R_INTERVIEW_NOTES',
  AdiRToddler = 'ADI_R_TODDLER',
  Ados = 'ADOS',
  Ados_2 = 'ADOS_2',
  Afls = 'AFLS',
  Apsi = 'APSI',
  Asrs = 'ASRS',
  Basc_3 = 'BASC_3',
  Basc_3Prq = 'BASC_3_PRQ',
  Basc_4 = 'BASC_4',
  Bayley_3 = 'BAYLEY_3',
  Bayley_4 = 'BAYLEY_4',
  Bdi_2 = 'BDI_2',
  Bdi_3 = 'BDI_3',
  Befas = 'BEFAS',
  BehavioralObservations = 'BEHAVIORAL_OBSERVATIONS',
  Bhi = 'BHI',
  Bhtia = 'BHTIA',
  Brief = 'BRIEF',
  Brief_2 = 'BRIEF_2',
  Cars_2 = 'CARS_2',
  CatalightIntake = 'CATALIGHT_INTAKE',
  Cbcl = 'CBCL',
  Cfql = 'CFQL',
  ChatAsset = 'CHAT_ASSET',
  ClinicalNotes = 'CLINICAL_NOTES',
  Conners_4Adhd = 'CONNERS_4_ADHD',
  Ctoni_2 = 'CTONI_2',
  ConnersCpt3Adhd = 'Conners_CPT3_ADHD',
  Das_2 = 'DAS_2',
  Dayc = 'DAYC',
  DiagnosisReport = 'DIAGNOSIS_REPORT',
  Dp_4 = 'DP_4',
  Earlipoint = 'EARLIPOINT',
  Esdm = 'ESDM',
  EssentialForLivingQuick = 'ESSENTIAL_FOR_LIVING_QUICK',
  Evt_3 = 'EVT_3',
  Fast = 'FAST',
  Gars_2 = 'GARS_2',
  Gars_3 = 'GARS_3',
  HanleyFba = 'HANLEY_FBA',
  IntakeCall = 'INTAKE_CALL',
  IntakeCallTranscript = 'INTAKE_CALL_TRANSCRIPT',
  IntakeCallTranscriptJson = 'INTAKE_CALL_TRANSCRIPT_JSON',
  Interview = 'INTERVIEW',
  Kbit_2 = 'KBIT_2',
  Mas = 'MAS',
  Migdas_2 = 'MIGDAS_2',
  MullenScalesOfEarlyLearners = 'MULLEN_SCALES_OF_EARLY_LEARNERS',
  MChat = 'M_CHAT',
  Nichq = 'NICHQ',
  Pddbi = 'PDDBI',
  Pdpvts = 'PDPVTS',
  Peak = 'PEAK',
  Pls_5 = 'PLS_5',
  Ppvt_5 = 'PPVT_5',
  PreviousAssessment = 'PREVIOUS_ASSESSMENT',
  Psi_4 = 'PSI_4',
  PToni = 'P_TONI',
  Qabf = 'QABF',
  Rcmas_2 = 'RCMAS_2',
  Rias_2 = 'RIAS_2',
  Scared = 'SCARED',
  Scq = 'SCQ',
  Sipa = 'SIPA',
  SkillStreaming = 'SKILL_STREAMING',
  SociallySavvy = 'SOCIALLY_SAVVY',
  SocialSkillsSolutions = 'SOCIAL_SKILLS_SOLUTIONS',
  Spm_2 = 'SPM_2',
  Srs2 = 'SRS2',
  Ssis = 'SSIS',
  StanfordBinet_5 = 'STANFORD_BINET_5',
  SensoryProfile_2 = 'Sensory_Profile_2',
  StanfordBinet = 'Stanford_Binet',
  Tasi = 'TASI',
  TeleAsdPeds = 'TELE_ASD_PEDS',
  Toni_4 = 'TONI_4',
  TreatmentPlan = 'TREATMENT_PLAN',
  Tscc = 'TSCC',
  Tscyc = 'TSCYC',
  Unclassified = 'UNCLASSIFIED',
  Vbmapp = 'VBMAPP',
  VbmappLearn = 'VBMAPP_LEARN',
  VbmappOpya = 'VBMAPP_OPYA',
  Vineland = 'VINELAND',
  Wais_4 = 'WAIS_4',
  WaisV = 'WAIS_V',
  WasiIi = 'WASI_II',
  WiatIv = 'WIAT_IV',
  WiscV = 'WISC_V',
  WppsiIv = 'WPPSI_IV',
  Wurs = 'WURS',
  EssentialForLiving = 'essential_for_living',
  PdbbiParent = 'pdbbi_parent',
  PdbbiTeacher = 'pdbbi_teacher'
}

export type FillGasTables = {
  __typename?: 'FillGasTables';
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type FinishChat = {
  __typename?: 'FinishChat';
  chat?: Maybe<ChatType>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

/** Mark an INTAKE or ASSISTANT chat as finished. */
export type FinishChatbotChat = {
  __typename?: 'FinishChatbotChat';
  chat?: Maybe<ChatType>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type FronteraEhrClientExportType = {
  __typename?: 'FronteraEhrClientExportType';
  /** Safe to show the user. */
  message: Scalars['String']['output'];
  status: FronteraEhrLearnerExportStatusEnum;
};

export enum FronteraEhrLearnerExportStatusEnum {
  Failed = 'FAILED',
  Pending = 'PENDING',
  Sent = 'SENT'
}

export type FronteraGoalBankType = Node & {
  __typename?: 'FronteraGoalBankType';
  aiGenerated: Scalars['Boolean']['output'];
  baseline?: Maybe<Scalars['String']['output']>;
  baselineDate?: Maybe<Scalars['Date']['output']>;
  createdDate: Scalars['DateTime']['output'];
  dateMastered?: Maybe<Scalars['Date']['output']>;
  externalId?: Maybe<Scalars['String']['output']>;
  goal: GoalType;
  goalBank?: Maybe<ReportGoalBankType>;
  /** The ID of the object */
  id: Scalars['ID']['output'];
  inUse: Scalars['Boolean']['output'];
  lastUpdatedDate: Scalars['DateTime']['output'];
  masteryCriteria: Scalars['String']['output'];
  name: Scalars['String']['output'];
  organization: OrganizationType;
  pk?: Maybe<Scalars['Int']['output']>;
  tags?: Maybe<Scalars['JSONString']['output']>;
};

export type FronteraGoalBankTypeConnection = {
  __typename?: 'FronteraGoalBankTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<FronteraGoalBankTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `FronteraGoalBankType` and its cursor. */
export type FronteraGoalBankTypeEdge = {
  __typename?: 'FronteraGoalBankTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<FronteraGoalBankType>;
};

export type FronteraGoalFilter = {
  /** Filter by latest FronteraGoalPhase status (case-insensitive partial match) */
  goalStatus?: InputMaybe<Scalars['String']['input']>;
};

export type FronteraGoalPhaseType = Node & {
  __typename?: 'FronteraGoalPhaseType';
  createdDate: Scalars['DateTime']['output'];
  date: Scalars['DateTime']['output'];
  externalId?: Maybe<Scalars['String']['output']>;
  goal: FronteraGoalType;
  /** The ID of the object */
  id: Scalars['ID']['output'];
  lastUpdatedDate: Scalars['DateTime']['output'];
  organization: OrganizationType;
  pk?: Maybe<Scalars['Int']['output']>;
  status: ApiFronteraGoalPhaseStatusChoices;
};

export type FronteraGoalPhaseTypeConnection = {
  __typename?: 'FronteraGoalPhaseTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<FronteraGoalPhaseTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `FronteraGoalPhaseType` and its cursor. */
export type FronteraGoalPhaseTypeEdge = {
  __typename?: 'FronteraGoalPhaseTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<FronteraGoalPhaseType>;
};

export type FronteraGoalType = Node & {
  __typename?: 'FronteraGoalType';
  aiGenerated: Scalars['Boolean']['output'];
  baseline?: Maybe<Scalars['String']['output']>;
  baselineDate?: Maybe<Scalars['Date']['output']>;
  createdDate: Scalars['DateTime']['output'];
  dateMastered?: Maybe<Scalars['Date']['output']>;
  externalId?: Maybe<Scalars['String']['output']>;
  fronteraTargets: FronteraTargetTypeConnection;
  goal: GoalType;
  /** The ID of the object */
  id: Scalars['ID']['output'];
  inUse: Scalars['Boolean']['output'];
  lastUpdatedDate: Scalars['DateTime']['output'];
  masteryCriteria: Scalars['String']['output'];
  name: Scalars['String']['output'];
  organization: OrganizationType;
  phases: FronteraGoalPhaseTypeConnection;
  pk?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  tags?: Maybe<Scalars['JSONString']['output']>;
};


export type FronteraGoalTypeFronteraTargetsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  aiGenerated?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdDate?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  fronteraGoal?: InputMaybe<Scalars['ID']['input']>;
  inUse?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedDate?: InputMaybe<Scalars['DateTime']['input']>;
  masteryCriteria?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  organization?: InputMaybe<Scalars['ID']['input']>;
  target?: InputMaybe<Scalars['ID']['input']>;
  type?: InputMaybe<ApiFronteraTargetTypeChoices>;
};


export type FronteraGoalTypePhasesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdDate?: InputMaybe<Scalars['DateTime']['input']>;
  date?: InputMaybe<Scalars['DateTime']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  goal?: InputMaybe<Scalars['ID']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedDate?: InputMaybe<Scalars['DateTime']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  organization?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<ApiFronteraGoalPhaseStatusChoices>;
};

export type FronteraGoalTypeConnection = {
  __typename?: 'FronteraGoalTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<FronteraGoalTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `FronteraGoalType` and its cursor. */
export type FronteraGoalTypeEdge = {
  __typename?: 'FronteraGoalTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<FronteraGoalType>;
};

export type FronteraTargetBankType = Node & {
  __typename?: 'FronteraTargetBankType';
  aiGenerated: Scalars['Boolean']['output'];
  createdDate: Scalars['DateTime']['output'];
  description: Scalars['String']['output'];
  externalId?: Maybe<Scalars['String']['output']>;
  /** The ID of the object */
  id: Scalars['ID']['output'];
  inUse: Scalars['Boolean']['output'];
  lastUpdatedDate: Scalars['DateTime']['output'];
  masteryCriteria: Scalars['String']['output'];
  name: Scalars['String']['output'];
  organization: OrganizationType;
  pk?: Maybe<Scalars['Int']['output']>;
  target: TargetType;
  targetBank?: Maybe<ReportTargetGoalBankType>;
  type?: Maybe<ApiFronteraTargetBankTypeChoices>;
};

export type FronteraTargetBankTypeConnection = {
  __typename?: 'FronteraTargetBankTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<FronteraTargetBankTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `FronteraTargetBankType` and its cursor. */
export type FronteraTargetBankTypeEdge = {
  __typename?: 'FronteraTargetBankTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<FronteraTargetBankType>;
};

export type FronteraTargetPhaseType = Node & {
  __typename?: 'FronteraTargetPhaseType';
  createdDate: Scalars['DateTime']['output'];
  date: Scalars['DateTime']['output'];
  externalId?: Maybe<Scalars['String']['output']>;
  /** The ID of the object */
  id: Scalars['ID']['output'];
  lastUpdatedDate: Scalars['DateTime']['output'];
  organization: OrganizationType;
  pk?: Maybe<Scalars['Int']['output']>;
  status: ApiFronteraTargetPhaseStatusChoices;
  target: FronteraTargetType;
};

export type FronteraTargetPhaseTypeConnection = {
  __typename?: 'FronteraTargetPhaseTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<FronteraTargetPhaseTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `FronteraTargetPhaseType` and its cursor. */
export type FronteraTargetPhaseTypeEdge = {
  __typename?: 'FronteraTargetPhaseTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<FronteraTargetPhaseType>;
};

export type FronteraTargetType = Node & {
  __typename?: 'FronteraTargetType';
  aiGenerated: Scalars['Boolean']['output'];
  createdDate: Scalars['DateTime']['output'];
  description: Scalars['String']['output'];
  externalId?: Maybe<Scalars['String']['output']>;
  fronteraGoal?: Maybe<FronteraGoalType>;
  /** The ID of the object */
  id: Scalars['ID']['output'];
  inUse: Scalars['Boolean']['output'];
  lastUpdatedDate: Scalars['DateTime']['output'];
  masteryCriteria: Scalars['String']['output'];
  name: Scalars['String']['output'];
  organization: OrganizationType;
  phases: FronteraTargetPhaseTypeConnection;
  pk?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  target: TargetType;
  type?: Maybe<ApiFronteraTargetTypeChoices>;
};


export type FronteraTargetTypePhasesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdDate?: InputMaybe<Scalars['DateTime']['input']>;
  date?: InputMaybe<Scalars['DateTime']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedDate?: InputMaybe<Scalars['DateTime']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  organization?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<ApiFronteraTargetPhaseStatusChoices>;
  target?: InputMaybe<Scalars['ID']['input']>;
};

export type FronteraTargetTypeConnection = {
  __typename?: 'FronteraTargetTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<FronteraTargetTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `FronteraTargetType` and its cursor. */
export type FronteraTargetTypeEdge = {
  __typename?: 'FronteraTargetTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<FronteraTargetType>;
};

export type GasExtractionDataInput = {
  assessmentToolSource?: InputMaybe<Scalars['String']['input']>;
  baselineData?: InputMaybe<Scalars['String']['input']>;
  baselineDate?: InputMaybe<Scalars['Date']['input']>;
  domain?: InputMaybe<Scalars['String']['input']>;
  gasLevel1?: InputMaybe<Scalars['String']['input']>;
  gasLevel2?: InputMaybe<Scalars['String']['input']>;
  gasLevel3?: InputMaybe<Scalars['String']['input']>;
  gasLevel4?: InputMaybe<Scalars['String']['input']>;
  gasLevelScore?: InputMaybe<Scalars['String']['input']>;
  generalizationCriteria?: InputMaybe<Scalars['String']['input']>;
  goalId?: InputMaybe<Scalars['ID']['input']>;
  goalName?: InputMaybe<Scalars['String']['input']>;
  matchStatus?: InputMaybe<Scalars['String']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
};

export type GenerateLearnerFilePdfPreview = {
  __typename?: 'GenerateLearnerFilePdfPreview';
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type GeneratePdfInput = {
  docxExport?: InputMaybe<Scalars['Boolean']['input']>;
  learnerId: Scalars['ID']['input'];
  reportId: Scalars['ID']['input'];
  reportType: ReportTypeEnums;
};

/**
 * Accepts a client-generated DOCX file, stores it in S3, and kicks off the
 * DocxToPdfConversionWorkflow on the Python Temporal worker.  The report status
 * is set to GENERATING immediately; the workflow callback mutations below flip it
 * to COMPLETED or FAILURE once the ConvertAPI conversion finishes.
 */
export type GenerateReportPdfFromDocx = {
  __typename?: 'GenerateReportPdfFromDocx';
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type GenerateTranscriptCsvInput = {
  endTime: Scalars['Float']['input'];
  mediaId: Scalars['ID']['input'];
  startTime: Scalars['Float']['input'];
};

export type GenerateTranscriptCsvMutation = {
  __typename?: 'GenerateTranscriptCsvMutation';
  fileSignedUrl?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type GetCumulativeTargetsFilter = {
  fromDate?: InputMaybe<Scalars['Date']['input']>;
  goalId: Scalars['ID']['input'];
  targetStatus: Array<InputMaybe<GoalStatusEnums>>;
  toDate?: InputMaybe<Scalars['Date']['input']>;
};

export type GetFronteraGoalsFilter = {
  hasExternalId?: InputMaybe<ExternalIdFilter>;
  learnerId: Scalars['ID']['input'];
  reportId?: InputMaybe<Scalars['Int']['input']>;
};

/** Return a presigned S3 PUT URL so the client can upload an Excel file. */
export type GetGoalBankUploadUrl = {
  __typename?: 'GetGoalBankUploadUrl';
  s3Key?: Maybe<Scalars['String']['output']>;
  signedUrl?: Maybe<Scalars['String']['output']>;
};

export type GetReassessmentReportGoalsFilter = {
  included?: InputMaybe<Array<InputMaybe<ReassessmentGoalIncluded>>>;
  reportId: Scalars['ID']['input'];
  reviewed?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<SortBy>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  subType?: InputMaybe<Array<InputMaybe<ReassessmentGoalSubTypeEnums>>>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type GetReportGoalsFilter = {
  goalId?: InputMaybe<Scalars['ID']['input']>;
  goalStatus?: InputMaybe<Scalars['String']['input']>;
  reportDomainId?: InputMaybe<Scalars['ID']['input']>;
};

export type GetReportTemplatesFilter = {
  /** Learner (client) global ID. When provided, templates are narrowed to those whose payor_type matches one of the learner's active payors. If no template matches, the unnarrowed list is returned. */
  learner?: InputMaybe<Scalars['ID']['input']>;
  reportType?: InputMaybe<Scalars['String']['input']>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<Array<InputMaybe<ReportTemplateStatus>>>;
};

export type GetReportsFilter = {
  createdById?: InputMaybe<Scalars['ID']['input']>;
  fromDate?: InputMaybe<Scalars['Date']['input']>;
  learnerId?: InputMaybe<Scalars['ID']['input']>;
  reportIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  reportType?: InputMaybe<ReportTypeEnums>;
  reviewView?: InputMaybe<ReportReviewView>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  toDate?: InputMaybe<Scalars['Date']['input']>;
};

export type GetSessionProgressFilter = {
  chartType?: InputMaybe<ChartTypes>;
  excludeTargetStatus?: InputMaybe<Array<InputMaybe<GoalStatusEnums>>>;
  fromDate?: InputMaybe<Scalars['Date']['input']>;
  goalId: Scalars['ID']['input'];
  targetId?: InputMaybe<Scalars['ID']['input']>;
  toDate?: InputMaybe<Scalars['Date']['input']>;
};

export type GetSessionProgressType = {
  __typename?: 'GetSessionProgressType';
  goalEvents?: Maybe<Array<Maybe<EventType>>>;
  goalPhases?: Maybe<Array<Maybe<PhaseChangeType>>>;
  progress?: Maybe<Array<Maybe<TargetProgressType>>>;
};

export type GetTargetsFilter = {
  goalId?: InputMaybe<Scalars['ID']['input']>;
  learnerId: Scalars['ID']['input'];
  reportDomainId?: InputMaybe<Scalars['ID']['input']>;
  targetId?: InputMaybe<Scalars['ID']['input']>;
};

export type GoalAttainmentScaleInput = {
  level1: Scalars['String']['input'];
  level3: Scalars['String']['input'];
  level4: Scalars['String']['input'];
  reportGoalId: Scalars['ID']['input'];
};

export type GoalBankFolderType = Node & {
  __typename?: 'GoalBankFolderType';
  auth0User?: Maybe<UserType>;
  createdBy?: Maybe<UserType>;
  createdDate: Scalars['DateTime']['output'];
  curriculum?: Maybe<CurriculumType>;
  folderType: ApiGoalBankFolderFolderTypeChoices;
  goalsCount?: Maybe<Scalars['Int']['output']>;
  /** The ID of the object */
  id: Scalars['ID']['output'];
  lastUpdatedDate: Scalars['DateTime']['output'];
  longtermgoalbankSet: LongTermGoalBankTypeConnection;
  name: Scalars['String']['output'];
  organization: OrganizationType;
  pk?: Maybe<Scalars['Int']['output']>;
  reportgoalbankSet: ReportGoalBankTypeConnection;
  reporttargetgoalbankSet: ReportTargetGoalBankTypeConnection;
  targetsCount?: Maybe<Scalars['Int']['output']>;
  updatedBy?: Maybe<UserType>;
};


export type GoalBankFolderTypeLongtermgoalbankSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdDate?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  folder?: InputMaybe<Scalars['ID']['input']>;
  goalName?: InputMaybe<Scalars['String']['input']>;
  goalType?: InputMaybe<ApiLongTermGoalBankGoalTypeChoices>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedDate?: InputMaybe<Scalars['DateTime']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  organization?: InputMaybe<Scalars['ID']['input']>;
  updatedBy?: InputMaybe<Scalars['ID']['input']>;
};


export type GoalBankFolderTypeReportgoalbankSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  assessmentToolSource?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdDate?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  domain?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  folder?: InputMaybe<Scalars['ID']['input']>;
  goalName?: InputMaybe<Scalars['String']['input']>;
  hasMedicalNecessity?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedDate?: InputMaybe<Scalars['DateTime']['input']>;
  longTermGoalBank?: InputMaybe<Scalars['ID']['input']>;
  masteryCriteria?: InputMaybe<Scalars['String']['input']>;
  medicalNecessityCriteria?: InputMaybe<Scalars['String']['input']>;
  medicalRationale?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  organization?: InputMaybe<Scalars['ID']['input']>;
  programGoal?: InputMaybe<Scalars['String']['input']>;
  timelineEstimationType?: InputMaybe<ApiReportGoalBankTimelineEstimationTypeChoices>;
  timelineEstimationValue?: InputMaybe<Scalars['Int']['input']>;
  updatedBy?: InputMaybe<Scalars['ID']['input']>;
};


export type GoalBankFolderTypeReporttargetgoalbankSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdDate?: InputMaybe<Scalars['DateTime']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  folder?: InputMaybe<Scalars['ID']['input']>;
  goalBank?: InputMaybe<Scalars['ID']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedDate?: InputMaybe<Scalars['DateTime']['input']>;
  longTermGoalBank?: InputMaybe<Scalars['ID']['input']>;
  masteryCriteria?: InputMaybe<Scalars['String']['input']>;
  medicalRationale?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  organization?: InputMaybe<Scalars['ID']['input']>;
  targetDescription?: InputMaybe<Scalars['String']['input']>;
  targetName?: InputMaybe<Scalars['String']['input']>;
  timelineEstimationType?: InputMaybe<ApiReportTargetGoalBankTimelineEstimationTypeChoices>;
  timelineEstimationValue?: InputMaybe<Scalars['Int']['input']>;
  updatedBy?: InputMaybe<Scalars['ID']['input']>;
};

export type GoalBankFolderTypeConnection = {
  __typename?: 'GoalBankFolderTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<GoalBankFolderTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `GoalBankFolderType` and its cursor. */
export type GoalBankFolderTypeEdge = {
  __typename?: 'GoalBankFolderTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<GoalBankFolderType>;
};

export enum GoalBankFolderTypeEnum {
  Organization = 'ORGANIZATION',
  User = 'USER'
}

/** An enumeration. */
export enum GoalBankImportMode {
  CreateOnly = 'CREATE_ONLY',
  Update = 'UPDATE'
}

export type GoalBankInput = {
  aiGenerated?: InputMaybe<Scalars['Boolean']['input']>;
  aiSuggestedShortGoal?: InputMaybe<Scalars['ID']['input']>;
  assessmentToolSource?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  domainId?: InputMaybe<Scalars['ID']['input']>;
  goalName: Scalars['String']['input'];
  hasMedicalNecessity?: InputMaybe<Scalars['Boolean']['input']>;
  longTermGoalBankId?: InputMaybe<Scalars['ID']['input']>;
  masteryCriteria?: InputMaybe<Scalars['String']['input']>;
  medicalNecessityCriteria?: InputMaybe<Scalars['String']['input']>;
  medicalRationale?: InputMaybe<Scalars['String']['input']>;
  programGoal?: InputMaybe<Scalars['String']['input']>;
  timelineEstimationType?: InputMaybe<ShortTermTimelineEstimationEnums>;
  timelineEstimationValue?: InputMaybe<Scalars['Float']['input']>;
};

export type GoalBankMutationResult = {
  __typename?: 'GoalBankMutationResult';
  affectedTemplates?: Maybe<Scalars['JSONString']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  stats?: Maybe<Scalars['JSONString']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

/**
 * A goal bank goal returned by vector similarity search, augmented with a
 * similarity score (0.0–1.0, higher = more similar).
 */
export type GoalBankSearchResultType = {
  __typename?: 'GoalBankSearchResultType';
  folder?: Maybe<GoalBankFolderType>;
  goalName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  masteryCriteria?: Maybe<Scalars['String']['output']>;
  similarity?: Maybe<Scalars['Float']['output']>;
};

export type GoalBankSuggestionInput = {
  goalBankId: Scalars['ID']['input'];
  reportDomainId?: InputMaybe<Scalars['ID']['input']>;
  suggestionConfidence: Scalars['Float']['input'];
};

/**
 * Reassign a single ReportGoal to a different ReportDomain.
 *
 * Set `destination_domain_id` to reference an existing domain, or
 * `destination_client_id` to reference a brand-new domain being created
 * in the same call. Leaving both unset unassigns the goal (uncategorized).
 */
export type GoalDomainAssignmentInput = {
  destinationClientId?: InputMaybe<Scalars['String']['input']>;
  destinationDomainId?: InputMaybe<Scalars['ID']['input']>;
  goalId: Scalars['ID']['input'];
};

export type GoalEhrImportInput = {
  autoProgressToMaintenanceEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  autoProgressToMasteredEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  baselineData?: InputMaybe<Scalars['String']['input']>;
  baselineDate?: InputMaybe<Scalars['DateTime']['input']>;
  baselineMetric?: InputMaybe<Scalars['JSONString']['input']>;
  categoryId?: InputMaybe<Scalars['Int']['input']>;
  categoryName?: InputMaybe<Scalars['String']['input']>;
  dataCollectionType?: InputMaybe<Scalars['String']['input']>;
  definition?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  goalName: Scalars['String']['input'];
  goalType?: InputMaybe<Scalars['String']['input']>;
  inCurrentPlan?: InputMaybe<Scalars['Boolean']['input']>;
  instructions?: InputMaybe<Scalars['String']['input']>;
  lessonOnCurrentPlan?: InputMaybe<Scalars['Boolean']['input']>;
  maintenanceMetric?: InputMaybe<Scalars['JSONString']['input']>;
  masteryCriteria?: InputMaybe<Scalars['String']['input']>;
  phases?: InputMaybe<Array<InputMaybe<PhaseEhrImportInput>>>;
  programGoal?: InputMaybe<Scalars['String']['input']>;
  progressSummary?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  successMetric?: InputMaybe<Scalars['JSONString']['input']>;
  tags?: InputMaybe<Scalars['JSONString']['input']>;
  targetAchievementDate?: InputMaybe<Scalars['DateTime']['input']>;
  targetMaladaptiveBehaviorName?: InputMaybe<Scalars['String']['input']>;
};

export type GoalFilter = {
  /** Filter by latest goal phase status (case-insensitive partial match) */
  goalStatus?: InputMaybe<Scalars['String']['input']>;
};

export type GoalProgressSummaryInput = {
  baselineData?: InputMaybe<Scalars['String']['input']>;
  completionDate?: InputMaybe<Scalars['Date']['input']>;
  goalId: Scalars['ID']['input'];
  progressSummary: Scalars['String']['input'];
  targets: Array<InputMaybe<TargetProgressSummaryInput>>;
};

export enum GoalStatusEnums {
  Baseline = 'BASELINE',
  Closed = 'CLOSED',
  Generalization = 'GENERALIZATION',
  Hold = 'HOLD',
  Inactive = 'INACTIVE',
  Maintenance = 'MAINTENANCE',
  Mastered = 'MASTERED',
  Treatment = 'TREATMENT'
}

export type GoalStatusType = {
  __typename?: 'GoalStatusType';
  createdDate: Scalars['DateTime']['output'];
  date?: Maybe<Scalars['DateTime']['output']>;
  goal?: Maybe<ReportGoalType>;
  id: Scalars['ID']['output'];
  lastUpdatedDate: Scalars['DateTime']['output'];
  organization: OrganizationType;
  pk?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<ApiGoalStatusStatusChoices>;
};

export type GoalType = Node & {
  __typename?: 'GoalType';
  createdDate: Scalars['DateTime']['output'];
  fronteragoal?: Maybe<FronteraGoalType>;
  fronteragoalbankSet: FronteraGoalBankTypeConnection;
  /** Set when the progress is tracked at the goal level */
  goalProgress: SessionTargetProgressTypeConnection;
  hipphealthgoal?: Maybe<HippHealthGoalType>;
  hirasmusgoal?: Maybe<HiRasmusGoalType>;
  /** The ID of the object */
  id: Scalars['ID']['output'];
  isPinned: Scalars['Boolean']['output'];
  lastUpdatedDate: Scalars['DateTime']['output'];
  learner: LearnerType;
  mediatargetpredictionSet: MediaTargetPredictionTypeConnection;
  motivitygoal?: Maybe<MotivityGoalType>;
  name?: Maybe<Scalars['String']['output']>;
  organization: OrganizationType;
  passagegoal?: Maybe<PassageGoalType>;
  passagegoalbankSet: PassageGoalBankTypeConnection;
  pk?: Maybe<Scalars['Int']['output']>;
  rankOrder: Scalars['Int']['output'];
  reportgoalSet: ReportGoalTypeConnection;
  /** Latest status from goal phases */
  status?: Maybe<UnifiedGoalStatusEnum>;
  targetGenerationStatus?: Maybe<ApiGoalTargetGenerationStatusChoices>;
  targets: TargetTypeConnection;
  therapzgoal?: Maybe<TherapzGoalType>;
};


export type GoalTypeFronteragoalbankSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  aiGenerated?: InputMaybe<Scalars['Boolean']['input']>;
  baseline?: InputMaybe<Scalars['String']['input']>;
  baselineDate?: InputMaybe<Scalars['Date']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdDate?: InputMaybe<Scalars['DateTime']['input']>;
  dateMastered?: InputMaybe<Scalars['Date']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  goal?: InputMaybe<Scalars['ID']['input']>;
  goalBank?: InputMaybe<Scalars['ID']['input']>;
  inUse?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedDate?: InputMaybe<Scalars['DateTime']['input']>;
  masteryCriteria?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  organization?: InputMaybe<Scalars['ID']['input']>;
  tags?: InputMaybe<Scalars['JSONString']['input']>;
};


export type GoalTypeGoalProgressArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  count?: InputMaybe<Scalars['Float']['input']>;
  createdDate?: InputMaybe<Scalars['DateTime']['input']>;
  date?: InputMaybe<Scalars['DateTime']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  goal?: InputMaybe<Scalars['ID']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedDate?: InputMaybe<Scalars['DateTime']['input']>;
  learner?: InputMaybe<Scalars['ID']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  organization?: InputMaybe<Scalars['ID']['input']>;
  progressType?: InputMaybe<ApiSessionTargetProgressProgressTypeChoices>;
  target?: InputMaybe<Scalars['ID']['input']>;
  therapySession?: InputMaybe<Scalars['ID']['input']>;
  total?: InputMaybe<Scalars['Float']['input']>;
};


export type GoalTypeMediatargetpredictionSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdDate?: InputMaybe<Scalars['DateTime']['input']>;
  endTime?: InputMaybe<Scalars['Float']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  goal?: InputMaybe<Scalars['ID']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedDate?: InputMaybe<Scalars['DateTime']['input']>;
  media?: InputMaybe<Scalars['ID']['input']>;
  modalityType?: InputMaybe<ApiMediaTargetPredictionModalityTypeChoices>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  organization?: InputMaybe<Scalars['ID']['input']>;
  predictionId?: InputMaybe<Scalars['String']['input']>;
  rationale?: InputMaybe<Scalars['String']['input']>;
  reportGoalOld?: InputMaybe<Scalars['ID']['input']>;
  reportTargetOld?: InputMaybe<Scalars['ID']['input']>;
  startTime?: InputMaybe<Scalars['Float']['input']>;
  target?: InputMaybe<Scalars['ID']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
};


export type GoalTypePassagegoalbankSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  aiGenerated?: InputMaybe<Scalars['Boolean']['input']>;
  antecedentStrategy?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdDate?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  discriminativeStimulus?: InputMaybe<Scalars['String']['input']>;
  errorConsequenceStrategy?: InputMaybe<Scalars['String']['input']>;
  errorCorrectionStrategy?: InputMaybe<Scalars['String']['input']>;
  expectedResponse?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  goal?: InputMaybe<Scalars['ID']['input']>;
  goalBank?: InputMaybe<Scalars['ID']['input']>;
  hypothesizedFunction?: InputMaybe<Scalars['String']['input']>;
  inUse?: InputMaybe<Scalars['Boolean']['input']>;
  labels?: InputMaybe<Scalars['JSONString']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedDate?: InputMaybe<Scalars['DateTime']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  onset?: InputMaybe<Scalars['String']['input']>;
  operationalDefinition?: InputMaybe<Scalars['String']['input']>;
  organization?: InputMaybe<Scalars['ID']['input']>;
  passageOffset?: InputMaybe<Scalars['String']['input']>;
  promptingInstructions?: InputMaybe<Scalars['String']['input']>;
  reinforcementStrategy?: InputMaybe<Scalars['String']['input']>;
  replacementBehavior?: InputMaybe<Scalars['String']['input']>;
  teachingMethod?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<ApiPassageGoalBankTypeChoices>;
};


export type GoalTypeReportgoalSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  aiBaselineDataPredictionStatus?: InputMaybe<ApiReportGoalAiBaselineDataPredictionStatusChoices>;
  aiGenerated?: InputMaybe<Scalars['Boolean']['input']>;
  aiGoalAttainmentScalePredictionStatus?: InputMaybe<ApiReportGoalAiGoalAttainmentScalePredictionStatusChoices>;
  aiProgressSummaryPredictionStatus?: InputMaybe<ApiReportGoalAiProgressSummaryPredictionStatusChoices>;
  assessmentToolSource?: InputMaybe<Scalars['String']['input']>;
  baselineData?: InputMaybe<Scalars['String']['input']>;
  baselineDate?: InputMaybe<Scalars['Date']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  chartFromDate?: InputMaybe<Scalars['Date']['input']>;
  chartImageUrl?: InputMaybe<Scalars['String']['input']>;
  chartToDate?: InputMaybe<Scalars['Date']['input']>;
  chartType?: InputMaybe<ApiReportGoalChartTypeChoices>;
  completionDate?: InputMaybe<Scalars['Date']['input']>;
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdDate?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  excludeFromReport?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  gasLevel1?: InputMaybe<Scalars['String']['input']>;
  gasLevel3?: InputMaybe<Scalars['String']['input']>;
  gasLevel4?: InputMaybe<Scalars['String']['input']>;
  gasMatchMessage?: InputMaybe<Scalars['String']['input']>;
  gasMatchStatus?: InputMaybe<ApiReportGoalGasMatchStatusChoices>;
  gasScore?: InputMaybe<Scalars['String']['input']>;
  generalizationCriteria?: InputMaybe<Scalars['String']['input']>;
  goal?: InputMaybe<Scalars['ID']['input']>;
  goalBank?: InputMaybe<Scalars['ID']['input']>;
  goalName?: InputMaybe<Scalars['String']['input']>;
  goalSubType?: InputMaybe<Scalars['String']['input']>;
  goalType?: InputMaybe<Scalars['String']['input']>;
  hasMedicalNecessity?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  inUse?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedDate?: InputMaybe<Scalars['DateTime']['input']>;
  learner?: InputMaybe<Scalars['ID']['input']>;
  masteryCriteria?: InputMaybe<Scalars['String']['input']>;
  medicalNecessityCriteria?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  organization?: InputMaybe<Scalars['ID']['input']>;
  predictionId?: InputMaybe<Scalars['String']['input']>;
  programGoal?: InputMaybe<Scalars['String']['input']>;
  progressSummary?: InputMaybe<Scalars['String']['input']>;
  projectedIntroductionDate?: InputMaybe<Scalars['Date']['input']>;
  rationale?: InputMaybe<Scalars['String']['input']>;
  report?: InputMaybe<Scalars['ID']['input']>;
  reportDomain?: InputMaybe<Scalars['ID']['input']>;
  reportTreatmentPlan?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<ApiReportGoalStatusChoices>;
  suggestionConfidence?: InputMaybe<Scalars['Float']['input']>;
  summaryReviewed?: InputMaybe<Scalars['Boolean']['input']>;
  summaryReviewedOn?: InputMaybe<Scalars['DateTime']['input']>;
  timelineEstimationType?: InputMaybe<ApiReportGoalTimelineEstimationTypeChoices>;
  timelineEstimationValue?: InputMaybe<Scalars['Int']['input']>;
};


export type GoalTypeTargetsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdDate?: InputMaybe<Scalars['DateTime']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  goal?: InputMaybe<Scalars['ID']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedDate?: InputMaybe<Scalars['DateTime']['input']>;
  learner?: InputMaybe<Scalars['ID']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  organization?: InputMaybe<Scalars['ID']['input']>;
};

export type GoalTypeConnection = {
  __typename?: 'GoalTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<GoalTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `GoalType` and its cursor. */
export type GoalTypeEdge = {
  __typename?: 'GoalTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<GoalType>;
};

export enum GoalTypeEnums {
  BehaviorReduction = 'BEHAVIOR_REDUCTION',
  ParentCaregiverInvolvement = 'PARENT_CAREGIVER_INVOLVEMENT',
  SkillAcquisition = 'SKILL_ACQUISITION'
}

export type GoalWithTargetsInput = {
  goalDescription: Scalars['String']['input'];
  goalName: Scalars['String']['input'];
  targets?: InputMaybe<Array<TargetImportInput>>;
};

/**
 * GraphQL mutation for creating targets in an external HR system.
 *
 * This mutation creates targets for a specific learner and short-term goal
 * by initiating a Temporal workflow that handles the actual creation
 * in the external HR system.
 *
 * :param learner_external_id: External ID of the learner in the HR system
 * :param goal_external_id: External ID of the short-term goal in the HR system
 *
 * :return: HRTargetsCreationMutation: Mutation result with status message
 */
export type HrTargetsCreationMutation = {
  __typename?: 'HRTargetsCreationMutation';
  message?: Maybe<Scalars['String']['output']>;
};

export type HatchPlanType = Node & {
  __typename?: 'HatchPlanType';
  caregiver: CaregiverType;
  createdDate: Scalars['DateTime']['output'];
  /** The ID of the object */
  id: Scalars['ID']['output'];
  lastUpdatedDate: Scalars['DateTime']['output'];
  learner: LearnerType;
  organization: OrganizationType;
  pk?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<ApiHatchPlanStatusChoices>;
  statusReason?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  visualizations: HatchPlanVisualizationTypeConnection;
};


export type HatchPlanTypeVisualizationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  organization?: InputMaybe<Scalars['ID']['input']>;
  plan?: InputMaybe<Scalars['ID']['input']>;
  visualizationType?: InputMaybe<ApiHatchPlanVisualizationVisualizationTypeChoices>;
};

export type HatchPlanTypeConnection = {
  __typename?: 'HatchPlanTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<HatchPlanTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `HatchPlanType` and its cursor. */
export type HatchPlanTypeEdge = {
  __typename?: 'HatchPlanTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<HatchPlanType>;
};

export type HatchPlanVisualizationType = Node & {
  __typename?: 'HatchPlanVisualizationType';
  createdDate: Scalars['DateTime']['output'];
  generatedData: Scalars['JSONString']['output'];
  /** The ID of the object */
  id: Scalars['ID']['output'];
  lastUpdatedDate: Scalars['DateTime']['output'];
  organization: OrganizationType;
  pk?: Maybe<Scalars['Int']['output']>;
  plan: HatchPlanType;
  renderedSvg: Scalars['String']['output'];
  visualizationType: ApiHatchPlanVisualizationVisualizationTypeChoices;
};

export type HatchPlanVisualizationTypeConnection = {
  __typename?: 'HatchPlanVisualizationTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<HatchPlanVisualizationTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `HatchPlanVisualizationType` and its cursor. */
export type HatchPlanVisualizationTypeEdge = {
  __typename?: 'HatchPlanVisualizationTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<HatchPlanVisualizationType>;
};

export enum HatchVisualizationType {
  ChoiceBoard = 'CHOICE_BOARD',
  FirstThen = 'FIRST_THEN',
  VisualSchedule = 'VISUAL_SCHEDULE'
}

export type HiRasmusGoalFilter = {
  /** Filter by latest HiRasmusGoalPhase status (case-insensitive partial match) */
  goalStatus?: InputMaybe<Scalars['String']['input']>;
};

export enum HiRasmusGoalStatusEnums {
  Active = 'ACTIVE',
  Baseline = 'BASELINE',
  Closed = 'CLOSED',
  Discontinued = 'DISCONTINUED',
  Hold = 'HOLD',
  Maintenance = 'MAINTENANCE',
  Waiting = 'WAITING'
}

export type HiRasmusGoalType = Node & {
  __typename?: 'HiRasmusGoalType';
  aiGenerated: Scalars['Boolean']['output'];
  baseline?: Maybe<Scalars['String']['output']>;
  baselineDate?: Maybe<Scalars['Date']['output']>;
  createdDate: Scalars['DateTime']['output'];
  externalId?: Maybe<Scalars['String']['output']>;
  goal: GoalType;
  hirasmusTargets: HiRasmusTargetTypeConnection;
  /** The ID of the object */
  id: Scalars['ID']['output'];
  inUse: Scalars['Boolean']['output'];
  instructions?: Maybe<Scalars['String']['output']>;
  lastUpdatedDate: Scalars['DateTime']['output'];
  masteringWorkflow?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  objective?: Maybe<Scalars['String']['output']>;
  organization: OrganizationType;
  pk?: Maybe<Scalars['Int']['output']>;
  progressSummary?: Maybe<Scalars['String']['output']>;
  promptLevelTemplate?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  treatmentArea?: Maybe<Scalars['String']['output']>;
  treatmentInstructions?: Maybe<Scalars['String']['output']>;
  type?: Maybe<ApiHiRasmusGoalTypeChoices>;
};


export type HiRasmusGoalTypeHirasmusTargetsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  aiGenerated?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdDate?: InputMaybe<Scalars['DateTime']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hirasmusGoal?: InputMaybe<Scalars['ID']['input']>;
  inUse?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedDate?: InputMaybe<Scalars['DateTime']['input']>;
  masteringWorkflow?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  organization?: InputMaybe<Scalars['ID']['input']>;
  promptLevelTemplate?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  target?: InputMaybe<Scalars['ID']['input']>;
  type?: InputMaybe<ApiHiRasmusTargetTypeChoices>;
};

export type HiRasmusGoalTypeConnection = {
  __typename?: 'HiRasmusGoalTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<HiRasmusGoalTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `HiRasmusGoalType` and its cursor. */
export type HiRasmusGoalTypeEdge = {
  __typename?: 'HiRasmusGoalTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<HiRasmusGoalType>;
};

export enum HiRasmusGoalTypeEnums {
  HrDuration = 'HR_DURATION',
  HrEsdm = 'HR_ESDM',
  HrFrequency = 'HR_FREQUENCY',
  HrInterval = 'HR_INTERVAL',
  HrSkillAcquisition = 'HR_SKILL_ACQUISITION',
  HrSufficientExemplarTraining = 'HR_SUFFICIENT_EXEMPLAR_TRAINING',
  HrTaskAnalysis = 'HR_TASK_ANALYSIS'
}

export enum HiRasmusTargetStatusEnums {
  Acquisition = 'ACQUISITION',
  Baseline = 'BASELINE',
  Closed = 'CLOSED',
  Discontinued = 'DISCONTINUED',
  Hold = 'HOLD',
  Intervention = 'INTERVENTION',
  Mastered = 'MASTERED',
  Probe = 'PROBE',
  Waiting = 'WAITING'
}

export type HiRasmusTargetType = Node & {
  __typename?: 'HiRasmusTargetType';
  aiGenerated: Scalars['Boolean']['output'];
  createdDate: Scalars['DateTime']['output'];
  externalId?: Maybe<Scalars['String']['output']>;
  hirasmusGoal: HiRasmusGoalType;
  /** The ID of the object */
  id: Scalars['ID']['output'];
  inUse: Scalars['Boolean']['output'];
  lastUpdatedDate: Scalars['DateTime']['output'];
  masteringWorkflow?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  organization: OrganizationType;
  pk?: Maybe<Scalars['Int']['output']>;
  promptLevelTemplate?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  target: TargetType;
  type?: Maybe<ApiHiRasmusTargetTypeChoices>;
};

export type HiRasmusTargetTypeConnection = {
  __typename?: 'HiRasmusTargetTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<HiRasmusTargetTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `HiRasmusTargetType` and its cursor. */
export type HiRasmusTargetTypeEdge = {
  __typename?: 'HiRasmusTargetTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<HiRasmusTargetType>;
};

export type HippHealthGoalFilter = {
  /** Filter by latest HippHealthGoalPhase status (case-insensitive partial match) */
  goalStatus?: InputMaybe<Scalars['String']['input']>;
  /** Filter by external_id presence: 'WITH_EXTERNAL_ID', 'WITHOUT_EXTERNAL_ID', or 'ANY' */
  hasExternalId?: InputMaybe<Scalars['String']['input']>;
};

/** Input type for Hipp Health goals - includes all fields for AI type determination. */
export type HippHealthGoalInput = {
  autoProgressToMaintenanceEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  autoProgressToMasteredEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  baselineDate?: InputMaybe<Scalars['DateTime']['input']>;
  baselineMetric?: InputMaybe<Scalars['JSONString']['input']>;
  dataCollectionType?: InputMaybe<Scalars['String']['input']>;
  definition?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  enabledOutcomes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  goalStatement?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  instructions?: InputMaybe<Scalars['String']['input']>;
  intervalDuration?: InputMaybe<Scalars['Int']['input']>;
  intervalQuantity?: InputMaybe<Scalars['Int']['input']>;
  intervalRecordingType?: InputMaybe<Scalars['String']['input']>;
  maintenanceMetric?: InputMaybe<Scalars['JSONString']['input']>;
  minTrialsCount?: InputMaybe<Scalars['Int']['input']>;
  progressSummary?: InputMaybe<Scalars['String']['input']>;
  sets?: InputMaybe<Scalars['Int']['input']>;
  shortDescription?: InputMaybe<Scalars['String']['input']>;
  skillAcquisitionGoalType?: InputMaybe<Scalars['String']['input']>;
  skillCategory?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  successMetric?: InputMaybe<Scalars['JSONString']['input']>;
  targetAchievementDate?: InputMaybe<Scalars['DateTime']['input']>;
  targetMaladaptiveBehaviorName?: InputMaybe<Scalars['String']['input']>;
  targets?: InputMaybe<Array<InputMaybe<HippHealthTargetInput>>>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  window?: InputMaybe<Scalars['Int']['input']>;
};

export type HippHealthGoalType = Node & {
  __typename?: 'HippHealthGoalType';
  aiGenerated: Scalars['Boolean']['output'];
  autoProgressToMaintenanceEnabled: Scalars['Boolean']['output'];
  autoProgressToMasteredEnabled: Scalars['Boolean']['output'];
  baselineDate?: Maybe<Scalars['DateTime']['output']>;
  baselineMetric: Scalars['JSONString']['output'];
  createdDate: Scalars['DateTime']['output'];
  dataCollectionType?: Maybe<Scalars['String']['output']>;
  definition?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  enabledOutcomes: Scalars['JSONString']['output'];
  externalId?: Maybe<Scalars['String']['output']>;
  goal: GoalType;
  goalStatement?: Maybe<Scalars['String']['output']>;
  hippHealthTargets: HippHealthTargetTypeConnection;
  /** The ID of the object */
  id: Scalars['ID']['output'];
  inUse: Scalars['Boolean']['output'];
  instructions?: Maybe<Scalars['String']['output']>;
  intervalDuration?: Maybe<Scalars['Int']['output']>;
  intervalQuantity?: Maybe<Scalars['Int']['output']>;
  intervalRecordingType?: Maybe<ApiHippHealthGoalIntervalRecordingTypeChoices>;
  lastUpdatedDate: Scalars['DateTime']['output'];
  maintenanceMetric: Scalars['JSONString']['output'];
  minTrialsCount?: Maybe<Scalars['Int']['output']>;
  organization: OrganizationType;
  pk?: Maybe<Scalars['Int']['output']>;
  progressSummary?: Maybe<Scalars['String']['output']>;
  sets?: Maybe<Scalars['Int']['output']>;
  shortDescription?: Maybe<Scalars['String']['output']>;
  skillAcquisitionGoalType?: Maybe<Scalars['String']['output']>;
  skillCategory?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  successMetric: Scalars['JSONString']['output'];
  targetAchievementDate?: Maybe<Scalars['DateTime']['output']>;
  targetMaladaptiveBehaviorName?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  type: ApiHippHealthGoalTypeChoices;
  window?: Maybe<Scalars['Int']['output']>;
};


export type HippHealthGoalTypeHippHealthTargetsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  description_Icontains?: InputMaybe<Scalars['String']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hippHealthGoal?: InputMaybe<Scalars['ID']['input']>;
  inUse?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_Icontains?: InputMaybe<Scalars['String']['input']>;
};

export type HippHealthGoalTypeConnection = {
  __typename?: 'HippHealthGoalTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<HippHealthGoalTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `HippHealthGoalType` and its cursor. */
export type HippHealthGoalTypeEdge = {
  __typename?: 'HippHealthGoalTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<HippHealthGoalType>;
};

export type HippHealthTargetInput = {
  antecedent?: InputMaybe<Scalars['String']['input']>;
  consequence?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  durationSeconds?: InputMaybe<Scalars['Int']['input']>;
  happenedAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  trialOutcome?: InputMaybe<Scalars['String']['input']>;
};

export type HippHealthTargetType = Node & {
  __typename?: 'HippHealthTargetType';
  aiGenerated: Scalars['Boolean']['output'];
  autoProgressToMaintenanceEnabled: Scalars['Boolean']['output'];
  autoProgressToMasteredEnabled: Scalars['Boolean']['output'];
  baselineDate?: Maybe<Scalars['DateTime']['output']>;
  baselineMetric: Scalars['JSONString']['output'];
  createdDate: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  enabledOutcomes: Scalars['JSONString']['output'];
  externalId?: Maybe<Scalars['String']['output']>;
  hippHealthGoal: HippHealthGoalType;
  /** The ID of the object */
  id: Scalars['ID']['output'];
  inUse: Scalars['Boolean']['output'];
  instructions?: Maybe<Scalars['String']['output']>;
  lastUpdatedDate: Scalars['DateTime']['output'];
  maintenanceMetric: Scalars['JSONString']['output'];
  minTrialsCount?: Maybe<Scalars['Int']['output']>;
  orderAmongSiblings?: Maybe<Scalars['Int']['output']>;
  organization: OrganizationType;
  pk?: Maybe<Scalars['Int']['output']>;
  progressSummary?: Maybe<Scalars['String']['output']>;
  shortDescription?: Maybe<Scalars['String']['output']>;
  skillAcquisitionGoalType?: Maybe<ApiHippHealthTargetSkillAcquisitionGoalTypeChoices>;
  skillCategory?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  successMetric: Scalars['JSONString']['output'];
  target: TargetType;
  targetAchievementDate?: Maybe<Scalars['DateTime']['output']>;
  title: Scalars['String']['output'];
};

export type HippHealthTargetTypeConnection = {
  __typename?: 'HippHealthTargetTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<HippHealthTargetTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `HippHealthTargetType` and its cursor. */
export type HippHealthTargetTypeEdge = {
  __typename?: 'HippHealthTargetTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<HippHealthTargetType>;
};

export type HippHealthTreatmentPlanInput = {
  goals?: InputMaybe<Array<InputMaybe<HippHealthGoalInput>>>;
};

export type ImportClientFromEhr = {
  __typename?: 'ImportClientFromEHR';
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type ImportClientList = {
  __typename?: 'ImportClientList';
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

/**
 * Import goals from an uploaded Excel spreadsheet into the requesting
 * enterprise-admin's organization goal bank.
 *
 * With ``dry_run=True`` the spreadsheet is parsed and validated but nothing is
 * written, so the client can show a "found X goals, skipped Y empty rows"
 * preview before committing the real import.
 */
export type ImportGoalBank = {
  __typename?: 'ImportGoalBank';
  message?: Maybe<Scalars['String']['output']>;
  stats?: Maybe<Scalars['JSONString']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type ImportGoalBankInput = {
  /** Folder Category / curriculum name (new or existing). Required so imported folders are scoped to one goal bank (curriculum). */
  curriculumName: Scalars['String']['input'];
  /** Preview the import (counts + skipped rows) without saving */
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  /** CREATE_ONLY (default) or UPDATE */
  mode?: InputMaybe<GoalBankImportMode>;
  /** S3 key of the uploaded Excel file */
  s3Key: Scalars['String']['input'];
  /** Sheet name or index to import (default: 0) */
  sheet?: InputMaybe<Scalars['String']['input']>;
  /** Trigger goal-suggestion embeddings even if the org has none yet */
  triggerEmbeddings?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ImportGoalsFromEhr = {
  __typename?: 'ImportGoalsFromEHR';
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type ImportReportTemplateJson = {
  __typename?: 'ImportReportTemplateJson';
  reportTemplate?: Maybe<ReportTemplateType>;
};

/**
 * M2M-authorized variant of ImportReportTemplateJson.
 *
 * Used by the report_template_builder Temporal workflow to persist an
 * AI-generated draft template into the basecamp UI. Differs from the
 * human-admin version only in the auth decorator + arguments (single
 * organizationId so the audit middleware sees org context).
 */
export type ImportReportTemplateJsonM2m = {
  __typename?: 'ImportReportTemplateJsonM2m';
  reportTemplate?: Maybe<ReportTemplateType>;
};

export type ImportSessionsFromEhr = {
  __typename?: 'ImportSessionsFromEHR';
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type ImportTargetsFromEhr = {
  __typename?: 'ImportTargetsFromEHR';
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

/**
 * Initiates a chunked S3 upload for a chat-sourced video.
 *
 * Creates a Media row (no VideoSession) and returns the multipart upload
 * metadata. The Media is attached to the chat's learner via the eventual
 * ChatMessage.media FK created by ``createChatMessage``. Also returns a
 * single-PUT URL for a client-extracted JPG thumbnail; on completion the
 * server writes a manifest JSON pointing at it so ``MediaType.thumbnailUrl``
 * resolves.
 */
export type InitiateChatVideoUpload = {
  __typename?: 'InitiateChatVideoUpload';
  fileKey?: Maybe<Scalars['String']['output']>;
  media?: Maybe<MediaType>;
  message?: Maybe<Scalars['String']['output']>;
  multipartUploadId?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
  /** Optional single-PUT URL for a JPG thumbnail (Content-Type image/jpeg). Clients that can't generate one can skip; chat falls back to local frame extraction. */
  thumbnailUploadUrl?: Maybe<Scalars['String']['output']>;
  uploadUrls?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type InitiateChatVideoUploadInput = {
  chatId: Scalars['ID']['input'];
  fileName: Scalars['String']['input'];
  mediaLanguage: LanguageEnumType;
  mediaSource: MediaSourceEnum;
  requiredParts: Scalars['Int']['input'];
};

/** An enumeration. */
export enum InputDependencyChoices {
  Abas = 'ABAS',
  Ablls = 'ABLLS',
  ActionBehavioralCenterIntake = 'ACTION_BEHAVIORAL_CENTER_INTAKE',
  AdiR = 'ADI_R',
  AdiRInterviewNotes = 'ADI_R_INTERVIEW_NOTES',
  AdiRToddler = 'ADI_R_TODDLER',
  Ados = 'ADOS',
  Ados_2 = 'ADOS_2',
  Afls = 'AFLS',
  Apsi = 'APSI',
  Asrs = 'ASRS',
  Basc_3 = 'BASC_3',
  Basc_3Prq = 'BASC_3_PRQ',
  Basc_4 = 'BASC_4',
  Bayley_3 = 'BAYLEY_3',
  Bayley_4 = 'BAYLEY_4',
  Bdi_2 = 'BDI_2',
  Bdi_3 = 'BDI_3',
  Befas = 'BEFAS',
  BehavioralObservations = 'BEHAVIORAL_OBSERVATIONS',
  Bhi = 'BHI',
  Bhtia = 'BHTIA',
  Brief = 'BRIEF',
  Brief_2 = 'BRIEF_2',
  Cars_2 = 'CARS_2',
  CatalightIntake = 'CATALIGHT_INTAKE',
  Cbcl = 'CBCL',
  Cfql = 'CFQL',
  ChatAsset = 'CHAT_ASSET',
  ClinicalNotes = 'CLINICAL_NOTES',
  Conners_4Adhd = 'CONNERS_4_ADHD',
  Ctoni_2 = 'CTONI_2',
  ConnersCpt3Adhd = 'Conners_CPT3_ADHD',
  Das_2 = 'DAS_2',
  Dayc = 'DAYC',
  DiagnosisReport = 'DIAGNOSIS_REPORT',
  Dp_4 = 'DP_4',
  Earlipoint = 'EARLIPOINT',
  Esdm = 'ESDM',
  EssentialForLivingQuick = 'ESSENTIAL_FOR_LIVING_QUICK',
  Evt_3 = 'EVT_3',
  Fast = 'FAST',
  Gars_2 = 'GARS_2',
  Gars_3 = 'GARS_3',
  HanleyFba = 'HANLEY_FBA',
  IntakeCall = 'INTAKE_CALL',
  IntakeCallTranscript = 'INTAKE_CALL_TRANSCRIPT',
  IntakeCallTranscriptJson = 'INTAKE_CALL_TRANSCRIPT_JSON',
  Interview = 'INTERVIEW',
  InterviewChild = 'INTERVIEW_CHILD',
  InterviewOther = 'INTERVIEW_OTHER',
  InterviewParent = 'INTERVIEW_PARENT',
  InterviewTeacher = 'INTERVIEW_TEACHER',
  Kbit_2 = 'KBIT_2',
  Mas = 'MAS',
  Migdas_2 = 'MIGDAS_2',
  MullenScalesOfEarlyLearners = 'MULLEN_SCALES_OF_EARLY_LEARNERS',
  MChat = 'M_CHAT',
  Nichq = 'NICHQ',
  Pddbi = 'PDDBI',
  Pdpvts = 'PDPVTS',
  Peak = 'PEAK',
  Pls_5 = 'PLS_5',
  Ppvt_5 = 'PPVT_5',
  PreviousAssessment = 'PREVIOUS_ASSESSMENT',
  Psi_4 = 'PSI_4',
  PToni = 'P_TONI',
  Qabf = 'QABF',
  Rcmas_2 = 'RCMAS_2',
  Rias_2 = 'RIAS_2',
  SafetyConcerns = 'SAFETY_CONCERNS',
  Scared = 'SCARED',
  Scq = 'SCQ',
  Sipa = 'SIPA',
  SkillStreaming = 'SKILL_STREAMING',
  SociallySavvy = 'SOCIALLY_SAVVY',
  SocialSkillsSolutions = 'SOCIAL_SKILLS_SOLUTIONS',
  Spm_2 = 'SPM_2',
  Srs2 = 'SRS2',
  Ssis = 'SSIS',
  StanfordBinet_5 = 'STANFORD_BINET_5',
  SensoryProfile_2 = 'Sensory_Profile_2',
  StanfordBinet = 'Stanford_Binet',
  Tasi = 'TASI',
  TeleAsdPeds = 'TELE_ASD_PEDS',
  Toni_4 = 'TONI_4',
  TreatmentPlan = 'TREATMENT_PLAN',
  Tscc = 'TSCC',
  Tscyc = 'TSCYC',
  Unclassified = 'UNCLASSIFIED',
  Vbmapp = 'VBMAPP',
  VbmappLearn = 'VBMAPP_LEARN',
  VbmappOpya = 'VBMAPP_OPYA',
  Vineland = 'VINELAND',
  Wais_4 = 'WAIS_4',
  WaisV = 'WAIS_V',
  WasiIi = 'WASI_II',
  WiatIv = 'WIAT_IV',
  WiscV = 'WISC_V',
  WppsiIv = 'WPPSI_IV',
  Wurs = 'WURS',
  EssentialForLiving = 'essential_for_living',
  PdbbiParent = 'pdbbi_parent',
  PdbbiTeacher = 'pdbbi_teacher'
}

export type InsuranceDetailsType = Node & {
  __typename?: 'InsuranceDetailsType';
  backOfCardLocation?: Maybe<Scalars['String']['output']>;
  caregiver?: Maybe<CaregiverType>;
  city?: Maybe<Scalars['String']['output']>;
  claimsAddress?: Maybe<Scalars['String']['output']>;
  claimsAddressLine2?: Maybe<Scalars['String']['output']>;
  createdDate: Scalars['DateTime']['output'];
  frontOfCardLocation?: Maybe<Scalars['String']['output']>;
  groupName?: Maybe<Scalars['String']['output']>;
  /** The ID of the object */
  id: Scalars['ID']['output'];
  idNumber?: Maybe<Scalars['String']['output']>;
  inNetwork?: Maybe<ApiInsuranceDetailsInNetworkChoices>;
  insurancePolicyHolder?: Maybe<Scalars['String']['output']>;
  insuranceType: ApiInsuranceDetailsInsuranceTypeChoices;
  insurer: ApiInsuranceDetailsInsurerChoices;
  isPrimaryInsurance: Scalars['Boolean']['output'];
  lastUpdatedDate: Scalars['DateTime']['output'];
  learner?: Maybe<LearnerType>;
  organization: OrganizationType;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  pk?: Maybe<Scalars['Int']['output']>;
  policyHolderBirthDate?: Maybe<Scalars['Date']['output']>;
  signedUrlOfCardBack?: Maybe<Scalars['String']['output']>;
  signedUrlOfCardFront?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  zip?: Maybe<Scalars['String']['output']>;
};

export type InsuranceDetailsTypeConnection = {
  __typename?: 'InsuranceDetailsTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<InsuranceDetailsTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `InsuranceDetailsType` and its cursor. */
export type InsuranceDetailsTypeEdge = {
  __typename?: 'InsuranceDetailsTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<InsuranceDetailsType>;
};

export enum InsuranceInNetworkEnums {
  No = 'NO',
  Unknown = 'UNKNOWN',
  Yes = 'YES'
}

export type InsuranceInput = {
  inNetwork?: InputMaybe<InsuranceInNetworkEnums>;
  insuranceType: InsuranceTypeEnums;
  insurer: InsurerEnums;
};

export enum InsuranceTypeEnums {
  Commercial = 'COMMERCIAL',
  Federal = 'FEDERAL',
  Medicaid = 'MEDICAID',
  Other = 'OTHER'
}

export enum InsurerEnums {
  BlueCross = 'BLUE_CROSS',
  HealthFirstColorado = 'HEALTH_FIRST_COLORADO',
  Other = 'OTHER',
  Presbyterian = 'PRESBYTERIAN',
  WesternSky = 'WESTERN_SKY'
}

export type IntegrationSyncConfigFilter = {
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  organizationType?: InputMaybe<Scalars['String']['input']>;
};

export type IntegrationSyncConfigType = Node & {
  __typename?: 'IntegrationSyncConfigType';
  createdDate: Scalars['DateTime']['output'];
  /** The ID of the object */
  id: Scalars['ID']['output'];
  isEnabled: Scalars['Boolean']['output'];
  lastUpdatedDate: Scalars['DateTime']['output'];
  organization: OrganizationType;
  pk?: Maybe<Scalars['Int']['output']>;
  syncFeature: ApiIntegrationSyncConfigSyncFeatureChoices;
};

export enum LanguageEnumType {
  Arabic = 'ARABIC',
  English = 'ENGLISH',
  Hindi = 'HINDI',
  Spanish = 'SPANISH'
}

export type LanguageStylePromptType = Node & {
  __typename?: 'LanguageStylePromptType';
  createdDate: Scalars['DateTime']['output'];
  /** The ID of the object */
  id: Scalars['ID']['output'];
  languageFragment?: Maybe<Scalars['String']['output']>;
  lastUpdatedDate: Scalars['DateTime']['output'];
  organization: OrganizationType;
  pk?: Maybe<Scalars['Int']['output']>;
  predictionId?: Maybe<Scalars['String']['output']>;
  processingFailureReason?: Maybe<Scalars['String']['output']>;
  provider?: Maybe<ProviderType>;
  status?: Maybe<ApiLanguageStylePromptStatusChoices>;
};

export type LanguageStylePromptTypeConnection = {
  __typename?: 'LanguageStylePromptTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<LanguageStylePromptTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `LanguageStylePromptType` and its cursor. */
export type LanguageStylePromptTypeEdge = {
  __typename?: 'LanguageStylePromptTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<LanguageStylePromptType>;
};

export type LearnerAdditionalDetailsInput = {
  anythingThatCameUpToBeMentioned?: InputMaybe<Scalars['String']['input']>;
  anythingThatWeDidNotCoverEnough?: InputMaybe<Scalars['String']['input']>;
  mainConcerns?: InputMaybe<Scalars['String']['input']>;
  mchatResultForClient?: InputMaybe<Scalars['String']['input']>;
  whoReferredYou?: InputMaybe<Scalars['String']['input']>;
};

export type LearnerAdditionalDetailsType = Node & {
  __typename?: 'LearnerAdditionalDetailsType';
  anythingThatCameUpToBeMentioned?: Maybe<Scalars['String']['output']>;
  anythingThatWeDidNotCoverEnough?: Maybe<Scalars['String']['output']>;
  createdDate: Scalars['DateTime']['output'];
  /** The ID of the object */
  id: Scalars['ID']['output'];
  lastUpdatedDate: Scalars['DateTime']['output'];
  learner: LearnerType;
  mainConcerns?: Maybe<Scalars['String']['output']>;
  mchatResultForClient?: Maybe<Scalars['String']['output']>;
  organization: OrganizationType;
  pk?: Maybe<Scalars['Int']['output']>;
  whoReferredYou?: Maybe<Scalars['String']['output']>;
};

export type LearnerAuthorizationsFilter = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the end date less than or equal to */
  endDateLte?: InputMaybe<Scalars['Date']['input']>;
  orgId?: InputMaybe<Scalars['ID']['input']>;
  reassessmentReportCompleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type LearnerAuthorizationsType = Node & {
  __typename?: 'LearnerAuthorizationsType';
  active: Scalars['Boolean']['output'];
  authorizationId: Scalars['String']['output'];
  createdDate: Scalars['DateTime']['output'];
  endDate: Scalars['Date']['output'];
  externalId: Scalars['String']['output'];
  /** The ID of the object */
  id: Scalars['ID']['output'];
  lastUpdatedDate: Scalars['DateTime']['output'];
  learner: LearnerType;
  organization: OrganizationType;
  pk?: Maybe<Scalars['Int']['output']>;
  reassessmentReportCompleted?: Maybe<Scalars['Boolean']['output']>;
  startDate: Scalars['Date']['output'];
};

export type LearnerAuthorizationsTypeConnection = {
  __typename?: 'LearnerAuthorizationsTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<LearnerAuthorizationsTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `LearnerAuthorizationsType` and its cursor. */
export type LearnerAuthorizationsTypeEdge = {
  __typename?: 'LearnerAuthorizationsTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<LearnerAuthorizationsType>;
};

export enum LearnerAvailabilityDaysEnums {
  Friday = 'FRIDAY',
  Monday = 'MONDAY',
  Saturday = 'SATURDAY',
  Sunday = 'SUNDAY',
  Thursday = 'THURSDAY',
  Tuesday = 'TUESDAY',
  Wednesday = 'WEDNESDAY'
}

export type LearnerAvailabilityInput = {
  day: LearnerAvailabilityDaysEnums;
  timeOfDay: LearnerAvailabilityTimeOfDayEnums;
};

export enum LearnerAvailabilityTimeOfDayEnums {
  Afternoon = 'AFTERNOON',
  Evening = 'EVENING',
  Midday = 'MIDDAY',
  Morning = 'MORNING'
}

export type LearnerAvailabilityType = Node & {
  __typename?: 'LearnerAvailabilityType';
  createdDate: Scalars['DateTime']['output'];
  day: ApiLearnerAvailabilityDayChoices;
  /** The ID of the object */
  id: Scalars['ID']['output'];
  lastUpdatedDate: Scalars['DateTime']['output'];
  learner: LearnerType;
  organization: OrganizationType;
  pk?: Maybe<Scalars['Int']['output']>;
  timeOfDay: ApiLearnerAvailabilityTimeOfDayChoices;
};

export type LearnerAvailabilityTypeConnection = {
  __typename?: 'LearnerAvailabilityTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<LearnerAvailabilityTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `LearnerAvailabilityType` and its cursor. */
export type LearnerAvailabilityTypeEdge = {
  __typename?: 'LearnerAvailabilityTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<LearnerAvailabilityType>;
};

export type LearnerBehaviorQuestionInput = {
  answer: Scalars['String']['input'];
  questionKey: BehaviorsQuestionType;
  questionPageOrigin: Scalars['String']['input'];
};

export type LearnerBehaviorsInput = {
  behaviorQuestions: Array<InputMaybe<LearnerBehaviorQuestionInput>>;
};

export type LearnerBirthHistoryInput = {
  alcohol: Scalars['Boolean']['input'];
  cesareanBirth: Scalars['Boolean']['input'];
  clientLikeAsBaby: Scalars['String']['input'];
  complicationsDuringPregnancy: Scalars['Boolean']['input'];
  concernsIssuesPregnancyDelivery: Scalars['String']['input'];
  difficultLaborDelivery: Scalars['Boolean']['input'];
  difficultyBreathing: Scalars['Boolean']['input'];
  difficultyRespondingToTouch: Scalars['Boolean']['input'];
  difficultySucking: Scalars['Boolean']['input'];
  hospitalizedForHealthConcernsAtBirth: Scalars['Boolean']['input'];
  hospitalizedForHealthConcernsAtBirthExplanation?: InputMaybe<Scalars['String']['input']>;
  illnessesDuringPregnancyFevers: Scalars['Boolean']['input'];
  illnessesDuringPregnancyGestationalDiabetes: Scalars['Boolean']['input'];
  illnessesDuringPregnancyHypertension: Scalars['Boolean']['input'];
  illnessesDuringPregnancyInfections: Scalars['Boolean']['input'];
  illnessesDuringPregnancyOther?: InputMaybe<Scalars['String']['input']>;
  illnessesDuringPregnancyPreEclampsia: Scalars['Boolean']['input'];
  normalFullTermPregnancy: Scalars['Boolean']['input'];
  overdueBirth: Scalars['Boolean']['input'];
  prematureBirth: Scalars['Boolean']['input'];
  prescriptionDrugsOrMedications: Scalars['Boolean']['input'];
  prescriptionDrugsOrMedicationsList?: InputMaybe<Scalars['String']['input']>;
  recreationalDrugs: Scalars['Boolean']['input'];
  separatedFromParentFirst24Months: Scalars['Boolean']['input'];
  separatedFromParentFirst24MonthsExplanation?: InputMaybe<Scalars['String']['input']>;
  temperamentAsBaby: Scalars['String']['input'];
  tobacco: Scalars['Boolean']['input'];
  weightAtBirthOunces: Scalars['String']['input'];
  weightAtBirthPounds: Scalars['String']['input'];
};

export type LearnerBirthHistoryType = Node & {
  __typename?: 'LearnerBirthHistoryType';
  alcoholUsed: Scalars['Boolean']['output'];
  babyTemperament?: Maybe<Scalars['String']['output']>;
  birthWeightInOunces: Scalars['String']['output'];
  birthWeightInPounds: Scalars['String']['output'];
  breathingDifficulty: Scalars['Boolean']['output'];
  cesareanBirth: Scalars['Boolean']['output'];
  clientLikeAsBaby?: Maybe<Scalars['String']['output']>;
  createdDate: Scalars['DateTime']['output'];
  difficultLaborDelivery: Scalars['Boolean']['output'];
  gestationalDiabetes: Scalars['Boolean']['output'];
  hospitalizedForHealthConcernsAtBirth: Scalars['Boolean']['output'];
  hospitalizedForHealthConcernsAtBirthExplanatiion?: Maybe<Scalars['String']['output']>;
  /** The ID of the object */
  id: Scalars['ID']['output'];
  lastUpdatedDate: Scalars['DateTime']['output'];
  learner: LearnerType;
  normalFullTermPregnancy: Scalars['Boolean']['output'];
  organization: OrganizationType;
  otherPregnancyIllnesses: Scalars['String']['output'];
  overdueBirth: Scalars['Boolean']['output'];
  pk?: Maybe<Scalars['Int']['output']>;
  pregnancyComplications: Scalars['Boolean']['output'];
  pregnancyDeliveryConcerns: Scalars['String']['output'];
  pregnancyFevers: Scalars['Boolean']['output'];
  pregnancyHypertension: Scalars['Boolean']['output'];
  pregnancyInfections: Scalars['Boolean']['output'];
  pregnancyPreEclampsia: Scalars['Boolean']['output'];
  prematureBirth: Scalars['Boolean']['output'];
  prescriptionDrugsUsed: Scalars['Boolean']['output'];
  prescriptionList?: Maybe<Scalars['String']['output']>;
  recreationalDrugsUsed: Scalars['Boolean']['output'];
  separatedFromParentFirst24Months: Scalars['Boolean']['output'];
  separatedFromParentFirst24MonthsExplanation?: Maybe<Scalars['String']['output']>;
  suckingDifficulty: Scalars['Boolean']['output'];
  tobaccoUsed: Scalars['Boolean']['output'];
  touchResponseDifficulty: Scalars['Boolean']['output'];
};

export type LearnerCaregiverMinimalInput = {
  address: Scalars['String']['input'];
  addressLine2?: InputMaybe<Scalars['String']['input']>;
  birthDate: Scalars['Date']['input'];
  caregiver2FirstName?: InputMaybe<Scalars['String']['input']>;
  caregiver2LastName?: InputMaybe<Scalars['String']['input']>;
  caregiverFirstName: Scalars['String']['input'];
  caregiverLastName: Scalars['String']['input'];
  city?: InputMaybe<Scalars['String']['input']>;
  clientFirstName: Scalars['String']['input'];
  clientLastName: Scalars['String']['input'];
  gender?: InputMaybe<Scalars['String']['input']>;
  specifyGender?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

export type LearnerChatMemoryType = Node & {
  __typename?: 'LearnerChatMemoryType';
  createdDate: Scalars['DateTime']['output'];
  /** The ID of the object */
  id: Scalars['ID']['output'];
  lastUpdatedDate: Scalars['DateTime']['output'];
  learner: LearnerType;
  memory?: Maybe<Scalars['JSONString']['output']>;
  organization: OrganizationType;
  pk?: Maybe<Scalars['Int']['output']>;
};

export type LearnerCommunicationInput = {
  communicationQuestions: Array<InputMaybe<LearnerCommunicationQuestionInput>>;
};

export type LearnerCommunicationQuestionInput = {
  answer: Scalars['String']['input'];
  questionKey: CommunicationQuestionType;
  questionPageOrigin: Scalars['String']['input'];
};

export type LearnerConnection = {
  newLearner: Scalars['ID']['input'];
  oldLearner: Scalars['ID']['input'];
};

export type LearnerConsentFilesType = Node & {
  __typename?: 'LearnerConsentFilesType';
  caregiver: CaregiverType;
  consentFile?: Maybe<Scalars['String']['output']>;
  consentType?: Maybe<ApiLearnerConsentFilesConsentTypeChoices>;
  createdDate: Scalars['DateTime']['output'];
  fileSizeInBytes?: Maybe<Scalars['BigInt']['output']>;
  /** The ID of the object */
  id: Scalars['ID']['output'];
  lastUpdatedDate: Scalars['DateTime']['output'];
  learner: LearnerType;
  organization: OrganizationType;
  pk?: Maybe<Scalars['Int']['output']>;
  signedConsentFileUrl?: Maybe<Scalars['String']['output']>;
};

export type LearnerConsentFilesTypeConnection = {
  __typename?: 'LearnerConsentFilesTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<LearnerConsentFilesTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `LearnerConsentFilesType` and its cursor. */
export type LearnerConsentFilesTypeEdge = {
  __typename?: 'LearnerConsentFilesTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<LearnerConsentFilesType>;
};

export type LearnerDetailsInput = {
  assessmentAppointmentDate?: InputMaybe<Scalars['DateTime']['input']>;
  bcbaForAssessment?: InputMaybe<Scalars['ID']['input']>;
  diagnosisAppointmentDate?: InputMaybe<Scalars['DateTime']['input']>;
  dob: Scalars['Date']['input'];
  firstName: Scalars['String']['input'];
  gender?: InputMaybe<Scalars['String']['input']>;
  hasPreviousDiagnosis?: InputMaybe<Scalars['Boolean']['input']>;
  lastName: Scalars['String']['input'];
  physclogistForDiagnosis?: InputMaybe<Scalars['ID']['input']>;
  specifyGender?: InputMaybe<Scalars['String']['input']>;
};

export type LearnerDevelopmentalMilestonesInput = {
  milestones: Array<InputMaybe<LearnerDevelopmentalMilestonesQuestionInput>>;
};

export type LearnerDevelopmentalMilestonesQuestionInput = {
  answer: Scalars['String']['input'];
  questionKey: DevelopmentMilestonesQuestionType;
  questionPageOrigin: Scalars['String']['input'];
};

export type LearnerEarlyInterventionServicesInput = {
  clientEnrolledInEarlyServices: Scalars['Boolean']['input'];
  clientEnrolledInEarlyServicesAge?: InputMaybe<Scalars['String']['input']>;
  clientEnrolledInEarlyServicesDismissedOrTransferred?: InputMaybe<Scalars['String']['input']>;
  clientEnrolledInEarlyServicesSpecialEducation?: InputMaybe<Scalars['String']['input']>;
};

export type LearnerEarlyInterventionServicesType = Node & {
  __typename?: 'LearnerEarlyInterventionServicesType';
  clientEarlyInterventionEnrollment: Scalars['Boolean']['output'];
  createdDate: Scalars['DateTime']['output'];
  dismissedOrTransferredToPreschool?: Maybe<Scalars['String']['output']>;
  earlyInterventionStartAge?: Maybe<Scalars['String']['output']>;
  /** The ID of the object */
  id: Scalars['ID']['output'];
  lastUpdatedDate: Scalars['DateTime']['output'];
  learner: LearnerType;
  organization: OrganizationType;
  pk?: Maybe<Scalars['Int']['output']>;
  specialEducationOrOutsideServices?: Maybe<Scalars['String']['output']>;
};

export type LearnerEducationDetailsInput = {
  academicStrengthsAndWeaknesses: Scalars['String']['input'];
  currentGrades: Scalars['String']['input'];
  educationSetting: Scalars['String']['input'];
  grade: Scalars['String']['input'];
  nameOfSchool: Scalars['String']['input'];
  otherHistoricalServices: Array<InputMaybe<OtherHistoricalServiceInput>>;
  schoolBehaviorProblems: Scalars['String']['input'];
  specialEducation: Scalars['Boolean']['input'];
  therapeuticServices: Array<InputMaybe<TherapeuticServiceInput>>;
};

export type LearnerEducationMetaDataType = Node & {
  __typename?: 'LearnerEducationMetaDataType';
  academicStrengthsAndWeaknesses: Scalars['String']['output'];
  createdDate: Scalars['DateTime']['output'];
  currentGrades: Scalars['String']['output'];
  /** The ID of the object */
  id: Scalars['ID']['output'];
  lastUpdatedDate: Scalars['DateTime']['output'];
  learnerEducation: LearnerEducationType;
  organization: OrganizationType;
  pk?: Maybe<Scalars['Int']['output']>;
  schoolBehaviorProblems: Scalars['String']['output'];
};

export type LearnerEducationType = Node & {
  __typename?: 'LearnerEducationType';
  createdDate: Scalars['DateTime']['output'];
  educationSetting: Scalars['String']['output'];
  grade: Scalars['String']['output'];
  /** The ID of the object */
  id: Scalars['ID']['output'];
  lastUpdatedDate: Scalars['DateTime']['output'];
  learner: LearnerType;
  learnerEducationMetaData?: Maybe<LearnerEducationMetaDataType>;
  nameOfSchool: Scalars['String']['output'];
  organization: OrganizationType;
  pk?: Maybe<Scalars['Int']['output']>;
  specialEducation: Scalars['Boolean']['output'];
};

export type LearnerEhrProgramming = {
  __typename?: 'LearnerEhrProgramming';
  goals: Array<EhrProgrammingGoal>;
  organizationType: Scalars['String']['output'];
  /** Session data not tied to any goal or target listed in goals. */
  unmatchedSessionSummary: EhrSessionDataSummary;
};

export type LearnerEmergencyContactInput = {
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
  relationshipToClient: Scalars['String']['input'];
};

export type LearnerEmergencyContactType = Node & {
  __typename?: 'LearnerEmergencyContactType';
  createdDate: Scalars['DateTime']['output'];
  firstName: Scalars['String']['output'];
  /** The ID of the object */
  id: Scalars['ID']['output'];
  lastName: Scalars['String']['output'];
  lastUpdatedDate: Scalars['DateTime']['output'];
  learner: LearnerType;
  organization: OrganizationType;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  pk?: Maybe<Scalars['Int']['output']>;
  relationshipToClient: Scalars['String']['output'];
};

export enum LearnerFileAssessmentTemplateTypeEnums {
  CustomTemplate = 'CUSTOM_TEMPLATE',
  FronteraHealthTemplate = 'FRONTERA_HEALTH_TEMPLATE',
  OfficialScoringFile = 'OFFICIAL_SCORING_FILE'
}

export enum LearnerFileStatusEnum {
  AiGenerating = 'AI_GENERATING',
  AiGeneratingError = 'AI_GENERATING_ERROR',
  Classifying = 'CLASSIFYING',
  ClassifyingError = 'CLASSIFYING_ERROR',
  ClassifyingSuccess = 'CLASSIFYING_SUCCESS',
  Pending = 'PENDING',
  Processing = 'PROCESSING',
  ProcessError = 'PROCESS_ERROR',
  ProcessSuccess = 'PROCESS_SUCCESS',
  Uploaded = 'UPLOADED'
}

export type LearnerFileType = Node & {
  __typename?: 'LearnerFileType';
  assessmentTemplateType?: Maybe<ApiLearnerFileAssessmentTemplateTypeChoices>;
  /** Non-video file attachment (PDFs, images). For video uploads use `media`. */
  chatMessagesFile: ChatMessageTypeConnection;
  chatTasks: TaskTypeConnection;
  /** When parser-derived metadata (effective_date, respondent) was overridden out-of-band. Non-NULL means re-parse must not clobber those fields. */
  clinicianEditedAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<UserType>;
  createdDate: Scalars['DateTime']['output'];
  /** Administration date of the assessment, derived from parsed_result. Distinct from created_date (upload time). */
  effectiveDate?: Maybe<Scalars['Date']['output']>;
  fileKind: ApiLearnerFileFileKindChoices;
  fileSize: Scalars['BigInt']['output'];
  /** True if this file_kind has a registered Layer 1 Pydantic schema, enabling the review panel. */
  hasParsedResultSchema?: Maybe<Scalars['Boolean']['output']>;
  /** The ID of the object */
  id: Scalars['ID']['output'];
  lastUpdatedDate: Scalars['DateTime']['output'];
  learner: LearnerType;
  learnerfileSet?: Maybe<LearnerFileTypeConnection>;
  metadata?: Maybe<Scalars['JSONString']['output']>;
  mimeType: Scalars['String']['output'];
  organization: OrganizationType;
  originalFileName: Scalars['String']['output'];
  parentFile?: Maybe<LearnerFileType>;
  /** Stores output from the FileParsingWorkflow */
  parsedResult?: Maybe<Scalars['String']['output']>;
  /** Enriched assessment data derived from parsed_result (descriptions, cutoffs, derived scores) */
  parsedResultEnriched?: Maybe<Scalars['JSONString']['output']>;
  /** This file's own parsed result only (single _assessment_1_results), sliced out of the merged sister-file parsed_result. The review panel reads this so each file shows its own data; parsed_result stays the merged blob for report generation. */
  parsedResultScoped?: Maybe<Scalars['String']['output']>;
  /** Stores parsed table output for assessments from the FileParsingWorkflow */
  parsedTables?: Maybe<Scalars['JSONString']['output']>;
  parsedTreatmentPlanFilesData: ParsedTreatmentPlanFileDataTypeConnection;
  pdfPreviewSignedUrl?: Maybe<Scalars['String']['output']>;
  pdfPreviewStatus?: Maybe<ApiLearnerFilePdfPreviewStatusChoices>;
  pk?: Maybe<Scalars['Int']['output']>;
  /** Stable machine code for the failure reason, for clients to switch on without matching prose. */
  processingFailureCode?: Maybe<ApiLearnerFileProcessingFailureCodeChoices>;
  processingFailureReason?: Maybe<Scalars['String']['output']>;
  reports: ReportTypeConnection;
  /** Denormalized respondent (TEACHER/PARENT) from the parser's report-type field, for history queries. */
  respondent?: Maybe<ApiLearnerFileRespondentChoices>;
  s3Key: Scalars['String']['output'];
  /** The signed S3 Learner File URL to download the file, only available when the file is successfully uploaded */
  signedS3LearnerFile?: Maybe<Scalars['String']['output']>;
  /** The signed S3 URL to upload the file, only available when the file is in pending status */
  signedS3Url?: Maybe<Scalars['String']['output']>;
  status: ApiLearnerFileStatusChoices;
};


export type LearnerFileTypeChatMessagesFileArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  chat?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  role?: InputMaybe<ApiChatMessageRoleChoices>;
  sequenceNumber?: InputMaybe<Scalars['Int']['input']>;
};


export type LearnerFileTypeChatTasksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  chat?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  learner?: InputMaybe<Scalars['ID']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<ApiTaskStatusChoices>;
  type?: InputMaybe<ApiTaskTypeChoices>;
  user?: InputMaybe<Scalars['ID']['input']>;
};


export type LearnerFileTypeLearnerfileSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  learner?: InputMaybe<Scalars['ID']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type LearnerFileTypeParsedTreatmentPlanFilesDataArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  learner?: InputMaybe<Scalars['ID']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<ApiParsedTreatmentPlanFileDataStatusChoices>;
};


export type LearnerFileTypeReportsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  isArchive?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  ordering?: InputMaybe<Scalars['String']['input']>;
  reportClientDetails_ClientFirstName_Icontains?: InputMaybe<Scalars['String']['input']>;
};

export type LearnerFileTypeConnection = {
  __typename?: 'LearnerFileTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<LearnerFileTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `LearnerFileType` and its cursor. */
export type LearnerFileTypeEdge = {
  __typename?: 'LearnerFileTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<LearnerFileType>;
};

export type LearnerFilter = {
  externalIdExists?: InputMaybe<Scalars['Boolean']['input']>;
  organizationExternalId?: InputMaybe<Scalars['String']['input']>;
  organizationType?: InputMaybe<Scalars['String']['input']>;
};

export type LearnerGeneralDetailsInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  addressLine2?: InputMaybe<Scalars['String']['input']>;
  birthDate: Scalars['Date']['input'];
  city?: InputMaybe<Scalars['String']['input']>;
  firstName: Scalars['String']['input'];
  gender?: InputMaybe<Scalars['String']['input']>;
  lastName: Scalars['String']['input'];
  preferredLanguage?: InputMaybe<Scalars['String']['input']>;
  preferredName?: InputMaybe<Scalars['String']['input']>;
  specifyGender?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

export type LearnerGuardianDetailsInput = {
  guardians: Array<InputMaybe<LearnerGuardianInput>>;
};

export type LearnerGuardianInput = {
  abaClientGoalsForGuardian: Scalars['String']['input'];
  addressLine1: Scalars['String']['input'];
  addressLine2?: InputMaybe<Scalars['String']['input']>;
  birthDate: Scalars['Date']['input'];
  city: Scalars['String']['input'];
  email: Scalars['String']['input'];
  employer: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  guardianId?: InputMaybe<Scalars['ID']['input']>;
  lastName: Scalars['String']['input'];
  maritalStatus: Scalars['String']['input'];
  occupation: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
  primaryLanguage: Scalars['String']['input'];
  relationshipToClient: Scalars['String']['input'];
  requiresInterpreter: Scalars['Boolean']['input'];
  secondaryPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  sex?: InputMaybe<Scalars['String']['input']>;
  specifyGender?: InputMaybe<Scalars['String']['input']>;
  state: Scalars['String']['input'];
  zip: Scalars['String']['input'];
};

export enum LearnerImportStatusEnum {
  Failure = 'FAILURE',
  InProgress = 'IN_PROGRESS',
  Pending = 'PENDING',
  Success = 'SUCCESS'
}

export type LearnerImportStatusType = Node & {
  __typename?: 'LearnerImportStatusType';
  alert?: Maybe<Scalars['JSONString']['output']>;
  createdDate: Scalars['DateTime']['output'];
  /** The ID of the object */
  id: Scalars['ID']['output'];
  lastUpdatedDate: Scalars['DateTime']['output'];
  learner: LearnerType;
  organization: OrganizationType;
  pk?: Maybe<Scalars['Int']['output']>;
  provider: ProviderType;
  scraperSessionWorkflow: ScraperWorkflowType;
  status: ApiScraperLearnerImportStatusStatusChoices;
};

export type LearnerIndividualLivingInHouseInput = {
  age: Scalars['String']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  relationshipToClient: Scalars['String']['input'];
};

export type LearnerIndividualsThatLiveInHomeType = Node & {
  __typename?: 'LearnerIndividualsThatLiveInHomeType';
  age: Scalars['String']['output'];
  createdDate: Scalars['DateTime']['output'];
  /** The ID of the object */
  id: Scalars['ID']['output'];
  lastUpdatedDate: Scalars['DateTime']['output'];
  learner: LearnerType;
  name: Scalars['String']['output'];
  organization: OrganizationType;
  pk?: Maybe<Scalars['Int']['output']>;
  relationshipToClient: Scalars['String']['output'];
};

export type LearnerIndividualsThatLiveInHomeTypeConnection = {
  __typename?: 'LearnerIndividualsThatLiveInHomeTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<LearnerIndividualsThatLiveInHomeTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `LearnerIndividualsThatLiveInHomeType` and its cursor. */
export type LearnerIndividualsThatLiveInHomeTypeEdge = {
  __typename?: 'LearnerIndividualsThatLiveInHomeTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<LearnerIndividualsThatLiveInHomeType>;
};

export type LearnerInput = {
  assessmentAppointmentDate?: InputMaybe<Scalars['DateTime']['input']>;
  assessmentBcba?: InputMaybe<Scalars['String']['input']>;
  birthDate: Scalars['Date']['input'];
  diagnosisAppointmentDate?: InputMaybe<Scalars['DateTime']['input']>;
  diagnosisPsychologist?: InputMaybe<Scalars['String']['input']>;
  firstName: Scalars['String']['input'];
  gender?: InputMaybe<Scalars['String']['input']>;
  hasPreviousDiagnosis?: InputMaybe<Scalars['Boolean']['input']>;
  lastName: Scalars['String']['input'];
  specifyGender?: InputMaybe<Scalars['String']['input']>;
};

export type LearnerInsuranceAdminInput = {
  inNetwork: InsuranceInNetworkEnums;
  insuranceId: Scalars['ID']['input'];
  insuranceType: InsuranceTypeEnums;
  insurer: InsurerEnums;
};

export type LearnerInsuranceDetailsInput = {
  insurances: Array<InputMaybe<LearnerInsuranceInput>>;
};

export type LearnerInsuranceInput = {
  backOfCardImage?: InputMaybe<Scalars['Upload']['input']>;
  city: Scalars['String']['input'];
  claimsAddress: Scalars['String']['input'];
  claimsAddress2?: InputMaybe<Scalars['String']['input']>;
  frontOfCardImage?: InputMaybe<Scalars['Upload']['input']>;
  groupName: Scalars['String']['input'];
  idNumber: Scalars['String']['input'];
  insuranceId?: InputMaybe<Scalars['ID']['input']>;
  insurancePolicyHolder: Scalars['String']['input'];
  insuranceType: InsuranceTypeEnums;
  insurer: InsurerEnums;
  isPrimaryInsurance: Scalars['Boolean']['input'];
  phoneNumber: Scalars['String']['input'];
  policyHolderDateOfBirth: Scalars['Date']['input'];
  state: Scalars['String']['input'];
  zip: Scalars['String']['input'];
};

export type LearnerLivingConditionsInput = {
  clientHouseholdParentCount: Scalars['String']['input'];
  clientInFosterCare: Scalars['Boolean']['input'];
  clientLivesBetweenParentsAndGrandparents: Scalars['Boolean']['input'];
  clientTimeSpentWithOtherParent?: InputMaybe<Scalars['String']['input']>;
  cyfdCaseManagerName?: InputMaybe<Scalars['String']['input']>;
  cyfdCaseManagerPhone?: InputMaybe<Scalars['String']['input']>;
  delaysOrDiagnosesInClientSiblings?: InputMaybe<Scalars['String']['input']>;
  individualsLivingInHouse: Array<InputMaybe<LearnerIndividualLivingInHouseInput>>;
};

export type LearnerLivingConditionsType = Node & {
  __typename?: 'LearnerLivingConditionsType';
  clientHouseholdParentCount: ApiLearnerLivingConditionsClientHouseholdParentCountChoices;
  clientInFosterCare: Scalars['Boolean']['output'];
  clientLivesBetweenParentsAndGrandparents: Scalars['Boolean']['output'];
  clientTimeSpentWithOtherParent?: Maybe<Scalars['String']['output']>;
  createdDate: Scalars['DateTime']['output'];
  cyfdCaseManagerName?: Maybe<Scalars['String']['output']>;
  cyfdCaseManagerPhone?: Maybe<Scalars['String']['output']>;
  delaysOrDiagnosesInClientSiblings?: Maybe<Scalars['String']['output']>;
  /** The ID of the object */
  id: Scalars['ID']['output'];
  lastUpdatedDate: Scalars['DateTime']['output'];
  learner: LearnerType;
  organization: OrganizationType;
  pk?: Maybe<Scalars['Int']['output']>;
};

export type LearnerMedicalHistoryConditionsQuestionInput = {
  answer: Scalars['String']['input'];
  questionKey: MedicalHistoryConditionsQuestionType;
  questionPageOrigin: Scalars['String']['input'];
};

export type LearnerMedicalHistoryInput = {
  allergiesOrDietaryRestrictions?: InputMaybe<Scalars['String']['input']>;
  clientGiDifficulties: Scalars['Boolean']['input'];
  clientHasBeenHospitalized: Scalars['Boolean']['input'];
  clientHasBeenHospitalizedDetails?: InputMaybe<Scalars['String']['input']>;
  clientHasCurrentCounselor: Scalars['Boolean']['input'];
  clientHasCurrentCounselorClientThoughts?: InputMaybe<Scalars['String']['input']>;
  clientHasCurrentCounselorName?: InputMaybe<Scalars['String']['input']>;
  clientHasCurrentCounselorPhone?: InputMaybe<Scalars['String']['input']>;
  clientHasMedicalDiagnoses: Scalars['Boolean']['input'];
  clientHasMedicalDiagnosesDetails?: InputMaybe<Scalars['String']['input']>;
  clientOtherHealthConcerns?: InputMaybe<Scalars['String']['input']>;
  clientOverallHealth: Scalars['String']['input'];
  familyHistoryOfDiagnoses?: InputMaybe<Scalars['String']['input']>;
  hospitalizationsOrSurgeries?: InputMaybe<Scalars['String']['input']>;
  medicalConditionQuestions: Array<InputMaybe<LearnerMedicalHistoryConditionsQuestionInput>>;
  medications: Array<InputMaybe<LearnerMedicalHistoryMedicationInput>>;
  primaryCareAddress: Scalars['String']['input'];
  primaryCareAddressTwo?: InputMaybe<Scalars['String']['input']>;
  primaryCareCity: Scalars['String']['input'];
  primaryCarePhoneNumber: Scalars['String']['input'];
  primaryCareProvider: Scalars['String']['input'];
  primaryCareState: Scalars['String']['input'];
  primaryCareZip: Scalars['String']['input'];
  sideEffectsOfEmotionalBehaviourMedication?: InputMaybe<Scalars['String']['input']>;
};

export type LearnerMedicalHistoryMedicationInput = {
  dosage: Scalars['String']['input'];
  medicationId?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  prescriber: Scalars['String']['input'];
};

export type LearnerMedicalHistoryMetaDataType = Node & {
  __typename?: 'LearnerMedicalHistoryMetaDataType';
  allergiesOrDietaryRestrictions?: Maybe<Scalars['String']['output']>;
  clientCurrentCounselorName?: Maybe<Scalars['String']['output']>;
  clientCurrentCounselorPhone?: Maybe<Scalars['String']['output']>;
  clientGiDifficulties: Scalars['Boolean']['output'];
  clientHasBeenHospitalized: Scalars['Boolean']['output'];
  clientHasCurrentCounselor: Scalars['Boolean']['output'];
  clientHasMedicalDiagnoses: Scalars['Boolean']['output'];
  clientHospitalizedDetails?: Maybe<Scalars['String']['output']>;
  clientMedicalDiagnosesDetails?: Maybe<Scalars['String']['output']>;
  clientOtherHealthConcerns?: Maybe<Scalars['String']['output']>;
  clientOverallHealth?: Maybe<Scalars['String']['output']>;
  clientThoughtsForParticipatingCounseling?: Maybe<Scalars['String']['output']>;
  createdDate: Scalars['DateTime']['output'];
  familyHistoryOfDiagnoses?: Maybe<Scalars['String']['output']>;
  hospitalizationsOrSurgeries?: Maybe<Scalars['String']['output']>;
  /** The ID of the object */
  id: Scalars['ID']['output'];
  lastUpdatedDate: Scalars['DateTime']['output'];
  learner: LearnerType;
  organization: OrganizationType;
  pk?: Maybe<Scalars['Int']['output']>;
  sideEffectsOfEmotionalBehaviourMedication?: Maybe<Scalars['String']['output']>;
};

export type LearnerMedicationsType = Node & {
  __typename?: 'LearnerMedicationsType';
  createdDate: Scalars['DateTime']['output'];
  dosage: Scalars['String']['output'];
  /** The ID of the object */
  id: Scalars['ID']['output'];
  lastUpdatedDate: Scalars['DateTime']['output'];
  learner: LearnerType;
  name: Scalars['String']['output'];
  organization: OrganizationType;
  pk?: Maybe<Scalars['Int']['output']>;
  prescriber: Scalars['String']['output'];
};

export type LearnerMedicationsTypeConnection = {
  __typename?: 'LearnerMedicationsTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<LearnerMedicationsTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `LearnerMedicationsType` and its cursor. */
export type LearnerMedicationsTypeEdge = {
  __typename?: 'LearnerMedicationsTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<LearnerMedicationsType>;
};

export type LearnerMetadataType = Node & {
  __typename?: 'LearnerMetadataType';
  address?: Maybe<Scalars['String']['output']>;
  addressLine2?: Maybe<Scalars['String']['output']>;
  assessmentAppointmentDate?: Maybe<Scalars['DateTime']['output']>;
  assessmentBcba?: Maybe<Scalars['String']['output']>;
  birthDate?: Maybe<Scalars['Date']['output']>;
  birthWeightLbs?: Maybe<Scalars['Float']['output']>;
  birthWeightOz?: Maybe<Scalars['Float']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<UserType>;
  createdDate: Scalars['DateTime']['output'];
  diagnosisAppointmentDate?: Maybe<Scalars['DateTime']['output']>;
  diagnosisPsychologist?: Maybe<Scalars['String']['output']>;
  firstName: Scalars['String']['output'];
  gender?: Maybe<ApiLearnerMetadataGenderChoices>;
  hasPreviousDiagnosis: Scalars['Boolean']['output'];
  /** The ID of the object */
  id: Scalars['ID']['output'];
  lastName: Scalars['String']['output'];
  lastUpdatedDate: Scalars['DateTime']['output'];
  learner: LearnerType;
  middleName?: Maybe<Scalars['String']['output']>;
  /** Medical Record Number. */
  mrn?: Maybe<Scalars['String']['output']>;
  organization: OrganizationType;
  pk?: Maybe<Scalars['Int']['output']>;
  preferredLanguage: Scalars['String']['output'];
  preferredName?: Maybe<Scalars['String']['output']>;
  specifyGender?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  zip?: Maybe<Scalars['String']['output']>;
};

export type LearnerMetadataTypeConnection = {
  __typename?: 'LearnerMetadataTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<LearnerMetadataTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `LearnerMetadataType` and its cursor. */
export type LearnerMetadataTypeEdge = {
  __typename?: 'LearnerMetadataTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<LearnerMetadataType>;
};

export type LearnerOnboardingQuestionsType = Node & {
  __typename?: 'LearnerOnboardingQuestionsType';
  additionalAnswer?: Maybe<Scalars['String']['output']>;
  answer: Scalars['String']['output'];
  createdDate: Scalars['DateTime']['output'];
  /** The ID of the object */
  id: Scalars['ID']['output'];
  lastUpdatedDate: Scalars['DateTime']['output'];
  learner: LearnerType;
  organization: OrganizationType;
  pk?: Maybe<Scalars['Int']['output']>;
  questionKey: Scalars['String']['output'];
  questionPageOrigin: Scalars['String']['output'];
};

export type LearnerOnboardingQuestionsTypeConnection = {
  __typename?: 'LearnerOnboardingQuestionsTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<LearnerOnboardingQuestionsTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `LearnerOnboardingQuestionsType` and its cursor. */
export type LearnerOnboardingQuestionsTypeEdge = {
  __typename?: 'LearnerOnboardingQuestionsTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<LearnerOnboardingQuestionsType>;
};

export type LearnerOtherServicesHistoryType = Node & {
  __typename?: 'LearnerOtherServicesHistoryType';
  createdDate: Scalars['DateTime']['output'];
  /** The ID of the object */
  id: Scalars['ID']['output'];
  lastUpdatedDate: Scalars['DateTime']['output'];
  learner: LearnerType;
  organization: OrganizationType;
  pk?: Maybe<Scalars['Int']['output']>;
  service?: Maybe<Scalars['String']['output']>;
  serviceEndDate?: Maybe<Scalars['String']['output']>;
  serviceHours?: Maybe<Scalars['String']['output']>;
  serviceProviderName?: Maybe<Scalars['String']['output']>;
  serviceStartDate?: Maybe<Scalars['String']['output']>;
};

export type LearnerOtherServicesHistoryTypeConnection = {
  __typename?: 'LearnerOtherServicesHistoryTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<LearnerOtherServicesHistoryTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `LearnerOtherServicesHistoryType` and its cursor. */
export type LearnerOtherServicesHistoryTypeEdge = {
  __typename?: 'LearnerOtherServicesHistoryTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<LearnerOtherServicesHistoryType>;
};

export type LearnerPayorType = Node & {
  __typename?: 'LearnerPayorType';
  createdDate: Scalars['DateTime']['output'];
  externalId?: Maybe<Scalars['String']['output']>;
  /** The ID of the object */
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  lastUpdatedDate: Scalars['DateTime']['output'];
  learner: LearnerType;
  organization: OrganizationType;
  payorType: ApiLearnerPayorPayorTypeChoices;
  pk?: Maybe<Scalars['Int']['output']>;
  /** Path or key prefix where this payor expects assessment reports to be uploaded (storage is payor-specific). */
  reportUploadPrefix?: Maybe<Scalars['String']['output']>;
};

export type LearnerPayorTypeConnection = {
  __typename?: 'LearnerPayorTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<LearnerPayorTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `LearnerPayorType` and its cursor. */
export type LearnerPayorTypeEdge = {
  __typename?: 'LearnerPayorTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<LearnerPayorType>;
};

export type LearnerPrimaryProviderType = Node & {
  __typename?: 'LearnerPrimaryProviderType';
  address: Scalars['String']['output'];
  addressLine2?: Maybe<Scalars['String']['output']>;
  city: Scalars['String']['output'];
  createdDate: Scalars['DateTime']['output'];
  /** The ID of the object */
  id: Scalars['ID']['output'];
  lastUpdatedDate: Scalars['DateTime']['output'];
  learner: LearnerType;
  organization: OrganizationType;
  phoneNumber: Scalars['String']['output'];
  pk?: Maybe<Scalars['Int']['output']>;
  primaryCareProvider: Scalars['String']['output'];
  state: Scalars['String']['output'];
  zip: Scalars['String']['output'];
};

export type LearnerProviderFilter = {
  learnerIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};

export type LearnerProviderM2MFilter = {
  organizationExternalId?: InputMaybe<Scalars['String']['input']>;
  providerIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};

export type LearnerProviderType = Node & {
  __typename?: 'LearnerProviderType';
  createdDate: Scalars['DateTime']['output'];
  /** The ID of the object */
  id: Scalars['ID']['output'];
  lastUpdatedDate: Scalars['DateTime']['output'];
  learner: LearnerType;
  organization: OrganizationType;
  pk?: Maybe<Scalars['Int']['output']>;
  provider: ProviderType;
};

export type LearnerProviderTypeConnection = {
  __typename?: 'LearnerProviderTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<LearnerProviderTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `LearnerProviderType` and its cursor. */
export type LearnerProviderTypeEdge = {
  __typename?: 'LearnerProviderTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<LearnerProviderType>;
};

export type LearnerTendenciesInput = {
  tendenciesQuestions: Array<InputMaybe<LearnerTendenciesQuestionInput>>;
};

export type LearnerTendenciesQuestionInput = {
  answer: Scalars['String']['input'];
  questionKey: TendenciesQuestionType;
  questionPageOrigin: Scalars['String']['input'];
};

export type LearnerTheraputicServicesInSchoolType = Node & {
  __typename?: 'LearnerTheraputicServicesInSchoolType';
  createdDate: Scalars['DateTime']['output'];
  /** The ID of the object */
  id: Scalars['ID']['output'];
  lastUpdatedDate: Scalars['DateTime']['output'];
  learner: LearnerType;
  organization: OrganizationType;
  pk?: Maybe<Scalars['Int']['output']>;
  service?: Maybe<Scalars['String']['output']>;
  serviceHours?: Maybe<Scalars['String']['output']>;
};

export type LearnerTheraputicServicesInSchoolTypeConnection = {
  __typename?: 'LearnerTheraputicServicesInSchoolTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<LearnerTheraputicServicesInSchoolTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `LearnerTheraputicServicesInSchoolType` and its cursor. */
export type LearnerTheraputicServicesInSchoolTypeEdge = {
  __typename?: 'LearnerTheraputicServicesInSchoolTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<LearnerTheraputicServicesInSchoolType>;
};

export type LearnerType = Node & {
  __typename?: 'LearnerType';
  archived?: Maybe<Scalars['Boolean']['output']>;
  caregiverConsents: CaregiverConsentTypeConnection;
  chatMemory?: Maybe<LearnerChatMemoryType>;
  chatSuggestions: ChatSuggestionTypeConnection;
  chatTasks: TaskTypeConnection;
  chats: ChatTypeConnection;
  clinicleadSet: ClinicLeadTypeConnection;
  createdBy?: Maybe<UserType>;
  createdDate: Scalars['DateTime']['output'];
  ehrLearningTreeId?: Maybe<Scalars['String']['output']>;
  externalId?: Maybe<Scalars['String']['output']>;
  externalLastUpdate?: Maybe<Scalars['DateTime']['output']>;
  files: LearnerFileTypeConnection;
  formStatusForLearner: OnboardingFormStatusTypeConnection;
  goals: GoalTypeConnection;
  hasCaregiverConsent: Scalars['Boolean']['output'];
  hatchPlans: HatchPlanTypeConnection;
  /** The ID of the object */
  id: Scalars['ID']['output'];
  insuranceForLearner: InsuranceDetailsTypeConnection;
  lastUpdatedDate: Scalars['DateTime']['output'];
  learnerAdditionalDetails?: Maybe<LearnerAdditionalDetailsType>;
  learnerAvailability: LearnerAvailabilityTypeConnection;
  learnerEarlyInterventionServices?: Maybe<LearnerEarlyInterventionServicesType>;
  learnerEducation?: Maybe<LearnerEducationType>;
  learnerOtherServicesHistory: LearnerOtherServicesHistoryTypeConnection;
  learnerSessionTargetProgress: SessionTargetProgressTypeConnection;
  learnerTheraputicServicesInSchool: LearnerTheraputicServicesInSchoolTypeConnection;
  learnerTreatmentPlan: ReportTreatmentPlanTypeConnection;
  /** The learner the voice signature relates to */
  learnerVoiceSignature: VoiceSignatureTypeConnection;
  learnerauthorizationsSet: LearnerAuthorizationsTypeConnection;
  learnerbirthhistory?: Maybe<LearnerBirthHistoryType>;
  learnerconsentfilesSet: LearnerConsentFilesTypeConnection;
  learneremergencycontact?: Maybe<LearnerEmergencyContactType>;
  learnerindividualsthatliveinhomeSet: LearnerIndividualsThatLiveInHomeTypeConnection;
  learnerlivingconditions?: Maybe<LearnerLivingConditionsType>;
  learnermedicalhistorymetadata?: Maybe<LearnerMedicalHistoryMetaDataType>;
  learnermetadata?: Maybe<LearnerMetadataType>;
  learnerpayorSet: LearnerPayorTypeConnection;
  learnerproviderSet: LearnerProviderTypeConnection;
  manualGoalSyncLastUpdated?: Maybe<Scalars['DateTime']['output']>;
  manualGoalSyncStatus?: Maybe<ApiLearnerManualGoalSyncStatusChoices>;
  medicalHistoryForLearner?: Maybe<LearnerPrimaryProviderType>;
  medicationsForLearner: LearnerMedicationsTypeConnection;
  onboardingQuestionsForLearner: LearnerOnboardingQuestionsTypeConnection;
  /** @deprecated PROA-2446: Learner.organization FK was removed in PLA-1181; this field is a compatibility shim that delegates to learnermetadata.organization. Select learnermetadata.organization directly. Removed once all callers migrate and ≥7 days after last observed use (target: 2026-09-10). */
  organization?: Maybe<OrganizationType>;
  parsedTreatmentPlanFilesData: ParsedTreatmentPlanFileDataTypeConnection;
  pk?: Maybe<Scalars['Int']['output']>;
  relationshipSet: RelationshipTypeConnection;
  report: ReportTypeConnection;
  reportDomains: ReportDomainTypeConnection;
  reportGoals: ReportGoalTypeConnection;
  reportTargets: ReportTargetTypeConnection;
  runEngagementScorer: Scalars['Boolean']['output'];
  scraperlearnerimportstatusSet: ScraperLearnerImportStatusTypeConnection;
  sessionlearnerSet: SessionLearnerTypeConnection;
  targets: TargetTypeConnection;
};


export type LearnerTypeCaregiverConsentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type LearnerTypeChatSuggestionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type LearnerTypeChatTasksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  chat?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  learner?: InputMaybe<Scalars['ID']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<ApiTaskStatusChoices>;
  type?: InputMaybe<ApiTaskTypeChoices>;
  user?: InputMaybe<Scalars['ID']['input']>;
};


export type LearnerTypeChatsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  learner?: InputMaybe<Scalars['ID']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<ApiChatStatusChoices>;
  summaryStatus?: InputMaybe<ApiChatSummaryStatusChoices>;
  type?: InputMaybe<ApiChatTypeChoices>;
  user?: InputMaybe<Scalars['ID']['input']>;
};


export type LearnerTypeClinicleadSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  clinicListing?: InputMaybe<Scalars['ID']['input']>;
  createdDate?: InputMaybe<Scalars['DateTime']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedDate?: InputMaybe<Scalars['DateTime']['input']>;
  learner?: InputMaybe<Scalars['ID']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  payor?: InputMaybe<ApiClinicLeadPayorChoices>;
};


export type LearnerTypeFilesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  learner?: InputMaybe<Scalars['ID']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type LearnerTypeFormStatusForLearnerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdDate?: InputMaybe<Scalars['DateTime']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  formName?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedDate?: InputMaybe<Scalars['DateTime']['input']>;
  learner?: InputMaybe<Scalars['ID']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  organization?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<ApiOnboardingFormStatusStatusChoices>;
};


export type LearnerTypeGoalsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdDate?: InputMaybe<Scalars['DateTime']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  isPinned?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedDate?: InputMaybe<Scalars['DateTime']['input']>;
  learner?: InputMaybe<Scalars['ID']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  organization?: InputMaybe<Scalars['ID']['input']>;
  rankOrder?: InputMaybe<Scalars['Int']['input']>;
  targetGenerationStatus?: InputMaybe<ApiGoalTargetGenerationStatusChoices>;
};


export type LearnerTypeHatchPlansArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  caregiver?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  learner?: InputMaybe<Scalars['ID']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  organization?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<ApiHatchPlanStatusChoices>;
};


export type LearnerTypeInsuranceForLearnerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type LearnerTypeLearnerAvailabilityArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type LearnerTypeLearnerOtherServicesHistoryArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type LearnerTypeLearnerSessionTargetProgressArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  count?: InputMaybe<Scalars['Float']['input']>;
  createdDate?: InputMaybe<Scalars['DateTime']['input']>;
  date?: InputMaybe<Scalars['DateTime']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  goal?: InputMaybe<Scalars['ID']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedDate?: InputMaybe<Scalars['DateTime']['input']>;
  learner?: InputMaybe<Scalars['ID']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  organization?: InputMaybe<Scalars['ID']['input']>;
  progressType?: InputMaybe<ApiSessionTargetProgressProgressTypeChoices>;
  target?: InputMaybe<Scalars['ID']['input']>;
  therapySession?: InputMaybe<Scalars['ID']['input']>;
  total?: InputMaybe<Scalars['Float']['input']>;
};


export type LearnerTypeLearnerTheraputicServicesInSchoolArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type LearnerTypeLearnerTreatmentPlanArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type LearnerTypeLearnerVoiceSignatureArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdDate?: InputMaybe<Scalars['DateTime']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedDate?: InputMaybe<Scalars['DateTime']['input']>;
  learner?: InputMaybe<Scalars['ID']['input']>;
  learnerLevel?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  organization?: InputMaybe<Scalars['ID']['input']>;
  provider?: InputMaybe<Scalars['ID']['input']>;
  s3Path?: InputMaybe<Scalars['String']['input']>;
  totalDurationMs?: InputMaybe<Scalars['Int']['input']>;
};


export type LearnerTypeLearnerauthorizationsSetArgs = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  authorizationId?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdDate?: InputMaybe<Scalars['DateTime']['input']>;
  endDate?: InputMaybe<Scalars['Date']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedDate?: InputMaybe<Scalars['DateTime']['input']>;
  learner?: InputMaybe<Scalars['ID']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  organization?: InputMaybe<Scalars['ID']['input']>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
};


export type LearnerTypeLearnerconsentfilesSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  caregiver?: InputMaybe<Scalars['ID']['input']>;
  consentFile?: InputMaybe<Scalars['String']['input']>;
  consentType?: InputMaybe<ApiLearnerConsentFilesConsentTypeChoices>;
  createdDate?: InputMaybe<Scalars['DateTime']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedDate?: InputMaybe<Scalars['DateTime']['input']>;
  learner?: InputMaybe<Scalars['ID']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  organization?: InputMaybe<Scalars['ID']['input']>;
};


export type LearnerTypeLearnerindividualsthatliveinhomeSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type LearnerTypeLearnerpayorSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type LearnerTypeLearnerproviderSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdDate?: InputMaybe<Scalars['DateTime']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedDate?: InputMaybe<Scalars['DateTime']['input']>;
  learner?: InputMaybe<Scalars['ID']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  organization?: InputMaybe<Scalars['ID']['input']>;
  provider?: InputMaybe<Scalars['ID']['input']>;
};


export type LearnerTypeMedicationsForLearnerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type LearnerTypeOnboardingQuestionsForLearnerArgs = {
  additionalAnswer?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  answer?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdDate?: InputMaybe<Scalars['DateTime']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedDate?: InputMaybe<Scalars['DateTime']['input']>;
  learner?: InputMaybe<Scalars['ID']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  organization?: InputMaybe<Scalars['ID']['input']>;
  questionKey?: InputMaybe<Scalars['String']['input']>;
  questionPageOrigin?: InputMaybe<Scalars['String']['input']>;
};


export type LearnerTypeParsedTreatmentPlanFilesDataArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  learner?: InputMaybe<Scalars['ID']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<ApiParsedTreatmentPlanFileDataStatusChoices>;
};


export type LearnerTypeRelationshipSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type LearnerTypeReportArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  isArchive?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  ordering?: InputMaybe<Scalars['String']['input']>;
  reportClientDetails_ClientFirstName_Icontains?: InputMaybe<Scalars['String']['input']>;
};


export type LearnerTypeReportDomainsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdDate?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedDate?: InputMaybe<Scalars['DateTime']['input']>;
  learner?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  organization?: InputMaybe<Scalars['ID']['input']>;
  rankOrder?: InputMaybe<Scalars['Int']['input']>;
  reportTreatmentPlan?: InputMaybe<Scalars['ID']['input']>;
};


export type LearnerTypeReportGoalsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  aiBaselineDataPredictionStatus?: InputMaybe<ApiReportGoalAiBaselineDataPredictionStatusChoices>;
  aiGenerated?: InputMaybe<Scalars['Boolean']['input']>;
  aiGoalAttainmentScalePredictionStatus?: InputMaybe<ApiReportGoalAiGoalAttainmentScalePredictionStatusChoices>;
  aiProgressSummaryPredictionStatus?: InputMaybe<ApiReportGoalAiProgressSummaryPredictionStatusChoices>;
  assessmentToolSource?: InputMaybe<Scalars['String']['input']>;
  baselineData?: InputMaybe<Scalars['String']['input']>;
  baselineDate?: InputMaybe<Scalars['Date']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  chartFromDate?: InputMaybe<Scalars['Date']['input']>;
  chartImageUrl?: InputMaybe<Scalars['String']['input']>;
  chartToDate?: InputMaybe<Scalars['Date']['input']>;
  chartType?: InputMaybe<ApiReportGoalChartTypeChoices>;
  completionDate?: InputMaybe<Scalars['Date']['input']>;
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdDate?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  excludeFromReport?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  gasLevel1?: InputMaybe<Scalars['String']['input']>;
  gasLevel3?: InputMaybe<Scalars['String']['input']>;
  gasLevel4?: InputMaybe<Scalars['String']['input']>;
  gasMatchMessage?: InputMaybe<Scalars['String']['input']>;
  gasMatchStatus?: InputMaybe<ApiReportGoalGasMatchStatusChoices>;
  gasScore?: InputMaybe<Scalars['String']['input']>;
  generalizationCriteria?: InputMaybe<Scalars['String']['input']>;
  goal?: InputMaybe<Scalars['ID']['input']>;
  goalBank?: InputMaybe<Scalars['ID']['input']>;
  goalName?: InputMaybe<Scalars['String']['input']>;
  goalSubType?: InputMaybe<Scalars['String']['input']>;
  goalType?: InputMaybe<Scalars['String']['input']>;
  hasMedicalNecessity?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  inUse?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedDate?: InputMaybe<Scalars['DateTime']['input']>;
  learner?: InputMaybe<Scalars['ID']['input']>;
  masteryCriteria?: InputMaybe<Scalars['String']['input']>;
  medicalNecessityCriteria?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  organization?: InputMaybe<Scalars['ID']['input']>;
  predictionId?: InputMaybe<Scalars['String']['input']>;
  programGoal?: InputMaybe<Scalars['String']['input']>;
  progressSummary?: InputMaybe<Scalars['String']['input']>;
  projectedIntroductionDate?: InputMaybe<Scalars['Date']['input']>;
  rationale?: InputMaybe<Scalars['String']['input']>;
  report?: InputMaybe<Scalars['ID']['input']>;
  reportDomain?: InputMaybe<Scalars['ID']['input']>;
  reportTreatmentPlan?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<ApiReportGoalStatusChoices>;
  suggestionConfidence?: InputMaybe<Scalars['Float']['input']>;
  summaryReviewed?: InputMaybe<Scalars['Boolean']['input']>;
  summaryReviewedOn?: InputMaybe<Scalars['DateTime']['input']>;
  timelineEstimationType?: InputMaybe<ApiReportGoalTimelineEstimationTypeChoices>;
  timelineEstimationValue?: InputMaybe<Scalars['Int']['input']>;
};


export type LearnerTypeReportTargetsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  aiGenerated?: InputMaybe<Scalars['Boolean']['input']>;
  aiProgressSummaryPredictionStatus?: InputMaybe<ApiReportTargetAiProgressSummaryPredictionStatusChoices>;
  baselineData?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  chartFromDate?: InputMaybe<Scalars['Date']['input']>;
  chartImageUrl?: InputMaybe<Scalars['String']['input']>;
  chartToDate?: InputMaybe<Scalars['Date']['input']>;
  chartType?: InputMaybe<ApiReportTargetChartTypeChoices>;
  completionDate?: InputMaybe<Scalars['Date']['input']>;
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdDate?: InputMaybe<Scalars['DateTime']['input']>;
  excludeFromReport?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  inUse?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedDate?: InputMaybe<Scalars['DateTime']['input']>;
  learner?: InputMaybe<Scalars['ID']['input']>;
  masteryCriteria?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  organization?: InputMaybe<Scalars['ID']['input']>;
  predictionId?: InputMaybe<Scalars['String']['input']>;
  priorityOrder?: InputMaybe<Scalars['Int']['input']>;
  progressSummary?: InputMaybe<Scalars['String']['input']>;
  progressType?: InputMaybe<ApiReportTargetProgressTypeChoices>;
  projectedIntroductionDate?: InputMaybe<Scalars['Date']['input']>;
  report?: InputMaybe<Scalars['ID']['input']>;
  reportDomain?: InputMaybe<Scalars['ID']['input']>;
  reportGoal?: InputMaybe<Scalars['ID']['input']>;
  reportTreatmentPlan?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<ApiReportTargetStatusChoices>;
  summaryReviewed?: InputMaybe<Scalars['Boolean']['input']>;
  summaryReviewedOn?: InputMaybe<Scalars['DateTime']['input']>;
  target?: InputMaybe<Scalars['ID']['input']>;
  targetDescription?: InputMaybe<Scalars['String']['input']>;
  targetName?: InputMaybe<Scalars['String']['input']>;
  timelineEstimationType?: InputMaybe<ApiReportTargetTimelineEstimationTypeChoices>;
  timelineEstimationValue?: InputMaybe<Scalars['Int']['input']>;
};


export type LearnerTypeScraperlearnerimportstatusSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type LearnerTypeSessionlearnerSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  videoSession_SessionStatus?: InputMaybe<ApiVideoSessionSessionStatusChoices>;
};


export type LearnerTypeTargetsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdDate?: InputMaybe<Scalars['DateTime']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  goal?: InputMaybe<Scalars['ID']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedDate?: InputMaybe<Scalars['DateTime']['input']>;
  learner?: InputMaybe<Scalars['ID']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  organization?: InputMaybe<Scalars['ID']['input']>;
};

export type LearnerTypeConnection = {
  __typename?: 'LearnerTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<LearnerTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `LearnerType` and its cursor. */
export type LearnerTypeEdge = {
  __typename?: 'LearnerTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<LearnerType>;
};

export type LoadGoalBank = {
  __typename?: 'LoadGoalBank';
  message?: Maybe<Scalars['String']['output']>;
  stats?: Maybe<Scalars['JSONString']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type LoadGoalBankInput = {
  /** Optional curriculum name to associate with all created folders */
  curriculumName?: InputMaybe<Scalars['String']['input']>;
  /** Preview the generated data without saving to database */
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  /** CREATE_ONLY (default) or UPDATE */
  mode?: InputMaybe<GoalBankImportMode>;
  /** Organization ID to associate with the goal bank data */
  organizationId: Scalars['ID']['input'];
  /** S3 key of the Excel file to import */
  s3Key: Scalars['String']['input'];
  /** Sheet name or index to read from (default: 0) */
  sheet?: InputMaybe<Scalars['String']['input']>;
  /** Force goal-suggestion embeddings (use after emptyGoalBankCurriculum, which clears them) */
  triggerEmbeddings?: InputMaybe<Scalars['Boolean']['input']>;
  /** User ID for the created_by field */
  userId: Scalars['ID']['input'];
};

export type LoadRecommendationBank = {
  __typename?: 'LoadRecommendationBank';
  message?: Maybe<Scalars['String']['output']>;
  stats?: Maybe<Scalars['JSONString']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type LoadRecommendationBankInput = {
  /** Preview the generated data without saving to database */
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  /** Organization ID to associate with the recommendation bank data */
  organizationId: Scalars['ID']['input'];
  /** If true, clears existing organization-level recommendation bank data before loading. */
  reset?: InputMaybe<Scalars['Boolean']['input']>;
  /** S3 key of the Excel file to import */
  s3Key: Scalars['String']['input'];
  /** Sheet name or index to read from (default: 0) */
  sheet?: InputMaybe<Scalars['String']['input']>;
  /** User ID for the created_by field */
  userId: Scalars['ID']['input'];
};

/** Result of resolving a US postal code to location via Google Geocoding API. */
export type LocationFromZipResult = {
  __typename?: 'LocationFromZipResult';
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type LocationType = Node & {
  __typename?: 'LocationType';
  addressLine1?: Maybe<Scalars['String']['output']>;
  addressLine2?: Maybe<Scalars['String']['output']>;
  city: Scalars['String']['output'];
  clinicSet: ClinicTypeConnection;
  cliniclistingSet: ClinicListingTypeConnection;
  cliniclistingstagingSet: ClinicListingStagingTypeConnection;
  country: Scalars['String']['output'];
  createdDate: Scalars['DateTime']['output'];
  /** The ID of the object */
  id: Scalars['ID']['output'];
  lastUpdatedDate: Scalars['DateTime']['output'];
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  pk?: Maybe<Scalars['Int']['output']>;
  postalCode: Scalars['String']['output'];
  state: Scalars['String']['output'];
};


export type LocationTypeClinicSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdDate?: InputMaybe<Scalars['DateTime']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedDate?: InputMaybe<Scalars['DateTime']['input']>;
  location?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type LocationTypeCliniclistingSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdDate?: InputMaybe<Scalars['DateTime']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedDate?: InputMaybe<Scalars['DateTime']['input']>;
  location?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  verificationStatus?: InputMaybe<ApiClinicListingVerificationStatusChoices>;
};


export type LocationTypeCliniclistingstagingSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  crawlStatus?: InputMaybe<ApiClinicListingStagingCrawlStatusChoices>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  parseStatus?: InputMaybe<ApiClinicListingStagingParseStatusChoices>;
  runId?: InputMaybe<Scalars['String']['input']>;
};

/**
 * First import: lock the reviewed structure and import what's locked.
 *
 * Reruns the checks; any error rejects the lock. Waiting items are left out.
 */
export type LockCrLearningTree = {
  __typename?: 'LockCRLearningTree';
  checks?: Maybe<Array<CrLearningTreeCheckType>>;
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

export enum LoginStateEnum {
  CaptchaError = 'CAPTCHA_ERROR',
  ConnectionError = 'CONNECTION_ERROR',
  FailedCreds = 'FAILED_CREDS',
  FailedMfa = 'FAILED_MFA',
  LoggingIn = 'LOGGING_IN',
  LoginAttemptsExhausted = 'LOGIN_ATTEMPTS_EXHAUSTED',
  MfaNotSupported = 'MFA_NOT_SUPPORTED',
  MfaRequired = 'MFA_REQUIRED',
  ProxyError = 'PROXY_ERROR',
  Success = 'SUCCESS'
}

export type LongTermGoalBankInput = {
  aiSuggestedLongGoal?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  goalName: Scalars['String']['input'];
  goalType: GoalTypeEnums;
};

export type LongTermGoalBankType = Node & {
  __typename?: 'LongTermGoalBankType';
  createdBy?: Maybe<UserType>;
  createdDate: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  folder: GoalBankFolderType;
  goalName: Scalars['String']['output'];
  goalType: ApiLongTermGoalBankGoalTypeChoices;
  /** The ID of the object */
  id: Scalars['ID']['output'];
  lastUpdatedDate: Scalars['DateTime']['output'];
  organization: OrganizationType;
  pk?: Maybe<Scalars['Int']['output']>;
  reportgoalbankSet: ReportGoalBankTypeConnection;
  reporttargetgoalbankSet: ReportTargetGoalBankTypeConnection;
  updatedBy?: Maybe<UserType>;
};


export type LongTermGoalBankTypeReportgoalbankSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  assessmentToolSource?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdDate?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  domain?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  folder?: InputMaybe<Scalars['ID']['input']>;
  goalName?: InputMaybe<Scalars['String']['input']>;
  hasMedicalNecessity?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedDate?: InputMaybe<Scalars['DateTime']['input']>;
  longTermGoalBank?: InputMaybe<Scalars['ID']['input']>;
  masteryCriteria?: InputMaybe<Scalars['String']['input']>;
  medicalNecessityCriteria?: InputMaybe<Scalars['String']['input']>;
  medicalRationale?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  organization?: InputMaybe<Scalars['ID']['input']>;
  programGoal?: InputMaybe<Scalars['String']['input']>;
  timelineEstimationType?: InputMaybe<ApiReportGoalBankTimelineEstimationTypeChoices>;
  timelineEstimationValue?: InputMaybe<Scalars['Int']['input']>;
  updatedBy?: InputMaybe<Scalars['ID']['input']>;
};


export type LongTermGoalBankTypeReporttargetgoalbankSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdDate?: InputMaybe<Scalars['DateTime']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  folder?: InputMaybe<Scalars['ID']['input']>;
  goalBank?: InputMaybe<Scalars['ID']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedDate?: InputMaybe<Scalars['DateTime']['input']>;
  longTermGoalBank?: InputMaybe<Scalars['ID']['input']>;
  masteryCriteria?: InputMaybe<Scalars['String']['input']>;
  medicalRationale?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  organization?: InputMaybe<Scalars['ID']['input']>;
  targetDescription?: InputMaybe<Scalars['String']['input']>;
  targetName?: InputMaybe<Scalars['String']['input']>;
  timelineEstimationType?: InputMaybe<ApiReportTargetGoalBankTimelineEstimationTypeChoices>;
  timelineEstimationValue?: InputMaybe<Scalars['Int']['input']>;
  updatedBy?: InputMaybe<Scalars['ID']['input']>;
};

export type LongTermGoalBankTypeConnection = {
  __typename?: 'LongTermGoalBankTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<LongTermGoalBankTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `LongTermGoalBankType` and its cursor. */
export type LongTermGoalBankTypeEdge = {
  __typename?: 'LongTermGoalBankTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<LongTermGoalBankType>;
};

export enum LongTermTimelineEstimationEnums {
  Days = 'DAYS',
  Months = 'MONTHS',
  Weeks = 'WEEKS'
}

/**
 * One entry in the desired final list of domains for a report.
 *
 * Omit `id` to create a new domain. Position in the array is the
 * authoritative `rank_order`. `client_id` is an optional caller-supplied
 * string so brand-new domains can be referenced as a goal-move destination
 * in the same call (since they have no DB id yet).
 */
export type ManageReportDomainInput = {
  clientId?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
};

/**
 * Apply all domain + goal-domain edits for a report in one atomic call.
 *
 * Handles:
 * - Rename, reorder, add, and delete domains (position in `domains`
 *   becomes `rank_order`).
 * - Move goals between domains, including unassigning (no destination)
 *   and moving into a brand-new domain via `destination_client_id`.
 * - Validates that any domain marked for deletion contains zero goals
 *   AFTER the supplied moves are applied — so the client must drain a
 *   domain by moving its goals out (anywhere) before deleting it.
 *
 * Frontera-internal-only.
 */
export type ManageReportDomains = {
  __typename?: 'ManageReportDomains';
  message?: Maybe<Scalars['String']['output']>;
  reportDomains?: Maybe<Array<Maybe<ReportDomainType>>>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type ManuallyMarkMediaAsViewed = {
  __typename?: 'ManuallyMarkMediaAsViewed';
  media?: Maybe<MediaType>;
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type MarkEnteredVideoCaptureApp = {
  __typename?: 'MarkEnteredVideoCaptureApp';
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type MarkLearnerFileAsProcessError = {
  __typename?: 'MarkLearnerFileAsProcessError';
  learnerFile?: Maybe<LearnerFileType>;
};

export type MarkLearnerFileAsProcessSuccess = {
  __typename?: 'MarkLearnerFileAsProcessSuccess';
  learnerFile?: Maybe<LearnerFileType>;
};

export type MarkLearnerFileAsUploaded = {
  __typename?: 'MarkLearnerFileAsUploaded';
  learnerFile?: Maybe<LearnerFileType>;
};

/**
 * UI-accessible mutation to mark a file as uploaded.
 *
 * This is the ONLY status update mutation accessible to UI users (PROVIDER_PERMISSION_CFG).
 * It transitions status from "pending" -> "uploaded".
 *
 * All other status transitions (processing, completed, failed) are backend-only
 * and handled by UpdateProviderFileProcessStatus (TEMPORAL_PERMISSION_CFG).
 */
export type MarkProviderFileAsUploaded = {
  __typename?: 'MarkProviderFileAsUploaded';
  providerFile?: Maybe<ProviderFileType>;
};

export enum MediaAiMetricEnum {
  VideoQuality = 'VIDEO_QUALITY'
}

export enum MediaAiMetricLabelEnum {
  Artifacts = 'ARTIFACTS',
  Blur = 'BLUR',
  Brisque = 'BRISQUE',
  Overexposed = 'OVEREXPOSED',
  Underexposed = 'UNDEREXPOSED'
}

export enum MediaAiPredictionEnum {
  PersonDetector = 'PERSON_DETECTOR',
  ReId = 'RE_ID',
  VideoQualityMetrics = 'VIDEO_QUALITY_METRICS'
}

export type MediaAiPredictionInput = {
  media: Scalars['ID']['input'];
  model: Scalars['String']['input'];
  prediction: Scalars['String']['input'];
  predictionType: MediaAiPredictionEnum;
  version: Scalars['String']['input'];
};

export type MediaAiPredictionMetricType = Node & {
  __typename?: 'MediaAIPredictionMetricType';
  createdDate: Scalars['DateTime']['output'];
  endTime: Scalars['Float']['output'];
  /** The ID of the object */
  id: Scalars['ID']['output'];
  label?: Maybe<ApiMediaAiPredictionMetricLabelChoices>;
  lastUpdatedDate: Scalars['DateTime']['output'];
  media: MediaType;
  mediaAiPrediction: MediaAiPredictionType;
  metricType: ApiMediaAiPredictionMetricMetricTypeChoices;
  organization: OrganizationType;
  pk?: Maybe<Scalars['Int']['output']>;
  startTime: Scalars['Float']['output'];
};

export type MediaAiPredictionMetricTypeConnection = {
  __typename?: 'MediaAIPredictionMetricTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<MediaAiPredictionMetricTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `MediaAIPredictionMetricType` and its cursor. */
export type MediaAiPredictionMetricTypeEdge = {
  __typename?: 'MediaAIPredictionMetricTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<MediaAiPredictionMetricType>;
};

export type MediaAiPredictionMetricsInput = {
  endTime: Scalars['Float']['input'];
  label: MediaAiMetricLabelEnum;
  metricType: MediaAiMetricEnum;
  startTime: Scalars['Float']['input'];
};

export type MediaAiPredictionType = Node & {
  __typename?: 'MediaAIPredictionType';
  createdDate: Scalars['DateTime']['output'];
  /** The ID of the object */
  id: Scalars['ID']['output'];
  lastUpdatedDate: Scalars['DateTime']['output'];
  media: MediaType;
  mediaaipredictionmetricSet: MediaAiPredictionMetricTypeConnection;
  model: Scalars['String']['output'];
  organization: OrganizationType;
  pk?: Maybe<Scalars['Int']['output']>;
  prediction: Scalars['String']['output'];
  predictionType: ApiMediaAiPredictionPredictionTypeChoices;
  version: Scalars['String']['output'];
};


export type MediaAiPredictionTypeMediaaipredictionmetricSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdDate?: InputMaybe<Scalars['DateTime']['input']>;
  endTime?: InputMaybe<Scalars['Float']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  label?: InputMaybe<ApiMediaAiPredictionMetricLabelChoices>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedDate?: InputMaybe<Scalars['DateTime']['input']>;
  media?: InputMaybe<Scalars['ID']['input']>;
  mediaAiPrediction?: InputMaybe<Scalars['ID']['input']>;
  metricType?: InputMaybe<ApiMediaAiPredictionMetricMetricTypeChoices>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  organization?: InputMaybe<Scalars['ID']['input']>;
  startTime?: InputMaybe<Scalars['Float']['input']>;
};

export type MediaAiPredictionTypeConnection = {
  __typename?: 'MediaAIPredictionTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<MediaAiPredictionTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `MediaAIPredictionType` and its cursor. */
export type MediaAiPredictionTypeEdge = {
  __typename?: 'MediaAIPredictionTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<MediaAiPredictionType>;
};

export type MediaAudioType = Node & {
  __typename?: 'MediaAudioType';
  audioMedia: MediaType;
  createdDate: Scalars['DateTime']['output'];
  filePath?: Maybe<Scalars['String']['output']>;
  /** The ID of the object */
  id: Scalars['ID']['output'];
  lastUpdatedDate: Scalars['DateTime']['output'];
  organization: OrganizationType;
  pk?: Maybe<Scalars['Int']['output']>;
  videoSession?: Maybe<VideoSessionType>;
};

export type MediaAudioTypeConnection = {
  __typename?: 'MediaAudioTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<MediaAudioTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `MediaAudioType` and its cursor. */
export type MediaAudioTypeEdge = {
  __typename?: 'MediaAudioTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<MediaAudioType>;
};

export type MediaClassificationAiPredictionType = Node & {
  __typename?: 'MediaClassificationAiPredictionType';
  classType: Scalars['String']['output'];
  classificationFeedback?: Maybe<MediaClassificationFeedbackType>;
  confidenceLevel: Scalars['Float']['output'];
  createdDate: Scalars['DateTime']['output'];
  endTime: Scalars['Float']['output'];
  /** The ID of the object */
  id: Scalars['ID']['output'];
  lastUpdatedDate: Scalars['DateTime']['output'];
  media: MediaType;
  organization: OrganizationType;
  pk?: Maybe<Scalars['Int']['output']>;
  startTime: Scalars['Float']['output'];
  subclassType: Scalars['String']['output'];
  version: Scalars['String']['output'];
};

export type MediaClassificationAiPredictionTypeConnection = {
  __typename?: 'MediaClassificationAiPredictionTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<MediaClassificationAiPredictionTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `MediaClassificationAiPredictionType` and its cursor. */
export type MediaClassificationAiPredictionTypeEdge = {
  __typename?: 'MediaClassificationAiPredictionTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<MediaClassificationAiPredictionType>;
};

export type MediaClassificationFeedbackType = Node & {
  __typename?: 'MediaClassificationFeedbackType';
  createdDate: Scalars['DateTime']['output'];
  endTime: Scalars['Float']['output'];
  /** The ID of the object */
  id: Scalars['ID']['output'];
  isClassifiedCorrectly: Scalars['Boolean']['output'];
  lastUpdatedDate: Scalars['DateTime']['output'];
  media: MediaType;
  mediaclassificationaipredictionSet: MediaClassificationAiPredictionTypeConnection;
  organization: OrganizationType;
  pk?: Maybe<Scalars['Int']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
  startTime: Scalars['Float']['output'];
};


export type MediaClassificationFeedbackTypeMediaclassificationaipredictionSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  classType?: InputMaybe<Scalars['String']['input']>;
  classificationFeedback?: InputMaybe<Scalars['ID']['input']>;
  confidenceLevel?: InputMaybe<Scalars['Float']['input']>;
  createdDate?: InputMaybe<Scalars['DateTime']['input']>;
  endTime?: InputMaybe<Scalars['Float']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedDate?: InputMaybe<Scalars['DateTime']['input']>;
  media?: InputMaybe<Scalars['ID']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  organization?: InputMaybe<Scalars['ID']['input']>;
  startTime?: InputMaybe<Scalars['Float']['input']>;
  subclassType?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
};

export type MediaClassificationFeedbackTypeConnection = {
  __typename?: 'MediaClassificationFeedbackTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<MediaClassificationFeedbackTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `MediaClassificationFeedbackType` and its cursor. */
export type MediaClassificationFeedbackTypeEdge = {
  __typename?: 'MediaClassificationFeedbackTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<MediaClassificationFeedbackType>;
};

export type MediaClassificationType = {
  __typename?: 'MediaClassificationType';
  continuousInteractions?: Maybe<Array<Maybe<ContinousInteractionClassification>>>;
  nonContinuousInteractions?: Maybe<Array<Maybe<NonContinousInteractionClassification>>>;
};

export enum MediaCommentEnum {
  Feedback = 'FEEDBACK',
  Love = 'LOVE',
  Praise = 'PRAISE',
  Question = 'QUESTION'
}

export enum MediaCommentFilterEnum {
  BcbaQuestions = 'BCBA_QUESTIONS',
  Feedback = 'FEEDBACK',
  Love = 'LOVE',
  Praise = 'PRAISE',
  RbtQuestions = 'RBT_QUESTIONS',
  YourQuestions = 'YOUR_QUESTIONS'
}

export type MediaCommentInput = {
  commentType: MediaCommentEnum;
  content: Scalars['String']['input'];
  mediaId: Scalars['ID']['input'];
  mediaStartTime: Scalars['Float']['input'];
  parentCommentId?: InputMaybe<Scalars['ID']['input']>;
};

export type MediaCommentsType = Node & {
  __typename?: 'MediaCommentsType';
  author?: Maybe<UserType>;
  commentReplies?: Maybe<MediaCommentsTypeConnection>;
  commentType: ApiMediaCommentsCommentTypeChoices;
  content: Scalars['String']['output'];
  createdDate: Scalars['DateTime']['output'];
  /** Source MediaComment for chat-sourced video comment echoes. Set only when role is COMMENT. */
  echoChatMessage?: Maybe<ChatMessageType>;
  hasReplies?: Maybe<Scalars['Boolean']['output']>;
  /** The ID of the object */
  id: Scalars['ID']['output'];
  lastUpdatedDate: Scalars['DateTime']['output'];
  media: MediaType;
  mediaStartTime: Scalars['Float']['output'];
  organization: OrganizationType;
  parentComment?: Maybe<MediaCommentsType>;
  pk?: Maybe<Scalars['Int']['output']>;
};


export type MediaCommentsTypeCommentRepliesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  author?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  commentType?: InputMaybe<ApiMediaCommentsCommentTypeChoices>;
  content?: InputMaybe<Scalars['String']['input']>;
  createdDate?: InputMaybe<Scalars['DateTime']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedDate?: InputMaybe<Scalars['DateTime']['input']>;
  media?: InputMaybe<Scalars['ID']['input']>;
  mediaStartTime?: InputMaybe<Scalars['Float']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  organization?: InputMaybe<Scalars['ID']['input']>;
  parentComment?: InputMaybe<Scalars['ID']['input']>;
};

export type MediaCommentsTypeConnection = {
  __typename?: 'MediaCommentsTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<MediaCommentsTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `MediaCommentsType` and its cursor. */
export type MediaCommentsTypeEdge = {
  __typename?: 'MediaCommentsTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<MediaCommentsType>;
};

export type MediaDeviceType = Node & {
  __typename?: 'MediaDeviceType';
  active: ApiMediaDeviceActiveChoices;
  availabilityStatus: ApiMediaDeviceAvailabilityStatusChoices;
  createdBy?: Maybe<UserType>;
  createdDate: Scalars['DateTime']['output'];
  deviceName?: Maybe<Scalars['String']['output']>;
  /** The ID of the object */
  id: Scalars['ID']['output'];
  lastUpdatedDate: Scalars['DateTime']['output'];
  mediametadataSet: MediaMetadataTypeConnection;
  organization: OrganizationType;
  pk?: Maybe<Scalars['Int']['output']>;
};


export type MediaDeviceTypeMediametadataSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type MediaDeviceTypeConnection = {
  __typename?: 'MediaDeviceTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<MediaDeviceTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `MediaDeviceType` and its cursor. */
export type MediaDeviceTypeEdge = {
  __typename?: 'MediaDeviceTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<MediaDeviceType>;
};

export type MediaGoalMomentsFilter = {
  goalStatus?: InputMaybe<Scalars['String']['input']>;
  mediaId: Scalars['ID']['input'];
  /** when true, returns only STGs with moments. */
  onlyMoments?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MediaMetadataType = Node & {
  __typename?: 'MediaMetadataType';
  createdBy?: Maybe<UserType>;
  createdDate: Scalars['DateTime']['output'];
  device: MediaDeviceType;
  /** The ID of the object */
  id: Scalars['ID']['output'];
  lastUpdatedDate: Scalars['DateTime']['output'];
  location: Scalars['String']['output'];
  media: MediaType;
  organization: OrganizationType;
  pk?: Maybe<Scalars['Int']['output']>;
};

export type MediaMetadataTypeConnection = {
  __typename?: 'MediaMetadataTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<MediaMetadataTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `MediaMetadataType` and its cursor. */
export type MediaMetadataTypeEdge = {
  __typename?: 'MediaMetadataTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<MediaMetadataType>;
};

export type MediaModelConfigType = Node & {
  __typename?: 'MediaModelConfigType';
  createdAt: Scalars['DateTime']['output'];
  enabled: Scalars['Boolean']['output'];
  /** The ID of the object */
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  model: ApiMediaModelConfigModelChoices;
  organization: OrganizationType;
  pk?: Maybe<Scalars['Int']['output']>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  publishedBy?: Maybe<UserType>;
  version?: Maybe<Scalars['String']['output']>;
};

export type MediaModelConfigTypeConnection = {
  __typename?: 'MediaModelConfigTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<MediaModelConfigTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `MediaModelConfigType` and its cursor. */
export type MediaModelConfigTypeEdge = {
  __typename?: 'MediaModelConfigTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<MediaModelConfigType>;
};

export enum MediaSortByEnum {
  AscSessionDate = 'ASC_SESSION_DATE',
  AscSessionRating = 'ASC_SESSION_RATING',
  AscSessionUploadDate = 'ASC_SESSION_UPLOAD_DATE',
  DescSessionDate = 'DESC_SESSION_DATE',
  DescSessionRating = 'DESC_SESSION_RATING',
  DescSessionUploadDate = 'DESC_SESSION_UPLOAD_DATE'
}

export enum MediaSourceEnum {
  AnnotationTool = 'ANNOTATION_TOOL',
  ExpertChatUpload = 'EXPERT_CHAT_UPLOAD',
  GcpBucket = 'GCP_BUCKET',
  GoogleCloudRecording = 'GOOGLE_CLOUD_RECORDING',
  GoogleDrive = 'GOOGLE_DRIVE',
  InClinicVideoCapture = 'IN_CLINIC_VIDEO_CAPTURE',
  OldAnnotationTool = 'OLD_ANNOTATION_TOOL',
  Other = 'OTHER',
  Swivl = 'SWIVL',
  VideoCaptureApp = 'VIDEO_CAPTURE_APP',
  ZoomCloudRecording = 'ZOOM_CLOUD_RECORDING'
}

export enum MediaStatusEnumType {
  Active = 'ACTIVE',
  Archived = 'ARCHIVED',
  Done = 'DONE'
}

export type MediaStreamType = Node & {
  __typename?: 'MediaStreamType';
  createdDate: Scalars['DateTime']['output'];
  dashUrl?: Maybe<Scalars['String']['output']>;
  endTime?: Maybe<Scalars['DateTime']['output']>;
  /** The ID of the object */
  id: Scalars['ID']['output'];
  lastUpdatedDate: Scalars['DateTime']['output'];
  media: MediaType;
  organization: OrganizationType;
  pk?: Maybe<Scalars['Int']['output']>;
  startTime?: Maybe<Scalars['DateTime']['output']>;
  transcript?: Maybe<TranscriptType>;
  videoSession?: Maybe<VideoSessionType>;
};

export type MediaTargetPredictionFeedbackInput = {
  improvementComment?: InputMaybe<Scalars['String']['input']>;
  isAccurate: Scalars['Boolean']['input'];
  mediaTargetPredictionId: Scalars['ID']['input'];
  reasonOfRating?: InputMaybe<Scalars['String']['input']>;
};

export type MediaTargetPredictionFeedbackType = Node & {
  __typename?: 'MediaTargetPredictionFeedbackType';
  createdDate: Scalars['DateTime']['output'];
  /** The ID of the object */
  id: Scalars['ID']['output'];
  /** Optional suggestions for improvement */
  improvementComment?: Maybe<Scalars['String']['output']>;
  /** Whether the prediction was good or bad */
  isAccurate: Scalars['Boolean']['output'];
  lastUpdatedDate: Scalars['DateTime']['output'];
  mediaTargetPrediction: MediaTargetPredictionType;
  organization: OrganizationType;
  pk?: Maybe<Scalars['Int']['output']>;
  /** Short reason for rating */
  reasonOfRating?: Maybe<Scalars['String']['output']>;
  user: UserType;
};

export type MediaTargetPredictionFeedbackTypeConnection = {
  __typename?: 'MediaTargetPredictionFeedbackTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<MediaTargetPredictionFeedbackTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `MediaTargetPredictionFeedbackType` and its cursor. */
export type MediaTargetPredictionFeedbackTypeEdge = {
  __typename?: 'MediaTargetPredictionFeedbackTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<MediaTargetPredictionFeedbackType>;
};

export type MediaTargetPredictionFilter = {
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  goalIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  location?: InputMaybe<Scalars['String']['input']>;
  mediaId?: InputMaybe<Scalars['ID']['input']>;
  sortBy?: InputMaybe<SortBy>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  targetId?: InputMaybe<Scalars['ID']['input']>;
  targetStatus?: InputMaybe<GoalStatusEnums>;
  videoSessionId?: InputMaybe<Scalars['ID']['input']>;
};

export type MediaTargetPredictionType = Node & {
  __typename?: 'MediaTargetPredictionType';
  createdDate: Scalars['DateTime']['output'];
  /** End time (in seconds) */
  endTime: Scalars['Float']['output'];
  goal?: Maybe<GoalType>;
  /** The ID of the object */
  id: Scalars['ID']['output'];
  lastUpdatedDate: Scalars['DateTime']['output'];
  media: MediaType;
  mediaTargetFeedbacks: MediaTargetPredictionFeedbackTypeConnection;
  modalityType: ApiMediaTargetPredictionModalityTypeChoices;
  organization: OrganizationType;
  pk?: Maybe<Scalars['Int']['output']>;
  predictionId?: Maybe<Scalars['String']['output']>;
  rationale?: Maybe<Scalars['String']['output']>;
  reportGoalOld?: Maybe<ReportGoalType>;
  reportTargetOld?: Maybe<ReportTargetType>;
  /** Start time (in seconds) */
  startTime: Scalars['Float']['output'];
  target?: Maybe<TargetType>;
  thumbnailUrl?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['String']['output']>;
};


export type MediaTargetPredictionTypeMediaTargetFeedbacksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdDate?: InputMaybe<Scalars['DateTime']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  improvementComment?: InputMaybe<Scalars['String']['input']>;
  isAccurate?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedDate?: InputMaybe<Scalars['DateTime']['input']>;
  mediaTargetPrediction?: InputMaybe<Scalars['ID']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  organization?: InputMaybe<Scalars['ID']['input']>;
  reasonOfRating?: InputMaybe<Scalars['String']['input']>;
  user?: InputMaybe<Scalars['ID']['input']>;
};

export type MediaTargetPredictionTypeConnection = {
  __typename?: 'MediaTargetPredictionTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<MediaTargetPredictionTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `MediaTargetPredictionType` and its cursor. */
export type MediaTargetPredictionTypeEdge = {
  __typename?: 'MediaTargetPredictionTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<MediaTargetPredictionType>;
};

export type MediaTargetPredictionsInput = {
  mediaId: Scalars['ID']['input'];
  mediaTargetPredictions: Array<InputMaybe<TargetPredictionsInput>>;
  predictionId: Scalars['String']['input'];
  version?: InputMaybe<Scalars['String']['input']>;
};

export type MediaTranscriptType = {
  __typename?: 'MediaTranscriptType';
  media?: Maybe<MediaType>;
  transcript?: Maybe<Scalars['JSONString']['output']>;
  transcriptFile?: Maybe<TranscriptType>;
};

export type MediaType = Node & {
  __typename?: 'MediaType';
  annotationSet: AnnotationTypeConnection;
  audioMedia: MediaAudioTypeConnection;
  blobId: Scalars['UUID']['output'];
  /** Chat-sourced video attachment (via initiateChatVideoUpload). Surfaces in the video library; carries duration/thumbnail metadata. */
  chatMessages: ChatMessageTypeConnection;
  chatTasks: TaskTypeConnection;
  clipSet: ClipTypeConnection;
  clipsCount?: Maybe<Scalars['Int']['output']>;
  commentsCount?: Maybe<Scalars['JSONString']['output']>;
  createdBy?: Maybe<UserType>;
  createdDate: Scalars['DateTime']['output'];
  endDatetime?: Maybe<Scalars['DateTime']['output']>;
  fileName?: Maybe<Scalars['String']['output']>;
  filePath?: Maybe<Scalars['String']['output']>;
  fileSize?: Maybe<Scalars['Int']['output']>;
  /** The ID of the object */
  id: Scalars['ID']['output'];
  isViewed: Scalars['Boolean']['output'];
  lastUpdatedDate: Scalars['DateTime']['output'];
  /** The signed S3 URL as a downloadable attachment */
  mediaAttachmentUrl?: Maybe<Scalars['String']['output']>;
  mediaClassifications?: Maybe<MediaClassificationType>;
  mediaComments: MediaCommentsTypeConnection;
  mediaLanguage?: Maybe<ApiMediaMediaLanguageChoices>;
  mediaMetadata?: Maybe<MediaMetadataType>;
  mediaSource?: Maybe<ApiMediaMediaSourceChoices>;
  mediaStatus: ApiMediaMediaStatusChoices;
  mediaType: ApiMediaMediaTypeChoices;
  mediaaipredictionSet: MediaAiPredictionTypeConnection;
  mediaaipredictionmetricSet: MediaAiPredictionMetricTypeConnection;
  mediaclassificationaipredictionSet: MediaClassificationAiPredictionTypeConnection;
  mediaclassificationfeedbackSet: MediaClassificationFeedbackTypeConnection;
  mediatargetpredictionSet: MediaTargetPredictionTypeConnection;
  multiplePeopleIncludingChildDuration?: Maybe<Scalars['Float']['output']>;
  organization: OrganizationType;
  pk?: Maybe<Scalars['Int']['output']>;
  recordingId?: Maybe<Scalars['String']['output']>;
  sessionFinalMedia?: Maybe<VideoSessionType>;
  sessionmediareviewactivitylogSet: SessionMediaReviewActivityLogTypeConnection;
  signedUploadUrl?: Maybe<Scalars['String']['output']>;
  startDatetime?: Maybe<Scalars['DateTime']['output']>;
  streamMedia?: Maybe<MediaStreamType>;
  thumbnailManifest?: Maybe<ThumbnailManifestType>;
  thumbnailManifestPath?: Maybe<Scalars['String']['output']>;
  thumbnailUrl?: Maybe<Scalars['String']['output']>;
  totalDuration?: Maybe<Scalars['Float']['output']>;
  transcriptMedia: TranscriptLineRecordTypeConnection;
  transcriptSet: TranscriptTypeConnection;
  videoSession?: Maybe<VideoSessionType>;
  videoUploadStatus?: Maybe<ApiMediaVideoUploadStatusChoices>;
  viewedAt?: Maybe<Scalars['DateTime']['output']>;
  viewedBy?: Maybe<UserType>;
};


export type MediaTypeAnnotationSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type MediaTypeAudioMediaArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type MediaTypeChatMessagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  chat?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  role?: InputMaybe<ApiChatMessageRoleChoices>;
  sequenceNumber?: InputMaybe<Scalars['Int']['input']>;
};


export type MediaTypeChatTasksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  chat?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  learner?: InputMaybe<Scalars['ID']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<ApiTaskStatusChoices>;
  type?: InputMaybe<ApiTaskTypeChoices>;
  user?: InputMaybe<Scalars['ID']['input']>;
};


export type MediaTypeClipSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdDate?: InputMaybe<Scalars['DateTime']['input']>;
  endTime?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedDate?: InputMaybe<Scalars['DateTime']['input']>;
  media?: InputMaybe<Scalars['ID']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  organization?: InputMaybe<Scalars['ID']['input']>;
  startTime?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};


export type MediaTypeMediaCommentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  author?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  commentType?: InputMaybe<ApiMediaCommentsCommentTypeChoices>;
  content?: InputMaybe<Scalars['String']['input']>;
  createdDate?: InputMaybe<Scalars['DateTime']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedDate?: InputMaybe<Scalars['DateTime']['input']>;
  media?: InputMaybe<Scalars['ID']['input']>;
  mediaStartTime?: InputMaybe<Scalars['Float']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  organization?: InputMaybe<Scalars['ID']['input']>;
  parentComment?: InputMaybe<Scalars['ID']['input']>;
};


export type MediaTypeMediaaipredictionSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdDate?: InputMaybe<Scalars['DateTime']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedDate?: InputMaybe<Scalars['DateTime']['input']>;
  media?: InputMaybe<Scalars['ID']['input']>;
  model?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  organization?: InputMaybe<Scalars['ID']['input']>;
  prediction?: InputMaybe<Scalars['String']['input']>;
  predictionType?: InputMaybe<ApiMediaAiPredictionPredictionTypeChoices>;
  version?: InputMaybe<Scalars['String']['input']>;
};


export type MediaTypeMediaaipredictionmetricSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdDate?: InputMaybe<Scalars['DateTime']['input']>;
  endTime?: InputMaybe<Scalars['Float']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  label?: InputMaybe<ApiMediaAiPredictionMetricLabelChoices>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedDate?: InputMaybe<Scalars['DateTime']['input']>;
  media?: InputMaybe<Scalars['ID']['input']>;
  mediaAiPrediction?: InputMaybe<Scalars['ID']['input']>;
  metricType?: InputMaybe<ApiMediaAiPredictionMetricMetricTypeChoices>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  organization?: InputMaybe<Scalars['ID']['input']>;
  startTime?: InputMaybe<Scalars['Float']['input']>;
};


export type MediaTypeMediaclassificationaipredictionSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  classType?: InputMaybe<Scalars['String']['input']>;
  classificationFeedback?: InputMaybe<Scalars['ID']['input']>;
  confidenceLevel?: InputMaybe<Scalars['Float']['input']>;
  createdDate?: InputMaybe<Scalars['DateTime']['input']>;
  endTime?: InputMaybe<Scalars['Float']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedDate?: InputMaybe<Scalars['DateTime']['input']>;
  media?: InputMaybe<Scalars['ID']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  organization?: InputMaybe<Scalars['ID']['input']>;
  startTime?: InputMaybe<Scalars['Float']['input']>;
  subclassType?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
};


export type MediaTypeMediaclassificationfeedbackSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdDate?: InputMaybe<Scalars['DateTime']['input']>;
  endTime?: InputMaybe<Scalars['Float']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  isClassifiedCorrectly?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedDate?: InputMaybe<Scalars['DateTime']['input']>;
  media?: InputMaybe<Scalars['ID']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  organization?: InputMaybe<Scalars['ID']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
  startTime?: InputMaybe<Scalars['Float']['input']>;
};


export type MediaTypeMediatargetpredictionSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdDate?: InputMaybe<Scalars['DateTime']['input']>;
  endTime?: InputMaybe<Scalars['Float']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  goal?: InputMaybe<Scalars['ID']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedDate?: InputMaybe<Scalars['DateTime']['input']>;
  media?: InputMaybe<Scalars['ID']['input']>;
  modalityType?: InputMaybe<ApiMediaTargetPredictionModalityTypeChoices>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  organization?: InputMaybe<Scalars['ID']['input']>;
  predictionId?: InputMaybe<Scalars['String']['input']>;
  rationale?: InputMaybe<Scalars['String']['input']>;
  reportGoalOld?: InputMaybe<Scalars['ID']['input']>;
  reportTargetOld?: InputMaybe<Scalars['ID']['input']>;
  startTime?: InputMaybe<Scalars['Float']['input']>;
  target?: InputMaybe<Scalars['ID']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
};


export type MediaTypeSessionmediareviewactivitylogSetArgs = {
  activityType?: InputMaybe<ApiSessionMediaReviewActivityLogActivityTypeChoices>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdDate?: InputMaybe<Scalars['DateTime']['input']>;
  durationSeconds?: InputMaybe<Scalars['Int']['input']>;
  endTime?: InputMaybe<Scalars['Float']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedDate?: InputMaybe<Scalars['DateTime']['input']>;
  media?: InputMaybe<Scalars['ID']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  organization?: InputMaybe<Scalars['ID']['input']>;
  startTime?: InputMaybe<Scalars['Float']['input']>;
  user?: InputMaybe<Scalars['ID']['input']>;
};


export type MediaTypeTranscriptMediaArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  speaker?: InputMaybe<Scalars['String']['input']>;
};


export type MediaTypeTranscriptSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  aiModelVersion?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdDate?: InputMaybe<Scalars['DateTime']['input']>;
  filePath?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedDate?: InputMaybe<Scalars['DateTime']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  organization?: InputMaybe<Scalars['ID']['input']>;
  transcriptMedia?: InputMaybe<Scalars['ID']['input']>;
  transcriptModel?: InputMaybe<ApiTranscriptTranscriptModelChoices>;
  transcriptType?: InputMaybe<ApiTranscriptTranscriptTypeChoices>;
  videoSession?: InputMaybe<Scalars['ID']['input']>;
};

export type MediaTypeConnection = {
  __typename?: 'MediaTypeConnection';
  activeCount?: Maybe<Scalars['Int']['output']>;
  archivedCount?: Maybe<Scalars['Int']['output']>;
  doneCount?: Maybe<Scalars['Int']['output']>;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<MediaTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `MediaType` and its cursor. */
export type MediaTypeEdge = {
  __typename?: 'MediaTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<MediaType>;
};

export enum MedicalHistoryConditionsQuestionType {
  Allergies = 'ALLERGIES',
  Anemia = 'ANEMIA',
  Asphyxia = 'ASPHYXIA',
  Asthma = 'ASTHMA',
  BladderControl = 'BLADDER_CONTROL',
  BleedingProblems = 'BLEEDING_PROBLEMS',
  BoneOrJointDisease = 'BONE_OR_JOINT_DISEASE',
  Cancer = 'CANCER',
  ChargeSyndrome = 'CHARGE_SYNDROME',
  Convulsions = 'CONVULSIONS',
  Diabetes = 'DIABETES',
  Dizziness = 'DIZZINESS',
  DownsSyndrome = 'DOWNS_SYNDROME',
  EarInfections = 'EAR_INFECTIONS',
  EatingProblems = 'EATING_PROBLEMS',
  Encephalitis = 'ENCEPHALITIS',
  ExtremeTiredness = 'EXTREME_TIREDNESS',
  EyeProblems = 'EYE_PROBLEMS',
  FaintingSpells = 'FAINTING_SPELLS',
  FetalAlcoholSyndrome = 'FETAL_ALCOHOL_SYNDROME',
  FrequentOrSevereHeadaches = 'FREQUENT_OR_SEVERE_HEADACHES',
  HeadInjury = 'HEAD_INJURY',
  HeartDiseaseOrCondition = 'HEART_DISEASE_OR_CONDITION',
  Herpes = 'HERPES',
  HighBloodPressure = 'HIGH_BLOOD_PRESSURE',
  HighFever = 'HIGH_FEVER',
  Hydrocephalus = 'HYDROCEPHALUS',
  LossOfConsciousness = 'LOSS_OF_CONSCIOUSNESS',
  MaternalDrugUse = 'MATERNAL_DRUG_USE',
  MemoryProblems = 'MEMORY_PROBLEMS',
  Meningitis = 'MENINGITIS',
  Microcephaly = 'MICROCEPHALY',
  OtherMultipleAnomaly = 'OTHER_MULTIPLE_ANOMALY',
  OtherPostnatal = 'OTHER_POSTNATAL',
  OtherPrenatalConditions = 'OTHER_PRENATAL_CONDITIONS',
  OtherSyndrome = 'OTHER_SYNDROME',
  Paralysis = 'PARALYSIS',
  PoorCoordination = 'POOR_COORDINATION',
  RheumaticFever = 'RHEUMATIC_FEVER',
  Rubella = 'RUBELLA',
  ScarletFever = 'SCARLET_FEVER',
  Seizures = 'SEIZURES',
  SleepingProblems = 'SLEEPING_PROBLEMS',
  Stroke = 'STROKE',
  Syphilis = 'SYPHILIS',
  Toxoplasmosis = 'TOXOPLASMOSIS',
  Trisomy_13 = 'TRISOMY_13',
  Tuberculosis = 'TUBERCULOSIS',
  TubesInEars = 'TUBES_IN_EARS',
  Ushers = 'USHERS'
}

/** The cross-tenant `Principal × Tenant` link (see `Membership` model). */
export type MembershipType = Node & {
  __typename?: 'MembershipType';
  /** False once the principal is disconnected from the tenant. The row is kept (soft delete) for audit rather than being deleted. */
  active: Scalars['Boolean']['output'];
  createdDate: Scalars['DateTime']['output'];
  /** The ID of the object */
  id: Scalars['ID']['output'];
  lastUpdatedDate: Scalars['DateTime']['output'];
  pk?: Maybe<Scalars['Int']['output']>;
  /** The identity (Principal) that belongs to the tenant. */
  principal: UserType;
  /** The Organization (Tenant) the principal is a member of. */
  tenant: OrganizationType;
};

export type MembershipTypeConnection = {
  __typename?: 'MembershipTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<MembershipTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `MembershipType` and its cursor. */
export type MembershipTypeEdge = {
  __typename?: 'MembershipTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<MembershipType>;
};

/**
 * Consolidate a duplicated organization by migrating data from an old organization into a new one.
 *
 * This mutation transfers all learners, metadata, and report-related records from the `old_organization`
 * into the `new_organization`, effectively replacing the old one.
 *
 * If any learners exist in both organizations, the optional `learner_connections` list maps old learner IDs
 * to new ones to ensure external identifiers are preserved and data remains consistent.
 *
 * After migration:
 * - All relevant data is moved into `new_organization`
 * - `old_organization` is deleted
 * - Learner links and metadata are updated accordingly
 */
export type MigrateDuplicatedOrganization = {
  __typename?: 'MigrateDuplicatedOrganization';
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

export enum ModalityType {
  InClinic = 'IN_CLINIC',
  InHome = 'IN_HOME',
  InSchool = 'IN_SCHOOL',
  Telehealth = 'TELEHEALTH'
}

export type MotivityGoalFilter = {
  /** Filter by latest MotivityGoalPhase status (case-insensitive partial match) */
  goalStatus?: InputMaybe<Scalars['String']['input']>;
};

export type MotivityGoalType = Node & {
  __typename?: 'MotivityGoalType';
  aiGenerated: Scalars['Boolean']['output'];
  createdDate: Scalars['DateTime']['output'];
  externalId?: Maybe<Scalars['String']['output']>;
  goal: GoalType;
  goalType?: Maybe<ApiMotivityGoalGoalTypeChoices>;
  /** The ID of the object */
  id: Scalars['ID']['output'];
  inUse: Scalars['Boolean']['output'];
  lastUpdatedDate: Scalars['DateTime']['output'];
  masteryCriteria?: Maybe<Scalars['String']['output']>;
  motivityTargets: MotivityTargetTypeConnection;
  name: Scalars['String']['output'];
  organization: OrganizationType;
  pk?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};


export type MotivityGoalTypeMotivityTargetsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  aiGenerated?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdDate?: InputMaybe<Scalars['DateTime']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  inUse?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedDate?: InputMaybe<Scalars['DateTime']['input']>;
  masteryCriteria?: InputMaybe<Scalars['String']['input']>;
  motivityGoal?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  organization?: InputMaybe<Scalars['ID']['input']>;
  progressType?: InputMaybe<ApiMotivityTargetProgressTypeChoices>;
  status?: InputMaybe<Scalars['String']['input']>;
  target?: InputMaybe<Scalars['ID']['input']>;
};

export type MotivityGoalTypeConnection = {
  __typename?: 'MotivityGoalTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<MotivityGoalTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `MotivityGoalType` and its cursor. */
export type MotivityGoalTypeEdge = {
  __typename?: 'MotivityGoalTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<MotivityGoalType>;
};

export type MotivityTargetType = Node & {
  __typename?: 'MotivityTargetType';
  aiGenerated: Scalars['Boolean']['output'];
  createdDate: Scalars['DateTime']['output'];
  externalId?: Maybe<Scalars['String']['output']>;
  /** The ID of the object */
  id: Scalars['ID']['output'];
  inUse: Scalars['Boolean']['output'];
  lastUpdatedDate: Scalars['DateTime']['output'];
  masteryCriteria?: Maybe<Scalars['String']['output']>;
  motivityGoal: MotivityGoalType;
  name: Scalars['String']['output'];
  organization: OrganizationType;
  pk?: Maybe<Scalars['Int']['output']>;
  progressType?: Maybe<ApiMotivityTargetProgressTypeChoices>;
  status?: Maybe<Scalars['String']['output']>;
  target: TargetType;
};

export type MotivityTargetTypeConnection = {
  __typename?: 'MotivityTargetTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<MotivityTargetTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `MotivityTargetType` and its cursor. */
export type MotivityTargetTypeEdge = {
  __typename?: 'MotivityTargetTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<MotivityTargetType>;
};

export type MoveGoalBankGoal = {
  __typename?: 'MoveGoalBankGoal';
  goalBankShortGoalData?: Maybe<ReportGoalBankType>;
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type MoveGoalBankGoalInput = {
  currentFolderId: Scalars['ID']['input'];
  goalBankShortTermId: Scalars['ID']['input'];
  newFolderId: Scalars['ID']['input'];
};

export type MoveGoalBankLongTermGoal = {
  __typename?: 'MoveGoalBankLongTermGoal';
  goalBankLongGoalData?: Maybe<LongTermGoalBankType>;
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type MoveGoalBankLongTermGoalInput = {
  currentFolderId: Scalars['ID']['input'];
  goalBankLongTermId: Scalars['ID']['input'];
  newFolderId: Scalars['ID']['input'];
};

export type MoveGoalBankTarget = {
  __typename?: 'MoveGoalBankTarget';
  goalBankTargetData?: Maybe<ReportTargetGoalBankType>;
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type MoveGoalBankTargetInput = {
  currentFolderId: Scalars['ID']['input'];
  goalBankShortTermId: Scalars['ID']['input'];
  goalBankTargetId: Scalars['ID']['input'];
  newFolderId: Scalars['ID']['input'];
};

export type MoveRecommendationBankItem = {
  __typename?: 'MoveRecommendationBankItem';
  message?: Maybe<Scalars['String']['output']>;
  recommendationBankItemData?: Maybe<RecommendationBankItemType>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type MoveRecommendationBankItemInput = {
  currentFolderId: Scalars['ID']['input'];
  newFolderId: Scalars['ID']['input'];
  recommendationBankItemId: Scalars['ID']['input'];
};

export type MoveReportSection = {
  __typename?: 'MoveReportSection';
  message?: Maybe<Scalars['String']['output']>;
  reportSection?: Maybe<ReportSectionsType>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type MoveReportSectionFieldToAnotherSection = {
  __typename?: 'MoveReportSectionFieldToAnotherSection';
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type MoveReportSectionFieldUpAndDown = {
  __typename?: 'MoveReportSectionFieldUpAndDown';
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type MoveReportSectionInput = {
  action: MoveSectionActionEnum;
  reportSectionId: Scalars['ID']['input'];
};

export type MoveReportSectionUpAndDown = {
  __typename?: 'MoveReportSectionUpAndDown';
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

export enum MoveSectionActionEnum {
  MoveBack = 'MOVE_BACK',
  MoveToAppendix = 'MOVE_TO_APPENDIX'
}

export type Mutation = {
  __typename?: 'Mutation';
  /**
   * Redeem a one-time activation code to join the caregiver to a clinic tenant.
   *
   * Called when a caregiver submits the code + their child's date of birth and
   * last name in-app. Verifies the DOB and last name against the clinic record,
   * then creates/reactivates the `Membership` linking the caller (`Principal`)
   * to the code's `Organization` (`Tenant`) and spends the code. Returns the
   * verified child's first name so the app can show a personalized success
   * screen.
   */
  activateCaregiverToOrganization?: Maybe<ActivateCaregiverToOrganization>;
  addAiReportSectionFields?: Maybe<AddAiReportSectionFields>;
  addClipAnnotationDataByM2m?: Maybe<AddClipAnnotationDataByM2M>;
  /** Adding missing transcipt data in db, if file is already there but transcript line data is not there */
  addMissingTranscriptDataBySuperadmin?: Maybe<AddMissingTranscriptDataBySuperAdmin>;
  /**
   * Legacy signature-detail mutation, superseded by `signReport` +
   * in-section `WET_SIGNATURE`/`TYPED_SIGNATURE` fields. Kept and marked
   * `@deprecated` (see the `Field()` registration on `ReportMutations`
   * below) rather than removed outright — expand/contract split per the
   * PROA-2308 PR discussion: removing a public mutation atomically forces
   * every caller (portal-web-ui, and potentially others) to migrate in the
   * same deploy as the new, unproven `signReport` path. Deletion is a
   * follow-up PR, gated on Datadog confirming zero traffic here.
   * A call by the report's current signer on an existing detail row is an
   * edit, not a signing, and does not restamp a `last_signed_at` already set.
   * @deprecated Use signReport instead; will be removed once traffic drops to zero (PROA-2308).
   */
  addOrUpdateReportSignatureSectionDetail?: Maybe<AddOrUpdateReportSignatureSectionDetail>;
  addReportClientDetails?: Maybe<AddReportClientDetails>;
  addReportGoalsSuggestedByAi?: Maybe<AddReportGoalsSuggestedByAi>;
  addReportTargetsSuggestedByAi?: Maybe<AddReportTargetsSuggestedByAi>;
  addSessionAnalyzerFeedback?: Maybe<AddSessionAnalyzerFeedback>;
  addSuggestedReportGoals?: Maybe<AddSuggestedReportGoals>;
  addSuggestedReportTargets?: Maybe<AddSuggestedReportTargets>;
  addTranscriptData?: Maybe<AddTranscriptData>;
  addUpdateReportTreatmentPlanPrioritizeFields?: Maybe<AddUpdateReportTreatmentPlanPrioritizeFields>;
  addUpdateReportTreatmentPlanPrioritizeFieldsByAi?: Maybe<AddUpdateReportTreatmentPlanPrioritizeFieldsByAi>;
  /**
   * Marks the comment applied. Does not write to the report field's live
   * content -- that happens through a separate, already-existing field-update
   * mutation on the frontend.
   */
  applyReportComment?: Maybe<ApplyReportComment>;
  /**
   * Archive every learner in the organization whose external id is not in
   * ``active_external_ids``.
   *
   * Used by the Passage full-roster reconcile sync: the caller passes the
   * complete set of external client ids currently present in the source EHR
   * for the org, and this archives the learners that no longer appear there.
   * The archive is scoped to the single organization resolved from
   * ``organization_external_id`` and only touches EHR-synced learners
   * (``external_id`` is not null), leaving Frontera-native learners alone.
   */
  archiveExternalClientsNotIn?: Maybe<ArchiveExternalClientsNotIn>;
  /**
   * Archive/unarchive a curriculum in the requesting enterprise-admin's org.
   *
   * Public user-token twin of the internal M2M mutation; org is derived from
   * the session, never a client-supplied id. Shares one service code path.
   */
  archiveGoalBankCurriculum?: Maybe<GoalBankMutationResult>;
  archiveUnarchiveReport?: Maybe<ArchiveOrUnArchiveLearnerReport>;
  assignAnnotaterToMedia?: Maybe<AssignAnnotaterToMedia>;
  backfillOrganizationUserRoles?: Maybe<BackfillOrganizationUserRoles>;
  backfillSelfServeUserRoles?: Maybe<BackfillSelfServeUserRoles>;
  /**
   * Mutation to book an appointment in Care
   *
   * This mutation creates an appointment booking between a Care Customer and a Care Resource for a Care Service
   */
  bookCareAppointment?: Maybe<BookCareAppointment>;
  /**
   * Reassign multiple ReportGoals to new ReportDomains in a single mutation.
   * All records are fetched and validated before any DB write; a failure in any
   * item aborts the entire operation.
   */
  bulkReassignReportGoals?: Maybe<BulkReassignReportGoals>;
  /**
   * Cancels a service by removing the payment intent on Stripe and updating the UserBillingDetails record.
   *
   * This mutation:
   * 1. Retrieves the UserBillingDetails record by payment_intent_id
   * 2. Cancels the payment intent on Stripe (if not already processed)
   * 3. Updates the UserBillingDetails record to mark it as cancelled
   * 4. Returns confirmation of the cancellation
   */
  cancelService?: Maybe<CancelService>;
  changeActiveStatusAnnotation?: Maybe<ChangeActiveAnnotation>;
  changePassageEventsInUse?: Maybe<ChangePassageProgramingEventsInUseStatusMutation>;
  changePassagePhasesInUse?: Maybe<ChangePassageProgramingPhasesInUseStatusMutation>;
  changePassageProgramingInUseStatus?: Maybe<ChangePassageProgramingInUseStatusMutation>;
  changeTreatmentPlanDeleteStatus?: Maybe<ChangeReportTreatmentPlanDeleteStatusMutation>;
  /**
   * Charges a customer using their saved Stripe payment method.
   *
   * This mutation retrieves and confirms an existing PaymentIntent using the stored
   * `payment_method_id` associated with the user’s Stripe account.
   *
   * Steps:
   * 1. Fetches the PaymentIntent by ID from Stripe.
   * 2. Confirms the intent using the saved payment method (if applicable).
   * 3. Returns confirmation details including the charged amount and status.
   *
   * If the PaymentIntent was already confirmed, it returns a success response
   * without reprocessing the charge.
   *
   * Response:
   * - `message`: Status or error message
   * - `status`: Boolean indicating success
   * - `payment_intent_id`: The ID of the charged PaymentIntent
   * - `amount_charged`: Amount successfully charged (in USD)
   */
  chargeSavedPaymentMethod?: Maybe<ChargeSavedPaymentMethod>;
  checkDifferenceBetweenAuth0AndFdmRoles?: Maybe<CheckAuth0UserRolesAndFdmUserRolesDiff>;
  completeAnnotationFileUpload?: Maybe<CompleteUploadAnnotationFile>;
  /**
   * Finalizes a chunked S3 upload for a chat-sourced video.
   *
   * Marks the Media as COMPLETED so it's queryable through MediaType; the
   * caller then calls ``createChatMessage`` with ``mediaId`` to attach the
   * video to the chat.
   */
  completeChatVideoUpload?: Maybe<CompleteChatVideoUpload>;
  completeExportReportGeneration?: Maybe<CompleteExportReportGeneration>;
  /** @deprecated Use completeLearnerFilePdfPreviewM2m on the internal M2M schema (/graphql/internal/); requires organization_id (PLA-1173). */
  completeLearnerFilePdfPreview?: Maybe<CompleteLearnerFilePdfPreview>;
  completeProviderOnboarding?: Maybe<CompleteProviderOnboarding>;
  /**
   * Called by the Python Temporal worker (DocxToPdfConversionWorkflow) once
   * ConvertAPI has successfully produced a PDF.  Sets the PDF S3 key and marks
   * the report COMPLETED so the frontend can download it.
   */
  completeReportPdfConversion?: Maybe<CompleteReportPdfConversion>;
  completeSampleTemplateGeneration?: Maybe<CompleteSampleTemplateGeneration>;
  completeSessionVideoForLearner?: Maybe<CompleteSessionVideoForLearner>;
  completeUploadTaskMedia?: Maybe<CompleteUploadTaskMedia>;
  completeUploadVideo?: Maybe<CompleteUploadVideoMutation>;
  completeUploadVideoSession?: Maybe<CompleteUploadVideoSessionVideoMutation>;
  /**
   * Completes the Zoom OAuth process using the provided authorization code.
   * Returns a message indicating the connection and cloud recording status.
   */
  completeZoomConnect?: Maybe<CompleteZoomConnect>;
  confirmPaymentAndAddAssessmentCredits?: Maybe<ConfirmPaymentAndAddAssessmentCredits>;
  /**
   * Return and clear the pending interactive-MFA code for a workflow.
   *
   * Polled by the CentralReach scraper (M2M) while it holds the browser open on
   * the MFA challenge (PROA-1534). Reads ``ScraperLogin.pending_mfa_code``,
   * clears it (so the same code is consumed once), and returns it — ``code`` is
   * null when no code has been entered yet.
   */
  consumePendingMfaCode?: Maybe<ConsumePendingMfaCodeMutation>;
  createAnnotater?: Maybe<CreateAnnotater>;
  createAnnotation?: Maybe<CreateAnnotation>;
  createAnnotationCategory?: Maybe<CreateAnnotationCategoryValue>;
  createAnnotationValidated?: Maybe<CreateAnnotationValidate>;
  createAnnotator?: Maybe<CreateAnnotatorUser>;
  createAudio?: Maybe<CreateAudio>;
  /** Create a new base SuggestionCriteria (is_base_criteria=True) */
  createBaseSuggestionCriteria?: Maybe<CreateBaseSuggestionCriteria>;
  /** Mutation to create a single availability block (one-off availability block) for a resource in the Care Resource Calendar */
  createCareResourceSingleAllocationBlock?: Maybe<CreateCareResourceSingleAllocationBlock>;
  /** Mutation to create a weekly availability allocation for a resource */
  createCareResourceWeeklyAllocationBlock?: Maybe<CreateCareResourceWeeklyAllocationBlock>;
  createCaregiverAuth0User?: Maybe<CreateCaregiverAuth0User>;
  createCaregiverMetadata?: Maybe<CreateCargiverMetadata>;
  createChat?: Maybe<CreateChat>;
  createChatMessage?: Maybe<CreateChatMessage>;
  createChatNote?: Maybe<CreateUpdateChatNote>;
  createChatTag?: Maybe<CreateChatTag>;
  /**
   * Mutation for creating INTAKE and ASSISTANT chats only.
   * For EXPERT chats, use the main CreateChat mutation.
   */
  createChatbotChat?: Maybe<CreateChatbotChat>;
  /** Mutation for creating chat messages in INTAKE and ASSISTANT chats. */
  createChatbotChatMessage?: Maybe<CreateChatbotChatMessage>;
  createCheckoutSession?: Maybe<CreateCheckoutSession>;
  createClassificationFeedback?: Maybe<CreateClassficationFeedback>;
  createClientFromEhr?: Maybe<CreateClientFromEhr>;
  createClinicLead?: Maybe<CreateClinicLead>;
  createClipAnnotationByM2m?: Maybe<CreateClipAnnotationByM2M>;
  createClipAssignment?: Maybe<CreateClipAssignment>;
  createCloudRecordingMediaM2m?: Maybe<CreatCloudRecordingMediaM2M>;
  createCloudRecordingVideoSessionM2m?: Maybe<CreateCloudRecordingVideoSessionM2M>;
  createCombinedMedia?: Maybe<CreateCombinedMedia>;
  /**
   * Mutation to create a new community member in Circle.so
   *
   * This mutation:
   * 1. Validates that the logged-in user is a Caregiver
   * 2. Checks that the email matches the Caregiver's email (users can only create accounts for themselves)
   * 3. Checks if a member with this email already exists in Circle
   * 4. Creates the member if they don't exist
   * 5. Optionally adds them to specified spaces
   *
   * The mutation uses the Admin API V2 to create members and sends them
   * an invitation email to join the community.
   */
  createCommunityMember?: Maybe<CreateCommunityMember>;
  /**
   * Creates a new Stripe SetupIntent for the logged-in user.
   *
   * This mutation is used to initiate the process of securely collecting and saving
   * a user's payment method for future off-session payments.
   *
   * Steps:
   * 1. Ensures the user has an existing Stripe Customer; creates one if missing.
   * 2. Creates a Stripe SetupIntent associated with that customer.
   * 3. Returns the `client_secret`, which the frontend uses to confirm the SetupIntent
   *    using Stripe’s SDK (e.g., `confirmSetupIntent`).
   *
   * Use this mutation when you need to allow a user to save their card details
   * without charging them immediately.
   *
   * Response:
   * - `message`: Status message
   * - `status`: Boolean success flag
   * - `setup_client_secret`: The secret token used on the frontend to complete setup
   * - `stripe_customer_id`: ID of the Stripe customer linked to this user
   */
  createCustomerAndPreparePaymentMethod?: Maybe<CreateCustomerAndPreparePaymentMethod>;
  createEnterpriseReportExportTemplate?: Maybe<CreateEnterpriseReportExportTemplate>;
  createExportReportGeneration?: Maybe<CreateExportReportGeneration>;
  createGoalBankFolder?: Maybe<CreateGoalBankFolder>;
  createGoalBankGoals?: Maybe<CreateGoalBankGoals>;
  createGoalBankLongTermGoals?: Maybe<CreateGoalBankLongTermGoals>;
  createGoalBankTargets?: Maybe<CreateGoalBankTargets>;
  createGoalsAndTargets?: Maybe<CreateGoalsAndTargets>;
  createHatchPlan?: Maybe<CreateHatchPlanPayload>;
  createHatchPlanVisualization?: Maybe<CreateHatchPlanVisualizationPayload>;
  /** Upload a LearnerFile associated directly to a Learner, without tying it to a Report. */
  createIndependentLearnerFile?: Maybe<CreateIndependentLearnerFile>;
  createLanguageStylePrompt?: Maybe<CreateLanguageStylePrompt>;
  createLearner?: Maybe<CreateLearner>;
  createLearnerAndVideoSessionByM2m?: Maybe<CreateLearnerAndVideoSessionByM2M>;
  createLearnerAvailabilty?: Maybe<CreateLearnerAvailability>;
  createLearnerCaregiver?: Maybe<CreateLearnerCaregiver>;
  createLearnerEducation?: Maybe<CreateLearnerEducation>;
  createLearnerInsurance?: Maybe<CreateLearnerInsurance>;
  createLearnerMedications?: Maybe<CreateLearnerMedications>;
  createLearnerMetadata?: Maybe<CreateLearnerMetadata>;
  createLearnerPrimaryProvider?: Maybe<CreateLearnerPrimaryProvider>;
  createLearnerVideoSession?: Maybe<CreateLearnerVideoSessionMutation>;
  createLearnerWithSessionAndMediaM2m?: Maybe<CreateLearnerWithVideoSessionAndMediaByM2M>;
  createMedia?: Maybe<CreateMedia>;
  createMediaAiPrediction?: Maybe<CreateMediaAiPrediction>;
  createMediaAiPredictionMetrics?: Maybe<CreateMediaAiPredictionMetrics>;
  createMediaClassificationPrediction?: Maybe<CreateMediaClassificationPrediction>;
  createMediaClip?: Maybe<CreateMediaClip>;
  createMediaComment?: Maybe<CreateMediaComment>;
  createMediaDevice?: Maybe<CreateMediaDevice>;
  createMediaFronteraM2m?: Maybe<CreateMediaFronteraM2M>;
  createMediaM2m?: Maybe<CreateMediaM2M>;
  createMediaMetadata?: Maybe<CreateMediaMetadata>;
  createMediaStream?: Maybe<CreateMediaStream>;
  createMediaTargetPredictionFeedback?: Maybe<CreateMediaTargetPredictionFeedback>;
  createMediaTargetPredictions?: Maybe<CreateMediaTargetPredictions>;
  createMultipleLearnerAvailabilties?: Maybe<CreateMultipleLearnerAvailabilities>;
  createMultipleLearnerMedications?: Maybe<CreateMultipleLearnerMedications>;
  createMultipleOnboardingQuestions?: Maybe<CreateMultipleOnboardingQuestions>;
  createNotification?: Maybe<CreateNotification>;
  createOnboardingQuestion?: Maybe<CreateOnboardingQuestion>;
  createOrUpdateLearnerFormStatus?: Maybe<CreateOrUpdateLearnerFormStatus>;
  /** Mutation for creating or updating SES email templates. */
  createOrUpdateSesEmailTemplate?: Maybe<CreateOrUpdateTemplate>;
  /** Create a new SuggestionCriteria and link it to the requesting organization */
  createOrganizationSuggestionCriteria?: Maybe<CreateOrganizationSuggestionCriteria>;
  createOrganizationTemplateLogo?: Maybe<CreateOrganizationTemplateLogo>;
  createParsedTreatmentPlanFileData?: Maybe<CreateParsedTreatmentPlanFileData>;
  createPassageSessions?: Maybe<CreatePassageSessions>;
  createPaymentIntent?: Maybe<CreatePaymentIntent>;
  createPrompt?: Maybe<CreatePrompt>;
  createProvider?: Maybe<CreateProvider>;
  createProviderFile?: Maybe<CreateProviderFile>;
  createProviderFromAuth0User?: Maybe<CreateProviderFromAuth0User>;
  createReassessmentReportGoals?: Maybe<CreateReassessmentReportGoals>;
  createRecommendationBankFolder?: Maybe<CreateRecommendationBankFolder>;
  createRecommendationBankItem?: Maybe<CreateRecommendationBankItem>;
  createReport?: Maybe<CreateReport>;
  /**
   * Create a root peer-review comment on a field, or a reply to an
   * existing peer-review comment. QA suggestions cannot be replied to.
   */
  createReportComment?: Maybe<CreateReportComment>;
  createReportFromTemplate?: Maybe<CreateReportFromTemplate>;
  createReportInternalLearnerFile?: Maybe<CreateReportInternalLearnerFile>;
  createReportLearnerFile?: Maybe<CreateReportLearnerFile>;
  createReportSectionField?: Maybe<CreateReportSectionField>;
  createReportSectionFieldFile?: Maybe<CreateReportSectionFieldFile>;
  createReportSections?: Maybe<CreateReportSections>;
  /** Create multiple ReportSuggestion objects */
  createReportSuggestions?: Maybe<CreateReportSuggestions>;
  createReportTemplateLogo?: Maybe<CreateReportTemplateLogo>;
  /**
   * Given a page location and report id, generates the appropriate sections from report templates.
   * If running for the first time, will additionally kick off AI generation (via Temporal) for all AI sections.
   *
   * Uses database templates instead of code configuration to determine section structure.
   */
  createReportTemplateSections?: Maybe<CreateReportTemplateSections>;
  /** Create a new SuggestionCriteria and link it to a ReportTemplate */
  createReportTemplateSuggestionCriteria?: Maybe<CreateReportTemplateSuggestionCriteria>;
  createSampleTemplate?: Maybe<CreateSampleTemplate>;
  createSelfServeCaregiverFromAuth0User?: Maybe<CreateSelfServeCaregiverFromAuth0User>;
  createSelfServeProviderFromAuth0User?: Maybe<CreateSelfServeProviderFromAuth0User>;
  createSessionAiPreds?: Maybe<CreateSessionAiPrediction>;
  createSessionEngagementScore?: Maybe<CreateSessionEngagementScorePart>;
  createSessionInsights?: Maybe<CreateSessionInsights>;
  createSetupIntent?: Maybe<CreateSetupIntent>;
  createTaskLearnerFile?: Maybe<CreateTaskLearnerFile>;
  createTaskMedia?: Maybe<CreateTaskMedia>;
  createTranscript?: Maybe<CreateTranscript>;
  createTreatmentPlanCustomFieldFile?: Maybe<CreateTreatmentPlanCustomFieldFile>;
  /**
   * Upsert the content (value) of a TreatmentPlanCustomField.
   *
   * Two modes:
   *
   * 1. When ``custom_field_id`` is provided, update the existing row.
   * 2. When ``custom_field_id`` is null, the client must provide
   *    ``field_identifier`` and exactly one of ``report_goal_id``,
   *    ``report_target_id``, or ``report_domain_id``. If a matching custom
   *    field already exists for that entity it is updated; otherwise we look
   *    up the TreatmentPlanTemplateField with the same identifier on the
   *    entity's treatment plan template, create a custom field row from that
   *    spec, then set its content.
   */
  createUpdateCustomFieldValue?: Maybe<CreateUpdateCustomFieldValue>;
  createUpdateReportGoal?: Maybe<CreateUpdateReportGoal>;
  createUpdateReportTarget?: Maybe<CreateUpdateReportTarget>;
  createUpdateSessionMediaReviewActivityLog?: Maybe<CreateUpdateSessionMediaReviewActivityLog>;
  createUpdateVoiceSignature?: Maybe<CreateUpdateVoiceSignature>;
  createVerifier?: Maybe<CreateVerifier>;
  createVideoSession?: Maybe<CreateVideoSession>;
  createVideoSessionAndMediaInClinic?: Maybe<CreateVideoSessionAndMediaInClinic>;
  createVideoSessionM2m?: Maybe<CreateVideoSessionM2M>;
  /**
   * Mutation for a logged-in caregiver to deactivate their own account.
   * Blocks user in Auth0 and deactivates local user.
   */
  deactivateCaregiverAccount?: Maybe<DeactivateCaregiverAccount>;
  deleteAnnotation?: Maybe<DeleteAnnotation>;
  deleteAnnotationFile?: Maybe<DeleteAnnotationFile>;
  deleteAnnotationMedia?: Maybe<DeleteAnnotationMedia>;
  /** Mutation to delete a single allocation (one-off availability block) */
  deleteCareResourceSingleAllocationBlock?: Maybe<DeleteCareResourceSingleAllocationBlock>;
  /** Mutation to delete a weekly allocation */
  deleteCareResourceWeeklyAllocationBlock?: Maybe<DeleteCareResourceWeeklyAllocationBlock>;
  /** Delete ASSISTANT chats. */
  deleteChat?: Maybe<DeleteChat>;
  deleteChatNote?: Maybe<DeleteChatNote>;
  deleteClipAssignemntAnnotation?: Maybe<DeleteClipAssignmentAnnotation>;
  deleteDeviceToken?: Maybe<DeleteDeviceToken>;
  /**
   * Delete EHR credentials on logout (Frontend)
   *
   * Also ends any active ScraperSessionWorkflow for this provider
   *
   * returns: Success message
   */
  deleteEhrCredentials?: Maybe<DeleteEhrCredentials>;
  /**
   * The mutation deletes the given report template by ID.
   * Allows deleting base templates and templates with existing reports.
   * Available only to enterprise admins
   */
  deleteEnterpriseReportTemplate?: Maybe<DeleteEnterpriseReportTemplate>;
  deleteGoalBankFolder?: Maybe<DeleteGoalBankFolder>;
  deleteGoalBankGoal?: Maybe<DeleteGoalBankGoal>;
  deleteGoalBankLongTermGoal?: Maybe<DeleteGoalBankLongTermGoal>;
  deleteGoalBankTarget?: Maybe<DeleteGoalBankTarget>;
  /**
   * Mutation to delete all short term goals for a specific learner.
   * Originally written to support end to end testing scenarios where we need a clean state.
   */
  deleteGoalsForLearner?: Maybe<DeleteGoalsForLearner>;
  deleteLearnerAvailabilty?: Maybe<DeleteLearnerAvailability>;
  deleteLearnerFile?: Maybe<DeleteLearnerFile>;
  deleteMediaClip?: Maybe<DeleteMediaClip>;
  deletePaymentMethod?: Maybe<DeletePaymentMethod>;
  deleteProviderFile?: Maybe<DeleteProviderFile>;
  deleteRecommendationBankFolder?: Maybe<DeleteRecommendationBankFolder>;
  deleteRecommendationBankItem?: Maybe<DeleteRecommendationBankItem>;
  deleteReport?: Maybe<DeleteReport>;
  /**
   * Deletes the caller's own comment or reply, whatever its status. The
   * row stays as a tombstone so replies and the activity log survive; its
   * text and edit history are cleared.
   */
  deleteReportComment?: Maybe<DeleteReportComment>;
  deleteReportSection?: Maybe<DeleteReportSection>;
  deleteReportSectionField?: Maybe<DeleteReportSectionField>;
  /** The mutation deletes the given report template by ID. */
  deleteReportTemplate?: Maybe<DeleteReportTemplate>;
  /** Mutation for deleting SES email templates. */
  deleteSesTemplate?: Maybe<DeleteTemplate>;
  /**
   * Soft-disconnect a caregiver from a clinic tenant.
   *
   * A caregiver can disconnect themselves; an internal caller may disconnect a
   * specific caregiver by passing `caregiver`. Sets the `Membership` inactive.
   * The activation code stays spent.
   */
  disconnectCaregiverFromOrganization?: Maybe<DisconnectCaregiverFromOrganization>;
  dismissNotification?: Maybe<DismissNotification>;
  dispatchMediaCommentNotifications?: Maybe<DispatchMediaCommentNotifications>;
  /**
   * Create a new report goal by copying metadata from an existing goal.
   * Resets status to New Goal, strips progress/chart/approval data, and does not
   * copy targets or goal phase/event rows.
   */
  duplicateReportGoal?: Maybe<DuplicateReportGoal>;
  /** The mutation duplicates the given report template by ID and saves it in draft state to be edited. */
  duplicateReportTemplate?: Maybe<DuplicateReportTemplate>;
  /**
   * Edits the body of the caller's own open comment or reply. A Proposed
   * Edit's suggested text is not editable, only the explanation around it.
   */
  editReportComment?: Maybe<EditReportComment>;
  ehrGetClientList?: Maybe<ClientListMutation>;
  /**
   * Queue one EHR action for this provider.
   *
   * ``created`` is False when an identical request was already in flight. The
   * caller should show the existing request with attribution ("already
   * running, started by X") — not report a fresh success, and not silently do
   * nothing.
   */
  ehrRequestAction?: Maybe<EhrRequestAction>;
  ehrStartWorkflowAndLogin?: Maybe<StartWorkflowAndLoginMutation>;
  /**
   * GraphQL mutation for creating targets in an external HR system.
   *
   * This mutation creates targets for a specific learner and short-term goal
   * by initiating a Temporal workflow that handles the actual creation
   * in the external HR system.
   *
   * :param learner_external_id: External ID of the learner in the HR system
   * :param goal_external_id: External ID of the short-term goal in the HR system
   *
   * :return: HRTargetsCreationMutation: Mutation result with status message
   */
  ehrTargetCreationWorkflow?: Maybe<HrTargetsCreationMutation>;
  ehrUpdateLoginStatus?: Maybe<UpdateLoginStatusMutation>;
  ehrUpdateSyncStatus?: Maybe<EhrUpdateSyncStatusMutation>;
  endEhrScraperWorkflow?: Maybe<EndEhrScraperWorkflow>;
  /** Export a draft whose Team Review has started, marked as a draft. */
  exportDraftReportDocument?: Maybe<ExportReportDocumentPayload>;
  /** Auxiliary mutation to codegen EHR enums */
  exportEhrEnums?: Maybe<EhrEnumsCodegen>;
  /**
   * Generate a reimportable .xlsx for one of the org's curricula and return a
   * signed S3 download URL.
   *
   * Columns match the importer (Folder Name, Goal Name, Mastery Criteria, Mapped
   * Domains), so a downloaded file is a backup that can be edited and loaded back
   * in. Org is derived from the session, never a client-supplied id.
   */
  exportGoalBankCurriculum?: Maybe<ExportGoalBankCurriculum>;
  /** @deprecated Use failLearnerFilePdfPreviewM2m on the internal M2M schema (/graphql/internal/); requires organization_id (PLA-1173). */
  failLearnerFilePdfPreview?: Maybe<FailLearnerFilePdfPreview>;
  /**
   * Called by the Python Temporal worker (DocxToPdfConversionWorkflow) when
   * the ConvertAPI conversion fails.  Sets the report status to FAILURE so the
   * frontend can surface an error to the user.
   */
  failReportPdfConversion?: Maybe<FailReportPdfConversion>;
  fillGasTables?: Maybe<FillGasTables>;
  finishChat?: Maybe<FinishChat>;
  /** Mark an INTAKE or ASSISTANT chat as finished. */
  finishChatbotChat?: Maybe<FinishChatbotChat>;
  generateLearnerFilePdfPreview?: Maybe<GenerateLearnerFilePdfPreview>;
  /**
   * Accepts a client-generated DOCX file, stores it in S3, and kicks off the
   * DocxToPdfConversionWorkflow on the Python Temporal worker.  The report status
   * is set to GENERATING immediately; the workflow callback mutations below flip it
   * to COMPLETED or FAILURE once the ConvertAPI conversion finishes.
   */
  generateReportPdfFromDocx?: Maybe<GenerateReportPdfFromDocx>;
  generateTranscriptCsv?: Maybe<GenerateTranscriptCsvMutation>;
  /** Return a presigned S3 PUT URL so the client can upload an Excel file. */
  getGoalBankUploadUrl?: Maybe<GetGoalBankUploadUrl>;
  importClientFromEhr?: Maybe<ImportClientFromEhr>;
  importClientList?: Maybe<ImportClientList>;
  /**
   * Import goals from an uploaded Excel spreadsheet into the requesting
   * enterprise-admin's organization goal bank.
   *
   * With ``dry_run=True`` the spreadsheet is parsed and validated but nothing is
   * written, so the client can show a "found X goals, skipped Y empty rows"
   * preview before committing the real import.
   */
  importGoalBank?: Maybe<ImportGoalBank>;
  importGoalsFromEhr?: Maybe<ImportGoalsFromEhr>;
  importReportTemplateJson?: Maybe<ImportReportTemplateJson>;
  /**
   * M2M-authorized variant of ImportReportTemplateJson.
   *
   * Used by the report_template_builder Temporal workflow to persist an
   * AI-generated draft template into the basecamp UI. Differs from the
   * human-admin version only in the auth decorator + arguments (single
   * organizationId so the audit middleware sees org context).
   */
  importReportTemplateJsonM2m?: Maybe<ImportReportTemplateJsonM2m>;
  importSessionsFromEhr?: Maybe<ImportSessionsFromEhr>;
  importTargetsFromEhr?: Maybe<ImportTargetsFromEhr>;
  /**
   * Initiates a chunked S3 upload for a chat-sourced video.
   *
   * Creates a Media row (no VideoSession) and returns the multipart upload
   * metadata. The Media is attached to the chat's learner via the eventual
   * ChatMessage.media FK created by ``createChatMessage``. Also returns a
   * single-PUT URL for a client-extracted JPG thumbnail; on completion the
   * server writes a manifest JSON pointing at it so ``MediaType.thumbnailUrl``
   * resolves.
   */
  initiateChatVideoUpload?: Maybe<InitiateChatVideoUpload>;
  loadGoalBank?: Maybe<LoadGoalBank>;
  loadRecommendationBank?: Maybe<LoadRecommendationBank>;
  /**
   * First import: lock the reviewed structure and import what's locked.
   *
   * Reruns the checks; any error rejects the lock. Waiting items are left out.
   */
  lockCrLearningTree?: Maybe<LockCrLearningTree>;
  /**
   * Apply all domain + goal-domain edits for a report in one atomic call.
   *
   * Handles:
   * - Rename, reorder, add, and delete domains (position in `domains`
   *   becomes `rank_order`).
   * - Move goals between domains, including unassigning (no destination)
   *   and moving into a brand-new domain via `destination_client_id`.
   * - Validates that any domain marked for deletion contains zero goals
   *   AFTER the supplied moves are applied — so the client must drain a
   *   domain by moving its goals out (anywhere) before deleting it.
   *
   * Frontera-internal-only.
   */
  manageReportDomains?: Maybe<ManageReportDomains>;
  manuallyMarkMediaAsViewed?: Maybe<ManuallyMarkMediaAsViewed>;
  markEnteredVideoCaptureApp?: Maybe<MarkEnteredVideoCaptureApp>;
  markLearnerFileAsProcessError?: Maybe<MarkLearnerFileAsProcessError>;
  markLearnerFileAsProcessSuccess?: Maybe<MarkLearnerFileAsProcessSuccess>;
  markLearnerFileAsUploaded?: Maybe<MarkLearnerFileAsUploaded>;
  /**
   * UI-accessible mutation to mark a file as uploaded.
   *
   * This is the ONLY status update mutation accessible to UI users (PROVIDER_PERMISSION_CFG).
   * It transitions status from "pending" -> "uploaded".
   *
   * All other status transitions (processing, completed, failed) are backend-only
   * and handled by UpdateProviderFileProcessStatus (TEMPORAL_PERMISSION_CFG).
   */
  markProviderFileAsUploaded?: Maybe<MarkProviderFileAsUploaded>;
  /**
   * Consolidate a duplicated organization by migrating data from an old organization into a new one.
   *
   * This mutation transfers all learners, metadata, and report-related records from the `old_organization`
   * into the `new_organization`, effectively replacing the old one.
   *
   * If any learners exist in both organizations, the optional `learner_connections` list maps old learner IDs
   * to new ones to ensure external identifiers are preserved and data remains consistent.
   *
   * After migration:
   * - All relevant data is moved into `new_organization`
   * - `old_organization` is deleted
   * - Learner links and metadata are updated accordingly
   */
  migrateDuplicatedOrganization?: Maybe<MigrateDuplicatedOrganization>;
  moveGoalBankGoal?: Maybe<MoveGoalBankGoal>;
  moveGoalBankLongTermGoal?: Maybe<MoveGoalBankLongTermGoal>;
  moveGoalBankTarget?: Maybe<MoveGoalBankTarget>;
  moveRecommendationBankItem?: Maybe<MoveRecommendationBankItem>;
  moveReportSection?: Maybe<MoveReportSection>;
  moveReportSectionFieldToAnotherSection?: Maybe<MoveReportSectionFieldToAnotherSection>;
  moveReportSectionFieldUpAndDown?: Maybe<MoveReportSectionFieldUpAndDown>;
  moveReportSectionUpAndDown?: Maybe<MoveReportSectionUpAndDown>;
  openChat?: Maybe<OpenChat>;
  populateDataFromBhtia?: Maybe<PopulateDataFromBhtia>;
  promoteReportTemplate?: Maybe<PromoteReportTemplate>;
  /**
   * Dev and staging only, for test organizations and internal or admin logins, and only
   * for goals whose names an autotest generated. Always in the schema so the schema stays
   * the same everywhere; it refuses unless every gate holds. Returns when the
   * organization's CentralReach session has made the change, or after about 20 seconds
   * with ``status`` false: a name that is not found is listed in ``message``, not an
   * error.
   */
  qaSetCentralReachItemStatus?: Maybe<QaSetCentralReachItemStatus>;
  /** Re run failed video_session */
  reRunFailedSessionBySuperAdmin?: Maybe<ReRunFailedSessionBySuperAdmin>;
  readAllNotifications?: Maybe<ReadAllNotifications>;
  readNotification?: Maybe<ReadNotification>;
  reassignReportGoal?: Maybe<ReassignReportGoal>;
  /**
   * Regenerate the Goal Status Summary TABLE field's content for a
   * report, from current `ReportGoal` data. Called at the Narrative →
   * Review-and-Sign transition — see
   * `docs/adr/0004-goal-status-summary-table-key.md` in the workspace root.
   * A no-op (status=True, updated=False) when the report has no field
   * wired to this table_key; the caller should not treat that as an error.
   */
  recalculateGoalStatusSummary?: Maybe<RecalculateGoalStatusSummary>;
  refreshToken?: Maybe<Refresh>;
  registerDeviceToken?: Maybe<RegisterDeviceToken>;
  reissueCaregiverInvitation?: Maybe<ReissueCaregiverInvitation>;
  reissueProviderInvitation?: Maybe<ReissueProviderInvitation>;
  /**
   * Remove a learner-payor mapping created from the portal (PROA-1736).
   *
   * Soft-deletes the ``LearnerPayor`` row for (learner, payor_type) in the
   * caller's organization by marking it ``is_active=False`` rather than
   * deleting it — the row (and any sync-owned fields like ``external_id`` /
   * ``report_upload_prefix``) is preserved. A missing mapping is surfaced as a
   * field error rather than raising.
   */
  removeLearnerPayor?: Maybe<RemoveLearnerPayor>;
  removeMediaAiPredictions?: Maybe<RemoveMediaAiPredictions>;
  removeMediaComment?: Maybe<RemoveMediaComment>;
  removeReportGoal?: Maybe<RemoveReportGoal>;
  removeReportTarget?: Maybe<RemoveReportTarget>;
  removeSessionData?: Maybe<RemoveSessionData>;
  reopenReportComment?: Maybe<ReopenReportComment>;
  reorderGoals?: Maybe<ReorderGoals>;
  /**
   * Reorder report goals by updating rank_order on their underlying base Goals.
   * If a ReportGoal has no linked base Goal yet, one is created automatically.
   */
  reorderReportGoals?: Maybe<ReorderReportGoals>;
  requestReportReview?: Maybe<RequestReportReview>;
  /** Mutation to reschedule an appointment (update start and end times) */
  rescheduleCareAppointment?: Maybe<RescheduleCareAppointment>;
  resolveReportComment?: Maybe<ResolveReportComment>;
  /** Mark a ReportSuggestion as resolved */
  resolveReportSuggestion?: Maybe<ResolveReportSuggestion>;
  /** Re run video_session workflow to add video_session summary and metrics */
  runSessionWorkflowToBackfill?: Maybe<RunSessionWorkflowToAddSessionSummaryAndMetrics>;
  /**
   * API to run workflow for sessions that do not have transcript and
   * to run workflow if there is multiple videos but not combined one for a sesssion
   */
  runVideoWorkflowForSessionBySuperadmin?: Maybe<RunVideoWorkflowForSessionsBySuperAdmin>;
  /** After a refresh: answer new items, lock them, and import only those. */
  saveAndLockCrLearningTreeItems?: Maybe<SaveAndLockCrLearningTreeItems>;
  /** Save summary for INTAKE and ASSISTANT chats. */
  saveChatbotSummary?: Maybe<SaveChatbotSummary>;
  /** Save role choices as the person changes dropdowns (drafts). */
  saveCrLearningTreeRoles?: Maybe<SaveCrLearningTreeRoles>;
  /**
   * Save EHR credentials after successful login (Temporal)
   *
   * param: provider_id: Provider global ID
   * param: organization_id: Organization global ID
   * param: username: EHR username
   * param: password: EHR password
   *
   * returns: Success message
   */
  saveEhrCredentials?: Maybe<SaveEhrCredentials>;
  saveGoalBankEmbeddings?: Maybe<SaveGoalBankEmbeddings>;
  /**
   * Creates ReportGoal records for each goal bank suggestion produced by
   * SuggestGoalBankGoalsWorkflow. Each goal is created with ai_generated=True
   * and in_use=False so it surfaces as a suggestion without blocking the user.
   * Goal name, mastery criteria, and timeline are copied from the source
   * ReportGoalBank record.
   * @deprecated Use saveGoalBankSuggestedGoals on the internal M2M schema (/graphql/internal/); requires organization_id (PLA-792).
   */
  saveGoalBankSuggestedGoals?: Maybe<SaveGoalBankSuggestedGoals>;
  saveLearnerConsentFile?: Maybe<SaveLearnerConsentFileMutation>;
  saveReportWritingTimes?: Maybe<SaveReportWritingTimes>;
  saveSessionAudioMetrics?: Maybe<SaveSessionAudioMetrics>;
  /**
   * Saves or updates the user's Stripe payment method in the backend database.
   *
   * This mutation is typically called **after** a successful SetupIntent confirmation on the frontend.
   * It takes the `payment_method_id` returned from Stripe and attaches it to the user's Stripe customer.
   *
   * Steps:
   * 1. Validates the payment method and ensures it belongs to the correct Stripe customer.
   * 2. Saves the `payment_method_id` in the backend for future off-session charges.
   *
   * Response:
   * - `message`: Confirmation message
   * - `status`: Boolean success flag
   */
  saveStripePaymentMethod?: Maybe<SaveStripePaymentMethod>;
  saveTasks?: Maybe<SaveTasks>;
  /** Mutation for sending daily digest emails to RBTS and Caregivers */
  sendActivityEmailsToRbts?: Maybe<SendActivityEmailsToRbts>;
  /** Send one caregiver their app activation code via email and/or SMS. */
  sendCaregiverActivationCodeNotification?: Maybe<SendCaregiverActivationCodeNotification>;
  /**
   * Queue sending a batch of caregivers their app activation code via email/SMS.
   *
   * A single caregiver invite/resend
   * should use `sendCaregiverActivationCodeNotification` (singular) instead,
   * which sends synchronously and returns real success/failure. Triggers a
   * frontera-pipelines Temporal workflow that sends each caregiver's code — one
   * activity per caregiver, so a bad address or transient send failure only
   * affects that caregiver. This mutation returns as soon as the workflow is
   * queued; it does not wait for sends to complete. Sending stamps the
   * per-channel "last sent" timestamp; it does not change activation
   * eligibility.
   */
  sendCaregiverActivationCodeNotifications?: Maybe<SendCaregiverActivationCodeNotifications>;
  sendClientToFronteraEhr?: Maybe<SendClientToFronteraEhr>;
  sendPendingUploadReminders?: Maybe<SendPendingUploadReminders>;
  sendTestEmail?: Maybe<SendTestEmail>;
  setEhrConnectionStatus?: Maybe<SetEhrConnectionStatusMutation>;
  setLearnerFileStatus?: Maybe<SetLearnerFileStatus>;
  /**
   * Map a learner to one or more payors from the portal (PROA-1736).
   *
   * Upserts a ``LearnerPayor`` row per (learner, payor_type) in the caller's
   * organization — an existing mapping is returned rather than duplicated.
   * Portal-created mappings are active (``is_active=True``) but carry no payor
   * ``external_id`` (only the sync pipeline sets that), so it stays null.
   * Submitting a report to the payor additionally requires the ``external_id``
   * to be populated by the sync pipeline (see ``StartPayorSubmissionWorkflow``).
   */
  setLearnerPayor?: Maybe<SetLearnerPayor>;
  setReportCommentHidden?: Maybe<SetReportCommentHidden>;
  setReportReviewStatus?: Maybe<SetReportReviewStatus>;
  /**
   * Creates a Stripe PaymentIntent for a future charge, without confirming or charging immediately.
   *
   * This mutation is designed for use cases where a user may have a saved payment method,
   * but you want to prepare the intent for a later charge (e.g., billing once a service completes).
   *
   * Steps:
   * 1. Ensures the user has a Stripe Customer record.
   * 2. Creates a PaymentIntent with `automatic_payment_methods` enabled,
   *    but does not confirm or charge the payment.
   * 3. Returns the client secret so the frontend can handle confirmation later if needed.
   *
   * Response:
   * - `message`: Status message
   * - `status`: Boolean success flag
   * - `payment_client_secret`: The PaymentIntent client secret
   * - `payment_intent_id`: The Stripe PaymentIntent ID
   */
  setupPaymentIntent?: Maybe<SetupPaymentIntent>;
  /**
   * Finalizes a report's signature: validates the signature section's
   * required fields (including whichever signature-type field(s) a
   * template marks required — the same generic `is_required` mechanism
   * every other field already uses, no special-casing by field type),
   * stamps the signature-date field with the server clock's calendar day in
   * the signing zone (the caller supplies only an optional display zone,
   * `time_zone`, never a time or date), stamps `last_signed_by_provider`,
   * `last_signed_at` (server UTC) and `last_signed_timezone` (browser zone,
   * else profile, else "UTC") on the report, and freezes an audit snapshot
   * of every `is_auditable` field, plus the signing's instant and zone
   * (task 1.4, PROA-2891). The signature content itself (typed text, or an
   * uploaded/drawn image) is written beforehand through ordinary field
   * edits, exactly like any other report field — this mutation only
   * finalizes.
   * Supersedes the deprecated `addOrUpdateReportSignatureSectionDetail`
   * (kept around one more deploy cycle, see its own docstring) as the
   * step the frontend calls first in the sign flow, before whichever
   * export/completion mutation runs next — it does not change report
   * status.
   */
  signReport?: Maybe<SignReport>;
  startD2pOnboardingWorkflow?: Maybe<StartD2POnboardingWorkflow>;
  startGoalAttainmentScaleWorkflow?: Maybe<StartGoalAttainmentScaleWorkflow>;
  startGoalBaselineDataWorkflow?: Maybe<StartGoalBaselineDataWorkflow>;
  startGoalProgressSummaryWorkflow?: Maybe<StartGoalProgressSummaryWorkflow>;
  startGoalsSyncToEhr?: Maybe<StartGoalsSyncToEhr>;
  startLearnerFileClassification?: Maybe<StartLearnerFileClassification>;
  startLearnerFileValidation?: Maybe<StartLearnerFileValidation>;
  startLearnerMetadataCreationFromAbcIntakeFile?: Maybe<StartLearnerMetadataCreationFromAbcIntakeFile>;
  startLearnerMetadataCreationFromBhtiaFile?: Maybe<StartLearnerMetadataCreationFromBhtiaFile>;
  startManualSyncWorkflow?: Maybe<StartManualSyncWorkflow>;
  startPayorSubmissionWorkflow?: Maybe<StartPayorSubmissionWorkflow>;
  /**
   * Kick off validation / parsing for a provider file, similar to StartLearnerFileValidation.
   *
   * This is called by providers from the UI once the file has been uploaded.
   */
  startProviderFileValidation?: Maybe<StartProviderFileValidation>;
  startReassessmentFileClassification?: Maybe<StartReassessmentFileClassification>;
  /** Start the report suggestions generation workflow for a report */
  startReportSuggestionsWorkflow?: Maybe<StartReportSuggestionsWorkflow>;
  startSessionProcessingWorkflow?: Maybe<StartSessionProcessingWorkflow>;
  /**
   * Regenerate a single AI section using either the template reference or code configuration.
   * If the section has no AI fields, return success without regenerating.
   */
  startSingleReportTemplateSectionWorkflow?: Maybe<StartSingleReportTemplateSectionWorkflow>;
  startTargetProgressSummaryWorkflow?: Maybe<StartTargetProgressSummaryWorkflow>;
  /**
   * Returns Zoom OAuth URL.
   * FE should redirect user to this URL.
   */
  startZoomConnect?: Maybe<StartZoomConnect>;
  syncCrGoalOrTargetAndProgressData?: Maybe<SyncCrGoalOrTargetAndProgressData>;
  /** @deprecated Use syncExternalClients on /graphql/internal/ (PLA-799). org_id callers: cut over to the internal endpoint. Therapz (organization_external_id path): stays on public until org_id is available. This field will be removed after Datadog confirms zero traffic. */
  syncExternalClients?: Maybe<SyncExternalClients>;
  syncExternalOrganization?: Maybe<SyncExternalOrganization>;
  syncExternalProviders?: Maybe<SyncExternalProviders>;
  /**
   * Sync clients from Hipp Health to FDM.
   * Uses organization ID instead of external_id since Hipp Health organizations don't have external IDs.
   * @deprecated Use syncHippHealthClients on the internal M2M schema (/graphql/internal/); requires organization_id (PLA-801).
   */
  syncHippHealthClients?: Maybe<SyncHippHealthClients>;
  syncHippHealthTreatmentPlans?: Maybe<SyncHippHealthTreatmentPlans>;
  syncPassageTreatmentPlans?: Maybe<SyncPassageTreatmentPlans>;
  syncPayorClientData?: Maybe<SyncPayorClientData>;
  /**
   * Payor pipeline (Temporal M2M): create a single initial-assessment report for the
   * learner payor, attach payor-supplied documents as ``LearnerFile`` rows, then start
   * the appropriate Temporal workflow per file kind.
   *
   * Business logic lives in ``services.payor_service`` so this deprecated public
   * mutation and its org-scoped internal twin (``SyncPayorClientDocumentAndCreateReportM2m``)
   * share one code path (PLA-1173).
   * @deprecated Use syncPayorClientDocumentAndCreateReportM2m on the internal M2M schema (/graphql/internal/) (PLA-1173).
   */
  syncPayorClientDocumentAndCreateReport?: Maybe<SyncPayorClientDocumentAndCreateReport>;
  syncPayorOrganization?: Maybe<SyncPayorOrganization>;
  /** Obtain JSON Web Token mutation */
  tokenAuth?: Maybe<ObtainJsonWebToken>;
  uiEhrUpdateLoginStatus?: Maybe<UiUpdateLoginStatusMutation>;
  unassignCaregiverFromLearner?: Maybe<UnassignCaregiverFromLearner>;
  /**
   * Unlock an item and everything under it so its roles can change again.
   *
   * Changes nothing else; the next lock applies the differences (archive,
   * move, open reports). Same permission as Lock.
   */
  unlockCrLearningTreeBranch?: Maybe<UnlockCrLearningTreeBranch>;
  updateAnnotation?: Maybe<UpdateAnnotation>;
  updateAnnotator?: Maybe<UpdateAnnotatorUser>;
  updateAnnotatorUserAuth0id?: Maybe<UpdateAnnotatorUserAuth0Id>;
  /** Update name, content, and/or category on a base SuggestionCriteria */
  updateBaseSuggestionCriteria?: Maybe<UpdateBaseSuggestionCriteria>;
  updateBillableSummary?: Maybe<UpdateBillableSessionSummary>;
  /** Mutation to update custom fields on an appointment */
  updateCareAppointmentCustomFields?: Maybe<UpdateCareAppointmentCustomFields>;
  /** Mutation to update the notes field of an appointment */
  updateCareAppointmentNote?: Maybe<UpdateCareAppointmentNote>;
  updateCaregiverConsents?: Maybe<UpdateCaregiverConsents>;
  updateCaregiverLearnerRelationship?: Maybe<UpdateCaregiverLearnerRelationship>;
  updateCaregiverMetadata?: Maybe<UpdateCaregiverMetadata>;
  updateCaregiverSupportNotes?: Maybe<UpdateCaregiverSupportNotes>;
  updateChat?: Maybe<UpdateChat>;
  updateChatConversationSummary?: Maybe<UpdateChatConversationSummary>;
  updateChatMessage?: Maybe<UpdateChatMessage>;
  /** Update title for INTAKE and ASSISTANT chats. */
  updateChatTitle?: Maybe<UpdateChatTitle>;
  /** Update processing status for INTAKE and ASSISTANT chats. */
  updateChatbotProcessingStatus?: Maybe<UpdateChatbotProcessingStatus>;
  updateClipAnnotationStatus?: Maybe<UpdateClipAnnotationStatus>;
  updateClipAssignment?: Maybe<UpdateClipAssignment>;
  updateDomainConfig?: Maybe<UpdateDomainConfig>;
  /**
   * GraphQL mutation for updating external IDs from EHR system.
   *
   * This mutation is called by Temporal workflow after successful creation
   * of goals and targets in the external EHR system to update our database
   * with the external IDs provided by the EHR system.
   *
   * Supports EHR-specific goal/target models based on org_type:
   * - HI_RASMUS: HiRasmusGoal/HiRasmusTarget (lookup by goal__id/target__id)
   * - MOTIVITY: MotivityGoal/MotivityTarget (lookup by goal__id/target__id)
   * - CENTRAL_REACH: CentralReachGoal/CentralReachTarget (lookup by goal__id/target__id)
   * - HIPP_HEALTH: HippHealthGoal/HippHealthTarget (lookup by goal__id/target__id)
   * - RETHINK: RethinkGoal/RethinkTarget (lookup by goal__id/target__id)
   * - ENSORA: EnsoraGoal/EnsoraTarget (lookup by goal__id/target__id)
   *
   * :param org_type: Organization type to determine which model to update
   * :param goals_and_targets: List of goals with their targets and external IDs
   * :return: EHRUpdateExternalIds: Mutation result with status and message
   * :raises GraphQLError: If goal or target not found
   */
  updateEhrExternalIds?: Maybe<EhrUpdateExternalIds>;
  updateEhrGoalsAndTargets?: Maybe<UpdateEhrGoalsAndTargets>;
  updateEnterpriseReportExportTemplate?: Maybe<UpdateEnterpriseReportExportTemplate>;
  /** The mutation updates the given report template by ID. */
  updateEnterpriseReportTemplate?: Maybe<UpdateEnterpriseReportTemplate>;
  /** @deprecated Use updateGasExtractionDataM2m on the internal M2M schema (/graphql/internal/); requires organization_id (PLA-1172). */
  updateGasExtractionDataM2m?: Maybe<UpdateGasExtractionDataM2M>;
  updateGoal?: Maybe<UpdateGoal>;
  updateGoalAttainmentScaleM2m?: Maybe<UpdateGoalAttainmentScaleM2M>;
  updateGoalBankFolder?: Maybe<UpdateGoalBankFolder>;
  updateGoalBankGoal?: Maybe<UpdateGoalBankGoal>;
  updateGoalBankLongTermGoal?: Maybe<UpdateGoalBankLongTermGoal>;
  updateGoalBankTarget?: Maybe<UpdateGoalBankTarget>;
  updateGoalBaselineDataM2m?: Maybe<UpdateGoalBaselineDataM2M>;
  updateGoalExcludeFromReport?: Maybe<UpdateGoalExcludeFromReport>;
  updateGoalPredictionStatusM2m?: Maybe<UpdateGoalPredictionStatusM2M>;
  /** @deprecated Use updateGoalProgressSummariesM2m on the internal M2M schema (/graphql/internal/); requires organization_id (PLA-1172). */
  updateGoalProgressSummariesM2m?: Maybe<UpdateGoalProgressSummariesM2M>;
  updateGoalProgressSummary?: Maybe<UpdateGoalProgressSummary>;
  updateGoalProgressSummaryM2m?: Maybe<UpdateGoalProgressSummaryM2M>;
  /**
   * Updates the ai_goal_suggestion_status field on a ReportTreatmentPlan.
   * Called by SuggestGoalBankGoalsWorkflow on completion or failure.
   * @deprecated Use updateGoalSuggestionStatus on the internal M2M schema (/graphql/internal/); requires organization_id (PLA-792).
   */
  updateGoalSuggestionStatus?: Maybe<UpdateGoalSuggestionStatus>;
  updateGoalTargetGenerationStatusM2m?: Maybe<UpdateGoalTargetGenerationStatusM2M>;
  updateGoogleDriveUploadFlag?: Maybe<UpdateGoogleDriveUploadFlag>;
  /** @deprecated Use updateLanguageStylePromptM2m on the internal M2M schema (/graphql/internal/); requires organization_id (PLA-1173). */
  updateLanguageStylePrompt?: Maybe<UpdateLanguageStylePrompt>;
  updateLearnerAdditionalDetails?: Maybe<UpdateLearnerAdditionalDetails>;
  updateLearnerAvailabilityDetails?: Maybe<UpdateLearnerAvailabilityDetails>;
  updateLearnerBehaviors?: Maybe<UpdateLearnerBehaviors>;
  updateLearnerBirthHistory?: Maybe<UpdateLearnerBirthHistory>;
  updateLearnerCaregiverDetails?: Maybe<UpdateLearnerCaregiverDetails>;
  /** @deprecated PLA-912/PLA-410: use updateLearnerChatMemory on the internal M2M schema (/graphql/internal/). Removed after Datadog confirms zero traffic. */
  updateLearnerChatMemory?: Maybe<UpdateLearnerChatMemory>;
  updateLearnerCommunication?: Maybe<UpdateLearnerCommunication>;
  updateLearnerDetails?: Maybe<UpdateLearnerDetails>;
  updateLearnerDevelopmentalMilestones?: Maybe<UpdateLearnerDevelopmentalMilestones>;
  updateLearnerEarlyInterventionServices?: Maybe<UpdateLearnerEarlyInterventionServices>;
  updateLearnerEducation?: Maybe<UpdateLearnerEducation>;
  updateLearnerEducationDetails?: Maybe<UpdateLearnerEducationDetails>;
  updateLearnerEmergencyContact?: Maybe<UpdateLearnerEmergencyContact>;
  updateLearnerFileClassification?: Maybe<UpdateLearnerFileClassification>;
  /**
   * Clinician override for the parser-derived effective_date.
   *
   * Writes `effective_date` (which may be null to clear it) and sets
   * `clinician_edited_at = now()` atomically. After this runs, the race-safe
   * write hook in `LearnerFileService.update_parsed_results` and the M5
   * backfill migration both skip the row — the clinician's value wins.
   */
  updateLearnerFileEffectiveDate?: Maybe<UpdateLearnerFileEffectiveDate>;
  updateLearnerFileInterviewType?: Maybe<UpdateLearnerFileInterviewType>;
  updateLearnerFileLanguage?: Maybe<UpdateLearnerFileLanguage>;
  updateLearnerFileParsedResult?: Maybe<UpdateLearnerFileParsedResult>;
  updateLearnerGeneralDetails?: Maybe<UpdateLearnerGeneralDetails>;
  updateLearnerGuardianDetails?: Maybe<UpdateLearnerGuardianDetails>;
  updateLearnerInsurance?: Maybe<UpdateLearnerInsurance>;
  updateLearnerInsuranceDetails?: Maybe<UpdateLearnerInsuranceDetails>;
  updateLearnerIntakeOverviewDetails?: Maybe<UpdateLearnerIntakeOverviewDetails>;
  updateLearnerLivingConditions?: Maybe<UpdateLearnerLivingConditions>;
  updateLearnerManualSyncM2m?: Maybe<UpdateLearnerManualSync>;
  updateLearnerMedicalHistory?: Maybe<UpdateLearnerMedicalHistory>;
  updateLearnerMetadata?: Maybe<UpdateLearnerMetadata>;
  updateLearnerPrimaryProvider?: Maybe<UpdateLearnerPrimaryProvider>;
  updateLearnerProviders?: Maybe<UpdateLearnerProviders>;
  updateLearnerTendencies?: Maybe<UpdateLearnerTendencies>;
  updateMediaClip?: Maybe<UpdateMediaClip>;
  updateMediaComment?: Maybe<UpdateMediaComment>;
  updateMediaM2m?: Maybe<UpdateMediaM2M>;
  updateMediaStatus?: Maybe<UpdateMediaStatus>;
  updateMessageReadStatus?: Maybe<UpdateMessageReadStatus>;
  updateNotificationOptOut?: Maybe<UpdateNotificationOptOut>;
  updateOrgNotificationSettings?: Maybe<UpdateOrgNotificationSettings>;
  /** Update content and/or enabled on an OrganizationSuggestionCriteria */
  updateOrganizationSuggestionCriteria?: Maybe<UpdateOrganizationSuggestionCriteria>;
  updateOrganizationTemplateLogoUrl?: Maybe<UpdateOrganizationTemplateLogoUrl>;
  updateParsedTreatmentPlanFileData?: Maybe<UpdateParsedTreatmentPlanFileData>;
  updatePassageGoalAndTargetIdsM2m?: Maybe<UpdatePassageGoalAndTargetIdsM2m>;
  /** @deprecated Use updatePayorReportReviewStatusM2m on the internal M2M schema (/graphql/internal/); requires organization_id (PLA-1173). */
  updatePayorReportReviewStatus?: Maybe<UpdatePayorReportReviewStatus>;
  /** @deprecated Use updatePayorSubmissionStatusM2m on the internal M2M schema (/graphql/internal/); requires organization_id (PLA-1173). */
  updatePayorSubmissionStatus?: Maybe<UpdatePayorSubmissionStatus>;
  updatePrompt?: Maybe<UpdatePrompt>;
  updateProvider?: Maybe<UpdateProvider>;
  updateProviderAuth0Id?: Maybe<UpdateProviderAuth0Id>;
  updateProviderFileParsedResult?: Maybe<UpdateProviderFileParsedResult>;
  /**
   * Backend-only mutation to update file processing status.
   *
   * This mutation is restricted to TEMPORAL_PERMISSION_CFG (backend/system users only).
   * UI users cannot call this mutation.
   *
   * Allowed status transitions:
   * - uploaded -> PROCESSING (start processing)
   * - PROCESSING -> COMPLETED (success) or FAILED (error)
   * - FAILED -> PROCESSING (retry)
   *
   * NOTE: UI can only update status to "uploaded" via MarkProviderFileAsUploaded.
   */
  updateProviderFileProcessStatus?: Maybe<UpdateProviderFileProcessStatus>;
  updateProviderLearners?: Maybe<UpdateProviderLearners>;
  updateProviderProfile?: Maybe<UpdateProviderProfile>;
  updateRecommendationBankFolder?: Maybe<UpdateRecommendationBankFolder>;
  updateRecommendationBankItem?: Maybe<UpdateRecommendationBankItem>;
  updateReport?: Maybe<UpdateReport>;
  updateReportClientDetails?: Maybe<UpdateReportClientDetails>;
  /** @deprecated Use updateReportEhrSyncStatus on /graphql/internal/ (PLA-799). org_id callers: cut over to the internal endpoint. Therapz (no org_id): stays on public until org_id is available. This field will be removed after Datadog confirms zero traffic. */
  updateReportEhrSyncStatus?: Maybe<UpdateReportEhrSyncStatus>;
  updateReportGoalDomainsM2m?: Maybe<UpdateReportGoalDomainsM2M>;
  updateReportPageHeading?: Maybe<UpdateReportPageHeading>;
  updateReportSection?: Maybe<UpdateReportSection>;
  updateReportSectionField?: Maybe<UpdateReportSectionField>;
  updateReportSectionFieldFileUrl?: Maybe<UpdateReportSectionFieldFileUrl>;
  updateReportSectionFieldFromBhtia?: Maybe<UpdateReportSectionFieldFromBhtia>;
  updateReportSectionFieldOrder?: Maybe<UpdateReportSectionFieldsOrder>;
  updateReportSectionsOrder?: Maybe<UpdateReportSectionsOrder>;
  updateReportStatusAndUploadReportFile?: Maybe<UpdateReportStatusAndUploadReportFile>;
  /** Update the suggestion generation status for a report */
  updateReportSuggestionGenerationStatus?: Maybe<UpdateReportSuggestionGenerationStatus>;
  /** The mutation updates the given report template by ID. */
  updateReportTemplate?: Maybe<UpdateReportTemplate>;
  updateReportTemplateLogo?: Maybe<UpdateReportTemplateLogo>;
  /** Update content, category, and/or enabled on a ReportTemplateSuggestionCriteria */
  updateReportTemplateSuggestionCriteria?: Maybe<UpdateReportTemplateSuggestionCriteria>;
  updateReportTreatmentPlanPredictionStatus?: Maybe<UpdateReportTreatmentPlanPredictionStatus>;
  updateReportTreatmentPlanTargetsPriorityOrder?: Maybe<UpdateReportTreatmentPlanTargetPriorityOrder>;
  updateSessionRatingAndCommnent?: Maybe<UpdateSessionRatingAndComment>;
  updateTargetExcludeFromReport?: Maybe<UpdateTargetExcludeFromReport>;
  updateTargetPredictionStatusM2m?: Maybe<UpdateTargetPredictionStatusM2M>;
  updateTargetProgressSummary?: Maybe<UpdateTargetProgressSummary>;
  updateTargetProgressSummaryM2m?: Maybe<UpdateTargetProgressSummaryM2M>;
  updateTargetsPriorityOrder?: Maybe<UpdateTargetPriorityOrder>;
  updateTaxTransaction?: Maybe<UpdateTaxTransaction>;
  /** @deprecated Use updateTherapzGoalsAndTargets on the internal M2M schema (/graphql/internal/); requires organization_id (PLA-803). */
  updateTherapzGoalsAndTargets?: Maybe<UpdateTherapzGoalsAndTargets>;
  updateTranscriptSpeaker?: Maybe<UpdateTranscriptSpeaker>;
  updateTreatmentPlanCustomFieldFileUrl?: Maybe<UpdateTreatmentPlanCustomFieldFileUrl>;
  updateTreatmentPlanPassageManualSyncM2m?: Maybe<UpdateReportPassageManualSync>;
  updateVideoSessionScore?: Maybe<UpdateVideoSessionScore>;
  updateVideoSessionStatus?: Maybe<UpdateVideoSessionStatus>;
  uploadAnnotationFile?: Maybe<UploadAnnotationFile>;
  uploadAnnotationMedia?: Maybe<UploadAnnotationMedia>;
  uploadSessionVideoForLearner?: Maybe<UploadSessionVideoForLearner>;
  uploadVideoSessionVideo?: Maybe<UploadVideoSessionVideoMutation>;
  upsertChatSuggestions?: Maybe<UpsertChatSuggestions>;
  /**
   * Get-or-create an OrganizationSuggestionCriteria join record and set enabled.
   * Used for base criteria that don't yet have a real join record (virtual entries).
   */
  upsertOrganizationSuggestionCriteria?: Maybe<UpsertOrganizationSuggestionCriteria>;
  upsertReportPayorMetadata?: Maybe<UpsertReportPayorMetadata>;
  validateUserAndOrganizationData?: Maybe<ValidateUserAndOrganizationData>;
  verifyToken?: Maybe<Verify>;
  writeEvalPromptThemes?: Maybe<WriteEvalPromptThemes>;
};


export type MutationActivateCaregiverToOrganizationArgs = {
  activationCode: Scalars['String']['input'];
  childDob: Scalars['Date']['input'];
  lastName: Scalars['String']['input'];
};


export type MutationAddAiReportSectionFieldsArgs = {
  fieldsData: Array<InputMaybe<AiReportSectionFieldInput>>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  reportId: Scalars['ID']['input'];
  reportSectionId: Scalars['ID']['input'];
};


export type MutationAddClipAnnotationDataByM2mArgs = {
  clipAnnotationData: AddClipAnnotationDataByM2MInput;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationAddMissingTranscriptDataBySuperadminArgs = {
  transcriptId: Scalars['ID']['input'];
};


export type MutationAddOrUpdateReportSignatureSectionDetailArgs = {
  input: ReportSignatureSectionDetailInput;
};


export type MutationAddReportClientDetailsArgs = {
  clientDetails: LearnerCaregiverMinimalInput;
  reportId: Scalars['ID']['input'];
};


export type MutationAddReportGoalsSuggestedByAiArgs = {
  aiGoalsData: Array<InputMaybe<AiSuggestedGoalInput>>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  reportTreatmentPlanId: Scalars['ID']['input'];
};


export type MutationAddReportTargetsSuggestedByAiArgs = {
  aiTargetsData: Array<InputMaybe<AiSuggestedTargetInput>>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  reportTreatmentPlanId: Scalars['ID']['input'];
};


export type MutationAddSessionAnalyzerFeedbackArgs = {
  sessionAnalyzerFeedbackDetails: SessionAnalyzerFeedbackDetails;
};


export type MutationAddSuggestedReportGoalsArgs = {
  aiSuggestedGoalIds: Array<InputMaybe<Scalars['ID']['input']>>;
  reportId: Scalars['ID']['input'];
};


export type MutationAddSuggestedReportTargetsArgs = {
  aiSuggestedTargetsIds: Array<InputMaybe<Scalars['ID']['input']>>;
  reportGoalId: Scalars['ID']['input'];
  reportId: Scalars['ID']['input'];
};


export type MutationAddTranscriptDataArgs = {
  input: AddTranscriptDataInput;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationAddUpdateReportTreatmentPlanPrioritizeFieldsArgs = {
  prioritizeFieldsDetails: ReportTreatmentPlanPrioritizeFieldsInput;
  reportId: Scalars['ID']['input'];
};


export type MutationAddUpdateReportTreatmentPlanPrioritizeFieldsByAiArgs = {
  assessmentId: Scalars['ID']['input'];
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  prioritizeFieldsDetailsAi: ReportTreatmentPlanPrioritizeFieldsAiInput;
};


export type MutationApplyReportCommentArgs = {
  id: Scalars['ID']['input'];
};


export type MutationArchiveExternalClientsNotInArgs = {
  input: ArchiveExternalClientsNotInInput;
};


export type MutationArchiveGoalBankCurriculumArgs = {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  curriculumId: Scalars['ID']['input'];
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationArchiveUnarchiveReportArgs = {
  archive: Scalars['Boolean']['input'];
  reportId: Scalars['ID']['input'];
};


export type MutationAssignAnnotaterToMediaArgs = {
  annotaterId?: InputMaybe<Scalars['ID']['input']>;
  mediaId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationBackfillOrganizationUserRolesArgs = {
  input: BackfillOrganizationUserRolesInput;
};


export type MutationBackfillSelfServeUserRolesArgs = {
  organizationId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationBookCareAppointmentArgs = {
  customer: CareCustomerAppointmentInputType;
  endTime: Scalars['String']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  resourceIds: Array<InputMaybe<Scalars['String']['input']>>;
  serviceId: Scalars['String']['input'];
  startTime: Scalars['String']['input'];
};


export type MutationBulkReassignReportGoalsArgs = {
  goals: Array<InputMaybe<ReassignReportGoalInput>>;
};


export type MutationCancelServiceArgs = {
  paymentIntentId: Scalars['String']['input'];
};


export type MutationChangeActiveStatusAnnotationArgs = {
  active: Scalars['Boolean']['input'];
  annotation: Scalars['ID']['input'];
};


export type MutationChangePassageEventsInUseArgs = {
  goalIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  inUse: Scalars['Boolean']['input'];
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  targetIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};


export type MutationChangePassagePhasesInUseArgs = {
  goalIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  inUse: Scalars['Boolean']['input'];
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  targetIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};


export type MutationChangePassageProgramingInUseStatusArgs = {
  goalIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  inUse: Scalars['Boolean']['input'];
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  targetIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};


export type MutationChangeTreatmentPlanDeleteStatusArgs = {
  goalIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  inUse?: InputMaybe<Scalars['Boolean']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  targetIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};


export type MutationChargeSavedPaymentMethodArgs = {
  paymentIntentId: Scalars['String']['input'];
};


export type MutationCheckDifferenceBetweenAuth0AndFdmRolesArgs = {
  input: CheckAuth0UserRolesAndFdmUserRolesDiffInput;
};


export type MutationCompleteAnnotationFileUploadArgs = {
  input: CompleteUploadAnnotationFileInput;
};


export type MutationCompleteChatVideoUploadArgs = {
  input: CompleteChatVideoUploadInput;
};


export type MutationCompleteExportReportGenerationArgs = {
  input: CompleteExportReportGenerationInput;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationCompleteLearnerFilePdfPreviewArgs = {
  learnerFileId: Scalars['String']['input'];
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  pdfS3Key: Scalars['String']['input'];
};


export type MutationCompleteReportPdfConversionArgs = {
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  pdfS3Key: Scalars['String']['input'];
  reportId: Scalars['String']['input'];
};


export type MutationCompleteSampleTemplateGenerationArgs = {
  input: CompleteSampleTemplateGenerationInput;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationCompleteSessionVideoForLearnerArgs = {
  input: CompleteSessionVideoForLearnerInput;
};


export type MutationCompleteUploadTaskMediaArgs = {
  input: CompleteUploadTaskMediaInput;
};


export type MutationCompleteUploadVideoArgs = {
  fileKey: Scalars['String']['input'];
  mediaId: Scalars['ID']['input'];
  uploadId: Scalars['String']['input'];
  uploadParts: Array<InputMaybe<CompleteUploadMediaInput>>;
};


export type MutationCompleteUploadVideoSessionArgs = {
  fileKey: Scalars['String']['input'];
  uploadId: Scalars['String']['input'];
  uploadParts: Array<InputMaybe<CompleteUploadVideoSessionPartInput>>;
  videoSessionId: Scalars['ID']['input'];
};


export type MutationCompleteZoomConnectArgs = {
  code: Scalars['String']['input'];
};


export type MutationConfirmPaymentAndAddAssessmentCreditsArgs = {
  paymentIntentId: Scalars['String']['input'];
};


export type MutationConsumePendingMfaCodeArgs = {
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  workflowId: Scalars['String']['input'];
};


export type MutationCreateAnnotationArgs = {
  annotater: Scalars['ID']['input'];
  category: Scalars['String']['input'];
  endTime: Scalars['Time']['input'];
  mediaId: Scalars['ID']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  startTime: Scalars['Time']['input'];
  value: Scalars['String']['input'];
};


export type MutationCreateAnnotationCategoryArgs = {
  category?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateAnnotationValidatedArgs = {
  annotater: Scalars['ID']['input'];
  category: Scalars['String']['input'];
  endTime: Scalars['Time']['input'];
  mediaId: Scalars['ID']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  startTime: Scalars['Time']['input'];
  value: Scalars['String']['input'];
};


export type MutationCreateAnnotatorArgs = {
  annotatorDetails: CreateAnnotatorInput;
};


export type MutationCreateAudioArgs = {
  filePath: Scalars['String']['input'];
  mediaId: Scalars['ID']['input'];
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  videoSessionId: Scalars['ID']['input'];
};


export type MutationCreateBaseSuggestionCriteriaArgs = {
  category?: InputMaybe<Scalars['String']['input']>;
  content: Scalars['String']['input'];
  name: Scalars['String']['input'];
};


export type MutationCreateCareResourceSingleAllocationBlockArgs = {
  endDatetime: Scalars['String']['input'];
  resourceEmail: Scalars['String']['input'];
  startDatetime: Scalars['String']['input'];
};


export type MutationCreateCareResourceWeeklyAllocationBlockArgs = {
  endDate: Scalars['String']['input'];
  friday?: InputMaybe<DayScheduleInputType>;
  monday?: InputMaybe<DayScheduleInputType>;
  resourceEmail: Scalars['String']['input'];
  saturday?: InputMaybe<DayScheduleInputType>;
  startDate: Scalars['String']['input'];
  sunday?: InputMaybe<DayScheduleInputType>;
  thursday?: InputMaybe<DayScheduleInputType>;
  tuesday?: InputMaybe<DayScheduleInputType>;
  wednesday?: InputMaybe<DayScheduleInputType>;
};


export type MutationCreateCaregiverAuth0UserArgs = {
  auth0Id: Scalars['String']['input'];
  auth0OrganizationId: Scalars['String']['input'];
  caregiver?: InputMaybe<Scalars['ID']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationCreateCaregiverMetadataArgs = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  addressLine1?: InputMaybe<Scalars['String']['input']>;
  addressLine2?: InputMaybe<Scalars['String']['input']>;
  birthDate?: InputMaybe<Scalars['Date']['input']>;
  caregiver?: InputMaybe<Scalars['ID']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  createCaregiver?: InputMaybe<Scalars['Boolean']['input']>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  employer?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  isAllowedAppAccess?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  maritalStatus?: InputMaybe<Scalars['String']['input']>;
  occupation?: InputMaybe<Scalars['String']['input']>;
  organization?: InputMaybe<Scalars['String']['input']>;
  phoneNumber1?: InputMaybe<Scalars['String']['input']>;
  phoneNumber2?: InputMaybe<Scalars['String']['input']>;
  preferredLanguage?: InputMaybe<Scalars['String']['input']>;
  preferredName?: InputMaybe<Scalars['String']['input']>;
  requiresInterpreter?: InputMaybe<Scalars['Boolean']['input']>;
  smsAgreement?: InputMaybe<Scalars['Boolean']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateChatArgs = {
  initialMessage?: InputMaybe<Scalars['String']['input']>;
  learnerId: Scalars['ID']['input'];
  summary?: InputMaybe<Scalars['String']['input']>;
  type: Scalars['String']['input'];
};


export type MutationCreateChatMessageArgs = {
  input: CreateChatMessageInput;
};


export type MutationCreateChatNoteArgs = {
  input: CreateUpdateChatNoteInput;
};


export type MutationCreateChatTagArgs = {
  input: CreateChatTagInput;
};


export type MutationCreateChatbotChatArgs = {
  learnerId: Scalars['ID']['input'];
  summary?: InputMaybe<Scalars['String']['input']>;
  type: Scalars['String']['input'];
};


export type MutationCreateChatbotChatMessageArgs = {
  input: CreateChatbotChatMessageInput;
};


export type MutationCreateCheckoutSessionArgs = {
  priceId?: InputMaybe<Scalars['String']['input']>;
  redirectOrigin: Scalars['String']['input'];
};


export type MutationCreateClassificationFeedbackArgs = {
  input: ClassficationFeedbackInput;
};


export type MutationCreateClientFromEhrArgs = {
  addressLine1?: InputMaybe<Scalars['String']['input']>;
  addressLine2?: InputMaybe<Scalars['String']['input']>;
  birthDate?: InputMaybe<Scalars['Date']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  firstName: Scalars['String']['input'];
  gender?: InputMaybe<Scalars['String']['input']>;
  isImportForReassessment?: InputMaybe<Scalars['Boolean']['input']>;
  lastName: Scalars['String']['input'];
  learnerExternalId: Scalars['String']['input'];
  preferredName?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  zipCode?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateClinicLeadArgs = {
  input: CreateClinicLeadInput;
};


export type MutationCreateClipAnnotationByM2mArgs = {
  clipAnnotationDetails: CreateClipAnnotationByM2MInput;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationCreateClipAssignmentArgs = {
  clipAssignmentDetails: CreateClipAssignmentInput;
};


export type MutationCreateCloudRecordingMediaM2mArgs = {
  input: CreatCloudRecordingMediaM2MInput;
};


export type MutationCreateCloudRecordingVideoSessionM2mArgs = {
  input: CreateCloudRecordingVideoSessionM2MInput;
};


export type MutationCreateCombinedMediaArgs = {
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  videoSessionId: Scalars['ID']['input'];
};


export type MutationCreateCommunityMemberArgs = {
  bio?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  headline?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  spaceIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};


export type MutationCreateEnterpriseReportExportTemplateArgs = {
  input: CreateReportTemplateFileInput;
};


export type MutationCreateExportReportGenerationArgs = {
  input: GeneratePdfInput;
};


export type MutationCreateGoalBankFolderArgs = {
  input: CreateGoalBankFolderInput;
};


export type MutationCreateGoalBankGoalsArgs = {
  input: CreateGoalBankGoalsInput;
};


export type MutationCreateGoalBankLongTermGoalsArgs = {
  input: CreateGoalBankLongTermGoalsInput;
};


export type MutationCreateGoalBankTargetsArgs = {
  input: CreateGoalBankTargetsInput;
};


export type MutationCreateGoalsAndTargetsArgs = {
  goals: Array<GoalWithTargetsInput>;
  learnerId: Scalars['ID']['input'];
};


export type MutationCreateHatchPlanArgs = {
  input: CreateHatchPlanInput;
};


export type MutationCreateHatchPlanVisualizationArgs = {
  input: CreateHatchPlanVisualizationInput;
};


export type MutationCreateIndependentLearnerFileArgs = {
  input: CreateIndependentLearnerFileInput;
};


export type MutationCreateLearnerAndVideoSessionByM2mArgs = {
  learnerName: Scalars['String']['input'];
  organizationId: Scalars['Int']['input'];
};


export type MutationCreateLearnerAvailabiltyArgs = {
  day?: InputMaybe<Scalars['String']['input']>;
  learner?: InputMaybe<Scalars['ID']['input']>;
  timeOfDay?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateLearnerCaregiverArgs = {
  availability?: InputMaybe<AvailabilityInput>;
  caregiver?: InputMaybe<CaregiverInput>;
  insurance?: InputMaybe<InsuranceInput>;
  learner: LearnerInput;
  providerIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  sendIntake?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationCreateLearnerEducationArgs = {
  educationSetting?: InputMaybe<Scalars['String']['input']>;
  grade?: InputMaybe<Scalars['String']['input']>;
  learner?: InputMaybe<Scalars['ID']['input']>;
  nameOfSchool?: InputMaybe<Scalars['String']['input']>;
  specialEducation?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationCreateLearnerInsuranceArgs = {
  input: CreateLearnerInsuranceInput;
};


export type MutationCreateLearnerMedicationsArgs = {
  dosage?: InputMaybe<Scalars['String']['input']>;
  learner?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  prescriber?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateLearnerMetadataArgs = {
  address?: InputMaybe<Scalars['String']['input']>;
  addressLine2?: InputMaybe<Scalars['String']['input']>;
  birthDate?: InputMaybe<Scalars['Date']['input']>;
  birthWeightLbs?: InputMaybe<Scalars['Float']['input']>;
  birthWeightOz?: InputMaybe<Scalars['Float']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  createLearner?: InputMaybe<Scalars['Boolean']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  learner?: InputMaybe<Scalars['ID']['input']>;
  organization?: InputMaybe<Scalars['ID']['input']>;
  preferredLanguage?: InputMaybe<Scalars['String']['input']>;
  preferredName?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateLearnerPrimaryProviderArgs = {
  address?: InputMaybe<Scalars['String']['input']>;
  addressLine2?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  learner?: InputMaybe<Scalars['ID']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  primaryCareProvider?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateLearnerVideoSessionArgs = {
  date: Scalars['Date']['input'];
  engagementScore?: InputMaybe<Scalars['Float']['input']>;
  engagementScoreVersion?: InputMaybe<Scalars['String']['input']>;
  learnerId: Scalars['ID']['input'];
  sessionStatus: VideoSessionStatusEnums;
  sourceType?: InputMaybe<VideoSessionSourceTypeEnums>;
  totalDuration?: InputMaybe<Scalars['Float']['input']>;
};


export type MutationCreateLearnerWithSessionAndMediaM2mArgs = {
  input: CreateLearnerWithVideoSessionAndMediaM2MInput;
};


export type MutationCreateMediaArgs = {
  mediaSource: MediaSourceEnum;
  mediaType?: InputMaybe<Scalars['String']['input']>;
  videoSessionId: Scalars['ID']['input'];
};


export type MutationCreateMediaAiPredictionArgs = {
  mediaAiPredInputs: Array<InputMaybe<MediaAiPredictionInput>>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationCreateMediaAiPredictionMetricsArgs = {
  mediaAiMetricsInputs: Array<InputMaybe<MediaAiPredictionMetricsInput>>;
  mediaAiPredictionId: Scalars['ID']['input'];
  organizationId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationCreateMediaClassificationPredictionArgs = {
  input: SessionMediaClassificationInput;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationCreateMediaClipArgs = {
  clipDetails: CreateMediaClipInput;
};


export type MutationCreateMediaCommentArgs = {
  input: MediaCommentInput;
};


export type MutationCreateMediaDeviceArgs = {
  active?: InputMaybe<Scalars['String']['input']>;
  availabiltyStatus?: InputMaybe<Scalars['String']['input']>;
  deviceName?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateMediaFronteraM2mArgs = {
  filePath: Scalars['String']['input'];
  mediaSource: MediaSourceEnum;
  mediaType: Scalars['String']['input'];
  organizationId: Scalars['Int']['input'];
  videoSessionId: Scalars['ID']['input'];
};


export type MutationCreateMediaM2mArgs = {
  filePath: Scalars['String']['input'];
  mediaSource?: InputMaybe<MediaSourceEnum>;
  mediaType: Scalars['String']['input'];
  organizationId: Scalars['Int']['input'];
  videoSessionId: Scalars['ID']['input'];
};


export type MutationCreateMediaMetadataArgs = {
  location?: InputMaybe<Scalars['String']['input']>;
  media: Scalars['ID']['input'];
  mediaDevice: Scalars['ID']['input'];
};


export type MutationCreateMediaStreamArgs = {
  endTime: Scalars['DateTime']['input'];
  mediaId: Scalars['ID']['input'];
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  startTime: Scalars['DateTime']['input'];
  transcriptId?: InputMaybe<Scalars['ID']['input']>;
  videoSessionId: Scalars['ID']['input'];
};


export type MutationCreateMediaTargetPredictionFeedbackArgs = {
  input: MediaTargetPredictionFeedbackInput;
};


export type MutationCreateMediaTargetPredictionsArgs = {
  input: MediaTargetPredictionsInput;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationCreateMultipleLearnerAvailabiltiesArgs = {
  days?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  learner?: InputMaybe<Scalars['ID']['input']>;
  timesOfDay?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationCreateMultipleLearnerMedicationsArgs = {
  dosage?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  learner?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  prescriber?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationCreateMultipleOnboardingQuestionsArgs = {
  aditionalAnswers?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  answers?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  learner?: InputMaybe<Scalars['ID']['input']>;
  questions?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationCreateNotificationArgs = {
  input: CreateNotificationInput;
};


export type MutationCreateOnboardingQuestionArgs = {
  aditionalAnswer?: InputMaybe<Scalars['String']['input']>;
  answer?: InputMaybe<Scalars['String']['input']>;
  learner?: InputMaybe<Scalars['ID']['input']>;
  question?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateOrUpdateLearnerFormStatusArgs = {
  formName: OnboardingFormStatusEnumType;
  formStatus: Scalars['String']['input'];
  learner: Scalars['ID']['input'];
};


export type MutationCreateOrUpdateSesEmailTemplateArgs = {
  subject: Scalars['String']['input'];
  templateName: Scalars['String']['input'];
  textContent?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateOrganizationSuggestionCriteriaArgs = {
  category?: InputMaybe<Scalars['String']['input']>;
  content: Scalars['String']['input'];
  name: Scalars['String']['input'];
};


export type MutationCreateOrganizationTemplateLogoArgs = {
  input: CreateOrganizationTemplateLogoInput;
};


export type MutationCreateParsedTreatmentPlanFileDataArgs = {
  input: CreateParsedTreatmentPlanFileDataInput;
  learnerId: Scalars['ID']['input'];
};


export type MutationCreatePassageSessionsArgs = {
  deleteMissingSessionTargetProgress?: InputMaybe<Scalars['Boolean']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  passageSessionInformation: Array<InputMaybe<PassageSessionInformation>>;
};


export type MutationCreatePaymentIntentArgs = {
  priceId: Scalars['String']['input'];
};


export type MutationCreatePromptArgs = {
  input: PromptInput;
};


export type MutationCreateProviderArgs = {
  provider: ProviderInput;
};


export type MutationCreateProviderFileArgs = {
  input: CreateProviderFileInput;
};


export type MutationCreateProviderFromAuth0UserArgs = {
  auth0Id: Scalars['String']['input'];
  email: Scalars['String']['input'];
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  organizationAuth0Id: Scalars['String']['input'];
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  roles: Array<InputMaybe<Scalars['String']['input']>>;
};


export type MutationCreateReassessmentReportGoalsArgs = {
  goals: Array<InputMaybe<SelectedEhrGoalInput>>;
  reportId: Scalars['ID']['input'];
};


export type MutationCreateRecommendationBankFolderArgs = {
  input: CreateRecommendationBankFolderInput;
};


export type MutationCreateRecommendationBankItemArgs = {
  input: CreateRecommendationBankItemInput;
};


export type MutationCreateReportArgs = {
  learner?: InputMaybe<Scalars['ID']['input']>;
  learnerFileId?: InputMaybe<Scalars['ID']['input']>;
  reportClientMetaData?: InputMaybe<Scalars['JSONString']['input']>;
  reportMetaData?: InputMaybe<Scalars['JSONString']['input']>;
  reportTemplateId?: InputMaybe<Scalars['ID']['input']>;
  reportType: ReportTypeEnums;
};


export type MutationCreateReportCommentArgs = {
  baseValue?: InputMaybe<Scalars['String']['input']>;
  body: Scalars['String']['input'];
  fieldId?: InputMaybe<Scalars['ID']['input']>;
  parentId?: InputMaybe<Scalars['ID']['input']>;
  proposedValue?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateReportFromTemplateArgs = {
  reportId: Scalars['ID']['input'];
};


export type MutationCreateReportInternalLearnerFileArgs = {
  input: CreateReportInternalLearnerFileInput;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationCreateReportLearnerFileArgs = {
  input: CreateReportLearnerFileInput;
};


export type MutationCreateReportSectionFieldArgs = {
  fieldData: ReportSectionFieldInput;
  reportId: Scalars['ID']['input'];
  reportSectionId: Scalars['ID']['input'];
};


export type MutationCreateReportSectionFieldFileArgs = {
  input: CreateReportSectionFieldFileInput;
};


export type MutationCreateReportSectionsArgs = {
  reportId: Scalars['ID']['input'];
  runWorkflow?: InputMaybe<Scalars['Boolean']['input']>;
  sections: Array<InputMaybe<ReportSectionInput>>;
};


export type MutationCreateReportSuggestionsArgs = {
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  predictionId: Scalars['String']['input'];
  reportId: Scalars['ID']['input'];
  reportSuggestions: Array<InputMaybe<ReportSuggestionInput>>;
};


export type MutationCreateReportTemplateLogoArgs = {
  input: CreateReportTemplateFileInput;
};


export type MutationCreateReportTemplateSectionsArgs = {
  input: ReportTemplateSectionsInput;
};


export type MutationCreateReportTemplateSuggestionCriteriaArgs = {
  category?: InputMaybe<Scalars['String']['input']>;
  content: Scalars['String']['input'];
  name: Scalars['String']['input'];
  reportTemplateId: Scalars['ID']['input'];
};


export type MutationCreateSampleTemplateArgs = {
  reportTemplate: Scalars['ID']['input'];
};


export type MutationCreateSelfServeCaregiverFromAuth0UserArgs = {
  auth0Id: Scalars['String']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateSelfServeProviderFromAuth0UserArgs = {
  auth0Id: Scalars['String']['input'];
  email: Scalars['String']['input'];
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationCreateSessionAiPredsArgs = {
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  sessionAiPredInputs: Array<InputMaybe<SessionAiPredictionInput>>;
};


export type MutationCreateSessionEngagementScoreArgs = {
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  sessionEngagementDetails: Array<InputMaybe<SessionEngagementDetails>>;
};


export type MutationCreateSessionInsightsArgs = {
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  sessionEngagementInsightInputs: Array<InputMaybe<SessionEngagementInsightInput>>;
};


export type MutationCreateTaskLearnerFileArgs = {
  input: CreateTaskLearnerFileInput;
};


export type MutationCreateTaskMediaArgs = {
  input: CreateTaskMediaInput;
};


export type MutationCreateTranscriptArgs = {
  aiModelVersion?: InputMaybe<Scalars['String']['input']>;
  filePath: Scalars['String']['input'];
  mediaId: Scalars['ID']['input'];
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  transcriptModel: Scalars['String']['input'];
  transcriptType: Scalars['String']['input'];
  videoSessionId: Scalars['ID']['input'];
};


export type MutationCreateTreatmentPlanCustomFieldFileArgs = {
  input: CreateTreatmentPlanCustomFieldFileInput;
};


export type MutationCreateUpdateCustomFieldValueArgs = {
  content: Scalars['String']['input'];
  customFieldId?: InputMaybe<Scalars['ID']['input']>;
  fieldIdentifier?: InputMaybe<Scalars['String']['input']>;
  reportDomainId?: InputMaybe<Scalars['ID']['input']>;
  reportGoalId?: InputMaybe<Scalars['ID']['input']>;
  reportTargetId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationCreateUpdateReportGoalArgs = {
  goalInput: ReportGoalInput;
  learner: Scalars['ID']['input'];
};


export type MutationCreateUpdateReportTargetArgs = {
  learner: Scalars['ID']['input'];
  targetData: ReportTargetInput;
};


export type MutationCreateUpdateSessionMediaReviewActivityLogArgs = {
  activityLogInput: SessionMediaReviewActivityLogInput;
};


export type MutationCreateUpdateVoiceSignatureArgs = {
  input: CreateUpdateVoiceSignatureInput;
};


export type MutationCreateVideoSessionArgs = {
  date: Scalars['DateTime']['input'];
};


export type MutationCreateVideoSessionAndMediaInClinicArgs = {
  mediaFilePath: Scalars['String']['input'];
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  therapySessionId: Scalars['Int']['input'];
};


export type MutationCreateVideoSessionM2mArgs = {
  date: Scalars['DateTime']['input'];
  learnerId?: InputMaybe<Scalars['ID']['input']>;
  organizationId: Scalars['Int']['input'];
  providerId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationDeleteAnnotationArgs = {
  annotationId?: InputMaybe<Scalars['ID']['input']>;
  forceDelete?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationDeleteAnnotationFileArgs = {
  clipAnnotationId: Scalars['ID']['input'];
};


export type MutationDeleteAnnotationMediaArgs = {
  mediaId: Scalars['ID']['input'];
};


export type MutationDeleteCareResourceSingleAllocationBlockArgs = {
  allocationId: Scalars['String']['input'];
};


export type MutationDeleteCareResourceWeeklyAllocationBlockArgs = {
  allocationId: Scalars['String']['input'];
};


export type MutationDeleteChatArgs = {
  chatId: Scalars['ID']['input'];
};


export type MutationDeleteChatNoteArgs = {
  chatNoteId: Scalars['ID']['input'];
};


export type MutationDeleteClipAssignemntAnnotationArgs = {
  clipAnnotationId: Scalars['ID']['input'];
};


export type MutationDeleteDeviceTokenArgs = {
  input: DeleteDeviceTokenInput;
};


export type MutationDeleteEnterpriseReportTemplateArgs = {
  reportTemplateId: Scalars['ID']['input'];
};


export type MutationDeleteGoalBankFolderArgs = {
  input: DeleteGoalBankFolderInput;
};


export type MutationDeleteGoalBankGoalArgs = {
  input: DeleteGoalBankGoalInput;
};


export type MutationDeleteGoalBankLongTermGoalArgs = {
  input: DeleteGoalBankLongTermGoalInput;
};


export type MutationDeleteGoalBankTargetArgs = {
  input: DeleteGoalBankTargetInput;
};


export type MutationDeleteGoalsForLearnerArgs = {
  learnerId: Scalars['ID']['input'];
  organizationId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationDeleteLearnerAvailabiltyArgs = {
  day?: InputMaybe<Scalars['String']['input']>;
  learner?: InputMaybe<Scalars['ID']['input']>;
  timeOfDay?: InputMaybe<Scalars['String']['input']>;
};


export type MutationDeleteLearnerFileArgs = {
  fileId: Scalars['ID']['input'];
};


export type MutationDeleteMediaClipArgs = {
  clipId: Scalars['ID']['input'];
};


export type MutationDeletePaymentMethodArgs = {
  paymentMethodId: Scalars['String']['input'];
};


export type MutationDeleteProviderFileArgs = {
  fileId: Scalars['ID']['input'];
};


export type MutationDeleteRecommendationBankFolderArgs = {
  input: DeleteRecommendationBankFolderInput;
};


export type MutationDeleteRecommendationBankItemArgs = {
  recommendationBankItemId: Scalars['ID']['input'];
};


export type MutationDeleteReportArgs = {
  report: Scalars['ID']['input'];
};


export type MutationDeleteReportCommentArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteReportSectionArgs = {
  reportId: Scalars['ID']['input'];
  sectionId: Scalars['ID']['input'];
};


export type MutationDeleteReportSectionFieldArgs = {
  fieldId: Scalars['ID']['input'];
  sectionId: Scalars['ID']['input'];
};


export type MutationDeleteReportTemplateArgs = {
  reportTemplateId: Scalars['ID']['input'];
};


export type MutationDeleteSesTemplateArgs = {
  templateName: Scalars['String']['input'];
};


export type MutationDisconnectCaregiverFromOrganizationArgs = {
  caregiver?: InputMaybe<Scalars['ID']['input']>;
  organization: Scalars['ID']['input'];
};


export type MutationDismissNotificationArgs = {
  input: DismissNotificationInput;
};


export type MutationDispatchMediaCommentNotificationsArgs = {
  commentId: Scalars['ID']['input'];
};


export type MutationDuplicateReportGoalArgs = {
  learner: Scalars['ID']['input'];
  reportGoalId: Scalars['ID']['input'];
};


export type MutationDuplicateReportTemplateArgs = {
  input: DuplicateReportTemplateInput;
};


export type MutationEditReportCommentArgs = {
  body: Scalars['String']['input'];
  id: Scalars['ID']['input'];
};


export type MutationEhrRequestActionArgs = {
  actionType: Scalars['String']['input'];
  learnerId?: InputMaybe<Scalars['ID']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  reportId?: InputMaybe<Scalars['ID']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};


export type MutationEhrStartWorkflowAndLoginArgs = {
  mfa?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};


export type MutationEhrTargetCreationWorkflowArgs = {
  goalExternalId: Scalars['ID']['input'];
  learnerExternalId: Scalars['ID']['input'];
};


export type MutationEhrUpdateLoginStatusArgs = {
  alert?: InputMaybe<Scalars['String']['input']>;
  loginStatus: LoginStateEnum;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  workflowId: Scalars['String']['input'];
};


export type MutationEhrUpdateSyncStatusArgs = {
  ehrSyncAlert?: InputMaybe<EhrSyncAlertInput>;
  learnerExternalId: Scalars['String']['input'];
  organizationId: Scalars['BigInt']['input'];
  scraperStatusEnum: LearnerImportStatusEnum;
  workflowId: Scalars['String']['input'];
};


export type MutationEndEhrScraperWorkflowArgs = {
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  workflowId: Scalars['String']['input'];
};


export type MutationExportDraftReportDocumentArgs = {
  exportType: ExportTypeEnum;
  reportId: Scalars['ID']['input'];
};


export type MutationExportEhrEnumsArgs = {
  input?: InputMaybe<ExportEhrEnums>;
};


export type MutationExportGoalBankCurriculumArgs = {
  curriculumId: Scalars['ID']['input'];
};


export type MutationFailLearnerFilePdfPreviewArgs = {
  learnerFileId: Scalars['String']['input'];
  organizationId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationFailReportPdfConversionArgs = {
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  reportId: Scalars['String']['input'];
};


export type MutationFillGasTablesArgs = {
  reportId: Scalars['ID']['input'];
};


export type MutationFinishChatArgs = {
  chatId: Scalars['ID']['input'];
};


export type MutationFinishChatbotChatArgs = {
  chatId: Scalars['ID']['input'];
};


export type MutationGenerateLearnerFilePdfPreviewArgs = {
  learnerFileId: Scalars['ID']['input'];
};


export type MutationGenerateReportPdfFromDocxArgs = {
  report: Scalars['ID']['input'];
  reportDocxFile: Scalars['Upload']['input'];
};


export type MutationGenerateTranscriptCsvArgs = {
  input: GenerateTranscriptCsvInput;
};


export type MutationGetGoalBankUploadUrlArgs = {
  contentType: Scalars['String']['input'];
  fileName: Scalars['String']['input'];
};


export type MutationImportClientFromEhrArgs = {
  learnerExternalId: Scalars['String']['input'];
  learningTreeReview?: InputMaybe<Scalars['Boolean']['input']>;
  reportId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationImportGoalBankArgs = {
  input: ImportGoalBankInput;
};


export type MutationImportGoalsFromEhrArgs = {
  goalData?: InputMaybe<Array<InputMaybe<GoalEhrImportInput>>>;
  learnerExternalId: Scalars['String']['input'];
  organizationId: Scalars['BigInt']['input'];
  reportId?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationImportReportTemplateJsonArgs = {
  json: Scalars['String']['input'];
  organizationIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};


export type MutationImportReportTemplateJsonM2mArgs = {
  json: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
};


export type MutationImportSessionsFromEhrArgs = {
  learnerExternalId: Scalars['String']['input'];
  organizationId: Scalars['BigInt']['input'];
  sessions?: InputMaybe<Array<InputMaybe<SessionEhrImportInput>>>;
};


export type MutationImportTargetsFromEhrArgs = {
  learnerExternalId: Scalars['String']['input'];
  organizationId: Scalars['BigInt']['input'];
  reportId?: InputMaybe<Scalars['Int']['input']>;
  targets?: InputMaybe<Array<InputMaybe<TargetEhrImportInput>>>;
};


export type MutationInitiateChatVideoUploadArgs = {
  input: InitiateChatVideoUploadInput;
};


export type MutationLoadGoalBankArgs = {
  input: LoadGoalBankInput;
};


export type MutationLoadRecommendationBankArgs = {
  input: LoadRecommendationBankInput;
};


export type MutationLockCrLearningTreeArgs = {
  learnerId: Scalars['ID']['input'];
  reportId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationManageReportDomainsArgs = {
  deletedDomainIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  domains: Array<InputMaybe<ManageReportDomainInput>>;
  goalMoves?: InputMaybe<Array<InputMaybe<GoalDomainAssignmentInput>>>;
  reportId: Scalars['ID']['input'];
};


export type MutationManuallyMarkMediaAsViewedArgs = {
  isViewed: Scalars['Boolean']['input'];
  mediaId: Scalars['ID']['input'];
};


export type MutationMarkLearnerFileAsProcessErrorArgs = {
  errorCode?: InputMaybe<ProcessingFailureCodeEnum>;
  errorMsg?: InputMaybe<Scalars['String']['input']>;
  fileId: Scalars['ID']['input'];
  organizationId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationMarkLearnerFileAsProcessSuccessArgs = {
  fileId: Scalars['ID']['input'];
  organizationId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationMarkLearnerFileAsUploadedArgs = {
  fileId: Scalars['ID']['input'];
};


export type MutationMarkProviderFileAsUploadedArgs = {
  fileId: Scalars['ID']['input'];
};


export type MutationMigrateDuplicatedOrganizationArgs = {
  learnerConnections?: InputMaybe<Array<InputMaybe<LearnerConnection>>>;
  newOrganization: Scalars['ID']['input'];
  oldOrganization: Scalars['ID']['input'];
};


export type MutationMoveGoalBankGoalArgs = {
  input: MoveGoalBankGoalInput;
};


export type MutationMoveGoalBankLongTermGoalArgs = {
  input: MoveGoalBankLongTermGoalInput;
};


export type MutationMoveGoalBankTargetArgs = {
  input: MoveGoalBankTargetInput;
};


export type MutationMoveRecommendationBankItemArgs = {
  input: MoveRecommendationBankItemInput;
};


export type MutationMoveReportSectionArgs = {
  input: MoveReportSectionInput;
};


export type MutationMoveReportSectionFieldToAnotherSectionArgs = {
  fieldId: Scalars['ID']['input'];
  targetSectionId: Scalars['ID']['input'];
};


export type MutationMoveReportSectionFieldUpAndDownArgs = {
  fieldId: Scalars['ID']['input'];
  moveUp: Scalars['Boolean']['input'];
  reportSectionId: Scalars['ID']['input'];
};


export type MutationMoveReportSectionUpAndDownArgs = {
  moveUp: Scalars['Boolean']['input'];
  pageLocation: Scalars['String']['input'];
  reportId: Scalars['ID']['input'];
  sectionId: Scalars['ID']['input'];
};


export type MutationOpenChatArgs = {
  chatId: Scalars['ID']['input'];
};


export type MutationPopulateDataFromBhtiaArgs = {
  learnerFileId: Scalars['ID']['input'];
  pageLocation: ReportPageLocationEnums;
  reportId: Scalars['ID']['input'];
};


export type MutationPromoteReportTemplateArgs = {
  id: Scalars['ID']['input'];
  previousTemplate?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationQaSetCentralReachItemStatusArgs = {
  includeChildren: Scalars['Boolean']['input'];
  itemNames: Array<Scalars['String']['input']>;
  learnerId: Scalars['ID']['input'];
  status: QaCentralReachItemStatus;
};


export type MutationReRunFailedSessionBySuperAdminArgs = {
  fromSessionDate: Scalars['Date']['input'];
};


export type MutationReadNotificationArgs = {
  input: ReadNotificationInput;
};


export type MutationReassignReportGoalArgs = {
  input: ReassignReportGoalInput;
};


export type MutationRecalculateGoalStatusSummaryArgs = {
  reportId: Scalars['ID']['input'];
};


export type MutationRefreshTokenArgs = {
  token?: InputMaybe<Scalars['String']['input']>;
};


export type MutationRegisterDeviceTokenArgs = {
  input: RegisterDeviceTokenInput;
};


export type MutationReissueCaregiverInvitationArgs = {
  caregiverId: Scalars['ID']['input'];
};


export type MutationReissueProviderInvitationArgs = {
  connectionType?: InputMaybe<ConnectionTypeEnum>;
  providerId: Scalars['ID']['input'];
  providerRoles?: InputMaybe<Array<InputMaybe<ProviderRoleEnums>>>;
};


export type MutationRemoveLearnerPayorArgs = {
  learnerId: Scalars['ID']['input'];
  payorType: PayorType;
};


export type MutationRemoveMediaAiPredictionsArgs = {
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  removePredictionsInput: RemoveMediaAiPredictionsInput;
};


export type MutationRemoveMediaCommentArgs = {
  commentId: Scalars['ID']['input'];
};


export type MutationRemoveReportGoalArgs = {
  reportGoalId: Scalars['ID']['input'];
};


export type MutationRemoveReportTargetArgs = {
  learnerId: Scalars['ID']['input'];
  reportTargetId: Scalars['ID']['input'];
};


export type MutationRemoveSessionDataArgs = {
  input: RemoveSessionDataInput;
};


export type MutationReopenReportCommentArgs = {
  id: Scalars['ID']['input'];
};


export type MutationReorderGoalsArgs = {
  goals: Array<InputMaybe<ReorderGoalsInput>>;
};


export type MutationReorderReportGoalsArgs = {
  goals: Array<InputMaybe<ReorderReportGoalsInput>>;
};


export type MutationRequestReportReviewArgs = {
  includeInternal?: InputMaybe<Scalars['Boolean']['input']>;
  reportId: Scalars['ID']['input'];
  reviewers: Array<ReviewerRequestInput>;
};


export type MutationRescheduleCareAppointmentArgs = {
  appointmentId: Scalars['String']['input'];
  endTime: Scalars['String']['input'];
  startTime: Scalars['String']['input'];
};


export type MutationResolveReportCommentArgs = {
  id: Scalars['ID']['input'];
};


export type MutationResolveReportSuggestionArgs = {
  suggestionId: Scalars['ID']['input'];
};


export type MutationSaveAndLockCrLearningTreeItemsArgs = {
  changes: Array<InputMaybe<CrLearningTreeRoleInput>>;
  learnerId: Scalars['ID']['input'];
  reportId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationSaveChatbotSummaryArgs = {
  input: SaveChatbotSummaryInput;
};


export type MutationSaveCrLearningTreeRolesArgs = {
  changes: Array<InputMaybe<CrLearningTreeRoleInput>>;
  learnerId: Scalars['ID']['input'];
};


export type MutationSaveEhrCredentialsArgs = {
  organizationId: Scalars['ID']['input'];
  password: Scalars['String']['input'];
  providerId: Scalars['ID']['input'];
  username: Scalars['String']['input'];
};


export type MutationSaveGoalBankEmbeddingsArgs = {
  embeddings: Array<InputMaybe<SaveGoalBankEmbeddingInput>>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationSaveGoalBankSuggestedGoalsArgs = {
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  reportTreatmentPlanId: Scalars['ID']['input'];
  suggestions: Array<InputMaybe<GoalBankSuggestionInput>>;
};


export type MutationSaveLearnerConsentFileArgs = {
  consentFile: Scalars['Upload']['input'];
  consentType: ConsentTypeEnums;
  learner: Scalars['ID']['input'];
};


export type MutationSaveReportWritingTimesArgs = {
  entries: Array<ReportWritingTimeInput>;
};


export type MutationSaveSessionAudioMetricsArgs = {
  input: SaveSessionAudioMetricsInput;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationSaveStripePaymentMethodArgs = {
  paymentMethodId: Scalars['String']['input'];
};


export type MutationSaveTasksArgs = {
  input: SaveTasksInput;
};


export type MutationSendActivityEmailsToRbtsArgs = {
  currentDatetime: Scalars['DateTime']['input'];
  organizationId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationSendCaregiverActivationCodeNotificationArgs = {
  caregiverId: Scalars['ID']['input'];
  organizationId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationSendCaregiverActivationCodeNotificationsArgs = {
  caregiverIds: Array<Scalars['ID']['input']>;
};


export type MutationSendClientToFronteraEhrArgs = {
  reportId: Scalars['ID']['input'];
};


export type MutationSendPendingUploadRemindersArgs = {
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  sessionIds: Array<InputMaybe<Scalars['ID']['input']>>;
};


export type MutationSendTestEmailArgs = {
  emails: Array<InputMaybe<Scalars['String']['input']>>;
};


export type MutationSetEhrConnectionStatusArgs = {
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  status: EhrConnectionStatus;
  workflowId: Scalars['String']['input'];
};


export type MutationSetLearnerFileStatusArgs = {
  fileId: Scalars['ID']['input'];
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  status: LearnerFileStatusEnum;
};


export type MutationSetLearnerPayorArgs = {
  learnerId: Scalars['ID']['input'];
  payorTypes: Array<PayorType>;
};


export type MutationSetReportCommentHiddenArgs = {
  hidden: Scalars['Boolean']['input'];
  id: Scalars['ID']['input'];
};


export type MutationSetReportReviewStatusArgs = {
  note?: InputMaybe<Scalars['String']['input']>;
  reportId: Scalars['ID']['input'];
  status: ReportReviewerStatus;
  userId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationSetupPaymentIntentArgs = {
  paymentMethodId: Scalars['String']['input'];
  priceId: Scalars['String']['input'];
};


export type MutationSignReportArgs = {
  input: SignReportInput;
};


export type MutationStartD2pOnboardingWorkflowArgs = {
  input: StartD2POnboardingWorkflowInput;
};


export type MutationStartGoalAttainmentScaleWorkflowArgs = {
  reportGoalId: Scalars['ID']['input'];
};


export type MutationStartGoalBaselineDataWorkflowArgs = {
  reportGoalId: Scalars['ID']['input'];
  reportId: Scalars['ID']['input'];
};


export type MutationStartGoalProgressSummaryWorkflowArgs = {
  reportGoalId: Scalars['ID']['input'];
  reportId: Scalars['ID']['input'];
};


export type MutationStartGoalsSyncToEhrArgs = {
  reportId: Scalars['ID']['input'];
};


export type MutationStartLearnerFileClassificationArgs = {
  learnerFileId: Scalars['ID']['input'];
};


export type MutationStartLearnerFileValidationArgs = {
  learnerFileId: Scalars['ID']['input'];
};


export type MutationStartLearnerMetadataCreationFromAbcIntakeFileArgs = {
  learnerFileId: Scalars['ID']['input'];
};


export type MutationStartLearnerMetadataCreationFromBhtiaFileArgs = {
  learnerFileId: Scalars['ID']['input'];
};


export type MutationStartManualSyncWorkflowArgs = {
  learnerId: Scalars['ID']['input'];
  learningTreeReview?: InputMaybe<Scalars['Boolean']['input']>;
  learningTreeStructureOnly?: InputMaybe<Scalars['Boolean']['input']>;
  reassessmentReportGoalSync?: InputMaybe<Scalars['Boolean']['input']>;
  reportId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationStartPayorSubmissionWorkflowArgs = {
  input: StartPayorSubmissionWorkflowInput;
};


export type MutationStartProviderFileValidationArgs = {
  providerFileId: Scalars['ID']['input'];
};


export type MutationStartReassessmentFileClassificationArgs = {
  learnerFileId: Scalars['ID']['input'];
};


export type MutationStartReportSuggestionsWorkflowArgs = {
  reportId: Scalars['ID']['input'];
};


export type MutationStartSessionProcessingWorkflowArgs = {
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  videoSession?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationStartSingleReportTemplateSectionWorkflowArgs = {
  sectionId: Scalars['ID']['input'];
};


export type MutationStartTargetProgressSummaryWorkflowArgs = {
  reportId: Scalars['ID']['input'];
  targetId: Scalars['ID']['input'];
};


export type MutationSyncCrGoalOrTargetAndProgressDataArgs = {
  input: SyncCrGoalOrTargetAndProgressDataInput;
};


export type MutationSyncExternalClientsArgs = {
  input: SyncExternalClientsInput;
};


export type MutationSyncExternalOrganizationArgs = {
  organization: ExternalOrganization;
  organizationType: OrganizationTypeEnum;
};


export type MutationSyncExternalProvidersArgs = {
  organizationExternalId: Scalars['String']['input'];
  providers?: InputMaybe<Array<InputMaybe<ExternalProvider>>>;
};


export type MutationSyncHippHealthClientsArgs = {
  clients?: InputMaybe<Array<InputMaybe<ExternalClient>>>;
  organizationId: Scalars['ID']['input'];
};


export type MutationSyncHippHealthTreatmentPlansArgs = {
  organizationExternalId: Scalars['String']['input'];
  treatmentPlans: Array<InputMaybe<SyncHippHealthTreatmentPlansInput>>;
};


export type MutationSyncPassageTreatmentPlansArgs = {
  organizationExternalId: Scalars['String']['input'];
  treatmentPlans: Array<InputMaybe<SyncPassageTreatmentPlansInput>>;
};


export type MutationSyncPayorClientDataArgs = {
  clientDataInputs: Array<InputMaybe<SyncPayorClientDataInput>>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationSyncPayorClientDocumentAndCreateReportArgs = {
  documentInputs: Array<InputMaybe<SyncPayorClientDocumentAndCreateReportInput>>;
  learnerPayorExternalId: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
  payorType: PayorType;
};


export type MutationSyncPayorOrganizationArgs = {
  input: SyncPayorOrganizationInput;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationTokenAuthArgs = {
  password: Scalars['String']['input'];
  username: Scalars['String']['input'];
};


export type MutationUiEhrUpdateLoginStatusArgs = {
  loginStatus: LoginStateEnum;
  workflowId: Scalars['String']['input'];
};


export type MutationUnassignCaregiverFromLearnerArgs = {
  caregiverId: Scalars['ID']['input'];
  learnerId: Scalars['ID']['input'];
};


export type MutationUnlockCrLearningTreeBranchArgs = {
  externalId: Scalars['String']['input'];
  learnerId: Scalars['ID']['input'];
};


export type MutationUpdateAnnotationArgs = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  annotation: Scalars['ID']['input'];
  category?: InputMaybe<Scalars['String']['input']>;
  endTime?: InputMaybe<Scalars['Time']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  startTime?: InputMaybe<Scalars['Time']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateAnnotatorArgs = {
  annotatorDetails: UpdateAnnotatorInput;
};


export type MutationUpdateAnnotatorUserAuth0idArgs = {
  annotatorDetails: UpdateAnnotatorAuth0IdInput;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationUpdateBaseSuggestionCriteriaArgs = {
  category?: InputMaybe<Scalars['String']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateBillableSummaryArgs = {
  input: UpdateBillableSummaryNoteInput;
};


export type MutationUpdateCareAppointmentCustomFieldsArgs = {
  appointmentId: Scalars['String']['input'];
  customFields: Scalars['JSONString']['input'];
};


export type MutationUpdateCareAppointmentNoteArgs = {
  appointmentId: Scalars['String']['input'];
  notes: Scalars['String']['input'];
};


export type MutationUpdateCaregiverConsentsArgs = {
  consentUpdates: Array<CaregiverConsentInput>;
};


export type MutationUpdateCaregiverLearnerRelationshipArgs = {
  input: UpdateCaregiverLearnerRelationshipInput;
};


export type MutationUpdateCaregiverMetadataArgs = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  address?: InputMaybe<Scalars['String']['input']>;
  addressLine2?: InputMaybe<Scalars['String']['input']>;
  appActivationEligible?: InputMaybe<Scalars['Boolean']['input']>;
  birthDate?: InputMaybe<Scalars['Date']['input']>;
  caregiver?: InputMaybe<Scalars['ID']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  employer?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  isAllowedAppAccess?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  martialStatus?: InputMaybe<Scalars['String']['input']>;
  occupation?: InputMaybe<Scalars['String']['input']>;
  phoneNumber1?: InputMaybe<Scalars['String']['input']>;
  phoneNumber2?: InputMaybe<Scalars['String']['input']>;
  preferredName?: InputMaybe<Scalars['String']['input']>;
  prefferedLanguage?: InputMaybe<Scalars['String']['input']>;
  requiresInterpreter?: InputMaybe<Scalars['Boolean']['input']>;
  smsAgreement?: InputMaybe<Scalars['Boolean']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateCaregiverSupportNotesArgs = {
  caregiverNeedSupport: Scalars['String']['input'];
};


export type MutationUpdateChatArgs = {
  input: UpdateChatInput;
};


export type MutationUpdateChatConversationSummaryArgs = {
  chatId: Scalars['ID']['input'];
  conversationSummary: Scalars['String']['input'];
  organizationId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationUpdateChatMessageArgs = {
  input: UpdateChatMessageInput;
};


export type MutationUpdateChatTitleArgs = {
  input: UpdateChatTitleInput;
};


export type MutationUpdateChatbotProcessingStatusArgs = {
  input: UpdateChatbotProcessingStatusInput;
};


export type MutationUpdateClipAnnotationStatusArgs = {
  input: UpdateClipAnnotationStatusInput;
};


export type MutationUpdateClipAssignmentArgs = {
  clipAssignmentDetails: UpdateClipAssignmentInput;
};


export type MutationUpdateDomainConfigArgs = {
  input: UpdateDomainConfigInput;
};


export type MutationUpdateEhrExternalIdsArgs = {
  goalsAndTargets: Array<InputMaybe<EhrGoalTargetInput>>;
  orgType: Scalars['String']['input'];
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  stgTargetsAreGoals?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationUpdateEhrGoalsAndTargetsArgs = {
  goals: Array<InputMaybe<UpdateEhrGoalsInput>>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationUpdateEnterpriseReportExportTemplateArgs = {
  input: UpdateReportTemplateFileInput;
};


export type MutationUpdateEnterpriseReportTemplateArgs = {
  input: UpdateEnterpriseReportTemplateInput;
};


export type MutationUpdateGasExtractionDataM2mArgs = {
  goalExtractions: Array<InputMaybe<GasExtractionDataInput>>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  reportId: Scalars['ID']['input'];
};


export type MutationUpdateGoalArgs = {
  input: UpdateGoalInput;
  learnerId: Scalars['ID']['input'];
};


export type MutationUpdateGoalAttainmentScaleM2mArgs = {
  input: GoalAttainmentScaleInput;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationUpdateGoalBankFolderArgs = {
  input: UpdateGoalBankFolderInput;
};


export type MutationUpdateGoalBankGoalArgs = {
  input: UpdateGoalBankGoalInput;
};


export type MutationUpdateGoalBankLongTermGoalArgs = {
  input: UpdateGoalBankLongTermGoalInput;
};


export type MutationUpdateGoalBankTargetArgs = {
  input: UpdateGoalBankTargetInput;
};


export type MutationUpdateGoalBaselineDataM2mArgs = {
  baselineData: Scalars['String']['input'];
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  reportGoalId: Scalars['ID']['input'];
};


export type MutationUpdateGoalExcludeFromReportArgs = {
  input: UpdateGoalExcludeFromReportInput;
};


export type MutationUpdateGoalPredictionStatusM2mArgs = {
  failureMessage?: InputMaybe<Scalars['String']['input']>;
  goalId: Scalars['ID']['input'];
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  predictionOf?: InputMaybe<AiPredictionOfEnum>;
  status: TreatmentPlanAiGoalsPredictionStatusEnums;
};


export type MutationUpdateGoalProgressSummariesM2mArgs = {
  inputs: Array<InputMaybe<GoalProgressSummaryInput>>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationUpdateGoalProgressSummaryArgs = {
  input: UpdateGoalProgressSummaryInput;
};


export type MutationUpdateGoalProgressSummaryM2mArgs = {
  goalId: Scalars['ID']['input'];
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  progressSummary: Scalars['String']['input'];
};


export type MutationUpdateGoalSuggestionStatusArgs = {
  failureMessage?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  reportTreatmentPlanId: Scalars['ID']['input'];
  status: TreatmentPlanAiGoalsPredictionStatusEnums;
};


export type MutationUpdateGoalTargetGenerationStatusM2mArgs = {
  input: UpdateGoalTargetGenerationStatusM2MInput;
};


export type MutationUpdateGoogleDriveUploadFlagArgs = {
  input: UpdateGoogleDriveUploadFlagInput;
};


export type MutationUpdateLanguageStylePromptArgs = {
  errorMsg?: InputMaybe<Scalars['String']['input']>;
  languageFragment?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  predictionId?: InputMaybe<Scalars['String']['input']>;
  status: StylePromptStatusEnum;
  stylePromptId: Scalars['ID']['input'];
};


export type MutationUpdateLearnerAdditionalDetailsArgs = {
  additionalDetails: LearnerAdditionalDetailsInput;
  learner: Scalars['ID']['input'];
};


export type MutationUpdateLearnerAvailabilityDetailsArgs = {
  details: AvailabilityInput;
  learner: Scalars['ID']['input'];
};


export type MutationUpdateLearnerBehaviorsArgs = {
  behaviors: LearnerBehaviorsInput;
  learner: Scalars['ID']['input'];
  requestQuestionPageOrigin: Scalars['String']['input'];
};


export type MutationUpdateLearnerBirthHistoryArgs = {
  birthHistory: LearnerBirthHistoryInput;
  learner: Scalars['ID']['input'];
};


export type MutationUpdateLearnerCaregiverDetailsArgs = {
  caregiverDetails: CaregiverInput;
  learner: Scalars['ID']['input'];
};


export type MutationUpdateLearnerChatMemoryArgs = {
  learnerId: Scalars['ID']['input'];
  memoryData: Scalars['JSONString']['input'];
  organizationId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationUpdateLearnerCommunicationArgs = {
  communication: LearnerCommunicationInput;
  learner: Scalars['ID']['input'];
  requestQuestionPageOrigin: Scalars['String']['input'];
};


export type MutationUpdateLearnerDetailsArgs = {
  learner: Scalars['ID']['input'];
  learnerDetails: LearnerDetailsInput;
};


export type MutationUpdateLearnerDevelopmentalMilestonesArgs = {
  developmentalMilestones: LearnerDevelopmentalMilestonesInput;
  learner: Scalars['ID']['input'];
};


export type MutationUpdateLearnerEarlyInterventionServicesArgs = {
  earlyInterventionServices: LearnerEarlyInterventionServicesInput;
  learner: Scalars['ID']['input'];
};


export type MutationUpdateLearnerEducationArgs = {
  educationSetting?: InputMaybe<Scalars['String']['input']>;
  grade?: InputMaybe<Scalars['String']['input']>;
  learner?: InputMaybe<Scalars['ID']['input']>;
  nameOfSchool?: InputMaybe<Scalars['String']['input']>;
  specialEducation?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationUpdateLearnerEducationDetailsArgs = {
  educationDetails: LearnerEducationDetailsInput;
  learner: Scalars['ID']['input'];
};


export type MutationUpdateLearnerEmergencyContactArgs = {
  emergencyContact: LearnerEmergencyContactInput;
  learner: Scalars['ID']['input'];
};


export type MutationUpdateLearnerFileClassificationArgs = {
  classification?: InputMaybe<Scalars['String']['input']>;
  fileId: Scalars['ID']['input'];
  organizationId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationUpdateLearnerFileEffectiveDateArgs = {
  effectiveDate?: InputMaybe<Scalars['Date']['input']>;
  fileId: Scalars['ID']['input'];
};


export type MutationUpdateLearnerFileInterviewTypeArgs = {
  fileId: Scalars['ID']['input'];
  interviewType: Scalars['String']['input'];
};


export type MutationUpdateLearnerFileLanguageArgs = {
  fileId: Scalars['ID']['input'];
  language: Scalars['String']['input'];
};


export type MutationUpdateLearnerFileParsedResultArgs = {
  fileId: Scalars['ID']['input'];
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  parsedData?: InputMaybe<Scalars['String']['input']>;
  parsedDataScoped?: InputMaybe<Scalars['String']['input']>;
  parsedTables?: InputMaybe<Scalars['JSONString']['input']>;
  triggerSectionRegen?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationUpdateLearnerGeneralDetailsArgs = {
  generalDetails: LearnerGeneralDetailsInput;
  learner: Scalars['ID']['input'];
};


export type MutationUpdateLearnerGuardianDetailsArgs = {
  guardianDetails: LearnerGuardianDetailsInput;
  learner: Scalars['ID']['input'];
};


export type MutationUpdateLearnerInsuranceArgs = {
  insuranceDetails: LearnerInsuranceDetailsInput;
  learner: Scalars['ID']['input'];
};


export type MutationUpdateLearnerInsuranceDetailsArgs = {
  insuranceData: LearnerInsuranceAdminInput;
  learner: Scalars['ID']['input'];
};


export type MutationUpdateLearnerIntakeOverviewDetailsArgs = {
  learner: Scalars['ID']['input'];
  learnerDetails: UpdateLearnerIntakeOverviewDetailsInput;
};


export type MutationUpdateLearnerLivingConditionsArgs = {
  learner: Scalars['ID']['input'];
  livingConditions: LearnerLivingConditionsInput;
};


export type MutationUpdateLearnerManualSyncM2mArgs = {
  learnerId: Scalars['ID']['input'];
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  status: Scalars['String']['input'];
};


export type MutationUpdateLearnerMedicalHistoryArgs = {
  learner: Scalars['ID']['input'];
  medicalHistory: LearnerMedicalHistoryInput;
};


export type MutationUpdateLearnerMetadataArgs = {
  address?: InputMaybe<Scalars['String']['input']>;
  addressLine2?: InputMaybe<Scalars['String']['input']>;
  birthDate?: InputMaybe<Scalars['Date']['input']>;
  birthWeightLbs?: InputMaybe<Scalars['Float']['input']>;
  birthWeightOz?: InputMaybe<Scalars['Float']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  learner?: InputMaybe<Scalars['ID']['input']>;
  preferredLanguage?: InputMaybe<Scalars['String']['input']>;
  preferredName?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateLearnerPrimaryProviderArgs = {
  address?: InputMaybe<Scalars['String']['input']>;
  addressLine2?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  learner?: InputMaybe<Scalars['ID']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  primaryCareProvider?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateLearnerProvidersArgs = {
  input: UpdateLearnerProvidersInput;
};


export type MutationUpdateLearnerTendenciesArgs = {
  learner?: InputMaybe<Scalars['ID']['input']>;
  requestQuestionPageOrigin: Scalars['String']['input'];
  tendencies: LearnerTendenciesInput;
};


export type MutationUpdateMediaClipArgs = {
  clipDetails: UpdateMediaClipInput;
};


export type MutationUpdateMediaCommentArgs = {
  input: UpdateMediaCommentInput;
};


export type MutationUpdateMediaM2mArgs = {
  input: UpdateMediaM2MInput;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationUpdateMediaStatusArgs = {
  input: UpdateMediaStatusInput;
};


export type MutationUpdateMessageReadStatusArgs = {
  input: UpdateMessageReadStatusInput;
};


export type MutationUpdateNotificationOptOutArgs = {
  input: UpdateNotificationOptOutInput;
};


export type MutationUpdateOrgNotificationSettingsArgs = {
  input: UpdateOrgNotificationSettingsInput;
};


export type MutationUpdateOrganizationSuggestionCriteriaArgs = {
  category?: InputMaybe<Scalars['String']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
};


export type MutationUpdateOrganizationTemplateLogoUrlArgs = {
  input: UpdateOrganizationTemplateLogoUrlInput;
};


export type MutationUpdateParsedTreatmentPlanFileDataArgs = {
  id: Scalars['ID']['input'];
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  updates: UpdateParsedTreatmentPlanFileDataInput;
};


export type MutationUpdatePassageGoalAndTargetIdsM2mArgs = {
  goals: Array<InputMaybe<UpdatePassageGoalAndTargetIdsM2mInput>>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationUpdatePayorReportReviewStatusArgs = {
  input: UpdatePayorReportReviewStatusInput;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationUpdatePayorSubmissionStatusArgs = {
  input: UpdatePayorSubmissionStatusInput;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationUpdatePromptArgs = {
  input: PromptInput;
};


export type MutationUpdateProviderArgs = {
  provider: UpdateProviderInput;
  providerId: Scalars['ID']['input'];
};


export type MutationUpdateProviderAuth0IdArgs = {
  auth0Id: Scalars['String']['input'];
  auth0OrganizationId: Scalars['String']['input'];
  providerId: Scalars['ID']['input'];
};


export type MutationUpdateProviderFileParsedResultArgs = {
  fileId: Scalars['ID']['input'];
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  parsedData?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateProviderFileProcessStatusArgs = {
  errorMsg?: InputMaybe<Scalars['String']['input']>;
  fileId: Scalars['ID']['input'];
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  status: ProviderFileStatusEnum;
};


export type MutationUpdateProviderLearnersArgs = {
  learners?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  providerId: Scalars['ID']['input'];
};


export type MutationUpdateProviderProfileArgs = {
  providerData: UpdateProviderProfileInput;
};


export type MutationUpdateRecommendationBankFolderArgs = {
  input: UpdateRecommendationBankFolderInput;
};


export type MutationUpdateRecommendationBankItemArgs = {
  input: UpdateRecommendationBankItemInput;
};


export type MutationUpdateReportArgs = {
  reportId: Scalars['ID']['input'];
  reportMetaData?: InputMaybe<Scalars['JSONString']['input']>;
  status?: InputMaybe<ReportStatusEnums>;
};


export type MutationUpdateReportClientDetailsArgs = {
  clientDetails: LearnerCaregiverMinimalInput;
  previousReportDetails?: InputMaybe<PreviousReportDetailsInput>;
  reportId: Scalars['ID']['input'];
  reportWriterAndDate?: InputMaybe<UpdateReportWriterAndDateInput>;
  updateLearner?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationUpdateReportEhrSyncStatusArgs = {
  input: UpdateReportEhrSyncStatusInput;
};


export type MutationUpdateReportGoalDomainsM2mArgs = {
  inputs: Array<InputMaybe<UpdateReportGoalDomainsInput>>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationUpdateReportPageHeadingArgs = {
  input: UpdateReportPageHeadingInput;
};


export type MutationUpdateReportSectionArgs = {
  aiGeneratedStatus?: InputMaybe<ReportSectionAiPredictionStatusEnums>;
  reportSectionId: Scalars['ID']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateReportSectionFieldArgs = {
  content?: InputMaybe<Scalars['String']['input']>;
  reportSectionFieldId: Scalars['ID']['input'];
  reportSectionId: Scalars['ID']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateReportSectionFieldFileUrlArgs = {
  input: UpdateReportSectionFieldFileUrlInput;
};


export type MutationUpdateReportSectionFieldFromBhtiaArgs = {
  pageLocation: Scalars['String']['input'];
  parsedData: Scalars['String']['input'];
  reportId: Scalars['ID']['input'];
};


export type MutationUpdateReportSectionFieldOrderArgs = {
  reportSectionId: Scalars['ID']['input'];
  sectionFields: Array<InputMaybe<ReportSectionFieldOrderInput>>;
};


export type MutationUpdateReportSectionsOrderArgs = {
  reportId: Scalars['ID']['input'];
  sections: Array<InputMaybe<ReportSectionOrderInput>>;
};


export type MutationUpdateReportStatusAndUploadReportFileArgs = {
  report: Scalars['ID']['input'];
  reportDocxFile: Scalars['Upload']['input'];
};


export type MutationUpdateReportSuggestionGenerationStatusArgs = {
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  reportId: Scalars['ID']['input'];
  status?: InputMaybe<ReportSuggestionGenerationStatusEnum>;
};


export type MutationUpdateReportTemplateArgs = {
  input: UpdateReportTemplateInput;
};


export type MutationUpdateReportTemplateLogoArgs = {
  input: UpdateReportTemplateFileInput;
};


export type MutationUpdateReportTemplateSuggestionCriteriaArgs = {
  category?: InputMaybe<Scalars['String']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
};


export type MutationUpdateReportTreatmentPlanPredictionStatusArgs = {
  failureMessage?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  predictionOf?: InputMaybe<AiPredictionOfEnum>;
  reportTreatmentPlanId: Scalars['ID']['input'];
  status: TreatmentPlanAiGoalsPredictionStatusEnums;
};


export type MutationUpdateReportTreatmentPlanTargetsPriorityOrderArgs = {
  learner: Scalars['ID']['input'];
  targetsPriorityData: Array<InputMaybe<ReportTreatmentPlanTargetPriorityInput>>;
};


export type MutationUpdateSessionRatingAndCommnentArgs = {
  input: UpdateSessionRatingAndCommentInput;
};


export type MutationUpdateTargetExcludeFromReportArgs = {
  input: UpdateTargetExcludeFromReportInput;
};


export type MutationUpdateTargetPredictionStatusM2mArgs = {
  failureMessage?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  predictionOf?: InputMaybe<AiPredictionOfEnum>;
  status: TreatmentPlanAiGoalsPredictionStatusEnums;
  targetId: Scalars['ID']['input'];
};


export type MutationUpdateTargetProgressSummaryArgs = {
  input: UpdateTargetProgressSummaryInput;
};


export type MutationUpdateTargetProgressSummaryM2mArgs = {
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  progressSummary: Scalars['String']['input'];
  targetId: Scalars['ID']['input'];
};


export type MutationUpdateTargetsPriorityOrderArgs = {
  learner: Scalars['ID']['input'];
  targetsPriorityData: Array<InputMaybe<TargetPriorityInput>>;
};


export type MutationUpdateTaxTransactionArgs = {
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  line1?: InputMaybe<Scalars['String']['input']>;
  paymentIntentId?: InputMaybe<Scalars['String']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['Int']['input']>;
  productId?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateTherapzGoalsAndTargetsArgs = {
  goals: Array<InputMaybe<UpdateTherapzGoalsInput>>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationUpdateTranscriptSpeakerArgs = {
  input: UpdateTranscriptSpeakerInput;
};


export type MutationUpdateTreatmentPlanCustomFieldFileUrlArgs = {
  input: UpdateTreatmentPlanCustomFieldFileUrlInput;
};


export type MutationUpdateTreatmentPlanPassageManualSyncM2mArgs = {
  learnerId: Scalars['ID']['input'];
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  reportId: Scalars['Int']['input'];
};


export type MutationUpdateVideoSessionScoreArgs = {
  engagementScore: Scalars['Float']['input'];
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  videoSessionId: Scalars['ID']['input'];
};


export type MutationUpdateVideoSessionStatusArgs = {
  mediaId?: InputMaybe<Scalars['Int']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  sessionStatus: VideoSessionStatusEnums;
  videoSessionId: Scalars['ID']['input'];
};


export type MutationUploadAnnotationFileArgs = {
  input: UploadAnnotationFileInput;
};


export type MutationUploadAnnotationMediaArgs = {
  input: UploadAnnotationMediaInput;
};


export type MutationUploadSessionVideoForLearnerArgs = {
  input: UploadSessionVideoForLearnerInput;
};


export type MutationUploadVideoSessionVideoArgs = {
  deviceName: Scalars['String']['input'];
  location: Scalars['String']['input'];
  requiredParts: Scalars['Int']['input'];
  useCustomHeaderSigning?: InputMaybe<Scalars['Boolean']['input']>;
  videoSegmentIndex: Scalars['Int']['input'];
  videoSessionId: Scalars['ID']['input'];
};


export type MutationUpsertChatSuggestionsArgs = {
  input: UpsertChatSuggestionsInput;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationUpsertOrganizationSuggestionCriteriaArgs = {
  enabled: Scalars['Boolean']['input'];
  suggestionCriteriaId: Scalars['ID']['input'];
};


export type MutationUpsertReportPayorMetadataArgs = {
  input: UpsertReportPayorMetadataInput;
};


export type MutationValidateUserAndOrganizationDataArgs = {
  input: ValidateUserAndOrganizationDataInput;
};


export type MutationVerifyTokenArgs = {
  token?: InputMaybe<Scalars['String']['input']>;
};


export type MutationWriteEvalPromptThemesArgs = {
  computedAt: Scalars['DateTime']['input'];
  themes: Array<EvalPromptThemeInput>;
};

/** An object with an ID */
export type Node = {
  /** The ID of the object */
  id: Scalars['ID']['output'];
};

export type NonContinousInteractionClassification = {
  __typename?: 'NonContinousInteractionClassification';
  interactionCount?: Maybe<Scalars['Int']['output']>;
  intervals?: Maybe<Array<Maybe<ClassificationInterval>>>;
  subclass?: Maybe<Scalars['String']['output']>;
};

export enum NotificationDeliveryMethod {
  Email = 'EMAIL',
  Push = 'PUSH',
  Sms = 'SMS'
}

export type NotificationOptOutType = Node & {
  __typename?: 'NotificationOptOutType';
  createdDate: Scalars['DateTime']['output'];
  deliveryMethod: ApiNotificationOptOutDeliveryMethodChoices;
  /** The ID of the object */
  id: Scalars['ID']['output'];
  lastUpdatedDate: Scalars['DateTime']['output'];
  notificationType: ApiNotificationOptOutNotificationTypeChoices;
  organization: OrganizationType;
  pk?: Maybe<Scalars['Int']['output']>;
  user: UserType;
};

export type NotificationOptOutTypeConnection = {
  __typename?: 'NotificationOptOutTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<NotificationOptOutTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `NotificationOptOutType` and its cursor. */
export type NotificationOptOutTypeEdge = {
  __typename?: 'NotificationOptOutTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<NotificationOptOutType>;
};

export enum NotificationOrdering {
  NewestFirst = 'NEWEST_FIRST',
  OldestFirst = 'OLDEST_FIRST'
}

export enum NotificationTypeEnums {
  CircleCommunityNotification = 'CIRCLE_COMMUNITY_NOTIFICATION',
  ClinicLead = 'CLINIC_LEAD',
  CommunityDigest = 'COMMUNITY_DIGEST',
  CommunityLiveEvent = 'COMMUNITY_LIVE_EVENT',
  EhrClientImportCompleted = 'EHR_CLIENT_IMPORT_COMPLETED',
  EhrConnected = 'EHR_CONNECTED',
  ExpertChatMatchAssigned = 'EXPERT_CHAT_MATCH_ASSIGNED',
  ExpertChatNewMessage = 'EXPERT_CHAT_NEW_MESSAGE',
  ExpertChatReplyNeeded = 'EXPERT_CHAT_REPLY_NEEDED',
  ExpertChatUnreadChats = 'EXPERT_CHAT_UNREAD_CHATS',
  MediaComment = 'MEDIA_COMMENT',
  MediaCommentReply = 'MEDIA_COMMENT_REPLY',
  MediaProcessed = 'MEDIA_PROCESSED',
  ParentSessionSummary = 'PARENT_SESSION_SUMMARY',
  ProgrammingRefreshCompleted = 'PROGRAMMING_REFRESH_COMPLETED',
  ReassessmentReminder = 'REASSESSMENT_REMINDER',
  ReportReview = 'REPORT_REVIEW',
  UploadReminder = 'UPLOAD_REMINDER'
}

export type NotificationsType = Node & {
  __typename?: 'NotificationsType';
  channel: ApiNotificationsChannelChoices;
  createdDate: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  /** The ID of the object */
  id: Scalars['ID']['output'];
  lastUpdatedDate: Scalars['DateTime']['output'];
  notificationType: ApiNotificationsNotificationTypeChoices;
  organization: OrganizationType;
  payload: Scalars['JSONString']['output'];
  pk?: Maybe<Scalars['Int']['output']>;
  read: Scalars['Boolean']['output'];
  recipient: UserType;
  sender?: Maybe<UserType>;
  title: Scalars['String']['output'];
};

export type NotificationsTypeConnection = {
  __typename?: 'NotificationsTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<NotificationsTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
  totalUnread?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `NotificationsType` and its cursor. */
export type NotificationsTypeEdge = {
  __typename?: 'NotificationsTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<NotificationsType>;
};

/** Obtain JSON Web Token mutation */
export type ObtainJsonWebToken = {
  __typename?: 'ObtainJSONWebToken';
  payload: Scalars['GenericScalar']['output'];
  refreshExpiresIn: Scalars['Int']['output'];
  token: Scalars['String']['output'];
};

export enum OnboardingFormStatusEnumType {
  AdditionalDetails = 'ADDITIONAL_DETAILS',
  BehaviorsDiet = 'BEHAVIORS_DIET',
  BehaviorsGeneral = 'BEHAVIORS_GENERAL',
  BehaviorsInterests = 'BEHAVIORS_INTERESTS',
  BehaviorsMovementAndPlay = 'BEHAVIORS_MOVEMENT_AND_PLAY',
  BehaviorsSensory = 'BEHAVIORS_SENSORY',
  BehaviorsSleep = 'BEHAVIORS_SLEEP',
  CancellationPolicy = 'CANCELLATION_POLICY',
  ClientDetailsEmergencyContact = 'CLIENT_DETAILS_EMERGENCY_CONTACT',
  ClientDetailsGeneralDetails = 'CLIENT_DETAILS_GENERAL_DETAILS',
  CommunicationNonVerbalCommunication = 'COMMUNICATION_NON_VERBAL_COMMUNICATION',
  CommunicationVerbalCommunication = 'COMMUNICATION_VERBAL_COMMUNICATION',
  DevelopmentDevelopmentalMilestones = 'DEVELOPMENT_DEVELOPMENTAL_MILESTONES',
  DevelopmentEarlyInterventionServices = 'DEVELOPMENT_EARLY_INTERVENTION_SERVICES',
  DevelopmentEducation = 'DEVELOPMENT_EDUCATION',
  FinancialPolicy = 'FINANCIAL_POLICY',
  HealthBirthHistory = 'HEALTH_BIRTH_HISTORY',
  HealthInformation = 'HEALTH_INFORMATION',
  HealthMedicalHistory = 'HEALTH_MEDICAL_HISTORY',
  HippaAuthorization = 'HIPPA_AUTHORIZATION',
  HomeEnvironmentGuardianDetails = 'HOME_ENVIRONMENT_GUARDIAN_DETAILS',
  HomeEnvironmentLivingConditions = 'HOME_ENVIRONMENT_LIVING_CONDITIONS',
  IllnessInfection = 'ILLNESS_INFECTION',
  Insurance = 'INSURANCE',
  ProgramSafeguards = 'PROGRAM_SAFEGUARDS',
  Submit = 'SUBMIT',
  TendenciesAggression = 'TENDENCIES_AGGRESSION',
  TendenciesAttachment = 'TENDENCIES_ATTACHMENT',
  TendenciesAttention = 'TENDENCIES_ATTENTION',
  TendenciesDefiance = 'TENDENCIES_DEFIANCE',
  TendenciesExecutiveFunctions = 'TENDENCIES_EXECUTIVE_FUNCTIONS',
  TendenciesLanguage = 'TENDENCIES_LANGUAGE',
  TendenciesMood = 'TENDENCIES_MOOD',
  TendenciesOddIdeas = 'TENDENCIES_ODD_IDEAS',
  TendenciesSocialSkills = 'TENDENCIES_SOCIAL_SKILLS',
  TendenciesSomatic = 'TENDENCIES_SOMATIC',
  TendenciesStrengths = 'TENDENCIES_STRENGTHS',
  TendenciesTrauma = 'TENDENCIES_TRAUMA',
  VideoRecording = 'VIDEO_RECORDING'
}

export type OnboardingFormStatusType = Node & {
  __typename?: 'OnboardingFormStatusType';
  createdBy?: Maybe<UserType>;
  createdDate: Scalars['DateTime']['output'];
  formName: Scalars['String']['output'];
  /** The ID of the object */
  id: Scalars['ID']['output'];
  lastUpdatedDate: Scalars['DateTime']['output'];
  learner?: Maybe<LearnerType>;
  organization: OrganizationType;
  pk?: Maybe<Scalars['Int']['output']>;
  status: ApiOnboardingFormStatusStatusChoices;
};

export type OnboardingFormStatusTypeConnection = {
  __typename?: 'OnboardingFormStatusTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<OnboardingFormStatusTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `OnboardingFormStatusType` and its cursor. */
export type OnboardingFormStatusTypeEdge = {
  __typename?: 'OnboardingFormStatusTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<OnboardingFormStatusType>;
};

export type OpenChat = {
  __typename?: 'OpenChat';
  chat?: Maybe<ChatType>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

/** Organization with EHR credentials for M2M queries (Temporal workflows) */
export type OrganizationEhrCredentialType = {
  __typename?: 'OrganizationEhrCredentialType';
  apiKey?: Maybe<Scalars['String']['output']>;
  dbCredentials?: Maybe<OrganizationEhrDataWarehouseType>;
  id: Scalars['String']['output'];
  organization?: Maybe<OrganizationType>;
};

/** Organization type with Data Warehouse credentials for M2M queries (Temporal workflows). */
export type OrganizationEhrDataWarehouseType = {
  __typename?: 'OrganizationEhrDataWarehouseType';
  dbAuthenticationType?: Maybe<Scalars['String']['output']>;
  dbHost?: Maybe<Scalars['String']['output']>;
  dbName?: Maybe<Scalars['String']['output']>;
  dbPasswordSecretName?: Maybe<Scalars['String']['output']>;
  dbPort?: Maybe<Scalars['String']['output']>;
  dbType?: Maybe<Scalars['String']['output']>;
  dbUser?: Maybe<Scalars['String']['output']>;
};

export type OrganizationFilter = {
  organizationType?: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationNotificationSettingsType = Node & {
  __typename?: 'OrganizationNotificationSettingsType';
  createdDate: Scalars['DateTime']['output'];
  /** The ID of the object */
  id: Scalars['ID']['output'];
  lastUpdatedDate: Scalars['DateTime']['output'];
  organization: OrganizationType;
  pk?: Maybe<Scalars['Int']['output']>;
  reassessmentReminder: Scalars['Boolean']['output'];
};

export type OrganizationNotificationSettingsTypeConnection = {
  __typename?: 'OrganizationNotificationSettingsTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<OrganizationNotificationSettingsTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `OrganizationNotificationSettingsType` and its cursor. */
export type OrganizationNotificationSettingsTypeEdge = {
  __typename?: 'OrganizationNotificationSettingsTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<OrganizationNotificationSettingsType>;
};

export type OrganizationPayorType = Node & {
  __typename?: 'OrganizationPayorType';
  createdDate: Scalars['DateTime']['output'];
  externalId: Scalars['String']['output'];
  /** The ID of the object */
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  lastUpdatedDate: Scalars['DateTime']['output'];
  organization: OrganizationType;
  payorType: ApiOrganizationPayorPayorTypeChoices;
  payorreportsubmissionSet: PayorReportSubmissionTypeConnection;
  pk?: Maybe<Scalars['Int']['output']>;
  submissionMethod: ApiOrganizationPayorSubmissionMethodChoices;
};


export type OrganizationPayorTypePayorreportsubmissionSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type OrganizationPayorTypeConnection = {
  __typename?: 'OrganizationPayorTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<OrganizationPayorTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `OrganizationPayorType` and its cursor. */
export type OrganizationPayorTypeEdge = {
  __typename?: 'OrganizationPayorTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<OrganizationPayorType>;
};

export type OrganizationSuggestionCriteriaType = Node & {
  __typename?: 'OrganizationSuggestionCriteriaType';
  enabled: Scalars['Boolean']['output'];
  /** The ID of the object */
  id: Scalars['ID']['output'];
  isVirtual?: Maybe<Scalars['Boolean']['output']>;
  organization: OrganizationType;
  suggestionCriteria: SuggestionCriteriaType;
};

export type OrganizationSuggestionCriteriaTypeConnection = {
  __typename?: 'OrganizationSuggestionCriteriaTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<OrganizationSuggestionCriteriaTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `OrganizationSuggestionCriteriaType` and its cursor. */
export type OrganizationSuggestionCriteriaTypeEdge = {
  __typename?: 'OrganizationSuggestionCriteriaTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<OrganizationSuggestionCriteriaType>;
};

export type OrganizationType = Node & {
  __typename?: 'OrganizationType';
  abExportTemplateName: ApiOrganizationAbExportTemplateNameChoices;
  auth0OrganizationId?: Maybe<Scalars['String']['output']>;
  auth0SelfServeUserId?: Maybe<Scalars['String']['output']>;
  consentRequired: Scalars['Boolean']['output'];
  customReportTypes?: Maybe<Array<Scalars['JSONString']['output']>>;
  ehrIntegrationType: ApiOrganizationEhrIntegrationTypeChoices;
  ehrSyncCleared?: Maybe<Scalars['Boolean']['output']>;
  externalId?: Maybe<Scalars['String']['output']>;
  externalLastUpdate?: Maybe<Scalars['DateTime']['output']>;
  /** The final approver can decide, and is notified, only after every other active reviewer has approved. Templates can override this. */
  finalApproverWaitsForReviewers: Scalars['Boolean']['output'];
  hubspotCompanyId?: Maybe<Scalars['String']['output']>;
  /** The ID of the object */
  id: Scalars['ID']['output'];
  inClinicVideoCaptureEnabled: Scalars['Boolean']['output'];
  isGoogleDriveUploadEnabled: Scalars['Boolean']['output'];
  isTestOrganization: Scalars['Boolean']['output'];
  manualEhrIntegration: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  notificationSettings?: Maybe<OrganizationNotificationSettingsType>;
  onboardingEnabled: Scalars['Boolean']['output'];
  organizationType: ApiOrganizationOrganizationTypeChoices;
  organizationpayorSet: OrganizationPayorTypeConnection;
  /** On by default. Turn off to opt this organization out of Team review. The report-peer-review feature flag still gates it for everyone. */
  peerReviewEnabled: Scalars['Boolean']['output'];
  reportTemplates: ReportTemplateTypeConnection;
  /** When enabled, users in this organization cannot advance past review-and-sign until all active QA suggestions on the report are resolved. */
  requireAllQaResolved: Scalars['Boolean']['output'];
  /** When Team review is on, reports cannot be completed or signed until every active reviewer has approved. Templates can override this. */
  requireApprovalBeforeExport: Scalars['Boolean']['output'];
  serviceType: ApiOrganizationServiceTypeChoices;
  suggestionCriteria?: Maybe<Array<Maybe<OrganizationSuggestionCriteriaType>>>;
  templateLogoSignedUrl?: Maybe<Scalars['String']['output']>;
  useLongTermGoals: Scalars['Boolean']['output'];
};


export type OrganizationTypeOrganizationpayorSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type OrganizationTypeReportTemplatesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdDate?: InputMaybe<Scalars['DateTime']['input']>;
  curriculum?: InputMaybe<Scalars['ID']['input']>;
  defaultPayorTemplate?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  enterpriseTemplate?: InputMaybe<Scalars['Boolean']['input']>;
  exportFramework?: InputMaybe<ApiReportTemplateExportFrameworkChoices>;
  exportTemplateFont?: InputMaybe<ApiReportTemplateExportTemplateFontChoices>;
  fileUploadConfig?: InputMaybe<ApiReportTemplateFileUploadConfigChoices>;
  finalApproverWaitsForReviewers?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  footerText?: InputMaybe<Scalars['String']['input']>;
  headerText?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  isBaseTemplate?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedDate?: InputMaybe<Scalars['DateTime']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderedReplacement?: InputMaybe<Scalars['Boolean']['input']>;
  organizationLogoAllowed?: InputMaybe<Scalars['Boolean']['input']>;
  payorType?: InputMaybe<ApiReportTemplatePayorTypeChoices>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  publishedBy?: InputMaybe<Scalars['ID']['input']>;
  reportNarrativeMappingWorkflow?: InputMaybe<Scalars['Boolean']['input']>;
  reportType?: InputMaybe<ApiReportTemplateReportTypeChoices>;
  requireAllQaResolved?: InputMaybe<Scalars['Boolean']['input']>;
  requireApprovalBeforeExport?: InputMaybe<Scalars['Boolean']['input']>;
  sampleFile?: InputMaybe<Scalars['String']['input']>;
  sampleStatus?: InputMaybe<ApiReportTemplateSampleStatusChoices>;
  status?: InputMaybe<ApiReportTemplateStatusChoices>;
  templateLogoUrl?: InputMaybe<Scalars['String']['input']>;
  templateUrl?: InputMaybe<Scalars['String']['input']>;
  treatmentPlanTemplate?: InputMaybe<Scalars['ID']['input']>;
  unifiedExport?: InputMaybe<Scalars['Boolean']['input']>;
  updatedBy?: InputMaybe<Scalars['ID']['input']>;
};

export type OrganizationTypeConnection = {
  __typename?: 'OrganizationTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<OrganizationTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `OrganizationType` and its cursor. */
export type OrganizationTypeEdge = {
  __typename?: 'OrganizationTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<OrganizationType>;
};

export enum OrganizationTypeEnum {
  Artemis = 'ARTEMIS',
  CentralReach = 'CENTRAL_REACH',
  Ensora = 'ENSORA',
  FronteraClarity = 'FRONTERA_CLARITY',
  FronteraEhr = 'FRONTERA_EHR',
  FronteraHealth = 'FRONTERA_HEALTH',
  HippHealth = 'HIPP_HEALTH',
  HiRasmus = 'HI_RASMUS',
  Measurepm = 'MEASUREPM',
  Motivity = 'MOTIVITY',
  PassageHealth = 'PASSAGE_HEALTH',
  Rethink = 'RETHINK',
  Therapz = 'THERAPZ'
}

export type OrganizationUserRolesType = Node & {
  __typename?: 'OrganizationUserRolesType';
  auth0User?: Maybe<UserType>;
  caregiver?: Maybe<CaregiverType>;
  createdDate: Scalars['DateTime']['output'];
  /** The ID of the object */
  id: Scalars['ID']['output'];
  lastUpdatedDate: Scalars['DateTime']['output'];
  organization: OrganizationType;
  pk?: Maybe<Scalars['Int']['output']>;
  provider?: Maybe<ProviderType>;
  role: ApiOrganizationUserRolesRoleChoices;
};

export type OrganizationUserRolesTypeConnection = {
  __typename?: 'OrganizationUserRolesTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<OrganizationUserRolesTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `OrganizationUserRolesType` and its cursor. */
export type OrganizationUserRolesTypeEdge = {
  __typename?: 'OrganizationUserRolesTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<OrganizationUserRolesType>;
};

/** Organization with decrypted API key for Temporal workflows */
export type OrganizationWithApiKeyType = {
  __typename?: 'OrganizationWithApiKeyType';
  apiKey?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  organizationType?: Maybe<Scalars['String']['output']>;
};

export type OtherHistoricalServiceInput = {
  endDateOfService?: InputMaybe<Scalars['String']['input']>;
  hours: Scalars['String']['input'];
  nameOfProvider?: InputMaybe<Scalars['String']['input']>;
  otherServiceId?: InputMaybe<Scalars['ID']['input']>;
  service: Scalars['String']['input'];
  startDateOfService?: InputMaybe<Scalars['String']['input']>;
};

/** The Relay compliant `PageInfo` type, containing data necessary to paginate this connection. */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']['output']>;
};

export type ParentSessionSummaryBehaviorTrendType = {
  __typename?: 'ParentSessionSummaryBehaviorTrendType';
  behavior?: Maybe<Scalars['String']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
};

export type ParentSessionSummaryHighlightType = {
  __typename?: 'ParentSessionSummaryHighlightType';
  icon?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
};

export type ParentSessionSummarySessionEntryType = {
  __typename?: 'ParentSessionSummarySessionEntryType';
  duration?: Maybe<Scalars['String']['output']>;
  locationLabel?: Maybe<Scalars['String']['output']>;
  provider?: Maybe<Scalars['String']['output']>;
};

export type ParentSessionSummaryType = Node & {
  __typename?: 'ParentSessionSummaryType';
  alsoWorkedOn?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  behaviorTrends?: Maybe<Array<Maybe<ParentSessionSummaryBehaviorTrendType>>>;
  createdDate: Scalars['DateTime']['output'];
  goalsCoveredCount?: Maybe<Scalars['Int']['output']>;
  highlights?: Maybe<Array<Maybe<ParentSessionSummaryHighlightType>>>;
  /** The ID of the object */
  id: Scalars['ID']['output'];
  lastUpdatedDate: Scalars['DateTime']['output'];
  learner: LearnerType;
  modelUsed: Scalars['String']['output'];
  organization: OrganizationType;
  pk?: Maybe<Scalars['Int']['output']>;
  promptVersion: Scalars['String']['output'];
  sessionEndDatetime?: Maybe<Scalars['DateTime']['output']>;
  sessionRecap: Scalars['String']['output'];
  sessionStartDatetime?: Maybe<Scalars['DateTime']['output']>;
  sessions?: Maybe<Array<Maybe<ParentSessionSummarySessionEntryType>>>;
  status: ApiParentSessionSummaryStatusChoices;
  summaryType: ApiParentSessionSummarySummaryTypeChoices;
  tldr: Scalars['String']['output'];
};

export enum ParsedTreatmentPlanFileDataStatusEnum {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  InProgress = 'IN_PROGRESS',
  Pending = 'PENDING'
}

export type ParsedTreatmentPlanFileDataType = Node & {
  __typename?: 'ParsedTreatmentPlanFileDataType';
  createdBy?: Maybe<UserType>;
  createdDate: Scalars['DateTime']['output'];
  data?: Maybe<Scalars['JSONString']['output']>;
  files: LearnerFileTypeConnection;
  /** The ID of the object */
  id: Scalars['ID']['output'];
  lastUpdatedDate: Scalars['DateTime']['output'];
  learner: LearnerType;
  organization: OrganizationType;
  pk?: Maybe<Scalars['Int']['output']>;
  status: ApiParsedTreatmentPlanFileDataStatusChoices;
};


export type ParsedTreatmentPlanFileDataTypeFilesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  learner?: InputMaybe<Scalars['ID']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type ParsedTreatmentPlanFileDataTypeConnection = {
  __typename?: 'ParsedTreatmentPlanFileDataTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ParsedTreatmentPlanFileDataTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `ParsedTreatmentPlanFileDataType` and its cursor. */
export type ParsedTreatmentPlanFileDataTypeEdge = {
  __typename?: 'ParsedTreatmentPlanFileDataTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<ParsedTreatmentPlanFileDataType>;
};

export type PassageEhrTargetInput = {
  ehrId: Scalars['String']['input'];
  fdmId: Scalars['ID']['input'];
  masteredOverType: Scalars['String']['input'];
  masteredOverValue: Scalars['Int']['input'];
  measureType: Scalars['String']['input'];
  measureValue: Scalars['Int']['input'];
  threshold: Scalars['String']['input'];
  title: Scalars['String']['input'];
};

export type PassageEventInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  startedAt?: InputMaybe<Scalars['String']['input']>;
};

export type PassageGoalBankType = Node & {
  __typename?: 'PassageGoalBankType';
  aiGenerated: Scalars['Boolean']['output'];
  antecedentStrategy?: Maybe<Scalars['String']['output']>;
  createdDate: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  discriminativeStimulus?: Maybe<Scalars['String']['output']>;
  errorConsequenceStrategy?: Maybe<Scalars['String']['output']>;
  errorCorrectionStrategy?: Maybe<Scalars['String']['output']>;
  expectedResponse?: Maybe<Scalars['String']['output']>;
  goal: GoalType;
  goalBank?: Maybe<ReportGoalBankType>;
  hypothesizedFunction?: Maybe<Scalars['String']['output']>;
  /** The ID of the object */
  id: Scalars['ID']['output'];
  inUse: Scalars['Boolean']['output'];
  labels?: Maybe<Scalars['JSONString']['output']>;
  lastUpdatedDate: Scalars['DateTime']['output'];
  offset?: Maybe<Scalars['String']['output']>;
  onset?: Maybe<Scalars['String']['output']>;
  operationalDefinition?: Maybe<Scalars['String']['output']>;
  organization: OrganizationType;
  pk?: Maybe<Scalars['Int']['output']>;
  promptingInstructions?: Maybe<Scalars['String']['output']>;
  reinforcementStrategy?: Maybe<Scalars['String']['output']>;
  replacementBehavior?: Maybe<Scalars['String']['output']>;
  teachingMethod?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  type: ApiPassageGoalBankTypeChoices;
};

export type PassageGoalBankTypeConnection = {
  __typename?: 'PassageGoalBankTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<PassageGoalBankTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `PassageGoalBankType` and its cursor. */
export type PassageGoalBankTypeEdge = {
  __typename?: 'PassageGoalBankTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<PassageGoalBankType>;
};

export type PassageGoalEventType = Node & {
  __typename?: 'PassageGoalEventType';
  createdDate: Scalars['DateTime']['output'];
  date: Scalars['DateTime']['output'];
  externalId: Scalars['String']['output'];
  goal: PassageGoalType;
  /** The ID of the object */
  id: Scalars['ID']['output'];
  inUse: Scalars['Boolean']['output'];
  lastUpdatedDate: Scalars['DateTime']['output'];
  organization: OrganizationType;
  pk?: Maybe<Scalars['Int']['output']>;
  text: Scalars['String']['output'];
};

export type PassageGoalEventTypeConnection = {
  __typename?: 'PassageGoalEventTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<PassageGoalEventTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `PassageGoalEventType` and its cursor. */
export type PassageGoalEventTypeEdge = {
  __typename?: 'PassageGoalEventTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<PassageGoalEventType>;
};

export type PassageGoalFilter = {
  /** Filter by latest PassageGoalPhase status (case-insensitive partial match) */
  goalStatus?: InputMaybe<Scalars['String']['input']>;
};

export type PassageGoalInput = {
  behaviorDetails?: InputMaybe<TreatmentPlanGoalsBehaviorDetailsInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  events?: InputMaybe<Array<InputMaybe<PassageEventInput>>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  labels?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  phases?: InputMaybe<Array<InputMaybe<PassagePhaseInput>>>;
  skillDetails?: InputMaybe<TreatmentPlanGoalsSkillDetailsInput>;
  targets?: InputMaybe<Array<InputMaybe<PassageTargetInput>>>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type PassageGoalPhaseType = Node & {
  __typename?: 'PassageGoalPhaseType';
  createdDate: Scalars['DateTime']['output'];
  date: Scalars['DateTime']['output'];
  externalId: Scalars['String']['output'];
  goal: PassageGoalType;
  /** The ID of the object */
  id: Scalars['ID']['output'];
  inUse: Scalars['Boolean']['output'];
  lastUpdatedDate: Scalars['DateTime']['output'];
  organization: OrganizationType;
  pk?: Maybe<Scalars['Int']['output']>;
  status: ApiPassageGoalPhaseStatusChoices;
};

export type PassageGoalPhaseTypeConnection = {
  __typename?: 'PassageGoalPhaseTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<PassageGoalPhaseTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `PassageGoalPhaseType` and its cursor. */
export type PassageGoalPhaseTypeEdge = {
  __typename?: 'PassageGoalPhaseTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<PassageGoalPhaseType>;
};

export enum PassageGoalStatusEnums {
  Baseline = 'BASELINE',
  Closed = 'CLOSED',
  Generalization = 'GENERALIZATION',
  Hold = 'HOLD',
  Inactive = 'INACTIVE',
  Maintenance = 'MAINTENANCE',
  Mastered = 'MASTERED',
  Treatment = 'TREATMENT'
}

export type PassageGoalType = Node & {
  __typename?: 'PassageGoalType';
  aiGenerated: Scalars['Boolean']['output'];
  antecedentStrategy?: Maybe<Scalars['String']['output']>;
  createdDate: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  discriminativeStimulus?: Maybe<Scalars['String']['output']>;
  errorConsequenceStrategy?: Maybe<Scalars['String']['output']>;
  errorCorrectionStrategy?: Maybe<Scalars['String']['output']>;
  events: PassageGoalEventTypeConnection;
  expectedResponse?: Maybe<Scalars['String']['output']>;
  externalId: Scalars['String']['output'];
  goal: GoalType;
  hypothesizedFunction?: Maybe<Scalars['String']['output']>;
  /** The ID of the object */
  id: Scalars['ID']['output'];
  inUse: Scalars['Boolean']['output'];
  labels?: Maybe<Scalars['JSONString']['output']>;
  lastUpdatedDate: Scalars['DateTime']['output'];
  offset?: Maybe<Scalars['String']['output']>;
  onset?: Maybe<Scalars['String']['output']>;
  operationalDefinition?: Maybe<Scalars['String']['output']>;
  organization: OrganizationType;
  passageTargets: PassageTargetTypeConnection;
  phases: PassageGoalPhaseTypeConnection;
  pk?: Maybe<Scalars['Int']['output']>;
  promptingInstructions?: Maybe<Scalars['String']['output']>;
  reinforcementStrategy?: Maybe<Scalars['String']['output']>;
  replacementBehavior?: Maybe<Scalars['String']['output']>;
  status?: Maybe<PassageGoalStatusEnums>;
  teachingMethod?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  type: ApiPassageGoalTypeChoices;
};


export type PassageGoalTypeEventsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdDate?: InputMaybe<Scalars['DateTime']['input']>;
  date?: InputMaybe<Scalars['DateTime']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  goal?: InputMaybe<Scalars['ID']['input']>;
  inUse?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedDate?: InputMaybe<Scalars['DateTime']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  organization?: InputMaybe<Scalars['ID']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
};


export type PassageGoalTypePassageTargetsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  aiGenerated?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdDate?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  discriminativeStimulus?: InputMaybe<Scalars['String']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  inUse?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedDate?: InputMaybe<Scalars['DateTime']['input']>;
  masteredOverType?: InputMaybe<Scalars['String']['input']>;
  masteredOverValue?: InputMaybe<Scalars['Int']['input']>;
  measureType?: InputMaybe<Scalars['String']['input']>;
  measureValue?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  organization?: InputMaybe<Scalars['ID']['input']>;
  passageGoal?: InputMaybe<Scalars['ID']['input']>;
  target?: InputMaybe<Scalars['ID']['input']>;
  threshold?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<ApiPassageTargetTypeChoices>;
};


export type PassageGoalTypePhasesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdDate?: InputMaybe<Scalars['DateTime']['input']>;
  date?: InputMaybe<Scalars['DateTime']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  goal?: InputMaybe<Scalars['ID']['input']>;
  inUse?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedDate?: InputMaybe<Scalars['DateTime']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  organization?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<ApiPassageGoalPhaseStatusChoices>;
};

export type PassageGoalTypeConnection = {
  __typename?: 'PassageGoalTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<PassageGoalTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `PassageGoalType` and its cursor. */
export type PassageGoalTypeEdge = {
  __typename?: 'PassageGoalTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<PassageGoalType>;
};

export type PassagePhaseInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  startedAt?: InputMaybe<Scalars['String']['input']>;
};

export type PassageSessionInformation = {
  billingCode?: InputMaybe<Scalars['String']['input']>;
  clientDateOfBirth?: InputMaybe<Scalars['Date']['input']>;
  clientExternalId?: InputMaybe<Scalars['String']['input']>;
  clientMemberFirstName?: InputMaybe<Scalars['String']['input']>;
  clientMemberLastName?: InputMaybe<Scalars['String']['input']>;
  endTime?: InputMaybe<Scalars['DateTime']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  externalOrgId?: InputMaybe<Scalars['String']['input']>;
  locationType?: InputMaybe<Scalars['String']['input']>;
  sessionNotes?: InputMaybe<Array<InputMaybe<PassageSessionNotes>>>;
  sessionTargets?: InputMaybe<Array<InputMaybe<PassageSessionTargets>>>;
  sessionTimezone?: InputMaybe<Scalars['String']['input']>;
  startTime?: InputMaybe<Scalars['DateTime']['input']>;
  teamMemberEmail?: InputMaybe<Scalars['String']['input']>;
  teamMemberExternalId?: InputMaybe<Scalars['String']['input']>;
  teamMemberFirstName?: InputMaybe<Scalars['String']['input']>;
  teamMemberLastName?: InputMaybe<Scalars['String']['input']>;
};

export type PassageSessionNotes = {
  qaDescription?: InputMaybe<Scalars['String']['input']>;
  qaExternalId: Scalars['String']['input'];
  qaResponse: Scalars['String']['input'];
  qaTitle: Scalars['String']['input'];
  qaType: SessionNoteQaTypeEnums;
  sectionDescription?: InputMaybe<Scalars['String']['input']>;
  sectionExternalId: Scalars['String']['input'];
  sectionTitle: Scalars['String']['input'];
};

export type PassageSessionTargets = {
  goalExternalId?: InputMaybe<Scalars['String']['input']>;
  goalTitle?: InputMaybe<Scalars['String']['input']>;
  goalType?: InputMaybe<Scalars['String']['input']>;
  targetDescription?: InputMaybe<Scalars['String']['input']>;
  targetExternalId?: InputMaybe<Scalars['String']['input']>;
  targetProgressCount?: InputMaybe<Scalars['Float']['input']>;
  targetProgressTotal?: InputMaybe<Scalars['Float']['input']>;
  targetTitle?: InputMaybe<Scalars['String']['input']>;
  targetType?: InputMaybe<Scalars['String']['input']>;
};

export type PassageTargetBankType = Node & {
  __typename?: 'PassageTargetBankType';
  aiGenerated: Scalars['Boolean']['output'];
  createdDate: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  discriminativeStimulus?: Maybe<Scalars['String']['output']>;
  /** The ID of the object */
  id: Scalars['ID']['output'];
  inUse: Scalars['Boolean']['output'];
  lastUpdatedDate: Scalars['DateTime']['output'];
  masteredOverType: Scalars['String']['output'];
  masteredOverValue: Scalars['Int']['output'];
  measureType: Scalars['String']['output'];
  measureValue: Scalars['Int']['output'];
  organization: OrganizationType;
  pk?: Maybe<Scalars['Int']['output']>;
  target: TargetType;
  targetBank?: Maybe<ReportTargetGoalBankType>;
  threshold: Scalars['String']['output'];
  title: Scalars['String']['output'];
  type: ApiPassageTargetBankTypeChoices;
};

export type PassageTargetBankTypeConnection = {
  __typename?: 'PassageTargetBankTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<PassageTargetBankTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `PassageTargetBankType` and its cursor. */
export type PassageTargetBankTypeEdge = {
  __typename?: 'PassageTargetBankTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<PassageTargetBankType>;
};

export type PassageTargetEventType = Node & {
  __typename?: 'PassageTargetEventType';
  createdDate: Scalars['DateTime']['output'];
  date: Scalars['DateTime']['output'];
  externalId: Scalars['String']['output'];
  /** The ID of the object */
  id: Scalars['ID']['output'];
  inUse: Scalars['Boolean']['output'];
  lastUpdatedDate: Scalars['DateTime']['output'];
  organization: OrganizationType;
  pk?: Maybe<Scalars['Int']['output']>;
  target: PassageTargetType;
  text: Scalars['String']['output'];
};

export type PassageTargetEventTypeConnection = {
  __typename?: 'PassageTargetEventTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<PassageTargetEventTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `PassageTargetEventType` and its cursor. */
export type PassageTargetEventTypeEdge = {
  __typename?: 'PassageTargetEventTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<PassageTargetEventType>;
};

export type PassageTargetInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  discriminativeStimulus?: InputMaybe<Scalars['String']['input']>;
  events?: InputMaybe<Array<InputMaybe<PassageEventInput>>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  phases?: InputMaybe<Array<InputMaybe<PassagePhaseInput>>>;
  targetMasteryCriteria?: InputMaybe<PassageTargetMasteryCriteriaInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type PassageTargetMasteryCriteriaInput = {
  masteredOverType?: InputMaybe<Scalars['String']['input']>;
  masteredOverValue?: InputMaybe<Scalars['Int']['input']>;
  measureType?: InputMaybe<Scalars['String']['input']>;
  measureValue?: InputMaybe<Scalars['Int']['input']>;
  threshold?: InputMaybe<Scalars['String']['input']>;
};

export type PassageTargetPhaseType = Node & {
  __typename?: 'PassageTargetPhaseType';
  createdDate: Scalars['DateTime']['output'];
  date: Scalars['DateTime']['output'];
  externalId: Scalars['String']['output'];
  /** The ID of the object */
  id: Scalars['ID']['output'];
  inUse: Scalars['Boolean']['output'];
  lastUpdatedDate: Scalars['DateTime']['output'];
  organization: OrganizationType;
  pk?: Maybe<Scalars['Int']['output']>;
  status: ApiPassageTargetPhaseStatusChoices;
  target: PassageTargetType;
};

export type PassageTargetPhaseTypeConnection = {
  __typename?: 'PassageTargetPhaseTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<PassageTargetPhaseTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `PassageTargetPhaseType` and its cursor. */
export type PassageTargetPhaseTypeEdge = {
  __typename?: 'PassageTargetPhaseTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<PassageTargetPhaseType>;
};

export type PassageTargetType = Node & {
  __typename?: 'PassageTargetType';
  aiGenerated: Scalars['Boolean']['output'];
  createdDate: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  discriminativeStimulus?: Maybe<Scalars['String']['output']>;
  events: PassageTargetEventTypeConnection;
  externalId: Scalars['String']['output'];
  /** The ID of the object */
  id: Scalars['ID']['output'];
  inUse: Scalars['Boolean']['output'];
  lastUpdatedDate: Scalars['DateTime']['output'];
  masteredOverType: Scalars['String']['output'];
  masteredOverValue: Scalars['Int']['output'];
  measureType: Scalars['String']['output'];
  measureValue: Scalars['Int']['output'];
  organization: OrganizationType;
  passageGoal: PassageGoalType;
  phases: PassageTargetPhaseTypeConnection;
  pk?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<PassageGoalStatusEnums>;
  target: TargetType;
  threshold: Scalars['String']['output'];
  title: Scalars['String']['output'];
  type: ApiPassageTargetTypeChoices;
};


export type PassageTargetTypeEventsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdDate?: InputMaybe<Scalars['DateTime']['input']>;
  date?: InputMaybe<Scalars['DateTime']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  inUse?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedDate?: InputMaybe<Scalars['DateTime']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  organization?: InputMaybe<Scalars['ID']['input']>;
  target?: InputMaybe<Scalars['ID']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
};


export type PassageTargetTypePhasesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdDate?: InputMaybe<Scalars['DateTime']['input']>;
  date?: InputMaybe<Scalars['DateTime']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  inUse?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedDate?: InputMaybe<Scalars['DateTime']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  organization?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<ApiPassageTargetPhaseStatusChoices>;
  target?: InputMaybe<Scalars['ID']['input']>;
};

export type PassageTargetTypeConnection = {
  __typename?: 'PassageTargetTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<PassageTargetTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `PassageTargetType` and its cursor. */
export type PassageTargetTypeEdge = {
  __typename?: 'PassageTargetTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<PassageTargetType>;
};

export type PassageTreatmentPlanInput = {
  goals?: InputMaybe<Array<InputMaybe<PassageGoalInput>>>;
};

export type PayorOrganizationInput = {
  externalPayorOrganizationId: Scalars['String']['input'];
  isActive: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
};

export type PayorReportDataToSubmitType = {
  __typename?: 'PayorReportDataToSubmitType';
  displayFilename?: Maybe<Scalars['String']['output']>;
  fileToUpload?: Maybe<Scalars['String']['output']>;
  reportData?: Maybe<Scalars['JSONString']['output']>;
};

export enum PayorReportReviewStatusEnum {
  Approved = 'APPROVED',
  NeedsRevision = 'NEEDS_REVISION'
}

export type PayorReportReviewType = Node & {
  __typename?: 'PayorReportReviewType';
  adminReviewerId?: Maybe<Scalars['String']['output']>;
  clinicalReviewerId?: Maybe<Scalars['String']['output']>;
  createdDate: Scalars['DateTime']['output'];
  feedback?: Maybe<Scalars['String']['output']>;
  feedbackFilePath?: Maybe<Scalars['String']['output']>;
  feedbackFileSignedUrl?: Maybe<Scalars['String']['output']>;
  /** The ID of the object */
  id: Scalars['ID']['output'];
  reviewerId?: Maybe<Scalars['String']['output']>;
  revisionScope?: Maybe<Scalars['String']['output']>;
  status: ApiPayorReportReviewStatusChoices;
  versionReviewed?: Maybe<Scalars['Int']['output']>;
};

export type PayorReportReviewTypeConnection = {
  __typename?: 'PayorReportReviewTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<PayorReportReviewTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `PayorReportReviewType` and its cursor. */
export type PayorReportReviewTypeEdge = {
  __typename?: 'PayorReportReviewTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<PayorReportReviewType>;
};

export enum PayorReportSubmissionStatusEnum {
  Approved = 'APPROVED',
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  Initialized = 'INITIALIZED',
  InProgress = 'IN_PROGRESS',
  NeedsRevision = 'NEEDS_REVISION'
}

export type PayorReportSubmissionType = Node & {
  __typename?: 'PayorReportSubmissionType';
  errorMessage?: Maybe<Scalars['String']['output']>;
  /** External payor report identifier (e.g. MBL report ID) */
  externalReportId?: Maybe<Scalars['String']['output']>;
  /** The ID of the object */
  id: Scalars['ID']['output'];
  jobId: Scalars['UUID']['output'];
  reportVersion?: Maybe<Scalars['Int']['output']>;
  response?: Maybe<Scalars['JSONString']['output']>;
  reviews: PayorReportReviewTypeConnection;
  status: ApiPayorReportSubmissionStatusChoices;
  submittedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type PayorReportSubmissionTypeReviewsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type PayorReportSubmissionTypeConnection = {
  __typename?: 'PayorReportSubmissionTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<PayorReportSubmissionTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `PayorReportSubmissionType` and its cursor. */
export type PayorReportSubmissionTypeEdge = {
  __typename?: 'PayorReportSubmissionTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<PayorReportSubmissionType>;
};

export enum PayorSelectionType {
  Aetna = 'AETNA',
  Anthem = 'ANTHEM',
  Bcbs = 'BCBS',
  BeaconHealthOptions = 'BEACON_HEALTH_OPTIONS',
  Bsw = 'BSW',
  Catalight = 'CATALIGHT',
  Cigna = 'CIGNA',
  EmiHealth = 'EMI_HEALTH',
  Evernorth = 'EVERNORTH',
  Humana = 'HUMANA',
  KaiserPermanente = 'KAISER_PERMANENTE',
  MagellanHealth = 'MAGELLAN_HEALTH',
  Medicaid = 'MEDICAID',
  Molina = 'MOLINA',
  Optum = 'OPTUM',
  Other = 'OTHER',
  ShareLater = 'SHARE_LATER',
  Tricare = 'TRICARE',
  UnitedHealthcare = 'UNITED_HEALTHCARE'
}

export enum PayorType {
  Aetna = 'AETNA',
  Anthem = 'ANTHEM',
  Bcbs = 'BCBS',
  BeaconHealthOptions = 'BEACON_HEALTH_OPTIONS',
  Bsw = 'BSW',
  Catalight = 'CATALIGHT',
  Cigna = 'CIGNA',
  EmiHealth = 'EMI_HEALTH',
  Evernorth = 'EVERNORTH',
  Humana = 'HUMANA',
  KaiserPermanente = 'KAISER_PERMANENTE',
  MagellanHealth = 'MAGELLAN_HEALTH',
  Medicaid = 'MEDICAID',
  Molina = 'MOLINA',
  Optum = 'OPTUM',
  Tricare = 'TRICARE',
  UnitedHealthcare = 'UNITED_HEALTHCARE'
}

export type PhaseChangeType = {
  __typename?: 'PhaseChangeType';
  date?: Maybe<Scalars['DateTime']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export type PhaseEhrImportInput = {
  date: Scalars['DateTime']['input'];
  externalId?: InputMaybe<Scalars['String']['input']>;
  status: Scalars['String']['input'];
};

export type PopulateDataFromBhtia = {
  __typename?: 'PopulateDataFromBHTIA';
  learnerFile?: Maybe<LearnerFileType>;
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type PreviousReportDetailsInput = {
  endDate: Scalars['Date']['input'];
  startDate: Scalars['Date']['input'];
  submittedDate: Scalars['Date']['input'];
};

export enum ProcessingFailureCodeEnum {
  FronteraTemplatePdf = 'FRONTERA_TEMPLATE_PDF'
}

export enum ProcessingStatus {
  Failed = 'FAILED',
  Pending = 'PENDING',
  Processing = 'PROCESSING',
  Success = 'SUCCESS'
}

export type ProductPriceListType = {
  __typename?: 'ProductPriceListType';
  price?: Maybe<Scalars['Float']['output']>;
  priceId?: Maybe<Scalars['String']['output']>;
  productId?: Maybe<Scalars['String']['output']>;
  productName?: Maybe<Scalars['String']['output']>;
  quantity?: Maybe<Scalars['Int']['output']>;
};

export type ProgressDataPointType = {
  __typename?: 'ProgressDataPointType';
  date?: Maybe<Scalars['DateTime']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

export enum ProgressType {
  Duration = 'DURATION',
  Frequency = 'FREQUENCY',
  Interval = 'INTERVAL',
  Rate = 'RATE',
  Scale = 'SCALE',
  TaskAnalysis = 'TASK_ANALYSIS',
  Trial = 'TRIAL'
}

export type PromoteReportTemplate = {
  __typename?: 'PromoteReportTemplate';
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type PromptFilter = {
  /** Prompt key to filter by */
  key?: InputMaybe<Scalars['String']['input']>;
  /** Search term to filter by name or key */
  searchTerm?: InputMaybe<Scalars['String']['input']>;
};

export type PromptInput = {
  fallbackText?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  key: Scalars['String']['input'];
  name: Scalars['String']['input'];
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  responseSchema?: InputMaybe<Scalars['JSONString']['input']>;
  sampleOutput?: InputMaybe<Scalars['String']['input']>;
};

export type PromptType = Node & {
  __typename?: 'PromptType';
  createdBy: UserType;
  createdDate: Scalars['DateTime']['output'];
  /** Prompts that must be executed before this prompt */
  dependencies: PromptTypeConnection;
  /** Prompts that must be executed before this prompt */
  dependentPrompts: PromptTypeConnection;
  draftBy?: Maybe<UserType>;
  draftOverrides?: Maybe<Scalars['JSONString']['output']>;
  draftUpdatedAt?: Maybe<Scalars['DateTime']['output']>;
  fallbackText: Scalars['String']['output'];
  /** The ID of the object */
  id: Scalars['ID']['output'];
  key: Scalars['String']['output'];
  lastUpdatedDate: Scalars['DateTime']['output'];
  name: Scalars['String']['output'];
  organization?: Maybe<OrganizationType>;
  pk?: Maybe<Scalars['Int']['output']>;
  reportTemplateSectionFields: ReportTemplateSectionFieldTypeConnection;
  /** Report types this prompt is valid for (from ReportTypeEnums). */
  reportTypes: Array<Scalars['String']['output']>;
  responseSchema?: Maybe<Scalars['JSONString']['output']>;
  sampleOutput?: Maybe<Scalars['String']['output']>;
};


export type PromptTypeDependenciesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type PromptTypeDependentPromptsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type PromptTypeReportTemplateSectionFieldsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  fieldIdentifier?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  reportSection?: InputMaybe<Scalars['ID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type PromptTypeConnection = {
  __typename?: 'PromptTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<PromptTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `PromptType` and its cursor. */
export type PromptTypeEdge = {
  __typename?: 'PromptTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<PromptType>;
};

export enum ProviderAvailability {
  Available = 'AVAILABLE',
  Unavailable = 'UNAVAILABLE'
}

export type ProviderBoolExp = {
  _and?: InputMaybe<Array<ProviderBoolExp>>;
  _not?: InputMaybe<ProviderBoolExp>;
  _or?: InputMaybe<Array<ProviderBoolExp>>;
  id?: InputMaybe<ProviderIdComparisonExp>;
  name?: InputMaybe<ProviderNameComparisonExp>;
  role?: InputMaybe<ProviderRoleComparisonExp>;
};

export type ProviderConfigFilter = {
  inClinicVideoCaptureEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  organizationExternalId?: InputMaybe<Scalars['String']['input']>;
};

export type ProviderConfigsType = Node & {
  __typename?: 'ProviderConfigsType';
  createdDate: Scalars['DateTime']['output'];
  /** The ID of the object */
  id: Scalars['ID']['output'];
  inClinicVideoCaptureEnabled: Scalars['Boolean']['output'];
  lastUpdatedDate: Scalars['DateTime']['output'];
  organization: OrganizationType;
  pk?: Maybe<Scalars['Int']['output']>;
  provider: ProviderType;
};

export type ProviderConfigsTypeConnection = {
  __typename?: 'ProviderConfigsTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ProviderConfigsTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `ProviderConfigsType` and its cursor. */
export type ProviderConfigsTypeEdge = {
  __typename?: 'ProviderConfigsTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<ProviderConfigsType>;
};

export enum ProviderFileCategoryEnum {
  ProfileImage = 'PROFILE_IMAGE',
  StyleSample = 'STYLE_SAMPLE'
}

export enum ProviderFileStatusEnum {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  Pending = 'PENDING',
  Processing = 'PROCESSING',
  Uploaded = 'UPLOADED'
}

export type ProviderFileType = Node & {
  __typename?: 'ProviderFileType';
  /** User who uploaded this file */
  createdBy?: Maybe<UserType>;
  createdDate: Scalars['DateTime']['output'];
  /** Category of the provider file */
  fileCategory: ApiProviderFileFileCategoryChoices;
  fileSize: Scalars['BigInt']['output'];
  /** The ID of the object */
  id: Scalars['ID']['output'];
  lastUpdatedDate: Scalars['DateTime']['output'];
  metadata?: Maybe<Scalars['JSONString']['output']>;
  mimeType: Scalars['String']['output'];
  organization: OrganizationType;
  originalFileName: Scalars['String']['output'];
  /** Stores output from the FileParsingWorkflow */
  parsedResult?: Maybe<Scalars['String']['output']>;
  pk?: Maybe<Scalars['Int']['output']>;
  /** Stable machine code for the failure reason, for clients to switch on without matching prose. */
  processingFailureCode?: Maybe<ApiProviderFileProcessingFailureCodeChoices>;
  processingFailureReason?: Maybe<Scalars['String']['output']>;
  /** Provider this file belongs to */
  provider: ProviderType;
  s3Key: Scalars['String']['output'];
  /** The signed S3 Provider File URL to download the file, only available when the file is successfully uploaded */
  signedS3ProviderFile?: Maybe<Scalars['String']['output']>;
  /** The signed S3 URL to upload the file, only available when the file is in pending status */
  signedS3Url?: Maybe<Scalars['String']['output']>;
  /** Current processing status of the file */
  status: ApiProviderFileStatusChoices;
};

export type ProviderFileTypeConnection = {
  __typename?: 'ProviderFileTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ProviderFileTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `ProviderFileType` and its cursor. */
export type ProviderFileTypeEdge = {
  __typename?: 'ProviderFileTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<ProviderFileType>;
};

export type ProviderFilter = {
  externalIdExists?: InputMaybe<Scalars['Boolean']['input']>;
  organizationType?: InputMaybe<Scalars['String']['input']>;
};

export type ProviderIdComparisonExp = {
  _eq?: InputMaybe<Scalars['ID']['input']>;
  _in?: InputMaybe<Array<Scalars['ID']['input']>>;
  _nin?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type ProviderInput = {
  connectionType: ConnectionTypeEnum;
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName?: InputMaybe<Scalars['String']['input']>;
  learners?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  providerRole: Array<InputMaybe<ProviderRoleEnums>>;
};

export type ProviderIntegrationsType = {
  __typename?: 'ProviderIntegrationsType';
  zoomIntegration?: Maybe<ProviderZoomIntegrationType>;
};

export type ProviderMetadataType = Node & {
  __typename?: 'ProviderMetadataType';
  active: Scalars['Boolean']['output'];
  archived?: Maybe<Scalars['Boolean']['output']>;
  bio?: Maybe<Scalars['String']['output']>;
  chatAvailability?: Maybe<ApiProviderMetadataChatAvailabilityChoices>;
  clinic?: Maybe<ClinicType>;
  clinicalCredentials?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<UserType>;
  createdDate: Scalars['DateTime']['output'];
  email?: Maybe<Scalars['String']['output']>;
  firstName: Scalars['String']['output'];
  gender?: Maybe<ApiProviderMetadataGenderChoices>;
  /** The ID of the object */
  id: Scalars['ID']['output'];
  invitationConnectionType?: Maybe<ApiProviderMetadataInvitationConnectionTypeChoices>;
  invitationCreatedAt?: Maybe<Scalars['DateTime']['output']>;
  invitationExpiresAt?: Maybe<Scalars['DateTime']['output']>;
  invitationId?: Maybe<Scalars['String']['output']>;
  invitationStatus?: Maybe<ApiProviderMetadataInvitationStatusChoices>;
  invitationUrl?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  lastUpdatedDate: Scalars['DateTime']['output'];
  licenseNumber?: Maybe<Scalars['String']['output']>;
  onboardingCompleted: Scalars['Boolean']['output'];
  organization: OrganizationType;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  pk?: Maybe<Scalars['Int']['output']>;
  professionalTitle?: Maybe<Scalars['String']['output']>;
  provider: ProviderType;
  sendNotificationAboutAssessment: Scalars['Boolean']['output'];
  smsAgreement: Scalars['Boolean']['output'];
  specifyGender?: Maybe<Scalars['String']['output']>;
  timezone?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  workingHoursEnd?: Maybe<Scalars['Time']['output']>;
  workingHoursStart?: Maybe<Scalars['Time']['output']>;
};

export type ProviderMetadataTypeConnection = {
  __typename?: 'ProviderMetadataTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ProviderMetadataTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `ProviderMetadataType` and its cursor. */
export type ProviderMetadataTypeEdge = {
  __typename?: 'ProviderMetadataTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<ProviderMetadataType>;
};

export type ProviderNameComparisonExp = {
  _ilike?: InputMaybe<Scalars['String']['input']>;
};

export type ProviderRoleComparisonExp = {
  _eq?: InputMaybe<RolesEnum>;
  _in?: InputMaybe<Array<RolesEnum>>;
  _nin?: InputMaybe<Array<RolesEnum>>;
};

export enum ProviderRoleEnums {
  Admin = 'ADMIN',
  AssessmentBcba = 'ASSESSMENT_BCBA',
  Bcba = 'BCBA',
  EvaluationPsychologist = 'EVALUATION_PSYCHOLOGIST',
  Intake = 'INTAKE',
  Psychologist = 'PSYCHOLOGIST',
  Rbt = 'RBT'
}

export type ProviderType = Node & {
  __typename?: 'ProviderType';
  archived?: Maybe<Scalars['Boolean']['output']>;
  auth0User?: Maybe<UserType>;
  createdDate: Scalars['DateTime']['output'];
  externalId?: Maybe<Scalars['String']['output']>;
  externalLastUpdate?: Maybe<Scalars['DateTime']['output']>;
  /** Provider this file belongs to */
  files: ProviderFileTypeConnection;
  hasEnteredVideoCaptureApp: Scalars['Boolean']['output'];
  /** The ID of the object */
  id: Scalars['ID']['output'];
  intercomUserJwt?: Maybe<Scalars['String']['output']>;
  lastSignedReports: ReportTypeConnection;
  lastUpdatedDate: Scalars['DateTime']['output'];
  learnerproviderSet: LearnerProviderTypeConnection;
  organizationuserrolesSet: OrganizationUserRolesTypeConnection;
  payorSubmissions: PayorReportSubmissionTypeConnection;
  pk?: Maybe<Scalars['Int']['output']>;
  profileImage?: Maybe<ProviderFileType>;
  providerOrgConfigs: ProviderConfigsTypeConnection;
  providerOrgMetadata: ProviderMetadataTypeConnection;
  /** The provider the voice signature relates to */
  providerVoiceSignature: VoiceSignatureTypeConnection;
  providermetadata?: Maybe<ProviderMetadataType>;
  role?: Maybe<Scalars['String']['output']>;
  rolesNameOnly?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  scraperlearnerimportstatusSet: ScraperLearnerImportStatusTypeConnection;
  scraperloginSet: ScraperLoginTypeConnection;
  scrapersessionworkflowSet: ScraperWorkflowTypeConnection;
  sessionproviderSet: SessionProviderTypeConnection;
  stylePrompt: LanguageStylePromptTypeConnection;
  userRoles?: Maybe<Array<Maybe<Scalars['JSONString']['output']>>>;
  zoomIntegration?: Maybe<ProviderZoomIntegrationType>;
};


export type ProviderTypeFilesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  fileCategory?: InputMaybe<ApiProviderFileFileCategoryChoices>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  provider?: InputMaybe<Scalars['ID']['input']>;
};


export type ProviderTypeLastSignedReportsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  isArchive?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  ordering?: InputMaybe<Scalars['String']['input']>;
  reportClientDetails_ClientFirstName_Icontains?: InputMaybe<Scalars['String']['input']>;
};


export type ProviderTypeLearnerproviderSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdDate?: InputMaybe<Scalars['DateTime']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedDate?: InputMaybe<Scalars['DateTime']['input']>;
  learner?: InputMaybe<Scalars['ID']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  organization?: InputMaybe<Scalars['ID']['input']>;
  provider?: InputMaybe<Scalars['ID']['input']>;
};


export type ProviderTypeOrganizationuserrolesSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  auth0User?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  caregiver?: InputMaybe<Scalars['ID']['input']>;
  createdDate?: InputMaybe<Scalars['DateTime']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedDate?: InputMaybe<Scalars['DateTime']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  organization?: InputMaybe<Scalars['ID']['input']>;
  provider?: InputMaybe<Scalars['ID']['input']>;
  role?: InputMaybe<ApiOrganizationUserRolesRoleChoices>;
};


export type ProviderTypePayorSubmissionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type ProviderTypeProviderOrgConfigsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type ProviderTypeProviderOrgMetadataArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type ProviderTypeProviderVoiceSignatureArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdDate?: InputMaybe<Scalars['DateTime']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedDate?: InputMaybe<Scalars['DateTime']['input']>;
  learner?: InputMaybe<Scalars['ID']['input']>;
  learnerLevel?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  organization?: InputMaybe<Scalars['ID']['input']>;
  provider?: InputMaybe<Scalars['ID']['input']>;
  s3Path?: InputMaybe<Scalars['String']['input']>;
  totalDurationMs?: InputMaybe<Scalars['Int']['input']>;
};


export type ProviderTypeScraperlearnerimportstatusSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type ProviderTypeScraperloginSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type ProviderTypeScrapersessionworkflowSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type ProviderTypeSessionproviderSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdDate?: InputMaybe<Scalars['DateTime']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedDate?: InputMaybe<Scalars['DateTime']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  organization?: InputMaybe<Scalars['ID']['input']>;
  provider?: InputMaybe<Scalars['ID']['input']>;
  providerType?: InputMaybe<ApiSessionProviderProviderTypeChoices>;
  therapySession?: InputMaybe<Scalars['ID']['input']>;
  videoSession?: InputMaybe<Scalars['ID']['input']>;
};


export type ProviderTypeStylePromptArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type ProviderTypeConnection = {
  __typename?: 'ProviderTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ProviderTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `ProviderType` and its cursor. */
export type ProviderTypeEdge = {
  __typename?: 'ProviderTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<ProviderType>;
};

export type ProviderZoomIntegrationType = Node & {
  __typename?: 'ProviderZoomIntegrationType';
  hasCloudRecording: Scalars['Boolean']['output'];
  /** The ID of the object */
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
};

/**
 * The status a learning-tree item is set to. CentralReach's own spelling is lower
 * case; the service maps the enum to it.
 */
export enum QaCentralReachItemStatus {
  Active = 'ACTIVE',
  Archived = 'ARCHIVED',
  Draft = 'DRAFT'
}

export type QaChangedItem = {
  __typename?: 'QaChangedItem';
  itemId?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  newStatus?: Maybe<Scalars['String']['output']>;
  previousStatus?: Maybe<Scalars['String']['output']>;
};

/**
 * Dev and staging only, for test organizations and internal or admin logins, and only
 * for goals whose names an autotest generated. Always in the schema so the schema stays
 * the same everywhere; it refuses unless every gate holds. Returns when the
 * organization's CentralReach session has made the change, or after about 20 seconds
 * with ``status`` false: a name that is not found is listed in ``message``, not an
 * error.
 */
export type QaSetCentralReachItemStatus = {
  __typename?: 'QaSetCentralReachItemStatus';
  items?: Maybe<Array<QaChangedItem>>;
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type Query = {
  __typename?: 'Query';
  /** Admin Analytics dashboard. `filters` are the page-level filters; each cell field takes optional `filters` that override them for that cell only. */
  adminAnalytics?: Maybe<AdminAnalyticsType>;
  adminDashboardEligibleOrgsM2m?: Maybe<Array<Maybe<OrganizationType>>>;
  annotation?: Maybe<Array<AnnotationType>>;
  annotationCategory?: Maybe<Array<AnnotationCategoryType>>;
  annotationMedia?: Maybe<MediaTypeConnection>;
  annotationsByAnnotater?: Maybe<Array<Maybe<AnnotationType>>>;
  annotationsByGroup?: Maybe<Array<Maybe<AnnotationType>>>;
  annotationsByMedia?: Maybe<Array<Maybe<AnnotationType>>>;
  annotationsBySession?: Maybe<Array<Maybe<AnnotationType>>>;
  annotationsByVerifier?: Maybe<Array<Maybe<AnnotationType>>>;
  assessmentTools?: Maybe<Array<Maybe<AssessmentToolType>>>;
  assignedChatTags?: Maybe<ChatTagTypeConnection>;
  avgQuestionsAskedByRbtPerVideoGraph?: Maybe<Array<Maybe<AvgQuestionAskedPerVideoGraphType>>>;
  avgResponseTimeToBcbaGraph?: Maybe<Array<Maybe<AvgResponseTimeForBcbaQuestionGraphType>>>;
  bcbaCommentsDistributionRawData?: Maybe<BcbaCommentsDistributionRawDataType>;
  bcbaResponsesToRbtQuestionsRawData?: Maybe<ResponsesToQuestionsRawDataType>;
  bcbaSessionVideosAnalytics?: Maybe<BcbaSessionAnalyticsVideosType>;
  /** Get all appointments for the configured location */
  careAllAppointments?: Maybe<Array<Maybe<CareAppointmentType>>>;
  /** Get all appointments for a specific customer by email */
  careAppointmentsByCustomerEmail?: Maybe<Array<Maybe<CareAppointmentType>>>;
  /** Get all appointments for a specific resource/clinician by email */
  careAppointmentsByResourceEmail?: Maybe<Array<Maybe<CareAppointmentType>>>;
  /** Get availability for a service within a date range (location is configured via ONSCHED_LOCATION_ID) */
  careAvailabilityByServiceId?: Maybe<CareAvailabilityType>;
  /** Get a Care Resource by email address */
  careResourceByEmail?: Maybe<CareResourceType>;
  /** Get single allocations (one-off availability blocks) for a specific resource/provider */
  careResourceSingleAllocationBlocks?: Maybe<Array<Maybe<CareResourceSingleAllocationBlockType>>>;
  /** Get weekly allocations (day-specific availability blocks for a date range) for a specific resource/provider */
  careResourceWeeklyAllocationBlocks?: Maybe<Array<Maybe<CareResourceWeeklyAllocationBlockType>>>;
  /** Get a specific Care Service by ID */
  careServiceById?: Maybe<CareServiceType>;
  /** Get all available Care Services */
  careServices?: Maybe<Array<Maybe<CareServiceType>>>;
  caregiverById?: Maybe<CaregiverType>;
  caregiverConsents?: Maybe<Array<Maybe<CaregiverConsentType>>>;
  caregiverMetadata?: Maybe<Array<CaregiverMetadataType>>;
  caregivers?: Maybe<CaregiverTypeConnection>;
  chat?: Maybe<ChatType>;
  chatConversationSummary?: Maybe<Scalars['String']['output']>;
  chatMembers?: Maybe<ChatMemberTypeConnection>;
  chatMessages?: Maybe<ChatMessageTypeConnection>;
  chatNotes?: Maybe<ChatNoteTypeConnection>;
  chatSuggestions?: Maybe<Array<Maybe<ChatSuggestionType>>>;
  chatTags?: Maybe<ChatTagTypeConnection>;
  chatbotChatMessages?: Maybe<ChatMessageTypeConnection>;
  chatbotChats?: Maybe<ChatTypeConnection>;
  chats?: Maybe<ChatTypeConnection>;
  /** Check the invitation status for the logged-in Caregiver's Circle community account. Returns memberExists=true if the member has been invited, and invitationAccepted=true if they have accepted the invitation and can access the community. Use this to poll for invitation acceptance after creating a community profile. */
  circleCommunityInvitationStatus?: Maybe<CircleInvitationStatusType>;
  /** Check if the logged-in Caregiver has a Circle community account. Returns exists=true with member details if found, exists=false otherwise. */
  circleCommunityMemberExists?: Maybe<CommunityMemberExistsType>;
  /** Get an access token for the logged-in Caregiver's Circle community account. This token can be used to access Circle's Member APIs (home feed, spaces, posts, etc.). The token has an expiration time and should be refreshed before expiry. */
  circleCommunityMemberToken?: Maybe<CircleAuthTokenType>;
  /** Get all available spaces in the Circle community. Returns a list of spaces that members can join. Use this during onboarding to let users select their interests. */
  circleCommunitySpaces?: Maybe<Array<Maybe<CircleSpaceType>>>;
  clinicLeads?: Maybe<ClinicLeadTypeConnection>;
  clinicListingStaging?: Maybe<ClinicListingStagingTypeConnection>;
  clinicListings?: Maybe<ClinicListingTypeConnection>;
  clinicMemberships?: Maybe<Array<Maybe<ClinicMembershipType>>>;
  clinics?: Maybe<ClinicTypeConnection>;
  clipById?: Maybe<ClipType>;
  communityCaregiverByEmail?: Maybe<CaregiverType>;
  communityCaregivers?: Maybe<CaregiverMetadataTypeConnection>;
  /** The client's CentralReach learning tree with roles and the checks before lock. Null until a structure has been read. */
  crLearningTree?: Maybe<CrLearningTreeType>;
  downloadableTemplates: Array<DownloadableTemplatesType>;
  /** One EHR action request by id (Frontend) */
  ehrActionRequest?: Maybe<EhrActionRequestType>;
  /** Recent EHR action requests for the organization (Frontend) */
  ehrActionRequests?: Maybe<Array<Maybe<EhrActionRequestType>>>;
  ehrConnection?: Maybe<EhrConnection>;
  ehrExternalIds?: Maybe<EhrExternalIdsResult>;
  exportReportDocument?: Maybe<ExportReportDocumentPayload>;
  /** Export a ReportTemplate as JSON for migration/import. */
  exportReportTemplateJson?: Maybe<ReportTemplateJsonType>;
  fronteraClarityProviders?: Maybe<ProviderTypeConnection>;
  fronteraGoal?: Maybe<FronteraGoalType>;
  fronteraGoals?: Maybe<FronteraGoalTypeConnection>;
  getAllAuth0OrganizationsInFdm?: Maybe<OrganizationTypeConnection>;
  getAllBaseSuggestionCriteria?: Maybe<Array<SuggestionCriteriaType>>;
  getAnnotationClipsCount?: Maybe<Scalars['JSONString']['output']>;
  getAnnotationMediaByVideoId?: Maybe<MediaType>;
  getAnnotationTag?: Maybe<AnnotationTagTypeConnection>;
  getAnnotatorUsers?: Maybe<AnnotatorUserTypeConnection>;
  getAssignmentAnnotation?: Maybe<ClipAnnotationTypeConnection>;
  getAssignmentAnnotationById?: Maybe<ClipAnnotationType>;
  /** M2M-authorized: returns the most-recently-updated PUBLISHED base ReportTemplate for the given report_type (or null). Base templates are global, so this query does not require organization context. */
  getBaseReportTemplateM2m?: Maybe<ReportTemplateType>;
  getBeaconCameraConfigs?: Maybe<Array<Maybe<BeaconCameraConfigType>>>;
  getBillableSummaryByM2m?: Maybe<BillableSessionSummaryType>;
  getCumulativeTargets?: Maybe<Array<Maybe<CumulativeTargets>>>;
  /** Return all curricula for the requesting organization. */
  getCurricula?: Maybe<Array<CurriculumType>>;
  getEhrClientImportStatus?: Maybe<EhrScraperLearnerImportStatusResponse>;
  getEhrClientImportStatusM2m?: Maybe<LearnerImportStatusType>;
  /** Get saved EHR credentials for provider (Temporal) */
  getEhrCredentials?: Maybe<EhrCredentialsType>;
  getEnterpriseReportTemplate?: Maybe<ReportTemplateType>;
  getEnterpriseReportTemplates?: Maybe<ReportTemplateTypeConnection>;
  getFronteraReportGoals?: Maybe<ReportGoalTypeConnection>;
  getGoalBankFolders?: Maybe<CustomGoalBankFoldersType>;
  getGoalBankGoals?: Maybe<ReportGoalBankTypeConnection>;
  getGoalBankLongTermGoals?: Maybe<LongTermGoalBankTypeConnection>;
  getGoalBankTargets?: Maybe<ReportTargetGoalBankTypeConnection>;
  getGoogleDriveUploadEnableOrganizations?: Maybe<OrganizationTypeConnection>;
  getHippHealthOrganizationsWithApiKeys?: Maybe<Array<Maybe<OrganizationWithApiKeyType>>>;
  getLanguageStylePrompt?: Maybe<LanguageStylePromptType>;
  getLearnerFiles?: Maybe<LearnerFileTypeConnection>;
  getLearnerFilesByLearner?: Maybe<LearnerFileTypeConnection>;
  getLearnerFormStatus?: Maybe<OnboardingFormStatusTypeConnection>;
  getLearnerLatestSessionsByM2m?: Maybe<VideoSessionTypeConnection>;
  getLearnerProviderSessions?: Maybe<VideoSessionTypeConnection>;
  getLearnersSessionForVqmByM2m?: Maybe<SessionLearnerTypeConnection>;
  getLinkedCaregiverLearners?: Maybe<LearnerTypeConnection>;
  getLinkedProviderLearners?: Maybe<LearnerTypeConnection>;
  /** Resolve a ZIP code to location (country, state, city, lat/lng) using Google Geocoding API. For invalid/empty zip or no results, returns success=false and message. For other issues (e.g. missing credentials) raises a GraphQL error. */
  getLocationFromZip?: Maybe<LocationFromZipResult>;
  getLoginCaregiver?: Maybe<CaregiverType>;
  getLoginProvider?: Maybe<ProviderType>;
  getLoginStatus?: Maybe<EhrScraperLoginStatusType>;
  getMediaAiPrediction?: Maybe<MediaAiPredictionTypeConnection>;
  getMediaAiPredictionMetricsByMediaId?: Maybe<MediaAiPredictionMetricTypeConnection>;
  getMediaByCaregiver?: Maybe<MediaTypeConnection>;
  getMediaByCaregiverByMediaId?: Maybe<MediaType>;
  getMediaById?: Maybe<MediaTypeConnection>;
  getMediaByProvider?: Maybe<MediaTypeConnection>;
  getMediaByProviderByMediaId?: Maybe<MediaType>;
  getMediaBySessionId?: Maybe<MediaTypeConnection>;
  getMediaBySessionIdM2m?: Maybe<MediaTypeConnection>;
  getMediaClip?: Maybe<Array<ClipType>>;
  getMediaCommentReplies?: Maybe<MediaCommentsTypeConnection>;
  getMediaComments?: Maybe<MediaCommentsTypeConnection>;
  getMediaGoalMoments?: Maybe<GoalTypeConnection>;
  getMediaModelConfigByOrg?: Maybe<Array<Maybe<MediaModelConfigType>>>;
  getMediaStatusCount?: Maybe<Scalars['JSONString']['output']>;
  getMediaStreamByMediaId?: Maybe<MediaStreamType>;
  getMediaTargetPredictionFeedbacks?: Maybe<MediaTargetPredictionFeedbackTypeConnection>;
  getMediaTargetPredictions?: Maybe<MediaTargetPredictionTypeConnection>;
  getMediaTargetPredictionsByM2m?: Maybe<MediaTargetPredictionTypeConnection>;
  getMediaTranscript?: Maybe<TranscriptLineRecordTypeConnection>;
  getMediaTranscriptByM2m?: Maybe<MediaTranscriptType>;
  getNotifications?: Maybe<NotificationsTypeConnection>;
  getOrganizationByIdM2m?: Maybe<OrganizationType>;
  getOrganizationEhrCredentials?: Maybe<OrganizationEhrCredentialType>;
  getOrganizationProviders?: Maybe<ProviderTypeConnection>;
  getPassageHealthOrganizations?: Maybe<OrganizationTypeConnection>;
  getPayorReportDataToSubmit?: Maybe<PayorReportDataToSubmitType>;
  getPayorReportSubmissionStatus?: Maybe<PayorReportSubmissionType>;
  /** Payor report submission rows for the given report (current organization only) */
  getPayorReportSubmissionsByReportId?: Maybe<PayorReportSubmissionTypeConnection>;
  getPendingUploadSessionIds?: Maybe<Array<Maybe<Scalars['ID']['output']>>>;
  getProductPriceList?: Maybe<Array<Maybe<ProductPriceListType>>>;
  getPrompt?: Maybe<PromptType>;
  getProviderFiles?: Maybe<ProviderFileTypeConnection>;
  getProviderFilesByM2m?: Maybe<ProviderFileTypeConnection>;
  getProviderLearners?: Maybe<LearnerTypeConnection>;
  getProviderListByRole?: Maybe<ProviderTypeConnection>;
  getProvidersForAssigningToLearner?: Maybe<ProviderTypeConnection>;
  getProvidersForSession?: Maybe<ProviderTypeConnection>;
  getQuestionsAskedByRbtRawData?: Maybe<QuestionsAskedByRbtRawDataType>;
  getRbtVideoUploadTimeRawData?: Maybe<RbtVideoUploadTimeRawDataType>;
  getReIdFileOfSessionMedia?: Maybe<MediaAiPredictionTypeConnection>;
  getReassessmentReportGoals?: Maybe<ReportGoalTypeConnection>;
  getRecommendationBankFolders?: Maybe<RecommendationBankFoldersType>;
  getRecommendationBankItems?: Maybe<Array<RecommendationBankItemType>>;
  getRecordedVideoDistributionRawData?: Maybe<RecordedVideosDistributionRawDataType>;
  getReport?: Maybe<ReportTypeConnection>;
  /** Return all ReportDomain records for the given report, ordered by template rank. */
  getReportDomains?: Maybe<Array<ReportDomainType>>;
  getReportDomainsM2m?: Maybe<ReportDomainTypeConnection>;
  getReportGoal?: Maybe<ReportGoalType>;
  getReportGoalM2m?: Maybe<ReportGoalType>;
  getReportGoals?: Maybe<ReportGoalTypeConnection>;
  getReportGoalsByReport?: Maybe<ReportGoalTypeConnection>;
  getReportGoalsM2m?: Maybe<ReportGoalTypeConnection>;
  getReportLearnerFiles?: Maybe<LearnerFileTypeConnection>;
  getReportM2m?: Maybe<ReportType>;
  /** Payor-specific metadata for the given report (current organization only) */
  getReportPayorMetadataByReportId?: Maybe<ReportPayorMetadataType>;
  getReportPdfStatus?: Maybe<ReportPdfStatusType>;
  getReportReviewItems?: Maybe<Array<Maybe<ReportReviewItemInterface>>>;
  getReportReviewers: Array<ReportReviewerType>;
  getReportSectionFields?: Maybe<ReportSectionFieldsTypeConnection>;
  getReportSections?: Maybe<ReportSectionsTypeConnection>;
  getReportSuggestionWorkflowData?: Maybe<ReportSuggestionWorkflowDataType>;
  /** @deprecated Use getReportReviewItems(filter: {source: QA_SCAN}) instead. */
  getReportSuggestions?: Maybe<ReportSuggestionTypeConnection>;
  getReportTargetM2m?: Maybe<ReportTargetType>;
  getReportTargets?: Maybe<ReportTargetTypeConnection>;
  getReportTemplate?: Maybe<ReportTemplateType>;
  getReportTemplateGlobals?: Maybe<ReportTemplateSectionFieldTypeConnection>;
  getReportTemplateToExport?: Maybe<ReportTemplateTypeConnection>;
  getReportTemplates?: Maybe<ReportTemplateTypeConnection>;
  getReportToExport?: Maybe<ReportTypeConnection>;
  getReports?: Maybe<ReportTypeConnection>;
  getSessionAiPredictionBySessionId?: Maybe<SessionAiPredictionTypeConnection>;
  getSessionAndSessionNoteDataByM2m?: Maybe<SessionWithSessionNoteDataType>;
  getSessionAudioMetricsByM2m?: Maybe<SessionAudioMetricsType>;
  getSessionCaregivers?: Maybe<CaregiverTypeConnection>;
  getSessionEngagementInsight?: Maybe<SessionEngagementInsightTypeConnection>;
  getSessionEngagementScoreBySessionId?: Maybe<Array<Maybe<EngagementScoreType>>>;
  getSessionListByM2m?: Maybe<VideoSessionTypeConnection>;
  getSessionMediaStream?: Maybe<MediaStreamType>;
  getSessionProgress?: Maybe<GetSessionProgressType>;
  getSessionSummaries?: Maybe<SessionAiPredictionTypeConnection>;
  getSessionSummaryBySessionId?: Maybe<SessionAiPredictionType>;
  getTargetProgressTreatmentPlanByM2m?: Maybe<TargetProgressTreatmentPlanType>;
  getTotalVideoDurationRawData?: Maybe<TotalVideoDurationRawDataType>;
  getTranscriptCsvContent?: Maybe<TranscriptCsvContentType>;
  getTranscriptDataByMediaId?: Maybe<TranscriptLineRecordTypeConnection>;
  getUserAccountDetails?: Maybe<UserStripeAccountDetailsType>;
  getUserBillingDetails?: Maybe<UserBillingDetailsTypeConnection>;
  getUserCardAndAssessmentDetails?: Maybe<UserCardAndAssessmentDetailsType>;
  getUserOrgnizationDetails?: Maybe<OrganizationType>;
  getVideoCommentsReceivedByRbtRawData?: Maybe<VideoCommentsReceivedByRbtRawDataType>;
  getZoomAccountAccessToken?: Maybe<Scalars['String']['output']>;
  goal?: Maybe<GoalType>;
  goalCategories?: Maybe<DomainTypeConnection>;
  goals?: Maybe<GoalTypeConnection>;
  /** Check if current provider has saved EHR credentials (Frontend) */
  hasEhrCredentials?: Maybe<EhrCredentialsExistType>;
  hatchPlanById?: Maybe<HatchPlanType>;
  hatchPlanVisualizationById?: Maybe<HatchPlanVisualizationType>;
  hatchPlansByLearnerCaregiver?: Maybe<Array<Maybe<HatchPlanType>>>;
  hippHealthGoal?: Maybe<HippHealthGoalType>;
  hippHealthGoals?: Maybe<HippHealthGoalTypeConnection>;
  /** @deprecated Use hippHealthGoalsM2m on the internal M2M schema (/graphql/internal/); requires organization_id (PLA-801). */
  hippHealthGoalsM2m?: Maybe<HippHealthGoalTypeConnection>;
  hirasmusGoal?: Maybe<HiRasmusGoalType>;
  hirasmusGoals?: Maybe<HiRasmusGoalTypeConnection>;
  inClinicVideoCaptureEnabledOrganizations?: Maybe<OrganizationTypeConnection>;
  insuranceDetails?: Maybe<Array<InsuranceDetailsType>>;
  integrationSyncConfigM2m?: Maybe<Array<IntegrationSyncConfigType>>;
  learner?: Maybe<Array<LearnerType>>;
  learnerAuthorizations?: Maybe<LearnerAuthorizationsTypeConnection>;
  learnerAvailability?: Maybe<Array<LearnerAvailabilityType>>;
  learnerById?: Maybe<LearnerType>;
  learnerByIdM2m?: Maybe<LearnerType>;
  learnerChatMemory?: Maybe<LearnerChatMemoryType>;
  learnerEducation?: Maybe<Array<LearnerEducationType>>;
  /** Internal-only: every stored field on the learner's EHR goal and target rows. */
  learnerEhrProgramming?: Maybe<LearnerEhrProgramming>;
  /** Internal-only: one page of session data points, newest first, for exactly one of targetId, goalId (goal-level rows) or unmatched. */
  learnerEhrSessionData?: Maybe<EhrSessionDataPage>;
  /** Internal-only: the learner's EHR read runs, newest first. */
  learnerEhrSyncs?: Maybe<EhrSyncRunPage>;
  learnerFileById?: Maybe<LearnerFileType>;
  learnerM2m?: Maybe<Array<LearnerType>>;
  learnerMedications?: Maybe<Array<LearnerMedicationsType>>;
  learnerMetadata?: Maybe<Array<LearnerMetadataType>>;
  learnerOnboardingQuestions?: Maybe<Array<LearnerOnboardingQuestionsType>>;
  learnerPrimaryProvider?: Maybe<Array<LearnerPrimaryProviderType>>;
  learnerProviders?: Maybe<LearnerProviderTypeConnection>;
  learnersRecentSession?: Maybe<SessionLearnerTypeConnection>;
  media?: Maybe<Array<MediaType>>;
  mediaByAnnotater?: Maybe<Array<Maybe<MediaType>>>;
  mediaById?: Maybe<MediaType>;
  mediaDevice?: Maybe<Array<MediaDeviceType>>;
  mediaMetaData?: Maybe<Array<MediaMetadataType>>;
  motivityGoal?: Maybe<MotivityGoalType>;
  motivityGoals?: Maybe<MotivityGoalTypeConnection>;
  notificationOptOut?: Maybe<NotificationOptOutTypeConnection>;
  orgHasGoalBankEmbeddings?: Maybe<Scalars['Boolean']['output']>;
  organizationNotificationSettings?: Maybe<OrganizationNotificationSettingsTypeConnection>;
  organizations?: Maybe<OrganizationTypeConnection>;
  orginazationFilterM2m?: Maybe<Array<OrganizationType>>;
  parentSessionSummaries?: Maybe<Array<Maybe<ParentSessionSummaryType>>>;
  parsedTreatmentPlanFileDataById?: Maybe<ParsedTreatmentPlanFileDataType>;
  parsedTreatmentPlanFilesData?: Maybe<ParsedTreatmentPlanFileDataTypeConnection>;
  passageGoal?: Maybe<PassageGoalType>;
  passageGoals?: Maybe<PassageGoalTypeConnection>;
  passageGoalsM2m?: Maybe<PassageGoalTypeConnection>;
  passageSessionSummaryEligibleOrgsM2m?: Maybe<Array<Maybe<OrganizationType>>>;
  prompts?: Maybe<PromptTypeConnection>;
  provider?: Maybe<Array<ProviderType>>;
  providerByAuth0Id?: Maybe<ProviderType>;
  providerByEmail?: Maybe<ProviderType>;
  providerById?: Maybe<ProviderType>;
  providerFilteredByConfig?: Maybe<ProviderTypeConnection>;
  providerIntegrations?: Maybe<ProviderIntegrationsType>;
  providerM2m?: Maybe<Array<ProviderType>>;
  providerMetadata?: Maybe<Array<ProviderMetadataType>>;
  providersLearnersM2m?: Maybe<LearnerTypeConnection>;
  rbtResponsesToBcbaQuestionsRawData?: Maybe<ResponsesToQuestionsRawDataType>;
  rbtSessionVideosAnalytics?: Maybe<RbtSessionAnalyticsVideosType>;
  reassessmentEhrGoals?: Maybe<Array<Maybe<EhrGoal>>>;
  relationship?: Maybe<Array<RelationshipType>>;
  reportExportData?: Maybe<ReportExportDataType>;
  reportReviewCounts: ReportReviewCountsType;
  reviewCompletionTimeRawData?: Maybe<ReviewCompletionTimeRawDataType>;
  /** Vector similarity search over the goal bank scoped to an organization and the curriculum linked to the given report template. Returns up to top_k results ordered by cosine similarity (highest first). */
  searchSimilarGoalBankGoals?: Maybe<Array<Maybe<GoalBankSearchResultType>>>;
  sessionAnalyticsVideosOverview?: Maybe<SessionAnalyticsVideosOverviewType>;
  sessionByProviderDateRangeDataM2m?: Maybe<TherapySessionTypeConnection>;
  sessionCaregiver?: Maybe<Array<SessionCaregiverType>>;
  sessionLearnersWithSessions?: Maybe<SessionLearnerTypeConnection>;
  sessionProvider?: Maybe<Array<SessionProviderType>>;
  sessionsByLearnerId?: Maybe<VideoSessionTypeConnection>;
  tasks?: Maybe<TaskTypeConnection>;
  templateExportData?: Maybe<ReportExportDataType>;
  therapzGoal?: Maybe<TherapzGoalType>;
  therapzGoals?: Maybe<TherapzGoalTypeConnection>;
  totalOverviewVideosRawTextData?: Maybe<TotalVideosOverviewRawTextType>;
  totalVideosOverviewGraph?: Maybe<Array<Maybe<TotalVideosOverviewGraphType>>>;
  transcript?: Maybe<Array<TranscriptType>>;
  /** Get treatment plan template by report ID */
  treatmentPlanTemplate?: Maybe<TreatmentPlanTemplateType>;
  unembeddedGoalBankGoals?: Maybe<ReportGoalBankTypeConnection>;
  videoSessionById?: Maybe<VideoSessionType>;
  videoSessionByIdM2m?: Maybe<VideoSessionType>;
  videoSessions?: Maybe<Array<VideoSessionType>>;
  videosDurationOverviewGraph?: Maybe<Array<Maybe<VideosDurationOverviewGraphType>>>;
  videosReviewedOverviewGraph?: Maybe<Array<Maybe<VideosReviewedOverviewGraphType>>>;
  videosReviewedRawData?: Maybe<VideosReviewedRawTextType>;
  voiceSignature?: Maybe<VoiceSignatureTypeConnection>;
};


export type QueryAdminAnalyticsArgs = {
  filters: AnalyticsFiltersInput;
};


export type QueryAnnotationMediaArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  blobId?: InputMaybe<Scalars['UUID']['input']>;
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdDate?: InputMaybe<Scalars['DateTime']['input']>;
  endDatetime?: InputMaybe<Scalars['DateTime']['input']>;
  filePath?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedDate?: InputMaybe<Scalars['DateTime']['input']>;
  mediaGroup?: InputMaybe<Scalars['ID']['input']>;
  mediaLanguage?: InputMaybe<ApiMediaMediaLanguageChoices>;
  mediaSource?: InputMaybe<ApiMediaMediaSourceChoices>;
  mediaType?: InputMaybe<ApiMediaMediaTypeChoices>;
  multiplePeopleIncludingChildDuration?: InputMaybe<Scalars['Float']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  organization?: InputMaybe<Scalars['ID']['input']>;
  recordingId?: InputMaybe<Scalars['String']['input']>;
  startDatetime?: InputMaybe<Scalars['DateTime']['input']>;
  thumbnailManifestPath?: InputMaybe<Scalars['String']['input']>;
  totalDuration?: InputMaybe<Scalars['Float']['input']>;
  videoSession?: InputMaybe<Scalars['ID']['input']>;
  videoUploadStatus?: InputMaybe<ApiMediaVideoUploadStatusChoices>;
  viewedAt?: InputMaybe<Scalars['DateTime']['input']>;
  viewedBy?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryAnnotationsByAnnotaterArgs = {
  annotaterId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryAnnotationsByGroupArgs = {
  groupId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryAnnotationsByMediaArgs = {
  mediaId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryAnnotationsBySessionArgs = {
  videoSessionId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryAnnotationsByVerifierArgs = {
  verifierId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryAssessmentToolsArgs = {
  reportType: ReportTypeEnums;
};


export type QueryAssignedChatTagsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  chatId: Scalars['ID']['input'];
  createdDate?: InputMaybe<Scalars['DateTime']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedDate?: InputMaybe<Scalars['DateTime']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  organization?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryAvgQuestionsAskedByRbtPerVideoGraphArgs = {
  comparisonFromDate?: InputMaybe<Scalars['Date']['input']>;
  comparisonToDate?: InputMaybe<Scalars['Date']['input']>;
  fromDate: Scalars['Date']['input'];
  toDate: Scalars['Date']['input'];
};


export type QueryAvgResponseTimeToBcbaGraphArgs = {
  comparisonFromDate?: InputMaybe<Scalars['Date']['input']>;
  comparisonToDate?: InputMaybe<Scalars['Date']['input']>;
  fromDate: Scalars['Date']['input'];
  toDate: Scalars['Date']['input'];
};


export type QueryBcbaCommentsDistributionRawDataArgs = {
  bcbaProviderIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  fromDate: Scalars['Date']['input'];
  learnerIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  toDate: Scalars['Date']['input'];
};


export type QueryBcbaResponsesToRbtQuestionsRawDataArgs = {
  bcbaProviderIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  forResponseRate?: InputMaybe<Scalars['Boolean']['input']>;
  fromDate: Scalars['Date']['input'];
  learnerIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  toDate: Scalars['Date']['input'];
};


export type QueryBcbaSessionVideosAnalyticsArgs = {
  bcbaProviderIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  comparisonFromDate?: InputMaybe<Scalars['Date']['input']>;
  comparisonToDate?: InputMaybe<Scalars['Date']['input']>;
  fromDate: Scalars['Date']['input'];
  toDate: Scalars['Date']['input'];
};


export type QueryCareAppointmentsByCustomerEmailArgs = {
  email: Scalars['String']['input'];
  endDate?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCareAppointmentsByResourceEmailArgs = {
  email: Scalars['String']['input'];
  endDate?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCareAvailabilityByServiceIdArgs = {
  endDate: Scalars['String']['input'];
  resourceIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  serviceId: Scalars['String']['input'];
  startDate: Scalars['String']['input'];
  timezone?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCareResourceByEmailArgs = {
  email: Scalars['String']['input'];
};


export type QueryCareResourceSingleAllocationBlocksArgs = {
  endDate: Scalars['String']['input'];
  resourceEmail: Scalars['String']['input'];
  startDate: Scalars['String']['input'];
};


export type QueryCareResourceWeeklyAllocationBlocksArgs = {
  endDate: Scalars['String']['input'];
  resourceEmail: Scalars['String']['input'];
  startDate: Scalars['String']['input'];
};


export type QueryCareServiceByIdArgs = {
  serviceId: Scalars['String']['input'];
};


export type QueryCaregiverByIdArgs = {
  caregiverId: Scalars['ID']['input'];
};


export type QueryCaregiverConsentsArgs = {
  caregiverId?: InputMaybe<Scalars['ID']['input']>;
  learnerId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryCaregiversArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  caregiverOrgMetadata_Email_Icontains?: InputMaybe<Scalars['String']['input']>;
  caregiverOrgMetadata_FirstName_Icontains?: InputMaybe<Scalars['String']['input']>;
  caregiverOrgMetadata_HasEnteredParentCommunity?: InputMaybe<Scalars['Boolean']['input']>;
  caregiverOrgMetadata_LastName_Icontains?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<CaregiversFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryChatArgs = {
  chatId: Scalars['ID']['input'];
  includeMessages?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryChatConversationSummaryArgs = {
  chatId: Scalars['ID']['input'];
};


export type QueryChatMembersArgs = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ChatsFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryChatMessagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  attachmentKind?: InputMaybe<ChatAttachmentKindEnum>;
  before?: InputMaybe<Scalars['String']['input']>;
  chat?: InputMaybe<Scalars['ID']['input']>;
  chatId: Scalars['ID']['input'];
  createdAfter?: InputMaybe<Scalars['DateTime']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  role?: InputMaybe<ApiChatMessageRoleChoices>;
  sequenceNumber?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<ChatMessageSortByEnum>;
  untilSequenceNumber?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryChatNotesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  chat?: InputMaybe<Scalars['ID']['input']>;
  chatId: Scalars['ID']['input'];
  content?: InputMaybe<Scalars['String']['input']>;
  createdDate?: InputMaybe<Scalars['DateTime']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedDate?: InputMaybe<Scalars['DateTime']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  organization?: InputMaybe<Scalars['ID']['input']>;
  user?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryChatSuggestionsArgs = {
  learnerId: Scalars['ID']['input'];
};


export type QueryChatTagsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdDate?: InputMaybe<Scalars['DateTime']['input']>;
  filter?: InputMaybe<ChatTagsFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedDate?: InputMaybe<Scalars['DateTime']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  organization?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryChatbotChatMessagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  chat?: InputMaybe<Scalars['ID']['input']>;
  chatId: Scalars['ID']['input'];
  createdAfter?: InputMaybe<Scalars['DateTime']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  role?: InputMaybe<ApiChatMessageRoleChoices>;
  sequenceNumber?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryChatbotChatsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ChatbotChatsFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  learner?: InputMaybe<Scalars['ID']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<ApiChatStatusChoices>;
  summaryStatus?: InputMaybe<ApiChatSummaryStatusChoices>;
  type?: InputMaybe<ApiChatTypeChoices>;
  user?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryChatsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ChatsFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  learner?: InputMaybe<Scalars['ID']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<ApiChatStatusChoices>;
  summaryStatus?: InputMaybe<ApiChatSummaryStatusChoices>;
  type?: InputMaybe<ApiChatTypeChoices>;
  user?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryClinicLeadsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  clinicListing?: InputMaybe<Scalars['ID']['input']>;
  createdDate?: InputMaybe<Scalars['DateTime']['input']>;
  filter: ClinicLeadFilter;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedDate?: InputMaybe<Scalars['DateTime']['input']>;
  learner?: InputMaybe<Scalars['ID']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  payor?: InputMaybe<ApiClinicLeadPayorChoices>;
};


export type QueryClinicListingStagingArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  crawlStatus?: InputMaybe<ApiClinicListingStagingCrawlStatusChoices>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  parseStatus?: InputMaybe<ApiClinicListingStagingParseStatusChoices>;
  runId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryClinicListingsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdDate?: InputMaybe<Scalars['DateTime']['input']>;
  filter: ClinicListingSearchFilter;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedDate?: InputMaybe<Scalars['DateTime']['input']>;
  location?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  verificationStatus?: InputMaybe<ApiClinicListingVerificationStatusChoices>;
};


export type QueryClinicsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdDate?: InputMaybe<Scalars['DateTime']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedDate?: InputMaybe<Scalars['DateTime']['input']>;
  location?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryClipByIdArgs = {
  clipId: Scalars['ID']['input'];
};


export type QueryCommunityCaregiverByEmailArgs = {
  email: Scalars['String']['input'];
};


export type QueryCommunityCaregiversArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryCrLearningTreeArgs = {
  learnerId: Scalars['ID']['input'];
  reportId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryEhrActionRequestArgs = {
  requestId: Scalars['Int']['input'];
};


export type QueryEhrActionRequestsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};


export type QueryEhrExternalIdsArgs = {
  goalIds: Array<InputMaybe<Scalars['Int']['input']>>;
  orgType: Scalars['String']['input'];
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  targetIds: Array<InputMaybe<Scalars['Int']['input']>>;
};


export type QueryExportReportDocumentArgs = {
  exportType: ExportTypeEnum;
  reportId: Scalars['ID']['input'];
};


export type QueryExportReportTemplateJsonArgs = {
  id: Scalars['ID']['input'];
};


export type QueryFronteraClarityProvidersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  auth0User?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdDate?: InputMaybe<Scalars['DateTime']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  externalLastUpdate?: InputMaybe<Scalars['DateTime']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasEnteredVideoCaptureApp?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedDate?: InputMaybe<Scalars['DateTime']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryFronteraGoalArgs = {
  id: Scalars['ID']['input'];
};


export type QueryFronteraGoalsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  aiGenerated?: InputMaybe<Scalars['Boolean']['input']>;
  baseline?: InputMaybe<Scalars['String']['input']>;
  baselineDate?: InputMaybe<Scalars['Date']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdDate?: InputMaybe<Scalars['DateTime']['input']>;
  dateMastered?: InputMaybe<Scalars['Date']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FronteraGoalFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  goal?: InputMaybe<Scalars['ID']['input']>;
  inUse?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedDate?: InputMaybe<Scalars['DateTime']['input']>;
  learnerId: Scalars['ID']['input'];
  masteryCriteria?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  organization?: InputMaybe<Scalars['ID']['input']>;
  tags?: InputMaybe<Scalars['JSONString']['input']>;
};


export type QueryGetAllAuth0OrganizationsInFdmArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hubspotCompanyId?: InputMaybe<Scalars['String']['input']>;
  hubspotCompanyId_Isnull?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  isTestOrganization?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_Icontains?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetAnnotationMediaByVideoIdArgs = {
  videoId: Scalars['ID']['input'];
};


export type QueryGetAnnotationTagArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdDate?: InputMaybe<Scalars['DateTime']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedDate?: InputMaybe<Scalars['DateTime']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetAnnotatorUsersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  annotatorRole?: InputMaybe<AnnotationUserRolesEnum>;
  auth0User?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdDate?: InputMaybe<Scalars['DateTime']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedDate?: InputMaybe<Scalars['DateTime']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetAssignmentAnnotationArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  annotationTag?: InputMaybe<Scalars['ID']['input']>;
  assignedUser?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  clip?: InputMaybe<Scalars['ID']['input']>;
  clipId?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  reviewer?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<ApiClipAnnotationStatusChoices>;
};


export type QueryGetAssignmentAnnotationByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetBaseReportTemplateM2mArgs = {
  reportType: Scalars['String']['input'];
};


export type QueryGetBeaconCameraConfigsArgs = {
  clinic?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['ID']['input'];
};


export type QueryGetBillableSummaryByM2mArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetCumulativeTargetsArgs = {
  filter: GetCumulativeTargetsFilter;
};


export type QueryGetEhrClientImportStatusArgs = {
  externalLearnerId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetEhrClientImportStatusM2mArgs = {
  externalLearnerId: Scalars['String']['input'];
  organizationId: Scalars['BigInt']['input'];
  workflowId: Scalars['String']['input'];
};


export type QueryGetEhrCredentialsArgs = {
  organizationId: Scalars['ID']['input'];
  providerId: Scalars['ID']['input'];
};


export type QueryGetEnterpriseReportTemplateArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetEnterpriseReportTemplatesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdDate?: InputMaybe<Scalars['DateTime']['input']>;
  curriculum?: InputMaybe<Scalars['ID']['input']>;
  defaultPayorTemplate?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  enterpriseTemplate?: InputMaybe<Scalars['Boolean']['input']>;
  exportFramework?: InputMaybe<ApiReportTemplateExportFrameworkChoices>;
  exportTemplateFont?: InputMaybe<ApiReportTemplateExportTemplateFontChoices>;
  fileUploadConfig?: InputMaybe<ApiReportTemplateFileUploadConfigChoices>;
  filter?: InputMaybe<GetReportTemplatesFilter>;
  finalApproverWaitsForReviewers?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  footerText?: InputMaybe<Scalars['String']['input']>;
  headerText?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  isBaseTemplate?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedDate?: InputMaybe<Scalars['DateTime']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderedReplacement?: InputMaybe<Scalars['Boolean']['input']>;
  organizationLogoAllowed?: InputMaybe<Scalars['Boolean']['input']>;
  payorType?: InputMaybe<ApiReportTemplatePayorTypeChoices>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  publishedBy?: InputMaybe<Scalars['ID']['input']>;
  reportNarrativeMappingWorkflow?: InputMaybe<Scalars['Boolean']['input']>;
  reportType?: InputMaybe<ApiReportTemplateReportTypeChoices>;
  requireAllQaResolved?: InputMaybe<Scalars['Boolean']['input']>;
  requireApprovalBeforeExport?: InputMaybe<Scalars['Boolean']['input']>;
  sampleFile?: InputMaybe<Scalars['String']['input']>;
  sampleStatus?: InputMaybe<ApiReportTemplateSampleStatusChoices>;
  status?: InputMaybe<ApiReportTemplateStatusChoices>;
  templateLogoUrl?: InputMaybe<Scalars['String']['input']>;
  templateUrl?: InputMaybe<Scalars['String']['input']>;
  treatmentPlanTemplate?: InputMaybe<Scalars['ID']['input']>;
  unifiedExport?: InputMaybe<Scalars['Boolean']['input']>;
  updatedBy?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryGetFronteraReportGoalsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  aiBaselineDataPredictionStatus?: InputMaybe<ApiReportGoalAiBaselineDataPredictionStatusChoices>;
  aiGenerated?: InputMaybe<Scalars['Boolean']['input']>;
  aiGoalAttainmentScalePredictionStatus?: InputMaybe<ApiReportGoalAiGoalAttainmentScalePredictionStatusChoices>;
  aiProgressSummaryPredictionStatus?: InputMaybe<ApiReportGoalAiProgressSummaryPredictionStatusChoices>;
  assessmentToolSource?: InputMaybe<Scalars['String']['input']>;
  baselineData?: InputMaybe<Scalars['String']['input']>;
  baselineDate?: InputMaybe<Scalars['Date']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  chartFromDate?: InputMaybe<Scalars['Date']['input']>;
  chartImageUrl?: InputMaybe<Scalars['String']['input']>;
  chartToDate?: InputMaybe<Scalars['Date']['input']>;
  chartType?: InputMaybe<ApiReportGoalChartTypeChoices>;
  completionDate?: InputMaybe<Scalars['Date']['input']>;
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdDate?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  excludeFromReport?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<GetFronteraGoalsFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  gasLevel1?: InputMaybe<Scalars['String']['input']>;
  gasLevel3?: InputMaybe<Scalars['String']['input']>;
  gasLevel4?: InputMaybe<Scalars['String']['input']>;
  gasMatchMessage?: InputMaybe<Scalars['String']['input']>;
  gasMatchStatus?: InputMaybe<ApiReportGoalGasMatchStatusChoices>;
  gasScore?: InputMaybe<Scalars['String']['input']>;
  generalizationCriteria?: InputMaybe<Scalars['String']['input']>;
  goal?: InputMaybe<Scalars['ID']['input']>;
  goalBank?: InputMaybe<Scalars['ID']['input']>;
  goalName?: InputMaybe<Scalars['String']['input']>;
  goalSubType?: InputMaybe<Scalars['String']['input']>;
  goalType?: InputMaybe<Scalars['String']['input']>;
  hasMedicalNecessity?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  inUse?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedDate?: InputMaybe<Scalars['DateTime']['input']>;
  learner?: InputMaybe<Scalars['ID']['input']>;
  masteryCriteria?: InputMaybe<Scalars['String']['input']>;
  medicalNecessityCriteria?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  organization?: InputMaybe<Scalars['ID']['input']>;
  predictionId?: InputMaybe<Scalars['String']['input']>;
  programGoal?: InputMaybe<Scalars['String']['input']>;
  progressSummary?: InputMaybe<Scalars['String']['input']>;
  projectedIntroductionDate?: InputMaybe<Scalars['Date']['input']>;
  rationale?: InputMaybe<Scalars['String']['input']>;
  report?: InputMaybe<Scalars['ID']['input']>;
  reportDomain?: InputMaybe<Scalars['ID']['input']>;
  reportTreatmentPlan?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<ApiReportGoalStatusChoices>;
  suggestionConfidence?: InputMaybe<Scalars['Float']['input']>;
  summaryReviewed?: InputMaybe<Scalars['Boolean']['input']>;
  summaryReviewedOn?: InputMaybe<Scalars['DateTime']['input']>;
  timelineEstimationType?: InputMaybe<ApiReportGoalTimelineEstimationTypeChoices>;
  timelineEstimationValue?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetGoalBankFoldersArgs = {
  searchTerm?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetGoalBankGoalsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  assessmentToolSource?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdDate?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  domain?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  folder?: InputMaybe<Scalars['ID']['input']>;
  folderId: Scalars['ID']['input'];
  goalName?: InputMaybe<Scalars['String']['input']>;
  hasMedicalNecessity?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedDate?: InputMaybe<Scalars['DateTime']['input']>;
  longTermGoalBank?: InputMaybe<Scalars['ID']['input']>;
  longTermGoalBankId?: InputMaybe<Scalars['ID']['input']>;
  masteryCriteria?: InputMaybe<Scalars['String']['input']>;
  medicalNecessityCriteria?: InputMaybe<Scalars['String']['input']>;
  medicalRationale?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  organization?: InputMaybe<Scalars['ID']['input']>;
  programGoal?: InputMaybe<Scalars['String']['input']>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  timelineEstimationType?: InputMaybe<ApiReportGoalBankTimelineEstimationTypeChoices>;
  timelineEstimationValue?: InputMaybe<Scalars['Int']['input']>;
  updatedBy?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryGetGoalBankLongTermGoalsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdDate?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  folder?: InputMaybe<Scalars['ID']['input']>;
  folderId: Scalars['ID']['input'];
  goalName?: InputMaybe<Scalars['String']['input']>;
  goalType?: InputMaybe<ApiLongTermGoalBankGoalTypeChoices>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedDate?: InputMaybe<Scalars['DateTime']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  organization?: InputMaybe<Scalars['ID']['input']>;
  updatedBy?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryGetGoalBankTargetsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdDate?: InputMaybe<Scalars['DateTime']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  folder?: InputMaybe<Scalars['ID']['input']>;
  folderId: Scalars['ID']['input'];
  goalBank?: InputMaybe<Scalars['ID']['input']>;
  goalBankId?: InputMaybe<Scalars['ID']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedDate?: InputMaybe<Scalars['DateTime']['input']>;
  longTermGoalBank?: InputMaybe<Scalars['ID']['input']>;
  masteryCriteria?: InputMaybe<Scalars['String']['input']>;
  medicalRationale?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  organization?: InputMaybe<Scalars['ID']['input']>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  targetDescription?: InputMaybe<Scalars['String']['input']>;
  targetName?: InputMaybe<Scalars['String']['input']>;
  timelineEstimationType?: InputMaybe<ApiReportTargetGoalBankTimelineEstimationTypeChoices>;
  timelineEstimationValue?: InputMaybe<Scalars['Int']['input']>;
  updatedBy?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryGetGoogleDriveUploadEnableOrganizationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hubspotCompanyId?: InputMaybe<Scalars['String']['input']>;
  hubspotCompanyId_Isnull?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  isTestOrganization?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_Icontains?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetHippHealthOrganizationsWithApiKeysArgs = {
  organizationId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryGetLanguageStylePromptArgs = {
  organizationId: Scalars['ID']['input'];
  providerId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryGetLearnerFilesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  assessmentId?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  fileId?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  learner?: InputMaybe<Scalars['ID']['input']>;
  learnerId?: InputMaybe<Scalars['ID']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryGetLearnerFilesByLearnerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  fileKind?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  isReportAttached?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  learner?: InputMaybe<Scalars['ID']['input']>;
  learnerId: Scalars['ID']['input'];
  offset?: InputMaybe<Scalars['Int']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryGetLearnerFormStatusArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdDate?: InputMaybe<Scalars['DateTime']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  formName?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedDate?: InputMaybe<Scalars['DateTime']['input']>;
  learner?: InputMaybe<Scalars['ID']['input']>;
  learnerId: Scalars['ID']['input'];
  offset?: InputMaybe<Scalars['Int']['input']>;
  organization?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<ApiOnboardingFormStatusStatusChoices>;
};


export type QueryGetLearnerLatestSessionsByM2mArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdDate?: InputMaybe<Scalars['DateTime']['input']>;
  date?: InputMaybe<Scalars['Date']['input']>;
  endDatetime?: InputMaybe<Scalars['DateTime']['input']>;
  engagementScore?: InputMaybe<Scalars['Float']['input']>;
  engagementScoreVersion?: InputMaybe<Scalars['String']['input']>;
  finalMedia?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedDate?: InputMaybe<Scalars['DateTime']['input']>;
  learnerId?: InputMaybe<Scalars['ID']['input']>;
  meetingId?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  organization?: InputMaybe<Scalars['ID']['input']>;
  recorderType?: InputMaybe<ApiVideoSessionRecorderTypeChoices>;
  sessionCount?: InputMaybe<Scalars['Int']['input']>;
  sessionRating?: InputMaybe<Scalars['Int']['input']>;
  sessionStatus?: InputMaybe<ApiVideoSessionSessionStatusChoices>;
  sourceType?: InputMaybe<ApiVideoSessionSourceTypeChoices>;
  startDatetime?: InputMaybe<Scalars['DateTime']['input']>;
  therapySession?: InputMaybe<Scalars['ID']['input']>;
  videoSessionId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryGetLearnerProviderSessionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdDate?: InputMaybe<Scalars['DateTime']['input']>;
  date?: InputMaybe<Scalars['Date']['input']>;
  endDatetime?: InputMaybe<Scalars['DateTime']['input']>;
  engagementScore?: InputMaybe<Scalars['Float']['input']>;
  engagementScoreVersion?: InputMaybe<Scalars['String']['input']>;
  finalMedia?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedDate?: InputMaybe<Scalars['DateTime']['input']>;
  learnerId: Scalars['ID']['input'];
  meetingId?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  organization?: InputMaybe<Scalars['ID']['input']>;
  recorderType?: InputMaybe<ApiVideoSessionRecorderTypeChoices>;
  sessionRating?: InputMaybe<Scalars['Int']['input']>;
  sessionStatus?: InputMaybe<ApiVideoSessionSessionStatusChoices>;
  sourceType?: InputMaybe<ApiVideoSessionSourceTypeChoices>;
  startDatetime?: InputMaybe<Scalars['DateTime']['input']>;
  therapySession?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryGetLearnersSessionForVqmByM2mArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  fromDate: Scalars['Date']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  toDate: Scalars['Date']['input'];
  videoSession_SessionStatus?: InputMaybe<ApiVideoSessionSessionStatusChoices>;
};


export type QueryGetLinkedCaregiverLearnersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdDate?: InputMaybe<Scalars['DateTime']['input']>;
  ehrLearningTreeId?: InputMaybe<Scalars['String']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  externalLastUpdate?: InputMaybe<Scalars['DateTime']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedDate?: InputMaybe<Scalars['DateTime']['input']>;
  manualGoalSyncLastUpdated?: InputMaybe<Scalars['DateTime']['input']>;
  manualGoalSyncStatus?: InputMaybe<ApiLearnerManualGoalSyncStatusChoices>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  runEngagementScorer?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryGetLinkedProviderLearnersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdDate?: InputMaybe<Scalars['DateTime']['input']>;
  ehrLearningTreeId?: InputMaybe<Scalars['String']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  externalLastUpdate?: InputMaybe<Scalars['DateTime']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedDate?: InputMaybe<Scalars['DateTime']['input']>;
  manualGoalSyncLastUpdated?: InputMaybe<Scalars['DateTime']['input']>;
  manualGoalSyncStatus?: InputMaybe<ApiLearnerManualGoalSyncStatusChoices>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  runEngagementScorer?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryGetLocationFromZipArgs = {
  zip: Scalars['String']['input'];
};


export type QueryGetMediaAiPredictionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdDate?: InputMaybe<Scalars['DateTime']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedDate?: InputMaybe<Scalars['DateTime']['input']>;
  media?: InputMaybe<Scalars['ID']['input']>;
  mediaId: Scalars['ID']['input'];
  mediaPredictionType?: InputMaybe<MediaAiPredictionEnum>;
  model?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  organization?: InputMaybe<Scalars['ID']['input']>;
  prediction?: InputMaybe<Scalars['String']['input']>;
  predictionType?: InputMaybe<ApiMediaAiPredictionPredictionTypeChoices>;
  version?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetMediaAiPredictionMetricsByMediaIdArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdDate?: InputMaybe<Scalars['DateTime']['input']>;
  endTime?: InputMaybe<Scalars['Float']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  label?: InputMaybe<ApiMediaAiPredictionMetricLabelChoices>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedDate?: InputMaybe<Scalars['DateTime']['input']>;
  media?: InputMaybe<Scalars['ID']['input']>;
  mediaAiPrediction?: InputMaybe<Scalars['ID']['input']>;
  mediaId: Scalars['ID']['input'];
  mediaMetricType: MediaAiMetricEnum;
  metricType?: InputMaybe<ApiMediaAiPredictionMetricMetricTypeChoices>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  organization?: InputMaybe<Scalars['ID']['input']>;
  startTime?: InputMaybe<Scalars['Float']['input']>;
};


export type QueryGetMediaByCaregiverArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  blobId?: InputMaybe<Scalars['UUID']['input']>;
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdDate?: InputMaybe<Scalars['DateTime']['input']>;
  endDatetime?: InputMaybe<Scalars['DateTime']['input']>;
  filePath?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  isViewed?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedDate?: InputMaybe<Scalars['DateTime']['input']>;
  learnerIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  mediaGroup?: InputMaybe<Scalars['ID']['input']>;
  mediaLanguage?: InputMaybe<ApiMediaMediaLanguageChoices>;
  mediaSource?: InputMaybe<ApiMediaMediaSourceChoices>;
  mediaStatus?: InputMaybe<MediaStatusEnumType>;
  mediaType?: InputMaybe<ApiMediaMediaTypeChoices>;
  multiplePeopleIncludingChildDuration?: InputMaybe<Scalars['Float']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  organization?: InputMaybe<Scalars['ID']['input']>;
  recordingId?: InputMaybe<Scalars['String']['input']>;
  sessionEndDate?: InputMaybe<Scalars['Date']['input']>;
  sessionStartDate?: InputMaybe<Scalars['Date']['input']>;
  sessionStatus?: InputMaybe<Array<InputMaybe<VideoSessionStatusEnums>>>;
  sortBy?: InputMaybe<Array<InputMaybe<MediaSortByEnum>>>;
  startDatetime?: InputMaybe<Scalars['DateTime']['input']>;
  thumbnailManifestPath?: InputMaybe<Scalars['String']['input']>;
  totalDuration?: InputMaybe<Scalars['Float']['input']>;
  videoSession?: InputMaybe<Scalars['ID']['input']>;
  videoUploadStatus?: InputMaybe<ApiMediaVideoUploadStatusChoices>;
  viewedAt?: InputMaybe<Scalars['DateTime']['input']>;
  viewedBy?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryGetMediaByCaregiverByMediaIdArgs = {
  mediaId: Scalars['ID']['input'];
};


export type QueryGetMediaByIdArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  blobId?: InputMaybe<Scalars['UUID']['input']>;
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdDate?: InputMaybe<Scalars['DateTime']['input']>;
  endDatetime?: InputMaybe<Scalars['DateTime']['input']>;
  filePath?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedDate?: InputMaybe<Scalars['DateTime']['input']>;
  mediaGroup?: InputMaybe<Scalars['ID']['input']>;
  mediaId: Scalars['ID']['input'];
  mediaLanguage?: InputMaybe<ApiMediaMediaLanguageChoices>;
  mediaSource?: InputMaybe<ApiMediaMediaSourceChoices>;
  mediaType?: InputMaybe<ApiMediaMediaTypeChoices>;
  multiplePeopleIncludingChildDuration?: InputMaybe<Scalars['Float']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  organization?: InputMaybe<Scalars['ID']['input']>;
  recordingId?: InputMaybe<Scalars['String']['input']>;
  startDatetime?: InputMaybe<Scalars['DateTime']['input']>;
  thumbnailManifestPath?: InputMaybe<Scalars['String']['input']>;
  totalDuration?: InputMaybe<Scalars['Float']['input']>;
  videoSession?: InputMaybe<Scalars['ID']['input']>;
  videoUploadStatus?: InputMaybe<ApiMediaVideoUploadStatusChoices>;
  viewedAt?: InputMaybe<Scalars['DateTime']['input']>;
  viewedBy?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryGetMediaByProviderArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  blobId?: InputMaybe<Scalars['UUID']['input']>;
  caregiverIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdDate?: InputMaybe<Scalars['DateTime']['input']>;
  endDatetime?: InputMaybe<Scalars['DateTime']['input']>;
  filePath?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  isViewed?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedDate?: InputMaybe<Scalars['DateTime']['input']>;
  learnerIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  mediaGroup?: InputMaybe<Scalars['ID']['input']>;
  mediaLanguage?: InputMaybe<ApiMediaMediaLanguageChoices>;
  mediaSource?: InputMaybe<ApiMediaMediaSourceChoices>;
  mediaStatus?: InputMaybe<MediaStatusEnumType>;
  mediaType?: InputMaybe<ApiMediaMediaTypeChoices>;
  multiplePeopleIncludingChildDuration?: InputMaybe<Scalars['Float']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  organization?: InputMaybe<Scalars['ID']['input']>;
  providerIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  recordingId?: InputMaybe<Scalars['String']['input']>;
  sessionEndDate?: InputMaybe<Scalars['Date']['input']>;
  sessionRating?: InputMaybe<Scalars['Int']['input']>;
  sessionStartDate?: InputMaybe<Scalars['Date']['input']>;
  sessionStatus?: InputMaybe<Array<InputMaybe<VideoSessionStatusEnums>>>;
  sortBy?: InputMaybe<Array<InputMaybe<MediaSortByEnum>>>;
  startDatetime?: InputMaybe<Scalars['DateTime']['input']>;
  thumbnailManifestPath?: InputMaybe<Scalars['String']['input']>;
  totalDuration?: InputMaybe<Scalars['Float']['input']>;
  videoSession?: InputMaybe<Scalars['ID']['input']>;
  videoUploadStatus?: InputMaybe<ApiMediaVideoUploadStatusChoices>;
  viewedAt?: InputMaybe<Scalars['DateTime']['input']>;
  viewedBy?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryGetMediaByProviderByMediaIdArgs = {
  mediaId: Scalars['ID']['input'];
};


export type QueryGetMediaBySessionIdArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  blobId?: InputMaybe<Scalars['UUID']['input']>;
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdDate?: InputMaybe<Scalars['DateTime']['input']>;
  endDatetime?: InputMaybe<Scalars['DateTime']['input']>;
  filePath?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedDate?: InputMaybe<Scalars['DateTime']['input']>;
  mediaGroup?: InputMaybe<Scalars['ID']['input']>;
  mediaLanguage?: InputMaybe<ApiMediaMediaLanguageChoices>;
  mediaSource?: InputMaybe<ApiMediaMediaSourceChoices>;
  mediaType?: InputMaybe<ApiMediaMediaTypeChoices>;
  multiplePeopleIncludingChildDuration?: InputMaybe<Scalars['Float']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  organization?: InputMaybe<Scalars['ID']['input']>;
  recordingId?: InputMaybe<Scalars['String']['input']>;
  startDatetime?: InputMaybe<Scalars['DateTime']['input']>;
  thumbnailManifestPath?: InputMaybe<Scalars['String']['input']>;
  totalDuration?: InputMaybe<Scalars['Float']['input']>;
  videoSession?: InputMaybe<Scalars['ID']['input']>;
  videoSessionId: Scalars['ID']['input'];
  videoUploadStatus?: InputMaybe<ApiMediaVideoUploadStatusChoices>;
  viewedAt?: InputMaybe<Scalars['DateTime']['input']>;
  viewedBy?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryGetMediaBySessionIdM2mArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  blobId?: InputMaybe<Scalars['UUID']['input']>;
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdDate?: InputMaybe<Scalars['DateTime']['input']>;
  endDatetime?: InputMaybe<Scalars['DateTime']['input']>;
  filePath?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedDate?: InputMaybe<Scalars['DateTime']['input']>;
  mediaGroup?: InputMaybe<Scalars['ID']['input']>;
  mediaLanguage?: InputMaybe<ApiMediaMediaLanguageChoices>;
  mediaSource?: InputMaybe<ApiMediaMediaSourceChoices>;
  mediaType?: InputMaybe<ApiMediaMediaTypeChoices>;
  multiplePeopleIncludingChildDuration?: InputMaybe<Scalars['Float']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  organization?: InputMaybe<Scalars['ID']['input']>;
  recordingId?: InputMaybe<Scalars['String']['input']>;
  startDatetime?: InputMaybe<Scalars['DateTime']['input']>;
  thumbnailManifestPath?: InputMaybe<Scalars['String']['input']>;
  totalDuration?: InputMaybe<Scalars['Float']['input']>;
  videoSession?: InputMaybe<Scalars['ID']['input']>;
  videoSessionId: Scalars['ID']['input'];
  videoUploadStatus?: InputMaybe<ApiMediaVideoUploadStatusChoices>;
  viewedAt?: InputMaybe<Scalars['DateTime']['input']>;
  viewedBy?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryGetMediaClipArgs = {
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdDate?: InputMaybe<Scalars['DateTime']['input']>;
  endTime?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedDate?: InputMaybe<Scalars['DateTime']['input']>;
  media?: InputMaybe<Scalars['ID']['input']>;
  organization?: InputMaybe<Scalars['ID']['input']>;
  startTime?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  videoId: Scalars['ID']['input'];
};


export type QueryGetMediaCommentRepliesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  author?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  commentType?: InputMaybe<ApiMediaCommentsCommentTypeChoices>;
  commentTypes?: InputMaybe<Array<InputMaybe<MediaCommentEnum>>>;
  content?: InputMaybe<Scalars['String']['input']>;
  createdDate?: InputMaybe<Scalars['DateTime']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedDate?: InputMaybe<Scalars['DateTime']['input']>;
  media?: InputMaybe<Scalars['ID']['input']>;
  mediaStartTime?: InputMaybe<Scalars['Float']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  organization?: InputMaybe<Scalars['ID']['input']>;
  parentComment?: InputMaybe<Scalars['ID']['input']>;
  parentCommentId: Scalars['ID']['input'];
};


export type QueryGetMediaCommentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  author?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  commentType?: InputMaybe<ApiMediaCommentsCommentTypeChoices>;
  commentTypes?: InputMaybe<Array<InputMaybe<MediaCommentFilterEnum>>>;
  content?: InputMaybe<Scalars['String']['input']>;
  createdDate?: InputMaybe<Scalars['DateTime']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedDate?: InputMaybe<Scalars['DateTime']['input']>;
  media?: InputMaybe<Scalars['ID']['input']>;
  mediaId: Scalars['ID']['input'];
  mediaStartTime?: InputMaybe<Scalars['Float']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  organization?: InputMaybe<Scalars['ID']['input']>;
  parentComment?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryGetMediaGoalMomentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdDate?: InputMaybe<Scalars['DateTime']['input']>;
  filter?: InputMaybe<MediaGoalMomentsFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  isPinned?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedDate?: InputMaybe<Scalars['DateTime']['input']>;
  learner?: InputMaybe<Scalars['ID']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  organization?: InputMaybe<Scalars['ID']['input']>;
  rankOrder?: InputMaybe<Scalars['Int']['input']>;
  targetGenerationStatus?: InputMaybe<ApiGoalTargetGenerationStatusChoices>;
};


export type QueryGetMediaModelConfigByOrgArgs = {
  configType?: InputMaybe<DefaultConfigEnums>;
  orgId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryGetMediaStreamByMediaIdArgs = {
  endTime?: InputMaybe<Scalars['Int']['input']>;
  mediaId: Scalars['ID']['input'];
  startTime?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetMediaTargetPredictionFeedbacksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdDate?: InputMaybe<Scalars['DateTime']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  improvementComment?: InputMaybe<Scalars['String']['input']>;
  isAccurate?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedDate?: InputMaybe<Scalars['DateTime']['input']>;
  mediaTargetPrediction?: InputMaybe<Scalars['ID']['input']>;
  mediaTargetPredictionId?: InputMaybe<Scalars['ID']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  organization?: InputMaybe<Scalars['ID']['input']>;
  reasonOfRating?: InputMaybe<Scalars['String']['input']>;
  user?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryGetMediaTargetPredictionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdDate?: InputMaybe<Scalars['DateTime']['input']>;
  endTime?: InputMaybe<Scalars['Float']['input']>;
  filter?: InputMaybe<MediaTargetPredictionFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  goal?: InputMaybe<Scalars['ID']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedDate?: InputMaybe<Scalars['DateTime']['input']>;
  media?: InputMaybe<Scalars['ID']['input']>;
  modalityType?: InputMaybe<ApiMediaTargetPredictionModalityTypeChoices>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  organization?: InputMaybe<Scalars['ID']['input']>;
  predictionId?: InputMaybe<Scalars['String']['input']>;
  rationale?: InputMaybe<Scalars['String']['input']>;
  reportGoalOld?: InputMaybe<Scalars['ID']['input']>;
  reportTargetOld?: InputMaybe<Scalars['ID']['input']>;
  startTime?: InputMaybe<Scalars['Float']['input']>;
  target?: InputMaybe<Scalars['ID']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetMediaTargetPredictionsByM2mArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdDate?: InputMaybe<Scalars['DateTime']['input']>;
  endTime?: InputMaybe<Scalars['Float']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  goal?: InputMaybe<Scalars['ID']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedDate?: InputMaybe<Scalars['DateTime']['input']>;
  media?: InputMaybe<Scalars['ID']['input']>;
  mediaId?: InputMaybe<Scalars['ID']['input']>;
  modalityType?: InputMaybe<ApiMediaTargetPredictionModalityTypeChoices>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  organization?: InputMaybe<Scalars['ID']['input']>;
  predictionId?: InputMaybe<Scalars['String']['input']>;
  rationale?: InputMaybe<Scalars['String']['input']>;
  reportGoalOld?: InputMaybe<Scalars['ID']['input']>;
  reportTargetOld?: InputMaybe<Scalars['ID']['input']>;
  startTime?: InputMaybe<Scalars['Float']['input']>;
  target?: InputMaybe<Scalars['ID']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
  videoSessionId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryGetMediaTranscriptArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  endTime?: InputMaybe<Scalars['Float']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  mediaId: Scalars['ID']['input'];
  offset?: InputMaybe<Scalars['Int']['input']>;
  speaker?: InputMaybe<Scalars['String']['input']>;
  startTime?: InputMaybe<Scalars['Float']['input']>;
};


export type QueryGetMediaTranscriptByM2mArgs = {
  endTime?: InputMaybe<Scalars['Float']['input']>;
  mediaId: Scalars['ID']['input'];
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  speaker?: InputMaybe<Scalars['String']['input']>;
  startTime?: InputMaybe<Scalars['Float']['input']>;
};


export type QueryGetNotificationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  channel?: InputMaybe<ApiNotificationsChannelChoices>;
  description?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  notificationType?: InputMaybe<ApiNotificationsNotificationTypeChoices>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  ordering?: InputMaybe<NotificationOrdering>;
  organization?: InputMaybe<Scalars['ID']['input']>;
  read?: InputMaybe<Scalars['Boolean']['input']>;
  recipient?: InputMaybe<Scalars['ID']['input']>;
  recipient_Auth0id?: InputMaybe<Scalars['String']['input']>;
  sender?: InputMaybe<Scalars['ID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetOrganizationByIdM2mArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetOrganizationEhrCredentialsArgs = {
  credentialsType: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
};


export type QueryGetOrganizationProvidersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  auth0User?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdDate?: InputMaybe<Scalars['DateTime']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  externalLastUpdate?: InputMaybe<Scalars['DateTime']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasEnteredVideoCaptureApp?: InputMaybe<Scalars['Boolean']['input']>;
  includeInternal?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedDate?: InputMaybe<Scalars['DateTime']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ProviderBoolExp>;
};


export type QueryGetPassageHealthOrganizationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hubspotCompanyId?: InputMaybe<Scalars['String']['input']>;
  hubspotCompanyId_Isnull?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  isTestOrganization?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_Icontains?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetPayorReportDataToSubmitArgs = {
  reportSubmissionJobId: Scalars['ID']['input'];
};


export type QueryGetPayorReportSubmissionStatusArgs = {
  reportSubmissionJobId: Scalars['ID']['input'];
};


export type QueryGetPayorReportSubmissionsByReportIdArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  reportId: Scalars['ID']['input'];
};


export type QueryGetPromptArgs = {
  filter?: InputMaybe<PromptFilter>;
};


export type QueryGetProviderFilesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  fileCategory?: InputMaybe<ApiProviderFileFileCategoryChoices>;
  fileId?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  provider?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryGetProviderFilesByM2mArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  fileCategory?: InputMaybe<ApiProviderFileFileCategoryChoices>;
  fileId?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  provider?: InputMaybe<Scalars['ID']['input']>;
  providerId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryGetProviderLearnersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdDate?: InputMaybe<Scalars['DateTime']['input']>;
  ehrLearningTreeId?: InputMaybe<Scalars['String']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  externalLastUpdate?: InputMaybe<Scalars['DateTime']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedDate?: InputMaybe<Scalars['DateTime']['input']>;
  learnerName?: InputMaybe<Scalars['String']['input']>;
  manualGoalSyncLastUpdated?: InputMaybe<Scalars['DateTime']['input']>;
  manualGoalSyncStatus?: InputMaybe<ApiLearnerManualGoalSyncStatusChoices>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  runEngagementScorer?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryGetProviderListByRoleArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  auth0User?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdDate?: InputMaybe<Scalars['DateTime']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  externalLastUpdate?: InputMaybe<Scalars['DateTime']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasEnteredVideoCaptureApp?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedDate?: InputMaybe<Scalars['DateTime']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  roles: Array<InputMaybe<RolesEnum>>;
};


export type QueryGetProvidersForAssigningToLearnerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  auth0User?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdDate?: InputMaybe<Scalars['DateTime']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  externalLastUpdate?: InputMaybe<Scalars['DateTime']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasEnteredVideoCaptureApp?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedDate?: InputMaybe<Scalars['DateTime']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetProvidersForSessionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  auth0User?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdDate?: InputMaybe<Scalars['DateTime']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  externalLastUpdate?: InputMaybe<Scalars['DateTime']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasEnteredVideoCaptureApp?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedDate?: InputMaybe<Scalars['DateTime']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetQuestionsAskedByRbtRawDataArgs = {
  count?: InputMaybe<Scalars['Int']['input']>;
  fromDate: Scalars['Date']['input'];
  learnerIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  rbtProviderIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  toDate: Scalars['Date']['input'];
};


export type QueryGetRbtVideoUploadTimeRawDataArgs = {
  count?: InputMaybe<Scalars['Int']['input']>;
  fromDate: Scalars['Date']['input'];
  learnerIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  rbtProviderIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  toDate: Scalars['Date']['input'];
};


export type QueryGetReIdFileOfSessionMediaArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdDate?: InputMaybe<Scalars['DateTime']['input']>;
  decodedMediaIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedDate?: InputMaybe<Scalars['DateTime']['input']>;
  media?: InputMaybe<Scalars['ID']['input']>;
  mediaIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  model?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  organization?: InputMaybe<Scalars['ID']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  prediction?: InputMaybe<Scalars['String']['input']>;
  predictionType?: InputMaybe<ApiMediaAiPredictionPredictionTypeChoices>;
  version?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetReassessmentReportGoalsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  aiBaselineDataPredictionStatus?: InputMaybe<ApiReportGoalAiBaselineDataPredictionStatusChoices>;
  aiGenerated?: InputMaybe<Scalars['Boolean']['input']>;
  aiGoalAttainmentScalePredictionStatus?: InputMaybe<ApiReportGoalAiGoalAttainmentScalePredictionStatusChoices>;
  aiProgressSummaryPredictionStatus?: InputMaybe<ApiReportGoalAiProgressSummaryPredictionStatusChoices>;
  assessmentToolSource?: InputMaybe<Scalars['String']['input']>;
  baselineData?: InputMaybe<Scalars['String']['input']>;
  baselineDate?: InputMaybe<Scalars['Date']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  chartFromDate?: InputMaybe<Scalars['Date']['input']>;
  chartImageUrl?: InputMaybe<Scalars['String']['input']>;
  chartToDate?: InputMaybe<Scalars['Date']['input']>;
  chartType?: InputMaybe<ApiReportGoalChartTypeChoices>;
  completionDate?: InputMaybe<Scalars['Date']['input']>;
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdDate?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  excludeFromReport?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<GetReassessmentReportGoalsFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  gasLevel1?: InputMaybe<Scalars['String']['input']>;
  gasLevel3?: InputMaybe<Scalars['String']['input']>;
  gasLevel4?: InputMaybe<Scalars['String']['input']>;
  gasMatchMessage?: InputMaybe<Scalars['String']['input']>;
  gasMatchStatus?: InputMaybe<ApiReportGoalGasMatchStatusChoices>;
  gasScore?: InputMaybe<Scalars['String']['input']>;
  generalizationCriteria?: InputMaybe<Scalars['String']['input']>;
  goal?: InputMaybe<Scalars['ID']['input']>;
  goalBank?: InputMaybe<Scalars['ID']['input']>;
  goalName?: InputMaybe<Scalars['String']['input']>;
  goalSubType?: InputMaybe<Scalars['String']['input']>;
  goalType?: InputMaybe<Scalars['String']['input']>;
  hasMedicalNecessity?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  inUse?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedDate?: InputMaybe<Scalars['DateTime']['input']>;
  learner?: InputMaybe<Scalars['ID']['input']>;
  masteryCriteria?: InputMaybe<Scalars['String']['input']>;
  medicalNecessityCriteria?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  organization?: InputMaybe<Scalars['ID']['input']>;
  predictionId?: InputMaybe<Scalars['String']['input']>;
  programGoal?: InputMaybe<Scalars['String']['input']>;
  progressSummary?: InputMaybe<Scalars['String']['input']>;
  projectedIntroductionDate?: InputMaybe<Scalars['Date']['input']>;
  rationale?: InputMaybe<Scalars['String']['input']>;
  report?: InputMaybe<Scalars['ID']['input']>;
  reportDomain?: InputMaybe<Scalars['ID']['input']>;
  reportTreatmentPlan?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<ApiReportGoalStatusChoices>;
  suggestionConfidence?: InputMaybe<Scalars['Float']['input']>;
  summaryReviewed?: InputMaybe<Scalars['Boolean']['input']>;
  summaryReviewedOn?: InputMaybe<Scalars['DateTime']['input']>;
  timelineEstimationType?: InputMaybe<ApiReportGoalTimelineEstimationTypeChoices>;
  timelineEstimationValue?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetRecommendationBankFoldersArgs = {
  searchTerm?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetRecommendationBankItemsArgs = {
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdDate?: InputMaybe<Scalars['DateTime']['input']>;
  folder?: InputMaybe<Scalars['ID']['input']>;
  lastUpdatedDate?: InputMaybe<Scalars['DateTime']['input']>;
  organization?: InputMaybe<Scalars['ID']['input']>;
  recommendationCategory?: InputMaybe<Scalars['String']['input']>;
  recommendationContent?: InputMaybe<Scalars['String']['input']>;
  recommendationTitle?: InputMaybe<Scalars['String']['input']>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  updatedBy?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryGetRecordedVideoDistributionRawDataArgs = {
  count?: InputMaybe<Scalars['Int']['input']>;
  fromDate: Scalars['Date']['input'];
  learnerIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  rbtProviderIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  toDate: Scalars['Date']['input'];
};


export type QueryGetReportArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  isArchive?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  ordering?: InputMaybe<Scalars['String']['input']>;
  reportClientDetails_ClientFirstName_Icontains?: InputMaybe<Scalars['String']['input']>;
  reportId: Scalars['ID']['input'];
};


export type QueryGetReportDomainsArgs = {
  reportId: Scalars['ID']['input'];
};


export type QueryGetReportDomainsM2mArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdDate?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedDate?: InputMaybe<Scalars['DateTime']['input']>;
  learner?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  organization?: InputMaybe<Scalars['ID']['input']>;
  rankOrder?: InputMaybe<Scalars['Int']['input']>;
  reportId: Scalars['ID']['input'];
  reportTreatmentPlan?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryGetReportGoalArgs = {
  reportGoalId: Scalars['ID']['input'];
};


export type QueryGetReportGoalM2mArgs = {
  goalId: Scalars['ID']['input'];
};


export type QueryGetReportGoalsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  aiBaselineDataPredictionStatus?: InputMaybe<ApiReportGoalAiBaselineDataPredictionStatusChoices>;
  aiGenerated?: InputMaybe<Scalars['Boolean']['input']>;
  aiGoalAttainmentScalePredictionStatus?: InputMaybe<ApiReportGoalAiGoalAttainmentScalePredictionStatusChoices>;
  aiProgressSummaryPredictionStatus?: InputMaybe<ApiReportGoalAiProgressSummaryPredictionStatusChoices>;
  assessmentToolSource?: InputMaybe<Scalars['String']['input']>;
  baselineData?: InputMaybe<Scalars['String']['input']>;
  baselineDate?: InputMaybe<Scalars['Date']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  chartFromDate?: InputMaybe<Scalars['Date']['input']>;
  chartImageUrl?: InputMaybe<Scalars['String']['input']>;
  chartToDate?: InputMaybe<Scalars['Date']['input']>;
  chartType?: InputMaybe<ApiReportGoalChartTypeChoices>;
  completionDate?: InputMaybe<Scalars['Date']['input']>;
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdDate?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  excludeFromReport?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<GetReportGoalsFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  gasLevel1?: InputMaybe<Scalars['String']['input']>;
  gasLevel3?: InputMaybe<Scalars['String']['input']>;
  gasLevel4?: InputMaybe<Scalars['String']['input']>;
  gasMatchMessage?: InputMaybe<Scalars['String']['input']>;
  gasMatchStatus?: InputMaybe<ApiReportGoalGasMatchStatusChoices>;
  gasScore?: InputMaybe<Scalars['String']['input']>;
  generalizationCriteria?: InputMaybe<Scalars['String']['input']>;
  goal?: InputMaybe<Scalars['ID']['input']>;
  goalBank?: InputMaybe<Scalars['ID']['input']>;
  goalName?: InputMaybe<Scalars['String']['input']>;
  goalSubType?: InputMaybe<Scalars['String']['input']>;
  goalType?: InputMaybe<Scalars['String']['input']>;
  hasMedicalNecessity?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  inUse?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedDate?: InputMaybe<Scalars['DateTime']['input']>;
  learner?: InputMaybe<Scalars['ID']['input']>;
  learnerId: Scalars['ID']['input'];
  masteryCriteria?: InputMaybe<Scalars['String']['input']>;
  medicalNecessityCriteria?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  organization?: InputMaybe<Scalars['ID']['input']>;
  predictionId?: InputMaybe<Scalars['String']['input']>;
  programGoal?: InputMaybe<Scalars['String']['input']>;
  progressSummary?: InputMaybe<Scalars['String']['input']>;
  projectedIntroductionDate?: InputMaybe<Scalars['Date']['input']>;
  rationale?: InputMaybe<Scalars['String']['input']>;
  report?: InputMaybe<Scalars['ID']['input']>;
  reportDomain?: InputMaybe<Scalars['ID']['input']>;
  reportTreatmentPlan?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<ApiReportGoalStatusChoices>;
  suggestionConfidence?: InputMaybe<Scalars['Float']['input']>;
  summaryReviewed?: InputMaybe<Scalars['Boolean']['input']>;
  summaryReviewedOn?: InputMaybe<Scalars['DateTime']['input']>;
  timelineEstimationType?: InputMaybe<ApiReportGoalTimelineEstimationTypeChoices>;
  timelineEstimationValue?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetReportGoalsByReportArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  aiBaselineDataPredictionStatus?: InputMaybe<ApiReportGoalAiBaselineDataPredictionStatusChoices>;
  aiGenerated?: InputMaybe<Scalars['Boolean']['input']>;
  aiGoalAttainmentScalePredictionStatus?: InputMaybe<ApiReportGoalAiGoalAttainmentScalePredictionStatusChoices>;
  aiProgressSummaryPredictionStatus?: InputMaybe<ApiReportGoalAiProgressSummaryPredictionStatusChoices>;
  assessmentToolSource?: InputMaybe<Scalars['String']['input']>;
  baselineData?: InputMaybe<Scalars['String']['input']>;
  baselineDate?: InputMaybe<Scalars['Date']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  chartFromDate?: InputMaybe<Scalars['Date']['input']>;
  chartImageUrl?: InputMaybe<Scalars['String']['input']>;
  chartToDate?: InputMaybe<Scalars['Date']['input']>;
  chartType?: InputMaybe<ApiReportGoalChartTypeChoices>;
  completionDate?: InputMaybe<Scalars['Date']['input']>;
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdDate?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  excludeFromReport?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  gasLevel1?: InputMaybe<Scalars['String']['input']>;
  gasLevel3?: InputMaybe<Scalars['String']['input']>;
  gasLevel4?: InputMaybe<Scalars['String']['input']>;
  gasMatchMessage?: InputMaybe<Scalars['String']['input']>;
  gasMatchStatus?: InputMaybe<ApiReportGoalGasMatchStatusChoices>;
  gasScore?: InputMaybe<Scalars['String']['input']>;
  generalizationCriteria?: InputMaybe<Scalars['String']['input']>;
  goal?: InputMaybe<Scalars['ID']['input']>;
  goalBank?: InputMaybe<Scalars['ID']['input']>;
  goalName?: InputMaybe<Scalars['String']['input']>;
  goalSubType?: InputMaybe<Scalars['String']['input']>;
  goalType?: InputMaybe<Scalars['String']['input']>;
  hasEhrGoal?: InputMaybe<Scalars['Boolean']['input']>;
  hasMedicalNecessity?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  inUse?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedDate?: InputMaybe<Scalars['DateTime']['input']>;
  learner?: InputMaybe<Scalars['ID']['input']>;
  masteryCriteria?: InputMaybe<Scalars['String']['input']>;
  medicalNecessityCriteria?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  organization?: InputMaybe<Scalars['ID']['input']>;
  predictionId?: InputMaybe<Scalars['String']['input']>;
  programGoal?: InputMaybe<Scalars['String']['input']>;
  progressSummary?: InputMaybe<Scalars['String']['input']>;
  projectedIntroductionDate?: InputMaybe<Scalars['Date']['input']>;
  rationale?: InputMaybe<Scalars['String']['input']>;
  report?: InputMaybe<Scalars['ID']['input']>;
  reportDomain?: InputMaybe<Scalars['ID']['input']>;
  reportId: Scalars['ID']['input'];
  reportTreatmentPlan?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<ApiReportGoalStatusChoices>;
  suggestionConfidence?: InputMaybe<Scalars['Float']['input']>;
  summaryReviewed?: InputMaybe<Scalars['Boolean']['input']>;
  summaryReviewedOn?: InputMaybe<Scalars['DateTime']['input']>;
  timelineEstimationType?: InputMaybe<ApiReportGoalTimelineEstimationTypeChoices>;
  timelineEstimationValue?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetReportGoalsM2mArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  aiBaselineDataPredictionStatus?: InputMaybe<ApiReportGoalAiBaselineDataPredictionStatusChoices>;
  aiGenerated?: InputMaybe<Scalars['Boolean']['input']>;
  aiGoalAttainmentScalePredictionStatus?: InputMaybe<ApiReportGoalAiGoalAttainmentScalePredictionStatusChoices>;
  aiProgressSummaryPredictionStatus?: InputMaybe<ApiReportGoalAiProgressSummaryPredictionStatusChoices>;
  assessmentToolSource?: InputMaybe<Scalars['String']['input']>;
  baselineData?: InputMaybe<Scalars['String']['input']>;
  baselineDate?: InputMaybe<Scalars['Date']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  chartFromDate?: InputMaybe<Scalars['Date']['input']>;
  chartImageUrl?: InputMaybe<Scalars['String']['input']>;
  chartToDate?: InputMaybe<Scalars['Date']['input']>;
  chartType?: InputMaybe<ApiReportGoalChartTypeChoices>;
  completionDate?: InputMaybe<Scalars['Date']['input']>;
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdDate?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  excludeFromReport?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  gasLevel1?: InputMaybe<Scalars['String']['input']>;
  gasLevel3?: InputMaybe<Scalars['String']['input']>;
  gasLevel4?: InputMaybe<Scalars['String']['input']>;
  gasMatchMessage?: InputMaybe<Scalars['String']['input']>;
  gasMatchStatus?: InputMaybe<ApiReportGoalGasMatchStatusChoices>;
  gasScore?: InputMaybe<Scalars['String']['input']>;
  generalizationCriteria?: InputMaybe<Scalars['String']['input']>;
  goal?: InputMaybe<Scalars['ID']['input']>;
  goalBank?: InputMaybe<Scalars['ID']['input']>;
  goalName?: InputMaybe<Scalars['String']['input']>;
  goalSubType?: InputMaybe<Scalars['String']['input']>;
  goalType?: InputMaybe<Scalars['String']['input']>;
  hasMedicalNecessity?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  inUse?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedDate?: InputMaybe<Scalars['DateTime']['input']>;
  learner?: InputMaybe<Scalars['ID']['input']>;
  learnerId: Scalars['ID']['input'];
  masteryCriteria?: InputMaybe<Scalars['String']['input']>;
  medicalNecessityCriteria?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  organization?: InputMaybe<Scalars['ID']['input']>;
  predictionId?: InputMaybe<Scalars['String']['input']>;
  programGoal?: InputMaybe<Scalars['String']['input']>;
  progressSummary?: InputMaybe<Scalars['String']['input']>;
  projectedIntroductionDate?: InputMaybe<Scalars['Date']['input']>;
  rationale?: InputMaybe<Scalars['String']['input']>;
  report?: InputMaybe<Scalars['ID']['input']>;
  reportDomain?: InputMaybe<Scalars['ID']['input']>;
  reportTreatmentPlan?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<ApiReportGoalStatusChoices>;
  suggestionConfidence?: InputMaybe<Scalars['Float']['input']>;
  summaryReviewed?: InputMaybe<Scalars['Boolean']['input']>;
  summaryReviewedOn?: InputMaybe<Scalars['DateTime']['input']>;
  timelineEstimationType?: InputMaybe<ApiReportGoalTimelineEstimationTypeChoices>;
  timelineEstimationValue?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetReportLearnerFilesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  fileId?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  learner?: InputMaybe<Scalars['ID']['input']>;
  learnerId?: InputMaybe<Scalars['ID']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  reportId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryGetReportM2mArgs = {
  reportId: Scalars['ID']['input'];
};


export type QueryGetReportPayorMetadataByReportIdArgs = {
  reportId: Scalars['ID']['input'];
};


export type QueryGetReportPdfStatusArgs = {
  reportSubmissionJobId: Scalars['ID']['input'];
};


export type QueryGetReportReviewItemsArgs = {
  filter?: InputMaybe<ReportReviewItemFilterInput>;
  reportId: Scalars['ID']['input'];
};


export type QueryGetReportReviewersArgs = {
  reportId: Scalars['ID']['input'];
};


export type QueryGetReportSectionFieldsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  aiGenerated?: InputMaybe<Scalars['Boolean']['input']>;
  aiSectionField?: InputMaybe<Scalars['ID']['input']>;
  aiSources?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  createdDate?: InputMaybe<Scalars['DateTime']['input']>;
  fieldIdentifier?: InputMaybe<Scalars['String']['input']>;
  fieldType?: InputMaybe<ApiReportSectionFieldsFieldTypeChoices>;
  first?: InputMaybe<Scalars['Int']['input']>;
  isAuditable?: InputMaybe<Scalars['Boolean']['input']>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isRequired?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedDate?: InputMaybe<Scalars['DateTime']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  organization?: InputMaybe<Scalars['ID']['input']>;
  rankOrder?: InputMaybe<Scalars['Int']['input']>;
  report?: InputMaybe<Scalars['ID']['input']>;
  reportSection?: InputMaybe<Scalars['ID']['input']>;
  reportSectionId: Scalars['ID']['input'];
  sectionFieldId?: InputMaybe<Scalars['ID']['input']>;
  templateSectionField?: InputMaybe<Scalars['ID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetReportSectionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  aiGeneratedStatus?: InputMaybe<ApiReportSectionsAiGeneratedStatusChoices>;
  aiPredictionOwnerRunId?: InputMaybe<Scalars['String']['input']>;
  aiPredictionOwnerStartedAt?: InputMaybe<Scalars['DateTime']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdDate?: InputMaybe<Scalars['DateTime']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedDate?: InputMaybe<Scalars['DateTime']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  organization?: InputMaybe<Scalars['ID']['input']>;
  pageLocation?: InputMaybe<Scalars['String']['input']>;
  previousPageLocation?: InputMaybe<Scalars['String']['input']>;
  rankOrder?: InputMaybe<Scalars['Int']['input']>;
  report?: InputMaybe<Scalars['ID']['input']>;
  reportId: Scalars['ID']['input'];
  reportSectionId?: InputMaybe<Scalars['ID']['input']>;
  sectionIdentifier?: InputMaybe<Scalars['String']['input']>;
  templateSection?: InputMaybe<Scalars['ID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetReportSuggestionWorkflowDataArgs = {
  reportId: Scalars['ID']['input'];
};


export type QueryGetReportSuggestionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  createdDate?: InputMaybe<Scalars['DateTime']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  goalField?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedDate?: InputMaybe<Scalars['DateTime']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  organization?: InputMaybe<Scalars['ID']['input']>;
  predictionId?: InputMaybe<Scalars['String']['input']>;
  report?: InputMaybe<Scalars['ID']['input']>;
  reportGoal?: InputMaybe<Scalars['ID']['input']>;
  reportId: Scalars['ID']['input'];
  reportSectionField?: InputMaybe<Scalars['ID']['input']>;
  reportTarget?: InputMaybe<Scalars['ID']['input']>;
  resolvedAt?: InputMaybe<Scalars['DateTime']['input']>;
  resolvedBy?: InputMaybe<Scalars['ID']['input']>;
  targetField?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetReportTargetM2mArgs = {
  targetId: Scalars['ID']['input'];
};


export type QueryGetReportTargetsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  aiGenerated?: InputMaybe<Scalars['Boolean']['input']>;
  aiProgressSummaryPredictionStatus?: InputMaybe<ApiReportTargetAiProgressSummaryPredictionStatusChoices>;
  baselineData?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  chartFromDate?: InputMaybe<Scalars['Date']['input']>;
  chartImageUrl?: InputMaybe<Scalars['String']['input']>;
  chartToDate?: InputMaybe<Scalars['Date']['input']>;
  chartType?: InputMaybe<ApiReportTargetChartTypeChoices>;
  completionDate?: InputMaybe<Scalars['Date']['input']>;
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdDate?: InputMaybe<Scalars['DateTime']['input']>;
  excludeFromReport?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<GetTargetsFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  inUse?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedDate?: InputMaybe<Scalars['DateTime']['input']>;
  learner?: InputMaybe<Scalars['ID']['input']>;
  masteryCriteria?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  organization?: InputMaybe<Scalars['ID']['input']>;
  predictionId?: InputMaybe<Scalars['String']['input']>;
  priorityOrder?: InputMaybe<Scalars['Int']['input']>;
  progressSummary?: InputMaybe<Scalars['String']['input']>;
  progressType?: InputMaybe<ApiReportTargetProgressTypeChoices>;
  projectedIntroductionDate?: InputMaybe<Scalars['Date']['input']>;
  report?: InputMaybe<Scalars['ID']['input']>;
  reportDomain?: InputMaybe<Scalars['ID']['input']>;
  reportGoal?: InputMaybe<Scalars['ID']['input']>;
  reportTreatmentPlan?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<ApiReportTargetStatusChoices>;
  summaryReviewed?: InputMaybe<Scalars['Boolean']['input']>;
  summaryReviewedOn?: InputMaybe<Scalars['DateTime']['input']>;
  target?: InputMaybe<Scalars['ID']['input']>;
  targetDescription?: InputMaybe<Scalars['String']['input']>;
  targetName?: InputMaybe<Scalars['String']['input']>;
  timelineEstimationType?: InputMaybe<ApiReportTargetTimelineEstimationTypeChoices>;
  timelineEstimationValue?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetReportTemplateArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetReportTemplateGlobalsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  fieldIdentifier?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['ID']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  reportSection?: InputMaybe<Scalars['ID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetReportTemplateToExportArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdDate?: InputMaybe<Scalars['DateTime']['input']>;
  curriculum?: InputMaybe<Scalars['ID']['input']>;
  defaultPayorTemplate?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  enterpriseTemplate?: InputMaybe<Scalars['Boolean']['input']>;
  exportFramework?: InputMaybe<ApiReportTemplateExportFrameworkChoices>;
  exportTemplateFont?: InputMaybe<ApiReportTemplateExportTemplateFontChoices>;
  fileUploadConfig?: InputMaybe<ApiReportTemplateFileUploadConfigChoices>;
  finalApproverWaitsForReviewers?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  footerText?: InputMaybe<Scalars['String']['input']>;
  headerText?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  isBaseTemplate?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedDate?: InputMaybe<Scalars['DateTime']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderedReplacement?: InputMaybe<Scalars['Boolean']['input']>;
  organizationLogoAllowed?: InputMaybe<Scalars['Boolean']['input']>;
  payorType?: InputMaybe<ApiReportTemplatePayorTypeChoices>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  publishedBy?: InputMaybe<Scalars['ID']['input']>;
  reportNarrativeMappingWorkflow?: InputMaybe<Scalars['Boolean']['input']>;
  reportTemplate: Scalars['ID']['input'];
  reportType?: InputMaybe<ApiReportTemplateReportTypeChoices>;
  requireAllQaResolved?: InputMaybe<Scalars['Boolean']['input']>;
  requireApprovalBeforeExport?: InputMaybe<Scalars['Boolean']['input']>;
  sampleFile?: InputMaybe<Scalars['String']['input']>;
  sampleStatus?: InputMaybe<ApiReportTemplateSampleStatusChoices>;
  status?: InputMaybe<ApiReportTemplateStatusChoices>;
  templateLogoUrl?: InputMaybe<Scalars['String']['input']>;
  templateUrl?: InputMaybe<Scalars['String']['input']>;
  treatmentPlanTemplate?: InputMaybe<Scalars['ID']['input']>;
  unifiedExport?: InputMaybe<Scalars['Boolean']['input']>;
  updatedBy?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryGetReportTemplatesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdDate?: InputMaybe<Scalars['DateTime']['input']>;
  curriculum?: InputMaybe<Scalars['ID']['input']>;
  defaultPayorTemplate?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  enterpriseTemplate?: InputMaybe<Scalars['Boolean']['input']>;
  exportFramework?: InputMaybe<ApiReportTemplateExportFrameworkChoices>;
  exportTemplateFont?: InputMaybe<ApiReportTemplateExportTemplateFontChoices>;
  fileUploadConfig?: InputMaybe<ApiReportTemplateFileUploadConfigChoices>;
  filter?: InputMaybe<GetReportTemplatesFilter>;
  finalApproverWaitsForReviewers?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  footerText?: InputMaybe<Scalars['String']['input']>;
  headerText?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  isBaseTemplate?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedDate?: InputMaybe<Scalars['DateTime']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderedReplacement?: InputMaybe<Scalars['Boolean']['input']>;
  organizationLogoAllowed?: InputMaybe<Scalars['Boolean']['input']>;
  payorType?: InputMaybe<ApiReportTemplatePayorTypeChoices>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  publishedBy?: InputMaybe<Scalars['ID']['input']>;
  reportNarrativeMappingWorkflow?: InputMaybe<Scalars['Boolean']['input']>;
  reportType?: InputMaybe<ApiReportTemplateReportTypeChoices>;
  requireAllQaResolved?: InputMaybe<Scalars['Boolean']['input']>;
  requireApprovalBeforeExport?: InputMaybe<Scalars['Boolean']['input']>;
  sampleFile?: InputMaybe<Scalars['String']['input']>;
  sampleStatus?: InputMaybe<ApiReportTemplateSampleStatusChoices>;
  status?: InputMaybe<ApiReportTemplateStatusChoices>;
  templateLogoUrl?: InputMaybe<Scalars['String']['input']>;
  templateUrl?: InputMaybe<Scalars['String']['input']>;
  treatmentPlanTemplate?: InputMaybe<Scalars['ID']['input']>;
  unifiedExport?: InputMaybe<Scalars['Boolean']['input']>;
  updatedBy?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryGetReportToExportArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  isArchive?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  ordering?: InputMaybe<Scalars['String']['input']>;
  reportClientDetails_ClientFirstName_Icontains?: InputMaybe<Scalars['String']['input']>;
  reportId: Scalars['ID']['input'];
};


export type QueryGetReportsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<GetReportsFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  isArchive?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  ordering?: InputMaybe<Scalars['String']['input']>;
  reportClientDetails_ClientFirstName_Icontains?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetSessionAiPredictionBySessionIdArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdDate?: InputMaybe<Scalars['DateTime']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedDate?: InputMaybe<Scalars['DateTime']['input']>;
  model?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  organization?: InputMaybe<Scalars['ID']['input']>;
  prediction?: InputMaybe<Scalars['String']['input']>;
  predictionType?: InputMaybe<ApiSessionAiPredictionPredictionTypeChoices>;
  vellumPredictionId?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
  videoSession?: InputMaybe<Scalars['ID']['input']>;
  videoSessionId: Scalars['ID']['input'];
};


export type QueryGetSessionAndSessionNoteDataByM2mArgs = {
  externalSessionId?: InputMaybe<Scalars['String']['input']>;
  organizationExternalId: Scalars['String']['input'];
  therapySessionId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryGetSessionAudioMetricsByM2mArgs = {
  videoSessionId: Scalars['ID']['input'];
};


export type QueryGetSessionCaregiversArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  caregiverOrgMetadata_Email_Icontains?: InputMaybe<Scalars['String']['input']>;
  caregiverOrgMetadata_FirstName_Icontains?: InputMaybe<Scalars['String']['input']>;
  caregiverOrgMetadata_HasEnteredParentCommunity?: InputMaybe<Scalars['Boolean']['input']>;
  caregiverOrgMetadata_LastName_Icontains?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetSessionEngagementInsightArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdDate?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  endTime?: InputMaybe<Scalars['Float']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  insightType?: InputMaybe<ApiSessionEngagementInsightInsightTypeChoices>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedDate?: InputMaybe<Scalars['DateTime']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  organization?: InputMaybe<Scalars['ID']['input']>;
  startTime?: InputMaybe<Scalars['Float']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
  videoSession?: InputMaybe<Scalars['ID']['input']>;
  videoSessionId: Scalars['ID']['input'];
};


export type QueryGetSessionEngagementScoreBySessionIdArgs = {
  videoDuration: Scalars['Int']['input'];
  videoSessionId: Scalars['ID']['input'];
};


export type QueryGetSessionListByM2mArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdDate?: InputMaybe<Scalars['DateTime']['input']>;
  date?: InputMaybe<Scalars['Date']['input']>;
  endDatetime?: InputMaybe<Scalars['DateTime']['input']>;
  engagementScore?: InputMaybe<Scalars['Float']['input']>;
  engagementScoreVersion?: InputMaybe<Scalars['String']['input']>;
  finalMedia?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  fromDate: Scalars['Date']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedDate?: InputMaybe<Scalars['DateTime']['input']>;
  meetingId?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  organization?: InputMaybe<Scalars['ID']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  recorderType?: InputMaybe<ApiVideoSessionRecorderTypeChoices>;
  sessionRating?: InputMaybe<Scalars['Int']['input']>;
  sessionStatus?: InputMaybe<ApiVideoSessionSessionStatusChoices>;
  sourceType?: InputMaybe<ApiVideoSessionSourceTypeChoices>;
  startDatetime?: InputMaybe<Scalars['DateTime']['input']>;
  therapySession?: InputMaybe<Scalars['ID']['input']>;
  toDate: Scalars['Date']['input'];
};


export type QueryGetSessionMediaStreamArgs = {
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  videoSessionId: Scalars['ID']['input'];
};


export type QueryGetSessionProgressArgs = {
  filter: GetSessionProgressFilter;
};


export type QueryGetSessionSummariesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdDate?: InputMaybe<Scalars['DateTime']['input']>;
  endDate?: InputMaybe<Scalars['Date']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedDate?: InputMaybe<Scalars['DateTime']['input']>;
  learnerId?: InputMaybe<Scalars['ID']['input']>;
  model?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  organization?: InputMaybe<Scalars['ID']['input']>;
  prediction?: InputMaybe<Scalars['String']['input']>;
  predictionType?: InputMaybe<ApiSessionAiPredictionPredictionTypeChoices>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
  vellumPredictionId?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
  videoSession?: InputMaybe<Scalars['ID']['input']>;
  videoSessionId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryGetSessionSummaryBySessionIdArgs = {
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  videoSessionId: Scalars['ID']['input'];
};


export type QueryGetTargetProgressTreatmentPlanByM2mArgs = {
  organizationId: Scalars['ID']['input'];
  videoSessionId: Scalars['ID']['input'];
};


export type QueryGetTotalVideoDurationRawDataArgs = {
  count?: InputMaybe<Scalars['Int']['input']>;
  fromDate: Scalars['Date']['input'];
  learnerIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  rbtProviderIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  toDate: Scalars['Date']['input'];
};


export type QueryGetTranscriptCsvContentArgs = {
  videoSessionId: Scalars['ID']['input'];
};


export type QueryGetTranscriptDataByMediaIdArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  mediaId: Scalars['ID']['input'];
  offset?: InputMaybe<Scalars['Int']['input']>;
  speaker?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetUserBillingDetailsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  amount?: InputMaybe<Scalars['Decimal']['input']>;
  auth0User?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdDate?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  invoiceId?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedDate?: InputMaybe<Scalars['DateTime']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  organization?: InputMaybe<Scalars['ID']['input']>;
  paymentIntentId?: InputMaybe<Scalars['String']['input']>;
  paymentMethodId?: InputMaybe<Scalars['String']['input']>;
  paymentStatus?: InputMaybe<ApiUserBillingDetailsPaymentStatusChoices>;
  priceId?: InputMaybe<Scalars['String']['input']>;
  productId?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
  report?: InputMaybe<Scalars['ID']['input']>;
  transactionType?: InputMaybe<ApiUserBillingDetailsTransactionTypeChoices>;
  updatedBy?: InputMaybe<Scalars['ID']['input']>;
  userStripeAccount?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryGetVideoCommentsReceivedByRbtRawDataArgs = {
  count?: InputMaybe<Scalars['Int']['input']>;
  fromDate: Scalars['Date']['input'];
  learnerIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  rbtProviderIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  toDate: Scalars['Date']['input'];
};


export type QueryGetZoomAccountAccessTokenArgs = {
  accountId: Scalars['String']['input'];
};


export type QueryGoalArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGoalCategoriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  organizationId: Scalars['ID']['input'];
};


export type QueryGoalsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdDate?: InputMaybe<Scalars['DateTime']['input']>;
  filter?: InputMaybe<GoalFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  isPinned?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedDate?: InputMaybe<Scalars['DateTime']['input']>;
  learner?: InputMaybe<Scalars['ID']['input']>;
  learnerId: Scalars['ID']['input'];
  offset?: InputMaybe<Scalars['Int']['input']>;
  organization?: InputMaybe<Scalars['ID']['input']>;
  rankOrder?: InputMaybe<Scalars['Int']['input']>;
  targetGenerationStatus?: InputMaybe<ApiGoalTargetGenerationStatusChoices>;
};


export type QueryHatchPlanByIdArgs = {
  planId: Scalars['ID']['input'];
};


export type QueryHatchPlanVisualizationByIdArgs = {
  hatchPlanVisualizationId: Scalars['ID']['input'];
};


export type QueryHatchPlansByLearnerCaregiverArgs = {
  caregiverId: Scalars['ID']['input'];
  learnerId: Scalars['ID']['input'];
};


export type QueryHippHealthGoalArgs = {
  id: Scalars['ID']['input'];
};


export type QueryHippHealthGoalsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  aiGenerated?: InputMaybe<Scalars['Boolean']['input']>;
  autoProgressToMaintenanceEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  autoProgressToMasteredEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  baselineDate?: InputMaybe<Scalars['DateTime']['input']>;
  baselineMetric?: InputMaybe<Scalars['JSONString']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdDate?: InputMaybe<Scalars['DateTime']['input']>;
  dataCollectionType?: InputMaybe<Scalars['String']['input']>;
  definition?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  enabledOutcomes?: InputMaybe<Scalars['JSONString']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<HippHealthGoalFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  goal?: InputMaybe<Scalars['ID']['input']>;
  goalStatement?: InputMaybe<Scalars['String']['input']>;
  inUse?: InputMaybe<Scalars['Boolean']['input']>;
  instructions?: InputMaybe<Scalars['String']['input']>;
  intervalDuration?: InputMaybe<Scalars['Int']['input']>;
  intervalQuantity?: InputMaybe<Scalars['Int']['input']>;
  intervalRecordingType?: InputMaybe<ApiHippHealthGoalIntervalRecordingTypeChoices>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedDate?: InputMaybe<Scalars['DateTime']['input']>;
  learnerId: Scalars['ID']['input'];
  maintenanceMetric?: InputMaybe<Scalars['JSONString']['input']>;
  minTrialsCount?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  organization?: InputMaybe<Scalars['ID']['input']>;
  progressSummary?: InputMaybe<Scalars['String']['input']>;
  sets?: InputMaybe<Scalars['Int']['input']>;
  shortDescription?: InputMaybe<Scalars['String']['input']>;
  skillAcquisitionGoalType?: InputMaybe<Scalars['String']['input']>;
  skillCategory?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  successMetric?: InputMaybe<Scalars['JSONString']['input']>;
  targetAchievementDate?: InputMaybe<Scalars['DateTime']['input']>;
  targetMaladaptiveBehaviorName?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<ApiHippHealthGoalTypeChoices>;
  window?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryHippHealthGoalsM2mArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  aiGenerated?: InputMaybe<Scalars['Boolean']['input']>;
  autoProgressToMaintenanceEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  autoProgressToMasteredEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  baselineDate?: InputMaybe<Scalars['DateTime']['input']>;
  baselineMetric?: InputMaybe<Scalars['JSONString']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdDate?: InputMaybe<Scalars['DateTime']['input']>;
  dataCollectionType?: InputMaybe<Scalars['String']['input']>;
  definition?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  enabledOutcomes?: InputMaybe<Scalars['JSONString']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<HippHealthGoalFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  goal?: InputMaybe<Scalars['ID']['input']>;
  goalStatement?: InputMaybe<Scalars['String']['input']>;
  inUse?: InputMaybe<Scalars['Boolean']['input']>;
  instructions?: InputMaybe<Scalars['String']['input']>;
  intervalDuration?: InputMaybe<Scalars['Int']['input']>;
  intervalQuantity?: InputMaybe<Scalars['Int']['input']>;
  intervalRecordingType?: InputMaybe<ApiHippHealthGoalIntervalRecordingTypeChoices>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedDate?: InputMaybe<Scalars['DateTime']['input']>;
  learnerId: Scalars['ID']['input'];
  maintenanceMetric?: InputMaybe<Scalars['JSONString']['input']>;
  minTrialsCount?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  organization?: InputMaybe<Scalars['ID']['input']>;
  progressSummary?: InputMaybe<Scalars['String']['input']>;
  sets?: InputMaybe<Scalars['Int']['input']>;
  shortDescription?: InputMaybe<Scalars['String']['input']>;
  skillAcquisitionGoalType?: InputMaybe<Scalars['String']['input']>;
  skillCategory?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  successMetric?: InputMaybe<Scalars['JSONString']['input']>;
  targetAchievementDate?: InputMaybe<Scalars['DateTime']['input']>;
  targetMaladaptiveBehaviorName?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<ApiHippHealthGoalTypeChoices>;
  window?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryHirasmusGoalArgs = {
  id: Scalars['ID']['input'];
};


export type QueryHirasmusGoalsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  aiGenerated?: InputMaybe<Scalars['Boolean']['input']>;
  baseline?: InputMaybe<Scalars['String']['input']>;
  baselineDate?: InputMaybe<Scalars['Date']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdDate?: InputMaybe<Scalars['DateTime']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<HiRasmusGoalFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  goal?: InputMaybe<Scalars['ID']['input']>;
  inUse?: InputMaybe<Scalars['Boolean']['input']>;
  instructions?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedDate?: InputMaybe<Scalars['DateTime']['input']>;
  learnerId: Scalars['ID']['input'];
  masteringWorkflow?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  objective?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  organization?: InputMaybe<Scalars['ID']['input']>;
  progressSummary?: InputMaybe<Scalars['String']['input']>;
  promptLevelTemplate?: InputMaybe<Scalars['String']['input']>;
  treatmentArea?: InputMaybe<Scalars['String']['input']>;
  treatmentInstructions?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<ApiHiRasmusGoalTypeChoices>;
};


export type QueryInClinicVideoCaptureEnabledOrganizationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hubspotCompanyId?: InputMaybe<Scalars['String']['input']>;
  hubspotCompanyId_Isnull?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  isTestOrganization?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_Icontains?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryIntegrationSyncConfigM2mArgs = {
  createdDate?: InputMaybe<Scalars['DateTime']['input']>;
  filter?: InputMaybe<IntegrationSyncConfigFilter>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  lastUpdatedDate?: InputMaybe<Scalars['DateTime']['input']>;
  organization?: InputMaybe<Scalars['ID']['input']>;
  syncFeature?: InputMaybe<ApiIntegrationSyncConfigSyncFeatureChoices>;
};


export type QueryLearnerArgs = {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdDate?: InputMaybe<Scalars['DateTime']['input']>;
  ehrLearningTreeId?: InputMaybe<Scalars['String']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  externalLastUpdate?: InputMaybe<Scalars['DateTime']['input']>;
  includeArchived?: InputMaybe<Scalars['Boolean']['input']>;
  lastUpdatedDate?: InputMaybe<Scalars['DateTime']['input']>;
  manualGoalSyncLastUpdated?: InputMaybe<Scalars['DateTime']['input']>;
  manualGoalSyncStatus?: InputMaybe<ApiLearnerManualGoalSyncStatusChoices>;
  runEngagementScorer?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryLearnerAuthorizationsArgs = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  authorizationId?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdDate?: InputMaybe<Scalars['DateTime']['input']>;
  endDate?: InputMaybe<Scalars['Date']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<LearnerAuthorizationsFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedDate?: InputMaybe<Scalars['DateTime']['input']>;
  learner?: InputMaybe<Scalars['ID']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  organization?: InputMaybe<Scalars['ID']['input']>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
};


export type QueryLearnerByIdArgs = {
  learnerId: Scalars['ID']['input'];
};


export type QueryLearnerByIdM2mArgs = {
  learnerId: Scalars['ID']['input'];
};


export type QueryLearnerChatMemoryArgs = {
  learnerId: Scalars['ID']['input'];
};


export type QueryLearnerEhrProgrammingArgs = {
  learnerId: Scalars['ID']['input'];
};


export type QueryLearnerEhrSessionDataArgs = {
  goalId?: InputMaybe<Scalars['ID']['input']>;
  learnerId: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  targetId?: InputMaybe<Scalars['ID']['input']>;
  unmatched?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryLearnerEhrSyncsArgs = {
  learnerId: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryLearnerFileByIdArgs = {
  fileId: Scalars['ID']['input'];
  organizationId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryLearnerM2mArgs = {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdDate?: InputMaybe<Scalars['DateTime']['input']>;
  ehrLearningTreeId?: InputMaybe<Scalars['String']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  externalLastUpdate?: InputMaybe<Scalars['DateTime']['input']>;
  filter?: InputMaybe<LearnerFilter>;
  lastUpdatedDate?: InputMaybe<Scalars['DateTime']['input']>;
  manualGoalSyncLastUpdated?: InputMaybe<Scalars['DateTime']['input']>;
  manualGoalSyncStatus?: InputMaybe<ApiLearnerManualGoalSyncStatusChoices>;
  runEngagementScorer?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryLearnerOnboardingQuestionsArgs = {
  additionalAnswer?: InputMaybe<Scalars['String']['input']>;
  answer?: InputMaybe<Scalars['String']['input']>;
  createdDate?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedDate?: InputMaybe<Scalars['DateTime']['input']>;
  learner?: InputMaybe<Scalars['ID']['input']>;
  organization?: InputMaybe<Scalars['ID']['input']>;
  questionKey?: InputMaybe<Scalars['String']['input']>;
  questionPageOrigin?: InputMaybe<Scalars['String']['input']>;
};


export type QueryLearnerProvidersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdDate?: InputMaybe<Scalars['DateTime']['input']>;
  filter?: InputMaybe<LearnerProviderFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedDate?: InputMaybe<Scalars['DateTime']['input']>;
  learner?: InputMaybe<Scalars['ID']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  organization?: InputMaybe<Scalars['ID']['input']>;
  provider?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryLearnersRecentSessionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  learnerId?: InputMaybe<Scalars['ID']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  providerId?: InputMaybe<Scalars['ID']['input']>;
  videoSession_SessionStatus?: InputMaybe<ApiVideoSessionSessionStatusChoices>;
};


export type QueryMediaArgs = {
  blobId?: InputMaybe<Scalars['UUID']['input']>;
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdDate?: InputMaybe<Scalars['DateTime']['input']>;
  endDatetime?: InputMaybe<Scalars['DateTime']['input']>;
  filePath?: InputMaybe<Scalars['String']['input']>;
  lastUpdatedDate?: InputMaybe<Scalars['DateTime']['input']>;
  mediaGroup?: InputMaybe<Scalars['ID']['input']>;
  mediaLanguage?: InputMaybe<ApiMediaMediaLanguageChoices>;
  mediaSource?: InputMaybe<ApiMediaMediaSourceChoices>;
  mediaType?: InputMaybe<ApiMediaMediaTypeChoices>;
  multiplePeopleIncludingChildDuration?: InputMaybe<Scalars['Float']['input']>;
  organization?: InputMaybe<Scalars['ID']['input']>;
  recordingId?: InputMaybe<Scalars['String']['input']>;
  startDatetime?: InputMaybe<Scalars['DateTime']['input']>;
  thumbnailManifestPath?: InputMaybe<Scalars['String']['input']>;
  totalDuration?: InputMaybe<Scalars['Float']['input']>;
  videoSession?: InputMaybe<Scalars['ID']['input']>;
  videoUploadStatus?: InputMaybe<ApiMediaVideoUploadStatusChoices>;
  viewedAt?: InputMaybe<Scalars['DateTime']['input']>;
  viewedBy?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryMediaByAnnotaterArgs = {
  annotaterId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryMediaByIdArgs = {
  mediaId: Scalars['ID']['input'];
};


export type QueryMotivityGoalArgs = {
  id: Scalars['ID']['input'];
};


export type QueryMotivityGoalsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  aiGenerated?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdDate?: InputMaybe<Scalars['DateTime']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<MotivityGoalFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  goal?: InputMaybe<Scalars['ID']['input']>;
  goalType?: InputMaybe<ApiMotivityGoalGoalTypeChoices>;
  inUse?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedDate?: InputMaybe<Scalars['DateTime']['input']>;
  learnerId: Scalars['ID']['input'];
  masteryCriteria?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  organization?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};


export type QueryNotificationOptOutArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdDate?: InputMaybe<Scalars['DateTime']['input']>;
  deliveryMethod?: InputMaybe<ApiNotificationOptOutDeliveryMethodChoices>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedDate?: InputMaybe<Scalars['DateTime']['input']>;
  notificationType?: InputMaybe<ApiNotificationOptOutNotificationTypeChoices>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  organization?: InputMaybe<Scalars['ID']['input']>;
  user?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryOrganizationNotificationSettingsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdDate?: InputMaybe<Scalars['DateTime']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedDate?: InputMaybe<Scalars['DateTime']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  organization?: InputMaybe<Scalars['ID']['input']>;
  reassessmentReminder?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryOrganizationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hubspotCompanyId?: InputMaybe<Scalars['String']['input']>;
  hubspotCompanyId_Isnull?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  isTestOrganization?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_Icontains?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryOrginazationFilterM2mArgs = {
  filter?: InputMaybe<OrganizationFilter>;
  hubspotCompanyId?: InputMaybe<Scalars['String']['input']>;
  hubspotCompanyId_Isnull?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  isTestOrganization?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_Icontains?: InputMaybe<Scalars['String']['input']>;
};


export type QueryParentSessionSummariesArgs = {
  learnerId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryParsedTreatmentPlanFileDataByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryParsedTreatmentPlanFilesDataArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  learner?: InputMaybe<Scalars['ID']['input']>;
  learnerId: Scalars['ID']['input'];
  offset?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<ApiParsedTreatmentPlanFileDataStatusChoices>;
};


export type QueryPassageGoalArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPassageGoalsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  aiGenerated?: InputMaybe<Scalars['Boolean']['input']>;
  antecedentStrategy?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdDate?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  discriminativeStimulus?: InputMaybe<Scalars['String']['input']>;
  errorConsequenceStrategy?: InputMaybe<Scalars['String']['input']>;
  errorCorrectionStrategy?: InputMaybe<Scalars['String']['input']>;
  expectedResponse?: InputMaybe<Scalars['String']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<PassageGoalFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  goal?: InputMaybe<Scalars['ID']['input']>;
  hypothesizedFunction?: InputMaybe<Scalars['String']['input']>;
  inUse?: InputMaybe<Scalars['Boolean']['input']>;
  labels?: InputMaybe<Scalars['JSONString']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedDate?: InputMaybe<Scalars['DateTime']['input']>;
  learnerId: Scalars['ID']['input'];
  offset?: InputMaybe<Scalars['Int']['input']>;
  onset?: InputMaybe<Scalars['String']['input']>;
  operationalDefinition?: InputMaybe<Scalars['String']['input']>;
  organization?: InputMaybe<Scalars['ID']['input']>;
  passageOffset?: InputMaybe<Scalars['String']['input']>;
  promptingInstructions?: InputMaybe<Scalars['String']['input']>;
  reinforcementStrategy?: InputMaybe<Scalars['String']['input']>;
  replacementBehavior?: InputMaybe<Scalars['String']['input']>;
  teachingMethod?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<ApiPassageGoalTypeChoices>;
};


export type QueryPassageGoalsM2mArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  aiGenerated?: InputMaybe<Scalars['Boolean']['input']>;
  antecedentStrategy?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdDate?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  discriminativeStimulus?: InputMaybe<Scalars['String']['input']>;
  errorConsequenceStrategy?: InputMaybe<Scalars['String']['input']>;
  errorCorrectionStrategy?: InputMaybe<Scalars['String']['input']>;
  expectedResponse?: InputMaybe<Scalars['String']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<PassageGoalFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  goal?: InputMaybe<Scalars['ID']['input']>;
  hypothesizedFunction?: InputMaybe<Scalars['String']['input']>;
  inUse?: InputMaybe<Scalars['Boolean']['input']>;
  labels?: InputMaybe<Scalars['JSONString']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedDate?: InputMaybe<Scalars['DateTime']['input']>;
  learnerId: Scalars['ID']['input'];
  offset?: InputMaybe<Scalars['Int']['input']>;
  onset?: InputMaybe<Scalars['String']['input']>;
  operationalDefinition?: InputMaybe<Scalars['String']['input']>;
  organization?: InputMaybe<Scalars['ID']['input']>;
  passageOffset?: InputMaybe<Scalars['String']['input']>;
  promptingInstructions?: InputMaybe<Scalars['String']['input']>;
  reinforcementStrategy?: InputMaybe<Scalars['String']['input']>;
  replacementBehavior?: InputMaybe<Scalars['String']['input']>;
  teachingMethod?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<ApiPassageGoalTypeChoices>;
};


export type QueryPromptsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  filter?: InputMaybe<PromptFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryProviderArgs = {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  auth0User?: InputMaybe<Scalars['ID']['input']>;
  createdDate?: InputMaybe<Scalars['DateTime']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  externalLastUpdate?: InputMaybe<Scalars['DateTime']['input']>;
  hasEnteredVideoCaptureApp?: InputMaybe<Scalars['Boolean']['input']>;
  includeArchived?: InputMaybe<Scalars['Boolean']['input']>;
  lastUpdatedDate?: InputMaybe<Scalars['DateTime']['input']>;
};


export type QueryProviderByAuth0IdArgs = {
  auth0Id: Scalars['String']['input'];
};


export type QueryProviderByEmailArgs = {
  email: Scalars['String']['input'];
};


export type QueryProviderByIdArgs = {
  providerId: Scalars['ID']['input'];
};


export type QueryProviderFilteredByConfigArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  auth0User?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdDate?: InputMaybe<Scalars['DateTime']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  externalLastUpdate?: InputMaybe<Scalars['DateTime']['input']>;
  filter: ProviderConfigFilter;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasEnteredVideoCaptureApp?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedDate?: InputMaybe<Scalars['DateTime']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryProviderM2mArgs = {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  auth0User?: InputMaybe<Scalars['ID']['input']>;
  createdDate?: InputMaybe<Scalars['DateTime']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  externalLastUpdate?: InputMaybe<Scalars['DateTime']['input']>;
  filter?: InputMaybe<ProviderFilter>;
  hasEnteredVideoCaptureApp?: InputMaybe<Scalars['Boolean']['input']>;
  lastUpdatedDate?: InputMaybe<Scalars['DateTime']['input']>;
};


export type QueryProvidersLearnersM2mArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdDate?: InputMaybe<Scalars['DateTime']['input']>;
  ehrLearningTreeId?: InputMaybe<Scalars['String']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  externalLastUpdate?: InputMaybe<Scalars['DateTime']['input']>;
  filter?: InputMaybe<LearnerProviderM2MFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedDate?: InputMaybe<Scalars['DateTime']['input']>;
  manualGoalSyncLastUpdated?: InputMaybe<Scalars['DateTime']['input']>;
  manualGoalSyncStatus?: InputMaybe<ApiLearnerManualGoalSyncStatusChoices>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  runEngagementScorer?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryRbtResponsesToBcbaQuestionsRawDataArgs = {
  count?: InputMaybe<Scalars['Int']['input']>;
  forResponseRate?: InputMaybe<Scalars['Boolean']['input']>;
  fromDate: Scalars['Date']['input'];
  learnerIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  rbtProviderIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  toDate: Scalars['Date']['input'];
};


export type QueryRbtSessionVideosAnalyticsArgs = {
  comparisonFromDate?: InputMaybe<Scalars['Date']['input']>;
  comparisonToDate?: InputMaybe<Scalars['Date']['input']>;
  fromDate: Scalars['Date']['input'];
  rbtProviderIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  toDate: Scalars['Date']['input'];
};


export type QueryReassessmentEhrGoalsArgs = {
  reportId: Scalars['ID']['input'];
};


export type QueryReportExportDataArgs = {
  reportId: Scalars['ID']['input'];
};


export type QueryReviewCompletionTimeRawDataArgs = {
  bcbaProviderIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  fromDate: Scalars['Date']['input'];
  learnerIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  toDate: Scalars['Date']['input'];
};


export type QuerySearchSimilarGoalBankGoalsArgs = {
  embedding: Array<InputMaybe<Scalars['Float']['input']>>;
  organizationId: Scalars['ID']['input'];
  reportTemplateId: Scalars['ID']['input'];
  topK?: InputMaybe<Scalars['Int']['input']>;
};


export type QuerySessionAnalyticsVideosOverviewArgs = {
  comparisonFromDate?: InputMaybe<Scalars['Date']['input']>;
  comparisonToDate?: InputMaybe<Scalars['Date']['input']>;
  fromDate: Scalars['Date']['input'];
  toDate: Scalars['Date']['input'];
};


export type QuerySessionByProviderDateRangeDataM2mArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  billingCode?: InputMaybe<Scalars['String']['input']>;
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdDate?: InputMaybe<Scalars['DateTime']['input']>;
  endDatetime?: InputMaybe<Scalars['DateTime']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedDate?: InputMaybe<Scalars['DateTime']['input']>;
  locationType?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  organization?: InputMaybe<Scalars['ID']['input']>;
  organizationExternalId: Scalars['String']['input'];
  providerId: Scalars['Int']['input'];
  sessionEndDatetime: Scalars['DateTime']['input'];
  sessionStartDatetime: Scalars['DateTime']['input'];
  sessionTimezone?: InputMaybe<Scalars['String']['input']>;
  sessionType?: InputMaybe<ApiTherapySessionSessionTypeChoices>;
  startDatetime?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<ApiTherapySessionStatusChoices>;
};


export type QuerySessionLearnersWithSessionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  videoSession_SessionStatus?: InputMaybe<ApiVideoSessionSessionStatusChoices>;
};


export type QuerySessionProviderArgs = {
  createdDate?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedDate?: InputMaybe<Scalars['DateTime']['input']>;
  organization?: InputMaybe<Scalars['ID']['input']>;
  provider?: InputMaybe<Scalars['ID']['input']>;
  providerType?: InputMaybe<ApiSessionProviderProviderTypeChoices>;
  therapySession?: InputMaybe<Scalars['ID']['input']>;
  videoSession?: InputMaybe<Scalars['ID']['input']>;
};


export type QuerySessionsByLearnerIdArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdDate?: InputMaybe<Scalars['DateTime']['input']>;
  date?: InputMaybe<Scalars['Date']['input']>;
  endDatetime?: InputMaybe<Scalars['DateTime']['input']>;
  engagementScore?: InputMaybe<Scalars['Float']['input']>;
  engagementScoreVersion?: InputMaybe<Scalars['String']['input']>;
  finalMedia?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedDate?: InputMaybe<Scalars['DateTime']['input']>;
  learnerId: Scalars['ID']['input'];
  meetingId?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  organization?: InputMaybe<Scalars['ID']['input']>;
  providerId?: InputMaybe<Scalars['ID']['input']>;
  recorderType?: InputMaybe<ApiVideoSessionRecorderTypeChoices>;
  sessionRating?: InputMaybe<Scalars['Int']['input']>;
  sessionStatus?: InputMaybe<ApiVideoSessionSessionStatusChoices>;
  sourceType?: InputMaybe<ApiVideoSessionSourceTypeChoices>;
  startDatetime?: InputMaybe<Scalars['DateTime']['input']>;
  therapySession?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryTasksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  chat?: InputMaybe<Scalars['ID']['input']>;
  filter?: InputMaybe<TasksFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  learner?: InputMaybe<Scalars['ID']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<ApiTaskStatusChoices>;
  type?: InputMaybe<ApiTaskTypeChoices>;
  user?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryTemplateExportDataArgs = {
  reportTemplate: Scalars['ID']['input'];
};


export type QueryTherapzGoalArgs = {
  id: Scalars['ID']['input'];
};


export type QueryTherapzGoalsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  aiGenerated?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdDate?: InputMaybe<Scalars['DateTime']['input']>;
  dataCollectionType?: InputMaybe<ApiTherapzGoalDataCollectionTypeChoices>;
  description?: InputMaybe<Scalars['String']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  goal?: InputMaybe<Scalars['ID']['input']>;
  inUse?: InputMaybe<Scalars['Boolean']['input']>;
  labels?: InputMaybe<Scalars['JSONString']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedDate?: InputMaybe<Scalars['DateTime']['input']>;
  learnerId: Scalars['ID']['input'];
  offset?: InputMaybe<Scalars['Int']['input']>;
  organization?: InputMaybe<Scalars['ID']['input']>;
  phase?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<ApiTherapzGoalTypeChoices>;
};


export type QueryTotalOverviewVideosRawTextDataArgs = {
  bcbaProviderId?: InputMaybe<Scalars['ID']['input']>;
  count?: InputMaybe<Scalars['Int']['input']>;
  fromDate: Scalars['Date']['input'];
  learnerId?: InputMaybe<Scalars['ID']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  toDate: Scalars['Date']['input'];
};


export type QueryTotalVideosOverviewGraphArgs = {
  comparisonFromDate?: InputMaybe<Scalars['Date']['input']>;
  comparisonToDate?: InputMaybe<Scalars['Date']['input']>;
  fromDate: Scalars['Date']['input'];
  toDate: Scalars['Date']['input'];
};


export type QueryTranscriptArgs = {
  aiModelVersion?: InputMaybe<Scalars['String']['input']>;
  createdDate?: InputMaybe<Scalars['DateTime']['input']>;
  filePath?: InputMaybe<Scalars['String']['input']>;
  lastUpdatedDate?: InputMaybe<Scalars['DateTime']['input']>;
  organization?: InputMaybe<Scalars['ID']['input']>;
  transcriptMedia?: InputMaybe<Scalars['ID']['input']>;
  transcriptModel?: InputMaybe<ApiTranscriptTranscriptModelChoices>;
  transcriptType?: InputMaybe<ApiTranscriptTranscriptTypeChoices>;
  videoSession?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryTreatmentPlanTemplateArgs = {
  reportId: Scalars['ID']['input'];
};


export type QueryUnembeddedGoalBankGoalsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  assessmentToolSource?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdDate?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  domain?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  folder?: InputMaybe<Scalars['ID']['input']>;
  goalName?: InputMaybe<Scalars['String']['input']>;
  hasMedicalNecessity?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedDate?: InputMaybe<Scalars['DateTime']['input']>;
  longTermGoalBank?: InputMaybe<Scalars['ID']['input']>;
  masteryCriteria?: InputMaybe<Scalars['String']['input']>;
  medicalNecessityCriteria?: InputMaybe<Scalars['String']['input']>;
  medicalRationale?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  organization?: InputMaybe<Scalars['ID']['input']>;
  organizationId: Scalars['ID']['input'];
  programGoal?: InputMaybe<Scalars['String']['input']>;
  timelineEstimationType?: InputMaybe<ApiReportGoalBankTimelineEstimationTypeChoices>;
  timelineEstimationValue?: InputMaybe<Scalars['Int']['input']>;
  updatedBy?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryVideoSessionByIdArgs = {
  videoSessionId: Scalars['ID']['input'];
};


export type QueryVideoSessionByIdM2mArgs = {
  videoSessionId: Scalars['ID']['input'];
};


export type QueryVideoSessionsArgs = {
  comment?: InputMaybe<Scalars['String']['input']>;
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdDate?: InputMaybe<Scalars['DateTime']['input']>;
  date?: InputMaybe<Scalars['Date']['input']>;
  endDatetime?: InputMaybe<Scalars['DateTime']['input']>;
  engagementScore?: InputMaybe<Scalars['Float']['input']>;
  engagementScoreVersion?: InputMaybe<Scalars['String']['input']>;
  finalMedia?: InputMaybe<Scalars['ID']['input']>;
  lastUpdatedDate?: InputMaybe<Scalars['DateTime']['input']>;
  meetingId?: InputMaybe<Scalars['String']['input']>;
  organization?: InputMaybe<Scalars['ID']['input']>;
  recorderType?: InputMaybe<ApiVideoSessionRecorderTypeChoices>;
  sessionRating?: InputMaybe<Scalars['Int']['input']>;
  sessionStatus?: InputMaybe<ApiVideoSessionSessionStatusChoices>;
  sourceType?: InputMaybe<ApiVideoSessionSourceTypeChoices>;
  startDatetime?: InputMaybe<Scalars['DateTime']['input']>;
  therapySession?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryVideosDurationOverviewGraphArgs = {
  comparisonFromDate?: InputMaybe<Scalars['Date']['input']>;
  comparisonToDate?: InputMaybe<Scalars['Date']['input']>;
  fromDate: Scalars['Date']['input'];
  toDate: Scalars['Date']['input'];
};


export type QueryVideosReviewedOverviewGraphArgs = {
  comparisonFromDate?: InputMaybe<Scalars['Date']['input']>;
  comparisonToDate?: InputMaybe<Scalars['Date']['input']>;
  fromDate: Scalars['Date']['input'];
  toDate: Scalars['Date']['input'];
};


export type QueryVideosReviewedRawDataArgs = {
  avgVideosReviewed?: InputMaybe<Scalars['Boolean']['input']>;
  bcbaProviderIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  fromDate: Scalars['Date']['input'];
  learnerIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  toDate: Scalars['Date']['input'];
};


export type QueryVoiceSignatureArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdDate?: InputMaybe<Scalars['DateTime']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedDate?: InputMaybe<Scalars['DateTime']['input']>;
  learner?: InputMaybe<Scalars['ID']['input']>;
  learnerLevel?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  organization?: InputMaybe<Scalars['ID']['input']>;
  provider?: InputMaybe<Scalars['ID']['input']>;
  s3Path?: InputMaybe<Scalars['String']['input']>;
  totalDurationMs?: InputMaybe<Scalars['Int']['input']>;
};

export type QuestionsAskedByRbtRawDataType = {
  __typename?: 'QuestionsAskedByRbtRawDataType';
  rawData?: Maybe<Array<Maybe<QuestionsAskedByRbtRawTextDataType>>>;
  totalRecordsCount?: Maybe<Scalars['Int']['output']>;
};

export type QuestionsAskedByRbtRawTextDataType = {
  __typename?: 'QuestionsAskedByRbtRawTextDataType';
  rbtName?: Maybe<Scalars['String']['output']>;
  sessionDate?: Maybe<Scalars['Date']['output']>;
  sessionDatetime?: Maybe<Scalars['DateTime']['output']>;
  sessionDuration?: Maybe<Scalars['Float']['output']>;
  totalQuestionsAsked?: Maybe<Scalars['Int']['output']>;
};

export type RbtSessionAnalyticsVideosDataType = {
  __typename?: 'RBTSessionAnalyticsVideosDataType';
  averageCommentsReceivedPerVideo?: Maybe<Scalars['Int']['output']>;
  averageQuestionAskedPerVideo?: Maybe<Scalars['Int']['output']>;
  averageResponseRateToBcbaQuestions?: Maybe<Scalars['Int']['output']>;
  averageResponseTimeToBcbaQuestions?: Maybe<Scalars['Float']['output']>;
  averageVideoUploadTime?: Maybe<Scalars['Float']['output']>;
  receivedCommentsDistributionCount?: Maybe<CommentsDataType>;
  sessionsStateDistribution?: Maybe<SessionRecordingStateDistributionType>;
  totalSessionsRecorded?: Maybe<Scalars['Int']['output']>;
  videoRecordingsDurationInSeconds?: Maybe<Scalars['Float']['output']>;
};

export type RbtSessionAnalyticsVideosType = {
  __typename?: 'RBTSessionAnalyticsVideosType';
  comparisonData?: Maybe<RbtSessionAnalyticsVideosDataType>;
  currentData?: Maybe<RbtSessionAnalyticsVideosDataType>;
};

export type RbtVideoUploadTimeRawDataType = {
  __typename?: 'RbtVideoUploadTimeRawDataType';
  rawData?: Maybe<Array<Maybe<RbtVideoUploadTimeRawTextDataType>>>;
  totalRecordsCount?: Maybe<Scalars['Int']['output']>;
};

export type RbtVideoUploadTimeRawTextDataType = {
  __typename?: 'RbtVideoUploadTimeRawTextDataType';
  rbtName?: Maybe<Scalars['String']['output']>;
  sessionDate?: Maybe<Scalars['Date']['output']>;
  sessionDatetime?: Maybe<Scalars['DateTime']['output']>;
  sessionDuration?: Maybe<Scalars['Float']['output']>;
  uploadCompletionTimeInSeconds?: Maybe<Scalars['Float']['output']>;
};

/** Re run failed video_session */
export type ReRunFailedSessionBySuperAdmin = {
  __typename?: 'ReRunFailedSessionBySuperAdmin';
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type ReadAllNotifications = {
  __typename?: 'ReadAllNotifications';
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type ReadNotification = {
  __typename?: 'ReadNotification';
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type ReadNotificationInput = {
  notificationId: Scalars['ID']['input'];
};

export enum ReassessmentGoalIncluded {
  Included = 'INCLUDED',
  NotIncluded = 'NOT_INCLUDED'
}

export enum ReassessmentGoalSubTypeEnums {
  AdaptiveSkills = 'ADAPTIVE_SKILLS',
  CommunicationSkills = 'COMMUNICATION_SKILLS',
  ParentCaregiver = 'PARENT_CAREGIVER',
  ReplacementBehaviors = 'REPLACEMENT_BEHAVIORS',
  SocialSkills = 'SOCIAL_SKILLS'
}

export enum ReassessmentGoalTypeEnums {
  Behavior = 'BEHAVIOR',
  Caregiver = 'CAREGIVER',
  Skill = 'SKILL'
}

export type ReassignReportGoal = {
  __typename?: 'ReassignReportGoal';
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type ReassignReportGoalInput = {
  newReportDomainId: Scalars['ID']['input'];
  reportGoalId: Scalars['ID']['input'];
};

/**
 * Regenerate the Goal Status Summary TABLE field's content for a
 * report, from current `ReportGoal` data. Called at the Narrative →
 * Review-and-Sign transition — see
 * `docs/adr/0004-goal-status-summary-table-key.md` in the workspace root.
 * A no-op (status=True, updated=False) when the report has no field
 * wired to this table_key; the caller should not treat that as an error.
 */
export type RecalculateGoalStatusSummary = {
  __typename?: 'RecalculateGoalStatusSummary';
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
  updated?: Maybe<Scalars['Boolean']['output']>;
};

export type RecommendationBankFolderType = Node & {
  __typename?: 'RecommendationBankFolderType';
  auth0User?: Maybe<UserType>;
  createdBy?: Maybe<UserType>;
  createdDate: Scalars['DateTime']['output'];
  folderType: ApiRecommendationBankFolderFolderTypeChoices;
  /** The ID of the object */
  id: Scalars['ID']['output'];
  lastUpdatedDate: Scalars['DateTime']['output'];
  name: Scalars['String']['output'];
  organization: OrganizationType;
  pk?: Maybe<Scalars['Int']['output']>;
  recommendationbankitemSet: RecommendationBankItemTypeConnection;
  recommendationsCount?: Maybe<Scalars['Int']['output']>;
  updatedBy?: Maybe<UserType>;
};


export type RecommendationBankFolderTypeRecommendationbankitemSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdDate?: InputMaybe<Scalars['DateTime']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  folder?: InputMaybe<Scalars['ID']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedDate?: InputMaybe<Scalars['DateTime']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  organization?: InputMaybe<Scalars['ID']['input']>;
  recommendationCategory?: InputMaybe<Scalars['String']['input']>;
  recommendationContent?: InputMaybe<Scalars['String']['input']>;
  recommendationTitle?: InputMaybe<Scalars['String']['input']>;
  updatedBy?: InputMaybe<Scalars['ID']['input']>;
};

export type RecommendationBankFolderTypeConnection = {
  __typename?: 'RecommendationBankFolderTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<RecommendationBankFolderTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `RecommendationBankFolderType` and its cursor. */
export type RecommendationBankFolderTypeEdge = {
  __typename?: 'RecommendationBankFolderTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<RecommendationBankFolderType>;
};

export enum RecommendationBankFolderTypeEnum {
  Organization = 'ORGANIZATION',
  User = 'USER'
}

export type RecommendationBankFoldersType = {
  __typename?: 'RecommendationBankFoldersType';
  organizationFolders?: Maybe<Array<Maybe<RecommendationBankFolderType>>>;
  userFolders?: Maybe<Array<Maybe<RecommendationBankFolderType>>>;
};

export type RecommendationBankItemType = Node & {
  __typename?: 'RecommendationBankItemType';
  createdBy?: Maybe<UserType>;
  createdDate: Scalars['DateTime']['output'];
  folder: RecommendationBankFolderType;
  /** The ID of the object */
  id: Scalars['ID']['output'];
  lastUpdatedDate: Scalars['DateTime']['output'];
  organization: OrganizationType;
  pk?: Maybe<Scalars['Int']['output']>;
  recommendationCategory?: Maybe<Scalars['String']['output']>;
  recommendationContent?: Maybe<Scalars['String']['output']>;
  recommendationTitle?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<UserType>;
};

export type RecommendationBankItemTypeConnection = {
  __typename?: 'RecommendationBankItemTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<RecommendationBankItemTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `RecommendationBankItemType` and its cursor. */
export type RecommendationBankItemTypeEdge = {
  __typename?: 'RecommendationBankItemTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<RecommendationBankItemType>;
};

export type RecordedVideosDistributionRawDataType = {
  __typename?: 'RecordedVideosDistributionRawDataType';
  rawData?: Maybe<Array<Maybe<RecordedVideosDistributionRawTextDataType>>>;
  totalRecordsCount?: Maybe<Scalars['Int']['output']>;
};

export type RecordedVideosDistributionRawTextDataType = {
  __typename?: 'RecordedVideosDistributionRawTextDataType';
  clientId?: Maybe<Scalars['Int']['output']>;
  clientName?: Maybe<Scalars['String']['output']>;
  completedVideosCount?: Maybe<Scalars['Int']['output']>;
  failedVideosCount?: Maybe<Scalars['Int']['output']>;
  processingVideosCount?: Maybe<Scalars['Int']['output']>;
  rbtName?: Maybe<Scalars['String']['output']>;
  scheduledVideosCount?: Maybe<Scalars['Int']['output']>;
  totalVideosRecorded?: Maybe<Scalars['Int']['output']>;
  uploadingVideosCount?: Maybe<Scalars['Int']['output']>;
};

export type Refresh = {
  __typename?: 'Refresh';
  payload: Scalars['GenericScalar']['output'];
  refreshExpiresIn: Scalars['Int']['output'];
  token: Scalars['String']['output'];
};

export type RegisterDeviceToken = {
  __typename?: 'RegisterDeviceToken';
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type RegisterDeviceTokenInput = {
  deviceIdentifier: Scalars['String']['input'];
  deviceType: Scalars['String']['input'];
  pushToken: Scalars['String']['input'];
};

export type ReissueCaregiverInvitation = {
  __typename?: 'ReissueCaregiverInvitation';
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type ReissueProviderInvitation = {
  __typename?: 'ReissueProviderInvitation';
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type RelationshipType = Node & {
  __typename?: 'RelationshipType';
  caregiver: CaregiverType;
  createdBy?: Maybe<UserType>;
  createdDate: Scalars['DateTime']['output'];
  hasCaregiverConsent: Scalars['Boolean']['output'];
  /** The ID of the object */
  id: Scalars['ID']['output'];
  isPrimary: Scalars['Boolean']['output'];
  lastUpdatedDate: Scalars['DateTime']['output'];
  organization: OrganizationType;
  pk?: Maybe<Scalars['Int']['output']>;
  relationship: ApiRelationshipRelationshipChoices;
  relationshipLearner: LearnerType;
  socialRelationship?: Maybe<Scalars['String']['output']>;
};

export type RelationshipTypeConnection = {
  __typename?: 'RelationshipTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<RelationshipTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `RelationshipType` and its cursor. */
export type RelationshipTypeEdge = {
  __typename?: 'RelationshipTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<RelationshipType>;
};

/**
 * Remove a learner-payor mapping created from the portal (PROA-1736).
 *
 * Soft-deletes the ``LearnerPayor`` row for (learner, payor_type) in the
 * caller's organization by marking it ``is_active=False`` rather than
 * deleting it — the row (and any sync-owned fields like ``external_id`` /
 * ``report_upload_prefix``) is preserved. A missing mapping is surfaced as a
 * field error rather than raising.
 */
export type RemoveLearnerPayor = {
  __typename?: 'RemoveLearnerPayor';
  errors?: Maybe<Array<Maybe<FieldError>>>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type RemoveMediaAiPredictions = {
  __typename?: 'RemoveMediaAIPredictions';
  message?: Maybe<Scalars['String']['output']>;
  response?: Maybe<Scalars['JSONString']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type RemoveMediaAiPredictionsInput = {
  mediaIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  predictionType: MediaAiPredictionEnum;
  sessionIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};

export type RemoveMediaComment = {
  __typename?: 'RemoveMediaComment';
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type RemoveReportGoal = {
  __typename?: 'RemoveReportGoal';
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type RemoveReportTarget = {
  __typename?: 'RemoveReportTarget';
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type RemoveSessionData = {
  __typename?: 'RemoveSessionData';
  message?: Maybe<Scalars['String']['output']>;
  sessionMetaData?: Maybe<Scalars['JSONString']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type RemoveSessionDataInput = {
  videoSessionId: Scalars['ID']['input'];
};

export type ReopenReportComment = {
  __typename?: 'ReopenReportComment';
  comment?: Maybe<ReportCommentType>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type ReorderGoals = {
  __typename?: 'ReorderGoals';
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type ReorderGoalsInput = {
  goal: Scalars['ID']['input'];
  rankOrder: Scalars['Int']['input'];
};

/**
 * Reorder report goals by updating rank_order on their underlying base Goals.
 * If a ReportGoal has no linked base Goal yet, one is created automatically.
 */
export type ReorderReportGoals = {
  __typename?: 'ReorderReportGoals';
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type ReorderReportGoalsInput = {
  rankOrder: Scalars['Int']['input'];
  reportGoalId: Scalars['ID']['input'];
};

export enum ReportAnalyticsStatus {
  Approved = 'APPROVED',
  Complete = 'COMPLETE',
  Draft = 'DRAFT',
  NeedsRevision = 'NEEDS_REVISION',
  Submitted = 'SUBMITTED'
}

export enum ReportAnalyticsTemplateType {
  Db = 'DB',
  Ia = 'IA',
  Ra = 'RA'
}

export type ReportClientDetailsType = Node & {
  __typename?: 'ReportClientDetailsType';
  address?: Maybe<Scalars['String']['output']>;
  addressLine2?: Maybe<Scalars['String']['output']>;
  birthDate?: Maybe<Scalars['Date']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  clientFirstName: Scalars['String']['output'];
  clientLastName?: Maybe<Scalars['String']['output']>;
  createdBy: UserType;
  createdDate: Scalars['DateTime']['output'];
  gender?: Maybe<ApiReportClientDetailsGenderChoices>;
  guardian2FirstName?: Maybe<Scalars['String']['output']>;
  guardian2LastName?: Maybe<Scalars['String']['output']>;
  guardianFirstName: Scalars['String']['output'];
  guardianLastName?: Maybe<Scalars['String']['output']>;
  /** The ID of the object */
  id: Scalars['ID']['output'];
  lastUpdatedDate: Scalars['DateTime']['output'];
  organization: OrganizationType;
  pk?: Maybe<Scalars['Int']['output']>;
  report: ReportType;
  reportClientMetaData?: Maybe<Scalars['JSONString']['output']>;
  specifyGender?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  zip?: Maybe<Scalars['String']['output']>;
};

export type ReportClientDetailsTypeConnection = {
  __typename?: 'ReportClientDetailsTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ReportClientDetailsTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `ReportClientDetailsType` and its cursor. */
export type ReportClientDetailsTypeEdge = {
  __typename?: 'ReportClientDetailsTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<ReportClientDetailsType>;
};

export type ReportCommentType = Node & ReportReviewItemInterface & {
  __typename?: 'ReportCommentType';
  author?: Maybe<ReportReviewUserType>;
  /** Snapshot of the anchor's content when a Proposed Edit was created. */
  baseValue?: Maybe<Scalars['String']['output']>;
  /** Whether the requesting user may delete this comment. */
  canDelete: Scalars['Boolean']['output'];
  /** Whether the requesting user may edit this comment's body. */
  canEdit: Scalars['Boolean']['output'];
  content?: Maybe<Scalars['String']['output']>;
  createdDate: Scalars['DateTime']['output'];
  /** When a peer-review comment's body was last edited by its author. Null if never edited. */
  editedAt?: Maybe<Scalars['DateTime']['output']>;
  goalField?: Maybe<Scalars['String']['output']>;
  hidden: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  /** Whether the author deleted this comment. A deleted comment has no content or author; review items include it only while it still has replies. */
  isDeleted: Scalars['Boolean']['output'];
  parent?: Maybe<ReportReviewItemParent>;
  /** The reviewer's suggested replacement content. */
  proposedValue?: Maybe<Scalars['String']['output']>;
  report: ReportType;
  reportGoal?: Maybe<ReportGoalType>;
  reportSectionField?: Maybe<ReportSectionFieldsType>;
  reportTarget?: Maybe<ReportTargetType>;
  resolvedAt?: Maybe<Scalars['DateTime']['output']>;
  resolvedBy?: Maybe<ReportReviewUserType>;
  source: Scalars['String']['output'];
  status: Scalars['String']['output'];
  targetField?: Maybe<Scalars['String']['output']>;
};

export type ReportDomainType = Node & {
  __typename?: 'ReportDomainType';
  createdBy?: Maybe<UserType>;
  createdDate: Scalars['DateTime']['output'];
  customFields: TreatmentPlanCustomFieldTypeConnection;
  description?: Maybe<Scalars['String']['output']>;
  domainName?: Maybe<Scalars['String']['output']>;
  /** The ID of the object */
  id: Scalars['ID']['output'];
  lastUpdatedDate: Scalars['DateTime']['output'];
  learner: LearnerType;
  name: Scalars['String']['output'];
  organization: OrganizationType;
  pk?: Maybe<Scalars['Int']['output']>;
  rankOrder: Scalars['Int']['output'];
  reportTreatmentPlan?: Maybe<ReportTreatmentPlanType>;
  reportgoalSet: ReportGoalTypeConnection;
  reporttargetSet: ReportTargetTypeConnection;
};


export type ReportDomainTypeCustomFieldsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  fieldIdentifier?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  reportGoal?: InputMaybe<Scalars['ID']['input']>;
  reportTarget?: InputMaybe<Scalars['ID']['input']>;
};


export type ReportDomainTypeReportgoalSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  aiBaselineDataPredictionStatus?: InputMaybe<ApiReportGoalAiBaselineDataPredictionStatusChoices>;
  aiGenerated?: InputMaybe<Scalars['Boolean']['input']>;
  aiGoalAttainmentScalePredictionStatus?: InputMaybe<ApiReportGoalAiGoalAttainmentScalePredictionStatusChoices>;
  aiProgressSummaryPredictionStatus?: InputMaybe<ApiReportGoalAiProgressSummaryPredictionStatusChoices>;
  assessmentToolSource?: InputMaybe<Scalars['String']['input']>;
  baselineData?: InputMaybe<Scalars['String']['input']>;
  baselineDate?: InputMaybe<Scalars['Date']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  chartFromDate?: InputMaybe<Scalars['Date']['input']>;
  chartImageUrl?: InputMaybe<Scalars['String']['input']>;
  chartToDate?: InputMaybe<Scalars['Date']['input']>;
  chartType?: InputMaybe<ApiReportGoalChartTypeChoices>;
  completionDate?: InputMaybe<Scalars['Date']['input']>;
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdDate?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  excludeFromReport?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  gasLevel1?: InputMaybe<Scalars['String']['input']>;
  gasLevel3?: InputMaybe<Scalars['String']['input']>;
  gasLevel4?: InputMaybe<Scalars['String']['input']>;
  gasMatchMessage?: InputMaybe<Scalars['String']['input']>;
  gasMatchStatus?: InputMaybe<ApiReportGoalGasMatchStatusChoices>;
  gasScore?: InputMaybe<Scalars['String']['input']>;
  generalizationCriteria?: InputMaybe<Scalars['String']['input']>;
  goal?: InputMaybe<Scalars['ID']['input']>;
  goalBank?: InputMaybe<Scalars['ID']['input']>;
  goalName?: InputMaybe<Scalars['String']['input']>;
  goalSubType?: InputMaybe<Scalars['String']['input']>;
  goalType?: InputMaybe<Scalars['String']['input']>;
  hasMedicalNecessity?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  inUse?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedDate?: InputMaybe<Scalars['DateTime']['input']>;
  learner?: InputMaybe<Scalars['ID']['input']>;
  masteryCriteria?: InputMaybe<Scalars['String']['input']>;
  medicalNecessityCriteria?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  organization?: InputMaybe<Scalars['ID']['input']>;
  predictionId?: InputMaybe<Scalars['String']['input']>;
  programGoal?: InputMaybe<Scalars['String']['input']>;
  progressSummary?: InputMaybe<Scalars['String']['input']>;
  projectedIntroductionDate?: InputMaybe<Scalars['Date']['input']>;
  rationale?: InputMaybe<Scalars['String']['input']>;
  report?: InputMaybe<Scalars['ID']['input']>;
  reportDomain?: InputMaybe<Scalars['ID']['input']>;
  reportTreatmentPlan?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<ApiReportGoalStatusChoices>;
  suggestionConfidence?: InputMaybe<Scalars['Float']['input']>;
  summaryReviewed?: InputMaybe<Scalars['Boolean']['input']>;
  summaryReviewedOn?: InputMaybe<Scalars['DateTime']['input']>;
  timelineEstimationType?: InputMaybe<ApiReportGoalTimelineEstimationTypeChoices>;
  timelineEstimationValue?: InputMaybe<Scalars['Int']['input']>;
};


export type ReportDomainTypeReporttargetSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  aiGenerated?: InputMaybe<Scalars['Boolean']['input']>;
  aiProgressSummaryPredictionStatus?: InputMaybe<ApiReportTargetAiProgressSummaryPredictionStatusChoices>;
  baselineData?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  chartFromDate?: InputMaybe<Scalars['Date']['input']>;
  chartImageUrl?: InputMaybe<Scalars['String']['input']>;
  chartToDate?: InputMaybe<Scalars['Date']['input']>;
  chartType?: InputMaybe<ApiReportTargetChartTypeChoices>;
  completionDate?: InputMaybe<Scalars['Date']['input']>;
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdDate?: InputMaybe<Scalars['DateTime']['input']>;
  excludeFromReport?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  inUse?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedDate?: InputMaybe<Scalars['DateTime']['input']>;
  learner?: InputMaybe<Scalars['ID']['input']>;
  masteryCriteria?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  organization?: InputMaybe<Scalars['ID']['input']>;
  predictionId?: InputMaybe<Scalars['String']['input']>;
  priorityOrder?: InputMaybe<Scalars['Int']['input']>;
  progressSummary?: InputMaybe<Scalars['String']['input']>;
  progressType?: InputMaybe<ApiReportTargetProgressTypeChoices>;
  projectedIntroductionDate?: InputMaybe<Scalars['Date']['input']>;
  report?: InputMaybe<Scalars['ID']['input']>;
  reportDomain?: InputMaybe<Scalars['ID']['input']>;
  reportGoal?: InputMaybe<Scalars['ID']['input']>;
  reportTreatmentPlan?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<ApiReportTargetStatusChoices>;
  summaryReviewed?: InputMaybe<Scalars['Boolean']['input']>;
  summaryReviewedOn?: InputMaybe<Scalars['DateTime']['input']>;
  target?: InputMaybe<Scalars['ID']['input']>;
  targetDescription?: InputMaybe<Scalars['String']['input']>;
  targetName?: InputMaybe<Scalars['String']['input']>;
  timelineEstimationType?: InputMaybe<ApiReportTargetTimelineEstimationTypeChoices>;
  timelineEstimationValue?: InputMaybe<Scalars['Int']['input']>;
};

export type ReportDomainTypeConnection = {
  __typename?: 'ReportDomainTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ReportDomainTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `ReportDomainType` and its cursor. */
export type ReportDomainTypeEdge = {
  __typename?: 'ReportDomainTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<ReportDomainType>;
};

export type ReportExportDataType = {
  __typename?: 'ReportExportDataType';
  clientDetails?: Maybe<ExportClientDetailsType>;
  dateOfReport?: Maybe<Scalars['String']['output']>;
  exportFont?: Maybe<ReportTemplateExportFontEnums>;
  exportFramework?: Maybe<ReportExportFrameworkEnums>;
  fileUploadConfig?: Maybe<ReportTemplateFileUploadConfig>;
  footerText?: Maybe<Scalars['String']['output']>;
  goalGroups?: Maybe<Array<Maybe<ExportGoalGroupType>>>;
  headerText?: Maybe<Scalars['String']['output']>;
  isGasEnabled?: Maybe<Scalars['Boolean']['output']>;
  lastUpdatedDate?: Maybe<Scalars['String']['output']>;
  organizationLogoAllowed?: Maybe<Scalars['Boolean']['output']>;
  organizationLogoSignedUrl?: Maybe<Scalars['String']['output']>;
  organizationName?: Maybe<Scalars['String']['output']>;
  reportType?: Maybe<Scalars['String']['output']>;
  reportWriter?: Maybe<Scalars['String']['output']>;
  sections?: Maybe<Array<Maybe<ExportSectionType>>>;
  signatureSection?: Maybe<ExportSignatureSectionType>;
  signedTemplateUrl?: Maybe<Scalars['String']['output']>;
  templateLogoSignedUrl?: Maybe<Scalars['String']['output']>;
  templateUrl?: Maybe<Scalars['String']['output']>;
  treatmentPlan?: Maybe<ExportTreatmentPlanType>;
};

export enum ReportExportFrameworkEnums {
  Docxtemplater = 'DOCXTEMPLATER',
  GoogleDocs = 'GOOGLE_DOCS',
  Handlebars = 'HANDLEBARS'
}

export type ReportGoalBankType = Node & {
  __typename?: 'ReportGoalBankType';
  assessmentToolSource?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<UserType>;
  createdDate: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  domain?: Maybe<DomainType>;
  folder: GoalBankFolderType;
  fronteragoalbankSet: FronteraGoalBankTypeConnection;
  goalName: Scalars['String']['output'];
  hasMedicalNecessity: Scalars['Boolean']['output'];
  /** The ID of the object */
  id: Scalars['ID']['output'];
  lastUpdatedDate: Scalars['DateTime']['output'];
  longTermGoalBank?: Maybe<LongTermGoalBankType>;
  masteryCriteria?: Maybe<Scalars['String']['output']>;
  medicalNecessityCriteria?: Maybe<Scalars['String']['output']>;
  medicalRationale?: Maybe<Scalars['String']['output']>;
  organization: OrganizationType;
  passagegoalbankSet: PassageGoalBankTypeConnection;
  pk?: Maybe<Scalars['Int']['output']>;
  programGoal?: Maybe<Scalars['String']['output']>;
  reportgoalSet: ReportGoalTypeConnection;
  reporttargetgoalbankSet: ReportTargetGoalBankTypeConnection;
  timelineEstimationType?: Maybe<ApiReportGoalBankTimelineEstimationTypeChoices>;
  timelineEstimationValue?: Maybe<Scalars['Int']['output']>;
  updatedBy?: Maybe<UserType>;
};


export type ReportGoalBankTypeFronteragoalbankSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  aiGenerated?: InputMaybe<Scalars['Boolean']['input']>;
  baseline?: InputMaybe<Scalars['String']['input']>;
  baselineDate?: InputMaybe<Scalars['Date']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdDate?: InputMaybe<Scalars['DateTime']['input']>;
  dateMastered?: InputMaybe<Scalars['Date']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  goal?: InputMaybe<Scalars['ID']['input']>;
  goalBank?: InputMaybe<Scalars['ID']['input']>;
  inUse?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedDate?: InputMaybe<Scalars['DateTime']['input']>;
  masteryCriteria?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  organization?: InputMaybe<Scalars['ID']['input']>;
  tags?: InputMaybe<Scalars['JSONString']['input']>;
};


export type ReportGoalBankTypePassagegoalbankSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  aiGenerated?: InputMaybe<Scalars['Boolean']['input']>;
  antecedentStrategy?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdDate?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  discriminativeStimulus?: InputMaybe<Scalars['String']['input']>;
  errorConsequenceStrategy?: InputMaybe<Scalars['String']['input']>;
  errorCorrectionStrategy?: InputMaybe<Scalars['String']['input']>;
  expectedResponse?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  goal?: InputMaybe<Scalars['ID']['input']>;
  goalBank?: InputMaybe<Scalars['ID']['input']>;
  hypothesizedFunction?: InputMaybe<Scalars['String']['input']>;
  inUse?: InputMaybe<Scalars['Boolean']['input']>;
  labels?: InputMaybe<Scalars['JSONString']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedDate?: InputMaybe<Scalars['DateTime']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  onset?: InputMaybe<Scalars['String']['input']>;
  operationalDefinition?: InputMaybe<Scalars['String']['input']>;
  organization?: InputMaybe<Scalars['ID']['input']>;
  passageOffset?: InputMaybe<Scalars['String']['input']>;
  promptingInstructions?: InputMaybe<Scalars['String']['input']>;
  reinforcementStrategy?: InputMaybe<Scalars['String']['input']>;
  replacementBehavior?: InputMaybe<Scalars['String']['input']>;
  teachingMethod?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<ApiPassageGoalBankTypeChoices>;
};


export type ReportGoalBankTypeReportgoalSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  aiBaselineDataPredictionStatus?: InputMaybe<ApiReportGoalAiBaselineDataPredictionStatusChoices>;
  aiGenerated?: InputMaybe<Scalars['Boolean']['input']>;
  aiGoalAttainmentScalePredictionStatus?: InputMaybe<ApiReportGoalAiGoalAttainmentScalePredictionStatusChoices>;
  aiProgressSummaryPredictionStatus?: InputMaybe<ApiReportGoalAiProgressSummaryPredictionStatusChoices>;
  assessmentToolSource?: InputMaybe<Scalars['String']['input']>;
  baselineData?: InputMaybe<Scalars['String']['input']>;
  baselineDate?: InputMaybe<Scalars['Date']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  chartFromDate?: InputMaybe<Scalars['Date']['input']>;
  chartImageUrl?: InputMaybe<Scalars['String']['input']>;
  chartToDate?: InputMaybe<Scalars['Date']['input']>;
  chartType?: InputMaybe<ApiReportGoalChartTypeChoices>;
  completionDate?: InputMaybe<Scalars['Date']['input']>;
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdDate?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  excludeFromReport?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  gasLevel1?: InputMaybe<Scalars['String']['input']>;
  gasLevel3?: InputMaybe<Scalars['String']['input']>;
  gasLevel4?: InputMaybe<Scalars['String']['input']>;
  gasMatchMessage?: InputMaybe<Scalars['String']['input']>;
  gasMatchStatus?: InputMaybe<ApiReportGoalGasMatchStatusChoices>;
  gasScore?: InputMaybe<Scalars['String']['input']>;
  generalizationCriteria?: InputMaybe<Scalars['String']['input']>;
  goal?: InputMaybe<Scalars['ID']['input']>;
  goalBank?: InputMaybe<Scalars['ID']['input']>;
  goalName?: InputMaybe<Scalars['String']['input']>;
  goalSubType?: InputMaybe<Scalars['String']['input']>;
  goalType?: InputMaybe<Scalars['String']['input']>;
  hasMedicalNecessity?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  inUse?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedDate?: InputMaybe<Scalars['DateTime']['input']>;
  learner?: InputMaybe<Scalars['ID']['input']>;
  masteryCriteria?: InputMaybe<Scalars['String']['input']>;
  medicalNecessityCriteria?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  organization?: InputMaybe<Scalars['ID']['input']>;
  predictionId?: InputMaybe<Scalars['String']['input']>;
  programGoal?: InputMaybe<Scalars['String']['input']>;
  progressSummary?: InputMaybe<Scalars['String']['input']>;
  projectedIntroductionDate?: InputMaybe<Scalars['Date']['input']>;
  rationale?: InputMaybe<Scalars['String']['input']>;
  report?: InputMaybe<Scalars['ID']['input']>;
  reportDomain?: InputMaybe<Scalars['ID']['input']>;
  reportTreatmentPlan?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<ApiReportGoalStatusChoices>;
  suggestionConfidence?: InputMaybe<Scalars['Float']['input']>;
  summaryReviewed?: InputMaybe<Scalars['Boolean']['input']>;
  summaryReviewedOn?: InputMaybe<Scalars['DateTime']['input']>;
  timelineEstimationType?: InputMaybe<ApiReportGoalTimelineEstimationTypeChoices>;
  timelineEstimationValue?: InputMaybe<Scalars['Int']['input']>;
};


export type ReportGoalBankTypeReporttargetgoalbankSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdDate?: InputMaybe<Scalars['DateTime']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  folder?: InputMaybe<Scalars['ID']['input']>;
  goalBank?: InputMaybe<Scalars['ID']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedDate?: InputMaybe<Scalars['DateTime']['input']>;
  longTermGoalBank?: InputMaybe<Scalars['ID']['input']>;
  masteryCriteria?: InputMaybe<Scalars['String']['input']>;
  medicalRationale?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  organization?: InputMaybe<Scalars['ID']['input']>;
  targetDescription?: InputMaybe<Scalars['String']['input']>;
  targetName?: InputMaybe<Scalars['String']['input']>;
  timelineEstimationType?: InputMaybe<ApiReportTargetGoalBankTimelineEstimationTypeChoices>;
  timelineEstimationValue?: InputMaybe<Scalars['Int']['input']>;
  updatedBy?: InputMaybe<Scalars['ID']['input']>;
};

export type ReportGoalBankTypeConnection = {
  __typename?: 'ReportGoalBankTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ReportGoalBankTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `ReportGoalBankType` and its cursor. */
export type ReportGoalBankTypeEdge = {
  __typename?: 'ReportGoalBankTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<ReportGoalBankType>;
};

export type ReportGoalInput = {
  assessmentToolSource?: InputMaybe<Scalars['String']['input']>;
  baselineData?: InputMaybe<Scalars['String']['input']>;
  baselineDate?: InputMaybe<Scalars['Date']['input']>;
  completionDate?: InputMaybe<Scalars['Date']['input']>;
  customFieldValues?: InputMaybe<Array<InputMaybe<CustomFieldValueInput>>>;
  description?: InputMaybe<Scalars['String']['input']>;
  gasLevel1?: InputMaybe<Scalars['String']['input']>;
  gasLevel3?: InputMaybe<Scalars['String']['input']>;
  gasLevel4?: InputMaybe<Scalars['String']['input']>;
  gasScore?: InputMaybe<Scalars['String']['input']>;
  generalizationCriteria?: InputMaybe<Scalars['String']['input']>;
  goalBankId?: InputMaybe<Scalars['ID']['input']>;
  goalName?: InputMaybe<Scalars['String']['input']>;
  goalSubType?: InputMaybe<Scalars['String']['input']>;
  goalType?: InputMaybe<Scalars['String']['input']>;
  hasMedicalNecessity?: InputMaybe<Scalars['Boolean']['input']>;
  masteryCriteria?: InputMaybe<Scalars['String']['input']>;
  medicalNecessityCriteria?: InputMaybe<Scalars['String']['input']>;
  programGoal?: InputMaybe<Scalars['String']['input']>;
  progressSummary?: InputMaybe<Scalars['String']['input']>;
  projectedIntroductionDate?: InputMaybe<Scalars['Date']['input']>;
  rationale?: InputMaybe<Scalars['String']['input']>;
  reportDomainId?: InputMaybe<Scalars['ID']['input']>;
  reportGoalId?: InputMaybe<Scalars['ID']['input']>;
  reportId?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<CatalightGoalStatus>;
  summaryReviewed?: InputMaybe<Scalars['Boolean']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  timelineEstimationType?: InputMaybe<ShortTermTimelineEstimationEnums>;
  timelineEstimationValue?: InputMaybe<Scalars['Int']['input']>;
};

export type ReportGoalType = Node & {
  __typename?: 'ReportGoalType';
  aiBaselineDataPredictionStatus: ApiReportGoalAiBaselineDataPredictionStatusChoices;
  aiGenerated: Scalars['Boolean']['output'];
  aiGoalAttainmentScalePredictionStatus: ApiReportGoalAiGoalAttainmentScalePredictionStatusChoices;
  aiProgressSummaryPredictionStatus: ApiReportGoalAiProgressSummaryPredictionStatusChoices;
  assessmentToolSource?: Maybe<Scalars['String']['output']>;
  baselineData?: Maybe<Scalars['String']['output']>;
  baselineDate?: Maybe<Scalars['Date']['output']>;
  chartFromDate?: Maybe<Scalars['Date']['output']>;
  chartImageUrl?: Maybe<Scalars['String']['output']>;
  chartToDate?: Maybe<Scalars['Date']['output']>;
  chartType?: Maybe<ApiReportGoalChartTypeChoices>;
  completionDate?: Maybe<Scalars['Date']['output']>;
  createdBy?: Maybe<UserType>;
  createdDate: Scalars['DateTime']['output'];
  customFields: TreatmentPlanCustomFieldTypeConnection;
  description?: Maybe<Scalars['String']['output']>;
  excludeFromReport: Scalars['Boolean']['output'];
  gasLevel1?: Maybe<Scalars['String']['output']>;
  gasLevel3?: Maybe<Scalars['String']['output']>;
  gasLevel4?: Maybe<Scalars['String']['output']>;
  gasMatchMessage?: Maybe<Scalars['String']['output']>;
  gasMatchStatus: ApiReportGoalGasMatchStatusChoices;
  gasScore?: Maybe<Scalars['String']['output']>;
  generalizationCriteria?: Maybe<Scalars['String']['output']>;
  goal?: Maybe<GoalType>;
  goalBank?: Maybe<ReportGoalBankType>;
  goalName: Scalars['String']['output'];
  goalSubType?: Maybe<Scalars['String']['output']>;
  goalType?: Maybe<Scalars['String']['output']>;
  goalstatusSet: Array<GoalStatusType>;
  hasMedicalNecessity: Scalars['Boolean']['output'];
  /** The ID of the object */
  id: Scalars['ID']['output'];
  inUse: Scalars['Boolean']['output'];
  lastUpdatedDate: Scalars['DateTime']['output'];
  learner: LearnerType;
  masteryCriteria?: Maybe<Scalars['String']['output']>;
  mediatargetpredictionSet: MediaTargetPredictionTypeConnection;
  medicalNecessityCriteria?: Maybe<Scalars['String']['output']>;
  organization: OrganizationType;
  passageExternalId?: Maybe<Scalars['String']['output']>;
  pk?: Maybe<Scalars['Int']['output']>;
  predictionId?: Maybe<Scalars['String']['output']>;
  programGoal?: Maybe<Scalars['String']['output']>;
  progressSummary?: Maybe<Scalars['String']['output']>;
  projectedIntroductionDate?: Maybe<Scalars['Date']['output']>;
  rationale?: Maybe<Scalars['String']['output']>;
  report?: Maybe<ReportType>;
  reportDomain?: Maybe<ReportDomainType>;
  /** Associated goal for goal-level suggestions */
  reportSuggestions: ReportSuggestionTypeConnection;
  reportTreatmentPlan?: Maybe<ReportTreatmentPlanType>;
  reporttargetSet: ReportTargetTypeConnection;
  signedChartImageUrl?: Maybe<Scalars['String']['output']>;
  status?: Maybe<ApiReportGoalStatusChoices>;
  suggestionConfidence?: Maybe<Scalars['Float']['output']>;
  summaryReviewed: Scalars['Boolean']['output'];
  summaryReviewedOn?: Maybe<Scalars['DateTime']['output']>;
  tags?: Maybe<Scalars['JSONString']['output']>;
  timelineEstimationType?: Maybe<ApiReportGoalTimelineEstimationTypeChoices>;
  timelineEstimationValue?: Maybe<Scalars['Int']['output']>;
};


export type ReportGoalTypeCustomFieldsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  fieldIdentifier?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  reportGoal?: InputMaybe<Scalars['ID']['input']>;
  reportTarget?: InputMaybe<Scalars['ID']['input']>;
};


export type ReportGoalTypeMediatargetpredictionSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdDate?: InputMaybe<Scalars['DateTime']['input']>;
  endTime?: InputMaybe<Scalars['Float']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  goal?: InputMaybe<Scalars['ID']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedDate?: InputMaybe<Scalars['DateTime']['input']>;
  media?: InputMaybe<Scalars['ID']['input']>;
  modalityType?: InputMaybe<ApiMediaTargetPredictionModalityTypeChoices>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  organization?: InputMaybe<Scalars['ID']['input']>;
  predictionId?: InputMaybe<Scalars['String']['input']>;
  rationale?: InputMaybe<Scalars['String']['input']>;
  reportGoalOld?: InputMaybe<Scalars['ID']['input']>;
  reportTargetOld?: InputMaybe<Scalars['ID']['input']>;
  startTime?: InputMaybe<Scalars['Float']['input']>;
  target?: InputMaybe<Scalars['ID']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
};


export type ReportGoalTypeReportSuggestionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  createdDate?: InputMaybe<Scalars['DateTime']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  goalField?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedDate?: InputMaybe<Scalars['DateTime']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  organization?: InputMaybe<Scalars['ID']['input']>;
  predictionId?: InputMaybe<Scalars['String']['input']>;
  report?: InputMaybe<Scalars['ID']['input']>;
  reportGoal?: InputMaybe<Scalars['ID']['input']>;
  reportSectionField?: InputMaybe<Scalars['ID']['input']>;
  reportTarget?: InputMaybe<Scalars['ID']['input']>;
  resolvedAt?: InputMaybe<Scalars['DateTime']['input']>;
  resolvedBy?: InputMaybe<Scalars['ID']['input']>;
  targetField?: InputMaybe<Scalars['String']['input']>;
};


export type ReportGoalTypeReporttargetSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  aiGenerated?: InputMaybe<Scalars['Boolean']['input']>;
  aiProgressSummaryPredictionStatus?: InputMaybe<ApiReportTargetAiProgressSummaryPredictionStatusChoices>;
  baselineData?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  chartFromDate?: InputMaybe<Scalars['Date']['input']>;
  chartImageUrl?: InputMaybe<Scalars['String']['input']>;
  chartToDate?: InputMaybe<Scalars['Date']['input']>;
  chartType?: InputMaybe<ApiReportTargetChartTypeChoices>;
  completionDate?: InputMaybe<Scalars['Date']['input']>;
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdDate?: InputMaybe<Scalars['DateTime']['input']>;
  excludeFromReport?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  inUse?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedDate?: InputMaybe<Scalars['DateTime']['input']>;
  learner?: InputMaybe<Scalars['ID']['input']>;
  masteryCriteria?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  organization?: InputMaybe<Scalars['ID']['input']>;
  predictionId?: InputMaybe<Scalars['String']['input']>;
  priorityOrder?: InputMaybe<Scalars['Int']['input']>;
  progressSummary?: InputMaybe<Scalars['String']['input']>;
  progressType?: InputMaybe<ApiReportTargetProgressTypeChoices>;
  projectedIntroductionDate?: InputMaybe<Scalars['Date']['input']>;
  report?: InputMaybe<Scalars['ID']['input']>;
  reportDomain?: InputMaybe<Scalars['ID']['input']>;
  reportGoal?: InputMaybe<Scalars['ID']['input']>;
  reportTreatmentPlan?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<ApiReportTargetStatusChoices>;
  summaryReviewed?: InputMaybe<Scalars['Boolean']['input']>;
  summaryReviewedOn?: InputMaybe<Scalars['DateTime']['input']>;
  target?: InputMaybe<Scalars['ID']['input']>;
  targetDescription?: InputMaybe<Scalars['String']['input']>;
  targetName?: InputMaybe<Scalars['String']['input']>;
  timelineEstimationType?: InputMaybe<ApiReportTargetTimelineEstimationTypeChoices>;
  timelineEstimationValue?: InputMaybe<Scalars['Int']['input']>;
};

export type ReportGoalTypeConnection = {
  __typename?: 'ReportGoalTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ReportGoalTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
  totalNeedReview?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `ReportGoalType` and its cursor. */
export type ReportGoalTypeEdge = {
  __typename?: 'ReportGoalTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<ReportGoalType>;
};

export enum ReportPageLocationEnums {
  Appendix = 'APPENDIX',
  Conclusions = 'CONCLUSIONS',
  Recommendations = 'RECOMMENDATIONS',
  ReportPart_1 = 'REPORT_PART_1',
  ReportPart_2 = 'REPORT_PART_2',
  TreatmentPlan = 'TREATMENT_PLAN'
}

export type ReportPayorMetadataType = Node & {
  __typename?: 'ReportPayorMetadataType';
  comments?: Maybe<Scalars['String']['output']>;
  createdDate: Scalars['DateTime']['output'];
  firstTreatmentOfferedDate?: Maybe<Scalars['Date']['output']>;
  groupCare?: Maybe<Scalars['Float']['output']>;
  highLevelHours?: Maybe<Scalars['Float']['output']>;
  /** The ID of the object */
  id: Scalars['ID']['output'];
  lastUpdatedDate: Scalars['DateTime']['output'];
  midLevelHours?: Maybe<Scalars['Float']['output']>;
  paraprofessionalHours?: Maybe<Scalars['Float']['output']>;
  treatmentOffered?: Maybe<Scalars['Boolean']['output']>;
};

export type ReportPdfStatusType = {
  __typename?: 'ReportPdfStatusType';
  learnerGlobalId?: Maybe<Scalars['ID']['output']>;
  reportGlobalId?: Maybe<Scalars['ID']['output']>;
  reportPdfFile?: Maybe<Scalars['String']['output']>;
  reportType?: Maybe<Scalars['String']['output']>;
};

export type ReportReviewCountsType = {
  __typename?: 'ReportReviewCountsType';
  inReview: Scalars['Int']['output'];
  reviewedByMe: Scalars['Int']['output'];
  sentBackToMe: Scalars['Int']['output'];
  waitingOnMe: Scalars['Int']['output'];
};

/**
 * The one filter dimension needed today. New filters (status, hidden,
 * ...) are added as more optional fields here, not new top-level query
 * arguments -- keeps getReportReviewItems's own signature stable.
 */
export type ReportReviewItemFilterInput = {
  source?: InputMaybe<ReportSuggestionSourceEnum>;
};

/**
 * Shared shape for a QA-generated Suggestion or a reviewer-authored
 * Comment -- same underlying row, discriminated by `source`.
 */
export type ReportReviewItemInterface = {
  content?: Maybe<Scalars['String']['output']>;
  createdDate: Scalars['DateTime']['output'];
  goalField?: Maybe<Scalars['String']['output']>;
  hidden: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  parent?: Maybe<ReportReviewItemParent>;
  report: ReportType;
  reportGoal?: Maybe<ReportGoalType>;
  reportSectionField?: Maybe<ReportSectionFieldsType>;
  reportTarget?: Maybe<ReportTargetType>;
  resolvedAt?: Maybe<Scalars['DateTime']['output']>;
  resolvedBy?: Maybe<ReportReviewUserType>;
  source: Scalars['String']['output'];
  status: Scalars['String']['output'];
  targetField?: Maybe<Scalars['String']['output']>;
};

export type ReportReviewItemParent = ReportCommentType | ReportSuggestionType;

/**
 * Name and email of a review item's author or resolver, taken from the
 * provider profile of the item's own organization. The field is null when
 * the user has no profile in that organization.
 */
export type ReportReviewUserType = {
  __typename?: 'ReportReviewUserType';
  email?: Maybe<Scalars['String']['output']>;
  firstName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
};

export enum ReportReviewView {
  InReview = 'IN_REVIEW',
  ReviewedByMe = 'REVIEWED_BY_ME',
  SentBackToMe = 'SENT_BACK_TO_ME',
  WaitingOnMe = 'WAITING_ON_ME'
}

export enum ReportReviewerKind {
  FinalApprover = 'FINAL_APPROVER',
  Reviewer = 'REVIEWER'
}

export enum ReportReviewerStatus {
  Approved = 'APPROVED',
  ChangesRequested = 'CHANGES_REQUESTED',
  Requested = 'REQUESTED',
  Withdrawn = 'WITHDRAWN'
}

export type ReportReviewerStatusLogType = Node & {
  __typename?: 'ReportReviewerStatusLogType';
  actor?: Maybe<ReportReviewUserType>;
  createdDate: Scalars['DateTime']['output'];
  /** The ID of the object */
  id: Scalars['ID']['output'];
  note: Scalars['String']['output'];
  reportReviewer: ReportReviewerType;
  status: ReportReviewerStatus;
};

export type ReportReviewerType = Node & {
  __typename?: 'ReportReviewerType';
  createdDate: Scalars['DateTime']['output'];
  /** The ID of the object */
  id: Scalars['ID']['output'];
  reviewer?: Maybe<ReportReviewUserType>;
  status?: Maybe<ReportReviewerStatus>;
  statusLog: Array<ReportReviewerStatusLogType>;
  type: ReportReviewerKind;
};

export enum ReportSectionAiPredictionStatusEnums {
  Failure = 'FAILURE',
  ManualEntry = 'MANUAL_ENTRY',
  Pending = 'PENDING',
  SectionPredictionPending = 'SECTION_PREDICTION_PENDING',
  SectionPredictionPredicted = 'SECTION_PREDICTION_PREDICTED'
}

export type ReportSectionAiFieldsType = Node & {
  __typename?: 'ReportSectionAiFieldsType';
  aiSources?: Maybe<Scalars['String']['output']>;
  content?: Maybe<Scalars['String']['output']>;
  createdDate: Scalars['DateTime']['output'];
  fieldIdentifier?: Maybe<Scalars['String']['output']>;
  fieldType: ApiReportSectionAiFieldsFieldTypeChoices;
  /** The ID of the object */
  id: Scalars['ID']['output'];
  lastUpdatedDate: Scalars['DateTime']['output'];
  organization: OrganizationType;
  pk?: Maybe<Scalars['Int']['output']>;
  rankOrder: Scalars['Int']['output'];
  report: ReportType;
  reportSection: ReportSectionsType;
  reportsectionfieldsSet: ReportSectionFieldsTypeConnection;
  templateSectionField?: Maybe<ReportTemplateSectionFieldType>;
  title: Scalars['String']['output'];
};


export type ReportSectionAiFieldsTypeReportsectionfieldsSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  aiGenerated?: InputMaybe<Scalars['Boolean']['input']>;
  aiSectionField?: InputMaybe<Scalars['ID']['input']>;
  aiSources?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  createdDate?: InputMaybe<Scalars['DateTime']['input']>;
  fieldIdentifier?: InputMaybe<Scalars['String']['input']>;
  fieldType?: InputMaybe<ApiReportSectionFieldsFieldTypeChoices>;
  first?: InputMaybe<Scalars['Int']['input']>;
  isAuditable?: InputMaybe<Scalars['Boolean']['input']>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isRequired?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedDate?: InputMaybe<Scalars['DateTime']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  organization?: InputMaybe<Scalars['ID']['input']>;
  rankOrder?: InputMaybe<Scalars['Int']['input']>;
  report?: InputMaybe<Scalars['ID']['input']>;
  reportSection?: InputMaybe<Scalars['ID']['input']>;
  templateSectionField?: InputMaybe<Scalars['ID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ReportSectionAiFieldsTypeConnection = {
  __typename?: 'ReportSectionAiFieldsTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ReportSectionAiFieldsTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `ReportSectionAiFieldsType` and its cursor. */
export type ReportSectionAiFieldsTypeEdge = {
  __typename?: 'ReportSectionAiFieldsTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<ReportSectionAiFieldsType>;
};

export type ReportSectionFieldInput = {
  content?: InputMaybe<Scalars['String']['input']>;
  fieldType: ReportSectionFieldTypeEnums;
  rankOrder: Scalars['Int']['input'];
  replacePlaceholders?: InputMaybe<Scalars['Boolean']['input']>;
  title: Scalars['String']['input'];
};

export type ReportSectionFieldOrderInput = {
  fieldId: Scalars['ID']['input'];
  rankOrder: Scalars['Int']['input'];
};

export enum ReportSectionFieldTypeEnums {
  AssessmentAppointments = 'ASSESSMENT_APPOINTMENTS',
  AssessmentImage = 'ASSESSMENT_IMAGE',
  BlankSignatureLine = 'BLANK_SIGNATURE_LINE',
  Checkbox = 'CHECKBOX',
  CoordinationOfCare = 'COORDINATION_OF_CARE',
  Date = 'DATE',
  Datetime = 'DATETIME',
  DsmTable = 'DSM_TABLE',
  Image = 'IMAGE',
  Radio = 'RADIO',
  Select = 'SELECT',
  SimpleText = 'SIMPLE_TEXT',
  SpecifiersTable = 'SPECIFIERS_TABLE',
  Table = 'TABLE',
  TreatmentOptionTable = 'TREATMENT_OPTION_TABLE',
  TreatmentPlan = 'TREATMENT_PLAN',
  TypedSignature = 'TYPED_SIGNATURE',
  WetSignature = 'WET_SIGNATURE',
  Wysiwyg = 'WYSIWYG'
}

export type ReportSectionFieldsType = Node & {
  __typename?: 'ReportSectionFieldsType';
  aiGenerated: Scalars['Boolean']['output'];
  aiSectionField?: Maybe<ReportSectionAiFieldsType>;
  aiSources?: Maybe<Scalars['String']['output']>;
  content?: Maybe<Scalars['String']['output']>;
  createdDate: Scalars['DateTime']['output'];
  fieldIdentifier: Scalars['String']['output'];
  fieldType: ApiReportSectionFieldsFieldTypeChoices;
  /** The ID of the object */
  id: Scalars['ID']['output'];
  imageContentBase64?: Maybe<Scalars['String']['output']>;
  imageSignedUrl?: Maybe<Scalars['String']['output']>;
  isAuditable: Scalars['Boolean']['output'];
  isEnabled: Scalars['Boolean']['output'];
  isRequired: Scalars['Boolean']['output'];
  lastUpdatedDate: Scalars['DateTime']['output'];
  organization: OrganizationType;
  pk?: Maybe<Scalars['Int']['output']>;
  rankOrder: Scalars['Int']['output'];
  report: ReportType;
  reportSection: ReportSectionsType;
  /** Associated report section field for field-level suggestions */
  reportSuggestions: ReportSuggestionTypeConnection;
  templateSectionField?: Maybe<ReportTemplateSectionFieldType>;
  title?: Maybe<Scalars['String']['output']>;
};


export type ReportSectionFieldsTypeReportSuggestionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  createdDate?: InputMaybe<Scalars['DateTime']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  goalField?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedDate?: InputMaybe<Scalars['DateTime']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  organization?: InputMaybe<Scalars['ID']['input']>;
  predictionId?: InputMaybe<Scalars['String']['input']>;
  report?: InputMaybe<Scalars['ID']['input']>;
  reportGoal?: InputMaybe<Scalars['ID']['input']>;
  reportSectionField?: InputMaybe<Scalars['ID']['input']>;
  reportTarget?: InputMaybe<Scalars['ID']['input']>;
  resolvedAt?: InputMaybe<Scalars['DateTime']['input']>;
  resolvedBy?: InputMaybe<Scalars['ID']['input']>;
  targetField?: InputMaybe<Scalars['String']['input']>;
};

export type ReportSectionFieldsTypeConnection = {
  __typename?: 'ReportSectionFieldsTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ReportSectionFieldsTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `ReportSectionFieldsType` and its cursor. */
export type ReportSectionFieldsTypeEdge = {
  __typename?: 'ReportSectionFieldsTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<ReportSectionFieldsType>;
};

export type ReportSectionInput = {
  aiGeneratedStatus?: InputMaybe<ReportSectionAiPredictionStatusEnums>;
  pageLocation: Scalars['String']['input'];
  rankOrder: Scalars['Int']['input'];
  title: Scalars['String']['input'];
};

export type ReportSectionOrderInput = {
  rankOrder: Scalars['Int']['input'];
  sectionId: Scalars['ID']['input'];
};

export type ReportSectionsType = Node & {
  __typename?: 'ReportSectionsType';
  aiGeneratedStatus: ApiReportSectionsAiGeneratedStatusChoices;
  aiPredictionOwnerRunId?: Maybe<Scalars['String']['output']>;
  aiPredictionOwnerStartedAt?: Maybe<Scalars['DateTime']['output']>;
  createdDate: Scalars['DateTime']['output'];
  /** The ID of the object */
  id: Scalars['ID']['output'];
  lastUpdatedDate: Scalars['DateTime']['output'];
  organization: OrganizationType;
  pageLocation: Scalars['String']['output'];
  pk?: Maybe<Scalars['Int']['output']>;
  previousPageLocation?: Maybe<Scalars['String']['output']>;
  rankOrder: Scalars['Int']['output'];
  report: ReportType;
  sectionAiField: ReportSectionAiFieldsTypeConnection;
  sectionField: ReportSectionFieldsTypeConnection;
  sectionIdentifier?: Maybe<Scalars['String']['output']>;
  templateSection?: Maybe<ReportTemplateSectionType>;
  title: Scalars['String']['output'];
};


export type ReportSectionsTypeSectionAiFieldArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  aiSources?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  createdDate?: InputMaybe<Scalars['DateTime']['input']>;
  fieldIdentifier?: InputMaybe<Scalars['String']['input']>;
  fieldType?: InputMaybe<ApiReportSectionAiFieldsFieldTypeChoices>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedDate?: InputMaybe<Scalars['DateTime']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  organization?: InputMaybe<Scalars['ID']['input']>;
  rankOrder?: InputMaybe<Scalars['Int']['input']>;
  report?: InputMaybe<Scalars['ID']['input']>;
  reportSection?: InputMaybe<Scalars['ID']['input']>;
  templateSectionField?: InputMaybe<Scalars['ID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};


export type ReportSectionsTypeSectionFieldArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  aiGenerated?: InputMaybe<Scalars['Boolean']['input']>;
  aiSectionField?: InputMaybe<Scalars['ID']['input']>;
  aiSources?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  createdDate?: InputMaybe<Scalars['DateTime']['input']>;
  fieldIdentifier?: InputMaybe<Scalars['String']['input']>;
  fieldType?: InputMaybe<ApiReportSectionFieldsFieldTypeChoices>;
  first?: InputMaybe<Scalars['Int']['input']>;
  isAuditable?: InputMaybe<Scalars['Boolean']['input']>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isRequired?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedDate?: InputMaybe<Scalars['DateTime']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  organization?: InputMaybe<Scalars['ID']['input']>;
  rankOrder?: InputMaybe<Scalars['Int']['input']>;
  report?: InputMaybe<Scalars['ID']['input']>;
  reportSection?: InputMaybe<Scalars['ID']['input']>;
  templateSectionField?: InputMaybe<Scalars['ID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ReportSectionsTypeConnection = {
  __typename?: 'ReportSectionsTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ReportSectionsTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `ReportSectionsType` and its cursor. */
export type ReportSectionsTypeEdge = {
  __typename?: 'ReportSectionsTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<ReportSectionsType>;
};

export type ReportSignatureSectionDetailInput = {
  closingRemark?: InputMaybe<Scalars['String']['input']>;
  licenseNumber?: InputMaybe<Scalars['String']['input']>;
  practitionerEmail?: InputMaybe<Scalars['String']['input']>;
  professionalTitle?: InputMaybe<Scalars['String']['input']>;
  reportId: Scalars['ID']['input'];
  signedAt: Scalars['DateTime']['input'];
  signedBy: Scalars['String']['input'];
};

export type ReportSignatureSectionDetailType = Node & {
  __typename?: 'ReportSignatureSectionDetailType';
  closingRemark?: Maybe<Scalars['String']['output']>;
  createdDate: Scalars['DateTime']['output'];
  /** The ID of the object */
  id: Scalars['ID']['output'];
  lastUpdatedDate: Scalars['DateTime']['output'];
  licenseNumber?: Maybe<Scalars['String']['output']>;
  organization: OrganizationType;
  pk?: Maybe<Scalars['Int']['output']>;
  practitionerEmail?: Maybe<Scalars['String']['output']>;
  professionalTitle?: Maybe<Scalars['String']['output']>;
  report: ReportType;
  signedAt: Scalars['DateTime']['output'];
  signedBy: Scalars['String']['output'];
};

export enum ReportStatusEnums {
  AwaitingGoalSelection = 'AWAITING_GOAL_SELECTION',
  Completed = 'COMPLETED',
  Draft = 'DRAFT',
  Failure = 'FAILURE',
  Generating = 'GENERATING'
}

export enum ReportStatusExtendedEnums {
  AwaitingGoalSelection = 'AWAITING_GOAL_SELECTION',
  Completed = 'COMPLETED',
  Draft = 'DRAFT',
  Failure = 'FAILURE',
  Generating = 'GENERATING',
  ImportingClientData = 'IMPORTING_CLIENT_DATA',
  ImportFailed = 'IMPORT_FAILED'
}

export enum ReportSuggestionGenerationStatusEnum {
  Completed = 'COMPLETED',
  Failure = 'FAILURE',
  InProgress = 'IN_PROGRESS'
}

/** Input type for creating ReportSuggestion objects */
export type ReportSuggestionInput = {
  /** Category of the suggestion */
  category: Scalars['String']['input'];
  /** Suggestion content */
  content: Scalars['String']['input'];
  /** Field name associated with the goal */
  goalField?: InputMaybe<Scalars['String']['input']>;
  /** Global ID of the report goal */
  reportGoalId?: InputMaybe<Scalars['ID']['input']>;
  /** Global ID of the report section field */
  reportSectionFieldId?: InputMaybe<Scalars['ID']['input']>;
  /** Global ID of the report target */
  reportTargetId?: InputMaybe<Scalars['ID']['input']>;
  /** Field name associated with the target */
  targetField?: InputMaybe<Scalars['String']['input']>;
};

export enum ReportSuggestionSourceEnum {
  PeerReview = 'PEER_REVIEW',
  QaScan = 'QA_SCAN'
}

export type ReportSuggestionType = Node & ReportReviewItemInterface & {
  __typename?: 'ReportSuggestionType';
  /** The reviewer who wrote this comment. PROTECT because attribution is part of the datum, same rationale as EvalReviewScore.reviewer. */
  author?: Maybe<UserType>;
  /** Snapshot of the anchor's content when a Proposed Edit was created. */
  baseValue?: Maybe<Scalars['String']['output']>;
  /** Category of the report suggestion */
  category: Scalars['String']['output'];
  content?: Maybe<Scalars['String']['output']>;
  createdDate: Scalars['DateTime']['output'];
  goalField?: Maybe<Scalars['String']['output']>;
  hidden: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  /** Whether the suggestion is shown (from the most recent generation) */
  isActive: Scalars['Boolean']['output'];
  isResolved?: Maybe<Scalars['Boolean']['output']>;
  lastUpdatedDate: Scalars['DateTime']['output'];
  organization: OrganizationType;
  parent?: Maybe<ReportReviewItemParent>;
  pk?: Maybe<Scalars['Int']['output']>;
  /** For pointing back to vellum workflow */
  predictionId?: Maybe<Scalars['String']['output']>;
  /** The reviewer's suggested replacement content. */
  proposedValue?: Maybe<Scalars['String']['output']>;
  /** A reply's target -- either a QA suggestion or another comment. */
  replies: ReportSuggestionTypeConnection;
  report: ReportType;
  reportGoal?: Maybe<ReportGoalType>;
  reportSectionField?: Maybe<ReportSectionFieldsType>;
  reportTarget?: Maybe<ReportTargetType>;
  resolvedAt?: Maybe<Scalars['DateTime']['output']>;
  resolvedBy?: Maybe<ReportReviewUserType>;
  source: Scalars['String']['output'];
  status: Scalars['String']['output'];
  targetField?: Maybe<Scalars['String']['output']>;
};


export type ReportSuggestionTypeRepliesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  createdDate?: InputMaybe<Scalars['DateTime']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  goalField?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedDate?: InputMaybe<Scalars['DateTime']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  organization?: InputMaybe<Scalars['ID']['input']>;
  predictionId?: InputMaybe<Scalars['String']['input']>;
  report?: InputMaybe<Scalars['ID']['input']>;
  reportGoal?: InputMaybe<Scalars['ID']['input']>;
  reportSectionField?: InputMaybe<Scalars['ID']['input']>;
  reportTarget?: InputMaybe<Scalars['ID']['input']>;
  resolvedAt?: InputMaybe<Scalars['DateTime']['input']>;
  resolvedBy?: InputMaybe<Scalars['ID']['input']>;
  targetField?: InputMaybe<Scalars['String']['input']>;
};

export type ReportSuggestionTypeConnection = {
  __typename?: 'ReportSuggestionTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ReportSuggestionTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalActive?: Maybe<Scalars['Int']['output']>;
  totalCount?: Maybe<Scalars['Int']['output']>;
  totalResolved?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `ReportSuggestionType` and its cursor. */
export type ReportSuggestionTypeEdge = {
  __typename?: 'ReportSuggestionTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<ReportSuggestionType>;
};

export type ReportSuggestionWorkflowDataType = {
  __typename?: 'ReportSuggestionWorkflowDataType';
  age?: Maybe<Scalars['String']['output']>;
  criteria?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  gender?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  reportType?: Maybe<Scalars['String']['output']>;
  sections?: Maybe<Array<Maybe<SuggestionWorkflowSectionType>>>;
  treatmentPlan?: Maybe<ExportTreatmentPlanType>;
};

export type ReportTargetGoalBankType = Node & {
  __typename?: 'ReportTargetGoalBankType';
  createdBy?: Maybe<UserType>;
  createdDate: Scalars['DateTime']['output'];
  folder: GoalBankFolderType;
  fronteratargetbankSet: FronteraTargetBankTypeConnection;
  goalBank?: Maybe<ReportGoalBankType>;
  /** The ID of the object */
  id: Scalars['ID']['output'];
  lastUpdatedDate: Scalars['DateTime']['output'];
  longTermGoalBank?: Maybe<LongTermGoalBankType>;
  masteryCriteria?: Maybe<Scalars['String']['output']>;
  medicalRationale?: Maybe<Scalars['String']['output']>;
  organization: OrganizationType;
  passagetargetbankSet: PassageTargetBankTypeConnection;
  pk?: Maybe<Scalars['Int']['output']>;
  targetDescription?: Maybe<Scalars['String']['output']>;
  targetName: Scalars['String']['output'];
  timelineEstimationType?: Maybe<ApiReportTargetGoalBankTimelineEstimationTypeChoices>;
  timelineEstimationValue?: Maybe<Scalars['Int']['output']>;
  updatedBy?: Maybe<UserType>;
};


export type ReportTargetGoalBankTypeFronteratargetbankSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  aiGenerated?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdDate?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  inUse?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedDate?: InputMaybe<Scalars['DateTime']['input']>;
  masteryCriteria?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  organization?: InputMaybe<Scalars['ID']['input']>;
  target?: InputMaybe<Scalars['ID']['input']>;
  targetBank?: InputMaybe<Scalars['ID']['input']>;
  type?: InputMaybe<ApiFronteraTargetBankTypeChoices>;
};


export type ReportTargetGoalBankTypePassagetargetbankSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  aiGenerated?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdDate?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  discriminativeStimulus?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  inUse?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedDate?: InputMaybe<Scalars['DateTime']['input']>;
  masteredOverType?: InputMaybe<Scalars['String']['input']>;
  masteredOverValue?: InputMaybe<Scalars['Int']['input']>;
  measureType?: InputMaybe<Scalars['String']['input']>;
  measureValue?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  organization?: InputMaybe<Scalars['ID']['input']>;
  target?: InputMaybe<Scalars['ID']['input']>;
  targetBank?: InputMaybe<Scalars['ID']['input']>;
  threshold?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<ApiPassageTargetBankTypeChoices>;
};

export type ReportTargetGoalBankTypeConnection = {
  __typename?: 'ReportTargetGoalBankTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ReportTargetGoalBankTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `ReportTargetGoalBankType` and its cursor. */
export type ReportTargetGoalBankTypeEdge = {
  __typename?: 'ReportTargetGoalBankTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<ReportTargetGoalBankType>;
};

export type ReportTargetInput = {
  baselineData?: InputMaybe<Scalars['String']['input']>;
  completionDate?: InputMaybe<Scalars['Date']['input']>;
  customFieldValues?: InputMaybe<Array<InputMaybe<CustomFieldValueInput>>>;
  masteryCriteria?: InputMaybe<Scalars['String']['input']>;
  progressSummary?: InputMaybe<Scalars['String']['input']>;
  projectedIntroductionDate?: InputMaybe<Scalars['Date']['input']>;
  reportGoalId: Scalars['ID']['input'];
  reportId?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<CatalightGoalStatus>;
  targetDescription?: InputMaybe<Scalars['String']['input']>;
  targetId?: InputMaybe<Scalars['ID']['input']>;
  targetName?: InputMaybe<Scalars['String']['input']>;
  timelineEstimationType?: InputMaybe<TargetTimelineEstimationEnums>;
  timelineEstimationValue?: InputMaybe<Scalars['Int']['input']>;
};

export type ReportTargetType = Node & {
  __typename?: 'ReportTargetType';
  aiGenerated: Scalars['Boolean']['output'];
  aiProgressSummaryPredictionStatus: ApiReportTargetAiProgressSummaryPredictionStatusChoices;
  baselineData?: Maybe<Scalars['String']['output']>;
  chartFromDate?: Maybe<Scalars['Date']['output']>;
  chartImageUrl?: Maybe<Scalars['String']['output']>;
  chartToDate?: Maybe<Scalars['Date']['output']>;
  chartType?: Maybe<ApiReportTargetChartTypeChoices>;
  completionDate?: Maybe<Scalars['Date']['output']>;
  createdBy?: Maybe<UserType>;
  createdDate: Scalars['DateTime']['output'];
  customFields: TreatmentPlanCustomFieldTypeConnection;
  excludeFromReport: Scalars['Boolean']['output'];
  /** The ID of the object */
  id: Scalars['ID']['output'];
  inUse: Scalars['Boolean']['output'];
  lastUpdatedDate: Scalars['DateTime']['output'];
  learner: LearnerType;
  masteryCriteria?: Maybe<Scalars['String']['output']>;
  mediatargetpredictionSet: MediaTargetPredictionTypeConnection;
  organization: OrganizationType;
  passageExternalId?: Maybe<Scalars['String']['output']>;
  pk?: Maybe<Scalars['Int']['output']>;
  predictionId?: Maybe<Scalars['String']['output']>;
  priorityOrder: Scalars['Int']['output'];
  progressSummary?: Maybe<Scalars['String']['output']>;
  progressType?: Maybe<ApiReportTargetProgressTypeChoices>;
  projectedIntroductionDate?: Maybe<Scalars['Date']['output']>;
  report?: Maybe<ReportType>;
  reportDomain?: Maybe<ReportDomainType>;
  reportGoal: ReportGoalType;
  /** Associated target for target-level suggestions */
  reportSuggestions: ReportSuggestionTypeConnection;
  reportTreatmentPlan?: Maybe<ReportTreatmentPlanType>;
  /** The latest session target progress record for this target */
  sessionTargetProgressType?: Maybe<ProgressType>;
  signedChartImageUrl?: Maybe<Scalars['String']['output']>;
  status?: Maybe<ApiReportTargetStatusChoices>;
  summaryReviewed: Scalars['Boolean']['output'];
  summaryReviewedOn?: Maybe<Scalars['DateTime']['output']>;
  target?: Maybe<TargetType>;
  targetDescription?: Maybe<Scalars['String']['output']>;
  targetName: Scalars['String']['output'];
  targetstatusSet: Array<TargetStatusType>;
  timelineEstimationType?: Maybe<ApiReportTargetTimelineEstimationTypeChoices>;
  timelineEstimationValue?: Maybe<Scalars['Int']['output']>;
};


export type ReportTargetTypeCustomFieldsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  fieldIdentifier?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  reportGoal?: InputMaybe<Scalars['ID']['input']>;
  reportTarget?: InputMaybe<Scalars['ID']['input']>;
};


export type ReportTargetTypeMediatargetpredictionSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdDate?: InputMaybe<Scalars['DateTime']['input']>;
  endTime?: InputMaybe<Scalars['Float']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  goal?: InputMaybe<Scalars['ID']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedDate?: InputMaybe<Scalars['DateTime']['input']>;
  media?: InputMaybe<Scalars['ID']['input']>;
  modalityType?: InputMaybe<ApiMediaTargetPredictionModalityTypeChoices>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  organization?: InputMaybe<Scalars['ID']['input']>;
  predictionId?: InputMaybe<Scalars['String']['input']>;
  rationale?: InputMaybe<Scalars['String']['input']>;
  reportGoalOld?: InputMaybe<Scalars['ID']['input']>;
  reportTargetOld?: InputMaybe<Scalars['ID']['input']>;
  startTime?: InputMaybe<Scalars['Float']['input']>;
  target?: InputMaybe<Scalars['ID']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
};


export type ReportTargetTypeReportSuggestionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  createdDate?: InputMaybe<Scalars['DateTime']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  goalField?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedDate?: InputMaybe<Scalars['DateTime']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  organization?: InputMaybe<Scalars['ID']['input']>;
  predictionId?: InputMaybe<Scalars['String']['input']>;
  report?: InputMaybe<Scalars['ID']['input']>;
  reportGoal?: InputMaybe<Scalars['ID']['input']>;
  reportSectionField?: InputMaybe<Scalars['ID']['input']>;
  reportTarget?: InputMaybe<Scalars['ID']['input']>;
  resolvedAt?: InputMaybe<Scalars['DateTime']['input']>;
  resolvedBy?: InputMaybe<Scalars['ID']['input']>;
  targetField?: InputMaybe<Scalars['String']['input']>;
};

export type ReportTargetTypeConnection = {
  __typename?: 'ReportTargetTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ReportTargetTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `ReportTargetType` and its cursor. */
export type ReportTargetTypeEdge = {
  __typename?: 'ReportTargetTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<ReportTargetType>;
};

export enum ReportTemplateExportFontEnums {
  Arial = 'ARIAL',
  Calibri = 'CALIBRI',
  CenturyGothic = 'CENTURY_GOTHIC',
  Georgia = 'GEORGIA',
  PublicSans = 'PUBLIC_SANS',
  TimesNewRoman = 'TIMES_NEW_ROMAN'
}

export enum ReportTemplateFileUploadConfig {
  AbcKuwait = 'ABC_KUWAIT',
  Catalight = 'CATALIGHT',
  Default = 'DEFAULT'
}

export type ReportTemplateJsonType = {
  __typename?: 'ReportTemplateJSONType';
  json: Scalars['JSONString']['output'];
};

export enum ReportTemplateSampleStatusEnums {
  Completed = 'COMPLETED',
  Failure = 'FAILURE',
  Generating = 'GENERATING',
  Pending = 'PENDING'
}

export type ReportTemplateSectionFieldInput = {
  content?: InputMaybe<Scalars['String']['input']>;
  fieldType?: InputMaybe<ReportSectionFieldTypeEnums>;
  id: Scalars['ID']['input'];
  isAuditable?: InputMaybe<Scalars['Boolean']['input']>;
  isRequired?: InputMaybe<Scalars['Boolean']['input']>;
  rankOrder?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ReportTemplateSectionFieldType = Node & {
  __typename?: 'ReportTemplateSectionFieldType';
  aiReportSectionFields: ReportSectionAiFieldsTypeConnection;
  content?: Maybe<Scalars['String']['output']>;
  createdDate: Scalars['DateTime']['output'];
  fieldIdentifier: Scalars['String']['output'];
  fieldType: ApiReportTemplateSectionFieldFieldTypeChoices;
  /** The ID of the object */
  id: Scalars['ID']['output'];
  inputDependency?: Maybe<Array<Maybe<InputDependencyChoices>>>;
  isAuditable: Scalars['Boolean']['output'];
  isDefault: Scalars['Boolean']['output'];
  isEditable: Scalars['Boolean']['output'];
  isEnabled: Scalars['Boolean']['output'];
  isRequired: Scalars['Boolean']['output'];
  lastUpdatedDate: Scalars['DateTime']['output'];
  pk?: Maybe<Scalars['Int']['output']>;
  prompt?: Maybe<PromptType>;
  rankOrder: Scalars['Int']['output'];
  reportSection: ReportTemplateSectionType;
  reportSectionFields: ReportSectionFieldsTypeConnection;
  sampleData?: Maybe<Scalars['String']['output']>;
  tableKey?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<UserType>;
  updatedByDisplay?: Maybe<Scalars['String']['output']>;
};


export type ReportTemplateSectionFieldTypeAiReportSectionFieldsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  aiSources?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  createdDate?: InputMaybe<Scalars['DateTime']['input']>;
  fieldIdentifier?: InputMaybe<Scalars['String']['input']>;
  fieldType?: InputMaybe<ApiReportSectionAiFieldsFieldTypeChoices>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedDate?: InputMaybe<Scalars['DateTime']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  organization?: InputMaybe<Scalars['ID']['input']>;
  rankOrder?: InputMaybe<Scalars['Int']['input']>;
  report?: InputMaybe<Scalars['ID']['input']>;
  reportSection?: InputMaybe<Scalars['ID']['input']>;
  templateSectionField?: InputMaybe<Scalars['ID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};


export type ReportTemplateSectionFieldTypeReportSectionFieldsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  aiGenerated?: InputMaybe<Scalars['Boolean']['input']>;
  aiSectionField?: InputMaybe<Scalars['ID']['input']>;
  aiSources?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  createdDate?: InputMaybe<Scalars['DateTime']['input']>;
  fieldIdentifier?: InputMaybe<Scalars['String']['input']>;
  fieldType?: InputMaybe<ApiReportSectionFieldsFieldTypeChoices>;
  first?: InputMaybe<Scalars['Int']['input']>;
  isAuditable?: InputMaybe<Scalars['Boolean']['input']>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isRequired?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedDate?: InputMaybe<Scalars['DateTime']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  organization?: InputMaybe<Scalars['ID']['input']>;
  rankOrder?: InputMaybe<Scalars['Int']['input']>;
  report?: InputMaybe<Scalars['ID']['input']>;
  reportSection?: InputMaybe<Scalars['ID']['input']>;
  templateSectionField?: InputMaybe<Scalars['ID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ReportTemplateSectionFieldTypeConnection = {
  __typename?: 'ReportTemplateSectionFieldTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ReportTemplateSectionFieldTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `ReportTemplateSectionFieldType` and its cursor. */
export type ReportTemplateSectionFieldTypeEdge = {
  __typename?: 'ReportTemplateSectionFieldTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<ReportTemplateSectionFieldType>;
};

export type ReportTemplateSectionInput = {
  id: Scalars['ID']['input'];
  pageLocation?: InputMaybe<ReportPageLocationEnums>;
  rankOrder?: InputMaybe<Scalars['Int']['input']>;
  sectionFields?: InputMaybe<Array<InputMaybe<ReportTemplateSectionFieldInput>>>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ReportTemplateSectionType = Node & {
  __typename?: 'ReportTemplateSectionType';
  createdDate: Scalars['DateTime']['output'];
  /** The ID of the object */
  id: Scalars['ID']['output'];
  inputDependency?: Maybe<Array<Maybe<InputDependencyChoices>>>;
  isDefault: Scalars['Boolean']['output'];
  key?: Maybe<Scalars['String']['output']>;
  lastUpdatedDate: Scalars['DateTime']['output'];
  pageLocation: ApiReportTemplateSectionPageLocationChoices;
  pk?: Maybe<Scalars['Int']['output']>;
  rankOrder: Scalars['Int']['output'];
  reportSections: ReportSectionsTypeConnection;
  reportTemplate: ReportTemplateType;
  reportTemplateSectionFields: ReportTemplateSectionFieldTypeConnection;
  title: Scalars['String']['output'];
  updatedBy?: Maybe<UserType>;
  updatedByDisplay?: Maybe<Scalars['String']['output']>;
};


export type ReportTemplateSectionTypeReportSectionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  aiGeneratedStatus?: InputMaybe<ApiReportSectionsAiGeneratedStatusChoices>;
  aiPredictionOwnerRunId?: InputMaybe<Scalars['String']['input']>;
  aiPredictionOwnerStartedAt?: InputMaybe<Scalars['DateTime']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdDate?: InputMaybe<Scalars['DateTime']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedDate?: InputMaybe<Scalars['DateTime']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  organization?: InputMaybe<Scalars['ID']['input']>;
  pageLocation?: InputMaybe<Scalars['String']['input']>;
  previousPageLocation?: InputMaybe<Scalars['String']['input']>;
  rankOrder?: InputMaybe<Scalars['Int']['input']>;
  report?: InputMaybe<Scalars['ID']['input']>;
  sectionIdentifier?: InputMaybe<Scalars['String']['input']>;
  templateSection?: InputMaybe<Scalars['ID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};


export type ReportTemplateSectionTypeReportTemplateSectionFieldsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  fieldIdentifier?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  reportSection?: InputMaybe<Scalars['ID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ReportTemplateSectionTypeConnection = {
  __typename?: 'ReportTemplateSectionTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ReportTemplateSectionTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `ReportTemplateSectionType` and its cursor. */
export type ReportTemplateSectionTypeEdge = {
  __typename?: 'ReportTemplateSectionTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<ReportTemplateSectionType>;
};

export type ReportTemplateSectionsInput = {
  pageLocation: ReportPageLocationEnums;
  reportId: Scalars['ID']['input'];
  skipAiGeneration?: InputMaybe<Scalars['Boolean']['input']>;
  /** When True, convert EHR goals to ReportGoals and copy phase history. */
  useConverter?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum ReportTemplateStatus {
  Archived = 'ARCHIVED',
  Draft = 'DRAFT',
  Published = 'PUBLISHED'
}

export type ReportTemplateSuggestionCriteriaType = Node & {
  __typename?: 'ReportTemplateSuggestionCriteriaType';
  enabled: Scalars['Boolean']['output'];
  /** The ID of the object */
  id: Scalars['ID']['output'];
  reportTemplate: ReportTemplateType;
  suggestionCriteria: SuggestionCriteriaType;
};

export type ReportTemplateSuggestionCriteriaTypeConnection = {
  __typename?: 'ReportTemplateSuggestionCriteriaTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ReportTemplateSuggestionCriteriaTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `ReportTemplateSuggestionCriteriaType` and its cursor. */
export type ReportTemplateSuggestionCriteriaTypeEdge = {
  __typename?: 'ReportTemplateSuggestionCriteriaTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<ReportTemplateSuggestionCriteriaType>;
};

export type ReportTemplateType = Node & {
  __typename?: 'ReportTemplateType';
  createdDate: Scalars['DateTime']['output'];
  curriculum?: Maybe<CurriculumType>;
  defaultLogoSignedUrl?: Maybe<Scalars['String']['output']>;
  /** This template will be used as the default template for the payor */
  defaultPayorTemplate: Scalars['Boolean']['output'];
  description?: Maybe<Scalars['String']['output']>;
  enterpriseTemplate: Scalars['Boolean']['output'];
  exportFramework: ApiReportTemplateExportFrameworkChoices;
  exportTemplateFont: ApiReportTemplateExportTemplateFontChoices;
  fileUploadConfig: ApiReportTemplateFileUploadConfigChoices;
  /** Overrides the organization's setting; null uses the organization's. */
  finalApproverWaitsForReviewers?: Maybe<Scalars['Boolean']['output']>;
  footerText?: Maybe<Scalars['String']['output']>;
  headerText?: Maybe<Scalars['String']['output']>;
  /** The ID of the object */
  id: Scalars['ID']['output'];
  isBaseTemplate: Scalars['Boolean']['output'];
  lastUpdatedDate: Scalars['DateTime']['output'];
  name: Scalars['String']['output'];
  orderedReplacement: Scalars['Boolean']['output'];
  organizationLogoAllowed: Scalars['Boolean']['output'];
  organizations: OrganizationTypeConnection;
  payorType?: Maybe<ApiReportTemplatePayorTypeChoices>;
  pk?: Maybe<Scalars['Int']['output']>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  publishedBy?: Maybe<UserType>;
  /** When enabled, completing a reassessment's CentralReach learning-tree sync triggers the report-narrative mapping workflow (PROA-2693), which maps stored CR node descriptions into this report's fields. No effect when disabled. */
  reportNarrativeMappingWorkflow: Scalars['Boolean']['output'];
  reportSet: ReportTypeConnection;
  reportTemplateSections: ReportTemplateSectionTypeConnection;
  reportType: ApiReportTemplateReportTypeChoices;
  /** When enabled, users cannot advance past review-and-sign until all active QA suggestions on the report are resolved. */
  requireAllQaResolved: Scalars['Boolean']['output'];
  /** Overrides the organization's setting; null uses the organization's. */
  requireApprovalBeforeExport?: Maybe<Scalars['Boolean']['output']>;
  sampleFile?: Maybe<Scalars['String']['output']>;
  sampleFileSignedUrl?: Maybe<Scalars['String']['output']>;
  sampleStatus: ApiReportTemplateSampleStatusChoices;
  status: ApiReportTemplateStatusChoices;
  suggestionCriteria?: Maybe<Array<Maybe<ReportTemplateSuggestionCriteriaType>>>;
  templateLogoSignedUrl?: Maybe<Scalars['String']['output']>;
  templateLogoUrl?: Maybe<Scalars['String']['output']>;
  templateResolvedUrl?: Maybe<Scalars['String']['output']>;
  templateUrl?: Maybe<Scalars['String']['output']>;
  treatmentPlanTemplate?: Maybe<TreatmentPlanTemplateType>;
  /** When enabled, this DOCXTEMPLATER template's export renders through the unified pipeline (frontera-pipelines' server-side docxtemplater renderer), the same path Handlebars templates always use. When disabled, exports fall back to the legacy client-side docxtemplater renderer. Replaces the retired 'unified-export' LaunchDarkly flag's name-based allowlist (PROA-2237) — requires the template's .docx to have been migrated off raw-XML `{@field}` tags onto `{~~field}` tags. */
  unifiedExport: Scalars['Boolean']['output'];
  updatedBy?: Maybe<UserType>;
  updatedByDisplay?: Maybe<Scalars['String']['output']>;
};


export type ReportTemplateTypeOrganizationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hubspotCompanyId?: InputMaybe<Scalars['String']['input']>;
  hubspotCompanyId_Isnull?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  isTestOrganization?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_Icontains?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type ReportTemplateTypeReportSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  isArchive?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  ordering?: InputMaybe<Scalars['String']['input']>;
  reportClientDetails_ClientFirstName_Icontains?: InputMaybe<Scalars['String']['input']>;
};


export type ReportTemplateTypeReportTemplateSectionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type ReportTemplateTypeConnection = {
  __typename?: 'ReportTemplateTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ReportTemplateTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `ReportTemplateType` and its cursor. */
export type ReportTemplateTypeEdge = {
  __typename?: 'ReportTemplateTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<ReportTemplateType>;
};

export type ReportTreatmentPlanPrioritizeFieldsAiInput = {
  familyLife: Array<InputMaybe<Scalars['String']['input']>>;
  predictionId?: InputMaybe<Scalars['String']['input']>;
  safetyConcerns: Array<InputMaybe<Scalars['String']['input']>>;
};

export type ReportTreatmentPlanPrioritizeFieldsInput = {
  additionalUserDetails?: InputMaybe<Scalars['String']['input']>;
  communicationAbility?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  engagementAbility?: InputMaybe<Scalars['Boolean']['input']>;
  familyLife?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  safetyConcerns?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  socialDesires?: InputMaybe<Scalars['String']['input']>;
};

export type ReportTreatmentPlanPrioritizeFieldsType = Node & {
  __typename?: 'ReportTreatmentPlanPrioritizeFieldsType';
  additionalUserDetails?: Maybe<Scalars['String']['output']>;
  aiGenerated: Scalars['Boolean']['output'];
  communicationAbility?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  createdDate: Scalars['DateTime']['output'];
  engagementAbility?: Maybe<Scalars['Boolean']['output']>;
  familyLife?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** The ID of the object */
  id: Scalars['ID']['output'];
  lastUpdatedDate: Scalars['DateTime']['output'];
  organization: OrganizationType;
  pk?: Maybe<Scalars['Int']['output']>;
  predictionId?: Maybe<Scalars['String']['output']>;
  report?: Maybe<ReportType>;
  safetyConcerns?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  socialDesires?: Maybe<Scalars['String']['output']>;
};

export type ReportTreatmentPlanTargetPriorityInput = {
  priorityOrder: Scalars['Int']['input'];
  targetId: Scalars['ID']['input'];
};

export type ReportTreatmentPlanType = Node & {
  __typename?: 'ReportTreatmentPlanType';
  aiGoalProgressSummaryPredictionStatus: ApiReportTreatmentPlanAiGoalProgressSummaryPredictionStatusChoices;
  aiGoalSuggestionStatus: ApiReportTreatmentPlanAiGoalSuggestionStatusChoices;
  aiLtgPredictionStatus: ApiReportTreatmentPlanAiLtgPredictionStatusChoices;
  aiPrioritizeStatus: ApiReportTreatmentPlanAiPrioritizeStatusChoices;
  aiStgPredictionStatus: ApiReportTreatmentPlanAiStgPredictionStatusChoices;
  aiTargetPredictionStatus: ApiReportTreatmentPlanAiTargetPredictionStatusChoices;
  createdDate: Scalars['DateTime']['output'];
  customFields: TreatmentPlanCustomFieldTypeConnection;
  failureReason?: Maybe<Scalars['String']['output']>;
  /** The ID of the object */
  id: Scalars['ID']['output'];
  lastUpdatedDate: Scalars['DateTime']['output'];
  learner?: Maybe<LearnerType>;
  organization: OrganizationType;
  pk?: Maybe<Scalars['Int']['output']>;
  report?: Maybe<ReportType>;
  reportdomainSet: ReportDomainTypeConnection;
  reportgoalSet: ReportGoalTypeConnection;
  reporttargetSet: ReportTargetTypeConnection;
  useLongTermGoals: Scalars['Boolean']['output'];
};


export type ReportTreatmentPlanTypeCustomFieldsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  fieldIdentifier?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  reportGoal?: InputMaybe<Scalars['ID']['input']>;
  reportTarget?: InputMaybe<Scalars['ID']['input']>;
};


export type ReportTreatmentPlanTypeReportdomainSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdDate?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedDate?: InputMaybe<Scalars['DateTime']['input']>;
  learner?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  organization?: InputMaybe<Scalars['ID']['input']>;
  rankOrder?: InputMaybe<Scalars['Int']['input']>;
  reportTreatmentPlan?: InputMaybe<Scalars['ID']['input']>;
};


export type ReportTreatmentPlanTypeReportgoalSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  aiBaselineDataPredictionStatus?: InputMaybe<ApiReportGoalAiBaselineDataPredictionStatusChoices>;
  aiGenerated?: InputMaybe<Scalars['Boolean']['input']>;
  aiGoalAttainmentScalePredictionStatus?: InputMaybe<ApiReportGoalAiGoalAttainmentScalePredictionStatusChoices>;
  aiProgressSummaryPredictionStatus?: InputMaybe<ApiReportGoalAiProgressSummaryPredictionStatusChoices>;
  assessmentToolSource?: InputMaybe<Scalars['String']['input']>;
  baselineData?: InputMaybe<Scalars['String']['input']>;
  baselineDate?: InputMaybe<Scalars['Date']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  chartFromDate?: InputMaybe<Scalars['Date']['input']>;
  chartImageUrl?: InputMaybe<Scalars['String']['input']>;
  chartToDate?: InputMaybe<Scalars['Date']['input']>;
  chartType?: InputMaybe<ApiReportGoalChartTypeChoices>;
  completionDate?: InputMaybe<Scalars['Date']['input']>;
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdDate?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  excludeFromReport?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  gasLevel1?: InputMaybe<Scalars['String']['input']>;
  gasLevel3?: InputMaybe<Scalars['String']['input']>;
  gasLevel4?: InputMaybe<Scalars['String']['input']>;
  gasMatchMessage?: InputMaybe<Scalars['String']['input']>;
  gasMatchStatus?: InputMaybe<ApiReportGoalGasMatchStatusChoices>;
  gasScore?: InputMaybe<Scalars['String']['input']>;
  generalizationCriteria?: InputMaybe<Scalars['String']['input']>;
  goal?: InputMaybe<Scalars['ID']['input']>;
  goalBank?: InputMaybe<Scalars['ID']['input']>;
  goalName?: InputMaybe<Scalars['String']['input']>;
  goalSubType?: InputMaybe<Scalars['String']['input']>;
  goalType?: InputMaybe<Scalars['String']['input']>;
  hasMedicalNecessity?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  inUse?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedDate?: InputMaybe<Scalars['DateTime']['input']>;
  learner?: InputMaybe<Scalars['ID']['input']>;
  masteryCriteria?: InputMaybe<Scalars['String']['input']>;
  medicalNecessityCriteria?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  organization?: InputMaybe<Scalars['ID']['input']>;
  predictionId?: InputMaybe<Scalars['String']['input']>;
  programGoal?: InputMaybe<Scalars['String']['input']>;
  progressSummary?: InputMaybe<Scalars['String']['input']>;
  projectedIntroductionDate?: InputMaybe<Scalars['Date']['input']>;
  rationale?: InputMaybe<Scalars['String']['input']>;
  report?: InputMaybe<Scalars['ID']['input']>;
  reportDomain?: InputMaybe<Scalars['ID']['input']>;
  reportTreatmentPlan?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<ApiReportGoalStatusChoices>;
  suggestionConfidence?: InputMaybe<Scalars['Float']['input']>;
  summaryReviewed?: InputMaybe<Scalars['Boolean']['input']>;
  summaryReviewedOn?: InputMaybe<Scalars['DateTime']['input']>;
  timelineEstimationType?: InputMaybe<ApiReportGoalTimelineEstimationTypeChoices>;
  timelineEstimationValue?: InputMaybe<Scalars['Int']['input']>;
};


export type ReportTreatmentPlanTypeReporttargetSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  aiGenerated?: InputMaybe<Scalars['Boolean']['input']>;
  aiProgressSummaryPredictionStatus?: InputMaybe<ApiReportTargetAiProgressSummaryPredictionStatusChoices>;
  baselineData?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  chartFromDate?: InputMaybe<Scalars['Date']['input']>;
  chartImageUrl?: InputMaybe<Scalars['String']['input']>;
  chartToDate?: InputMaybe<Scalars['Date']['input']>;
  chartType?: InputMaybe<ApiReportTargetChartTypeChoices>;
  completionDate?: InputMaybe<Scalars['Date']['input']>;
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdDate?: InputMaybe<Scalars['DateTime']['input']>;
  excludeFromReport?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  inUse?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedDate?: InputMaybe<Scalars['DateTime']['input']>;
  learner?: InputMaybe<Scalars['ID']['input']>;
  masteryCriteria?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  organization?: InputMaybe<Scalars['ID']['input']>;
  predictionId?: InputMaybe<Scalars['String']['input']>;
  priorityOrder?: InputMaybe<Scalars['Int']['input']>;
  progressSummary?: InputMaybe<Scalars['String']['input']>;
  progressType?: InputMaybe<ApiReportTargetProgressTypeChoices>;
  projectedIntroductionDate?: InputMaybe<Scalars['Date']['input']>;
  report?: InputMaybe<Scalars['ID']['input']>;
  reportDomain?: InputMaybe<Scalars['ID']['input']>;
  reportGoal?: InputMaybe<Scalars['ID']['input']>;
  reportTreatmentPlan?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<ApiReportTargetStatusChoices>;
  summaryReviewed?: InputMaybe<Scalars['Boolean']['input']>;
  summaryReviewedOn?: InputMaybe<Scalars['DateTime']['input']>;
  target?: InputMaybe<Scalars['ID']['input']>;
  targetDescription?: InputMaybe<Scalars['String']['input']>;
  targetName?: InputMaybe<Scalars['String']['input']>;
  timelineEstimationType?: InputMaybe<ApiReportTargetTimelineEstimationTypeChoices>;
  timelineEstimationValue?: InputMaybe<Scalars['Int']['input']>;
};

export type ReportTreatmentPlanTypeConnection = {
  __typename?: 'ReportTreatmentPlanTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ReportTreatmentPlanTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `ReportTreatmentPlanType` and its cursor. */
export type ReportTreatmentPlanTypeEdge = {
  __typename?: 'ReportTreatmentPlanTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<ReportTreatmentPlanType>;
};

export type ReportType = Node & {
  __typename?: 'ReportType';
  completionDate?: Maybe<Scalars['Date']['output']>;
  createdBy?: Maybe<UserType>;
  createdDate: Scalars['DateTime']['output'];
  ehrSync?: Maybe<ApiReportEhrSyncChoices>;
  ehrSyncAlerts?: Maybe<EhrSyncAlertsType>;
  ehrSyncExportAlert?: Maybe<Scalars['JSONString']['output']>;
  extendedStatus?: Maybe<ReportStatusExtendedEnums>;
  /** The latest send of this report's client to Frontera EHR from this organization, by any report; unset when never sent. */
  fronteraEhrClientExport?: Maybe<FronteraEhrClientExportType>;
  headerLogoUrl?: Maybe<Scalars['String']['output']>;
  headerPageHeading?: Maybe<Scalars['String']['output']>;
  /** The ID of the object */
  id: Scalars['ID']['output'];
  isArchive: Scalars['Boolean']['output'];
  lastSignedAt?: Maybe<Scalars['DateTime']['output']>;
  lastSignedByProvider?: Maybe<ProviderType>;
  lastSignedTimezone?: Maybe<Scalars['String']['output']>;
  lastUpdatedDate: Scalars['DateTime']['output'];
  learner?: Maybe<LearnerType>;
  /** The signed-in user's review state on this report, if any. */
  myReviewState?: Maybe<ReportReviewView>;
  /** The CentralReach learning-tree mapping is filling the report's narrative fields. Always false unless the report's template has reportNarrativeMappingWorkflow on; a run past its stale cutoff no longer counts. */
  narrativeMappingInProgress?: Maybe<Scalars['Boolean']['output']>;
  narrativeMappingStatus?: Maybe<ApiReportNarrativeMappingStatusChoices>;
  narrativeMappingStatusUpdatedAt?: Maybe<Scalars['DateTime']['output']>;
  organization: OrganizationType;
  payorreportsubmissionSet: PayorReportSubmissionTypeConnection;
  pk?: Maybe<Scalars['Int']['output']>;
  previousReportEndDate?: Maybe<Scalars['Date']['output']>;
  previousReportStartDate?: Maybe<Scalars['Date']['output']>;
  previousReportSubmittedDate?: Maybe<Scalars['Date']['output']>;
  reportClientDetails?: Maybe<ReportClientDetailsType>;
  reportDocxFile?: Maybe<Scalars['String']['output']>;
  reportDocxFileSignedUrl?: Maybe<Scalars['String']['output']>;
  reportFiles: LearnerFileTypeConnection;
  reportMetaData?: Maybe<Scalars['JSONString']['output']>;
  reportPayorMetadata?: Maybe<ReportPayorMetadataType>;
  reportPdfFile?: Maybe<Scalars['String']['output']>;
  reportPdfFileSignedUrl?: Maybe<Scalars['String']['output']>;
  reportSectionAiField: ReportSectionAiFieldsTypeConnection;
  reportSectionField: ReportSectionFieldsTypeConnection;
  reportSections: ReportSectionsTypeConnection;
  reportStatus: ApiReportReportStatusChoices;
  /** FK to report for convenience */
  reportSuggestions: ReportSuggestionTypeConnection;
  reportTemplate?: Maybe<ReportTemplateType>;
  reportTreatmentPlan?: Maybe<ReportTreatmentPlanType>;
  reportTreatmentPlanPrioritizeFields?: Maybe<ReportTreatmentPlanPrioritizeFieldsType>;
  reportType: ApiReportReportTypeChoices;
  reportWriter?: Maybe<Scalars['String']['output']>;
  reportgoalSet: ReportGoalTypeConnection;
  reporttargetSet: ReportTargetTypeConnection;
  signatureSectionDetail?: Maybe<ReportSignatureSectionDetailType>;
  suggestionGenerationStatus?: Maybe<ApiReportSuggestionGenerationStatusChoices>;
  userbillingdetailsSet: UserBillingDetailsTypeConnection;
};


export type ReportTypePayorreportsubmissionSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type ReportTypeReportFilesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  learner?: InputMaybe<Scalars['ID']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type ReportTypeReportSectionAiFieldArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  aiSources?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  createdDate?: InputMaybe<Scalars['DateTime']['input']>;
  fieldIdentifier?: InputMaybe<Scalars['String']['input']>;
  fieldType?: InputMaybe<ApiReportSectionAiFieldsFieldTypeChoices>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedDate?: InputMaybe<Scalars['DateTime']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  organization?: InputMaybe<Scalars['ID']['input']>;
  rankOrder?: InputMaybe<Scalars['Int']['input']>;
  report?: InputMaybe<Scalars['ID']['input']>;
  reportSection?: InputMaybe<Scalars['ID']['input']>;
  templateSectionField?: InputMaybe<Scalars['ID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};


export type ReportTypeReportSectionFieldArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  aiGenerated?: InputMaybe<Scalars['Boolean']['input']>;
  aiSectionField?: InputMaybe<Scalars['ID']['input']>;
  aiSources?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  createdDate?: InputMaybe<Scalars['DateTime']['input']>;
  fieldIdentifier?: InputMaybe<Scalars['String']['input']>;
  fieldType?: InputMaybe<ApiReportSectionFieldsFieldTypeChoices>;
  first?: InputMaybe<Scalars['Int']['input']>;
  isAuditable?: InputMaybe<Scalars['Boolean']['input']>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isRequired?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedDate?: InputMaybe<Scalars['DateTime']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  organization?: InputMaybe<Scalars['ID']['input']>;
  rankOrder?: InputMaybe<Scalars['Int']['input']>;
  report?: InputMaybe<Scalars['ID']['input']>;
  reportSection?: InputMaybe<Scalars['ID']['input']>;
  templateSectionField?: InputMaybe<Scalars['ID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};


export type ReportTypeReportSectionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  aiGeneratedStatus?: InputMaybe<ApiReportSectionsAiGeneratedStatusChoices>;
  aiPredictionOwnerRunId?: InputMaybe<Scalars['String']['input']>;
  aiPredictionOwnerStartedAt?: InputMaybe<Scalars['DateTime']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdDate?: InputMaybe<Scalars['DateTime']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedDate?: InputMaybe<Scalars['DateTime']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  organization?: InputMaybe<Scalars['ID']['input']>;
  pageLocation?: InputMaybe<Scalars['String']['input']>;
  previousPageLocation?: InputMaybe<Scalars['String']['input']>;
  rankOrder?: InputMaybe<Scalars['Int']['input']>;
  report?: InputMaybe<Scalars['ID']['input']>;
  sectionIdentifier?: InputMaybe<Scalars['String']['input']>;
  templateSection?: InputMaybe<Scalars['ID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};


export type ReportTypeReportSuggestionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  createdDate?: InputMaybe<Scalars['DateTime']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  goalField?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedDate?: InputMaybe<Scalars['DateTime']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  organization?: InputMaybe<Scalars['ID']['input']>;
  predictionId?: InputMaybe<Scalars['String']['input']>;
  report?: InputMaybe<Scalars['ID']['input']>;
  reportGoal?: InputMaybe<Scalars['ID']['input']>;
  reportSectionField?: InputMaybe<Scalars['ID']['input']>;
  reportTarget?: InputMaybe<Scalars['ID']['input']>;
  resolvedAt?: InputMaybe<Scalars['DateTime']['input']>;
  resolvedBy?: InputMaybe<Scalars['ID']['input']>;
  targetField?: InputMaybe<Scalars['String']['input']>;
};


export type ReportTypeReportgoalSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  aiBaselineDataPredictionStatus?: InputMaybe<ApiReportGoalAiBaselineDataPredictionStatusChoices>;
  aiGenerated?: InputMaybe<Scalars['Boolean']['input']>;
  aiGoalAttainmentScalePredictionStatus?: InputMaybe<ApiReportGoalAiGoalAttainmentScalePredictionStatusChoices>;
  aiProgressSummaryPredictionStatus?: InputMaybe<ApiReportGoalAiProgressSummaryPredictionStatusChoices>;
  assessmentToolSource?: InputMaybe<Scalars['String']['input']>;
  baselineData?: InputMaybe<Scalars['String']['input']>;
  baselineDate?: InputMaybe<Scalars['Date']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  chartFromDate?: InputMaybe<Scalars['Date']['input']>;
  chartImageUrl?: InputMaybe<Scalars['String']['input']>;
  chartToDate?: InputMaybe<Scalars['Date']['input']>;
  chartType?: InputMaybe<ApiReportGoalChartTypeChoices>;
  completionDate?: InputMaybe<Scalars['Date']['input']>;
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdDate?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  excludeFromReport?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  gasLevel1?: InputMaybe<Scalars['String']['input']>;
  gasLevel3?: InputMaybe<Scalars['String']['input']>;
  gasLevel4?: InputMaybe<Scalars['String']['input']>;
  gasMatchMessage?: InputMaybe<Scalars['String']['input']>;
  gasMatchStatus?: InputMaybe<ApiReportGoalGasMatchStatusChoices>;
  gasScore?: InputMaybe<Scalars['String']['input']>;
  generalizationCriteria?: InputMaybe<Scalars['String']['input']>;
  goal?: InputMaybe<Scalars['ID']['input']>;
  goalBank?: InputMaybe<Scalars['ID']['input']>;
  goalName?: InputMaybe<Scalars['String']['input']>;
  goalSubType?: InputMaybe<Scalars['String']['input']>;
  goalType?: InputMaybe<Scalars['String']['input']>;
  hasMedicalNecessity?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  inUse?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedDate?: InputMaybe<Scalars['DateTime']['input']>;
  learner?: InputMaybe<Scalars['ID']['input']>;
  masteryCriteria?: InputMaybe<Scalars['String']['input']>;
  medicalNecessityCriteria?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  organization?: InputMaybe<Scalars['ID']['input']>;
  predictionId?: InputMaybe<Scalars['String']['input']>;
  programGoal?: InputMaybe<Scalars['String']['input']>;
  progressSummary?: InputMaybe<Scalars['String']['input']>;
  projectedIntroductionDate?: InputMaybe<Scalars['Date']['input']>;
  rationale?: InputMaybe<Scalars['String']['input']>;
  report?: InputMaybe<Scalars['ID']['input']>;
  reportDomain?: InputMaybe<Scalars['ID']['input']>;
  reportTreatmentPlan?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<ApiReportGoalStatusChoices>;
  suggestionConfidence?: InputMaybe<Scalars['Float']['input']>;
  summaryReviewed?: InputMaybe<Scalars['Boolean']['input']>;
  summaryReviewedOn?: InputMaybe<Scalars['DateTime']['input']>;
  timelineEstimationType?: InputMaybe<ApiReportGoalTimelineEstimationTypeChoices>;
  timelineEstimationValue?: InputMaybe<Scalars['Int']['input']>;
};


export type ReportTypeReporttargetSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  aiGenerated?: InputMaybe<Scalars['Boolean']['input']>;
  aiProgressSummaryPredictionStatus?: InputMaybe<ApiReportTargetAiProgressSummaryPredictionStatusChoices>;
  baselineData?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  chartFromDate?: InputMaybe<Scalars['Date']['input']>;
  chartImageUrl?: InputMaybe<Scalars['String']['input']>;
  chartToDate?: InputMaybe<Scalars['Date']['input']>;
  chartType?: InputMaybe<ApiReportTargetChartTypeChoices>;
  completionDate?: InputMaybe<Scalars['Date']['input']>;
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdDate?: InputMaybe<Scalars['DateTime']['input']>;
  excludeFromReport?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  inUse?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedDate?: InputMaybe<Scalars['DateTime']['input']>;
  learner?: InputMaybe<Scalars['ID']['input']>;
  masteryCriteria?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  organization?: InputMaybe<Scalars['ID']['input']>;
  predictionId?: InputMaybe<Scalars['String']['input']>;
  priorityOrder?: InputMaybe<Scalars['Int']['input']>;
  progressSummary?: InputMaybe<Scalars['String']['input']>;
  progressType?: InputMaybe<ApiReportTargetProgressTypeChoices>;
  projectedIntroductionDate?: InputMaybe<Scalars['Date']['input']>;
  report?: InputMaybe<Scalars['ID']['input']>;
  reportDomain?: InputMaybe<Scalars['ID']['input']>;
  reportGoal?: InputMaybe<Scalars['ID']['input']>;
  reportTreatmentPlan?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<ApiReportTargetStatusChoices>;
  summaryReviewed?: InputMaybe<Scalars['Boolean']['input']>;
  summaryReviewedOn?: InputMaybe<Scalars['DateTime']['input']>;
  target?: InputMaybe<Scalars['ID']['input']>;
  targetDescription?: InputMaybe<Scalars['String']['input']>;
  targetName?: InputMaybe<Scalars['String']['input']>;
  timelineEstimationType?: InputMaybe<ApiReportTargetTimelineEstimationTypeChoices>;
  timelineEstimationValue?: InputMaybe<Scalars['Int']['input']>;
};


export type ReportTypeUserbillingdetailsSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  amount?: InputMaybe<Scalars['Decimal']['input']>;
  auth0User?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdDate?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  invoiceId?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedDate?: InputMaybe<Scalars['DateTime']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  organization?: InputMaybe<Scalars['ID']['input']>;
  paymentIntentId?: InputMaybe<Scalars['String']['input']>;
  paymentMethodId?: InputMaybe<Scalars['String']['input']>;
  paymentStatus?: InputMaybe<ApiUserBillingDetailsPaymentStatusChoices>;
  priceId?: InputMaybe<Scalars['String']['input']>;
  productId?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
  report?: InputMaybe<Scalars['ID']['input']>;
  transactionType?: InputMaybe<ApiUserBillingDetailsTransactionTypeChoices>;
  updatedBy?: InputMaybe<Scalars['ID']['input']>;
  userStripeAccount?: InputMaybe<Scalars['ID']['input']>;
};

export type ReportTypeConnection = {
  __typename?: 'ReportTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ReportTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `ReportType` and its cursor. */
export type ReportTypeEdge = {
  __typename?: 'ReportTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<ReportType>;
};

export enum ReportTypeEnums {
  DiagnosisEvaluation = 'DIAGNOSIS_EVALUATION',
  InitialAssessment = 'INITIAL_ASSESSMENT',
  Reassessment = 'REASSESSMENT'
}

export type ReportWritingTimeInput = {
  completedAt: Scalars['DateTime']['input'];
  reportId: Scalars['ID']['input'];
  writingTimeSeconds: Scalars['Int']['input'];
};

export type RequestReportReview = {
  __typename?: 'RequestReportReview';
  message?: Maybe<Scalars['String']['output']>;
  statusLogs?: Maybe<Array<ReportReviewerStatusLogType>>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

/** Mutation to reschedule an appointment (update start and end times) */
export type RescheduleCareAppointment = {
  __typename?: 'RescheduleCareAppointment';
  appointment?: Maybe<CareAppointmentType>;
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type ResolveReportComment = {
  __typename?: 'ResolveReportComment';
  comment?: Maybe<ReportCommentType>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

/** Mark a ReportSuggestion as resolved */
export type ResolveReportSuggestion = {
  __typename?: 'ResolveReportSuggestion';
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type ResolvedSuggestionType = {
  __typename?: 'ResolvedSuggestionType';
  category?: Maybe<Scalars['String']['output']>;
  content?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  resolvedAt?: Maybe<Scalars['String']['output']>;
};

export type ResponsesToQuestionsRawDataType = {
  __typename?: 'ResponsesToQuestionsRawDataType';
  rawData?: Maybe<Array<Maybe<ResponsesToQuestionsRawTextDataType>>>;
  totalRecordsCount?: Maybe<Scalars['Int']['output']>;
};

export type ResponsesToQuestionsRawTextDataType = {
  __typename?: 'ResponsesToQuestionsRawTextDataType';
  bcbaName?: Maybe<Scalars['String']['output']>;
  commentId?: Maybe<Scalars['Int']['output']>;
  questionAskedAt?: Maybe<Scalars['DateTime']['output']>;
  rbtName?: Maybe<Scalars['String']['output']>;
  respondedOn?: Maybe<Scalars['DateTime']['output']>;
  responseTimeInSeconds?: Maybe<Scalars['Float']['output']>;
};

export type ReviewCompletionTimeRawDataType = {
  __typename?: 'ReviewCompletionTimeRawDataType';
  rawData?: Maybe<Array<Maybe<ReviewCompletionTimeRawTextDataType>>>;
  totalRecordsCount?: Maybe<Scalars['Int']['output']>;
};

export type ReviewCompletionTimeRawTextDataType = {
  __typename?: 'ReviewCompletionTimeRawTextDataType';
  clientId?: Maybe<Scalars['Int']['output']>;
  clientName?: Maybe<Scalars['String']['output']>;
  readyForReviewAt?: Maybe<Scalars['DateTime']['output']>;
  reviewCompletionTimeInSeconds?: Maybe<Scalars['Float']['output']>;
  reviewedAt?: Maybe<Scalars['DateTime']['output']>;
  sessionDate?: Maybe<Scalars['Date']['output']>;
  sessionDatetime?: Maybe<Scalars['DateTime']['output']>;
  sessionRecordedBy?: Maybe<Scalars['String']['output']>;
  sessionViewedByBcba?: Maybe<Scalars['String']['output']>;
};

export type ReviewerRequestInput = {
  type: ReportReviewerKind;
  userId: Scalars['ID']['input'];
};

export enum RolesEnum {
  Admin = 'ADMIN',
  AssessmentBcba = 'ASSESSMENT_BCBA',
  Bcba = 'BCBA',
  Caregiver = 'CAREGIVER',
  Director = 'DIRECTOR',
  EnterpriseAdmin = 'ENTERPRISE_ADMIN',
  EvaluationPsychologist = 'EVALUATION_PSYCHOLOGIST',
  FronteraInternal = 'FRONTERA_INTERNAL',
  Intake = 'INTAKE',
  Psychologist = 'PSYCHOLOGIST',
  Rbt = 'RBT'
}

/** Re run video_session workflow to add video_session summary and metrics */
export type RunSessionWorkflowToAddSessionSummaryAndMetrics = {
  __typename?: 'RunSessionWorkflowToAddSessionSummaryAndMetrics';
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

/**
 * API to run workflow for sessions that do not have transcript and
 * to run workflow if there is multiple videos but not combined one for a sesssion
 */
export type RunVideoWorkflowForSessionsBySuperAdmin = {
  __typename?: 'RunVideoWorkflowForSessionsBySuperAdmin';
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

/** After a refresh: answer new items, lock them, and import only those. */
export type SaveAndLockCrLearningTreeItems = {
  __typename?: 'SaveAndLockCRLearningTreeItems';
  checks?: Maybe<Array<CrLearningTreeCheckType>>;
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

/** Save role choices as the person changes dropdowns (drafts). */
export type SaveCrLearningTreeRoles = {
  __typename?: 'SaveCRLearningTreeRoles';
  checks?: Maybe<Array<CrLearningTreeCheckType>>;
  message?: Maybe<Scalars['String']['output']>;
  saved?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

/** Save summary for INTAKE and ASSISTANT chats. */
export type SaveChatbotSummary = {
  __typename?: 'SaveChatbotSummary';
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
  summary?: Maybe<Scalars['String']['output']>;
};

export type SaveChatbotSummaryInput = {
  chatId: Scalars['ID']['input'];
  summary: Scalars['String']['input'];
  summaryType: Scalars['String']['input'];
};

/**
 * Save EHR credentials after successful login (Temporal)
 *
 * param: provider_id: Provider global ID
 * param: organization_id: Organization global ID
 * param: username: EHR username
 * param: password: EHR password
 *
 * returns: Success message
 */
export type SaveEhrCredentials = {
  __typename?: 'SaveEhrCredentials';
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type SaveGoalBankEmbeddingInput = {
  embeddedText: Scalars['String']['input'];
  embedding: Array<InputMaybe<Scalars['Float']['input']>>;
  goalBankId: Scalars['ID']['input'];
};

export type SaveGoalBankEmbeddings = {
  __typename?: 'SaveGoalBankEmbeddings';
  success?: Maybe<Scalars['Boolean']['output']>;
};

/**
 * Creates ReportGoal records for each goal bank suggestion produced by
 * SuggestGoalBankGoalsWorkflow. Each goal is created with ai_generated=True
 * and in_use=False so it surfaces as a suggestion without blocking the user.
 * Goal name, mastery criteria, and timeline are copied from the source
 * ReportGoalBank record.
 */
export type SaveGoalBankSuggestedGoals = {
  __typename?: 'SaveGoalBankSuggestedGoals';
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type SaveLearnerConsentFileMutation = {
  __typename?: 'SaveLearnerConsentFileMutation';
  learnerConsent?: Maybe<LearnerConsentFilesType>;
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type SaveReportWritingTimes = {
  __typename?: 'SaveReportWritingTimes';
  reportsNotFound?: Maybe<Scalars['Int']['output']>;
  reportsSkipped?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
  writingTimesWritten?: Maybe<Scalars['Int']['output']>;
};

export type SaveSessionAudioMetrics = {
  __typename?: 'SaveSessionAudioMetrics';
  message?: Maybe<Scalars['String']['output']>;
  sessionAudioMetrics?: Maybe<SessionAudioMetricsType>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type SaveSessionAudioMetricsInput = {
  activeTalkTimePercentageTherapist?: InputMaybe<Scalars['Float']['input']>;
  asrCoverage?: InputMaybe<Scalars['Float']['input']>;
  conversationalDuration?: InputMaybe<Scalars['Float']['input']>;
  meanLengthOfUtteranceTimeLearner?: InputMaybe<Scalars['Float']['input']>;
  meanLengthOfUtteranceTimeTherapist?: InputMaybe<Scalars['Float']['input']>;
  meanLengthOfUtteranceWordsLearner?: InputMaybe<Scalars['Float']['input']>;
  meanLengthOfUtteranceWordsTherapist?: InputMaybe<Scalars['Float']['input']>;
  nonConversationalDuration?: InputMaybe<Scalars['Float']['input']>;
  therapistLearnerTalkBalance?: InputMaybe<Scalars['Float']['input']>;
  totalDuration?: InputMaybe<Scalars['Float']['input']>;
  turnTakingRate?: InputMaybe<Scalars['Float']['input']>;
  utterancesPerMinuteLearner?: InputMaybe<Scalars['Float']['input']>;
  utterancesPerMinuteTherapist?: InputMaybe<Scalars['Float']['input']>;
  videoSessionId: Scalars['ID']['input'];
};

/**
 * Saves or updates the user's Stripe payment method in the backend database.
 *
 * This mutation is typically called **after** a successful SetupIntent confirmation on the frontend.
 * It takes the `payment_method_id` returned from Stripe and attaches it to the user's Stripe customer.
 *
 * Steps:
 * 1. Validates the payment method and ensures it belongs to the correct Stripe customer.
 * 2. Saves the `payment_method_id` in the backend for future off-session charges.
 *
 * Response:
 * - `message`: Confirmation message
 * - `status`: Boolean success flag
 */
export type SaveStripePaymentMethod = {
  __typename?: 'SaveStripePaymentMethod';
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
  userAccountDetails?: Maybe<UserStripeAccountDetailsType>;
};

export type SaveTasks = {
  __typename?: 'SaveTasks';
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type SaveTasksInput = {
  chatId: Scalars['ID']['input'];
  tasks?: InputMaybe<Array<InputMaybe<TaskInput>>>;
};

export type ScraperLearnerImportStatusType = Node & {
  __typename?: 'ScraperLearnerImportStatusType';
  alert?: Maybe<Scalars['JSONString']['output']>;
  createdDate: Scalars['DateTime']['output'];
  /** The ID of the object */
  id: Scalars['ID']['output'];
  lastUpdatedDate: Scalars['DateTime']['output'];
  learner: LearnerType;
  organization: OrganizationType;
  pk?: Maybe<Scalars['Int']['output']>;
  provider: ProviderType;
  scraperSessionWorkflow: ScraperWorkflowType;
  status: ApiScraperLearnerImportStatusStatusChoices;
};

export type ScraperLearnerImportStatusTypeConnection = {
  __typename?: 'ScraperLearnerImportStatusTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ScraperLearnerImportStatusTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `ScraperLearnerImportStatusType` and its cursor. */
export type ScraperLearnerImportStatusTypeEdge = {
  __typename?: 'ScraperLearnerImportStatusTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<ScraperLearnerImportStatusType>;
};

export type ScraperLoginType = Node & {
  __typename?: 'ScraperLoginType';
  alert?: Maybe<Scalars['String']['output']>;
  createdDate: Scalars['DateTime']['output'];
  /** The ID of the object */
  id: Scalars['ID']['output'];
  lastUpdatedDate: Scalars['DateTime']['output'];
  loginAttemptsExhausted?: Maybe<Scalars['Boolean']['output']>;
  organization: OrganizationType;
  pendingMfaCode?: Maybe<Scalars['String']['output']>;
  pk?: Maybe<Scalars['Int']['output']>;
  provider: ProviderType;
  scraperSessionWorkflow: ScraperWorkflowType;
  status: ApiScraperLoginStatusChoices;
};

export type ScraperLoginTypeConnection = {
  __typename?: 'ScraperLoginTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ScraperLoginTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `ScraperLoginType` and its cursor. */
export type ScraperLoginTypeEdge = {
  __typename?: 'ScraperLoginTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<ScraperLoginType>;
};

export type ScraperWorkflowType = Node & {
  __typename?: 'ScraperWorkflowType';
  createdDate: Scalars['DateTime']['output'];
  ehrIntegrationType?: Maybe<ApiScraperSessionWorkflowEhrIntegrationTypeChoices>;
  endTime: Scalars['DateTime']['output'];
  /** The ID of the object */
  id: Scalars['ID']['output'];
  lastUpdatedDate: Scalars['DateTime']['output'];
  organization: OrganizationType;
  pk?: Maybe<Scalars['Int']['output']>;
  provider: ProviderType;
  scraperlearnerimportstatusSet: ScraperLearnerImportStatusTypeConnection;
  scraperloginSet: ScraperLoginTypeConnection;
  startTime: Scalars['DateTime']['output'];
  status: ApiScraperSessionWorkflowStatusChoices;
  workflowTemporalId: Scalars['String']['output'];
};


export type ScraperWorkflowTypeScraperlearnerimportstatusSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type ScraperWorkflowTypeScraperloginSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type ScraperWorkflowTypeConnection = {
  __typename?: 'ScraperWorkflowTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ScraperWorkflowTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `ScraperWorkflowType` and its cursor. */
export type ScraperWorkflowTypeEdge = {
  __typename?: 'ScraperWorkflowTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<ScraperWorkflowType>;
};

export type SelectedEhrGoalInput = {
  goalId: Scalars['ID']['input'];
  reportDomainId?: InputMaybe<Scalars['ID']['input']>;
  targetExclusions?: InputMaybe<Array<InputMaybe<TargetExclusionInput>>>;
};

/** Mutation for sending daily digest emails to RBTS and Caregivers */
export type SendActivityEmailsToRbts = {
  __typename?: 'SendActivityEmailsToRbts';
  message?: Maybe<Scalars['String']['output']>;
  response?: Maybe<Scalars['JSONString']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

/** Send one caregiver their app activation code via email and/or SMS. */
export type SendCaregiverActivationCodeNotification = {
  __typename?: 'SendCaregiverActivationCodeNotification';
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

/**
 * Queue sending a batch of caregivers their app activation code via email/SMS.
 *
 * A single caregiver invite/resend
 * should use `sendCaregiverActivationCodeNotification` (singular) instead,
 * which sends synchronously and returns real success/failure. Triggers a
 * frontera-pipelines Temporal workflow that sends each caregiver's code — one
 * activity per caregiver, so a bad address or transient send failure only
 * affects that caregiver. This mutation returns as soon as the workflow is
 * queued; it does not wait for sends to complete. Sending stamps the
 * per-channel "last sent" timestamp; it does not change activation
 * eligibility.
 */
export type SendCaregiverActivationCodeNotifications = {
  __typename?: 'SendCaregiverActivationCodeNotifications';
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type SendClientToFronteraEhr = {
  __typename?: 'SendClientToFronteraEhr';
  /** PENDING once the send starts; read the report's fronteraEhrClientExport for its outcome. */
  exportStatus?: Maybe<FronteraEhrLearnerExportStatusEnum>;
  learner?: Maybe<LearnerType>;
  /** True once the report's client is linked to a Frontera EHR learner; false while the send runs. */
  linked?: Maybe<Scalars['Boolean']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
  /** Unset while the send runs. */
  verticalLearnerId?: Maybe<Scalars['String']['output']>;
};

export type SendPendingUploadReminders = {
  __typename?: 'SendPendingUploadReminders';
  failureCount?: Maybe<Scalars['Int']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  successCount?: Maybe<Scalars['Int']['output']>;
};

export type SendTestEmail = {
  __typename?: 'SendTestEmail';
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

export enum SessionAiPredictionEnum {
  ParentSummary = 'PARENT_SUMMARY',
  SessionSummary = 'SESSION_SUMMARY'
}

export type SessionAiPredictionInput = {
  model: Scalars['String']['input'];
  prediction: Scalars['String']['input'];
  predictionType: SessionAiPredictionEnum;
  vellumPredictionId?: InputMaybe<Scalars['String']['input']>;
  version: Scalars['String']['input'];
  videoSession: Scalars['ID']['input'];
};

export type SessionAiPredictionType = Node & {
  __typename?: 'SessionAIPredictionType';
  createdDate: Scalars['DateTime']['output'];
  /** The ID of the object */
  id: Scalars['ID']['output'];
  lastUpdatedDate: Scalars['DateTime']['output'];
  model: Scalars['String']['output'];
  organization: OrganizationType;
  pk?: Maybe<Scalars['Int']['output']>;
  prediction: Scalars['String']['output'];
  predictionType: ApiSessionAiPredictionPredictionTypeChoices;
  vellumPredictionId?: Maybe<Scalars['String']['output']>;
  version: Scalars['String']['output'];
  videoSession: VideoSessionType;
};

export type SessionAiPredictionTypeConnection = {
  __typename?: 'SessionAIPredictionTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<SessionAiPredictionTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `SessionAIPredictionType` and its cursor. */
export type SessionAiPredictionTypeEdge = {
  __typename?: 'SessionAIPredictionTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<SessionAiPredictionType>;
};

export type SessionAnalyticsVideosOverviewDataType = {
  __typename?: 'SessionAnalyticsVideosOverviewDataType';
  averageQuestionAskedByRbtPerVideo?: Maybe<Scalars['Int']['output']>;
  averageResponseTimeToBcbaQuestions?: Maybe<Scalars['Float']['output']>;
  totalVideosCount?: Maybe<Scalars['Int']['output']>;
  totalVideosDurationInSeconds?: Maybe<Scalars['Float']['output']>;
  videosReviewedPercentage?: Maybe<Scalars['Int']['output']>;
};

export type SessionAnalyticsVideosOverviewType = {
  __typename?: 'SessionAnalyticsVideosOverviewType';
  comparisonData?: Maybe<SessionAnalyticsVideosOverviewDataType>;
  currentData?: Maybe<SessionAnalyticsVideosOverviewDataType>;
};

export type SessionAnalyzerFeedbackDetails = {
  improveOptions: Array<InputMaybe<Scalars['String']['input']>>;
  improveText?: InputMaybe<Scalars['String']['input']>;
  positiveFeedback: Scalars['Boolean']['input'];
  version?: InputMaybe<Scalars['String']['input']>;
  videoSession: Scalars['ID']['input'];
  videoTimestamp: Scalars['Time']['input'];
};

export type SessionAnalyzerFeedbackType = Node & {
  __typename?: 'SessionAnalyzerFeedbackType';
  createdDate: Scalars['DateTime']['output'];
  /** The ID of the object */
  id: Scalars['ID']['output'];
  improveOptions?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  improveText: Scalars['String']['output'];
  lastUpdatedDate: Scalars['DateTime']['output'];
  organization: OrganizationType;
  pk?: Maybe<Scalars['Int']['output']>;
  positiveFeedback: Scalars['Boolean']['output'];
  version: Scalars['String']['output'];
  videoSession?: Maybe<VideoSessionType>;
  videoTimestamp: Scalars['Time']['output'];
};

export type SessionAnalyzerFeedbackTypeConnection = {
  __typename?: 'SessionAnalyzerFeedbackTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<SessionAnalyzerFeedbackTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `SessionAnalyzerFeedbackType` and its cursor. */
export type SessionAnalyzerFeedbackTypeEdge = {
  __typename?: 'SessionAnalyzerFeedbackTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<SessionAnalyzerFeedbackType>;
};

export type SessionAudioMetricsType = Node & {
  __typename?: 'SessionAudioMetricsType';
  activeTalkTimePercentageTherapist: Scalars['Float']['output'];
  asrCoverage: Scalars['Float']['output'];
  conversationalDuration: Scalars['Float']['output'];
  createdDate: Scalars['DateTime']['output'];
  /** The ID of the object */
  id: Scalars['ID']['output'];
  lastUpdatedDate: Scalars['DateTime']['output'];
  meanLengthOfUtteranceTimeLearner: Scalars['Float']['output'];
  meanLengthOfUtteranceTimeTherapist: Scalars['Float']['output'];
  meanLengthOfUtteranceWordsLearner: Scalars['Float']['output'];
  meanLengthOfUtteranceWordsTherapist: Scalars['Float']['output'];
  nonConversationalDuration: Scalars['Float']['output'];
  organization: OrganizationType;
  pk?: Maybe<Scalars['Int']['output']>;
  therapistLearnerTalkBalance: Scalars['Float']['output'];
  totalDuration: Scalars['Float']['output'];
  turnTakingRate: Scalars['Float']['output'];
  utterancesPerMinuteLearner: Scalars['Float']['output'];
  utterancesPerMinuteTherapist: Scalars['Float']['output'];
  videoSession: VideoSessionType;
};

export type SessionCaregiverType = Node & {
  __typename?: 'SessionCaregiverType';
  caregiver: CaregiverType;
  createdDate: Scalars['DateTime']['output'];
  /** The ID of the object */
  id: Scalars['ID']['output'];
  lastUpdatedDate: Scalars['DateTime']['output'];
  organization: OrganizationType;
  pk?: Maybe<Scalars['Int']['output']>;
  videoSession: VideoSessionType;
};

export type SessionCaregiverTypeConnection = {
  __typename?: 'SessionCaregiverTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<SessionCaregiverTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `SessionCaregiverType` and its cursor. */
export type SessionCaregiverTypeEdge = {
  __typename?: 'SessionCaregiverTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<SessionCaregiverType>;
};

export type SessionEhrImportInput = {
  endDatetime?: InputMaybe<Scalars['DateTime']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  sessionDate: Scalars['DateTime']['input'];
  sessionProgress?: InputMaybe<Array<InputMaybe<SessionTargetProgressEhrImportInput>>>;
  sessionStatus?: InputMaybe<Scalars['String']['input']>;
  sessionTimezone?: InputMaybe<Scalars['String']['input']>;
  startDatetime?: InputMaybe<Scalars['DateTime']['input']>;
};

export type SessionEngagementDetails = {
  description?: InputMaybe<Scalars['String']['input']>;
  engaged?: InputMaybe<Scalars['Boolean']['input']>;
  partEndTime?: InputMaybe<Scalars['Float']['input']>;
  partStartTime?: InputMaybe<Scalars['Float']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
  videoSession: Scalars['ID']['input'];
};

export type SessionEngagementInsightInput = {
  description: Scalars['String']['input'];
  endTime: Scalars['Float']['input'];
  insightType: Scalars['String']['input'];
  startTime: Scalars['Float']['input'];
  version?: InputMaybe<Scalars['String']['input']>;
  videoSession: Scalars['ID']['input'];
};

export type SessionEngagementInsightType = Node & {
  __typename?: 'SessionEngagementInsightType';
  createdDate: Scalars['DateTime']['output'];
  description: Scalars['String']['output'];
  endTime: Scalars['Float']['output'];
  /** The ID of the object */
  id: Scalars['ID']['output'];
  insightType: ApiSessionEngagementInsightInsightTypeChoices;
  lastUpdatedDate: Scalars['DateTime']['output'];
  organization: OrganizationType;
  pk?: Maybe<Scalars['Int']['output']>;
  startTime: Scalars['Float']['output'];
  version: Scalars['String']['output'];
  videoSession: VideoSessionType;
};

export type SessionEngagementInsightTypeConnection = {
  __typename?: 'SessionEngagementInsightTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<SessionEngagementInsightTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `SessionEngagementInsightType` and its cursor. */
export type SessionEngagementInsightTypeEdge = {
  __typename?: 'SessionEngagementInsightTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<SessionEngagementInsightType>;
};

export type SessionEngagementScorePartType = Node & {
  __typename?: 'SessionEngagementScorePartType';
  createdDate: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  engaged?: Maybe<Scalars['Boolean']['output']>;
  /** The ID of the object */
  id: Scalars['ID']['output'];
  lastUpdatedDate: Scalars['DateTime']['output'];
  organization: OrganizationType;
  partEndTime: Scalars['Float']['output'];
  partStartTime: Scalars['Float']['output'];
  pk?: Maybe<Scalars['Int']['output']>;
  version: Scalars['String']['output'];
  videoSession: VideoSessionType;
};

export type SessionEngagementScorePartTypeConnection = {
  __typename?: 'SessionEngagementScorePartTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<SessionEngagementScorePartTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `SessionEngagementScorePartType` and its cursor. */
export type SessionEngagementScorePartTypeEdge = {
  __typename?: 'SessionEngagementScorePartTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<SessionEngagementScorePartType>;
};

export type SessionLearnerType = Node & {
  __typename?: 'SessionLearnerType';
  createdDate: Scalars['DateTime']['output'];
  /** The ID of the object */
  id: Scalars['ID']['output'];
  lastUpdatedDate: Scalars['DateTime']['output'];
  organization: OrganizationType;
  pk?: Maybe<Scalars['Int']['output']>;
  sessionLearners: LearnerType;
  therapySession?: Maybe<TherapySessionType>;
  videoSession?: Maybe<VideoSessionType>;
};

export type SessionLearnerTypeConnection = {
  __typename?: 'SessionLearnerTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<SessionLearnerTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `SessionLearnerType` and its cursor. */
export type SessionLearnerTypeEdge = {
  __typename?: 'SessionLearnerTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<SessionLearnerType>;
};

export type SessionMediaAiPredictionsInput = {
  classType: ClassificationClassEnum;
  confidenceLevel: Scalars['Float']['input'];
  endTime: Scalars['Float']['input'];
  modelVersion: Scalars['String']['input'];
  startTime: Scalars['Float']['input'];
  subclassType: ClassificationSubClassEnum;
};

export type SessionMediaClassificationInput = {
  classificationPredictions: Array<InputMaybe<SessionMediaAiPredictionsInput>>;
  mediaId: Scalars['ID']['input'];
};

export enum SessionMediaReviewActivityLogEnum {
  TimeSpent = 'TIME_SPENT'
}

export type SessionMediaReviewActivityLogInput = {
  activityType: SessionMediaReviewActivityLogEnum;
  duration: Scalars['Int']['input'];
  endTime: Scalars['Float']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  mediaId: Scalars['ID']['input'];
  startTime?: InputMaybe<Scalars['Float']['input']>;
};

export type SessionMediaReviewActivityLogType = Node & {
  __typename?: 'SessionMediaReviewActivityLogType';
  activityType: ApiSessionMediaReviewActivityLogActivityTypeChoices;
  createdDate: Scalars['DateTime']['output'];
  durationSeconds?: Maybe<Scalars['Int']['output']>;
  /** End time (in seconds) of the video segment reviewed */
  endTime: Scalars['Float']['output'];
  /** The ID of the object */
  id: Scalars['ID']['output'];
  lastUpdatedDate: Scalars['DateTime']['output'];
  media?: Maybe<MediaType>;
  organization: OrganizationType;
  pk?: Maybe<Scalars['Int']['output']>;
  /** Start time (in seconds) of the video segment reviewed */
  startTime: Scalars['Float']['output'];
  user: UserType;
};

export type SessionMediaReviewActivityLogTypeConnection = {
  __typename?: 'SessionMediaReviewActivityLogTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<SessionMediaReviewActivityLogTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `SessionMediaReviewActivityLogType` and its cursor. */
export type SessionMediaReviewActivityLogTypeEdge = {
  __typename?: 'SessionMediaReviewActivityLogTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<SessionMediaReviewActivityLogType>;
};

export enum SessionNoteQaTypeEnums {
  MultiSelect = 'MULTI_SELECT',
  SingleSelect = 'SINGLE_SELECT',
  Text = 'TEXT'
}

export type SessionNoteType = Node & {
  __typename?: 'SessionNoteType';
  createdDate: Scalars['DateTime']['output'];
  /** The ID of the object */
  id: Scalars['ID']['output'];
  lastUpdatedDate: Scalars['DateTime']['output'];
  organization: OrganizationType;
  pk?: Maybe<Scalars['Int']['output']>;
  qaDescription?: Maybe<Scalars['String']['output']>;
  qaExternalId?: Maybe<Scalars['String']['output']>;
  qaResponse?: Maybe<Scalars['String']['output']>;
  qaTitle: Scalars['String']['output'];
  qaType: ApiSessionNoteQaTypeChoices;
  sectionDescription?: Maybe<Scalars['String']['output']>;
  sectionExternalId?: Maybe<Scalars['String']['output']>;
  sectionTitle: Scalars['String']['output'];
  therapySession: TherapySessionType;
};

export type SessionNoteTypeConnection = {
  __typename?: 'SessionNoteTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<SessionNoteTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `SessionNoteType` and its cursor. */
export type SessionNoteTypeEdge = {
  __typename?: 'SessionNoteTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<SessionNoteType>;
};

export type SessionProviderType = Node & {
  __typename?: 'SessionProviderType';
  createdDate: Scalars['DateTime']['output'];
  /** The ID of the object */
  id: Scalars['ID']['output'];
  lastUpdatedDate: Scalars['DateTime']['output'];
  organization: OrganizationType;
  pk?: Maybe<Scalars['Int']['output']>;
  provider: ProviderType;
  providerType: ApiSessionProviderProviderTypeChoices;
  therapySession?: Maybe<TherapySessionType>;
  videoSession?: Maybe<VideoSessionType>;
};

export type SessionProviderTypeConnection = {
  __typename?: 'SessionProviderTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<SessionProviderTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `SessionProviderType` and its cursor. */
export type SessionProviderTypeEdge = {
  __typename?: 'SessionProviderTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<SessionProviderType>;
};

export type SessionRecordingStateDistributionType = {
  __typename?: 'SessionRecordingStateDistributionType';
  completed?: Maybe<Scalars['Int']['output']>;
  failed?: Maybe<Scalars['Int']['output']>;
  processing?: Maybe<Scalars['Int']['output']>;
  scheduled?: Maybe<Scalars['Int']['output']>;
  totalSessionsRecorded?: Maybe<Scalars['Int']['output']>;
  uploading?: Maybe<Scalars['Int']['output']>;
};

export type SessionTargetProgressEhrImportInput = {
  count: Scalars['Float']['input'];
  date: Scalars['DateTime']['input'];
  goalExternalId?: InputMaybe<Scalars['String']['input']>;
  goalName: Scalars['String']['input'];
  progressType?: InputMaybe<ProgressType>;
  targetExternalId?: InputMaybe<Scalars['String']['input']>;
  targetName: Scalars['String']['input'];
  total: Scalars['Float']['input'];
};

export type SessionTargetProgressType = Node & {
  __typename?: 'SessionTargetProgressType';
  count: Scalars['Float']['output'];
  createdDate: Scalars['DateTime']['output'];
  date: Scalars['DateTime']['output'];
  /** Set when the progress is tracked at the goal level */
  goal?: Maybe<GoalType>;
  /** The ID of the object */
  id: Scalars['ID']['output'];
  lastUpdatedDate: Scalars['DateTime']['output'];
  learner: LearnerType;
  organization: OrganizationType;
  pk?: Maybe<Scalars['Int']['output']>;
  progressType: ApiSessionTargetProgressProgressTypeChoices;
  target?: Maybe<TargetType>;
  therapySession?: Maybe<TherapySessionType>;
  total: Scalars['Float']['output'];
};

export type SessionTargetProgressTypeConnection = {
  __typename?: 'SessionTargetProgressTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<SessionTargetProgressTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `SessionTargetProgressType` and its cursor. */
export type SessionTargetProgressTypeEdge = {
  __typename?: 'SessionTargetProgressTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<SessionTargetProgressType>;
};

export type SessionWithSessionNoteDataType = {
  __typename?: 'SessionWithSessionNoteDataType';
  clientName?: Maybe<Scalars['String']['output']>;
  providerName?: Maybe<Scalars['String']['output']>;
  sessionNoteData?: Maybe<Array<Maybe<SessionNoteType>>>;
  sessionProgressData?: Maybe<Array<Maybe<SessionTargetProgressType>>>;
  therapySession?: Maybe<TherapySessionType>;
};

export type SetEhrConnectionStatusMutation = {
  __typename?: 'SetEhrConnectionStatusMutation';
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type SetLearnerFileStatus = {
  __typename?: 'SetLearnerFileStatus';
  learnerFile?: Maybe<LearnerFileType>;
};

/**
 * Map a learner to one or more payors from the portal (PROA-1736).
 *
 * Upserts a ``LearnerPayor`` row per (learner, payor_type) in the caller's
 * organization — an existing mapping is returned rather than duplicated.
 * Portal-created mappings are active (``is_active=True``) but carry no payor
 * ``external_id`` (only the sync pipeline sets that), so it stays null.
 * Submitting a report to the payor additionally requires the ``external_id``
 * to be populated by the sync pipeline (see ``StartPayorSubmissionWorkflow``).
 */
export type SetLearnerPayor = {
  __typename?: 'SetLearnerPayor';
  errors?: Maybe<Array<Maybe<FieldError>>>;
  learnerPayors?: Maybe<Array<Maybe<LearnerPayorType>>>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type SetReportCommentHidden = {
  __typename?: 'SetReportCommentHidden';
  comment?: Maybe<ReportCommentType>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type SetReportReviewStatus = {
  __typename?: 'SetReportReviewStatus';
  message?: Maybe<Scalars['String']['output']>;
  statusLog?: Maybe<ReportReviewerStatusLogType>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

/**
 * Creates a Stripe PaymentIntent for a future charge, without confirming or charging immediately.
 *
 * This mutation is designed for use cases where a user may have a saved payment method,
 * but you want to prepare the intent for a later charge (e.g., billing once a service completes).
 *
 * Steps:
 * 1. Ensures the user has a Stripe Customer record.
 * 2. Creates a PaymentIntent with `automatic_payment_methods` enabled,
 *    but does not confirm or charge the payment.
 * 3. Returns the client secret so the frontend can handle confirmation later if needed.
 *
 * Response:
 * - `message`: Status message
 * - `status`: Boolean success flag
 * - `payment_client_secret`: The PaymentIntent client secret
 * - `payment_intent_id`: The Stripe PaymentIntent ID
 */
export type SetupPaymentIntent = {
  __typename?: 'SetupPaymentIntent';
  message?: Maybe<Scalars['String']['output']>;
  paymentClientSecret?: Maybe<Scalars['String']['output']>;
  paymentIntentId?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
  userAccountDetails?: Maybe<UserStripeAccountDetailsType>;
};

export enum ShortTermTimelineEstimationEnums {
  Days = 'DAYS',
  Months = 'MONTHS',
  Weeks = 'WEEKS'
}

/**
 * Finalizes a report's signature: validates the signature section's
 * required fields (including whichever signature-type field(s) a
 * template marks required — the same generic `is_required` mechanism
 * every other field already uses, no special-casing by field type),
 * stamps the signature-date field with the server clock's calendar day in
 * the signing zone (the caller supplies only an optional display zone,
 * `time_zone`, never a time or date), stamps `last_signed_by_provider`,
 * `last_signed_at` (server UTC) and `last_signed_timezone` (browser zone,
 * else profile, else "UTC") on the report, and freezes an audit snapshot
 * of every `is_auditable` field, plus the signing's instant and zone
 * (task 1.4, PROA-2891). The signature content itself (typed text, or an
 * uploaded/drawn image) is written beforehand through ordinary field
 * edits, exactly like any other report field — this mutation only
 * finalizes.
 * Supersedes the deprecated `addOrUpdateReportSignatureSectionDetail`
 * (kept around one more deploy cycle, see its own docstring) as the
 * step the frontend calls first in the sign flow, before whichever
 * export/completion mutation runs next — it does not change report
 * status.
 */
export type SignReport = {
  __typename?: 'SignReport';
  message?: Maybe<Scalars['String']['output']>;
  reportSectionField?: Maybe<ReportSectionFieldsType>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type SignReportInput = {
  reportId: Scalars['ID']['input'];
  timeZone?: InputMaybe<Scalars['String']['input']>;
};

/** Simplified goal type with only essential fields */
export type SimplifiedGoalType = {
  __typename?: 'SimplifiedGoalType';
  description?: Maybe<Scalars['String']['output']>;
  externalId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  masteryCriteria?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  tags?: Maybe<Scalars['JSONString']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type SimplifiedSessionTargetProgressType = {
  __typename?: 'SimplifiedSessionTargetProgressType';
  goal?: Maybe<SimplifiedGoalType>;
  sessionTargetProgress?: Maybe<SessionTargetProgressType>;
  target?: Maybe<SimplifiedTargetType>;
};

/** Simplified target type with only essential fields */
export type SimplifiedTargetType = {
  __typename?: 'SimplifiedTargetType';
  description?: Maybe<Scalars['String']['output']>;
  externalId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  masteryCriteria?: Maybe<Scalars['String']['output']>;
  progressType?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export enum SortBy {
  Alphabetical = 'ALPHABETICAL',
  LastUpdated = 'LAST_UPDATED'
}

export type StartD2POnboardingWorkflow = {
  __typename?: 'StartD2POnboardingWorkflow';
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type StartD2POnboardingWorkflowInput = {
  caregiverId: Scalars['ID']['input'];
  learner: Scalars['ID']['input'];
};

export type StartGoalAttainmentScaleWorkflow = {
  __typename?: 'StartGoalAttainmentScaleWorkflow';
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type StartGoalBaselineDataWorkflow = {
  __typename?: 'StartGoalBaselineDataWorkflow';
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type StartGoalProgressSummaryWorkflow = {
  __typename?: 'StartGoalProgressSummaryWorkflow';
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type StartGoalsSyncToEhr = {
  __typename?: 'StartGoalsSyncToEhr';
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type StartLearnerFileClassification = {
  __typename?: 'StartLearnerFileClassification';
  learnerFile?: Maybe<LearnerFileType>;
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type StartLearnerFileValidation = {
  __typename?: 'StartLearnerFileValidation';
  learnerFile?: Maybe<LearnerFileType>;
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type StartLearnerMetadataCreationFromAbcIntakeFile = {
  __typename?: 'StartLearnerMetadataCreationFromABCIntakeFile';
  learnerFile?: Maybe<LearnerFileType>;
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type StartLearnerMetadataCreationFromBhtiaFile = {
  __typename?: 'StartLearnerMetadataCreationFromBhtiaFile';
  learnerFile?: Maybe<LearnerFileType>;
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type StartManualSyncWorkflow = {
  __typename?: 'StartManualSyncWorkflow';
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type StartPayorSubmissionWorkflow = {
  __typename?: 'StartPayorSubmissionWorkflow';
  message?: Maybe<Scalars['String']['output']>;
  payorReportSubmission?: Maybe<PayorReportSubmissionType>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type StartPayorSubmissionWorkflowInput = {
  reportId: Scalars['ID']['input'];
};

/**
 * Kick off validation / parsing for a provider file, similar to StartLearnerFileValidation.
 *
 * This is called by providers from the UI once the file has been uploaded.
 */
export type StartProviderFileValidation = {
  __typename?: 'StartProviderFileValidation';
  message?: Maybe<Scalars['String']['output']>;
  providerFile?: Maybe<ProviderFileType>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type StartReassessmentFileClassification = {
  __typename?: 'StartReassessmentFileClassification';
  learnerFile?: Maybe<LearnerFileType>;
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

/** Start the report suggestions generation workflow for a report */
export type StartReportSuggestionsWorkflow = {
  __typename?: 'StartReportSuggestionsWorkflow';
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type StartSessionProcessingWorkflow = {
  __typename?: 'StartSessionProcessingWorkflow';
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  workflowId?: Maybe<Scalars['String']['output']>;
};

/**
 * Regenerate a single AI section using either the template reference or code configuration.
 * If the section has no AI fields, return success without regenerating.
 */
export type StartSingleReportTemplateSectionWorkflow = {
  __typename?: 'StartSingleReportTemplateSectionWorkflow';
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type StartTargetProgressSummaryWorkflow = {
  __typename?: 'StartTargetProgressSummaryWorkflow';
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type StartWorkflowAndLoginMutation = {
  __typename?: 'StartWorkflowAndLoginMutation';
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

/**
 * Returns Zoom OAuth URL.
 * FE should redirect user to this URL.
 */
export type StartZoomConnect = {
  __typename?: 'StartZoomConnect';
  url?: Maybe<Scalars['String']['output']>;
};

export enum StylePromptStatusEnum {
  Completed = 'COMPLETED',
  Failure = 'FAILURE',
  InProgress = 'IN_PROGRESS'
}

export enum SubmissionMethodEnum {
  EventBridge = 'EVENT_BRIDGE'
}

export type SuggestionCriteriaType = Node & {
  __typename?: 'SuggestionCriteriaType';
  /** Category of the suggestion criteria, for display and organizational purposes */
  category: Scalars['String']['output'];
  /** Criteria content or description, stored as markdown */
  content: Scalars['String']['output'];
  /** The ID of the object */
  id: Scalars['ID']['output'];
  /** Indicates if this criteria is a base criteria that should be included by default for all organizations */
  isBaseCriteria: Scalars['Boolean']['output'];
  /** Descriptive name of the suggestion criteria */
  name: Scalars['String']['output'];
  organizations: OrganizationSuggestionCriteriaTypeConnection;
  reportTemplates: ReportTemplateSuggestionCriteriaTypeConnection;
};


export type SuggestionCriteriaTypeOrganizationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type SuggestionCriteriaTypeReportTemplatesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type SuggestionWorkflowSectionFieldType = {
  __typename?: 'SuggestionWorkflowSectionFieldType';
  content?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  resolvedSuggestions?: Maybe<Array<Maybe<ResolvedSuggestionType>>>;
  title?: Maybe<Scalars['String']['output']>;
};

export type SuggestionWorkflowSectionType = {
  __typename?: 'SuggestionWorkflowSectionType';
  fields?: Maybe<Array<Maybe<SuggestionWorkflowSectionFieldType>>>;
  id?: Maybe<Scalars['Int']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type SyncCrGoalOrTargetAndProgressData = {
  __typename?: 'SyncCRGoalOrTargetAndProgressData';
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type SyncCrGoalOrTargetAndProgressDataInput = {
  externalLearnerId: Scalars['ID']['input'];
  goals?: InputMaybe<Array<InputMaybe<CentralReachGoalDataInput>>>;
  organizationId: Scalars['ID']['input'];
  reportId?: InputMaybe<Scalars['Int']['input']>;
  targetAndProgressData?: InputMaybe<Array<InputMaybe<CentralReachTargetAndSessionProgressDataInput>>>;
};

export type SyncExternalClients = {
  __typename?: 'SyncExternalClients';
  message?: Maybe<Scalars['String']['output']>;
  newClients?: Maybe<Array<Maybe<LearnerMetadataType>>>;
  status?: Maybe<Scalars['Boolean']['output']>;
  updatedClients?: Maybe<Array<Maybe<LearnerMetadataType>>>;
};

export type SyncExternalClientsInput = {
  clients?: InputMaybe<Array<InputMaybe<ExternalClient>>>;
  organizationExternalId?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  providerId?: InputMaybe<Scalars['ID']['input']>;
  shouldMapProviderToLearners?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SyncExternalOrganization = {
  __typename?: 'SyncExternalOrganization';
  message?: Maybe<Scalars['String']['output']>;
  organization?: Maybe<OrganizationType>;
  status?: Maybe<Scalars['Boolean']['output']>;
  syncStatus?: Maybe<ExternalOrganizationSyncStatusEnums>;
};

export type SyncExternalProviders = {
  __typename?: 'SyncExternalProviders';
  message?: Maybe<Scalars['String']['output']>;
  newProviders?: Maybe<Array<Maybe<ProviderMetadataType>>>;
  status?: Maybe<Scalars['Boolean']['output']>;
  updatedProviders?: Maybe<Array<Maybe<ProviderMetadataType>>>;
};

/**
 * Sync clients from Hipp Health to FDM.
 * Uses organization ID instead of external_id since Hipp Health organizations don't have external IDs.
 */
export type SyncHippHealthClients = {
  __typename?: 'SyncHippHealthClients';
  message?: Maybe<Scalars['String']['output']>;
  newClients?: Maybe<Array<Maybe<LearnerMetadataType>>>;
  status?: Maybe<Scalars['Boolean']['output']>;
  updatedClients?: Maybe<Array<Maybe<LearnerMetadataType>>>;
};

export type SyncHippHealthTreatmentPlans = {
  __typename?: 'SyncHippHealthTreatmentPlans';
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type SyncHippHealthTreatmentPlansInput = {
  learnerId: Scalars['ID']['input'];
  treatmentPlan: HippHealthTreatmentPlanInput;
};

export type SyncPassageTreatmentPlans = {
  __typename?: 'SyncPassageTreatmentPlans';
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type SyncPassageTreatmentPlansInput = {
  learnerId: Scalars['ID']['input'];
  reportId?: InputMaybe<Scalars['Int']['input']>;
  treatmentPlan: PassageTreatmentPlanInput;
};

export type SyncPayorClientData = {
  __typename?: 'SyncPayorClientData';
  data?: Maybe<Scalars['JSONString']['output']>;
  learnerPayors?: Maybe<Array<Maybe<LearnerPayorType>>>;
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type SyncPayorClientDataInput = {
  dateOfBirth: Scalars['Date']['input'];
  firstName: Scalars['String']['input'];
  isActive: Scalars['Boolean']['input'];
  lastName: Scalars['String']['input'];
  learnerPayorExternalId: Scalars['String']['input'];
  mrn?: InputMaybe<Scalars['String']['input']>;
  organizationPayorExternalId: Scalars['String']['input'];
  payorType: PayorType;
  reportUploadPrefix: Scalars['String']['input'];
};

/**
 * Payor pipeline (Temporal M2M): create a single initial-assessment report for the
 * learner payor, attach payor-supplied documents as ``LearnerFile`` rows, then start
 * the appropriate Temporal workflow per file kind.
 *
 * Business logic lives in ``services.payor_service`` so this deprecated public
 * mutation and its org-scoped internal twin (``SyncPayorClientDocumentAndCreateReportM2m``)
 * share one code path (PLA-1173).
 */
export type SyncPayorClientDocumentAndCreateReport = {
  __typename?: 'SyncPayorClientDocumentAndCreateReport';
  data?: Maybe<Scalars['JSONString']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type SyncPayorClientDocumentAndCreateReportInput = {
  fileSize: Scalars['Int']['input'];
  mimeType: Scalars['String']['input'];
  originalFileName: Scalars['String']['input'];
  s3Key: Scalars['String']['input'];
  type: Scalars['String']['input'];
};

export type SyncPayorOrganization = {
  __typename?: 'SyncPayorOrganization';
  message?: Maybe<Scalars['String']['output']>;
  organization?: Maybe<OrganizationType>;
  organizationPayor?: Maybe<OrganizationPayorType>;
  organizationSyncStatus?: Maybe<Scalars['String']['output']>;
  payorSyncStatus?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type SyncPayorOrganizationInput = {
  payorOrganization: PayorOrganizationInput;
  payorType: PayorType;
  submissionMethod: SubmissionMethodEnum;
};

export type TargetBankInput = {
  aiSuggestedTarget?: InputMaybe<Scalars['ID']['input']>;
  goalBankId: Scalars['ID']['input'];
  masteryCriteria?: InputMaybe<Scalars['String']['input']>;
  medicalRationale?: InputMaybe<Scalars['String']['input']>;
  targetDescription?: InputMaybe<Scalars['String']['input']>;
  targetName: Scalars['String']['input'];
  timelineEstimationType?: InputMaybe<TargetTimelineEstimationEnums>;
  timelineEstimationValue?: InputMaybe<Scalars['Float']['input']>;
};

export type TargetEhrImportInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  antecedent?: InputMaybe<Scalars['String']['input']>;
  baselineDate?: InputMaybe<Scalars['Date']['input']>;
  completionDate?: InputMaybe<Scalars['Date']['input']>;
  consequence?: InputMaybe<Scalars['String']['input']>;
  dateMaintenanceMastered?: InputMaybe<Scalars['DateTime']['input']>;
  dateReintroduced?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  durationSeconds?: InputMaybe<Scalars['Int']['input']>;
  events?: InputMaybe<Array<InputMaybe<EventEhrImportInput>>>;
  externalGoalId: Scalars['String']['input'];
  externalId?: InputMaybe<Scalars['String']['input']>;
  happenedAt?: InputMaybe<Scalars['DateTime']['input']>;
  hasData?: InputMaybe<Scalars['Boolean']['input']>;
  isMaintenanceAutomastered?: InputMaybe<Scalars['Boolean']['input']>;
  isMaintenanceOff?: InputMaybe<Scalars['Boolean']['input']>;
  mastered?: InputMaybe<Scalars['Boolean']['input']>;
  masteredDate?: InputMaybe<Scalars['DateTime']['input']>;
  masteryCriteria?: InputMaybe<Scalars['String']['input']>;
  objectiveId?: InputMaybe<Scalars['String']['input']>;
  objectiveText?: InputMaybe<Scalars['String']['input']>;
  openedDate?: InputMaybe<Scalars['DateTime']['input']>;
  phases?: InputMaybe<Array<InputMaybe<PhaseEhrImportInput>>>;
  progressType?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
  targetKind?: InputMaybe<Scalars['Int']['input']>;
  targetName: Scalars['String']['input'];
  targetStatus?: InputMaybe<Scalars['String']['input']>;
  trialOutcome?: InputMaybe<Scalars['String']['input']>;
};

export type TargetExclusionInput = {
  excludeFromReport: Scalars['Boolean']['input'];
  targetId: Scalars['ID']['input'];
};

export enum TargetFindingModalityEnum {
  Audio = 'AUDIO',
  Video = 'VIDEO'
}

export type TargetImportInput = {
  targetDescription: Scalars['String']['input'];
  targetName: Scalars['String']['input'];
  targetPhaseDate?: InputMaybe<Scalars['DateTime']['input']>;
  targetProgressType?: InputMaybe<ProgressType>;
  targetStatus?: InputMaybe<GoalStatusEnums>;
};

export type TargetPredictionsInput = {
  endTime: Scalars['Float']['input'];
  goalId?: InputMaybe<Scalars['ID']['input']>;
  modalityType: TargetFindingModalityEnum;
  rationale: Scalars['String']['input'];
  startTime: Scalars['Float']['input'];
  targetId?: InputMaybe<Scalars['ID']['input']>;
};

export type TargetPriorityInput = {
  priorityOrder: Scalars['Int']['input'];
  targetId: Scalars['ID']['input'];
};

export type TargetProgressSummaryInput = {
  progressSummary: Scalars['String']['input'];
  targetId: Scalars['ID']['input'];
};

export type TargetProgressTreatmentPlanType = {
  __typename?: 'TargetProgressTreatmentPlanType';
  sessionTargetProgressData?: Maybe<Array<Maybe<SimplifiedSessionTargetProgressType>>>;
  treatmentPlanData?: Maybe<Array<Maybe<TreatmentPlanGoalAndTargetType>>>;
};

export type TargetProgressType = {
  __typename?: 'TargetProgressType';
  data?: Maybe<Array<Maybe<ProgressDataPointType>>>;
  events?: Maybe<Array<Maybe<EventType>>>;
  phases?: Maybe<Array<Maybe<PhaseChangeType>>>;
  progressType?: Maybe<Scalars['String']['output']>;
  targetId?: Maybe<Scalars['ID']['output']>;
  targetName?: Maybe<Scalars['String']['output']>;
};

export type TargetStatusType = {
  __typename?: 'TargetStatusType';
  createdDate: Scalars['DateTime']['output'];
  date?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  lastUpdatedDate: Scalars['DateTime']['output'];
  organization: OrganizationType;
  pk?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  target?: Maybe<ReportTargetType>;
};

export enum TargetTimelineEstimationEnums {
  Days = 'DAYS',
  Months = 'MONTHS',
  Sessions = 'SESSIONS',
  Weeks = 'WEEKS'
}

export type TargetType = Node & {
  __typename?: 'TargetType';
  createdDate: Scalars['DateTime']['output'];
  fronteratarget?: Maybe<FronteraTargetType>;
  fronteratargetbankSet: FronteraTargetBankTypeConnection;
  goal: GoalType;
  hipphealthtarget?: Maybe<HippHealthTargetType>;
  hirasmustarget?: Maybe<HiRasmusTargetType>;
  /** The ID of the object */
  id: Scalars['ID']['output'];
  lastUpdatedDate: Scalars['DateTime']['output'];
  learner: LearnerType;
  mediatargetpredictionSet: MediaTargetPredictionTypeConnection;
  motivitytarget?: Maybe<MotivityTargetType>;
  name?: Maybe<Scalars['String']['output']>;
  organization: OrganizationType;
  passagetarget?: Maybe<PassageTargetType>;
  passagetargetbankSet: PassageTargetBankTypeConnection;
  pk?: Maybe<Scalars['Int']['output']>;
  reporttargetSet: ReportTargetTypeConnection;
  /** Latest status from target phases */
  status?: Maybe<UnifiedTargetStatusEnum>;
  targetProgress: SessionTargetProgressTypeConnection;
  therapztarget?: Maybe<TherapzTargetType>;
};


export type TargetTypeFronteratargetbankSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  aiGenerated?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdDate?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  inUse?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedDate?: InputMaybe<Scalars['DateTime']['input']>;
  masteryCriteria?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  organization?: InputMaybe<Scalars['ID']['input']>;
  target?: InputMaybe<Scalars['ID']['input']>;
  targetBank?: InputMaybe<Scalars['ID']['input']>;
  type?: InputMaybe<ApiFronteraTargetBankTypeChoices>;
};


export type TargetTypeMediatargetpredictionSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdDate?: InputMaybe<Scalars['DateTime']['input']>;
  endTime?: InputMaybe<Scalars['Float']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  goal?: InputMaybe<Scalars['ID']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedDate?: InputMaybe<Scalars['DateTime']['input']>;
  media?: InputMaybe<Scalars['ID']['input']>;
  modalityType?: InputMaybe<ApiMediaTargetPredictionModalityTypeChoices>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  organization?: InputMaybe<Scalars['ID']['input']>;
  predictionId?: InputMaybe<Scalars['String']['input']>;
  rationale?: InputMaybe<Scalars['String']['input']>;
  reportGoalOld?: InputMaybe<Scalars['ID']['input']>;
  reportTargetOld?: InputMaybe<Scalars['ID']['input']>;
  startTime?: InputMaybe<Scalars['Float']['input']>;
  target?: InputMaybe<Scalars['ID']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
};


export type TargetTypePassagetargetbankSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  aiGenerated?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdDate?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  discriminativeStimulus?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  inUse?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedDate?: InputMaybe<Scalars['DateTime']['input']>;
  masteredOverType?: InputMaybe<Scalars['String']['input']>;
  masteredOverValue?: InputMaybe<Scalars['Int']['input']>;
  measureType?: InputMaybe<Scalars['String']['input']>;
  measureValue?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  organization?: InputMaybe<Scalars['ID']['input']>;
  target?: InputMaybe<Scalars['ID']['input']>;
  targetBank?: InputMaybe<Scalars['ID']['input']>;
  threshold?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<ApiPassageTargetBankTypeChoices>;
};


export type TargetTypeReporttargetSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  aiGenerated?: InputMaybe<Scalars['Boolean']['input']>;
  aiProgressSummaryPredictionStatus?: InputMaybe<ApiReportTargetAiProgressSummaryPredictionStatusChoices>;
  baselineData?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  chartFromDate?: InputMaybe<Scalars['Date']['input']>;
  chartImageUrl?: InputMaybe<Scalars['String']['input']>;
  chartToDate?: InputMaybe<Scalars['Date']['input']>;
  chartType?: InputMaybe<ApiReportTargetChartTypeChoices>;
  completionDate?: InputMaybe<Scalars['Date']['input']>;
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdDate?: InputMaybe<Scalars['DateTime']['input']>;
  excludeFromReport?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  inUse?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedDate?: InputMaybe<Scalars['DateTime']['input']>;
  learner?: InputMaybe<Scalars['ID']['input']>;
  masteryCriteria?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  organization?: InputMaybe<Scalars['ID']['input']>;
  predictionId?: InputMaybe<Scalars['String']['input']>;
  priorityOrder?: InputMaybe<Scalars['Int']['input']>;
  progressSummary?: InputMaybe<Scalars['String']['input']>;
  progressType?: InputMaybe<ApiReportTargetProgressTypeChoices>;
  projectedIntroductionDate?: InputMaybe<Scalars['Date']['input']>;
  report?: InputMaybe<Scalars['ID']['input']>;
  reportDomain?: InputMaybe<Scalars['ID']['input']>;
  reportGoal?: InputMaybe<Scalars['ID']['input']>;
  reportTreatmentPlan?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<ApiReportTargetStatusChoices>;
  summaryReviewed?: InputMaybe<Scalars['Boolean']['input']>;
  summaryReviewedOn?: InputMaybe<Scalars['DateTime']['input']>;
  target?: InputMaybe<Scalars['ID']['input']>;
  targetDescription?: InputMaybe<Scalars['String']['input']>;
  targetName?: InputMaybe<Scalars['String']['input']>;
  timelineEstimationType?: InputMaybe<ApiReportTargetTimelineEstimationTypeChoices>;
  timelineEstimationValue?: InputMaybe<Scalars['Int']['input']>;
};


export type TargetTypeTargetProgressArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  count?: InputMaybe<Scalars['Float']['input']>;
  createdDate?: InputMaybe<Scalars['DateTime']['input']>;
  date?: InputMaybe<Scalars['DateTime']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  goal?: InputMaybe<Scalars['ID']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedDate?: InputMaybe<Scalars['DateTime']['input']>;
  learner?: InputMaybe<Scalars['ID']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  organization?: InputMaybe<Scalars['ID']['input']>;
  progressType?: InputMaybe<ApiSessionTargetProgressProgressTypeChoices>;
  target?: InputMaybe<Scalars['ID']['input']>;
  therapySession?: InputMaybe<Scalars['ID']['input']>;
  total?: InputMaybe<Scalars['Float']['input']>;
};

export type TargetTypeConnection = {
  __typename?: 'TargetTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<TargetTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `TargetType` and its cursor. */
export type TargetTypeEdge = {
  __typename?: 'TargetTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<TargetType>;
};

export type TaskInput = {
  subtitle: Scalars['String']['input'];
  title: Scalars['String']['input'];
  type: Scalars['String']['input'];
};

export type TaskType = Node & {
  __typename?: 'TaskType';
  chat: ChatType;
  createdDate: Scalars['DateTime']['output'];
  file?: Maybe<LearnerFileType>;
  /** The ID of the object */
  id: Scalars['ID']['output'];
  isCaregiver?: Maybe<Scalars['Boolean']['output']>;
  isProvider?: Maybe<Scalars['Boolean']['output']>;
  lastUpdatedDate: Scalars['DateTime']['output'];
  learner: LearnerType;
  media?: Maybe<MediaType>;
  organization: OrganizationType;
  pk?: Maybe<Scalars['Int']['output']>;
  status: ApiTaskStatusChoices;
  subtitle: Scalars['String']['output'];
  title: Scalars['String']['output'];
  type: ApiTaskTypeChoices;
  user: UserType;
};

export type TaskTypeConnection = {
  __typename?: 'TaskTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<TaskTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `TaskType` and its cursor. */
export type TaskTypeEdge = {
  __typename?: 'TaskTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<TaskType>;
};

export type TasksFilter = {
  chatId: Scalars['ID']['input'];
  status?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export enum TendenciesQuestionType {
  ActsWithoutThinking = 'ACTS_WITHOUT_THINKING',
  AggressionComment = 'AGGRESSION_COMMENT',
  ApologizesWhenHurtsSomeonesFeelings = 'APOLOGIZES_WHEN_HURTS_SOMEONES_FEELINGS',
  ArguesWithAdults = 'ARGUES_WITH_ADULTS',
  ArticulationProblemsDifficultToUnderstandSpeech = 'ARTICULATION_PROBLEMS_DIFFICULT_TO_UNDERSTAND_SPEECH',
  AttachmentComment = 'ATTACHMENT_COMMENT',
  AttentionComment = 'ATTENTION_COMMENT',
  AvoidsTasksThatTakeALotOfEffort = 'AVOIDS_TASKS_THAT_TAKE_A_LOT_OF_EFFORT',
  BlamesOthersForMisbehavior = 'BLAMES_OTHERS_FOR_MISBEHAVIOR',
  BulliesThreatensOrIntimidatesOthers = 'BULLIES_THREATENS_OR_INTIMIDATES_OTHERS',
  CannotGetUpsettingThoughtsOrMemoriesOutOfTheirMind = 'CANNOT_GET_UPSETTING_THOUGHTS_OR_MEMORIES_OUT_OF_THEIR_MIND',
  CantSitStill = 'CANT_SIT_STILL',
  ClientHaveHistory = 'CLIENT_HAVE_HISTORY',
  ComplainsOfHeadachesStomachachesOrBodilyPains = 'COMPLAINS_OF_HEADACHES_STOMACHACHES_OR_BODILY_PAINS',
  CompletesHomeworkWithMinimalReminders = 'COMPLETES_HOMEWORK_WITH_MINIMAL_REMINDERS',
  CrueltyToAnimals = 'CRUELTY_TO_ANIMALS',
  CutsOnSelfOrEngagesInOtherTypesOfSelfHarm = 'CUTS_ON_SELF_OR_ENGAGES_IN_OTHER_TYPES_OF_SELF_HARM',
  DefianceComment = 'DEFIANCE_COMMENT',
  DefiantRefusesWhatYouTellThemToDo = 'DEFIANT_REFUSES_WHAT_YOU_TELL_THEM_TO_DO',
  DifficultyAdjustingToUnforeseenProblemsOrUnclearDirections = 'DIFFICULTY_ADJUSTING_TO_UNFORESEEN_PROBLEMS_OR_UNCLEAR_DIRECTIONS',
  DifficultyDealingWithFrustrationInCompletingTasks = 'DIFFICULTY_DEALING_WITH_FRUSTRATION_IN_COMPLETING_TASKS',
  DifficultyFollowingMultiStepDirections = 'DIFFICULTY_FOLLOWING_MULTI_STEP_DIRECTIONS',
  DifficultyHandlingChangesInRoutine = 'DIFFICULTY_HANDLING_CHANGES_IN_ROUTINE',
  DifficultyHandlingTransitions = 'DIFFICULTY_HANDLING_TRANSITIONS',
  DifficultyWithOrganizingTasksOrSchoolWork = 'DIFFICULTY_WITH_ORGANIZING_TASKS_OR_SCHOOL_WORK',
  DisplaysAbruptRapidMoodSwings = 'DISPLAYS_ABRUPT_RAPID_MOOD_SWINGS',
  DissociatesSeemsToBeOffInTheirOwnWorld = 'DISSOCIATES_SEEMS_TO_BE_OFF_IN_THEIR_OWN_WORLD',
  DoesntStartTasksWithoutALotOfPrompting = 'DOESNT_START_TASKS_WITHOUT_A_LOT_OF_PROMPTING',
  DoesNotApologizeForPoorBehavior = 'DOES_NOT_APOLOGIZE_FOR_POOR_BEHAVIOR',
  DoesNotListenVeryWellToOtherPeoplesPointOfViewOrPerspective = 'DOES_NOT_LISTEN_VERY_WELL_TO_OTHER_PEOPLES_POINT_OF_VIEW_OR_PERSPECTIVE',
  DoesNotSeemToListenWhenSpokenToDirectly = 'DOES_NOT_SEEM_TO_LISTEN_WHEN_SPOKEN_TO_DIRECTLY',
  DoesNotTrustAnyone = 'DOES_NOT_TRUST_ANYONE',
  EatsTooMuchOrEatsPoorly = 'EATS_TOO_MUCH_OR_EATS_POORLY',
  ExecutiveFunctionsComment = 'EXECUTIVE_FUNCTIONS_COMMENT',
  FailsToLearnFromHisOrHerExperienceSuccessOrFailure = 'FAILS_TO_LEARN_FROM_HIS_OR_HER_EXPERIENCE_SUCCESS_OR_FAILURE',
  FailsToUnderstandHowHisOrHerBehaviorAffectsOthers = 'FAILS_TO_UNDERSTAND_HOW_HIS_OR_HER_BEHAVIOR_AFFECTS_OTHERS',
  FrequentConflictsWithOtherPeopleInTheHome = 'FREQUENT_CONFLICTS_WITH_OTHER_PEOPLE_IN_THE_HOME',
  GangInvolvement = 'GANG_INVOLVEMENT',
  GetsAlongWellWithFamilyMembers = 'GETS_ALONG_WELL_WITH_FAMILY_MEMBERS',
  HasAnExplosiveTemperOrHasRageReactions = 'HAS_AN_EXPLOSIVE_TEMPER_OR_HAS_RAGE_REACTIONS',
  HasBadDreamsOrNightTerrors = 'HAS_BAD_DREAMS_OR_NIGHT_TERRORS',
  HasCompulsiveBehaviors = 'HAS_COMPULSIVE_BEHAVIORS',
  HasDestroyedOthersProperty = 'HAS_DESTROYED_OTHERS_PROPERTY',
  HasDifficultyAccuratelyUnderstandingSocialAndCommunicationCues = 'HAS_DIFFICULTY_ACCURATELY_UNDERSTANDING_SOCIAL_AND_COMMUNICATION_CUES',
  HasDifficultyExpressingThoughtsAndOrFeelings = 'HAS_DIFFICULTY_EXPRESSING_THOUGHTS_AND_OR_FEELINGS',
  HasDifficultyFallingAsleep = 'HAS_DIFFICULTY_FALLING_ASLEEP',
  HasDifficultyPayingAttentionOrMakesCarelessMistakes = 'HAS_DIFFICULTY_PAYING_ATTENTION_OR_MAKES_CARELESS_MISTAKES',
  HasDifficultyUnderstandingWhatIsBeingSaid = 'HAS_DIFFICULTY_UNDERSTANDING_WHAT_IS_BEING_SAID',
  HasExtremelyStrangeOrIllogicalIdeas = 'HAS_EXTREMELY_STRANGE_OR_ILLOGICAL_IDEAS',
  HasFewOrNoFriends = 'HAS_FEW_OR_NO_FRIENDS',
  HasGoodManners = 'HAS_GOOD_MANNERS',
  HasLowEnergyOrIsTiredForNoApparentReason = 'HAS_LOW_ENERGY_OR_IS_TIRED_FOR_NO_APPARENT_REASON',
  HasManyThoughtsAtOnce = 'HAS_MANY_THOUGHTS_AT_ONCE',
  HasNoFearOrStrangersWillGoWithAnyone = 'HAS_NO_FEAR_OR_STRANGERS_WILL_GO_WITH_ANYONE',
  HasStartedFires = 'HAS_STARTED_FIRES',
  HasStolenThingsFromOthers = 'HAS_STOLEN_THINGS_FROM_OTHERS',
  HearsVoicesEspeciallyTellingThemToDoThings = 'HEARS_VOICES_ESPECIALLY_TELLING_THEM_TO_DO_THINGS',
  HelpsWithChoresAroundTheHouse = 'HELPS_WITH_CHORES_AROUND_THE_HOUSE',
  HypervigilantAlwaysWatchingOthers = 'HYPERVIGILANT_ALWAYS_WATCHING_OTHERS',
  InterruptsOthers = 'INTERRUPTS_OTHERS',
  IsAffectionate = 'IS_AFFECTIONATE',
  IsAngry = 'IS_ANGRY',
  IsArtisticCreativeOrMusical = 'IS_ARTISTIC_CREATIVE_OR_MUSICAL',
  IsEasilyDistracted = 'IS_EASILY_DISTRACTED',
  IsHypersensitiveOrHyposensitive = 'IS_HYPERSENSITIVE_OR_HYPOSENSITIVE',
  IsOnTheGoOrActsAsIfDrivenByAMotor = 'IS_ON_THE_GO_OR_ACTS_AS_IF_DRIVEN_BY_A_MOTOR',
  IsSadOrIrritatedMostOfTheDay = 'IS_SAD_OR_IRRITATED_MOST_OF_THE_DAY',
  IsVeryTenseWorriedOrAnxious = 'IS_VERY_TENSE_WORRIED_OR_ANXIOUS',
  LackOfRemorseOrConscience = 'LACK_OF_REMORSE_OR_CONSCIENCE',
  LanguageComment = 'LANGUAGE_COMMENT',
  LiesToGetThingsOrAvoidResponsibility = 'LIES_TO_GET_THINGS_OR_AVOID_RESPONSIBILITY',
  LikesAnimals = 'LIKES_ANIMALS',
  LikesSchool = 'LIKES_SCHOOL',
  LosesTemperOrTemperTantrums = 'LOSES_TEMPER_OR_TEMPER_TANTRUMS',
  MoodComment = 'MOOD_COMMENT',
  OddIdeasComment = 'ODD_IDEAS_COMMENT',
  PhysicalFights = 'PHYSICAL_FIGHTS',
  PoorAppetite = 'POOR_APPETITE',
  PoorEyeContactEvenIfNotInTrouble = 'POOR_EYE_CONTACT_EVEN_IF_NOT_IN_TROUBLE',
  ReenactsTraumaThroughPlayOrActsOutSexuallyOrAggressively = 'REENACTS_TRAUMA_THROUGH_PLAY_OR_ACTS_OUT_SEXUALLY_OR_AGGRESSIVELY',
  RelatesToOthersOnOnlyASuperficialLevel = 'RELATES_TO_OTHERS_ON_ONLY_A_SUPERFICIAL_LEVEL',
  ReportsTraumaDreams = 'REPORTS_TRAUMA_DREAMS',
  RushesThroughTasksOrGivesUpEasily = 'RUSHES_THROUGH_TASKS_OR_GIVES_UP_EASILY',
  SeemsEmotionallyNumb = 'SEEMS_EMOTIONALLY_NUMB',
  SeemsToHaveALackOfPurpose = 'SEEMS_TO_HAVE_A_LACK_OF_PURPOSE',
  SenseOfHumor = 'SENSE_OF_HUMOR',
  ShowsLittleAffectionDoesNotAcceptAffectionFromOthers = 'SHOWS_LITTLE_AFFECTION_DOES_NOT_ACCEPT_AFFECTION_FROM_OTHERS',
  ShowsLittleInterestInPleasurableActivities = 'SHOWS_LITTLE_INTEREST_IN_PLEASURABLE_ACTIVITIES',
  ShowsLittleOrNotInterestInOtherPeoplesFeelings = 'SHOWS_LITTLE_OR_NOT_INTEREST_IN_OTHER_PEOPLES_FEELINGS',
  SocialSkillsComment = 'SOCIAL_SKILLS_COMMENT',
  SomaticComment = 'SOMATIC_COMMENT',
  SometimesIsSoWoundUpOrHyperThatTheyDoNotSleepForADayOrTwo = 'SOMETIMES_IS_SO_WOUND_UP_OR_HYPER_THAT_THEY_DO_NOT_SLEEP_FOR_A_DAY_OR_TWO',
  StaresEasily = 'STARES_EASILY',
  StrengthsComment = 'STRENGTHS_COMMENT',
  SubstanceAbuse = 'SUBSTANCE_ABUSE',
  TalksAboutKillingThemselvesOrNotWantingToLive = 'TALKS_ABOUT_KILLING_THEMSELVES_OR_NOT_WANTING_TO_LIVE',
  TalksToImaginaryPeople = 'TALKS_TO_IMAGINARY_PEOPLE',
  TraumaComment = 'TRAUMA_COMMENT',
  TroubleCompletingTasks = 'TROUBLE_COMPLETING_TASKS',
  VeryManipulative = 'VERY_MANIPULATIVE',
  WakesFrequentlyInTheNightAndHasTroubleGettingBackToSleep = 'WAKES_FREQUENTLY_IN_THE_NIGHT_AND_HAS_TROUBLE_GETTING_BACK_TO_SLEEP',
  WetsOrSoilsSelfDuringDaytimeHours = 'WETS_OR_SOILS_SELF_DURING_DAYTIME_HOURS',
  WetsOrSoilsTheBed = 'WETS_OR_SOILS_THE_BED'
}

export type TherapeuticServiceInput = {
  hours: Scalars['String']['input'];
  service: Scalars['String']['input'];
  therapeuticServiceId?: InputMaybe<Scalars['ID']['input']>;
};

export type TherapySessionType = Node & {
  __typename?: 'TherapySessionType';
  billingCode?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<UserType>;
  createdDate: Scalars['DateTime']['output'];
  endDatetime?: Maybe<Scalars['DateTime']['output']>;
  externalId?: Maybe<Scalars['String']['output']>;
  /** The ID of the object */
  id: Scalars['ID']['output'];
  lastUpdatedDate: Scalars['DateTime']['output'];
  locationType?: Maybe<Scalars['String']['output']>;
  organization: OrganizationType;
  pk?: Maybe<Scalars['Int']['output']>;
  sessionTimezone?: Maybe<Scalars['String']['output']>;
  sessionType?: Maybe<ApiTherapySessionSessionTypeChoices>;
  sessionlearnerSet: SessionLearnerTypeConnection;
  sessionnoteSet: SessionNoteTypeConnection;
  sessionproviderSet: SessionProviderTypeConnection;
  sessiontargetprogressSet: SessionTargetProgressTypeConnection;
  startDatetime?: Maybe<Scalars['DateTime']['output']>;
  status?: Maybe<ApiTherapySessionStatusChoices>;
  videosessionSet: VideoSessionTypeConnection;
};


export type TherapySessionTypeSessionlearnerSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  videoSession_SessionStatus?: InputMaybe<ApiVideoSessionSessionStatusChoices>;
};


export type TherapySessionTypeSessionnoteSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdDate?: InputMaybe<Scalars['DateTime']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedDate?: InputMaybe<Scalars['DateTime']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  organization?: InputMaybe<Scalars['ID']['input']>;
  qaDescription?: InputMaybe<Scalars['String']['input']>;
  qaExternalId?: InputMaybe<Scalars['String']['input']>;
  qaResponse?: InputMaybe<Scalars['String']['input']>;
  qaTitle?: InputMaybe<Scalars['String']['input']>;
  qaType?: InputMaybe<ApiSessionNoteQaTypeChoices>;
  sectionDescription?: InputMaybe<Scalars['String']['input']>;
  sectionExternalId?: InputMaybe<Scalars['String']['input']>;
  sectionTitle?: InputMaybe<Scalars['String']['input']>;
  therapySession?: InputMaybe<Scalars['ID']['input']>;
};


export type TherapySessionTypeSessionproviderSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdDate?: InputMaybe<Scalars['DateTime']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedDate?: InputMaybe<Scalars['DateTime']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  organization?: InputMaybe<Scalars['ID']['input']>;
  provider?: InputMaybe<Scalars['ID']['input']>;
  providerType?: InputMaybe<ApiSessionProviderProviderTypeChoices>;
  therapySession?: InputMaybe<Scalars['ID']['input']>;
  videoSession?: InputMaybe<Scalars['ID']['input']>;
};


export type TherapySessionTypeSessiontargetprogressSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  count?: InputMaybe<Scalars['Float']['input']>;
  createdDate?: InputMaybe<Scalars['DateTime']['input']>;
  date?: InputMaybe<Scalars['DateTime']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  goal?: InputMaybe<Scalars['ID']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedDate?: InputMaybe<Scalars['DateTime']['input']>;
  learner?: InputMaybe<Scalars['ID']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  organization?: InputMaybe<Scalars['ID']['input']>;
  progressType?: InputMaybe<ApiSessionTargetProgressProgressTypeChoices>;
  target?: InputMaybe<Scalars['ID']['input']>;
  therapySession?: InputMaybe<Scalars['ID']['input']>;
  total?: InputMaybe<Scalars['Float']['input']>;
};


export type TherapySessionTypeVideosessionSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdDate?: InputMaybe<Scalars['DateTime']['input']>;
  date?: InputMaybe<Scalars['Date']['input']>;
  endDatetime?: InputMaybe<Scalars['DateTime']['input']>;
  engagementScore?: InputMaybe<Scalars['Float']['input']>;
  engagementScoreVersion?: InputMaybe<Scalars['String']['input']>;
  finalMedia?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedDate?: InputMaybe<Scalars['DateTime']['input']>;
  meetingId?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  organization?: InputMaybe<Scalars['ID']['input']>;
  recorderType?: InputMaybe<ApiVideoSessionRecorderTypeChoices>;
  sessionRating?: InputMaybe<Scalars['Int']['input']>;
  sessionStatus?: InputMaybe<ApiVideoSessionSessionStatusChoices>;
  sourceType?: InputMaybe<ApiVideoSessionSourceTypeChoices>;
  startDatetime?: InputMaybe<Scalars['DateTime']['input']>;
  therapySession?: InputMaybe<Scalars['ID']['input']>;
};

export type TherapySessionTypeConnection = {
  __typename?: 'TherapySessionTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<TherapySessionTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `TherapySessionType` and its cursor. */
export type TherapySessionTypeEdge = {
  __typename?: 'TherapySessionTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<TherapySessionType>;
};

export type TherapzEhrTargetInput = {
  description: Scalars['String']['input'];
  discriminativeStimulus: Scalars['String']['input'];
  ehrId: Scalars['String']['input'];
  fdmId: Scalars['ID']['input'];
  masteredOverType: Scalars['String']['input'];
  masteredOverValue: Scalars['Int']['input'];
  measureType: Scalars['String']['input'];
  measureValue: Scalars['Int']['input'];
  phase: Scalars['String']['input'];
  targetMasteryDate: Scalars['Date']['input'];
  threshold: Scalars['String']['input'];
  title: Scalars['String']['input'];
  type: Scalars['String']['input'];
};

export type TherapzGoalType = Node & {
  __typename?: 'TherapzGoalType';
  aiGenerated: Scalars['Boolean']['output'];
  createdDate: Scalars['DateTime']['output'];
  dataCollectionType: ApiTherapzGoalDataCollectionTypeChoices;
  description?: Maybe<Scalars['String']['output']>;
  externalId: Scalars['String']['output'];
  goal: GoalType;
  /** The ID of the object */
  id: Scalars['ID']['output'];
  inUse: Scalars['Boolean']['output'];
  labels?: Maybe<Scalars['JSONString']['output']>;
  lastUpdatedDate: Scalars['DateTime']['output'];
  organization: OrganizationType;
  phase: Scalars['String']['output'];
  pk?: Maybe<Scalars['Int']['output']>;
  therapztargetSet: TherapzTargetTypeConnection;
  title: Scalars['String']['output'];
  type: ApiTherapzGoalTypeChoices;
};


export type TherapzGoalTypeTherapztargetSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  aiGenerated?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdDate?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  discriminativeStimulus?: InputMaybe<Scalars['String']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  inUse?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedDate?: InputMaybe<Scalars['DateTime']['input']>;
  masteredOverType?: InputMaybe<Scalars['String']['input']>;
  masteredOverValue?: InputMaybe<Scalars['Int']['input']>;
  measureType?: InputMaybe<Scalars['String']['input']>;
  measureValue?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  organization?: InputMaybe<Scalars['ID']['input']>;
  phase?: InputMaybe<Scalars['String']['input']>;
  target?: InputMaybe<Scalars['ID']['input']>;
  targetMasteryDate?: InputMaybe<Scalars['Date']['input']>;
  therapzGoal?: InputMaybe<Scalars['ID']['input']>;
  threshold?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type TherapzGoalTypeConnection = {
  __typename?: 'TherapzGoalTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<TherapzGoalTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `TherapzGoalType` and its cursor. */
export type TherapzGoalTypeEdge = {
  __typename?: 'TherapzGoalTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<TherapzGoalType>;
};

export type TherapzTargetType = Node & {
  __typename?: 'TherapzTargetType';
  aiGenerated: Scalars['Boolean']['output'];
  createdDate: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  discriminativeStimulus?: Maybe<Scalars['String']['output']>;
  externalId: Scalars['String']['output'];
  /** The ID of the object */
  id: Scalars['ID']['output'];
  inUse: Scalars['Boolean']['output'];
  lastUpdatedDate: Scalars['DateTime']['output'];
  masteredOverType: Scalars['String']['output'];
  masteredOverValue: Scalars['Int']['output'];
  measureType: Scalars['String']['output'];
  measureValue: Scalars['Int']['output'];
  organization: OrganizationType;
  phase: Scalars['String']['output'];
  pk?: Maybe<Scalars['Int']['output']>;
  target: TargetType;
  targetMasteryDate: Scalars['Date']['output'];
  therapzGoal: TherapzGoalType;
  threshold: Scalars['String']['output'];
  title: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type TherapzTargetTypeConnection = {
  __typename?: 'TherapzTargetTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<TherapzTargetTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `TherapzTargetType` and its cursor. */
export type TherapzTargetTypeEdge = {
  __typename?: 'TherapzTargetTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<TherapzTargetType>;
};

export type ThumbnailManifestType = {
  __typename?: 'ThumbnailManifestType';
  intervalSeconds?: Maybe<Scalars['Int']['output']>;
  mediaId?: Maybe<Scalars['Int']['output']>;
  thumbnails?: Maybe<Array<Maybe<ThumbnailType>>>;
};

export type ThumbnailType = {
  __typename?: 'ThumbnailType';
  time?: Maybe<Scalars['Int']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type TotalVideoDurationRawDataType = {
  __typename?: 'TotalVideoDurationRawDataType';
  rawData?: Maybe<Array<Maybe<TotalVideoDurationRawTextDataType>>>;
  totalRecordsCount?: Maybe<Scalars['Int']['output']>;
};

export type TotalVideoDurationRawTextDataType = {
  __typename?: 'TotalVideoDurationRawTextDataType';
  clientId?: Maybe<Scalars['Int']['output']>;
  clientName?: Maybe<Scalars['String']['output']>;
  rbtName?: Maybe<Scalars['String']['output']>;
  sessionDate?: Maybe<Scalars['Date']['output']>;
  sessionDatetime?: Maybe<Scalars['DateTime']['output']>;
  sessionDurationInSeconds?: Maybe<Scalars['Float']['output']>;
};

export type TotalVideoOverviewRawTextDataType = {
  __typename?: 'TotalVideoOverviewRawTextDataType';
  clientId?: Maybe<Scalars['Int']['output']>;
  clientName?: Maybe<Scalars['String']['output']>;
  recorder?: Maybe<Scalars['String']['output']>;
  sessionDate?: Maybe<Scalars['Date']['output']>;
  sessionDuration?: Maybe<Scalars['Float']['output']>;
};

export type TotalVideosOverviewGraphType = {
  __typename?: 'TotalVideosOverviewGraphType';
  currentCount?: Maybe<Scalars['Int']['output']>;
  date?: Maybe<Scalars['String']['output']>;
  previousCount?: Maybe<Scalars['Int']['output']>;
};

export type TotalVideosOverviewRawTextType = {
  __typename?: 'TotalVideosOverviewRawTextType';
  rawData?: Maybe<Array<Maybe<TotalVideoOverviewRawTextDataType>>>;
  totalRecordsCount?: Maybe<Scalars['Int']['output']>;
};

export type TranscriptCsvContentType = {
  __typename?: 'TranscriptCsvContentType';
  csvContent?: Maybe<Scalars['String']['output']>;
  filename?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
  status: Scalars['Boolean']['output'];
};

export type TranscriptLineRecordType = Node & {
  __typename?: 'TranscriptLineRecordType';
  conversation: Scalars['String']['output'];
  createdDate: Scalars['DateTime']['output'];
  endTime: Scalars['Float']['output'];
  /** The ID of the object */
  id: Scalars['ID']['output'];
  lastUpdatedDate: Scalars['DateTime']['output'];
  media: MediaType;
  organization: OrganizationType;
  pk?: Maybe<Scalars['Int']['output']>;
  speaker: Scalars['String']['output'];
  startTime: Scalars['Float']['output'];
  transcriptFile?: Maybe<TranscriptType>;
  updatedBy?: Maybe<UserType>;
};

export type TranscriptLineRecordTypeConnection = {
  __typename?: 'TranscriptLineRecordTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<TranscriptLineRecordTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `TranscriptLineRecordType` and its cursor. */
export type TranscriptLineRecordTypeEdge = {
  __typename?: 'TranscriptLineRecordTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<TranscriptLineRecordType>;
};

export type TranscriptLinesInput = {
  conversation: Scalars['String']['input'];
  endTime: Scalars['Float']['input'];
  speaker: Scalars['String']['input'];
  startTime: Scalars['Float']['input'];
};

export type TranscriptType = Node & {
  __typename?: 'TranscriptType';
  aiModelVersion?: Maybe<Scalars['String']['output']>;
  createdDate: Scalars['DateTime']['output'];
  filePath?: Maybe<Scalars['String']['output']>;
  /** The ID of the object */
  id: Scalars['ID']['output'];
  lastUpdatedDate: Scalars['DateTime']['output'];
  organization: OrganizationType;
  pk?: Maybe<Scalars['Int']['output']>;
  streamTranscript?: Maybe<MediaStreamType>;
  transcriptFile: TranscriptLineRecordTypeConnection;
  transcriptMedia?: Maybe<MediaType>;
  transcriptModel: ApiTranscriptTranscriptModelChoices;
  transcriptType: ApiTranscriptTranscriptTypeChoices;
  videoSession?: Maybe<VideoSessionType>;
};


export type TranscriptTypeTranscriptFileArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  speaker?: InputMaybe<Scalars['String']['input']>;
};

export type TranscriptTypeConnection = {
  __typename?: 'TranscriptTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<TranscriptTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `TranscriptType` and its cursor. */
export type TranscriptTypeEdge = {
  __typename?: 'TranscriptTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<TranscriptType>;
};

export enum TreatmentPlanAiGoalsPredictionStatusEnums {
  Failure = 'FAILURE',
  GoalPredictionPending = 'GOAL_PREDICTION_PENDING',
  GoalPredictionPredicted = 'GOAL_PREDICTION_PREDICTED',
  GoalPredictionSkipped = 'GOAL_PREDICTION_SKIPPED',
  Pending = 'PENDING'
}

export type TreatmentPlanCustomFieldType = Node & {
  __typename?: 'TreatmentPlanCustomFieldType';
  content?: Maybe<Scalars['String']['output']>;
  createdDate: Scalars['DateTime']['output'];
  domain?: Maybe<ReportDomainType>;
  fieldIdentifier: Scalars['String']['output'];
  fieldType: ApiTreatmentPlanCustomFieldFieldTypeChoices;
  /** The ID of the object */
  id: Scalars['ID']['output'];
  imageSignedUrl?: Maybe<Scalars['String']['output']>;
  isAuditable: Scalars['Boolean']['output'];
  isEnabled: Scalars['Boolean']['output'];
  isRequired: Scalars['Boolean']['output'];
  lastUpdatedDate: Scalars['DateTime']['output'];
  organization: OrganizationType;
  pk?: Maybe<Scalars['Int']['output']>;
  rankOrder: Scalars['Int']['output'];
  reportGoal?: Maybe<ReportGoalType>;
  reportTarget?: Maybe<ReportTargetType>;
  reportTreatmentPlan: ReportTreatmentPlanType;
  templateField?: Maybe<TreatmentPlanTemplateFieldType>;
  title?: Maybe<Scalars['String']['output']>;
};

export type TreatmentPlanCustomFieldTypeConnection = {
  __typename?: 'TreatmentPlanCustomFieldTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<TreatmentPlanCustomFieldTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `TreatmentPlanCustomFieldType` and its cursor. */
export type TreatmentPlanCustomFieldTypeEdge = {
  __typename?: 'TreatmentPlanCustomFieldTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<TreatmentPlanCustomFieldType>;
};

/** Treatment plan data with simplified goal and targets */
export type TreatmentPlanGoalAndTargetType = {
  __typename?: 'TreatmentPlanGoalAndTargetType';
  goal?: Maybe<SimplifiedGoalType>;
  targets?: Maybe<Array<Maybe<SimplifiedTargetType>>>;
};

export type TreatmentPlanGoalsBehaviorDetailsInput = {
  antecedentStrategy?: InputMaybe<Scalars['String']['input']>;
  consequencesStrategy?: InputMaybe<Scalars['String']['input']>;
  hypothesizedFunction?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['String']['input']>;
  onset?: InputMaybe<Scalars['String']['input']>;
  operationalDefinition?: InputMaybe<Scalars['String']['input']>;
  replacementBehavior?: InputMaybe<Scalars['String']['input']>;
};

export type TreatmentPlanGoalsSkillDetailsInput = {
  discriminativeStimulus?: InputMaybe<Scalars['String']['input']>;
  errorCorrectionStrategy?: InputMaybe<Scalars['String']['input']>;
  expectedResponse?: InputMaybe<Scalars['String']['input']>;
  promptingInstructions?: InputMaybe<Scalars['String']['input']>;
  reinforcementStrategy?: InputMaybe<Scalars['String']['input']>;
  teachingMethod?: InputMaybe<Scalars['String']['input']>;
};

export type TreatmentPlanTemplateDomainInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  rankOrder: Scalars['Int']['input'];
  templateFields?: InputMaybe<Array<InputMaybe<TreatmentPlanTemplateFieldInput>>>;
};

export type TreatmentPlanTemplateDomainType = Node & {
  __typename?: 'TreatmentPlanTemplateDomainType';
  createdBy?: Maybe<UserType>;
  createdDate: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  /** The ID of the object */
  id: Scalars['ID']['output'];
  lastUpdatedDate: Scalars['DateTime']['output'];
  name: Scalars['String']['output'];
  pk?: Maybe<Scalars['Int']['output']>;
  rankOrder: Scalars['Int']['output'];
  templateFields: TreatmentPlanTemplateFieldTypeConnection;
  treatmentPlanTemplate: TreatmentPlanTemplateType;
};


export type TreatmentPlanTemplateDomainTypeTemplateFieldsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type TreatmentPlanTemplateDomainTypeConnection = {
  __typename?: 'TreatmentPlanTemplateDomainTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<TreatmentPlanTemplateDomainTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `TreatmentPlanTemplateDomainType` and its cursor. */
export type TreatmentPlanTemplateDomainTypeEdge = {
  __typename?: 'TreatmentPlanTemplateDomainTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<TreatmentPlanTemplateDomainType>;
};

export type TreatmentPlanTemplateFieldInput = {
  content?: InputMaybe<Scalars['String']['input']>;
  fieldType?: InputMaybe<BaseFieldType>;
  id?: InputMaybe<Scalars['ID']['input']>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isRequired?: InputMaybe<Scalars['Boolean']['input']>;
  rankOrder: Scalars['Int']['input'];
  reportGoalField?: InputMaybe<Scalars['Boolean']['input']>;
  reportTargetField?: InputMaybe<Scalars['Boolean']['input']>;
  title: Scalars['String']['input'];
  type?: InputMaybe<TreatmentPlanTemplateFieldTypeEnum>;
};

export type TreatmentPlanTemplateFieldType = Node & {
  __typename?: 'TreatmentPlanTemplateFieldType';
  /** Per-template goal-generation instructions for this field (goal-customization-ai). Empty = no template-level text; resolution falls back to the org-level rules map (org-linked templates) or the org map wins outright (shared templates). */
  aiInstructions: Scalars['String']['output'];
  content?: Maybe<Scalars['String']['output']>;
  createdDate: Scalars['DateTime']['output'];
  customFields: TreatmentPlanCustomFieldTypeConnection;
  domain?: Maybe<TreatmentPlanTemplateDomainType>;
  fieldIdentifier: Scalars['String']['output'];
  fieldType: ApiTreatmentPlanTemplateFieldFieldTypeChoices;
  /** The ID of the object */
  id: Scalars['ID']['output'];
  /** When True, this field is populated by AI goal generation: it is included in the dynamically built response schema of the *_custom goal-generation prompts (goal-customization-ai). */
  isAiGenerated: Scalars['Boolean']['output'];
  isAuditable: Scalars['Boolean']['output'];
  /** False for core native fields (see NATIVE_FIELD_SPECS). */
  isEditable: Scalars['Boolean']['output'];
  isEnabled: Scalars['Boolean']['output'];
  isRequired: Scalars['Boolean']['output'];
  lastUpdatedDate: Scalars['DateTime']['output'];
  pk?: Maybe<Scalars['Int']['output']>;
  rankOrder: Scalars['Int']['output'];
  /** When True, field_identifier maps to a native column on ReportGoal. No TreatmentPlanCustomField is created for this field. */
  reportGoalField: Scalars['Boolean']['output'];
  /** When True, field_identifier maps to a native column on ReportTarget. No TreatmentPlanCustomField is created for this field. */
  reportTargetField: Scalars['Boolean']['output'];
  title?: Maybe<Scalars['String']['output']>;
  treatmentPlanTemplate: TreatmentPlanTemplateType;
  type: ApiTreatmentPlanTemplateFieldTypeChoices;
};


export type TreatmentPlanTemplateFieldTypeCustomFieldsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  fieldIdentifier?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  reportGoal?: InputMaybe<Scalars['ID']['input']>;
  reportTarget?: InputMaybe<Scalars['ID']['input']>;
};

export type TreatmentPlanTemplateFieldTypeConnection = {
  __typename?: 'TreatmentPlanTemplateFieldTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<TreatmentPlanTemplateFieldTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `TreatmentPlanTemplateFieldType` and its cursor. */
export type TreatmentPlanTemplateFieldTypeEdge = {
  __typename?: 'TreatmentPlanTemplateFieldTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<TreatmentPlanTemplateFieldType>;
};

export enum TreatmentPlanTemplateFieldTypeEnum {
  Domain = 'DOMAIN',
  Goal = 'GOAL',
  Target = 'TARGET'
}

export type TreatmentPlanTemplateInput = {
  aiGenerationConfig?: InputMaybe<Scalars['String']['input']>;
  defaultFields?: InputMaybe<Array<InputMaybe<TreatmentPlanTemplateFieldInput>>>;
  domains?: InputMaybe<Array<InputMaybe<TreatmentPlanTemplateDomainInput>>>;
  isAddTargetsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isGoalBankSuggestionsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TreatmentPlanTemplateType = Node & {
  __typename?: 'TreatmentPlanTemplateType';
  aiGenerationConfig: ApiTreatmentPlanTemplateAiGenerationConfigChoices;
  createdDate: Scalars['DateTime']['output'];
  domains: TreatmentPlanTemplateDomainTypeConnection;
  /** The ID of the object */
  id: Scalars['ID']['output'];
  isAddTargetsEnabled: Scalars['Boolean']['output'];
  isGasEnabled: Scalars['Boolean']['output'];
  isGoalBankSuggestionsEnabled: Scalars['Boolean']['output'];
  isMedicalNecessityEnabled: Scalars['Boolean']['output'];
  lastUpdatedDate: Scalars['DateTime']['output'];
  pk?: Maybe<Scalars['Int']['output']>;
  reportTemplates: ReportTemplateTypeConnection;
  templateFields: TreatmentPlanTemplateFieldTypeConnection;
};


export type TreatmentPlanTemplateTypeDomainsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type TreatmentPlanTemplateTypeReportTemplatesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdDate?: InputMaybe<Scalars['DateTime']['input']>;
  curriculum?: InputMaybe<Scalars['ID']['input']>;
  defaultPayorTemplate?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  enterpriseTemplate?: InputMaybe<Scalars['Boolean']['input']>;
  exportFramework?: InputMaybe<ApiReportTemplateExportFrameworkChoices>;
  exportTemplateFont?: InputMaybe<ApiReportTemplateExportTemplateFontChoices>;
  fileUploadConfig?: InputMaybe<ApiReportTemplateFileUploadConfigChoices>;
  finalApproverWaitsForReviewers?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  footerText?: InputMaybe<Scalars['String']['input']>;
  headerText?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  isBaseTemplate?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedDate?: InputMaybe<Scalars['DateTime']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderedReplacement?: InputMaybe<Scalars['Boolean']['input']>;
  organizationLogoAllowed?: InputMaybe<Scalars['Boolean']['input']>;
  payorType?: InputMaybe<ApiReportTemplatePayorTypeChoices>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  publishedBy?: InputMaybe<Scalars['ID']['input']>;
  reportNarrativeMappingWorkflow?: InputMaybe<Scalars['Boolean']['input']>;
  reportType?: InputMaybe<ApiReportTemplateReportTypeChoices>;
  requireAllQaResolved?: InputMaybe<Scalars['Boolean']['input']>;
  requireApprovalBeforeExport?: InputMaybe<Scalars['Boolean']['input']>;
  sampleFile?: InputMaybe<Scalars['String']['input']>;
  sampleStatus?: InputMaybe<ApiReportTemplateSampleStatusChoices>;
  status?: InputMaybe<ApiReportTemplateStatusChoices>;
  templateLogoUrl?: InputMaybe<Scalars['String']['input']>;
  templateUrl?: InputMaybe<Scalars['String']['input']>;
  treatmentPlanTemplate?: InputMaybe<Scalars['ID']['input']>;
  unifiedExport?: InputMaybe<Scalars['Boolean']['input']>;
  updatedBy?: InputMaybe<Scalars['ID']['input']>;
};


export type TreatmentPlanTemplateTypeTemplateFieldsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type UiUpdateLoginStatusMutation = {
  __typename?: 'UIUpdateLoginStatusMutation';
  message?: Maybe<Scalars['String']['output']>;
};

export type UnassignCaregiverFromLearner = {
  __typename?: 'UnassignCaregiverFromLearner';
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

/** Unified enum combining all goal status values from Frontera, Passage, HiRasmus, Motivity, Central Reach, Hipp Health, and Rethink */
export enum UnifiedGoalStatusEnum {
  Active = 'ACTIVE',
  Archived = 'ARCHIVED',
  Baseline = 'BASELINE',
  BaselineAssess = 'BASELINE_ASSESS',
  Closed = 'CLOSED',
  Completed = 'COMPLETED',
  Deactivated = 'DEACTIVATED',
  Discontinued = 'DISCONTINUED',
  Future = 'FUTURE',
  Generalization = 'GENERALIZATION',
  Hold = 'HOLD',
  Inactive = 'INACTIVE',
  InMaintenance = 'IN_MAINTENANCE',
  InProgress = 'IN_PROGRESS',
  Maintenance = 'MAINTENANCE',
  Mastered = 'MASTERED',
  Met = 'MET',
  NotActive = 'NOT_ACTIVE',
  NotIntroduced = 'NOT_INTRODUCED',
  OnHold = 'ON_HOLD',
  Progress = 'PROGRESS',
  Treatment = 'TREATMENT',
  Waiting = 'WAITING'
}

/** Unified enum combining all target status values from Frontera, Passage, HiRasmus, Motivity, Central Reach, and Rethink */
export enum UnifiedTargetStatusEnum {
  Acquisition = 'ACQUISITION',
  AlreadyKnown = 'ALREADY_KNOWN',
  Assess = 'ASSESS',
  Baseline = 'BASELINE',
  BaselineAssess = 'BASELINE_ASSESS',
  Closed = 'CLOSED',
  Completed = 'COMPLETED',
  Custom = 'CUSTOM',
  Deactivated = 'DEACTIVATED',
  Discontinued = 'DISCONTINUED',
  Generalization = 'GENERALIZATION',
  Hold = 'HOLD',
  Inactive = 'INACTIVE',
  Intervention = 'INTERVENTION',
  InMaintenance = 'IN_MAINTENANCE',
  Maintain = 'MAINTAIN',
  Maintenance = 'MAINTENANCE',
  Mastered = 'MASTERED',
  Met = 'MET',
  NotActive = 'NOT_ACTIVE',
  NotStarted = 'NOT_STARTED',
  OnHold = 'ON_HOLD',
  Probe = 'PROBE',
  Progress = 'PROGRESS',
  Reintroduced = 'REINTRODUCED',
  Started = 'STARTED',
  Track = 'TRACK',
  Train = 'TRAIN',
  Treatment = 'TREATMENT',
  Waiting = 'WAITING'
}

/**
 * Unlock an item and everything under it so its roles can change again.
 *
 * Changes nothing else; the next lock applies the differences (archive,
 * move, open reports). Same permission as Lock.
 */
export type UnlockCrLearningTreeBranch = {
  __typename?: 'UnlockCRLearningTreeBranch';
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
  unlocked?: Maybe<Scalars['Int']['output']>;
};

export type UpdateAnnotation = {
  __typename?: 'UpdateAnnotation';
  updatedAnnotation?: Maybe<AnnotationType>;
};

export type UpdateAnnotatorAuth0IdInput = {
  auth0Id: Scalars['String']['input'];
  email: Scalars['String']['input'];
};

export type UpdateAnnotatorInput = {
  annotatorUserId: Scalars['ID']['input'];
  firstName: Scalars['String']['input'];
  lastName?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateAnnotatorUser = {
  __typename?: 'UpdateAnnotatorUser';
  annotatorUserDetails?: Maybe<AnnotatorUserType>;
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type UpdateAnnotatorUserAuth0Id = {
  __typename?: 'UpdateAnnotatorUserAuth0Id';
  annotatorUserDetails?: Maybe<AnnotatorUserType>;
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

/** Update name, content, and/or category on a base SuggestionCriteria */
export type UpdateBaseSuggestionCriteria = {
  __typename?: 'UpdateBaseSuggestionCriteria';
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
  suggestionCriteria?: Maybe<SuggestionCriteriaType>;
};

export type UpdateBillableSessionSummary = {
  __typename?: 'UpdateBillableSessionSummary';
  billableSummaryData?: Maybe<BillableSessionSummaryType>;
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type UpdateBillableSummaryNoteInput = {
  errorMessage?: InputMaybe<Scalars['String']['input']>;
  externalProviderId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  providerFirstName?: InputMaybe<Scalars['String']['input']>;
  providerLastName?: InputMaybe<Scalars['String']['input']>;
  sessionCode?: InputMaybe<Scalars['String']['input']>;
  status: BillableSessionSummaryStatusEnums;
  summaryGeneratedAt?: InputMaybe<Scalars['DateTime']['input']>;
  summaryText?: InputMaybe<Scalars['String']['input']>;
  vellumPredictionId?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
};

/** Mutation to update custom fields on an appointment */
export type UpdateCareAppointmentCustomFields = {
  __typename?: 'UpdateCareAppointmentCustomFields';
  appointment?: Maybe<CareAppointmentType>;
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

/** Mutation to update the notes field of an appointment */
export type UpdateCareAppointmentNote = {
  __typename?: 'UpdateCareAppointmentNote';
  appointment?: Maybe<CareAppointmentType>;
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type UpdateCaregiverConsents = {
  __typename?: 'UpdateCaregiverConsents';
  consents?: Maybe<Array<Maybe<CaregiverConsentType>>>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type UpdateCaregiverLearnerRelationship = {
  __typename?: 'UpdateCaregiverLearnerRelationship';
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type UpdateCaregiverLearnerRelationshipInput = {
  caregiverId?: InputMaybe<Scalars['ID']['input']>;
  learnerId: Scalars['ID']['input'];
  socialRelationship: Scalars['String']['input'];
};

export type UpdateCaregiverMetadata = {
  __typename?: 'UpdateCaregiverMetadata';
  caregiverMetadata?: Maybe<CaregiverMetadataType>;
};

export type UpdateCaregiverSupportNotes = {
  __typename?: 'UpdateCaregiverSupportNotes';
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type UpdateChat = {
  __typename?: 'UpdateChat';
  chat?: Maybe<ChatType>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type UpdateChatConversationSummary = {
  __typename?: 'UpdateChatConversationSummary';
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type UpdateChatInput = {
  careStage?: InputMaybe<ChatCareStage>;
  chatId: Scalars['ID']['input'];
  messageDraft?: InputMaybe<Scalars['String']['input']>;
  /** list of chat tag IDs */
  tags?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};

export type UpdateChatMessage = {
  __typename?: 'UpdateChatMessage';
  chatMessage?: Maybe<ChatMessageType>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type UpdateChatMessageInput = {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  chatMessageId: Scalars['ID']['input'];
  content?: InputMaybe<Scalars['String']['input']>;
};

/** Update title for INTAKE and ASSISTANT chats. */
export type UpdateChatTitle = {
  __typename?: 'UpdateChatTitle';
  chat?: Maybe<ChatType>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type UpdateChatTitleInput = {
  chatId: Scalars['ID']['input'];
  title: Scalars['String']['input'];
};

/** Update processing status for INTAKE and ASSISTANT chats. */
export type UpdateChatbotProcessingStatus = {
  __typename?: 'UpdateChatbotProcessingStatus';
  chat?: Maybe<ChatType>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type UpdateChatbotProcessingStatusInput = {
  chatId: Scalars['ID']['input'];
  status: Scalars['String']['input'];
  statusType: Scalars['String']['input'];
};

export type UpdateClipAnnotationStatus = {
  __typename?: 'UpdateClipAnnotationStatus';
  clipAnnotation?: Maybe<ClipAnnotationType>;
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type UpdateClipAnnotationStatusInput = {
  clipAnnotationId: Scalars['ID']['input'];
  status: AnnotationStatusEnumType;
};

export type UpdateClipAssignment = {
  __typename?: 'UpdateClipAssignment';
  clipAssignmentData?: Maybe<ClipAnnotationType>;
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type UpdateClipAssignmentInput = {
  annotationTag?: InputMaybe<Scalars['ID']['input']>;
  assigneeId?: InputMaybe<Scalars['ID']['input']>;
  clipAssignmentId: Scalars['ID']['input'];
  status?: InputMaybe<AnnotationStatusEnumType>;
};

export type UpdateDomainConfig = {
  __typename?: 'UpdateDomainConfig';
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type UpdateDomainConfigInput = {
  categoryConfigType: Scalars['String']['input'];
  goalCategories: Array<DomainInput>;
};

export type UpdateEhrGoalsAndTargets = {
  __typename?: 'UpdateEHRGoalsAndTargets';
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type UpdateEhrGoalsInput = {
  ehrId: Scalars['String']['input'];
  fdmId: Scalars['ID']['input'];
  targets: Array<InputMaybe<PassageEhrTargetInput>>;
  title: Scalars['String']['input'];
};

export type UpdateEnterpriseReportExportTemplate = {
  __typename?: 'UpdateEnterpriseReportExportTemplate';
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

/** The mutation updates the given report template by ID. */
export type UpdateEnterpriseReportTemplate = {
  __typename?: 'UpdateEnterpriseReportTemplate';
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type UpdateEnterpriseReportTemplateInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  exportFramework?: InputMaybe<Scalars['String']['input']>;
  font?: InputMaybe<ReportTemplateExportFontEnums>;
  footerText?: InputMaybe<Scalars['String']['input']>;
  goalBankCurriculumId?: InputMaybe<Scalars['ID']['input']>;
  headerText?: InputMaybe<Scalars['String']['input']>;
  inputDependency?: InputMaybe<Array<InputMaybe<InputDependencyChoices>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  organizations?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  reportTemplateId: Scalars['ID']['input'];
  reportTemplateSections?: InputMaybe<Array<InputMaybe<EnterpriseReportTemplateSectionInput>>>;
  status?: InputMaybe<ReportTemplateStatus>;
  templateUrl?: InputMaybe<Scalars['String']['input']>;
  treatmentPlanTemplate?: InputMaybe<TreatmentPlanTemplateInput>;
};

export type UpdateGasExtractionDataM2M = {
  __typename?: 'UpdateGASExtractionDataM2M';
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type UpdateGoal = {
  __typename?: 'UpdateGoal';
  data?: Maybe<GoalType>;
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type UpdateGoalAttainmentScaleM2M = {
  __typename?: 'UpdateGoalAttainmentScaleM2M';
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type UpdateGoalBankFolder = {
  __typename?: 'UpdateGoalBankFolder';
  goalBankFolder?: Maybe<GoalBankFolderType>;
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type UpdateGoalBankFolderInput = {
  folderId: Scalars['ID']['input'];
  folderType: GoalBankFolderTypeEnum;
  name: Scalars['String']['input'];
};

export type UpdateGoalBankGoal = {
  __typename?: 'UpdateGoalBankGoal';
  goalBankShortGoalData?: Maybe<ReportGoalBankType>;
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type UpdateGoalBankGoalInput = {
  assessmentToolSource?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  domainId?: InputMaybe<Scalars['ID']['input']>;
  goalBankShortTermId: Scalars['ID']['input'];
  goalName: Scalars['String']['input'];
  hasMedicalNecessity?: InputMaybe<Scalars['Boolean']['input']>;
  longTermGoalBankId?: InputMaybe<Scalars['ID']['input']>;
  masteryCriteria?: InputMaybe<Scalars['String']['input']>;
  medicalNecessityCriteria?: InputMaybe<Scalars['String']['input']>;
  medicalRationale?: InputMaybe<Scalars['String']['input']>;
  programGoal?: InputMaybe<Scalars['String']['input']>;
  timelineEstimationType?: InputMaybe<ShortTermTimelineEstimationEnums>;
  timelineEstimationValue?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateGoalBankLongTermGoal = {
  __typename?: 'UpdateGoalBankLongTermGoal';
  goalBankLongGoalData?: Maybe<LongTermGoalBankType>;
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type UpdateGoalBankLongTermGoalInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  goalBankLongTermId: Scalars['ID']['input'];
  goalName: Scalars['String']['input'];
  goalType: GoalTypeEnums;
};

export type UpdateGoalBankTarget = {
  __typename?: 'UpdateGoalBankTarget';
  goalBankTargetData?: Maybe<ReportTargetGoalBankType>;
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type UpdateGoalBankTargetInput = {
  goalBankId: Scalars['ID']['input'];
  goalBankTargetId: Scalars['ID']['input'];
  masteryCriteria?: InputMaybe<Scalars['String']['input']>;
  medicalRationale?: InputMaybe<Scalars['String']['input']>;
  targetDescription?: InputMaybe<Scalars['String']['input']>;
  targetName: Scalars['String']['input'];
  timelineEstimationType?: InputMaybe<TargetTimelineEstimationEnums>;
  timelineEstimationValue?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateGoalBaselineDataM2M = {
  __typename?: 'UpdateGoalBaselineDataM2M';
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type UpdateGoalExcludeFromReport = {
  __typename?: 'UpdateGoalExcludeFromReport';
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type UpdateGoalExcludeFromReportInput = {
  excludeFromReport: Scalars['Boolean']['input'];
  reportGoalId: Scalars['ID']['input'];
};

export type UpdateGoalInput = {
  id: Scalars['ID']['input'];
  isPinned?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateGoalPredictionStatusM2M = {
  __typename?: 'UpdateGoalPredictionStatusM2M';
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type UpdateGoalProgressSummariesM2M = {
  __typename?: 'UpdateGoalProgressSummariesM2M';
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type UpdateGoalProgressSummary = {
  __typename?: 'UpdateGoalProgressSummary';
  message?: Maybe<Scalars['String']['output']>;
  signedChartImageUrl?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
  summaryReviewedOn?: Maybe<Scalars['DateTime']['output']>;
};

export type UpdateGoalProgressSummaryInput = {
  chartFromDate?: InputMaybe<Scalars['Date']['input']>;
  chartImageUri?: InputMaybe<Scalars['String']['input']>;
  chartToDate?: InputMaybe<Scalars['Date']['input']>;
  chartType: Scalars['String']['input'];
  goalId: Scalars['ID']['input'];
  isApproved: Scalars['Boolean']['input'];
  progressSummary?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateGoalProgressSummaryM2M = {
  __typename?: 'UpdateGoalProgressSummaryM2M';
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

/**
 * Updates the ai_goal_suggestion_status field on a ReportTreatmentPlan.
 * Called by SuggestGoalBankGoalsWorkflow on completion or failure.
 */
export type UpdateGoalSuggestionStatus = {
  __typename?: 'UpdateGoalSuggestionStatus';
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type UpdateGoalTargetGenerationStatusM2M = {
  __typename?: 'UpdateGoalTargetGenerationStatusM2M';
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type UpdateGoalTargetGenerationStatusM2MInput = {
  goalId: Scalars['ID']['input'];
  status: WorkflowStatusEnum;
};

export type UpdateGoogleDriveUploadFlag = {
  __typename?: 'UpdateGoogleDriveUploadFlag';
  message?: Maybe<Scalars['String']['output']>;
  organization?: Maybe<OrganizationType>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type UpdateGoogleDriveUploadFlagInput = {
  auth0OrganizationId: Scalars['String']['input'];
  isGoogleDriveUploadEnabled: Scalars['Boolean']['input'];
};

export type UpdateLanguageStylePrompt = {
  __typename?: 'UpdateLanguageStylePrompt';
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  stylePrompt?: Maybe<LanguageStylePromptType>;
};

export type UpdateLearnerAdditionalDetails = {
  __typename?: 'UpdateLearnerAdditionalDetails';
  learnerAdditionalDetails?: Maybe<LearnerAdditionalDetailsType>;
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type UpdateLearnerAvailabilityDetails = {
  __typename?: 'UpdateLearnerAvailabilityDetails';
  learnerAvailabilityData?: Maybe<Array<Maybe<LearnerAvailabilityType>>>;
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type UpdateLearnerBehaviors = {
  __typename?: 'UpdateLearnerBehaviors';
  message?: Maybe<Scalars['String']['output']>;
  onboardingQuestionsData?: Maybe<Array<Maybe<LearnerOnboardingQuestionsType>>>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type UpdateLearnerBirthHistory = {
  __typename?: 'UpdateLearnerBirthHistory';
  learnerBirthHistroy?: Maybe<LearnerBirthHistoryType>;
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type UpdateLearnerCaregiverDetails = {
  __typename?: 'UpdateLearnerCaregiverDetails';
  caregiverData?: Maybe<CaregiverType>;
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type UpdateLearnerChatMemory = {
  __typename?: 'UpdateLearnerChatMemory';
  learnerChatMemory?: Maybe<LearnerChatMemoryType>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type UpdateLearnerCommunication = {
  __typename?: 'UpdateLearnerCommunication';
  message?: Maybe<Scalars['String']['output']>;
  onboardingQuestionsData?: Maybe<Array<Maybe<LearnerOnboardingQuestionsType>>>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type UpdateLearnerDetails = {
  __typename?: 'UpdateLearnerDetails';
  learnerData?: Maybe<LearnerType>;
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type UpdateLearnerDevelopmentalMilestones = {
  __typename?: 'UpdateLearnerDevelopmentalMilestones';
  message?: Maybe<Scalars['String']['output']>;
  onboardingQuestionsData?: Maybe<Array<Maybe<LearnerOnboardingQuestionsType>>>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type UpdateLearnerEarlyInterventionServices = {
  __typename?: 'UpdateLearnerEarlyInterventionServices';
  learnerEarlyInterventionService?: Maybe<LearnerEarlyInterventionServicesType>;
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type UpdateLearnerEducation = {
  __typename?: 'UpdateLearnerEducation';
  learnerEducation?: Maybe<LearnerEducationType>;
};

export type UpdateLearnerEducationDetails = {
  __typename?: 'UpdateLearnerEducationDetails';
  learnerEducation?: Maybe<LearnerEducationType>;
  learnerOtherServicesHistory?: Maybe<Array<Maybe<LearnerOtherServicesHistoryType>>>;
  learnerTheraputicServices?: Maybe<Array<Maybe<LearnerTheraputicServicesInSchoolType>>>;
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type UpdateLearnerEmergencyContact = {
  __typename?: 'UpdateLearnerEmergencyContact';
  learnerEmergencyContact?: Maybe<LearnerEmergencyContactType>;
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type UpdateLearnerFileClassification = {
  __typename?: 'UpdateLearnerFileClassification';
  alreadyClassified?: Maybe<Scalars['Boolean']['output']>;
  learnerFile?: Maybe<LearnerFileType>;
};

/**
 * Clinician override for the parser-derived effective_date.
 *
 * Writes `effective_date` (which may be null to clear it) and sets
 * `clinician_edited_at = now()` atomically. After this runs, the race-safe
 * write hook in `LearnerFileService.update_parsed_results` and the M5
 * backfill migration both skip the row — the clinician's value wins.
 */
export type UpdateLearnerFileEffectiveDate = {
  __typename?: 'UpdateLearnerFileEffectiveDate';
  learnerFile?: Maybe<LearnerFileType>;
};

export type UpdateLearnerFileInterviewType = {
  __typename?: 'UpdateLearnerFileInterviewType';
  learnerFile?: Maybe<LearnerFileType>;
};

export type UpdateLearnerFileLanguage = {
  __typename?: 'UpdateLearnerFileLanguage';
  learnerFile?: Maybe<LearnerFileType>;
};

export type UpdateLearnerFileParsedResult = {
  __typename?: 'UpdateLearnerFileParsedResult';
  learnerFile?: Maybe<LearnerFileType>;
};

export type UpdateLearnerGeneralDetails = {
  __typename?: 'UpdateLearnerGeneralDetails';
  learnerMetadata?: Maybe<LearnerMetadataType>;
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type UpdateLearnerGuardianDetails = {
  __typename?: 'UpdateLearnerGuardianDetails';
  caregiverMetadata?: Maybe<Array<Maybe<CaregiverMetadataType>>>;
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type UpdateLearnerInsurance = {
  __typename?: 'UpdateLearnerInsurance';
  insurancesData?: Maybe<Array<Maybe<InsuranceDetailsType>>>;
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type UpdateLearnerInsuranceDetails = {
  __typename?: 'UpdateLearnerInsuranceDetails';
  insuranceDetails?: Maybe<InsuranceDetailsType>;
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type UpdateLearnerIntakeOverviewDetails = {
  __typename?: 'UpdateLearnerIntakeOverviewDetails';
  learnerData?: Maybe<LearnerType>;
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type UpdateLearnerIntakeOverviewDetailsInput = {
  assessmentAppointmentDate?: InputMaybe<Scalars['DateTime']['input']>;
  bcbaForAssessment?: InputMaybe<Scalars['String']['input']>;
  diagnosisAppointmentDate?: InputMaybe<Scalars['DateTime']['input']>;
  hasPreviousDiagnosis: Scalars['Boolean']['input'];
  physclogistForDiagnosis?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateLearnerLivingConditions = {
  __typename?: 'UpdateLearnerLivingConditions';
  individualsLivingInHome?: Maybe<Array<Maybe<LearnerIndividualsThatLiveInHomeType>>>;
  learnerLivingConditions?: Maybe<LearnerLivingConditionsType>;
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type UpdateLearnerManualSync = {
  __typename?: 'UpdateLearnerManualSync';
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type UpdateLearnerMedicalHistory = {
  __typename?: 'UpdateLearnerMedicalHistory';
  medicalHistoryMetaData?: Maybe<LearnerMedicalHistoryMetaDataType>;
  medicationsData?: Maybe<Array<Maybe<LearnerMedicationsType>>>;
  message?: Maybe<Scalars['String']['output']>;
  onboardingQuestionsData?: Maybe<Array<Maybe<LearnerOnboardingQuestionsType>>>;
  primaryProviderData?: Maybe<LearnerPrimaryProviderType>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type UpdateLearnerMetadata = {
  __typename?: 'UpdateLearnerMetadata';
  learnerMetadata?: Maybe<LearnerMetadataType>;
};

export type UpdateLearnerPrimaryProvider = {
  __typename?: 'UpdateLearnerPrimaryProvider';
  primaryProvider?: Maybe<LearnerPrimaryProviderType>;
};

export type UpdateLearnerProviders = {
  __typename?: 'UpdateLearnerProviders';
  learner?: Maybe<LearnerType>;
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type UpdateLearnerProvidersInput = {
  learnerId: Scalars['ID']['input'];
  providerIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};

export type UpdateLearnerTendencies = {
  __typename?: 'UpdateLearnerTendencies';
  message?: Maybe<Scalars['String']['output']>;
  onboardingQuestionsData?: Maybe<Array<Maybe<LearnerOnboardingQuestionsType>>>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type UpdateLoginStatusMutation = {
  __typename?: 'UpdateLoginStatusMutation';
  message?: Maybe<Scalars['String']['output']>;
};

export type UpdateMediaClip = {
  __typename?: 'UpdateMediaClip';
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
  videoClip?: Maybe<ClipType>;
};

export type UpdateMediaClipInput = {
  clipId: Scalars['ID']['input'];
  endTime: Scalars['Float']['input'];
  startTime: Scalars['Float']['input'];
  title: Scalars['String']['input'];
};

export type UpdateMediaComment = {
  __typename?: 'UpdateMediaComment';
  mediaComment?: Maybe<MediaCommentsType>;
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type UpdateMediaCommentInput = {
  commentId: Scalars['ID']['input'];
  content: Scalars['String']['input'];
};

export type UpdateMediaM2M = {
  __typename?: 'UpdateMediaM2M';
  media?: Maybe<MediaType>;
};

export type UpdateMediaM2MInput = {
  mediaId: Scalars['ID']['input'];
  multiplePeopleIncludingChildDuration?: InputMaybe<Scalars['Float']['input']>;
  thumbnailManifestPath?: InputMaybe<Scalars['String']['input']>;
  totalDuration?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateMediaStatus = {
  __typename?: 'UpdateMediaStatus';
  media?: Maybe<MediaType>;
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type UpdateMediaStatusInput = {
  mediaId: Scalars['ID']['input'];
  status?: InputMaybe<MediaStatusEnumType>;
};

export type UpdateMessageReadStatus = {
  __typename?: 'UpdateMessageReadStatus';
  chatMessage?: Maybe<ChatMessageType>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type UpdateMessageReadStatusInput = {
  messageId: Scalars['ID']['input'];
  /** If the chat is read/unread */
  read: Scalars['Boolean']['input'];
};

export type UpdateNotificationOptOut = {
  __typename?: 'UpdateNotificationOptOut';
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type UpdateNotificationOptOutInput = {
  deliveryMethod: NotificationDeliveryMethod;
  notificationType: NotificationTypeEnums;
  optedOut: Scalars['Boolean']['input'];
};

export type UpdateOrgNotificationSettings = {
  __typename?: 'UpdateOrgNotificationSettings';
  message?: Maybe<Scalars['String']['output']>;
  notificationSettings?: Maybe<OrganizationNotificationSettingsType>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type UpdateOrgNotificationSettingsInput = {
  reassessmentReminder: Scalars['Boolean']['input'];
};

/** Update content and/or enabled on an OrganizationSuggestionCriteria */
export type UpdateOrganizationSuggestionCriteria = {
  __typename?: 'UpdateOrganizationSuggestionCriteria';
  message?: Maybe<Scalars['String']['output']>;
  organizationSuggestionCriteria?: Maybe<OrganizationSuggestionCriteriaType>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type UpdateOrganizationTemplateLogoUrl = {
  __typename?: 'UpdateOrganizationTemplateLogoURL';
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type UpdateOrganizationTemplateLogoUrlInput = {
  /** Original file name (optional, leave blank to remove logo) */
  originalFileName?: InputMaybe<Scalars['String']['input']>;
  /** Global ID of the report */
  reportId: Scalars['String']['input'];
};

export type UpdateParsedTreatmentPlanFileData = {
  __typename?: 'UpdateParsedTreatmentPlanFileData';
  message?: Maybe<Scalars['String']['output']>;
  record?: Maybe<ParsedTreatmentPlanFileDataType>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type UpdateParsedTreatmentPlanFileDataInput = {
  data?: InputMaybe<Scalars['JSONString']['input']>;
  status?: InputMaybe<ParsedTreatmentPlanFileDataStatusEnum>;
};

export type UpdatePassageGoalAndTargetIdsM2m = {
  __typename?: 'UpdatePassageGoalAndTargetIdsM2m';
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type UpdatePassageGoalAndTargetIdsM2mInput = {
  ehrId: Scalars['String']['input'];
  fdmId: Scalars['ID']['input'];
  targets: Array<InputMaybe<BaseEhrInput>>;
  title: Scalars['String']['input'];
};

export type UpdatePayorReportReviewStatus = {
  __typename?: 'UpdatePayorReportReviewStatus';
  message?: Maybe<Scalars['String']['output']>;
  payorSubmission?: Maybe<PayorReportSubmissionType>;
  review?: Maybe<PayorReportReviewType>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type UpdatePayorReportReviewStatusInput = {
  adminReviewerId?: InputMaybe<Scalars['String']['input']>;
  clinicalReviewerId?: InputMaybe<Scalars['String']['input']>;
  externalReportId?: InputMaybe<Scalars['String']['input']>;
  feedback?: InputMaybe<Scalars['String']['input']>;
  feedbackFilePath?: InputMaybe<Scalars['String']['input']>;
  reportId: Scalars['ID']['input'];
  reviewerId?: InputMaybe<Scalars['String']['input']>;
  revisionScope?: InputMaybe<Scalars['String']['input']>;
  status: PayorReportReviewStatusEnum;
  versionReviewed?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdatePayorSubmissionStatus = {
  __typename?: 'UpdatePayorSubmissionStatus';
  message?: Maybe<Scalars['String']['output']>;
  payorSubmission?: Maybe<PayorReportSubmissionType>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type UpdatePayorSubmissionStatusInput = {
  errorMessage?: InputMaybe<Scalars['String']['input']>;
  reportJson?: InputMaybe<Scalars['JSONString']['input']>;
  reportSubmissionJobId: Scalars['ID']['input'];
  response?: InputMaybe<Scalars['JSONString']['input']>;
  status: PayorReportSubmissionStatusEnum;
};

export type UpdatePrompt = {
  __typename?: 'UpdatePrompt';
  message?: Maybe<Scalars['String']['output']>;
  prompt?: Maybe<PromptType>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type UpdateProvider = {
  __typename?: 'UpdateProvider';
  message?: Maybe<Scalars['String']['output']>;
  provider?: Maybe<ProviderType>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type UpdateProviderAuth0Id = {
  __typename?: 'UpdateProviderAuth0Id';
  message?: Maybe<Scalars['String']['output']>;
  provider?: Maybe<ProviderType>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type UpdateProviderFileParsedResult = {
  __typename?: 'UpdateProviderFileParsedResult';
  providerFile?: Maybe<ProviderFileType>;
};

/**
 * Backend-only mutation to update file processing status.
 *
 * This mutation is restricted to TEMPORAL_PERMISSION_CFG (backend/system users only).
 * UI users cannot call this mutation.
 *
 * Allowed status transitions:
 * - uploaded -> PROCESSING (start processing)
 * - PROCESSING -> COMPLETED (success) or FAILED (error)
 * - FAILED -> PROCESSING (retry)
 *
 * NOTE: UI can only update status to "uploaded" via MarkProviderFileAsUploaded.
 */
export type UpdateProviderFileProcessStatus = {
  __typename?: 'UpdateProviderFileProcessStatus';
  providerFile?: Maybe<ProviderFileType>;
};

export type UpdateProviderInput = {
  firstName: Scalars['String']['input'];
  gender?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  learners?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  providerRole?: InputMaybe<Array<InputMaybe<ProviderRoleEnums>>>;
  specifyGender?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateProviderLearners = {
  __typename?: 'UpdateProviderLearners';
  message?: Maybe<Scalars['String']['output']>;
  provider?: Maybe<ProviderType>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type UpdateProviderProfile = {
  __typename?: 'UpdateProviderProfile';
  message?: Maybe<Scalars['String']['output']>;
  provider?: Maybe<ProviderType>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type UpdateProviderProfileInput = {
  bio?: InputMaybe<Scalars['String']['input']>;
  chatAvailability?: InputMaybe<ProviderAvailability>;
  clinicalCredentials?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  licenseNumber?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  professionalTitle?: InputMaybe<Scalars['String']['input']>;
  sendNotificationAboutAssessment?: InputMaybe<Scalars['Boolean']['input']>;
  smsAgreement?: InputMaybe<Scalars['Boolean']['input']>;
  specifyGender?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  workingHoursEnd?: InputMaybe<Scalars['Time']['input']>;
  workingHoursStart?: InputMaybe<Scalars['Time']['input']>;
};

export type UpdateRecommendationBankFolder = {
  __typename?: 'UpdateRecommendationBankFolder';
  message?: Maybe<Scalars['String']['output']>;
  recommendationBankFolder?: Maybe<RecommendationBankFolderType>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type UpdateRecommendationBankFolderInput = {
  folderId: Scalars['ID']['input'];
  folderType: RecommendationBankFolderTypeEnum;
  name: Scalars['String']['input'];
};

export type UpdateRecommendationBankItem = {
  __typename?: 'UpdateRecommendationBankItem';
  message?: Maybe<Scalars['String']['output']>;
  recommendationBankItem?: Maybe<RecommendationBankItemType>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type UpdateRecommendationBankItemInput = {
  folderId: Scalars['ID']['input'];
  recommendationBankId: Scalars['ID']['input'];
  recommendationContent: Scalars['String']['input'];
  recommendationTitle: Scalars['String']['input'];
};

export type UpdateReport = {
  __typename?: 'UpdateReport';
  message?: Maybe<Scalars['String']['output']>;
  report?: Maybe<ReportType>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type UpdateReportClientDetails = {
  __typename?: 'UpdateReportClientDetails';
  message?: Maybe<Scalars['String']['output']>;
  report?: Maybe<ReportType>;
  reportClientDetails?: Maybe<ReportClientDetailsType>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type UpdateReportEhrSyncStatus = {
  __typename?: 'UpdateReportEhrSyncStatus';
  alert?: Maybe<EhrSyncAlertType>;
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type UpdateReportEhrSyncStatusInput = {
  alert?: InputMaybe<EhrSyncAlertInput>;
  ehrSyncStatus: EhrSyncStatusEnum;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  reportId: Scalars['ID']['input'];
};

export type UpdateReportGoalDomainsInput = {
  domainId: Scalars['ID']['input'];
  goalId: Scalars['ID']['input'];
};

export type UpdateReportGoalDomainsM2M = {
  __typename?: 'UpdateReportGoalDomainsM2M';
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type UpdateReportPageHeading = {
  __typename?: 'UpdateReportPageHeading';
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type UpdateReportPageHeadingInput = {
  pageHeadingText: Scalars['String']['input'];
  reportId: Scalars['ID']['input'];
};

export type UpdateReportPassageManualSync = {
  __typename?: 'UpdateReportPassageManualSync';
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type UpdateReportSection = {
  __typename?: 'UpdateReportSection';
  message?: Maybe<Scalars['String']['output']>;
  reportSection?: Maybe<ReportSectionsType>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type UpdateReportSectionField = {
  __typename?: 'UpdateReportSectionField';
  message?: Maybe<Scalars['String']['output']>;
  reportSectionField?: Maybe<ReportSectionFieldsType>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type UpdateReportSectionFieldFileUrl = {
  __typename?: 'UpdateReportSectionFieldFileURL';
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type UpdateReportSectionFieldFileUrlInput = {
  /** Which capture method produced this upload. Required when the target field is WET_SIGNATURE (the mutation raises otherwise) — every other field type ignores this argument and keeps writing the bare S3 key. */
  captureMethod?: InputMaybe<WetSignatureCaptureMethodEnums>;
  /** Global ID of the field */
  fieldId: Scalars['String']['input'];
  /** Original file name */
  originalFileName: Scalars['String']['input'];
  /** Global ID of the report */
  reportId: Scalars['String']['input'];
};

export type UpdateReportSectionFieldFromBhtia = {
  __typename?: 'UpdateReportSectionFieldFromBHTIA';
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type UpdateReportSectionFieldsOrder = {
  __typename?: 'UpdateReportSectionFieldsOrder';
  message?: Maybe<Scalars['String']['output']>;
  reportSectionFields?: Maybe<Array<Maybe<ReportSectionFieldsType>>>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type UpdateReportSectionsOrder = {
  __typename?: 'UpdateReportSectionsOrder';
  message?: Maybe<Scalars['String']['output']>;
  reportSections?: Maybe<Array<Maybe<ReportSectionsType>>>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type UpdateReportStatusAndUploadReportFile = {
  __typename?: 'UpdateReportStatusAndUploadReportFile';
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

/** Update the suggestion generation status for a report */
export type UpdateReportSuggestionGenerationStatus = {
  __typename?: 'UpdateReportSuggestionGenerationStatus';
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<ReportSuggestionGenerationStatusEnum>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

/** The mutation updates the given report template by ID. */
export type UpdateReportTemplate = {
  __typename?: 'UpdateReportTemplate';
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type UpdateReportTemplateFileInput = {
  /** Original file name (optional, leave blank to remove file) */
  originalFileName?: InputMaybe<Scalars['String']['input']>;
  /** Global ID of the report */
  reportTemplateId: Scalars['String']['input'];
};

export type UpdateReportTemplateInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  font?: InputMaybe<ReportTemplateExportFontEnums>;
  footerText?: InputMaybe<Scalars['String']['input']>;
  goalBankCurriculumId?: InputMaybe<Scalars['ID']['input']>;
  headerText?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  reportTemplateId: Scalars['ID']['input'];
  reportTemplateSections?: InputMaybe<Array<InputMaybe<ReportTemplateSectionInput>>>;
  status?: InputMaybe<ReportTemplateStatus>;
  treatmentPlanTemplate?: InputMaybe<TreatmentPlanTemplateInput>;
};

export type UpdateReportTemplateLogo = {
  __typename?: 'UpdateReportTemplateLogo';
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

/** Update content, category, and/or enabled on a ReportTemplateSuggestionCriteria */
export type UpdateReportTemplateSuggestionCriteria = {
  __typename?: 'UpdateReportTemplateSuggestionCriteria';
  message?: Maybe<Scalars['String']['output']>;
  reportTemplateSuggestionCriteria?: Maybe<ReportTemplateSuggestionCriteriaType>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type UpdateReportTreatmentPlanPredictionStatus = {
  __typename?: 'UpdateReportTreatmentPlanPredictionStatus';
  message?: Maybe<Scalars['String']['output']>;
  reportTreatmentPlan?: Maybe<ReportTreatmentPlanType>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type UpdateReportTreatmentPlanTargetPriorityOrder = {
  __typename?: 'UpdateReportTreatmentPlanTargetPriorityOrder';
  message?: Maybe<Scalars['String']['output']>;
  reportTargetsDetails?: Maybe<Array<Maybe<ReportTargetType>>>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type UpdateReportWriterAndDateInput = {
  reportCompletionDate?: InputMaybe<Scalars['Date']['input']>;
  reportWriter?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateSessionRatingAndComment = {
  __typename?: 'UpdateSessionRatingAndComment';
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
  videoSession?: Maybe<VideoSessionType>;
};

export type UpdateSessionRatingAndCommentInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  sessionRating?: InputMaybe<Scalars['Int']['input']>;
  videoSessionId: Scalars['ID']['input'];
};

export type UpdateTargetExcludeFromReport = {
  __typename?: 'UpdateTargetExcludeFromReport';
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type UpdateTargetExcludeFromReportInput = {
  excludeFromReport: Scalars['Boolean']['input'];
  targetId: Scalars['ID']['input'];
};

export type UpdateTargetPredictionStatusM2M = {
  __typename?: 'UpdateTargetPredictionStatusM2M';
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type UpdateTargetPriorityOrder = {
  __typename?: 'UpdateTargetPriorityOrder';
  message?: Maybe<Scalars['String']['output']>;
  reportTargetsDetails?: Maybe<Array<Maybe<ReportTargetType>>>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type UpdateTargetProgressSummary = {
  __typename?: 'UpdateTargetProgressSummary';
  message?: Maybe<Scalars['String']['output']>;
  signedChartImageUrl?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type UpdateTargetProgressSummaryInput = {
  chartFromDate?: InputMaybe<Scalars['Date']['input']>;
  chartImageUri?: InputMaybe<Scalars['String']['input']>;
  chartToDate?: InputMaybe<Scalars['Date']['input']>;
  isApproved: Scalars['Boolean']['input'];
  progressSummary?: InputMaybe<Scalars['String']['input']>;
  targetId: Scalars['ID']['input'];
};

export type UpdateTargetProgressSummaryM2M = {
  __typename?: 'UpdateTargetProgressSummaryM2M';
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type UpdateTaxTransaction = {
  __typename?: 'UpdateTaxTransaction';
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Int']['output']>;
  taxId?: Maybe<Scalars['String']['output']>;
  taxRate?: Maybe<Scalars['Int']['output']>;
};

export type UpdateTherapzGoalsAndTargets = {
  __typename?: 'UpdateTherapzGoalsAndTargets';
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type UpdateTherapzGoalsInput = {
  dataCollectionType: Scalars['String']['input'];
  ehrId: Scalars['String']['input'];
  fdmId: Scalars['ID']['input'];
  phase: Scalars['String']['input'];
  targets: Array<InputMaybe<TherapzEhrTargetInput>>;
  title: Scalars['String']['input'];
  type: Scalars['String']['input'];
};

export type UpdateTranscriptSpeaker = {
  __typename?: 'UpdateTranscriptSpeaker';
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
  transcriptLineRecordData?: Maybe<TranscriptLineRecordType>;
};

export type UpdateTranscriptSpeakerInput = {
  speaker: Scalars['String']['input'];
  transcriptLineRecordId: Scalars['ID']['input'];
};

export type UpdateTreatmentPlanCustomFieldFileUrl = {
  __typename?: 'UpdateTreatmentPlanCustomFieldFileURL';
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type UpdateTreatmentPlanCustomFieldFileUrlInput = {
  /** Global ID of the treatment plan custom field */
  customFieldId: Scalars['String']['input'];
  /** Original file name */
  originalFileName: Scalars['String']['input'];
};

export type UpdateVideoSessionScore = {
  __typename?: 'UpdateVideoSessionScore';
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  videoSession?: Maybe<VideoSessionType>;
};

export type UpdateVideoSessionStatus = {
  __typename?: 'UpdateVideoSessionStatus';
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  videoSession?: Maybe<VideoSessionType>;
  workflowId?: Maybe<Scalars['String']['output']>;
};

export type UploadAnnotationFile = {
  __typename?: 'UploadAnnotationFile';
  clipAnnotation?: Maybe<ClipAnnotationType>;
  fileKey?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  multipartUploadId?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
  uploadUrls?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type UploadAnnotationFileInput = {
  clipAnnotationId: Scalars['ID']['input'];
  fileName: Scalars['String']['input'];
  fileSize: Scalars['BigInt']['input'];
  requiredParts: Scalars['Int']['input'];
};

export type UploadAnnotationFilePartsInput = {
  ETag: Scalars['String']['input'];
  PartNumber: Scalars['Int']['input'];
};

export type UploadAnnotationMedia = {
  __typename?: 'UploadAnnotationMedia';
  fileKey?: Maybe<Scalars['String']['output']>;
  media?: Maybe<MediaType>;
  message?: Maybe<Scalars['String']['output']>;
  multipartUploadId?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
  uploadUrls?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type UploadAnnotationMediaInput = {
  fileName: Scalars['String']['input'];
  fileSize: Scalars['BigInt']['input'];
  mediaLanguage: LanguageEnumType;
  mediaType: AnnotationUploadMediaTypeEnum;
  requiredParts: Scalars['Int']['input'];
};

export type UploadSessionVideoForLearner = {
  __typename?: 'UploadSessionVideoForLearner';
  fileKey?: Maybe<Scalars['String']['output']>;
  media?: Maybe<MediaType>;
  message?: Maybe<Scalars['String']['output']>;
  multipartUploadId?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
  uploadUrls?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type UploadSessionVideoForLearnerInput = {
  fileName: Scalars['String']['input'];
  fileSize: Scalars['BigInt']['input'];
  learnerId: Scalars['ID']['input'];
  mediaLanguage: LanguageEnumType;
  mediaSource: MediaSourceEnum;
  requiredParts: Scalars['Int']['input'];
  sessionDatetime?: InputMaybe<Scalars['DateTime']['input']>;
};

export type UploadVideoSessionVideoMutation = {
  __typename?: 'UploadVideoSessionVideoMutation';
  fileKey?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  multipartUploadId?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
  uploadUrls?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  videoSession?: Maybe<VideoSessionType>;
};

export type UpsertChatSuggestions = {
  __typename?: 'UpsertChatSuggestions';
  chatSuggestions?: Maybe<Array<Maybe<ChatSuggestionType>>>;
};

export type UpsertChatSuggestionsInput = {
  learnerId: Scalars['ID']['input'];
  suggestions: Array<InputMaybe<Scalars['String']['input']>>;
};

/**
 * Get-or-create an OrganizationSuggestionCriteria join record and set enabled.
 * Used for base criteria that don't yet have a real join record (virtual entries).
 */
export type UpsertOrganizationSuggestionCriteria = {
  __typename?: 'UpsertOrganizationSuggestionCriteria';
  message?: Maybe<Scalars['String']['output']>;
  organizationSuggestionCriteria?: Maybe<OrganizationSuggestionCriteriaType>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type UpsertReportPayorMetadata = {
  __typename?: 'UpsertReportPayorMetadata';
  message?: Maybe<Scalars['String']['output']>;
  reportPayorMetadata?: Maybe<ReportPayorMetadataType>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type UpsertReportPayorMetadataInput = {
  comments?: InputMaybe<Scalars['String']['input']>;
  firstTreatmentOfferedDate?: InputMaybe<Scalars['Date']['input']>;
  groupCare?: InputMaybe<Scalars['Float']['input']>;
  highLevelHours?: InputMaybe<Scalars['Float']['input']>;
  midLevelHours?: InputMaybe<Scalars['Float']['input']>;
  paraprofessionalHours?: InputMaybe<Scalars['Float']['input']>;
  reportId: Scalars['ID']['input'];
  treatmentOffered?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UserBillingDetailsType = Node & {
  __typename?: 'UserBillingDetailsType';
  amount?: Maybe<Scalars['Decimal']['output']>;
  auth0User: UserType;
  createdBy?: Maybe<UserType>;
  createdDate: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  /** The ID of the object */
  id: Scalars['ID']['output'];
  invoiceId?: Maybe<Scalars['String']['output']>;
  lastUpdatedDate: Scalars['DateTime']['output'];
  organization: OrganizationType;
  paymentIntentId?: Maybe<Scalars['String']['output']>;
  paymentMethodId?: Maybe<Scalars['String']['output']>;
  paymentStatus: ApiUserBillingDetailsPaymentStatusChoices;
  pk?: Maybe<Scalars['Int']['output']>;
  priceId?: Maybe<Scalars['String']['output']>;
  productId?: Maybe<Scalars['String']['output']>;
  quantity?: Maybe<Scalars['Int']['output']>;
  report?: Maybe<ReportType>;
  transactionType: ApiUserBillingDetailsTransactionTypeChoices;
  updatedBy?: Maybe<UserType>;
  userStripeAccount?: Maybe<UserStripeAccountDetailsType>;
};

export type UserBillingDetailsTypeConnection = {
  __typename?: 'UserBillingDetailsTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<UserBillingDetailsTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `UserBillingDetailsType` and its cursor. */
export type UserBillingDetailsTypeEdge = {
  __typename?: 'UserBillingDetailsTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<UserBillingDetailsType>;
};

export type UserCardAndAssessmentDetailsType = {
  __typename?: 'UserCardAndAssessmentDetailsType';
  defaultCardDetails?: Maybe<Scalars['JSONString']['output']>;
  userAccountDetails?: Maybe<UserStripeAccountDetailsType>;
  userCardsDetails?: Maybe<Scalars['JSONString']['output']>;
};

export type UserNotificationDeviceTokenType = Node & {
  __typename?: 'UserNotificationDeviceTokenType';
  auth0User: UserType;
  createdBy?: Maybe<UserType>;
  createdDate: Scalars['DateTime']['output'];
  deviceIdentifier: Scalars['String']['output'];
  deviceType: ApiUserNotificationDeviceTokensDeviceTypeChoices;
  /** The ID of the object */
  id: Scalars['ID']['output'];
  lastUpdatedDate: Scalars['DateTime']['output'];
  organization: OrganizationType;
  pk?: Maybe<Scalars['Int']['output']>;
  pushToken: Scalars['String']['output'];
};

export type UserNotificationDeviceTokenTypeConnection = {
  __typename?: 'UserNotificationDeviceTokenTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<UserNotificationDeviceTokenTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `UserNotificationDeviceTokenType` and its cursor. */
export type UserNotificationDeviceTokenTypeEdge = {
  __typename?: 'UserNotificationDeviceTokenTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<UserNotificationDeviceTokenType>;
};

export type UserStripeAccountDetailsType = Node & {
  __typename?: 'UserStripeAccountDetailsType';
  auth0User: UserType;
  createdBy?: Maybe<UserType>;
  createdDate: Scalars['DateTime']['output'];
  /** The ID of the object */
  id: Scalars['ID']['output'];
  lastUpdatedDate: Scalars['DateTime']['output'];
  organization: OrganizationType;
  pendingAssessment: Scalars['Int']['output'];
  pk?: Maybe<Scalars['Int']['output']>;
  purchasedAssessment: Scalars['Int']['output'];
  stripeCustomerId?: Maybe<Scalars['String']['output']>;
  stripePaymentMethodId?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<UserType>;
  userbillingdetailsSet: UserBillingDetailsTypeConnection;
};


export type UserStripeAccountDetailsTypeUserbillingdetailsSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  amount?: InputMaybe<Scalars['Decimal']['input']>;
  auth0User?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdDate?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  invoiceId?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedDate?: InputMaybe<Scalars['DateTime']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  organization?: InputMaybe<Scalars['ID']['input']>;
  paymentIntentId?: InputMaybe<Scalars['String']['input']>;
  paymentMethodId?: InputMaybe<Scalars['String']['input']>;
  paymentStatus?: InputMaybe<ApiUserBillingDetailsPaymentStatusChoices>;
  priceId?: InputMaybe<Scalars['String']['input']>;
  productId?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
  report?: InputMaybe<Scalars['ID']['input']>;
  transactionType?: InputMaybe<ApiUserBillingDetailsTransactionTypeChoices>;
  updatedBy?: InputMaybe<Scalars['ID']['input']>;
  userStripeAccount?: InputMaybe<Scalars['ID']['input']>;
};

export type UserStripeAccountDetailsTypeConnection = {
  __typename?: 'UserStripeAccountDetailsTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<UserStripeAccountDetailsTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `UserStripeAccountDetailsType` and its cursor. */
export type UserStripeAccountDetailsTypeEdge = {
  __typename?: 'UserStripeAccountDetailsTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<UserStripeAccountDetailsType>;
};

export type UserType = Node & {
  __typename?: 'UserType';
  addedUserBillingDetails: UserBillingDetailsTypeConnection;
  addedUserStripeAccountDetails: UserStripeAccountDetailsTypeConnection;
  annotationTagUser: AnnotationTagTypeConnection;
  annotatoruser?: Maybe<AnnotatorUserType>;
  auth0id?: Maybe<Scalars['String']['output']>;
  /** The reviewer who wrote this comment. PROTECT because attribution is part of the datum, same rationale as EvalReviewScore.reviewer. */
  authoredReportSuggestions: ReportSuggestionTypeConnection;
  caregiver?: Maybe<CaregiverType>;
  chatMessages: ChatMessageTypeConnection;
  chatMessagesReadBy: ChatMessageTypeConnection;
  chatTasks: TaskTypeConnection;
  chatnoteSet: ChatNoteTypeConnection;
  chats: ChatTypeConnection;
  clips: ClipTypeConnection;
  commentAuthor: MediaCommentsTypeConnection;
  createdAnnotaion: AnnotationTypeConnection;
  createdAnnotator: AnnotatorUserTypeConnection;
  createdByFormStatus: OnboardingFormStatusTypeConnection;
  createdCaregiver: CaregiverTypeConnection;
  createdCaregiverMetadata: CaregiverMetadataTypeConnection;
  createdLearner: LearnerTypeConnection;
  createdLearnerFiles: LearnerFileTypeConnection;
  createdLearnerMetadata: LearnerMetadataTypeConnection;
  createdMedia: MediaTypeConnection;
  createdMediaDevice: MediaDeviceTypeConnection;
  createdMediaMetadata: MediaMetadataTypeConnection;
  createdNotificationDeviceToken: UserNotificationDeviceTokenTypeConnection;
  createdParsedTreatmentPlanFilesData: ParsedTreatmentPlanFileDataTypeConnection;
  createdProvider: ProviderMetadataTypeConnection;
  /** User who uploaded this file */
  createdProviderFiles: ProviderFileTypeConnection;
  createdRelationship: RelationshipTypeConnection;
  createdSessions: VideoSessionTypeConnection;
  createdTherapySession: TherapySessionTypeConnection;
  dateJoined: Scalars['DateTime']['output'];
  domainSet: DomainTypeConnection;
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  folderUpdatedBy: GoalBankFolderTypeConnection;
  goalBankFolder: GoalBankFolderTypeConnection;
  goalBankTargetUpdatedBy: ReportTargetGoalBankTypeConnection;
  goalbankfolderSet: GoalBankFolderTypeConnection;
  /** The ID of the object */
  id: Scalars['ID']['output'];
  /** Designates whether this user should be treated as active. Unselect this instead of deleting accounts. */
  isActive: Scalars['Boolean']['output'];
  /** Designates whether the user can log into this admin site. */
  isStaff: Scalars['Boolean']['output'];
  /** Designates that this user has all permissions without explicitly assigning them. */
  isSuperuser: Scalars['Boolean']['output'];
  lastLogin?: Maybe<Scalars['DateTime']['output']>;
  lastName: Scalars['String']['output'];
  longGoalBankUpdatedBy: LongTermGoalBankTypeConnection;
  longtermgoalbankSet: LongTermGoalBankTypeConnection;
  mediaTargetPredictionFeedbacks: MediaTargetPredictionFeedbackTypeConnection;
  mediaViewedBy: MediaTypeConnection;
  /** The identity (Principal) that belongs to the tenant. */
  memberships: MembershipTypeConnection;
  notificationOptOuts: NotificationOptOutTypeConnection;
  organizationuserrolesSet: OrganizationUserRolesTypeConnection;
  pk?: Maybe<Scalars['Int']['output']>;
  promptDraftsAuthored: PromptTypeConnection;
  promptSet: PromptTypeConnection;
  provider?: Maybe<ProviderType>;
  publishedMediaModel: MediaModelConfigTypeConnection;
  publishedReportTemplates: ReportTemplateTypeConnection;
  receivedNotifications: NotificationsTypeConnection;
  recommendationBankFolder: RecommendationBankFolderTypeConnection;
  recommendationBankFolderUpdatedBy: RecommendationBankFolderTypeConnection;
  recommendationGoalBankUpdatedBy: RecommendationBankItemTypeConnection;
  recommendationbankfolderSet: RecommendationBankFolderTypeConnection;
  recommendationbankitemSet: RecommendationBankItemTypeConnection;
  reportSet: ReportTypeConnection;
  reportclientdetailsSet: ReportClientDetailsTypeConnection;
  reportdomainSet: ReportDomainTypeConnection;
  reportgoalSet: ReportGoalTypeConnection;
  reportgoalbankSet: ReportGoalBankTypeConnection;
  reporttargetSet: ReportTargetTypeConnection;
  reporttargetgoalbankSet: ReportTargetGoalBankTypeConnection;
  reporttemplateSet: ReportTemplateTypeConnection;
  reporttemplatesectionSet: ReportTemplateSectionTypeConnection;
  reporttemplatesectionfieldSet: ReportTemplateSectionFieldTypeConnection;
  /** User who resolved this suggestion */
  resolvedReportSuggestions: ReportSuggestionTypeConnection;
  sentNotifications: NotificationsTypeConnection;
  sessionmediareviewactivitylogSet: SessionMediaReviewActivityLogTypeConnection;
  shortGoalBankUpdatedBy: ReportGoalBankTypeConnection;
  transcriptlinerecordSet: TranscriptLineRecordTypeConnection;
  treatmentplantemplatedomainSet: TreatmentPlanTemplateDomainTypeConnection;
  updatedUserBillingDetails: UserBillingDetailsTypeConnection;
  updatedUserStripeAccountDetails: UserStripeAccountDetailsTypeConnection;
  userBillingDetails: UserBillingDetailsTypeConnection;
  userNotificationDeviceToken: UserNotificationDeviceTokenTypeConnection;
  userStripeAccountDetails?: Maybe<UserStripeAccountDetailsType>;
  /** Required. 150 characters or fewer. Letters, digits and @/./+/-/_/| only. */
  username: Scalars['String']['output'];
};


export type UserTypeAddedUserBillingDetailsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  amount?: InputMaybe<Scalars['Decimal']['input']>;
  auth0User?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdDate?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  invoiceId?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedDate?: InputMaybe<Scalars['DateTime']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  organization?: InputMaybe<Scalars['ID']['input']>;
  paymentIntentId?: InputMaybe<Scalars['String']['input']>;
  paymentMethodId?: InputMaybe<Scalars['String']['input']>;
  paymentStatus?: InputMaybe<ApiUserBillingDetailsPaymentStatusChoices>;
  priceId?: InputMaybe<Scalars['String']['input']>;
  productId?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
  report?: InputMaybe<Scalars['ID']['input']>;
  transactionType?: InputMaybe<ApiUserBillingDetailsTransactionTypeChoices>;
  updatedBy?: InputMaybe<Scalars['ID']['input']>;
  userStripeAccount?: InputMaybe<Scalars['ID']['input']>;
};


export type UserTypeAddedUserStripeAccountDetailsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  auth0User?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdDate?: InputMaybe<Scalars['DateTime']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedDate?: InputMaybe<Scalars['DateTime']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  organization?: InputMaybe<Scalars['ID']['input']>;
  pendingAssessment?: InputMaybe<Scalars['Int']['input']>;
  purchasedAssessment?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId?: InputMaybe<Scalars['String']['input']>;
  stripePaymentMethodId?: InputMaybe<Scalars['String']['input']>;
  updatedBy?: InputMaybe<Scalars['ID']['input']>;
};


export type UserTypeAnnotationTagUserArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdDate?: InputMaybe<Scalars['DateTime']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedDate?: InputMaybe<Scalars['DateTime']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type UserTypeAuthoredReportSuggestionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  createdDate?: InputMaybe<Scalars['DateTime']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  goalField?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedDate?: InputMaybe<Scalars['DateTime']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  organization?: InputMaybe<Scalars['ID']['input']>;
  predictionId?: InputMaybe<Scalars['String']['input']>;
  report?: InputMaybe<Scalars['ID']['input']>;
  reportGoal?: InputMaybe<Scalars['ID']['input']>;
  reportSectionField?: InputMaybe<Scalars['ID']['input']>;
  reportTarget?: InputMaybe<Scalars['ID']['input']>;
  resolvedAt?: InputMaybe<Scalars['DateTime']['input']>;
  resolvedBy?: InputMaybe<Scalars['ID']['input']>;
  targetField?: InputMaybe<Scalars['String']['input']>;
};


export type UserTypeChatMessagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  chat?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  role?: InputMaybe<ApiChatMessageRoleChoices>;
  sequenceNumber?: InputMaybe<Scalars['Int']['input']>;
};


export type UserTypeChatMessagesReadByArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  chat?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  role?: InputMaybe<ApiChatMessageRoleChoices>;
  sequenceNumber?: InputMaybe<Scalars['Int']['input']>;
};


export type UserTypeChatTasksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  chat?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  learner?: InputMaybe<Scalars['ID']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<ApiTaskStatusChoices>;
  type?: InputMaybe<ApiTaskTypeChoices>;
  user?: InputMaybe<Scalars['ID']['input']>;
};


export type UserTypeChatnoteSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  chat?: InputMaybe<Scalars['ID']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  createdDate?: InputMaybe<Scalars['DateTime']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedDate?: InputMaybe<Scalars['DateTime']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  organization?: InputMaybe<Scalars['ID']['input']>;
  user?: InputMaybe<Scalars['ID']['input']>;
};


export type UserTypeChatsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  learner?: InputMaybe<Scalars['ID']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<ApiChatStatusChoices>;
  summaryStatus?: InputMaybe<ApiChatSummaryStatusChoices>;
  type?: InputMaybe<ApiChatTypeChoices>;
  user?: InputMaybe<Scalars['ID']['input']>;
};


export type UserTypeClipsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdDate?: InputMaybe<Scalars['DateTime']['input']>;
  endTime?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedDate?: InputMaybe<Scalars['DateTime']['input']>;
  media?: InputMaybe<Scalars['ID']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  organization?: InputMaybe<Scalars['ID']['input']>;
  startTime?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};


export type UserTypeCommentAuthorArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  author?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  commentType?: InputMaybe<ApiMediaCommentsCommentTypeChoices>;
  content?: InputMaybe<Scalars['String']['input']>;
  createdDate?: InputMaybe<Scalars['DateTime']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedDate?: InputMaybe<Scalars['DateTime']['input']>;
  media?: InputMaybe<Scalars['ID']['input']>;
  mediaStartTime?: InputMaybe<Scalars['Float']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  organization?: InputMaybe<Scalars['ID']['input']>;
  parentComment?: InputMaybe<Scalars['ID']['input']>;
};


export type UserTypeCreatedAnnotaionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type UserTypeCreatedAnnotatorArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  auth0User?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdDate?: InputMaybe<Scalars['DateTime']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedDate?: InputMaybe<Scalars['DateTime']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type UserTypeCreatedByFormStatusArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdDate?: InputMaybe<Scalars['DateTime']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  formName?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedDate?: InputMaybe<Scalars['DateTime']['input']>;
  learner?: InputMaybe<Scalars['ID']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  organization?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<ApiOnboardingFormStatusStatusChoices>;
};


export type UserTypeCreatedCaregiverArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  caregiverOrgMetadata_Email_Icontains?: InputMaybe<Scalars['String']['input']>;
  caregiverOrgMetadata_FirstName_Icontains?: InputMaybe<Scalars['String']['input']>;
  caregiverOrgMetadata_HasEnteredParentCommunity?: InputMaybe<Scalars['Boolean']['input']>;
  caregiverOrgMetadata_LastName_Icontains?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type UserTypeCreatedCaregiverMetadataArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type UserTypeCreatedLearnerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdDate?: InputMaybe<Scalars['DateTime']['input']>;
  ehrLearningTreeId?: InputMaybe<Scalars['String']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  externalLastUpdate?: InputMaybe<Scalars['DateTime']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedDate?: InputMaybe<Scalars['DateTime']['input']>;
  manualGoalSyncLastUpdated?: InputMaybe<Scalars['DateTime']['input']>;
  manualGoalSyncStatus?: InputMaybe<ApiLearnerManualGoalSyncStatusChoices>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  runEngagementScorer?: InputMaybe<Scalars['Boolean']['input']>;
};


export type UserTypeCreatedLearnerFilesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  learner?: InputMaybe<Scalars['ID']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type UserTypeCreatedLearnerMetadataArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type UserTypeCreatedMediaArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  blobId?: InputMaybe<Scalars['UUID']['input']>;
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdDate?: InputMaybe<Scalars['DateTime']['input']>;
  endDatetime?: InputMaybe<Scalars['DateTime']['input']>;
  filePath?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedDate?: InputMaybe<Scalars['DateTime']['input']>;
  mediaGroup?: InputMaybe<Scalars['ID']['input']>;
  mediaLanguage?: InputMaybe<ApiMediaMediaLanguageChoices>;
  mediaSource?: InputMaybe<ApiMediaMediaSourceChoices>;
  mediaType?: InputMaybe<ApiMediaMediaTypeChoices>;
  multiplePeopleIncludingChildDuration?: InputMaybe<Scalars['Float']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  organization?: InputMaybe<Scalars['ID']['input']>;
  recordingId?: InputMaybe<Scalars['String']['input']>;
  startDatetime?: InputMaybe<Scalars['DateTime']['input']>;
  thumbnailManifestPath?: InputMaybe<Scalars['String']['input']>;
  totalDuration?: InputMaybe<Scalars['Float']['input']>;
  videoSession?: InputMaybe<Scalars['ID']['input']>;
  videoUploadStatus?: InputMaybe<ApiMediaVideoUploadStatusChoices>;
  viewedAt?: InputMaybe<Scalars['DateTime']['input']>;
  viewedBy?: InputMaybe<Scalars['ID']['input']>;
};


export type UserTypeCreatedMediaDeviceArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type UserTypeCreatedMediaMetadataArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type UserTypeCreatedNotificationDeviceTokenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type UserTypeCreatedParsedTreatmentPlanFilesDataArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  learner?: InputMaybe<Scalars['ID']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<ApiParsedTreatmentPlanFileDataStatusChoices>;
};


export type UserTypeCreatedProviderArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type UserTypeCreatedProviderFilesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  fileCategory?: InputMaybe<ApiProviderFileFileCategoryChoices>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  provider?: InputMaybe<Scalars['ID']['input']>;
};


export type UserTypeCreatedRelationshipArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type UserTypeCreatedSessionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdDate?: InputMaybe<Scalars['DateTime']['input']>;
  date?: InputMaybe<Scalars['Date']['input']>;
  endDatetime?: InputMaybe<Scalars['DateTime']['input']>;
  engagementScore?: InputMaybe<Scalars['Float']['input']>;
  engagementScoreVersion?: InputMaybe<Scalars['String']['input']>;
  finalMedia?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedDate?: InputMaybe<Scalars['DateTime']['input']>;
  meetingId?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  organization?: InputMaybe<Scalars['ID']['input']>;
  recorderType?: InputMaybe<ApiVideoSessionRecorderTypeChoices>;
  sessionRating?: InputMaybe<Scalars['Int']['input']>;
  sessionStatus?: InputMaybe<ApiVideoSessionSessionStatusChoices>;
  sourceType?: InputMaybe<ApiVideoSessionSourceTypeChoices>;
  startDatetime?: InputMaybe<Scalars['DateTime']['input']>;
  therapySession?: InputMaybe<Scalars['ID']['input']>;
};


export type UserTypeCreatedTherapySessionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  billingCode?: InputMaybe<Scalars['String']['input']>;
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdDate?: InputMaybe<Scalars['DateTime']['input']>;
  endDatetime?: InputMaybe<Scalars['DateTime']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedDate?: InputMaybe<Scalars['DateTime']['input']>;
  locationType?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  organization?: InputMaybe<Scalars['ID']['input']>;
  sessionTimezone?: InputMaybe<Scalars['String']['input']>;
  sessionType?: InputMaybe<ApiTherapySessionSessionTypeChoices>;
  startDatetime?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<ApiTherapySessionStatusChoices>;
};


export type UserTypeDomainSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type UserTypeFolderUpdatedByArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  auth0User?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdDate?: InputMaybe<Scalars['DateTime']['input']>;
  curriculum?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  folderType?: InputMaybe<ApiGoalBankFolderFolderTypeChoices>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedDate?: InputMaybe<Scalars['DateTime']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  organization?: InputMaybe<Scalars['ID']['input']>;
  updatedBy?: InputMaybe<Scalars['ID']['input']>;
};


export type UserTypeGoalBankFolderArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  auth0User?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdDate?: InputMaybe<Scalars['DateTime']['input']>;
  curriculum?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  folderType?: InputMaybe<ApiGoalBankFolderFolderTypeChoices>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedDate?: InputMaybe<Scalars['DateTime']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  organization?: InputMaybe<Scalars['ID']['input']>;
  updatedBy?: InputMaybe<Scalars['ID']['input']>;
};


export type UserTypeGoalBankTargetUpdatedByArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdDate?: InputMaybe<Scalars['DateTime']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  folder?: InputMaybe<Scalars['ID']['input']>;
  goalBank?: InputMaybe<Scalars['ID']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedDate?: InputMaybe<Scalars['DateTime']['input']>;
  longTermGoalBank?: InputMaybe<Scalars['ID']['input']>;
  masteryCriteria?: InputMaybe<Scalars['String']['input']>;
  medicalRationale?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  organization?: InputMaybe<Scalars['ID']['input']>;
  targetDescription?: InputMaybe<Scalars['String']['input']>;
  targetName?: InputMaybe<Scalars['String']['input']>;
  timelineEstimationType?: InputMaybe<ApiReportTargetGoalBankTimelineEstimationTypeChoices>;
  timelineEstimationValue?: InputMaybe<Scalars['Int']['input']>;
  updatedBy?: InputMaybe<Scalars['ID']['input']>;
};


export type UserTypeGoalbankfolderSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  auth0User?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdDate?: InputMaybe<Scalars['DateTime']['input']>;
  curriculum?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  folderType?: InputMaybe<ApiGoalBankFolderFolderTypeChoices>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedDate?: InputMaybe<Scalars['DateTime']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  organization?: InputMaybe<Scalars['ID']['input']>;
  updatedBy?: InputMaybe<Scalars['ID']['input']>;
};


export type UserTypeLongGoalBankUpdatedByArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdDate?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  folder?: InputMaybe<Scalars['ID']['input']>;
  goalName?: InputMaybe<Scalars['String']['input']>;
  goalType?: InputMaybe<ApiLongTermGoalBankGoalTypeChoices>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedDate?: InputMaybe<Scalars['DateTime']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  organization?: InputMaybe<Scalars['ID']['input']>;
  updatedBy?: InputMaybe<Scalars['ID']['input']>;
};


export type UserTypeLongtermgoalbankSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdDate?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  folder?: InputMaybe<Scalars['ID']['input']>;
  goalName?: InputMaybe<Scalars['String']['input']>;
  goalType?: InputMaybe<ApiLongTermGoalBankGoalTypeChoices>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedDate?: InputMaybe<Scalars['DateTime']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  organization?: InputMaybe<Scalars['ID']['input']>;
  updatedBy?: InputMaybe<Scalars['ID']['input']>;
};


export type UserTypeMediaTargetPredictionFeedbacksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdDate?: InputMaybe<Scalars['DateTime']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  improvementComment?: InputMaybe<Scalars['String']['input']>;
  isAccurate?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedDate?: InputMaybe<Scalars['DateTime']['input']>;
  mediaTargetPrediction?: InputMaybe<Scalars['ID']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  organization?: InputMaybe<Scalars['ID']['input']>;
  reasonOfRating?: InputMaybe<Scalars['String']['input']>;
  user?: InputMaybe<Scalars['ID']['input']>;
};


export type UserTypeMediaViewedByArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  blobId?: InputMaybe<Scalars['UUID']['input']>;
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdDate?: InputMaybe<Scalars['DateTime']['input']>;
  endDatetime?: InputMaybe<Scalars['DateTime']['input']>;
  filePath?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedDate?: InputMaybe<Scalars['DateTime']['input']>;
  mediaGroup?: InputMaybe<Scalars['ID']['input']>;
  mediaLanguage?: InputMaybe<ApiMediaMediaLanguageChoices>;
  mediaSource?: InputMaybe<ApiMediaMediaSourceChoices>;
  mediaType?: InputMaybe<ApiMediaMediaTypeChoices>;
  multiplePeopleIncludingChildDuration?: InputMaybe<Scalars['Float']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  organization?: InputMaybe<Scalars['ID']['input']>;
  recordingId?: InputMaybe<Scalars['String']['input']>;
  startDatetime?: InputMaybe<Scalars['DateTime']['input']>;
  thumbnailManifestPath?: InputMaybe<Scalars['String']['input']>;
  totalDuration?: InputMaybe<Scalars['Float']['input']>;
  videoSession?: InputMaybe<Scalars['ID']['input']>;
  videoUploadStatus?: InputMaybe<ApiMediaVideoUploadStatusChoices>;
  viewedAt?: InputMaybe<Scalars['DateTime']['input']>;
  viewedBy?: InputMaybe<Scalars['ID']['input']>;
};


export type UserTypeMembershipsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type UserTypeNotificationOptOutsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdDate?: InputMaybe<Scalars['DateTime']['input']>;
  deliveryMethod?: InputMaybe<ApiNotificationOptOutDeliveryMethodChoices>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedDate?: InputMaybe<Scalars['DateTime']['input']>;
  notificationType?: InputMaybe<ApiNotificationOptOutNotificationTypeChoices>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  organization?: InputMaybe<Scalars['ID']['input']>;
  user?: InputMaybe<Scalars['ID']['input']>;
};


export type UserTypeOrganizationuserrolesSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  auth0User?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  caregiver?: InputMaybe<Scalars['ID']['input']>;
  createdDate?: InputMaybe<Scalars['DateTime']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedDate?: InputMaybe<Scalars['DateTime']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  organization?: InputMaybe<Scalars['ID']['input']>;
  provider?: InputMaybe<Scalars['ID']['input']>;
  role?: InputMaybe<ApiOrganizationUserRolesRoleChoices>;
};


export type UserTypePromptDraftsAuthoredArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type UserTypePromptSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type UserTypePublishedMediaModelArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  model?: InputMaybe<ApiMediaModelConfigModelChoices>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  organization?: InputMaybe<Scalars['ID']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  publishedBy?: InputMaybe<Scalars['ID']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
};


export type UserTypePublishedReportTemplatesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdDate?: InputMaybe<Scalars['DateTime']['input']>;
  curriculum?: InputMaybe<Scalars['ID']['input']>;
  defaultPayorTemplate?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  enterpriseTemplate?: InputMaybe<Scalars['Boolean']['input']>;
  exportFramework?: InputMaybe<ApiReportTemplateExportFrameworkChoices>;
  exportTemplateFont?: InputMaybe<ApiReportTemplateExportTemplateFontChoices>;
  fileUploadConfig?: InputMaybe<ApiReportTemplateFileUploadConfigChoices>;
  finalApproverWaitsForReviewers?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  footerText?: InputMaybe<Scalars['String']['input']>;
  headerText?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  isBaseTemplate?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedDate?: InputMaybe<Scalars['DateTime']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderedReplacement?: InputMaybe<Scalars['Boolean']['input']>;
  organizationLogoAllowed?: InputMaybe<Scalars['Boolean']['input']>;
  payorType?: InputMaybe<ApiReportTemplatePayorTypeChoices>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  publishedBy?: InputMaybe<Scalars['ID']['input']>;
  reportNarrativeMappingWorkflow?: InputMaybe<Scalars['Boolean']['input']>;
  reportType?: InputMaybe<ApiReportTemplateReportTypeChoices>;
  requireAllQaResolved?: InputMaybe<Scalars['Boolean']['input']>;
  requireApprovalBeforeExport?: InputMaybe<Scalars['Boolean']['input']>;
  sampleFile?: InputMaybe<Scalars['String']['input']>;
  sampleStatus?: InputMaybe<ApiReportTemplateSampleStatusChoices>;
  status?: InputMaybe<ApiReportTemplateStatusChoices>;
  templateLogoUrl?: InputMaybe<Scalars['String']['input']>;
  templateUrl?: InputMaybe<Scalars['String']['input']>;
  treatmentPlanTemplate?: InputMaybe<Scalars['ID']['input']>;
  unifiedExport?: InputMaybe<Scalars['Boolean']['input']>;
  updatedBy?: InputMaybe<Scalars['ID']['input']>;
};


export type UserTypeReceivedNotificationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  channel?: InputMaybe<ApiNotificationsChannelChoices>;
  description?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  notificationType?: InputMaybe<ApiNotificationsNotificationTypeChoices>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  organization?: InputMaybe<Scalars['ID']['input']>;
  read?: InputMaybe<Scalars['Boolean']['input']>;
  recipient?: InputMaybe<Scalars['ID']['input']>;
  recipient_Auth0id?: InputMaybe<Scalars['String']['input']>;
  sender?: InputMaybe<Scalars['ID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};


export type UserTypeRecommendationBankFolderArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  auth0User?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdDate?: InputMaybe<Scalars['DateTime']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  folderType?: InputMaybe<ApiRecommendationBankFolderFolderTypeChoices>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedDate?: InputMaybe<Scalars['DateTime']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  organization?: InputMaybe<Scalars['ID']['input']>;
  updatedBy?: InputMaybe<Scalars['ID']['input']>;
};


export type UserTypeRecommendationBankFolderUpdatedByArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  auth0User?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdDate?: InputMaybe<Scalars['DateTime']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  folderType?: InputMaybe<ApiRecommendationBankFolderFolderTypeChoices>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedDate?: InputMaybe<Scalars['DateTime']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  organization?: InputMaybe<Scalars['ID']['input']>;
  updatedBy?: InputMaybe<Scalars['ID']['input']>;
};


export type UserTypeRecommendationGoalBankUpdatedByArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdDate?: InputMaybe<Scalars['DateTime']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  folder?: InputMaybe<Scalars['ID']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedDate?: InputMaybe<Scalars['DateTime']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  organization?: InputMaybe<Scalars['ID']['input']>;
  recommendationCategory?: InputMaybe<Scalars['String']['input']>;
  recommendationContent?: InputMaybe<Scalars['String']['input']>;
  recommendationTitle?: InputMaybe<Scalars['String']['input']>;
  updatedBy?: InputMaybe<Scalars['ID']['input']>;
};


export type UserTypeRecommendationbankfolderSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  auth0User?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdDate?: InputMaybe<Scalars['DateTime']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  folderType?: InputMaybe<ApiRecommendationBankFolderFolderTypeChoices>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedDate?: InputMaybe<Scalars['DateTime']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  organization?: InputMaybe<Scalars['ID']['input']>;
  updatedBy?: InputMaybe<Scalars['ID']['input']>;
};


export type UserTypeRecommendationbankitemSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdDate?: InputMaybe<Scalars['DateTime']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  folder?: InputMaybe<Scalars['ID']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedDate?: InputMaybe<Scalars['DateTime']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  organization?: InputMaybe<Scalars['ID']['input']>;
  recommendationCategory?: InputMaybe<Scalars['String']['input']>;
  recommendationContent?: InputMaybe<Scalars['String']['input']>;
  recommendationTitle?: InputMaybe<Scalars['String']['input']>;
  updatedBy?: InputMaybe<Scalars['ID']['input']>;
};


export type UserTypeReportSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  isArchive?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  ordering?: InputMaybe<Scalars['String']['input']>;
  reportClientDetails_ClientFirstName_Icontains?: InputMaybe<Scalars['String']['input']>;
};


export type UserTypeReportclientdetailsSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type UserTypeReportdomainSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdDate?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedDate?: InputMaybe<Scalars['DateTime']['input']>;
  learner?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  organization?: InputMaybe<Scalars['ID']['input']>;
  rankOrder?: InputMaybe<Scalars['Int']['input']>;
  reportTreatmentPlan?: InputMaybe<Scalars['ID']['input']>;
};


export type UserTypeReportgoalSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  aiBaselineDataPredictionStatus?: InputMaybe<ApiReportGoalAiBaselineDataPredictionStatusChoices>;
  aiGenerated?: InputMaybe<Scalars['Boolean']['input']>;
  aiGoalAttainmentScalePredictionStatus?: InputMaybe<ApiReportGoalAiGoalAttainmentScalePredictionStatusChoices>;
  aiProgressSummaryPredictionStatus?: InputMaybe<ApiReportGoalAiProgressSummaryPredictionStatusChoices>;
  assessmentToolSource?: InputMaybe<Scalars['String']['input']>;
  baselineData?: InputMaybe<Scalars['String']['input']>;
  baselineDate?: InputMaybe<Scalars['Date']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  chartFromDate?: InputMaybe<Scalars['Date']['input']>;
  chartImageUrl?: InputMaybe<Scalars['String']['input']>;
  chartToDate?: InputMaybe<Scalars['Date']['input']>;
  chartType?: InputMaybe<ApiReportGoalChartTypeChoices>;
  completionDate?: InputMaybe<Scalars['Date']['input']>;
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdDate?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  excludeFromReport?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  gasLevel1?: InputMaybe<Scalars['String']['input']>;
  gasLevel3?: InputMaybe<Scalars['String']['input']>;
  gasLevel4?: InputMaybe<Scalars['String']['input']>;
  gasMatchMessage?: InputMaybe<Scalars['String']['input']>;
  gasMatchStatus?: InputMaybe<ApiReportGoalGasMatchStatusChoices>;
  gasScore?: InputMaybe<Scalars['String']['input']>;
  generalizationCriteria?: InputMaybe<Scalars['String']['input']>;
  goal?: InputMaybe<Scalars['ID']['input']>;
  goalBank?: InputMaybe<Scalars['ID']['input']>;
  goalName?: InputMaybe<Scalars['String']['input']>;
  goalSubType?: InputMaybe<Scalars['String']['input']>;
  goalType?: InputMaybe<Scalars['String']['input']>;
  hasMedicalNecessity?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  inUse?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedDate?: InputMaybe<Scalars['DateTime']['input']>;
  learner?: InputMaybe<Scalars['ID']['input']>;
  masteryCriteria?: InputMaybe<Scalars['String']['input']>;
  medicalNecessityCriteria?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  organization?: InputMaybe<Scalars['ID']['input']>;
  predictionId?: InputMaybe<Scalars['String']['input']>;
  programGoal?: InputMaybe<Scalars['String']['input']>;
  progressSummary?: InputMaybe<Scalars['String']['input']>;
  projectedIntroductionDate?: InputMaybe<Scalars['Date']['input']>;
  rationale?: InputMaybe<Scalars['String']['input']>;
  report?: InputMaybe<Scalars['ID']['input']>;
  reportDomain?: InputMaybe<Scalars['ID']['input']>;
  reportTreatmentPlan?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<ApiReportGoalStatusChoices>;
  suggestionConfidence?: InputMaybe<Scalars['Float']['input']>;
  summaryReviewed?: InputMaybe<Scalars['Boolean']['input']>;
  summaryReviewedOn?: InputMaybe<Scalars['DateTime']['input']>;
  timelineEstimationType?: InputMaybe<ApiReportGoalTimelineEstimationTypeChoices>;
  timelineEstimationValue?: InputMaybe<Scalars['Int']['input']>;
};


export type UserTypeReportgoalbankSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  assessmentToolSource?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdDate?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  domain?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  folder?: InputMaybe<Scalars['ID']['input']>;
  goalName?: InputMaybe<Scalars['String']['input']>;
  hasMedicalNecessity?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedDate?: InputMaybe<Scalars['DateTime']['input']>;
  longTermGoalBank?: InputMaybe<Scalars['ID']['input']>;
  masteryCriteria?: InputMaybe<Scalars['String']['input']>;
  medicalNecessityCriteria?: InputMaybe<Scalars['String']['input']>;
  medicalRationale?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  organization?: InputMaybe<Scalars['ID']['input']>;
  programGoal?: InputMaybe<Scalars['String']['input']>;
  timelineEstimationType?: InputMaybe<ApiReportGoalBankTimelineEstimationTypeChoices>;
  timelineEstimationValue?: InputMaybe<Scalars['Int']['input']>;
  updatedBy?: InputMaybe<Scalars['ID']['input']>;
};


export type UserTypeReporttargetSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  aiGenerated?: InputMaybe<Scalars['Boolean']['input']>;
  aiProgressSummaryPredictionStatus?: InputMaybe<ApiReportTargetAiProgressSummaryPredictionStatusChoices>;
  baselineData?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  chartFromDate?: InputMaybe<Scalars['Date']['input']>;
  chartImageUrl?: InputMaybe<Scalars['String']['input']>;
  chartToDate?: InputMaybe<Scalars['Date']['input']>;
  chartType?: InputMaybe<ApiReportTargetChartTypeChoices>;
  completionDate?: InputMaybe<Scalars['Date']['input']>;
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdDate?: InputMaybe<Scalars['DateTime']['input']>;
  excludeFromReport?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  inUse?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedDate?: InputMaybe<Scalars['DateTime']['input']>;
  learner?: InputMaybe<Scalars['ID']['input']>;
  masteryCriteria?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  organization?: InputMaybe<Scalars['ID']['input']>;
  predictionId?: InputMaybe<Scalars['String']['input']>;
  priorityOrder?: InputMaybe<Scalars['Int']['input']>;
  progressSummary?: InputMaybe<Scalars['String']['input']>;
  progressType?: InputMaybe<ApiReportTargetProgressTypeChoices>;
  projectedIntroductionDate?: InputMaybe<Scalars['Date']['input']>;
  report?: InputMaybe<Scalars['ID']['input']>;
  reportDomain?: InputMaybe<Scalars['ID']['input']>;
  reportGoal?: InputMaybe<Scalars['ID']['input']>;
  reportTreatmentPlan?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<ApiReportTargetStatusChoices>;
  summaryReviewed?: InputMaybe<Scalars['Boolean']['input']>;
  summaryReviewedOn?: InputMaybe<Scalars['DateTime']['input']>;
  target?: InputMaybe<Scalars['ID']['input']>;
  targetDescription?: InputMaybe<Scalars['String']['input']>;
  targetName?: InputMaybe<Scalars['String']['input']>;
  timelineEstimationType?: InputMaybe<ApiReportTargetTimelineEstimationTypeChoices>;
  timelineEstimationValue?: InputMaybe<Scalars['Int']['input']>;
};


export type UserTypeReporttargetgoalbankSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdDate?: InputMaybe<Scalars['DateTime']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  folder?: InputMaybe<Scalars['ID']['input']>;
  goalBank?: InputMaybe<Scalars['ID']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedDate?: InputMaybe<Scalars['DateTime']['input']>;
  longTermGoalBank?: InputMaybe<Scalars['ID']['input']>;
  masteryCriteria?: InputMaybe<Scalars['String']['input']>;
  medicalRationale?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  organization?: InputMaybe<Scalars['ID']['input']>;
  targetDescription?: InputMaybe<Scalars['String']['input']>;
  targetName?: InputMaybe<Scalars['String']['input']>;
  timelineEstimationType?: InputMaybe<ApiReportTargetGoalBankTimelineEstimationTypeChoices>;
  timelineEstimationValue?: InputMaybe<Scalars['Int']['input']>;
  updatedBy?: InputMaybe<Scalars['ID']['input']>;
};


export type UserTypeReporttemplateSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdDate?: InputMaybe<Scalars['DateTime']['input']>;
  curriculum?: InputMaybe<Scalars['ID']['input']>;
  defaultPayorTemplate?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  enterpriseTemplate?: InputMaybe<Scalars['Boolean']['input']>;
  exportFramework?: InputMaybe<ApiReportTemplateExportFrameworkChoices>;
  exportTemplateFont?: InputMaybe<ApiReportTemplateExportTemplateFontChoices>;
  fileUploadConfig?: InputMaybe<ApiReportTemplateFileUploadConfigChoices>;
  finalApproverWaitsForReviewers?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  footerText?: InputMaybe<Scalars['String']['input']>;
  headerText?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  isBaseTemplate?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedDate?: InputMaybe<Scalars['DateTime']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderedReplacement?: InputMaybe<Scalars['Boolean']['input']>;
  organizationLogoAllowed?: InputMaybe<Scalars['Boolean']['input']>;
  payorType?: InputMaybe<ApiReportTemplatePayorTypeChoices>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  publishedBy?: InputMaybe<Scalars['ID']['input']>;
  reportNarrativeMappingWorkflow?: InputMaybe<Scalars['Boolean']['input']>;
  reportType?: InputMaybe<ApiReportTemplateReportTypeChoices>;
  requireAllQaResolved?: InputMaybe<Scalars['Boolean']['input']>;
  requireApprovalBeforeExport?: InputMaybe<Scalars['Boolean']['input']>;
  sampleFile?: InputMaybe<Scalars['String']['input']>;
  sampleStatus?: InputMaybe<ApiReportTemplateSampleStatusChoices>;
  status?: InputMaybe<ApiReportTemplateStatusChoices>;
  templateLogoUrl?: InputMaybe<Scalars['String']['input']>;
  templateUrl?: InputMaybe<Scalars['String']['input']>;
  treatmentPlanTemplate?: InputMaybe<Scalars['ID']['input']>;
  unifiedExport?: InputMaybe<Scalars['Boolean']['input']>;
  updatedBy?: InputMaybe<Scalars['ID']['input']>;
};


export type UserTypeReporttemplatesectionSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type UserTypeReporttemplatesectionfieldSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  fieldIdentifier?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  reportSection?: InputMaybe<Scalars['ID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};


export type UserTypeResolvedReportSuggestionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  createdDate?: InputMaybe<Scalars['DateTime']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  goalField?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedDate?: InputMaybe<Scalars['DateTime']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  organization?: InputMaybe<Scalars['ID']['input']>;
  predictionId?: InputMaybe<Scalars['String']['input']>;
  report?: InputMaybe<Scalars['ID']['input']>;
  reportGoal?: InputMaybe<Scalars['ID']['input']>;
  reportSectionField?: InputMaybe<Scalars['ID']['input']>;
  reportTarget?: InputMaybe<Scalars['ID']['input']>;
  resolvedAt?: InputMaybe<Scalars['DateTime']['input']>;
  resolvedBy?: InputMaybe<Scalars['ID']['input']>;
  targetField?: InputMaybe<Scalars['String']['input']>;
};


export type UserTypeSentNotificationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  channel?: InputMaybe<ApiNotificationsChannelChoices>;
  description?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  notificationType?: InputMaybe<ApiNotificationsNotificationTypeChoices>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  organization?: InputMaybe<Scalars['ID']['input']>;
  read?: InputMaybe<Scalars['Boolean']['input']>;
  recipient?: InputMaybe<Scalars['ID']['input']>;
  recipient_Auth0id?: InputMaybe<Scalars['String']['input']>;
  sender?: InputMaybe<Scalars['ID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};


export type UserTypeSessionmediareviewactivitylogSetArgs = {
  activityType?: InputMaybe<ApiSessionMediaReviewActivityLogActivityTypeChoices>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdDate?: InputMaybe<Scalars['DateTime']['input']>;
  durationSeconds?: InputMaybe<Scalars['Int']['input']>;
  endTime?: InputMaybe<Scalars['Float']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedDate?: InputMaybe<Scalars['DateTime']['input']>;
  media?: InputMaybe<Scalars['ID']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  organization?: InputMaybe<Scalars['ID']['input']>;
  startTime?: InputMaybe<Scalars['Float']['input']>;
  user?: InputMaybe<Scalars['ID']['input']>;
};


export type UserTypeShortGoalBankUpdatedByArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  assessmentToolSource?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdDate?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  domain?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  folder?: InputMaybe<Scalars['ID']['input']>;
  goalName?: InputMaybe<Scalars['String']['input']>;
  hasMedicalNecessity?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedDate?: InputMaybe<Scalars['DateTime']['input']>;
  longTermGoalBank?: InputMaybe<Scalars['ID']['input']>;
  masteryCriteria?: InputMaybe<Scalars['String']['input']>;
  medicalNecessityCriteria?: InputMaybe<Scalars['String']['input']>;
  medicalRationale?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  organization?: InputMaybe<Scalars['ID']['input']>;
  programGoal?: InputMaybe<Scalars['String']['input']>;
  timelineEstimationType?: InputMaybe<ApiReportGoalBankTimelineEstimationTypeChoices>;
  timelineEstimationValue?: InputMaybe<Scalars['Int']['input']>;
  updatedBy?: InputMaybe<Scalars['ID']['input']>;
};


export type UserTypeTranscriptlinerecordSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  speaker?: InputMaybe<Scalars['String']['input']>;
};


export type UserTypeTreatmentplantemplatedomainSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type UserTypeUpdatedUserBillingDetailsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  amount?: InputMaybe<Scalars['Decimal']['input']>;
  auth0User?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdDate?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  invoiceId?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedDate?: InputMaybe<Scalars['DateTime']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  organization?: InputMaybe<Scalars['ID']['input']>;
  paymentIntentId?: InputMaybe<Scalars['String']['input']>;
  paymentMethodId?: InputMaybe<Scalars['String']['input']>;
  paymentStatus?: InputMaybe<ApiUserBillingDetailsPaymentStatusChoices>;
  priceId?: InputMaybe<Scalars['String']['input']>;
  productId?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
  report?: InputMaybe<Scalars['ID']['input']>;
  transactionType?: InputMaybe<ApiUserBillingDetailsTransactionTypeChoices>;
  updatedBy?: InputMaybe<Scalars['ID']['input']>;
  userStripeAccount?: InputMaybe<Scalars['ID']['input']>;
};


export type UserTypeUpdatedUserStripeAccountDetailsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  auth0User?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdDate?: InputMaybe<Scalars['DateTime']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedDate?: InputMaybe<Scalars['DateTime']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  organization?: InputMaybe<Scalars['ID']['input']>;
  pendingAssessment?: InputMaybe<Scalars['Int']['input']>;
  purchasedAssessment?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId?: InputMaybe<Scalars['String']['input']>;
  stripePaymentMethodId?: InputMaybe<Scalars['String']['input']>;
  updatedBy?: InputMaybe<Scalars['ID']['input']>;
};


export type UserTypeUserBillingDetailsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  amount?: InputMaybe<Scalars['Decimal']['input']>;
  auth0User?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdDate?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  invoiceId?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedDate?: InputMaybe<Scalars['DateTime']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  organization?: InputMaybe<Scalars['ID']['input']>;
  paymentIntentId?: InputMaybe<Scalars['String']['input']>;
  paymentMethodId?: InputMaybe<Scalars['String']['input']>;
  paymentStatus?: InputMaybe<ApiUserBillingDetailsPaymentStatusChoices>;
  priceId?: InputMaybe<Scalars['String']['input']>;
  productId?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
  report?: InputMaybe<Scalars['ID']['input']>;
  transactionType?: InputMaybe<ApiUserBillingDetailsTransactionTypeChoices>;
  updatedBy?: InputMaybe<Scalars['ID']['input']>;
  userStripeAccount?: InputMaybe<Scalars['ID']['input']>;
};


export type UserTypeUserNotificationDeviceTokenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type ValidateUserAndOrganizationData = {
  __typename?: 'ValidateUserAndOrganizationData';
  isValidLearner?: Maybe<Scalars['Boolean']['output']>;
  isValidOrganization?: Maybe<Scalars['Boolean']['output']>;
  isValidProvider?: Maybe<Scalars['Boolean']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type ValidateUserAndOrganizationDataInput = {
  learnerId?: InputMaybe<Scalars['ID']['input']>;
  organizationId: Scalars['ID']['input'];
  providerId?: InputMaybe<Scalars['ID']['input']>;
};

export type Verify = {
  __typename?: 'Verify';
  payload: Scalars['GenericScalar']['output'];
};

export type VideoCommentsReceivedByRbtRawDataType = {
  __typename?: 'VideoCommentsReceivedByRbtRawDataType';
  rawData?: Maybe<Array<Maybe<VideoCommentsReceivedByRbtRawTextDataType>>>;
  totalRecordsCount?: Maybe<Scalars['Int']['output']>;
};

export type VideoCommentsReceivedByRbtRawTextDataType = {
  __typename?: 'VideoCommentsReceivedByRbtRawTextDataType';
  clientId?: Maybe<Scalars['Int']['output']>;
  clientName?: Maybe<Scalars['String']['output']>;
  commentTypeCounts?: Maybe<CommentsDataType>;
  rbtName?: Maybe<Scalars['String']['output']>;
  sessionDate?: Maybe<Scalars['Date']['output']>;
  sessionDatetime?: Maybe<Scalars['DateTime']['output']>;
  sessionDuration?: Maybe<Scalars['Float']['output']>;
  totalComments?: Maybe<Scalars['Int']['output']>;
};

export enum VideoSessionSourceTypeEnums {
  InAppVideoRecording = 'IN_APP_VIDEO_RECORDING',
  UserVideoUpload = 'USER_VIDEO_UPLOAD'
}

export enum VideoSessionStatusEnums {
  Completed = 'COMPLETED',
  Created = 'CREATED',
  Failed = 'FAILED',
  FullCaptureError = 'FULL_CAPTURE_ERROR',
  PartialCaptureError = 'PARTIAL_CAPTURE_ERROR',
  PartialUploadError = 'PARTIAL_UPLOAD_ERROR',
  Processing = 'PROCESSING',
  Recording = 'RECORDING',
  Scheduled = 'SCHEDULED',
  Uploading = 'UPLOADING'
}

export type VideoSessionType = Node & {
  __typename?: 'VideoSessionType';
  audio: MediaAudioTypeConnection;
  comment?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<UserType>;
  createdDate: Scalars['DateTime']['output'];
  date: Scalars['Date']['output'];
  endDatetime?: Maybe<Scalars['DateTime']['output']>;
  engagementScore?: Maybe<Scalars['Float']['output']>;
  engagementScoreVersion?: Maybe<Scalars['String']['output']>;
  finalMedia?: Maybe<MediaType>;
  /** The ID of the object */
  id: Scalars['ID']['output'];
  lastUpdatedDate: Scalars['DateTime']['output'];
  media: MediaTypeConnection;
  mediastream?: Maybe<MediaStreamType>;
  /** Meeting ID from Zoom or other meeting platform */
  meetingId?: Maybe<Scalars['String']['output']>;
  organization: OrganizationType;
  pk?: Maybe<Scalars['Int']['output']>;
  recorderType?: Maybe<ApiVideoSessionRecorderTypeChoices>;
  sessionAudioMetrics?: Maybe<SessionAudioMetricsType>;
  sessionRating?: Maybe<Scalars['Int']['output']>;
  sessionStatus?: Maybe<ApiVideoSessionSessionStatusChoices>;
  sessionaipredictionSet: SessionAiPredictionTypeConnection;
  sessionanalyzerfeedbackSet: SessionAnalyzerFeedbackTypeConnection;
  sessioncaregiverSet: SessionCaregiverTypeConnection;
  sessionengagementinsightSet: SessionEngagementInsightTypeConnection;
  sessionengagementscorepartSet: SessionEngagementScorePartTypeConnection;
  sessionlearnerSet: SessionLearnerTypeConnection;
  sessionproviderSet: SessionProviderTypeConnection;
  sourceType?: Maybe<ApiVideoSessionSourceTypeChoices>;
  startDatetime?: Maybe<Scalars['DateTime']['output']>;
  therapySession?: Maybe<TherapySessionType>;
  transcript: TranscriptTypeConnection;
};


export type VideoSessionTypeAudioArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type VideoSessionTypeMediaArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  blobId?: InputMaybe<Scalars['UUID']['input']>;
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdDate?: InputMaybe<Scalars['DateTime']['input']>;
  endDatetime?: InputMaybe<Scalars['DateTime']['input']>;
  filePath?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedDate?: InputMaybe<Scalars['DateTime']['input']>;
  mediaGroup?: InputMaybe<Scalars['ID']['input']>;
  mediaLanguage?: InputMaybe<ApiMediaMediaLanguageChoices>;
  mediaSource?: InputMaybe<ApiMediaMediaSourceChoices>;
  mediaType?: InputMaybe<ApiMediaMediaTypeChoices>;
  multiplePeopleIncludingChildDuration?: InputMaybe<Scalars['Float']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  organization?: InputMaybe<Scalars['ID']['input']>;
  recordingId?: InputMaybe<Scalars['String']['input']>;
  startDatetime?: InputMaybe<Scalars['DateTime']['input']>;
  thumbnailManifestPath?: InputMaybe<Scalars['String']['input']>;
  totalDuration?: InputMaybe<Scalars['Float']['input']>;
  videoSession?: InputMaybe<Scalars['ID']['input']>;
  videoUploadStatus?: InputMaybe<ApiMediaVideoUploadStatusChoices>;
  viewedAt?: InputMaybe<Scalars['DateTime']['input']>;
  viewedBy?: InputMaybe<Scalars['ID']['input']>;
};


export type VideoSessionTypeSessionaipredictionSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdDate?: InputMaybe<Scalars['DateTime']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedDate?: InputMaybe<Scalars['DateTime']['input']>;
  model?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  organization?: InputMaybe<Scalars['ID']['input']>;
  prediction?: InputMaybe<Scalars['String']['input']>;
  predictionType?: InputMaybe<ApiSessionAiPredictionPredictionTypeChoices>;
  vellumPredictionId?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
  videoSession?: InputMaybe<Scalars['ID']['input']>;
};


export type VideoSessionTypeSessionanalyzerfeedbackSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdDate?: InputMaybe<Scalars['DateTime']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  improveOptions?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  improveText?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedDate?: InputMaybe<Scalars['DateTime']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  organization?: InputMaybe<Scalars['ID']['input']>;
  positiveFeedback?: InputMaybe<Scalars['Boolean']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
  videoSession?: InputMaybe<Scalars['ID']['input']>;
  videoTimestamp?: InputMaybe<Scalars['Time']['input']>;
};


export type VideoSessionTypeSessioncaregiverSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type VideoSessionTypeSessionengagementinsightSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdDate?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  endTime?: InputMaybe<Scalars['Float']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  insightType?: InputMaybe<ApiSessionEngagementInsightInsightTypeChoices>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedDate?: InputMaybe<Scalars['DateTime']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  organization?: InputMaybe<Scalars['ID']['input']>;
  startTime?: InputMaybe<Scalars['Float']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
  videoSession?: InputMaybe<Scalars['ID']['input']>;
};


export type VideoSessionTypeSessionengagementscorepartSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdDate?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  engaged?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedDate?: InputMaybe<Scalars['DateTime']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  organization?: InputMaybe<Scalars['ID']['input']>;
  partEndTime?: InputMaybe<Scalars['Float']['input']>;
  partStartTime?: InputMaybe<Scalars['Float']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
  videoSession?: InputMaybe<Scalars['ID']['input']>;
};


export type VideoSessionTypeSessionlearnerSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  videoSession_SessionStatus?: InputMaybe<ApiVideoSessionSessionStatusChoices>;
};


export type VideoSessionTypeSessionproviderSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdDate?: InputMaybe<Scalars['DateTime']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedDate?: InputMaybe<Scalars['DateTime']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  organization?: InputMaybe<Scalars['ID']['input']>;
  provider?: InputMaybe<Scalars['ID']['input']>;
  providerType?: InputMaybe<ApiSessionProviderProviderTypeChoices>;
  therapySession?: InputMaybe<Scalars['ID']['input']>;
  videoSession?: InputMaybe<Scalars['ID']['input']>;
};


export type VideoSessionTypeTranscriptArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  aiModelVersion?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdDate?: InputMaybe<Scalars['DateTime']['input']>;
  filePath?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedDate?: InputMaybe<Scalars['DateTime']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  organization?: InputMaybe<Scalars['ID']['input']>;
  transcriptMedia?: InputMaybe<Scalars['ID']['input']>;
  transcriptModel?: InputMaybe<ApiTranscriptTranscriptModelChoices>;
  transcriptType?: InputMaybe<ApiTranscriptTranscriptTypeChoices>;
  videoSession?: InputMaybe<Scalars['ID']['input']>;
};

export type VideoSessionTypeConnection = {
  __typename?: 'VideoSessionTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<VideoSessionTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `VideoSessionType` and its cursor. */
export type VideoSessionTypeEdge = {
  __typename?: 'VideoSessionTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<VideoSessionType>;
};

export type VideosDurationOverviewGraphType = {
  __typename?: 'VideosDurationOverviewGraphType';
  currentDuration?: Maybe<Scalars['Float']['output']>;
  date?: Maybe<Scalars['String']['output']>;
  previousDuration?: Maybe<Scalars['Float']['output']>;
};

export type VideosReviewedOverviewGraphType = {
  __typename?: 'VideosReviewedOverviewGraphType';
  currentReviewedCount?: Maybe<Scalars['Int']['output']>;
  currentReviewedPercentage?: Maybe<Scalars['Int']['output']>;
  currentTotalCount?: Maybe<Scalars['Int']['output']>;
  date?: Maybe<Scalars['String']['output']>;
  previousReviewedCount?: Maybe<Scalars['Int']['output']>;
  previousReviewedPercentage?: Maybe<Scalars['Int']['output']>;
  previousTotalCount?: Maybe<Scalars['Int']['output']>;
};

export type VideosReviewedRawTextDataType = {
  __typename?: 'VideosReviewedRawTextDataType';
  clientId?: Maybe<Scalars['Int']['output']>;
  clientName?: Maybe<Scalars['String']['output']>;
  learnerBcba?: Maybe<Scalars['String']['output']>;
  percentReviewed?: Maybe<Scalars['Int']['output']>;
  sessionViewedBy?: Maybe<Scalars['String']['output']>;
  totalVideos?: Maybe<Scalars['Int']['output']>;
  videosReviewed?: Maybe<Scalars['Int']['output']>;
};

export type VideosReviewedRawTextType = {
  __typename?: 'VideosReviewedRawTextType';
  rawData?: Maybe<Array<Maybe<VideosReviewedRawTextDataType>>>;
  totalRecordsCount?: Maybe<Scalars['Int']['output']>;
};

export type VoiceSignatureType = Node & {
  __typename?: 'VoiceSignatureType';
  createdDate: Scalars['DateTime']['output'];
  /** The ID of the object */
  id: Scalars['ID']['output'];
  lastUpdatedDate: Scalars['DateTime']['output'];
  /** The learner the voice signature relates to */
  learner?: Maybe<LearnerType>;
  /** The speech level of the learner */
  learnerLevel?: Maybe<Scalars['String']['output']>;
  organization: OrganizationType;
  pk?: Maybe<Scalars['Int']['output']>;
  /** The provider the voice signature relates to */
  provider?: Maybe<ProviderType>;
  /** The s3 path where the voice signature file is stored. */
  s3Path: Scalars['String']['output'];
  /** total voice signature media duration in MS */
  totalDurationMs?: Maybe<Scalars['Int']['output']>;
};

export type VoiceSignatureTypeConnection = {
  __typename?: 'VoiceSignatureTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<VoiceSignatureTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `VoiceSignatureType` and its cursor. */
export type VoiceSignatureTypeEdge = {
  __typename?: 'VoiceSignatureTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<VoiceSignatureType>;
};

/**
 * The upload-derived capture methods for a `WET_SIGNATURE` field —
 * "typed" is composed client-side through the generic content-update
 * mutation instead (design.md Decision 3 of `unify-wet-signature-field-type`),
 * so it isn't offered here.
 */
export enum WetSignatureCaptureMethodEnums {
  Drawn = 'DRAWN',
  Uploaded = 'UPLOADED'
}

export enum WorkflowStatusEnum {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  InProgress = 'IN_PROGRESS'
}

export type WriteEvalPromptThemes = {
  __typename?: 'WriteEvalPromptThemes';
  status?: Maybe<Scalars['Boolean']['output']>;
  themesDeleted?: Maybe<Scalars['Int']['output']>;
  themesSkipped?: Maybe<Scalars['Int']['output']>;
  themesWritten?: Maybe<Scalars['Int']['output']>;
};

export type DisconnectCaregiverFromOrganizationMutationVariables = Exact<{
  organization: Scalars['ID']['input'];
  caregiver?: InputMaybe<Scalars['ID']['input']>;
}>;


export type DisconnectCaregiverFromOrganizationMutation = { __typename?: 'Mutation', disconnectCaregiverFromOrganization?: { __typename?: 'DisconnectCaregiverFromOrganization', success?: boolean | null, message?: string | null } | null };

export type ReissueCaregiverInvitationMutationVariables = Exact<{
  caregiverId: Scalars['ID']['input'];
}>;


export type ReissueCaregiverInvitationMutation = { __typename?: 'Mutation', reissueCaregiverInvitation?: { __typename?: 'ReissueCaregiverInvitation', message?: string | null, status?: boolean | null } | null };

export type SendCaregiverActivationCodeNotificationMutationVariables = Exact<{
  caregiverId: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
}>;


export type SendCaregiverActivationCodeNotificationMutation = { __typename?: 'Mutation', sendCaregiverActivationCodeNotification?: { __typename?: 'SendCaregiverActivationCodeNotification', status?: boolean | null, message?: string | null } | null };

export type SendCaregiverActivationCodeNotificationsMutationVariables = Exact<{
  caregiverIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type SendCaregiverActivationCodeNotificationsMutation = { __typename?: 'Mutation', sendCaregiverActivationCodeNotifications?: { __typename?: 'SendCaregiverActivationCodeNotifications', status?: boolean | null, message?: string | null } | null };

export type UpdateCaregiverMetadataMutationVariables = Exact<{
  caregiver?: InputMaybe<Scalars['ID']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  phoneNumber1?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateCaregiverMetadataMutation = { __typename?: 'Mutation', updateCaregiverMetadata?: { __typename?: 'UpdateCaregiverMetadata', caregiverMetadata?: { __typename?: 'CaregiverMetadataType', id: string, firstName: string, lastName: string, email?: string | null, phoneNumber1?: string | null } | null } | null };

export type CreateChatNoteMutationVariables = Exact<{
  input: CreateUpdateChatNoteInput;
}>;


export type CreateChatNoteMutation = { __typename?: 'Mutation', createChatNote?: { __typename?: 'CreateUpdateChatNote', success?: boolean | null, message?: string | null, chatNote?: { __typename?: 'ChatNoteType', id: string, content?: string | null, createdDate: any, user: { __typename?: 'UserType', auth0id?: string | null, provider?: { __typename?: 'ProviderType', id: string, providermetadata?: { __typename?: 'ProviderMetadataType', firstName: string, lastName?: string | null } | null } | null } } | null } | null };

export type CreateChatTagMutationVariables = Exact<{
  input: CreateChatTagInput;
}>;


export type CreateChatTagMutation = { __typename?: 'Mutation', createChatTag?: { __typename?: 'CreateChatTag', success?: boolean | null, message?: string | null, chatTag?: { __typename?: 'ChatTagType', id: string, name: string } | null, chat?: { __typename?: 'ChatType', id: string, status: ApiChatStatusChoices } | null } | null };

export type DeleteChatNoteMutationVariables = Exact<{
  chatNoteId: Scalars['ID']['input'];
}>;


export type DeleteChatNoteMutation = { __typename?: 'Mutation', deleteChatNote?: { __typename?: 'DeleteChatNote', success?: boolean | null, message?: string | null } | null };

export type FinishChatMutationVariables = Exact<{
  chatId: Scalars['ID']['input'];
}>;


export type FinishChatMutation = { __typename?: 'Mutation', finishChat?: { __typename?: 'FinishChat', success?: boolean | null, message?: string | null, chat?: { __typename?: 'ChatType', id: string, status: ApiChatStatusChoices } | null } | null };

export type OpenChatMutationVariables = Exact<{
  chatId: Scalars['ID']['input'];
}>;


export type OpenChatMutation = { __typename?: 'Mutation', openChat?: { __typename?: 'OpenChat', success?: boolean | null, message?: string | null, chat?: { __typename?: 'ChatType', id: string, status: ApiChatStatusChoices } | null } | null };

export type UpdateChatMutationVariables = Exact<{
  input: UpdateChatInput;
}>;


export type UpdateChatMutation = { __typename?: 'Mutation', updateChat?: { __typename?: 'UpdateChat', success?: boolean | null, message?: string | null, chat?: { __typename?: 'ChatType', id: string, careStage?: ApiChatCareStageChoices | null, status: ApiChatStatusChoices } | null } | null };

export type UpdateChatMessageMutationVariables = Exact<{
  input: UpdateChatMessageInput;
}>;


export type UpdateChatMessageMutation = { __typename?: 'Mutation', updateChatMessage?: { __typename?: 'UpdateChatMessage', success?: boolean | null, message?: string | null, chatMessage?: { __typename?: 'ChatMessageType', id: string, content?: string | null, edited: boolean } | null } | null };

export type UpdateMessageReadStatusMutationVariables = Exact<{
  input: UpdateMessageReadStatusInput;
}>;


export type UpdateMessageReadStatusMutation = { __typename?: 'Mutation', updateMessageReadStatus?: { __typename?: 'UpdateMessageReadStatus', success?: boolean | null, message?: string | null } | null };

export type SaveCrLearningTreeRolesMutationVariables = Exact<{
  learnerId: Scalars['ID']['input'];
  changes: Array<InputMaybe<CrLearningTreeRoleInput>> | InputMaybe<CrLearningTreeRoleInput>;
}>;


export type SaveCrLearningTreeRolesMutation = { __typename?: 'Mutation', saveCrLearningTreeRoles?: { __typename?: 'SaveCRLearningTreeRoles', status?: boolean | null, message?: string | null, saved?: number | null, checks?: Array<{ __typename?: 'CRLearningTreeCheckType', externalId: string, level: string, code: string, message: string }> | null } | null };

export type LockCrLearningTreeMutationVariables = Exact<{
  learnerId: Scalars['ID']['input'];
  reportId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type LockCrLearningTreeMutation = { __typename?: 'Mutation', lockCrLearningTree?: { __typename?: 'LockCRLearningTree', status?: boolean | null, message?: string | null, checks?: Array<{ __typename?: 'CRLearningTreeCheckType', externalId: string, level: string, code: string, message: string }> | null } | null };

export type SaveAndLockCrLearningTreeItemsMutationVariables = Exact<{
  learnerId: Scalars['ID']['input'];
  changes: Array<InputMaybe<CrLearningTreeRoleInput>> | InputMaybe<CrLearningTreeRoleInput>;
  reportId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type SaveAndLockCrLearningTreeItemsMutation = { __typename?: 'Mutation', saveAndLockCrLearningTreeItems?: { __typename?: 'SaveAndLockCRLearningTreeItems', status?: boolean | null, message?: string | null, checks?: Array<{ __typename?: 'CRLearningTreeCheckType', externalId: string, level: string, code: string, message: string }> | null } | null };

export type UnlockCrLearningTreeBranchMutationVariables = Exact<{
  learnerId: Scalars['ID']['input'];
  externalId: Scalars['String']['input'];
}>;


export type UnlockCrLearningTreeBranchMutation = { __typename?: 'Mutation', unlockCrLearningTreeBranch?: { __typename?: 'UnlockCRLearningTreeBranch', status?: boolean | null, message?: string | null, unlocked?: number | null } | null };

export type CreateClientFromEhrMutationVariables = Exact<{
  learnerExternalId: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  preferredName?: InputMaybe<Scalars['String']['input']>;
  birthDate?: InputMaybe<Scalars['Date']['input']>;
  addressLine1?: InputMaybe<Scalars['String']['input']>;
  addressLine2?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  zipCode?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  isImportForReassessment?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CreateClientFromEhrMutation = { __typename?: 'Mutation', createClientFromEhr?: { __typename?: 'CreateClientFromEHR', status?: boolean | null, message?: string | null, learner?: { __typename?: 'LearnerType', id: string, learnermetadata?: { __typename?: 'LearnerMetadataType', firstName: string, lastName: string } | null } | null } | null };

export type DeleteEhrCredentialsMutationVariables = Exact<{ [key: string]: never; }>;


export type DeleteEhrCredentialsMutation = { __typename?: 'Mutation', deleteEhrCredentials?: { __typename?: 'DeleteEhrCredentials', message?: string | null, success?: boolean | null } | null };

export type EhrRequestActionMutationVariables = Exact<{
  actionType: Scalars['String']['input'];
  learnerId?: InputMaybe<Scalars['ID']['input']>;
  reportId?: InputMaybe<Scalars['ID']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
}>;


export type EhrRequestActionMutation = { __typename?: 'Mutation', ehrRequestAction?: { __typename?: 'EhrRequestAction', requestId?: number | null, status?: string | null, created?: boolean | null, requestedById?: number | null, message?: string | null } | null };

export type EhrStartWorkflowAndLoginMutationVariables = Exact<{
  username?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  mfa?: InputMaybe<Scalars['String']['input']>;
}>;


export type EhrStartWorkflowAndLoginMutation = { __typename?: 'Mutation', ehrStartWorkflowAndLogin?: { __typename?: 'StartWorkflowAndLoginMutation', message?: string | null, status?: boolean | null } | null };

export type EhrGetClientListMutationVariables = Exact<{ [key: string]: never; }>;


export type EhrGetClientListMutation = { __typename?: 'Mutation', ehrGetClientList?: { __typename?: 'ClientListMutation', isComplete?: boolean | null, clients?: Array<{ __typename?: 'ClientDataType', clientId?: string | null, firstName: string, lastName: string, preferredName?: string | null, alias?: string | null, status?: string | null, addressLine1?: string | null, addressLine2?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, country?: string | null, dateOfBirth?: string | null, gender?: string | null, phone?: string | null, email?: string | null } | null> | null } | null };

export type ImportClientFromEhrMutationVariables = Exact<{
  learnerExternalId: Scalars['String']['input'];
  reportId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type ImportClientFromEhrMutation = { __typename?: 'Mutation', importClientFromEhr?: { __typename?: 'ImportClientFromEHR', status?: boolean | null, message?: string | null } | null };

export type SendClientToFronteraEhrMutationVariables = Exact<{
  reportId: Scalars['ID']['input'];
}>;


export type SendClientToFronteraEhrMutation = { __typename?: 'Mutation', sendClientToFronteraEhr?: { __typename?: 'SendClientToFronteraEhr', status?: boolean | null, message?: string | null, linked?: boolean | null, verticalLearnerId?: string | null, exportStatus?: FronteraEhrLearnerExportStatusEnum | null, learner?: { __typename?: 'LearnerType', id: string, externalId?: string | null } | null } | null };

export type StartGoalsSyncToEhrMutationVariables = Exact<{
  reportId: Scalars['ID']['input'];
}>;


export type StartGoalsSyncToEhrMutation = { __typename?: 'Mutation', startGoalsSyncToEhr?: { __typename?: 'StartGoalsSyncToEhr', message?: string | null, status?: boolean | null } | null };

export type CreateCareResourceSingleAllocationBlockMutationVariables = Exact<{
  resourceEmail: Scalars['String']['input'];
  startDatetime: Scalars['String']['input'];
  endDatetime: Scalars['String']['input'];
}>;


export type CreateCareResourceSingleAllocationBlockMutation = { __typename?: 'Mutation', createCareResourceSingleAllocationBlock?: { __typename?: 'CreateCareResourceSingleAllocationBlock', status?: boolean | null, message?: string | null, allocation?: { __typename?: 'CareResourceSingleAllocationBlockType', id: string, resourceId: string, startTime: string, endTime: string, repeats: boolean, resourceEmail?: string | null, deleted: boolean } | null } | null };

export type CreateCareResourceWeeklyAllocationBlockMutationVariables = Exact<{
  resourceEmail: Scalars['String']['input'];
  startDate: Scalars['String']['input'];
  endDate: Scalars['String']['input'];
  sunday?: InputMaybe<DayScheduleInputType>;
  monday?: InputMaybe<DayScheduleInputType>;
  tuesday?: InputMaybe<DayScheduleInputType>;
  wednesday?: InputMaybe<DayScheduleInputType>;
  thursday?: InputMaybe<DayScheduleInputType>;
  friday?: InputMaybe<DayScheduleInputType>;
  saturday?: InputMaybe<DayScheduleInputType>;
}>;


export type CreateCareResourceWeeklyAllocationBlockMutation = { __typename?: 'Mutation', createCareResourceWeeklyAllocationBlock?: { __typename?: 'CreateCareResourceWeeklyAllocationBlock', status?: boolean | null, message?: string | null, allocation?: { __typename?: 'CareResourceWeeklyAllocationBlockType', id: string, resourceId: string, startDate: string, endDate: string, resourceEmail?: string | null, deleted: boolean, sunday?: { __typename?: 'DayScheduleType', startTime: string, endTime: string } | null, monday?: { __typename?: 'DayScheduleType', startTime: string, endTime: string } | null, tuesday?: { __typename?: 'DayScheduleType', startTime: string, endTime: string } | null, wednesday?: { __typename?: 'DayScheduleType', startTime: string, endTime: string } | null, thursday?: { __typename?: 'DayScheduleType', startTime: string, endTime: string } | null, friday?: { __typename?: 'DayScheduleType', startTime: string, endTime: string } | null, saturday?: { __typename?: 'DayScheduleType', startTime: string, endTime: string } | null } | null } | null };

export type DeleteCareResourceSingleAllocationBlockMutationVariables = Exact<{
  allocationId: Scalars['String']['input'];
}>;


export type DeleteCareResourceSingleAllocationBlockMutation = { __typename?: 'Mutation', deleteCareResourceSingleAllocationBlock?: { __typename?: 'DeleteCareResourceSingleAllocationBlock', status?: boolean | null, message?: string | null } | null };

export type DeleteCareResourceWeeklyAllocationBlockMutationVariables = Exact<{
  allocationId: Scalars['String']['input'];
}>;


export type DeleteCareResourceWeeklyAllocationBlockMutation = { __typename?: 'Mutation', deleteCareResourceWeeklyAllocationBlock?: { __typename?: 'DeleteCareResourceWeeklyAllocationBlock', status?: boolean | null, message?: string | null } | null };

export type RescheduleCareAppointmentMutationVariables = Exact<{
  appointmentId: Scalars['String']['input'];
  startTime: Scalars['String']['input'];
  endTime: Scalars['String']['input'];
}>;


export type RescheduleCareAppointmentMutation = { __typename?: 'Mutation', rescheduleCareAppointment?: { __typename?: 'RescheduleCareAppointment', status?: boolean | null, message?: string | null, appointment?: { __typename?: 'CareAppointmentType', id: string, startTime: string, endTime: string, status: string, serviceId: string, serviceName?: string | null, locationId?: string | null, locationName?: string | null, resourceId?: string | null, resourceName?: string | null, resourceEmail?: string | null, customerFirstName?: string | null, customerLastName?: string | null, customerEmail?: string | null, notes?: string | null } | null } | null };

export type UpdateCareAppointmentCustomFieldsMutationVariables = Exact<{
  appointmentId: Scalars['String']['input'];
  customFields: Scalars['JSONString']['input'];
}>;


export type UpdateCareAppointmentCustomFieldsMutation = { __typename?: 'Mutation', updateCareAppointmentCustomFields?: { __typename?: 'UpdateCareAppointmentCustomFields', status?: boolean | null, message?: string | null, appointment?: { __typename?: 'CareAppointmentType', id: string, startTime: string, endTime: string, status: string, serviceId: string, serviceName?: string | null, locationId?: string | null, locationName?: string | null, resourceId?: string | null, resourceName?: string | null, resourceEmail?: string | null, customerFirstName?: string | null, customerLastName?: string | null, customerEmail?: string | null, notes?: string | null, customFields?: any | null } | null } | null };

export type UpdateCareAppointmentNoteMutationVariables = Exact<{
  appointmentId: Scalars['String']['input'];
  notes: Scalars['String']['input'];
}>;


export type UpdateCareAppointmentNoteMutation = { __typename?: 'Mutation', updateCareAppointmentNote?: { __typename?: 'UpdateCareAppointmentNote', status?: boolean | null, message?: string | null, appointment?: { __typename?: 'CareAppointmentType', id: string, startTime: string, endTime: string, status: string, serviceId: string, serviceName?: string | null, locationId?: string | null, locationName?: string | null, resourceId?: string | null, resourceName?: string | null, resourceEmail?: string | null, customerFirstName?: string | null, customerLastName?: string | null, customerEmail?: string | null, notes?: string | null } | null } | null };

export type ArchiveGoalBankCurriculumMutationVariables = Exact<{
  curriculumId: Scalars['ID']['input'];
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type ArchiveGoalBankCurriculumMutation = { __typename?: 'Mutation', archiveGoalBankCurriculum?: { __typename?: 'GoalBankMutationResult', message?: string | null, status?: boolean | null } | null };

export type CreateGoalBankFolderMutationVariables = Exact<{
  input: CreateGoalBankFolderInput;
}>;


export type CreateGoalBankFolderMutation = { __typename?: 'Mutation', createGoalBankFolder?: { __typename?: 'CreateGoalBankFolder', message?: string | null, status?: boolean | null, goalBankFolder?: { __typename?: 'GoalBankFolderType', id: string, name: string, folderType: ApiGoalBankFolderFolderTypeChoices } | null } | null };

export type CreateGoalBankGoalsMutationVariables = Exact<{
  input: CreateGoalBankGoalsInput;
}>;


export type CreateGoalBankGoalsMutation = { __typename?: 'Mutation', createGoalBankGoals?: { __typename?: 'CreateGoalBankGoals', message?: string | null, status?: boolean | null } | null };

export type CreateGoalBankTargetsMutationVariables = Exact<{
  input: CreateGoalBankTargetsInput;
}>;


export type CreateGoalBankTargetsMutation = { __typename?: 'Mutation', createGoalBankTargets?: { __typename?: 'CreateGoalBankTargets', message?: string | null, status?: boolean | null } | null };

export type DeleteGoalBankFolderMutationVariables = Exact<{
  input: DeleteGoalBankFolderInput;
}>;


export type DeleteGoalBankFolderMutation = { __typename?: 'Mutation', deleteGoalBankFolder?: { __typename?: 'DeleteGoalBankFolder', message?: string | null, status?: boolean | null } | null };

export type DeleteGoalBankGoalMutationVariables = Exact<{
  input: DeleteGoalBankGoalInput;
}>;


export type DeleteGoalBankGoalMutation = { __typename?: 'Mutation', deleteGoalBankGoal?: { __typename?: 'DeleteGoalBankGoal', message?: string | null, status?: boolean | null } | null };

export type DeleteGoalBankTargetMutationVariables = Exact<{
  input: DeleteGoalBankTargetInput;
}>;


export type DeleteGoalBankTargetMutation = { __typename?: 'Mutation', deleteGoalBankTarget?: { __typename?: 'DeleteGoalBankTarget', message?: string | null, status?: boolean | null } | null };

export type ExportGoalBankCurriculumMutationVariables = Exact<{
  curriculumId: Scalars['ID']['input'];
}>;


export type ExportGoalBankCurriculumMutation = { __typename?: 'Mutation', exportGoalBankCurriculum?: { __typename?: 'ExportGoalBankCurriculum', signedUrl?: string | null, fileName?: string | null } | null };

export type GetGoalBankUploadUrlMutationVariables = Exact<{
  fileName: Scalars['String']['input'];
  contentType: Scalars['String']['input'];
}>;


export type GetGoalBankUploadUrlMutation = { __typename?: 'Mutation', getGoalBankUploadUrl?: { __typename?: 'GetGoalBankUploadUrl', signedUrl?: string | null, s3Key?: string | null } | null };

export type ImportGoalBankMutationVariables = Exact<{
  input: ImportGoalBankInput;
}>;


export type ImportGoalBankMutation = { __typename?: 'Mutation', importGoalBank?: { __typename?: 'ImportGoalBank', status?: boolean | null, message?: string | null, stats?: any | null } | null };

export type MoveGoalBankGoalMutationVariables = Exact<{
  input: MoveGoalBankGoalInput;
}>;


export type MoveGoalBankGoalMutation = { __typename?: 'Mutation', moveGoalBankGoal?: { __typename?: 'MoveGoalBankGoal', message?: string | null, status?: boolean | null } | null };

export type MoveTargetToFolderMutationVariables = Exact<{
  input: MoveGoalBankTargetInput;
}>;


export type MoveTargetToFolderMutation = { __typename?: 'Mutation', moveGoalBankTarget?: { __typename?: 'MoveGoalBankTarget', message?: string | null, status?: boolean | null } | null };

export type UpdateGoalBankFolderMutationVariables = Exact<{
  input: UpdateGoalBankFolderInput;
}>;


export type UpdateGoalBankFolderMutation = { __typename?: 'Mutation', updateGoalBankFolder?: { __typename?: 'UpdateGoalBankFolder', message?: string | null, status?: boolean | null } | null };

export type UpdateGoalBankGoalMutationVariables = Exact<{
  input: UpdateGoalBankGoalInput;
}>;


export type UpdateGoalBankGoalMutation = { __typename?: 'Mutation', updateGoalBankGoal?: { __typename?: 'UpdateGoalBankGoal', message?: string | null, status?: boolean | null } | null };

export type UpdateGoalBankTargetMutationVariables = Exact<{
  input: UpdateGoalBankTargetInput;
}>;


export type UpdateGoalBankTargetMutation = { __typename?: 'Mutation', updateGoalBankTarget?: { __typename?: 'UpdateGoalBankTarget', message?: string | null, status?: boolean | null } | null };

export type UpdateProgrammingGoalMutationVariables = Exact<{
  learnerId: Scalars['ID']['input'];
  input: UpdateGoalInput;
}>;


export type UpdateProgrammingGoalMutation = { __typename?: 'Mutation', updateGoal?: { __typename?: 'UpdateGoal', status?: boolean | null, message?: string | null } | null };

export type CompleteZoomConnectMutationVariables = Exact<{
  code: Scalars['String']['input'];
}>;


export type CompleteZoomConnectMutation = { __typename?: 'Mutation', completeZoomConnect?: { __typename?: 'CompleteZoomConnect', status?: boolean | null } | null };

export type StartZoomConnectMutationVariables = Exact<{ [key: string]: never; }>;


export type StartZoomConnectMutation = { __typename?: 'Mutation', startZoomConnect?: { __typename?: 'StartZoomConnect', url?: string | null } | null };

export type CreateIndependentLearnerFileMutationVariables = Exact<{
  input: CreateIndependentLearnerFileInput;
}>;


export type CreateIndependentLearnerFileMutation = { __typename?: 'Mutation', createIndependentLearnerFile?: { __typename?: 'CreateIndependentLearnerFile', learnerFile?: { __typename?: 'LearnerFileType', id: string, signedS3Url?: string | null, status: ApiLearnerFileStatusChoices, fileKind: ApiLearnerFileFileKindChoices, mimeType: string, originalFileName: string, metadata?: any | null, fileSize: any, s3Key: string } | null } | null };

export type DeleteLearnerFileMutationVariables = Exact<{
  fileId: Scalars['ID']['input'];
}>;


export type DeleteLearnerFileMutation = { __typename?: 'Mutation', deleteLearnerFile?: { __typename?: 'DeleteLearnerFile', status?: boolean | null } | null };

export type GenerateLearnerFilePdfPreviewMutationVariables = Exact<{
  learnerFileId: Scalars['ID']['input'];
}>;


export type GenerateLearnerFilePdfPreviewMutation = { __typename?: 'Mutation', generateLearnerFilePdfPreview?: { __typename?: 'GenerateLearnerFilePdfPreview', status?: boolean | null, message?: string | null } | null };

export type MarkLearnerFileAsUploadedMutationVariables = Exact<{
  fileId: Scalars['ID']['input'];
}>;


export type MarkLearnerFileAsUploadedMutation = { __typename?: 'Mutation', markLearnerFileAsUploaded?: { __typename?: 'MarkLearnerFileAsUploaded', learnerFile?: { __typename?: 'LearnerFileType', id: string, status: ApiLearnerFileStatusChoices, mimeType: string } | null } | null };

export type StartLearnerFileClassificationMutationVariables = Exact<{
  learnerFileId: Scalars['ID']['input'];
}>;


export type StartLearnerFileClassificationMutation = { __typename?: 'Mutation', startLearnerFileClassification?: { __typename?: 'StartLearnerFileClassification', message?: string | null, status?: boolean | null, learnerFile?: { __typename?: 'LearnerFileType', status: ApiLearnerFileStatusChoices } | null } | null };

export type StartLearnerFileValidationMutationVariables = Exact<{
  learnerFileId: Scalars['ID']['input'];
}>;


export type StartLearnerFileValidationMutation = { __typename?: 'Mutation', startLearnerFileValidation?: { __typename?: 'StartLearnerFileValidation', status?: boolean | null, message?: string | null, learnerFile?: { __typename?: 'LearnerFileType', status: ApiLearnerFileStatusChoices } | null } | null };

export type StartLearnerMetadataCreationFromAbcIntakeFileMutationVariables = Exact<{
  learnerFileId: Scalars['ID']['input'];
}>;


export type StartLearnerMetadataCreationFromAbcIntakeFileMutation = { __typename?: 'Mutation', startLearnerMetadataCreationFromAbcIntakeFile?: { __typename?: 'StartLearnerMetadataCreationFromABCIntakeFile', status?: boolean | null, message?: string | null, learnerFile?: { __typename?: 'LearnerFileType', status: ApiLearnerFileStatusChoices } | null } | null };

export type StartLearnerMetadataCreationFromBhtiaFileMutationVariables = Exact<{
  learnerFileId: Scalars['ID']['input'];
}>;


export type StartLearnerMetadataCreationFromBhtiaFileMutation = { __typename?: 'Mutation', startLearnerMetadataCreationFromBhtiaFile?: { __typename?: 'StartLearnerMetadataCreationFromBhtiaFile', status?: boolean | null, message?: string | null, learnerFile?: { __typename?: 'LearnerFileType', status: ApiLearnerFileStatusChoices } | null } | null };

export type StartReassessmentFileClassificationMutationVariables = Exact<{
  learnerFileId: Scalars['ID']['input'];
}>;


export type StartReassessmentFileClassificationMutation = { __typename?: 'Mutation', startReassessmentFileClassification?: { __typename?: 'StartReassessmentFileClassification', message?: string | null, status?: boolean | null, learnerFile?: { __typename?: 'LearnerFileType', status: ApiLearnerFileStatusChoices } | null } | null };

export type UpdateLearnerFileClassificationMutationVariables = Exact<{
  fileId: Scalars['ID']['input'];
  classification?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateLearnerFileClassificationMutation = { __typename?: 'Mutation', updateLearnerFileClassification?: { __typename?: 'UpdateLearnerFileClassification', learnerFile?: { __typename?: 'LearnerFileType', id: string, fileKind: ApiLearnerFileFileKindChoices, status: ApiLearnerFileStatusChoices } | null } | null };

export type UpdateLearnerFileEffectiveDateMutationVariables = Exact<{
  fileId: Scalars['ID']['input'];
  effectiveDate?: InputMaybe<Scalars['Date']['input']>;
}>;


export type UpdateLearnerFileEffectiveDateMutation = { __typename?: 'Mutation', updateLearnerFileEffectiveDate?: { __typename?: 'UpdateLearnerFileEffectiveDate', learnerFile?: { __typename?: 'LearnerFileType', id: string, effectiveDate?: any | null, clinicianEditedAt?: any | null } | null } | null };

export type UpdateLearnerFileInterviewTypeMutationVariables = Exact<{
  fileId: Scalars['ID']['input'];
  interviewType: Scalars['String']['input'];
}>;


export type UpdateLearnerFileInterviewTypeMutation = { __typename?: 'Mutation', updateLearnerFileInterviewType?: { __typename?: 'UpdateLearnerFileInterviewType', learnerFile?: { __typename?: 'LearnerFileType', id: string, status: ApiLearnerFileStatusChoices, metadata?: any | null } | null } | null };

export type UpdateLearnerFileLanguageMutationVariables = Exact<{
  fileId: Scalars['ID']['input'];
  language: Scalars['String']['input'];
}>;


export type UpdateLearnerFileLanguageMutation = { __typename?: 'Mutation', updateLearnerFileLanguage?: { __typename?: 'UpdateLearnerFileLanguage', learnerFile?: { __typename?: 'LearnerFileType', id: string, status: ApiLearnerFileStatusChoices, metadata?: any | null } | null } | null };

export type UpdateLearnerFileParsedResultMutationVariables = Exact<{
  fileId: Scalars['ID']['input'];
  parsedData?: InputMaybe<Scalars['String']['input']>;
  parsedDataScoped?: InputMaybe<Scalars['String']['input']>;
  parsedTables?: InputMaybe<Scalars['JSONString']['input']>;
  triggerSectionRegen?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UpdateLearnerFileParsedResultMutation = { __typename?: 'Mutation', updateLearnerFileParsedResult?: { __typename?: 'UpdateLearnerFileParsedResult', learnerFile?: { __typename?: 'LearnerFileType', id: string, parsedResult?: string | null, parsedResultScoped?: string | null } | null } | null };

export type UploadChatAssetFileMutationVariables = Exact<{
  input: CreateIndependentLearnerFileInput;
}>;


export type UploadChatAssetFileMutation = { __typename?: 'Mutation', createIndependentLearnerFile?: { __typename?: 'CreateIndependentLearnerFile', learnerFile?: { __typename?: 'LearnerFileType', id: string, signedS3Url?: string | null } | null } | null };

export type CreateLearnerMutationVariables = Exact<{ [key: string]: never; }>;


export type CreateLearnerMutation = { __typename?: 'Mutation', createLearner?: { __typename?: 'CreateLearner', learner?: { __typename?: 'LearnerType', id: string } | null } | null };

export type CreateLearnerCaregiverMutationVariables = Exact<{
  availability?: InputMaybe<AvailabilityInput>;
  learner: LearnerInput;
  insurance?: InputMaybe<InsuranceInput>;
  caregiver?: InputMaybe<CaregiverInput>;
  sendIntake: Scalars['Boolean']['input'];
  providerIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
}>;


export type CreateLearnerCaregiverMutation = { __typename?: 'Mutation', createLearnerCaregiver?: { __typename?: 'CreateLearnerCaregiver', message?: string | null, status?: boolean | null, learner?: { __typename?: 'LearnerType', id: string } | null, caregiver?: { __typename?: 'CaregiverType', id: string, caregivermetadata?: { __typename?: 'CaregiverMetadataType', id: string, firstName: string, lastName: string, email?: string | null, phoneNumber1?: string | null, nearestLocation?: string | null, referralSource?: string | null, smsAgreement: boolean, appActivationCode?: string | null, appActivationCodeUsedAt?: any | null, appActivationEligible: boolean, activationCodeEmailLastSendDate?: any | null, activationCodeSmsLastSendDate?: any | null } | null, relationshipSet: { __typename?: 'RelationshipTypeConnection', edges: Array<{ __typename?: 'RelationshipTypeEdge', node?: { __typename?: 'RelationshipType', isPrimary: boolean, relationship: ApiRelationshipRelationshipChoices, relationshipLearner: { __typename?: 'LearnerType', id: string, learnermetadata?: { __typename?: 'LearnerMetadataType', firstName: string, lastName: string, birthDate?: any | null } | null, learnerproviderSet: { __typename?: 'LearnerProviderTypeConnection', edges: Array<{ __typename?: 'LearnerProviderTypeEdge', node?: { __typename?: 'LearnerProviderType', provider: { __typename?: 'ProviderType', id: string } } | null } | null> } } } | null } | null> } } | null } | null };

export type CreateLearnerInsuranceMutationVariables = Exact<{
  input: CreateLearnerInsuranceInput;
}>;


export type CreateLearnerInsuranceMutation = { __typename?: 'Mutation', createLearnerInsurance?: { __typename?: 'CreateLearnerInsurance', message?: string | null, status?: boolean | null } | null };

export type UpdateCaregiverConsentsMutationVariables = Exact<{
  consentUpdates: Array<CaregiverConsentInput> | CaregiverConsentInput;
}>;


export type UpdateCaregiverConsentsMutation = { __typename?: 'Mutation', updateCaregiverConsents?: { __typename?: 'UpdateCaregiverConsents', success?: boolean | null } | null };

export type ImportClientListMutationVariables = Exact<{ [key: string]: never; }>;


export type ImportClientListMutation = { __typename?: 'Mutation', importClientList?: { __typename?: 'ImportClientList', status?: boolean | null, message?: string | null } | null };

export type RemoveLearnerPayorMutationVariables = Exact<{
  learnerId: Scalars['ID']['input'];
  payorType: PayorType;
}>;


export type RemoveLearnerPayorMutation = { __typename?: 'Mutation', removeLearnerPayor?: { __typename?: 'RemoveLearnerPayor', status?: boolean | null, errors?: Array<{ __typename?: 'FieldError', field?: string | null, messages?: Array<string | null> | null } | null> | null } | null };

export type SetLearnerPayorMutationVariables = Exact<{
  learnerId: Scalars['ID']['input'];
  payorTypes: Array<PayorType> | PayorType;
}>;


export type SetLearnerPayorMutation = { __typename?: 'Mutation', setLearnerPayor?: { __typename?: 'SetLearnerPayor', status?: boolean | null, learnerPayors?: Array<{ __typename?: 'LearnerPayorType', id: string, payorType: ApiLearnerPayorPayorTypeChoices, isActive: boolean, createdDate: any } | null> | null, errors?: Array<{ __typename?: 'FieldError', field?: string | null, messages?: Array<string | null> | null } | null> | null } | null };

export type UnassignCaregiverFromLearnerMutationVariables = Exact<{
  learnerId: Scalars['ID']['input'];
  caregiverId: Scalars['ID']['input'];
}>;


export type UnassignCaregiverFromLearnerMutation = { __typename?: 'Mutation', unassignCaregiverFromLearner?: { __typename?: 'UnassignCaregiverFromLearner', message?: string | null, status?: boolean | null } | null };

export type UpdateLearnerAvailabilityDetailsMutationVariables = Exact<{
  learner: Scalars['ID']['input'];
  details: AvailabilityInput;
}>;


export type UpdateLearnerAvailabilityDetailsMutation = { __typename?: 'Mutation', updateLearnerAvailabilityDetails?: { __typename?: 'UpdateLearnerAvailabilityDetails', message?: string | null, status?: boolean | null } | null };

export type UpdateLearnerGeneralDetailsMutationVariables = Exact<{
  learner: Scalars['ID']['input'];
  learnerDetails: LearnerGeneralDetailsInput;
}>;


export type UpdateLearnerGeneralDetailsMutation = { __typename?: 'Mutation', updateLearnerGeneralDetails?: { __typename?: 'UpdateLearnerGeneralDetails', message?: string | null, status?: boolean | null } | null };

export type UpdateLearnerCaregiverDetailsMutationVariables = Exact<{
  learner: Scalars['ID']['input'];
  caregiverDetails: CaregiverInput;
}>;


export type UpdateLearnerCaregiverDetailsMutation = { __typename?: 'Mutation', updateLearnerCaregiverDetails?: { __typename?: 'UpdateLearnerCaregiverDetails', message?: string | null, status?: boolean | null, caregiverData?: { __typename?: 'CaregiverType', id: string, isAllowedAppAccess?: boolean | null, caregivermetadata?: { __typename?: 'CaregiverMetadataType', id: string, firstName: string, lastName: string, email?: string | null, phoneNumber1?: string | null, nearestLocation?: string | null, referralSource?: string | null, smsAgreement: boolean, appActivationCode?: string | null, appActivationCodeUsedAt?: any | null, appActivationEligible: boolean, activationCodeEmailLastSendDate?: any | null, activationCodeSmsLastSendDate?: any | null } | null, relationshipSet: { __typename?: 'RelationshipTypeConnection', edges: Array<{ __typename?: 'RelationshipTypeEdge', node?: { __typename?: 'RelationshipType', isPrimary: boolean, relationship: ApiRelationshipRelationshipChoices, relationshipLearner: { __typename?: 'LearnerType', id: string, learnermetadata?: { __typename?: 'LearnerMetadataType', firstName: string, lastName: string, birthDate?: any | null } | null, learnerproviderSet: { __typename?: 'LearnerProviderTypeConnection', edges: Array<{ __typename?: 'LearnerProviderTypeEdge', node?: { __typename?: 'LearnerProviderType', provider: { __typename?: 'ProviderType', id: string } } | null } | null> } } } | null } | null> } } | null } | null };

export type UpdateLearnerDetailsMutationVariables = Exact<{
  learner: Scalars['ID']['input'];
  learnerDetails: LearnerDetailsInput;
}>;


export type UpdateLearnerDetailsMutation = { __typename?: 'Mutation', updateLearnerDetails?: { __typename?: 'UpdateLearnerDetails', message?: string | null, status?: boolean | null } | null };

export type UpdateLearnerInsuranceDetailsMutationVariables = Exact<{
  learner: Scalars['ID']['input'];
  insuranceData: LearnerInsuranceAdminInput;
}>;


export type UpdateLearnerInsuranceDetailsMutation = { __typename?: 'Mutation', updateLearnerInsuranceDetails?: { __typename?: 'UpdateLearnerInsuranceDetails', message?: string | null, status?: boolean | null } | null };

export type UpdateLearnerIntakeOverviewDetailsMutationVariables = Exact<{
  learner: Scalars['ID']['input'];
  learnerDetails: UpdateLearnerIntakeOverviewDetailsInput;
}>;


export type UpdateLearnerIntakeOverviewDetailsMutation = { __typename?: 'Mutation', updateLearnerIntakeOverviewDetails?: { __typename?: 'UpdateLearnerIntakeOverviewDetails', message?: string | null, status?: boolean | null } | null };

export type CreateMediaCommentMutationVariables = Exact<{
  input: MediaCommentInput;
}>;


export type CreateMediaCommentMutation = { __typename?: 'Mutation', createMediaComment?: { __typename?: 'CreateMediaComment', status?: boolean | null, message?: string | null, mediaComment?: { __typename?: 'MediaCommentsType', id: string, content: string, commentType: ApiMediaCommentsCommentTypeChoices, mediaStartTime: number, hasReplies?: boolean | null, createdDate: any, commentReplies?: { __typename?: 'MediaCommentsTypeConnection', totalCount?: number | null, edges: Array<{ __typename?: 'MediaCommentsTypeEdge', node?: { __typename?: 'MediaCommentsType', id: string, content: string, commentType: ApiMediaCommentsCommentTypeChoices, createdDate: any, author?: { __typename?: 'UserType', id: string, auth0id?: string | null, provider?: { __typename?: 'ProviderType', providermetadata?: { __typename?: 'ProviderMetadataType', firstName: string, lastName?: string | null } | null } | null, caregiver?: { __typename?: 'CaregiverType', caregivermetadata?: { __typename?: 'CaregiverMetadataType', firstName: string, lastName: string } | null } | null } | null, parentComment?: { __typename?: 'MediaCommentsType', id: string } | null } | null } | null> } | null, author?: { __typename?: 'UserType', id: string, auth0id?: string | null, provider?: { __typename?: 'ProviderType', providermetadata?: { __typename?: 'ProviderMetadataType', firstName: string, lastName?: string | null } | null } | null, caregiver?: { __typename?: 'CaregiverType', caregivermetadata?: { __typename?: 'CaregiverMetadataType', firstName: string, lastName: string } | null } | null } | null, parentComment?: { __typename?: 'MediaCommentsType', id: string } | null, media: { __typename?: 'MediaType', id: string } } | null } | null };

export type CreateMediaTargetPredictionFeedbackMutationVariables = Exact<{
  input: MediaTargetPredictionFeedbackInput;
}>;


export type CreateMediaTargetPredictionFeedbackMutation = { __typename?: 'Mutation', createMediaTargetPredictionFeedback?: { __typename?: 'CreateMediaTargetPredictionFeedback', status?: boolean | null, message?: string | null } | null };

export type CreateUpdateSessionMediaReviewActivityLogMutationVariables = Exact<{
  input: SessionMediaReviewActivityLogInput;
}>;


export type CreateUpdateSessionMediaReviewActivityLogMutation = { __typename?: 'Mutation', createUpdateSessionMediaReviewActivityLog?: { __typename?: 'CreateUpdateSessionMediaReviewActivityLog', status?: boolean | null, message?: string | null, mediaActivityLog?: { __typename?: 'SessionMediaReviewActivityLogType', id: string, startTime: number, endTime: number, durationSeconds?: number | null, activityType: ApiSessionMediaReviewActivityLogActivityTypeChoices, media?: { __typename?: 'MediaType', id: string } | null } | null } | null };

export type DeleteMediaCommentMutationVariables = Exact<{
  commentId: Scalars['ID']['input'];
}>;


export type DeleteMediaCommentMutation = { __typename?: 'Mutation', removeMediaComment?: { __typename?: 'RemoveMediaComment', status?: boolean | null, message?: string | null } | null };

export type RemoveSessionDataMutationVariables = Exact<{
  input: RemoveSessionDataInput;
}>;


export type RemoveSessionDataMutation = { __typename?: 'Mutation', removeSessionData?: { __typename?: 'RemoveSessionData', message?: string | null, status?: boolean | null, sessionMetaData?: any | null } | null };

export type ManuallyMarkMediaAsViewedMutationVariables = Exact<{
  mediId: Scalars['ID']['input'];
  isReviewed: Scalars['Boolean']['input'];
}>;


export type ManuallyMarkMediaAsViewedMutation = { __typename?: 'Mutation', manuallyMarkMediaAsViewed?: { __typename?: 'ManuallyMarkMediaAsViewed', message?: string | null, status?: boolean | null, media?: { __typename?: 'MediaType', id: string, isViewed: boolean } | null } | null };

export type UpdateMediaCommentMutationVariables = Exact<{
  input: UpdateMediaCommentInput;
}>;


export type UpdateMediaCommentMutation = { __typename?: 'Mutation', updateMediaComment?: { __typename?: 'UpdateMediaComment', status?: boolean | null, message?: string | null, mediaComment?: { __typename?: 'MediaCommentsType', id: string, content: string, commentType: ApiMediaCommentsCommentTypeChoices, mediaStartTime: number, hasReplies?: boolean | null, createdDate: any, commentReplies?: { __typename?: 'MediaCommentsTypeConnection', totalCount?: number | null, edges: Array<{ __typename?: 'MediaCommentsTypeEdge', node?: { __typename?: 'MediaCommentsType', id: string, content: string, commentType: ApiMediaCommentsCommentTypeChoices, createdDate: any, author?: { __typename?: 'UserType', id: string, auth0id?: string | null, provider?: { __typename?: 'ProviderType', providermetadata?: { __typename?: 'ProviderMetadataType', firstName: string, lastName?: string | null } | null } | null, caregiver?: { __typename?: 'CaregiverType', caregivermetadata?: { __typename?: 'CaregiverMetadataType', firstName: string, lastName: string } | null } | null } | null, parentComment?: { __typename?: 'MediaCommentsType', id: string } | null } | null } | null> } | null, author?: { __typename?: 'UserType', id: string, auth0id?: string | null, provider?: { __typename?: 'ProviderType', providermetadata?: { __typename?: 'ProviderMetadataType', firstName: string, lastName?: string | null } | null } | null, caregiver?: { __typename?: 'CaregiverType', caregivermetadata?: { __typename?: 'CaregiverMetadataType', firstName: string, lastName: string } | null } | null } | null, parentComment?: { __typename?: 'MediaCommentsType', id: string } | null, media: { __typename?: 'MediaType', id: string } } | null } | null };

export type DismissNotificationMutationVariables = Exact<{
  input: DismissNotificationInput;
}>;


export type DismissNotificationMutation = { __typename?: 'Mutation', dismissNotification?: { __typename?: 'DismissNotification', status?: boolean | null, message?: string | null } | null };

export type ReadAllNotificationsMutationVariables = Exact<{ [key: string]: never; }>;


export type ReadAllNotificationsMutation = { __typename?: 'Mutation', readAllNotifications?: { __typename?: 'ReadAllNotifications', status?: boolean | null, message?: string | null } | null };

export type ReadNotificationMutationVariables = Exact<{
  input: ReadNotificationInput;
}>;


export type ReadNotificationMutation = { __typename?: 'Mutation', readNotification?: { __typename?: 'ReadNotification', status?: boolean | null, message?: string | null } | null };

export type UpdateNotificationOptOutMutationVariables = Exact<{
  input: UpdateNotificationOptOutInput;
}>;


export type UpdateNotificationOptOutMutation = { __typename?: 'Mutation', updateNotificationOptOut?: { __typename?: 'UpdateNotificationOptOut', success?: boolean | null, message?: string | null } | null };

export type UpdateOrgNotificationSettingsMutationVariables = Exact<{
  input: UpdateOrgNotificationSettingsInput;
}>;


export type UpdateOrgNotificationSettingsMutation = { __typename?: 'Mutation', updateOrgNotificationSettings?: { __typename?: 'UpdateOrgNotificationSettings', success?: boolean | null, message?: string | null, notificationSettings?: { __typename?: 'OrganizationNotificationSettingsType', id: string, reassessmentReminder: boolean } | null } | null };

export type ChargeSavedPaymentMethodMutationVariables = Exact<{
  paymentIntentId: Scalars['String']['input'];
}>;


export type ChargeSavedPaymentMethodMutation = { __typename?: 'Mutation', chargeSavedPaymentMethod?: { __typename?: 'ChargeSavedPaymentMethod', message?: string | null, status?: boolean | null, paymentIntentId?: string | null, amountCharged?: number | null } | null };

export type CreateCheckoutSessionMutationVariables = Exact<{
  priceId?: InputMaybe<Scalars['String']['input']>;
  redirectOrigin: Scalars['String']['input'];
}>;


export type CreateCheckoutSessionMutation = { __typename?: 'Mutation', createCheckoutSession?: { __typename?: 'CreateCheckoutSession', message?: string | null, status?: boolean | null, clientSecret?: string | null } | null };

export type CreatePaymentIntentMutationVariables = Exact<{
  priceId: Scalars['String']['input'];
}>;


export type CreatePaymentIntentMutation = { __typename?: 'Mutation', createPaymentIntent?: { __typename?: 'CreatePaymentIntent', message?: string | null, status?: boolean | null, paymentClientSecret?: string | null, sessionClientSecret?: string | null, paymentIntentId?: string | null, userAccountDetails?: { __typename?: 'UserStripeAccountDetailsType', stripeCustomerId?: string | null, stripePaymentMethodId?: string | null } | null } | null };

export type CreateSetupIntentMutationVariables = Exact<{ [key: string]: never; }>;


export type CreateSetupIntentMutation = { __typename?: 'Mutation', createSetupIntent?: { __typename?: 'CreateSetupIntent', setupClientSecret?: string | null, sessionClientSecret?: string | null } | null };

export type UpdateTaxTransactionMutationVariables = Exact<{
  line1?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  postal_code?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['Int']['input']>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
  paymentIntentId?: InputMaybe<Scalars['String']['input']>;
  productId?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateTaxTransactionMutation = { __typename?: 'Mutation', updateTaxTransaction?: { __typename?: 'UpdateTaxTransaction', message?: string | null, status?: number | null, taxRate?: number | null, taxId?: string | null } | null };

export type StartPayorSubmissionWorkflowMutationVariables = Exact<{
  reportId: Scalars['ID']['input'];
}>;


export type StartPayorSubmissionWorkflowMutation = { __typename?: 'Mutation', startPayorSubmissionWorkflow?: { __typename?: 'StartPayorSubmissionWorkflow', status?: boolean | null, message?: string | null, payorReportSubmission?: { __typename?: 'PayorReportSubmissionType', id: string, status: ApiPayorReportSubmissionStatusChoices } | null } | null };

export type UpsertReportPayorMetadataMutationVariables = Exact<{
  input: UpsertReportPayorMetadataInput;
}>;


export type UpsertReportPayorMetadataMutation = { __typename?: 'Mutation', upsertReportPayorMetadata?: { __typename?: 'UpsertReportPayorMetadata', status?: boolean | null, message?: string | null, reportPayorMetadata?: { __typename?: 'ReportPayorMetadataType', id: string, treatmentOffered?: boolean | null, firstTreatmentOfferedDate?: any | null, paraprofessionalHours?: number | null, midLevelHours?: number | null, highLevelHours?: number | null, groupCare?: number | null, comments?: string | null } | null } | null };

export type CompleteProviderOnboardingMutationVariables = Exact<{ [key: string]: never; }>;


export type CompleteProviderOnboardingMutation = { __typename?: 'Mutation', completeProviderOnboarding?: { __typename?: 'CompleteProviderOnboarding', message?: string | null, status?: boolean | null, provider?: { __typename?: 'ProviderType', id: string, providermetadata?: { __typename?: 'ProviderMetadataType', id: string, onboardingCompleted: boolean } | null } | null } | null };

export type CreateProviderMutationVariables = Exact<{
  provider: ProviderInput;
}>;


export type CreateProviderMutation = { __typename?: 'Mutation', createProvider?: { __typename?: 'CreateProvider', message?: string | null, status?: boolean | null, provider?: { __typename?: 'ProviderType', id: string, providermetadata?: { __typename?: 'ProviderMetadataType', id: string, firstName: string, lastName?: string | null, email?: string | null } | null } | null } | null };

export type CreateProviderFileMutationVariables = Exact<{
  input: CreateProviderFileInput;
}>;


export type CreateProviderFileMutation = { __typename?: 'Mutation', createProviderFile?: { __typename?: 'CreateProviderFile', providerFile?: { __typename?: 'ProviderFileType', id: string, signedS3Url?: string | null } | null } | null };

export type DeleteProviderFileMutationVariables = Exact<{
  fileId: Scalars['ID']['input'];
}>;


export type DeleteProviderFileMutation = { __typename?: 'Mutation', deleteProviderFile?: { __typename?: 'DeleteProviderFile', status?: boolean | null } | null };

export type MarkProviderFileAsUploadedMutationVariables = Exact<{
  fileId: Scalars['ID']['input'];
}>;


export type MarkProviderFileAsUploadedMutation = { __typename?: 'Mutation', markProviderFileAsUploaded?: { __typename?: 'MarkProviderFileAsUploaded', providerFile?: { __typename?: 'ProviderFileType', id: string, signedS3ProviderFile?: string | null } | null } | null };

export type ReissueProviderInvitationMutationVariables = Exact<{
  providerId: Scalars['ID']['input'];
  providerRoles?: InputMaybe<Array<InputMaybe<ProviderRoleEnums>> | InputMaybe<ProviderRoleEnums>>;
  connectionType?: InputMaybe<ConnectionTypeEnum>;
}>;


export type ReissueProviderInvitationMutation = { __typename?: 'Mutation', reissueProviderInvitation?: { __typename?: 'ReissueProviderInvitation', message?: string | null, status?: boolean | null } | null };

export type UpdateLearnerProvidersMutationVariables = Exact<{
  learnerId: Scalars['ID']['input'];
  providerIds: Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>;
}>;


export type UpdateLearnerProvidersMutation = { __typename?: 'Mutation', updateLearnerProviders?: { __typename?: 'UpdateLearnerProviders', message?: string | null, status?: boolean | null } | null };

export type UpdateProviderMutationVariables = Exact<{
  provider: UpdateProviderInput;
  providerId: Scalars['ID']['input'];
}>;


export type UpdateProviderMutation = { __typename?: 'Mutation', updateProvider?: { __typename?: 'UpdateProvider', message?: string | null, status?: boolean | null, provider?: { __typename?: 'ProviderType', id: string, providermetadata?: { __typename?: 'ProviderMetadataType', id: string, firstName: string, lastName?: string | null, email?: string | null } | null } | null } | null };

export type UpdateProviderLearnersMutationVariables = Exact<{
  learners?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  providerId: Scalars['ID']['input'];
}>;


export type UpdateProviderLearnersMutation = { __typename?: 'Mutation', updateProviderLearners?: { __typename?: 'UpdateProviderLearners', message?: string | null, status?: boolean | null, provider?: { __typename?: 'ProviderType', id: string, providermetadata?: { __typename?: 'ProviderMetadataType', id: string, firstName: string, lastName?: string | null, email?: string | null } | null } | null } | null };

export type UpdateProviderProfileMutationVariables = Exact<{
  providerData: UpdateProviderProfileInput;
}>;


export type UpdateProviderProfileMutation = { __typename?: 'Mutation', updateProviderProfile?: { __typename?: 'UpdateProviderProfile', message?: string | null, status?: boolean | null, provider?: { __typename?: 'ProviderType', id: string, providermetadata?: { __typename?: 'ProviderMetadataType', id: string, firstName: string, lastName?: string | null, chatAvailability?: ApiProviderMetadataChatAvailabilityChoices | null, professionalTitle?: string | null, licenseNumber?: string | null } | null } | null } | null };

export type CreateRecommendationBankFolderMutationVariables = Exact<{
  input: CreateRecommendationBankFolderInput;
}>;


export type CreateRecommendationBankFolderMutation = { __typename?: 'Mutation', createRecommendationBankFolder?: { __typename?: 'CreateRecommendationBankFolder', message?: string | null, status?: boolean | null, recommendationBankFolder?: { __typename?: 'RecommendationBankFolderType', id: string, name: string, folderType: ApiRecommendationBankFolderFolderTypeChoices } | null } | null };

export type CreateRecommendationBankItemMutationVariables = Exact<{
  input: CreateRecommendationBankItemInput;
}>;


export type CreateRecommendationBankItemMutation = { __typename?: 'Mutation', createRecommendationBankItem?: { __typename?: 'CreateRecommendationBankItem', message?: string | null, status?: boolean | null, recommendationBankItem?: { __typename?: 'RecommendationBankItemType', id: string, recommendationContent?: string | null, folder: { __typename?: 'RecommendationBankFolderType', id: string, name: string, folderType: ApiRecommendationBankFolderFolderTypeChoices }, createdBy?: { __typename?: 'UserType', id: string, username: string } | null, updatedBy?: { __typename?: 'UserType', id: string, username: string } | null } | null } | null };

export type DeleteRecommendationBankFolderMutationVariables = Exact<{
  input: DeleteRecommendationBankFolderInput;
}>;


export type DeleteRecommendationBankFolderMutation = { __typename?: 'Mutation', deleteRecommendationBankFolder?: { __typename?: 'DeleteRecommendationBankFolder', message?: string | null, status?: boolean | null } | null };

export type DeleteRecommendationBankItemMutationVariables = Exact<{
  recommendationBankItemId: Scalars['ID']['input'];
}>;


export type DeleteRecommendationBankItemMutation = { __typename?: 'Mutation', deleteRecommendationBankItem?: { __typename?: 'DeleteRecommendationBankItem', message?: string | null, status?: boolean | null } | null };

export type MoveRecommendationBankItemMutationVariables = Exact<{
  input: MoveRecommendationBankItemInput;
}>;


export type MoveRecommendationBankItemMutation = { __typename?: 'Mutation', moveRecommendationBankItem?: { __typename?: 'MoveRecommendationBankItem', message?: string | null, status?: boolean | null, recommendationBankItemData?: { __typename?: 'RecommendationBankItemType', id: string, recommendationContent?: string | null, folder: { __typename?: 'RecommendationBankFolderType', id: string, name: string, folderType: ApiRecommendationBankFolderFolderTypeChoices }, createdBy?: { __typename?: 'UserType', id: string, username: string } | null, updatedBy?: { __typename?: 'UserType', id: string, username: string } | null } | null } | null };

export type UpdateRecommendationBankFolderMutationVariables = Exact<{
  input: UpdateRecommendationBankFolderInput;
}>;


export type UpdateRecommendationBankFolderMutation = { __typename?: 'Mutation', updateRecommendationBankFolder?: { __typename?: 'UpdateRecommendationBankFolder', message?: string | null, status?: boolean | null } | null };

export type UpdateRecommendationBankItemMutationVariables = Exact<{
  input: UpdateRecommendationBankItemInput;
}>;


export type UpdateRecommendationBankItemMutation = { __typename?: 'Mutation', updateRecommendationBankItem?: { __typename?: 'UpdateRecommendationBankItem', message?: string | null, status?: boolean | null, recommendationBankItem?: { __typename?: 'RecommendationBankItemType', id: string, recommendationContent?: string | null, folder: { __typename?: 'RecommendationBankFolderType', id: string, name: string, folderType: ApiRecommendationBankFolderFolderTypeChoices }, createdBy?: { __typename?: 'UserType', id: string, username: string } | null, updatedBy?: { __typename?: 'UserType', id: string, username: string } | null } | null } | null };

export type CreateReportFromTemplateMutationVariables = Exact<{
  reportId: Scalars['ID']['input'];
}>;


export type CreateReportFromTemplateMutation = { __typename?: 'Mutation', createReportFromTemplate?: { __typename?: 'CreateReportFromTemplate', success?: boolean | null } | null };

export type CreateReportTemplateLogoMutationVariables = Exact<{
  input: CreateReportTemplateFileInput;
}>;


export type CreateReportTemplateLogoMutation = { __typename?: 'Mutation', createReportTemplateLogo?: { __typename?: 'CreateReportTemplateLogo', message?: string | null, status?: boolean | null, fileUrl?: string | null } | null };

export type CreateSampleTemplateMutationVariables = Exact<{
  reportTemplate: Scalars['ID']['input'];
}>;


export type CreateSampleTemplateMutation = { __typename?: 'Mutation', createSampleTemplate?: { __typename?: 'CreateSampleTemplate', message?: string | null, status?: boolean | null } | null };

export type DeleteReportTemplateMutationVariables = Exact<{
  reportTemplateId: Scalars['ID']['input'];
}>;


export type DeleteReportTemplateMutation = { __typename?: 'Mutation', deleteReportTemplate?: { __typename?: 'DeleteReportTemplate', status?: boolean | null, message?: string | null } | null };

export type DuplicateReportTemplateMutationVariables = Exact<{
  input: DuplicateReportTemplateInput;
}>;


export type DuplicateReportTemplateMutation = { __typename?: 'Mutation', duplicateReportTemplate?: { __typename?: 'DuplicateReportTemplate', message?: string | null, status?: boolean | null, newTemplate?: { __typename?: 'ReportTemplateType', id: string } | null } | null };

export type UpdateReportTemplateMutationVariables = Exact<{
  input: UpdateReportTemplateInput;
}>;


export type UpdateReportTemplateMutation = { __typename?: 'Mutation', updateReportTemplate?: { __typename?: 'UpdateReportTemplate', message?: string | null, status?: boolean | null } | null };

export type UpdateReportTemplateLogoMutationVariables = Exact<{
  input: UpdateReportTemplateFileInput;
}>;


export type UpdateReportTemplateLogoMutation = { __typename?: 'Mutation', updateReportTemplateLogo?: { __typename?: 'UpdateReportTemplateLogo', message?: string | null, status?: boolean | null } | null };

export type AddReportClientDetailsMutationVariables = Exact<{
  learnerCaregiverMinimalInput: LearnerCaregiverMinimalInput;
  reportId: Scalars['ID']['input'];
}>;


export type AddReportClientDetailsMutation = { __typename?: 'Mutation', addReportClientDetails?: { __typename?: 'AddReportClientDetails', message?: string | null, status?: boolean | null } | null };

export type AddUpdateReportTreatmentPlanPrioritizeFieldsMutationVariables = Exact<{
  reportId: Scalars['ID']['input'];
  prioritizeFieldsDetails: ReportTreatmentPlanPrioritizeFieldsInput;
}>;


export type AddUpdateReportTreatmentPlanPrioritizeFieldsMutation = { __typename?: 'Mutation', addUpdateReportTreatmentPlanPrioritizeFields?: { __typename?: 'AddUpdateReportTreatmentPlanPrioritizeFields', status?: boolean | null, reportTreatmentPlanPrioritizeFields?: { __typename?: 'ReportTreatmentPlanPrioritizeFieldsType', id: string } | null } | null };

export type ApplyReportCommentMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ApplyReportCommentMutation = { __typename?: 'Mutation', applyReportComment?: { __typename?: 'ApplyReportComment', success?: boolean | null, message?: string | null, comment?: { __typename?: 'ReportCommentType', id: string, status: string, resolvedAt?: any | null } | null } | null };

export type CreateExportReportGenerationMutationVariables = Exact<{
  input: GeneratePdfInput;
}>;


export type CreateExportReportGenerationMutation = { __typename?: 'Mutation', createExportReportGeneration?: { __typename?: 'CreateExportReportGeneration', status?: boolean | null, message?: string | null } | null };

export type CreateReassessmentReportGoalsMutationVariables = Exact<{
  goals: Array<SelectedEhrGoalInput> | SelectedEhrGoalInput;
  reportId: Scalars['ID']['input'];
}>;


export type CreateReassessmentReportGoalsMutation = { __typename?: 'Mutation', createReassessmentReportGoals?: { __typename?: 'CreateReassessmentReportGoals', message?: string | null, status?: boolean | null } | null };

export type CreateReportMutationVariables = Exact<{
  learnerId?: InputMaybe<Scalars['ID']['input']>;
  reportClientMetaData?: InputMaybe<Scalars['JSONString']['input']>;
  reportType: ReportTypeEnums;
  learnerFileId?: InputMaybe<Scalars['ID']['input']>;
  reportTemplateId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type CreateReportMutation = { __typename?: 'Mutation', createReport?: { __typename?: 'CreateReport', message?: string | null, status?: boolean | null, report?: { __typename?: 'ReportType', id: string, createdDate: any, lastUpdatedDate: any, reportStatus: ApiReportReportStatusChoices, reportType: ApiReportReportTypeChoices, isArchive: boolean, reportMetaData?: any | null, reportClientDetails?: { __typename?: 'ReportClientDetailsType', id: string, clientFirstName: string, clientLastName?: string | null, guardianFirstName: string, guardianLastName?: string | null, guardian2FirstName?: string | null, guardian2LastName?: string | null, birthDate?: any | null, address?: string | null, addressLine2?: string | null, city?: string | null, state?: string | null, zip?: string | null } | null } | null } | null };

export type CreateReportCommentMutationVariables = Exact<{
  fieldId?: InputMaybe<Scalars['ID']['input']>;
  parentId?: InputMaybe<Scalars['ID']['input']>;
  body: Scalars['String']['input'];
  proposedValue?: InputMaybe<Scalars['String']['input']>;
  baseValue?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateReportCommentMutation = { __typename?: 'Mutation', createReportComment?: { __typename?: 'CreateReportComment', success?: boolean | null, message?: string | null, comment?: { __typename?: 'ReportCommentType', id: string, content?: string | null, source: string, status: string, hidden: boolean, createdDate: any, baseValue?: string | null, proposedValue?: string | null, author?: { __typename?: 'ReportReviewUserType', id: string, firstName: string, lastName?: string | null } | null, reportSectionField?: { __typename?: 'ReportSectionFieldsType', id: string, title?: string | null } | null, parent?: { __typename: 'ReportCommentType', id: string } | { __typename: 'ReportSuggestionType', id: string } | null } | null } | null };

export type CreateReportLearnerFileInputMutationVariables = Exact<{
  input: CreateReportLearnerFileInput;
}>;


export type CreateReportLearnerFileInputMutation = { __typename?: 'Mutation', createReportLearnerFile?: { __typename?: 'CreateReportLearnerFile', learnerFile?: { __typename?: 'LearnerFileType', signedS3Url?: string | null, id: string } | null } | null };

export type DeleteReportMutationVariables = Exact<{
  report: Scalars['ID']['input'];
}>;


export type DeleteReportMutation = { __typename?: 'Mutation', deleteReport?: { __typename?: 'DeleteReport', status?: boolean | null, message?: string | null } | null };

export type DeleteReportCommentMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteReportCommentMutation = { __typename?: 'Mutation', deleteReportComment?: { __typename?: 'DeleteReportComment', success?: boolean | null, message?: string | null } | null };

export type EditReportCommentMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  body: Scalars['String']['input'];
}>;


export type EditReportCommentMutation = { __typename?: 'Mutation', editReportComment?: { __typename?: 'EditReportComment', success?: boolean | null, message?: string | null } | null };

export type ExportDraftReportDocumentMutationVariables = Exact<{
  reportId: Scalars['ID']['input'];
  exportType: ExportTypeEnum;
}>;


export type ExportDraftReportDocumentMutation = { __typename?: 'Mutation', exportDraftReportDocument?: { __typename?: 'ExportReportDocumentPayload', file?: any | null, fileName?: string | null } | null };

export type GenerateReportPdfFromDocxMutationVariables = Exact<{
  reportId: Scalars['ID']['input'];
  reportDocxFile: Scalars['Upload']['input'];
}>;


export type GenerateReportPdfFromDocxMutation = { __typename?: 'Mutation', generateReportPdfFromDocx?: { __typename?: 'GenerateReportPdfFromDocx', status?: boolean | null, message?: string | null } | null };

export type CreateOrganizationTemplateLogoMutationVariables = Exact<{
  input: CreateOrganizationTemplateLogoInput;
}>;


export type CreateOrganizationTemplateLogoMutation = { __typename?: 'Mutation', createOrganizationTemplateLogo?: { __typename?: 'CreateOrganizationTemplateLogo', fileUrl?: string | null } | null };

export type UpdateOrganizationTemplateLogoUrlMutationVariables = Exact<{
  input: UpdateOrganizationTemplateLogoUrlInput;
}>;


export type UpdateOrganizationTemplateLogoUrlMutation = { __typename?: 'Mutation', updateOrganizationTemplateLogoUrl?: { __typename?: 'UpdateOrganizationTemplateLogoURL', status?: boolean | null, message?: string | null } | null };

export type UpdateReportPageHeadingMutationVariables = Exact<{
  input: UpdateReportPageHeadingInput;
}>;


export type UpdateReportPageHeadingMutation = { __typename?: 'Mutation', updateReportPageHeading?: { __typename?: 'UpdateReportPageHeading', status?: boolean | null, message?: string | null } | null };

export type PopulateDataFromBhtiaMutationVariables = Exact<{
  learnerFileId: Scalars['ID']['input'];
  reportId: Scalars['ID']['input'];
  pageLocation: ReportPageLocationEnums;
}>;


export type PopulateDataFromBhtiaMutation = { __typename?: 'Mutation', populateDataFromBhtia?: { __typename?: 'PopulateDataFromBHTIA', status?: boolean | null, message?: string | null } | null };

export type ReopenReportCommentMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ReopenReportCommentMutation = { __typename?: 'Mutation', reopenReportComment?: { __typename?: 'ReopenReportComment', success?: boolean | null, message?: string | null, comment?: { __typename?: 'ReportCommentType', id: string, status: string } | null } | null };

export type ManageReportDomainsMutationVariables = Exact<{
  reportId: Scalars['ID']['input'];
  domains: Array<InputMaybe<ManageReportDomainInput>> | InputMaybe<ManageReportDomainInput>;
  deletedDomainIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  goalMoves?: InputMaybe<Array<InputMaybe<GoalDomainAssignmentInput>> | InputMaybe<GoalDomainAssignmentInput>>;
}>;


export type ManageReportDomainsMutation = { __typename?: 'Mutation', manageReportDomains?: { __typename?: 'ManageReportDomains', status?: boolean | null, message?: string | null, reportDomains?: Array<{ __typename?: 'ReportDomainType', id: string, name: string, description?: string | null, rankOrder: number } | null> | null } | null };

export type AddSuggestedReportGoalsMutationVariables = Exact<{
  reportId: Scalars['ID']['input'];
  aiSuggestedGoalIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type AddSuggestedReportGoalsMutation = { __typename?: 'Mutation', addSuggestedReportGoals?: { __typename?: 'AddSuggestedReportGoals', status?: boolean | null, message?: string | null } | null };

export type AddSuggestedReportTargetsMutationVariables = Exact<{
  aiSuggestedTargetsIds: Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>;
  reportId: Scalars['ID']['input'];
  reportGoalId: Scalars['ID']['input'];
}>;


export type AddSuggestedReportTargetsMutation = { __typename?: 'Mutation', addSuggestedReportTargets?: { __typename?: 'AddSuggestedReportTargets', message?: string | null, status?: boolean | null, reportTargetsData?: Array<{ __typename?: 'ReportTargetType', id: string, targetName: string, reportGoal: { __typename?: 'ReportGoalType', id: string, goalName: string } } | null> | null } | null };

export type BulkReassignReportGoalsMutationVariables = Exact<{
  goals: Array<InputMaybe<ReassignReportGoalInput>> | InputMaybe<ReassignReportGoalInput>;
}>;


export type BulkReassignReportGoalsMutation = { __typename?: 'Mutation', bulkReassignReportGoals?: { __typename?: 'BulkReassignReportGoals', status?: boolean | null, message?: string | null } | null };

export type CreateTreatmentPlanCustomFieldFileMutationVariables = Exact<{
  input: CreateTreatmentPlanCustomFieldFileInput;
}>;


export type CreateTreatmentPlanCustomFieldFileMutation = { __typename?: 'Mutation', createTreatmentPlanCustomFieldFile?: { __typename?: 'CreateTreatmentPlanCustomFieldFile', fileUrl?: string | null } | null };

export type CreateUpdateCustomFieldValueMutationVariables = Exact<{
  customFieldId?: InputMaybe<Scalars['ID']['input']>;
  content: Scalars['String']['input'];
  fieldIdentifier?: InputMaybe<Scalars['String']['input']>;
  reportGoalId?: InputMaybe<Scalars['ID']['input']>;
  reportTargetId?: InputMaybe<Scalars['ID']['input']>;
  reportDomainId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type CreateUpdateCustomFieldValueMutation = { __typename?: 'Mutation', createUpdateCustomFieldValue?: { __typename?: 'CreateUpdateCustomFieldValue', status?: boolean | null, message?: string | null, customField?: { __typename?: 'TreatmentPlanCustomFieldType', id: string, content?: string | null, fieldIdentifier: string } | null } | null };

export type CreateUpdateReportGoalMutationVariables = Exact<{
  learnerId: Scalars['ID']['input'];
  goalInput: ReportGoalInput;
}>;


export type CreateUpdateReportGoalMutation = { __typename?: 'Mutation', createUpdateReportGoal?: { __typename?: 'CreateUpdateReportGoal', message?: string | null, status?: boolean | null, reportGoalData?: { __typename?: 'ReportGoalType', id: string, goalName: string, createdDate: any, lastUpdatedDate: any, completionDate?: any | null, projectedIntroductionDate?: any | null, assessmentToolSource?: string | null, baselineDate?: any | null, programGoal?: string | null, description?: string | null, timelineEstimationType?: ApiReportGoalTimelineEstimationTypeChoices | null, timelineEstimationValue?: number | null, baselineData?: string | null, masteryCriteria?: string | null, hasMedicalNecessity: boolean, medicalNecessityCriteria?: string | null, generalizationCriteria?: string | null, aiGoalAttainmentScalePredictionStatus: ApiReportGoalAiGoalAttainmentScalePredictionStatusChoices, gasLevel1?: string | null, gasLevel3?: string | null, gasLevel4?: string | null, rationale?: string | null, status?: ApiReportGoalStatusChoices | null, goalType?: string | null, goalSubType?: string | null, tags?: any | null, aiGenerated: boolean, inUse: boolean, progressSummary?: string | null, gasScore?: string | null, reportDomain?: { __typename?: 'ReportDomainType', id: string } | null } | null } | null };

export type CreateUpdateReportTargetMutationVariables = Exact<{
  learnerId: Scalars['ID']['input'];
  targetData: ReportTargetInput;
}>;


export type CreateUpdateReportTargetMutation = { __typename?: 'Mutation', createUpdateReportTarget?: { __typename?: 'CreateUpdateReportTarget', message?: string | null, status?: boolean | null, reportTargetDetails?: { __typename?: 'ReportTargetType', id: string, targetName: string, aiGenerated: boolean, inUse: boolean, createdDate: any, lastUpdatedDate: any, targetDescription?: string | null, timelineEstimationValue?: number | null, timelineEstimationType?: ApiReportTargetTimelineEstimationTypeChoices | null, masteryCriteria?: string | null, baselineData?: string | null, status?: ApiReportTargetStatusChoices | null, progressSummary?: string | null, completionDate?: any | null, summaryReviewed: boolean, signedChartImageUrl?: string | null, aiProgressSummaryPredictionStatus: ApiReportTargetAiProgressSummaryPredictionStatusChoices, reportGoal: { __typename?: 'ReportGoalType', id: string, reportDomain?: { __typename?: 'ReportDomainType', id: string } | null } } | null } | null };

export type DuplicateReportGoalMutationVariables = Exact<{
  learnerId: Scalars['ID']['input'];
  reportGoalId: Scalars['ID']['input'];
}>;


export type DuplicateReportGoalMutation = { __typename?: 'Mutation', duplicateReportGoal?: { __typename?: 'DuplicateReportGoal', status?: boolean | null, message?: string | null } | null };

export type ReassignReportGoalMutationVariables = Exact<{
  input: ReassignReportGoalInput;
}>;


export type ReassignReportGoalMutation = { __typename?: 'Mutation', reassignReportGoal?: { __typename?: 'ReassignReportGoal', status?: boolean | null, message?: string | null } | null };

export type RemoveReportGoalMutationVariables = Exact<{
  reportGoalId: Scalars['ID']['input'];
}>;


export type RemoveReportGoalMutation = { __typename?: 'Mutation', removeReportGoal?: { __typename?: 'RemoveReportGoal', status?: boolean | null, message?: string | null } | null };

export type RemoveReportTargetMutationVariables = Exact<{
  learnerId: Scalars['ID']['input'];
  reportTargetId: Scalars['ID']['input'];
}>;


export type RemoveReportTargetMutation = { __typename?: 'Mutation', removeReportTarget?: { __typename?: 'RemoveReportTarget', status?: boolean | null, message?: string | null } | null };

export type ReorderReportGoalsMutationVariables = Exact<{
  goals: Array<InputMaybe<ReorderReportGoalsInput>> | InputMaybe<ReorderReportGoalsInput>;
}>;


export type ReorderReportGoalsMutation = { __typename?: 'Mutation', reorderReportGoals?: { __typename?: 'ReorderReportGoals', status?: boolean | null, message?: string | null } | null };

export type StartGoalAttainmentScaleWorkflowMutationVariables = Exact<{
  reportGoalId: Scalars['ID']['input'];
}>;


export type StartGoalAttainmentScaleWorkflowMutation = { __typename?: 'Mutation', startGoalAttainmentScaleWorkflow?: { __typename?: 'StartGoalAttainmentScaleWorkflow', status?: boolean | null, message?: string | null } | null };

export type StartGoalBaselineDataWorkflowMutationVariables = Exact<{
  reportId: Scalars['ID']['input'];
  reportGoalId: Scalars['ID']['input'];
}>;


export type StartGoalBaselineDataWorkflowMutation = { __typename?: 'Mutation', startGoalBaselineDataWorkflow?: { __typename?: 'StartGoalBaselineDataWorkflow', status?: boolean | null, message?: string | null } | null };

export type StartGoalProgressSummaryWorkflowMutationVariables = Exact<{
  reportId: Scalars['ID']['input'];
  reportGoalId: Scalars['ID']['input'];
}>;


export type StartGoalProgressSummaryWorkflowMutation = { __typename?: 'Mutation', startGoalProgressSummaryWorkflow?: { __typename?: 'StartGoalProgressSummaryWorkflow', status?: boolean | null, message?: string | null } | null };

export type StartManualSyncWorkflowMutationVariables = Exact<{
  learnerId: Scalars['ID']['input'];
  reportId?: InputMaybe<Scalars['ID']['input']>;
  reassessmentReportGoalSync?: InputMaybe<Scalars['Boolean']['input']>;
  learningTreeReview?: InputMaybe<Scalars['Boolean']['input']>;
  learningTreeStructureOnly?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type StartManualSyncWorkflowMutation = { __typename?: 'Mutation', startManualSyncWorkflow?: { __typename?: 'StartManualSyncWorkflow', status?: boolean | null, message?: string | null } | null };

export type StartTargetProgressSummaryWorkflowMutationVariables = Exact<{
  reportId: Scalars['ID']['input'];
  targetId: Scalars['ID']['input'];
}>;


export type StartTargetProgressSummaryWorkflowMutation = { __typename?: 'Mutation', startTargetProgressSummaryWorkflow?: { __typename?: 'StartTargetProgressSummaryWorkflow', status?: boolean | null, message?: string | null } | null };

export type UpdateGoalExcludeFromReportMutationVariables = Exact<{
  input: UpdateGoalExcludeFromReportInput;
}>;


export type UpdateGoalExcludeFromReportMutation = { __typename?: 'Mutation', updateGoalExcludeFromReport?: { __typename?: 'UpdateGoalExcludeFromReport', message?: string | null, status?: boolean | null } | null };

export type UpdateGoalProgressSummaryMutationVariables = Exact<{
  input: UpdateGoalProgressSummaryInput;
}>;


export type UpdateGoalProgressSummaryMutation = { __typename?: 'Mutation', updateGoalProgressSummary?: { __typename?: 'UpdateGoalProgressSummary', message?: string | null, status?: boolean | null, summaryReviewedOn?: any | null, signedChartImageUrl?: string | null } | null };

export type UpdateTargetExcludeFromReportMutationVariables = Exact<{
  input: UpdateTargetExcludeFromReportInput;
}>;


export type UpdateTargetExcludeFromReportMutation = { __typename?: 'Mutation', updateTargetExcludeFromReport?: { __typename?: 'UpdateTargetExcludeFromReport', message?: string | null, status?: boolean | null } | null };

export type UpdateTargetProgressSummaryMutationVariables = Exact<{
  input: UpdateTargetProgressSummaryInput;
}>;


export type UpdateTargetProgressSummaryMutation = { __typename?: 'Mutation', updateTargetProgressSummary?: { __typename?: 'UpdateTargetProgressSummary', message?: string | null, status?: boolean | null, signedChartImageUrl?: string | null } | null };

export type UpdateTreatmentPlanCustomFieldFileUrlMutationVariables = Exact<{
  input: UpdateTreatmentPlanCustomFieldFileUrlInput;
}>;


export type UpdateTreatmentPlanCustomFieldFileUrlMutation = { __typename?: 'Mutation', updateTreatmentPlanCustomFieldFileUrl?: { __typename?: 'UpdateTreatmentPlanCustomFieldFileURL', message?: string | null, status?: boolean | null } | null };

export type RequestReportReviewMutationVariables = Exact<{
  reportId: Scalars['ID']['input'];
  reviewers: Array<ReviewerRequestInput> | ReviewerRequestInput;
  includeInternal?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type RequestReportReviewMutation = { __typename?: 'Mutation', requestReportReview?: { __typename?: 'RequestReportReview', success?: boolean | null, message?: string | null, statusLogs?: Array<{ __typename?: 'ReportReviewerStatusLogType', id: string, status: ReportReviewerStatus }> | null } | null };

export type ResolveReportCommentMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ResolveReportCommentMutation = { __typename?: 'Mutation', resolveReportComment?: { __typename?: 'ResolveReportComment', success?: boolean | null, message?: string | null, comment?: { __typename?: 'ReportCommentType', id: string, status: string } | null } | null };

export type ResolveReportSuggestionMutationVariables = Exact<{
  suggestionId: Scalars['ID']['input'];
}>;


export type ResolveReportSuggestionMutation = { __typename?: 'Mutation', resolveReportSuggestion?: { __typename?: 'ResolveReportSuggestion', success?: boolean | null, message?: string | null } | null };

export type CreateReportSectionsMutationVariables = Exact<{
  reportId: Scalars['ID']['input'];
  sections: Array<InputMaybe<ReportSectionInput>> | InputMaybe<ReportSectionInput>;
  runWorkflow?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CreateReportSectionsMutation = { __typename?: 'Mutation', createReportSections?: { __typename?: 'CreateReportSections', message?: string | null, status?: boolean | null } | null };

export type CreateReportTemplateSectionsMutationVariables = Exact<{
  input: ReportTemplateSectionsInput;
}>;


export type CreateReportTemplateSectionsMutation = { __typename?: 'Mutation', createReportTemplateSections?: { __typename?: 'CreateReportTemplateSections', message?: string | null, status?: boolean | null } | null };

export type DeleteReportSectionMutationVariables = Exact<{
  reportSectionId: Scalars['ID']['input'];
  reportId: Scalars['ID']['input'];
}>;


export type DeleteReportSectionMutation = { __typename?: 'Mutation', deleteReportSection?: { __typename?: 'DeleteReportSection', message?: string | null, status?: boolean | null } | null };

export type CreateReportSectionFieldMutationVariables = Exact<{
  reportId: Scalars['ID']['input'];
  reportSectionId: Scalars['ID']['input'];
  fieldData: ReportSectionFieldInput;
}>;


export type CreateReportSectionFieldMutation = { __typename?: 'Mutation', createReportSectionField?: { __typename?: 'CreateReportSectionField', message?: string | null, status?: boolean | null } | null };

export type CreateReportSectionFieldFileMutationVariables = Exact<{
  input: CreateReportSectionFieldFileInput;
}>;


export type CreateReportSectionFieldFileMutation = { __typename?: 'Mutation', createReportSectionFieldFile?: { __typename?: 'CreateReportSectionFieldFile', fileUrl?: string | null } | null };

export type DeleteReportSectionFieldMutationVariables = Exact<{
  sectionId: Scalars['ID']['input'];
  fieldId: Scalars['ID']['input'];
}>;


export type DeleteReportSectionFieldMutation = { __typename?: 'Mutation', deleteReportSectionField?: { __typename?: 'DeleteReportSectionField', message?: string | null, status?: boolean | null } | null };

export type MoveReportSectionFieldToAnotherSectionMutationVariables = Exact<{
  fieldId: Scalars['ID']['input'];
  targetSectionId: Scalars['ID']['input'];
}>;


export type MoveReportSectionFieldToAnotherSectionMutation = { __typename?: 'Mutation', moveReportSectionFieldToAnotherSection?: { __typename?: 'MoveReportSectionFieldToAnotherSection', status?: boolean | null, message?: string | null } | null };

export type MoveReportSectionFieldUpAndDownMutationVariables = Exact<{
  fieldId: Scalars['ID']['input'];
  moveUp: Scalars['Boolean']['input'];
  reportSectionId: Scalars['ID']['input'];
}>;


export type MoveReportSectionFieldUpAndDownMutation = { __typename?: 'Mutation', moveReportSectionFieldUpAndDown?: { __typename?: 'MoveReportSectionFieldUpAndDown', status?: boolean | null, message?: string | null } | null };

export type UpdateReportSectionFieldMutationVariables = Exact<{
  reportSectionId: Scalars['ID']['input'];
  reportSectionFieldId: Scalars['ID']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateReportSectionFieldMutation = { __typename?: 'Mutation', updateReportSectionField?: { __typename?: 'UpdateReportSectionField', message?: string | null, status?: boolean | null } | null };

export type UpdateReportSectionFieldFileUrlMutationVariables = Exact<{
  input: UpdateReportSectionFieldFileUrlInput;
}>;


export type UpdateReportSectionFieldFileUrlMutation = { __typename?: 'Mutation', updateReportSectionFieldFileUrl?: { __typename?: 'UpdateReportSectionFieldFileURL', message?: string | null, status?: boolean | null } | null };

export type FillGasTablesMutationVariables = Exact<{
  reportId: Scalars['ID']['input'];
}>;


export type FillGasTablesMutation = { __typename?: 'Mutation', fillGasTables?: { __typename?: 'FillGasTables', message?: string | null, status?: boolean | null } | null };

export type MoveReportSectionUpAndDownMutationVariables = Exact<{
  sectionId: Scalars['ID']['input'];
  moveUp: Scalars['Boolean']['input'];
  pageLocation: Scalars['String']['input'];
  reportId: Scalars['ID']['input'];
}>;


export type MoveReportSectionUpAndDownMutation = { __typename?: 'Mutation', moveReportSectionUpAndDown?: { __typename?: 'MoveReportSectionUpAndDown', status?: boolean | null, message?: string | null } | null };

export type MoveSectionToOrFromAppendixMutationVariables = Exact<{
  input: MoveReportSectionInput;
}>;


export type MoveSectionToOrFromAppendixMutation = { __typename?: 'Mutation', moveReportSection?: { __typename?: 'MoveReportSection', status?: boolean | null, message?: string | null } | null };

export type RecalculateGoalStatusSummaryMutationVariables = Exact<{
  reportId: Scalars['ID']['input'];
}>;


export type RecalculateGoalStatusSummaryMutation = { __typename?: 'Mutation', recalculateGoalStatusSummary?: { __typename?: 'RecalculateGoalStatusSummary', message?: string | null, status?: boolean | null, updated?: boolean | null } | null };

export type StartSingleReportTemplateSectionWorkflowMutationVariables = Exact<{
  sectionId: Scalars['ID']['input'];
}>;


export type StartSingleReportTemplateSectionWorkflowMutation = { __typename?: 'Mutation', startSingleReportTemplateSectionWorkflow?: { __typename?: 'StartSingleReportTemplateSectionWorkflow', message?: string | null, status?: boolean | null } | null };

export type StartReportSuggestionsWorkflowMutationVariables = Exact<{
  reportId: Scalars['ID']['input'];
}>;


export type StartReportSuggestionsWorkflowMutation = { __typename?: 'Mutation', startReportSuggestionsWorkflow?: { __typename?: 'StartReportSuggestionsWorkflow', success?: boolean | null, message?: string | null } | null };

export type UpdateReportSectionMutationVariables = Exact<{
  reportSectionId: Scalars['ID']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
  aiGeneratedStatus?: InputMaybe<ReportSectionAiPredictionStatusEnums>;
}>;


export type UpdateReportSectionMutation = { __typename?: 'Mutation', updateReportSection?: { __typename?: 'UpdateReportSection', message?: string | null, status?: boolean | null } | null };

export type SetReportCommentHiddenMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  hidden: Scalars['Boolean']['input'];
}>;


export type SetReportCommentHiddenMutation = { __typename?: 'Mutation', setReportCommentHidden?: { __typename?: 'SetReportCommentHidden', success?: boolean | null, message?: string | null, comment?: { __typename?: 'ReportCommentType', id: string, hidden: boolean } | null } | null };

export type SetReportReviewStatusMutationVariables = Exact<{
  reportId: Scalars['ID']['input'];
  status: ReportReviewerStatus;
  userId?: InputMaybe<Scalars['ID']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
}>;


export type SetReportReviewStatusMutation = { __typename?: 'Mutation', setReportReviewStatus?: { __typename?: 'SetReportReviewStatus', success?: boolean | null, message?: string | null, statusLog?: { __typename?: 'ReportReviewerStatusLogType', id: string, status: ReportReviewerStatus } | null } | null };

export type SignReportMutationVariables = Exact<{
  input: SignReportInput;
}>;


export type SignReportMutation = { __typename?: 'Mutation', signReport?: { __typename?: 'SignReport', message?: string | null, status?: boolean | null } | null };

export type UpdateReportMutationVariables = Exact<{
  reportId: Scalars['ID']['input'];
  status: ReportStatusEnums;
}>;


export type UpdateReportMutation = { __typename?: 'Mutation', updateReport?: { __typename?: 'UpdateReport', status?: boolean | null, message?: string | null } | null };

export type UpdateReportClientDetailsMutationVariables = Exact<{
  reportId: Scalars['ID']['input'];
  learnerCaregiverMinimalInput: LearnerCaregiverMinimalInput;
  reportWriterAndDate?: InputMaybe<UpdateReportWriterAndDateInput>;
  previousReportDetails?: InputMaybe<PreviousReportDetailsInput>;
  updateLearner?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UpdateReportClientDetailsMutation = { __typename?: 'Mutation', updateReportClientDetails?: { __typename?: 'UpdateReportClientDetails', message?: string | null, status?: boolean | null } | null };

export type UpdateReportStatusAndUploadReportFileMutationVariables = Exact<{
  reportId: Scalars['ID']['input'];
  reportDocxFile: Scalars['Upload']['input'];
}>;


export type UpdateReportStatusAndUploadReportFileMutation = { __typename?: 'Mutation', updateReportStatusAndUploadReportFile?: { __typename?: 'UpdateReportStatusAndUploadReportFile', status?: boolean | null, message?: string | null } | null };

export type AddSessionAnalyzerFeedbackMutationVariables = Exact<{
  sessionAnalyzerFeedbackDetails: SessionAnalyzerFeedbackDetails;
}>;


export type AddSessionAnalyzerFeedbackMutation = { __typename?: 'Mutation', addSessionAnalyzerFeedback?: { __typename?: 'AddSessionAnalyzerFeedback', status?: boolean | null, message?: string | null } | null };

export type CreateBaseSuggestionCriteriaMutationVariables = Exact<{
  name: Scalars['String']['input'];
  content: Scalars['String']['input'];
  category?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateBaseSuggestionCriteriaMutation = { __typename?: 'Mutation', createBaseSuggestionCriteria?: { __typename?: 'CreateBaseSuggestionCriteria', success?: boolean | null, message?: string | null, suggestionCriteria?: { __typename?: 'SuggestionCriteriaType', id: string, name: string, category: string, content: string, isBaseCriteria: boolean } | null } | null };

export type CreateOrganizationSuggestionCriteriaMutationVariables = Exact<{
  name: Scalars['String']['input'];
  content: Scalars['String']['input'];
  category?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateOrganizationSuggestionCriteriaMutation = { __typename?: 'Mutation', createOrganizationSuggestionCriteria?: { __typename?: 'CreateOrganizationSuggestionCriteria', success?: boolean | null, message?: string | null, organizationSuggestionCriteria?: { __typename?: 'OrganizationSuggestionCriteriaType', id: string, enabled: boolean, suggestionCriteria: { __typename?: 'SuggestionCriteriaType', id: string, name: string, category: string, content: string, isBaseCriteria: boolean } } | null } | null };

export type CreateReportTemplateSuggestionCriteriaMutationVariables = Exact<{
  reportTemplateId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  content: Scalars['String']['input'];
  category?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateReportTemplateSuggestionCriteriaMutation = { __typename?: 'Mutation', createReportTemplateSuggestionCriteria?: { __typename?: 'CreateReportTemplateSuggestionCriteria', success?: boolean | null, message?: string | null, reportTemplateSuggestionCriteria?: { __typename?: 'ReportTemplateSuggestionCriteriaType', id: string, enabled: boolean, suggestionCriteria: { __typename?: 'SuggestionCriteriaType', id: string, name: string, category: string, content: string } } | null } | null };

export type UpdateBaseSuggestionCriteriaMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateBaseSuggestionCriteriaMutation = { __typename?: 'Mutation', updateBaseSuggestionCriteria?: { __typename?: 'UpdateBaseSuggestionCriteria', success?: boolean | null, message?: string | null, suggestionCriteria?: { __typename?: 'SuggestionCriteriaType', id: string, name: string, category: string, content: string, isBaseCriteria: boolean } | null } | null };

export type UpdateOrganizationSuggestionCriteriaMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  content?: InputMaybe<Scalars['String']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UpdateOrganizationSuggestionCriteriaMutation = { __typename?: 'Mutation', updateOrganizationSuggestionCriteria?: { __typename?: 'UpdateOrganizationSuggestionCriteria', success?: boolean | null, message?: string | null, organizationSuggestionCriteria?: { __typename?: 'OrganizationSuggestionCriteriaType', id: string, enabled: boolean, suggestionCriteria: { __typename?: 'SuggestionCriteriaType', id: string, name: string, category: string, content: string, isBaseCriteria: boolean } } | null } | null };

export type UpdateReportTemplateSuggestionCriteriaMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  content?: InputMaybe<Scalars['String']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UpdateReportTemplateSuggestionCriteriaMutation = { __typename?: 'Mutation', updateReportTemplateSuggestionCriteria?: { __typename?: 'UpdateReportTemplateSuggestionCriteria', success?: boolean | null, message?: string | null, reportTemplateSuggestionCriteria?: { __typename?: 'ReportTemplateSuggestionCriteriaType', id: string, enabled: boolean, suggestionCriteria: { __typename?: 'SuggestionCriteriaType', id: string, name: string, category: string, content: string } } | null } | null };

export type UpsertOrganizationSuggestionCriteriaMutationVariables = Exact<{
  suggestionCriteriaId: Scalars['ID']['input'];
  enabled: Scalars['Boolean']['input'];
}>;


export type UpsertOrganizationSuggestionCriteriaMutation = { __typename?: 'Mutation', upsertOrganizationSuggestionCriteria?: { __typename?: 'UpsertOrganizationSuggestionCriteria', success?: boolean | null, message?: string | null, organizationSuggestionCriteria?: { __typename?: 'OrganizationSuggestionCriteriaType', id: string, enabled: boolean, isVirtual?: boolean | null, suggestionCriteria: { __typename?: 'SuggestionCriteriaType', id: string, name: string, category: string, content: string, isBaseCriteria: boolean } } | null } | null };

export type CreateGoalsAndTargetsMutationVariables = Exact<{
  learnerId: Scalars['ID']['input'];
  goals: Array<GoalWithTargetsInput> | GoalWithTargetsInput;
}>;


export type CreateGoalsAndTargetsMutation = { __typename?: 'Mutation', createGoalsAndTargets?: { __typename?: 'CreateGoalsAndTargets', status?: boolean | null, message?: string | null } | null };

export type ReorderGoalsMutationVariables = Exact<{
  goals: Array<ReorderGoalsInput> | ReorderGoalsInput;
}>;


export type ReorderGoalsMutation = { __typename?: 'Mutation', reorderGoals?: { __typename?: 'ReorderGoals', message?: string | null, status?: boolean | null } | null };

export type StartTreatmentPlanUploadParsingMutationVariables = Exact<{
  learnerId: Scalars['ID']['input'];
  input: CreateParsedTreatmentPlanFileDataInput;
}>;


export type StartTreatmentPlanUploadParsingMutation = { __typename?: 'Mutation', createParsedTreatmentPlanFileData?: { __typename?: 'CreateParsedTreatmentPlanFileData', status?: boolean | null, message?: string | null, record?: { __typename?: 'ParsedTreatmentPlanFileDataType', id: string } | null } | null };

export type ProgrammingGoalChartQueryVariables = Exact<{
  goalId: Scalars['ID']['input'];
}>;


export type ProgrammingGoalChartQuery = { __typename?: 'Query', goal?: { __typename?: 'GoalType', reportgoalSet: { __typename?: 'ReportGoalTypeConnection', edges: Array<{ __typename?: 'ReportGoalTypeEdge', node?: { __typename?: 'ReportGoalType', id: string, chartType?: ApiReportGoalChartTypeChoices | null, chartImageUrl?: string | null, summaryReviewed: boolean, summaryReviewedOn?: any | null, reporttargetSet: { __typename?: 'ReportTargetTypeConnection', edges: Array<{ __typename?: 'ReportTargetTypeEdge', node?: { __typename?: 'ReportTargetType', id: string, summaryReviewed: boolean, chartImageUrl?: string | null, target?: { __typename?: 'TargetType', id: string } | null } | null } | null> } } | null } | null> } } | null };

export type AnalyticsMetricFieldsFragment = { __typename?: 'AnalyticsMetricType', value: number, previousValue?: number | null };

export type AnalyticsStatusCountFieldsFragment = { __typename?: 'AnalyticsStatusCountType', status: ReportAnalyticsStatus, count: number };

export type AnalyticsWritingTimeFieldsFragment = { __typename?: 'AnalyticsWritingTimeRowType', reportType: ReportAnalyticsTemplateType, medianWritingMinutes: number, previousMedianWritingMinutes?: number | null };

export type AnalyticsTrendPointFieldsFragment = { __typename?: 'AnalyticsTrendPointType', weekStart: any, submitted: number };

export type AnalyticsTemplateOptionFieldsFragment = { __typename?: 'AnalyticsTemplateOptionType', templateGroup: string, count: number };

export type AnalyticsReportsByUserPageFieldsFragment = { __typename?: 'AnalyticsReportsByUserPage', totalCount: number, rows: Array<{ __typename?: 'AnalyticsReportsByUserRowType', providerId: string, providerName?: string | null, count: number, previousCount?: number | null }> };

export type AnalyticsQaByUserPageFieldsFragment = { __typename?: 'AnalyticsQaByUserPage', totalCount: number, rows: Array<{ __typename?: 'AnalyticsQaByUserRowType', providerId: string, providerName?: string | null, totalFlags: number, openFlags: number, resolvedFlags: number, resolutionRate: number }> };

export type AnalyticsOverdueRowFieldsFragment = { __typename?: 'AnalyticsOverdueReportRowType', reportId: string, reportType?: ReportAnalyticsTemplateType | null, templateGroup?: string | null, learnerName?: string | null, providerId?: string | null, providerName?: string | null, createdDate: any, daysOpen: number };

export type AnalyticsReportRowFieldsFragment = { __typename?: 'AnalyticsReportRowType', reportId: string, reportType?: ReportAnalyticsTemplateType | null, templateGroup?: string | null, status?: ReportAnalyticsStatus | null, providerId?: string | null, providerName?: string | null, learnerName?: string | null, createdDate: any, completedDate?: any | null, submittedDate?: any | null, writingMinutes?: number | null };

export type AnalyticsQaFlagRowFieldsFragment = { __typename?: 'AnalyticsQaFlagRowType', flagId: string, reportId: string, reportType?: ReportAnalyticsTemplateType | null, category: AnalyticsQaCategory, providerId?: string | null, providerName?: string | null, createdDate: any, resolved: boolean, resolvedDate?: any | null };

export type AnalyticsFacetFieldsFragment = { __typename?: 'AnalyticsFacetType', key: string, truncated: boolean, values: Array<{ __typename?: 'AnalyticsFacetValueType', value: string, label: string, count: number }> };

export type AdminAnalyticsDashboardQueryVariables = Exact<{
  filters: AnalyticsFiltersInput;
  reportsByUserPage: AnalyticsPageInput;
  overduePage: AnalyticsPageInput;
  qaByUserPage: AnalyticsPageInput;
  includeSubmissionTrend: Scalars['Boolean']['input'];
}>;


export type AdminAnalyticsDashboardQuery = { __typename?: 'Query', adminAnalytics?: { __typename?: 'AdminAnalyticsType', totalReports?: { __typename?: 'AnalyticsMetricType', value: number, previousValue?: number | null } | null, openQaFlags?: { __typename?: 'AnalyticsMetricType', value: number, previousValue?: number | null } | null, resolvedQaFlags?: { __typename?: 'AnalyticsMetricType', value: number, previousValue?: number | null } | null, reportsByStatus?: Array<{ __typename?: 'AnalyticsStatusCountType', status: ReportAnalyticsStatus, count: number }> | null, writingTimeByReportType?: Array<{ __typename?: 'AnalyticsWritingTimeRowType', reportType: ReportAnalyticsTemplateType, medianWritingMinutes: number, previousMedianWritingMinutes?: number | null }> | null, submissionTrend?: Array<{ __typename?: 'AnalyticsTrendPointType', weekStart: any, submitted: number }> | null, templateOptions?: Array<{ __typename?: 'AnalyticsTemplateOptionType', templateGroup: string, count: number }> | null, reportsByUser?: { __typename?: 'AnalyticsReportsByUserPage', totalCount: number, rows: Array<{ __typename?: 'AnalyticsReportsByUserRowType', providerId: string, providerName?: string | null, count: number, previousCount?: number | null }> } | null, overdueReports?: { __typename?: 'AnalyticsOverdueReportsPage', totalCount: number, rows: Array<{ __typename?: 'AnalyticsOverdueReportRowType', reportId: string, reportType?: ReportAnalyticsTemplateType | null, templateGroup?: string | null, learnerName?: string | null, providerId?: string | null, providerName?: string | null, createdDate: any, daysOpen: number }> } | null, qaByUser?: { __typename?: 'AnalyticsQaByUserPage', totalCount: number, rows: Array<{ __typename?: 'AnalyticsQaByUserRowType', providerId: string, providerName?: string | null, totalFlags: number, openFlags: number, resolvedFlags: number, resolutionRate: number }> } | null } | null };

export type AdminAnalyticsOpenQaFlagsQueryVariables = Exact<{
  filters: AnalyticsFiltersInput;
  cell?: InputMaybe<AnalyticsCellFiltersInput>;
}>;


export type AdminAnalyticsOpenQaFlagsQuery = { __typename?: 'Query', adminAnalytics?: { __typename?: 'AdminAnalyticsType', openQaFlags?: { __typename?: 'AnalyticsMetricType', value: number, previousValue?: number | null } | null } | null };

export type AdminAnalyticsOverdueReportFacetsQueryVariables = Exact<{
  filters: AnalyticsFiltersInput;
  cell?: InputMaybe<AnalyticsCellFiltersInput>;
  facetLimit?: InputMaybe<Scalars['Int']['input']>;
  facetSearch?: InputMaybe<Array<AnalyticsFacetSearchInput> | AnalyticsFacetSearchInput>;
}>;


export type AdminAnalyticsOverdueReportFacetsQuery = { __typename?: 'Query', adminAnalytics?: { __typename?: 'AdminAnalyticsType', overdueReports?: { __typename?: 'AnalyticsOverdueReportsPage', facets?: Array<{ __typename?: 'AnalyticsFacetType', key: string, truncated: boolean, values: Array<{ __typename?: 'AnalyticsFacetValueType', value: string, label: string, count: number }> }> | null } | null } | null };

export type AdminAnalyticsOverdueReportRowsQueryVariables = Exact<{
  filters: AnalyticsFiltersInput;
  cell?: InputMaybe<AnalyticsCellFiltersInput>;
  page: AnalyticsPageInput;
  sort: AnalyticsOverdueReportSortInput;
  withTotal?: Scalars['Boolean']['input'];
}>;


export type AdminAnalyticsOverdueReportRowsQuery = { __typename?: 'Query', adminAnalytics?: { __typename?: 'AdminAnalyticsType', overdueReports?: { __typename?: 'AnalyticsOverdueReportsPage', totalCount?: number, rows: Array<{ __typename?: 'AnalyticsOverdueReportRowType', reportId: string, reportType?: ReportAnalyticsTemplateType | null, templateGroup?: string | null, learnerName?: string | null, providerId?: string | null, providerName?: string | null, createdDate: any, daysOpen: number }> } | null } | null };

export type AdminAnalyticsOverdueReportsQueryVariables = Exact<{
  filters: AnalyticsFiltersInput;
  cell?: InputMaybe<AnalyticsCellFiltersInput>;
  page: AnalyticsPageInput;
}>;


export type AdminAnalyticsOverdueReportsQuery = { __typename?: 'Query', adminAnalytics?: { __typename?: 'AdminAnalyticsType', overdueReports?: { __typename?: 'AnalyticsOverdueReportsPage', totalCount: number, rows: Array<{ __typename?: 'AnalyticsOverdueReportRowType', reportId: string, reportType?: ReportAnalyticsTemplateType | null, templateGroup?: string | null, learnerName?: string | null, providerId?: string | null, providerName?: string | null, createdDate: any, daysOpen: number }> } | null } | null };

export type AdminAnalyticsQaByUserQueryVariables = Exact<{
  filters: AnalyticsFiltersInput;
  cell?: InputMaybe<AnalyticsCellFiltersInput>;
  page: AnalyticsPageInput;
}>;


export type AdminAnalyticsQaByUserQuery = { __typename?: 'Query', adminAnalytics?: { __typename?: 'AdminAnalyticsType', qaByUser?: { __typename?: 'AnalyticsQaByUserPage', totalCount: number, rows: Array<{ __typename?: 'AnalyticsQaByUserRowType', providerId: string, providerName?: string | null, totalFlags: number, openFlags: number, resolvedFlags: number, resolutionRate: number }> } | null } | null };

export type AdminAnalyticsQaFlagFacetsQueryVariables = Exact<{
  filters: AnalyticsFiltersInput;
  cell?: InputMaybe<AnalyticsCellFiltersInput>;
  facetLimit?: InputMaybe<Scalars['Int']['input']>;
  facetSearch?: InputMaybe<Array<AnalyticsFacetSearchInput> | AnalyticsFacetSearchInput>;
}>;


export type AdminAnalyticsQaFlagFacetsQuery = { __typename?: 'Query', adminAnalytics?: { __typename?: 'AdminAnalyticsType', qaFlags?: { __typename?: 'AnalyticsQaFlagsPage', facets?: Array<{ __typename?: 'AnalyticsFacetType', key: string, truncated: boolean, values: Array<{ __typename?: 'AnalyticsFacetValueType', value: string, label: string, count: number }> }> | null } | null } | null };

export type AdminAnalyticsQaFlagRowsQueryVariables = Exact<{
  filters: AnalyticsFiltersInput;
  cell?: InputMaybe<AnalyticsCellFiltersInput>;
  page: AnalyticsPageInput;
  sort: AnalyticsQaFlagSortInput;
  withTotal?: Scalars['Boolean']['input'];
}>;


export type AdminAnalyticsQaFlagRowsQuery = { __typename?: 'Query', adminAnalytics?: { __typename?: 'AdminAnalyticsType', qaFlags?: { __typename?: 'AnalyticsQaFlagsPage', totalCount?: number, rows: Array<{ __typename?: 'AnalyticsQaFlagRowType', flagId: string, reportId: string, reportType?: ReportAnalyticsTemplateType | null, category: AnalyticsQaCategory, providerId?: string | null, providerName?: string | null, createdDate: any, resolved: boolean, resolvedDate?: any | null }> } | null } | null };

export type AdminAnalyticsReportFacetsQueryVariables = Exact<{
  filters: AnalyticsFiltersInput;
  cell?: InputMaybe<AnalyticsCellFiltersInput>;
  dateField: AnalyticsReportDateField;
  facetLimit?: InputMaybe<Scalars['Int']['input']>;
  facetSearch?: InputMaybe<Array<AnalyticsFacetSearchInput> | AnalyticsFacetSearchInput>;
}>;


export type AdminAnalyticsReportFacetsQuery = { __typename?: 'Query', adminAnalytics?: { __typename?: 'AdminAnalyticsType', reports?: { __typename?: 'AnalyticsReportsPage', facets?: Array<{ __typename?: 'AnalyticsFacetType', key: string, truncated: boolean, values: Array<{ __typename?: 'AnalyticsFacetValueType', value: string, label: string, count: number }> }> | null } | null } | null };

export type AdminAnalyticsReportRowsQueryVariables = Exact<{
  filters: AnalyticsFiltersInput;
  cell?: InputMaybe<AnalyticsCellFiltersInput>;
  dateField: AnalyticsReportDateField;
  page: AnalyticsPageInput;
  sort: AnalyticsReportSortInput;
  withTotal?: Scalars['Boolean']['input'];
}>;


export type AdminAnalyticsReportRowsQuery = { __typename?: 'Query', adminAnalytics?: { __typename?: 'AdminAnalyticsType', reports?: { __typename?: 'AnalyticsReportsPage', totalCount?: number, rows: Array<{ __typename?: 'AnalyticsReportRowType', reportId: string, reportType?: ReportAnalyticsTemplateType | null, templateGroup?: string | null, status?: ReportAnalyticsStatus | null, providerId?: string | null, providerName?: string | null, learnerName?: string | null, createdDate: any, completedDate?: any | null, submittedDate?: any | null, writingMinutes?: number | null }> } | null } | null };

export type AdminAnalyticsReportsByStatusQueryVariables = Exact<{
  filters: AnalyticsFiltersInput;
  cell?: InputMaybe<AnalyticsCellFiltersInput>;
}>;


export type AdminAnalyticsReportsByStatusQuery = { __typename?: 'Query', adminAnalytics?: { __typename?: 'AdminAnalyticsType', reportsByStatus?: Array<{ __typename?: 'AnalyticsStatusCountType', status: ReportAnalyticsStatus, count: number }> | null } | null };

export type AdminAnalyticsReportsByUserQueryVariables = Exact<{
  filters: AnalyticsFiltersInput;
  cell?: InputMaybe<AnalyticsCellFiltersInput>;
  page: AnalyticsPageInput;
}>;


export type AdminAnalyticsReportsByUserQuery = { __typename?: 'Query', adminAnalytics?: { __typename?: 'AdminAnalyticsType', reportsByUser?: { __typename?: 'AnalyticsReportsByUserPage', totalCount: number, rows: Array<{ __typename?: 'AnalyticsReportsByUserRowType', providerId: string, providerName?: string | null, count: number, previousCount?: number | null }> } | null } | null };

export type AdminAnalyticsResolvedQaFlagsQueryVariables = Exact<{
  filters: AnalyticsFiltersInput;
  cell?: InputMaybe<AnalyticsCellFiltersInput>;
}>;


export type AdminAnalyticsResolvedQaFlagsQuery = { __typename?: 'Query', adminAnalytics?: { __typename?: 'AdminAnalyticsType', resolvedQaFlags?: { __typename?: 'AnalyticsMetricType', value: number, previousValue?: number | null } | null } | null };

export type AdminAnalyticsSubmissionTrendQueryVariables = Exact<{
  filters: AnalyticsFiltersInput;
  cell?: InputMaybe<AnalyticsCellFiltersInput>;
}>;


export type AdminAnalyticsSubmissionTrendQuery = { __typename?: 'Query', adminAnalytics?: { __typename?: 'AdminAnalyticsType', submissionTrend?: Array<{ __typename?: 'AnalyticsTrendPointType', weekStart: any, submitted: number }> | null } | null };

export type AdminAnalyticsTemplateOptionsQueryVariables = Exact<{
  filters: AnalyticsFiltersInput;
}>;


export type AdminAnalyticsTemplateOptionsQuery = { __typename?: 'Query', adminAnalytics?: { __typename?: 'AdminAnalyticsType', templateOptions?: Array<{ __typename?: 'AnalyticsTemplateOptionType', templateGroup: string, count: number }> | null } | null };

export type AdminAnalyticsTotalReportsQueryVariables = Exact<{
  filters: AnalyticsFiltersInput;
  cell?: InputMaybe<AnalyticsCellFiltersInput>;
}>;


export type AdminAnalyticsTotalReportsQuery = { __typename?: 'Query', adminAnalytics?: { __typename?: 'AdminAnalyticsType', totalReports?: { __typename?: 'AnalyticsMetricType', value: number, previousValue?: number | null } | null } | null };

export type AdminAnalyticsWritingTimeQueryVariables = Exact<{
  filters: AnalyticsFiltersInput;
  cell?: InputMaybe<AnalyticsCellFiltersInput>;
}>;


export type AdminAnalyticsWritingTimeQuery = { __typename?: 'Query', adminAnalytics?: { __typename?: 'AdminAnalyticsType', writingTimeByReportType?: Array<{ __typename?: 'AnalyticsWritingTimeRowType', reportType: ReportAnalyticsTemplateType, medianWritingMinutes: number, previousMedianWritingMinutes?: number | null }> | null } | null };

export type BcbaCommentsDistributionRawDataQueryVariables = Exact<{
  fromDate: Scalars['Date']['input'];
  toDate: Scalars['Date']['input'];
  offset?: InputMaybe<Scalars['Int']['input']>;
  count?: InputMaybe<Scalars['Int']['input']>;
  bcbaProviderIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  learnerIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
}>;


export type BcbaCommentsDistributionRawDataQuery = { __typename?: 'Query', bcbaCommentsDistributionRawData?: { __typename?: 'BCBACommentsDistributionRawDataType', totalRecordsCount?: number | null, rawData?: Array<{ __typename?: 'BCBACommentsDistributionRawTextDataType', clientId?: number | null, clientName?: string | null, sessionDate?: any | null, sessionDatetime?: any | null, sessionDuration?: number | null, totalComments?: number | null, bcbaName?: string | null, commentTypeCounts?: { __typename?: 'CommentsDataType', love?: number | null, praise?: number | null, question?: number | null, feedback?: number | null, totalComments?: number | null } | null } | null> | null } | null };

export type ReviewCompletionTimeRawDataQueryVariables = Exact<{
  bcbaProviderIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  learnerIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  fromDate: Scalars['Date']['input'];
  toDate: Scalars['Date']['input'];
  offset?: InputMaybe<Scalars['Int']['input']>;
  count?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ReviewCompletionTimeRawDataQuery = { __typename?: 'Query', reviewCompletionTimeRawData?: { __typename?: 'ReviewCompletionTimeRawDataType', totalRecordsCount?: number | null, rawData?: Array<{ __typename?: 'ReviewCompletionTimeRawTextDataType', clientId?: number | null, clientName?: string | null, sessionDate?: any | null, sessionDatetime?: any | null, sessionRecordedBy?: string | null, readyForReviewAt?: any | null, reviewedAt?: any | null, sessionViewedByBcba?: string | null, reviewCompletionTimeInSeconds?: number | null } | null> | null } | null };

export type BcbaResponsesToRbtQuestionsRawDataQueryVariables = Exact<{
  fromDate: Scalars['Date']['input'];
  toDate: Scalars['Date']['input'];
  offset?: InputMaybe<Scalars['Int']['input']>;
  bcbaProviderIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  learnerIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  forResponseRate?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type BcbaResponsesToRbtQuestionsRawDataQuery = { __typename?: 'Query', bcbaResponsesToRbtQuestionsRawData?: { __typename?: 'ResponsesToQuestionsRawDataType', totalRecordsCount?: number | null, rawData?: Array<{ __typename?: 'ResponsesToQuestionsRawTextDataType', commentId?: number | null, rbtName?: string | null, questionAskedAt?: any | null, respondedOn?: any | null, responseTimeInSeconds?: number | null, bcbaName?: string | null } | null> | null } | null };

export type BcbaSessionVideosAnalyticsQueryVariables = Exact<{
  fromDate: Scalars['Date']['input'];
  toDate: Scalars['Date']['input'];
  comparisonFromDate?: InputMaybe<Scalars['Date']['input']>;
  comparisonToDate?: InputMaybe<Scalars['Date']['input']>;
  bcbaProviderIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;


export type BcbaSessionVideosAnalyticsQuery = { __typename?: 'Query', bcbaSessionVideosAnalytics?: { __typename?: 'BCBASessionAnalyticsVideosType', currentData?: { __typename?: 'BCBASessionAnalyticsVideosDataType', totalVideosCount?: number | null, averageSessionsReviewedByBcba?: number | null, videosReviewedPercentage?: number | null, averageResponseTimeToRbtQuestions?: number | null, averageResponseRateToRbtQuestions?: number | null, averageCommentLeftByBcbaPerVideo?: number | null, averageReviewCompletionTime?: number | null, commentsData?: { __typename?: 'CommentsDataType', love?: number | null, praise?: number | null, feedback?: number | null, question?: number | null, totalComments?: number | null } | null } | null, comparisonData?: { __typename?: 'BCBASessionAnalyticsVideosDataType', totalVideosCount?: number | null, averageSessionsReviewedByBcba?: number | null, videosReviewedPercentage?: number | null, averageResponseTimeToRbtQuestions?: number | null, averageResponseRateToRbtQuestions?: number | null, averageCommentLeftByBcbaPerVideo?: number | null, averageReviewCompletionTime?: number | null, commentsData?: { __typename?: 'CommentsDataType', love?: number | null, praise?: number | null, feedback?: number | null, question?: number | null, totalComments?: number | null } | null } | null } | null };

export type BcbaVideosReviewedRawDataQueryVariables = Exact<{
  fromDate: Scalars['Date']['input'];
  toDate: Scalars['Date']['input'];
  offset?: InputMaybe<Scalars['Int']['input']>;
  bcbaProviderIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  learnerIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  avgVideosReviewed?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type BcbaVideosReviewedRawDataQuery = { __typename?: 'Query', videosReviewedRawData?: { __typename?: 'VideosReviewedRawTextType', totalRecordsCount?: number | null, rawData?: Array<{ __typename?: 'VideosReviewedRawTextDataType', clientId?: number | null, clientName?: string | null, totalVideos?: number | null, videosReviewed?: number | null, percentReviewed?: number | null, sessionViewedBy?: string | null } | null> | null } | null };

export type GetProviderListByRoleQueryVariables = Exact<{
  roles: Array<InputMaybe<RolesEnum>> | InputMaybe<RolesEnum>;
}>;


export type GetProviderListByRoleQuery = { __typename?: 'Query', getProviderListByRole?: { __typename?: 'ProviderTypeConnection', totalCount?: number | null, edges: Array<{ __typename?: 'ProviderTypeEdge', node?: { __typename?: 'ProviderType', id: string, providermetadata?: { __typename?: 'ProviderMetadataType', firstName: string, lastName?: string | null } | null, organizationuserrolesSet: { __typename?: 'OrganizationUserRolesTypeConnection', edges: Array<{ __typename?: 'OrganizationUserRolesTypeEdge', node?: { __typename?: 'OrganizationUserRolesType', role: ApiOrganizationUserRolesRoleChoices } | null } | null> } } | null } | null> } | null };

export type GetQuestionsAskedByRbtRawDataQueryVariables = Exact<{
  fromDate: Scalars['Date']['input'];
  toDate: Scalars['Date']['input'];
  offset?: InputMaybe<Scalars['Int']['input']>;
  rbtProviderIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  learnerIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  count?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetQuestionsAskedByRbtRawDataQuery = { __typename?: 'Query', getQuestionsAskedByRbtRawData?: { __typename?: 'QuestionsAskedByRbtRawDataType', totalRecordsCount?: number | null, rawData?: Array<{ __typename?: 'QuestionsAskedByRbtRawTextDataType', rbtName?: string | null, sessionDate?: any | null, sessionDatetime?: any | null, sessionDuration?: number | null, totalQuestionsAsked?: number | null } | null> | null } | null };

export type GetRbtVideoUploadTimeRawDataQueryVariables = Exact<{
  fromDate: Scalars['Date']['input'];
  toDate: Scalars['Date']['input'];
  offset?: InputMaybe<Scalars['Int']['input']>;
  rbtProviderIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  learnerIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  count?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetRbtVideoUploadTimeRawDataQuery = { __typename?: 'Query', getRbtVideoUploadTimeRawData?: { __typename?: 'RbtVideoUploadTimeRawDataType', totalRecordsCount?: number | null, rawData?: Array<{ __typename?: 'RbtVideoUploadTimeRawTextDataType', rbtName?: string | null, sessionDate?: any | null, sessionDatetime?: any | null, sessionDuration?: number | null, uploadCompletionTimeInSeconds?: number | null } | null> | null } | null };

export type GetRecordedVideoDistributionRawDataQueryVariables = Exact<{
  fromDate: Scalars['Date']['input'];
  toDate: Scalars['Date']['input'];
  offset?: InputMaybe<Scalars['Int']['input']>;
  rbtProviderIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  learnerIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  count?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetRecordedVideoDistributionRawDataQuery = { __typename?: 'Query', getRecordedVideoDistributionRawData?: { __typename?: 'RecordedVideosDistributionRawDataType', totalRecordsCount?: number | null, rawData?: Array<{ __typename?: 'RecordedVideosDistributionRawTextDataType', clientId?: number | null, clientName?: string | null, rbtName?: string | null, uploadingVideosCount?: number | null, scheduledVideosCount?: number | null, processingVideosCount?: number | null, failedVideosCount?: number | null, completedVideosCount?: number | null, totalVideosRecorded?: number | null } | null> | null } | null };

export type GetTotalVideoDurationRawDataQueryVariables = Exact<{
  fromDate: Scalars['Date']['input'];
  toDate: Scalars['Date']['input'];
  offset?: InputMaybe<Scalars['Int']['input']>;
  rbtProviderIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  learnerIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  count?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetTotalVideoDurationRawDataQuery = { __typename?: 'Query', getTotalVideoDurationRawData?: { __typename?: 'TotalVideoDurationRawDataType', totalRecordsCount?: number | null, rawData?: Array<{ __typename?: 'TotalVideoDurationRawTextDataType', clientId?: number | null, clientName?: string | null, sessionDate?: any | null, sessionDatetime?: any | null, sessionDurationInSeconds?: number | null, rbtName?: string | null } | null> | null } | null };

export type GetVideoCommentsReceivedByRbtRawDataQueryVariables = Exact<{
  fromDate: Scalars['Date']['input'];
  toDate: Scalars['Date']['input'];
  offset?: InputMaybe<Scalars['Int']['input']>;
  rbtProviderIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  learnerIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  count?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetVideoCommentsReceivedByRbtRawDataQuery = { __typename?: 'Query', getVideoCommentsReceivedByRbtRawData?: { __typename?: 'VideoCommentsReceivedByRbtRawDataType', totalRecordsCount?: number | null, rawData?: Array<{ __typename?: 'VideoCommentsReceivedByRbtRawTextDataType', clientId?: number | null, clientName?: string | null, sessionDate?: any | null, sessionDatetime?: any | null, sessionDuration?: number | null, totalComments?: number | null, rbtName?: string | null, commentTypeCounts?: { __typename?: 'CommentsDataType', love?: number | null, praise?: number | null, question?: number | null, feedback?: number | null, totalComments?: number | null } | null } | null> | null } | null };

export type RbtResponsesToBcbaQuestionsRawDataQueryVariables = Exact<{
  fromDate: Scalars['Date']['input'];
  toDate: Scalars['Date']['input'];
  offset?: InputMaybe<Scalars['Int']['input']>;
  rbtProviderIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  learnerIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  forResponseRate?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type RbtResponsesToBcbaQuestionsRawDataQuery = { __typename?: 'Query', rbtResponsesToBcbaQuestionsRawData?: { __typename?: 'ResponsesToQuestionsRawDataType', totalRecordsCount?: number | null, rawData?: Array<{ __typename?: 'ResponsesToQuestionsRawTextDataType', commentId?: number | null, bcbaName?: string | null, questionAskedAt?: any | null, respondedOn?: any | null, responseTimeInSeconds?: number | null, rbtName?: string | null } | null> | null } | null };

export type RbtSessionVideosAnalyticsQueryVariables = Exact<{
  fromDate: Scalars['Date']['input'];
  toDate: Scalars['Date']['input'];
  comparisonFromDate?: InputMaybe<Scalars['Date']['input']>;
  comparisonToDate?: InputMaybe<Scalars['Date']['input']>;
  rbtIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
}>;


export type RbtSessionVideosAnalyticsQuery = { __typename?: 'Query', rbtSessionVideosAnalytics?: { __typename?: 'RBTSessionAnalyticsVideosType', currentData?: { __typename?: 'RBTSessionAnalyticsVideosDataType', totalSessionsRecorded?: number | null, videoRecordingsDurationInSeconds?: number | null, averageVideoUploadTime?: number | null, averageResponseTimeToBcbaQuestions?: number | null, averageResponseRateToBcbaQuestions?: number | null, averageQuestionAskedPerVideo?: number | null, averageCommentsReceivedPerVideo?: number | null, sessionsStateDistribution?: { __typename?: 'SessionRecordingStateDistributionType', uploading?: number | null, scheduled?: number | null, processing?: number | null, failed?: number | null, completed?: number | null, totalSessionsRecorded?: number | null } | null, receivedCommentsDistributionCount?: { __typename?: 'CommentsDataType', love?: number | null, praise?: number | null, feedback?: number | null, question?: number | null, totalComments?: number | null } | null } | null, comparisonData?: { __typename?: 'RBTSessionAnalyticsVideosDataType', totalSessionsRecorded?: number | null, videoRecordingsDurationInSeconds?: number | null, averageVideoUploadTime?: number | null, averageResponseTimeToBcbaQuestions?: number | null, averageResponseRateToBcbaQuestions?: number | null, averageQuestionAskedPerVideo?: number | null, averageCommentsReceivedPerVideo?: number | null, sessionsStateDistribution?: { __typename?: 'SessionRecordingStateDistributionType', uploading?: number | null, scheduled?: number | null, processing?: number | null, failed?: number | null, completed?: number | null, totalSessionsRecorded?: number | null } | null, receivedCommentsDistributionCount?: { __typename?: 'CommentsDataType', love?: number | null, praise?: number | null, feedback?: number | null, question?: number | null, totalComments?: number | null } | null } | null } | null };

export type CaregiverByIdQueryVariables = Exact<{
  caregiverId: Scalars['ID']['input'];
}>;


export type CaregiverByIdQuery = { __typename?: 'Query', caregiverById?: { __typename?: 'CaregiverType', id: string, caregivermetadata?: { __typename?: 'CaregiverMetadataType', firstName: string, lastName: string, email?: string | null, phoneNumber1?: string | null, appActivationCode?: string | null, appActivationCodeUsedAt?: any | null, appActivationEligible: boolean, activationCodeEmailLastSendDate?: any | null, activationCodeSmsLastSendDate?: any | null } | null, relationshipSet: { __typename?: 'RelationshipTypeConnection', edges: Array<{ __typename?: 'RelationshipTypeEdge', node?: { __typename?: 'RelationshipType', isPrimary: boolean, relationship: ApiRelationshipRelationshipChoices, relationshipLearner: { __typename?: 'LearnerType', id: string, learnermetadata?: { __typename?: 'LearnerMetadataType', firstName: string, lastName: string, birthDate?: any | null } | null, learnerproviderSet: { __typename?: 'LearnerProviderTypeConnection', edges: Array<{ __typename?: 'LearnerProviderTypeEdge', node?: { __typename?: 'LearnerProviderType', provider: { __typename?: 'ProviderType', id: string } } | null } | null> } } } | null } | null> } } | null };

export type GetCaregiversDataQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<CaregiversFilter>;
}>;


export type GetCaregiversDataQuery = { __typename?: 'Query', caregivers?: { __typename?: 'CaregiverTypeConnection', totalCount?: number | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null }, edges: Array<{ __typename?: 'CaregiverTypeEdge', node?: { __typename?: 'CaregiverType', id: string, caregivermetadata?: { __typename?: 'CaregiverMetadataType', id: string, firstName: string, lastName: string, email?: string | null, phoneNumber1?: string | null, nearestLocation?: string | null, referralSource?: string | null, smsAgreement: boolean, appActivationCode?: string | null, appActivationCodeUsedAt?: any | null, appActivationEligible: boolean, activationCodeEmailLastSendDate?: any | null, activationCodeSmsLastSendDate?: any | null } | null, relationshipSet: { __typename?: 'RelationshipTypeConnection', edges: Array<{ __typename?: 'RelationshipTypeEdge', node?: { __typename?: 'RelationshipType', isPrimary: boolean, relationship: ApiRelationshipRelationshipChoices, relationshipLearner: { __typename?: 'LearnerType', id: string, learnermetadata?: { __typename?: 'LearnerMetadataType', firstName: string, lastName: string, birthDate?: any | null } | null, learnerproviderSet: { __typename?: 'LearnerProviderTypeConnection', edges: Array<{ __typename?: 'LearnerProviderTypeEdge', node?: { __typename?: 'LearnerProviderType', provider: { __typename?: 'ProviderType', id: string } } | null } | null> } } } | null } | null> } } | null } | null> } | null };

export type GetLoginCaregiverQueryVariables = Exact<{ [key: string]: never; }>;


export type GetLoginCaregiverQuery = { __typename?: 'Query', getLoginCaregiver?: { __typename?: 'CaregiverType', id: string, hasEnteredVideoCaptureApp: boolean, caregivermetadata?: { __typename?: 'CaregiverMetadataType', id: string, firstName: string, lastName: string, email?: string | null } | null } | null };

export type GetAssignedChatTagsQueryVariables = Exact<{
  chatId: Scalars['ID']['input'];
}>;


export type GetAssignedChatTagsQuery = { __typename?: 'Query', assignedChatTags?: { __typename?: 'ChatTagTypeConnection', totalCount?: number | null, edges: Array<{ __typename?: 'ChatTagTypeEdge', node?: { __typename?: 'ChatTagType', id: string, name: string } | null } | null>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type GetBillingChatMembersQueryVariables = Exact<{ [key: string]: never; }>;


export type GetBillingChatMembersQuery = { __typename?: 'Query', chatMembers?: { __typename?: 'ChatMemberTypeConnection', edges: Array<{ __typename?: 'ChatMemberTypeEdge', node?: { __typename?: 'ChatMemberType', id: string, chat: { __typename?: 'ChatType', id: string, type: ApiChatTypeChoices, status: ApiChatStatusChoices, summary?: string | null, summaryStatus: ApiChatSummaryStatusChoices, clinicianSummary?: string | null, clinicianSummaryStatus: ApiChatClinicianSummaryStatusChoices, createdDate: any, lastUpdatedDate: any, chatTasks: { __typename?: 'TaskTypeConnection', edges: Array<{ __typename?: 'TaskTypeEdge', node?: { __typename?: 'TaskType', id: string, title: string, status: ApiTaskStatusChoices } | null } | null> }, learner: { __typename?: 'LearnerType', id: string, learnermetadata?: { __typename?: 'LearnerMetadataType', firstName: string, lastName: string } | null, relationshipSet: { __typename?: 'RelationshipTypeConnection', edges: Array<{ __typename?: 'RelationshipTypeEdge', node?: { __typename?: 'RelationshipType', id: string, relationship: ApiRelationshipRelationshipChoices, socialRelationship?: string | null, isPrimary: boolean, caregiver: { __typename?: 'CaregiverType', id: string, caregivermetadata?: { __typename?: 'CaregiverMetadataType', firstName: string, lastName: string } | null } } | null } | null> } }, user: { __typename?: 'UserType', userBillingDetails: { __typename?: 'UserBillingDetailsTypeConnection', edges: Array<{ __typename?: 'UserBillingDetailsTypeEdge', node?: { __typename?: 'UserBillingDetailsType', id: string, paymentStatus: ApiUserBillingDetailsPaymentStatusChoices, paymentMethodId?: string | null, paymentIntentId?: string | null, description?: string | null, amount?: any | null } | null } | null> } } } } | null } | null> } | null };

export type GetChatMediaQueryVariables = Exact<{
  chatId: Scalars['ID']['input'];
  attachmentKind?: InputMaybe<ChatAttachmentKindEnum>;
}>;


export type GetChatMediaQuery = { __typename?: 'Query', chatMessages?: { __typename?: 'ChatMessageTypeConnection', totalCount?: number | null, edges: Array<{ __typename?: 'ChatMessageTypeEdge', node?: { __typename?: 'ChatMessageType', id: string, content?: string | null, createdDate: any, userFirstName?: string | null, userLastName?: string | null, media?: { __typename?: 'MediaType', id: string, videoUploadStatus?: ApiMediaVideoUploadStatusChoices | null, thumbnailUrl?: string | null } | null, file?: { __typename?: 'LearnerFileType', id: string, originalFileName: string, mimeType: string, signedS3LearnerFile?: string | null } | null } | null } | null> } | null };

export type GetChatMessagesQueryVariables = Exact<{
  chatId: Scalars['ID']['input'];
}>;


export type GetChatMessagesQuery = { __typename?: 'Query', chatMessages?: { __typename?: 'ChatMessageTypeConnection', totalCount?: number | null, edges: Array<{ __typename?: 'ChatMessageTypeEdge', node?: { __typename?: 'ChatMessageType', id: string, content?: string | null, role: ApiChatMessageRoleChoices, createdDate: any, readAt?: any | null, edited: boolean, archived: boolean, userFirstName?: string | null, userLastName?: string | null, user?: { __typename?: 'UserType', id: string, username: string, email: string, auth0id?: string | null } | null, readBy?: { __typename?: 'UserType', id: string } | null, media?: { __typename?: 'MediaType', id: string, videoUploadStatus?: ApiMediaVideoUploadStatusChoices | null, thumbnailUrl?: string | null, commentsCount?: any | null, createdBy?: { __typename?: 'UserType', id: string } | null } | null, mediaComment?: { __typename?: 'MediaCommentsType', id: string, mediaStartTime: number, author?: { __typename?: 'UserType', id: string, auth0id?: string | null } | null, media: { __typename?: 'MediaType', id: string, createdBy?: { __typename?: 'UserType', id: string, auth0id?: string | null } | null }, parentComment?: { __typename?: 'MediaCommentsType', id: string, author?: { __typename?: 'UserType', id: string, auth0id?: string | null } | null } | null } | null, file?: { __typename?: 'LearnerFileType', id: string, originalFileName: string, mimeType: string, fileSize: any, signedS3LearnerFile?: string | null } | null, chat: { __typename?: 'ChatType', learner: { __typename?: 'LearnerType', id: string, relationshipSet: { __typename?: 'RelationshipTypeConnection', edges: Array<{ __typename?: 'RelationshipTypeEdge', node?: { __typename?: 'RelationshipType', id: string, relationship: ApiRelationshipRelationshipChoices, socialRelationship?: string | null, isPrimary: boolean, caregiver: { __typename?: 'CaregiverType', id: string, caregivermetadata?: { __typename?: 'CaregiverMetadataType', firstName: string, lastName: string } | null } } | null } | null> } } } } | null } | null>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type GetChatNotesQueryVariables = Exact<{
  chatId: Scalars['ID']['input'];
}>;


export type GetChatNotesQuery = { __typename?: 'Query', chatNotes?: { __typename?: 'ChatNoteTypeConnection', totalCount?: number | null, edges: Array<{ __typename?: 'ChatNoteTypeEdge', node?: { __typename?: 'ChatNoteType', id: string, createdDate: any, content?: string | null, user: { __typename?: 'UserType', auth0id?: string | null, provider?: { __typename?: 'ProviderType', id: string, providermetadata?: { __typename?: 'ProviderMetadataType', firstName: string, lastName?: string | null } | null } | null } } | null } | null>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type GetChatTagsQueryVariables = Exact<{
  filter: ChatTagsFilter;
}>;


export type GetChatTagsQuery = { __typename?: 'Query', chatTags?: { __typename?: 'ChatTagTypeConnection', totalCount?: number | null, edges: Array<{ __typename?: 'ChatTagTypeEdge', node?: { __typename?: 'ChatTagType', id: string, name: string } | null } | null>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type GetExpertChatMembersQueryVariables = Exact<{
  filter?: InputMaybe<ChatsFilter>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetExpertChatMembersQuery = { __typename?: 'Query', chatMembers?: { __typename?: 'ChatMemberTypeConnection', edges: Array<{ __typename?: 'ChatMemberTypeEdge', node?: { __typename?: 'ChatMemberType', id: string, chat: { __typename?: 'ChatType', id: string, type: ApiChatTypeChoices, status: ApiChatStatusChoices, summary?: string | null, summaryStatus: ApiChatSummaryStatusChoices, clinicianSummary?: string | null, clinicianSummaryStatus: ApiChatClinicianSummaryStatusChoices, createdDate: any, lastUpdatedDate: any, needsReview?: boolean | null, isUnread?: boolean | null, history: any, careStage?: ApiChatCareStageChoices | null, messageDraft?: string | null, lastMessage?: { __typename?: 'ChatMessageType', id: string, createdDate: any, content?: string | null, readAt?: any | null, role: ApiChatMessageRoleChoices, file?: { __typename?: 'LearnerFileType', id: string } | null, user?: { __typename?: 'UserType', id: string, auth0id?: string | null, username: string } | null } | null, learner: { __typename?: 'LearnerType', id: string, learnermetadata?: { __typename?: 'LearnerMetadataType', firstName: string, lastName: string, birthDate?: any | null, city?: string | null, state?: string | null } | null, relationshipSet: { __typename?: 'RelationshipTypeConnection', edges: Array<{ __typename?: 'RelationshipTypeEdge', node?: { __typename?: 'RelationshipType', id: string, relationship: ApiRelationshipRelationshipChoices, socialRelationship?: string | null, isPrimary: boolean, caregiver: { __typename?: 'CaregiverType', id: string, auth0User?: { __typename?: 'UserType', auth0id?: string | null } | null, caregivermetadata?: { __typename?: 'CaregiverMetadataType', firstName: string, lastName: string, email?: string | null, city?: string | null, state?: string | null, careStage?: ApiCaregiverMetadataCareStageChoices | null } | null }, organization: { __typename?: 'OrganizationType', id: string } } | null } | null> } }, members: { __typename?: 'ChatMemberTypeConnection', edges: Array<{ __typename?: 'ChatMemberTypeEdge', node?: { __typename?: 'ChatMemberType', member: { __typename?: 'UserType', id: string, auth0id?: string | null, provider?: { __typename?: 'ProviderType', id: string, providermetadata?: { __typename?: 'ProviderMetadataType', firstName: string, lastName?: string | null } | null } | null }, memberOrg: { __typename?: 'OrganizationType', id: string } } | null } | null> } } } | null } | null>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } | null };

export type GetClinicLeadsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  filter: ClinicLeadFilter;
}>;


export type GetClinicLeadsQuery = { __typename?: 'Query', clinicLeads?: { __typename?: 'ClinicLeadTypeConnection', totalCount?: number | null, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean }, edges: Array<{ __typename?: 'ClinicLeadTypeEdge', cursor: string, node?: { __typename?: 'ClinicLeadType', id: string, createdDate: any, requestedServiceTypes: Array<string>, requestedModalityTypes: Array<string>, payor?: ApiClinicLeadPayorChoices | null, learner: { __typename?: 'LearnerType', id: string, learnermetadata?: { __typename?: 'LearnerMetadataType', id: string, firstName: string, lastName: string, birthDate?: any | null } | null }, caregiver?: { __typename?: 'CaregiverType', caregivermetadata?: { __typename?: 'CaregiverMetadataType', firstName: string, lastName: string, city?: string | null, state?: string | null, zip?: string | null, phoneNumber1?: string | null, email?: string | null } | null } | null } | null } | null> } | null };

export type ClinicListingsQueryVariables = Exact<{
  filter: ClinicListingSearchFilter;
}>;


export type ClinicListingsQuery = { __typename?: 'Query', clinicListings?: { __typename?: 'ClinicListingTypeConnection', totalCount?: number | null, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean }, edges: Array<{ __typename?: 'ClinicListingTypeEdge', cursor: string, node?: { __typename?: 'ClinicListingType', id: string, name: string, createdDate: any, payors: Array<string>, location?: { __typename?: 'LocationType', addressLine1?: string | null, addressLine2?: string | null, city: string, state: string, postalCode: string } | null } | null } | null> } | null };

export type GetClinicsQueryVariables = Exact<{
  clinicId?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetClinicsQuery = { __typename?: 'Query', clinics?: { __typename?: 'ClinicTypeConnection', totalCount?: number | null, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean }, edges: Array<{ __typename?: 'ClinicTypeEdge', cursor: string, node?: { __typename?: 'ClinicType', id: string, name: string, createdDate: any, location?: { __typename?: 'LocationType', addressLine1?: string | null, addressLine2?: string | null, city: string, state: string, postalCode: string } | null, cliniclistingSet: { __typename?: 'ClinicListingTypeConnection', edges: Array<{ __typename?: 'ClinicListingTypeEdge', node?: { __typename?: 'ClinicListingType', id: string, publicId: any, websiteUrl?: string | null, verificationStatus?: ApiClinicListingVerificationStatusChoices | null, phoneNumber?: string | null, contactEmail?: string | null, description?: string | null, modalityTypes: Array<string>, payors: Array<string>, servicesOffered: Array<string>, createdDate: any, lastUpdatedDate: any } | null } | null> } } | null } | null> } | null };

export type DownloadableTemplatesQueryVariables = Exact<{ [key: string]: never; }>;


export type DownloadableTemplatesQuery = { __typename?: 'Query', downloadableTemplates: Array<{ __typename?: 'DownloadableTemplatesType', key?: string | null, assessment: string, name: string, officialFileLink: string, fronteraFileLink: string }> };

export type CrLearningTreeQueryVariables = Exact<{
  learnerId: Scalars['ID']['input'];
  reportId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type CrLearningTreeQuery = { __typename?: 'Query', crLearningTree?: { __typename?: 'CRLearningTreeType', learningTreeId?: string | null, status?: string | null, nodes: Array<{ __typename?: 'CRLearningTreeNodeType', externalId: string, parentExternalId?: string | null, name?: string | null, nodeType?: string | null, dataType?: string | null, dataTypeLabel?: string | null, progressType?: string | null, hasGoal?: boolean | null, isBehavior?: boolean | null, crStatus?: string | null, crLevel?: string | null, sortOrder?: number | null, removed: boolean, suggestedRole?: string | null, ruleRole?: string | null, approvedIn: Array<string>, goalApprovedIn: Array<string>, usedIn: Array<string>, role?: string | null, roleSource?: string | null, confirmKind?: string | null, confirmAnswered: boolean, locked: boolean, status?: string | null, movedInCr: boolean, goalExternalId?: string | null }>, checks: Array<{ __typename?: 'CRLearningTreeCheckType', externalId: string, level: string, code: string, message: string }>, importedNotInTree: Array<{ __typename?: 'CRLearningTreeImportedItemType', externalId: string, name?: string | null, role: string }>, reportChanges: Array<{ __typename?: 'CRLearningTreeReportImpactType', reportId: string, label: string, changes: Array<{ __typename?: 'CRLearningTreeReportChangeType', externalId: string, kind: string, name?: string | null, fromGoalName?: string | null, toGoalName?: string | null, approved: boolean }> }> } | null };

export type EhrConnectionQueryVariables = Exact<{ [key: string]: never; }>;


export type EhrConnectionQuery = { __typename?: 'Query', ehrConnection?: { __typename?: 'EHRConnection', status?: EhrConnectionStatus | null } | null };

export type GetEhrClientImportStatusQueryVariables = Exact<{
  learnerExternalId: Scalars['String']['input'];
}>;


export type GetEhrClientImportStatusQuery = { __typename?: 'Query', getEhrClientImportStatus?: { __typename?: 'EHRScraperLearnerImportStatusResponse', status?: boolean | null, message?: string | null, leanerImportStatus?: { __typename?: 'LearnerImportStatusType', status: ApiScraperLearnerImportStatusStatusChoices } | null } | null };

export type GetEhrLoginStatusQueryVariables = Exact<{ [key: string]: never; }>;


export type GetEhrLoginStatusQuery = { __typename?: 'Query', getLoginStatus?: { __typename?: 'EHRScraperLoginStatusType', status?: boolean | null, message?: string | null, getLoginStatus?: { __typename?: 'ScraperLoginType', id: string, status: ApiScraperLoginStatusChoices, alert?: string | null, loginAttemptsExhausted?: boolean | null, provider: { __typename?: 'ProviderType', id: string }, organization: { __typename?: 'OrganizationType', id: string }, scraperSessionWorkflow: { __typename?: 'ScraperWorkflowType', id: string, workflowTemporalId: string } } | null } | null };

export type GetHasEhrCredentialsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetHasEhrCredentialsQuery = { __typename?: 'Query', hasEhrCredentials?: { __typename?: 'EhrCredentialsExistType', hasCredentials?: boolean | null } | null };

export type EhrStoredFieldPartsFragment = { __typename?: 'EhrStoredField', key: string, value?: string | null };

export type EhrChildCollectionPartsFragment = { __typename?: 'EhrChildCollection', key: string, label: string, rows: Array<{ __typename?: 'EhrStoredRow', fields: Array<{ __typename?: 'EhrStoredField', key: string, value?: string | null }> }> };

export type EhrSessionDataSummaryPartsFragment = { __typename?: 'EhrSessionDataSummary', dataPointCount: number, sessionCount: number, firstDate?: string | null, lastDate?: string | null };

export type LearnerEhrProgrammingQueryVariables = Exact<{
  learnerId: Scalars['ID']['input'];
}>;


export type LearnerEhrProgrammingQuery = { __typename?: 'Query', learnerEhrProgramming?: { __typename?: 'LearnerEhrProgramming', organizationType: string, goals: Array<{ __typename?: 'EhrProgrammingGoal', id: string, name?: string | null, externalId?: string | null, createdDate?: string | null, lastUpdatedDate?: string | null, fields: Array<{ __typename?: 'EhrStoredField', key: string, value?: string | null }>, collections: Array<{ __typename?: 'EhrChildCollection', key: string, label: string, rows: Array<{ __typename?: 'EhrStoredRow', fields: Array<{ __typename?: 'EhrStoredField', key: string, value?: string | null }> }> }>, sessionSummary: { __typename?: 'EhrSessionDataSummary', dataPointCount: number, sessionCount: number, firstDate?: string | null, lastDate?: string | null }, targets: Array<{ __typename?: 'EhrProgrammingTarget', id: string, name?: string | null, externalId?: string | null, createdDate?: string | null, lastUpdatedDate?: string | null, fields: Array<{ __typename?: 'EhrStoredField', key: string, value?: string | null }>, collections: Array<{ __typename?: 'EhrChildCollection', key: string, label: string, rows: Array<{ __typename?: 'EhrStoredRow', fields: Array<{ __typename?: 'EhrStoredField', key: string, value?: string | null }> }> }>, sessionSummary: { __typename?: 'EhrSessionDataSummary', dataPointCount: number, sessionCount: number, firstDate?: string | null, lastDate?: string | null } }> }>, unmatchedSessionSummary: { __typename?: 'EhrSessionDataSummary', dataPointCount: number, sessionCount: number, firstDate?: string | null, lastDate?: string | null } } | null };

export type LearnerEhrSessionDataQueryVariables = Exact<{
  learnerId: Scalars['ID']['input'];
  targetId?: InputMaybe<Scalars['ID']['input']>;
  goalId?: InputMaybe<Scalars['ID']['input']>;
  unmatched?: InputMaybe<Scalars['Boolean']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type LearnerEhrSessionDataQuery = { __typename?: 'Query', learnerEhrSessionData?: { __typename?: 'EhrSessionDataPage', totalCount: number, rows: Array<{ __typename?: 'EhrSessionDataRow', id: string, targetId?: string | null, goalId?: string | null, fields: Array<{ __typename?: 'EhrStoredField', key: string, value?: string | null }>, session?: { __typename?: 'EhrSessionRecord', id: string, fields: Array<{ __typename?: 'EhrStoredField', key: string, value?: string | null }> } | null }> } | null };

export type LearnerEhrSyncsQueryVariables = Exact<{
  learnerId: Scalars['ID']['input'];
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type LearnerEhrSyncsQuery = { __typename?: 'Query', learnerEhrSyncs?: { __typename?: 'EhrSyncRunPage', totalCount: number, rows: Array<{ __typename?: 'EhrSyncRun', id: string, ehrName: string, runFolder: string, temporalWorkflowId?: string | null, startedAt: string }> } | null };

export type EhrActionRequestQueryVariables = Exact<{
  requestId: Scalars['Int']['input'];
}>;


export type EhrActionRequestQuery = { __typename?: 'Query', ehrActionRequest?: { __typename?: 'EhrActionRequestType', id: number, actionType: string, status: string, error?: string | null, learnerId?: number | null, reportId?: number | null, createdDate?: any | null, startedAt?: any | null, finishedAt?: any | null } | null };

export type CareAppointmentsByResourceEmailQueryVariables = Exact<{
  email: Scalars['String']['input'];
  startDate?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['String']['input']>;
}>;


export type CareAppointmentsByResourceEmailQuery = { __typename?: 'Query', careAppointmentsByResourceEmail?: Array<{ __typename?: 'CareAppointmentType', id: string, startTime: string, endTime: string, status: string, serviceId: string, serviceName?: string | null, locationId?: string | null, locationName?: string | null, resourceId?: string | null, resourceName?: string | null, resourceEmail?: string | null, customerFirstName?: string | null, customerLastName?: string | null, customerEmail?: string | null, notes?: string | null, appointmentMeetingLink?: string | null } | null> | null };

export type CareResourceByEmailQueryVariables = Exact<{
  email: Scalars['String']['input'];
}>;


export type CareResourceByEmailQuery = { __typename?: 'Query', careResourceByEmail?: { __typename?: 'CareResourceType', id: string, name: string, email: string, availabilityType?: AvailabilityTypeEnum | null, about?: string | null, timezone?: string | null, imageUrl?: string | null, phone?: string | null, bookingLimit?: number | null, bookingsPerSlot?: number | null, services?: Array<{ __typename?: 'CareServiceType', id: string, name: string, durationMinutes: number, description?: string | null, priceDollars?: number | null, isActive: boolean, paddingMinutes?: number | null } | null> | null, locations?: Array<{ __typename?: 'CareLocationType', id: string, name: string, address?: string | null } | null> | null } | null };

export type CareResourceSingleAllocationBlocksQueryVariables = Exact<{
  resourceEmail: Scalars['String']['input'];
  startDate: Scalars['String']['input'];
  endDate: Scalars['String']['input'];
}>;


export type CareResourceSingleAllocationBlocksQuery = { __typename?: 'Query', careResourceSingleAllocationBlocks?: Array<{ __typename?: 'CareResourceSingleAllocationBlockType', id: string, resourceId: string, startTime: string, endTime: string, repeats: boolean, resourceEmail?: string | null, deleted: boolean } | null> | null };

export type CareResourceWeeklyAllocationBlocksQueryVariables = Exact<{
  resourceEmail: Scalars['String']['input'];
  startDate: Scalars['String']['input'];
  endDate: Scalars['String']['input'];
}>;


export type CareResourceWeeklyAllocationBlocksQuery = { __typename?: 'Query', careResourceWeeklyAllocationBlocks?: Array<{ __typename?: 'CareResourceWeeklyAllocationBlockType', id: string, resourceId: string, startDate: string, endDate: string, resourceEmail?: string | null, deleted: boolean, sunday?: { __typename?: 'DayScheduleType', startTime: string, endTime: string } | null, monday?: { __typename?: 'DayScheduleType', startTime: string, endTime: string } | null, tuesday?: { __typename?: 'DayScheduleType', startTime: string, endTime: string } | null, wednesday?: { __typename?: 'DayScheduleType', startTime: string, endTime: string } | null, thursday?: { __typename?: 'DayScheduleType', startTime: string, endTime: string } | null, friday?: { __typename?: 'DayScheduleType', startTime: string, endTime: string } | null, saturday?: { __typename?: 'DayScheduleType', startTime: string, endTime: string } | null } | null> | null };

export type GetProvidersForAssigningToLearnerQueryVariables = Exact<{ [key: string]: never; }>;


export type GetProvidersForAssigningToLearnerQuery = { __typename?: 'Query', getProvidersForAssigningToLearner?: { __typename?: 'ProviderTypeConnection', edges: Array<{ __typename?: 'ProviderTypeEdge', node?: { __typename?: 'ProviderType', id: string, archived?: boolean | null, rolesNameOnly?: Array<string | null> | null, providermetadata?: { __typename?: 'ProviderMetadataType', firstName: string, lastName?: string | null, email?: string | null } | null } | null } | null> } | null };

export type GetCurriculumsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCurriculumsQuery = { __typename?: 'Query', getCurricula?: Array<{ __typename?: 'CurriculumType', id: string, name: string }> | null };

export type GoalBankFoldersQueryVariables = Exact<{
  searchTerm?: InputMaybe<Scalars['String']['input']>;
}>;


export type GoalBankFoldersQuery = { __typename?: 'Query', getGoalBankFolders?: { __typename?: 'CustomGoalBankFoldersType', userFolders?: Array<{ __typename?: 'GoalBankFolderType', id: string, name: string, folderType: ApiGoalBankFolderFolderTypeChoices, goalsCount?: number | null, targetsCount?: number | null } | null> | null, organizationFolders?: Array<{ __typename?: 'GoalBankFolderType', id: string, name: string, folderType: ApiGoalBankFolderFolderTypeChoices, goalsCount?: number | null, targetsCount?: number | null, curriculum?: { __typename?: 'CurriculumType', id: string, name: string } | null } | null> | null } | null };

export type GoalBankGoalsQueryVariables = Exact<{
  folderId: Scalars['ID']['input'];
  searchTerm?: InputMaybe<Scalars['String']['input']>;
}>;


export type GoalBankGoalsQuery = { __typename?: 'Query', getGoalBankGoals?: { __typename?: 'ReportGoalBankTypeConnection', edges: Array<{ __typename?: 'ReportGoalBankTypeEdge', node?: { __typename?: 'ReportGoalBankType', id: string, goalName: string, description?: string | null, medicalRationale?: string | null, programGoal?: string | null, masteryCriteria?: string | null, timelineEstimationType?: ApiReportGoalBankTimelineEstimationTypeChoices | null, timelineEstimationValue?: number | null, hasMedicalNecessity: boolean, medicalNecessityCriteria?: string | null, assessmentToolSource?: string | null, domain?: { __typename?: 'DomainType', id: string, name: string } | null } | null } | null> } | null };

export type GoalBankTargetsQueryVariables = Exact<{
  folderId: Scalars['ID']['input'];
  goalBankId?: InputMaybe<Scalars['ID']['input']>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
}>;


export type GoalBankTargetsQuery = { __typename?: 'Query', getGoalBankTargets?: { __typename?: 'ReportTargetGoalBankTypeConnection', edges: Array<{ __typename?: 'ReportTargetGoalBankTypeEdge', node?: { __typename?: 'ReportTargetGoalBankType', id: string, targetName: string, targetDescription?: string | null, medicalRationale?: string | null, masteryCriteria?: string | null, timelineEstimationType?: ApiReportTargetGoalBankTimelineEstimationTypeChoices | null, timelineEstimationValue?: number | null, goalBank?: { __typename?: 'ReportGoalBankType', id: string, goalName: string } | null } | null } | null> } | null };

export type OrgHasGoalBankEmbeddingsQueryVariables = Exact<{ [key: string]: never; }>;


export type OrgHasGoalBankEmbeddingsQuery = { __typename?: 'Query', orgHasGoalBankEmbeddings?: boolean | null };

export type ReassessmentShortTermGoalPanelQueryVariables = Exact<{
  reportGoalId: Scalars['ID']['input'];
}>;


export type ReassessmentShortTermGoalPanelQuery = { __typename?: 'Query', getReportGoal?: { __typename?: 'ReportGoalType', id: string, aiBaselineDataPredictionStatus: ApiReportGoalAiBaselineDataPredictionStatusChoices, aiGoalAttainmentScalePredictionStatus: ApiReportGoalAiGoalAttainmentScalePredictionStatusChoices, aiProgressSummaryPredictionStatus: ApiReportGoalAiProgressSummaryPredictionStatusChoices, assessmentToolSource?: string | null, baselineData?: string | null, baselineDate?: any | null, chartType?: ApiReportGoalChartTypeChoices | null, chartFromDate?: any | null, chartToDate?: any | null, completionDate?: any | null, description?: string | null, projectedIntroductionDate?: any | null, gasLevel1?: string | null, gasLevel3?: string | null, gasLevel4?: string | null, gasMatchMessage?: string | null, gasMatchStatus: ApiReportGoalGasMatchStatusChoices, gasScore?: string | null, generalizationCriteria?: string | null, goalName: string, goalSubType?: string | null, goalType?: string | null, hasMedicalNecessity: boolean, masteryCriteria?: string | null, medicalNecessityCriteria?: string | null, progressSummary?: string | null, rationale?: string | null, signedChartImageUrl?: string | null, status?: ApiReportGoalStatusChoices | null, summaryReviewed: boolean, summaryReviewedOn?: any | null, tags?: any | null, lastUpdatedDate: any, createdDate: any, goalBank?: { __typename?: 'ReportGoalBankType', id: string } | null, customFields: { __typename?: 'TreatmentPlanCustomFieldTypeConnection', edges: Array<{ __typename?: 'TreatmentPlanCustomFieldTypeEdge', node?: { __typename?: 'TreatmentPlanCustomFieldType', id: string, fieldIdentifier: string, fieldType: ApiTreatmentPlanCustomFieldFieldTypeChoices, title?: string | null, content?: string | null, rankOrder: number, imageSignedUrl?: string | null } | null } | null> } } | null };

export type ReportGoalPanelSingleViewQueryVariables = Exact<{
  reportGoalId: Scalars['ID']['input'];
}>;


export type ReportGoalPanelSingleViewQuery = { __typename?: 'Query', getReportGoal?: { __typename?: 'ReportGoalType', id: string, createdDate: any, lastUpdatedDate: any, assessmentToolSource?: string | null, baselineDate?: any | null, completionDate?: any | null, projectedIntroductionDate?: any | null, goalName: string, programGoal?: string | null, description?: string | null, timelineEstimationType?: ApiReportGoalTimelineEstimationTypeChoices | null, timelineEstimationValue?: number | null, baselineData?: string | null, masteryCriteria?: string | null, hasMedicalNecessity: boolean, medicalNecessityCriteria?: string | null, generalizationCriteria?: string | null, aiGoalAttainmentScalePredictionStatus: ApiReportGoalAiGoalAttainmentScalePredictionStatusChoices, gasLevel1?: string | null, gasLevel3?: string | null, gasLevel4?: string | null, gasScore?: string | null, rationale?: string | null, status?: ApiReportGoalStatusChoices | null, goalType?: string | null, tags?: any | null, progressSummary?: string | null, aiGenerated: boolean, inUse: boolean, reportDomain?: { __typename?: 'ReportDomainType', id: string, name: string } | null, customFields: { __typename?: 'TreatmentPlanCustomFieldTypeConnection', edges: Array<{ __typename?: 'TreatmentPlanCustomFieldTypeEdge', node?: { __typename?: 'TreatmentPlanCustomFieldType', id: string, fieldIdentifier: string, fieldType: ApiTreatmentPlanCustomFieldFieldTypeChoices, title?: string | null, content?: string | null, rankOrder: number, imageSignedUrl?: string | null } | null } | null> } } | null };

export type ReportTargetPanelSingleViewQueryVariables = Exact<{
  filter: GetTargetsFilter;
}>;


export type ReportTargetPanelSingleViewQuery = { __typename?: 'Query', getReportTargets?: { __typename?: 'ReportTargetTypeConnection', edges: Array<{ __typename?: 'ReportTargetTypeEdge', node?: { __typename?: 'ReportTargetType', id: string, aiGenerated: boolean, inUse: boolean, createdDate: any, lastUpdatedDate: any, targetName: string, targetDescription?: string | null, timelineEstimationValue?: number | null, timelineEstimationType?: ApiReportTargetTimelineEstimationTypeChoices | null, masteryCriteria?: string | null, baselineData?: string | null, status?: ApiReportTargetStatusChoices | null, progressSummary?: string | null, completionDate?: any | null, summaryReviewed: boolean, summaryReviewedOn?: any | null, excludeFromReport: boolean, signedChartImageUrl?: string | null, aiProgressSummaryPredictionStatus: ApiReportTargetAiProgressSummaryPredictionStatusChoices, projectedIntroductionDate?: any | null, customFields: { __typename?: 'TreatmentPlanCustomFieldTypeConnection', edges: Array<{ __typename?: 'TreatmentPlanCustomFieldTypeEdge', node?: { __typename?: 'TreatmentPlanCustomFieldType', id: string, fieldIdentifier: string, fieldType: ApiTreatmentPlanCustomFieldFieldTypeChoices, title?: string | null, content?: string | null, rankOrder: number, imageSignedUrl?: string | null } | null } | null> } } | null } | null> } | null };

export type GetReportDomainsQueryVariables = Exact<{
  reportId: Scalars['ID']['input'];
}>;


export type GetReportDomainsQuery = { __typename?: 'Query', getReportDomains?: Array<{ __typename?: 'ReportDomainType', id: string, name: string, description?: string | null, rankOrder: number }> | null };

export type GetReportGoalBaselineStatusQueryVariables = Exact<{
  reportGoalId: Scalars['ID']['input'];
}>;


export type GetReportGoalBaselineStatusQuery = { __typename?: 'Query', getReportGoal?: { __typename?: 'ReportGoalType', aiBaselineDataPredictionStatus: ApiReportGoalAiBaselineDataPredictionStatusChoices, baselineData?: string | null } | null };

export type GetReportGoalSummaryStatusQueryVariables = Exact<{
  reportGoalId: Scalars['ID']['input'];
}>;


export type GetReportGoalSummaryStatusQuery = { __typename?: 'Query', getReportGoal?: { __typename?: 'ReportGoalType', aiProgressSummaryPredictionStatus: ApiReportGoalAiProgressSummaryPredictionStatusChoices, progressSummary?: string | null } | null };

export type GetTargetSummaryStatusQueryVariables = Exact<{
  filter: GetTargetsFilter;
}>;


export type GetTargetSummaryStatusQuery = { __typename?: 'Query', getReportTargets?: { __typename?: 'ReportTargetTypeConnection', edges: Array<{ __typename?: 'ReportTargetTypeEdge', node?: { __typename?: 'ReportTargetType', aiProgressSummaryPredictionStatus: ApiReportTargetAiProgressSummaryPredictionStatusChoices, progressSummary?: string | null } | null } | null> } | null };

export type LearnerAdditionalDetailsQueryVariables = Exact<{
  learnerId: Scalars['ID']['input'];
}>;


export type LearnerAdditionalDetailsQuery = { __typename?: 'Query', learnerById?: { __typename?: 'LearnerType', learnerAdditionalDetails?: { __typename?: 'LearnerAdditionalDetailsType', anythingThatCameUpToBeMentioned?: string | null, anythingThatWeDidNotCoverEnough?: string | null, mainConcerns?: string | null, whoReferredYou?: string | null, mchatResultForClient?: string | null } | null } | null };

export type LearnerAllIntakeDataQueryVariables = Exact<{
  learnerId: Scalars['ID']['input'];
}>;


export type LearnerAllIntakeDataQuery = { __typename?: 'Query', learnerById?: { __typename?: 'LearnerType', formStatusForLearner: { __typename?: 'OnboardingFormStatusTypeConnection', edges: Array<{ __typename?: 'OnboardingFormStatusTypeEdge', node?: { __typename?: 'OnboardingFormStatusType', formName: string, status: ApiOnboardingFormStatusStatusChoices } | null } | null> }, learnermetadata?: { __typename?: 'LearnerMetadataType', firstName: string, lastName: string, preferredName?: string | null, birthDate?: any | null, gender?: ApiLearnerMetadataGenderChoices | null, specifyGender?: string | null, preferredLanguage: string, address?: string | null, addressLine2?: string | null, city?: string | null, state?: string | null, zip?: string | null } | null, relationshipSet: { __typename?: 'RelationshipTypeConnection', edges: Array<{ __typename?: 'RelationshipTypeEdge', node?: { __typename?: 'RelationshipType', socialRelationship?: string | null, caregiver: { __typename?: 'CaregiverType', caregivermetadata?: { __typename?: 'CaregiverMetadataType', firstName: string, lastName: string, email?: string | null, phoneNumber1?: string | null, phoneNumber2?: string | null, preferredLanguage: string, requiresInterpreter?: boolean | null, birthDate?: any | null, gender?: ApiCaregiverMetadataGenderChoices | null, specifyGender?: string | null, maritalStatus?: ApiCaregiverMetadataMaritalStatusChoices | null, addressLine1?: string | null, addressLine2?: string | null, city?: string | null, state?: string | null, zip?: string | null, occupation?: string | null, employer?: string | null, abaClientGoalsForGuardian?: string | null } | null } } | null } | null> }, insuranceForLearner: { __typename?: 'InsuranceDetailsTypeConnection', edges: Array<{ __typename?: 'InsuranceDetailsTypeEdge', node?: { __typename?: 'InsuranceDetailsType', insuranceType: ApiInsuranceDetailsInsuranceTypeChoices, insurer: ApiInsuranceDetailsInsurerChoices, idNumber?: string | null, groupName?: string | null, isPrimaryInsurance: boolean, claimsAddress?: string | null, claimsAddressLine2?: string | null, city?: string | null, state?: string | null, zip?: string | null, phoneNumber?: string | null, insurancePolicyHolder?: string | null, policyHolderBirthDate?: any | null, signedUrlOfCardFront?: string | null, signedUrlOfCardBack?: string | null } | null } | null> }, learnerindividualsthatliveinhomeSet: { __typename?: 'LearnerIndividualsThatLiveInHomeTypeConnection', edges: Array<{ __typename?: 'LearnerIndividualsThatLiveInHomeTypeEdge', node?: { __typename?: 'LearnerIndividualsThatLiveInHomeType', name: string, age: string, relationshipToClient: string } | null } | null> }, learnerlivingconditions?: { __typename?: 'LearnerLivingConditionsType', delaysOrDiagnosesInClientSiblings?: string | null, clientInFosterCare: boolean, cyfdCaseManagerName?: string | null, cyfdCaseManagerPhone?: string | null, clientLivesBetweenParentsAndGrandparents: boolean, clientHouseholdParentCount: ApiLearnerLivingConditionsClientHouseholdParentCountChoices, clientTimeSpentWithOtherParent?: string | null } | null, medicationsForLearner: { __typename?: 'LearnerMedicationsTypeConnection', edges: Array<{ __typename?: 'LearnerMedicationsTypeEdge', node?: { __typename?: 'LearnerMedicationsType', name: string, dosage: string, prescriber: string } | null } | null> }, learnermedicalhistorymetadata?: { __typename?: 'LearnerMedicalHistoryMetaDataType', clientHasBeenHospitalized: boolean, clientHospitalizedDetails?: string | null, clientHasCurrentCounselor: boolean, clientCurrentCounselorName?: string | null, clientCurrentCounselorPhone?: string | null, clientThoughtsForParticipatingCounseling?: string | null, clientHasMedicalDiagnoses: boolean, clientMedicalDiagnosesDetails?: string | null, sideEffectsOfEmotionalBehaviourMedication?: string | null, allergiesOrDietaryRestrictions?: string | null, familyHistoryOfDiagnoses?: string | null, hospitalizationsOrSurgeries?: string | null, clientOverallHealth?: string | null, clientOtherHealthConcerns?: string | null, clientGiDifficulties: boolean } | null, medicalHistoryForLearner?: { __typename?: 'LearnerPrimaryProviderType', primaryCareProvider: string, address: string, addressLine2?: string | null, city: string, state: string, zip: string } | null, learnerAdditionalDetails?: { __typename?: 'LearnerAdditionalDetailsType', anythingThatCameUpToBeMentioned?: string | null, anythingThatWeDidNotCoverEnough?: string | null, mainConcerns?: string | null, whoReferredYou?: string | null, mchatResultForClient?: string | null } | null, onboardingQuestionsForLearner: { __typename?: 'LearnerOnboardingQuestionsTypeConnection', edges: Array<{ __typename?: 'LearnerOnboardingQuestionsTypeEdge', node?: { __typename?: 'LearnerOnboardingQuestionsType', questionKey: string, answer: string, questionPageOrigin: string } | null } | null> }, learnerbirthhistory?: { __typename?: 'LearnerBirthHistoryType', pregnancyDeliveryConcerns: string, birthWeightInPounds: string, birthWeightInOunces: string, clientLikeAsBaby?: string | null, babyTemperament?: string | null, separatedFromParentFirst24Months: boolean, separatedFromParentFirst24MonthsExplanation?: string | null, normalFullTermPregnancy: boolean, pregnancyComplications: boolean, prematureBirth: boolean, cesareanBirth: boolean, difficultLaborDelivery: boolean, overdueBirth: boolean, breathingDifficulty: boolean, suckingDifficulty: boolean, touchResponseDifficulty: boolean, pregnancyInfections: boolean, pregnancyPreEclampsia: boolean, pregnancyHypertension: boolean, pregnancyFevers: boolean, gestationalDiabetes: boolean, otherPregnancyIllnesses: string, prescriptionDrugsUsed: boolean, prescriptionList?: string | null, alcoholUsed: boolean, recreationalDrugsUsed: boolean, tobaccoUsed: boolean, hospitalizedForHealthConcernsAtBirth: boolean, hospitalizedForHealthConcernsAtBirthExplanatiion?: string | null } | null, learnerEarlyInterventionServices?: { __typename?: 'LearnerEarlyInterventionServicesType', clientEarlyInterventionEnrollment: boolean, earlyInterventionStartAge?: string | null, dismissedOrTransferredToPreschool?: string | null, specialEducationOrOutsideServices?: string | null } | null, learnerTheraputicServicesInSchool: { __typename?: 'LearnerTheraputicServicesInSchoolTypeConnection', edges: Array<{ __typename?: 'LearnerTheraputicServicesInSchoolTypeEdge', node?: { __typename?: 'LearnerTheraputicServicesInSchoolType', service?: string | null, serviceHours?: string | null } | null } | null> }, learnerOtherServicesHistory: { __typename?: 'LearnerOtherServicesHistoryTypeConnection', edges: Array<{ __typename?: 'LearnerOtherServicesHistoryTypeEdge', node?: { __typename?: 'LearnerOtherServicesHistoryType', service?: string | null, serviceHours?: string | null, serviceStartDate?: string | null, serviceEndDate?: string | null, serviceProviderName?: string | null } | null } | null> }, learnerEducation?: { __typename?: 'LearnerEducationType', nameOfSchool: string, grade: string, educationSetting: string, specialEducation: boolean, learnerEducationMetaData?: { __typename?: 'LearnerEducationMetaDataType', currentGrades: string, academicStrengthsAndWeaknesses: string, schoolBehaviorProblems: string } | null } | null, learneremergencycontact?: { __typename?: 'LearnerEmergencyContactType', firstName: string, lastName: string, phoneNumber?: string | null, relationshipToClient: string } | null } | null };

export type LearnerBehaviorsQueryVariables = Exact<{
  learnerId: Scalars['ID']['input'];
  questionPageOrigin?: InputMaybe<Scalars['String']['input']>;
}>;


export type LearnerBehaviorsQuery = { __typename?: 'Query', learnerById?: { __typename?: 'LearnerType', onboardingQuestionsForLearner: { __typename?: 'LearnerOnboardingQuestionsTypeConnection', edges: Array<{ __typename?: 'LearnerOnboardingQuestionsTypeEdge', node?: { __typename?: 'LearnerOnboardingQuestionsType', questionKey: string, answer: string, questionPageOrigin: string } | null } | null> } } | null };

export type LearnerBirthHistoryQueryVariables = Exact<{
  learnerId: Scalars['ID']['input'];
}>;


export type LearnerBirthHistoryQuery = { __typename?: 'Query', learnerById?: { __typename?: 'LearnerType', learnerbirthhistory?: { __typename?: 'LearnerBirthHistoryType', pregnancyDeliveryConcerns: string, birthWeightInPounds: string, birthWeightInOunces: string, clientLikeAsBaby?: string | null, babyTemperament?: string | null, separatedFromParentFirst24Months: boolean, separatedFromParentFirst24MonthsExplanation?: string | null, normalFullTermPregnancy: boolean, pregnancyComplications: boolean, prematureBirth: boolean, cesareanBirth: boolean, difficultLaborDelivery: boolean, overdueBirth: boolean, breathingDifficulty: boolean, suckingDifficulty: boolean, touchResponseDifficulty: boolean, pregnancyInfections: boolean, pregnancyPreEclampsia: boolean, pregnancyHypertension: boolean, pregnancyFevers: boolean, gestationalDiabetes: boolean, otherPregnancyIllnesses: string, prescriptionDrugsUsed: boolean, prescriptionList?: string | null, alcoholUsed: boolean, recreationalDrugsUsed: boolean, tobaccoUsed: boolean, hospitalizedForHealthConcernsAtBirth: boolean, hospitalizedForHealthConcernsAtBirthExplanatiion?: string | null } | null } | null };

export type LearnerCommunicationQueryVariables = Exact<{
  learnerId: Scalars['ID']['input'];
  questionPageOrigin?: InputMaybe<Scalars['String']['input']>;
}>;


export type LearnerCommunicationQuery = { __typename?: 'Query', learnerById?: { __typename?: 'LearnerType', onboardingQuestionsForLearner: { __typename?: 'LearnerOnboardingQuestionsTypeConnection', edges: Array<{ __typename?: 'LearnerOnboardingQuestionsTypeEdge', node?: { __typename?: 'LearnerOnboardingQuestionsType', id: string, questionKey: string, answer: string, questionPageOrigin: string } | null } | null> } } | null };

export type LearnerDevelopmentalMileStonesQueryVariables = Exact<{
  learnerId: Scalars['ID']['input'];
}>;


export type LearnerDevelopmentalMileStonesQuery = { __typename?: 'Query', learnerById?: { __typename?: 'LearnerType', onboardingQuestionsForLearner: { __typename?: 'LearnerOnboardingQuestionsTypeConnection', edges: Array<{ __typename?: 'LearnerOnboardingQuestionsTypeEdge', node?: { __typename?: 'LearnerOnboardingQuestionsType', questionKey: string, answer: string, questionPageOrigin: string } | null } | null> } } | null };

export type LearnerEarlyInterventionServicesQueryVariables = Exact<{
  learnerId: Scalars['ID']['input'];
}>;


export type LearnerEarlyInterventionServicesQuery = { __typename?: 'Query', learnerById?: { __typename?: 'LearnerType', learnerEarlyInterventionServices?: { __typename?: 'LearnerEarlyInterventionServicesType', clientEarlyInterventionEnrollment: boolean, earlyInterventionStartAge?: string | null, dismissedOrTransferredToPreschool?: string | null, specialEducationOrOutsideServices?: string | null } | null } | null };

export type LearnerEducationQueryVariables = Exact<{
  learnerId: Scalars['ID']['input'];
}>;


export type LearnerEducationQuery = { __typename?: 'Query', learnerById?: { __typename?: 'LearnerType', learnerTheraputicServicesInSchool: { __typename?: 'LearnerTheraputicServicesInSchoolTypeConnection', edges: Array<{ __typename?: 'LearnerTheraputicServicesInSchoolTypeEdge', node?: { __typename?: 'LearnerTheraputicServicesInSchoolType', service?: string | null, serviceHours?: string | null } | null } | null> }, learnerOtherServicesHistory: { __typename?: 'LearnerOtherServicesHistoryTypeConnection', edges: Array<{ __typename?: 'LearnerOtherServicesHistoryTypeEdge', node?: { __typename?: 'LearnerOtherServicesHistoryType', service?: string | null, serviceHours?: string | null, serviceStartDate?: string | null, serviceEndDate?: string | null, serviceProviderName?: string | null } | null } | null> }, learnerEducation?: { __typename?: 'LearnerEducationType', nameOfSchool: string, grade: string, educationSetting: string, specialEducation: boolean, learnerEducationMetaData?: { __typename?: 'LearnerEducationMetaDataType', currentGrades: string, academicStrengthsAndWeaknesses: string, schoolBehaviorProblems: string } | null } | null } | null };

export type LearnerEmergencyContactQueryVariables = Exact<{
  learnerId: Scalars['ID']['input'];
}>;


export type LearnerEmergencyContactQuery = { __typename?: 'Query', learnerById?: { __typename?: 'LearnerType', learneremergencycontact?: { __typename?: 'LearnerEmergencyContactType', firstName: string, lastName: string, phoneNumber?: string | null, relationshipToClient: string } | null } | null };

export type LearnerGeneralDetailsQueryVariables = Exact<{
  learnerId: Scalars['ID']['input'];
}>;


export type LearnerGeneralDetailsQuery = { __typename?: 'Query', learnerById?: { __typename?: 'LearnerType', learnermetadata?: { __typename?: 'LearnerMetadataType', firstName: string, lastName: string, preferredName?: string | null, birthDate?: any | null, gender?: ApiLearnerMetadataGenderChoices | null, specifyGender?: string | null, preferredLanguage: string, address?: string | null, addressLine2?: string | null, city?: string | null, state?: string | null, zip?: string | null } | null } | null };

export type LearnerGuardianDetailsQueryVariables = Exact<{
  learnerId: Scalars['ID']['input'];
}>;


export type LearnerGuardianDetailsQuery = { __typename?: 'Query', learnerById?: { __typename?: 'LearnerType', relationshipSet: { __typename?: 'RelationshipTypeConnection', edges: Array<{ __typename?: 'RelationshipTypeEdge', node?: { __typename?: 'RelationshipType', socialRelationship?: string | null, caregiver: { __typename?: 'CaregiverType', caregivermetadata?: { __typename?: 'CaregiverMetadataType', firstName: string, lastName: string, email?: string | null, phoneNumber1?: string | null, phoneNumber2?: string | null, preferredLanguage: string, requiresInterpreter?: boolean | null, birthDate?: any | null, gender?: ApiCaregiverMetadataGenderChoices | null, specifyGender?: string | null, maritalStatus?: ApiCaregiverMetadataMaritalStatusChoices | null, addressLine1?: string | null, addressLine2?: string | null, city?: string | null, state?: string | null, zip?: string | null, occupation?: string | null, employer?: string | null, abaClientGoalsForGuardian?: string | null } | null } } | null } | null> } } | null };

export type LearnerInsuranceQueryVariables = Exact<{
  learnerId: Scalars['ID']['input'];
}>;


export type LearnerInsuranceQuery = { __typename?: 'Query', learnerById?: { __typename?: 'LearnerType', insuranceForLearner: { __typename?: 'InsuranceDetailsTypeConnection', edges: Array<{ __typename?: 'InsuranceDetailsTypeEdge', node?: { __typename?: 'InsuranceDetailsType', insuranceType: ApiInsuranceDetailsInsuranceTypeChoices, insurer: ApiInsuranceDetailsInsurerChoices, idNumber?: string | null, groupName?: string | null, isPrimaryInsurance: boolean, claimsAddress?: string | null, claimsAddressLine2?: string | null, city?: string | null, state?: string | null, zip?: string | null, phoneNumber?: string | null, insurancePolicyHolder?: string | null, policyHolderBirthDate?: any | null, signedUrlOfCardFront?: string | null, signedUrlOfCardBack?: string | null } | null } | null> } } | null };

export type LearnerLivingConditionsQueryVariables = Exact<{
  learnerId: Scalars['ID']['input'];
}>;


export type LearnerLivingConditionsQuery = { __typename?: 'Query', learnerById?: { __typename?: 'LearnerType', learnerindividualsthatliveinhomeSet: { __typename?: 'LearnerIndividualsThatLiveInHomeTypeConnection', edges: Array<{ __typename?: 'LearnerIndividualsThatLiveInHomeTypeEdge', node?: { __typename?: 'LearnerIndividualsThatLiveInHomeType', name: string, age: string, relationshipToClient: string } | null } | null> }, learnerlivingconditions?: { __typename?: 'LearnerLivingConditionsType', delaysOrDiagnosesInClientSiblings?: string | null, clientInFosterCare: boolean, cyfdCaseManagerName?: string | null, cyfdCaseManagerPhone?: string | null, clientLivesBetweenParentsAndGrandparents: boolean, clientHouseholdParentCount: ApiLearnerLivingConditionsClientHouseholdParentCountChoices, clientTimeSpentWithOtherParent?: string | null } | null } | null };

export type LearnerMedicalHistoryQueryVariables = Exact<{
  learnerId: Scalars['ID']['input'];
}>;


export type LearnerMedicalHistoryQuery = { __typename?: 'Query', learnerById?: { __typename?: 'LearnerType', onboardingQuestionsForLearner: { __typename?: 'LearnerOnboardingQuestionsTypeConnection', edges: Array<{ __typename?: 'LearnerOnboardingQuestionsTypeEdge', node?: { __typename?: 'LearnerOnboardingQuestionsType', questionKey: string, answer: string, questionPageOrigin: string } | null } | null> }, medicationsForLearner: { __typename?: 'LearnerMedicationsTypeConnection', edges: Array<{ __typename?: 'LearnerMedicationsTypeEdge', node?: { __typename?: 'LearnerMedicationsType', name: string, dosage: string, prescriber: string } | null } | null> }, learnermedicalhistorymetadata?: { __typename?: 'LearnerMedicalHistoryMetaDataType', clientHasBeenHospitalized: boolean, clientHospitalizedDetails?: string | null, clientHasCurrentCounselor: boolean, clientCurrentCounselorName?: string | null, clientCurrentCounselorPhone?: string | null, clientThoughtsForParticipatingCounseling?: string | null, clientHasMedicalDiagnoses: boolean, clientMedicalDiagnosesDetails?: string | null, sideEffectsOfEmotionalBehaviourMedication?: string | null, allergiesOrDietaryRestrictions?: string | null, familyHistoryOfDiagnoses?: string | null, hospitalizationsOrSurgeries?: string | null, clientOverallHealth?: string | null, clientOtherHealthConcerns?: string | null, clientGiDifficulties: boolean } | null, medicalHistoryForLearner?: { __typename?: 'LearnerPrimaryProviderType', primaryCareProvider: string, address: string, addressLine2?: string | null, city: string, state: string, zip: string } | null } | null };

export type LearnerTendenciesQueryVariables = Exact<{
  learnerId: Scalars['ID']['input'];
  questionPageOrigin?: InputMaybe<Scalars['String']['input']>;
}>;


export type LearnerTendenciesQuery = { __typename?: 'Query', learnerById?: { __typename?: 'LearnerType', onboardingQuestionsForLearner: { __typename?: 'LearnerOnboardingQuestionsTypeConnection', edges: Array<{ __typename?: 'LearnerOnboardingQuestionsTypeEdge', node?: { __typename?: 'LearnerOnboardingQuestionsType', questionKey: string, answer: string, questionPageOrigin: string } | null } | null> } } | null };

export type GetLearnerFileForReviewQueryVariables = Exact<{
  fileId: Scalars['ID']['input'];
}>;


export type GetLearnerFileForReviewQuery = { __typename?: 'Query', learnerFileById?: { __typename?: 'LearnerFileType', id: string, fileKind: ApiLearnerFileFileKindChoices, status: ApiLearnerFileStatusChoices, signedS3LearnerFile?: string | null, parsedResult?: string | null, parsedResultScoped?: string | null, hasParsedResultSchema?: boolean | null, effectiveDate?: any | null, clinicianEditedAt?: any | null, respondent?: ApiLearnerFileRespondentChoices | null } | null };

export type GetLearnerFilePdfPreviewStatusQueryVariables = Exact<{
  fileId: Scalars['ID']['input'];
}>;


export type GetLearnerFilePdfPreviewStatusQuery = { __typename?: 'Query', learnerFileById?: { __typename?: 'LearnerFileType', id: string, pdfPreviewStatus?: ApiLearnerFilePdfPreviewStatusChoices | null, pdfPreviewSignedUrl?: string | null } | null };

export type GetLearnerFilesByLearnerQueryVariables = Exact<{
  learnerId: Scalars['ID']['input'];
  fileKind?: InputMaybe<Scalars['String']['input']>;
  isReportAttached?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetLearnerFilesByLearnerQuery = { __typename?: 'Query', getLearnerFilesByLearner?: { __typename?: 'LearnerFileTypeConnection', edges: Array<{ __typename?: 'LearnerFileTypeEdge', node?: { __typename?: 'LearnerFileType', id: string, originalFileName: string, fileKind: ApiLearnerFileFileKindChoices, status: ApiLearnerFileStatusChoices, mimeType: string, fileSize: any, signedS3LearnerFile?: string | null, pdfPreviewStatus?: ApiLearnerFilePdfPreviewStatusChoices | null, pdfPreviewSignedUrl?: string | null, effectiveDate?: any | null, clinicianEditedAt?: any | null, respondent?: ApiLearnerFileRespondentChoices | null, reports: { __typename?: 'ReportTypeConnection', edges: Array<{ __typename?: 'ReportTypeEdge', node?: { __typename?: 'ReportType', id: string, reportType: ApiReportReportTypeChoices, reportStatus: ApiReportReportStatusChoices, createdDate: any, completionDate?: any | null } | null } | null> } } | null } | null> } | null };

export type LearnerFileByIdQueryVariables = Exact<{
  fileId: Scalars['ID']['input'];
}>;


export type LearnerFileByIdQuery = { __typename?: 'Query', learnerFileById?: { __typename?: 'LearnerFileType', id: string, originalFileName: string, fileKind: ApiLearnerFileFileKindChoices, status: ApiLearnerFileStatusChoices, mimeType: string, fileSize: any, signedS3LearnerFile?: string | null } | null };

export type LearnerManualGoalSyncByIdQueryVariables = Exact<{
  learnerId: Scalars['ID']['input'];
}>;


export type LearnerManualGoalSyncByIdQuery = { __typename?: 'Query', learnerById?: { __typename?: 'LearnerType', manualGoalSyncStatus?: ApiLearnerManualGoalSyncStatusChoices | null, manualGoalSyncLastUpdated?: any | null } | null };

export type GetMediaByCaregiverQueryVariables = Exact<{
  learnerIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  mediaStatus?: InputMaybe<MediaStatusEnumType>;
  sortBy?: InputMaybe<Array<InputMaybe<MediaSortByEnum>> | InputMaybe<MediaSortByEnum>>;
  sessionStartDate?: InputMaybe<Scalars['Date']['input']>;
  sessionEndDate?: InputMaybe<Scalars['Date']['input']>;
  isReviewed?: InputMaybe<Scalars['Boolean']['input']>;
  sessionStatus?: InputMaybe<Array<InputMaybe<VideoSessionStatusEnums>> | InputMaybe<VideoSessionStatusEnums>>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetMediaByCaregiverQuery = { __typename?: 'Query', getMediaByCaregiver?: { __typename?: 'MediaTypeConnection', totalCount?: number | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, startCursor?: string | null, endCursor?: string | null }, edges: Array<{ __typename?: 'MediaTypeEdge', node?: { __typename?: 'MediaType', id: string, mediaType: ApiMediaMediaTypeChoices, mediaStatus: ApiMediaMediaStatusChoices, isViewed: boolean, totalDuration?: number | null, createdDate: any, commentsCount?: any | null, videoSession?: { __typename?: 'VideoSessionType', id: string, date: any, createdDate: any, sessionRating?: number | null, sessionStatus?: ApiVideoSessionSessionStatusChoices | null, sessionaipredictionSet: { __typename?: 'SessionAIPredictionTypeConnection', edges: Array<{ __typename?: 'SessionAIPredictionTypeEdge', node?: { __typename?: 'SessionAIPredictionType', id: string, prediction: string } | null } | null> }, sessioncaregiverSet: { __typename?: 'SessionCaregiverTypeConnection', edges: Array<{ __typename?: 'SessionCaregiverTypeEdge', node?: { __typename?: 'SessionCaregiverType', caregiver: { __typename?: 'CaregiverType', id: string, caregivermetadata?: { __typename?: 'CaregiverMetadataType', firstName: string, lastName: string } | null } } | null } | null> }, sessionlearnerSet: { __typename?: 'SessionLearnerTypeConnection', edges: Array<{ __typename?: 'SessionLearnerTypeEdge', node?: { __typename?: 'SessionLearnerType', sessionLearners: { __typename?: 'LearnerType', id: string, learnermetadata?: { __typename?: 'LearnerMetadataType', firstName: string, lastName: string } | null } } | null } | null> }, sessionproviderSet: { __typename?: 'SessionProviderTypeConnection', edges: Array<{ __typename?: 'SessionProviderTypeEdge', node?: { __typename?: 'SessionProviderType', provider: { __typename?: 'ProviderType', id: string, providermetadata?: { __typename?: 'ProviderMetadataType', firstName: string, lastName?: string | null } | null } } | null } | null> } } | null, mediaClassifications?: { __typename?: 'MediaClassificationType', continuousInteractions?: Array<{ __typename?: 'ContinousInteractionClassification', subclass?: ClassificationSubClassEnum | null, totalDuration?: number | null, intervals?: Array<{ __typename?: 'ClassificationInterval', startTime?: number | null, endTime?: number | null, confidenceLevel?: number | null } | null> | null } | null> | null, nonContinuousInteractions?: Array<{ __typename?: 'NonContinousInteractionClassification', subclass?: string | null, interactionCount?: number | null, intervals?: Array<{ __typename?: 'ClassificationInterval', startTime?: number | null, endTime?: number | null, confidenceLevel?: number | null } | null> | null } | null> | null } | null } | null } | null> } | null };

export type GetMediaByCaregiverByMediaIdQueryVariables = Exact<{
  mediaId: Scalars['ID']['input'];
}>;


export type GetMediaByCaregiverByMediaIdQuery = { __typename?: 'Query', getMediaByCaregiverByMediaId?: { __typename?: 'MediaType', id: string, mediaType: ApiMediaMediaTypeChoices, mediaStatus: ApiMediaMediaStatusChoices, isViewed: boolean, commentsCount?: any | null, signedUploadUrl?: string | null, mediaAttachmentUrl?: string | null, createdDate: any, totalDuration?: number | null, thumbnailManifest?: { __typename?: 'ThumbnailManifestType', mediaId?: number | null, intervalSeconds?: number | null, thumbnails?: Array<{ __typename?: 'ThumbnailType', time?: number | null, url?: string | null } | null> | null } | null, videoSession?: { __typename?: 'VideoSessionType', id: string, date: any, sessionRating?: number | null, createdDate: any, comment?: string | null, sessionlearnerSet: { __typename?: 'SessionLearnerTypeConnection', edges: Array<{ __typename?: 'SessionLearnerTypeEdge', node?: { __typename?: 'SessionLearnerType', sessionLearners: { __typename?: 'LearnerType', id: string, learnermetadata?: { __typename?: 'LearnerMetadataType', firstName: string, lastName: string } | null } } | null } | null> }, sessioncaregiverSet: { __typename?: 'SessionCaregiverTypeConnection', edges: Array<{ __typename?: 'SessionCaregiverTypeEdge', node?: { __typename?: 'SessionCaregiverType', caregiver: { __typename?: 'CaregiverType', id: string, caregivermetadata?: { __typename?: 'CaregiverMetadataType', firstName: string, lastName: string } | null } } | null } | null> }, sessionproviderSet: { __typename?: 'SessionProviderTypeConnection', edges: Array<{ __typename?: 'SessionProviderTypeEdge', node?: { __typename?: 'SessionProviderType', provider: { __typename?: 'ProviderType', id: string, providermetadata?: { __typename?: 'ProviderMetadataType', firstName: string, lastName?: string | null } | null } } | null } | null> } } | null, mediaClassifications?: { __typename?: 'MediaClassificationType', continuousInteractions?: Array<{ __typename?: 'ContinousInteractionClassification', subclass?: ClassificationSubClassEnum | null, totalDuration?: number | null, intervals?: Array<{ __typename?: 'ClassificationInterval', startTime?: number | null, endTime?: number | null, confidenceLevel?: number | null } | null> | null } | null> | null, nonContinuousInteractions?: Array<{ __typename?: 'NonContinousInteractionClassification', subclass?: string | null, interactionCount?: number | null, intervals?: Array<{ __typename?: 'ClassificationInterval', startTime?: number | null, endTime?: number | null, confidenceLevel?: number | null } | null> | null } | null> | null } | null } | null };

export type GetMediaCommentsByMediaIdQueryVariables = Exact<{
  mediaId: Scalars['ID']['input'];
  commentTypes?: InputMaybe<Array<InputMaybe<MediaCommentFilterEnum>> | InputMaybe<MediaCommentFilterEnum>>;
}>;


export type GetMediaCommentsByMediaIdQuery = { __typename?: 'Query', getMediaComments?: { __typename?: 'MediaCommentsTypeConnection', totalCount?: number | null, edges: Array<{ __typename?: 'MediaCommentsTypeEdge', node?: { __typename?: 'MediaCommentsType', id: string, content: string, commentType: ApiMediaCommentsCommentTypeChoices, mediaStartTime: number, hasReplies?: boolean | null, createdDate: any, commentReplies?: { __typename?: 'MediaCommentsTypeConnection', totalCount?: number | null, edges: Array<{ __typename?: 'MediaCommentsTypeEdge', node?: { __typename?: 'MediaCommentsType', id: string, content: string, commentType: ApiMediaCommentsCommentTypeChoices, createdDate: any, author?: { __typename?: 'UserType', id: string, auth0id?: string | null, provider?: { __typename?: 'ProviderType', providermetadata?: { __typename?: 'ProviderMetadataType', firstName: string, lastName?: string | null } | null } | null, caregiver?: { __typename?: 'CaregiverType', caregivermetadata?: { __typename?: 'CaregiverMetadataType', firstName: string, lastName: string } | null } | null } | null, parentComment?: { __typename?: 'MediaCommentsType', id: string } | null } | null } | null> } | null, author?: { __typename?: 'UserType', id: string, auth0id?: string | null, provider?: { __typename?: 'ProviderType', providermetadata?: { __typename?: 'ProviderMetadataType', firstName: string, lastName?: string | null } | null } | null, caregiver?: { __typename?: 'CaregiverType', caregivermetadata?: { __typename?: 'CaregiverMetadataType', firstName: string, lastName: string } | null } | null } | null, parentComment?: { __typename?: 'MediaCommentsType', id: string } | null, media: { __typename?: 'MediaType', id: string } } | null } | null> } | null };

export type GetMediaCommentRepliesQueryVariables = Exact<{
  parentCommentId: Scalars['ID']['input'];
  commentType?: InputMaybe<ApiMediaCommentsCommentTypeChoices>;
}>;


export type GetMediaCommentRepliesQuery = { __typename?: 'Query', getMediaCommentReplies?: { __typename?: 'MediaCommentsTypeConnection', totalCount?: number | null, edges: Array<{ __typename?: 'MediaCommentsTypeEdge', node?: { __typename?: 'MediaCommentsType', id: string, content: string, commentType: ApiMediaCommentsCommentTypeChoices, mediaStartTime: number, hasReplies?: boolean | null, createdDate: any, author?: { __typename?: 'UserType', id: string, auth0id?: string | null, provider?: { __typename?: 'ProviderType', providermetadata?: { __typename?: 'ProviderMetadataType', firstName: string, lastName?: string | null } | null } | null, caregiver?: { __typename?: 'CaregiverType', caregivermetadata?: { __typename?: 'CaregiverMetadataType', firstName: string, lastName: string } | null } | null } | null, parentComment?: { __typename?: 'MediaCommentsType', id: string } | null, media: { __typename?: 'MediaType', id: string } } | null } | null> } | null };

export type GetMediaTargetPredictionsQueryVariables = Exact<{
  filter: MediaTargetPredictionFilter;
}>;


export type GetMediaTargetPredictionsQuery = { __typename?: 'Query', getMediaTargetPredictions?: { __typename?: 'MediaTargetPredictionTypeConnection', edges: Array<{ __typename?: 'MediaTargetPredictionTypeEdge', node?: { __typename?: 'MediaTargetPredictionType', id: string, createdDate: any, startTime: number, endTime: number, rationale?: string | null, modalityType: ApiMediaTargetPredictionModalityTypeChoices, thumbnailUrl?: string | null, mediaTargetFeedbacks: { __typename?: 'MediaTargetPredictionFeedbackTypeConnection', edges: Array<{ __typename?: 'MediaTargetPredictionFeedbackTypeEdge', node?: { __typename?: 'MediaTargetPredictionFeedbackType', lastUpdatedDate: any, isAccurate: boolean } | null } | null> }, goal?: { __typename?: 'GoalType', id: string, name?: string | null } | null, target?: { __typename?: 'TargetType', id: string, name?: string | null } | null, media: { __typename?: 'MediaType', id: string, filePath?: string | null, videoSession?: { __typename?: 'VideoSessionType', therapySession?: { __typename?: 'TherapySessionType', locationType?: string | null } | null, finalMedia?: { __typename?: 'MediaType', id: string, createdDate: any, totalDuration?: number | null, signedUploadUrl?: string | null } | null, sessioncaregiverSet: { __typename?: 'SessionCaregiverTypeConnection', edges: Array<{ __typename?: 'SessionCaregiverTypeEdge', node?: { __typename?: 'SessionCaregiverType', caregiver: { __typename?: 'CaregiverType', id: string, caregivermetadata?: { __typename?: 'CaregiverMetadataType', firstName: string, lastName: string } | null } } | null } | null> }, sessionproviderSet: { __typename?: 'SessionProviderTypeConnection', edges: Array<{ __typename?: 'SessionProviderTypeEdge', node?: { __typename?: 'SessionProviderType', provider: { __typename?: 'ProviderType', id: string, providermetadata?: { __typename?: 'ProviderMetadataType', firstName: string, lastName?: string | null } | null } } | null } | null> } } | null } } | null } | null> } | null };

export type GetMediaThumbnailManifestQueryVariables = Exact<{
  mediaId: Scalars['ID']['input'];
}>;


export type GetMediaThumbnailManifestQuery = { __typename?: 'Query', getMediaById?: { __typename?: 'MediaTypeConnection', edges: Array<{ __typename?: 'MediaTypeEdge', node?: { __typename?: 'MediaType', id: string, thumbnailManifest?: { __typename?: 'ThumbnailManifestType', thumbnails?: Array<{ __typename?: 'ThumbnailType', url?: string | null, time?: number | null } | null> | null } | null } | null } | null> } | null };

export type GetProvidersForSessionQueryVariables = Exact<{ [key: string]: never; }>;


export type GetProvidersForSessionQuery = { __typename?: 'Query', getProvidersForSession?: { __typename?: 'ProviderTypeConnection', totalCount?: number | null, edges: Array<{ __typename?: 'ProviderTypeEdge', node?: { __typename?: 'ProviderType', id: string, createdDate: any, providermetadata?: { __typename?: 'ProviderMetadataType', id: string, firstName: string, lastName?: string | null } | null, organizationuserrolesSet: { __typename?: 'OrganizationUserRolesTypeConnection', edges: Array<{ __typename?: 'OrganizationUserRolesTypeEdge', node?: { __typename?: 'OrganizationUserRolesType', role: ApiOrganizationUserRolesRoleChoices } | null } | null> } } | null } | null> } | null };

export type GetSessionCaregiversQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSessionCaregiversQuery = { __typename?: 'Query', getSessionCaregivers?: { __typename?: 'CaregiverTypeConnection', edges: Array<{ __typename?: 'CaregiverTypeEdge', node?: { __typename?: 'CaregiverType', id: string, caregivermetadata?: { __typename?: 'CaregiverMetadataType', firstName: string, lastName: string } | null } | null } | null> } | null };

export type GetSessionClientsQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetSessionClientsQuery = { __typename?: 'Query', sessionLearnersWithSessions?: { __typename?: 'SessionLearnerTypeConnection', pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, startCursor?: string | null, endCursor?: string | null }, edges: Array<{ __typename?: 'SessionLearnerTypeEdge', node?: { __typename?: 'SessionLearnerType', id: string, sessionLearners: { __typename?: 'LearnerType', id: string, learnermetadata?: { __typename?: 'LearnerMetadataType', firstName: string, lastName: string } | null } } | null } | null> } | null };

export type GetSessionSummaryBySessionIdQueryVariables = Exact<{
  videoSessionId: Scalars['ID']['input'];
}>;


export type GetSessionSummaryBySessionIdQuery = { __typename?: 'Query', getSessionSummaryBySessionId?: { __typename?: 'SessionAIPredictionType', model: string, version: string, predictionType: ApiSessionAiPredictionPredictionTypeChoices, prediction: string, videoSession: { __typename?: 'VideoSessionType', id: string } } | null };

export type GetTranscriptDataByMediaIdQueryVariables = Exact<{
  mediaId: Scalars['ID']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetTranscriptDataByMediaIdQuery = { __typename?: 'Query', getTranscriptDataByMediaId?: { __typename?: 'TranscriptLineRecordTypeConnection', totalCount?: number | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, startCursor?: string | null, endCursor?: string | null }, edges: Array<{ __typename?: 'TranscriptLineRecordTypeEdge', node?: { __typename?: 'TranscriptLineRecordType', id: string, startTime: number, endTime: number, conversation: string, speaker: string } | null } | null> } | null };

export type GetTranscriptCsvContentQueryVariables = Exact<{
  videoSessionId: Scalars['ID']['input'];
}>;


export type GetTranscriptCsvContentQuery = { __typename?: 'Query', getTranscriptCsvContent?: { __typename?: 'TranscriptCsvContentType', status: boolean, message: string, csvContent?: string | null, filename?: string | null } | null };

export type GetMediaByProviderQueryVariables = Exact<{
  learnerIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  providerIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  caregiverIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  sessionRating?: InputMaybe<Scalars['Int']['input']>;
  mediaStatus?: InputMaybe<MediaStatusEnumType>;
  sortBy?: InputMaybe<Array<InputMaybe<MediaSortByEnum>> | InputMaybe<MediaSortByEnum>>;
  sessionStartDate?: InputMaybe<Scalars['Date']['input']>;
  sessionEndDate?: InputMaybe<Scalars['Date']['input']>;
  isReviewed?: InputMaybe<Scalars['Boolean']['input']>;
  sessionStatus?: InputMaybe<Array<InputMaybe<VideoSessionStatusEnums>> | InputMaybe<VideoSessionStatusEnums>>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetMediaByProviderQuery = { __typename?: 'Query', getMediaByProvider?: { __typename?: 'MediaTypeConnection', totalCount?: number | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, startCursor?: string | null, endCursor?: string | null }, edges: Array<{ __typename?: 'MediaTypeEdge', node?: { __typename?: 'MediaType', id: string, mediaType: ApiMediaMediaTypeChoices, mediaStatus: ApiMediaMediaStatusChoices, isViewed: boolean, totalDuration?: number | null, createdDate: any, commentsCount?: any | null, thumbnailManifest?: { __typename?: 'ThumbnailManifestType', mediaId?: number | null, intervalSeconds?: number | null, thumbnails?: Array<{ __typename?: 'ThumbnailType', time?: number | null, url?: string | null } | null> | null } | null, videoSession?: { __typename?: 'VideoSessionType', id: string, date: any, createdDate: any, sessionRating?: number | null, sessionStatus?: ApiVideoSessionSessionStatusChoices | null, sessionaipredictionSet: { __typename?: 'SessionAIPredictionTypeConnection', edges: Array<{ __typename?: 'SessionAIPredictionTypeEdge', node?: { __typename?: 'SessionAIPredictionType', id: string, prediction: string } | null } | null> }, sessioncaregiverSet: { __typename?: 'SessionCaregiverTypeConnection', edges: Array<{ __typename?: 'SessionCaregiverTypeEdge', node?: { __typename?: 'SessionCaregiverType', caregiver: { __typename?: 'CaregiverType', id: string, caregivermetadata?: { __typename?: 'CaregiverMetadataType', firstName: string, lastName: string } | null } } | null } | null> }, sessionlearnerSet: { __typename?: 'SessionLearnerTypeConnection', edges: Array<{ __typename?: 'SessionLearnerTypeEdge', node?: { __typename?: 'SessionLearnerType', sessionLearners: { __typename?: 'LearnerType', id: string, learnermetadata?: { __typename?: 'LearnerMetadataType', firstName: string, lastName: string } | null } } | null } | null> }, sessionproviderSet: { __typename?: 'SessionProviderTypeConnection', edges: Array<{ __typename?: 'SessionProviderTypeEdge', node?: { __typename?: 'SessionProviderType', provider: { __typename?: 'ProviderType', id: string, providermetadata?: { __typename?: 'ProviderMetadataType', firstName: string, lastName?: string | null } | null } } | null } | null> } } | null, mediaClassifications?: { __typename?: 'MediaClassificationType', continuousInteractions?: Array<{ __typename?: 'ContinousInteractionClassification', subclass?: ClassificationSubClassEnum | null, totalDuration?: number | null, intervals?: Array<{ __typename?: 'ClassificationInterval', startTime?: number | null, endTime?: number | null, confidenceLevel?: number | null } | null> | null } | null> | null, nonContinuousInteractions?: Array<{ __typename?: 'NonContinousInteractionClassification', subclass?: string | null, interactionCount?: number | null, intervals?: Array<{ __typename?: 'ClassificationInterval', startTime?: number | null, endTime?: number | null, confidenceLevel?: number | null } | null> | null } | null> | null } | null } | null } | null> } | null };

export type GetMediaByProviderByMediaIdQueryVariables = Exact<{
  mediaId: Scalars['ID']['input'];
}>;


export type GetMediaByProviderByMediaIdQuery = { __typename?: 'Query', getMediaByProviderByMediaId?: { __typename?: 'MediaType', id: string, mediaType: ApiMediaMediaTypeChoices, mediaStatus: ApiMediaMediaStatusChoices, isViewed: boolean, commentsCount?: any | null, signedUploadUrl?: string | null, mediaAttachmentUrl?: string | null, createdDate: any, totalDuration?: number | null, thumbnailManifest?: { __typename?: 'ThumbnailManifestType', mediaId?: number | null, intervalSeconds?: number | null, thumbnails?: Array<{ __typename?: 'ThumbnailType', time?: number | null, url?: string | null } | null> | null } | null, videoSession?: { __typename?: 'VideoSessionType', id: string, date: any, sessionRating?: number | null, comment?: string | null, createdDate: any, sessionlearnerSet: { __typename?: 'SessionLearnerTypeConnection', edges: Array<{ __typename?: 'SessionLearnerTypeEdge', node?: { __typename?: 'SessionLearnerType', sessionLearners: { __typename?: 'LearnerType', id: string, learnermetadata?: { __typename?: 'LearnerMetadataType', firstName: string, lastName: string } | null } } | null } | null> }, sessioncaregiverSet: { __typename?: 'SessionCaregiverTypeConnection', edges: Array<{ __typename?: 'SessionCaregiverTypeEdge', node?: { __typename?: 'SessionCaregiverType', caregiver: { __typename?: 'CaregiverType', id: string, caregivermetadata?: { __typename?: 'CaregiverMetadataType', firstName: string, lastName: string } | null } } | null } | null> }, sessionproviderSet: { __typename?: 'SessionProviderTypeConnection', edges: Array<{ __typename?: 'SessionProviderTypeEdge', node?: { __typename?: 'SessionProviderType', provider: { __typename?: 'ProviderType', id: string, providermetadata?: { __typename?: 'ProviderMetadataType', firstName: string, lastName?: string | null } | null } } | null } | null> } } | null, mediaClassifications?: { __typename?: 'MediaClassificationType', continuousInteractions?: Array<{ __typename?: 'ContinousInteractionClassification', subclass?: ClassificationSubClassEnum | null, totalDuration?: number | null, intervals?: Array<{ __typename?: 'ClassificationInterval', startTime?: number | null, endTime?: number | null, confidenceLevel?: number | null } | null> | null } | null> | null, nonContinuousInteractions?: Array<{ __typename?: 'NonContinousInteractionClassification', subclass?: string | null, interactionCount?: number | null, intervals?: Array<{ __typename?: 'ClassificationInterval', startTime?: number | null, endTime?: number | null, confidenceLevel?: number | null } | null> | null } | null> | null } | null } | null };

export type GetProviderByEmailQueryVariables = Exact<{
  email: Scalars['String']['input'];
}>;


export type GetProviderByEmailQuery = { __typename?: 'Query', providerByEmail?: { __typename?: 'ProviderType', id: string, userRoles?: Array<any | null> | null, auth0User?: { __typename?: 'UserType', auth0id?: string | null } | null, providermetadata?: { __typename?: 'ProviderMetadataType', email?: string | null, firstName: string, lastName?: string | null, organization: { __typename?: 'OrganizationType', auth0OrganizationId?: string | null, id: string } } | null } | null };

export type GetNotificationOptOutsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  deliveryMethod?: InputMaybe<ApiNotificationOptOutDeliveryMethodChoices>;
  notificationType?: InputMaybe<ApiNotificationOptOutNotificationTypeChoices>;
}>;


export type GetNotificationOptOutsQuery = { __typename?: 'Query', notificationOptOut?: { __typename?: 'NotificationOptOutTypeConnection', totalCount?: number | null, edges: Array<{ __typename?: 'NotificationOptOutTypeEdge', cursor: string, node?: { __typename?: 'NotificationOptOutType', id: string, deliveryMethod: ApiNotificationOptOutDeliveryMethodChoices, notificationType: ApiNotificationOptOutNotificationTypeChoices, createdDate: any, lastUpdatedDate: any, user: { __typename?: 'UserType', id: string, username: string, email: string }, organization: { __typename?: 'OrganizationType', id: string, name: string } } | null } | null>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type GetNotificationsQueryVariables = Exact<{
  read?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetNotificationsQuery = { __typename?: 'Query', getNotifications?: { __typename?: 'NotificationsTypeConnection', totalCount?: number | null, totalUnread?: number | null, edges: Array<{ __typename?: 'NotificationsTypeEdge', cursor: string, node?: { __typename?: 'NotificationsType', id: string, title: string, description?: string | null, channel: ApiNotificationsChannelChoices, notificationType: ApiNotificationsNotificationTypeChoices, read: boolean, payload: any, createdDate: any, lastUpdatedDate: any, recipient: { __typename?: 'UserType', id: string, username: string, email: string, firstName: string, lastName: string }, sender?: { __typename?: 'UserType', id: string, username: string, email: string, firstName: string, lastName: string } | null, organization: { __typename?: 'OrganizationType', id: string, name: string } } | null } | null>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type GetAllBaseSuggestionCriteriaQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllBaseSuggestionCriteriaQuery = { __typename?: 'Query', getAllBaseSuggestionCriteria?: Array<{ __typename?: 'SuggestionCriteriaType', id: string, name: string, category: string, content: string, isBaseCriteria: boolean }> | null };

export type GetUserOrgnizationSuggestionConfigQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserOrgnizationSuggestionConfigQuery = { __typename?: 'Query', getUserOrgnizationDetails?: { __typename?: 'OrganizationType', suggestionCriteria?: Array<{ __typename?: 'OrganizationSuggestionCriteriaType', id: string, enabled: boolean, isVirtual?: boolean | null, suggestionCriteria: { __typename?: 'SuggestionCriteriaType', id: string, name: string, category: string, content: string, isBaseCriteria: boolean, organizations: { __typename?: 'OrganizationSuggestionCriteriaTypeConnection', edges: Array<{ __typename?: 'OrganizationSuggestionCriteriaTypeEdge', node?: { __typename?: 'OrganizationSuggestionCriteriaType', organization: { __typename?: 'OrganizationType', name: string } } | null } | null> } } } | null> | null } | null };

export type GetUserOrgnizationDetailsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserOrgnizationDetailsQuery = { __typename?: 'Query', getUserOrgnizationDetails?: { __typename?: 'OrganizationType', id: string, name: string, organizationType: ApiOrganizationOrganizationTypeChoices, ehrIntegrationType: ApiOrganizationEhrIntegrationTypeChoices, manualEhrIntegration: boolean, abExportTemplateName: ApiOrganizationAbExportTemplateNameChoices, onboardingEnabled: boolean, consentRequired: boolean, ehrSyncCleared?: boolean | null, peerReviewEnabled: boolean, notificationSettings?: { __typename?: 'OrganizationNotificationSettingsType', id: string, reassessmentReminder: boolean } | null } | null };

export type PromptsQueryVariables = Exact<{
  filter: PromptFilter;
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type PromptsQuery = { __typename?: 'Query', prompts?: { __typename?: 'PromptTypeConnection', totalCount?: number | null, edges: Array<{ __typename?: 'PromptTypeEdge', cursor: string, node?: { __typename?: 'PromptType', id: string, name: string, key: string, createdDate: any, responseSchema?: any | null, sampleOutput?: string | null, lastUpdatedDate: any } | null } | null>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type GetIntercomUserJwtQueryVariables = Exact<{ [key: string]: never; }>;


export type GetIntercomUserJwtQuery = { __typename?: 'Query', getLoginProvider?: { __typename?: 'ProviderType', intercomUserJwt?: string | null } | null };

export type ProviderIntegrationsQueryVariables = Exact<{ [key: string]: never; }>;


export type ProviderIntegrationsQuery = { __typename?: 'Query', providerIntegrations?: { __typename?: 'ProviderIntegrationsType', zoomIntegration?: { __typename?: 'ProviderZoomIntegrationType', id: string, isActive: boolean, hasCloudRecording: boolean } | null } | null };

export type GetLoginProviderQueryVariables = Exact<{ [key: string]: never; }>;


export type GetLoginProviderQuery = { __typename?: 'Query', getLoginProvider?: { __typename?: 'ProviderType', id: string, hasEnteredVideoCaptureApp: boolean, auth0User?: { __typename?: 'UserType', id: string } | null, providermetadata?: { __typename?: 'ProviderMetadataType', id: string, onboardingCompleted: boolean, firstName: string, lastName?: string | null, email?: string | null, phoneNumber?: string | null, smsAgreement: boolean, professionalTitle?: string | null, licenseNumber?: string | null, chatAvailability?: ApiProviderMetadataChatAvailabilityChoices | null, bio?: string | null, clinicalCredentials?: string | null, workingHoursStart?: any | null, workingHoursEnd?: any | null, timezone?: string | null } | null, profileImage?: { __typename?: 'ProviderFileType', id: string, signedS3ProviderFile?: string | null, status: ApiProviderFileStatusChoices } | null } | null };

export type ProviderByIdQueryVariables = Exact<{
  providerId: Scalars['ID']['input'];
}>;


export type ProviderByIdQuery = { __typename?: 'Query', providerById?: { __typename?: 'ProviderType', id: string, archived?: boolean | null, createdDate: any, userRoles?: Array<any | null> | null, auth0User?: { __typename?: 'UserType', id: string } | null, providermetadata?: { __typename?: 'ProviderMetadataType', firstName: string, lastName?: string | null, email?: string | null, gender?: ApiProviderMetadataGenderChoices | null, specifyGender?: string | null, invitationId?: string | null, invitationStatus?: ApiProviderMetadataInvitationStatusChoices | null, invitationCreatedAt?: any | null, invitationExpiresAt?: any | null, invitationUrl?: string | null } | null, organizationuserrolesSet: { __typename?: 'OrganizationUserRolesTypeConnection', edges: Array<{ __typename?: 'OrganizationUserRolesTypeEdge', node?: { __typename?: 'OrganizationUserRolesType', id: string, role: ApiOrganizationUserRolesRoleChoices } | null } | null> }, learnerproviderSet: { __typename?: 'LearnerProviderTypeConnection', edges: Array<{ __typename?: 'LearnerProviderTypeEdge', node?: { __typename?: 'LearnerProviderType', id: string, learner: { __typename?: 'LearnerType', id: string, archived?: boolean | null, learnermetadata?: { __typename?: 'LearnerMetadataType', firstName: string, lastName: string, diagnosisAppointmentDate?: any | null, assessmentAppointmentDate?: any | null } | null, relationshipSet: { __typename?: 'RelationshipTypeConnection', edges: Array<{ __typename?: 'RelationshipTypeEdge', node?: { __typename?: 'RelationshipType', caregiver: { __typename?: 'CaregiverType', caregivermetadata?: { __typename?: 'CaregiverMetadataType', firstName: string, lastName: string, email?: string | null } | null } } | null } | null> } } } | null } | null> } } | null };

export type ProvidersQueryVariables = Exact<{ [key: string]: never; }>;


export type ProvidersQuery = { __typename?: 'Query', provider?: Array<{ __typename?: 'ProviderType', id: string, archived?: boolean | null, createdDate: any, organizationuserrolesSet: { __typename?: 'OrganizationUserRolesTypeConnection', edges: Array<{ __typename?: 'OrganizationUserRolesTypeEdge', node?: { __typename?: 'OrganizationUserRolesType', id: string, role: ApiOrganizationUserRolesRoleChoices } | null } | null> }, providermetadata?: { __typename?: 'ProviderMetadataType', firstName: string, lastName?: string | null, gender?: ApiProviderMetadataGenderChoices | null, email?: string | null, specifyGender?: string | null, invitationId?: string | null, invitationStatus?: ApiProviderMetadataInvitationStatusChoices | null, invitationCreatedAt?: any | null, invitationExpiresAt?: any | null, invitationUrl?: string | null } | null, learnerproviderSet: { __typename?: 'LearnerProviderTypeConnection', edges: Array<{ __typename?: 'LearnerProviderTypeEdge', node?: { __typename?: 'LearnerProviderType', id: string, learner: { __typename?: 'LearnerType', archived?: boolean | null, learnermetadata?: { __typename?: 'LearnerMetadataType', firstName: string, lastName: string, diagnosisAppointmentDate?: any | null, assessmentAppointmentDate?: any | null } | null } } | null } | null> } }> | null };

export type GetUserAccountDetailsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserAccountDetailsQuery = { __typename?: 'Query', getUserAccountDetails?: { __typename?: 'UserStripeAccountDetailsType', pendingAssessment: number, purchasedAssessment: number } | null };

export type BillingDetailsQueryVariables = Exact<{
  userStripeAccount?: InputMaybe<Scalars['ID']['input']>;
}>;


export type BillingDetailsQuery = { __typename?: 'Query', getUserBillingDetails?: { __typename?: 'UserBillingDetailsTypeConnection', edges: Array<{ __typename?: 'UserBillingDetailsTypeEdge', node?: { __typename?: 'UserBillingDetailsType', transactionType: ApiUserBillingDetailsTransactionTypeChoices, amount?: any | null, createdDate: any, paymentIntentId?: string | null, priceId?: string | null, quantity?: number | null, userStripeAccount?: { __typename?: 'UserStripeAccountDetailsType', pendingAssessment: number } | null } | null } | null> } | null };

export type GetCardDetailsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCardDetailsQuery = { __typename?: 'Query', getUserCardAndAssessmentDetails?: { __typename?: 'UserCardAndAssessmentDetailsType', userCardsDetails?: any | null } | null };

export type GetProviderLearnersQueryVariables = Exact<{
  learnerName?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetProviderLearnersQuery = { __typename?: 'Query', getProviderLearners?: { __typename?: 'LearnerTypeConnection', totalCount?: number | null, edges: Array<{ __typename?: 'LearnerTypeEdge', node?: { __typename?: 'LearnerType', id: string, archived?: boolean | null, externalId?: string | null, createdBy?: { __typename?: 'UserType', id: string, email: string } | null, learnermetadata?: { __typename?: 'LearnerMetadataType', id: string, firstName: string, lastName: string } | null, scraperlearnerimportstatusSet: { __typename?: 'ScraperLearnerImportStatusTypeConnection', edges: Array<{ __typename?: 'ScraperLearnerImportStatusTypeEdge', node?: { __typename?: 'ScraperLearnerImportStatusType', id: string, status: ApiScraperLearnerImportStatusStatusChoices } | null } | null> } } | null } | null> } | null };

export type LearnersQueryVariables = Exact<{ [key: string]: never; }>;


export type LearnersQuery = { __typename?: 'Query', learner?: Array<{ __typename?: 'LearnerType', id: string, archived?: boolean | null, createdDate: any, hasCaregiverConsent: boolean, learnermetadata?: { __typename?: 'LearnerMetadataType', firstName: string, lastName: string, diagnosisAppointmentDate?: any | null, assessmentAppointmentDate?: any | null, birthDate?: any | null } | null, formStatusForLearner: { __typename?: 'OnboardingFormStatusTypeConnection', edges: Array<{ __typename?: 'OnboardingFormStatusTypeEdge', node?: { __typename?: 'OnboardingFormStatusType', formName: string, status: ApiOnboardingFormStatusStatusChoices, createdDate: any } | null } | null> }, learnerproviderSet: { __typename?: 'LearnerProviderTypeConnection', edges: Array<{ __typename?: 'LearnerProviderTypeEdge', node?: { __typename?: 'LearnerProviderType', provider: { __typename?: 'ProviderType', id: string } } | null } | null> }, relationshipSet: { __typename?: 'RelationshipTypeConnection', edges: Array<{ __typename?: 'RelationshipTypeEdge', node?: { __typename?: 'RelationshipType', isPrimary: boolean, hasCaregiverConsent: boolean, caregiver: { __typename?: 'CaregiverType', id: string, isAllowedAppAccess?: boolean | null, auth0User?: { __typename?: 'UserType', auth0id?: string | null } | null, caregivermetadata?: { __typename?: 'CaregiverMetadataType', firstName: string, lastName: string, email?: string | null, phoneNumber1?: string | null, nearestLocation?: string | null } | null } } | null } | null> } }> | null };

export type LearnerByIdQueryVariables = Exact<{
  learnerId: Scalars['ID']['input'];
}>;


export type LearnerByIdQuery = { __typename?: 'Query', learnerById?: { __typename?: 'LearnerType', id: string, externalId?: string | null, archived?: boolean | null, createdDate: any, lastUpdatedDate: any, learnermetadata?: { __typename?: 'LearnerMetadataType', id: string, firstName: string, lastName: string, preferredName?: string | null, gender?: ApiLearnerMetadataGenderChoices | null, birthDate?: any | null, diagnosisAppointmentDate?: any | null, diagnosisPsychologist?: string | null, assessmentBcba?: string | null, assessmentAppointmentDate?: any | null, address?: string | null, addressLine2?: string | null, city?: string | null, state?: string | null, zip?: string | null, hasPreviousDiagnosis: boolean } | null, learnerAvailability: { __typename?: 'LearnerAvailabilityTypeConnection', edges: Array<{ __typename?: 'LearnerAvailabilityTypeEdge', node?: { __typename?: 'LearnerAvailabilityType', day: ApiLearnerAvailabilityDayChoices, timeOfDay: ApiLearnerAvailabilityTimeOfDayChoices } | null } | null> }, insuranceForLearner: { __typename?: 'InsuranceDetailsTypeConnection', edges: Array<{ __typename?: 'InsuranceDetailsTypeEdge', node?: { __typename?: 'InsuranceDetailsType', id: string, insuranceType: ApiInsuranceDetailsInsuranceTypeChoices, insurer: ApiInsuranceDetailsInsurerChoices, inNetwork?: ApiInsuranceDetailsInNetworkChoices | null } | null } | null> }, formStatusForLearner: { __typename?: 'OnboardingFormStatusTypeConnection', edges: Array<{ __typename?: 'OnboardingFormStatusTypeEdge', node?: { __typename?: 'OnboardingFormStatusType', formName: string, status: ApiOnboardingFormStatusStatusChoices, createdDate: any } | null } | null> }, relationshipSet: { __typename?: 'RelationshipTypeConnection', edges: Array<{ __typename?: 'RelationshipTypeEdge', node?: { __typename?: 'RelationshipType', id: string, socialRelationship?: string | null, isPrimary: boolean, hasCaregiverConsent: boolean, caregiver: { __typename?: 'CaregiverType', id: string, hasEnteredVideoCaptureApp: boolean, isAllowedAppAccess?: boolean | null, auth0User?: { __typename?: 'UserType', auth0id?: string | null } | null, caregivermetadata?: { __typename?: 'CaregiverMetadataType', id: string, firstName: string, lastName: string, email?: string | null, phoneNumber1?: string | null, phoneNumber2?: string | null, nearestLocation?: string | null, referralSource?: string | null, smsAgreement: boolean, invitationId?: string | null, invitationStatus?: ApiCaregiverMetadataInvitationStatusChoices | null, invitationCreatedAt?: any | null, invitationExpiresAt?: any | null, invitationUrl?: string | null } | null } } | null } | null> }, learnerpayorSet: { __typename?: 'LearnerPayorTypeConnection', edges: Array<{ __typename?: 'LearnerPayorTypeEdge', node?: { __typename?: 'LearnerPayorType', id: string, payorType: ApiLearnerPayorPayorTypeChoices, isActive: boolean, createdDate: any } | null } | null> }, learnerproviderSet: { __typename?: 'LearnerProviderTypeConnection', edges: Array<{ __typename?: 'LearnerProviderTypeEdge', node?: { __typename?: 'LearnerProviderType', id: string, provider: { __typename?: 'ProviderType', id: string, archived?: boolean | null, userRoles?: Array<any | null> | null, auth0User?: { __typename?: 'UserType', auth0id?: string | null } | null, providermetadata?: { __typename?: 'ProviderMetadataType', firstName: string, lastName?: string | null, email?: string | null, invitationId?: string | null, invitationStatus?: ApiProviderMetadataInvitationStatusChoices | null, invitationCreatedAt?: any | null, invitationExpiresAt?: any | null, invitationUrl?: string | null } | null } } | null } | null> } } | null };

export type GetLearnerConsentDetailsQueryVariables = Exact<{
  learnerId: Scalars['ID']['input'];
}>;


export type GetLearnerConsentDetailsQuery = { __typename?: 'Query', learnerById?: { __typename?: 'LearnerType', learnerconsentfilesSet: { __typename?: 'LearnerConsentFilesTypeConnection', edges: Array<{ __typename?: 'LearnerConsentFilesTypeEdge', node?: { __typename?: 'LearnerConsentFilesType', id: string, consentFile?: string | null, consentType?: ApiLearnerConsentFilesConsentTypeChoices | null, signedConsentFileUrl?: string | null, lastUpdatedDate: any, fileSizeInBytes?: any | null } | null } | null> } } | null };

export type OrganizationsQueryVariables = Exact<{ [key: string]: never; }>;


export type OrganizationsQuery = { __typename?: 'Query', organizations?: { __typename?: 'OrganizationTypeConnection', edges: Array<{ __typename?: 'OrganizationTypeEdge', node?: { __typename?: 'OrganizationType', id: string, name: string } | null } | null> } | null };

export type QueryProductPriceQueryVariables = Exact<{ [key: string]: never; }>;


export type QueryProductPriceQuery = { __typename?: 'Query', getProductPriceList?: Array<{ __typename?: 'ProductPriceListType', price?: number | null, priceId?: string | null, productId?: string | null, productName?: string | null, quantity?: number | null } | null> | null };

export type RecommendationBankFoldersQueryVariables = Exact<{
  searchTerm?: InputMaybe<Scalars['String']['input']>;
}>;


export type RecommendationBankFoldersQuery = { __typename?: 'Query', getRecommendationBankFolders?: { __typename?: 'RecommendationBankFoldersType', userFolders?: Array<{ __typename?: 'RecommendationBankFolderType', id: string, name: string, folderType: ApiRecommendationBankFolderFolderTypeChoices, recommendationsCount?: number | null } | null> | null, organizationFolders?: Array<{ __typename?: 'RecommendationBankFolderType', id: string, name: string, folderType: ApiRecommendationBankFolderFolderTypeChoices, recommendationsCount?: number | null } | null> | null } | null };

export type GetRecommendationBankItemsQueryVariables = Exact<{
  searchTerm?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetRecommendationBankItemsQuery = { __typename?: 'Query', getRecommendationBankItems?: Array<{ __typename?: 'RecommendationBankItemType', id: string, recommendationContent?: string | null, recommendationTitle?: string | null, recommendationCategory?: string | null, folder: { __typename?: 'RecommendationBankFolderType', id: string, name: string, folderType: ApiRecommendationBankFolderFolderTypeChoices } }> | null };

export type GetExportReportDocumentQueryVariables = Exact<{
  reportId: Scalars['ID']['input'];
  exportType: ExportTypeEnum;
}>;


export type GetExportReportDocumentQuery = { __typename?: 'Query', exportReportDocument?: { __typename?: 'ExportReportDocumentPayload', file?: any | null, fileName?: string | null } | null };

export type GetReportTemplateSuggestionCriteriaQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetReportTemplateSuggestionCriteriaQuery = { __typename?: 'Query', getReportTemplate?: { __typename?: 'ReportTemplateType', id: string, name: string, suggestionCriteria?: Array<{ __typename?: 'ReportTemplateSuggestionCriteriaType', id: string, enabled: boolean, suggestionCriteria: { __typename?: 'SuggestionCriteriaType', id: string, name: string, category: string, content: string, reportTemplates: { __typename?: 'ReportTemplateSuggestionCriteriaTypeConnection', edges: Array<{ __typename?: 'ReportTemplateSuggestionCriteriaTypeEdge', node?: { __typename?: 'ReportTemplateSuggestionCriteriaType', reportTemplate: { __typename?: 'ReportTemplateType', id: string, name: string } } | null } | null> } } } | null> | null } | null };

export type ExportReportTemplateJsonQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ExportReportTemplateJsonQuery = { __typename?: 'Query', exportReportTemplateJson?: { __typename?: 'ReportTemplateJSONType', json: any } | null };

export type ReportTemplateQueryVariables = Exact<{
  reportTemplateId: Scalars['ID']['input'];
}>;


export type ReportTemplateQuery = { __typename?: 'Query', getReportTemplate?: { __typename?: 'ReportTemplateType', id: string, name: string, description?: string | null, reportType: ApiReportTemplateReportTypeChoices, createdDate: any, status: ApiReportTemplateStatusChoices, lastUpdatedDate: any, headerText?: string | null, footerText?: string | null, exportTemplateFont: ApiReportTemplateExportTemplateFontChoices, sampleStatus: ApiReportTemplateSampleStatusChoices, sampleFileSignedUrl?: string | null, templateLogoSignedUrl?: string | null, defaultLogoSignedUrl?: string | null, curriculum?: { __typename?: 'CurriculumType', id: string, name: string } | null, treatmentPlanTemplate?: { __typename?: 'TreatmentPlanTemplateType', id: string, aiGenerationConfig: ApiTreatmentPlanTemplateAiGenerationConfigChoices, isGoalBankSuggestionsEnabled: boolean, isAddTargetsEnabled: boolean, templateFields: { __typename?: 'TreatmentPlanTemplateFieldTypeConnection', edges: Array<{ __typename?: 'TreatmentPlanTemplateFieldTypeEdge', node?: { __typename?: 'TreatmentPlanTemplateFieldType', id: string, fieldIdentifier: string, title?: string | null, fieldType: ApiTreatmentPlanTemplateFieldFieldTypeChoices, rankOrder: number, isRequired: boolean, isEnabled: boolean, isEditable: boolean, content?: string | null, type: ApiTreatmentPlanTemplateFieldTypeChoices, reportGoalField: boolean, reportTargetField: boolean, domain?: { __typename?: 'TreatmentPlanTemplateDomainType', id: string } | null } | null } | null> }, domains: { __typename?: 'TreatmentPlanTemplateDomainTypeConnection', edges: Array<{ __typename?: 'TreatmentPlanTemplateDomainTypeEdge', node?: { __typename?: 'TreatmentPlanTemplateDomainType', id: string, name: string, description?: string | null, rankOrder: number, templateFields: { __typename?: 'TreatmentPlanTemplateFieldTypeConnection', edges: Array<{ __typename?: 'TreatmentPlanTemplateFieldTypeEdge', node?: { __typename?: 'TreatmentPlanTemplateFieldType', id: string, fieldIdentifier: string, title?: string | null, fieldType: ApiTreatmentPlanTemplateFieldFieldTypeChoices, rankOrder: number, isRequired: boolean, isEditable: boolean, isEnabled: boolean, content?: string | null, type: ApiTreatmentPlanTemplateFieldTypeChoices, reportGoalField: boolean, reportTargetField: boolean } | null } | null> } } | null } | null> } } | null, reportTemplateSections: { __typename?: 'ReportTemplateSectionTypeConnection', edges: Array<{ __typename?: 'ReportTemplateSectionTypeEdge', node?: { __typename?: 'ReportTemplateSectionType', id: string, key?: string | null, rankOrder: number, pageLocation: ApiReportTemplateSectionPageLocationChoices, title: string, inputDependency?: Array<InputDependencyChoices | null> | null, isDefault: boolean, reportTemplateSectionFields: { __typename?: 'ReportTemplateSectionFieldTypeConnection', edges: Array<{ __typename?: 'ReportTemplateSectionFieldTypeEdge', node?: { __typename?: 'ReportTemplateSectionFieldType', id: string, title?: string | null, rankOrder: number, fieldType: ApiReportTemplateSectionFieldFieldTypeChoices, isRequired: boolean, isAuditable: boolean, content?: string | null, sampleData?: string | null, inputDependency?: Array<InputDependencyChoices | null> | null, isDefault: boolean, prompt?: { __typename?: 'PromptType', id: string, key: string, name: string } | null } | null } | null> } } | null } | null> } } | null };

export type ReportTemplateGlobalsQueryVariables = Exact<{
  reportTemplateId: Scalars['ID']['input'];
}>;


export type ReportTemplateGlobalsQuery = { __typename?: 'Query', getReportTemplateGlobals?: { __typename?: 'ReportTemplateSectionFieldTypeConnection', edges: Array<{ __typename?: 'ReportTemplateSectionFieldTypeEdge', node?: { __typename?: 'ReportTemplateSectionFieldType', id: string, title?: string | null, fieldIdentifier: string, rankOrder: number, fieldType: ApiReportTemplateSectionFieldFieldTypeChoices, isRequired: boolean, content?: string | null, sampleData?: string | null, inputDependency?: Array<InputDependencyChoices | null> | null, prompt?: { __typename?: 'PromptType', id: string, key: string, name: string } | null } | null } | null> } | null };

export type ReportTemplateSampleStatusQueryVariables = Exact<{
  reportTemplateId: Scalars['ID']['input'];
}>;


export type ReportTemplateSampleStatusQuery = { __typename?: 'Query', getReportTemplate?: { __typename?: 'ReportTemplateType', sampleStatus: ApiReportTemplateSampleStatusChoices, sampleFileSignedUrl?: string | null } | null };

export type ReportTemplatesQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  filter: GetReportTemplatesFilter;
}>;


export type ReportTemplatesQuery = { __typename?: 'Query', getReportTemplates?: { __typename?: 'ReportTemplateTypeConnection', totalCount?: number | null, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean }, edges: Array<{ __typename?: 'ReportTemplateTypeEdge', cursor: string, node?: { __typename?: 'ReportTemplateType', id: string, name: string, description?: string | null, isBaseTemplate: boolean, reportType: ApiReportTemplateReportTypeChoices, payorType?: ApiReportTemplatePayorTypeChoices | null, createdDate: any, status: ApiReportTemplateStatusChoices, lastUpdatedDate: any } | null } | null> } | null };

export type AssessmentToolsQueryVariables = Exact<{
  reportType: ReportTypeEnums;
}>;


export type AssessmentToolsQuery = { __typename?: 'Query', assessmentTools?: Array<{ __typename?: 'AssessmentToolType', id?: string | null, primary?: string | null, secondary?: string | null, categories?: Array<DiagnosisEvaluationAssessmentToolCategoriesEnum | null> | null, multipleFileUpload?: boolean | null, supportedFileTypes?: Array<string | null> | null, supportedFileSource?: Array<LearnerFileAssessmentTemplateTypeEnums | null> | null, parsingSupported?: boolean | null } | null> | null };

export type GetRecentlyViewedReportsQueryVariables = Exact<{
  reportIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type GetRecentlyViewedReportsQuery = { __typename?: 'Query', getReports?: { __typename?: 'ReportTypeConnection', edges: Array<{ __typename?: 'ReportTypeEdge', node?: { __typename?: 'ReportType', id: string, reportType: ApiReportReportTypeChoices, reportStatus: ApiReportReportStatusChoices, reportClientDetails?: { __typename?: 'ReportClientDetailsType', clientFirstName: string, clientLastName?: string | null } | null, payorreportsubmissionSet: { __typename?: 'PayorReportSubmissionTypeConnection', edges: Array<{ __typename?: 'PayorReportSubmissionTypeEdge', node?: { __typename?: 'PayorReportSubmissionType', id: string, status: ApiPayorReportSubmissionStatusChoices, submittedAt?: any | null, reviews: { __typename?: 'PayorReportReviewTypeConnection', edges: Array<{ __typename?: 'PayorReportReviewTypeEdge', node?: { __typename?: 'PayorReportReviewType', id: string, status: ApiPayorReportReviewStatusChoices, createdDate: any } | null } | null> } } | null } | null> } } | null } | null> } | null };

export type GetReportReviewersQueryVariables = Exact<{
  reportId: Scalars['ID']['input'];
}>;


export type GetReportReviewersQuery = { __typename?: 'Query', getReportReviewers: Array<{ __typename?: 'ReportReviewerType', id: string, createdDate: any, type: ReportReviewerKind, status?: ReportReviewerStatus | null, reviewer?: { __typename?: 'ReportReviewUserType', id: string, firstName: string, lastName?: string | null, email?: string | null } | null, statusLog: Array<{ __typename?: 'ReportReviewerStatusLogType', id: string, createdDate: any, status: ReportReviewerStatus, note: string, actor?: { __typename?: 'ReportReviewUserType', id: string, firstName: string, lastName?: string | null } | null }> }> };

export type GetReviewerCandidatesQueryVariables = Exact<{
  where?: InputMaybe<ProviderBoolExp>;
  first?: InputMaybe<Scalars['Int']['input']>;
  includeInternal?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetReviewerCandidatesQuery = { __typename?: 'Query', getOrganizationProviders?: { __typename?: 'ProviderTypeConnection', edges: Array<{ __typename?: 'ProviderTypeEdge', node?: { __typename?: 'ProviderType', id: string, auth0User?: { __typename?: 'UserType', id: string } | null, organizationuserrolesSet: { __typename?: 'OrganizationUserRolesTypeConnection', edges: Array<{ __typename?: 'OrganizationUserRolesTypeEdge', node?: { __typename?: 'OrganizationUserRolesType', role: ApiOrganizationUserRolesRoleChoices } | null } | null> }, providermetadata?: { __typename?: 'ProviderMetadataType', id: string, firstName: string, lastName?: string | null, email?: string | null } | null } | null } | null> } | null };

export type GetCumulativeTargetsQueryVariables = Exact<{
  filter: GetCumulativeTargetsFilter;
}>;


export type GetCumulativeTargetsQuery = { __typename?: 'Query', getCumulativeTargets?: Array<{ __typename?: 'CumulativeTargets', date?: any | null, totalCount?: number | null } | null> | null };

export type GetSessionTargetProgressQueryVariables = Exact<{
  filter: GetSessionProgressFilter;
}>;


export type GetSessionTargetProgressQuery = { __typename?: 'Query', getSessionProgress?: { __typename?: 'GetSessionProgressType', goalPhases?: Array<{ __typename?: 'PhaseChangeType', status?: string | null, date?: any | null } | null> | null, goalEvents?: Array<{ __typename?: 'EventType', text?: string | null, date?: any | null } | null> | null, progress?: Array<{ __typename?: 'TargetProgressType', targetId?: string | null, targetName?: string | null, progressType?: string | null, data?: Array<{ __typename?: 'ProgressDataPointType', value?: number | null, date?: any | null } | null> | null, phases?: Array<{ __typename?: 'PhaseChangeType', status?: string | null, date?: any | null } | null> | null, events?: Array<{ __typename?: 'EventType', text?: string | null, date?: any | null } | null> | null } | null> | null } | null };

export type GetPayorReportSubmissionStatusByReportIdQueryVariables = Exact<{
  reportId: Scalars['ID']['input'];
}>;


export type GetPayorReportSubmissionStatusByReportIdQuery = { __typename?: 'Query', getPayorReportSubmissionsByReportId?: { __typename?: 'PayorReportSubmissionTypeConnection', edges: Array<{ __typename?: 'PayorReportSubmissionTypeEdge', node?: { __typename?: 'PayorReportSubmissionType', id: string, jobId: any, status: ApiPayorReportSubmissionStatusChoices } | null } | null> } | null };

export type GetPayorReportSubmissionWorkflowStatusQueryVariables = Exact<{
  reportSubmissionId: Scalars['ID']['input'];
}>;


export type GetPayorReportSubmissionWorkflowStatusQuery = { __typename?: 'Query', getPayorReportSubmissionStatus?: { __typename?: 'PayorReportSubmissionType', jobId: any, status: ApiPayorReportSubmissionStatusChoices } | null };

export type GetReportReviewItemsQueryVariables = Exact<{
  reportId: Scalars['ID']['input'];
  filter?: InputMaybe<ReportReviewItemFilterInput>;
}>;


export type GetReportReviewItemsQuery = { __typename?: 'Query', getReportReviewItems?: Array<{ __typename: 'ReportCommentType', baseValue?: string | null, proposedValue?: string | null, editedAt?: any | null, canEdit: boolean, canDelete: boolean, isDeleted: boolean, id: string, content?: string | null, status: string, hidden: boolean, createdDate: any, resolvedAt?: any | null, goalField?: string | null, targetField?: string | null, author?: { __typename?: 'ReportReviewUserType', id: string, firstName: string, lastName?: string | null, email?: string | null } | null, resolvedBy?: { __typename?: 'ReportReviewUserType', id: string, firstName: string, lastName?: string | null, email?: string | null } | null, reportSectionField?: { __typename?: 'ReportSectionFieldsType', id: string, title?: string | null } | null, reportGoal?: { __typename?: 'ReportGoalType', id: string, goalName: string, excludeFromReport: boolean } | null, reportTarget?: { __typename?: 'ReportTargetType', id: string, targetName: string, inUse: boolean, excludeFromReport: boolean } | null, parent?: { __typename: 'ReportCommentType', id: string } | { __typename: 'ReportSuggestionType', id: string } | null } | { __typename: 'ReportSuggestionType', category: string, id: string, content?: string | null, status: string, hidden: boolean, createdDate: any, resolvedAt?: any | null, goalField?: string | null, targetField?: string | null, resolvedBy?: { __typename?: 'ReportReviewUserType', id: string, firstName: string, lastName?: string | null, email?: string | null } | null, reportSectionField?: { __typename?: 'ReportSectionFieldsType', id: string, title?: string | null } | null, reportGoal?: { __typename?: 'ReportGoalType', id: string, goalName: string, excludeFromReport: boolean } | null, reportTarget?: { __typename?: 'ReportTargetType', id: string, targetName: string, inUse: boolean, excludeFromReport: boolean } | null, parent?: { __typename: 'ReportCommentType', id: string } | { __typename: 'ReportSuggestionType', id: string } | null } | null> | null };

export type GetSuggestionWorkflowStatusQueryVariables = Exact<{
  reportId: Scalars['ID']['input'];
  filter: GetReportsFilter;
}>;


export type GetSuggestionWorkflowStatusQuery = { __typename?: 'Query', getReports?: { __typename?: 'ReportTypeConnection', edges: Array<{ __typename?: 'ReportTypeEdge', node?: { __typename?: 'ReportType', id: string, suggestionGenerationStatus?: ApiReportSuggestionGenerationStatusChoices | null } | null } | null> } | null };

export type GetReportByIdQueryVariables = Exact<{
  reportId: Scalars['ID']['input'];
  filter: GetReportsFilter;
}>;


export type GetReportByIdQuery = { __typename?: 'Query', getReports?: { __typename?: 'ReportTypeConnection', totalCount?: number | null, edges: Array<{ __typename?: 'ReportTypeEdge', node?: { __typename?: 'ReportType', id: string, createdDate: any, lastUpdatedDate: any, reportStatus: ApiReportReportStatusChoices, extendedStatus?: ReportStatusExtendedEnums | null, reportPdfFileSignedUrl?: string | null, reportDocxFileSignedUrl?: string | null, reportType: ApiReportReportTypeChoices, headerPageHeading?: string | null, isArchive: boolean, reportMetaData?: any | null, reportWriter?: string | null, completionDate?: any | null, previousReportStartDate?: any | null, previousReportEndDate?: any | null, previousReportSubmittedDate?: any | null, ehrSync?: ApiReportEhrSyncChoices | null, narrativeMappingInProgress?: boolean | null, suggestionGenerationStatus?: ApiReportSuggestionGenerationStatusChoices | null, ehrSyncAlerts?: { __typename?: 'EHRSyncAlertsType', importAlert?: { __typename?: 'EHRSyncAlertType', error?: string | null, userMessage?: string | null, warnings?: Array<{ __typename?: 'EHRSyncWarningType', description: string, affectedItems: Array<{ __typename?: 'EHRSyncAffectedItemType', message: string }> } | null> | null } | null, exportAlert?: { __typename?: 'EHRSyncAlertType', error?: string | null, userMessage?: string | null, warnings?: Array<{ __typename?: 'EHRSyncWarningType', description: string, affectedItems: Array<{ __typename?: 'EHRSyncAffectedItemType', message: string }> } | null> | null } | null } | null, learner?: { __typename?: 'LearnerType', id: string, externalId?: string | null } | null, createdBy?: { __typename?: 'UserType', id: string, provider?: { __typename?: 'ProviderType', id: string, providermetadata?: { __typename?: 'ProviderMetadataType', id: string, firstName: string, lastName?: string | null } | null } | null } | null, reportFiles: { __typename?: 'LearnerFileTypeConnection', edges: Array<{ __typename?: 'LearnerFileTypeEdge', node?: { __typename?: 'LearnerFileType', createdDate: any, id: string, originalFileName: string, fileKind: ApiLearnerFileFileKindChoices, status: ApiLearnerFileStatusChoices, mimeType: string, fileSize: any, metadata?: any | null, assessmentTemplateType?: ApiLearnerFileAssessmentTemplateTypeChoices | null, signedS3LearnerFile?: string | null, pdfPreviewStatus?: ApiLearnerFilePdfPreviewStatusChoices | null, pdfPreviewSignedUrl?: string | null, processingFailureReason?: string | null, processingFailureCode?: ApiLearnerFileProcessingFailureCodeChoices | null, parentFile?: { __typename?: 'LearnerFileType', id: string } | null } | null } | null> }, reportClientDetails?: { __typename?: 'ReportClientDetailsType', id: string, clientFirstName: string, clientLastName?: string | null, guardianFirstName: string, guardianLastName?: string | null, guardian2FirstName?: string | null, guardian2LastName?: string | null, birthDate?: any | null, address?: string | null, addressLine2?: string | null, city?: string | null, state?: string | null, zip?: string | null, gender?: ApiReportClientDetailsGenderChoices | null, specifyGender?: string | null } | null, reportTreatmentPlanPrioritizeFields?: { __typename?: 'ReportTreatmentPlanPrioritizeFieldsType', safetyConcerns?: Array<string | null> | null, familyLife?: Array<string | null> | null, engagementAbility?: boolean | null, communicationAbility?: Array<string | null> | null, socialDesires?: string | null, additionalUserDetails?: string | null } | null, reportTreatmentPlan?: { __typename?: 'ReportTreatmentPlanType', aiLtgPredictionStatus: ApiReportTreatmentPlanAiLtgPredictionStatusChoices, aiStgPredictionStatus: ApiReportTreatmentPlanAiStgPredictionStatusChoices, aiTargetPredictionStatus: ApiReportTreatmentPlanAiTargetPredictionStatusChoices, aiGoalProgressSummaryPredictionStatus: ApiReportTreatmentPlanAiGoalProgressSummaryPredictionStatusChoices, aiGoalSuggestionStatus: ApiReportTreatmentPlanAiGoalSuggestionStatusChoices, failureReason?: string | null, reportdomainSet: { __typename?: 'ReportDomainTypeConnection', edges: Array<{ __typename?: 'ReportDomainTypeEdge', node?: { __typename?: 'ReportDomainType', id: string, createdDate: any, name: string, description?: string | null } | null } | null> }, reportgoalSet: { __typename?: 'ReportGoalTypeConnection', edges: Array<{ __typename?: 'ReportGoalTypeEdge', node?: { __typename?: 'ReportGoalType', id: string, assessmentToolSource?: string | null, baselineDate?: any | null, generalizationCriteria?: string | null, rationale?: string | null, createdDate: any, goalName: string, programGoal?: string | null, description?: string | null, timelineEstimationType?: ApiReportGoalTimelineEstimationTypeChoices | null, timelineEstimationValue?: number | null, baselineData?: string | null, aiGoalAttainmentScalePredictionStatus: ApiReportGoalAiGoalAttainmentScalePredictionStatusChoices, gasLevel1?: string | null, gasLevel3?: string | null, gasLevel4?: string | null, gasMatchStatus: ApiReportGoalGasMatchStatusChoices, gasMatchMessage?: string | null, masteryCriteria?: string | null, hasMedicalNecessity: boolean, medicalNecessityCriteria?: string | null, status?: ApiReportGoalStatusChoices | null, goalType?: string | null, tags?: any | null, progressSummary?: string | null, inUse: boolean, aiGenerated: boolean, reportDomain?: { __typename?: 'ReportDomainType', id: string } | null } | null } | null> } } | null, reportSections: { __typename?: 'ReportSectionsTypeConnection', edges: Array<{ __typename?: 'ReportSectionsTypeEdge', node?: { __typename?: 'ReportSectionsType', id: string, title: string, aiGeneratedStatus: ApiReportSectionsAiGeneratedStatusChoices, lastUpdatedDate: any, rankOrder: number, sectionIdentifier?: string | null, pageLocation: string, previousPageLocation?: string | null, sectionField: { __typename?: 'ReportSectionFieldsTypeConnection', edges: Array<{ __typename?: 'ReportSectionFieldsTypeEdge', node?: { __typename?: 'ReportSectionFieldsType', id: string, fieldType: ApiReportSectionFieldsFieldTypeChoices, title?: string | null, content?: string | null, aiGenerated: boolean, rankOrder: number, imageSignedUrl?: string | null, fieldIdentifier: string, imageContentBase64?: string | null, aiSources?: string | null, templateSectionField?: { __typename?: 'ReportTemplateSectionFieldType', isRequired: boolean, inputDependency?: Array<InputDependencyChoices | null> | null } | null, aiSectionField?: { __typename?: 'ReportSectionAiFieldsType', templateSectionField?: { __typename?: 'ReportTemplateSectionFieldType', prompt?: { __typename?: 'PromptType', id: string } | null } | null } | null } | null } | null> } } | null } | null> }, payorreportsubmissionSet: { __typename?: 'PayorReportSubmissionTypeConnection', edges: Array<{ __typename?: 'PayorReportSubmissionTypeEdge', node?: { __typename?: 'PayorReportSubmissionType', id: string, status: ApiPayorReportSubmissionStatusChoices, submittedAt?: any | null, reviews: { __typename?: 'PayorReportReviewTypeConnection', edges: Array<{ __typename?: 'PayorReportReviewTypeEdge', node?: { __typename?: 'PayorReportReviewType', id: string, status: ApiPayorReportReviewStatusChoices, createdDate: any, feedback?: string | null, feedbackFilePath?: string | null, feedbackFileSignedUrl?: string | null } | null } | null> } } | null } | null> }, reportTemplate?: { __typename?: 'ReportTemplateType', id: string, name: string, reportType: ApiReportTemplateReportTypeChoices, payorType?: ApiReportTemplatePayorTypeChoices | null, exportTemplateFont: ApiReportTemplateExportTemplateFontChoices, templateUrl?: string | null, templateResolvedUrl?: string | null, exportFramework: ApiReportTemplateExportFrameworkChoices, unifiedExport: boolean, isBaseTemplate: boolean, organizationLogoAllowed: boolean, fileUploadConfig: ApiReportTemplateFileUploadConfigChoices, templateLogoSignedUrl?: string | null, requireAllQaResolved: boolean, requireApprovalBeforeExport?: boolean | null, finalApproverWaitsForReviewers?: boolean | null, treatmentPlanTemplate?: { __typename?: 'TreatmentPlanTemplateType', isGasEnabled: boolean, isAddTargetsEnabled: boolean } | null, reportTemplateSections: { __typename?: 'ReportTemplateSectionTypeConnection', edges: Array<{ __typename?: 'ReportTemplateSectionTypeEdge', node?: { __typename?: 'ReportTemplateSectionType', id: string, pageLocation: ApiReportTemplateSectionPageLocationChoices, reportTemplateSectionFields: { __typename?: 'ReportTemplateSectionFieldTypeConnection', totalCount?: number | null } } | null } | null> } } | null, organization: { __typename?: 'OrganizationType', organizationType: ApiOrganizationOrganizationTypeChoices, templateLogoSignedUrl?: string | null, requireAllQaResolved: boolean, peerReviewEnabled: boolean, requireApprovalBeforeExport: boolean, finalApproverWaitsForReviewers: boolean } } | null } | null> } | null };

export type GetReportsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  filter: GetReportsFilter;
  records?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetReportsQuery = { __typename?: 'Query', getReports?: { __typename?: 'ReportTypeConnection', totalCount?: number | null, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean }, edges: Array<{ __typename?: 'ReportTypeEdge', cursor: string, node?: { __typename?: 'ReportType', id: string, createdDate: any, lastUpdatedDate: any, reportStatus: ApiReportReportStatusChoices, extendedStatus?: ReportStatusExtendedEnums | null, ehrSync?: ApiReportEhrSyncChoices | null, reportType: ApiReportReportTypeChoices, headerPageHeading?: string | null, isArchive: boolean, reportMetaData?: any | null, reportWriter?: string | null, reportTemplate?: { __typename?: 'ReportTemplateType', id: string, name: string, isBaseTemplate: boolean, organizationLogoAllowed: boolean, fileUploadConfig: ApiReportTemplateFileUploadConfigChoices, payorType?: ApiReportTemplatePayorTypeChoices | null } | null, payorreportsubmissionSet: { __typename?: 'PayorReportSubmissionTypeConnection', edges: Array<{ __typename?: 'PayorReportSubmissionTypeEdge', node?: { __typename?: 'PayorReportSubmissionType', id: string, status: ApiPayorReportSubmissionStatusChoices, submittedAt?: any | null, reviews: { __typename?: 'PayorReportReviewTypeConnection', edges: Array<{ __typename?: 'PayorReportReviewTypeEdge', node?: { __typename?: 'PayorReportReviewType', id: string, status: ApiPayorReportReviewStatusChoices, createdDate: any } | null } | null> } } | null } | null> }, learner?: { __typename?: 'LearnerType', id: string } | null, organization: { __typename?: 'OrganizationType', templateLogoSignedUrl?: string | null }, reportTreatmentPlan?: { __typename?: 'ReportTreatmentPlanType', aiLtgPredictionStatus: ApiReportTreatmentPlanAiLtgPredictionStatusChoices, aiStgPredictionStatus: ApiReportTreatmentPlanAiStgPredictionStatusChoices, aiTargetPredictionStatus: ApiReportTreatmentPlanAiTargetPredictionStatusChoices, aiGoalProgressSummaryPredictionStatus: ApiReportTreatmentPlanAiGoalProgressSummaryPredictionStatusChoices } | null, reportFiles: { __typename?: 'LearnerFileTypeConnection', edges: Array<{ __typename?: 'LearnerFileTypeEdge', node?: { __typename?: 'LearnerFileType', id: string, fileKind: ApiLearnerFileFileKindChoices, status: ApiLearnerFileStatusChoices, processingFailureReason?: string | null } | null } | null> }, createdBy?: { __typename?: 'UserType', id: string, provider?: { __typename?: 'ProviderType', providermetadata?: { __typename?: 'ProviderMetadataType', firstName: string, lastName?: string | null } | null } | null } | null, reportClientDetails?: { __typename?: 'ReportClientDetailsType', id: string, clientFirstName: string, clientLastName?: string | null } | null, reportTreatmentPlanPrioritizeFields?: { __typename?: 'ReportTreatmentPlanPrioritizeFieldsType', safetyConcerns?: Array<string | null> | null, familyLife?: Array<string | null> | null, engagementAbility?: boolean | null, communicationAbility?: Array<string | null> | null, socialDesires?: string | null, additionalUserDetails?: string | null } | null, reportSections: { __typename?: 'ReportSectionsTypeConnection', edges: Array<{ __typename?: 'ReportSectionsTypeEdge', node?: { __typename?: 'ReportSectionsType', id: string, aiGeneratedStatus: ApiReportSectionsAiGeneratedStatusChoices, lastUpdatedDate: any, pageLocation: string, previousPageLocation?: string | null } | null } | null> } } | null } | null> } | null };

export type GetReportsWithReviewStateQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  filter: GetReportsFilter;
  records?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetReportsWithReviewStateQuery = { __typename?: 'Query', getReports?: { __typename?: 'ReportTypeConnection', totalCount?: number | null, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean }, edges: Array<{ __typename?: 'ReportTypeEdge', cursor: string, node?: { __typename?: 'ReportType', id: string, createdDate: any, lastUpdatedDate: any, reportStatus: ApiReportReportStatusChoices, extendedStatus?: ReportStatusExtendedEnums | null, ehrSync?: ApiReportEhrSyncChoices | null, reportType: ApiReportReportTypeChoices, myReviewState?: ReportReviewView | null, headerPageHeading?: string | null, isArchive: boolean, reportMetaData?: any | null, reportWriter?: string | null, reportTemplate?: { __typename?: 'ReportTemplateType', id: string, name: string, isBaseTemplate: boolean, organizationLogoAllowed: boolean, fileUploadConfig: ApiReportTemplateFileUploadConfigChoices, payorType?: ApiReportTemplatePayorTypeChoices | null } | null, payorreportsubmissionSet: { __typename?: 'PayorReportSubmissionTypeConnection', edges: Array<{ __typename?: 'PayorReportSubmissionTypeEdge', node?: { __typename?: 'PayorReportSubmissionType', id: string, status: ApiPayorReportSubmissionStatusChoices, submittedAt?: any | null, reviews: { __typename?: 'PayorReportReviewTypeConnection', edges: Array<{ __typename?: 'PayorReportReviewTypeEdge', node?: { __typename?: 'PayorReportReviewType', id: string, status: ApiPayorReportReviewStatusChoices, createdDate: any } | null } | null> } } | null } | null> }, learner?: { __typename?: 'LearnerType', id: string } | null, organization: { __typename?: 'OrganizationType', templateLogoSignedUrl?: string | null }, reportTreatmentPlan?: { __typename?: 'ReportTreatmentPlanType', aiLtgPredictionStatus: ApiReportTreatmentPlanAiLtgPredictionStatusChoices, aiStgPredictionStatus: ApiReportTreatmentPlanAiStgPredictionStatusChoices, aiTargetPredictionStatus: ApiReportTreatmentPlanAiTargetPredictionStatusChoices, aiGoalProgressSummaryPredictionStatus: ApiReportTreatmentPlanAiGoalProgressSummaryPredictionStatusChoices } | null, reportFiles: { __typename?: 'LearnerFileTypeConnection', edges: Array<{ __typename?: 'LearnerFileTypeEdge', node?: { __typename?: 'LearnerFileType', id: string, fileKind: ApiLearnerFileFileKindChoices, status: ApiLearnerFileStatusChoices, processingFailureReason?: string | null } | null } | null> }, createdBy?: { __typename?: 'UserType', id: string, provider?: { __typename?: 'ProviderType', providermetadata?: { __typename?: 'ProviderMetadataType', firstName: string, lastName?: string | null } | null } | null } | null, reportClientDetails?: { __typename?: 'ReportClientDetailsType', id: string, clientFirstName: string, clientLastName?: string | null } | null, reportTreatmentPlanPrioritizeFields?: { __typename?: 'ReportTreatmentPlanPrioritizeFieldsType', safetyConcerns?: Array<string | null> | null, familyLife?: Array<string | null> | null, engagementAbility?: boolean | null, communicationAbility?: Array<string | null> | null, socialDesires?: string | null, additionalUserDetails?: string | null } | null, reportSections: { __typename?: 'ReportSectionsTypeConnection', edges: Array<{ __typename?: 'ReportSectionsTypeEdge', node?: { __typename?: 'ReportSectionsType', id: string, aiGeneratedStatus: ApiReportSectionsAiGeneratedStatusChoices, lastUpdatedDate: any, pageLocation: string, previousPageLocation?: string | null } | null } | null> } } | null } | null> } | null };

export type GetReassessmentEhrGoalsQueryVariables = Exact<{
  reportId: Scalars['ID']['input'];
}>;


export type GetReassessmentEhrGoalsQuery = { __typename?: 'Query', reassessmentEhrGoals?: Array<{ __typename?: 'EhrGoal', goalId: string, title: string, lastUpdatedDate: any, status?: string | null, reportGoalCreated: boolean, ehrTargets?: Array<{ __typename?: 'EhrTarget', targetId: string, title: string, lastUpdatedDate: any, status?: string | null, reportTargetExcluded?: boolean | null } | null> | null } | null> | null };

export type GetTargetsQueryVariables = Exact<{
  filter: GetTargetsFilter;
}>;


export type GetTargetsQuery = { __typename?: 'Query', getReportTargets?: { __typename?: 'ReportTargetTypeConnection', edges: Array<{ __typename?: 'ReportTargetTypeEdge', node?: { __typename?: 'ReportTargetType', id: string, aiGenerated: boolean, inUse: boolean, baselineData?: string | null, completionDate?: any | null, createdDate: any, excludeFromReport: boolean, lastUpdatedDate: any, masteryCriteria?: string | null, progressSummary?: string | null, status?: ApiReportTargetStatusChoices | null, targetDescription?: string | null, targetName: string, timelineEstimationType?: ApiReportTargetTimelineEstimationTypeChoices | null, timelineEstimationValue?: number | null } | null } | null> } | null };

export type GetReportTreatmentPlanByReportIdQueryVariables = Exact<{
  reportId: Scalars['ID']['input'];
  filter: GetReportsFilter;
}>;


export type GetReportTreatmentPlanByReportIdQuery = { __typename?: 'Query', getReports?: { __typename?: 'ReportTypeConnection', totalCount?: number | null, edges: Array<{ __typename?: 'ReportTypeEdge', node?: { __typename?: 'ReportType', id: string, reportStatus: ApiReportReportStatusChoices, reportTreatmentPlan?: { __typename?: 'ReportTreatmentPlanType', reportgoalSet: { __typename?: 'ReportGoalTypeConnection', edges: Array<{ __typename?: 'ReportGoalTypeEdge', node?: { __typename?: 'ReportGoalType', id: string, createdDate: any, assessmentToolSource?: string | null, baselineDate?: any | null, generalizationCriteria?: string | null, rationale?: string | null, goalName: string, goalType?: string | null, status?: ApiReportGoalStatusChoices | null, programGoal?: string | null, description?: string | null, timelineEstimationType?: ApiReportGoalTimelineEstimationTypeChoices | null, timelineEstimationValue?: number | null, baselineData?: string | null, masteryCriteria?: string | null, hasMedicalNecessity: boolean, medicalNecessityCriteria?: string | null, aiGoalAttainmentScalePredictionStatus: ApiReportGoalAiGoalAttainmentScalePredictionStatusChoices, gasLevel1?: string | null, gasLevel3?: string | null, gasLevel4?: string | null, progressSummary?: string | null, summaryReviewed: boolean, summaryReviewedOn?: any | null, goal?: { __typename?: 'GoalType', id: string } | null, goalBank?: { __typename?: 'ReportGoalBankType', id: string } | null, reportDomain?: { __typename?: 'ReportDomainType', id: string, name: string } | null, reporttargetSet: { __typename?: 'ReportTargetTypeConnection', edges: Array<{ __typename?: 'ReportTargetTypeEdge', node?: { __typename?: 'ReportTargetType', id: string, aiGenerated: boolean, createdDate: any, lastUpdatedDate: any, targetName: string, status?: ApiReportTargetStatusChoices | null, targetDescription?: string | null, timelineEstimationValue?: number | null, timelineEstimationType?: ApiReportTargetTimelineEstimationTypeChoices | null, masteryCriteria?: string | null, baselineData?: string | null, progressSummary?: string | null, summaryReviewed: boolean, summaryReviewedOn?: any | null } | null } | null> } } | null } | null> } } | null } | null } | null> } | null };

export type GetReassessmentReportGoalsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  filter: GetReassessmentReportGoalsFilter;
}>;


export type GetReassessmentReportGoalsQuery = { __typename?: 'Query', getReassessmentReportGoals?: { __typename?: 'ReportGoalTypeConnection', totalCount?: number | null, totalNeedReview?: number | null, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean }, edges: Array<{ __typename?: 'ReportGoalTypeEdge', cursor: string, node?: { __typename?: 'ReportGoalType', id: string, createdDate: any, assessmentToolSource?: string | null, baselineDate?: any | null, goalName: string, programGoal?: string | null, description?: string | null, timelineEstimationType?: ApiReportGoalTimelineEstimationTypeChoices | null, timelineEstimationValue?: number | null, aiGoalAttainmentScalePredictionStatus: ApiReportGoalAiGoalAttainmentScalePredictionStatusChoices, gasLevel1?: string | null, gasLevel3?: string | null, gasLevel4?: string | null, gasMatchStatus: ApiReportGoalGasMatchStatusChoices, gasMatchMessage?: string | null, gasScore?: string | null, completionDate?: any | null, projectedIntroductionDate?: any | null, baselineData?: string | null, masteryCriteria?: string | null, hasMedicalNecessity: boolean, medicalNecessityCriteria?: string | null, generalizationCriteria?: string | null, rationale?: string | null, status?: ApiReportGoalStatusChoices | null, goalType?: string | null, goalSubType?: string | null, tags?: any | null, progressSummary?: string | null, summaryReviewed: boolean, summaryReviewedOn?: any | null, excludeFromReport: boolean, chartType?: ApiReportGoalChartTypeChoices | null, signedChartImageUrl?: string | null, goal?: { __typename?: 'GoalType', id: string, rankOrder: number } | null, reportDomain?: { __typename?: 'ReportDomainType', id: string, name: string } | null, goalBank?: { __typename?: 'ReportGoalBankType', id: string } | null, customFields: { __typename?: 'TreatmentPlanCustomFieldTypeConnection', edges: Array<{ __typename?: 'TreatmentPlanCustomFieldTypeEdge', node?: { __typename?: 'TreatmentPlanCustomFieldType', id: string, fieldIdentifier: string, fieldType: ApiTreatmentPlanCustomFieldFieldTypeChoices, title?: string | null, content?: string | null, rankOrder: number, imageSignedUrl?: string | null } | null } | null> }, reporttargetSet: { __typename?: 'ReportTargetTypeConnection', edges: Array<{ __typename?: 'ReportTargetTypeEdge', node?: { __typename?: 'ReportTargetType', id: string, aiGenerated: boolean, inUse: boolean, createdDate: any, lastUpdatedDate: any, targetName: string, targetDescription?: string | null, timelineEstimationValue?: number | null, timelineEstimationType?: ApiReportTargetTimelineEstimationTypeChoices | null, completionDate?: any | null, masteryCriteria?: string | null, baselineData?: string | null, status?: ApiReportTargetStatusChoices | null, progressSummary?: string | null, excludeFromReport: boolean, signedChartImageUrl?: string | null, summaryReviewed: boolean, projectedIntroductionDate?: any | null, customFields: { __typename?: 'TreatmentPlanCustomFieldTypeConnection', edges: Array<{ __typename?: 'TreatmentPlanCustomFieldTypeEdge', node?: { __typename?: 'TreatmentPlanCustomFieldType', id: string, fieldIdentifier: string, fieldType: ApiTreatmentPlanCustomFieldFieldTypeChoices, title?: string | null, content?: string | null, rankOrder: number, imageSignedUrl?: string | null } | null } | null> } } | null } | null> } } | null } | null> } | null };

export type TreatmentPlanTemplateQueryVariables = Exact<{
  reportId: Scalars['ID']['input'];
}>;


export type TreatmentPlanTemplateQuery = { __typename?: 'Query', treatmentPlanTemplate?: { __typename?: 'TreatmentPlanTemplateType', isGasEnabled: boolean, isMedicalNecessityEnabled: boolean, aiGenerationConfig: ApiTreatmentPlanTemplateAiGenerationConfigChoices, isAddTargetsEnabled: boolean, isGoalBankSuggestionsEnabled: boolean, templateFields: { __typename?: 'TreatmentPlanTemplateFieldTypeConnection', edges: Array<{ __typename?: 'TreatmentPlanTemplateFieldTypeEdge', node?: { __typename?: 'TreatmentPlanTemplateFieldType', id: string, fieldIdentifier: string, title?: string | null, fieldType: ApiTreatmentPlanTemplateFieldFieldTypeChoices, rankOrder: number, isRequired: boolean, isEnabled: boolean, content?: string | null, type: ApiTreatmentPlanTemplateFieldTypeChoices, reportGoalField: boolean, reportTargetField: boolean, domain?: { __typename?: 'TreatmentPlanTemplateDomainType', id: string, name: string } | null } | null } | null> } } | null };

export type ReportExportDataQueryVariables = Exact<{
  reportId: Scalars['ID']['input'];
}>;


export type ReportExportDataQuery = { __typename?: 'Query', reportExportData?: { __typename?: 'ReportExportDataType', dateOfReport?: string | null, reportWriter?: string | null, templateLogoSignedUrl?: string | null, organizationLogoSignedUrl?: string | null, organizationLogoAllowed?: boolean | null, organizationName?: string | null, clientDetails?: { __typename?: 'ExportClientDetailsType', clientFirstName?: string | null, clientLastName?: string | null, clientName?: string | null, dateOfBirth?: string | null, age?: string | null, gender?: string | null, guardianName?: string | null, guardian2FullName?: string | null, guardian2FirstName?: string | null, guardian2LastName?: string | null, guardian2Phone?: string | null, caregiverNames?: string | null, address?: string | null, city?: string | null, state?: string | null, zip?: string | null } | null, signatureSection?: { __typename?: 'ExportSignatureSectionType', signatureName?: string | null, licenseNumber?: string | null, practitionerEmail?: string | null, professionalTitle?: string | null, signatureDate?: string | null } | null, goalGroups?: Array<{ __typename?: 'ExportGoalGroupType', goalType?: string | null, goals?: Array<{ __typename?: 'ExportGoalType', assessmentToolSource?: string | null, baselineData?: string | null, baselineDate?: string | null, medicalNecessityCriteria?: string | null, programGoal?: string | null, generalizationCriteria?: string | null, rationale?: string | null, goalName?: string | null, masteryCriteria?: string | null, expectedMasteryDate?: string | null, targets?: Array<{ __typename?: 'ExportGoalTargetType', name?: string | null, masteryCriteria?: string | null, baselineData?: string | null, masteryDate?: string | null } | null> | null } | null> | null } | null> | null, sections?: Array<{ __typename?: 'ExportSectionType', key?: string | null, title?: string | null, rankOrder?: number | null, pageLocation?: string | null, fields?: Array<{ __typename?: 'ExportSectionFieldType', field_identifier?: string | null, title?: string | null, content?: string | null, field_type?: string | null } | null> | null } | null> | null } | null };

export type ReportFronteraEhrClientExportQueryVariables = Exact<{
  reportId: Scalars['ID']['input'];
  filter: GetReportsFilter;
}>;


export type ReportFronteraEhrClientExportQuery = { __typename?: 'Query', getReports?: { __typename?: 'ReportTypeConnection', edges: Array<{ __typename?: 'ReportTypeEdge', node?: { __typename?: 'ReportType', id: string, fronteraEhrClientExport?: { __typename?: 'FronteraEhrClientExportType', status: FronteraEhrLearnerExportStatusEnum, message: string } | null, learner?: { __typename?: 'LearnerType', id: string, externalId?: string | null } | null } | null } | null> } | null };

export type ReportGoalsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  filter: GetReportsFilter;
}>;


export type ReportGoalsQuery = { __typename?: 'Query', getReports?: { __typename?: 'ReportTypeConnection', edges: Array<{ __typename?: 'ReportTypeEdge', node?: { __typename?: 'ReportType', reportTreatmentPlan?: { __typename?: 'ReportTreatmentPlanType', reportgoalSet: { __typename?: 'ReportGoalTypeConnection', edges: Array<{ __typename?: 'ReportGoalTypeEdge', node?: { __typename?: 'ReportGoalType', id: string, goalName: string, inUse: boolean, reportDomain?: { __typename?: 'ReportDomainType', id: string } | null } | null } | null> }, reportdomainSet: { __typename?: 'ReportDomainTypeConnection', edges: Array<{ __typename?: 'ReportDomainTypeEdge', node?: { __typename?: 'ReportDomainType', id: string, createdDate: any, name: string, description?: string | null, rankOrder: number, reportgoalSet: { __typename?: 'ReportGoalTypeConnection', edges: Array<{ __typename?: 'ReportGoalTypeEdge', node?: { __typename?: 'ReportGoalType', id: string, createdDate: any, lastUpdatedDate: any, assessmentToolSource?: string | null, baselineDate?: any | null, projectedIntroductionDate?: any | null, completionDate?: any | null, goalName: string, programGoal?: string | null, description?: string | null, timelineEstimationType?: ApiReportGoalTimelineEstimationTypeChoices | null, timelineEstimationValue?: number | null, baselineData?: string | null, masteryCriteria?: string | null, hasMedicalNecessity: boolean, medicalNecessityCriteria?: string | null, generalizationCriteria?: string | null, aiGoalAttainmentScalePredictionStatus: ApiReportGoalAiGoalAttainmentScalePredictionStatusChoices, gasLevel1?: string | null, gasLevel3?: string | null, gasLevel4?: string | null, gasScore?: string | null, rationale?: string | null, status?: ApiReportGoalStatusChoices | null, goalType?: string | null, tags?: any | null, progressSummary?: string | null, aiGenerated: boolean, inUse: boolean, goalBank?: { __typename?: 'ReportGoalBankType', id: string } | null, customFields: { __typename?: 'TreatmentPlanCustomFieldTypeConnection', edges: Array<{ __typename?: 'TreatmentPlanCustomFieldTypeEdge', node?: { __typename?: 'TreatmentPlanCustomFieldType', id: string, fieldIdentifier: string, fieldType: ApiTreatmentPlanCustomFieldFieldTypeChoices, title?: string | null, content?: string | null, rankOrder: number, imageSignedUrl?: string | null } | null } | null> }, reporttargetSet: { __typename?: 'ReportTargetTypeConnection', edges: Array<{ __typename?: 'ReportTargetTypeEdge', node?: { __typename?: 'ReportTargetType', id: string, aiGenerated: boolean, inUse: boolean, excludeFromReport: boolean, createdDate: any, lastUpdatedDate: any, targetName: string, targetDescription?: string | null, timelineEstimationValue?: number | null, timelineEstimationType?: ApiReportTargetTimelineEstimationTypeChoices | null, masteryCriteria?: string | null, baselineData?: string | null, status?: ApiReportTargetStatusChoices | null, progressSummary?: string | null, completionDate?: any | null, projectedIntroductionDate?: any | null, customFields: { __typename?: 'TreatmentPlanCustomFieldTypeConnection', edges: Array<{ __typename?: 'TreatmentPlanCustomFieldTypeEdge', node?: { __typename?: 'TreatmentPlanCustomFieldType', id: string, fieldIdentifier: string, fieldType: ApiTreatmentPlanCustomFieldFieldTypeChoices, title?: string | null, content?: string | null, rankOrder: number, imageSignedUrl?: string | null } | null } | null> } } | null } | null> } } | null } | null> } } | null } | null> } } | null } | null } | null> } | null };

export type GetReportLearnerFilesQueryVariables = Exact<{
  reportId?: InputMaybe<Scalars['ID']['input']>;
  fileId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type GetReportLearnerFilesQuery = { __typename?: 'Query', getReportLearnerFiles?: { __typename?: 'LearnerFileTypeConnection', edges: Array<{ __typename?: 'LearnerFileTypeEdge', node?: { __typename?: 'LearnerFileType', status: ApiLearnerFileStatusChoices, id: string, processingFailureReason?: string | null, processingFailureCode?: ApiLearnerFileProcessingFailureCodeChoices | null, fileKind: ApiLearnerFileFileKindChoices, mimeType: string, metadata?: any | null } | null } | null> } | null };

export type ReportReviewCountsQueryVariables = Exact<{ [key: string]: never; }>;


export type ReportReviewCountsQuery = { __typename?: 'Query', reportReviewCounts: { __typename?: 'ReportReviewCountsType', waitingOnMe: number, sentBackToMe: number, inReview: number, reviewedByMe: number } };

export type ReportStatusQueryVariables = Exact<{
  reportId: Scalars['ID']['input'];
}>;


export type ReportStatusQuery = { __typename?: 'Query', getReport?: { __typename?: 'ReportTypeConnection', edges: Array<{ __typename?: 'ReportTypeEdge', node?: { __typename?: 'ReportType', reportStatus: ApiReportReportStatusChoices } | null } | null> } | null };

export type GetReportSuggestionsQueryVariables = Exact<{
  reportId: Scalars['ID']['input'];
}>;


export type GetReportSuggestionsQuery = { __typename?: 'Query', getReportSuggestions?: { __typename?: 'ReportSuggestionTypeConnection', totalCount?: number | null, totalResolved?: number | null, totalActive?: number | null, edges: Array<{ __typename?: 'ReportSuggestionTypeEdge', node?: { __typename?: 'ReportSuggestionType', id: string, category: string, content?: string | null, isActive: boolean, isResolved?: boolean | null, goalField?: string | null, targetField?: string | null, reportSectionField?: { __typename?: 'ReportSectionFieldsType', id: string, title?: string | null } | null, reportGoal?: { __typename?: 'ReportGoalType', id: string, goalName: string, excludeFromReport: boolean } | null, reportTarget?: { __typename?: 'ReportTargetType', id: string, targetName: string, inUse: boolean, excludeFromReport: boolean } | null } | null } | null> } | null };

type ReviewItemFields_ReportCommentType_Fragment = { __typename: 'ReportCommentType', baseValue?: string | null, proposedValue?: string | null, editedAt?: any | null, canEdit: boolean, canDelete: boolean, isDeleted: boolean, id: string, content?: string | null, status: string, hidden: boolean, createdDate: any, resolvedAt?: any | null, goalField?: string | null, targetField?: string | null, author?: { __typename?: 'ReportReviewUserType', id: string, firstName: string, lastName?: string | null, email?: string | null } | null, resolvedBy?: { __typename?: 'ReportReviewUserType', id: string, firstName: string, lastName?: string | null, email?: string | null } | null, reportSectionField?: { __typename?: 'ReportSectionFieldsType', id: string, title?: string | null } | null, reportGoal?: { __typename?: 'ReportGoalType', id: string, goalName: string, excludeFromReport: boolean } | null, reportTarget?: { __typename?: 'ReportTargetType', id: string, targetName: string, inUse: boolean, excludeFromReport: boolean } | null, parent?: { __typename: 'ReportCommentType', id: string } | { __typename: 'ReportSuggestionType', id: string } | null };

type ReviewItemFields_ReportSuggestionType_Fragment = { __typename: 'ReportSuggestionType', category: string, id: string, content?: string | null, status: string, hidden: boolean, createdDate: any, resolvedAt?: any | null, goalField?: string | null, targetField?: string | null, resolvedBy?: { __typename?: 'ReportReviewUserType', id: string, firstName: string, lastName?: string | null, email?: string | null } | null, reportSectionField?: { __typename?: 'ReportSectionFieldsType', id: string, title?: string | null } | null, reportGoal?: { __typename?: 'ReportGoalType', id: string, goalName: string, excludeFromReport: boolean } | null, reportTarget?: { __typename?: 'ReportTargetType', id: string, targetName: string, inUse: boolean, excludeFromReport: boolean } | null, parent?: { __typename: 'ReportCommentType', id: string } | { __typename: 'ReportSuggestionType', id: string } | null };

export type ReviewItemFieldsFragment = ReviewItemFields_ReportCommentType_Fragment | ReviewItemFields_ReportSuggestionType_Fragment;

export type ClientProgrammingProviderQueryVariables = Exact<{
  learnerId: Scalars['ID']['input'];
  filter?: InputMaybe<GoalFilter>;
}>;


export type ClientProgrammingProviderQuery = { __typename?: 'Query', goals?: { __typename?: 'GoalTypeConnection', edges: Array<{ __typename?: 'GoalTypeEdge', node?: { __typename?: 'GoalType', id: string, name?: string | null, status?: UnifiedGoalStatusEnum | null, targets: { __typename?: 'TargetTypeConnection', edges: Array<{ __typename?: 'TargetTypeEdge', node?: { __typename?: 'TargetType', id: string, name?: string | null, status?: UnifiedTargetStatusEnum | null, goal: { __typename?: 'GoalType', id: string, name?: string | null }, mediatargetpredictionSet: { __typename?: 'MediaTargetPredictionTypeConnection', totalCount?: number | null } } | null } | null> }, mediatargetpredictionSet: { __typename?: 'MediaTargetPredictionTypeConnection', totalCount?: number | null } } | null } | null> } | null };

export type ProgrammingGoalOverviewQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ProgrammingGoalOverviewQuery = { __typename?: 'Query', goal?: { __typename?: 'GoalType', id: string, passagegoal?: { __typename?: 'PassageGoalType', id: string, title: string, type: ApiPassageGoalTypeChoices, description?: string | null, operationalDefinition?: string | null, onset?: string | null, offset?: string | null, antecedentStrategy?: string | null, errorCorrectionStrategy?: string | null, errorConsequenceStrategy?: string | null, replacementBehavior?: string | null, hypothesizedFunction?: string | null, teachingMethod?: string | null, discriminativeStimulus?: string | null, promptingInstructions?: string | null, expectedResponse?: string | null, reinforcementStrategy?: string | null, passageTargets: { __typename?: 'PassageTargetTypeConnection', edges: Array<{ __typename?: 'PassageTargetTypeEdge', node?: { __typename?: 'PassageTargetType', id: string, title: string, description?: string | null, type: ApiPassageTargetTypeChoices, measureType: string, measureValue: number, masteredOverType: string, masteredOverValue: number, threshold: string, target: { __typename?: 'TargetType', id: string } } | null } | null> } } | null } | null };

export type SessionsByLearnerIdQueryVariables = Exact<{
  providerId?: InputMaybe<Scalars['ID']['input']>;
  learnerId: Scalars['ID']['input'];
}>;


export type SessionsByLearnerIdQuery = { __typename?: 'Query', sessionsByLearnerId?: { __typename?: 'VideoSessionTypeConnection', edges: Array<{ __typename?: 'VideoSessionTypeEdge', node?: { __typename?: 'VideoSessionType', id: string, sessionStatus?: ApiVideoSessionSessionStatusChoices | null, date: any, createdDate: any, lastUpdatedDate: any, engagementScore?: number | null, sessionproviderSet: { __typename?: 'SessionProviderTypeConnection', edges: Array<{ __typename?: 'SessionProviderTypeEdge', node?: { __typename?: 'SessionProviderType', provider: { __typename?: 'ProviderType', id: string, providermetadata?: { __typename?: 'ProviderMetadataType', firstName: string, lastName?: string | null } | null } } | null } | null> }, finalMedia?: { __typename?: 'MediaType', id: string, totalDuration?: number | null } | null } | null } | null> } | null };

export type LearnersRecentSessionQueryVariables = Exact<{
  learnerId?: InputMaybe<Scalars['ID']['input']>;
  providerId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type LearnersRecentSessionQuery = { __typename?: 'Query', learnersRecentSession?: { __typename?: 'SessionLearnerTypeConnection', edges: Array<{ __typename?: 'SessionLearnerTypeEdge', node?: { __typename?: 'SessionLearnerType', id: string, sessionLearners: { __typename?: 'LearnerType', id: string, learnermetadata?: { __typename?: 'LearnerMetadataType', firstName: string, lastName: string } | null }, videoSession?: { __typename?: 'VideoSessionType', id: string, sessionStatus?: ApiVideoSessionSessionStatusChoices | null, engagementScore?: number | null, createdDate: any, lastUpdatedDate: any, sessionproviderSet: { __typename?: 'SessionProviderTypeConnection', edges: Array<{ __typename?: 'SessionProviderTypeEdge', node?: { __typename?: 'SessionProviderType', provider: { __typename?: 'ProviderType', id: string, providermetadata?: { __typename?: 'ProviderMetadataType', firstName: string, lastName?: string | null } | null } } | null } | null> } } | null } | null } | null> } | null };

export type VideoSessionByIdQueryVariables = Exact<{
  videoSessionId: Scalars['ID']['input'];
}>;


export type VideoSessionByIdQuery = { __typename?: 'Query', videoSessionById?: { __typename?: 'VideoSessionType', id: string, lastUpdatedDate: any } | null };

export type GetSesionEngagementInsightQueryVariables = Exact<{
  videoSessionId: Scalars['ID']['input'];
}>;


export type GetSesionEngagementInsightQuery = { __typename?: 'Query', getSessionEngagementInsight?: { __typename?: 'SessionEngagementInsightTypeConnection', edges: Array<{ __typename?: 'SessionEngagementInsightTypeEdge', node?: { __typename?: 'SessionEngagementInsightType', id: string, startTime: number, endTime: number, description: string, insightType: ApiSessionEngagementInsightInsightTypeChoices } | null } | null> } | null };

export type GetSessionEngagementScoreBySessionIdQueryVariables = Exact<{
  videoSessionId: Scalars['ID']['input'];
  videoDuration: Scalars['Int']['input'];
}>;


export type GetSessionEngagementScoreBySessionIdQuery = { __typename?: 'Query', getSessionEngagementScoreBySessionId?: Array<{ __typename?: 'EngagementScoreType', timeInMinute?: number | null, engagementScore?: number | null } | null> | null };

export type GetSessionMediaStreamQueryVariables = Exact<{
  videoSessionId: Scalars['ID']['input'];
}>;


export type GetSessionMediaStreamQuery = { __typename?: 'Query', getSessionMediaStream?: { __typename?: 'MediaStreamType', id: string, dashUrl?: string | null } | null };

export type GetTasksQueryVariables = Exact<{
  filter?: InputMaybe<TasksFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetTasksQuery = { __typename?: 'Query', tasks?: { __typename?: 'TaskTypeConnection', totalCount?: number | null, edges: Array<{ __typename?: 'TaskTypeEdge', node?: { __typename?: 'TaskType', id: string, title: string, subtitle: string, status: ApiTaskStatusChoices, media?: { __typename?: 'MediaType', id: string, filePath?: string | null, fileName?: string | null, fileSize?: number | null, mediaAttachmentUrl?: string | null } | null, file?: { __typename?: 'LearnerFileType', id: string, originalFileName: string, fileSize: any, signedS3LearnerFile?: string | null } | null } | null } | null>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type GetMediaGoalMomentsQueryVariables = Exact<{
  filter: MediaGoalMomentsFilter;
}>;


export type GetMediaGoalMomentsQuery = { __typename?: 'Query', getMediaGoalMoments?: { __typename?: 'GoalTypeConnection', edges: Array<{ __typename?: 'GoalTypeEdge', node?: { __typename?: 'GoalType', id: string, name?: string | null, status?: UnifiedGoalStatusEnum | null, isPinned: boolean, rankOrder: number, learner: { __typename?: 'LearnerType', id: string }, targets: { __typename?: 'TargetTypeConnection', edges: Array<{ __typename?: 'TargetTypeEdge', node?: { __typename?: 'TargetType', id: string, name?: string | null, status?: UnifiedTargetStatusEnum | null, mediatargetpredictionSet: { __typename?: 'MediaTargetPredictionTypeConnection', edges: Array<{ __typename?: 'MediaTargetPredictionTypeEdge', node?: { __typename?: 'MediaTargetPredictionType', id: string, startTime: number, endTime: number, mediaTargetFeedbacks: { __typename?: 'MediaTargetPredictionFeedbackTypeConnection', edges: Array<{ __typename?: 'MediaTargetPredictionFeedbackTypeEdge', node?: { __typename?: 'MediaTargetPredictionFeedbackType', lastUpdatedDate: any, isAccurate: boolean } | null } | null> } } | null } | null> } } | null } | null> }, mediatargetpredictionSet: { __typename?: 'MediaTargetPredictionTypeConnection', edges: Array<{ __typename?: 'MediaTargetPredictionTypeEdge', node?: { __typename?: 'MediaTargetPredictionType', id: string, startTime: number, endTime: number, mediaTargetFeedbacks: { __typename?: 'MediaTargetPredictionFeedbackTypeConnection', edges: Array<{ __typename?: 'MediaTargetPredictionFeedbackTypeEdge', node?: { __typename?: 'MediaTargetPredictionFeedbackType', lastUpdatedDate: any, isAccurate: boolean } | null } | null> } } | null } | null> } } | null } | null> } | null };

export type TreatmentPlanUploadParsingResultsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type TreatmentPlanUploadParsingResultsQuery = { __typename?: 'Query', parsedTreatmentPlanFileDataById?: { __typename?: 'ParsedTreatmentPlanFileDataType', id: string, status: ApiParsedTreatmentPlanFileDataStatusChoices, data?: any | null } | null };


export const AnalyticsMetricFieldsFragmentDoc = `
    fragment AnalyticsMetricFields on AnalyticsMetricType {
  value
  previousValue
}
    `;
export const AnalyticsStatusCountFieldsFragmentDoc = `
    fragment AnalyticsStatusCountFields on AnalyticsStatusCountType {
  status
  count
}
    `;
export const AnalyticsWritingTimeFieldsFragmentDoc = `
    fragment AnalyticsWritingTimeFields on AnalyticsWritingTimeRowType {
  reportType
  medianWritingMinutes
  previousMedianWritingMinutes
}
    `;
export const AnalyticsTrendPointFieldsFragmentDoc = `
    fragment AnalyticsTrendPointFields on AnalyticsTrendPointType {
  weekStart
  submitted
}
    `;
export const AnalyticsTemplateOptionFieldsFragmentDoc = `
    fragment AnalyticsTemplateOptionFields on AnalyticsTemplateOptionType {
  templateGroup
  count
}
    `;
export const AnalyticsReportsByUserPageFieldsFragmentDoc = `
    fragment AnalyticsReportsByUserPageFields on AnalyticsReportsByUserPage {
  totalCount
  rows {
    providerId
    providerName
    count
    previousCount
  }
}
    `;
export const AnalyticsQaByUserPageFieldsFragmentDoc = `
    fragment AnalyticsQaByUserPageFields on AnalyticsQaByUserPage {
  totalCount
  rows {
    providerId
    providerName
    totalFlags
    openFlags
    resolvedFlags
    resolutionRate
  }
}
    `;
export const AnalyticsOverdueRowFieldsFragmentDoc = `
    fragment AnalyticsOverdueRowFields on AnalyticsOverdueReportRowType {
  reportId
  reportType
  templateGroup
  learnerName
  providerId
  providerName
  createdDate
  daysOpen
}
    `;
export const AnalyticsReportRowFieldsFragmentDoc = `
    fragment AnalyticsReportRowFields on AnalyticsReportRowType {
  reportId
  reportType
  templateGroup
  status
  providerId
  providerName
  learnerName
  createdDate
  completedDate
  submittedDate
  writingMinutes
}
    `;
export const AnalyticsQaFlagRowFieldsFragmentDoc = `
    fragment AnalyticsQaFlagRowFields on AnalyticsQaFlagRowType {
  flagId
  reportId
  reportType
  category
  providerId
  providerName
  createdDate
  resolved
  resolvedDate
}
    `;
export const AnalyticsFacetFieldsFragmentDoc = `
    fragment AnalyticsFacetFields on AnalyticsFacetType {
  key
  truncated
  values {
    value
    label
    count
  }
}
    `;
export const EhrStoredFieldPartsFragmentDoc = `
    fragment EhrStoredFieldParts on EhrStoredField {
  key
  value
}
    `;
export const EhrChildCollectionPartsFragmentDoc = `
    fragment EhrChildCollectionParts on EhrChildCollection {
  key
  label
  rows {
    fields {
      key
      value
    }
  }
}
    `;
export const EhrSessionDataSummaryPartsFragmentDoc = `
    fragment EhrSessionDataSummaryParts on EhrSessionDataSummary {
  dataPointCount
  sessionCount
  firstDate
  lastDate
}
    `;
export const ReviewItemFieldsFragmentDoc = `
    fragment ReviewItemFields on ReportReviewItemInterface {
  __typename
  id
  content
  status
  hidden
  createdDate
  resolvedAt
  resolvedBy {
    id
    firstName
    lastName
    email
  }
  reportSectionField {
    id
    title
  }
  reportGoal {
    id
    goalName
    excludeFromReport
  }
  goalField
  reportTarget {
    id
    targetName
    inUse
    excludeFromReport
  }
  targetField
  parent {
    __typename
    ... on ReportSuggestionType {
      id
    }
    ... on ReportCommentType {
      id
    }
  }
  ... on ReportCommentType {
    author {
      id
      firstName
      lastName
      email
    }
    baseValue
    proposedValue
    editedAt
    canEdit
    canDelete
    isDeleted
  }
  ... on ReportSuggestionType {
    category
  }
}
    `;
export const DisconnectCaregiverFromOrganizationDocument = `
    mutation disconnectCaregiverFromOrganization($organization: ID!, $caregiver: ID) {
  disconnectCaregiverFromOrganization(
    organization: $organization
    caregiver: $caregiver
  ) {
    success
    message
  }
}
    `;

export const useDisconnectCaregiverFromOrganizationMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<DisconnectCaregiverFromOrganizationMutation, TError, DisconnectCaregiverFromOrganizationMutationVariables, TContext>) => {
    
    return useMutation<DisconnectCaregiverFromOrganizationMutation, TError, DisconnectCaregiverFromOrganizationMutationVariables, TContext>(
      {
    mutationKey: ['disconnectCaregiverFromOrganization'],
    mutationFn: useCustomFetcher<DisconnectCaregiverFromOrganizationMutation, DisconnectCaregiverFromOrganizationMutationVariables>(DisconnectCaregiverFromOrganizationDocument),
    ...options
  }
    )};

export const ReissueCaregiverInvitationDocument = `
    mutation reissueCaregiverInvitation($caregiverId: ID!) {
  reissueCaregiverInvitation(caregiverId: $caregiverId) {
    message
    status
  }
}
    `;

export const useReissueCaregiverInvitationMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<ReissueCaregiverInvitationMutation, TError, ReissueCaregiverInvitationMutationVariables, TContext>) => {
    
    return useMutation<ReissueCaregiverInvitationMutation, TError, ReissueCaregiverInvitationMutationVariables, TContext>(
      {
    mutationKey: ['reissueCaregiverInvitation'],
    mutationFn: useCustomFetcher<ReissueCaregiverInvitationMutation, ReissueCaregiverInvitationMutationVariables>(ReissueCaregiverInvitationDocument),
    ...options
  }
    )};

export const SendCaregiverActivationCodeNotificationDocument = `
    mutation sendCaregiverActivationCodeNotification($caregiverId: ID!, $organizationId: ID!) {
  sendCaregiverActivationCodeNotification(
    caregiverId: $caregiverId
    organizationId: $organizationId
  ) {
    status
    message
  }
}
    `;

export const useSendCaregiverActivationCodeNotificationMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<SendCaregiverActivationCodeNotificationMutation, TError, SendCaregiverActivationCodeNotificationMutationVariables, TContext>) => {
    
    return useMutation<SendCaregiverActivationCodeNotificationMutation, TError, SendCaregiverActivationCodeNotificationMutationVariables, TContext>(
      {
    mutationKey: ['sendCaregiverActivationCodeNotification'],
    mutationFn: useCustomFetcher<SendCaregiverActivationCodeNotificationMutation, SendCaregiverActivationCodeNotificationMutationVariables>(SendCaregiverActivationCodeNotificationDocument),
    ...options
  }
    )};

export const SendCaregiverActivationCodeNotificationsDocument = `
    mutation sendCaregiverActivationCodeNotifications($caregiverIds: [ID!]!) {
  sendCaregiverActivationCodeNotifications(caregiverIds: $caregiverIds) {
    status
    message
  }
}
    `;

export const useSendCaregiverActivationCodeNotificationsMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<SendCaregiverActivationCodeNotificationsMutation, TError, SendCaregiverActivationCodeNotificationsMutationVariables, TContext>) => {
    
    return useMutation<SendCaregiverActivationCodeNotificationsMutation, TError, SendCaregiverActivationCodeNotificationsMutationVariables, TContext>(
      {
    mutationKey: ['sendCaregiverActivationCodeNotifications'],
    mutationFn: useCustomFetcher<SendCaregiverActivationCodeNotificationsMutation, SendCaregiverActivationCodeNotificationsMutationVariables>(SendCaregiverActivationCodeNotificationsDocument),
    ...options
  }
    )};

export const UpdateCaregiverMetadataDocument = `
    mutation updateCaregiverMetadata($caregiver: ID, $firstName: String, $lastName: String, $email: String, $phoneNumber1: String) {
  updateCaregiverMetadata(
    caregiver: $caregiver
    firstName: $firstName
    lastName: $lastName
    email: $email
    phoneNumber1: $phoneNumber1
  ) {
    caregiverMetadata {
      id
      firstName
      lastName
      email
      phoneNumber1
    }
  }
}
    `;

export const useUpdateCaregiverMetadataMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateCaregiverMetadataMutation, TError, UpdateCaregiverMetadataMutationVariables, TContext>) => {
    
    return useMutation<UpdateCaregiverMetadataMutation, TError, UpdateCaregiverMetadataMutationVariables, TContext>(
      {
    mutationKey: ['updateCaregiverMetadata'],
    mutationFn: useCustomFetcher<UpdateCaregiverMetadataMutation, UpdateCaregiverMetadataMutationVariables>(UpdateCaregiverMetadataDocument),
    ...options
  }
    )};

export const CreateChatNoteDocument = `
    mutation createChatNote($input: CreateUpdateChatNoteInput!) {
  createChatNote(input: $input) {
    success
    message
    chatNote {
      id
      content
      createdDate
      user {
        auth0id
        provider {
          id
          providermetadata {
            firstName
            lastName
          }
        }
      }
    }
  }
}
    `;

export const useCreateChatNoteMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateChatNoteMutation, TError, CreateChatNoteMutationVariables, TContext>) => {
    
    return useMutation<CreateChatNoteMutation, TError, CreateChatNoteMutationVariables, TContext>(
      {
    mutationKey: ['createChatNote'],
    mutationFn: useCustomFetcher<CreateChatNoteMutation, CreateChatNoteMutationVariables>(CreateChatNoteDocument),
    ...options
  }
    )};

export const CreateChatTagDocument = `
    mutation createChatTag($input: CreateChatTagInput!) {
  createChatTag(input: $input) {
    success
    message
    chatTag {
      id
      name
    }
    chat {
      id
      status
    }
  }
}
    `;

export const useCreateChatTagMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateChatTagMutation, TError, CreateChatTagMutationVariables, TContext>) => {
    
    return useMutation<CreateChatTagMutation, TError, CreateChatTagMutationVariables, TContext>(
      {
    mutationKey: ['createChatTag'],
    mutationFn: useCustomFetcher<CreateChatTagMutation, CreateChatTagMutationVariables>(CreateChatTagDocument),
    ...options
  }
    )};

export const DeleteChatNoteDocument = `
    mutation deleteChatNote($chatNoteId: ID!) {
  deleteChatNote(chatNoteId: $chatNoteId) {
    success
    message
  }
}
    `;

export const useDeleteChatNoteMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<DeleteChatNoteMutation, TError, DeleteChatNoteMutationVariables, TContext>) => {
    
    return useMutation<DeleteChatNoteMutation, TError, DeleteChatNoteMutationVariables, TContext>(
      {
    mutationKey: ['deleteChatNote'],
    mutationFn: useCustomFetcher<DeleteChatNoteMutation, DeleteChatNoteMutationVariables>(DeleteChatNoteDocument),
    ...options
  }
    )};

export const FinishChatDocument = `
    mutation finishChat($chatId: ID!) {
  finishChat(chatId: $chatId) {
    success
    message
    chat {
      id
      status
    }
  }
}
    `;

export const useFinishChatMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<FinishChatMutation, TError, FinishChatMutationVariables, TContext>) => {
    
    return useMutation<FinishChatMutation, TError, FinishChatMutationVariables, TContext>(
      {
    mutationKey: ['finishChat'],
    mutationFn: useCustomFetcher<FinishChatMutation, FinishChatMutationVariables>(FinishChatDocument),
    ...options
  }
    )};

export const OpenChatDocument = `
    mutation openChat($chatId: ID!) {
  openChat(chatId: $chatId) {
    success
    message
    chat {
      id
      status
    }
  }
}
    `;

export const useOpenChatMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<OpenChatMutation, TError, OpenChatMutationVariables, TContext>) => {
    
    return useMutation<OpenChatMutation, TError, OpenChatMutationVariables, TContext>(
      {
    mutationKey: ['openChat'],
    mutationFn: useCustomFetcher<OpenChatMutation, OpenChatMutationVariables>(OpenChatDocument),
    ...options
  }
    )};

export const UpdateChatDocument = `
    mutation updateChat($input: UpdateChatInput!) {
  updateChat(input: $input) {
    success
    message
    chat {
      id
      careStage
      status
    }
  }
}
    `;

export const useUpdateChatMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateChatMutation, TError, UpdateChatMutationVariables, TContext>) => {
    
    return useMutation<UpdateChatMutation, TError, UpdateChatMutationVariables, TContext>(
      {
    mutationKey: ['updateChat'],
    mutationFn: useCustomFetcher<UpdateChatMutation, UpdateChatMutationVariables>(UpdateChatDocument),
    ...options
  }
    )};

export const UpdateChatMessageDocument = `
    mutation updateChatMessage($input: UpdateChatMessageInput!) {
  updateChatMessage(input: $input) {
    success
    message
    chatMessage {
      id
      content
      edited
    }
  }
}
    `;

export const useUpdateChatMessageMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateChatMessageMutation, TError, UpdateChatMessageMutationVariables, TContext>) => {
    
    return useMutation<UpdateChatMessageMutation, TError, UpdateChatMessageMutationVariables, TContext>(
      {
    mutationKey: ['updateChatMessage'],
    mutationFn: useCustomFetcher<UpdateChatMessageMutation, UpdateChatMessageMutationVariables>(UpdateChatMessageDocument),
    ...options
  }
    )};

export const UpdateMessageReadStatusDocument = `
    mutation updateMessageReadStatus($input: UpdateMessageReadStatusInput!) {
  updateMessageReadStatus(input: $input) {
    success
    message
  }
}
    `;

export const useUpdateMessageReadStatusMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateMessageReadStatusMutation, TError, UpdateMessageReadStatusMutationVariables, TContext>) => {
    
    return useMutation<UpdateMessageReadStatusMutation, TError, UpdateMessageReadStatusMutationVariables, TContext>(
      {
    mutationKey: ['updateMessageReadStatus'],
    mutationFn: useCustomFetcher<UpdateMessageReadStatusMutation, UpdateMessageReadStatusMutationVariables>(UpdateMessageReadStatusDocument),
    ...options
  }
    )};

export const SaveCrLearningTreeRolesDocument = `
    mutation saveCrLearningTreeRoles($learnerId: ID!, $changes: [CRLearningTreeRoleInput]!) {
  saveCrLearningTreeRoles(learnerId: $learnerId, changes: $changes) {
    status
    message
    saved
    checks {
      externalId
      level
      code
      message
    }
  }
}
    `;

export const useSaveCrLearningTreeRolesMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<SaveCrLearningTreeRolesMutation, TError, SaveCrLearningTreeRolesMutationVariables, TContext>) => {
    
    return useMutation<SaveCrLearningTreeRolesMutation, TError, SaveCrLearningTreeRolesMutationVariables, TContext>(
      {
    mutationKey: ['saveCrLearningTreeRoles'],
    mutationFn: useCustomFetcher<SaveCrLearningTreeRolesMutation, SaveCrLearningTreeRolesMutationVariables>(SaveCrLearningTreeRolesDocument),
    ...options
  }
    )};

export const LockCrLearningTreeDocument = `
    mutation lockCrLearningTree($learnerId: ID!, $reportId: ID) {
  lockCrLearningTree(learnerId: $learnerId, reportId: $reportId) {
    status
    message
    checks {
      externalId
      level
      code
      message
    }
  }
}
    `;

export const useLockCrLearningTreeMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<LockCrLearningTreeMutation, TError, LockCrLearningTreeMutationVariables, TContext>) => {
    
    return useMutation<LockCrLearningTreeMutation, TError, LockCrLearningTreeMutationVariables, TContext>(
      {
    mutationKey: ['lockCrLearningTree'],
    mutationFn: useCustomFetcher<LockCrLearningTreeMutation, LockCrLearningTreeMutationVariables>(LockCrLearningTreeDocument),
    ...options
  }
    )};

export const SaveAndLockCrLearningTreeItemsDocument = `
    mutation saveAndLockCrLearningTreeItems($learnerId: ID!, $changes: [CRLearningTreeRoleInput]!, $reportId: ID) {
  saveAndLockCrLearningTreeItems(
    learnerId: $learnerId
    changes: $changes
    reportId: $reportId
  ) {
    status
    message
    checks {
      externalId
      level
      code
      message
    }
  }
}
    `;

export const useSaveAndLockCrLearningTreeItemsMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<SaveAndLockCrLearningTreeItemsMutation, TError, SaveAndLockCrLearningTreeItemsMutationVariables, TContext>) => {
    
    return useMutation<SaveAndLockCrLearningTreeItemsMutation, TError, SaveAndLockCrLearningTreeItemsMutationVariables, TContext>(
      {
    mutationKey: ['saveAndLockCrLearningTreeItems'],
    mutationFn: useCustomFetcher<SaveAndLockCrLearningTreeItemsMutation, SaveAndLockCrLearningTreeItemsMutationVariables>(SaveAndLockCrLearningTreeItemsDocument),
    ...options
  }
    )};

export const UnlockCrLearningTreeBranchDocument = `
    mutation unlockCrLearningTreeBranch($learnerId: ID!, $externalId: String!) {
  unlockCrLearningTreeBranch(learnerId: $learnerId, externalId: $externalId) {
    status
    message
    unlocked
  }
}
    `;

export const useUnlockCrLearningTreeBranchMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UnlockCrLearningTreeBranchMutation, TError, UnlockCrLearningTreeBranchMutationVariables, TContext>) => {
    
    return useMutation<UnlockCrLearningTreeBranchMutation, TError, UnlockCrLearningTreeBranchMutationVariables, TContext>(
      {
    mutationKey: ['unlockCrLearningTreeBranch'],
    mutationFn: useCustomFetcher<UnlockCrLearningTreeBranchMutation, UnlockCrLearningTreeBranchMutationVariables>(UnlockCrLearningTreeBranchDocument),
    ...options
  }
    )};

export const CreateClientFromEhrDocument = `
    mutation CreateClientFromEhr($learnerExternalId: String!, $firstName: String!, $lastName: String!, $preferredName: String, $birthDate: Date, $addressLine1: String, $addressLine2: String, $city: String, $state: String, $zipCode: String, $gender: String, $isImportForReassessment: Boolean) {
  createClientFromEhr(
    learnerExternalId: $learnerExternalId
    firstName: $firstName
    lastName: $lastName
    preferredName: $preferredName
    birthDate: $birthDate
    addressLine1: $addressLine1
    addressLine2: $addressLine2
    city: $city
    state: $state
    zipCode: $zipCode
    gender: $gender
    isImportForReassessment: $isImportForReassessment
  ) {
    status
    message
    learner {
      id
      learnermetadata {
        firstName
        lastName
      }
    }
  }
}
    `;

export const useCreateClientFromEhrMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateClientFromEhrMutation, TError, CreateClientFromEhrMutationVariables, TContext>) => {
    
    return useMutation<CreateClientFromEhrMutation, TError, CreateClientFromEhrMutationVariables, TContext>(
      {
    mutationKey: ['CreateClientFromEhr'],
    mutationFn: useCustomFetcher<CreateClientFromEhrMutation, CreateClientFromEhrMutationVariables>(CreateClientFromEhrDocument),
    ...options
  }
    )};

export const DeleteEhrCredentialsDocument = `
    mutation deleteEhrCredentials {
  deleteEhrCredentials {
    message
    success
  }
}
    `;

export const useDeleteEhrCredentialsMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<DeleteEhrCredentialsMutation, TError, DeleteEhrCredentialsMutationVariables, TContext>) => {
    
    return useMutation<DeleteEhrCredentialsMutation, TError, DeleteEhrCredentialsMutationVariables, TContext>(
      {
    mutationKey: ['deleteEhrCredentials'],
    mutationFn: useCustomFetcher<DeleteEhrCredentialsMutation, DeleteEhrCredentialsMutationVariables>(DeleteEhrCredentialsDocument),
    ...options
  }
    )};

export const EhrRequestActionDocument = `
    mutation ehrRequestAction($actionType: String!, $learnerId: ID, $reportId: ID, $username: String, $password: String) {
  ehrRequestAction(
    actionType: $actionType
    learnerId: $learnerId
    reportId: $reportId
    username: $username
    password: $password
  ) {
    requestId
    status
    created
    requestedById
    message
  }
}
    `;

export const useEhrRequestActionMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<EhrRequestActionMutation, TError, EhrRequestActionMutationVariables, TContext>) => {
    
    return useMutation<EhrRequestActionMutation, TError, EhrRequestActionMutationVariables, TContext>(
      {
    mutationKey: ['ehrRequestAction'],
    mutationFn: useCustomFetcher<EhrRequestActionMutation, EhrRequestActionMutationVariables>(EhrRequestActionDocument),
    ...options
  }
    )};

export const EhrStartWorkflowAndLoginDocument = `
    mutation ehrStartWorkflowAndLogin($username: String, $password: String, $mfa: String) {
  ehrStartWorkflowAndLogin(username: $username, password: $password, mfa: $mfa) {
    message
    status
  }
}
    `;

export const useEhrStartWorkflowAndLoginMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<EhrStartWorkflowAndLoginMutation, TError, EhrStartWorkflowAndLoginMutationVariables, TContext>) => {
    
    return useMutation<EhrStartWorkflowAndLoginMutation, TError, EhrStartWorkflowAndLoginMutationVariables, TContext>(
      {
    mutationKey: ['ehrStartWorkflowAndLogin'],
    mutationFn: useCustomFetcher<EhrStartWorkflowAndLoginMutation, EhrStartWorkflowAndLoginMutationVariables>(EhrStartWorkflowAndLoginDocument),
    ...options
  }
    )};

export const EhrGetClientListDocument = `
    mutation ehrGetClientList {
  ehrGetClientList {
    isComplete
    clients {
      clientId
      firstName
      lastName
      preferredName
      alias
      status
      addressLine1
      addressLine2
      city
      state
      zipCode
      country
      dateOfBirth
      gender
      phone
      email
    }
  }
}
    `;

export const useEhrGetClientListMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<EhrGetClientListMutation, TError, EhrGetClientListMutationVariables, TContext>) => {
    
    return useMutation<EhrGetClientListMutation, TError, EhrGetClientListMutationVariables, TContext>(
      {
    mutationKey: ['ehrGetClientList'],
    mutationFn: useCustomFetcher<EhrGetClientListMutation, EhrGetClientListMutationVariables>(EhrGetClientListDocument),
    ...options
  }
    )};

export const ImportClientFromEhrDocument = `
    mutation importClientFromEhr($learnerExternalId: String!, $reportId: ID) {
  importClientFromEhr(learnerExternalId: $learnerExternalId, reportId: $reportId) {
    status
    message
  }
}
    `;

export const useImportClientFromEhrMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<ImportClientFromEhrMutation, TError, ImportClientFromEhrMutationVariables, TContext>) => {
    
    return useMutation<ImportClientFromEhrMutation, TError, ImportClientFromEhrMutationVariables, TContext>(
      {
    mutationKey: ['importClientFromEhr'],
    mutationFn: useCustomFetcher<ImportClientFromEhrMutation, ImportClientFromEhrMutationVariables>(ImportClientFromEhrDocument),
    ...options
  }
    )};

export const SendClientToFronteraEhrDocument = `
    mutation sendClientToFronteraEhr($reportId: ID!) {
  sendClientToFronteraEhr(reportId: $reportId) {
    status
    message
    linked
    verticalLearnerId
    learner {
      id
      externalId
    }
    exportStatus
  }
}
    `;

export const useSendClientToFronteraEhrMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<SendClientToFronteraEhrMutation, TError, SendClientToFronteraEhrMutationVariables, TContext>) => {
    
    return useMutation<SendClientToFronteraEhrMutation, TError, SendClientToFronteraEhrMutationVariables, TContext>(
      {
    mutationKey: ['sendClientToFronteraEhr'],
    mutationFn: useCustomFetcher<SendClientToFronteraEhrMutation, SendClientToFronteraEhrMutationVariables>(SendClientToFronteraEhrDocument),
    ...options
  }
    )};

export const StartGoalsSyncToEhrDocument = `
    mutation startGoalsSyncToEhr($reportId: ID!) {
  startGoalsSyncToEhr(reportId: $reportId) {
    message
    status
  }
}
    `;

export const useStartGoalsSyncToEhrMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<StartGoalsSyncToEhrMutation, TError, StartGoalsSyncToEhrMutationVariables, TContext>) => {
    
    return useMutation<StartGoalsSyncToEhrMutation, TError, StartGoalsSyncToEhrMutationVariables, TContext>(
      {
    mutationKey: ['startGoalsSyncToEhr'],
    mutationFn: useCustomFetcher<StartGoalsSyncToEhrMutation, StartGoalsSyncToEhrMutationVariables>(StartGoalsSyncToEhrDocument),
    ...options
  }
    )};

export const CreateCareResourceSingleAllocationBlockDocument = `
    mutation createCareResourceSingleAllocationBlock($resourceEmail: String!, $startDatetime: String!, $endDatetime: String!) {
  createCareResourceSingleAllocationBlock(
    resourceEmail: $resourceEmail
    startDatetime: $startDatetime
    endDatetime: $endDatetime
  ) {
    status
    message
    allocation {
      id
      resourceId
      startTime
      endTime
      repeats
      resourceEmail
      deleted
    }
  }
}
    `;

export const useCreateCareResourceSingleAllocationBlockMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateCareResourceSingleAllocationBlockMutation, TError, CreateCareResourceSingleAllocationBlockMutationVariables, TContext>) => {
    
    return useMutation<CreateCareResourceSingleAllocationBlockMutation, TError, CreateCareResourceSingleAllocationBlockMutationVariables, TContext>(
      {
    mutationKey: ['createCareResourceSingleAllocationBlock'],
    mutationFn: useCustomFetcher<CreateCareResourceSingleAllocationBlockMutation, CreateCareResourceSingleAllocationBlockMutationVariables>(CreateCareResourceSingleAllocationBlockDocument),
    ...options
  }
    )};

export const CreateCareResourceWeeklyAllocationBlockDocument = `
    mutation createCareResourceWeeklyAllocationBlock($resourceEmail: String!, $startDate: String!, $endDate: String!, $sunday: DayScheduleInputType, $monday: DayScheduleInputType, $tuesday: DayScheduleInputType, $wednesday: DayScheduleInputType, $thursday: DayScheduleInputType, $friday: DayScheduleInputType, $saturday: DayScheduleInputType) {
  createCareResourceWeeklyAllocationBlock(
    resourceEmail: $resourceEmail
    startDate: $startDate
    endDate: $endDate
    sunday: $sunday
    monday: $monday
    tuesday: $tuesday
    wednesday: $wednesday
    thursday: $thursday
    friday: $friday
    saturday: $saturday
  ) {
    status
    message
    allocation {
      id
      resourceId
      startDate
      endDate
      sunday {
        startTime
        endTime
      }
      monday {
        startTime
        endTime
      }
      tuesday {
        startTime
        endTime
      }
      wednesday {
        startTime
        endTime
      }
      thursday {
        startTime
        endTime
      }
      friday {
        startTime
        endTime
      }
      saturday {
        startTime
        endTime
      }
      resourceEmail
      deleted
    }
  }
}
    `;

export const useCreateCareResourceWeeklyAllocationBlockMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateCareResourceWeeklyAllocationBlockMutation, TError, CreateCareResourceWeeklyAllocationBlockMutationVariables, TContext>) => {
    
    return useMutation<CreateCareResourceWeeklyAllocationBlockMutation, TError, CreateCareResourceWeeklyAllocationBlockMutationVariables, TContext>(
      {
    mutationKey: ['createCareResourceWeeklyAllocationBlock'],
    mutationFn: useCustomFetcher<CreateCareResourceWeeklyAllocationBlockMutation, CreateCareResourceWeeklyAllocationBlockMutationVariables>(CreateCareResourceWeeklyAllocationBlockDocument),
    ...options
  }
    )};

export const DeleteCareResourceSingleAllocationBlockDocument = `
    mutation deleteCareResourceSingleAllocationBlock($allocationId: String!) {
  deleteCareResourceSingleAllocationBlock(allocationId: $allocationId) {
    status
    message
  }
}
    `;

export const useDeleteCareResourceSingleAllocationBlockMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<DeleteCareResourceSingleAllocationBlockMutation, TError, DeleteCareResourceSingleAllocationBlockMutationVariables, TContext>) => {
    
    return useMutation<DeleteCareResourceSingleAllocationBlockMutation, TError, DeleteCareResourceSingleAllocationBlockMutationVariables, TContext>(
      {
    mutationKey: ['deleteCareResourceSingleAllocationBlock'],
    mutationFn: useCustomFetcher<DeleteCareResourceSingleAllocationBlockMutation, DeleteCareResourceSingleAllocationBlockMutationVariables>(DeleteCareResourceSingleAllocationBlockDocument),
    ...options
  }
    )};

export const DeleteCareResourceWeeklyAllocationBlockDocument = `
    mutation deleteCareResourceWeeklyAllocationBlock($allocationId: String!) {
  deleteCareResourceWeeklyAllocationBlock(allocationId: $allocationId) {
    status
    message
  }
}
    `;

export const useDeleteCareResourceWeeklyAllocationBlockMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<DeleteCareResourceWeeklyAllocationBlockMutation, TError, DeleteCareResourceWeeklyAllocationBlockMutationVariables, TContext>) => {
    
    return useMutation<DeleteCareResourceWeeklyAllocationBlockMutation, TError, DeleteCareResourceWeeklyAllocationBlockMutationVariables, TContext>(
      {
    mutationKey: ['deleteCareResourceWeeklyAllocationBlock'],
    mutationFn: useCustomFetcher<DeleteCareResourceWeeklyAllocationBlockMutation, DeleteCareResourceWeeklyAllocationBlockMutationVariables>(DeleteCareResourceWeeklyAllocationBlockDocument),
    ...options
  }
    )};

export const RescheduleCareAppointmentDocument = `
    mutation rescheduleCareAppointment($appointmentId: String!, $startTime: String!, $endTime: String!) {
  rescheduleCareAppointment(
    appointmentId: $appointmentId
    startTime: $startTime
    endTime: $endTime
  ) {
    status
    message
    appointment {
      id
      startTime
      endTime
      status
      serviceId
      serviceName
      locationId
      locationName
      resourceId
      resourceName
      resourceEmail
      customerFirstName
      customerLastName
      customerEmail
      notes
    }
  }
}
    `;

export const useRescheduleCareAppointmentMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<RescheduleCareAppointmentMutation, TError, RescheduleCareAppointmentMutationVariables, TContext>) => {
    
    return useMutation<RescheduleCareAppointmentMutation, TError, RescheduleCareAppointmentMutationVariables, TContext>(
      {
    mutationKey: ['rescheduleCareAppointment'],
    mutationFn: useCustomFetcher<RescheduleCareAppointmentMutation, RescheduleCareAppointmentMutationVariables>(RescheduleCareAppointmentDocument),
    ...options
  }
    )};

export const UpdateCareAppointmentCustomFieldsDocument = `
    mutation updateCareAppointmentCustomFields($appointmentId: String!, $customFields: JSONString!) {
  updateCareAppointmentCustomFields(
    appointmentId: $appointmentId
    customFields: $customFields
  ) {
    status
    message
    appointment {
      id
      startTime
      endTime
      status
      serviceId
      serviceName
      locationId
      locationName
      resourceId
      resourceName
      resourceEmail
      customerFirstName
      customerLastName
      customerEmail
      notes
      customFields
    }
  }
}
    `;

export const useUpdateCareAppointmentCustomFieldsMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateCareAppointmentCustomFieldsMutation, TError, UpdateCareAppointmentCustomFieldsMutationVariables, TContext>) => {
    
    return useMutation<UpdateCareAppointmentCustomFieldsMutation, TError, UpdateCareAppointmentCustomFieldsMutationVariables, TContext>(
      {
    mutationKey: ['updateCareAppointmentCustomFields'],
    mutationFn: useCustomFetcher<UpdateCareAppointmentCustomFieldsMutation, UpdateCareAppointmentCustomFieldsMutationVariables>(UpdateCareAppointmentCustomFieldsDocument),
    ...options
  }
    )};

export const UpdateCareAppointmentNoteDocument = `
    mutation updateCareAppointmentNote($appointmentId: String!, $notes: String!) {
  updateCareAppointmentNote(appointmentId: $appointmentId, notes: $notes) {
    status
    message
    appointment {
      id
      startTime
      endTime
      status
      serviceId
      serviceName
      locationId
      locationName
      resourceId
      resourceName
      resourceEmail
      customerFirstName
      customerLastName
      customerEmail
      notes
    }
  }
}
    `;

export const useUpdateCareAppointmentNoteMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateCareAppointmentNoteMutation, TError, UpdateCareAppointmentNoteMutationVariables, TContext>) => {
    
    return useMutation<UpdateCareAppointmentNoteMutation, TError, UpdateCareAppointmentNoteMutationVariables, TContext>(
      {
    mutationKey: ['updateCareAppointmentNote'],
    mutationFn: useCustomFetcher<UpdateCareAppointmentNoteMutation, UpdateCareAppointmentNoteMutationVariables>(UpdateCareAppointmentNoteDocument),
    ...options
  }
    )};

export const ArchiveGoalBankCurriculumDocument = `
    mutation ArchiveGoalBankCurriculum($curriculumId: ID!, $archived: Boolean, $dryRun: Boolean) {
  archiveGoalBankCurriculum(
    curriculumId: $curriculumId
    archived: $archived
    dryRun: $dryRun
  ) {
    message
    status
  }
}
    `;

export const useArchiveGoalBankCurriculumMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<ArchiveGoalBankCurriculumMutation, TError, ArchiveGoalBankCurriculumMutationVariables, TContext>) => {
    
    return useMutation<ArchiveGoalBankCurriculumMutation, TError, ArchiveGoalBankCurriculumMutationVariables, TContext>(
      {
    mutationKey: ['ArchiveGoalBankCurriculum'],
    mutationFn: useCustomFetcher<ArchiveGoalBankCurriculumMutation, ArchiveGoalBankCurriculumMutationVariables>(ArchiveGoalBankCurriculumDocument),
    ...options
  }
    )};

export const CreateGoalBankFolderDocument = `
    mutation createGoalBankFolder($input: CreateGoalBankFolderInput!) {
  createGoalBankFolder(input: $input) {
    message
    status
    goalBankFolder {
      id
      name
      folderType
    }
  }
}
    `;

export const useCreateGoalBankFolderMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateGoalBankFolderMutation, TError, CreateGoalBankFolderMutationVariables, TContext>) => {
    
    return useMutation<CreateGoalBankFolderMutation, TError, CreateGoalBankFolderMutationVariables, TContext>(
      {
    mutationKey: ['createGoalBankFolder'],
    mutationFn: useCustomFetcher<CreateGoalBankFolderMutation, CreateGoalBankFolderMutationVariables>(CreateGoalBankFolderDocument),
    ...options
  }
    )};

export const CreateGoalBankGoalsDocument = `
    mutation createGoalBankGoals($input: CreateGoalBankGoalsInput!) {
  createGoalBankGoals(input: $input) {
    message
    status
  }
}
    `;

export const useCreateGoalBankGoalsMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateGoalBankGoalsMutation, TError, CreateGoalBankGoalsMutationVariables, TContext>) => {
    
    return useMutation<CreateGoalBankGoalsMutation, TError, CreateGoalBankGoalsMutationVariables, TContext>(
      {
    mutationKey: ['createGoalBankGoals'],
    mutationFn: useCustomFetcher<CreateGoalBankGoalsMutation, CreateGoalBankGoalsMutationVariables>(CreateGoalBankGoalsDocument),
    ...options
  }
    )};

export const CreateGoalBankTargetsDocument = `
    mutation createGoalBankTargets($input: CreateGoalBankTargetsInput!) {
  createGoalBankTargets(input: $input) {
    message
    status
  }
}
    `;

export const useCreateGoalBankTargetsMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateGoalBankTargetsMutation, TError, CreateGoalBankTargetsMutationVariables, TContext>) => {
    
    return useMutation<CreateGoalBankTargetsMutation, TError, CreateGoalBankTargetsMutationVariables, TContext>(
      {
    mutationKey: ['createGoalBankTargets'],
    mutationFn: useCustomFetcher<CreateGoalBankTargetsMutation, CreateGoalBankTargetsMutationVariables>(CreateGoalBankTargetsDocument),
    ...options
  }
    )};

export const DeleteGoalBankFolderDocument = `
    mutation DeleteGoalBankFolder($input: DeleteGoalBankFolderInput!) {
  deleteGoalBankFolder(input: $input) {
    message
    status
  }
}
    `;

export const useDeleteGoalBankFolderMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<DeleteGoalBankFolderMutation, TError, DeleteGoalBankFolderMutationVariables, TContext>) => {
    
    return useMutation<DeleteGoalBankFolderMutation, TError, DeleteGoalBankFolderMutationVariables, TContext>(
      {
    mutationKey: ['DeleteGoalBankFolder'],
    mutationFn: useCustomFetcher<DeleteGoalBankFolderMutation, DeleteGoalBankFolderMutationVariables>(DeleteGoalBankFolderDocument),
    ...options
  }
    )};

export const DeleteGoalBankGoalDocument = `
    mutation deleteGoalBankGoal($input: DeleteGoalBankGoalInput!) {
  deleteGoalBankGoal(input: $input) {
    message
    status
  }
}
    `;

export const useDeleteGoalBankGoalMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<DeleteGoalBankGoalMutation, TError, DeleteGoalBankGoalMutationVariables, TContext>) => {
    
    return useMutation<DeleteGoalBankGoalMutation, TError, DeleteGoalBankGoalMutationVariables, TContext>(
      {
    mutationKey: ['deleteGoalBankGoal'],
    mutationFn: useCustomFetcher<DeleteGoalBankGoalMutation, DeleteGoalBankGoalMutationVariables>(DeleteGoalBankGoalDocument),
    ...options
  }
    )};

export const DeleteGoalBankTargetDocument = `
    mutation deleteGoalBankTarget($input: DeleteGoalBankTargetInput!) {
  deleteGoalBankTarget(input: $input) {
    message
    status
  }
}
    `;

export const useDeleteGoalBankTargetMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<DeleteGoalBankTargetMutation, TError, DeleteGoalBankTargetMutationVariables, TContext>) => {
    
    return useMutation<DeleteGoalBankTargetMutation, TError, DeleteGoalBankTargetMutationVariables, TContext>(
      {
    mutationKey: ['deleteGoalBankTarget'],
    mutationFn: useCustomFetcher<DeleteGoalBankTargetMutation, DeleteGoalBankTargetMutationVariables>(DeleteGoalBankTargetDocument),
    ...options
  }
    )};

export const ExportGoalBankCurriculumDocument = `
    mutation ExportGoalBankCurriculum($curriculumId: ID!) {
  exportGoalBankCurriculum(curriculumId: $curriculumId) {
    signedUrl
    fileName
  }
}
    `;

export const useExportGoalBankCurriculumMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<ExportGoalBankCurriculumMutation, TError, ExportGoalBankCurriculumMutationVariables, TContext>) => {
    
    return useMutation<ExportGoalBankCurriculumMutation, TError, ExportGoalBankCurriculumMutationVariables, TContext>(
      {
    mutationKey: ['ExportGoalBankCurriculum'],
    mutationFn: useCustomFetcher<ExportGoalBankCurriculumMutation, ExportGoalBankCurriculumMutationVariables>(ExportGoalBankCurriculumDocument),
    ...options
  }
    )};

export const GetGoalBankUploadUrlDocument = `
    mutation GetGoalBankUploadUrl($fileName: String!, $contentType: String!) {
  getGoalBankUploadUrl(fileName: $fileName, contentType: $contentType) {
    signedUrl
    s3Key
  }
}
    `;

export const useGetGoalBankUploadUrlMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<GetGoalBankUploadUrlMutation, TError, GetGoalBankUploadUrlMutationVariables, TContext>) => {
    
    return useMutation<GetGoalBankUploadUrlMutation, TError, GetGoalBankUploadUrlMutationVariables, TContext>(
      {
    mutationKey: ['GetGoalBankUploadUrl'],
    mutationFn: useCustomFetcher<GetGoalBankUploadUrlMutation, GetGoalBankUploadUrlMutationVariables>(GetGoalBankUploadUrlDocument),
    ...options
  }
    )};

export const ImportGoalBankDocument = `
    mutation ImportGoalBank($input: ImportGoalBankInput!) {
  importGoalBank(input: $input) {
    status
    message
    stats
  }
}
    `;

export const useImportGoalBankMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<ImportGoalBankMutation, TError, ImportGoalBankMutationVariables, TContext>) => {
    
    return useMutation<ImportGoalBankMutation, TError, ImportGoalBankMutationVariables, TContext>(
      {
    mutationKey: ['ImportGoalBank'],
    mutationFn: useCustomFetcher<ImportGoalBankMutation, ImportGoalBankMutationVariables>(ImportGoalBankDocument),
    ...options
  }
    )};

export const MoveGoalBankGoalDocument = `
    mutation moveGoalBankGoal($input: MoveGoalBankGoalInput!) {
  moveGoalBankGoal(input: $input) {
    message
    status
  }
}
    `;

export const useMoveGoalBankGoalMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<MoveGoalBankGoalMutation, TError, MoveGoalBankGoalMutationVariables, TContext>) => {
    
    return useMutation<MoveGoalBankGoalMutation, TError, MoveGoalBankGoalMutationVariables, TContext>(
      {
    mutationKey: ['moveGoalBankGoal'],
    mutationFn: useCustomFetcher<MoveGoalBankGoalMutation, MoveGoalBankGoalMutationVariables>(MoveGoalBankGoalDocument),
    ...options
  }
    )};

export const MoveTargetToFolderDocument = `
    mutation moveTargetToFolder($input: MoveGoalBankTargetInput!) {
  moveGoalBankTarget(input: $input) {
    message
    status
  }
}
    `;

export const useMoveTargetToFolderMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<MoveTargetToFolderMutation, TError, MoveTargetToFolderMutationVariables, TContext>) => {
    
    return useMutation<MoveTargetToFolderMutation, TError, MoveTargetToFolderMutationVariables, TContext>(
      {
    mutationKey: ['moveTargetToFolder'],
    mutationFn: useCustomFetcher<MoveTargetToFolderMutation, MoveTargetToFolderMutationVariables>(MoveTargetToFolderDocument),
    ...options
  }
    )};

export const UpdateGoalBankFolderDocument = `
    mutation UpdateGoalBankFolder($input: UpdateGoalBankFolderInput!) {
  updateGoalBankFolder(input: $input) {
    message
    status
  }
}
    `;

export const useUpdateGoalBankFolderMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateGoalBankFolderMutation, TError, UpdateGoalBankFolderMutationVariables, TContext>) => {
    
    return useMutation<UpdateGoalBankFolderMutation, TError, UpdateGoalBankFolderMutationVariables, TContext>(
      {
    mutationKey: ['UpdateGoalBankFolder'],
    mutationFn: useCustomFetcher<UpdateGoalBankFolderMutation, UpdateGoalBankFolderMutationVariables>(UpdateGoalBankFolderDocument),
    ...options
  }
    )};

export const UpdateGoalBankGoalDocument = `
    mutation updateGoalBankGoal($input: UpdateGoalBankGoalInput!) {
  updateGoalBankGoal(input: $input) {
    message
    status
  }
}
    `;

export const useUpdateGoalBankGoalMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateGoalBankGoalMutation, TError, UpdateGoalBankGoalMutationVariables, TContext>) => {
    
    return useMutation<UpdateGoalBankGoalMutation, TError, UpdateGoalBankGoalMutationVariables, TContext>(
      {
    mutationKey: ['updateGoalBankGoal'],
    mutationFn: useCustomFetcher<UpdateGoalBankGoalMutation, UpdateGoalBankGoalMutationVariables>(UpdateGoalBankGoalDocument),
    ...options
  }
    )};

export const UpdateGoalBankTargetDocument = `
    mutation updateGoalBankTarget($input: UpdateGoalBankTargetInput!) {
  updateGoalBankTarget(input: $input) {
    message
    status
  }
}
    `;

export const useUpdateGoalBankTargetMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateGoalBankTargetMutation, TError, UpdateGoalBankTargetMutationVariables, TContext>) => {
    
    return useMutation<UpdateGoalBankTargetMutation, TError, UpdateGoalBankTargetMutationVariables, TContext>(
      {
    mutationKey: ['updateGoalBankTarget'],
    mutationFn: useCustomFetcher<UpdateGoalBankTargetMutation, UpdateGoalBankTargetMutationVariables>(UpdateGoalBankTargetDocument),
    ...options
  }
    )};

export const UpdateProgrammingGoalDocument = `
    mutation UpdateProgrammingGoal($learnerId: ID!, $input: UpdateGoalInput!) {
  updateGoal(learnerId: $learnerId, input: $input) {
    status
    message
  }
}
    `;

export const useUpdateProgrammingGoalMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateProgrammingGoalMutation, TError, UpdateProgrammingGoalMutationVariables, TContext>) => {
    
    return useMutation<UpdateProgrammingGoalMutation, TError, UpdateProgrammingGoalMutationVariables, TContext>(
      {
    mutationKey: ['UpdateProgrammingGoal'],
    mutationFn: useCustomFetcher<UpdateProgrammingGoalMutation, UpdateProgrammingGoalMutationVariables>(UpdateProgrammingGoalDocument),
    ...options
  }
    )};

export const CompleteZoomConnectDocument = `
    mutation completeZoomConnect($code: String!) {
  completeZoomConnect(code: $code) {
    status
  }
}
    `;

export const useCompleteZoomConnectMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CompleteZoomConnectMutation, TError, CompleteZoomConnectMutationVariables, TContext>) => {
    
    return useMutation<CompleteZoomConnectMutation, TError, CompleteZoomConnectMutationVariables, TContext>(
      {
    mutationKey: ['completeZoomConnect'],
    mutationFn: useCustomFetcher<CompleteZoomConnectMutation, CompleteZoomConnectMutationVariables>(CompleteZoomConnectDocument),
    ...options
  }
    )};

export const StartZoomConnectDocument = `
    mutation startZoomConnect {
  startZoomConnect {
    url
  }
}
    `;

export const useStartZoomConnectMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<StartZoomConnectMutation, TError, StartZoomConnectMutationVariables, TContext>) => {
    
    return useMutation<StartZoomConnectMutation, TError, StartZoomConnectMutationVariables, TContext>(
      {
    mutationKey: ['startZoomConnect'],
    mutationFn: useCustomFetcher<StartZoomConnectMutation, StartZoomConnectMutationVariables>(StartZoomConnectDocument),
    ...options
  }
    )};

export const CreateIndependentLearnerFileDocument = `
    mutation CreateIndependentLearnerFile($input: CreateIndependentLearnerFileInput!) {
  createIndependentLearnerFile(input: $input) {
    learnerFile {
      id
      signedS3Url
      status
      fileKind
      mimeType
      originalFileName
      metadata
      fileSize
      s3Key
    }
  }
}
    `;

export const useCreateIndependentLearnerFileMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateIndependentLearnerFileMutation, TError, CreateIndependentLearnerFileMutationVariables, TContext>) => {
    
    return useMutation<CreateIndependentLearnerFileMutation, TError, CreateIndependentLearnerFileMutationVariables, TContext>(
      {
    mutationKey: ['CreateIndependentLearnerFile'],
    mutationFn: useCustomFetcher<CreateIndependentLearnerFileMutation, CreateIndependentLearnerFileMutationVariables>(CreateIndependentLearnerFileDocument),
    ...options
  }
    )};

export const DeleteLearnerFileDocument = `
    mutation deleteLearnerFile($fileId: ID!) {
  deleteLearnerFile(fileId: $fileId) {
    status
  }
}
    `;

export const useDeleteLearnerFileMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<DeleteLearnerFileMutation, TError, DeleteLearnerFileMutationVariables, TContext>) => {
    
    return useMutation<DeleteLearnerFileMutation, TError, DeleteLearnerFileMutationVariables, TContext>(
      {
    mutationKey: ['deleteLearnerFile'],
    mutationFn: useCustomFetcher<DeleteLearnerFileMutation, DeleteLearnerFileMutationVariables>(DeleteLearnerFileDocument),
    ...options
  }
    )};

export const GenerateLearnerFilePdfPreviewDocument = `
    mutation generateLearnerFilePdfPreview($learnerFileId: ID!) {
  generateLearnerFilePdfPreview(learnerFileId: $learnerFileId) {
    status
    message
  }
}
    `;

export const useGenerateLearnerFilePdfPreviewMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<GenerateLearnerFilePdfPreviewMutation, TError, GenerateLearnerFilePdfPreviewMutationVariables, TContext>) => {
    
    return useMutation<GenerateLearnerFilePdfPreviewMutation, TError, GenerateLearnerFilePdfPreviewMutationVariables, TContext>(
      {
    mutationKey: ['generateLearnerFilePdfPreview'],
    mutationFn: useCustomFetcher<GenerateLearnerFilePdfPreviewMutation, GenerateLearnerFilePdfPreviewMutationVariables>(GenerateLearnerFilePdfPreviewDocument),
    ...options
  }
    )};

export const MarkLearnerFileAsUploadedDocument = `
    mutation markLearnerFileAsUploaded($fileId: ID!) {
  markLearnerFileAsUploaded(fileId: $fileId) {
    learnerFile {
      id
      status
      mimeType
    }
  }
}
    `;

export const useMarkLearnerFileAsUploadedMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<MarkLearnerFileAsUploadedMutation, TError, MarkLearnerFileAsUploadedMutationVariables, TContext>) => {
    
    return useMutation<MarkLearnerFileAsUploadedMutation, TError, MarkLearnerFileAsUploadedMutationVariables, TContext>(
      {
    mutationKey: ['markLearnerFileAsUploaded'],
    mutationFn: useCustomFetcher<MarkLearnerFileAsUploadedMutation, MarkLearnerFileAsUploadedMutationVariables>(MarkLearnerFileAsUploadedDocument),
    ...options
  }
    )};

export const StartLearnerFileClassificationDocument = `
    mutation startLearnerFileClassification($learnerFileId: ID!) {
  startLearnerFileClassification(learnerFileId: $learnerFileId) {
    message
    status
    learnerFile {
      status
    }
  }
}
    `;

export const useStartLearnerFileClassificationMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<StartLearnerFileClassificationMutation, TError, StartLearnerFileClassificationMutationVariables, TContext>) => {
    
    return useMutation<StartLearnerFileClassificationMutation, TError, StartLearnerFileClassificationMutationVariables, TContext>(
      {
    mutationKey: ['startLearnerFileClassification'],
    mutationFn: useCustomFetcher<StartLearnerFileClassificationMutation, StartLearnerFileClassificationMutationVariables>(StartLearnerFileClassificationDocument),
    ...options
  }
    )};

export const StartLearnerFileValidationDocument = `
    mutation startLearnerFileValidation($learnerFileId: ID!) {
  startLearnerFileValidation(learnerFileId: $learnerFileId) {
    status
    message
    learnerFile {
      status
    }
  }
}
    `;

export const useStartLearnerFileValidationMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<StartLearnerFileValidationMutation, TError, StartLearnerFileValidationMutationVariables, TContext>) => {
    
    return useMutation<StartLearnerFileValidationMutation, TError, StartLearnerFileValidationMutationVariables, TContext>(
      {
    mutationKey: ['startLearnerFileValidation'],
    mutationFn: useCustomFetcher<StartLearnerFileValidationMutation, StartLearnerFileValidationMutationVariables>(StartLearnerFileValidationDocument),
    ...options
  }
    )};

export const StartLearnerMetadataCreationFromAbcIntakeFileDocument = `
    mutation startLearnerMetadataCreationFromAbcIntakeFile($learnerFileId: ID!) {
  startLearnerMetadataCreationFromAbcIntakeFile(learnerFileId: $learnerFileId) {
    status
    message
    learnerFile {
      status
    }
  }
}
    `;

export const useStartLearnerMetadataCreationFromAbcIntakeFileMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<StartLearnerMetadataCreationFromAbcIntakeFileMutation, TError, StartLearnerMetadataCreationFromAbcIntakeFileMutationVariables, TContext>) => {
    
    return useMutation<StartLearnerMetadataCreationFromAbcIntakeFileMutation, TError, StartLearnerMetadataCreationFromAbcIntakeFileMutationVariables, TContext>(
      {
    mutationKey: ['startLearnerMetadataCreationFromAbcIntakeFile'],
    mutationFn: useCustomFetcher<StartLearnerMetadataCreationFromAbcIntakeFileMutation, StartLearnerMetadataCreationFromAbcIntakeFileMutationVariables>(StartLearnerMetadataCreationFromAbcIntakeFileDocument),
    ...options
  }
    )};

export const StartLearnerMetadataCreationFromBhtiaFileDocument = `
    mutation startLearnerMetadataCreationFromBhtiaFile($learnerFileId: ID!) {
  startLearnerMetadataCreationFromBhtiaFile(learnerFileId: $learnerFileId) {
    status
    message
    learnerFile {
      status
    }
  }
}
    `;

export const useStartLearnerMetadataCreationFromBhtiaFileMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<StartLearnerMetadataCreationFromBhtiaFileMutation, TError, StartLearnerMetadataCreationFromBhtiaFileMutationVariables, TContext>) => {
    
    return useMutation<StartLearnerMetadataCreationFromBhtiaFileMutation, TError, StartLearnerMetadataCreationFromBhtiaFileMutationVariables, TContext>(
      {
    mutationKey: ['startLearnerMetadataCreationFromBhtiaFile'],
    mutationFn: useCustomFetcher<StartLearnerMetadataCreationFromBhtiaFileMutation, StartLearnerMetadataCreationFromBhtiaFileMutationVariables>(StartLearnerMetadataCreationFromBhtiaFileDocument),
    ...options
  }
    )};

export const StartReassessmentFileClassificationDocument = `
    mutation startReassessmentFileClassification($learnerFileId: ID!) {
  startReassessmentFileClassification(learnerFileId: $learnerFileId) {
    message
    status
    learnerFile {
      status
    }
  }
}
    `;

export const useStartReassessmentFileClassificationMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<StartReassessmentFileClassificationMutation, TError, StartReassessmentFileClassificationMutationVariables, TContext>) => {
    
    return useMutation<StartReassessmentFileClassificationMutation, TError, StartReassessmentFileClassificationMutationVariables, TContext>(
      {
    mutationKey: ['startReassessmentFileClassification'],
    mutationFn: useCustomFetcher<StartReassessmentFileClassificationMutation, StartReassessmentFileClassificationMutationVariables>(StartReassessmentFileClassificationDocument),
    ...options
  }
    )};

export const UpdateLearnerFileClassificationDocument = `
    mutation UpdateLearnerFileClassification($fileId: ID!, $classification: String) {
  updateLearnerFileClassification(
    fileId: $fileId
    classification: $classification
  ) {
    learnerFile {
      id
      fileKind
      status
    }
  }
}
    `;

export const useUpdateLearnerFileClassificationMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateLearnerFileClassificationMutation, TError, UpdateLearnerFileClassificationMutationVariables, TContext>) => {
    
    return useMutation<UpdateLearnerFileClassificationMutation, TError, UpdateLearnerFileClassificationMutationVariables, TContext>(
      {
    mutationKey: ['UpdateLearnerFileClassification'],
    mutationFn: useCustomFetcher<UpdateLearnerFileClassificationMutation, UpdateLearnerFileClassificationMutationVariables>(UpdateLearnerFileClassificationDocument),
    ...options
  }
    )};

export const UpdateLearnerFileEffectiveDateDocument = `
    mutation UpdateLearnerFileEffectiveDate($fileId: ID!, $effectiveDate: Date) {
  updateLearnerFileEffectiveDate(fileId: $fileId, effectiveDate: $effectiveDate) {
    learnerFile {
      id
      effectiveDate
      clinicianEditedAt
    }
  }
}
    `;

export const useUpdateLearnerFileEffectiveDateMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateLearnerFileEffectiveDateMutation, TError, UpdateLearnerFileEffectiveDateMutationVariables, TContext>) => {
    
    return useMutation<UpdateLearnerFileEffectiveDateMutation, TError, UpdateLearnerFileEffectiveDateMutationVariables, TContext>(
      {
    mutationKey: ['UpdateLearnerFileEffectiveDate'],
    mutationFn: useCustomFetcher<UpdateLearnerFileEffectiveDateMutation, UpdateLearnerFileEffectiveDateMutationVariables>(UpdateLearnerFileEffectiveDateDocument),
    ...options
  }
    )};

export const UpdateLearnerFileInterviewTypeDocument = `
    mutation UpdateLearnerFileInterviewType($fileId: ID!, $interviewType: String!) {
  updateLearnerFileInterviewType(fileId: $fileId, interviewType: $interviewType) {
    learnerFile {
      id
      status
      metadata
    }
  }
}
    `;

export const useUpdateLearnerFileInterviewTypeMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateLearnerFileInterviewTypeMutation, TError, UpdateLearnerFileInterviewTypeMutationVariables, TContext>) => {
    
    return useMutation<UpdateLearnerFileInterviewTypeMutation, TError, UpdateLearnerFileInterviewTypeMutationVariables, TContext>(
      {
    mutationKey: ['UpdateLearnerFileInterviewType'],
    mutationFn: useCustomFetcher<UpdateLearnerFileInterviewTypeMutation, UpdateLearnerFileInterviewTypeMutationVariables>(UpdateLearnerFileInterviewTypeDocument),
    ...options
  }
    )};

export const UpdateLearnerFileLanguageDocument = `
    mutation UpdateLearnerFileLanguage($fileId: ID!, $language: String!) {
  updateLearnerFileLanguage(fileId: $fileId, language: $language) {
    learnerFile {
      id
      status
      metadata
    }
  }
}
    `;

export const useUpdateLearnerFileLanguageMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateLearnerFileLanguageMutation, TError, UpdateLearnerFileLanguageMutationVariables, TContext>) => {
    
    return useMutation<UpdateLearnerFileLanguageMutation, TError, UpdateLearnerFileLanguageMutationVariables, TContext>(
      {
    mutationKey: ['UpdateLearnerFileLanguage'],
    mutationFn: useCustomFetcher<UpdateLearnerFileLanguageMutation, UpdateLearnerFileLanguageMutationVariables>(UpdateLearnerFileLanguageDocument),
    ...options
  }
    )};

export const UpdateLearnerFileParsedResultDocument = `
    mutation UpdateLearnerFileParsedResult($fileId: ID!, $parsedData: String, $parsedDataScoped: String, $parsedTables: JSONString, $triggerSectionRegen: Boolean) {
  updateLearnerFileParsedResult(
    fileId: $fileId
    parsedData: $parsedData
    parsedDataScoped: $parsedDataScoped
    parsedTables: $parsedTables
    triggerSectionRegen: $triggerSectionRegen
  ) {
    learnerFile {
      id
      parsedResult
      parsedResultScoped
    }
  }
}
    `;

export const useUpdateLearnerFileParsedResultMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateLearnerFileParsedResultMutation, TError, UpdateLearnerFileParsedResultMutationVariables, TContext>) => {
    
    return useMutation<UpdateLearnerFileParsedResultMutation, TError, UpdateLearnerFileParsedResultMutationVariables, TContext>(
      {
    mutationKey: ['UpdateLearnerFileParsedResult'],
    mutationFn: useCustomFetcher<UpdateLearnerFileParsedResultMutation, UpdateLearnerFileParsedResultMutationVariables>(UpdateLearnerFileParsedResultDocument),
    ...options
  }
    )};

export const UploadChatAssetFileDocument = `
    mutation uploadChatAssetFile($input: CreateIndependentLearnerFileInput!) {
  createIndependentLearnerFile(input: $input) {
    learnerFile {
      id
      signedS3Url
    }
  }
}
    `;

export const useUploadChatAssetFileMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UploadChatAssetFileMutation, TError, UploadChatAssetFileMutationVariables, TContext>) => {
    
    return useMutation<UploadChatAssetFileMutation, TError, UploadChatAssetFileMutationVariables, TContext>(
      {
    mutationKey: ['uploadChatAssetFile'],
    mutationFn: useCustomFetcher<UploadChatAssetFileMutation, UploadChatAssetFileMutationVariables>(UploadChatAssetFileDocument),
    ...options
  }
    )};

export const CreateLearnerDocument = `
    mutation createLearner {
  createLearner {
    learner {
      id
    }
  }
}
    `;

export const useCreateLearnerMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateLearnerMutation, TError, CreateLearnerMutationVariables, TContext>) => {
    
    return useMutation<CreateLearnerMutation, TError, CreateLearnerMutationVariables, TContext>(
      {
    mutationKey: ['createLearner'],
    mutationFn: useCustomFetcher<CreateLearnerMutation, CreateLearnerMutationVariables>(CreateLearnerDocument),
    ...options
  }
    )};

export const CreateLearnerCaregiverDocument = `
    mutation createLearnerCaregiver($availability: AvailabilityInput, $learner: LearnerInput!, $insurance: InsuranceInput, $caregiver: CaregiverInput, $sendIntake: Boolean!, $providerIds: [ID]) {
  createLearnerCaregiver(
    availability: $availability
    insurance: $insurance
    learner: $learner
    caregiver: $caregiver
    sendIntake: $sendIntake
    providerIds: $providerIds
  ) {
    message
    status
    learner {
      id
    }
    caregiver {
      id
      caregivermetadata {
        id
        firstName
        lastName
        email
        phoneNumber1
        nearestLocation
        referralSource
        smsAgreement
        appActivationCode
        appActivationCodeUsedAt
        appActivationEligible
        activationCodeEmailLastSendDate
        activationCodeSmsLastSendDate
      }
      relationshipSet {
        edges {
          node {
            isPrimary
            relationship
            relationshipLearner {
              id
              learnermetadata {
                firstName
                lastName
                birthDate
              }
              learnerproviderSet {
                edges {
                  node {
                    provider {
                      id
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
    `;

export const useCreateLearnerCaregiverMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateLearnerCaregiverMutation, TError, CreateLearnerCaregiverMutationVariables, TContext>) => {
    
    return useMutation<CreateLearnerCaregiverMutation, TError, CreateLearnerCaregiverMutationVariables, TContext>(
      {
    mutationKey: ['createLearnerCaregiver'],
    mutationFn: useCustomFetcher<CreateLearnerCaregiverMutation, CreateLearnerCaregiverMutationVariables>(CreateLearnerCaregiverDocument),
    ...options
  }
    )};

export const CreateLearnerInsuranceDocument = `
    mutation createLearnerInsurance($input: CreateLearnerInsuranceInput!) {
  createLearnerInsurance(input: $input) {
    message
    status
  }
}
    `;

export const useCreateLearnerInsuranceMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateLearnerInsuranceMutation, TError, CreateLearnerInsuranceMutationVariables, TContext>) => {
    
    return useMutation<CreateLearnerInsuranceMutation, TError, CreateLearnerInsuranceMutationVariables, TContext>(
      {
    mutationKey: ['createLearnerInsurance'],
    mutationFn: useCustomFetcher<CreateLearnerInsuranceMutation, CreateLearnerInsuranceMutationVariables>(CreateLearnerInsuranceDocument),
    ...options
  }
    )};

export const UpdateCaregiverConsentsDocument = `
    mutation UpdateCaregiverConsents($consentUpdates: [CaregiverConsentInput!]!) {
  updateCaregiverConsents(consentUpdates: $consentUpdates) {
    success
  }
}
    `;

export const useUpdateCaregiverConsentsMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateCaregiverConsentsMutation, TError, UpdateCaregiverConsentsMutationVariables, TContext>) => {
    
    return useMutation<UpdateCaregiverConsentsMutation, TError, UpdateCaregiverConsentsMutationVariables, TContext>(
      {
    mutationKey: ['UpdateCaregiverConsents'],
    mutationFn: useCustomFetcher<UpdateCaregiverConsentsMutation, UpdateCaregiverConsentsMutationVariables>(UpdateCaregiverConsentsDocument),
    ...options
  }
    )};

export const ImportClientListDocument = `
    mutation importClientList {
  importClientList {
    status
    message
  }
}
    `;

export const useImportClientListMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<ImportClientListMutation, TError, ImportClientListMutationVariables, TContext>) => {
    
    return useMutation<ImportClientListMutation, TError, ImportClientListMutationVariables, TContext>(
      {
    mutationKey: ['importClientList'],
    mutationFn: useCustomFetcher<ImportClientListMutation, ImportClientListMutationVariables>(ImportClientListDocument),
    ...options
  }
    )};

export const RemoveLearnerPayorDocument = `
    mutation removeLearnerPayor($learnerId: ID!, $payorType: PayorType!) {
  removeLearnerPayor(learnerId: $learnerId, payorType: $payorType) {
    status
    errors {
      field
      messages
    }
  }
}
    `;

export const useRemoveLearnerPayorMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<RemoveLearnerPayorMutation, TError, RemoveLearnerPayorMutationVariables, TContext>) => {
    
    return useMutation<RemoveLearnerPayorMutation, TError, RemoveLearnerPayorMutationVariables, TContext>(
      {
    mutationKey: ['removeLearnerPayor'],
    mutationFn: useCustomFetcher<RemoveLearnerPayorMutation, RemoveLearnerPayorMutationVariables>(RemoveLearnerPayorDocument),
    ...options
  }
    )};

export const SetLearnerPayorDocument = `
    mutation setLearnerPayor($learnerId: ID!, $payorTypes: [PayorType!]!) {
  setLearnerPayor(learnerId: $learnerId, payorTypes: $payorTypes) {
    status
    learnerPayors {
      id
      payorType
      isActive
      createdDate
    }
    errors {
      field
      messages
    }
  }
}
    `;

export const useSetLearnerPayorMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<SetLearnerPayorMutation, TError, SetLearnerPayorMutationVariables, TContext>) => {
    
    return useMutation<SetLearnerPayorMutation, TError, SetLearnerPayorMutationVariables, TContext>(
      {
    mutationKey: ['setLearnerPayor'],
    mutationFn: useCustomFetcher<SetLearnerPayorMutation, SetLearnerPayorMutationVariables>(SetLearnerPayorDocument),
    ...options
  }
    )};

export const UnassignCaregiverFromLearnerDocument = `
    mutation unassignCaregiverFromLearner($learnerId: ID!, $caregiverId: ID!) {
  unassignCaregiverFromLearner(learnerId: $learnerId, caregiverId: $caregiverId) {
    message
    status
  }
}
    `;

export const useUnassignCaregiverFromLearnerMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UnassignCaregiverFromLearnerMutation, TError, UnassignCaregiverFromLearnerMutationVariables, TContext>) => {
    
    return useMutation<UnassignCaregiverFromLearnerMutation, TError, UnassignCaregiverFromLearnerMutationVariables, TContext>(
      {
    mutationKey: ['unassignCaregiverFromLearner'],
    mutationFn: useCustomFetcher<UnassignCaregiverFromLearnerMutation, UnassignCaregiverFromLearnerMutationVariables>(UnassignCaregiverFromLearnerDocument),
    ...options
  }
    )};

export const UpdateLearnerAvailabilityDetailsDocument = `
    mutation updateLearnerAvailabilityDetails($learner: ID!, $details: AvailabilityInput!) {
  updateLearnerAvailabilityDetails(learner: $learner, details: $details) {
    message
    status
  }
}
    `;

export const useUpdateLearnerAvailabilityDetailsMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateLearnerAvailabilityDetailsMutation, TError, UpdateLearnerAvailabilityDetailsMutationVariables, TContext>) => {
    
    return useMutation<UpdateLearnerAvailabilityDetailsMutation, TError, UpdateLearnerAvailabilityDetailsMutationVariables, TContext>(
      {
    mutationKey: ['updateLearnerAvailabilityDetails'],
    mutationFn: useCustomFetcher<UpdateLearnerAvailabilityDetailsMutation, UpdateLearnerAvailabilityDetailsMutationVariables>(UpdateLearnerAvailabilityDetailsDocument),
    ...options
  }
    )};

export const UpdateLearnerGeneralDetailsDocument = `
    mutation updateLearnerGeneralDetails($learner: ID!, $learnerDetails: LearnerGeneralDetailsInput!) {
  updateLearnerGeneralDetails(learner: $learner, generalDetails: $learnerDetails) {
    message
    status
  }
}
    `;

export const useUpdateLearnerGeneralDetailsMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateLearnerGeneralDetailsMutation, TError, UpdateLearnerGeneralDetailsMutationVariables, TContext>) => {
    
    return useMutation<UpdateLearnerGeneralDetailsMutation, TError, UpdateLearnerGeneralDetailsMutationVariables, TContext>(
      {
    mutationKey: ['updateLearnerGeneralDetails'],
    mutationFn: useCustomFetcher<UpdateLearnerGeneralDetailsMutation, UpdateLearnerGeneralDetailsMutationVariables>(UpdateLearnerGeneralDetailsDocument),
    ...options
  }
    )};

export const UpdateLearnerCaregiverDetailsDocument = `
    mutation updateLearnerCaregiverDetails($learner: ID!, $caregiverDetails: CaregiverInput!) {
  updateLearnerCaregiverDetails(
    learner: $learner
    caregiverDetails: $caregiverDetails
  ) {
    message
    status
    caregiverData {
      id
      isAllowedAppAccess
      caregivermetadata {
        id
        firstName
        lastName
        email
        phoneNumber1
        nearestLocation
        referralSource
        smsAgreement
        appActivationCode
        appActivationCodeUsedAt
        appActivationEligible
        activationCodeEmailLastSendDate
        activationCodeSmsLastSendDate
      }
      relationshipSet {
        edges {
          node {
            isPrimary
            relationship
            relationshipLearner {
              id
              learnermetadata {
                firstName
                lastName
                birthDate
              }
              learnerproviderSet {
                edges {
                  node {
                    provider {
                      id
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
    `;

export const useUpdateLearnerCaregiverDetailsMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateLearnerCaregiverDetailsMutation, TError, UpdateLearnerCaregiverDetailsMutationVariables, TContext>) => {
    
    return useMutation<UpdateLearnerCaregiverDetailsMutation, TError, UpdateLearnerCaregiverDetailsMutationVariables, TContext>(
      {
    mutationKey: ['updateLearnerCaregiverDetails'],
    mutationFn: useCustomFetcher<UpdateLearnerCaregiverDetailsMutation, UpdateLearnerCaregiverDetailsMutationVariables>(UpdateLearnerCaregiverDetailsDocument),
    ...options
  }
    )};

export const UpdateLearnerDetailsDocument = `
    mutation updateLearnerDetails($learner: ID!, $learnerDetails: LearnerDetailsInput!) {
  updateLearnerDetails(learner: $learner, learnerDetails: $learnerDetails) {
    message
    status
  }
}
    `;

export const useUpdateLearnerDetailsMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateLearnerDetailsMutation, TError, UpdateLearnerDetailsMutationVariables, TContext>) => {
    
    return useMutation<UpdateLearnerDetailsMutation, TError, UpdateLearnerDetailsMutationVariables, TContext>(
      {
    mutationKey: ['updateLearnerDetails'],
    mutationFn: useCustomFetcher<UpdateLearnerDetailsMutation, UpdateLearnerDetailsMutationVariables>(UpdateLearnerDetailsDocument),
    ...options
  }
    )};

export const UpdateLearnerInsuranceDetailsDocument = `
    mutation updateLearnerInsuranceDetails($learner: ID!, $insuranceData: LearnerInsuranceAdminInput!) {
  updateLearnerInsuranceDetails(learner: $learner, insuranceData: $insuranceData) {
    message
    status
  }
}
    `;

export const useUpdateLearnerInsuranceDetailsMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateLearnerInsuranceDetailsMutation, TError, UpdateLearnerInsuranceDetailsMutationVariables, TContext>) => {
    
    return useMutation<UpdateLearnerInsuranceDetailsMutation, TError, UpdateLearnerInsuranceDetailsMutationVariables, TContext>(
      {
    mutationKey: ['updateLearnerInsuranceDetails'],
    mutationFn: useCustomFetcher<UpdateLearnerInsuranceDetailsMutation, UpdateLearnerInsuranceDetailsMutationVariables>(UpdateLearnerInsuranceDetailsDocument),
    ...options
  }
    )};

export const UpdateLearnerIntakeOverviewDetailsDocument = `
    mutation updateLearnerIntakeOverviewDetails($learner: ID!, $learnerDetails: UpdateLearnerIntakeOverviewDetailsInput!) {
  updateLearnerIntakeOverviewDetails(
    learner: $learner
    learnerDetails: $learnerDetails
  ) {
    message
    status
  }
}
    `;

export const useUpdateLearnerIntakeOverviewDetailsMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateLearnerIntakeOverviewDetailsMutation, TError, UpdateLearnerIntakeOverviewDetailsMutationVariables, TContext>) => {
    
    return useMutation<UpdateLearnerIntakeOverviewDetailsMutation, TError, UpdateLearnerIntakeOverviewDetailsMutationVariables, TContext>(
      {
    mutationKey: ['updateLearnerIntakeOverviewDetails'],
    mutationFn: useCustomFetcher<UpdateLearnerIntakeOverviewDetailsMutation, UpdateLearnerIntakeOverviewDetailsMutationVariables>(UpdateLearnerIntakeOverviewDetailsDocument),
    ...options
  }
    )};

export const CreateMediaCommentDocument = `
    mutation createMediaComment($input: MediaCommentInput!) {
  createMediaComment(input: $input) {
    status
    message
    mediaComment {
      id
      content
      commentType
      commentReplies(last: 1) {
        totalCount
        edges {
          node {
            id
            content
            commentType
            author {
              id
              auth0id
              provider {
                providermetadata {
                  firstName
                  lastName
                }
              }
              caregiver {
                caregivermetadata {
                  firstName
                  lastName
                }
              }
            }
            parentComment {
              id
            }
            createdDate
          }
        }
      }
      author {
        id
        auth0id
        provider {
          providermetadata {
            firstName
            lastName
          }
        }
        caregiver {
          caregivermetadata {
            firstName
            lastName
          }
        }
      }
      parentComment {
        id
      }
      media {
        id
      }
      mediaStartTime
      hasReplies
      createdDate
    }
  }
}
    `;

export const useCreateMediaCommentMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateMediaCommentMutation, TError, CreateMediaCommentMutationVariables, TContext>) => {
    
    return useMutation<CreateMediaCommentMutation, TError, CreateMediaCommentMutationVariables, TContext>(
      {
    mutationKey: ['createMediaComment'],
    mutationFn: useCustomFetcher<CreateMediaCommentMutation, CreateMediaCommentMutationVariables>(CreateMediaCommentDocument),
    ...options
  }
    )};

export const CreateMediaTargetPredictionFeedbackDocument = `
    mutation createMediaTargetPredictionFeedback($input: MediaTargetPredictionFeedbackInput!) {
  createMediaTargetPredictionFeedback(input: $input) {
    status
    message
  }
}
    `;

export const useCreateMediaTargetPredictionFeedbackMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateMediaTargetPredictionFeedbackMutation, TError, CreateMediaTargetPredictionFeedbackMutationVariables, TContext>) => {
    
    return useMutation<CreateMediaTargetPredictionFeedbackMutation, TError, CreateMediaTargetPredictionFeedbackMutationVariables, TContext>(
      {
    mutationKey: ['createMediaTargetPredictionFeedback'],
    mutationFn: useCustomFetcher<CreateMediaTargetPredictionFeedbackMutation, CreateMediaTargetPredictionFeedbackMutationVariables>(CreateMediaTargetPredictionFeedbackDocument),
    ...options
  }
    )};

export const CreateUpdateSessionMediaReviewActivityLogDocument = `
    mutation createUpdateSessionMediaReviewActivityLog($input: SessionMediaReviewActivityLogInput!) {
  createUpdateSessionMediaReviewActivityLog(activityLogInput: $input) {
    status
    message
    mediaActivityLog {
      id
      startTime
      endTime
      durationSeconds
      activityType
      media {
        id
      }
    }
  }
}
    `;

export const useCreateUpdateSessionMediaReviewActivityLogMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateUpdateSessionMediaReviewActivityLogMutation, TError, CreateUpdateSessionMediaReviewActivityLogMutationVariables, TContext>) => {
    
    return useMutation<CreateUpdateSessionMediaReviewActivityLogMutation, TError, CreateUpdateSessionMediaReviewActivityLogMutationVariables, TContext>(
      {
    mutationKey: ['createUpdateSessionMediaReviewActivityLog'],
    mutationFn: useCustomFetcher<CreateUpdateSessionMediaReviewActivityLogMutation, CreateUpdateSessionMediaReviewActivityLogMutationVariables>(CreateUpdateSessionMediaReviewActivityLogDocument),
    ...options
  }
    )};

export const DeleteMediaCommentDocument = `
    mutation deleteMediaComment($commentId: ID!) {
  removeMediaComment(commentId: $commentId) {
    status
    message
  }
}
    `;

export const useDeleteMediaCommentMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<DeleteMediaCommentMutation, TError, DeleteMediaCommentMutationVariables, TContext>) => {
    
    return useMutation<DeleteMediaCommentMutation, TError, DeleteMediaCommentMutationVariables, TContext>(
      {
    mutationKey: ['deleteMediaComment'],
    mutationFn: useCustomFetcher<DeleteMediaCommentMutation, DeleteMediaCommentMutationVariables>(DeleteMediaCommentDocument),
    ...options
  }
    )};

export const RemoveSessionDataDocument = `
    mutation removeSessionData($input: RemoveSessionDataInput!) {
  removeSessionData(input: $input) {
    message
    status
    sessionMetaData
  }
}
    `;

export const useRemoveSessionDataMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<RemoveSessionDataMutation, TError, RemoveSessionDataMutationVariables, TContext>) => {
    
    return useMutation<RemoveSessionDataMutation, TError, RemoveSessionDataMutationVariables, TContext>(
      {
    mutationKey: ['removeSessionData'],
    mutationFn: useCustomFetcher<RemoveSessionDataMutation, RemoveSessionDataMutationVariables>(RemoveSessionDataDocument),
    ...options
  }
    )};

export const ManuallyMarkMediaAsViewedDocument = `
    mutation manuallyMarkMediaAsViewed($mediId: ID!, $isReviewed: Boolean!) {
  manuallyMarkMediaAsViewed(mediaId: $mediId, isViewed: $isReviewed) {
    message
    status
    media {
      id
      isViewed
    }
  }
}
    `;

export const useManuallyMarkMediaAsViewedMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<ManuallyMarkMediaAsViewedMutation, TError, ManuallyMarkMediaAsViewedMutationVariables, TContext>) => {
    
    return useMutation<ManuallyMarkMediaAsViewedMutation, TError, ManuallyMarkMediaAsViewedMutationVariables, TContext>(
      {
    mutationKey: ['manuallyMarkMediaAsViewed'],
    mutationFn: useCustomFetcher<ManuallyMarkMediaAsViewedMutation, ManuallyMarkMediaAsViewedMutationVariables>(ManuallyMarkMediaAsViewedDocument),
    ...options
  }
    )};

export const UpdateMediaCommentDocument = `
    mutation updateMediaComment($input: UpdateMediaCommentInput!) {
  updateMediaComment(input: $input) {
    status
    message
    mediaComment {
      id
      content
      commentType
      commentReplies(last: 1) {
        totalCount
        edges {
          node {
            id
            content
            commentType
            author {
              id
              auth0id
              provider {
                providermetadata {
                  firstName
                  lastName
                }
              }
              caregiver {
                caregivermetadata {
                  firstName
                  lastName
                }
              }
            }
            parentComment {
              id
            }
            createdDate
          }
        }
      }
      author {
        id
        auth0id
        provider {
          providermetadata {
            firstName
            lastName
          }
        }
        caregiver {
          caregivermetadata {
            firstName
            lastName
          }
        }
      }
      parentComment {
        id
      }
      media {
        id
      }
      mediaStartTime
      hasReplies
      createdDate
    }
  }
}
    `;

export const useUpdateMediaCommentMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateMediaCommentMutation, TError, UpdateMediaCommentMutationVariables, TContext>) => {
    
    return useMutation<UpdateMediaCommentMutation, TError, UpdateMediaCommentMutationVariables, TContext>(
      {
    mutationKey: ['updateMediaComment'],
    mutationFn: useCustomFetcher<UpdateMediaCommentMutation, UpdateMediaCommentMutationVariables>(UpdateMediaCommentDocument),
    ...options
  }
    )};

export const DismissNotificationDocument = `
    mutation dismissNotification($input: DismissNotificationInput!) {
  dismissNotification(input: $input) {
    status
    message
  }
}
    `;

export const useDismissNotificationMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<DismissNotificationMutation, TError, DismissNotificationMutationVariables, TContext>) => {
    
    return useMutation<DismissNotificationMutation, TError, DismissNotificationMutationVariables, TContext>(
      {
    mutationKey: ['dismissNotification'],
    mutationFn: useCustomFetcher<DismissNotificationMutation, DismissNotificationMutationVariables>(DismissNotificationDocument),
    ...options
  }
    )};

export const ReadAllNotificationsDocument = `
    mutation readAllNotifications {
  readAllNotifications {
    status
    message
  }
}
    `;

export const useReadAllNotificationsMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<ReadAllNotificationsMutation, TError, ReadAllNotificationsMutationVariables, TContext>) => {
    
    return useMutation<ReadAllNotificationsMutation, TError, ReadAllNotificationsMutationVariables, TContext>(
      {
    mutationKey: ['readAllNotifications'],
    mutationFn: useCustomFetcher<ReadAllNotificationsMutation, ReadAllNotificationsMutationVariables>(ReadAllNotificationsDocument),
    ...options
  }
    )};

export const ReadNotificationDocument = `
    mutation readNotification($input: ReadNotificationInput!) {
  readNotification(input: $input) {
    status
    message
  }
}
    `;

export const useReadNotificationMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<ReadNotificationMutation, TError, ReadNotificationMutationVariables, TContext>) => {
    
    return useMutation<ReadNotificationMutation, TError, ReadNotificationMutationVariables, TContext>(
      {
    mutationKey: ['readNotification'],
    mutationFn: useCustomFetcher<ReadNotificationMutation, ReadNotificationMutationVariables>(ReadNotificationDocument),
    ...options
  }
    )};

export const UpdateNotificationOptOutDocument = `
    mutation updateNotificationOptOut($input: UpdateNotificationOptOutInput!) {
  updateNotificationOptOut(input: $input) {
    success
    message
  }
}
    `;

export const useUpdateNotificationOptOutMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateNotificationOptOutMutation, TError, UpdateNotificationOptOutMutationVariables, TContext>) => {
    
    return useMutation<UpdateNotificationOptOutMutation, TError, UpdateNotificationOptOutMutationVariables, TContext>(
      {
    mutationKey: ['updateNotificationOptOut'],
    mutationFn: useCustomFetcher<UpdateNotificationOptOutMutation, UpdateNotificationOptOutMutationVariables>(UpdateNotificationOptOutDocument),
    ...options
  }
    )};

export const UpdateOrgNotificationSettingsDocument = `
    mutation updateOrgNotificationSettings($input: UpdateOrgNotificationSettingsInput!) {
  updateOrgNotificationSettings(input: $input) {
    success
    message
    notificationSettings {
      id
      reassessmentReminder
    }
  }
}
    `;

export const useUpdateOrgNotificationSettingsMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateOrgNotificationSettingsMutation, TError, UpdateOrgNotificationSettingsMutationVariables, TContext>) => {
    
    return useMutation<UpdateOrgNotificationSettingsMutation, TError, UpdateOrgNotificationSettingsMutationVariables, TContext>(
      {
    mutationKey: ['updateOrgNotificationSettings'],
    mutationFn: useCustomFetcher<UpdateOrgNotificationSettingsMutation, UpdateOrgNotificationSettingsMutationVariables>(UpdateOrgNotificationSettingsDocument),
    ...options
  }
    )};

export const ChargeSavedPaymentMethodDocument = `
    mutation chargeSavedPaymentMethod($paymentIntentId: String!) {
  chargeSavedPaymentMethod(paymentIntentId: $paymentIntentId) {
    message
    status
    paymentIntentId
    amountCharged
  }
}
    `;

export const useChargeSavedPaymentMethodMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<ChargeSavedPaymentMethodMutation, TError, ChargeSavedPaymentMethodMutationVariables, TContext>) => {
    
    return useMutation<ChargeSavedPaymentMethodMutation, TError, ChargeSavedPaymentMethodMutationVariables, TContext>(
      {
    mutationKey: ['chargeSavedPaymentMethod'],
    mutationFn: useCustomFetcher<ChargeSavedPaymentMethodMutation, ChargeSavedPaymentMethodMutationVariables>(ChargeSavedPaymentMethodDocument),
    ...options
  }
    )};

export const CreateCheckoutSessionDocument = `
    mutation createCheckoutSession($priceId: String, $redirectOrigin: String!) {
  createCheckoutSession(priceId: $priceId, redirectOrigin: $redirectOrigin) {
    message
    status
    clientSecret
  }
}
    `;

export const useCreateCheckoutSessionMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateCheckoutSessionMutation, TError, CreateCheckoutSessionMutationVariables, TContext>) => {
    
    return useMutation<CreateCheckoutSessionMutation, TError, CreateCheckoutSessionMutationVariables, TContext>(
      {
    mutationKey: ['createCheckoutSession'],
    mutationFn: useCustomFetcher<CreateCheckoutSessionMutation, CreateCheckoutSessionMutationVariables>(CreateCheckoutSessionDocument),
    ...options
  }
    )};

export const CreatePaymentIntentDocument = `
    mutation createPaymentIntent($priceId: String!) {
  createPaymentIntent(priceId: $priceId) {
    message
    status
    paymentClientSecret
    sessionClientSecret
    userAccountDetails {
      stripeCustomerId
      stripePaymentMethodId
    }
    paymentIntentId
  }
}
    `;

export const useCreatePaymentIntentMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreatePaymentIntentMutation, TError, CreatePaymentIntentMutationVariables, TContext>) => {
    
    return useMutation<CreatePaymentIntentMutation, TError, CreatePaymentIntentMutationVariables, TContext>(
      {
    mutationKey: ['createPaymentIntent'],
    mutationFn: useCustomFetcher<CreatePaymentIntentMutation, CreatePaymentIntentMutationVariables>(CreatePaymentIntentDocument),
    ...options
  }
    )};

export const CreateSetupIntentDocument = `
    mutation createSetupIntent {
  createSetupIntent {
    setupClientSecret
    sessionClientSecret
  }
}
    `;

export const useCreateSetupIntentMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateSetupIntentMutation, TError, CreateSetupIntentMutationVariables, TContext>) => {
    
    return useMutation<CreateSetupIntentMutation, TError, CreateSetupIntentMutationVariables, TContext>(
      {
    mutationKey: ['createSetupIntent'],
    mutationFn: useCustomFetcher<CreateSetupIntentMutation, CreateSetupIntentMutationVariables>(CreateSetupIntentDocument),
    ...options
  }
    )};

export const UpdateTaxTransactionDocument = `
    mutation updateTaxTransaction($line1: String, $city: String, $state: String, $postal_code: String, $country: String, $price: Int, $quantity: Int, $paymentIntentId: String, $productId: String) {
  updateTaxTransaction(
    line1: $line1
    city: $city
    state: $state
    postalCode: $postal_code
    country: $country
    price: $price
    quantity: $quantity
    paymentIntentId: $paymentIntentId
    productId: $productId
  ) {
    message
    status
    taxRate
    taxId
  }
}
    `;

export const useUpdateTaxTransactionMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateTaxTransactionMutation, TError, UpdateTaxTransactionMutationVariables, TContext>) => {
    
    return useMutation<UpdateTaxTransactionMutation, TError, UpdateTaxTransactionMutationVariables, TContext>(
      {
    mutationKey: ['updateTaxTransaction'],
    mutationFn: useCustomFetcher<UpdateTaxTransactionMutation, UpdateTaxTransactionMutationVariables>(UpdateTaxTransactionDocument),
    ...options
  }
    )};

export const StartPayorSubmissionWorkflowDocument = `
    mutation startPayorSubmissionWorkflow($reportId: ID!) {
  startPayorSubmissionWorkflow(input: {reportId: $reportId}) {
    status
    message
    payorReportSubmission {
      id
      status
    }
  }
}
    `;

export const useStartPayorSubmissionWorkflowMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<StartPayorSubmissionWorkflowMutation, TError, StartPayorSubmissionWorkflowMutationVariables, TContext>) => {
    
    return useMutation<StartPayorSubmissionWorkflowMutation, TError, StartPayorSubmissionWorkflowMutationVariables, TContext>(
      {
    mutationKey: ['startPayorSubmissionWorkflow'],
    mutationFn: useCustomFetcher<StartPayorSubmissionWorkflowMutation, StartPayorSubmissionWorkflowMutationVariables>(StartPayorSubmissionWorkflowDocument),
    ...options
  }
    )};

export const UpsertReportPayorMetadataDocument = `
    mutation upsertReportPayorMetadata($input: UpsertReportPayorMetadataInput!) {
  upsertReportPayorMetadata(input: $input) {
    status
    message
    reportPayorMetadata {
      id
      treatmentOffered
      firstTreatmentOfferedDate
      paraprofessionalHours
      midLevelHours
      highLevelHours
      groupCare
      comments
    }
  }
}
    `;

export const useUpsertReportPayorMetadataMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpsertReportPayorMetadataMutation, TError, UpsertReportPayorMetadataMutationVariables, TContext>) => {
    
    return useMutation<UpsertReportPayorMetadataMutation, TError, UpsertReportPayorMetadataMutationVariables, TContext>(
      {
    mutationKey: ['upsertReportPayorMetadata'],
    mutationFn: useCustomFetcher<UpsertReportPayorMetadataMutation, UpsertReportPayorMetadataMutationVariables>(UpsertReportPayorMetadataDocument),
    ...options
  }
    )};

export const CompleteProviderOnboardingDocument = `
    mutation completeProviderOnboarding {
  completeProviderOnboarding {
    message
    status
    provider {
      id
      providermetadata {
        id
        onboardingCompleted
      }
    }
  }
}
    `;

export const useCompleteProviderOnboardingMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CompleteProviderOnboardingMutation, TError, CompleteProviderOnboardingMutationVariables, TContext>) => {
    
    return useMutation<CompleteProviderOnboardingMutation, TError, CompleteProviderOnboardingMutationVariables, TContext>(
      {
    mutationKey: ['completeProviderOnboarding'],
    mutationFn: useCustomFetcher<CompleteProviderOnboardingMutation, CompleteProviderOnboardingMutationVariables>(CompleteProviderOnboardingDocument),
    ...options
  }
    )};

export const CreateProviderDocument = `
    mutation createProvider($provider: ProviderInput!) {
  createProvider(provider: $provider) {
    message
    status
    provider {
      id
      providermetadata {
        id
        firstName
        lastName
        email
      }
    }
  }
}
    `;

export const useCreateProviderMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateProviderMutation, TError, CreateProviderMutationVariables, TContext>) => {
    
    return useMutation<CreateProviderMutation, TError, CreateProviderMutationVariables, TContext>(
      {
    mutationKey: ['createProvider'],
    mutationFn: useCustomFetcher<CreateProviderMutation, CreateProviderMutationVariables>(CreateProviderDocument),
    ...options
  }
    )};

export const CreateProviderFileDocument = `
    mutation createProviderFile($input: CreateProviderFileInput!) {
  createProviderFile(input: $input) {
    providerFile {
      id
      signedS3Url
    }
  }
}
    `;

export const useCreateProviderFileMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateProviderFileMutation, TError, CreateProviderFileMutationVariables, TContext>) => {
    
    return useMutation<CreateProviderFileMutation, TError, CreateProviderFileMutationVariables, TContext>(
      {
    mutationKey: ['createProviderFile'],
    mutationFn: useCustomFetcher<CreateProviderFileMutation, CreateProviderFileMutationVariables>(CreateProviderFileDocument),
    ...options
  }
    )};

export const DeleteProviderFileDocument = `
    mutation deleteProviderFile($fileId: ID!) {
  deleteProviderFile(fileId: $fileId) {
    status
  }
}
    `;

export const useDeleteProviderFileMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<DeleteProviderFileMutation, TError, DeleteProviderFileMutationVariables, TContext>) => {
    
    return useMutation<DeleteProviderFileMutation, TError, DeleteProviderFileMutationVariables, TContext>(
      {
    mutationKey: ['deleteProviderFile'],
    mutationFn: useCustomFetcher<DeleteProviderFileMutation, DeleteProviderFileMutationVariables>(DeleteProviderFileDocument),
    ...options
  }
    )};

export const MarkProviderFileAsUploadedDocument = `
    mutation markProviderFileAsUploaded($fileId: ID!) {
  markProviderFileAsUploaded(fileId: $fileId) {
    providerFile {
      id
      signedS3ProviderFile
    }
  }
}
    `;

export const useMarkProviderFileAsUploadedMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<MarkProviderFileAsUploadedMutation, TError, MarkProviderFileAsUploadedMutationVariables, TContext>) => {
    
    return useMutation<MarkProviderFileAsUploadedMutation, TError, MarkProviderFileAsUploadedMutationVariables, TContext>(
      {
    mutationKey: ['markProviderFileAsUploaded'],
    mutationFn: useCustomFetcher<MarkProviderFileAsUploadedMutation, MarkProviderFileAsUploadedMutationVariables>(MarkProviderFileAsUploadedDocument),
    ...options
  }
    )};

export const ReissueProviderInvitationDocument = `
    mutation reissueProviderInvitation($providerId: ID!, $providerRoles: [ProviderRoleEnums], $connectionType: ConnectionTypeEnum) {
  reissueProviderInvitation(
    providerId: $providerId
    providerRoles: $providerRoles
    connectionType: $connectionType
  ) {
    message
    status
  }
}
    `;

export const useReissueProviderInvitationMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<ReissueProviderInvitationMutation, TError, ReissueProviderInvitationMutationVariables, TContext>) => {
    
    return useMutation<ReissueProviderInvitationMutation, TError, ReissueProviderInvitationMutationVariables, TContext>(
      {
    mutationKey: ['reissueProviderInvitation'],
    mutationFn: useCustomFetcher<ReissueProviderInvitationMutation, ReissueProviderInvitationMutationVariables>(ReissueProviderInvitationDocument),
    ...options
  }
    )};

export const UpdateLearnerProvidersDocument = `
    mutation updateLearnerProviders($learnerId: ID!, $providerIds: [ID]!) {
  updateLearnerProviders(
    input: {learnerId: $learnerId, providerIds: $providerIds}
  ) {
    message
    status
  }
}
    `;

export const useUpdateLearnerProvidersMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateLearnerProvidersMutation, TError, UpdateLearnerProvidersMutationVariables, TContext>) => {
    
    return useMutation<UpdateLearnerProvidersMutation, TError, UpdateLearnerProvidersMutationVariables, TContext>(
      {
    mutationKey: ['updateLearnerProviders'],
    mutationFn: useCustomFetcher<UpdateLearnerProvidersMutation, UpdateLearnerProvidersMutationVariables>(UpdateLearnerProvidersDocument),
    ...options
  }
    )};

export const UpdateProviderDocument = `
    mutation updateProvider($provider: UpdateProviderInput!, $providerId: ID!) {
  updateProvider(provider: $provider, providerId: $providerId) {
    message
    status
    provider {
      id
      providermetadata {
        id
        firstName
        lastName
        email
      }
    }
  }
}
    `;

export const useUpdateProviderMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateProviderMutation, TError, UpdateProviderMutationVariables, TContext>) => {
    
    return useMutation<UpdateProviderMutation, TError, UpdateProviderMutationVariables, TContext>(
      {
    mutationKey: ['updateProvider'],
    mutationFn: useCustomFetcher<UpdateProviderMutation, UpdateProviderMutationVariables>(UpdateProviderDocument),
    ...options
  }
    )};

export const UpdateProviderLearnersDocument = `
    mutation updateProviderLearners($learners: [ID], $providerId: ID!) {
  updateProviderLearners(learners: $learners, providerId: $providerId) {
    message
    status
    provider {
      id
      providermetadata {
        id
        firstName
        lastName
        email
      }
    }
  }
}
    `;

export const useUpdateProviderLearnersMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateProviderLearnersMutation, TError, UpdateProviderLearnersMutationVariables, TContext>) => {
    
    return useMutation<UpdateProviderLearnersMutation, TError, UpdateProviderLearnersMutationVariables, TContext>(
      {
    mutationKey: ['updateProviderLearners'],
    mutationFn: useCustomFetcher<UpdateProviderLearnersMutation, UpdateProviderLearnersMutationVariables>(UpdateProviderLearnersDocument),
    ...options
  }
    )};

export const UpdateProviderProfileDocument = `
    mutation updateProviderProfile($providerData: UpdateProviderProfileInput!) {
  updateProviderProfile(providerData: $providerData) {
    message
    status
    provider {
      id
      providermetadata {
        id
        firstName
        lastName
        chatAvailability
        professionalTitle
        licenseNumber
      }
    }
  }
}
    `;

export const useUpdateProviderProfileMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateProviderProfileMutation, TError, UpdateProviderProfileMutationVariables, TContext>) => {
    
    return useMutation<UpdateProviderProfileMutation, TError, UpdateProviderProfileMutationVariables, TContext>(
      {
    mutationKey: ['updateProviderProfile'],
    mutationFn: useCustomFetcher<UpdateProviderProfileMutation, UpdateProviderProfileMutationVariables>(UpdateProviderProfileDocument),
    ...options
  }
    )};

export const CreateRecommendationBankFolderDocument = `
    mutation createRecommendationBankFolder($input: CreateRecommendationBankFolderInput!) {
  createRecommendationBankFolder(input: $input) {
    message
    status
    recommendationBankFolder {
      id
      name
      folderType
    }
  }
}
    `;

export const useCreateRecommendationBankFolderMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateRecommendationBankFolderMutation, TError, CreateRecommendationBankFolderMutationVariables, TContext>) => {
    
    return useMutation<CreateRecommendationBankFolderMutation, TError, CreateRecommendationBankFolderMutationVariables, TContext>(
      {
    mutationKey: ['createRecommendationBankFolder'],
    mutationFn: useCustomFetcher<CreateRecommendationBankFolderMutation, CreateRecommendationBankFolderMutationVariables>(CreateRecommendationBankFolderDocument),
    ...options
  }
    )};

export const CreateRecommendationBankItemDocument = `
    mutation CreateRecommendationBankItem($input: CreateRecommendationBankItemInput!) {
  createRecommendationBankItem(input: $input) {
    message
    status
    recommendationBankItem {
      id
      recommendationContent
      folder {
        id
        name
        folderType
      }
      createdBy {
        id
        username
      }
      updatedBy {
        id
        username
      }
    }
  }
}
    `;

export const useCreateRecommendationBankItemMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateRecommendationBankItemMutation, TError, CreateRecommendationBankItemMutationVariables, TContext>) => {
    
    return useMutation<CreateRecommendationBankItemMutation, TError, CreateRecommendationBankItemMutationVariables, TContext>(
      {
    mutationKey: ['CreateRecommendationBankItem'],
    mutationFn: useCustomFetcher<CreateRecommendationBankItemMutation, CreateRecommendationBankItemMutationVariables>(CreateRecommendationBankItemDocument),
    ...options
  }
    )};

export const DeleteRecommendationBankFolderDocument = `
    mutation DeleteRecommendationBankFolder($input: DeleteRecommendationBankFolderInput!) {
  deleteRecommendationBankFolder(input: $input) {
    message
    status
  }
}
    `;

export const useDeleteRecommendationBankFolderMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<DeleteRecommendationBankFolderMutation, TError, DeleteRecommendationBankFolderMutationVariables, TContext>) => {
    
    return useMutation<DeleteRecommendationBankFolderMutation, TError, DeleteRecommendationBankFolderMutationVariables, TContext>(
      {
    mutationKey: ['DeleteRecommendationBankFolder'],
    mutationFn: useCustomFetcher<DeleteRecommendationBankFolderMutation, DeleteRecommendationBankFolderMutationVariables>(DeleteRecommendationBankFolderDocument),
    ...options
  }
    )};

export const DeleteRecommendationBankItemDocument = `
    mutation DeleteRecommendationBankItem($recommendationBankItemId: ID!) {
  deleteRecommendationBankItem(
    recommendationBankItemId: $recommendationBankItemId
  ) {
    message
    status
  }
}
    `;

export const useDeleteRecommendationBankItemMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<DeleteRecommendationBankItemMutation, TError, DeleteRecommendationBankItemMutationVariables, TContext>) => {
    
    return useMutation<DeleteRecommendationBankItemMutation, TError, DeleteRecommendationBankItemMutationVariables, TContext>(
      {
    mutationKey: ['DeleteRecommendationBankItem'],
    mutationFn: useCustomFetcher<DeleteRecommendationBankItemMutation, DeleteRecommendationBankItemMutationVariables>(DeleteRecommendationBankItemDocument),
    ...options
  }
    )};

export const MoveRecommendationBankItemDocument = `
    mutation MoveRecommendationBankItem($input: MoveRecommendationBankItemInput!) {
  moveRecommendationBankItem(input: $input) {
    message
    status
    recommendationBankItemData {
      id
      recommendationContent
      folder {
        id
        name
        folderType
      }
      createdBy {
        id
        username
      }
      updatedBy {
        id
        username
      }
    }
  }
}
    `;

export const useMoveRecommendationBankItemMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<MoveRecommendationBankItemMutation, TError, MoveRecommendationBankItemMutationVariables, TContext>) => {
    
    return useMutation<MoveRecommendationBankItemMutation, TError, MoveRecommendationBankItemMutationVariables, TContext>(
      {
    mutationKey: ['MoveRecommendationBankItem'],
    mutationFn: useCustomFetcher<MoveRecommendationBankItemMutation, MoveRecommendationBankItemMutationVariables>(MoveRecommendationBankItemDocument),
    ...options
  }
    )};

export const UpdateRecommendationBankFolderDocument = `
    mutation UpdateRecommendationBankFolder($input: UpdateRecommendationBankFolderInput!) {
  updateRecommendationBankFolder(input: $input) {
    message
    status
  }
}
    `;

export const useUpdateRecommendationBankFolderMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateRecommendationBankFolderMutation, TError, UpdateRecommendationBankFolderMutationVariables, TContext>) => {
    
    return useMutation<UpdateRecommendationBankFolderMutation, TError, UpdateRecommendationBankFolderMutationVariables, TContext>(
      {
    mutationKey: ['UpdateRecommendationBankFolder'],
    mutationFn: useCustomFetcher<UpdateRecommendationBankFolderMutation, UpdateRecommendationBankFolderMutationVariables>(UpdateRecommendationBankFolderDocument),
    ...options
  }
    )};

export const UpdateRecommendationBankItemDocument = `
    mutation UpdateRecommendationBankItem($input: UpdateRecommendationBankItemInput!) {
  updateRecommendationBankItem(input: $input) {
    message
    status
    recommendationBankItem {
      id
      recommendationContent
      folder {
        id
        name
        folderType
      }
      createdBy {
        id
        username
      }
      updatedBy {
        id
        username
      }
    }
  }
}
    `;

export const useUpdateRecommendationBankItemMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateRecommendationBankItemMutation, TError, UpdateRecommendationBankItemMutationVariables, TContext>) => {
    
    return useMutation<UpdateRecommendationBankItemMutation, TError, UpdateRecommendationBankItemMutationVariables, TContext>(
      {
    mutationKey: ['UpdateRecommendationBankItem'],
    mutationFn: useCustomFetcher<UpdateRecommendationBankItemMutation, UpdateRecommendationBankItemMutationVariables>(UpdateRecommendationBankItemDocument),
    ...options
  }
    )};

export const CreateReportFromTemplateDocument = `
    mutation createReportFromTemplate($reportId: ID!) {
  createReportFromTemplate(reportId: $reportId) {
    success
  }
}
    `;

export const useCreateReportFromTemplateMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateReportFromTemplateMutation, TError, CreateReportFromTemplateMutationVariables, TContext>) => {
    
    return useMutation<CreateReportFromTemplateMutation, TError, CreateReportFromTemplateMutationVariables, TContext>(
      {
    mutationKey: ['createReportFromTemplate'],
    mutationFn: useCustomFetcher<CreateReportFromTemplateMutation, CreateReportFromTemplateMutationVariables>(CreateReportFromTemplateDocument),
    ...options
  }
    )};

export const CreateReportTemplateLogoDocument = `
    mutation createReportTemplateLogo($input: CreateReportTemplateFileInput!) {
  createReportTemplateLogo(input: $input) {
    message
    status
    fileUrl
  }
}
    `;

export const useCreateReportTemplateLogoMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateReportTemplateLogoMutation, TError, CreateReportTemplateLogoMutationVariables, TContext>) => {
    
    return useMutation<CreateReportTemplateLogoMutation, TError, CreateReportTemplateLogoMutationVariables, TContext>(
      {
    mutationKey: ['createReportTemplateLogo'],
    mutationFn: useCustomFetcher<CreateReportTemplateLogoMutation, CreateReportTemplateLogoMutationVariables>(CreateReportTemplateLogoDocument),
    ...options
  }
    )};

export const CreateSampleTemplateDocument = `
    mutation createSampleTemplate($reportTemplate: ID!) {
  createSampleTemplate(reportTemplate: $reportTemplate) {
    message
    status
  }
}
    `;

export const useCreateSampleTemplateMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateSampleTemplateMutation, TError, CreateSampleTemplateMutationVariables, TContext>) => {
    
    return useMutation<CreateSampleTemplateMutation, TError, CreateSampleTemplateMutationVariables, TContext>(
      {
    mutationKey: ['createSampleTemplate'],
    mutationFn: useCustomFetcher<CreateSampleTemplateMutation, CreateSampleTemplateMutationVariables>(CreateSampleTemplateDocument),
    ...options
  }
    )};

export const DeleteReportTemplateDocument = `
    mutation DeleteReportTemplate($reportTemplateId: ID!) {
  deleteReportTemplate(reportTemplateId: $reportTemplateId) {
    status
    message
  }
}
    `;

export const useDeleteReportTemplateMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<DeleteReportTemplateMutation, TError, DeleteReportTemplateMutationVariables, TContext>) => {
    
    return useMutation<DeleteReportTemplateMutation, TError, DeleteReportTemplateMutationVariables, TContext>(
      {
    mutationKey: ['DeleteReportTemplate'],
    mutationFn: useCustomFetcher<DeleteReportTemplateMutation, DeleteReportTemplateMutationVariables>(DeleteReportTemplateDocument),
    ...options
  }
    )};

export const DuplicateReportTemplateDocument = `
    mutation duplicateReportTemplate($input: DuplicateReportTemplateInput!) {
  duplicateReportTemplate(input: $input) {
    message
    status
    newTemplate {
      id
    }
  }
}
    `;

export const useDuplicateReportTemplateMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<DuplicateReportTemplateMutation, TError, DuplicateReportTemplateMutationVariables, TContext>) => {
    
    return useMutation<DuplicateReportTemplateMutation, TError, DuplicateReportTemplateMutationVariables, TContext>(
      {
    mutationKey: ['duplicateReportTemplate'],
    mutationFn: useCustomFetcher<DuplicateReportTemplateMutation, DuplicateReportTemplateMutationVariables>(DuplicateReportTemplateDocument),
    ...options
  }
    )};

export const UpdateReportTemplateDocument = `
    mutation updateReportTemplate($input: UpdateReportTemplateInput!) {
  updateReportTemplate(input: $input) {
    message
    status
  }
}
    `;

export const useUpdateReportTemplateMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateReportTemplateMutation, TError, UpdateReportTemplateMutationVariables, TContext>) => {
    
    return useMutation<UpdateReportTemplateMutation, TError, UpdateReportTemplateMutationVariables, TContext>(
      {
    mutationKey: ['updateReportTemplate'],
    mutationFn: useCustomFetcher<UpdateReportTemplateMutation, UpdateReportTemplateMutationVariables>(UpdateReportTemplateDocument),
    ...options
  }
    )};

export const UpdateReportTemplateLogoDocument = `
    mutation updateReportTemplateLogo($input: UpdateReportTemplateFileInput!) {
  updateReportTemplateLogo(input: $input) {
    message
    status
  }
}
    `;

export const useUpdateReportTemplateLogoMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateReportTemplateLogoMutation, TError, UpdateReportTemplateLogoMutationVariables, TContext>) => {
    
    return useMutation<UpdateReportTemplateLogoMutation, TError, UpdateReportTemplateLogoMutationVariables, TContext>(
      {
    mutationKey: ['updateReportTemplateLogo'],
    mutationFn: useCustomFetcher<UpdateReportTemplateLogoMutation, UpdateReportTemplateLogoMutationVariables>(UpdateReportTemplateLogoDocument),
    ...options
  }
    )};

export const AddReportClientDetailsDocument = `
    mutation addReportClientDetails($learnerCaregiverMinimalInput: LearnerCaregiverMinimalInput!, $reportId: ID!) {
  addReportClientDetails(
    reportId: $reportId
    clientDetails: $learnerCaregiverMinimalInput
  ) {
    message
    status
  }
}
    `;

export const useAddReportClientDetailsMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<AddReportClientDetailsMutation, TError, AddReportClientDetailsMutationVariables, TContext>) => {
    
    return useMutation<AddReportClientDetailsMutation, TError, AddReportClientDetailsMutationVariables, TContext>(
      {
    mutationKey: ['addReportClientDetails'],
    mutationFn: useCustomFetcher<AddReportClientDetailsMutation, AddReportClientDetailsMutationVariables>(AddReportClientDetailsDocument),
    ...options
  }
    )};

export const AddUpdateReportTreatmentPlanPrioritizeFieldsDocument = `
    mutation addUpdateReportTreatmentPlanPrioritizeFields($reportId: ID!, $prioritizeFieldsDetails: ReportTreatmentPlanPrioritizeFieldsInput!) {
  addUpdateReportTreatmentPlanPrioritizeFields(
    reportId: $reportId
    prioritizeFieldsDetails: $prioritizeFieldsDetails
  ) {
    status
    reportTreatmentPlanPrioritizeFields {
      id
    }
  }
}
    `;

export const useAddUpdateReportTreatmentPlanPrioritizeFieldsMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<AddUpdateReportTreatmentPlanPrioritizeFieldsMutation, TError, AddUpdateReportTreatmentPlanPrioritizeFieldsMutationVariables, TContext>) => {
    
    return useMutation<AddUpdateReportTreatmentPlanPrioritizeFieldsMutation, TError, AddUpdateReportTreatmentPlanPrioritizeFieldsMutationVariables, TContext>(
      {
    mutationKey: ['addUpdateReportTreatmentPlanPrioritizeFields'],
    mutationFn: useCustomFetcher<AddUpdateReportTreatmentPlanPrioritizeFieldsMutation, AddUpdateReportTreatmentPlanPrioritizeFieldsMutationVariables>(AddUpdateReportTreatmentPlanPrioritizeFieldsDocument),
    ...options
  }
    )};

export const ApplyReportCommentDocument = `
    mutation applyReportComment($id: ID!) {
  applyReportComment(id: $id) {
    success
    message
    comment {
      id
      status
      resolvedAt
    }
  }
}
    `;

export const useApplyReportCommentMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<ApplyReportCommentMutation, TError, ApplyReportCommentMutationVariables, TContext>) => {
    
    return useMutation<ApplyReportCommentMutation, TError, ApplyReportCommentMutationVariables, TContext>(
      {
    mutationKey: ['applyReportComment'],
    mutationFn: useCustomFetcher<ApplyReportCommentMutation, ApplyReportCommentMutationVariables>(ApplyReportCommentDocument),
    ...options
  }
    )};

export const CreateExportReportGenerationDocument = `
    mutation createExportReportGeneration($input: GeneratePDFInput!) {
  createExportReportGeneration(input: $input) {
    status
    message
  }
}
    `;

export const useCreateExportReportGenerationMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateExportReportGenerationMutation, TError, CreateExportReportGenerationMutationVariables, TContext>) => {
    
    return useMutation<CreateExportReportGenerationMutation, TError, CreateExportReportGenerationMutationVariables, TContext>(
      {
    mutationKey: ['createExportReportGeneration'],
    mutationFn: useCustomFetcher<CreateExportReportGenerationMutation, CreateExportReportGenerationMutationVariables>(CreateExportReportGenerationDocument),
    ...options
  }
    )};

export const CreateReassessmentReportGoalsDocument = `
    mutation createReassessmentReportGoals($goals: [SelectedEhrGoalInput!]!, $reportId: ID!) {
  createReassessmentReportGoals(goals: $goals, reportId: $reportId) {
    message
    status
  }
}
    `;

export const useCreateReassessmentReportGoalsMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateReassessmentReportGoalsMutation, TError, CreateReassessmentReportGoalsMutationVariables, TContext>) => {
    
    return useMutation<CreateReassessmentReportGoalsMutation, TError, CreateReassessmentReportGoalsMutationVariables, TContext>(
      {
    mutationKey: ['createReassessmentReportGoals'],
    mutationFn: useCustomFetcher<CreateReassessmentReportGoalsMutation, CreateReassessmentReportGoalsMutationVariables>(CreateReassessmentReportGoalsDocument),
    ...options
  }
    )};

export const CreateReportDocument = `
    mutation createReport($learnerId: ID, $reportClientMetaData: JSONString, $reportType: ReportTypeEnums!, $learnerFileId: ID, $reportTemplateId: ID) {
  createReport(
    learner: $learnerId
    reportClientMetaData: $reportClientMetaData
    reportType: $reportType
    learnerFileId: $learnerFileId
    reportTemplateId: $reportTemplateId
  ) {
    message
    status
    report {
      id
      createdDate
      lastUpdatedDate
      reportStatus
      reportType
      isArchive
      reportMetaData
      reportClientDetails {
        id
        clientFirstName
        clientLastName
        guardianFirstName
        guardianLastName
        guardian2FirstName
        guardian2LastName
        birthDate
        address
        addressLine2
        city
        state
        zip
      }
    }
  }
}
    `;

export const useCreateReportMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateReportMutation, TError, CreateReportMutationVariables, TContext>) => {
    
    return useMutation<CreateReportMutation, TError, CreateReportMutationVariables, TContext>(
      {
    mutationKey: ['createReport'],
    mutationFn: useCustomFetcher<CreateReportMutation, CreateReportMutationVariables>(CreateReportDocument),
    ...options
  }
    )};

export const CreateReportCommentDocument = `
    mutation createReportComment($fieldId: ID, $parentId: ID, $body: String!, $proposedValue: String, $baseValue: String) {
  createReportComment(
    fieldId: $fieldId
    parentId: $parentId
    body: $body
    proposedValue: $proposedValue
    baseValue: $baseValue
  ) {
    success
    message
    comment {
      id
      content
      source
      status
      hidden
      createdDate
      baseValue
      proposedValue
      author {
        id
        firstName
        lastName
      }
      reportSectionField {
        id
        title
      }
      parent {
        __typename
        ... on ReportSuggestionType {
          id
        }
        ... on ReportCommentType {
          id
        }
      }
    }
  }
}
    `;

export const useCreateReportCommentMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateReportCommentMutation, TError, CreateReportCommentMutationVariables, TContext>) => {
    
    return useMutation<CreateReportCommentMutation, TError, CreateReportCommentMutationVariables, TContext>(
      {
    mutationKey: ['createReportComment'],
    mutationFn: useCustomFetcher<CreateReportCommentMutation, CreateReportCommentMutationVariables>(CreateReportCommentDocument),
    ...options
  }
    )};

export const CreateReportLearnerFileInputDocument = `
    mutation createReportLearnerFileInput($input: CreateReportLearnerFileInput!) {
  createReportLearnerFile(input: $input) {
    learnerFile {
      signedS3Url
      id
    }
  }
}
    `;

export const useCreateReportLearnerFileInputMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateReportLearnerFileInputMutation, TError, CreateReportLearnerFileInputMutationVariables, TContext>) => {
    
    return useMutation<CreateReportLearnerFileInputMutation, TError, CreateReportLearnerFileInputMutationVariables, TContext>(
      {
    mutationKey: ['createReportLearnerFileInput'],
    mutationFn: useCustomFetcher<CreateReportLearnerFileInputMutation, CreateReportLearnerFileInputMutationVariables>(CreateReportLearnerFileInputDocument),
    ...options
  }
    )};

export const DeleteReportDocument = `
    mutation deleteReport($report: ID!) {
  deleteReport(report: $report) {
    status
    message
  }
}
    `;

export const useDeleteReportMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<DeleteReportMutation, TError, DeleteReportMutationVariables, TContext>) => {
    
    return useMutation<DeleteReportMutation, TError, DeleteReportMutationVariables, TContext>(
      {
    mutationKey: ['deleteReport'],
    mutationFn: useCustomFetcher<DeleteReportMutation, DeleteReportMutationVariables>(DeleteReportDocument),
    ...options
  }
    )};

export const DeleteReportCommentDocument = `
    mutation deleteReportComment($id: ID!) {
  deleteReportComment(id: $id) {
    success
    message
  }
}
    `;

export const useDeleteReportCommentMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<DeleteReportCommentMutation, TError, DeleteReportCommentMutationVariables, TContext>) => {
    
    return useMutation<DeleteReportCommentMutation, TError, DeleteReportCommentMutationVariables, TContext>(
      {
    mutationKey: ['deleteReportComment'],
    mutationFn: useCustomFetcher<DeleteReportCommentMutation, DeleteReportCommentMutationVariables>(DeleteReportCommentDocument),
    ...options
  }
    )};

export const EditReportCommentDocument = `
    mutation editReportComment($id: ID!, $body: String!) {
  editReportComment(id: $id, body: $body) {
    success
    message
  }
}
    `;

export const useEditReportCommentMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<EditReportCommentMutation, TError, EditReportCommentMutationVariables, TContext>) => {
    
    return useMutation<EditReportCommentMutation, TError, EditReportCommentMutationVariables, TContext>(
      {
    mutationKey: ['editReportComment'],
    mutationFn: useCustomFetcher<EditReportCommentMutation, EditReportCommentMutationVariables>(EditReportCommentDocument),
    ...options
  }
    )};

export const ExportDraftReportDocumentDocument = `
    mutation exportDraftReportDocument($reportId: ID!, $exportType: ExportTypeEnum!) {
  exportDraftReportDocument(reportId: $reportId, exportType: $exportType) {
    file
    fileName
  }
}
    `;

export const useExportDraftReportDocumentMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<ExportDraftReportDocumentMutation, TError, ExportDraftReportDocumentMutationVariables, TContext>) => {
    
    return useMutation<ExportDraftReportDocumentMutation, TError, ExportDraftReportDocumentMutationVariables, TContext>(
      {
    mutationKey: ['exportDraftReportDocument'],
    mutationFn: useCustomFetcher<ExportDraftReportDocumentMutation, ExportDraftReportDocumentMutationVariables>(ExportDraftReportDocumentDocument),
    ...options
  }
    )};

export const GenerateReportPdfFromDocxDocument = `
    mutation generateReportPdfFromDocx($reportId: ID!, $reportDocxFile: Upload!) {
  generateReportPdfFromDocx(report: $reportId, reportDocxFile: $reportDocxFile) {
    status
    message
  }
}
    `;

export const useGenerateReportPdfFromDocxMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<GenerateReportPdfFromDocxMutation, TError, GenerateReportPdfFromDocxMutationVariables, TContext>) => {
    
    return useMutation<GenerateReportPdfFromDocxMutation, TError, GenerateReportPdfFromDocxMutationVariables, TContext>(
      {
    mutationKey: ['generateReportPdfFromDocx'],
    mutationFn: useCustomFetcher<GenerateReportPdfFromDocxMutation, GenerateReportPdfFromDocxMutationVariables>(GenerateReportPdfFromDocxDocument),
    ...options
  }
    )};

export const CreateOrganizationTemplateLogoDocument = `
    mutation createOrganizationTemplateLogo($input: CreateOrganizationTemplateLogoInput!) {
  createOrganizationTemplateLogo(input: $input) {
    fileUrl
  }
}
    `;

export const useCreateOrganizationTemplateLogoMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateOrganizationTemplateLogoMutation, TError, CreateOrganizationTemplateLogoMutationVariables, TContext>) => {
    
    return useMutation<CreateOrganizationTemplateLogoMutation, TError, CreateOrganizationTemplateLogoMutationVariables, TContext>(
      {
    mutationKey: ['createOrganizationTemplateLogo'],
    mutationFn: useCustomFetcher<CreateOrganizationTemplateLogoMutation, CreateOrganizationTemplateLogoMutationVariables>(CreateOrganizationTemplateLogoDocument),
    ...options
  }
    )};

export const UpdateOrganizationTemplateLogoUrlDocument = `
    mutation updateOrganizationTemplateLogoUrl($input: UpdateOrganizationTemplateLogoURLInput!) {
  updateOrganizationTemplateLogoUrl(input: $input) {
    status
    message
  }
}
    `;

export const useUpdateOrganizationTemplateLogoUrlMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateOrganizationTemplateLogoUrlMutation, TError, UpdateOrganizationTemplateLogoUrlMutationVariables, TContext>) => {
    
    return useMutation<UpdateOrganizationTemplateLogoUrlMutation, TError, UpdateOrganizationTemplateLogoUrlMutationVariables, TContext>(
      {
    mutationKey: ['updateOrganizationTemplateLogoUrl'],
    mutationFn: useCustomFetcher<UpdateOrganizationTemplateLogoUrlMutation, UpdateOrganizationTemplateLogoUrlMutationVariables>(UpdateOrganizationTemplateLogoUrlDocument),
    ...options
  }
    )};

export const UpdateReportPageHeadingDocument = `
    mutation updateReportPageHeading($input: UpdateReportPageHeadingInput!) {
  updateReportPageHeading(input: $input) {
    status
    message
  }
}
    `;

export const useUpdateReportPageHeadingMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateReportPageHeadingMutation, TError, UpdateReportPageHeadingMutationVariables, TContext>) => {
    
    return useMutation<UpdateReportPageHeadingMutation, TError, UpdateReportPageHeadingMutationVariables, TContext>(
      {
    mutationKey: ['updateReportPageHeading'],
    mutationFn: useCustomFetcher<UpdateReportPageHeadingMutation, UpdateReportPageHeadingMutationVariables>(UpdateReportPageHeadingDocument),
    ...options
  }
    )};

export const PopulateDataFromBhtiaDocument = `
    mutation populateDataFromBhtia($learnerFileId: ID!, $reportId: ID!, $pageLocation: ReportPageLocationEnums!) {
  populateDataFromBhtia(
    learnerFileId: $learnerFileId
    reportId: $reportId
    pageLocation: $pageLocation
  ) {
    status
    message
  }
}
    `;

export const usePopulateDataFromBhtiaMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<PopulateDataFromBhtiaMutation, TError, PopulateDataFromBhtiaMutationVariables, TContext>) => {
    
    return useMutation<PopulateDataFromBhtiaMutation, TError, PopulateDataFromBhtiaMutationVariables, TContext>(
      {
    mutationKey: ['populateDataFromBhtia'],
    mutationFn: useCustomFetcher<PopulateDataFromBhtiaMutation, PopulateDataFromBhtiaMutationVariables>(PopulateDataFromBhtiaDocument),
    ...options
  }
    )};

export const ReopenReportCommentDocument = `
    mutation reopenReportComment($id: ID!) {
  reopenReportComment(id: $id) {
    success
    message
    comment {
      id
      status
    }
  }
}
    `;

export const useReopenReportCommentMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<ReopenReportCommentMutation, TError, ReopenReportCommentMutationVariables, TContext>) => {
    
    return useMutation<ReopenReportCommentMutation, TError, ReopenReportCommentMutationVariables, TContext>(
      {
    mutationKey: ['reopenReportComment'],
    mutationFn: useCustomFetcher<ReopenReportCommentMutation, ReopenReportCommentMutationVariables>(ReopenReportCommentDocument),
    ...options
  }
    )};

export const ManageReportDomainsDocument = `
    mutation manageReportDomains($reportId: ID!, $domains: [ManageReportDomainInput]!, $deletedDomainIds: [ID], $goalMoves: [GoalDomainAssignmentInput]) {
  manageReportDomains(
    reportId: $reportId
    domains: $domains
    deletedDomainIds: $deletedDomainIds
    goalMoves: $goalMoves
  ) {
    status
    message
    reportDomains {
      id
      name
      description
      rankOrder
    }
  }
}
    `;

export const useManageReportDomainsMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<ManageReportDomainsMutation, TError, ManageReportDomainsMutationVariables, TContext>) => {
    
    return useMutation<ManageReportDomainsMutation, TError, ManageReportDomainsMutationVariables, TContext>(
      {
    mutationKey: ['manageReportDomains'],
    mutationFn: useCustomFetcher<ManageReportDomainsMutation, ManageReportDomainsMutationVariables>(ManageReportDomainsDocument),
    ...options
  }
    )};

export const AddSuggestedReportGoalsDocument = `
    mutation addSuggestedReportGoals($reportId: ID!, $aiSuggestedGoalIds: [ID!]!) {
  addSuggestedReportGoals(
    reportId: $reportId
    aiSuggestedGoalIds: $aiSuggestedGoalIds
  ) {
    status
    message
  }
}
    `;

export const useAddSuggestedReportGoalsMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<AddSuggestedReportGoalsMutation, TError, AddSuggestedReportGoalsMutationVariables, TContext>) => {
    
    return useMutation<AddSuggestedReportGoalsMutation, TError, AddSuggestedReportGoalsMutationVariables, TContext>(
      {
    mutationKey: ['addSuggestedReportGoals'],
    mutationFn: useCustomFetcher<AddSuggestedReportGoalsMutation, AddSuggestedReportGoalsMutationVariables>(AddSuggestedReportGoalsDocument),
    ...options
  }
    )};

export const AddSuggestedReportTargetsDocument = `
    mutation addSuggestedReportTargets($aiSuggestedTargetsIds: [ID]!, $reportId: ID!, $reportGoalId: ID!) {
  addSuggestedReportTargets(
    aiSuggestedTargetsIds: $aiSuggestedTargetsIds
    reportId: $reportId
    reportGoalId: $reportGoalId
  ) {
    message
    status
    reportTargetsData {
      id
      targetName
      reportGoal {
        id
        goalName
      }
    }
  }
}
    `;

export const useAddSuggestedReportTargetsMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<AddSuggestedReportTargetsMutation, TError, AddSuggestedReportTargetsMutationVariables, TContext>) => {
    
    return useMutation<AddSuggestedReportTargetsMutation, TError, AddSuggestedReportTargetsMutationVariables, TContext>(
      {
    mutationKey: ['addSuggestedReportTargets'],
    mutationFn: useCustomFetcher<AddSuggestedReportTargetsMutation, AddSuggestedReportTargetsMutationVariables>(AddSuggestedReportTargetsDocument),
    ...options
  }
    )};

export const BulkReassignReportGoalsDocument = `
    mutation bulkReassignReportGoals($goals: [ReassignReportGoalInput]!) {
  bulkReassignReportGoals(goals: $goals) {
    status
    message
  }
}
    `;

export const useBulkReassignReportGoalsMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<BulkReassignReportGoalsMutation, TError, BulkReassignReportGoalsMutationVariables, TContext>) => {
    
    return useMutation<BulkReassignReportGoalsMutation, TError, BulkReassignReportGoalsMutationVariables, TContext>(
      {
    mutationKey: ['bulkReassignReportGoals'],
    mutationFn: useCustomFetcher<BulkReassignReportGoalsMutation, BulkReassignReportGoalsMutationVariables>(BulkReassignReportGoalsDocument),
    ...options
  }
    )};

export const CreateTreatmentPlanCustomFieldFileDocument = `
    mutation createTreatmentPlanCustomFieldFile($input: CreateTreatmentPlanCustomFieldFileInput!) {
  createTreatmentPlanCustomFieldFile(input: $input) {
    fileUrl
  }
}
    `;

export const useCreateTreatmentPlanCustomFieldFileMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateTreatmentPlanCustomFieldFileMutation, TError, CreateTreatmentPlanCustomFieldFileMutationVariables, TContext>) => {
    
    return useMutation<CreateTreatmentPlanCustomFieldFileMutation, TError, CreateTreatmentPlanCustomFieldFileMutationVariables, TContext>(
      {
    mutationKey: ['createTreatmentPlanCustomFieldFile'],
    mutationFn: useCustomFetcher<CreateTreatmentPlanCustomFieldFileMutation, CreateTreatmentPlanCustomFieldFileMutationVariables>(CreateTreatmentPlanCustomFieldFileDocument),
    ...options
  }
    )};

export const CreateUpdateCustomFieldValueDocument = `
    mutation createUpdateCustomFieldValue($customFieldId: ID, $content: String!, $fieldIdentifier: String, $reportGoalId: ID, $reportTargetId: ID, $reportDomainId: ID) {
  createUpdateCustomFieldValue(
    customFieldId: $customFieldId
    content: $content
    fieldIdentifier: $fieldIdentifier
    reportGoalId: $reportGoalId
    reportTargetId: $reportTargetId
    reportDomainId: $reportDomainId
  ) {
    status
    message
    customField {
      id
      content
      fieldIdentifier
    }
  }
}
    `;

export const useCreateUpdateCustomFieldValueMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateUpdateCustomFieldValueMutation, TError, CreateUpdateCustomFieldValueMutationVariables, TContext>) => {
    
    return useMutation<CreateUpdateCustomFieldValueMutation, TError, CreateUpdateCustomFieldValueMutationVariables, TContext>(
      {
    mutationKey: ['createUpdateCustomFieldValue'],
    mutationFn: useCustomFetcher<CreateUpdateCustomFieldValueMutation, CreateUpdateCustomFieldValueMutationVariables>(CreateUpdateCustomFieldValueDocument),
    ...options
  }
    )};

export const CreateUpdateReportGoalDocument = `
    mutation createUpdateReportGoal($learnerId: ID!, $goalInput: ReportGoalInput!) {
  createUpdateReportGoal(learner: $learnerId, goalInput: $goalInput) {
    message
    status
    reportGoalData {
      id
      goalName
      reportDomain {
        id
      }
      createdDate
      lastUpdatedDate
      completionDate
      projectedIntroductionDate
      assessmentToolSource
      baselineDate
      programGoal
      description
      timelineEstimationType
      timelineEstimationValue
      baselineData
      masteryCriteria
      hasMedicalNecessity
      medicalNecessityCriteria
      generalizationCriteria
      aiGoalAttainmentScalePredictionStatus
      gasLevel1
      gasLevel3
      gasLevel4
      rationale
      status
      goalType
      goalSubType
      tags
      aiGenerated
      inUse
      status
      progressSummary
      tags
      gasScore
    }
  }
}
    `;

export const useCreateUpdateReportGoalMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateUpdateReportGoalMutation, TError, CreateUpdateReportGoalMutationVariables, TContext>) => {
    
    return useMutation<CreateUpdateReportGoalMutation, TError, CreateUpdateReportGoalMutationVariables, TContext>(
      {
    mutationKey: ['createUpdateReportGoal'],
    mutationFn: useCustomFetcher<CreateUpdateReportGoalMutation, CreateUpdateReportGoalMutationVariables>(CreateUpdateReportGoalDocument),
    ...options
  }
    )};

export const CreateUpdateReportTargetDocument = `
    mutation createUpdateReportTarget($learnerId: ID!, $targetData: ReportTargetInput!) {
  createUpdateReportTarget(learner: $learnerId, targetData: $targetData) {
    message
    status
    reportTargetDetails {
      id
      targetName
      reportGoal {
        id
        reportDomain {
          id
        }
      }
      aiGenerated
      inUse
      createdDate
      lastUpdatedDate
      targetDescription
      timelineEstimationValue
      timelineEstimationType
      masteryCriteria
      baselineData
      status
      progressSummary
      completionDate
      summaryReviewed
      signedChartImageUrl
      aiProgressSummaryPredictionStatus
    }
  }
}
    `;

export const useCreateUpdateReportTargetMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateUpdateReportTargetMutation, TError, CreateUpdateReportTargetMutationVariables, TContext>) => {
    
    return useMutation<CreateUpdateReportTargetMutation, TError, CreateUpdateReportTargetMutationVariables, TContext>(
      {
    mutationKey: ['createUpdateReportTarget'],
    mutationFn: useCustomFetcher<CreateUpdateReportTargetMutation, CreateUpdateReportTargetMutationVariables>(CreateUpdateReportTargetDocument),
    ...options
  }
    )};

export const DuplicateReportGoalDocument = `
    mutation duplicateReportGoal($learnerId: ID!, $reportGoalId: ID!) {
  duplicateReportGoal(learner: $learnerId, reportGoalId: $reportGoalId) {
    status
    message
  }
}
    `;

export const useDuplicateReportGoalMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<DuplicateReportGoalMutation, TError, DuplicateReportGoalMutationVariables, TContext>) => {
    
    return useMutation<DuplicateReportGoalMutation, TError, DuplicateReportGoalMutationVariables, TContext>(
      {
    mutationKey: ['duplicateReportGoal'],
    mutationFn: useCustomFetcher<DuplicateReportGoalMutation, DuplicateReportGoalMutationVariables>(DuplicateReportGoalDocument),
    ...options
  }
    )};

export const ReassignReportGoalDocument = `
    mutation reassignReportGoal($input: ReassignReportGoalInput!) {
  reassignReportGoal(input: $input) {
    status
    message
  }
}
    `;

export const useReassignReportGoalMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<ReassignReportGoalMutation, TError, ReassignReportGoalMutationVariables, TContext>) => {
    
    return useMutation<ReassignReportGoalMutation, TError, ReassignReportGoalMutationVariables, TContext>(
      {
    mutationKey: ['reassignReportGoal'],
    mutationFn: useCustomFetcher<ReassignReportGoalMutation, ReassignReportGoalMutationVariables>(ReassignReportGoalDocument),
    ...options
  }
    )};

export const RemoveReportGoalDocument = `
    mutation removeReportGoal($reportGoalId: ID!) {
  removeReportGoal(reportGoalId: $reportGoalId) {
    status
    message
  }
}
    `;

export const useRemoveReportGoalMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<RemoveReportGoalMutation, TError, RemoveReportGoalMutationVariables, TContext>) => {
    
    return useMutation<RemoveReportGoalMutation, TError, RemoveReportGoalMutationVariables, TContext>(
      {
    mutationKey: ['removeReportGoal'],
    mutationFn: useCustomFetcher<RemoveReportGoalMutation, RemoveReportGoalMutationVariables>(RemoveReportGoalDocument),
    ...options
  }
    )};

export const RemoveReportTargetDocument = `
    mutation removeReportTarget($learnerId: ID!, $reportTargetId: ID!) {
  removeReportTarget(learnerId: $learnerId, reportTargetId: $reportTargetId) {
    status
    message
  }
}
    `;

export const useRemoveReportTargetMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<RemoveReportTargetMutation, TError, RemoveReportTargetMutationVariables, TContext>) => {
    
    return useMutation<RemoveReportTargetMutation, TError, RemoveReportTargetMutationVariables, TContext>(
      {
    mutationKey: ['removeReportTarget'],
    mutationFn: useCustomFetcher<RemoveReportTargetMutation, RemoveReportTargetMutationVariables>(RemoveReportTargetDocument),
    ...options
  }
    )};

export const ReorderReportGoalsDocument = `
    mutation reorderReportGoals($goals: [ReorderReportGoalsInput]!) {
  reorderReportGoals(goals: $goals) {
    status
    message
  }
}
    `;

export const useReorderReportGoalsMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<ReorderReportGoalsMutation, TError, ReorderReportGoalsMutationVariables, TContext>) => {
    
    return useMutation<ReorderReportGoalsMutation, TError, ReorderReportGoalsMutationVariables, TContext>(
      {
    mutationKey: ['reorderReportGoals'],
    mutationFn: useCustomFetcher<ReorderReportGoalsMutation, ReorderReportGoalsMutationVariables>(ReorderReportGoalsDocument),
    ...options
  }
    )};

export const StartGoalAttainmentScaleWorkflowDocument = `
    mutation startGoalAttainmentScaleWorkflow($reportGoalId: ID!) {
  startGoalAttainmentScaleWorkflow(reportGoalId: $reportGoalId) {
    status
    message
  }
}
    `;

export const useStartGoalAttainmentScaleWorkflowMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<StartGoalAttainmentScaleWorkflowMutation, TError, StartGoalAttainmentScaleWorkflowMutationVariables, TContext>) => {
    
    return useMutation<StartGoalAttainmentScaleWorkflowMutation, TError, StartGoalAttainmentScaleWorkflowMutationVariables, TContext>(
      {
    mutationKey: ['startGoalAttainmentScaleWorkflow'],
    mutationFn: useCustomFetcher<StartGoalAttainmentScaleWorkflowMutation, StartGoalAttainmentScaleWorkflowMutationVariables>(StartGoalAttainmentScaleWorkflowDocument),
    ...options
  }
    )};

export const StartGoalBaselineDataWorkflowDocument = `
    mutation startGoalBaselineDataWorkflow($reportId: ID!, $reportGoalId: ID!) {
  startGoalBaselineDataWorkflow(reportId: $reportId, reportGoalId: $reportGoalId) {
    status
    message
  }
}
    `;

export const useStartGoalBaselineDataWorkflowMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<StartGoalBaselineDataWorkflowMutation, TError, StartGoalBaselineDataWorkflowMutationVariables, TContext>) => {
    
    return useMutation<StartGoalBaselineDataWorkflowMutation, TError, StartGoalBaselineDataWorkflowMutationVariables, TContext>(
      {
    mutationKey: ['startGoalBaselineDataWorkflow'],
    mutationFn: useCustomFetcher<StartGoalBaselineDataWorkflowMutation, StartGoalBaselineDataWorkflowMutationVariables>(StartGoalBaselineDataWorkflowDocument),
    ...options
  }
    )};

export const StartGoalProgressSummaryWorkflowDocument = `
    mutation startGoalProgressSummaryWorkflow($reportId: ID!, $reportGoalId: ID!) {
  startGoalProgressSummaryWorkflow(
    reportId: $reportId
    reportGoalId: $reportGoalId
  ) {
    status
    message
  }
}
    `;

export const useStartGoalProgressSummaryWorkflowMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<StartGoalProgressSummaryWorkflowMutation, TError, StartGoalProgressSummaryWorkflowMutationVariables, TContext>) => {
    
    return useMutation<StartGoalProgressSummaryWorkflowMutation, TError, StartGoalProgressSummaryWorkflowMutationVariables, TContext>(
      {
    mutationKey: ['startGoalProgressSummaryWorkflow'],
    mutationFn: useCustomFetcher<StartGoalProgressSummaryWorkflowMutation, StartGoalProgressSummaryWorkflowMutationVariables>(StartGoalProgressSummaryWorkflowDocument),
    ...options
  }
    )};

export const StartManualSyncWorkflowDocument = `
    mutation StartManualSyncWorkflow($learnerId: ID!, $reportId: ID, $reassessmentReportGoalSync: Boolean, $learningTreeReview: Boolean, $learningTreeStructureOnly: Boolean) {
  startManualSyncWorkflow(
    learnerId: $learnerId
    reportId: $reportId
    reassessmentReportGoalSync: $reassessmentReportGoalSync
    learningTreeReview: $learningTreeReview
    learningTreeStructureOnly: $learningTreeStructureOnly
  ) {
    status
    message
  }
}
    `;

export const useStartManualSyncWorkflowMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<StartManualSyncWorkflowMutation, TError, StartManualSyncWorkflowMutationVariables, TContext>) => {
    
    return useMutation<StartManualSyncWorkflowMutation, TError, StartManualSyncWorkflowMutationVariables, TContext>(
      {
    mutationKey: ['StartManualSyncWorkflow'],
    mutationFn: useCustomFetcher<StartManualSyncWorkflowMutation, StartManualSyncWorkflowMutationVariables>(StartManualSyncWorkflowDocument),
    ...options
  }
    )};

export const StartTargetProgressSummaryWorkflowDocument = `
    mutation startTargetProgressSummaryWorkflow($reportId: ID!, $targetId: ID!) {
  startTargetProgressSummaryWorkflow(reportId: $reportId, targetId: $targetId) {
    status
    message
  }
}
    `;

export const useStartTargetProgressSummaryWorkflowMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<StartTargetProgressSummaryWorkflowMutation, TError, StartTargetProgressSummaryWorkflowMutationVariables, TContext>) => {
    
    return useMutation<StartTargetProgressSummaryWorkflowMutation, TError, StartTargetProgressSummaryWorkflowMutationVariables, TContext>(
      {
    mutationKey: ['startTargetProgressSummaryWorkflow'],
    mutationFn: useCustomFetcher<StartTargetProgressSummaryWorkflowMutation, StartTargetProgressSummaryWorkflowMutationVariables>(StartTargetProgressSummaryWorkflowDocument),
    ...options
  }
    )};

export const UpdateGoalExcludeFromReportDocument = `
    mutation updateGoalExcludeFromReport($input: UpdateGoalExcludeFromReportInput!) {
  updateGoalExcludeFromReport(input: $input) {
    message
    status
  }
}
    `;

export const useUpdateGoalExcludeFromReportMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateGoalExcludeFromReportMutation, TError, UpdateGoalExcludeFromReportMutationVariables, TContext>) => {
    
    return useMutation<UpdateGoalExcludeFromReportMutation, TError, UpdateGoalExcludeFromReportMutationVariables, TContext>(
      {
    mutationKey: ['updateGoalExcludeFromReport'],
    mutationFn: useCustomFetcher<UpdateGoalExcludeFromReportMutation, UpdateGoalExcludeFromReportMutationVariables>(UpdateGoalExcludeFromReportDocument),
    ...options
  }
    )};

export const UpdateGoalProgressSummaryDocument = `
    mutation updateGoalProgressSummary($input: UpdateGoalProgressSummaryInput!) {
  updateGoalProgressSummary(input: $input) {
    message
    status
    summaryReviewedOn
    signedChartImageUrl
  }
}
    `;

export const useUpdateGoalProgressSummaryMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateGoalProgressSummaryMutation, TError, UpdateGoalProgressSummaryMutationVariables, TContext>) => {
    
    return useMutation<UpdateGoalProgressSummaryMutation, TError, UpdateGoalProgressSummaryMutationVariables, TContext>(
      {
    mutationKey: ['updateGoalProgressSummary'],
    mutationFn: useCustomFetcher<UpdateGoalProgressSummaryMutation, UpdateGoalProgressSummaryMutationVariables>(UpdateGoalProgressSummaryDocument),
    ...options
  }
    )};

export const UpdateTargetExcludeFromReportDocument = `
    mutation updateTargetExcludeFromReport($input: UpdateTargetExcludeFromReportInput!) {
  updateTargetExcludeFromReport(input: $input) {
    message
    status
  }
}
    `;

export const useUpdateTargetExcludeFromReportMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateTargetExcludeFromReportMutation, TError, UpdateTargetExcludeFromReportMutationVariables, TContext>) => {
    
    return useMutation<UpdateTargetExcludeFromReportMutation, TError, UpdateTargetExcludeFromReportMutationVariables, TContext>(
      {
    mutationKey: ['updateTargetExcludeFromReport'],
    mutationFn: useCustomFetcher<UpdateTargetExcludeFromReportMutation, UpdateTargetExcludeFromReportMutationVariables>(UpdateTargetExcludeFromReportDocument),
    ...options
  }
    )};

export const UpdateTargetProgressSummaryDocument = `
    mutation updateTargetProgressSummary($input: UpdateTargetProgressSummaryInput!) {
  updateTargetProgressSummary(input: $input) {
    message
    status
    signedChartImageUrl
  }
}
    `;

export const useUpdateTargetProgressSummaryMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateTargetProgressSummaryMutation, TError, UpdateTargetProgressSummaryMutationVariables, TContext>) => {
    
    return useMutation<UpdateTargetProgressSummaryMutation, TError, UpdateTargetProgressSummaryMutationVariables, TContext>(
      {
    mutationKey: ['updateTargetProgressSummary'],
    mutationFn: useCustomFetcher<UpdateTargetProgressSummaryMutation, UpdateTargetProgressSummaryMutationVariables>(UpdateTargetProgressSummaryDocument),
    ...options
  }
    )};

export const UpdateTreatmentPlanCustomFieldFileUrlDocument = `
    mutation updateTreatmentPlanCustomFieldFileUrl($input: UpdateTreatmentPlanCustomFieldFileURLInput!) {
  updateTreatmentPlanCustomFieldFileUrl(input: $input) {
    message
    status
  }
}
    `;

export const useUpdateTreatmentPlanCustomFieldFileUrlMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateTreatmentPlanCustomFieldFileUrlMutation, TError, UpdateTreatmentPlanCustomFieldFileUrlMutationVariables, TContext>) => {
    
    return useMutation<UpdateTreatmentPlanCustomFieldFileUrlMutation, TError, UpdateTreatmentPlanCustomFieldFileUrlMutationVariables, TContext>(
      {
    mutationKey: ['updateTreatmentPlanCustomFieldFileUrl'],
    mutationFn: useCustomFetcher<UpdateTreatmentPlanCustomFieldFileUrlMutation, UpdateTreatmentPlanCustomFieldFileUrlMutationVariables>(UpdateTreatmentPlanCustomFieldFileUrlDocument),
    ...options
  }
    )};

export const RequestReportReviewDocument = `
    mutation requestReportReview($reportId: ID!, $reviewers: [ReviewerRequestInput!]!, $includeInternal: Boolean) {
  requestReportReview(
    reportId: $reportId
    reviewers: $reviewers
    includeInternal: $includeInternal
  ) {
    success
    message
    statusLogs {
      id
      status
    }
  }
}
    `;

export const useRequestReportReviewMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<RequestReportReviewMutation, TError, RequestReportReviewMutationVariables, TContext>) => {
    
    return useMutation<RequestReportReviewMutation, TError, RequestReportReviewMutationVariables, TContext>(
      {
    mutationKey: ['requestReportReview'],
    mutationFn: useCustomFetcher<RequestReportReviewMutation, RequestReportReviewMutationVariables>(RequestReportReviewDocument),
    ...options
  }
    )};

export const ResolveReportCommentDocument = `
    mutation resolveReportComment($id: ID!) {
  resolveReportComment(id: $id) {
    success
    message
    comment {
      id
      status
    }
  }
}
    `;

export const useResolveReportCommentMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<ResolveReportCommentMutation, TError, ResolveReportCommentMutationVariables, TContext>) => {
    
    return useMutation<ResolveReportCommentMutation, TError, ResolveReportCommentMutationVariables, TContext>(
      {
    mutationKey: ['resolveReportComment'],
    mutationFn: useCustomFetcher<ResolveReportCommentMutation, ResolveReportCommentMutationVariables>(ResolveReportCommentDocument),
    ...options
  }
    )};

export const ResolveReportSuggestionDocument = `
    mutation resolveReportSuggestion($suggestionId: ID!) {
  resolveReportSuggestion(suggestionId: $suggestionId) {
    success
    message
  }
}
    `;

export const useResolveReportSuggestionMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<ResolveReportSuggestionMutation, TError, ResolveReportSuggestionMutationVariables, TContext>) => {
    
    return useMutation<ResolveReportSuggestionMutation, TError, ResolveReportSuggestionMutationVariables, TContext>(
      {
    mutationKey: ['resolveReportSuggestion'],
    mutationFn: useCustomFetcher<ResolveReportSuggestionMutation, ResolveReportSuggestionMutationVariables>(ResolveReportSuggestionDocument),
    ...options
  }
    )};

export const CreateReportSectionsDocument = `
    mutation createReportSections($reportId: ID!, $sections: [ReportSectionInput]!, $runWorkflow: Boolean) {
  createReportSections(
    reportId: $reportId
    sections: $sections
    runWorkflow: $runWorkflow
  ) {
    message
    status
  }
}
    `;

export const useCreateReportSectionsMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateReportSectionsMutation, TError, CreateReportSectionsMutationVariables, TContext>) => {
    
    return useMutation<CreateReportSectionsMutation, TError, CreateReportSectionsMutationVariables, TContext>(
      {
    mutationKey: ['createReportSections'],
    mutationFn: useCustomFetcher<CreateReportSectionsMutation, CreateReportSectionsMutationVariables>(CreateReportSectionsDocument),
    ...options
  }
    )};

export const CreateReportTemplateSectionsDocument = `
    mutation createReportTemplateSections($input: ReportTemplateSectionsInput!) {
  createReportTemplateSections(input: $input) {
    message
    status
  }
}
    `;

export const useCreateReportTemplateSectionsMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateReportTemplateSectionsMutation, TError, CreateReportTemplateSectionsMutationVariables, TContext>) => {
    
    return useMutation<CreateReportTemplateSectionsMutation, TError, CreateReportTemplateSectionsMutationVariables, TContext>(
      {
    mutationKey: ['createReportTemplateSections'],
    mutationFn: useCustomFetcher<CreateReportTemplateSectionsMutation, CreateReportTemplateSectionsMutationVariables>(CreateReportTemplateSectionsDocument),
    ...options
  }
    )};

export const DeleteReportSectionDocument = `
    mutation deleteReportSection($reportSectionId: ID!, $reportId: ID!) {
  deleteReportSection(sectionId: $reportSectionId, reportId: $reportId) {
    message
    status
  }
}
    `;

export const useDeleteReportSectionMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<DeleteReportSectionMutation, TError, DeleteReportSectionMutationVariables, TContext>) => {
    
    return useMutation<DeleteReportSectionMutation, TError, DeleteReportSectionMutationVariables, TContext>(
      {
    mutationKey: ['deleteReportSection'],
    mutationFn: useCustomFetcher<DeleteReportSectionMutation, DeleteReportSectionMutationVariables>(DeleteReportSectionDocument),
    ...options
  }
    )};

export const CreateReportSectionFieldDocument = `
    mutation createReportSectionField($reportId: ID!, $reportSectionId: ID!, $fieldData: ReportSectionFieldInput!) {
  createReportSectionField(
    reportId: $reportId
    reportSectionId: $reportSectionId
    fieldData: $fieldData
  ) {
    message
    status
  }
}
    `;

export const useCreateReportSectionFieldMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateReportSectionFieldMutation, TError, CreateReportSectionFieldMutationVariables, TContext>) => {
    
    return useMutation<CreateReportSectionFieldMutation, TError, CreateReportSectionFieldMutationVariables, TContext>(
      {
    mutationKey: ['createReportSectionField'],
    mutationFn: useCustomFetcher<CreateReportSectionFieldMutation, CreateReportSectionFieldMutationVariables>(CreateReportSectionFieldDocument),
    ...options
  }
    )};

export const CreateReportSectionFieldFileDocument = `
    mutation createReportSectionFieldFile($input: CreateReportSectionFieldFileInput!) {
  createReportSectionFieldFile(input: $input) {
    fileUrl
  }
}
    `;

export const useCreateReportSectionFieldFileMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateReportSectionFieldFileMutation, TError, CreateReportSectionFieldFileMutationVariables, TContext>) => {
    
    return useMutation<CreateReportSectionFieldFileMutation, TError, CreateReportSectionFieldFileMutationVariables, TContext>(
      {
    mutationKey: ['createReportSectionFieldFile'],
    mutationFn: useCustomFetcher<CreateReportSectionFieldFileMutation, CreateReportSectionFieldFileMutationVariables>(CreateReportSectionFieldFileDocument),
    ...options
  }
    )};

export const DeleteReportSectionFieldDocument = `
    mutation deleteReportSectionField($sectionId: ID!, $fieldId: ID!) {
  deleteReportSectionField(sectionId: $sectionId, fieldId: $fieldId) {
    message
    status
  }
}
    `;

export const useDeleteReportSectionFieldMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<DeleteReportSectionFieldMutation, TError, DeleteReportSectionFieldMutationVariables, TContext>) => {
    
    return useMutation<DeleteReportSectionFieldMutation, TError, DeleteReportSectionFieldMutationVariables, TContext>(
      {
    mutationKey: ['deleteReportSectionField'],
    mutationFn: useCustomFetcher<DeleteReportSectionFieldMutation, DeleteReportSectionFieldMutationVariables>(DeleteReportSectionFieldDocument),
    ...options
  }
    )};

export const MoveReportSectionFieldToAnotherSectionDocument = `
    mutation moveReportSectionFieldToAnotherSection($fieldId: ID!, $targetSectionId: ID!) {
  moveReportSectionFieldToAnotherSection(
    fieldId: $fieldId
    targetSectionId: $targetSectionId
  ) {
    status
    message
  }
}
    `;

export const useMoveReportSectionFieldToAnotherSectionMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<MoveReportSectionFieldToAnotherSectionMutation, TError, MoveReportSectionFieldToAnotherSectionMutationVariables, TContext>) => {
    
    return useMutation<MoveReportSectionFieldToAnotherSectionMutation, TError, MoveReportSectionFieldToAnotherSectionMutationVariables, TContext>(
      {
    mutationKey: ['moveReportSectionFieldToAnotherSection'],
    mutationFn: useCustomFetcher<MoveReportSectionFieldToAnotherSectionMutation, MoveReportSectionFieldToAnotherSectionMutationVariables>(MoveReportSectionFieldToAnotherSectionDocument),
    ...options
  }
    )};

export const MoveReportSectionFieldUpAndDownDocument = `
    mutation moveReportSectionFieldUpAndDown($fieldId: ID!, $moveUp: Boolean!, $reportSectionId: ID!) {
  moveReportSectionFieldUpAndDown(
    fieldId: $fieldId
    moveUp: $moveUp
    reportSectionId: $reportSectionId
  ) {
    status
    message
  }
}
    `;

export const useMoveReportSectionFieldUpAndDownMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<MoveReportSectionFieldUpAndDownMutation, TError, MoveReportSectionFieldUpAndDownMutationVariables, TContext>) => {
    
    return useMutation<MoveReportSectionFieldUpAndDownMutation, TError, MoveReportSectionFieldUpAndDownMutationVariables, TContext>(
      {
    mutationKey: ['moveReportSectionFieldUpAndDown'],
    mutationFn: useCustomFetcher<MoveReportSectionFieldUpAndDownMutation, MoveReportSectionFieldUpAndDownMutationVariables>(MoveReportSectionFieldUpAndDownDocument),
    ...options
  }
    )};

export const UpdateReportSectionFieldDocument = `
    mutation updateReportSectionField($reportSectionId: ID!, $reportSectionFieldId: ID!, $title: String, $content: String) {
  updateReportSectionField(
    reportSectionId: $reportSectionId
    reportSectionFieldId: $reportSectionFieldId
    title: $title
    content: $content
  ) {
    message
    status
  }
}
    `;

export const useUpdateReportSectionFieldMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateReportSectionFieldMutation, TError, UpdateReportSectionFieldMutationVariables, TContext>) => {
    
    return useMutation<UpdateReportSectionFieldMutation, TError, UpdateReportSectionFieldMutationVariables, TContext>(
      {
    mutationKey: ['updateReportSectionField'],
    mutationFn: useCustomFetcher<UpdateReportSectionFieldMutation, UpdateReportSectionFieldMutationVariables>(UpdateReportSectionFieldDocument),
    ...options
  }
    )};

export const UpdateReportSectionFieldFileUrlDocument = `
    mutation updateReportSectionFieldFileUrl($input: UpdateReportSectionFieldFileURLInput!) {
  updateReportSectionFieldFileUrl(input: $input) {
    message
    status
  }
}
    `;

export const useUpdateReportSectionFieldFileUrlMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateReportSectionFieldFileUrlMutation, TError, UpdateReportSectionFieldFileUrlMutationVariables, TContext>) => {
    
    return useMutation<UpdateReportSectionFieldFileUrlMutation, TError, UpdateReportSectionFieldFileUrlMutationVariables, TContext>(
      {
    mutationKey: ['updateReportSectionFieldFileUrl'],
    mutationFn: useCustomFetcher<UpdateReportSectionFieldFileUrlMutation, UpdateReportSectionFieldFileUrlMutationVariables>(UpdateReportSectionFieldFileUrlDocument),
    ...options
  }
    )};

export const FillGasTablesDocument = `
    mutation fillGasTables($reportId: ID!) {
  fillGasTables(reportId: $reportId) {
    message
    status
  }
}
    `;

export const useFillGasTablesMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<FillGasTablesMutation, TError, FillGasTablesMutationVariables, TContext>) => {
    
    return useMutation<FillGasTablesMutation, TError, FillGasTablesMutationVariables, TContext>(
      {
    mutationKey: ['fillGasTables'],
    mutationFn: useCustomFetcher<FillGasTablesMutation, FillGasTablesMutationVariables>(FillGasTablesDocument),
    ...options
  }
    )};

export const MoveReportSectionUpAndDownDocument = `
    mutation moveReportSectionUpAndDown($sectionId: ID!, $moveUp: Boolean!, $pageLocation: String!, $reportId: ID!) {
  moveReportSectionUpAndDown(
    sectionId: $sectionId
    moveUp: $moveUp
    pageLocation: $pageLocation
    reportId: $reportId
  ) {
    status
    message
  }
}
    `;

export const useMoveReportSectionUpAndDownMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<MoveReportSectionUpAndDownMutation, TError, MoveReportSectionUpAndDownMutationVariables, TContext>) => {
    
    return useMutation<MoveReportSectionUpAndDownMutation, TError, MoveReportSectionUpAndDownMutationVariables, TContext>(
      {
    mutationKey: ['moveReportSectionUpAndDown'],
    mutationFn: useCustomFetcher<MoveReportSectionUpAndDownMutation, MoveReportSectionUpAndDownMutationVariables>(MoveReportSectionUpAndDownDocument),
    ...options
  }
    )};

export const MoveSectionToOrFromAppendixDocument = `
    mutation moveSectionToOrFromAppendix($input: MoveReportSectionInput!) {
  moveReportSection(input: $input) {
    status
    message
  }
}
    `;

export const useMoveSectionToOrFromAppendixMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<MoveSectionToOrFromAppendixMutation, TError, MoveSectionToOrFromAppendixMutationVariables, TContext>) => {
    
    return useMutation<MoveSectionToOrFromAppendixMutation, TError, MoveSectionToOrFromAppendixMutationVariables, TContext>(
      {
    mutationKey: ['moveSectionToOrFromAppendix'],
    mutationFn: useCustomFetcher<MoveSectionToOrFromAppendixMutation, MoveSectionToOrFromAppendixMutationVariables>(MoveSectionToOrFromAppendixDocument),
    ...options
  }
    )};

export const RecalculateGoalStatusSummaryDocument = `
    mutation recalculateGoalStatusSummary($reportId: ID!) {
  recalculateGoalStatusSummary(reportId: $reportId) {
    message
    status
    updated
  }
}
    `;

export const useRecalculateGoalStatusSummaryMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<RecalculateGoalStatusSummaryMutation, TError, RecalculateGoalStatusSummaryMutationVariables, TContext>) => {
    
    return useMutation<RecalculateGoalStatusSummaryMutation, TError, RecalculateGoalStatusSummaryMutationVariables, TContext>(
      {
    mutationKey: ['recalculateGoalStatusSummary'],
    mutationFn: useCustomFetcher<RecalculateGoalStatusSummaryMutation, RecalculateGoalStatusSummaryMutationVariables>(RecalculateGoalStatusSummaryDocument),
    ...options
  }
    )};

export const StartSingleReportTemplateSectionWorkflowDocument = `
    mutation startSingleReportTemplateSectionWorkflow($sectionId: ID!) {
  startSingleReportTemplateSectionWorkflow(sectionId: $sectionId) {
    message
    status
  }
}
    `;

export const useStartSingleReportTemplateSectionWorkflowMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<StartSingleReportTemplateSectionWorkflowMutation, TError, StartSingleReportTemplateSectionWorkflowMutationVariables, TContext>) => {
    
    return useMutation<StartSingleReportTemplateSectionWorkflowMutation, TError, StartSingleReportTemplateSectionWorkflowMutationVariables, TContext>(
      {
    mutationKey: ['startSingleReportTemplateSectionWorkflow'],
    mutationFn: useCustomFetcher<StartSingleReportTemplateSectionWorkflowMutation, StartSingleReportTemplateSectionWorkflowMutationVariables>(StartSingleReportTemplateSectionWorkflowDocument),
    ...options
  }
    )};

export const StartReportSuggestionsWorkflowDocument = `
    mutation startReportSuggestionsWorkflow($reportId: ID!) {
  startReportSuggestionsWorkflow(reportId: $reportId) {
    success
    message
  }
}
    `;

export const useStartReportSuggestionsWorkflowMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<StartReportSuggestionsWorkflowMutation, TError, StartReportSuggestionsWorkflowMutationVariables, TContext>) => {
    
    return useMutation<StartReportSuggestionsWorkflowMutation, TError, StartReportSuggestionsWorkflowMutationVariables, TContext>(
      {
    mutationKey: ['startReportSuggestionsWorkflow'],
    mutationFn: useCustomFetcher<StartReportSuggestionsWorkflowMutation, StartReportSuggestionsWorkflowMutationVariables>(StartReportSuggestionsWorkflowDocument),
    ...options
  }
    )};

export const UpdateReportSectionDocument = `
    mutation updateReportSection($reportSectionId: ID!, $title: String, $aiGeneratedStatus: ReportSectionAIPredictionStatusEnums) {
  updateReportSection(
    reportSectionId: $reportSectionId
    title: $title
    aiGeneratedStatus: $aiGeneratedStatus
  ) {
    message
    status
  }
}
    `;

export const useUpdateReportSectionMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateReportSectionMutation, TError, UpdateReportSectionMutationVariables, TContext>) => {
    
    return useMutation<UpdateReportSectionMutation, TError, UpdateReportSectionMutationVariables, TContext>(
      {
    mutationKey: ['updateReportSection'],
    mutationFn: useCustomFetcher<UpdateReportSectionMutation, UpdateReportSectionMutationVariables>(UpdateReportSectionDocument),
    ...options
  }
    )};

export const SetReportCommentHiddenDocument = `
    mutation setReportCommentHidden($id: ID!, $hidden: Boolean!) {
  setReportCommentHidden(id: $id, hidden: $hidden) {
    success
    message
    comment {
      id
      hidden
    }
  }
}
    `;

export const useSetReportCommentHiddenMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<SetReportCommentHiddenMutation, TError, SetReportCommentHiddenMutationVariables, TContext>) => {
    
    return useMutation<SetReportCommentHiddenMutation, TError, SetReportCommentHiddenMutationVariables, TContext>(
      {
    mutationKey: ['setReportCommentHidden'],
    mutationFn: useCustomFetcher<SetReportCommentHiddenMutation, SetReportCommentHiddenMutationVariables>(SetReportCommentHiddenDocument),
    ...options
  }
    )};

export const SetReportReviewStatusDocument = `
    mutation setReportReviewStatus($reportId: ID!, $status: ReportReviewerStatus!, $userId: ID, $note: String) {
  setReportReviewStatus(
    reportId: $reportId
    status: $status
    userId: $userId
    note: $note
  ) {
    success
    message
    statusLog {
      id
      status
    }
  }
}
    `;

export const useSetReportReviewStatusMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<SetReportReviewStatusMutation, TError, SetReportReviewStatusMutationVariables, TContext>) => {
    
    return useMutation<SetReportReviewStatusMutation, TError, SetReportReviewStatusMutationVariables, TContext>(
      {
    mutationKey: ['setReportReviewStatus'],
    mutationFn: useCustomFetcher<SetReportReviewStatusMutation, SetReportReviewStatusMutationVariables>(SetReportReviewStatusDocument),
    ...options
  }
    )};

export const SignReportDocument = `
    mutation signReport($input: SignReportInput!) {
  signReport(input: $input) {
    message
    status
  }
}
    `;

export const useSignReportMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<SignReportMutation, TError, SignReportMutationVariables, TContext>) => {
    
    return useMutation<SignReportMutation, TError, SignReportMutationVariables, TContext>(
      {
    mutationKey: ['signReport'],
    mutationFn: useCustomFetcher<SignReportMutation, SignReportMutationVariables>(SignReportDocument),
    ...options
  }
    )};

export const UpdateReportDocument = `
    mutation updateReport($reportId: ID!, $status: ReportStatusEnums!) {
  updateReport(reportId: $reportId, status: $status) {
    status
    message
  }
}
    `;

export const useUpdateReportMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateReportMutation, TError, UpdateReportMutationVariables, TContext>) => {
    
    return useMutation<UpdateReportMutation, TError, UpdateReportMutationVariables, TContext>(
      {
    mutationKey: ['updateReport'],
    mutationFn: useCustomFetcher<UpdateReportMutation, UpdateReportMutationVariables>(UpdateReportDocument),
    ...options
  }
    )};

export const UpdateReportClientDetailsDocument = `
    mutation updateReportClientDetails($reportId: ID!, $learnerCaregiverMinimalInput: LearnerCaregiverMinimalInput!, $reportWriterAndDate: UpdateReportWriterAndDateInput, $previousReportDetails: PreviousReportDetailsInput, $updateLearner: Boolean) {
  updateReportClientDetails(
    reportId: $reportId
    clientDetails: $learnerCaregiverMinimalInput
    reportWriterAndDate: $reportWriterAndDate
    previousReportDetails: $previousReportDetails
    updateLearner: $updateLearner
  ) {
    message
    status
  }
}
    `;

export const useUpdateReportClientDetailsMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateReportClientDetailsMutation, TError, UpdateReportClientDetailsMutationVariables, TContext>) => {
    
    return useMutation<UpdateReportClientDetailsMutation, TError, UpdateReportClientDetailsMutationVariables, TContext>(
      {
    mutationKey: ['updateReportClientDetails'],
    mutationFn: useCustomFetcher<UpdateReportClientDetailsMutation, UpdateReportClientDetailsMutationVariables>(UpdateReportClientDetailsDocument),
    ...options
  }
    )};

export const UpdateReportStatusAndUploadReportFileDocument = `
    mutation updateReportStatusAndUploadReportFile($reportId: ID!, $reportDocxFile: Upload!) {
  updateReportStatusAndUploadReportFile(
    report: $reportId
    reportDocxFile: $reportDocxFile
  ) {
    status
    message
  }
}
    `;

export const useUpdateReportStatusAndUploadReportFileMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateReportStatusAndUploadReportFileMutation, TError, UpdateReportStatusAndUploadReportFileMutationVariables, TContext>) => {
    
    return useMutation<UpdateReportStatusAndUploadReportFileMutation, TError, UpdateReportStatusAndUploadReportFileMutationVariables, TContext>(
      {
    mutationKey: ['updateReportStatusAndUploadReportFile'],
    mutationFn: useCustomFetcher<UpdateReportStatusAndUploadReportFileMutation, UpdateReportStatusAndUploadReportFileMutationVariables>(UpdateReportStatusAndUploadReportFileDocument),
    ...options
  }
    )};

export const AddSessionAnalyzerFeedbackDocument = `
    mutation addSessionAnalyzerFeedback($sessionAnalyzerFeedbackDetails: SessionAnalyzerFeedbackDetails!) {
  addSessionAnalyzerFeedback(
    sessionAnalyzerFeedbackDetails: $sessionAnalyzerFeedbackDetails
  ) {
    status
    message
  }
}
    `;

export const useAddSessionAnalyzerFeedbackMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<AddSessionAnalyzerFeedbackMutation, TError, AddSessionAnalyzerFeedbackMutationVariables, TContext>) => {
    
    return useMutation<AddSessionAnalyzerFeedbackMutation, TError, AddSessionAnalyzerFeedbackMutationVariables, TContext>(
      {
    mutationKey: ['addSessionAnalyzerFeedback'],
    mutationFn: useCustomFetcher<AddSessionAnalyzerFeedbackMutation, AddSessionAnalyzerFeedbackMutationVariables>(AddSessionAnalyzerFeedbackDocument),
    ...options
  }
    )};

export const CreateBaseSuggestionCriteriaDocument = `
    mutation CreateBaseSuggestionCriteria($name: String!, $content: String!, $category: String) {
  createBaseSuggestionCriteria(
    name: $name
    content: $content
    category: $category
  ) {
    success
    message
    suggestionCriteria {
      id
      name
      category
      content
      isBaseCriteria
    }
  }
}
    `;

export const useCreateBaseSuggestionCriteriaMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateBaseSuggestionCriteriaMutation, TError, CreateBaseSuggestionCriteriaMutationVariables, TContext>) => {
    
    return useMutation<CreateBaseSuggestionCriteriaMutation, TError, CreateBaseSuggestionCriteriaMutationVariables, TContext>(
      {
    mutationKey: ['CreateBaseSuggestionCriteria'],
    mutationFn: useCustomFetcher<CreateBaseSuggestionCriteriaMutation, CreateBaseSuggestionCriteriaMutationVariables>(CreateBaseSuggestionCriteriaDocument),
    ...options
  }
    )};

export const CreateOrganizationSuggestionCriteriaDocument = `
    mutation CreateOrganizationSuggestionCriteria($name: String!, $content: String!, $category: String) {
  createOrganizationSuggestionCriteria(
    name: $name
    content: $content
    category: $category
  ) {
    success
    message
    organizationSuggestionCriteria {
      id
      enabled
      suggestionCriteria {
        id
        name
        category
        content
        isBaseCriteria
      }
    }
  }
}
    `;

export const useCreateOrganizationSuggestionCriteriaMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateOrganizationSuggestionCriteriaMutation, TError, CreateOrganizationSuggestionCriteriaMutationVariables, TContext>) => {
    
    return useMutation<CreateOrganizationSuggestionCriteriaMutation, TError, CreateOrganizationSuggestionCriteriaMutationVariables, TContext>(
      {
    mutationKey: ['CreateOrganizationSuggestionCriteria'],
    mutationFn: useCustomFetcher<CreateOrganizationSuggestionCriteriaMutation, CreateOrganizationSuggestionCriteriaMutationVariables>(CreateOrganizationSuggestionCriteriaDocument),
    ...options
  }
    )};

export const CreateReportTemplateSuggestionCriteriaDocument = `
    mutation CreateReportTemplateSuggestionCriteria($reportTemplateId: ID!, $name: String!, $content: String!, $category: String) {
  createReportTemplateSuggestionCriteria(
    reportTemplateId: $reportTemplateId
    name: $name
    content: $content
    category: $category
  ) {
    success
    message
    reportTemplateSuggestionCriteria {
      id
      enabled
      suggestionCriteria {
        id
        name
        category
        content
      }
    }
  }
}
    `;

export const useCreateReportTemplateSuggestionCriteriaMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateReportTemplateSuggestionCriteriaMutation, TError, CreateReportTemplateSuggestionCriteriaMutationVariables, TContext>) => {
    
    return useMutation<CreateReportTemplateSuggestionCriteriaMutation, TError, CreateReportTemplateSuggestionCriteriaMutationVariables, TContext>(
      {
    mutationKey: ['CreateReportTemplateSuggestionCriteria'],
    mutationFn: useCustomFetcher<CreateReportTemplateSuggestionCriteriaMutation, CreateReportTemplateSuggestionCriteriaMutationVariables>(CreateReportTemplateSuggestionCriteriaDocument),
    ...options
  }
    )};

export const UpdateBaseSuggestionCriteriaDocument = `
    mutation UpdateBaseSuggestionCriteria($id: ID!, $name: String, $content: String, $category: String) {
  updateBaseSuggestionCriteria(
    id: $id
    name: $name
    content: $content
    category: $category
  ) {
    success
    message
    suggestionCriteria {
      id
      name
      category
      content
      isBaseCriteria
    }
  }
}
    `;

export const useUpdateBaseSuggestionCriteriaMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateBaseSuggestionCriteriaMutation, TError, UpdateBaseSuggestionCriteriaMutationVariables, TContext>) => {
    
    return useMutation<UpdateBaseSuggestionCriteriaMutation, TError, UpdateBaseSuggestionCriteriaMutationVariables, TContext>(
      {
    mutationKey: ['UpdateBaseSuggestionCriteria'],
    mutationFn: useCustomFetcher<UpdateBaseSuggestionCriteriaMutation, UpdateBaseSuggestionCriteriaMutationVariables>(UpdateBaseSuggestionCriteriaDocument),
    ...options
  }
    )};

export const UpdateOrganizationSuggestionCriteriaDocument = `
    mutation UpdateOrganizationSuggestionCriteria($id: ID!, $content: String, $category: String, $enabled: Boolean) {
  updateOrganizationSuggestionCriteria(
    id: $id
    content: $content
    category: $category
    enabled: $enabled
  ) {
    success
    message
    organizationSuggestionCriteria {
      id
      enabled
      suggestionCriteria {
        id
        name
        category
        content
        isBaseCriteria
      }
    }
  }
}
    `;

export const useUpdateOrganizationSuggestionCriteriaMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateOrganizationSuggestionCriteriaMutation, TError, UpdateOrganizationSuggestionCriteriaMutationVariables, TContext>) => {
    
    return useMutation<UpdateOrganizationSuggestionCriteriaMutation, TError, UpdateOrganizationSuggestionCriteriaMutationVariables, TContext>(
      {
    mutationKey: ['UpdateOrganizationSuggestionCriteria'],
    mutationFn: useCustomFetcher<UpdateOrganizationSuggestionCriteriaMutation, UpdateOrganizationSuggestionCriteriaMutationVariables>(UpdateOrganizationSuggestionCriteriaDocument),
    ...options
  }
    )};

export const UpdateReportTemplateSuggestionCriteriaDocument = `
    mutation UpdateReportTemplateSuggestionCriteria($id: ID!, $content: String, $category: String, $enabled: Boolean) {
  updateReportTemplateSuggestionCriteria(
    id: $id
    content: $content
    category: $category
    enabled: $enabled
  ) {
    success
    message
    reportTemplateSuggestionCriteria {
      id
      enabled
      suggestionCriteria {
        id
        name
        category
        content
      }
    }
  }
}
    `;

export const useUpdateReportTemplateSuggestionCriteriaMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateReportTemplateSuggestionCriteriaMutation, TError, UpdateReportTemplateSuggestionCriteriaMutationVariables, TContext>) => {
    
    return useMutation<UpdateReportTemplateSuggestionCriteriaMutation, TError, UpdateReportTemplateSuggestionCriteriaMutationVariables, TContext>(
      {
    mutationKey: ['UpdateReportTemplateSuggestionCriteria'],
    mutationFn: useCustomFetcher<UpdateReportTemplateSuggestionCriteriaMutation, UpdateReportTemplateSuggestionCriteriaMutationVariables>(UpdateReportTemplateSuggestionCriteriaDocument),
    ...options
  }
    )};

export const UpsertOrganizationSuggestionCriteriaDocument = `
    mutation UpsertOrganizationSuggestionCriteria($suggestionCriteriaId: ID!, $enabled: Boolean!) {
  upsertOrganizationSuggestionCriteria(
    suggestionCriteriaId: $suggestionCriteriaId
    enabled: $enabled
  ) {
    success
    message
    organizationSuggestionCriteria {
      id
      enabled
      isVirtual
      suggestionCriteria {
        id
        name
        category
        content
        isBaseCriteria
      }
    }
  }
}
    `;

export const useUpsertOrganizationSuggestionCriteriaMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpsertOrganizationSuggestionCriteriaMutation, TError, UpsertOrganizationSuggestionCriteriaMutationVariables, TContext>) => {
    
    return useMutation<UpsertOrganizationSuggestionCriteriaMutation, TError, UpsertOrganizationSuggestionCriteriaMutationVariables, TContext>(
      {
    mutationKey: ['UpsertOrganizationSuggestionCriteria'],
    mutationFn: useCustomFetcher<UpsertOrganizationSuggestionCriteriaMutation, UpsertOrganizationSuggestionCriteriaMutationVariables>(UpsertOrganizationSuggestionCriteriaDocument),
    ...options
  }
    )};

export const CreateGoalsAndTargetsDocument = `
    mutation CreateGoalsAndTargets($learnerId: ID!, $goals: [GoalWithTargetsInput!]!) {
  createGoalsAndTargets(learnerId: $learnerId, goals: $goals) {
    status
    message
  }
}
    `;

export const useCreateGoalsAndTargetsMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateGoalsAndTargetsMutation, TError, CreateGoalsAndTargetsMutationVariables, TContext>) => {
    
    return useMutation<CreateGoalsAndTargetsMutation, TError, CreateGoalsAndTargetsMutationVariables, TContext>(
      {
    mutationKey: ['CreateGoalsAndTargets'],
    mutationFn: useCustomFetcher<CreateGoalsAndTargetsMutation, CreateGoalsAndTargetsMutationVariables>(CreateGoalsAndTargetsDocument),
    ...options
  }
    )};

export const ReorderGoalsDocument = `
    mutation ReorderGoals($goals: [ReorderGoalsInput!]!) {
  reorderGoals(goals: $goals) {
    message
    status
  }
}
    `;

export const useReorderGoalsMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<ReorderGoalsMutation, TError, ReorderGoalsMutationVariables, TContext>) => {
    
    return useMutation<ReorderGoalsMutation, TError, ReorderGoalsMutationVariables, TContext>(
      {
    mutationKey: ['ReorderGoals'],
    mutationFn: useCustomFetcher<ReorderGoalsMutation, ReorderGoalsMutationVariables>(ReorderGoalsDocument),
    ...options
  }
    )};

export const StartTreatmentPlanUploadParsingDocument = `
    mutation StartTreatmentPlanUploadParsing($learnerId: ID!, $input: CreateParsedTreatmentPlanFileDataInput!) {
  createParsedTreatmentPlanFileData(learnerId: $learnerId, input: $input) {
    status
    message
    record {
      id
    }
  }
}
    `;

export const useStartTreatmentPlanUploadParsingMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<StartTreatmentPlanUploadParsingMutation, TError, StartTreatmentPlanUploadParsingMutationVariables, TContext>) => {
    
    return useMutation<StartTreatmentPlanUploadParsingMutation, TError, StartTreatmentPlanUploadParsingMutationVariables, TContext>(
      {
    mutationKey: ['StartTreatmentPlanUploadParsing'],
    mutationFn: useCustomFetcher<StartTreatmentPlanUploadParsingMutation, StartTreatmentPlanUploadParsingMutationVariables>(StartTreatmentPlanUploadParsingDocument),
    ...options
  }
    )};

export const ProgrammingGoalChartDocument = `
    query ProgrammingGoalChart($goalId: ID!) {
  goal(id: $goalId) {
    reportgoalSet(first: 1) {
      edges {
        node {
          id
          chartType
          chartImageUrl
          summaryReviewed
          summaryReviewedOn
          reporttargetSet {
            edges {
              node {
                id
                summaryReviewed
                chartImageUrl
                target {
                  id
                }
              }
            }
          }
        }
      }
    }
  }
}
    `;

export const useProgrammingGoalChartQuery = <
      TData = ProgrammingGoalChartQuery,
      TError = unknown
    >(
      variables: ProgrammingGoalChartQueryVariables,
      options?: Omit<UseQueryOptions<ProgrammingGoalChartQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<ProgrammingGoalChartQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<ProgrammingGoalChartQuery, TError, TData>(
      {
    queryKey: ['ProgrammingGoalChart', variables],
    queryFn: useCustomFetcher<ProgrammingGoalChartQuery, ProgrammingGoalChartQueryVariables>(ProgrammingGoalChartDocument).bind(null, variables),
    ...options
  }
    )};

export const AdminAnalyticsDashboardDocument = `
    query adminAnalyticsDashboard($filters: AnalyticsFiltersInput!, $reportsByUserPage: AnalyticsPageInput!, $overduePage: AnalyticsPageInput!, $qaByUserPage: AnalyticsPageInput!, $includeSubmissionTrend: Boolean!) {
  adminAnalytics(filters: $filters) {
    totalReports {
      ...AnalyticsMetricFields
    }
    openQaFlags {
      ...AnalyticsMetricFields
    }
    resolvedQaFlags {
      ...AnalyticsMetricFields
    }
    reportsByStatus {
      ...AnalyticsStatusCountFields
    }
    writingTimeByReportType {
      ...AnalyticsWritingTimeFields
    }
    submissionTrend @include(if: $includeSubmissionTrend) {
      ...AnalyticsTrendPointFields
    }
    templateOptions {
      ...AnalyticsTemplateOptionFields
    }
    reportsByUser(page: $reportsByUserPage, sort: {field: COUNT, direction: DESC}) {
      ...AnalyticsReportsByUserPageFields
    }
    overdueReports(page: $overduePage, sort: {field: DAYS_OPEN, direction: DESC}) {
      totalCount
      rows {
        ...AnalyticsOverdueRowFields
      }
    }
    qaByUser(page: $qaByUserPage, sort: {field: TOTAL_FLAGS, direction: DESC}) {
      ...AnalyticsQaByUserPageFields
    }
  }
}
    ${AnalyticsMetricFieldsFragmentDoc}
${AnalyticsStatusCountFieldsFragmentDoc}
${AnalyticsWritingTimeFieldsFragmentDoc}
${AnalyticsTrendPointFieldsFragmentDoc}
${AnalyticsTemplateOptionFieldsFragmentDoc}
${AnalyticsReportsByUserPageFieldsFragmentDoc}
${AnalyticsOverdueRowFieldsFragmentDoc}
${AnalyticsQaByUserPageFieldsFragmentDoc}`;

export const useAdminAnalyticsDashboardQuery = <
      TData = AdminAnalyticsDashboardQuery,
      TError = unknown
    >(
      variables: AdminAnalyticsDashboardQueryVariables,
      options?: Omit<UseQueryOptions<AdminAnalyticsDashboardQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<AdminAnalyticsDashboardQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<AdminAnalyticsDashboardQuery, TError, TData>(
      {
    queryKey: ['adminAnalyticsDashboard', variables],
    queryFn: useCustomFetcher<AdminAnalyticsDashboardQuery, AdminAnalyticsDashboardQueryVariables>(AdminAnalyticsDashboardDocument).bind(null, variables),
    ...options
  }
    )};

export const AdminAnalyticsOpenQaFlagsDocument = `
    query adminAnalyticsOpenQaFlags($filters: AnalyticsFiltersInput!, $cell: AnalyticsCellFiltersInput) {
  adminAnalytics(filters: $filters) {
    openQaFlags(filters: $cell) {
      ...AnalyticsMetricFields
    }
  }
}
    ${AnalyticsMetricFieldsFragmentDoc}`;

export const useAdminAnalyticsOpenQaFlagsQuery = <
      TData = AdminAnalyticsOpenQaFlagsQuery,
      TError = unknown
    >(
      variables: AdminAnalyticsOpenQaFlagsQueryVariables,
      options?: Omit<UseQueryOptions<AdminAnalyticsOpenQaFlagsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<AdminAnalyticsOpenQaFlagsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<AdminAnalyticsOpenQaFlagsQuery, TError, TData>(
      {
    queryKey: ['adminAnalyticsOpenQaFlags', variables],
    queryFn: useCustomFetcher<AdminAnalyticsOpenQaFlagsQuery, AdminAnalyticsOpenQaFlagsQueryVariables>(AdminAnalyticsOpenQaFlagsDocument).bind(null, variables),
    ...options
  }
    )};

export const AdminAnalyticsOverdueReportFacetsDocument = `
    query adminAnalyticsOverdueReportFacets($filters: AnalyticsFiltersInput!, $cell: AnalyticsCellFiltersInput, $facetLimit: Int, $facetSearch: [AnalyticsFacetSearchInput!]) {
  adminAnalytics(filters: $filters) {
    overdueReports(filters: $cell) {
      facets(limit: $facetLimit, search: $facetSearch) {
        ...AnalyticsFacetFields
      }
    }
  }
}
    ${AnalyticsFacetFieldsFragmentDoc}`;

export const useAdminAnalyticsOverdueReportFacetsQuery = <
      TData = AdminAnalyticsOverdueReportFacetsQuery,
      TError = unknown
    >(
      variables: AdminAnalyticsOverdueReportFacetsQueryVariables,
      options?: Omit<UseQueryOptions<AdminAnalyticsOverdueReportFacetsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<AdminAnalyticsOverdueReportFacetsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<AdminAnalyticsOverdueReportFacetsQuery, TError, TData>(
      {
    queryKey: ['adminAnalyticsOverdueReportFacets', variables],
    queryFn: useCustomFetcher<AdminAnalyticsOverdueReportFacetsQuery, AdminAnalyticsOverdueReportFacetsQueryVariables>(AdminAnalyticsOverdueReportFacetsDocument).bind(null, variables),
    ...options
  }
    )};

export const AdminAnalyticsOverdueReportRowsDocument = `
    query adminAnalyticsOverdueReportRows($filters: AnalyticsFiltersInput!, $cell: AnalyticsCellFiltersInput, $page: AnalyticsPageInput!, $sort: AnalyticsOverdueReportSortInput!, $withTotal: Boolean! = true) {
  adminAnalytics(filters: $filters) {
    overdueReports(filters: $cell, page: $page, sort: $sort) {
      totalCount @include(if: $withTotal)
      rows {
        ...AnalyticsOverdueRowFields
      }
    }
  }
}
    ${AnalyticsOverdueRowFieldsFragmentDoc}`;

export const useAdminAnalyticsOverdueReportRowsQuery = <
      TData = AdminAnalyticsOverdueReportRowsQuery,
      TError = unknown
    >(
      variables: AdminAnalyticsOverdueReportRowsQueryVariables,
      options?: Omit<UseQueryOptions<AdminAnalyticsOverdueReportRowsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<AdminAnalyticsOverdueReportRowsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<AdminAnalyticsOverdueReportRowsQuery, TError, TData>(
      {
    queryKey: ['adminAnalyticsOverdueReportRows', variables],
    queryFn: useCustomFetcher<AdminAnalyticsOverdueReportRowsQuery, AdminAnalyticsOverdueReportRowsQueryVariables>(AdminAnalyticsOverdueReportRowsDocument).bind(null, variables),
    ...options
  }
    )};

export const AdminAnalyticsOverdueReportsDocument = `
    query adminAnalyticsOverdueReports($filters: AnalyticsFiltersInput!, $cell: AnalyticsCellFiltersInput, $page: AnalyticsPageInput!) {
  adminAnalytics(filters: $filters) {
    overdueReports(
      filters: $cell
      page: $page
      sort: {field: DAYS_OPEN, direction: DESC}
    ) {
      totalCount
      rows {
        ...AnalyticsOverdueRowFields
      }
    }
  }
}
    ${AnalyticsOverdueRowFieldsFragmentDoc}`;

export const useAdminAnalyticsOverdueReportsQuery = <
      TData = AdminAnalyticsOverdueReportsQuery,
      TError = unknown
    >(
      variables: AdminAnalyticsOverdueReportsQueryVariables,
      options?: Omit<UseQueryOptions<AdminAnalyticsOverdueReportsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<AdminAnalyticsOverdueReportsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<AdminAnalyticsOverdueReportsQuery, TError, TData>(
      {
    queryKey: ['adminAnalyticsOverdueReports', variables],
    queryFn: useCustomFetcher<AdminAnalyticsOverdueReportsQuery, AdminAnalyticsOverdueReportsQueryVariables>(AdminAnalyticsOverdueReportsDocument).bind(null, variables),
    ...options
  }
    )};

export const AdminAnalyticsQaByUserDocument = `
    query adminAnalyticsQaByUser($filters: AnalyticsFiltersInput!, $cell: AnalyticsCellFiltersInput, $page: AnalyticsPageInput!) {
  adminAnalytics(filters: $filters) {
    qaByUser(
      filters: $cell
      page: $page
      sort: {field: TOTAL_FLAGS, direction: DESC}
    ) {
      ...AnalyticsQaByUserPageFields
    }
  }
}
    ${AnalyticsQaByUserPageFieldsFragmentDoc}`;

export const useAdminAnalyticsQaByUserQuery = <
      TData = AdminAnalyticsQaByUserQuery,
      TError = unknown
    >(
      variables: AdminAnalyticsQaByUserQueryVariables,
      options?: Omit<UseQueryOptions<AdminAnalyticsQaByUserQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<AdminAnalyticsQaByUserQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<AdminAnalyticsQaByUserQuery, TError, TData>(
      {
    queryKey: ['adminAnalyticsQaByUser', variables],
    queryFn: useCustomFetcher<AdminAnalyticsQaByUserQuery, AdminAnalyticsQaByUserQueryVariables>(AdminAnalyticsQaByUserDocument).bind(null, variables),
    ...options
  }
    )};

export const AdminAnalyticsQaFlagFacetsDocument = `
    query adminAnalyticsQaFlagFacets($filters: AnalyticsFiltersInput!, $cell: AnalyticsCellFiltersInput, $facetLimit: Int, $facetSearch: [AnalyticsFacetSearchInput!]) {
  adminAnalytics(filters: $filters) {
    qaFlags(filters: $cell) {
      facets(limit: $facetLimit, search: $facetSearch) {
        ...AnalyticsFacetFields
      }
    }
  }
}
    ${AnalyticsFacetFieldsFragmentDoc}`;

export const useAdminAnalyticsQaFlagFacetsQuery = <
      TData = AdminAnalyticsQaFlagFacetsQuery,
      TError = unknown
    >(
      variables: AdminAnalyticsQaFlagFacetsQueryVariables,
      options?: Omit<UseQueryOptions<AdminAnalyticsQaFlagFacetsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<AdminAnalyticsQaFlagFacetsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<AdminAnalyticsQaFlagFacetsQuery, TError, TData>(
      {
    queryKey: ['adminAnalyticsQaFlagFacets', variables],
    queryFn: useCustomFetcher<AdminAnalyticsQaFlagFacetsQuery, AdminAnalyticsQaFlagFacetsQueryVariables>(AdminAnalyticsQaFlagFacetsDocument).bind(null, variables),
    ...options
  }
    )};

export const AdminAnalyticsQaFlagRowsDocument = `
    query adminAnalyticsQaFlagRows($filters: AnalyticsFiltersInput!, $cell: AnalyticsCellFiltersInput, $page: AnalyticsPageInput!, $sort: AnalyticsQaFlagSortInput!, $withTotal: Boolean! = true) {
  adminAnalytics(filters: $filters) {
    qaFlags(filters: $cell, page: $page, sort: $sort) {
      totalCount @include(if: $withTotal)
      rows {
        ...AnalyticsQaFlagRowFields
      }
    }
  }
}
    ${AnalyticsQaFlagRowFieldsFragmentDoc}`;

export const useAdminAnalyticsQaFlagRowsQuery = <
      TData = AdminAnalyticsQaFlagRowsQuery,
      TError = unknown
    >(
      variables: AdminAnalyticsQaFlagRowsQueryVariables,
      options?: Omit<UseQueryOptions<AdminAnalyticsQaFlagRowsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<AdminAnalyticsQaFlagRowsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<AdminAnalyticsQaFlagRowsQuery, TError, TData>(
      {
    queryKey: ['adminAnalyticsQaFlagRows', variables],
    queryFn: useCustomFetcher<AdminAnalyticsQaFlagRowsQuery, AdminAnalyticsQaFlagRowsQueryVariables>(AdminAnalyticsQaFlagRowsDocument).bind(null, variables),
    ...options
  }
    )};

export const AdminAnalyticsReportFacetsDocument = `
    query adminAnalyticsReportFacets($filters: AnalyticsFiltersInput!, $cell: AnalyticsCellFiltersInput, $dateField: AnalyticsReportDateField!, $facetLimit: Int, $facetSearch: [AnalyticsFacetSearchInput!]) {
  adminAnalytics(filters: $filters) {
    reports(dateField: $dateField, filters: $cell) {
      facets(limit: $facetLimit, search: $facetSearch) {
        ...AnalyticsFacetFields
      }
    }
  }
}
    ${AnalyticsFacetFieldsFragmentDoc}`;

export const useAdminAnalyticsReportFacetsQuery = <
      TData = AdminAnalyticsReportFacetsQuery,
      TError = unknown
    >(
      variables: AdminAnalyticsReportFacetsQueryVariables,
      options?: Omit<UseQueryOptions<AdminAnalyticsReportFacetsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<AdminAnalyticsReportFacetsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<AdminAnalyticsReportFacetsQuery, TError, TData>(
      {
    queryKey: ['adminAnalyticsReportFacets', variables],
    queryFn: useCustomFetcher<AdminAnalyticsReportFacetsQuery, AdminAnalyticsReportFacetsQueryVariables>(AdminAnalyticsReportFacetsDocument).bind(null, variables),
    ...options
  }
    )};

export const AdminAnalyticsReportRowsDocument = `
    query adminAnalyticsReportRows($filters: AnalyticsFiltersInput!, $cell: AnalyticsCellFiltersInput, $dateField: AnalyticsReportDateField!, $page: AnalyticsPageInput!, $sort: AnalyticsReportSortInput!, $withTotal: Boolean! = true) {
  adminAnalytics(filters: $filters) {
    reports(dateField: $dateField, filters: $cell, page: $page, sort: $sort) {
      totalCount @include(if: $withTotal)
      rows {
        ...AnalyticsReportRowFields
      }
    }
  }
}
    ${AnalyticsReportRowFieldsFragmentDoc}`;

export const useAdminAnalyticsReportRowsQuery = <
      TData = AdminAnalyticsReportRowsQuery,
      TError = unknown
    >(
      variables: AdminAnalyticsReportRowsQueryVariables,
      options?: Omit<UseQueryOptions<AdminAnalyticsReportRowsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<AdminAnalyticsReportRowsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<AdminAnalyticsReportRowsQuery, TError, TData>(
      {
    queryKey: ['adminAnalyticsReportRows', variables],
    queryFn: useCustomFetcher<AdminAnalyticsReportRowsQuery, AdminAnalyticsReportRowsQueryVariables>(AdminAnalyticsReportRowsDocument).bind(null, variables),
    ...options
  }
    )};

export const AdminAnalyticsReportsByStatusDocument = `
    query adminAnalyticsReportsByStatus($filters: AnalyticsFiltersInput!, $cell: AnalyticsCellFiltersInput) {
  adminAnalytics(filters: $filters) {
    reportsByStatus(filters: $cell) {
      ...AnalyticsStatusCountFields
    }
  }
}
    ${AnalyticsStatusCountFieldsFragmentDoc}`;

export const useAdminAnalyticsReportsByStatusQuery = <
      TData = AdminAnalyticsReportsByStatusQuery,
      TError = unknown
    >(
      variables: AdminAnalyticsReportsByStatusQueryVariables,
      options?: Omit<UseQueryOptions<AdminAnalyticsReportsByStatusQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<AdminAnalyticsReportsByStatusQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<AdminAnalyticsReportsByStatusQuery, TError, TData>(
      {
    queryKey: ['adminAnalyticsReportsByStatus', variables],
    queryFn: useCustomFetcher<AdminAnalyticsReportsByStatusQuery, AdminAnalyticsReportsByStatusQueryVariables>(AdminAnalyticsReportsByStatusDocument).bind(null, variables),
    ...options
  }
    )};

export const AdminAnalyticsReportsByUserDocument = `
    query adminAnalyticsReportsByUser($filters: AnalyticsFiltersInput!, $cell: AnalyticsCellFiltersInput, $page: AnalyticsPageInput!) {
  adminAnalytics(filters: $filters) {
    reportsByUser(
      filters: $cell
      page: $page
      sort: {field: COUNT, direction: DESC}
    ) {
      ...AnalyticsReportsByUserPageFields
    }
  }
}
    ${AnalyticsReportsByUserPageFieldsFragmentDoc}`;

export const useAdminAnalyticsReportsByUserQuery = <
      TData = AdminAnalyticsReportsByUserQuery,
      TError = unknown
    >(
      variables: AdminAnalyticsReportsByUserQueryVariables,
      options?: Omit<UseQueryOptions<AdminAnalyticsReportsByUserQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<AdminAnalyticsReportsByUserQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<AdminAnalyticsReportsByUserQuery, TError, TData>(
      {
    queryKey: ['adminAnalyticsReportsByUser', variables],
    queryFn: useCustomFetcher<AdminAnalyticsReportsByUserQuery, AdminAnalyticsReportsByUserQueryVariables>(AdminAnalyticsReportsByUserDocument).bind(null, variables),
    ...options
  }
    )};

export const AdminAnalyticsResolvedQaFlagsDocument = `
    query adminAnalyticsResolvedQaFlags($filters: AnalyticsFiltersInput!, $cell: AnalyticsCellFiltersInput) {
  adminAnalytics(filters: $filters) {
    resolvedQaFlags(filters: $cell) {
      ...AnalyticsMetricFields
    }
  }
}
    ${AnalyticsMetricFieldsFragmentDoc}`;

export const useAdminAnalyticsResolvedQaFlagsQuery = <
      TData = AdminAnalyticsResolvedQaFlagsQuery,
      TError = unknown
    >(
      variables: AdminAnalyticsResolvedQaFlagsQueryVariables,
      options?: Omit<UseQueryOptions<AdminAnalyticsResolvedQaFlagsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<AdminAnalyticsResolvedQaFlagsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<AdminAnalyticsResolvedQaFlagsQuery, TError, TData>(
      {
    queryKey: ['adminAnalyticsResolvedQaFlags', variables],
    queryFn: useCustomFetcher<AdminAnalyticsResolvedQaFlagsQuery, AdminAnalyticsResolvedQaFlagsQueryVariables>(AdminAnalyticsResolvedQaFlagsDocument).bind(null, variables),
    ...options
  }
    )};

export const AdminAnalyticsSubmissionTrendDocument = `
    query adminAnalyticsSubmissionTrend($filters: AnalyticsFiltersInput!, $cell: AnalyticsCellFiltersInput) {
  adminAnalytics(filters: $filters) {
    submissionTrend(filters: $cell) {
      ...AnalyticsTrendPointFields
    }
  }
}
    ${AnalyticsTrendPointFieldsFragmentDoc}`;

export const useAdminAnalyticsSubmissionTrendQuery = <
      TData = AdminAnalyticsSubmissionTrendQuery,
      TError = unknown
    >(
      variables: AdminAnalyticsSubmissionTrendQueryVariables,
      options?: Omit<UseQueryOptions<AdminAnalyticsSubmissionTrendQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<AdminAnalyticsSubmissionTrendQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<AdminAnalyticsSubmissionTrendQuery, TError, TData>(
      {
    queryKey: ['adminAnalyticsSubmissionTrend', variables],
    queryFn: useCustomFetcher<AdminAnalyticsSubmissionTrendQuery, AdminAnalyticsSubmissionTrendQueryVariables>(AdminAnalyticsSubmissionTrendDocument).bind(null, variables),
    ...options
  }
    )};

export const AdminAnalyticsTemplateOptionsDocument = `
    query adminAnalyticsTemplateOptions($filters: AnalyticsFiltersInput!) {
  adminAnalytics(filters: $filters) {
    templateOptions {
      ...AnalyticsTemplateOptionFields
    }
  }
}
    ${AnalyticsTemplateOptionFieldsFragmentDoc}`;

export const useAdminAnalyticsTemplateOptionsQuery = <
      TData = AdminAnalyticsTemplateOptionsQuery,
      TError = unknown
    >(
      variables: AdminAnalyticsTemplateOptionsQueryVariables,
      options?: Omit<UseQueryOptions<AdminAnalyticsTemplateOptionsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<AdminAnalyticsTemplateOptionsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<AdminAnalyticsTemplateOptionsQuery, TError, TData>(
      {
    queryKey: ['adminAnalyticsTemplateOptions', variables],
    queryFn: useCustomFetcher<AdminAnalyticsTemplateOptionsQuery, AdminAnalyticsTemplateOptionsQueryVariables>(AdminAnalyticsTemplateOptionsDocument).bind(null, variables),
    ...options
  }
    )};

export const AdminAnalyticsTotalReportsDocument = `
    query adminAnalyticsTotalReports($filters: AnalyticsFiltersInput!, $cell: AnalyticsCellFiltersInput) {
  adminAnalytics(filters: $filters) {
    totalReports(filters: $cell) {
      ...AnalyticsMetricFields
    }
  }
}
    ${AnalyticsMetricFieldsFragmentDoc}`;

export const useAdminAnalyticsTotalReportsQuery = <
      TData = AdminAnalyticsTotalReportsQuery,
      TError = unknown
    >(
      variables: AdminAnalyticsTotalReportsQueryVariables,
      options?: Omit<UseQueryOptions<AdminAnalyticsTotalReportsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<AdminAnalyticsTotalReportsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<AdminAnalyticsTotalReportsQuery, TError, TData>(
      {
    queryKey: ['adminAnalyticsTotalReports', variables],
    queryFn: useCustomFetcher<AdminAnalyticsTotalReportsQuery, AdminAnalyticsTotalReportsQueryVariables>(AdminAnalyticsTotalReportsDocument).bind(null, variables),
    ...options
  }
    )};

export const AdminAnalyticsWritingTimeDocument = `
    query adminAnalyticsWritingTime($filters: AnalyticsFiltersInput!, $cell: AnalyticsCellFiltersInput) {
  adminAnalytics(filters: $filters) {
    writingTimeByReportType(filters: $cell) {
      ...AnalyticsWritingTimeFields
    }
  }
}
    ${AnalyticsWritingTimeFieldsFragmentDoc}`;

export const useAdminAnalyticsWritingTimeQuery = <
      TData = AdminAnalyticsWritingTimeQuery,
      TError = unknown
    >(
      variables: AdminAnalyticsWritingTimeQueryVariables,
      options?: Omit<UseQueryOptions<AdminAnalyticsWritingTimeQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<AdminAnalyticsWritingTimeQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<AdminAnalyticsWritingTimeQuery, TError, TData>(
      {
    queryKey: ['adminAnalyticsWritingTime', variables],
    queryFn: useCustomFetcher<AdminAnalyticsWritingTimeQuery, AdminAnalyticsWritingTimeQueryVariables>(AdminAnalyticsWritingTimeDocument).bind(null, variables),
    ...options
  }
    )};

export const BcbaCommentsDistributionRawDataDocument = `
    query bcbaCommentsDistributionRawData($fromDate: Date!, $toDate: Date!, $offset: Int, $count: Int, $bcbaProviderIds: [ID], $learnerIds: [ID]) {
  bcbaCommentsDistributionRawData(
    fromDate: $fromDate
    toDate: $toDate
    offset: $offset
    count: $count
    bcbaProviderIds: $bcbaProviderIds
    learnerIds: $learnerIds
  ) {
    totalRecordsCount
    rawData {
      clientId
      clientName
      sessionDate
      sessionDatetime
      sessionDuration
      totalComments
      bcbaName
      commentTypeCounts {
        love
        praise
        question
        feedback
        totalComments
      }
    }
  }
}
    `;

export const useBcbaCommentsDistributionRawDataQuery = <
      TData = BcbaCommentsDistributionRawDataQuery,
      TError = unknown
    >(
      variables: BcbaCommentsDistributionRawDataQueryVariables,
      options?: Omit<UseQueryOptions<BcbaCommentsDistributionRawDataQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<BcbaCommentsDistributionRawDataQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<BcbaCommentsDistributionRawDataQuery, TError, TData>(
      {
    queryKey: ['bcbaCommentsDistributionRawData', variables],
    queryFn: useCustomFetcher<BcbaCommentsDistributionRawDataQuery, BcbaCommentsDistributionRawDataQueryVariables>(BcbaCommentsDistributionRawDataDocument).bind(null, variables),
    ...options
  }
    )};

export const ReviewCompletionTimeRawDataDocument = `
    query reviewCompletionTimeRawData($bcbaProviderIds: [ID], $learnerIds: [ID], $fromDate: Date!, $toDate: Date!, $offset: Int, $count: Int) {
  reviewCompletionTimeRawData(
    fromDate: $fromDate
    toDate: $toDate
    offset: $offset
    count: $count
    bcbaProviderIds: $bcbaProviderIds
    learnerIds: $learnerIds
  ) {
    totalRecordsCount
    rawData {
      clientId
      clientName
      sessionDate
      sessionDatetime
      sessionRecordedBy
      readyForReviewAt
      reviewedAt
      sessionViewedByBcba
      reviewCompletionTimeInSeconds
    }
  }
}
    `;

export const useReviewCompletionTimeRawDataQuery = <
      TData = ReviewCompletionTimeRawDataQuery,
      TError = unknown
    >(
      variables: ReviewCompletionTimeRawDataQueryVariables,
      options?: Omit<UseQueryOptions<ReviewCompletionTimeRawDataQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<ReviewCompletionTimeRawDataQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<ReviewCompletionTimeRawDataQuery, TError, TData>(
      {
    queryKey: ['reviewCompletionTimeRawData', variables],
    queryFn: useCustomFetcher<ReviewCompletionTimeRawDataQuery, ReviewCompletionTimeRawDataQueryVariables>(ReviewCompletionTimeRawDataDocument).bind(null, variables),
    ...options
  }
    )};

export const BcbaResponsesToRbtQuestionsRawDataDocument = `
    query bcbaResponsesToRbtQuestionsRawData($fromDate: Date!, $toDate: Date!, $offset: Int, $bcbaProviderIds: [ID], $learnerIds: [ID], $count: Int, $forResponseRate: Boolean) {
  bcbaResponsesToRbtQuestionsRawData(
    fromDate: $fromDate
    toDate: $toDate
    offset: $offset
    count: $count
    bcbaProviderIds: $bcbaProviderIds
    learnerIds: $learnerIds
    forResponseRate: $forResponseRate
  ) {
    totalRecordsCount
    rawData {
      commentId
      rbtName
      questionAskedAt
      respondedOn
      responseTimeInSeconds
      bcbaName
    }
  }
}
    `;

export const useBcbaResponsesToRbtQuestionsRawDataQuery = <
      TData = BcbaResponsesToRbtQuestionsRawDataQuery,
      TError = unknown
    >(
      variables: BcbaResponsesToRbtQuestionsRawDataQueryVariables,
      options?: Omit<UseQueryOptions<BcbaResponsesToRbtQuestionsRawDataQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<BcbaResponsesToRbtQuestionsRawDataQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<BcbaResponsesToRbtQuestionsRawDataQuery, TError, TData>(
      {
    queryKey: ['bcbaResponsesToRbtQuestionsRawData', variables],
    queryFn: useCustomFetcher<BcbaResponsesToRbtQuestionsRawDataQuery, BcbaResponsesToRbtQuestionsRawDataQueryVariables>(BcbaResponsesToRbtQuestionsRawDataDocument).bind(null, variables),
    ...options
  }
    )};

export const BcbaSessionVideosAnalyticsDocument = `
    query bcbaSessionVideosAnalytics($fromDate: Date!, $toDate: Date!, $comparisonFromDate: Date, $comparisonToDate: Date, $bcbaProviderIds: [ID!]) {
  bcbaSessionVideosAnalytics(
    fromDate: $fromDate
    toDate: $toDate
    comparisonFromDate: $comparisonFromDate
    comparisonToDate: $comparisonToDate
    bcbaProviderIds: $bcbaProviderIds
  ) {
    currentData {
      totalVideosCount
      averageSessionsReviewedByBcba
      videosReviewedPercentage
      averageResponseTimeToRbtQuestions
      averageResponseRateToRbtQuestions
      averageCommentLeftByBcbaPerVideo
      averageReviewCompletionTime
      commentsData {
        love
        praise
        feedback
        question
        totalComments
      }
    }
    comparisonData {
      totalVideosCount
      averageSessionsReviewedByBcba
      videosReviewedPercentage
      averageResponseTimeToRbtQuestions
      averageResponseRateToRbtQuestions
      averageCommentLeftByBcbaPerVideo
      averageReviewCompletionTime
      commentsData {
        love
        praise
        feedback
        question
        totalComments
      }
    }
  }
}
    `;

export const useBcbaSessionVideosAnalyticsQuery = <
      TData = BcbaSessionVideosAnalyticsQuery,
      TError = unknown
    >(
      variables: BcbaSessionVideosAnalyticsQueryVariables,
      options?: Omit<UseQueryOptions<BcbaSessionVideosAnalyticsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<BcbaSessionVideosAnalyticsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<BcbaSessionVideosAnalyticsQuery, TError, TData>(
      {
    queryKey: ['bcbaSessionVideosAnalytics', variables],
    queryFn: useCustomFetcher<BcbaSessionVideosAnalyticsQuery, BcbaSessionVideosAnalyticsQueryVariables>(BcbaSessionVideosAnalyticsDocument).bind(null, variables),
    ...options
  }
    )};

export const BcbaVideosReviewedRawDataDocument = `
    query bcbaVideosReviewedRawData($fromDate: Date!, $toDate: Date!, $offset: Int, $bcbaProviderIds: [ID], $learnerIds: [ID], $count: Int, $avgVideosReviewed: Boolean) {
  videosReviewedRawData(
    fromDate: $fromDate
    toDate: $toDate
    offset: $offset
    count: $count
    bcbaProviderIds: $bcbaProviderIds
    learnerIds: $learnerIds
    avgVideosReviewed: $avgVideosReviewed
  ) {
    totalRecordsCount
    rawData {
      clientId
      clientName
      totalVideos
      videosReviewed
      percentReviewed
      sessionViewedBy
    }
  }
}
    `;

export const useBcbaVideosReviewedRawDataQuery = <
      TData = BcbaVideosReviewedRawDataQuery,
      TError = unknown
    >(
      variables: BcbaVideosReviewedRawDataQueryVariables,
      options?: Omit<UseQueryOptions<BcbaVideosReviewedRawDataQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<BcbaVideosReviewedRawDataQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<BcbaVideosReviewedRawDataQuery, TError, TData>(
      {
    queryKey: ['bcbaVideosReviewedRawData', variables],
    queryFn: useCustomFetcher<BcbaVideosReviewedRawDataQuery, BcbaVideosReviewedRawDataQueryVariables>(BcbaVideosReviewedRawDataDocument).bind(null, variables),
    ...options
  }
    )};

export const GetProviderListByRoleDocument = `
    query getProviderListByRole($roles: [RolesEnum]!) {
  getProviderListByRole(roles: $roles) {
    totalCount
    edges {
      node {
        id
        providermetadata {
          firstName
          lastName
        }
        organizationuserrolesSet {
          edges {
            node {
              role
            }
          }
        }
      }
    }
  }
}
    `;

export const useGetProviderListByRoleQuery = <
      TData = GetProviderListByRoleQuery,
      TError = unknown
    >(
      variables: GetProviderListByRoleQueryVariables,
      options?: Omit<UseQueryOptions<GetProviderListByRoleQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetProviderListByRoleQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetProviderListByRoleQuery, TError, TData>(
      {
    queryKey: ['getProviderListByRole', variables],
    queryFn: useCustomFetcher<GetProviderListByRoleQuery, GetProviderListByRoleQueryVariables>(GetProviderListByRoleDocument).bind(null, variables),
    ...options
  }
    )};

export const GetQuestionsAskedByRbtRawDataDocument = `
    query getQuestionsAskedByRbtRawData($fromDate: Date!, $toDate: Date!, $offset: Int, $rbtProviderIds: [ID], $learnerIds: [ID], $count: Int) {
  getQuestionsAskedByRbtRawData(
    fromDate: $fromDate
    toDate: $toDate
    offset: $offset
    count: $count
    learnerIds: $learnerIds
    rbtProviderIds: $rbtProviderIds
  ) {
    totalRecordsCount
    rawData {
      rbtName
      sessionDate
      sessionDatetime
      sessionDuration
      totalQuestionsAsked
    }
  }
}
    `;

export const useGetQuestionsAskedByRbtRawDataQuery = <
      TData = GetQuestionsAskedByRbtRawDataQuery,
      TError = unknown
    >(
      variables: GetQuestionsAskedByRbtRawDataQueryVariables,
      options?: Omit<UseQueryOptions<GetQuestionsAskedByRbtRawDataQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetQuestionsAskedByRbtRawDataQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetQuestionsAskedByRbtRawDataQuery, TError, TData>(
      {
    queryKey: ['getQuestionsAskedByRbtRawData', variables],
    queryFn: useCustomFetcher<GetQuestionsAskedByRbtRawDataQuery, GetQuestionsAskedByRbtRawDataQueryVariables>(GetQuestionsAskedByRbtRawDataDocument).bind(null, variables),
    ...options
  }
    )};

export const GetRbtVideoUploadTimeRawDataDocument = `
    query getRbtVideoUploadTimeRawData($fromDate: Date!, $toDate: Date!, $offset: Int, $rbtProviderIds: [ID], $learnerIds: [ID], $count: Int) {
  getRbtVideoUploadTimeRawData(
    fromDate: $fromDate
    toDate: $toDate
    offset: $offset
    count: $count
    learnerIds: $learnerIds
    rbtProviderIds: $rbtProviderIds
  ) {
    totalRecordsCount
    rawData {
      rbtName
      sessionDate
      sessionDatetime
      sessionDuration
      uploadCompletionTimeInSeconds
    }
  }
}
    `;

export const useGetRbtVideoUploadTimeRawDataQuery = <
      TData = GetRbtVideoUploadTimeRawDataQuery,
      TError = unknown
    >(
      variables: GetRbtVideoUploadTimeRawDataQueryVariables,
      options?: Omit<UseQueryOptions<GetRbtVideoUploadTimeRawDataQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetRbtVideoUploadTimeRawDataQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetRbtVideoUploadTimeRawDataQuery, TError, TData>(
      {
    queryKey: ['getRbtVideoUploadTimeRawData', variables],
    queryFn: useCustomFetcher<GetRbtVideoUploadTimeRawDataQuery, GetRbtVideoUploadTimeRawDataQueryVariables>(GetRbtVideoUploadTimeRawDataDocument).bind(null, variables),
    ...options
  }
    )};

export const GetRecordedVideoDistributionRawDataDocument = `
    query getRecordedVideoDistributionRawData($fromDate: Date!, $toDate: Date!, $offset: Int, $rbtProviderIds: [ID], $learnerIds: [ID], $count: Int) {
  getRecordedVideoDistributionRawData(
    fromDate: $fromDate
    toDate: $toDate
    offset: $offset
    count: $count
    learnerIds: $learnerIds
    rbtProviderIds: $rbtProviderIds
  ) {
    totalRecordsCount
    rawData {
      clientId
      clientName
      rbtName
      uploadingVideosCount
      scheduledVideosCount
      processingVideosCount
      failedVideosCount
      completedVideosCount
      totalVideosRecorded
    }
  }
}
    `;

export const useGetRecordedVideoDistributionRawDataQuery = <
      TData = GetRecordedVideoDistributionRawDataQuery,
      TError = unknown
    >(
      variables: GetRecordedVideoDistributionRawDataQueryVariables,
      options?: Omit<UseQueryOptions<GetRecordedVideoDistributionRawDataQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetRecordedVideoDistributionRawDataQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetRecordedVideoDistributionRawDataQuery, TError, TData>(
      {
    queryKey: ['getRecordedVideoDistributionRawData', variables],
    queryFn: useCustomFetcher<GetRecordedVideoDistributionRawDataQuery, GetRecordedVideoDistributionRawDataQueryVariables>(GetRecordedVideoDistributionRawDataDocument).bind(null, variables),
    ...options
  }
    )};

export const GetTotalVideoDurationRawDataDocument = `
    query getTotalVideoDurationRawData($fromDate: Date!, $toDate: Date!, $offset: Int, $rbtProviderIds: [ID], $learnerIds: [ID], $count: Int) {
  getTotalVideoDurationRawData(
    fromDate: $fromDate
    toDate: $toDate
    offset: $offset
    count: $count
    learnerIds: $learnerIds
    rbtProviderIds: $rbtProviderIds
  ) {
    totalRecordsCount
    rawData {
      clientId
      clientName
      sessionDate
      sessionDatetime
      sessionDurationInSeconds
      rbtName
    }
  }
}
    `;

export const useGetTotalVideoDurationRawDataQuery = <
      TData = GetTotalVideoDurationRawDataQuery,
      TError = unknown
    >(
      variables: GetTotalVideoDurationRawDataQueryVariables,
      options?: Omit<UseQueryOptions<GetTotalVideoDurationRawDataQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetTotalVideoDurationRawDataQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetTotalVideoDurationRawDataQuery, TError, TData>(
      {
    queryKey: ['getTotalVideoDurationRawData', variables],
    queryFn: useCustomFetcher<GetTotalVideoDurationRawDataQuery, GetTotalVideoDurationRawDataQueryVariables>(GetTotalVideoDurationRawDataDocument).bind(null, variables),
    ...options
  }
    )};

export const GetVideoCommentsReceivedByRbtRawDataDocument = `
    query getVideoCommentsReceivedByRbtRawData($fromDate: Date!, $toDate: Date!, $offset: Int, $rbtProviderIds: [ID], $learnerIds: [ID], $count: Int) {
  getVideoCommentsReceivedByRbtRawData(
    fromDate: $fromDate
    toDate: $toDate
    offset: $offset
    count: $count
    learnerIds: $learnerIds
    rbtProviderIds: $rbtProviderIds
  ) {
    totalRecordsCount
    rawData {
      clientId
      clientName
      sessionDate
      sessionDatetime
      sessionDuration
      totalComments
      rbtName
      commentTypeCounts {
        love
        praise
        question
        feedback
        totalComments
      }
    }
  }
}
    `;

export const useGetVideoCommentsReceivedByRbtRawDataQuery = <
      TData = GetVideoCommentsReceivedByRbtRawDataQuery,
      TError = unknown
    >(
      variables: GetVideoCommentsReceivedByRbtRawDataQueryVariables,
      options?: Omit<UseQueryOptions<GetVideoCommentsReceivedByRbtRawDataQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetVideoCommentsReceivedByRbtRawDataQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetVideoCommentsReceivedByRbtRawDataQuery, TError, TData>(
      {
    queryKey: ['getVideoCommentsReceivedByRbtRawData', variables],
    queryFn: useCustomFetcher<GetVideoCommentsReceivedByRbtRawDataQuery, GetVideoCommentsReceivedByRbtRawDataQueryVariables>(GetVideoCommentsReceivedByRbtRawDataDocument).bind(null, variables),
    ...options
  }
    )};

export const RbtResponsesToBcbaQuestionsRawDataDocument = `
    query rbtResponsesToBcbaQuestionsRawData($fromDate: Date!, $toDate: Date!, $offset: Int, $rbtProviderIds: [ID], $learnerIds: [ID], $count: Int, $forResponseRate: Boolean) {
  rbtResponsesToBcbaQuestionsRawData(
    fromDate: $fromDate
    toDate: $toDate
    offset: $offset
    count: $count
    learnerIds: $learnerIds
    rbtProviderIds: $rbtProviderIds
    forResponseRate: $forResponseRate
  ) {
    totalRecordsCount
    rawData {
      commentId
      bcbaName
      questionAskedAt
      respondedOn
      responseTimeInSeconds
      rbtName
    }
  }
}
    `;

export const useRbtResponsesToBcbaQuestionsRawDataQuery = <
      TData = RbtResponsesToBcbaQuestionsRawDataQuery,
      TError = unknown
    >(
      variables: RbtResponsesToBcbaQuestionsRawDataQueryVariables,
      options?: Omit<UseQueryOptions<RbtResponsesToBcbaQuestionsRawDataQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<RbtResponsesToBcbaQuestionsRawDataQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<RbtResponsesToBcbaQuestionsRawDataQuery, TError, TData>(
      {
    queryKey: ['rbtResponsesToBcbaQuestionsRawData', variables],
    queryFn: useCustomFetcher<RbtResponsesToBcbaQuestionsRawDataQuery, RbtResponsesToBcbaQuestionsRawDataQueryVariables>(RbtResponsesToBcbaQuestionsRawDataDocument).bind(null, variables),
    ...options
  }
    )};

export const RbtSessionVideosAnalyticsDocument = `
    query rbtSessionVideosAnalytics($fromDate: Date!, $toDate: Date!, $comparisonFromDate: Date, $comparisonToDate: Date, $rbtIds: [ID]) {
  rbtSessionVideosAnalytics(
    fromDate: $fromDate
    toDate: $toDate
    comparisonFromDate: $comparisonFromDate
    comparisonToDate: $comparisonToDate
    rbtProviderIds: $rbtIds
  ) {
    currentData {
      totalSessionsRecorded
      videoRecordingsDurationInSeconds
      sessionsStateDistribution {
        uploading
        scheduled
        processing
        failed
        completed
        totalSessionsRecorded
      }
      averageVideoUploadTime
      averageResponseTimeToBcbaQuestions
      averageResponseRateToBcbaQuestions
      averageQuestionAskedPerVideo
      averageCommentsReceivedPerVideo
      receivedCommentsDistributionCount {
        love
        praise
        feedback
        question
        totalComments
      }
    }
    comparisonData {
      totalSessionsRecorded
      videoRecordingsDurationInSeconds
      sessionsStateDistribution {
        uploading
        scheduled
        processing
        failed
        completed
        totalSessionsRecorded
      }
      averageVideoUploadTime
      averageResponseTimeToBcbaQuestions
      averageResponseRateToBcbaQuestions
      averageQuestionAskedPerVideo
      averageCommentsReceivedPerVideo
      receivedCommentsDistributionCount {
        love
        praise
        feedback
        question
        totalComments
      }
    }
  }
}
    `;

export const useRbtSessionVideosAnalyticsQuery = <
      TData = RbtSessionVideosAnalyticsQuery,
      TError = unknown
    >(
      variables: RbtSessionVideosAnalyticsQueryVariables,
      options?: Omit<UseQueryOptions<RbtSessionVideosAnalyticsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<RbtSessionVideosAnalyticsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<RbtSessionVideosAnalyticsQuery, TError, TData>(
      {
    queryKey: ['rbtSessionVideosAnalytics', variables],
    queryFn: useCustomFetcher<RbtSessionVideosAnalyticsQuery, RbtSessionVideosAnalyticsQueryVariables>(RbtSessionVideosAnalyticsDocument).bind(null, variables),
    ...options
  }
    )};

export const CaregiverByIdDocument = `
    query caregiverById($caregiverId: ID!) {
  caregiverById(caregiverId: $caregiverId) {
    id
    caregivermetadata {
      firstName
      lastName
      email
      phoneNumber1
      appActivationCode
      appActivationCodeUsedAt
      appActivationEligible
      activationCodeEmailLastSendDate
      activationCodeSmsLastSendDate
    }
    relationshipSet {
      edges {
        node {
          isPrimary
          relationship
          relationshipLearner {
            id
            learnermetadata {
              firstName
              lastName
              birthDate
            }
            learnerproviderSet {
              edges {
                node {
                  provider {
                    id
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
    `;

export const useCaregiverByIdQuery = <
      TData = CaregiverByIdQuery,
      TError = unknown
    >(
      variables: CaregiverByIdQueryVariables,
      options?: Omit<UseQueryOptions<CaregiverByIdQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<CaregiverByIdQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<CaregiverByIdQuery, TError, TData>(
      {
    queryKey: ['caregiverById', variables],
    queryFn: useCustomFetcher<CaregiverByIdQuery, CaregiverByIdQueryVariables>(CaregiverByIdDocument).bind(null, variables),
    ...options
  }
    )};

export const GetCaregiversDataDocument = `
    query getCaregiversData($first: Int, $after: String, $filter: CaregiversFilter) {
  caregivers(first: $first, after: $after, filter: $filter) {
    totalCount
    pageInfo {
      hasNextPage
      endCursor
    }
    edges {
      node {
        id
        caregivermetadata {
          id
          firstName
          lastName
          email
          phoneNumber1
          nearestLocation
          referralSource
          smsAgreement
          appActivationCode
          appActivationCodeUsedAt
          appActivationEligible
          activationCodeEmailLastSendDate
          activationCodeSmsLastSendDate
        }
        relationshipSet {
          edges {
            node {
              isPrimary
              relationship
              relationshipLearner {
                id
                learnermetadata {
                  firstName
                  lastName
                  birthDate
                }
                learnerproviderSet {
                  edges {
                    node {
                      provider {
                        id
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
    `;

export const useGetCaregiversDataQuery = <
      TData = GetCaregiversDataQuery,
      TError = unknown
    >(
      variables?: GetCaregiversDataQueryVariables,
      options?: Omit<UseQueryOptions<GetCaregiversDataQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetCaregiversDataQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetCaregiversDataQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['getCaregiversData'] : ['getCaregiversData', variables],
    queryFn: useCustomFetcher<GetCaregiversDataQuery, GetCaregiversDataQueryVariables>(GetCaregiversDataDocument).bind(null, variables),
    ...options
  }
    )};

export const GetLoginCaregiverDocument = `
    query getLoginCaregiver {
  getLoginCaregiver {
    id
    hasEnteredVideoCaptureApp
    caregivermetadata {
      id
      firstName
      lastName
      email
    }
  }
}
    `;

export const useGetLoginCaregiverQuery = <
      TData = GetLoginCaregiverQuery,
      TError = unknown
    >(
      variables?: GetLoginCaregiverQueryVariables,
      options?: Omit<UseQueryOptions<GetLoginCaregiverQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetLoginCaregiverQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetLoginCaregiverQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['getLoginCaregiver'] : ['getLoginCaregiver', variables],
    queryFn: useCustomFetcher<GetLoginCaregiverQuery, GetLoginCaregiverQueryVariables>(GetLoginCaregiverDocument).bind(null, variables),
    ...options
  }
    )};

export const GetAssignedChatTagsDocument = `
    query getAssignedChatTags($chatId: ID!) {
  assignedChatTags(chatId: $chatId) {
    edges {
      node {
        id
        name
      }
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
    totalCount
  }
}
    `;

export const useGetAssignedChatTagsQuery = <
      TData = GetAssignedChatTagsQuery,
      TError = unknown
    >(
      variables: GetAssignedChatTagsQueryVariables,
      options?: Omit<UseQueryOptions<GetAssignedChatTagsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetAssignedChatTagsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetAssignedChatTagsQuery, TError, TData>(
      {
    queryKey: ['getAssignedChatTags', variables],
    queryFn: useCustomFetcher<GetAssignedChatTagsQuery, GetAssignedChatTagsQueryVariables>(GetAssignedChatTagsDocument).bind(null, variables),
    ...options
  }
    )};

export const GetBillingChatMembersDocument = `
    query getBillingChatMembers {
  chatMembers(active: true) {
    edges {
      node {
        id
        chat {
          id
          type
          status
          summary
          summaryStatus
          clinicianSummary
          clinicianSummaryStatus
          createdDate
          lastUpdatedDate
          chatTasks {
            edges {
              node {
                id
                title
                status
              }
            }
          }
          learner {
            id
            learnermetadata {
              firstName
              lastName
            }
            relationshipSet {
              edges {
                node {
                  id
                  relationship
                  socialRelationship
                  isPrimary
                  caregiver {
                    id
                    caregivermetadata {
                      firstName
                      lastName
                    }
                  }
                }
              }
            }
          }
          user {
            userBillingDetails {
              edges {
                node {
                  id
                  paymentStatus
                  paymentMethodId
                  paymentIntentId
                  description
                  amount
                }
              }
            }
          }
        }
      }
    }
  }
}
    `;

export const useGetBillingChatMembersQuery = <
      TData = GetBillingChatMembersQuery,
      TError = unknown
    >(
      variables?: GetBillingChatMembersQueryVariables,
      options?: Omit<UseQueryOptions<GetBillingChatMembersQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetBillingChatMembersQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetBillingChatMembersQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['getBillingChatMembers'] : ['getBillingChatMembers', variables],
    queryFn: useCustomFetcher<GetBillingChatMembersQuery, GetBillingChatMembersQueryVariables>(GetBillingChatMembersDocument).bind(null, variables),
    ...options
  }
    )};

export const GetChatMediaDocument = `
    query getChatMedia($chatId: ID!, $attachmentKind: ChatAttachmentKindEnum) {
  chatMessages(
    chatId: $chatId
    attachmentKind: $attachmentKind
    sortBy: CREATED_DATE_DESC
  ) {
    edges {
      node {
        id
        content
        createdDate
        userFirstName
        userLastName
        media {
          id
          videoUploadStatus
          thumbnailUrl
        }
        file {
          id
          originalFileName
          mimeType
          signedS3LearnerFile
        }
      }
    }
    totalCount
  }
}
    `;

export const useGetChatMediaQuery = <
      TData = GetChatMediaQuery,
      TError = unknown
    >(
      variables: GetChatMediaQueryVariables,
      options?: Omit<UseQueryOptions<GetChatMediaQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetChatMediaQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetChatMediaQuery, TError, TData>(
      {
    queryKey: ['getChatMedia', variables],
    queryFn: useCustomFetcher<GetChatMediaQuery, GetChatMediaQueryVariables>(GetChatMediaDocument).bind(null, variables),
    ...options
  }
    )};

export const GetChatMessagesDocument = `
    query getChatMessages($chatId: ID!) {
  chatMessages(chatId: $chatId) {
    edges {
      node {
        id
        content
        role
        createdDate
        readAt
        edited
        archived
        user {
          id
          username
          email
          auth0id
        }
        userFirstName
        userLastName
        readBy {
          id
        }
        media {
          id
          videoUploadStatus
          thumbnailUrl
          commentsCount
          createdBy {
            id
          }
        }
        mediaComment {
          id
          mediaStartTime
          author {
            id
            auth0id
          }
          media {
            id
            createdBy {
              id
              auth0id
            }
          }
          parentComment {
            id
            author {
              id
              auth0id
            }
          }
        }
        file {
          id
          originalFileName
          mimeType
          fileSize
          signedS3LearnerFile
        }
        chat {
          learner {
            id
            relationshipSet {
              edges {
                node {
                  id
                  relationship
                  socialRelationship
                  isPrimary
                  caregiver {
                    id
                    caregivermetadata {
                      firstName
                      lastName
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
    totalCount
  }
}
    `;

export const useGetChatMessagesQuery = <
      TData = GetChatMessagesQuery,
      TError = unknown
    >(
      variables: GetChatMessagesQueryVariables,
      options?: Omit<UseQueryOptions<GetChatMessagesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetChatMessagesQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetChatMessagesQuery, TError, TData>(
      {
    queryKey: ['getChatMessages', variables],
    queryFn: useCustomFetcher<GetChatMessagesQuery, GetChatMessagesQueryVariables>(GetChatMessagesDocument).bind(null, variables),
    ...options
  }
    )};

export const GetChatNotesDocument = `
    query getChatNotes($chatId: ID!) {
  chatNotes(chatId: $chatId) {
    edges {
      node {
        id
        createdDate
        content
        user {
          auth0id
          provider {
            id
            providermetadata {
              firstName
              lastName
            }
          }
        }
      }
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
    totalCount
  }
}
    `;

export const useGetChatNotesQuery = <
      TData = GetChatNotesQuery,
      TError = unknown
    >(
      variables: GetChatNotesQueryVariables,
      options?: Omit<UseQueryOptions<GetChatNotesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetChatNotesQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetChatNotesQuery, TError, TData>(
      {
    queryKey: ['getChatNotes', variables],
    queryFn: useCustomFetcher<GetChatNotesQuery, GetChatNotesQueryVariables>(GetChatNotesDocument).bind(null, variables),
    ...options
  }
    )};

export const GetChatTagsDocument = `
    query getChatTags($filter: ChatTagsFilter!) {
  chatTags(filter: $filter) {
    edges {
      node {
        id
        name
      }
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
    totalCount
  }
}
    `;

export const useGetChatTagsQuery = <
      TData = GetChatTagsQuery,
      TError = unknown
    >(
      variables: GetChatTagsQueryVariables,
      options?: Omit<UseQueryOptions<GetChatTagsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetChatTagsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetChatTagsQuery, TError, TData>(
      {
    queryKey: ['getChatTags', variables],
    queryFn: useCustomFetcher<GetChatTagsQuery, GetChatTagsQueryVariables>(GetChatTagsDocument).bind(null, variables),
    ...options
  }
    )};

export const GetExpertChatMembersDocument = `
    query getExpertChatMembers($filter: ChatsFilter, $offset: Int, $before: String, $after: String, $first: Int, $last: Int) {
  chatMembers(
    active: true
    filter: $filter
    offset: $offset
    before: $before
    after: $after
    first: $first
    last: $last
  ) {
    edges {
      node {
        id
        chat {
          id
          type
          status
          summary
          summaryStatus
          clinicianSummary
          clinicianSummaryStatus
          createdDate
          lastUpdatedDate
          needsReview
          isUnread
          history
          careStage
          messageDraft
          lastMessage {
            id
            createdDate
            content
            readAt
            role
            file {
              id
            }
            user {
              id
              auth0id
              username
            }
          }
          learner {
            id
            learnermetadata {
              firstName
              lastName
              birthDate
              city
              state
            }
            relationshipSet {
              edges {
                node {
                  id
                  relationship
                  socialRelationship
                  isPrimary
                  caregiver {
                    id
                    auth0User {
                      auth0id
                    }
                    caregivermetadata {
                      firstName
                      lastName
                      email
                      city
                      state
                      careStage
                    }
                  }
                  organization {
                    id
                  }
                }
              }
            }
          }
          members {
            edges {
              node {
                member {
                  id
                  auth0id
                  provider {
                    id
                    providermetadata {
                      firstName
                      lastName
                    }
                  }
                }
                memberOrg {
                  id
                }
              }
            }
          }
        }
      }
    }
    pageInfo {
      hasNextPage
      endCursor
    }
  }
}
    `;

export const useGetExpertChatMembersQuery = <
      TData = GetExpertChatMembersQuery,
      TError = unknown
    >(
      variables?: GetExpertChatMembersQueryVariables,
      options?: Omit<UseQueryOptions<GetExpertChatMembersQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetExpertChatMembersQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetExpertChatMembersQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['getExpertChatMembers'] : ['getExpertChatMembers', variables],
    queryFn: useCustomFetcher<GetExpertChatMembersQuery, GetExpertChatMembersQueryVariables>(GetExpertChatMembersDocument).bind(null, variables),
    ...options
  }
    )};

export const GetClinicLeadsDocument = `
    query getClinicLeads($first: Int, $after: String, $filter: ClinicLeadFilter!) {
  clinicLeads(first: $first, after: $after, filter: $filter) {
    totalCount
    pageInfo {
      endCursor
      hasNextPage
    }
    edges {
      cursor
      node {
        id
        createdDate
        requestedServiceTypes
        requestedModalityTypes
        payor
        learner {
          id
          learnermetadata {
            id
            firstName
            lastName
            birthDate
          }
        }
        caregiver {
          caregivermetadata {
            firstName
            lastName
            city
            state
            zip
            phoneNumber1
            email
          }
        }
      }
    }
  }
}
    `;

export const useGetClinicLeadsQuery = <
      TData = GetClinicLeadsQuery,
      TError = unknown
    >(
      variables: GetClinicLeadsQueryVariables,
      options?: Omit<UseQueryOptions<GetClinicLeadsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetClinicLeadsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetClinicLeadsQuery, TError, TData>(
      {
    queryKey: ['getClinicLeads', variables],
    queryFn: useCustomFetcher<GetClinicLeadsQuery, GetClinicLeadsQueryVariables>(GetClinicLeadsDocument).bind(null, variables),
    ...options
  }
    )};

export const ClinicListingsDocument = `
    query clinicListings($filter: ClinicListingSearchFilter!) {
  clinicListings(filter: $filter) {
    totalCount
    pageInfo {
      endCursor
      hasNextPage
    }
    edges {
      cursor
      node {
        id
        name
        createdDate
        payors
        location {
          addressLine1
          addressLine2
          city
          state
          postalCode
        }
      }
    }
  }
}
    `;

export const useClinicListingsQuery = <
      TData = ClinicListingsQuery,
      TError = unknown
    >(
      variables: ClinicListingsQueryVariables,
      options?: Omit<UseQueryOptions<ClinicListingsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<ClinicListingsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<ClinicListingsQuery, TError, TData>(
      {
    queryKey: ['clinicListings', variables],
    queryFn: useCustomFetcher<ClinicListingsQuery, ClinicListingsQueryVariables>(ClinicListingsDocument).bind(null, variables),
    ...options
  }
    )};

export const GetClinicsDocument = `
    query getClinics($clinicId: ID, $first: Int, $after: String, $name: String) {
  clinics(id: $clinicId, first: $first, after: $after, name: $name) {
    totalCount
    pageInfo {
      endCursor
      hasNextPage
    }
    edges {
      cursor
      node {
        id
        name
        createdDate
        location {
          addressLine1
          addressLine2
          city
          state
          postalCode
        }
        cliniclistingSet {
          edges {
            node {
              id
              publicId
              websiteUrl
              verificationStatus
              phoneNumber
              contactEmail
              description
              modalityTypes
              payors
              servicesOffered
              createdDate
              lastUpdatedDate
            }
          }
        }
      }
    }
  }
}
    `;

export const useGetClinicsQuery = <
      TData = GetClinicsQuery,
      TError = unknown
    >(
      variables?: GetClinicsQueryVariables,
      options?: Omit<UseQueryOptions<GetClinicsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetClinicsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetClinicsQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['getClinics'] : ['getClinics', variables],
    queryFn: useCustomFetcher<GetClinicsQuery, GetClinicsQueryVariables>(GetClinicsDocument).bind(null, variables),
    ...options
  }
    )};

export const DownloadableTemplatesDocument = `
    query downloadableTemplates {
  downloadableTemplates {
    key
    assessment
    name
    officialFileLink
    fronteraFileLink
  }
}
    `;

export const useDownloadableTemplatesQuery = <
      TData = DownloadableTemplatesQuery,
      TError = unknown
    >(
      variables?: DownloadableTemplatesQueryVariables,
      options?: Omit<UseQueryOptions<DownloadableTemplatesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<DownloadableTemplatesQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<DownloadableTemplatesQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['downloadableTemplates'] : ['downloadableTemplates', variables],
    queryFn: useCustomFetcher<DownloadableTemplatesQuery, DownloadableTemplatesQueryVariables>(DownloadableTemplatesDocument).bind(null, variables),
    ...options
  }
    )};

export const CrLearningTreeDocument = `
    query crLearningTree($learnerId: ID!, $reportId: ID) {
  crLearningTree(learnerId: $learnerId, reportId: $reportId) {
    learningTreeId
    status
    nodes {
      externalId
      parentExternalId
      name
      nodeType
      dataType
      dataTypeLabel
      progressType
      hasGoal
      isBehavior
      crStatus
      crLevel
      sortOrder
      removed
      suggestedRole
      ruleRole
      approvedIn
      goalApprovedIn
      usedIn
      role
      roleSource
      confirmKind
      confirmAnswered
      locked
      status
      movedInCr
      goalExternalId
    }
    checks {
      externalId
      level
      code
      message
    }
    importedNotInTree {
      externalId
      name
      role
    }
    reportChanges {
      reportId
      label
      changes {
        externalId
        kind
        name
        fromGoalName
        toGoalName
        approved
      }
    }
  }
}
    `;

export const useCrLearningTreeQuery = <
      TData = CrLearningTreeQuery,
      TError = unknown
    >(
      variables: CrLearningTreeQueryVariables,
      options?: Omit<UseQueryOptions<CrLearningTreeQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<CrLearningTreeQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<CrLearningTreeQuery, TError, TData>(
      {
    queryKey: ['crLearningTree', variables],
    queryFn: useCustomFetcher<CrLearningTreeQuery, CrLearningTreeQueryVariables>(CrLearningTreeDocument).bind(null, variables),
    ...options
  }
    )};

export const EhrConnectionDocument = `
    query ehrConnection {
  ehrConnection {
    status
  }
}
    `;

export const useEhrConnectionQuery = <
      TData = EhrConnectionQuery,
      TError = unknown
    >(
      variables?: EhrConnectionQueryVariables,
      options?: Omit<UseQueryOptions<EhrConnectionQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<EhrConnectionQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<EhrConnectionQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['ehrConnection'] : ['ehrConnection', variables],
    queryFn: useCustomFetcher<EhrConnectionQuery, EhrConnectionQueryVariables>(EhrConnectionDocument).bind(null, variables),
    ...options
  }
    )};

export const GetEhrClientImportStatusDocument = `
    query getEhrClientImportStatus($learnerExternalId: String!) {
  getEhrClientImportStatus(externalLearnerId: $learnerExternalId) {
    status
    message
    leanerImportStatus {
      status
    }
  }
}
    `;

export const useGetEhrClientImportStatusQuery = <
      TData = GetEhrClientImportStatusQuery,
      TError = unknown
    >(
      variables: GetEhrClientImportStatusQueryVariables,
      options?: Omit<UseQueryOptions<GetEhrClientImportStatusQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetEhrClientImportStatusQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetEhrClientImportStatusQuery, TError, TData>(
      {
    queryKey: ['getEhrClientImportStatus', variables],
    queryFn: useCustomFetcher<GetEhrClientImportStatusQuery, GetEhrClientImportStatusQueryVariables>(GetEhrClientImportStatusDocument).bind(null, variables),
    ...options
  }
    )};

export const GetEhrLoginStatusDocument = `
    query getEHRLoginStatus {
  getLoginStatus {
    status
    message
    getLoginStatus {
      id
      status
      alert
      loginAttemptsExhausted
      provider {
        id
      }
      organization {
        id
      }
      scraperSessionWorkflow {
        id
        workflowTemporalId
      }
    }
  }
}
    `;

export const useGetEhrLoginStatusQuery = <
      TData = GetEhrLoginStatusQuery,
      TError = unknown
    >(
      variables?: GetEhrLoginStatusQueryVariables,
      options?: Omit<UseQueryOptions<GetEhrLoginStatusQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetEhrLoginStatusQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetEhrLoginStatusQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['getEHRLoginStatus'] : ['getEHRLoginStatus', variables],
    queryFn: useCustomFetcher<GetEhrLoginStatusQuery, GetEhrLoginStatusQueryVariables>(GetEhrLoginStatusDocument).bind(null, variables),
    ...options
  }
    )};

export const GetHasEhrCredentialsDocument = `
    query getHasEhrCredentials {
  hasEhrCredentials {
    hasCredentials
  }
}
    `;

export const useGetHasEhrCredentialsQuery = <
      TData = GetHasEhrCredentialsQuery,
      TError = unknown
    >(
      variables?: GetHasEhrCredentialsQueryVariables,
      options?: Omit<UseQueryOptions<GetHasEhrCredentialsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetHasEhrCredentialsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetHasEhrCredentialsQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['getHasEhrCredentials'] : ['getHasEhrCredentials', variables],
    queryFn: useCustomFetcher<GetHasEhrCredentialsQuery, GetHasEhrCredentialsQueryVariables>(GetHasEhrCredentialsDocument).bind(null, variables),
    ...options
  }
    )};

export const LearnerEhrProgrammingDocument = `
    query LearnerEhrProgramming($learnerId: ID!) {
  learnerEhrProgramming(learnerId: $learnerId) {
    organizationType
    goals {
      id
      name
      externalId
      createdDate
      lastUpdatedDate
      fields {
        ...EhrStoredFieldParts
      }
      collections {
        ...EhrChildCollectionParts
      }
      sessionSummary {
        ...EhrSessionDataSummaryParts
      }
      targets {
        id
        name
        externalId
        createdDate
        lastUpdatedDate
        fields {
          ...EhrStoredFieldParts
        }
        collections {
          ...EhrChildCollectionParts
        }
        sessionSummary {
          ...EhrSessionDataSummaryParts
        }
      }
    }
    unmatchedSessionSummary {
      ...EhrSessionDataSummaryParts
    }
  }
}
    ${EhrStoredFieldPartsFragmentDoc}
${EhrChildCollectionPartsFragmentDoc}
${EhrSessionDataSummaryPartsFragmentDoc}`;

export const useLearnerEhrProgrammingQuery = <
      TData = LearnerEhrProgrammingQuery,
      TError = unknown
    >(
      variables: LearnerEhrProgrammingQueryVariables,
      options?: Omit<UseQueryOptions<LearnerEhrProgrammingQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<LearnerEhrProgrammingQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<LearnerEhrProgrammingQuery, TError, TData>(
      {
    queryKey: ['LearnerEhrProgramming', variables],
    queryFn: useCustomFetcher<LearnerEhrProgrammingQuery, LearnerEhrProgrammingQueryVariables>(LearnerEhrProgrammingDocument).bind(null, variables),
    ...options
  }
    )};

export const LearnerEhrSessionDataDocument = `
    query LearnerEhrSessionData($learnerId: ID!, $targetId: ID, $goalId: ID, $unmatched: Boolean, $offset: Int, $limit: Int) {
  learnerEhrSessionData(
    learnerId: $learnerId
    targetId: $targetId
    goalId: $goalId
    unmatched: $unmatched
    offset: $offset
    limit: $limit
  ) {
    totalCount
    rows {
      id
      targetId
      goalId
      fields {
        ...EhrStoredFieldParts
      }
      session {
        id
        fields {
          ...EhrStoredFieldParts
        }
      }
    }
  }
}
    ${EhrStoredFieldPartsFragmentDoc}`;

export const useLearnerEhrSessionDataQuery = <
      TData = LearnerEhrSessionDataQuery,
      TError = unknown
    >(
      variables: LearnerEhrSessionDataQueryVariables,
      options?: Omit<UseQueryOptions<LearnerEhrSessionDataQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<LearnerEhrSessionDataQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<LearnerEhrSessionDataQuery, TError, TData>(
      {
    queryKey: ['LearnerEhrSessionData', variables],
    queryFn: useCustomFetcher<LearnerEhrSessionDataQuery, LearnerEhrSessionDataQueryVariables>(LearnerEhrSessionDataDocument).bind(null, variables),
    ...options
  }
    )};

export const LearnerEhrSyncsDocument = `
    query LearnerEhrSyncs($learnerId: ID!, $offset: Int, $limit: Int) {
  learnerEhrSyncs(learnerId: $learnerId, offset: $offset, limit: $limit) {
    totalCount
    rows {
      id
      ehrName
      runFolder
      temporalWorkflowId
      startedAt
    }
  }
}
    `;

export const useLearnerEhrSyncsQuery = <
      TData = LearnerEhrSyncsQuery,
      TError = unknown
    >(
      variables: LearnerEhrSyncsQueryVariables,
      options?: Omit<UseQueryOptions<LearnerEhrSyncsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<LearnerEhrSyncsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<LearnerEhrSyncsQuery, TError, TData>(
      {
    queryKey: ['LearnerEhrSyncs', variables],
    queryFn: useCustomFetcher<LearnerEhrSyncsQuery, LearnerEhrSyncsQueryVariables>(LearnerEhrSyncsDocument).bind(null, variables),
    ...options
  }
    )};

export const EhrActionRequestDocument = `
    query ehrActionRequest($requestId: Int!) {
  ehrActionRequest(requestId: $requestId) {
    id
    actionType
    status
    error
    learnerId
    reportId
    createdDate
    startedAt
    finishedAt
  }
}
    `;

export const useEhrActionRequestQuery = <
      TData = EhrActionRequestQuery,
      TError = unknown
    >(
      variables: EhrActionRequestQueryVariables,
      options?: Omit<UseQueryOptions<EhrActionRequestQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<EhrActionRequestQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<EhrActionRequestQuery, TError, TData>(
      {
    queryKey: ['ehrActionRequest', variables],
    queryFn: useCustomFetcher<EhrActionRequestQuery, EhrActionRequestQueryVariables>(EhrActionRequestDocument).bind(null, variables),
    ...options
  }
    )};

export const CareAppointmentsByResourceEmailDocument = `
    query careAppointmentsByResourceEmail($email: String!, $startDate: String, $endDate: String) {
  careAppointmentsByResourceEmail(
    email: $email
    startDate: $startDate
    endDate: $endDate
  ) {
    id
    startTime
    endTime
    status
    serviceId
    serviceName
    locationId
    locationName
    resourceId
    resourceName
    resourceEmail
    customerFirstName
    customerLastName
    customerEmail
    notes
    appointmentMeetingLink
  }
}
    `;

export const useCareAppointmentsByResourceEmailQuery = <
      TData = CareAppointmentsByResourceEmailQuery,
      TError = unknown
    >(
      variables: CareAppointmentsByResourceEmailQueryVariables,
      options?: Omit<UseQueryOptions<CareAppointmentsByResourceEmailQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<CareAppointmentsByResourceEmailQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<CareAppointmentsByResourceEmailQuery, TError, TData>(
      {
    queryKey: ['careAppointmentsByResourceEmail', variables],
    queryFn: useCustomFetcher<CareAppointmentsByResourceEmailQuery, CareAppointmentsByResourceEmailQueryVariables>(CareAppointmentsByResourceEmailDocument).bind(null, variables),
    ...options
  }
    )};

export const CareResourceByEmailDocument = `
    query careResourceByEmail($email: String!) {
  careResourceByEmail(email: $email) {
    id
    name
    email
    availabilityType
    about
    timezone
    imageUrl
    phone
    bookingLimit
    bookingsPerSlot
    services {
      id
      name
      durationMinutes
      description
      priceDollars
      isActive
      paddingMinutes
    }
    locations {
      id
      name
      address
    }
  }
}
    `;

export const useCareResourceByEmailQuery = <
      TData = CareResourceByEmailQuery,
      TError = unknown
    >(
      variables: CareResourceByEmailQueryVariables,
      options?: Omit<UseQueryOptions<CareResourceByEmailQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<CareResourceByEmailQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<CareResourceByEmailQuery, TError, TData>(
      {
    queryKey: ['careResourceByEmail', variables],
    queryFn: useCustomFetcher<CareResourceByEmailQuery, CareResourceByEmailQueryVariables>(CareResourceByEmailDocument).bind(null, variables),
    ...options
  }
    )};

export const CareResourceSingleAllocationBlocksDocument = `
    query careResourceSingleAllocationBlocks($resourceEmail: String!, $startDate: String!, $endDate: String!) {
  careResourceSingleAllocationBlocks(
    resourceEmail: $resourceEmail
    startDate: $startDate
    endDate: $endDate
  ) {
    id
    resourceId
    startTime
    endTime
    repeats
    resourceEmail
    deleted
  }
}
    `;

export const useCareResourceSingleAllocationBlocksQuery = <
      TData = CareResourceSingleAllocationBlocksQuery,
      TError = unknown
    >(
      variables: CareResourceSingleAllocationBlocksQueryVariables,
      options?: Omit<UseQueryOptions<CareResourceSingleAllocationBlocksQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<CareResourceSingleAllocationBlocksQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<CareResourceSingleAllocationBlocksQuery, TError, TData>(
      {
    queryKey: ['careResourceSingleAllocationBlocks', variables],
    queryFn: useCustomFetcher<CareResourceSingleAllocationBlocksQuery, CareResourceSingleAllocationBlocksQueryVariables>(CareResourceSingleAllocationBlocksDocument).bind(null, variables),
    ...options
  }
    )};

export const CareResourceWeeklyAllocationBlocksDocument = `
    query careResourceWeeklyAllocationBlocks($resourceEmail: String!, $startDate: String!, $endDate: String!) {
  careResourceWeeklyAllocationBlocks(
    resourceEmail: $resourceEmail
    startDate: $startDate
    endDate: $endDate
  ) {
    id
    resourceId
    startDate
    endDate
    sunday {
      startTime
      endTime
    }
    monday {
      startTime
      endTime
    }
    tuesday {
      startTime
      endTime
    }
    wednesday {
      startTime
      endTime
    }
    thursday {
      startTime
      endTime
    }
    friday {
      startTime
      endTime
    }
    saturday {
      startTime
      endTime
    }
    resourceEmail
    deleted
  }
}
    `;

export const useCareResourceWeeklyAllocationBlocksQuery = <
      TData = CareResourceWeeklyAllocationBlocksQuery,
      TError = unknown
    >(
      variables: CareResourceWeeklyAllocationBlocksQueryVariables,
      options?: Omit<UseQueryOptions<CareResourceWeeklyAllocationBlocksQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<CareResourceWeeklyAllocationBlocksQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<CareResourceWeeklyAllocationBlocksQuery, TError, TData>(
      {
    queryKey: ['careResourceWeeklyAllocationBlocks', variables],
    queryFn: useCustomFetcher<CareResourceWeeklyAllocationBlocksQuery, CareResourceWeeklyAllocationBlocksQueryVariables>(CareResourceWeeklyAllocationBlocksDocument).bind(null, variables),
    ...options
  }
    )};

export const GetProvidersForAssigningToLearnerDocument = `
    query getProvidersForAssigningToLearner {
  getProvidersForAssigningToLearner {
    edges {
      node {
        id
        archived
        rolesNameOnly
        providermetadata {
          firstName
          lastName
          email
        }
      }
    }
  }
}
    `;

export const useGetProvidersForAssigningToLearnerQuery = <
      TData = GetProvidersForAssigningToLearnerQuery,
      TError = unknown
    >(
      variables?: GetProvidersForAssigningToLearnerQueryVariables,
      options?: Omit<UseQueryOptions<GetProvidersForAssigningToLearnerQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetProvidersForAssigningToLearnerQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetProvidersForAssigningToLearnerQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['getProvidersForAssigningToLearner'] : ['getProvidersForAssigningToLearner', variables],
    queryFn: useCustomFetcher<GetProvidersForAssigningToLearnerQuery, GetProvidersForAssigningToLearnerQueryVariables>(GetProvidersForAssigningToLearnerDocument).bind(null, variables),
    ...options
  }
    )};

export const GetCurriculumsDocument = `
    query GetCurriculums {
  getCurricula {
    id
    name
  }
}
    `;

export const useGetCurriculumsQuery = <
      TData = GetCurriculumsQuery,
      TError = unknown
    >(
      variables?: GetCurriculumsQueryVariables,
      options?: Omit<UseQueryOptions<GetCurriculumsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetCurriculumsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetCurriculumsQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['GetCurriculums'] : ['GetCurriculums', variables],
    queryFn: useCustomFetcher<GetCurriculumsQuery, GetCurriculumsQueryVariables>(GetCurriculumsDocument).bind(null, variables),
    ...options
  }
    )};

export const GoalBankFoldersDocument = `
    query goalBankFolders($searchTerm: String) {
  getGoalBankFolders(searchTerm: $searchTerm) {
    userFolders {
      id
      name
      folderType
      goalsCount
      targetsCount
    }
    organizationFolders {
      id
      name
      folderType
      goalsCount
      targetsCount
      curriculum {
        id
        name
      }
    }
  }
}
    `;

export const useGoalBankFoldersQuery = <
      TData = GoalBankFoldersQuery,
      TError = unknown
    >(
      variables?: GoalBankFoldersQueryVariables,
      options?: Omit<UseQueryOptions<GoalBankFoldersQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GoalBankFoldersQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GoalBankFoldersQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['goalBankFolders'] : ['goalBankFolders', variables],
    queryFn: useCustomFetcher<GoalBankFoldersQuery, GoalBankFoldersQueryVariables>(GoalBankFoldersDocument).bind(null, variables),
    ...options
  }
    )};

export const GoalBankGoalsDocument = `
    query goalBankGoals($folderId: ID!, $searchTerm: String) {
  getGoalBankGoals(folderId: $folderId, searchTerm: $searchTerm) {
    edges {
      node {
        id
        goalName
        description
        medicalRationale
        programGoal
        masteryCriteria
        timelineEstimationType
        timelineEstimationValue
        hasMedicalNecessity
        medicalNecessityCriteria
        assessmentToolSource
        domain {
          id
          name
        }
      }
    }
  }
}
    `;

export const useGoalBankGoalsQuery = <
      TData = GoalBankGoalsQuery,
      TError = unknown
    >(
      variables: GoalBankGoalsQueryVariables,
      options?: Omit<UseQueryOptions<GoalBankGoalsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GoalBankGoalsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GoalBankGoalsQuery, TError, TData>(
      {
    queryKey: ['goalBankGoals', variables],
    queryFn: useCustomFetcher<GoalBankGoalsQuery, GoalBankGoalsQueryVariables>(GoalBankGoalsDocument).bind(null, variables),
    ...options
  }
    )};

export const GoalBankTargetsDocument = `
    query goalBankTargets($folderId: ID!, $goalBankId: ID, $searchTerm: String) {
  getGoalBankTargets(
    folderId: $folderId
    goalBankId: $goalBankId
    searchTerm: $searchTerm
  ) {
    edges {
      node {
        id
        targetName
        targetDescription
        medicalRationale
        masteryCriteria
        timelineEstimationType
        timelineEstimationValue
        goalBank {
          id
          goalName
        }
      }
    }
  }
}
    `;

export const useGoalBankTargetsQuery = <
      TData = GoalBankTargetsQuery,
      TError = unknown
    >(
      variables: GoalBankTargetsQueryVariables,
      options?: Omit<UseQueryOptions<GoalBankTargetsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GoalBankTargetsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GoalBankTargetsQuery, TError, TData>(
      {
    queryKey: ['goalBankTargets', variables],
    queryFn: useCustomFetcher<GoalBankTargetsQuery, GoalBankTargetsQueryVariables>(GoalBankTargetsDocument).bind(null, variables),
    ...options
  }
    )};

export const OrgHasGoalBankEmbeddingsDocument = `
    query OrgHasGoalBankEmbeddings {
  orgHasGoalBankEmbeddings
}
    `;

export const useOrgHasGoalBankEmbeddingsQuery = <
      TData = OrgHasGoalBankEmbeddingsQuery,
      TError = unknown
    >(
      variables?: OrgHasGoalBankEmbeddingsQueryVariables,
      options?: Omit<UseQueryOptions<OrgHasGoalBankEmbeddingsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<OrgHasGoalBankEmbeddingsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<OrgHasGoalBankEmbeddingsQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['OrgHasGoalBankEmbeddings'] : ['OrgHasGoalBankEmbeddings', variables],
    queryFn: useCustomFetcher<OrgHasGoalBankEmbeddingsQuery, OrgHasGoalBankEmbeddingsQueryVariables>(OrgHasGoalBankEmbeddingsDocument).bind(null, variables),
    ...options
  }
    )};

export const ReassessmentShortTermGoalPanelDocument = `
    query ReassessmentShortTermGoalPanel($reportGoalId: ID!) {
  getReportGoal(reportGoalId: $reportGoalId) {
    id
    aiBaselineDataPredictionStatus
    aiGoalAttainmentScalePredictionStatus
    aiProgressSummaryPredictionStatus
    assessmentToolSource
    baselineData
    baselineDate
    chartType
    chartFromDate
    chartToDate
    completionDate
    description
    projectedIntroductionDate
    gasLevel1
    gasLevel3
    gasLevel4
    gasMatchMessage
    gasMatchStatus
    gasScore
    generalizationCriteria
    goalName
    goalSubType
    goalType
    hasMedicalNecessity
    masteryCriteria
    medicalNecessityCriteria
    progressSummary
    rationale
    signedChartImageUrl
    status
    summaryReviewed
    summaryReviewedOn
    tags
    lastUpdatedDate
    createdDate
    goalBank {
      id
    }
    customFields {
      edges {
        node {
          id
          fieldIdentifier
          fieldType
          title
          content
          rankOrder
          imageSignedUrl
        }
      }
    }
  }
}
    `;

export const useReassessmentShortTermGoalPanelQuery = <
      TData = ReassessmentShortTermGoalPanelQuery,
      TError = unknown
    >(
      variables: ReassessmentShortTermGoalPanelQueryVariables,
      options?: Omit<UseQueryOptions<ReassessmentShortTermGoalPanelQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<ReassessmentShortTermGoalPanelQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<ReassessmentShortTermGoalPanelQuery, TError, TData>(
      {
    queryKey: ['ReassessmentShortTermGoalPanel', variables],
    queryFn: useCustomFetcher<ReassessmentShortTermGoalPanelQuery, ReassessmentShortTermGoalPanelQueryVariables>(ReassessmentShortTermGoalPanelDocument).bind(null, variables),
    ...options
  }
    )};

export const ReportGoalPanelSingleViewDocument = `
    query ReportGoalPanelSingleView($reportGoalId: ID!) {
  getReportGoal(reportGoalId: $reportGoalId) {
    id
    reportDomain {
      id
      name
    }
    createdDate
    lastUpdatedDate
    assessmentToolSource
    baselineDate
    completionDate
    projectedIntroductionDate
    goalName
    programGoal
    description
    timelineEstimationType
    timelineEstimationValue
    baselineData
    masteryCriteria
    hasMedicalNecessity
    medicalNecessityCriteria
    generalizationCriteria
    aiGoalAttainmentScalePredictionStatus
    gasLevel1
    gasLevel3
    gasLevel4
    gasScore
    rationale
    status
    goalType
    tags
    progressSummary
    aiGenerated
    inUse
    customFields {
      edges {
        node {
          id
          fieldIdentifier
          fieldType
          title
          content
          rankOrder
          imageSignedUrl
        }
      }
    }
  }
}
    `;

export const useReportGoalPanelSingleViewQuery = <
      TData = ReportGoalPanelSingleViewQuery,
      TError = unknown
    >(
      variables: ReportGoalPanelSingleViewQueryVariables,
      options?: Omit<UseQueryOptions<ReportGoalPanelSingleViewQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<ReportGoalPanelSingleViewQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<ReportGoalPanelSingleViewQuery, TError, TData>(
      {
    queryKey: ['ReportGoalPanelSingleView', variables],
    queryFn: useCustomFetcher<ReportGoalPanelSingleViewQuery, ReportGoalPanelSingleViewQueryVariables>(ReportGoalPanelSingleViewDocument).bind(null, variables),
    ...options
  }
    )};

export const ReportTargetPanelSingleViewDocument = `
    query ReportTargetPanelSingleView($filter: GetTargetsFilter!) {
  getReportTargets(filter: $filter) {
    edges {
      node {
        id
        aiGenerated
        inUse
        createdDate
        lastUpdatedDate
        targetName
        targetDescription
        timelineEstimationValue
        timelineEstimationType
        masteryCriteria
        baselineData
        status
        progressSummary
        completionDate
        summaryReviewed
        summaryReviewedOn
        excludeFromReport
        signedChartImageUrl
        aiProgressSummaryPredictionStatus
        projectedIntroductionDate
        customFields {
          edges {
            node {
              id
              fieldIdentifier
              fieldType
              title
              content
              rankOrder
              imageSignedUrl
            }
          }
        }
      }
    }
  }
}
    `;

export const useReportTargetPanelSingleViewQuery = <
      TData = ReportTargetPanelSingleViewQuery,
      TError = unknown
    >(
      variables: ReportTargetPanelSingleViewQueryVariables,
      options?: Omit<UseQueryOptions<ReportTargetPanelSingleViewQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<ReportTargetPanelSingleViewQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<ReportTargetPanelSingleViewQuery, TError, TData>(
      {
    queryKey: ['ReportTargetPanelSingleView', variables],
    queryFn: useCustomFetcher<ReportTargetPanelSingleViewQuery, ReportTargetPanelSingleViewQueryVariables>(ReportTargetPanelSingleViewDocument).bind(null, variables),
    ...options
  }
    )};

export const GetReportDomainsDocument = `
    query GetReportDomains($reportId: ID!) {
  getReportDomains(reportId: $reportId) {
    id
    name
    description
    rankOrder
  }
}
    `;

export const useGetReportDomainsQuery = <
      TData = GetReportDomainsQuery,
      TError = unknown
    >(
      variables: GetReportDomainsQueryVariables,
      options?: Omit<UseQueryOptions<GetReportDomainsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetReportDomainsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetReportDomainsQuery, TError, TData>(
      {
    queryKey: ['GetReportDomains', variables],
    queryFn: useCustomFetcher<GetReportDomainsQuery, GetReportDomainsQueryVariables>(GetReportDomainsDocument).bind(null, variables),
    ...options
  }
    )};

export const GetReportGoalBaselineStatusDocument = `
    query getReportGoalBaselineStatus($reportGoalId: ID!) {
  getReportGoal(reportGoalId: $reportGoalId) {
    aiBaselineDataPredictionStatus
    baselineData
  }
}
    `;

export const useGetReportGoalBaselineStatusQuery = <
      TData = GetReportGoalBaselineStatusQuery,
      TError = unknown
    >(
      variables: GetReportGoalBaselineStatusQueryVariables,
      options?: Omit<UseQueryOptions<GetReportGoalBaselineStatusQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetReportGoalBaselineStatusQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetReportGoalBaselineStatusQuery, TError, TData>(
      {
    queryKey: ['getReportGoalBaselineStatus', variables],
    queryFn: useCustomFetcher<GetReportGoalBaselineStatusQuery, GetReportGoalBaselineStatusQueryVariables>(GetReportGoalBaselineStatusDocument).bind(null, variables),
    ...options
  }
    )};

export const GetReportGoalSummaryStatusDocument = `
    query getReportGoalSummaryStatus($reportGoalId: ID!) {
  getReportGoal(reportGoalId: $reportGoalId) {
    aiProgressSummaryPredictionStatus
    progressSummary
  }
}
    `;

export const useGetReportGoalSummaryStatusQuery = <
      TData = GetReportGoalSummaryStatusQuery,
      TError = unknown
    >(
      variables: GetReportGoalSummaryStatusQueryVariables,
      options?: Omit<UseQueryOptions<GetReportGoalSummaryStatusQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetReportGoalSummaryStatusQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetReportGoalSummaryStatusQuery, TError, TData>(
      {
    queryKey: ['getReportGoalSummaryStatus', variables],
    queryFn: useCustomFetcher<GetReportGoalSummaryStatusQuery, GetReportGoalSummaryStatusQueryVariables>(GetReportGoalSummaryStatusDocument).bind(null, variables),
    ...options
  }
    )};

export const GetTargetSummaryStatusDocument = `
    query getTargetSummaryStatus($filter: GetTargetsFilter!) {
  getReportTargets(filter: $filter) {
    edges {
      node {
        aiProgressSummaryPredictionStatus
        progressSummary
      }
    }
  }
}
    `;

export const useGetTargetSummaryStatusQuery = <
      TData = GetTargetSummaryStatusQuery,
      TError = unknown
    >(
      variables: GetTargetSummaryStatusQueryVariables,
      options?: Omit<UseQueryOptions<GetTargetSummaryStatusQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetTargetSummaryStatusQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetTargetSummaryStatusQuery, TError, TData>(
      {
    queryKey: ['getTargetSummaryStatus', variables],
    queryFn: useCustomFetcher<GetTargetSummaryStatusQuery, GetTargetSummaryStatusQueryVariables>(GetTargetSummaryStatusDocument).bind(null, variables),
    ...options
  }
    )};

export const LearnerAdditionalDetailsDocument = `
    query learnerAdditionalDetails($learnerId: ID!) {
  learnerById(learnerId: $learnerId) {
    learnerAdditionalDetails {
      anythingThatCameUpToBeMentioned
      anythingThatWeDidNotCoverEnough
      mainConcerns
      whoReferredYou
      mchatResultForClient
    }
  }
}
    `;

export const useLearnerAdditionalDetailsQuery = <
      TData = LearnerAdditionalDetailsQuery,
      TError = unknown
    >(
      variables: LearnerAdditionalDetailsQueryVariables,
      options?: Omit<UseQueryOptions<LearnerAdditionalDetailsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<LearnerAdditionalDetailsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<LearnerAdditionalDetailsQuery, TError, TData>(
      {
    queryKey: ['learnerAdditionalDetails', variables],
    queryFn: useCustomFetcher<LearnerAdditionalDetailsQuery, LearnerAdditionalDetailsQueryVariables>(LearnerAdditionalDetailsDocument).bind(null, variables),
    ...options
  }
    )};

export const LearnerAllIntakeDataDocument = `
    query learnerAllIntakeData($learnerId: ID!) {
  learnerById(learnerId: $learnerId) {
    formStatusForLearner {
      edges {
        node {
          formName
          status
        }
      }
    }
    learnermetadata {
      firstName
      lastName
      preferredName
      birthDate
      gender
      specifyGender
      preferredLanguage
      address
      addressLine2
      city
      state
      zip
    }
    relationshipSet {
      edges {
        node {
          socialRelationship
          caregiver {
            caregivermetadata {
              firstName
              lastName
              email
              phoneNumber1
              phoneNumber2
              preferredLanguage
              requiresInterpreter
              birthDate
              gender
              specifyGender
              maritalStatus
              addressLine1
              addressLine2
              city
              state
              zip
              occupation
              employer
              abaClientGoalsForGuardian
            }
          }
        }
      }
    }
    insuranceForLearner {
      edges {
        node {
          insuranceType
          insurer
          idNumber
          groupName
          isPrimaryInsurance
          claimsAddress
          claimsAddressLine2
          city
          state
          zip
          phoneNumber
          insurancePolicyHolder
          policyHolderBirthDate
          signedUrlOfCardFront
          signedUrlOfCardBack
        }
      }
    }
    learnerindividualsthatliveinhomeSet {
      edges {
        node {
          name
          age
          relationshipToClient
        }
      }
    }
    learnerlivingconditions {
      delaysOrDiagnosesInClientSiblings
      clientInFosterCare
      cyfdCaseManagerName
      cyfdCaseManagerPhone
      clientLivesBetweenParentsAndGrandparents
      clientHouseholdParentCount
      clientTimeSpentWithOtherParent
    }
    medicationsForLearner {
      edges {
        node {
          name
          dosage
          prescriber
        }
      }
    }
    learnermedicalhistorymetadata {
      clientHasBeenHospitalized
      clientHospitalizedDetails
      clientHasCurrentCounselor
      clientCurrentCounselorName
      clientCurrentCounselorPhone
      clientThoughtsForParticipatingCounseling
      clientHasMedicalDiagnoses
      clientMedicalDiagnosesDetails
      clientHasMedicalDiagnoses
      sideEffectsOfEmotionalBehaviourMedication
      allergiesOrDietaryRestrictions
      familyHistoryOfDiagnoses
      hospitalizationsOrSurgeries
      clientOverallHealth
      clientOtherHealthConcerns
      clientGiDifficulties
    }
    medicalHistoryForLearner {
      primaryCareProvider
      address
      addressLine2
      city
      state
      zip
    }
    learnerAdditionalDetails {
      anythingThatCameUpToBeMentioned
      anythingThatWeDidNotCoverEnough
      mainConcerns
      whoReferredYou
      mchatResultForClient
    }
    onboardingQuestionsForLearner {
      edges {
        node {
          questionKey
          answer
          questionPageOrigin
        }
      }
    }
    learnerbirthhistory {
      pregnancyDeliveryConcerns
      birthWeightInPounds
      birthWeightInOunces
      clientLikeAsBaby
      babyTemperament
      separatedFromParentFirst24Months
      separatedFromParentFirst24MonthsExplanation
      normalFullTermPregnancy
      pregnancyComplications
      prematureBirth
      cesareanBirth
      difficultLaborDelivery
      overdueBirth
      breathingDifficulty
      suckingDifficulty
      touchResponseDifficulty
      pregnancyInfections
      pregnancyPreEclampsia
      pregnancyHypertension
      pregnancyFevers
      gestationalDiabetes
      otherPregnancyIllnesses
      prescriptionDrugsUsed
      prescriptionList
      alcoholUsed
      recreationalDrugsUsed
      tobaccoUsed
      hospitalizedForHealthConcernsAtBirth
      hospitalizedForHealthConcernsAtBirthExplanatiion
    }
    learnerEarlyInterventionServices {
      clientEarlyInterventionEnrollment
      earlyInterventionStartAge
      dismissedOrTransferredToPreschool
      specialEducationOrOutsideServices
    }
    learnerTheraputicServicesInSchool {
      edges {
        node {
          service
          serviceHours
        }
      }
    }
    learnerOtherServicesHistory {
      edges {
        node {
          service
          serviceHours
          serviceStartDate
          serviceEndDate
          serviceProviderName
        }
      }
    }
    learnerEducation {
      nameOfSchool
      grade
      educationSetting
      specialEducation
      learnerEducationMetaData {
        currentGrades
        academicStrengthsAndWeaknesses
        schoolBehaviorProblems
      }
    }
    learneremergencycontact {
      firstName
      lastName
      phoneNumber
      relationshipToClient
    }
  }
}
    `;

export const useLearnerAllIntakeDataQuery = <
      TData = LearnerAllIntakeDataQuery,
      TError = unknown
    >(
      variables: LearnerAllIntakeDataQueryVariables,
      options?: Omit<UseQueryOptions<LearnerAllIntakeDataQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<LearnerAllIntakeDataQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<LearnerAllIntakeDataQuery, TError, TData>(
      {
    queryKey: ['learnerAllIntakeData', variables],
    queryFn: useCustomFetcher<LearnerAllIntakeDataQuery, LearnerAllIntakeDataQueryVariables>(LearnerAllIntakeDataDocument).bind(null, variables),
    ...options
  }
    )};

export const LearnerBehaviorsDocument = `
    query learnerBehaviors($learnerId: ID!, $questionPageOrigin: String) {
  learnerById(learnerId: $learnerId) {
    onboardingQuestionsForLearner(questionPageOrigin: $questionPageOrigin) {
      edges {
        node {
          questionKey
          answer
          questionPageOrigin
        }
      }
    }
  }
}
    `;

export const useLearnerBehaviorsQuery = <
      TData = LearnerBehaviorsQuery,
      TError = unknown
    >(
      variables: LearnerBehaviorsQueryVariables,
      options?: Omit<UseQueryOptions<LearnerBehaviorsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<LearnerBehaviorsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<LearnerBehaviorsQuery, TError, TData>(
      {
    queryKey: ['learnerBehaviors', variables],
    queryFn: useCustomFetcher<LearnerBehaviorsQuery, LearnerBehaviorsQueryVariables>(LearnerBehaviorsDocument).bind(null, variables),
    ...options
  }
    )};

export const LearnerBirthHistoryDocument = `
    query learnerBirthHistory($learnerId: ID!) {
  learnerById(learnerId: $learnerId) {
    learnerbirthhistory {
      pregnancyDeliveryConcerns
      birthWeightInPounds
      birthWeightInOunces
      clientLikeAsBaby
      babyTemperament
      separatedFromParentFirst24Months
      separatedFromParentFirst24MonthsExplanation
      normalFullTermPregnancy
      pregnancyComplications
      prematureBirth
      cesareanBirth
      difficultLaborDelivery
      overdueBirth
      breathingDifficulty
      suckingDifficulty
      touchResponseDifficulty
      pregnancyInfections
      pregnancyPreEclampsia
      pregnancyHypertension
      pregnancyFevers
      gestationalDiabetes
      otherPregnancyIllnesses
      prescriptionDrugsUsed
      prescriptionList
      alcoholUsed
      recreationalDrugsUsed
      tobaccoUsed
      hospitalizedForHealthConcernsAtBirth
      hospitalizedForHealthConcernsAtBirthExplanatiion
    }
  }
}
    `;

export const useLearnerBirthHistoryQuery = <
      TData = LearnerBirthHistoryQuery,
      TError = unknown
    >(
      variables: LearnerBirthHistoryQueryVariables,
      options?: Omit<UseQueryOptions<LearnerBirthHistoryQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<LearnerBirthHistoryQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<LearnerBirthHistoryQuery, TError, TData>(
      {
    queryKey: ['learnerBirthHistory', variables],
    queryFn: useCustomFetcher<LearnerBirthHistoryQuery, LearnerBirthHistoryQueryVariables>(LearnerBirthHistoryDocument).bind(null, variables),
    ...options
  }
    )};

export const LearnerCommunicationDocument = `
    query learnerCommunication($learnerId: ID!, $questionPageOrigin: String) {
  learnerById(learnerId: $learnerId) {
    onboardingQuestionsForLearner(questionPageOrigin: $questionPageOrigin) {
      edges {
        node {
          id
          questionKey
          answer
          questionPageOrigin
        }
      }
    }
  }
}
    `;

export const useLearnerCommunicationQuery = <
      TData = LearnerCommunicationQuery,
      TError = unknown
    >(
      variables: LearnerCommunicationQueryVariables,
      options?: Omit<UseQueryOptions<LearnerCommunicationQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<LearnerCommunicationQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<LearnerCommunicationQuery, TError, TData>(
      {
    queryKey: ['learnerCommunication', variables],
    queryFn: useCustomFetcher<LearnerCommunicationQuery, LearnerCommunicationQueryVariables>(LearnerCommunicationDocument).bind(null, variables),
    ...options
  }
    )};

export const LearnerDevelopmentalMileStonesDocument = `
    query learnerDevelopmentalMileStones($learnerId: ID!) {
  learnerById(learnerId: $learnerId) {
    onboardingQuestionsForLearner(
      questionPageOrigin: "development/development-milestones"
    ) {
      edges {
        node {
          questionKey
          answer
          questionPageOrigin
        }
      }
    }
  }
}
    `;

export const useLearnerDevelopmentalMileStonesQuery = <
      TData = LearnerDevelopmentalMileStonesQuery,
      TError = unknown
    >(
      variables: LearnerDevelopmentalMileStonesQueryVariables,
      options?: Omit<UseQueryOptions<LearnerDevelopmentalMileStonesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<LearnerDevelopmentalMileStonesQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<LearnerDevelopmentalMileStonesQuery, TError, TData>(
      {
    queryKey: ['learnerDevelopmentalMileStones', variables],
    queryFn: useCustomFetcher<LearnerDevelopmentalMileStonesQuery, LearnerDevelopmentalMileStonesQueryVariables>(LearnerDevelopmentalMileStonesDocument).bind(null, variables),
    ...options
  }
    )};

export const LearnerEarlyInterventionServicesDocument = `
    query learnerEarlyInterventionServices($learnerId: ID!) {
  learnerById(learnerId: $learnerId) {
    learnerEarlyInterventionServices {
      clientEarlyInterventionEnrollment
      earlyInterventionStartAge
      dismissedOrTransferredToPreschool
      specialEducationOrOutsideServices
    }
  }
}
    `;

export const useLearnerEarlyInterventionServicesQuery = <
      TData = LearnerEarlyInterventionServicesQuery,
      TError = unknown
    >(
      variables: LearnerEarlyInterventionServicesQueryVariables,
      options?: Omit<UseQueryOptions<LearnerEarlyInterventionServicesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<LearnerEarlyInterventionServicesQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<LearnerEarlyInterventionServicesQuery, TError, TData>(
      {
    queryKey: ['learnerEarlyInterventionServices', variables],
    queryFn: useCustomFetcher<LearnerEarlyInterventionServicesQuery, LearnerEarlyInterventionServicesQueryVariables>(LearnerEarlyInterventionServicesDocument).bind(null, variables),
    ...options
  }
    )};

export const LearnerEducationDocument = `
    query learnerEducation($learnerId: ID!) {
  learnerById(learnerId: $learnerId) {
    learnerTheraputicServicesInSchool {
      edges {
        node {
          service
          serviceHours
        }
      }
    }
    learnerOtherServicesHistory {
      edges {
        node {
          service
          serviceHours
          serviceStartDate
          serviceEndDate
          serviceProviderName
        }
      }
    }
    learnerEducation {
      nameOfSchool
      grade
      educationSetting
      specialEducation
      learnerEducationMetaData {
        currentGrades
        academicStrengthsAndWeaknesses
        schoolBehaviorProblems
      }
    }
  }
}
    `;

export const useLearnerEducationQuery = <
      TData = LearnerEducationQuery,
      TError = unknown
    >(
      variables: LearnerEducationQueryVariables,
      options?: Omit<UseQueryOptions<LearnerEducationQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<LearnerEducationQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<LearnerEducationQuery, TError, TData>(
      {
    queryKey: ['learnerEducation', variables],
    queryFn: useCustomFetcher<LearnerEducationQuery, LearnerEducationQueryVariables>(LearnerEducationDocument).bind(null, variables),
    ...options
  }
    )};

export const LearnerEmergencyContactDocument = `
    query learnerEmergencyContact($learnerId: ID!) {
  learnerById(learnerId: $learnerId) {
    learneremergencycontact {
      firstName
      lastName
      phoneNumber
      relationshipToClient
    }
  }
}
    `;

export const useLearnerEmergencyContactQuery = <
      TData = LearnerEmergencyContactQuery,
      TError = unknown
    >(
      variables: LearnerEmergencyContactQueryVariables,
      options?: Omit<UseQueryOptions<LearnerEmergencyContactQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<LearnerEmergencyContactQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<LearnerEmergencyContactQuery, TError, TData>(
      {
    queryKey: ['learnerEmergencyContact', variables],
    queryFn: useCustomFetcher<LearnerEmergencyContactQuery, LearnerEmergencyContactQueryVariables>(LearnerEmergencyContactDocument).bind(null, variables),
    ...options
  }
    )};

export const LearnerGeneralDetailsDocument = `
    query learnerGeneralDetails($learnerId: ID!) {
  learnerById(learnerId: $learnerId) {
    learnermetadata {
      firstName
      lastName
      preferredName
      birthDate
      gender
      specifyGender
      preferredLanguage
      address
      addressLine2
      city
      state
      zip
    }
  }
}
    `;

export const useLearnerGeneralDetailsQuery = <
      TData = LearnerGeneralDetailsQuery,
      TError = unknown
    >(
      variables: LearnerGeneralDetailsQueryVariables,
      options?: Omit<UseQueryOptions<LearnerGeneralDetailsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<LearnerGeneralDetailsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<LearnerGeneralDetailsQuery, TError, TData>(
      {
    queryKey: ['learnerGeneralDetails', variables],
    queryFn: useCustomFetcher<LearnerGeneralDetailsQuery, LearnerGeneralDetailsQueryVariables>(LearnerGeneralDetailsDocument).bind(null, variables),
    ...options
  }
    )};

export const LearnerGuardianDetailsDocument = `
    query learnerGuardianDetails($learnerId: ID!) {
  learnerById(learnerId: $learnerId) {
    relationshipSet {
      edges {
        node {
          socialRelationship
          caregiver {
            caregivermetadata {
              firstName
              lastName
              email
              phoneNumber1
              phoneNumber2
              preferredLanguage
              requiresInterpreter
              birthDate
              gender
              specifyGender
              maritalStatus
              addressLine1
              addressLine2
              city
              state
              zip
              occupation
              employer
              abaClientGoalsForGuardian
            }
          }
        }
      }
    }
  }
}
    `;

export const useLearnerGuardianDetailsQuery = <
      TData = LearnerGuardianDetailsQuery,
      TError = unknown
    >(
      variables: LearnerGuardianDetailsQueryVariables,
      options?: Omit<UseQueryOptions<LearnerGuardianDetailsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<LearnerGuardianDetailsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<LearnerGuardianDetailsQuery, TError, TData>(
      {
    queryKey: ['learnerGuardianDetails', variables],
    queryFn: useCustomFetcher<LearnerGuardianDetailsQuery, LearnerGuardianDetailsQueryVariables>(LearnerGuardianDetailsDocument).bind(null, variables),
    ...options
  }
    )};

export const LearnerInsuranceDocument = `
    query learnerInsurance($learnerId: ID!) {
  learnerById(learnerId: $learnerId) {
    insuranceForLearner {
      edges {
        node {
          insuranceType
          insurer
          idNumber
          groupName
          isPrimaryInsurance
          claimsAddress
          claimsAddressLine2
          city
          state
          zip
          phoneNumber
          insurancePolicyHolder
          policyHolderBirthDate
          signedUrlOfCardFront
          signedUrlOfCardBack
        }
      }
    }
  }
}
    `;

export const useLearnerInsuranceQuery = <
      TData = LearnerInsuranceQuery,
      TError = unknown
    >(
      variables: LearnerInsuranceQueryVariables,
      options?: Omit<UseQueryOptions<LearnerInsuranceQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<LearnerInsuranceQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<LearnerInsuranceQuery, TError, TData>(
      {
    queryKey: ['learnerInsurance', variables],
    queryFn: useCustomFetcher<LearnerInsuranceQuery, LearnerInsuranceQueryVariables>(LearnerInsuranceDocument).bind(null, variables),
    ...options
  }
    )};

export const LearnerLivingConditionsDocument = `
    query learnerLivingConditions($learnerId: ID!) {
  learnerById(learnerId: $learnerId) {
    learnerindividualsthatliveinhomeSet {
      edges {
        node {
          name
          age
          relationshipToClient
        }
      }
    }
    learnerlivingconditions {
      delaysOrDiagnosesInClientSiblings
      clientInFosterCare
      cyfdCaseManagerName
      cyfdCaseManagerPhone
      clientLivesBetweenParentsAndGrandparents
      clientHouseholdParentCount
      clientTimeSpentWithOtherParent
    }
  }
}
    `;

export const useLearnerLivingConditionsQuery = <
      TData = LearnerLivingConditionsQuery,
      TError = unknown
    >(
      variables: LearnerLivingConditionsQueryVariables,
      options?: Omit<UseQueryOptions<LearnerLivingConditionsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<LearnerLivingConditionsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<LearnerLivingConditionsQuery, TError, TData>(
      {
    queryKey: ['learnerLivingConditions', variables],
    queryFn: useCustomFetcher<LearnerLivingConditionsQuery, LearnerLivingConditionsQueryVariables>(LearnerLivingConditionsDocument).bind(null, variables),
    ...options
  }
    )};

export const LearnerMedicalHistoryDocument = `
    query learnerMedicalHistory($learnerId: ID!) {
  learnerById(learnerId: $learnerId) {
    onboardingQuestionsForLearner(questionPageOrigin: "health/medical-history") {
      edges {
        node {
          questionKey
          answer
          questionPageOrigin
        }
      }
    }
    medicationsForLearner {
      edges {
        node {
          name
          dosage
          prescriber
        }
      }
    }
    learnermedicalhistorymetadata {
      clientHasBeenHospitalized
      clientHospitalizedDetails
      clientHasCurrentCounselor
      clientCurrentCounselorName
      clientCurrentCounselorPhone
      clientThoughtsForParticipatingCounseling
      clientHasMedicalDiagnoses
      clientMedicalDiagnosesDetails
      clientHasMedicalDiagnoses
      sideEffectsOfEmotionalBehaviourMedication
      allergiesOrDietaryRestrictions
      familyHistoryOfDiagnoses
      hospitalizationsOrSurgeries
      clientOverallHealth
      clientOtherHealthConcerns
      clientGiDifficulties
    }
    medicalHistoryForLearner {
      primaryCareProvider
      address
      addressLine2
      city
      state
      zip
    }
  }
}
    `;

export const useLearnerMedicalHistoryQuery = <
      TData = LearnerMedicalHistoryQuery,
      TError = unknown
    >(
      variables: LearnerMedicalHistoryQueryVariables,
      options?: Omit<UseQueryOptions<LearnerMedicalHistoryQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<LearnerMedicalHistoryQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<LearnerMedicalHistoryQuery, TError, TData>(
      {
    queryKey: ['learnerMedicalHistory', variables],
    queryFn: useCustomFetcher<LearnerMedicalHistoryQuery, LearnerMedicalHistoryQueryVariables>(LearnerMedicalHistoryDocument).bind(null, variables),
    ...options
  }
    )};

export const LearnerTendenciesDocument = `
    query learnerTendencies($learnerId: ID!, $questionPageOrigin: String) {
  learnerById(learnerId: $learnerId) {
    onboardingQuestionsForLearner(questionPageOrigin: $questionPageOrigin) {
      edges {
        node {
          questionKey
          answer
          questionPageOrigin
        }
      }
    }
  }
}
    `;

export const useLearnerTendenciesQuery = <
      TData = LearnerTendenciesQuery,
      TError = unknown
    >(
      variables: LearnerTendenciesQueryVariables,
      options?: Omit<UseQueryOptions<LearnerTendenciesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<LearnerTendenciesQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<LearnerTendenciesQuery, TError, TData>(
      {
    queryKey: ['learnerTendencies', variables],
    queryFn: useCustomFetcher<LearnerTendenciesQuery, LearnerTendenciesQueryVariables>(LearnerTendenciesDocument).bind(null, variables),
    ...options
  }
    )};

export const GetLearnerFileForReviewDocument = `
    query GetLearnerFileForReview($fileId: ID!) {
  learnerFileById(fileId: $fileId) {
    id
    fileKind
    status
    signedS3LearnerFile
    parsedResult
    parsedResultScoped
    hasParsedResultSchema
    effectiveDate
    clinicianEditedAt
    respondent
  }
}
    `;

export const useGetLearnerFileForReviewQuery = <
      TData = GetLearnerFileForReviewQuery,
      TError = unknown
    >(
      variables: GetLearnerFileForReviewQueryVariables,
      options?: Omit<UseQueryOptions<GetLearnerFileForReviewQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetLearnerFileForReviewQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetLearnerFileForReviewQuery, TError, TData>(
      {
    queryKey: ['GetLearnerFileForReview', variables],
    queryFn: useCustomFetcher<GetLearnerFileForReviewQuery, GetLearnerFileForReviewQueryVariables>(GetLearnerFileForReviewDocument).bind(null, variables),
    ...options
  }
    )};

export const GetLearnerFilePdfPreviewStatusDocument = `
    query getLearnerFilePdfPreviewStatus($fileId: ID!) {
  learnerFileById(fileId: $fileId) {
    id
    pdfPreviewStatus
    pdfPreviewSignedUrl
  }
}
    `;

export const useGetLearnerFilePdfPreviewStatusQuery = <
      TData = GetLearnerFilePdfPreviewStatusQuery,
      TError = unknown
    >(
      variables: GetLearnerFilePdfPreviewStatusQueryVariables,
      options?: Omit<UseQueryOptions<GetLearnerFilePdfPreviewStatusQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetLearnerFilePdfPreviewStatusQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetLearnerFilePdfPreviewStatusQuery, TError, TData>(
      {
    queryKey: ['getLearnerFilePdfPreviewStatus', variables],
    queryFn: useCustomFetcher<GetLearnerFilePdfPreviewStatusQuery, GetLearnerFilePdfPreviewStatusQueryVariables>(GetLearnerFilePdfPreviewStatusDocument).bind(null, variables),
    ...options
  }
    )};

export const GetLearnerFilesByLearnerDocument = `
    query GetLearnerFilesByLearner($learnerId: ID!, $fileKind: String, $isReportAttached: Boolean) {
  getLearnerFilesByLearner(
    learnerId: $learnerId
    fileKind: $fileKind
    isReportAttached: $isReportAttached
  ) {
    edges {
      node {
        id
        originalFileName
        fileKind
        status
        mimeType
        fileSize
        signedS3LearnerFile
        pdfPreviewStatus
        pdfPreviewSignedUrl
        effectiveDate
        clinicianEditedAt
        respondent
        reports {
          edges {
            node {
              id
              reportType
              reportStatus
              createdDate
              completionDate
            }
          }
        }
      }
    }
  }
}
    `;

export const useGetLearnerFilesByLearnerQuery = <
      TData = GetLearnerFilesByLearnerQuery,
      TError = unknown
    >(
      variables: GetLearnerFilesByLearnerQueryVariables,
      options?: Omit<UseQueryOptions<GetLearnerFilesByLearnerQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetLearnerFilesByLearnerQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetLearnerFilesByLearnerQuery, TError, TData>(
      {
    queryKey: ['GetLearnerFilesByLearner', variables],
    queryFn: useCustomFetcher<GetLearnerFilesByLearnerQuery, GetLearnerFilesByLearnerQueryVariables>(GetLearnerFilesByLearnerDocument).bind(null, variables),
    ...options
  }
    )};

export const LearnerFileByIdDocument = `
    query learnerFileById($fileId: ID!) {
  learnerFileById(fileId: $fileId) {
    id
    originalFileName
    fileKind
    status
    mimeType
    fileSize
    signedS3LearnerFile
  }
}
    `;

export const useLearnerFileByIdQuery = <
      TData = LearnerFileByIdQuery,
      TError = unknown
    >(
      variables: LearnerFileByIdQueryVariables,
      options?: Omit<UseQueryOptions<LearnerFileByIdQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<LearnerFileByIdQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<LearnerFileByIdQuery, TError, TData>(
      {
    queryKey: ['learnerFileById', variables],
    queryFn: useCustomFetcher<LearnerFileByIdQuery, LearnerFileByIdQueryVariables>(LearnerFileByIdDocument).bind(null, variables),
    ...options
  }
    )};

export const LearnerManualGoalSyncByIdDocument = `
    query learnerManualGoalSyncByID($learnerId: ID!) {
  learnerById(learnerId: $learnerId) {
    manualGoalSyncStatus
    manualGoalSyncLastUpdated
  }
}
    `;

export const useLearnerManualGoalSyncByIdQuery = <
      TData = LearnerManualGoalSyncByIdQuery,
      TError = unknown
    >(
      variables: LearnerManualGoalSyncByIdQueryVariables,
      options?: Omit<UseQueryOptions<LearnerManualGoalSyncByIdQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<LearnerManualGoalSyncByIdQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<LearnerManualGoalSyncByIdQuery, TError, TData>(
      {
    queryKey: ['learnerManualGoalSyncByID', variables],
    queryFn: useCustomFetcher<LearnerManualGoalSyncByIdQuery, LearnerManualGoalSyncByIdQueryVariables>(LearnerManualGoalSyncByIdDocument).bind(null, variables),
    ...options
  }
    )};

export const GetMediaByCaregiverDocument = `
    query getMediaByCaregiver($learnerIds: [ID], $mediaStatus: MediaStatusEnumType, $sortBy: [MediaSortByEnum], $sessionStartDate: Date, $sessionEndDate: Date, $isReviewed: Boolean, $sessionStatus: [VideoSessionStatusEnums], $after: String) {
  getMediaByCaregiver(
    learnerIds: $learnerIds
    mediaStatus: $mediaStatus
    sortBy: $sortBy
    sessionStartDate: $sessionStartDate
    sessionEndDate: $sessionEndDate
    first: 21
    isViewed: $isReviewed
    sessionStatus: $sessionStatus
    after: $after
  ) {
    totalCount
    pageInfo {
      hasNextPage
      startCursor
      endCursor
    }
    edges {
      node {
        id
        mediaType
        mediaStatus
        isViewed
        totalDuration
        videoSession {
          id
          date
          createdDate
          sessionRating
          sessionStatus
          sessionaipredictionSet {
            edges {
              node {
                id
                prediction
              }
            }
          }
          sessioncaregiverSet {
            edges {
              node {
                caregiver {
                  id
                  caregivermetadata {
                    firstName
                    lastName
                  }
                }
              }
            }
          }
          sessionlearnerSet {
            edges {
              node {
                sessionLearners {
                  id
                  learnermetadata {
                    firstName
                    lastName
                  }
                }
              }
            }
          }
          sessionproviderSet {
            edges {
              node {
                provider {
                  id
                  providermetadata {
                    firstName
                    lastName
                  }
                }
              }
            }
          }
        }
        mediaClassifications {
          continuousInteractions {
            subclass
            totalDuration
            intervals {
              startTime
              endTime
              confidenceLevel
            }
          }
          nonContinuousInteractions {
            subclass
            interactionCount
            intervals {
              startTime
              endTime
              confidenceLevel
            }
          }
        }
        createdDate
        commentsCount
      }
    }
  }
}
    `;

export const useGetMediaByCaregiverQuery = <
      TData = GetMediaByCaregiverQuery,
      TError = unknown
    >(
      variables?: GetMediaByCaregiverQueryVariables,
      options?: Omit<UseQueryOptions<GetMediaByCaregiverQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetMediaByCaregiverQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetMediaByCaregiverQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['getMediaByCaregiver'] : ['getMediaByCaregiver', variables],
    queryFn: useCustomFetcher<GetMediaByCaregiverQuery, GetMediaByCaregiverQueryVariables>(GetMediaByCaregiverDocument).bind(null, variables),
    ...options
  }
    )};

export const GetMediaByCaregiverByMediaIdDocument = `
    query GetMediaByCaregiverByMediaId($mediaId: ID!) {
  getMediaByCaregiverByMediaId(mediaId: $mediaId) {
    id
    mediaType
    mediaStatus
    isViewed
    commentsCount
    signedUploadUrl
    mediaAttachmentUrl
    thumbnailManifest {
      mediaId
      intervalSeconds
      thumbnails {
        time
        url
      }
    }
    videoSession {
      id
      date
      sessionRating
      createdDate
      comment
      sessionlearnerSet {
        edges {
          node {
            sessionLearners {
              id
              learnermetadata {
                firstName
                lastName
              }
            }
          }
        }
      }
      sessioncaregiverSet {
        edges {
          node {
            caregiver {
              id
              caregivermetadata {
                firstName
                lastName
              }
            }
          }
        }
      }
      sessionproviderSet {
        edges {
          node {
            provider {
              id
              providermetadata {
                firstName
                lastName
              }
            }
          }
        }
      }
    }
    mediaClassifications {
      continuousInteractions {
        subclass
        totalDuration
        intervals {
          startTime
          endTime
          confidenceLevel
        }
      }
      nonContinuousInteractions {
        subclass
        interactionCount
        intervals {
          startTime
          endTime
          confidenceLevel
        }
      }
    }
    createdDate
    totalDuration
  }
}
    `;

export const useGetMediaByCaregiverByMediaIdQuery = <
      TData = GetMediaByCaregiverByMediaIdQuery,
      TError = unknown
    >(
      variables: GetMediaByCaregiverByMediaIdQueryVariables,
      options?: Omit<UseQueryOptions<GetMediaByCaregiverByMediaIdQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetMediaByCaregiverByMediaIdQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetMediaByCaregiverByMediaIdQuery, TError, TData>(
      {
    queryKey: ['GetMediaByCaregiverByMediaId', variables],
    queryFn: useCustomFetcher<GetMediaByCaregiverByMediaIdQuery, GetMediaByCaregiverByMediaIdQueryVariables>(GetMediaByCaregiverByMediaIdDocument).bind(null, variables),
    ...options
  }
    )};

export const GetMediaCommentsByMediaIdDocument = `
    query GetMediaCommentsByMediaId($mediaId: ID!, $commentTypes: [MediaCommentFilterEnum]) {
  getMediaComments(mediaId: $mediaId, commentTypes: $commentTypes) {
    totalCount
    edges {
      node {
        id
        content
        commentType
        commentReplies(last: 1) {
          totalCount
          edges {
            node {
              id
              content
              commentType
              author {
                id
                auth0id
                provider {
                  providermetadata {
                    firstName
                    lastName
                  }
                }
                caregiver {
                  caregivermetadata {
                    firstName
                    lastName
                  }
                }
              }
              parentComment {
                id
              }
              createdDate
            }
          }
        }
        author {
          id
          auth0id
          provider {
            providermetadata {
              firstName
              lastName
            }
          }
          caregiver {
            caregivermetadata {
              firstName
              lastName
            }
          }
        }
        parentComment {
          id
        }
        media {
          id
        }
        mediaStartTime
        hasReplies
        createdDate
      }
    }
  }
}
    `;

export const useGetMediaCommentsByMediaIdQuery = <
      TData = GetMediaCommentsByMediaIdQuery,
      TError = unknown
    >(
      variables: GetMediaCommentsByMediaIdQueryVariables,
      options?: Omit<UseQueryOptions<GetMediaCommentsByMediaIdQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetMediaCommentsByMediaIdQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetMediaCommentsByMediaIdQuery, TError, TData>(
      {
    queryKey: ['GetMediaCommentsByMediaId', variables],
    queryFn: useCustomFetcher<GetMediaCommentsByMediaIdQuery, GetMediaCommentsByMediaIdQueryVariables>(GetMediaCommentsByMediaIdDocument).bind(null, variables),
    ...options
  }
    )};

export const GetMediaCommentRepliesDocument = `
    query getMediaCommentReplies($parentCommentId: ID!, $commentType: ApiMediaCommentsCommentTypeChoices) {
  getMediaCommentReplies(
    parentCommentId: $parentCommentId
    commentType: $commentType
  ) {
    totalCount
    edges {
      node {
        id
        content
        commentType
        author {
          id
          auth0id
          provider {
            providermetadata {
              firstName
              lastName
            }
          }
          caregiver {
            caregivermetadata {
              firstName
              lastName
            }
          }
        }
        parentComment {
          id
        }
        media {
          id
        }
        mediaStartTime
        hasReplies
        createdDate
      }
    }
  }
}
    `;

export const useGetMediaCommentRepliesQuery = <
      TData = GetMediaCommentRepliesQuery,
      TError = unknown
    >(
      variables: GetMediaCommentRepliesQueryVariables,
      options?: Omit<UseQueryOptions<GetMediaCommentRepliesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetMediaCommentRepliesQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetMediaCommentRepliesQuery, TError, TData>(
      {
    queryKey: ['getMediaCommentReplies', variables],
    queryFn: useCustomFetcher<GetMediaCommentRepliesQuery, GetMediaCommentRepliesQueryVariables>(GetMediaCommentRepliesDocument).bind(null, variables),
    ...options
  }
    )};

export const GetMediaTargetPredictionsDocument = `
    query GetMediaTargetPredictions($filter: MediaTargetPredictionFilter!) {
  getMediaTargetPredictions(filter: $filter) {
    edges {
      node {
        id
        createdDate
        startTime
        endTime
        rationale
        modalityType
        thumbnailUrl
        mediaTargetFeedbacks {
          edges {
            node {
              lastUpdatedDate
              isAccurate
            }
          }
        }
        goal {
          id
          name
        }
        target {
          id
          name
        }
        media {
          id
          filePath
          videoSession {
            therapySession {
              locationType
            }
            finalMedia {
              id
              createdDate
              totalDuration
              signedUploadUrl
            }
            sessioncaregiverSet {
              edges {
                node {
                  caregiver {
                    id
                    caregivermetadata {
                      firstName
                      lastName
                    }
                  }
                }
              }
            }
            sessionproviderSet {
              edges {
                node {
                  provider {
                    id
                    providermetadata {
                      firstName
                      lastName
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
    `;

export const useGetMediaTargetPredictionsQuery = <
      TData = GetMediaTargetPredictionsQuery,
      TError = unknown
    >(
      variables: GetMediaTargetPredictionsQueryVariables,
      options?: Omit<UseQueryOptions<GetMediaTargetPredictionsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetMediaTargetPredictionsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetMediaTargetPredictionsQuery, TError, TData>(
      {
    queryKey: ['GetMediaTargetPredictions', variables],
    queryFn: useCustomFetcher<GetMediaTargetPredictionsQuery, GetMediaTargetPredictionsQueryVariables>(GetMediaTargetPredictionsDocument).bind(null, variables),
    ...options
  }
    )};

export const GetMediaThumbnailManifestDocument = `
    query GetMediaThumbnailManifest($mediaId: ID!) {
  getMediaById(mediaId: $mediaId) {
    edges {
      node {
        id
        thumbnailManifest {
          thumbnails {
            url
            time
          }
        }
      }
    }
  }
}
    `;

export const useGetMediaThumbnailManifestQuery = <
      TData = GetMediaThumbnailManifestQuery,
      TError = unknown
    >(
      variables: GetMediaThumbnailManifestQueryVariables,
      options?: Omit<UseQueryOptions<GetMediaThumbnailManifestQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetMediaThumbnailManifestQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetMediaThumbnailManifestQuery, TError, TData>(
      {
    queryKey: ['GetMediaThumbnailManifest', variables],
    queryFn: useCustomFetcher<GetMediaThumbnailManifestQuery, GetMediaThumbnailManifestQueryVariables>(GetMediaThumbnailManifestDocument).bind(null, variables),
    ...options
  }
    )};

export const GetProvidersForSessionDocument = `
    query getProvidersForSession {
  getProvidersForSession {
    totalCount
    edges {
      node {
        id
        createdDate
        providermetadata {
          id
          firstName
          lastName
        }
        organizationuserrolesSet {
          edges {
            node {
              role
            }
          }
        }
      }
    }
  }
}
    `;

export const useGetProvidersForSessionQuery = <
      TData = GetProvidersForSessionQuery,
      TError = unknown
    >(
      variables?: GetProvidersForSessionQueryVariables,
      options?: Omit<UseQueryOptions<GetProvidersForSessionQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetProvidersForSessionQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetProvidersForSessionQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['getProvidersForSession'] : ['getProvidersForSession', variables],
    queryFn: useCustomFetcher<GetProvidersForSessionQuery, GetProvidersForSessionQueryVariables>(GetProvidersForSessionDocument).bind(null, variables),
    ...options
  }
    )};

export const GetSessionCaregiversDocument = `
    query getSessionCaregivers {
  getSessionCaregivers {
    edges {
      node {
        id
        caregivermetadata {
          firstName
          lastName
        }
      }
    }
  }
}
    `;

export const useGetSessionCaregiversQuery = <
      TData = GetSessionCaregiversQuery,
      TError = unknown
    >(
      variables?: GetSessionCaregiversQueryVariables,
      options?: Omit<UseQueryOptions<GetSessionCaregiversQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetSessionCaregiversQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetSessionCaregiversQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['getSessionCaregivers'] : ['getSessionCaregivers', variables],
    queryFn: useCustomFetcher<GetSessionCaregiversQuery, GetSessionCaregiversQueryVariables>(GetSessionCaregiversDocument).bind(null, variables),
    ...options
  }
    )};

export const GetSessionClientsDocument = `
    query getSessionClients($after: String) {
  sessionLearnersWithSessions(first: 20, after: $after) {
    pageInfo {
      hasNextPage
      startCursor
      endCursor
    }
    edges {
      node {
        id
        sessionLearners {
          id
          learnermetadata {
            firstName
            lastName
          }
        }
      }
    }
  }
}
    `;

export const useGetSessionClientsQuery = <
      TData = GetSessionClientsQuery,
      TError = unknown
    >(
      variables?: GetSessionClientsQueryVariables,
      options?: Omit<UseQueryOptions<GetSessionClientsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetSessionClientsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetSessionClientsQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['getSessionClients'] : ['getSessionClients', variables],
    queryFn: useCustomFetcher<GetSessionClientsQuery, GetSessionClientsQueryVariables>(GetSessionClientsDocument).bind(null, variables),
    ...options
  }
    )};

export const GetSessionSummaryBySessionIdDocument = `
    query getSessionSummaryBySessionId($videoSessionId: ID!) {
  getSessionSummaryBySessionId(videoSessionId: $videoSessionId) {
    videoSession {
      id
    }
    model
    version
    predictionType
    prediction
  }
}
    `;

export const useGetSessionSummaryBySessionIdQuery = <
      TData = GetSessionSummaryBySessionIdQuery,
      TError = unknown
    >(
      variables: GetSessionSummaryBySessionIdQueryVariables,
      options?: Omit<UseQueryOptions<GetSessionSummaryBySessionIdQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetSessionSummaryBySessionIdQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetSessionSummaryBySessionIdQuery, TError, TData>(
      {
    queryKey: ['getSessionSummaryBySessionId', variables],
    queryFn: useCustomFetcher<GetSessionSummaryBySessionIdQuery, GetSessionSummaryBySessionIdQueryVariables>(GetSessionSummaryBySessionIdDocument).bind(null, variables),
    ...options
  }
    )};

export const GetTranscriptDataByMediaIdDocument = `
    query getTranscriptDataByMediaId($mediaId: ID!, $after: String) {
  getTranscriptDataByMediaId(mediaId: $mediaId, after: $after, first: 400) {
    totalCount
    pageInfo {
      hasNextPage
      startCursor
      endCursor
    }
    edges {
      node {
        id
        startTime
        endTime
        conversation
        speaker
      }
    }
  }
}
    `;

export const useGetTranscriptDataByMediaIdQuery = <
      TData = GetTranscriptDataByMediaIdQuery,
      TError = unknown
    >(
      variables: GetTranscriptDataByMediaIdQueryVariables,
      options?: Omit<UseQueryOptions<GetTranscriptDataByMediaIdQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetTranscriptDataByMediaIdQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetTranscriptDataByMediaIdQuery, TError, TData>(
      {
    queryKey: ['getTranscriptDataByMediaId', variables],
    queryFn: useCustomFetcher<GetTranscriptDataByMediaIdQuery, GetTranscriptDataByMediaIdQueryVariables>(GetTranscriptDataByMediaIdDocument).bind(null, variables),
    ...options
  }
    )};

export const GetTranscriptCsvContentDocument = `
    query getTranscriptCsvContent($videoSessionId: ID!) {
  getTranscriptCsvContent(videoSessionId: $videoSessionId) {
    status
    message
    csvContent
    filename
  }
}
    `;

export const useGetTranscriptCsvContentQuery = <
      TData = GetTranscriptCsvContentQuery,
      TError = unknown
    >(
      variables: GetTranscriptCsvContentQueryVariables,
      options?: Omit<UseQueryOptions<GetTranscriptCsvContentQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetTranscriptCsvContentQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetTranscriptCsvContentQuery, TError, TData>(
      {
    queryKey: ['getTranscriptCsvContent', variables],
    queryFn: useCustomFetcher<GetTranscriptCsvContentQuery, GetTranscriptCsvContentQueryVariables>(GetTranscriptCsvContentDocument).bind(null, variables),
    ...options
  }
    )};

export const GetMediaByProviderDocument = `
    query GetMediaByProvider($learnerIds: [ID], $providerIds: [ID], $caregiverIds: [ID], $sessionRating: Int, $mediaStatus: MediaStatusEnumType, $sortBy: [MediaSortByEnum], $sessionStartDate: Date, $sessionEndDate: Date, $isReviewed: Boolean, $sessionStatus: [VideoSessionStatusEnums], $after: String) {
  getMediaByProvider(
    learnerIds: $learnerIds
    providerIds: $providerIds
    caregiverIds: $caregiverIds
    sessionRating: $sessionRating
    mediaStatus: $mediaStatus
    sortBy: $sortBy
    sessionStartDate: $sessionStartDate
    sessionEndDate: $sessionEndDate
    first: 21
    isViewed: $isReviewed
    sessionStatus: $sessionStatus
    after: $after
  ) {
    totalCount
    pageInfo {
      hasNextPage
      startCursor
      endCursor
    }
    edges {
      node {
        id
        mediaType
        mediaStatus
        isViewed
        totalDuration
        thumbnailManifest {
          mediaId
          intervalSeconds
          thumbnails {
            time
            url
          }
        }
        videoSession {
          id
          date
          createdDate
          sessionRating
          sessionStatus
          sessionaipredictionSet {
            edges {
              node {
                id
                prediction
              }
            }
          }
          sessioncaregiverSet {
            edges {
              node {
                caregiver {
                  id
                  caregivermetadata {
                    firstName
                    lastName
                  }
                }
              }
            }
          }
          sessionlearnerSet {
            edges {
              node {
                sessionLearners {
                  id
                  learnermetadata {
                    firstName
                    lastName
                  }
                }
              }
            }
          }
          sessionproviderSet {
            edges {
              node {
                provider {
                  id
                  providermetadata {
                    firstName
                    lastName
                  }
                }
              }
            }
          }
        }
        mediaClassifications {
          continuousInteractions {
            subclass
            totalDuration
            intervals {
              startTime
              endTime
              confidenceLevel
            }
          }
          nonContinuousInteractions {
            subclass
            interactionCount
            intervals {
              startTime
              endTime
              confidenceLevel
            }
          }
        }
        createdDate
        commentsCount
      }
    }
  }
}
    `;

export const useGetMediaByProviderQuery = <
      TData = GetMediaByProviderQuery,
      TError = unknown
    >(
      variables?: GetMediaByProviderQueryVariables,
      options?: Omit<UseQueryOptions<GetMediaByProviderQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetMediaByProviderQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetMediaByProviderQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['GetMediaByProvider'] : ['GetMediaByProvider', variables],
    queryFn: useCustomFetcher<GetMediaByProviderQuery, GetMediaByProviderQueryVariables>(GetMediaByProviderDocument).bind(null, variables),
    ...options
  }
    )};

export const GetMediaByProviderByMediaIdDocument = `
    query GetMediaByProviderByMediaId($mediaId: ID!) {
  getMediaByProviderByMediaId(mediaId: $mediaId) {
    id
    mediaType
    mediaStatus
    isViewed
    commentsCount
    signedUploadUrl
    mediaAttachmentUrl
    thumbnailManifest {
      mediaId
      intervalSeconds
      thumbnails {
        time
        url
      }
    }
    videoSession {
      id
      date
      sessionRating
      comment
      createdDate
      sessionlearnerSet {
        edges {
          node {
            sessionLearners {
              id
              learnermetadata {
                firstName
                lastName
              }
            }
          }
        }
      }
      sessioncaregiverSet {
        edges {
          node {
            caregiver {
              id
              caregivermetadata {
                firstName
                lastName
              }
            }
          }
        }
      }
      sessionproviderSet {
        edges {
          node {
            provider {
              id
              providermetadata {
                firstName
                lastName
              }
            }
          }
        }
      }
    }
    mediaClassifications {
      continuousInteractions {
        subclass
        totalDuration
        intervals {
          startTime
          endTime
          confidenceLevel
        }
      }
      nonContinuousInteractions {
        subclass
        interactionCount
        intervals {
          startTime
          endTime
          confidenceLevel
        }
      }
    }
    createdDate
    totalDuration
  }
}
    `;

export const useGetMediaByProviderByMediaIdQuery = <
      TData = GetMediaByProviderByMediaIdQuery,
      TError = unknown
    >(
      variables: GetMediaByProviderByMediaIdQueryVariables,
      options?: Omit<UseQueryOptions<GetMediaByProviderByMediaIdQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetMediaByProviderByMediaIdQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetMediaByProviderByMediaIdQuery, TError, TData>(
      {
    queryKey: ['GetMediaByProviderByMediaId', variables],
    queryFn: useCustomFetcher<GetMediaByProviderByMediaIdQuery, GetMediaByProviderByMediaIdQueryVariables>(GetMediaByProviderByMediaIdDocument).bind(null, variables),
    ...options
  }
    )};

export const GetProviderByEmailDocument = `
    query GetProviderByEmail($email: String!) {
  providerByEmail(email: $email) {
    id
    auth0User {
      auth0id
    }
    providermetadata {
      email
      firstName
      lastName
      organization {
        auth0OrganizationId
        id
      }
    }
    userRoles
  }
}
    `;

export const useGetProviderByEmailQuery = <
      TData = GetProviderByEmailQuery,
      TError = unknown
    >(
      variables: GetProviderByEmailQueryVariables,
      options?: Omit<UseQueryOptions<GetProviderByEmailQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetProviderByEmailQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetProviderByEmailQuery, TError, TData>(
      {
    queryKey: ['GetProviderByEmail', variables],
    queryFn: useCustomFetcher<GetProviderByEmailQuery, GetProviderByEmailQueryVariables>(GetProviderByEmailDocument).bind(null, variables),
    ...options
  }
    )};

export const GetNotificationOptOutsDocument = `
    query getNotificationOptOuts($first: Int, $after: String, $deliveryMethod: ApiNotificationOptOutDeliveryMethodChoices, $notificationType: ApiNotificationOptOutNotificationTypeChoices) {
  notificationOptOut(
    first: $first
    after: $after
    deliveryMethod: $deliveryMethod
    notificationType: $notificationType
  ) {
    edges {
      node {
        id
        deliveryMethod
        notificationType
        createdDate
        lastUpdatedDate
        user {
          id
          username
          email
        }
        organization {
          id
          name
        }
      }
      cursor
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
    totalCount
  }
}
    `;

export const useGetNotificationOptOutsQuery = <
      TData = GetNotificationOptOutsQuery,
      TError = unknown
    >(
      variables?: GetNotificationOptOutsQueryVariables,
      options?: Omit<UseQueryOptions<GetNotificationOptOutsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetNotificationOptOutsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetNotificationOptOutsQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['getNotificationOptOuts'] : ['getNotificationOptOuts', variables],
    queryFn: useCustomFetcher<GetNotificationOptOutsQuery, GetNotificationOptOutsQueryVariables>(GetNotificationOptOutsDocument).bind(null, variables),
    ...options
  }
    )};

export const GetNotificationsDocument = `
    query getNotifications($read: Boolean, $first: Int, $last: Int, $after: String, $before: String, $offset: Int) {
  getNotifications(
    read: $read
    first: $first
    last: $last
    after: $after
    before: $before
    offset: $offset
  ) {
    edges {
      node {
        id
        title
        description
        channel
        notificationType
        read
        payload
        createdDate
        lastUpdatedDate
        recipient {
          id
          username
          email
          firstName
          lastName
        }
        sender {
          id
          username
          email
          firstName
          lastName
        }
        organization {
          id
          name
        }
      }
      cursor
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
    totalCount
    totalUnread
  }
}
    `;

export const useGetNotificationsQuery = <
      TData = GetNotificationsQuery,
      TError = unknown
    >(
      variables?: GetNotificationsQueryVariables,
      options?: Omit<UseQueryOptions<GetNotificationsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetNotificationsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetNotificationsQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['getNotifications'] : ['getNotifications', variables],
    queryFn: useCustomFetcher<GetNotificationsQuery, GetNotificationsQueryVariables>(GetNotificationsDocument).bind(null, variables),
    ...options
  }
    )};

export const GetAllBaseSuggestionCriteriaDocument = `
    query GetAllBaseSuggestionCriteria {
  getAllBaseSuggestionCriteria {
    id
    name
    category
    content
    isBaseCriteria
  }
}
    `;

export const useGetAllBaseSuggestionCriteriaQuery = <
      TData = GetAllBaseSuggestionCriteriaQuery,
      TError = unknown
    >(
      variables?: GetAllBaseSuggestionCriteriaQueryVariables,
      options?: Omit<UseQueryOptions<GetAllBaseSuggestionCriteriaQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetAllBaseSuggestionCriteriaQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetAllBaseSuggestionCriteriaQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['GetAllBaseSuggestionCriteria'] : ['GetAllBaseSuggestionCriteria', variables],
    queryFn: useCustomFetcher<GetAllBaseSuggestionCriteriaQuery, GetAllBaseSuggestionCriteriaQueryVariables>(GetAllBaseSuggestionCriteriaDocument).bind(null, variables),
    ...options
  }
    )};

export const GetUserOrgnizationSuggestionConfigDocument = `
    query getUserOrgnizationSuggestionConfig {
  getUserOrgnizationDetails {
    suggestionCriteria {
      id
      enabled
      isVirtual
      suggestionCriteria {
        id
        name
        category
        content
        isBaseCriteria
        organizations {
          edges {
            node {
              organization {
                name
              }
            }
          }
        }
      }
    }
  }
}
    `;

export const useGetUserOrgnizationSuggestionConfigQuery = <
      TData = GetUserOrgnizationSuggestionConfigQuery,
      TError = unknown
    >(
      variables?: GetUserOrgnizationSuggestionConfigQueryVariables,
      options?: Omit<UseQueryOptions<GetUserOrgnizationSuggestionConfigQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetUserOrgnizationSuggestionConfigQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetUserOrgnizationSuggestionConfigQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['getUserOrgnizationSuggestionConfig'] : ['getUserOrgnizationSuggestionConfig', variables],
    queryFn: useCustomFetcher<GetUserOrgnizationSuggestionConfigQuery, GetUserOrgnizationSuggestionConfigQueryVariables>(GetUserOrgnizationSuggestionConfigDocument).bind(null, variables),
    ...options
  }
    )};

export const GetUserOrgnizationDetailsDocument = `
    query getUserOrgnizationDetails {
  getUserOrgnizationDetails {
    id
    name
    organizationType
    ehrIntegrationType
    manualEhrIntegration
    abExportTemplateName
    onboardingEnabled
    consentRequired
    ehrSyncCleared
    peerReviewEnabled
    notificationSettings {
      id
      reassessmentReminder
    }
  }
}
    `;

export const useGetUserOrgnizationDetailsQuery = <
      TData = GetUserOrgnizationDetailsQuery,
      TError = unknown
    >(
      variables?: GetUserOrgnizationDetailsQueryVariables,
      options?: Omit<UseQueryOptions<GetUserOrgnizationDetailsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetUserOrgnizationDetailsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetUserOrgnizationDetailsQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['getUserOrgnizationDetails'] : ['getUserOrgnizationDetails', variables],
    queryFn: useCustomFetcher<GetUserOrgnizationDetailsQuery, GetUserOrgnizationDetailsQueryVariables>(GetUserOrgnizationDetailsDocument).bind(null, variables),
    ...options
  }
    )};

export const PromptsDocument = `
    query Prompts($filter: PromptFilter!, $first: Int, $after: String) {
  prompts(filter: $filter, first: $first, after: $after) {
    totalCount
    edges {
      cursor
      node {
        id
        name
        key
        createdDate
        responseSchema
        sampleOutput
        lastUpdatedDate
      }
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
  }
}
    `;

export const usePromptsQuery = <
      TData = PromptsQuery,
      TError = unknown
    >(
      variables: PromptsQueryVariables,
      options?: Omit<UseQueryOptions<PromptsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<PromptsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<PromptsQuery, TError, TData>(
      {
    queryKey: ['Prompts', variables],
    queryFn: useCustomFetcher<PromptsQuery, PromptsQueryVariables>(PromptsDocument).bind(null, variables),
    ...options
  }
    )};

export const GetIntercomUserJwtDocument = `
    query getIntercomUserJwt {
  getLoginProvider {
    intercomUserJwt
  }
}
    `;

export const useGetIntercomUserJwtQuery = <
      TData = GetIntercomUserJwtQuery,
      TError = unknown
    >(
      variables?: GetIntercomUserJwtQueryVariables,
      options?: Omit<UseQueryOptions<GetIntercomUserJwtQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetIntercomUserJwtQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetIntercomUserJwtQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['getIntercomUserJwt'] : ['getIntercomUserJwt', variables],
    queryFn: useCustomFetcher<GetIntercomUserJwtQuery, GetIntercomUserJwtQueryVariables>(GetIntercomUserJwtDocument).bind(null, variables),
    ...options
  }
    )};

export const ProviderIntegrationsDocument = `
    query providerIntegrations {
  providerIntegrations {
    zoomIntegration {
      id
      isActive
      hasCloudRecording
    }
  }
}
    `;

export const useProviderIntegrationsQuery = <
      TData = ProviderIntegrationsQuery,
      TError = unknown
    >(
      variables?: ProviderIntegrationsQueryVariables,
      options?: Omit<UseQueryOptions<ProviderIntegrationsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<ProviderIntegrationsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<ProviderIntegrationsQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['providerIntegrations'] : ['providerIntegrations', variables],
    queryFn: useCustomFetcher<ProviderIntegrationsQuery, ProviderIntegrationsQueryVariables>(ProviderIntegrationsDocument).bind(null, variables),
    ...options
  }
    )};

export const GetLoginProviderDocument = `
    query getLoginProvider {
  getLoginProvider {
    id
    auth0User {
      id
    }
    hasEnteredVideoCaptureApp
    providermetadata {
      id
      onboardingCompleted
      firstName
      lastName
      email
      phoneNumber
      smsAgreement
      professionalTitle
      licenseNumber
      chatAvailability
      bio
      clinicalCredentials
      workingHoursStart
      workingHoursEnd
      timezone
    }
    profileImage {
      id
      signedS3ProviderFile
      status
    }
  }
}
    `;

export const useGetLoginProviderQuery = <
      TData = GetLoginProviderQuery,
      TError = unknown
    >(
      variables?: GetLoginProviderQueryVariables,
      options?: Omit<UseQueryOptions<GetLoginProviderQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetLoginProviderQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetLoginProviderQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['getLoginProvider'] : ['getLoginProvider', variables],
    queryFn: useCustomFetcher<GetLoginProviderQuery, GetLoginProviderQueryVariables>(GetLoginProviderDocument).bind(null, variables),
    ...options
  }
    )};

export const ProviderByIdDocument = `
    query providerById($providerId: ID!) {
  providerById(providerId: $providerId) {
    id
    archived
    createdDate
    userRoles
    auth0User {
      id
    }
    providermetadata {
      firstName
      lastName
      email
      gender
      specifyGender
      invitationId
      invitationStatus
      invitationCreatedAt
      invitationExpiresAt
      invitationUrl
    }
    organizationuserrolesSet {
      edges {
        node {
          id
          role
        }
      }
    }
    learnerproviderSet {
      edges {
        node {
          id
          learner {
            id
            archived
            learnermetadata {
              firstName
              lastName
              diagnosisAppointmentDate
              assessmentAppointmentDate
            }
            relationshipSet {
              edges {
                node {
                  caregiver {
                    caregivermetadata {
                      firstName
                      lastName
                      email
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
    `;

export const useProviderByIdQuery = <
      TData = ProviderByIdQuery,
      TError = unknown
    >(
      variables: ProviderByIdQueryVariables,
      options?: Omit<UseQueryOptions<ProviderByIdQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<ProviderByIdQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<ProviderByIdQuery, TError, TData>(
      {
    queryKey: ['providerById', variables],
    queryFn: useCustomFetcher<ProviderByIdQuery, ProviderByIdQueryVariables>(ProviderByIdDocument).bind(null, variables),
    ...options
  }
    )};

export const ProvidersDocument = `
    query providers {
  provider {
    id
    archived
    createdDate
    organizationuserrolesSet {
      edges {
        node {
          id
          role
        }
      }
    }
    providermetadata {
      firstName
      lastName
      gender
      email
      specifyGender
      invitationId
      invitationStatus
      invitationCreatedAt
      invitationExpiresAt
      invitationUrl
    }
    learnerproviderSet {
      edges {
        node {
          id
          learner {
            archived
            learnermetadata {
              firstName
              lastName
              diagnosisAppointmentDate
              assessmentAppointmentDate
            }
          }
        }
      }
    }
  }
}
    `;

export const useProvidersQuery = <
      TData = ProvidersQuery,
      TError = unknown
    >(
      variables?: ProvidersQueryVariables,
      options?: Omit<UseQueryOptions<ProvidersQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<ProvidersQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<ProvidersQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['providers'] : ['providers', variables],
    queryFn: useCustomFetcher<ProvidersQuery, ProvidersQueryVariables>(ProvidersDocument).bind(null, variables),
    ...options
  }
    )};

export const GetUserAccountDetailsDocument = `
    query getUserAccountDetails {
  getUserAccountDetails {
    pendingAssessment
    purchasedAssessment
  }
}
    `;

export const useGetUserAccountDetailsQuery = <
      TData = GetUserAccountDetailsQuery,
      TError = unknown
    >(
      variables?: GetUserAccountDetailsQueryVariables,
      options?: Omit<UseQueryOptions<GetUserAccountDetailsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetUserAccountDetailsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetUserAccountDetailsQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['getUserAccountDetails'] : ['getUserAccountDetails', variables],
    queryFn: useCustomFetcher<GetUserAccountDetailsQuery, GetUserAccountDetailsQueryVariables>(GetUserAccountDetailsDocument).bind(null, variables),
    ...options
  }
    )};

export const BillingDetailsDocument = `
    query BillingDetails($userStripeAccount: ID) {
  getUserBillingDetails(userStripeAccount: $userStripeAccount) {
    edges {
      node {
        transactionType
        amount
        createdDate
        paymentIntentId
        priceId
        quantity
        userStripeAccount {
          pendingAssessment
        }
      }
    }
  }
}
    `;

export const useBillingDetailsQuery = <
      TData = BillingDetailsQuery,
      TError = unknown
    >(
      variables?: BillingDetailsQueryVariables,
      options?: Omit<UseQueryOptions<BillingDetailsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<BillingDetailsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<BillingDetailsQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['BillingDetails'] : ['BillingDetails', variables],
    queryFn: useCustomFetcher<BillingDetailsQuery, BillingDetailsQueryVariables>(BillingDetailsDocument).bind(null, variables),
    ...options
  }
    )};

export const GetCardDetailsDocument = `
    query getCardDetails {
  getUserCardAndAssessmentDetails {
    userCardsDetails
  }
}
    `;

export const useGetCardDetailsQuery = <
      TData = GetCardDetailsQuery,
      TError = unknown
    >(
      variables?: GetCardDetailsQueryVariables,
      options?: Omit<UseQueryOptions<GetCardDetailsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetCardDetailsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetCardDetailsQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['getCardDetails'] : ['getCardDetails', variables],
    queryFn: useCustomFetcher<GetCardDetailsQuery, GetCardDetailsQueryVariables>(GetCardDetailsDocument).bind(null, variables),
    ...options
  }
    )};

export const GetProviderLearnersDocument = `
    query getProviderLearners($learnerName: String) {
  getProviderLearners(learnerName: $learnerName) {
    totalCount
    edges {
      node {
        id
        archived
        externalId
        createdBy {
          id
          email
        }
        learnermetadata {
          id
          firstName
          lastName
        }
        scraperlearnerimportstatusSet {
          edges {
            node {
              id
              status
            }
          }
        }
      }
    }
  }
}
    `;

export const useGetProviderLearnersQuery = <
      TData = GetProviderLearnersQuery,
      TError = unknown
    >(
      variables?: GetProviderLearnersQueryVariables,
      options?: Omit<UseQueryOptions<GetProviderLearnersQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetProviderLearnersQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetProviderLearnersQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['getProviderLearners'] : ['getProviderLearners', variables],
    queryFn: useCustomFetcher<GetProviderLearnersQuery, GetProviderLearnersQueryVariables>(GetProviderLearnersDocument).bind(null, variables),
    ...options
  }
    )};

export const LearnersDocument = `
    query learners {
  learner {
    id
    archived
    createdDate
    learnermetadata {
      firstName
      lastName
      diagnosisAppointmentDate
      assessmentAppointmentDate
      birthDate
    }
    formStatusForLearner {
      edges {
        node {
          formName
          status
          createdDate
        }
      }
    }
    learnerproviderSet {
      edges {
        node {
          provider {
            id
          }
        }
      }
    }
    relationshipSet {
      edges {
        node {
          isPrimary
          caregiver {
            id
            auth0User {
              auth0id
            }
            isAllowedAppAccess
            caregivermetadata {
              firstName
              lastName
              email
              phoneNumber1
              nearestLocation
            }
          }
          hasCaregiverConsent
        }
      }
    }
    hasCaregiverConsent
  }
}
    `;

export const useLearnersQuery = <
      TData = LearnersQuery,
      TError = unknown
    >(
      variables?: LearnersQueryVariables,
      options?: Omit<UseQueryOptions<LearnersQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<LearnersQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<LearnersQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['learners'] : ['learners', variables],
    queryFn: useCustomFetcher<LearnersQuery, LearnersQueryVariables>(LearnersDocument).bind(null, variables),
    ...options
  }
    )};

export const LearnerByIdDocument = `
    query learnerById($learnerId: ID!) {
  learnerById(learnerId: $learnerId) {
    id
    externalId
    archived
    createdDate
    lastUpdatedDate
    learnermetadata {
      id
      firstName
      lastName
      preferredName
      gender
      birthDate
      diagnosisAppointmentDate
      diagnosisPsychologist
      assessmentBcba
      assessmentAppointmentDate
      address
      addressLine2
      city
      state
      zip
      hasPreviousDiagnosis
    }
    learnerAvailability {
      edges {
        node {
          day
          timeOfDay
        }
      }
    }
    insuranceForLearner {
      edges {
        node {
          id
          insuranceType
          insurer
          inNetwork
        }
      }
    }
    formStatusForLearner {
      edges {
        node {
          formName
          status
          createdDate
        }
      }
    }
    relationshipSet {
      edges {
        node {
          id
          socialRelationship
          isPrimary
          hasCaregiverConsent
          caregiver {
            id
            hasEnteredVideoCaptureApp
            auth0User {
              auth0id
            }
            isAllowedAppAccess
            caregivermetadata {
              id
              firstName
              lastName
              email
              phoneNumber1
              phoneNumber2
              nearestLocation
              referralSource
              smsAgreement
              invitationId
              invitationStatus
              invitationCreatedAt
              invitationExpiresAt
              invitationUrl
            }
          }
        }
      }
    }
    learnerpayorSet {
      edges {
        node {
          id
          payorType
          isActive
          createdDate
        }
      }
    }
    learnerproviderSet {
      edges {
        node {
          id
          provider {
            id
            archived
            userRoles
            auth0User {
              auth0id
            }
            providermetadata {
              firstName
              lastName
              email
              invitationId
              invitationStatus
              invitationCreatedAt
              invitationExpiresAt
              invitationUrl
            }
          }
        }
      }
    }
  }
}
    `;

export const useLearnerByIdQuery = <
      TData = LearnerByIdQuery,
      TError = unknown
    >(
      variables: LearnerByIdQueryVariables,
      options?: Omit<UseQueryOptions<LearnerByIdQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<LearnerByIdQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<LearnerByIdQuery, TError, TData>(
      {
    queryKey: ['learnerById', variables],
    queryFn: useCustomFetcher<LearnerByIdQuery, LearnerByIdQueryVariables>(LearnerByIdDocument).bind(null, variables),
    ...options
  }
    )};

export const GetLearnerConsentDetailsDocument = `
    query getLearnerConsentDetails($learnerId: ID!) {
  learnerById(learnerId: $learnerId) {
    learnerconsentfilesSet {
      edges {
        node {
          id
          consentFile
          consentType
          signedConsentFileUrl
          lastUpdatedDate
          fileSizeInBytes
        }
      }
    }
  }
}
    `;

export const useGetLearnerConsentDetailsQuery = <
      TData = GetLearnerConsentDetailsQuery,
      TError = unknown
    >(
      variables: GetLearnerConsentDetailsQueryVariables,
      options?: Omit<UseQueryOptions<GetLearnerConsentDetailsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetLearnerConsentDetailsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetLearnerConsentDetailsQuery, TError, TData>(
      {
    queryKey: ['getLearnerConsentDetails', variables],
    queryFn: useCustomFetcher<GetLearnerConsentDetailsQuery, GetLearnerConsentDetailsQueryVariables>(GetLearnerConsentDetailsDocument).bind(null, variables),
    ...options
  }
    )};

export const OrganizationsDocument = `
    query organizations {
  organizations {
    edges {
      node {
        id
        name
      }
    }
  }
}
    `;

export const useOrganizationsQuery = <
      TData = OrganizationsQuery,
      TError = unknown
    >(
      variables?: OrganizationsQueryVariables,
      options?: Omit<UseQueryOptions<OrganizationsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<OrganizationsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<OrganizationsQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['organizations'] : ['organizations', variables],
    queryFn: useCustomFetcher<OrganizationsQuery, OrganizationsQueryVariables>(OrganizationsDocument).bind(null, variables),
    ...options
  }
    )};

export const QueryProductPriceDocument = `
    query queryProductPrice {
  getProductPriceList {
    price
    priceId
    productId
    productName
    quantity
  }
}
    `;

export const useQueryProductPriceQuery = <
      TData = QueryProductPriceQuery,
      TError = unknown
    >(
      variables?: QueryProductPriceQueryVariables,
      options?: Omit<UseQueryOptions<QueryProductPriceQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<QueryProductPriceQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<QueryProductPriceQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['queryProductPrice'] : ['queryProductPrice', variables],
    queryFn: useCustomFetcher<QueryProductPriceQuery, QueryProductPriceQueryVariables>(QueryProductPriceDocument).bind(null, variables),
    ...options
  }
    )};

export const RecommendationBankFoldersDocument = `
    query recommendationBankFolders($searchTerm: String) {
  getRecommendationBankFolders(searchTerm: $searchTerm) {
    userFolders {
      id
      name
      folderType
      recommendationsCount
    }
    organizationFolders {
      id
      name
      folderType
      recommendationsCount
    }
  }
}
    `;

export const useRecommendationBankFoldersQuery = <
      TData = RecommendationBankFoldersQuery,
      TError = unknown
    >(
      variables?: RecommendationBankFoldersQueryVariables,
      options?: Omit<UseQueryOptions<RecommendationBankFoldersQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<RecommendationBankFoldersQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<RecommendationBankFoldersQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['recommendationBankFolders'] : ['recommendationBankFolders', variables],
    queryFn: useCustomFetcher<RecommendationBankFoldersQuery, RecommendationBankFoldersQueryVariables>(RecommendationBankFoldersDocument).bind(null, variables),
    ...options
  }
    )};

export const GetRecommendationBankItemsDocument = `
    query getRecommendationBankItems($searchTerm: String) {
  getRecommendationBankItems(searchTerm: $searchTerm) {
    id
    folder {
      id
      name
      folderType
    }
    recommendationContent
    recommendationTitle
    recommendationCategory
  }
}
    `;

export const useGetRecommendationBankItemsQuery = <
      TData = GetRecommendationBankItemsQuery,
      TError = unknown
    >(
      variables?: GetRecommendationBankItemsQueryVariables,
      options?: Omit<UseQueryOptions<GetRecommendationBankItemsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetRecommendationBankItemsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetRecommendationBankItemsQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['getRecommendationBankItems'] : ['getRecommendationBankItems', variables],
    queryFn: useCustomFetcher<GetRecommendationBankItemsQuery, GetRecommendationBankItemsQueryVariables>(GetRecommendationBankItemsDocument).bind(null, variables),
    ...options
  }
    )};

export const GetExportReportDocumentDocument = `
    query getExportReportDocument($reportId: ID!, $exportType: ExportTypeEnum!) {
  exportReportDocument(reportId: $reportId, exportType: $exportType) {
    file
    fileName
  }
}
    `;

export const useGetExportReportDocumentQuery = <
      TData = GetExportReportDocumentQuery,
      TError = unknown
    >(
      variables: GetExportReportDocumentQueryVariables,
      options?: Omit<UseQueryOptions<GetExportReportDocumentQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetExportReportDocumentQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetExportReportDocumentQuery, TError, TData>(
      {
    queryKey: ['getExportReportDocument', variables],
    queryFn: useCustomFetcher<GetExportReportDocumentQuery, GetExportReportDocumentQueryVariables>(GetExportReportDocumentDocument).bind(null, variables),
    ...options
  }
    )};

export const GetReportTemplateSuggestionCriteriaDocument = `
    query getReportTemplateSuggestionCriteria($id: ID!) {
  getReportTemplate(id: $id) {
    id
    name
    suggestionCriteria {
      id
      enabled
      suggestionCriteria {
        id
        name
        category
        content
        reportTemplates {
          edges {
            node {
              reportTemplate {
                id
                name
              }
            }
          }
        }
      }
    }
  }
}
    `;

export const useGetReportTemplateSuggestionCriteriaQuery = <
      TData = GetReportTemplateSuggestionCriteriaQuery,
      TError = unknown
    >(
      variables: GetReportTemplateSuggestionCriteriaQueryVariables,
      options?: Omit<UseQueryOptions<GetReportTemplateSuggestionCriteriaQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetReportTemplateSuggestionCriteriaQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetReportTemplateSuggestionCriteriaQuery, TError, TData>(
      {
    queryKey: ['getReportTemplateSuggestionCriteria', variables],
    queryFn: useCustomFetcher<GetReportTemplateSuggestionCriteriaQuery, GetReportTemplateSuggestionCriteriaQueryVariables>(GetReportTemplateSuggestionCriteriaDocument).bind(null, variables),
    ...options
  }
    )};

export const ExportReportTemplateJsonDocument = `
    query exportReportTemplateJson($id: ID!) {
  exportReportTemplateJson(id: $id) {
    json
  }
}
    `;

export const useExportReportTemplateJsonQuery = <
      TData = ExportReportTemplateJsonQuery,
      TError = unknown
    >(
      variables: ExportReportTemplateJsonQueryVariables,
      options?: Omit<UseQueryOptions<ExportReportTemplateJsonQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<ExportReportTemplateJsonQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<ExportReportTemplateJsonQuery, TError, TData>(
      {
    queryKey: ['exportReportTemplateJson', variables],
    queryFn: useCustomFetcher<ExportReportTemplateJsonQuery, ExportReportTemplateJsonQueryVariables>(ExportReportTemplateJsonDocument).bind(null, variables),
    ...options
  }
    )};

export const ReportTemplateDocument = `
    query reportTemplate($reportTemplateId: ID!) {
  getReportTemplate(id: $reportTemplateId) {
    id
    name
    description
    reportType
    createdDate
    status
    lastUpdatedDate
    headerText
    footerText
    exportTemplateFont
    sampleStatus
    sampleFileSignedUrl
    templateLogoSignedUrl
    defaultLogoSignedUrl
    curriculum {
      id
      name
    }
    treatmentPlanTemplate {
      id
      aiGenerationConfig
      isGoalBankSuggestionsEnabled
      isAddTargetsEnabled
      templateFields {
        edges {
          node {
            id
            fieldIdentifier
            title
            fieldType
            rankOrder
            isRequired
            isEnabled
            isEditable
            content
            type
            reportGoalField
            reportTargetField
            domain {
              id
            }
          }
        }
      }
      domains {
        edges {
          node {
            id
            name
            description
            rankOrder
            templateFields {
              edges {
                node {
                  id
                  fieldIdentifier
                  title
                  fieldType
                  rankOrder
                  isRequired
                  isEditable
                  isEnabled
                  content
                  type
                  reportGoalField
                  reportTargetField
                }
              }
            }
          }
        }
      }
    }
    reportTemplateSections {
      edges {
        node {
          id
          key
          rankOrder
          pageLocation
          title
          inputDependency
          isDefault
          reportTemplateSectionFields {
            edges {
              node {
                id
                title
                rankOrder
                fieldType
                isRequired
                isAuditable
                content
                sampleData
                inputDependency
                isDefault
                prompt {
                  id
                  key
                  name
                }
              }
            }
          }
        }
      }
    }
  }
}
    `;

export const useReportTemplateQuery = <
      TData = ReportTemplateQuery,
      TError = unknown
    >(
      variables: ReportTemplateQueryVariables,
      options?: Omit<UseQueryOptions<ReportTemplateQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<ReportTemplateQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<ReportTemplateQuery, TError, TData>(
      {
    queryKey: ['reportTemplate', variables],
    queryFn: useCustomFetcher<ReportTemplateQuery, ReportTemplateQueryVariables>(ReportTemplateDocument).bind(null, variables),
    ...options
  }
    )};

export const ReportTemplateGlobalsDocument = `
    query reportTemplateGlobals($reportTemplateId: ID!) {
  getReportTemplateGlobals(id: $reportTemplateId) {
    edges {
      node {
        id
        title
        fieldIdentifier
        rankOrder
        fieldType
        isRequired
        content
        sampleData
        inputDependency
        prompt {
          id
          key
          name
        }
      }
    }
  }
}
    `;

export const useReportTemplateGlobalsQuery = <
      TData = ReportTemplateGlobalsQuery,
      TError = unknown
    >(
      variables: ReportTemplateGlobalsQueryVariables,
      options?: Omit<UseQueryOptions<ReportTemplateGlobalsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<ReportTemplateGlobalsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<ReportTemplateGlobalsQuery, TError, TData>(
      {
    queryKey: ['reportTemplateGlobals', variables],
    queryFn: useCustomFetcher<ReportTemplateGlobalsQuery, ReportTemplateGlobalsQueryVariables>(ReportTemplateGlobalsDocument).bind(null, variables),
    ...options
  }
    )};

export const ReportTemplateSampleStatusDocument = `
    query reportTemplateSampleStatus($reportTemplateId: ID!) {
  getReportTemplate(id: $reportTemplateId) {
    sampleStatus
    sampleFileSignedUrl
  }
}
    `;

export const useReportTemplateSampleStatusQuery = <
      TData = ReportTemplateSampleStatusQuery,
      TError = unknown
    >(
      variables: ReportTemplateSampleStatusQueryVariables,
      options?: Omit<UseQueryOptions<ReportTemplateSampleStatusQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<ReportTemplateSampleStatusQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<ReportTemplateSampleStatusQuery, TError, TData>(
      {
    queryKey: ['reportTemplateSampleStatus', variables],
    queryFn: useCustomFetcher<ReportTemplateSampleStatusQuery, ReportTemplateSampleStatusQueryVariables>(ReportTemplateSampleStatusDocument).bind(null, variables),
    ...options
  }
    )};

export const ReportTemplatesDocument = `
    query reportTemplates($first: Int, $after: String, $filter: GetReportTemplatesFilter!) {
  getReportTemplates(first: $first, after: $after, filter: $filter) {
    totalCount
    pageInfo {
      endCursor
      hasNextPage
    }
    edges {
      cursor
      node {
        id
        name
        description
        isBaseTemplate
        reportType
        payorType
        createdDate
        status
        lastUpdatedDate
      }
    }
  }
}
    `;

export const useReportTemplatesQuery = <
      TData = ReportTemplatesQuery,
      TError = unknown
    >(
      variables: ReportTemplatesQueryVariables,
      options?: Omit<UseQueryOptions<ReportTemplatesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<ReportTemplatesQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<ReportTemplatesQuery, TError, TData>(
      {
    queryKey: ['reportTemplates', variables],
    queryFn: useCustomFetcher<ReportTemplatesQuery, ReportTemplatesQueryVariables>(ReportTemplatesDocument).bind(null, variables),
    ...options
  }
    )};

export const AssessmentToolsDocument = `
    query assessmentTools($reportType: ReportTypeEnums!) {
  assessmentTools(reportType: $reportType) {
    id
    primary
    secondary
    categories
    multipleFileUpload
    supportedFileTypes
    supportedFileSource
    parsingSupported
  }
}
    `;

export const useAssessmentToolsQuery = <
      TData = AssessmentToolsQuery,
      TError = unknown
    >(
      variables: AssessmentToolsQueryVariables,
      options?: Omit<UseQueryOptions<AssessmentToolsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<AssessmentToolsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<AssessmentToolsQuery, TError, TData>(
      {
    queryKey: ['assessmentTools', variables],
    queryFn: useCustomFetcher<AssessmentToolsQuery, AssessmentToolsQueryVariables>(AssessmentToolsDocument).bind(null, variables),
    ...options
  }
    )};

export const GetRecentlyViewedReportsDocument = `
    query getRecentlyViewedReports($reportIds: [ID!]!) {
  getReports(filter: {reportIds: $reportIds}) {
    edges {
      node {
        id
        reportType
        reportStatus
        reportClientDetails {
          clientFirstName
          clientLastName
        }
        payorreportsubmissionSet {
          edges {
            node {
              id
              status
              submittedAt
              reviews {
                edges {
                  node {
                    id
                    status
                    createdDate
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
    `;

export const useGetRecentlyViewedReportsQuery = <
      TData = GetRecentlyViewedReportsQuery,
      TError = unknown
    >(
      variables: GetRecentlyViewedReportsQueryVariables,
      options?: Omit<UseQueryOptions<GetRecentlyViewedReportsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetRecentlyViewedReportsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetRecentlyViewedReportsQuery, TError, TData>(
      {
    queryKey: ['getRecentlyViewedReports', variables],
    queryFn: useCustomFetcher<GetRecentlyViewedReportsQuery, GetRecentlyViewedReportsQueryVariables>(GetRecentlyViewedReportsDocument).bind(null, variables),
    ...options
  }
    )};

export const GetReportReviewersDocument = `
    query getReportReviewers($reportId: ID!) {
  getReportReviewers(reportId: $reportId) {
    id
    createdDate
    type
    status
    reviewer {
      id
      firstName
      lastName
      email
    }
    statusLog {
      id
      createdDate
      status
      note
      actor {
        id
        firstName
        lastName
      }
    }
  }
}
    `;

export const useGetReportReviewersQuery = <
      TData = GetReportReviewersQuery,
      TError = unknown
    >(
      variables: GetReportReviewersQueryVariables,
      options?: Omit<UseQueryOptions<GetReportReviewersQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetReportReviewersQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetReportReviewersQuery, TError, TData>(
      {
    queryKey: ['getReportReviewers', variables],
    queryFn: useCustomFetcher<GetReportReviewersQuery, GetReportReviewersQueryVariables>(GetReportReviewersDocument).bind(null, variables),
    ...options
  }
    )};

export const GetReviewerCandidatesDocument = `
    query getReviewerCandidates($where: ProviderBoolExp, $first: Int, $includeInternal: Boolean) {
  getOrganizationProviders(
    where: $where
    first: $first
    includeInternal: $includeInternal
  ) {
    edges {
      node {
        id
        auth0User {
          id
        }
        organizationuserrolesSet {
          edges {
            node {
              role
            }
          }
        }
        providermetadata {
          id
          firstName
          lastName
          email
        }
      }
    }
  }
}
    `;

export const useGetReviewerCandidatesQuery = <
      TData = GetReviewerCandidatesQuery,
      TError = unknown
    >(
      variables?: GetReviewerCandidatesQueryVariables,
      options?: Omit<UseQueryOptions<GetReviewerCandidatesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetReviewerCandidatesQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetReviewerCandidatesQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['getReviewerCandidates'] : ['getReviewerCandidates', variables],
    queryFn: useCustomFetcher<GetReviewerCandidatesQuery, GetReviewerCandidatesQueryVariables>(GetReviewerCandidatesDocument).bind(null, variables),
    ...options
  }
    )};

export const GetCumulativeTargetsDocument = `
    query GetCumulativeTargets($filter: GetCumulativeTargetsFilter!) {
  getCumulativeTargets(filter: $filter) {
    date
    totalCount
  }
}
    `;

export const useGetCumulativeTargetsQuery = <
      TData = GetCumulativeTargetsQuery,
      TError = unknown
    >(
      variables: GetCumulativeTargetsQueryVariables,
      options?: Omit<UseQueryOptions<GetCumulativeTargetsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetCumulativeTargetsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetCumulativeTargetsQuery, TError, TData>(
      {
    queryKey: ['GetCumulativeTargets', variables],
    queryFn: useCustomFetcher<GetCumulativeTargetsQuery, GetCumulativeTargetsQueryVariables>(GetCumulativeTargetsDocument).bind(null, variables),
    ...options
  }
    )};

export const GetSessionTargetProgressDocument = `
    query GetSessionTargetProgress($filter: GetSessionProgressFilter!) {
  getSessionProgress(filter: $filter) {
    goalPhases {
      status
      date
    }
    goalEvents {
      text
      date
    }
    progress {
      targetId
      targetName
      progressType
      data {
        value
        date
      }
      phases {
        status
        date
      }
      events {
        text
        date
      }
    }
  }
}
    `;

export const useGetSessionTargetProgressQuery = <
      TData = GetSessionTargetProgressQuery,
      TError = unknown
    >(
      variables: GetSessionTargetProgressQueryVariables,
      options?: Omit<UseQueryOptions<GetSessionTargetProgressQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetSessionTargetProgressQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetSessionTargetProgressQuery, TError, TData>(
      {
    queryKey: ['GetSessionTargetProgress', variables],
    queryFn: useCustomFetcher<GetSessionTargetProgressQuery, GetSessionTargetProgressQueryVariables>(GetSessionTargetProgressDocument).bind(null, variables),
    ...options
  }
    )};

export const GetPayorReportSubmissionStatusByReportIdDocument = `
    query getPayorReportSubmissionStatusByReportId($reportId: ID!) {
  getPayorReportSubmissionsByReportId(reportId: $reportId) {
    edges {
      node {
        id
        jobId
        status
      }
    }
  }
}
    `;

export const useGetPayorReportSubmissionStatusByReportIdQuery = <
      TData = GetPayorReportSubmissionStatusByReportIdQuery,
      TError = unknown
    >(
      variables: GetPayorReportSubmissionStatusByReportIdQueryVariables,
      options?: Omit<UseQueryOptions<GetPayorReportSubmissionStatusByReportIdQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetPayorReportSubmissionStatusByReportIdQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetPayorReportSubmissionStatusByReportIdQuery, TError, TData>(
      {
    queryKey: ['getPayorReportSubmissionStatusByReportId', variables],
    queryFn: useCustomFetcher<GetPayorReportSubmissionStatusByReportIdQuery, GetPayorReportSubmissionStatusByReportIdQueryVariables>(GetPayorReportSubmissionStatusByReportIdDocument).bind(null, variables),
    ...options
  }
    )};

export const GetPayorReportSubmissionWorkflowStatusDocument = `
    query getPayorReportSubmissionWorkflowStatus($reportSubmissionId: ID!) {
  getPayorReportSubmissionStatus(reportSubmissionJobId: $reportSubmissionId) {
    jobId
    status
  }
}
    `;

export const useGetPayorReportSubmissionWorkflowStatusQuery = <
      TData = GetPayorReportSubmissionWorkflowStatusQuery,
      TError = unknown
    >(
      variables: GetPayorReportSubmissionWorkflowStatusQueryVariables,
      options?: Omit<UseQueryOptions<GetPayorReportSubmissionWorkflowStatusQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetPayorReportSubmissionWorkflowStatusQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetPayorReportSubmissionWorkflowStatusQuery, TError, TData>(
      {
    queryKey: ['getPayorReportSubmissionWorkflowStatus', variables],
    queryFn: useCustomFetcher<GetPayorReportSubmissionWorkflowStatusQuery, GetPayorReportSubmissionWorkflowStatusQueryVariables>(GetPayorReportSubmissionWorkflowStatusDocument).bind(null, variables),
    ...options
  }
    )};

export const GetReportReviewItemsDocument = `
    query getReportReviewItems($reportId: ID!, $filter: ReportReviewItemFilterInput) {
  getReportReviewItems(reportId: $reportId, filter: $filter) {
    ...ReviewItemFields
  }
}
    ${ReviewItemFieldsFragmentDoc}`;

export const useGetReportReviewItemsQuery = <
      TData = GetReportReviewItemsQuery,
      TError = unknown
    >(
      variables: GetReportReviewItemsQueryVariables,
      options?: Omit<UseQueryOptions<GetReportReviewItemsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetReportReviewItemsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetReportReviewItemsQuery, TError, TData>(
      {
    queryKey: ['getReportReviewItems', variables],
    queryFn: useCustomFetcher<GetReportReviewItemsQuery, GetReportReviewItemsQueryVariables>(GetReportReviewItemsDocument).bind(null, variables),
    ...options
  }
    )};

export const GetSuggestionWorkflowStatusDocument = `
    query getSuggestionWorkflowStatus($reportId: ID!, $filter: GetReportsFilter!) {
  getReports(id: $reportId, filter: $filter) {
    edges {
      node {
        id
        suggestionGenerationStatus
      }
    }
  }
}
    `;

export const useGetSuggestionWorkflowStatusQuery = <
      TData = GetSuggestionWorkflowStatusQuery,
      TError = unknown
    >(
      variables: GetSuggestionWorkflowStatusQueryVariables,
      options?: Omit<UseQueryOptions<GetSuggestionWorkflowStatusQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetSuggestionWorkflowStatusQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetSuggestionWorkflowStatusQuery, TError, TData>(
      {
    queryKey: ['getSuggestionWorkflowStatus', variables],
    queryFn: useCustomFetcher<GetSuggestionWorkflowStatusQuery, GetSuggestionWorkflowStatusQueryVariables>(GetSuggestionWorkflowStatusDocument).bind(null, variables),
    ...options
  }
    )};

export const GetReportByIdDocument = `
    query getReportById($reportId: ID!, $filter: GetReportsFilter!) {
  getReports(id: $reportId, filter: $filter) {
    totalCount
    edges {
      node {
        id
        createdDate
        lastUpdatedDate
        reportStatus
        extendedStatus
        reportPdfFileSignedUrl
        reportDocxFileSignedUrl
        reportType
        headerPageHeading
        isArchive
        reportMetaData
        reportWriter
        completionDate
        previousReportStartDate
        previousReportEndDate
        previousReportSubmittedDate
        ehrSync
        narrativeMappingInProgress
        ehrSyncAlerts {
          importAlert {
            error
            userMessage
            warnings {
              description
              affectedItems {
                message
              }
            }
          }
          exportAlert {
            error
            userMessage
            warnings {
              description
              affectedItems {
                message
              }
            }
          }
        }
        learner {
          id
          externalId
        }
        createdBy {
          id
          provider {
            id
            providermetadata {
              id
              firstName
              lastName
            }
          }
        }
        reportFiles {
          edges {
            node {
              createdDate
              id
              originalFileName
              fileKind
              status
              mimeType
              fileSize
              metadata
              assessmentTemplateType
              signedS3LearnerFile
              pdfPreviewStatus
              pdfPreviewSignedUrl
              processingFailureReason
              processingFailureCode
              parentFile {
                id
              }
            }
          }
        }
        reportClientDetails {
          id
          clientFirstName
          clientLastName
          guardianFirstName
          guardianLastName
          guardian2FirstName
          guardian2LastName
          birthDate
          address
          addressLine2
          city
          state
          zip
          gender
          specifyGender
        }
        reportTreatmentPlanPrioritizeFields {
          safetyConcerns
          familyLife
          engagementAbility
          communicationAbility
          socialDesires
          additionalUserDetails
        }
        reportTreatmentPlan {
          aiLtgPredictionStatus
          aiStgPredictionStatus
          aiTargetPredictionStatus
          aiGoalProgressSummaryPredictionStatus
          aiGoalSuggestionStatus
          failureReason
          reportdomainSet {
            edges {
              node {
                id
                createdDate
                name
                description
              }
            }
          }
          reportgoalSet {
            edges {
              node {
                id
                reportDomain {
                  id
                }
                assessmentToolSource
                baselineDate
                generalizationCriteria
                rationale
                createdDate
                goalName
                programGoal
                description
                timelineEstimationType
                timelineEstimationValue
                baselineData
                aiGoalAttainmentScalePredictionStatus
                gasLevel1
                gasLevel3
                gasLevel4
                gasMatchStatus
                gasMatchMessage
                masteryCriteria
                hasMedicalNecessity
                medicalNecessityCriteria
                status
                goalType
                tags
                progressSummary
                inUse
                aiGenerated
              }
            }
          }
        }
        reportSections {
          edges {
            node {
              id
              title
              aiGeneratedStatus
              lastUpdatedDate
              rankOrder
              sectionIdentifier
              pageLocation
              previousPageLocation
              sectionField {
                edges {
                  node {
                    id
                    fieldType
                    title
                    content
                    aiGenerated
                    rankOrder
                    imageSignedUrl
                    fieldIdentifier
                    imageContentBase64
                    aiSources
                    templateSectionField {
                      isRequired
                      inputDependency
                    }
                    aiSectionField {
                      templateSectionField {
                        prompt {
                          id
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
        payorreportsubmissionSet {
          edges {
            node {
              id
              status
              submittedAt
              reviews {
                edges {
                  node {
                    id
                    status
                    createdDate
                    feedback
                    feedbackFilePath
                    feedbackFileSignedUrl
                  }
                }
              }
            }
          }
        }
        reportTemplate {
          id
          name
          reportType
          payorType
          exportTemplateFont
          templateUrl
          templateResolvedUrl
          exportFramework
          unifiedExport
          isBaseTemplate
          organizationLogoAllowed
          fileUploadConfig
          templateLogoSignedUrl
          requireAllQaResolved
          requireApprovalBeforeExport
          finalApproverWaitsForReviewers
          treatmentPlanTemplate {
            isGasEnabled
            isAddTargetsEnabled
          }
          reportTemplateSections {
            edges {
              node {
                id
                pageLocation
                reportTemplateSectionFields {
                  totalCount
                }
              }
            }
          }
        }
        organization {
          organizationType
          templateLogoSignedUrl
          requireAllQaResolved
          peerReviewEnabled
          requireApprovalBeforeExport
          finalApproverWaitsForReviewers
        }
        suggestionGenerationStatus
      }
    }
  }
}
    `;

export const useGetReportByIdQuery = <
      TData = GetReportByIdQuery,
      TError = unknown
    >(
      variables: GetReportByIdQueryVariables,
      options?: Omit<UseQueryOptions<GetReportByIdQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetReportByIdQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetReportByIdQuery, TError, TData>(
      {
    queryKey: ['getReportById', variables],
    queryFn: useCustomFetcher<GetReportByIdQuery, GetReportByIdQueryVariables>(GetReportByIdDocument).bind(null, variables),
    ...options
  }
    )};

export const GetReportsDocument = `
    query getReports($first: Int, $after: String, $filter: GetReportsFilter!, $records: Int) {
  getReports(first: $first, after: $after, filter: $filter, last: $records) {
    totalCount
    pageInfo {
      endCursor
      hasNextPage
    }
    edges {
      cursor
      node {
        id
        reportTemplate {
          id
          name
          isBaseTemplate
          organizationLogoAllowed
          fileUploadConfig
          payorType
        }
        payorreportsubmissionSet {
          edges {
            node {
              id
              status
              submittedAt
              reviews {
                edges {
                  node {
                    id
                    status
                    createdDate
                  }
                }
              }
            }
          }
        }
        createdDate
        lastUpdatedDate
        reportStatus
        extendedStatus
        ehrSync
        reportType
        headerPageHeading
        isArchive
        reportMetaData
        learner {
          id
        }
        organization {
          templateLogoSignedUrl
        }
        reportTreatmentPlan {
          aiLtgPredictionStatus
          aiStgPredictionStatus
          aiTargetPredictionStatus
          aiGoalProgressSummaryPredictionStatus
        }
        reportFiles {
          edges {
            node {
              id
              fileKind
              status
              processingFailureReason
            }
          }
        }
        reportWriter
        createdBy {
          id
          provider {
            providermetadata {
              firstName
              lastName
            }
          }
        }
        reportClientDetails {
          id
          clientFirstName
          clientLastName
        }
        reportTreatmentPlanPrioritizeFields {
          safetyConcerns
          familyLife
          engagementAbility
          communicationAbility
          socialDesires
          additionalUserDetails
        }
        reportSections {
          edges {
            node {
              id
              aiGeneratedStatus
              lastUpdatedDate
              pageLocation
              previousPageLocation
            }
          }
        }
      }
    }
  }
}
    `;

export const useGetReportsQuery = <
      TData = GetReportsQuery,
      TError = unknown
    >(
      variables: GetReportsQueryVariables,
      options?: Omit<UseQueryOptions<GetReportsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetReportsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetReportsQuery, TError, TData>(
      {
    queryKey: ['getReports', variables],
    queryFn: useCustomFetcher<GetReportsQuery, GetReportsQueryVariables>(GetReportsDocument).bind(null, variables),
    ...options
  }
    )};

export const GetReportsWithReviewStateDocument = `
    query getReportsWithReviewState($first: Int, $after: String, $filter: GetReportsFilter!, $records: Int) {
  getReports(first: $first, after: $after, filter: $filter, last: $records) {
    totalCount
    pageInfo {
      endCursor
      hasNextPage
    }
    edges {
      cursor
      node {
        id
        reportTemplate {
          id
          name
          isBaseTemplate
          organizationLogoAllowed
          fileUploadConfig
          payorType
        }
        payorreportsubmissionSet {
          edges {
            node {
              id
              status
              submittedAt
              reviews {
                edges {
                  node {
                    id
                    status
                    createdDate
                  }
                }
              }
            }
          }
        }
        createdDate
        lastUpdatedDate
        reportStatus
        extendedStatus
        ehrSync
        reportType
        myReviewState
        headerPageHeading
        isArchive
        reportMetaData
        learner {
          id
        }
        organization {
          templateLogoSignedUrl
        }
        reportTreatmentPlan {
          aiLtgPredictionStatus
          aiStgPredictionStatus
          aiTargetPredictionStatus
          aiGoalProgressSummaryPredictionStatus
        }
        reportFiles {
          edges {
            node {
              id
              fileKind
              status
              processingFailureReason
            }
          }
        }
        reportWriter
        createdBy {
          id
          provider {
            providermetadata {
              firstName
              lastName
            }
          }
        }
        reportClientDetails {
          id
          clientFirstName
          clientLastName
        }
        reportTreatmentPlanPrioritizeFields {
          safetyConcerns
          familyLife
          engagementAbility
          communicationAbility
          socialDesires
          additionalUserDetails
        }
        reportSections {
          edges {
            node {
              id
              aiGeneratedStatus
              lastUpdatedDate
              pageLocation
              previousPageLocation
            }
          }
        }
      }
    }
  }
}
    `;

export const useGetReportsWithReviewStateQuery = <
      TData = GetReportsWithReviewStateQuery,
      TError = unknown
    >(
      variables: GetReportsWithReviewStateQueryVariables,
      options?: Omit<UseQueryOptions<GetReportsWithReviewStateQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetReportsWithReviewStateQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetReportsWithReviewStateQuery, TError, TData>(
      {
    queryKey: ['getReportsWithReviewState', variables],
    queryFn: useCustomFetcher<GetReportsWithReviewStateQuery, GetReportsWithReviewStateQueryVariables>(GetReportsWithReviewStateDocument).bind(null, variables),
    ...options
  }
    )};

export const GetReassessmentEhrGoalsDocument = `
    query getReassessmentEhrGoals($reportId: ID!) {
  reassessmentEhrGoals(reportId: $reportId) {
    goalId
    title
    lastUpdatedDate
    status
    reportGoalCreated
    ehrTargets {
      targetId
      title
      lastUpdatedDate
      status
      reportTargetExcluded
    }
  }
}
    `;

export const useGetReassessmentEhrGoalsQuery = <
      TData = GetReassessmentEhrGoalsQuery,
      TError = unknown
    >(
      variables: GetReassessmentEhrGoalsQueryVariables,
      options?: Omit<UseQueryOptions<GetReassessmentEhrGoalsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetReassessmentEhrGoalsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetReassessmentEhrGoalsQuery, TError, TData>(
      {
    queryKey: ['getReassessmentEhrGoals', variables],
    queryFn: useCustomFetcher<GetReassessmentEhrGoalsQuery, GetReassessmentEhrGoalsQueryVariables>(GetReassessmentEhrGoalsDocument).bind(null, variables),
    ...options
  }
    )};

export const GetTargetsDocument = `
    query getTargets($filter: GetTargetsFilter!) {
  getReportTargets(filter: $filter) {
    edges {
      node {
        id
        aiGenerated
        inUse
        baselineData
        completionDate
        createdDate
        excludeFromReport
        lastUpdatedDate
        masteryCriteria
        progressSummary
        status
        targetDescription
        targetName
        timelineEstimationType
        timelineEstimationValue
      }
    }
  }
}
    `;

export const useGetTargetsQuery = <
      TData = GetTargetsQuery,
      TError = unknown
    >(
      variables: GetTargetsQueryVariables,
      options?: Omit<UseQueryOptions<GetTargetsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetTargetsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetTargetsQuery, TError, TData>(
      {
    queryKey: ['getTargets', variables],
    queryFn: useCustomFetcher<GetTargetsQuery, GetTargetsQueryVariables>(GetTargetsDocument).bind(null, variables),
    ...options
  }
    )};

export const GetReportTreatmentPlanByReportIdDocument = `
    query getReportTreatmentPlanByReportId($reportId: ID!, $filter: GetReportsFilter!) {
  getReports(id: $reportId, filter: $filter) {
    totalCount
    edges {
      node {
        id
        reportStatus
        reportTreatmentPlan {
          reportgoalSet {
            edges {
              node {
                id
                goal {
                  id
                }
                createdDate
                assessmentToolSource
                baselineDate
                generalizationCriteria
                rationale
                goalName
                goalType
                status
                programGoal
                description
                timelineEstimationType
                timelineEstimationValue
                baselineData
                masteryCriteria
                hasMedicalNecessity
                medicalNecessityCriteria
                generalizationCriteria
                aiGoalAttainmentScalePredictionStatus
                gasLevel1
                gasLevel3
                gasLevel4
                rationale
                progressSummary
                summaryReviewed
                summaryReviewedOn
                goalBank {
                  id
                }
                reportDomain {
                  id
                  name
                }
                reporttargetSet {
                  edges {
                    node {
                      id
                      aiGenerated
                      createdDate
                      lastUpdatedDate
                      targetName
                      status
                      targetDescription
                      timelineEstimationValue
                      timelineEstimationType
                      masteryCriteria
                      baselineData
                      progressSummary
                      summaryReviewed
                      summaryReviewedOn
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
    `;

export const useGetReportTreatmentPlanByReportIdQuery = <
      TData = GetReportTreatmentPlanByReportIdQuery,
      TError = unknown
    >(
      variables: GetReportTreatmentPlanByReportIdQueryVariables,
      options?: Omit<UseQueryOptions<GetReportTreatmentPlanByReportIdQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetReportTreatmentPlanByReportIdQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetReportTreatmentPlanByReportIdQuery, TError, TData>(
      {
    queryKey: ['getReportTreatmentPlanByReportId', variables],
    queryFn: useCustomFetcher<GetReportTreatmentPlanByReportIdQuery, GetReportTreatmentPlanByReportIdQueryVariables>(GetReportTreatmentPlanByReportIdDocument).bind(null, variables),
    ...options
  }
    )};

export const GetReassessmentReportGoalsDocument = `
    query getReassessmentReportGoals($first: Int, $after: String, $filter: GetReassessmentReportGoalsFilter!) {
  getReassessmentReportGoals(first: $first, after: $after, filter: $filter) {
    totalCount
    totalNeedReview
    pageInfo {
      endCursor
      hasNextPage
    }
    edges {
      cursor
      node {
        id
        goal {
          id
          rankOrder
        }
        reportDomain {
          id
          name
        }
        createdDate
        assessmentToolSource
        baselineDate
        goalName
        programGoal
        description
        timelineEstimationType
        timelineEstimationValue
        aiGoalAttainmentScalePredictionStatus
        gasLevel1
        gasLevel3
        gasLevel4
        gasMatchStatus
        gasMatchMessage
        gasScore
        completionDate
        projectedIntroductionDate
        baselineData
        masteryCriteria
        hasMedicalNecessity
        medicalNecessityCriteria
        generalizationCriteria
        rationale
        status
        goalType
        goalSubType
        tags
        progressSummary
        summaryReviewed
        summaryReviewedOn
        excludeFromReport
        chartType
        goalBank {
          id
        }
        signedChartImageUrl
        customFields {
          edges {
            node {
              id
              fieldIdentifier
              fieldType
              title
              content
              rankOrder
              imageSignedUrl
            }
          }
        }
        reporttargetSet {
          edges {
            node {
              id
              aiGenerated
              inUse
              createdDate
              lastUpdatedDate
              targetName
              targetDescription
              timelineEstimationValue
              timelineEstimationType
              completionDate
              masteryCriteria
              baselineData
              status
              progressSummary
              excludeFromReport
              signedChartImageUrl
              summaryReviewed
              projectedIntroductionDate
              customFields {
                edges {
                  node {
                    id
                    fieldIdentifier
                    fieldType
                    title
                    content
                    rankOrder
                    imageSignedUrl
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
    `;

export const useGetReassessmentReportGoalsQuery = <
      TData = GetReassessmentReportGoalsQuery,
      TError = unknown
    >(
      variables: GetReassessmentReportGoalsQueryVariables,
      options?: Omit<UseQueryOptions<GetReassessmentReportGoalsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetReassessmentReportGoalsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetReassessmentReportGoalsQuery, TError, TData>(
      {
    queryKey: ['getReassessmentReportGoals', variables],
    queryFn: useCustomFetcher<GetReassessmentReportGoalsQuery, GetReassessmentReportGoalsQueryVariables>(GetReassessmentReportGoalsDocument).bind(null, variables),
    ...options
  }
    )};

export const TreatmentPlanTemplateDocument = `
    query treatmentPlanTemplate($reportId: ID!) {
  treatmentPlanTemplate(reportId: $reportId) {
    isGasEnabled
    isMedicalNecessityEnabled
    aiGenerationConfig
    isAddTargetsEnabled
    isGoalBankSuggestionsEnabled
    templateFields {
      edges {
        node {
          id
          fieldIdentifier
          title
          fieldType
          rankOrder
          isRequired
          isEnabled
          content
          type
          reportGoalField
          reportTargetField
          domain {
            id
            name
          }
        }
      }
    }
  }
}
    `;

export const useTreatmentPlanTemplateQuery = <
      TData = TreatmentPlanTemplateQuery,
      TError = unknown
    >(
      variables: TreatmentPlanTemplateQueryVariables,
      options?: Omit<UseQueryOptions<TreatmentPlanTemplateQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<TreatmentPlanTemplateQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<TreatmentPlanTemplateQuery, TError, TData>(
      {
    queryKey: ['treatmentPlanTemplate', variables],
    queryFn: useCustomFetcher<TreatmentPlanTemplateQuery, TreatmentPlanTemplateQueryVariables>(TreatmentPlanTemplateDocument).bind(null, variables),
    ...options
  }
    )};

export const ReportExportDataDocument = `
    query reportExportData($reportId: ID!) {
  reportExportData(reportId: $reportId) {
    dateOfReport
    reportWriter
    templateLogoSignedUrl
    organizationLogoSignedUrl
    organizationLogoAllowed
    organizationName
    clientDetails {
      clientFirstName
      clientLastName
      clientName
      dateOfBirth
      age
      gender
      guardianName
      guardian2FullName
      guardian2FirstName
      guardian2LastName
      guardian2Phone
      caregiverNames
      address
      city
      state
      zip
    }
    signatureSection {
      signatureName
      licenseNumber
      practitionerEmail
      professionalTitle
      signatureDate
    }
    goalGroups {
      goalType
      goals {
        assessmentToolSource
        baselineData
        baselineDate
        medicalNecessityCriteria
        programGoal
        generalizationCriteria
        rationale
        goalName
        masteryCriteria
        expectedMasteryDate
        targets {
          name
          masteryCriteria
          baselineData
          masteryDate
        }
      }
    }
    sections {
      key
      title
      rankOrder
      pageLocation
      fields {
        field_identifier
        title
        content
        field_type
      }
    }
  }
}
    `;

export const useReportExportDataQuery = <
      TData = ReportExportDataQuery,
      TError = unknown
    >(
      variables: ReportExportDataQueryVariables,
      options?: Omit<UseQueryOptions<ReportExportDataQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<ReportExportDataQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<ReportExportDataQuery, TError, TData>(
      {
    queryKey: ['reportExportData', variables],
    queryFn: useCustomFetcher<ReportExportDataQuery, ReportExportDataQueryVariables>(ReportExportDataDocument).bind(null, variables),
    ...options
  }
    )};

export const ReportFronteraEhrClientExportDocument = `
    query reportFronteraEhrClientExport($reportId: ID!, $filter: GetReportsFilter!) {
  getReports(id: $reportId, filter: $filter) {
    edges {
      node {
        id
        fronteraEhrClientExport {
          status
          message
        }
        learner {
          id
          externalId
        }
      }
    }
  }
}
    `;

export const useReportFronteraEhrClientExportQuery = <
      TData = ReportFronteraEhrClientExportQuery,
      TError = unknown
    >(
      variables: ReportFronteraEhrClientExportQueryVariables,
      options?: Omit<UseQueryOptions<ReportFronteraEhrClientExportQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<ReportFronteraEhrClientExportQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<ReportFronteraEhrClientExportQuery, TError, TData>(
      {
    queryKey: ['reportFronteraEhrClientExport', variables],
    queryFn: useCustomFetcher<ReportFronteraEhrClientExportQuery, ReportFronteraEhrClientExportQueryVariables>(ReportFronteraEhrClientExportDocument).bind(null, variables),
    ...options
  }
    )};

export const ReportGoalsDocument = `
    query reportGoals($id: ID!, $filter: GetReportsFilter!) {
  getReports(id: $id, filter: $filter) {
    edges {
      node {
        reportTreatmentPlan {
          reportgoalSet {
            edges {
              node {
                id
                goalName
                inUse
                reportDomain {
                  id
                }
              }
            }
          }
          reportdomainSet {
            edges {
              node {
                id
                createdDate
                name
                description
                rankOrder
                reportgoalSet {
                  edges {
                    node {
                      id
                      createdDate
                      lastUpdatedDate
                      assessmentToolSource
                      baselineDate
                      projectedIntroductionDate
                      completionDate
                      goalName
                      programGoal
                      description
                      timelineEstimationType
                      timelineEstimationValue
                      baselineData
                      masteryCriteria
                      hasMedicalNecessity
                      medicalNecessityCriteria
                      generalizationCriteria
                      aiGoalAttainmentScalePredictionStatus
                      gasLevel1
                      gasLevel3
                      gasLevel4
                      gasScore
                      rationale
                      status
                      goalType
                      tags
                      progressSummary
                      aiGenerated
                      inUse
                      goalBank {
                        id
                      }
                      customFields {
                        edges {
                          node {
                            id
                            fieldIdentifier
                            fieldType
                            title
                            content
                            rankOrder
                            imageSignedUrl
                          }
                        }
                      }
                      reporttargetSet {
                        edges {
                          node {
                            id
                            aiGenerated
                            inUse
                            excludeFromReport
                            createdDate
                            lastUpdatedDate
                            targetName
                            targetDescription
                            timelineEstimationValue
                            timelineEstimationType
                            masteryCriteria
                            baselineData
                            status
                            progressSummary
                            completionDate
                            projectedIntroductionDate
                            customFields {
                              edges {
                                node {
                                  id
                                  fieldIdentifier
                                  fieldType
                                  title
                                  content
                                  rankOrder
                                  imageSignedUrl
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
    `;

export const useReportGoalsQuery = <
      TData = ReportGoalsQuery,
      TError = unknown
    >(
      variables: ReportGoalsQueryVariables,
      options?: Omit<UseQueryOptions<ReportGoalsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<ReportGoalsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<ReportGoalsQuery, TError, TData>(
      {
    queryKey: ['reportGoals', variables],
    queryFn: useCustomFetcher<ReportGoalsQuery, ReportGoalsQueryVariables>(ReportGoalsDocument).bind(null, variables),
    ...options
  }
    )};

export const GetReportLearnerFilesDocument = `
    query getReportLearnerFiles($reportId: ID, $fileId: ID) {
  getReportLearnerFiles(reportId: $reportId, fileId: $fileId) {
    edges {
      node {
        status
        id
        processingFailureReason
        processingFailureCode
        fileKind
        mimeType
        metadata
      }
    }
  }
}
    `;

export const useGetReportLearnerFilesQuery = <
      TData = GetReportLearnerFilesQuery,
      TError = unknown
    >(
      variables?: GetReportLearnerFilesQueryVariables,
      options?: Omit<UseQueryOptions<GetReportLearnerFilesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetReportLearnerFilesQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetReportLearnerFilesQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['getReportLearnerFiles'] : ['getReportLearnerFiles', variables],
    queryFn: useCustomFetcher<GetReportLearnerFilesQuery, GetReportLearnerFilesQueryVariables>(GetReportLearnerFilesDocument).bind(null, variables),
    ...options
  }
    )};

export const ReportReviewCountsDocument = `
    query reportReviewCounts {
  reportReviewCounts {
    waitingOnMe
    sentBackToMe
    inReview
    reviewedByMe
  }
}
    `;

export const useReportReviewCountsQuery = <
      TData = ReportReviewCountsQuery,
      TError = unknown
    >(
      variables?: ReportReviewCountsQueryVariables,
      options?: Omit<UseQueryOptions<ReportReviewCountsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<ReportReviewCountsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<ReportReviewCountsQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['reportReviewCounts'] : ['reportReviewCounts', variables],
    queryFn: useCustomFetcher<ReportReviewCountsQuery, ReportReviewCountsQueryVariables>(ReportReviewCountsDocument).bind(null, variables),
    ...options
  }
    )};

export const ReportStatusDocument = `
    query reportStatus($reportId: ID!) {
  getReport(reportId: $reportId) {
    edges {
      node {
        reportStatus
      }
    }
  }
}
    `;

export const useReportStatusQuery = <
      TData = ReportStatusQuery,
      TError = unknown
    >(
      variables: ReportStatusQueryVariables,
      options?: Omit<UseQueryOptions<ReportStatusQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<ReportStatusQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<ReportStatusQuery, TError, TData>(
      {
    queryKey: ['reportStatus', variables],
    queryFn: useCustomFetcher<ReportStatusQuery, ReportStatusQueryVariables>(ReportStatusDocument).bind(null, variables),
    ...options
  }
    )};

export const GetReportSuggestionsDocument = `
    query getReportSuggestions($reportId: ID!) {
  getReportSuggestions(reportId: $reportId) {
    totalCount
    totalResolved
    totalActive
    edges {
      node {
        id
        category
        content
        isActive
        isResolved
        reportSectionField {
          id
          title
        }
        reportGoal {
          id
          goalName
          excludeFromReport
        }
        goalField
        reportTarget {
          id
          targetName
          inUse
          excludeFromReport
        }
        targetField
      }
    }
  }
}
    `;

export const useGetReportSuggestionsQuery = <
      TData = GetReportSuggestionsQuery,
      TError = unknown
    >(
      variables: GetReportSuggestionsQueryVariables,
      options?: Omit<UseQueryOptions<GetReportSuggestionsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetReportSuggestionsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetReportSuggestionsQuery, TError, TData>(
      {
    queryKey: ['getReportSuggestions', variables],
    queryFn: useCustomFetcher<GetReportSuggestionsQuery, GetReportSuggestionsQueryVariables>(GetReportSuggestionsDocument).bind(null, variables),
    ...options
  }
    )};

export const ClientProgrammingProviderDocument = `
    query ClientProgrammingProvider($learnerId: ID!, $filter: GoalFilter) {
  goals(learnerId: $learnerId, filter: $filter) {
    edges {
      node {
        id
        name
        status
        targets {
          edges {
            node {
              id
              name
              status
              goal {
                id
                name
              }
              mediatargetpredictionSet {
                totalCount
              }
            }
          }
        }
        mediatargetpredictionSet {
          totalCount
        }
      }
    }
  }
}
    `;

export const useClientProgrammingProviderQuery = <
      TData = ClientProgrammingProviderQuery,
      TError = unknown
    >(
      variables: ClientProgrammingProviderQueryVariables,
      options?: Omit<UseQueryOptions<ClientProgrammingProviderQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<ClientProgrammingProviderQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<ClientProgrammingProviderQuery, TError, TData>(
      {
    queryKey: ['ClientProgrammingProvider', variables],
    queryFn: useCustomFetcher<ClientProgrammingProviderQuery, ClientProgrammingProviderQueryVariables>(ClientProgrammingProviderDocument).bind(null, variables),
    ...options
  }
    )};

export const ProgrammingGoalOverviewDocument = `
    query ProgrammingGoalOverview($id: ID!) {
  goal(id: $id) {
    id
    passagegoal {
      id
      title
      type
      description
      operationalDefinition
      onset
      offset
      antecedentStrategy
      errorCorrectionStrategy
      errorConsequenceStrategy
      replacementBehavior
      hypothesizedFunction
      teachingMethod
      discriminativeStimulus
      promptingInstructions
      expectedResponse
      reinforcementStrategy
      passageTargets {
        edges {
          node {
            id
            title
            description
            type
            measureType
            measureValue
            masteredOverType
            masteredOverValue
            threshold
            target {
              id
            }
          }
        }
      }
    }
  }
}
    `;

export const useProgrammingGoalOverviewQuery = <
      TData = ProgrammingGoalOverviewQuery,
      TError = unknown
    >(
      variables: ProgrammingGoalOverviewQueryVariables,
      options?: Omit<UseQueryOptions<ProgrammingGoalOverviewQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<ProgrammingGoalOverviewQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<ProgrammingGoalOverviewQuery, TError, TData>(
      {
    queryKey: ['ProgrammingGoalOverview', variables],
    queryFn: useCustomFetcher<ProgrammingGoalOverviewQuery, ProgrammingGoalOverviewQueryVariables>(ProgrammingGoalOverviewDocument).bind(null, variables),
    ...options
  }
    )};

export const SessionsByLearnerIdDocument = `
    query sessionsByLearnerId($providerId: ID, $learnerId: ID!) {
  sessionsByLearnerId(providerId: $providerId, learnerId: $learnerId) {
    edges {
      node {
        id
        sessionproviderSet {
          edges {
            node {
              provider {
                id
                providermetadata {
                  firstName
                  lastName
                }
              }
            }
          }
        }
        sessionStatus
        date
        createdDate
        lastUpdatedDate
        engagementScore
        finalMedia {
          id
          totalDuration
        }
      }
    }
  }
}
    `;

export const useSessionsByLearnerIdQuery = <
      TData = SessionsByLearnerIdQuery,
      TError = unknown
    >(
      variables: SessionsByLearnerIdQueryVariables,
      options?: Omit<UseQueryOptions<SessionsByLearnerIdQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<SessionsByLearnerIdQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<SessionsByLearnerIdQuery, TError, TData>(
      {
    queryKey: ['sessionsByLearnerId', variables],
    queryFn: useCustomFetcher<SessionsByLearnerIdQuery, SessionsByLearnerIdQueryVariables>(SessionsByLearnerIdDocument).bind(null, variables),
    ...options
  }
    )};

export const LearnersRecentSessionDocument = `
    query learnersRecentSession($learnerId: ID, $providerId: ID) {
  learnersRecentSession(learnerId: $learnerId, providerId: $providerId) {
    edges {
      node {
        id
        sessionLearners {
          id
          learnermetadata {
            firstName
            lastName
          }
        }
        videoSession {
          id
          sessionStatus
          engagementScore
          createdDate
          lastUpdatedDate
          sessionproviderSet {
            edges {
              node {
                provider {
                  id
                  providermetadata {
                    firstName
                    lastName
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
    `;

export const useLearnersRecentSessionQuery = <
      TData = LearnersRecentSessionQuery,
      TError = unknown
    >(
      variables?: LearnersRecentSessionQueryVariables,
      options?: Omit<UseQueryOptions<LearnersRecentSessionQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<LearnersRecentSessionQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<LearnersRecentSessionQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['learnersRecentSession'] : ['learnersRecentSession', variables],
    queryFn: useCustomFetcher<LearnersRecentSessionQuery, LearnersRecentSessionQueryVariables>(LearnersRecentSessionDocument).bind(null, variables),
    ...options
  }
    )};

export const VideoSessionByIdDocument = `
    query videoSessionById($videoSessionId: ID!) {
  videoSessionById(videoSessionId: $videoSessionId) {
    id
    lastUpdatedDate
  }
}
    `;

export const useVideoSessionByIdQuery = <
      TData = VideoSessionByIdQuery,
      TError = unknown
    >(
      variables: VideoSessionByIdQueryVariables,
      options?: Omit<UseQueryOptions<VideoSessionByIdQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<VideoSessionByIdQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<VideoSessionByIdQuery, TError, TData>(
      {
    queryKey: ['videoSessionById', variables],
    queryFn: useCustomFetcher<VideoSessionByIdQuery, VideoSessionByIdQueryVariables>(VideoSessionByIdDocument).bind(null, variables),
    ...options
  }
    )};

export const GetSesionEngagementInsightDocument = `
    query getSesionEngagementInsight($videoSessionId: ID!) {
  getSessionEngagementInsight(videoSessionId: $videoSessionId) {
    edges {
      node {
        id
        startTime
        endTime
        description
        insightType
      }
    }
  }
}
    `;

export const useGetSesionEngagementInsightQuery = <
      TData = GetSesionEngagementInsightQuery,
      TError = unknown
    >(
      variables: GetSesionEngagementInsightQueryVariables,
      options?: Omit<UseQueryOptions<GetSesionEngagementInsightQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetSesionEngagementInsightQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetSesionEngagementInsightQuery, TError, TData>(
      {
    queryKey: ['getSesionEngagementInsight', variables],
    queryFn: useCustomFetcher<GetSesionEngagementInsightQuery, GetSesionEngagementInsightQueryVariables>(GetSesionEngagementInsightDocument).bind(null, variables),
    ...options
  }
    )};

export const GetSessionEngagementScoreBySessionIdDocument = `
    query getSessionEngagementScoreBySessionId($videoSessionId: ID!, $videoDuration: Int!) {
  getSessionEngagementScoreBySessionId(
    videoSessionId: $videoSessionId
    videoDuration: $videoDuration
  ) {
    timeInMinute
    engagementScore
  }
}
    `;

export const useGetSessionEngagementScoreBySessionIdQuery = <
      TData = GetSessionEngagementScoreBySessionIdQuery,
      TError = unknown
    >(
      variables: GetSessionEngagementScoreBySessionIdQueryVariables,
      options?: Omit<UseQueryOptions<GetSessionEngagementScoreBySessionIdQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetSessionEngagementScoreBySessionIdQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetSessionEngagementScoreBySessionIdQuery, TError, TData>(
      {
    queryKey: ['getSessionEngagementScoreBySessionId', variables],
    queryFn: useCustomFetcher<GetSessionEngagementScoreBySessionIdQuery, GetSessionEngagementScoreBySessionIdQueryVariables>(GetSessionEngagementScoreBySessionIdDocument).bind(null, variables),
    ...options
  }
    )};

export const GetSessionMediaStreamDocument = `
    query getSessionMediaStream($videoSessionId: ID!) {
  getSessionMediaStream(videoSessionId: $videoSessionId) {
    id
    dashUrl
  }
}
    `;

export const useGetSessionMediaStreamQuery = <
      TData = GetSessionMediaStreamQuery,
      TError = unknown
    >(
      variables: GetSessionMediaStreamQueryVariables,
      options?: Omit<UseQueryOptions<GetSessionMediaStreamQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetSessionMediaStreamQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetSessionMediaStreamQuery, TError, TData>(
      {
    queryKey: ['getSessionMediaStream', variables],
    queryFn: useCustomFetcher<GetSessionMediaStreamQuery, GetSessionMediaStreamQueryVariables>(GetSessionMediaStreamDocument).bind(null, variables),
    ...options
  }
    )};

export const GetTasksDocument = `
    query getTasks($filter: TasksFilter, $first: Int, $last: Int, $after: String, $before: String) {
  tasks(
    filter: $filter
    first: $first
    last: $last
    after: $after
    before: $before
  ) {
    edges {
      node {
        id
        title
        subtitle
        status
        media {
          id
          filePath
          fileName
          fileSize
          mediaAttachmentUrl
        }
        file {
          id
          originalFileName
          fileSize
          signedS3LearnerFile
        }
      }
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
    totalCount
  }
}
    `;

export const useGetTasksQuery = <
      TData = GetTasksQuery,
      TError = unknown
    >(
      variables?: GetTasksQueryVariables,
      options?: Omit<UseQueryOptions<GetTasksQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetTasksQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetTasksQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['getTasks'] : ['getTasks', variables],
    queryFn: useCustomFetcher<GetTasksQuery, GetTasksQueryVariables>(GetTasksDocument).bind(null, variables),
    ...options
  }
    )};

export const GetMediaGoalMomentsDocument = `
    query getMediaGoalMoments($filter: MediaGoalMomentsFilter!) {
  getMediaGoalMoments(filter: $filter) {
    edges {
      node {
        id
        name
        status
        isPinned
        learner {
          id
        }
        rankOrder
        targets {
          edges {
            node {
              id
              name
              status
              mediatargetpredictionSet {
                edges {
                  node {
                    id
                    startTime
                    endTime
                    mediaTargetFeedbacks {
                      edges {
                        node {
                          lastUpdatedDate
                          isAccurate
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
        mediatargetpredictionSet {
          edges {
            node {
              id
              startTime
              endTime
              mediaTargetFeedbacks {
                edges {
                  node {
                    lastUpdatedDate
                    isAccurate
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
    `;

export const useGetMediaGoalMomentsQuery = <
      TData = GetMediaGoalMomentsQuery,
      TError = unknown
    >(
      variables: GetMediaGoalMomentsQueryVariables,
      options?: Omit<UseQueryOptions<GetMediaGoalMomentsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetMediaGoalMomentsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetMediaGoalMomentsQuery, TError, TData>(
      {
    queryKey: ['getMediaGoalMoments', variables],
    queryFn: useCustomFetcher<GetMediaGoalMomentsQuery, GetMediaGoalMomentsQueryVariables>(GetMediaGoalMomentsDocument).bind(null, variables),
    ...options
  }
    )};

export const TreatmentPlanUploadParsingResultsDocument = `
    query TreatmentPlanUploadParsingResults($id: ID!) {
  parsedTreatmentPlanFileDataById(id: $id) {
    id
    status
    data
  }
}
    `;

export const useTreatmentPlanUploadParsingResultsQuery = <
      TData = TreatmentPlanUploadParsingResultsQuery,
      TError = unknown
    >(
      variables: TreatmentPlanUploadParsingResultsQueryVariables,
      options?: Omit<UseQueryOptions<TreatmentPlanUploadParsingResultsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<TreatmentPlanUploadParsingResultsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<TreatmentPlanUploadParsingResultsQuery, TError, TData>(
      {
    queryKey: ['TreatmentPlanUploadParsingResults', variables],
    queryFn: useCustomFetcher<TreatmentPlanUploadParsingResultsQuery, TreatmentPlanUploadParsingResultsQueryVariables>(TreatmentPlanUploadParsingResultsDocument).bind(null, variables),
    ...options
  }
    )};
